// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
// Vietnamese translations for the AesirX ComplianceOne
import { viModuleTips, viFrameworkRequirements, viAdmin, viOrgIdentity, viFormPrefill, viCustomsTaxExports, viCrossBorderFilingFence, viSectorOverlaysModule, viFrameworkBriefings, viRegulatoryUpdateComparison, viDeploymentPrivacy, } from './vi-extras.js';
/**
 * Vietnamese (vi-VN) translations for the AesirX ComplianceOne.
 * Covers all Phase 1 (1.0.0–1.3.0) through Phase 12 modules.
 */
export const vi = {
    ai_governance_pages: {
        nav: {
            inventory: 'Rà soát kiểm kê hệ thống AI',
            payment: 'Ủy quyền thanh toán',
            interventions: 'Can thiệp',
            complaints: 'Khiếu nại về AI',
            framework: 'Bản ghi khung và ba tuyến bảo vệ',
            board: 'Báo cáo hội đồng: số liệu AI',
        },
        common: {
            loading: 'Đang tải…',
            loadFailed: 'Không thể đọc dữ liệu này.',
            retry: 'Thử lại',
            retrySr: 'đọc lại',
            notRecorded: 'Chưa ghi nhận',
            dueNotInForce: 'Không tính: chu kỳ chưa có hiệu lực',
            none: 'Không có',
            choose: 'Chọn…',
            cancel: 'Hủy',
            close: 'Đóng',
            saving: 'Đang lưu…',
            saveFailed: 'Bản ghi chưa được lưu.',
            requiredMark: '(bắt buộc)',
            missingHeading: 'Chưa thể lưu bản ghi. Còn thiếu:',
            directoryFailed: 'Không thể đọc danh sách người dùng.',
            directoryPartial: 'Đang hiển thị {shown} người. Danh sách chưa đầy đủ.',
            yes: 'Có',
            no: 'Không',
            readOnly: 'Chỉ xem',
            noAnswer: 'Máy chủ không phản hồi.',
            listTruncated: 'Đang hiển thị {shown} trên {total} dòng. Danh sách chưa đầy đủ.',
            awaitingOtherApprover: 'Đang chờ người khác phê duyệt',
            obligationsRetrySr: 'đọc lại các nghĩa vụ có thời hạn',
            systemDatesRetrySr: 'đọc lại các nghĩa vụ có thời hạn của hệ thống này',
            actions: 'Thao tác',
        },
        states: {
            incomplete: 'Chưa đầy đủ',
            complete: 'Hoàn thành',
            not_recorded: 'Chưa ghi nhận',
            not_evidenced: 'Chưa có bằng chứng',
            pending_approval: 'Chờ người thứ hai phê duyệt',
            expired: 'Đã hết hiệu lực',
            matches: 'Khớp',
            mismatch: 'Không khớp',
            requested: 'Đã yêu cầu',
            confirmed: 'Đã xác nhận',
            recorded: 'Đã ghi nhận',
            performed: 'Đã thực hiện',
            not_mandatory: 'Không bắt buộc',
            not_applicable: 'Không áp dụng',
            open: 'Đang mở',
            closed: 'Đã đóng',
            routed: 'Đã chuyển',
            stale: 'Lỗi thời',
            signed: 'Đã ký',
            current: 'Hiện hành',
            overdue: 'Quá hạn',
            due: 'Đến hạn',
            cadence_not_declared: 'Chưa khai báo chu kỳ',
            not_yet_in_force: 'Chưa có hiệu lực',
            not_judged: 'Chưa đánh giá',
            not_required: 'Không yêu cầu',
            not_trained: 'Chưa được đào tạo',
            completed: 'Đã hoàn thành',
            unsettled: 'Chưa xác định',
            present: 'Có',
            absent: 'Không có',
            pending: 'Chờ xử lý',
            ready: 'Sẵn sàng',
            active: 'Đang hoạt động',
            suspended: 'Đã tạm dừng',
            revoked: 'Đã thu hồi',
            approved: 'Đã phê duyệt',
            reopened: 'Mở lại',
            basis_not_retained: 'Không lưu căn cứ',
            reason_notified_basis_recorded: 'Đã thông báo lý do; có lưu căn cứ',
            needs_evidence: 'Cần bằng chứng',
            evidenced: 'Có bằng chứng',
            not_started: 'Chưa bắt đầu',
            in_progress: 'Đang thực hiện',
            evidence_captured: 'Đã ghi nhận bằng chứng',
            answered: 'Đã phản hồi',
        },
        missing: {
            risk_tier: 'Cần mức độ rủi ro đã phê duyệt từ một lần phân loại đã được rà soát.',
            impact_assessment: 'Hệ thống rủi ro cao cần đánh giá tác động đã được phê duyệt.',
            validation: 'Cần một lần kiểm tra, đánh giá mô hình đã ký cho phiên bản này.',
            validation_findings: 'Mọi phát hiện trong kết quả kiểm tra, đánh giá mô hình của phiên bản này phải được đóng sau kiểm thử lại.',
            security_tests: 'Mỗi nhóm tấn công cần có bản ghi, và không nhóm đầu độc, né tránh hoặc trích xuất nào được mở đối với phiên bản rủi ro cao.',
            rollback_plan: 'Cần phương án phục hồi nêu một phiên bản trước đó của hệ thống này.',
            senior_management_approval: 'Việc đưa hệ thống rủi ro cao vào vận hành cần nêu Hội đồng quản lý cấp cao đã phê duyệt và ngày quyết định.',
            documents_retained_for_audit: 'Tài liệu lưu phục vụ kiểm toán',
            data_disposition: 'Cách xử lý hoặc cô lập dữ liệu',
            model_disposition: 'Cách xử lý hoặc cô lập mô hình',
            configuration_disposition: 'Cách xử lý hoặc cô lập cấu hình',
        },
        revalidation: {
            revalidation_required: 'Cần kiểm tra, đánh giá lại mô hình',
            revalidation_not_required: 'Không cần kiểm tra, đánh giá lại mô hình',
        },
        separation: {
            required: 'Cần: người khác thực hiện kiểm thử lại',
            not_required: 'Không cần: đã nêu cơ sở',
        },
        securityStates: {
            not_mandatory: 'Không bắt buộc',
            performed: 'Đã thực hiện',
            not_applicable: 'Không áp dụng',
            open: 'Đang mở',
        },
        attackCategories: {
            privacy_breach: 'Xâm phạm quyền riêng tư',
            data_poisoning: 'Đầu độc dữ liệu',
            model_poisoning: 'Đầu độc mô hình',
            evasion: 'Né tránh',
            model_extraction: 'Trích xuất mô hình',
            prompt_injection: 'Chèn lệnh (prompt injection)',
            hallucination: 'Ảo giác',
            bias_in_generated_output: 'Thiên lệch trong đầu ra được tạo ra',
        },
        validationAreas: {
            data_fit: 'Mức phù hợp của dữ liệu huấn luyện và kiểm thử',
            algorithm_soundness: 'Tính hợp lý của thuật toán và kiến trúc',
            performance_accuracy: 'Hiệu năng và độ chính xác',
            explainability: 'Khả năng giải thích',
            fairness_bias_control: 'Kiểm soát tính công bằng và thiên lệch',
            stability: 'Tính ổn định',
            third_party_purpose_scope_risk: 'Bên thứ ba: mục đích, phạm vi và rủi ro',
            third_party_black_box_on_own_data: 'Bên thứ ba: kiểm thử hộp đen trên dữ liệu của ngân hàng',
            third_party_output_under_operating_conditions: 'Bên thứ ba: đầu ra trong điều kiện vận hành',
            third_party_provider_documentation: 'Bên thứ ba: tài liệu của nhà cung cấp',
            third_party_human_controls_and_monitoring: 'Bên thứ ba: kiểm soát và giám sát của con người',
        },
        versions: {
            heading: 'Phiên bản, kiểm soát thay đổi và khôi phục',
            description: 'Mỗi thay đổi ghi thành một dòng phiên bản; giá trị trước đó được giữ lại. Thay đổi sau khi phát hành cần quyết định kiểm tra, đánh giá lại mô hình của một người được nêu tên.',
            add: 'Thêm phiên bản',
            addTitle: 'Thêm phiên bản',
            addSubmit: 'Lưu phiên bản',
            empty: 'Chưa có phiên bản nào được ghi nhận.',
            colSequence: 'Số thứ tự',
            colKind: 'Loại',
            colModel: 'Phiên bản mô hình',
            colApplied: 'Áp dụng từ',
            colChanged: 'Thay đổi hoặc dừng',
            colConfig: 'Cấu hình',
            colTests: 'Kết quả kiểm thử',
            colRollbackPlan: 'Phương án phục hồi',
            colRestored: 'Phiên bản được khôi phục',
            colRestoredAt: 'Khôi phục lúc',
            colReason: 'Lý do',
            kind: { baseline: 'Ban đầu', change: 'Thay đổi', rollback: 'Khôi phục' },
            planRecorded: 'Đã ghi nhận',
            planNotRecorded: 'Chưa ghi nhận',
            stillInUse: 'Đang sử dụng',
            recordChange: 'Ghi nhận thay đổi',
            setPlan: 'Ghi nhận phương án phục hồi',
            fModel: 'Phiên bản mô hình',
            fScope: 'Phạm vi bị ảnh hưởng',
            fPrompt: 'Tham chiếu bộ lệnh hoặc hướng dẫn',
            fReferenceData: 'Tham chiếu dữ liệu tham chiếu',
            fIntegration: 'Tham chiếu tích hợp',
            fConfig: 'Tham chiếu cấu hình',
            fTests: 'Tham chiếu kết quả kiểm thử',
            fAutonomy: 'Mức tự chủ',
            fListedDevelopers: 'Người phát triển được nêu của phiên bản này',
            fRevalidation: 'Quyết định kiểm tra, đánh giá lại mô hình',
            fRevalidationReason: 'Lý do của quyết định',
            revalidationRequiredHint: 'Bắt buộc khi hệ thống đang ở giai đoạn sản xuất.',
            revalidationOptionalHint: 'Chỉ cần khi có thay đổi trong sản xuất.',
            changeDecisionHint: 'Thay đổi cần có quyết định kiểm tra, đánh giá lại mô hình và lý do.',
            changeTitle: 'Ghi nhận thay đổi',
            changeSubmit: 'Lưu thay đổi',
            fChangeSummary: 'Nội dung thay đổi',
            fChangedFields: 'Các trường đã thay đổi',
            changedField: {
                model_version: 'Phiên bản mô hình',
                prompt_reference: 'Tham chiếu bộ lệnh',
                reference_data_reference: 'Tham chiếu dữ liệu tham chiếu',
                integration_reference: 'Tham chiếu tích hợp',
                autonomy_level: 'Mức tự chủ',
                scope_affected: 'Phạm vi bị ảnh hưởng',
                configuration_reference: 'Tham chiếu cấu hình',
                test_result_reference: 'Tham chiếu kết quả kiểm thử',
                listed_developer_user_ids: 'Người phát triển được nêu',
            },
            planTitle: 'Phương án phục hồi',
            planSubmit: 'Lưu phương án',
            fLastGoodVersion: 'Phiên bản hoạt động tốt gần nhất đã biết',
            fSteps: 'Các bước khôi phục',
            fPlanOwner: 'Người phụ trách phương án',
            fLastRehearsal: 'Ngày diễn tập gần nhất',
            rollbackHeading: 'Sự kiện khôi phục',
            rollbackEmpty: 'Chưa có sự kiện khôi phục nào được ghi nhận.',
            recordRollback: 'Ghi nhận khôi phục',
            rollbackTitle: 'Ghi nhận khôi phục',
            rollbackSubmit: 'Lưu khôi phục',
            fRestoredVersion: 'Phiên bản được khôi phục',
            fRollbackReason: 'Lý do',
        },
        security: {
            fNotMandatory: 'Lý do không bắt buộc',
            notMandatoryHint: 'Bắt buộc khi trạng thái là không bắt buộc. Chỉ nhóm đầu độc, né tránh và trích xuất được ghi như vậy, và không bao giờ đối với hệ thống rủi ro cao.',
            findingsOpen: 'Phát hiện',
            findingsTitle: 'Phát hiện bảo mật',
            findingsDescription: 'Một phát hiện chỉ được đóng khi có mức độ, người phụ trách, hạn xử lý và bản ghi thay đổi, và đã được kiểm thử lại bởi người không phải người khắc phục.',
            findingsEmpty: 'Nhóm này chưa có phát hiện nào được ghi nhận.',
            addFinding: 'Mở phát hiện',
            fDescription: 'Nội dung phát hiện',
            fSeverity: 'Mức độ',
            fFindingOwner: 'Người phụ trách phát hiện',
            fDueDate: 'Hạn xử lý',
            fChangeRecord: 'Bản ghi thay đổi',
            noChangeRecord: 'Chưa có bản ghi thay đổi',
            recordFix: 'Ghi nhận khắc phục',
            closeOnRetest: 'Đóng sau kiểm thử lại',
            setDetails: 'Đặt mức độ, người phụ trách, hạn xử lý và bản ghi thay đổi',
            fFixedBy: 'Người khắc phục',
            fRetestDate: 'Ngày kiểm thử lại',
            fRetester: 'Người kiểm thử lại',
            fRetestResult: 'Kết quả kiểm thử lại',
            findingSubmit: 'Lưu phát hiện',
            findingNotClosed: 'Chưa đóng',
            findingStatus: {
                open: 'Đang mở',
                fixed: 'Đã khắc phục',
                closed: 'Đã đóng',
            },
            severities: {
                low: 'Thấp',
                medium: 'Trung bình',
                high: 'Cao',
                critical: 'Nghiêm trọng',
            },
            periodic: {
                heading: 'Kiểm thử bảo mật định kỳ',
                description: 'Chu kỳ và ngày kiểm thử gần nhất là của ngân hàng và được nhập tại đây. Nền tảng tính ngày kiểm thử tiếp theo và hiển thị. Nền tảng không thực hiện kiểm thử nào.',
                nextDate: 'Ngày kiểm thử tiếp theo: {date}',
                noNextDate: 'Phiên bản này chưa có lịch.',
                set: 'Đặt lịch',
                formTitle: 'Lịch kiểm thử bảo mật định kỳ',
                fPeriod: 'Chu kỳ tính bằng tháng',
                periodHint: 'Số tháng nguyên, từ 1 đến 120.',
                fLastTest: 'Ngày kiểm thử gần nhất',
                submit: 'Lưu lịch',
                states: {
                    not_scheduled: 'Chưa lên lịch',
                    scheduled: 'Đã lên lịch',
                    due: 'Đến hạn',
                    overdue: 'Quá hạn',
                },
            },
            heading: 'Kiểm thử bảo mật theo nhóm tấn công',
            description: 'Một bản ghi cho mỗi nhóm tấn công của phiên bản hiện tại. Nhóm chưa có bản ghi được hiển thị là chưa ghi nhận. Nền tảng không thực hiện kiểm thử nào.',
            empty: 'Chưa có kiểm thử bảo mật nào được ghi nhận.',
            blank: 'Chưa ghi nhận',
            colCategory: 'Nhóm tấn công',
            colState: 'Trạng thái',
            colOwner: 'Người phụ trách',
            colTest: 'Kiểm thử',
            colFindings: 'Phát hiện',
            findingCount: '{open} đang mở trên tổng {total}',
            record: 'Ghi nhận',
            update: 'Cập nhật',
            formTitle: 'Kiểm thử bảo mật',
            submit: 'Lưu bản ghi kiểm thử',
            fState: 'Trạng thái',
            fNotApplicable: 'Lý do không áp dụng',
            naHint: 'Bắt buộc khi trạng thái là không áp dụng.',
            fMethod: 'Phương pháp',
            fTester: 'Người kiểm thử',
            fTestDate: 'Ngày kiểm thử',
            fResult: 'Kết quả',
            fArtefact: 'Tham chiếu tài liệu đính kèm',
            fPersonalData: 'Tài liệu có chứa dữ liệu cá nhân không?',
            fOwner: 'Người phụ trách nhóm này',
            fSeparation: 'Tách bạch nhiệm vụ khi kiểm thử lại',
            fSeparationBasis: 'Cơ sở không tách bạch',
            separationBasisHint: 'Bắt buộc khi không yêu cầu tách bạch.',
        },
        validation: {
            heading: 'Kiểm tra, đánh giá mô hình độc lập',
            description: 'Kết quả kiểm tra, đánh giá mô hình do người kiểm tra, đánh giá ký xác nhận; người này độc lập với bộ phận phát triển, triển khai, vận hành và nhà cung cấp mô hình. Nền tảng ghi nhận xác nhận và không kết luận về xác nhận đó.',
            add: 'Mở một lần kiểm tra, đánh giá mô hình',
            empty: 'Chưa có lần kiểm tra, đánh giá mô hình nào được ký.',
            colScope: 'Phạm vi',
            colValidator: 'Người kiểm tra, đánh giá',
            colUnit: 'Bộ phận kiểm tra, đánh giá',
            colSigned: 'Ngày ký',
            colTests: 'Kiểm thử',
            colFindings: 'Phát hiện',
            closeFinding: 'Đóng phát hiện',
            colStatus: 'Trạng thái',
            signNow: 'Ký kết quả kiểm tra, đánh giá',
            signNowTitle: 'Ký kết quả kiểm tra, đánh giá này',
            signNowMessage: 'Việc ký ghi nhận xác nhận cho phiên bản đang được kiểm thử và không thể hoàn tác. Tuyên bố của người kiểm tra, đánh giá về tính độc lập của mình được ghi nhận đúng như đã nêu.',
            signNowSubmit: 'Ký kết quả kiểm tra, đánh giá',
            respond: 'Phản hồi',
            respondTitle: 'Phản hồi của người phụ trách',
            fResponse: 'Phản hồi',
            respondSubmit: 'Lưu phản hồi',
            responseLabel: 'Phản hồi của người phụ trách',
            addFinding: 'Mở phát hiện',
            signTitle: 'Mở một lần kiểm tra, đánh giá mô hình',
            signSubmit: 'Mở lần kiểm tra, đánh giá',
            fScope: 'Phạm vi kiểm tra, đánh giá',
            fValidator: 'Người kiểm tra, đánh giá',
            fUnit: 'Bộ phận kiểm tra, đánh giá',
            fIndependence: 'Tuyên bố về tính độc lập',
            independenceHint: 'Người kiểm tra, đánh giá nêu rõ bộ phận kiểm tra, đánh giá độc lập như thế nào với bộ phận phát triển, triển khai, vận hành và nhà cung cấp mô hình.',
            testsLegend: 'Kiểm thử',
            fTestArea: 'Lĩnh vực kiểm thử',
            fTestName: 'Tên kiểm thử',
            fTestMethod: 'Phương pháp',
            fTestData: 'Dữ liệu',
            fTestResult: 'Kết quả',
            confirmTitle: 'Xác nhận lần kiểm tra, đánh giá',
            confirmMessage: 'Thao tác mở ghi nhận lần kiểm tra, đánh giá này cho phiên bản đang được kiểm thử. Kết quả chưa được ký cho đến khi người kiểm tra, đánh giá ký, và việc ký cần ít nhất một kiểm thử trong bản ghi.',
            findingTitle: 'Phát hiện',
            openSubmit: 'Mở phát hiện',
            closeSubmit: 'Đóng phát hiện',
            fFindingDescription: 'Mô tả',
            fFindingOwner: 'Người phụ trách phát hiện',
            fDueDate: 'Hạn xử lý',
            fRetestDate: 'Ngày kiểm thử lại',
            fRetestResult: 'Kết quả kiểm thử lại',
            retestHint: 'Phát hiện chỉ đóng khi có kiểm thử lại sau ngày khắc phục.',
        },
        release: {
            heading: 'Phê duyệt phát hành',
            description: 'Việc phát hành bị từ chối cho đến khi mỗi điều kiện tiên quyết được ghi nhận. Người phê duyệt không thể là người phụ trách hệ thống, và người phát triển được nêu không thể phê duyệt phát hành phiên bản của chính mình.',
            add: 'Phê duyệt phát hành',
            empty: 'Chưa có phát hành nào được phê duyệt.',
            colStatus: 'Trạng thái',
            colGoLive: 'Ngày đưa vào vận hành',
            colLabel: 'Thời điểm phê duyệt',
            colApprover: 'Người phê duyệt',
            colApproved: 'Phê duyệt ngày',
            colStale: 'Lỗi thời vì',
            beforeGoLive: 'Trước khi đưa vào vận hành',
            afterTheFact: 'Sau khi đã đưa vào vận hành',
            staleBecause: 'Đã thay đổi:',
            formTitle: 'Phê duyệt phát hành',
            formDescription: 'Bảy điều kiện tiên quyết được kiểm tra khi lưu. Phát hành bị từ chối sẽ nêu từng điều kiện còn thiếu.',
            checklistLegend: 'Điều kiện tiên quyết',
            checklistUnmet: 'Còn thiếu',
            checklistNotChecked: 'Kiểm tra khi lưu',
            preconditions: {
                risk_tier: 'Mức độ rủi ro từ một lần phân loại đã được phê duyệt',
                impact_assessment: 'Đánh giá tác động đã được phê duyệt, đối với hệ thống rủi ro cao',
                validation: 'Kết quả kiểm tra, đánh giá mô hình đã ký cho phiên bản này',
                validation_findings: 'Mọi phát hiện trong kết quả kiểm tra, đánh giá đã ký được đóng sau kiểm thử lại',
                security_tests: 'Bản ghi kiểm thử bảo mật cho mọi nhóm, không có nhóm đầu độc, né tránh hoặc trích xuất nào đang mở',
                rollback_plan: 'Phương án phục hồi nêu một phiên bản trước đó',
                senior_management_approval: 'Với hệ thống rủi ro cao được đưa vào vận hành: Hội đồng quản lý cấp cao và ngày quyết định',
            },
            rehearsalLabel: 'Diễn tập khôi phục',
            rehearsalNotDone: 'Chưa diễn tập',
            rehearsalDone: 'Đã diễn tập ngày',
            openFindingsLabel: 'Phát hiện kiểm tra, đánh giá đang mở',
            gateUnreadable: 'Không đọc được cổng phát hành của phiên bản này. Hãy chọn lại phiên bản để thử lại.',
            fVersion: 'Phiên bản phát hành',
            fGoLive: 'Ngày đưa vào vận hành',
            fSeniorBody: 'Hội đồng quản lý cấp cao',
            fSeniorDate: 'Ngày quyết định của Hội đồng quản lý cấp cao',
            seniorHint: 'Bắt buộc khi đưa hệ thống rủi ro cao vào vận hành.',
            submit: 'Phê duyệt phát hành',
            confirmTitle: 'Phê duyệt phát hành này',
            confirmMessage: 'Thao tác này ghi nhận phê duyệt phát hành cho phiên bản đã chọn. Phê duyệt không triển khai hệ thống; việc phát hành được thực hiện trong hệ thống của ngân hàng.',
        },
        impact: {
            heading: 'Đánh giá tác động',
            description: 'Năm nội dung của đánh giá, phần công bằng và phê duyệt. Thay đổi chức năng, dữ liệu hoặc điều kiện vận hành sẽ mở lại đánh giá đã phê duyệt.',
            add: 'Ghi nhận đánh giá tác động',
            empty: 'Chưa có đánh giá tác động nào được ghi nhận.',
            colStatus: 'Trạng thái',
            colPurpose: 'Mục đích',
            colDpia: 'DPIA hoặc lý do',
            colFairness: 'Phần công bằng',
            colApproval: 'Phê duyệt',
            approve: 'Phê duyệt',
            fairnessAction: 'Phần công bằng',
            fairnessRecorded: 'Đã ghi nhận',
            fairnessNotRecorded: 'Chưa ghi nhận',
            addTitle: 'Ghi nhận đánh giá tác động',
            addSubmit: 'Lưu đánh giá',
            fPurpose: 'Mục đích',
            fScope: 'Phạm vi',
            fMechanism: 'Cách hệ thống hoạt động',
            fOversight: 'Cách con người giám sát và can thiệp',
            oversightHint: 'Mô tả việc giám sát của con người và phương thức can thiệp.',
            fFairness: 'Rủi ro công bằng',
            fTransparency: 'Rủi ro minh bạch',
            fExplainability: 'Rủi ro khả năng giải thích',
            fDiscrimination: 'Rủi ro phân biệt đối xử với khách hàng',
            fDpia: 'Mã định danh hồ sơ DPIA',
            dpiaHint: 'Mã định danh của hồ sơ DPIA. Nội dung DPIA không được sao chép.',
            fPersonalDataNotApplicable: 'Lý do đánh giá dữ liệu cá nhân không áp dụng',
            personalDataHint: 'Nêu mã định danh DPIA, hoặc lý do không áp dụng.',
            fControls: 'Biện pháp kiểm soát',
            fMonitoring: 'Kế hoạch giám sát',
            fIncident: 'Ứng phó sự cố',
            fairnessTitle: 'Phần công bằng',
            fairnessSubmit: 'Lưu phần công bằng',
            fFairnessAssessment: 'Đánh giá công bằng',
            fBiasControls: 'Kiểm soát thiên lệch',
            fVulnerable: 'Nhóm dễ bị tổn thương',
        },
        inventory: {
            heading: 'Rà soát kiểm kê hằng năm',
            description: 'Rà soát hằng năm của hệ thống trong năm được hiển thị. Hồ sơ chưa được xác nhận đến hạn sẽ hiển thị quá hạn.',
            confirm: 'Xác nhận rà soát',
            empty: 'Hệ thống này chưa có rà soát cho năm này.',
            colPeriod: 'Kỳ',
            colAnchor: 'Mốc tính',
            colDue: 'Hạn',
            colReading: 'Tình trạng',
            anchorKind: {
                first_recorded: 'Ngày ghi nhận đầu tiên',
                last_confirmation: 'Lần xác nhận gần nhất',
                review_duty_effective: 'Ngày nghĩa vụ rà soát có hiệu lực',
            },
            formTitle: 'Xác nhận rà soát hằng năm',
            submit: 'Xác nhận rà soát',
            fOutcome: 'Kết quả',
            outcome: { confirmed: 'Xác nhận không thay đổi', changed: 'Có thay đổi' },
            fChangeSummary: 'Nội dung thay đổi',
        },
        components: {
            heading: 'Sổ đăng ký thành phần AI',
            description: 'Thư viện, mô hình, tập dữ liệu và phụ thuộc, mỗi dòng có kiểm tra toàn vẹn. Dòng thiếu trường nào sẽ hiển thị chưa đầy đủ.',
            empty: 'Chưa có sổ đăng ký thành phần nào được ghi nhận.',
            noRows: 'Chưa có thành phần nào được liệt kê trong sổ đăng ký.',
            record: 'Ghi nhận sổ đăng ký',
            integrity: 'Ghi nhận kiểm tra toàn vẹn',
            advisory: 'Ghi nhận cảnh báo',
            supplyReview: 'Ghi nhận rà soát chuỗi cung ứng',
            incompleteCount: '{count} dòng chưa đầy đủ.',
            supplyReviewReading: 'Rà soát chuỗi cung ứng',
            colKind: 'Loại',
            colName: 'Tên',
            colSupplier: 'Nhà cung cấp hoặc nhà phát triển',
            colVersion: 'Phiên bản',
            colIntegrity: 'Giá trị kiểm tra toàn vẹn',
            colReading: 'Tình trạng',
            missingFields: 'Thiếu',
            integrityHeading: 'Kiểm tra toàn vẹn',
            integrityEmpty: 'Chưa có kiểm tra toàn vẹn nào được ghi nhận.',
            advisoryHeading: 'Cảnh báo',
            advisoryEmpty: 'Chưa có cảnh báo nào được ghi nhận.',
            kind: {
                library: 'Thư viện',
                model: 'Mô hình',
                dataset: 'Tập dữ liệu',
                dependency: 'Phụ thuộc',
            },
            formTitle: 'Ghi nhận sổ đăng ký thành phần',
            formDescription: 'Lưu sẽ thêm một bản chụp mới. Sổ đăng ký trước đó vẫn được xem lại.',
            submit: 'Lưu',
            rowLegend: 'Thành phần {n}',
            fKind: 'Loại',
            fName: 'Tên',
            fSupplier: 'Nhà cung cấp hoặc nhà phát triển',
            fVersion: 'Phiên bản',
            fLicence: 'Giấy phép',
            fCheck: 'Giá trị kiểm tra toàn vẹn',
            fOrigin: 'Nguồn gốc',
            fAffected: 'Các nhóm tấn công mà thành phần này ảnh hưởng',
            addRow: 'Thêm thành phần',
            removeRow: 'Xóa',
            integrityFormTitle: 'Ghi nhận kiểm tra toàn vẹn',
            fComponent: 'Thành phần',
            fMethod: 'Phương pháp kiểm tra',
            fCheckValue: 'Giá trị kiểm tra',
            fCheckedOn: 'Ngày kiểm tra',
            advisoryFormTitle: 'Ghi nhận cảnh báo',
            fAdvisoryRef: 'Tham chiếu cảnh báo',
            fReceivedOn: 'Ngày nhận',
            fRiskDecision: 'Quyết định rủi ro',
            reviewFormTitle: 'Ghi nhận rà soát chuỗi cung ứng',
            fReviewSummary: 'Tóm tắt rà soát',
        },
        provenance: {
            heading: 'Nguồn gốc dữ liệu và nhật ký vận hành',
            description: 'Nguồn của dữ liệu huấn luyện, kiểm thử và vận hành; tham chiếu chất lượng và rò rỉ; thời hạn lưu nhật ký cùng căn cứ.',
            record: 'Ghi nhận nguồn gốc',
            empty: 'Chưa có nguồn gốc dữ liệu nào được ghi nhận.',
            sources: 'Nguồn',
            thirdParty: 'Bên thứ ba',
            synthetic: 'Dữ liệu tổng hợp',
            qualityPolicy: 'Chính sách chất lượng dữ liệu',
            leakageControl: 'Kiểm soát rò rỉ',
            retention: 'Thời hạn lưu nhật ký',
            citation: 'Căn cứ',
            citationMissing: 'Chưa ghi nhận căn cứ',
            revision: 'Bản sửa đổi',
            dataUse: { training: 'Huấn luyện', test: 'Kiểm thử', operating: 'Vận hành' },
            formTitle: 'Ghi nhận nguồn gốc dữ liệu',
            submit: 'Lưu nguồn gốc',
            fDataUse: 'Mục đích sử dụng dữ liệu',
            fSource: 'Nguồn dữ liệu',
            fLawfulBasis: 'Tuyên bố căn cứ pháp lý',
            fThirdParty: 'Do bên thứ ba cung cấp',
            fSupplier: 'Tên nhà cung cấp',
            fWarranty: 'Cam kết về nguồn',
            fSharing: 'Quyền chia sẻ',
            fSynthetic: 'Sử dụng dữ liệu tổng hợp',
            fSyntheticAssessment: 'Đánh giá dữ liệu tổng hợp',
            fInputLog: 'Tham chiếu nhật ký xử lý đầu vào',
            fQualityPolicy: 'Tham chiếu chính sách chất lượng dữ liệu',
            fLeakage: 'Tham chiếu kiểm soát rò rỉ',
            fRetention: 'Thời hạn lưu nhật ký',
            retentionHint: 'Thời hạn do ngân hàng đặt cho nhật ký vận hành.',
            fCitation: 'Căn cứ của quy định đặt thời hạn',
            citationHint: 'Bắt buộc khi có thời hạn lưu.',
        },
        decisions: {
            heading: 'Bản ghi quyết định',
            description: 'Với mỗi quyết định tự động ảnh hưởng đến nghĩa vụ, tình hình tài chính hoặc khả năng tiếp cận sản phẩm: căn cứ và yếu tố chính, cùng lời giải thích đã đưa cho khách hàng.',
            add: 'Ghi nhận quyết định',
            empty: 'Chưa có quyết định nào được ghi nhận.',
            colDate: 'Ngày quyết định',
            colRef: 'Mã tham chiếu',
            colEffect: 'Tác động',
            colBasis: 'Căn cứ',
            colExplanation: 'Lời giải thích đã đưa',
            colVersion: 'Phiên bản tại ngày ra quyết định',
            versionLegacy: 'Phiên bản hiện hành khi ghi nhận',
            versionNone: 'Không có phiên bản nào áp dụng tại ngày ra quyết định',
            basisRuleHeading: 'Cách hiểu của nền tảng',
            basisRule: 'Cách hiểu của ComplianceOne đối với khoản 5 Điều 20: đối với mọi quyết định tự động có ảnh hưởng trực tiếp đến trách nhiệm pháp lý, nghĩa vụ tài chính hoặc việc tiếp cận, sử dụng sản phẩm, dịch vụ của khách hàng, thông tin về cơ sở và các yếu tố chính dẫn đến quyết định được lưu trữ, bất kể mục đích của quyết định. Đối với quyết định nhằm phòng chống gian lận, lừa đảo, rửa tiền, tài trợ khủng bố hoặc bảo đảm an ninh mạng, tổ chức chỉ cần thông báo cho khách hàng lý do phù hợp với việc rà soát rủi ro, bảo đảm an toàn tài sản cho khách hàng; tổ chức có thể cung cấp thêm thông tin. Việc giải thích không được làm lộ mã nguồn, thuật toán chi tiết, bộ tham số hoặc thông tin thuộc bí mật kinh doanh, bí mật công nghệ. Đây là cách hiểu văn bản của nền tảng, không phải ý kiến rà soát pháp lý.',
            effect: {
                legal_or_financial_obligation: 'Trách nhiệm pháp lý hoặc nghĩa vụ tài chính',
                customer_access: 'Khả năng tiếp cận sản phẩm hoặc dịch vụ',
            },
            category: {
                standard: 'Thông thường',
                fraud: 'Gian lận',
                scam: 'Lừa đảo',
                money_laundering: 'Rửa tiền',
                terrorism_financing: 'Tài trợ khủng bố',
                cyber_security: 'An ninh mạng',
            },
            formTitle: 'Ghi nhận quyết định',
            submit: 'Lưu quyết định',
            fDate: 'Ngày quyết định',
            fRef: 'Mã tham chiếu quyết định',
            fEffect: 'Tác động',
            fCategory: 'Loại quyết định',
            categoryHint: 'Với gian lận, lừa đảo, rửa tiền, tài trợ khủng bố hoặc an ninh mạng, đơn vị chỉ cần thông báo lý do cho khách hàng; căn cứ và các yếu tố chính vẫn được lưu trữ.',
            fBasis: 'Căn cứ của quyết định',
            basisHint: 'Chỉ để trống khi không lưu được căn cứ; bản ghi khi đó hiển thị không lưu căn cứ.',
            fKeyFactors: 'Yếu tố chính',
            factorsHint: 'Mỗi yếu tố một dòng.',
            fExplanation: 'Lời giải thích đã đưa cho khách hàng',
            fDelivered: 'Ngày đã đưa',
            fChannel: 'Kênh',
            fStatedReason: 'Lý do đã nêu',
            restrictedHint: 'Nội dung thông báo cho khách hàng. Với loại này, đơn vị chỉ cần thông báo lý do; nếu đã giải thích thêm cho khách hàng, hãy ghi nhận cả phần giải thích đó.',
            restrictedBasisHint: 'Được lưu trữ, không thông báo cho khách hàng. Chỉ để trống khi căn cứ không được lưu giữ; bản ghi khi đó hiển thị không lưu căn cứ.',
        },
        disclosures: {
            heading: 'Thông báo về AI đang sử dụng',
            description: 'Nội dung đang sử dụng vào ngày được chọn, theo loại, sản phẩm và kênh. Nội dung mới được ghi nhận bên cạnh nội dung cũ; không thay thế.',
            add: 'Ghi nhận thông báo',
            notRecorded: 'Chưa có thông báo nào được ghi nhận cho ngày này.',
            colKind: 'Loại',
            colProduct: 'Sản phẩm',
            colChannel: 'Kênh',
            colVersion: 'Phiên bản',
            colGoLive: 'Ngày đưa vào sử dụng',
            colText: 'Nội dung',
            kind: {
                pre_service_information: 'Thông tin trước khi cung cấp dịch vụ',
                ai_interaction_statement: 'Tuyên bố khách hàng đang tương tác với AI',
                internal_user_information: 'Thông tin cho người dùng nội bộ',
            },
            formTitle: 'Ghi nhận thông báo',
            submit: 'Lưu thông báo',
            fOn: 'Ngày đang sử dụng',
            fKind: 'Loại',
            fProduct: 'Sản phẩm',
            fChannel: 'Kênh',
            fGoLive: 'Ngày đưa vào sử dụng',
            fText: 'Nội dung đang sử dụng',
            textHint: 'Nhập hoặc dán nội dung. Nền tảng không tự soạn nội dung.',
            fPurpose: 'Mục đích',
            fScope: 'Phạm vi',
            fLimits: 'Giới hạn',
            fGuidance: 'Hướng dẫn diễn giải',
            fRoute: 'Đường dẫn để yêu cầu con người can thiệp',
            fFeedback: 'Kênh phản hồi',
            fSameDayReason: 'Lý do có phiên bản thứ hai trong cùng ngày',
            sameDayHint: 'Chỉ bắt buộc khi một phiên bản khác của nội dung này có hiệu lực cùng ngày.',
            noChannels: 'Ghi nhận kênh trước khi ghi nhận thông báo.',
            pendingHeading: 'Phiên bản chờ người thứ hai',
            pendingDescription: 'Phiên bản chỉ có hiệu lực khi người thứ hai phê duyệt. Người đã ghi nhận phiên bản không thể tự phê duyệt.',
            pendingEmpty: 'Không có phiên bản nào đang chờ phê duyệt.',
            inUseHeading: 'Đang sử dụng vào ngày được chọn',
            approve: 'Phê duyệt phiên bản',
        },
        payment: {
            heading: 'Ủy quyền thanh toán tự động',
            description: 'Một ủy quyền cho mỗi thỏa thuận với khách hàng: mười một yếu tố, hạn mức đối chiếu với trần mà khung tuân thủ đã cài đặt công bố, và tạm dừng hoặc thu hồi. Nền tảng không thực hiện hay dừng thanh toán.',
            add: 'Ghi nhận ủy quyền',
            empty: 'Hệ thống này chưa có ủy quyền thanh toán nào được ghi nhận.',
            colState: 'Trạng thái',
            colAgreement: 'Thỏa thuận',
            colAutonomy: 'Mức tự chủ trên hệ thống',
            colPerDay: 'Hạn mức mỗi ngày',
            colCeiling: 'Nguồn trần',
            colMissing: 'Yếu tố còn thiếu',
            colRelief: 'Miễn xác nhận giao dịch',
            relief: {
                heading: 'Miễn xác nhận giao dịch',
                open: 'Miễn xác nhận giao dịch',
                openSr: 'của thỏa thuận {agreement}',
                close: 'Đóng phần miễn xác nhận',
                intro: 'Nội dung Khung tuân thủ đã cài đặt quy định về việc không phải áp dụng xác nhận giao dịch đối với giao dịch thanh toán do hệ thống trí tuệ nhân tạo tự động thực hiện trong phạm vi thỏa thuận này, và các điều kiện nào đã được ghi nhận trên ủy quyền này.',
                notApplied: 'Nền tảng ghi nhận nội dung do một người khai báo. Nền tảng không áp dụng việc miễn, không xác nhận, không tính và không phân loại giao dịch, và không tính bất kỳ tổng giá trị nào do văn bản được dẫn chiếu quy định.',
                statedBy: 'Quy định tại {framework}, {provision}.',
                refersTo: 'Văn bản được dẫn chiếu',
                amendedBy: 'được sửa đổi, bổ sung bởi {list}',
                lifts: 'Việc xác nhận không phải áp dụng',
                quantities: 'Các tổng giá trị không tính giá trị giao dịch',
                annexVersion: 'Phiên bản phụ lục',
                conditionsHeading: 'Điều kiện',
                colCondition: 'Điều kiện',
                colBasis: 'Căn cứ',
                colRecorded: 'Trên ủy quyền này',
                colMissing: 'Cần ghi nhận',
                recorded: 'Đã ghi nhận',
                notRecorded: 'Chưa ghi nhận',
                effectHeading: 'Hệ quả',
                notLiftedHeading: 'Những nội dung vẫn phải áp dụng',
                reachHeading: 'Phạm vi',
                namedSection: '{section}: {framework}, {provision}',
                reading: {
                    conditions_not_recorded: 'Điều kiện chưa được ghi nhận',
                    conditions_recorded: 'Điều kiện đã được ghi nhận',
                    relied_on: 'Đơn vị đã dựa vào',
                    relied_on_conditions_no_longer_recorded: 'Đơn vị đã dựa vào; điều kiện không còn được ghi nhận',
                },
                reliance: '{who} ghi nhận đơn vị dựa vào việc miễn vào {when}. Lý do: {reason}',
                rely: 'Ghi nhận đơn vị dựa vào việc miễn này',
                relyDisabled: 'Chỉ ghi nhận được việc đơn vị dựa vào việc miễn khi mọi điều kiện đã được ghi nhận trên ủy quyền này.',
                relyTitle: 'Ghi nhận việc dựa vào miễn xác nhận giao dịch',
                relyDescription: 'Ghi nhận ai dựa vào việc miễn cho thỏa thuận này, vào thời điểm nào và lý do. Không thể ghi nhận khi chưa có điều khoản được phê duyệt đang có hiệu lực; người soạn các điều khoản đang có hiệu lực và người đã soạn một phiên bản được phê duyệt có đặt hoặc thay đổi một trong hai nội dung xác nhận cũng không được ghi nhận. Nền tảng không áp dụng việc miễn.',
                relySubmit: 'Ghi nhận việc dựa vào',
                fReason: 'Lý do đơn vị dựa vào việc miễn',
                relied: 'Đã ghi nhận việc đơn vị dựa vào miễn xác nhận giao dịch.',
                statements: 'Ghi nhận các tuyên bố',
                statementsTitle: 'Ghi nhận các tuyên bố làm căn cứ cho việc miễn',
                statementsDescription: 'Được lưu dưới dạng một thay đổi của ủy quyền. Thay đổi có hiệu lực khi người thứ hai phê duyệt.',
                statementsSubmit: 'Lưu thay đổi',
                statementsSaved: 'Đã lưu thay đổi. Người thứ hai phải phê duyệt.',
                statementsPending: 'Chỉ ghi nhận được các tuyên bố khi người thứ hai đã phê duyệt thay đổi đang chờ trên ủy quyền này.',
                fAiExecution: 'Cách đơn vị xác định giao dịch do hệ thống thực hiện',
                aiExecutionHint: 'Tham chiếu của dấu hiệu, trường dữ liệu hoặc nhật ký cho thấy giao dịch do hệ thống thực hiện, không phải do con người.',
                fAutomationConditions: 'Tuyên bố các điều kiện tự động hóa được đáp ứng',
                automationConditionsHint: 'Một người tuyên bố từng điều kiện mà văn bản quy định để tự động hóa hệ thống này đều được đáp ứng.',
                evidence: {
                    ai_execution_reference: 'Tuyên bố về cách xác định giao dịch do hệ thống thực hiện',
                    automation_conditions_statement: 'Tuyên bố các điều kiện tự động hóa được đáp ứng',
                    terms_approved: 'Điều khoản được người thứ hai phê duyệt',
                    ceiling_checked: 'Hạn mức theo ngày đã được đối chiếu với mức trần đã khai báo',
                    authority_active: 'Ủy quyền đang có hiệu lực (không bị tạm dừng, thu hồi hoặc hết hạn)',
                },
                noneDeclared: 'Không có Khung tuân thủ đã cài đặt nào quy định việc miễn xác nhận giao dịch cho ủy quyền thanh toán tự động.',
                unreadable: 'Không đọc được nội dung miễn xác nhận giao dịch do một Khung tuân thủ đã cài đặt khai báo.',
                notDeclared: 'Chưa được khai báo',
                listReferenceOnly: 'Được khai báo bởi Khung tuân thủ cài đặt ở chế độ Chỉ tham khảo',
                listNotOperational: 'Được khai báo bởi Khung tuân thủ không được áp dụng',
                listUnreadable: 'Đã được khai báo nhưng không đọc được',
                activationUpcoming: 'Khung tuân thủ khai báo việc miễn này chưa có hiệu lực. Việc miễn áp dụng từ ngày Khung tuân thủ có hiệu lực; có thể ghi nhận việc đơn vị dựa vào việc miễn trước ngày đó.',
            },
            scopeHeading: 'Phạm vi áp dụng đã được đánh dấu để rà soát pháp lý',
            scopeIntro: 'Tổ chức được khung tuân thủ đã cài đặt nêu tại một quy định nhưng không được nêu tại quy định về phạm vi áp dụng. Nền tảng không coi tổ chức này là thuộc hay không thuộc phạm vi áp dụng.',
            scopeNamed: 'Được nêu tại {named_in}; không được nêu tại {absent_from}.',
            scopeStatus: { under_legal_review: 'Đã đánh dấu để rà soát pháp lý' },
            scopeSource: 'Theo {framework}',
            scopeUnreadable: 'Không đọc được một nội dung giới hạn phạm vi do khung tuân thủ đã cài đặt quy định.',
            scopeLoadFailed: 'Không đọc được thông báo về phạm vi áp dụng.',
            scopeRetrySr: 'đọc lại thông báo về phạm vi áp dụng',
            recordEvent: 'Ghi nhận sự kiện',
            approve: 'Phê duyệt thay đổi này',
            exportHistory: 'Xuất lịch sử thẩm quyền',
            customerClass: { individual: 'Cá nhân', organisation: 'Tổ chức' },
            element: {
                customer_class: 'Loại khách hàng',
                agreement_reference: 'Tham chiếu thỏa thuận',
                automated_transaction_scope: 'Phạm vi giao dịch tự động',
                per_transaction_limit_vnd: 'Hạn mức mỗi giao dịch',
                per_day_limit_vnd: 'Hạn mức mỗi ngày',
                valid_from: 'Hiệu lực từ',
                valid_until: 'Hiệu lực đến',
                suspension_conditions: 'Điều kiện tạm dừng',
                customer_termination_clause_reference: 'Điều khoản chấm dứt của khách hàng',
                identity_verification_statement: 'Tuyên bố xác minh danh tính',
                pause_or_cancel_tool_reference: 'Công cụ tạm dừng hoặc hủy của khách hàng',
            },
            formTitle: 'Ghi nhận ủy quyền thanh toán',
            formDescription: 'Hạn mức mỗi ngày vượt trần mà khung tuân thủ đã cài đặt công bố sẽ bị từ chối, và thông báo từ chối nêu rõ khung đó cùng điều khoản.',
            submit: 'Lưu ủy quyền',
            fCustomerClass: 'Loại khách hàng',
            fAgreement: 'Tham chiếu thỏa thuận (tệp hoặc tham chiếu)',
            agreementHint: 'Thỏa thuận được ghi nhận theo tham chiếu.',
            fScope: 'Phạm vi giao dịch tự động',
            fScopeItem: 'Loại giao dịch',
            scopeHint: 'Thêm từng loại một.',
            addScope: 'Thêm vào phạm vi',
            removeScope: 'Xóa',
            fPerTransaction: 'Hạn mức mỗi giao dịch (VND)',
            fPerDay: 'Hạn mức mỗi ngày (VND)',
            perDayHint: 'Đối chiếu với trần mà khung tuân thủ đã cài đặt công bố.',
            fValidFrom: 'Hiệu lực từ',
            fValidUntil: 'Hiệu lực đến',
            fSuspension: 'Điều kiện tạm dừng',
            fTermination: 'Tham chiếu điều khoản chấm dứt của khách hàng',
            fIdentity: 'Tuyên bố xác minh danh tính',
            identityHint: 'Do người đã kiểm tra việc xác minh nhập. Nền tảng không kiểm tra sinh trắc học.',
            fPauseTool: 'Tham chiếu công cụ tạm dừng hoặc hủy của khách hàng',
            fLead: 'Người phụ trách thanh toán',
            eventTitle: 'Ghi nhận sự kiện',
            eventSubmit: 'Lưu sự kiện',
            eventKind: {
                activate: 'Kích hoạt',
                suspend: 'Tạm dừng',
                revoke: 'Thu hồi',
                execution_summary: 'Tóm tắt thực hiện',
            },
            fEventKind: 'Sự kiện',
            fReportedAt: 'Thời điểm báo cáo',
            reportedHint: 'Thời điểm dừng được báo cáo.',
            fImplementedAt: 'Thời điểm thực hiện',
            implementedHint: 'Để trống cho đến khi việc dừng được thực hiện; trạng thái khi đó là chưa có bằng chứng.',
            fReason: 'Lý do',
            fCustomerRef: 'Tham chiếu khách hàng',
            fExecutedOn: 'Ngày thực hiện',
            fTxCount: 'Số giao dịch',
            fLargest: 'Giao dịch lớn nhất (VND)',
            fLargestRef: 'Tham chiếu giao dịch lớn nhất',
            fDailyTotal: 'Tổng trong ngày (VND)',
        },
        interventions: {
            heading: 'Giám sát và can thiệp của con người',
            description: 'Mỗi can thiệp được ghi nhận kèm lý do. Tạm dừng hoặc dừng hiển thị là đã yêu cầu cho đến khi một người nhập thời điểm được xác nhận.',
            add: 'Ghi nhận can thiệp',
            empty: 'Chưa có can thiệp nào được ghi nhận.',
            colKind: 'Loại',
            colContent: 'Nội dung thay đổi',
            colReason: 'Lý do',
            colReading: 'Trạng thái',
            colRequested: 'Yêu cầu lúc',
            colConfirmed: 'Xác nhận lúc',
            kind: {
                content_change: 'Thay đổi nội dung',
                override: 'Ghi đè',
                pause: 'Tạm dừng',
                stop: 'Dừng',
                emergency_stop: 'Dừng khẩn cấp',
                manual_operation: 'Vận hành thủ công',
                resume: 'Tiếp tục',
            },
            confirm: 'Nhập thời điểm xác nhận',
            formTitle: 'Ghi nhận can thiệp',
            submit: 'Lưu can thiệp',
            fKind: 'Loại',
            fContent: 'Nội dung thay đổi',
            fReason: 'Lý do',
            fRequestedAt: 'Thời điểm yêu cầu',
            requestedHint: 'Bắt buộc với tạm dừng, dừng, dừng khẩn cấp hoặc vận hành thủ công.',
            confirmTitle: 'Nhập thời điểm được xác nhận',
            confirmSubmit: 'Lưu thời điểm xác nhận',
            fConfirmedAt: 'Thời điểm được xác nhận trong hệ thống của ngân hàng',
            confirmedHint: 'Lấy từ hệ thống của ngân hàng; nền tảng không đọc dữ liệu này.',
            alreadyRetired: 'Hệ thống này đã ngừng hoạt động.',
            retireHeading: 'Ngừng hoạt động',
            retireSectionDescription: 'Cho hệ thống này ngừng hoạt động khi không còn sử dụng; việc này cần một bản ghi ngừng hoạt động.',
            retire: 'Ngừng hoạt động hệ thống này',
            retireTitle: 'Ngừng hoạt động hệ thống này',
            retireDescription: 'Hệ thống đã ngừng hoạt động cần bản ghi ngừng hoạt động: tài liệu lưu phục vụ kiểm toán, và cách dữ liệu, mô hình và cấu hình được xử lý hoặc cô lập.',
            retireSubmit: 'Ngừng hoạt động',
            decom: {
                documents_retained_for_audit: 'Tài liệu lưu phục vụ kiểm toán',
                data_disposition: 'Cách xử lý dữ liệu',
                model_disposition: 'Cách xử lý mô hình',
                configuration_disposition: 'Cách xử lý cấu hình',
            },
            colChannel: 'Kênh',
            colDecision: 'Quyết định',
            fChannel: 'Kênh',
            fDecision: 'Mã quyết định',
            decisionHint: 'Bắt buộc với thay đổi nội dung, ghi đè hoặc vận hành thủ công. Để trống đối với tạm dừng, dừng, dừng khẩn cấp hoặc tiếp tục.',
            fResumes: 'Can thiệp được tiếp tục',
            resumeHint: 'Tạm dừng, dừng hoặc dừng khẩn cấp mà việc tiếp tục này nối theo.',
            requestedNote: 'Thời điểm yêu cầu được ghi nhận khi bạn lưu.',
            approve: 'Phê duyệt',
            awaitingApproval: 'Chờ người thứ hai',
            colApproval: 'Người thứ hai',
            approved: 'Đã phê duyệt',
            notRequired: 'Không cần',
        },
        channels: {
            heading: 'Kênh và tuyến giám sát',
            description: 'Mỗi kênh có hỗ trợ AI của hệ thống này, cùng tuyến giám sát phụ trách kênh. Can thiệp và thông báo đều nêu tên kênh.',
            add: 'Ghi nhận kênh',
            empty: 'Chưa có kênh nào được ghi nhận cho hệ thống này.',
            colName: 'Kênh',
            colLine: 'Tuyến giám sát',
            colRecorded: 'Ghi nhận ngày',
            export: 'Xuất nhật ký và thông báo về AI',
            formTitle: 'Ghi nhận kênh',
            submit: 'Lưu kênh',
            fName: 'Tên kênh',
            fLine: 'Tuyến giám sát',
            lineHint: 'Đơn vị hoặc vai trò giám sát kênh này.',
            exportTitle: 'Xuất nhật ký kênh',
            exportSubmit: 'Xuất',
            exportFrom: 'Từ ngày',
            exportTo: 'Đến ngày',
            colDualControl: 'Kiểm soát kép',
            fDualControl: 'Người thứ hai phê duyệt từng lần tạm dừng, dừng và tiếp tục',
            dualControlHint: 'Khi bật, tạm dừng, dừng và tiếp tục chỉ có hiệu lực sau khi người thứ hai phê duyệt. Dừng khẩn cấp không bao giờ bị giữ lại.',
            registerExport: 'Xuất sổ tạm dừng và dừng',
            registerTitle: 'Xuất sổ tạm dừng và dừng',
        },
        channelStatus: {
            heading: 'Trạng thái từng kênh',
            description: 'Trạng thái hiện tại của mỗi kênh, đọc từ hồ sơ kênh: thông báo đang sử dụng, phiên bản chờ người thứ hai, và can thiệp còn mở. Chỉ đọc.',
            empty: 'Chưa có kênh nào được ghi nhận cho hệ thống này.',
            colChannel: 'Kênh',
            colState: 'Trạng thái',
            colDisclosures: 'Thông báo đang sử dụng',
            colAwaiting: 'Chờ người thứ hai',
            colOpen: 'Can thiệp còn mở',
            noneOpen: 'Không có',
            openAwaiting: 'chờ người thứ hai',
            openUnanswered: 'leo thang chưa được phản hồi',
            openRequested: 'chờ hệ thống ngân hàng xác nhận',
            state: {
                running: 'Đang chạy',
                paused: 'Đang tạm dừng',
                stopped: 'Đã dừng',
                emergency_stopped: 'Đã dừng khẩn cấp',
            },
        },
        escalations: {
            heading: 'Leo thang và phản hồi',
            description: 'Mỗi can thiệp được leo thang lên người phụ trách hệ thống để phân tích nguyên nhân và lên tuyến bảo vệ thứ hai cho báo cáo hội đồng. Mỗi leo thang mở cho đến khi người nhận ghi nhận phản hồi.',
            empty: 'Chưa có leo thang nào.',
            colAddressee: 'Gửi tới',
            colIntervention: 'Can thiệp',
            colRaised: 'Ngày leo thang',
            colResponse: 'Phản hồi',
            none: 'Chưa nêu tên ai; việc được giao cho người đã ghi nhận.',
            respond: 'Ghi nhận phản hồi',
            respondTitle: 'Ghi nhận phản hồi',
            respondSubmit: 'Lưu phản hồi',
            fResponse: 'Phản hồi',
            responseHint: 'Chỉ ghi nhận một lần, kèm tên người phản hồi và thời điểm.',
            addressee: {
                owner: 'Người phụ trách hệ thống',
                second_line: 'Tuyến bảo vệ thứ hai',
            },
            colAnsweredAs: 'Trả lời với tư cách',
            answeredAs: {
                owner: 'Người phụ trách hệ thống',
                attest_fallback: 'Người có quyền xác nhận, thay cho người phụ trách hệ thống',
            },
        },
        briefings: {
            heading: 'Tập huấn nhân viên về giới hạn của hệ thống',
            description: 'Ai đã được tập huấn, khi nào và theo phiên bản quy trình nào. Việc hoàn thành đào tạo được lưu trong sổ đào tạo.',
            add: 'Ghi nhận tập huấn',
            empty: 'Chưa có tập huấn nào được ghi nhận.',
            colDate: 'Ngày tập huấn',
            colProcedure: 'Phiên bản quy trình',
            colAttendees: 'Người được tập huấn',
            formTitle: 'Ghi nhận tập huấn',
            submit: 'Lưu tập huấn',
            fDate: 'Ngày tập huấn',
            fLimits: 'Giới hạn đã trình bày',
            fProcedure: 'Phiên bản quy trình',
            fAttendees: 'Nhân viên được tập huấn (mã người dùng, cách nhau bằng dấu phẩy)',
            fTraining: 'Mã bản ghi đào tạo (không bắt buộc)',
            addAttendee: 'Thêm người này',
            removeAttendee: 'Bỏ',
        },
        monitoring: {
            heading: 'Giám sát hiệu năng và hành vi',
            description: 'So sánh kết quả dự báo với kết quả thực tế được nhập thủ công hoặc nhập từ tệp, ngưỡng do người phụ trách hệ thống đặt, và các sự kiện mở cho đến khi có người đóng.',
            addComparison: 'Ghi nhận so sánh',
            addEvent: 'Ghi nhận sự kiện',
            setThresholds: 'Đặt ngưỡng',
            eventsHeading: 'Sự kiện',
            eventsEmpty: 'Chưa có sự kiện nào được ghi nhận.',
            comparisonsHeading: 'So sánh',
            comparisonsEmpty: 'Chưa có so sánh nào được ghi nhận.',
            colReading: 'Trạng thái',
            colKind: 'Loại',
            colDetected: 'Phát hiện ngày',
            colDescription: 'Mô tả',
            colResponse: 'Phản hồi',
            colMetric: 'Chỉ số',
            colMeasured: 'Đo ngày',
            colPredicted: 'Dự báo',
            colActual: 'Thực tế',
            colDeviation: 'Độ lệch',
            colCrossed: 'Vượt ngưỡng',
            crossedYes: 'Có',
            crossedNo: 'Không',
            close: 'Đóng kèm phản hồi',
            kind: {
                output_deviation: 'Lệch đầu ra',
                quality_decline: 'Suy giảm chất lượng',
                bias: 'Thiên lệch',
                model_drift: 'Trôi dạt mô hình',
                data_drift: 'Trôi dạt dữ liệu',
                threshold_crossing: 'Vượt ngưỡng',
            },
            source: { entered: 'Do người nhập', imported: 'Nhập khẩu' },
            eventTitle: 'Ghi nhận sự kiện',
            submitEvent: 'Lưu sự kiện',
            fKind: 'Loại',
            fDescription: 'Mô tả',
            fMetric: 'Chỉ số',
            comparisonTitle: 'Ghi nhận so sánh',
            submitComparison: 'Lưu so sánh',
            fMeasuredOn: 'Ngày đo',
            fPredicted: 'Giá trị dự báo',
            fActual: 'Giá trị thực tế',
            fSource: 'Nguồn',
            closeTitle: 'Đóng sự kiện',
            submitClose: 'Đóng sự kiện',
            fResponse: 'Phản hồi',
            thresholdsTitle: 'Ngưỡng',
            submitThresholds: 'Lưu ngưỡng',
            thresholdLegend: 'Ngưỡng {n}',
            fMaxDeviation: 'Độ lệch tối đa được phép',
            addThreshold: 'Thêm ngưỡng',
        },
        duties: {
            heading: 'Người giữ nhiệm vụ và năng lực',
            description: 'Những người được nêu cho nhiệm vụ giám sát, phát hiện lệch hoặc can thiệp. Đào tạo được đối chiếu với một phân công đã hoàn thành; rà soát năng lực đến hạn hằng năm.',
            add: 'Nêu người giữ nhiệm vụ',
            capacity: 'Ghi nhận năng lực',
            empty: 'Chưa nêu người giữ nhiệm vụ nào.',
            colPerson: 'Người',
            colDuty: 'Nhiệm vụ',
            colTraining: 'Đào tạo',
            colCompetence: 'Rà soát năng lực',
            colDue: 'Đến hạn rà soát',
            duty: { monitor: 'Giám sát', detect_deviation: 'Phát hiện lệch', intervene: 'Can thiệp' },
            review: 'Ghi nhận rà soát năng lực',
            addTitle: 'Nêu người giữ nhiệm vụ',
            submit: 'Lưu người giữ nhiệm vụ',
            fPerson: 'Người',
            fDuty: 'Nhiệm vụ',
            fTraining: 'Tham chiếu phân công đào tạo (không bắt buộc)',
            trainingHint: 'Hoàn thành đào tạo chỉ được tính với một phân công đã hoàn thành.',
            reviewTitle: 'Rà soát năng lực',
            submitReview: 'Lưu rà soát',
            fReviewedOn: 'Ngày rà soát',
            fSummary: 'Tóm tắt rà soát',
            capacityTitle: 'Bản ghi năng lực',
            submitCapacity: 'Lưu năng lực',
            fBasis: 'Cơ sở',
            basis: {
                unit_builds_or_runs: 'Đơn vị tự xây dựng hoặc vận hành hệ thống',
                outsourced: 'Thuê ngoài',
            },
            fCapacity: 'Tuyên bố về năng lực',
            fSupplierName: 'Tên nhà cung cấp',
            supplierHint: 'Bắt buộc với hệ thống thuê ngoài.',
            fSupplierCapacity: 'Tuyên bố về năng lực của nhà cung cấp',
            fAssessedOn: 'Ngày đánh giá nhà cung cấp',
        },
        bankingTriggers: {
            heading: 'Ngưỡng ngân hàng',
            intro: 'Dữ kiện về ngưỡng được ghi nhận cho hệ thống này, đối chiếu với các ngưỡng do khung tuân thủ đã cài đặt quy định. Khi các ngưỡng áp dụng cho hệ thống và có dữ kiện vượt ngưỡng, nền tảng đưa ra một đề xuất phân loại, hiển thị tại đây và trong phần rà soát phân loại. Con người phân loại; nền tảng không xác định mức độ rủi ro.',
            listLabel: 'Thuộc một mục rủi ro cao của danh mục chính thức (theo các điều kiện ngoài mức giá trị)',
            listStatus: { listed: 'Thuộc một mục', not_listed: 'Không thuộc mục nào' },
            listNotRecorded: 'Chưa ghi nhận',
            listRecorded: 'Do {user} ghi nhận ngày {date}',
            listHint: 'Ghi nhận trên biểu mẫu hệ thống: hệ thống có đáp ứng các điều kiện của một mục rủi ro cao trong danh mục chính thức hay không, ngoài mức giá trị giao dịch hoặc khoản vay do các ngưỡng quy định. Bạn ghi nhận câu trả lời; nền tảng không quyết định thay bạn.',
            preconditionLabel: 'Điều kiện tiên quyết',
            precondition: 'Các ngưỡng chỉ áp dụng cho hệ thống thuộc một mục của {list}, theo các điều kiện của mục đó ngoài mức giá trị ({provision}).',
            preconditionNone: 'Không có khung tuân thủ đã cài đặt nào quy định điều kiện tiên quyết: các ngưỡng áp dụng cho mọi hệ thống.',
            scopeLabel: 'Phạm vi áp dụng',
            scope: {
                applies: 'Các ngưỡng áp dụng cho hệ thống này',
                not_applicable: 'Không thuộc mục nào của danh mục: không có ngưỡng ngân hàng nào áp dụng',
                not_recorded: 'Chưa ghi nhận: chưa biết các ngưỡng có áp dụng cho hệ thống này hay không',
                precondition_unreadable: 'Không đọc được điều kiện tiên quyết do khung tuân thủ đã cài đặt quy định, nên nền tảng không thể cho biết các ngưỡng có áp dụng cho hệ thống này hay không và không đưa ra đề xuất',
            },
            factsNotRecorded: 'Chưa ghi nhận dữ kiện về ngưỡng cho hệ thống này.',
            noThresholds: 'Không có khung tuân thủ đã cài đặt nào quy định ngưỡng ngân hàng.',
            unreadable: 'Không đọc được {count} nội dung do khung tuân thủ đã cài đặt quy định.',
            exceedancesHeading: 'Các ngưỡng bị vượt',
            noExceedance: 'Không có dữ kiện đã ghi nhận nào vượt ngưỡng đã quy định.',
            colThreshold: 'Ngưỡng kích hoạt',
            colValue: 'Giá trị đã ghi nhận (đồng)',
            colAmount: 'Mức ngưỡng (đồng)',
            colProvision: 'Quy định',
            measure: {
                per_transaction_payment: 'Một giao dịch thanh toán',
                daily_total_per_customer: 'Tổng giao dịch trong ngày của một khách hàng',
                credit_amount: 'Khoản cấp tín dụng',
            },
            customerClass: {
                individual: 'khách hàng cá nhân',
                organisation: 'khách hàng tổ chức',
                any: 'mọi khách hàng',
            },
            comparison: { greater_than: 'trên', greater_or_equal: 'từ' },
            thresholdLabel: '{measure}, {class}: {comparison} mức ngưỡng',
            proposalHeading: 'Đã đưa ra đề xuất phân loại',
            proposalText: 'Hãy chạy sàng lọc phân loại để rà soát các trường hợp này: phần rà soát phân loại hiển thị chúng bên cạnh mục chọn mức độ rủi ro. Mức độ rủi ro là mức do người rà soát ghi nhận tại đó.',
            noProposal: 'Chưa có đề xuất phân loại nào được đưa ra.',
            reviewProposalHeading: 'Đề xuất theo ngưỡng ngân hàng cho lần rà soát này',
            reviewProposalIntro: 'Hệ thống này được ghi nhận là thuộc một mục rủi ro cao của danh mục chính thức do khung tuân thủ đã cài đặt nêu, và có dữ kiện đã ghi nhận vượt các ngưỡng dưới đây. Hãy cân nhắc trong lần rà soát này; mức độ rủi ro là mức do bạn ghi nhận.',
            reviewProposalIntroNoPrecondition: 'Có dữ kiện đã ghi nhận của hệ thống này vượt các ngưỡng dưới đây, là các ngưỡng mà khung tuân thủ đã cài đặt áp dụng cho mọi hệ thống. Hãy cân nhắc trong lần rà soát này; mức độ rủi ro là mức do bạn ghi nhận.',
            reviewProposalItem: '{threshold}: {value} đồng so với {amount} đồng ({provision})',
        },
        systemDates: {
            heading: 'Nghĩa vụ có thời hạn đối với hệ thống này',
            intro: 'Các ngày có hiệu lực do khung tuân thủ đã cài đặt quy định, áp dụng cho hệ thống này: hệ thống đã vận hành trước ngày khung tuân thủ có hiệu lực hay chưa, và tổ chức của bạn có hệ thống ở mức độ rủi ro mà ngoại lệ nêu hay không.',
            inOperationSince: 'Đưa vào vận hành chính thức từ ngày',
            inOperationNotRecorded: 'Chưa ghi nhận. Ghi nhận trên biểu mẫu hệ thống; cho đến khi đó, ngày phụ thuộc vào thông tin này không được hiển thị.',
            empty: 'Không có khung tuân thủ đã cài đặt nào quy định nghĩa vụ có thời hạn cho hệ thống AI.',
            colReference: 'Quy định về hiệu lực',
            colDate: 'Ngày đối với hệ thống này',
            colReason: 'Lý do',
            colSource: 'Căn cứ',
            noDate: 'Không có ngày',
            notStated: 'ngày không được nêu',
            partNotNamed: 'các quy định không thuộc giai đoạn chuyển tiếp',
            decidedBy: 'Đối với hệ thống đã đưa vào vận hành chính thức trước ngày {cutoff}, {reference} quy định ngày khác cho toàn bộ hoặc một phần quy định này.',
            decidedByRow: 'Đối với hệ thống đã đưa vào vận hành chính thức trước ngày {cutoff}, {reference} quy định ngày khác cho toàn bộ hoặc một phần quy định này — xem dòng đó.',
            reason: {
                every_system: 'Cùng một ngày cho mọi hệ thống',
                unit_condition_not_held: 'Không có hệ thống nào của tổ chức được ghi nhận ở mức {tier}, là mức độ rủi ro mà ngoại lệ nêu, nên ngày được quy định áp dụng cho mọi hệ thống',
                unit_condition_undetermined: 'Phụ thuộc vào việc phân loại: {count} hệ thống của tổ chức chưa được phân loại. Nếu hệ thống đó được phân loại {tier}, áp dụng ngày {cutoffDate}; nếu không, áp dụng ngày {date}.',
                unit_condition_undetermined_plural: 'Phụ thuộc vào việc phân loại: {count} hệ thống của tổ chức chưa được phân loại. Nếu có hệ thống nào được phân loại {tier}, áp dụng ngày {cutoffDate}; nếu không, áp dụng ngày {date}.',
                new_systems_only: 'Chỉ áp dụng cho hệ thống đưa vào vận hành từ ngày {cutoff} trở đi',
                new_system_in_stated_period: 'Đưa vào vận hành từ ngày {cutoff} trở đi: ngày này áp dụng nếu thời điểm đó nằm trong thời hạn mà quy định nêu',
                existing_system: 'Đã vận hành trước ngày {cutoff}',
                existing_system_moved: 'Đã vận hành trước ngày {cutoff}: áp dụng ngày chuyển tiếp',
                existing_system_partly_moved: 'Đã vận hành trước ngày {cutoff}: ngày này áp dụng cho các quy định không thuộc giai đoạn chuyển tiếp; các quy định còn lại xem giai đoạn đó',
                new_system: 'Đưa vào vận hành từ ngày {cutoff} trở đi',
                unit_holds_tier: 'Tổ chức của bạn có hệ thống được phân loại {tier}, là mức độ rủi ro mà ngoại lệ nêu',
                existing_systems_only: 'Chỉ áp dụng cho hệ thống đã vận hành trước ngày {cutoff}',
                operation_start_not_recorded: 'Phụ thuộc vào ngày hệ thống được đưa vào vận hành, là thông tin chưa được ghi nhận',
                every_system_in_part: 'Áp dụng cho {part} đối với mọi hệ thống; đối với phần còn lại, phụ thuộc vào ngày hệ thống được đưa vào vận hành, là thông tin chưa được ghi nhận',
                declaration_unreadable: 'Không đọc được ngày có hiệu lực do khung tuân thủ đã cài đặt quy định cho nghĩa vụ này',
                applies_through_condition_met: 'Đã vận hành trước ngày {cutoff} và mức tự chủ được ghi nhận có tự động hóa việc thực hiện quyết định: quy định áp dụng cho hệ thống thông qua quy định khác từ ngày này',
                applies_through_condition_not_met: 'Đã vận hành trước ngày {cutoff} và mức tự chủ được ghi nhận không tự động hóa việc thực hiện quyết định: áp dụng ngày dành cho hệ thống đã vận hành',
                applies_through_condition_not_recorded: 'Phụ thuộc vào mức tự chủ, hiện chưa được ghi nhận: ngày {dateMet} nếu hệ thống tự động hóa việc thực hiện quyết định, ngày {dateNotMet} nếu không. Không có mục nào bị coi là quá hạn.',
            },
            // fix-sprint-20261031-1200 F39(e) — a provision brought in through another, with its reading.
            throughNote: '{provision} thông qua {via}: {reading}',
        },
        inventoryRegister: {
            heading: 'Tính đầy đủ của danh mục',
            statement: 'Danh mục này gồm các hệ thống trí tuệ nhân tạo đã được ghi nhận trong ComplianceOne và các mục kế thừa được nhập từ danh mục hiện có của tổ chức. Danh mục chỉ thể hiện những gì đã được ghi nhận: hệ thống nào chưa ai ghi nhận thì không nằm trong đây.',
            recordedSystems: 'Hệ thống đã ghi nhận',
            legacyEntries: 'Mục kế thừa đã nhập',
            noImport: 'Chưa có lần nhập kế thừa nào.',
            lastImport: 'Lần nhập gần nhất',
            received: 'Đã nhận',
            imported: 'Đã nhập',
            notImported: 'Chưa nhập',
            refusalHeading: 'Các dòng chưa được nhập',
            colRow: 'Dòng',
            colName: 'Tên',
            colReason: 'Lý do',
            refusal: {
                name_missing: 'Thiếu tên',
                already_registered: 'Đã được ghi nhận',
                duplicate_in_batch: 'Lặp lại trong tệp này',
            },
            importHeading: 'Nhập từ danh mục kế thừa',
            importHint: 'Mỗi dòng một hệ thống: tên | mã tham chiếu cũ | người phụ trách như đã ghi | trạng thái như đã ghi. Tên đã có trong danh mục, hoặc lặp lại trong tệp, sẽ không được nhập.',
            importField: 'Các dòng từ danh mục hiện có',
            importSource: 'Nhãn nguồn',
            importSubmit: 'Nhập các dòng',
            importDone: 'Đã ghi nhận lần nhập.',
            importFailed: 'Lần nhập chưa được ghi nhận.',
            importEmpty: 'Nhập ít nhất một dòng.',
            legacyHeading: 'Mục kế thừa đã nhập',
            legacyEmpty: 'Chưa có mục kế thừa nào được nhập.',
            colLegacyRef: 'Mã tham chiếu cũ',
            colOwnerRecorded: 'Người phụ trách như đã ghi',
            colStatusRecorded: 'Trạng thái như đã ghi',
            colImportedOn: 'Nhập ngày',
            colTier: 'Mức độ rủi ro',
            notClassified: 'Chưa phân loại',
            importedMarker: 'Đã nhập',
            obligationsHeading: 'Nghĩa vụ có thời hạn',
            obligationsHint: 'Các ngày mà công cụ AI đã cài đặt quy định, mỗi ngày kèm trạng thái và nguồn được đọc. Phạm vi áp dụng của từng ngày, kể cả quy định chuyển tiếp hoặc ngoại lệ, nằm ở cột riêng, theo đúng cách khung tuân thủ đã cài đặt diễn đạt.',
            obligationsEmpty: 'Không có công cụ AI đã cài đặt nào quy định nghĩa vụ có thời hạn.',
            colReference: 'Điều khoản',
            colFramework: 'Công cụ',
            colStatus: 'Trạng thái',
            colDate: 'Ngày hoặc thời hạn',
            colReasonNotEnforced: 'Vì sao chưa thi hành',
            colCarveOut: 'Phạm vi áp dụng của ngày',
            colSource: 'Nguồn bộ dữ liệu',
            noPeriod: 'Khung tuân thủ không quy định ngày hoặc thời hạn.',
            reasonNotApplicable: 'Không áp dụng',
            annualRecurrence: 'Hằng năm, chậm nhất ngày {day}/{month}',
            unitUnknown: '{amount} ({unit})',
            unit: {
                hours: 'giờ',
                days: 'ngày',
                working_days: 'ngày làm việc',
                calendar_days: 'ngày theo lịch',
                weeks: 'tuần',
                months: 'tháng',
                years: 'năm',
                annual: 'năm',
                working_days_before_event: 'ngày làm việc trước sự kiện',
                calendar_days_before_event: 'ngày theo lịch trước sự kiện',
                calendar_days_after_event: 'ngày theo lịch sau sự kiện',
                before_use: 'Trước khi đưa hệ thống vào sử dụng',
            },
            unitOne: {
                hours: 'giờ',
                days: 'ngày',
                working_days: 'ngày làm việc',
                calendar_days: 'ngày theo lịch',
                weeks: 'tuần',
                months: 'tháng',
                years: 'năm',
                annual: 'năm',
                working_days_before_event: 'ngày làm việc trước sự kiện',
                calendar_days_before_event: 'ngày theo lịch trước sự kiện',
                calendar_days_after_event: 'ngày theo lịch sau sự kiện',
            },
            periodRecurring: 'Mỗi {period}',
            noCarveOut: 'Khung tuân thủ đã cài đặt không nêu phạm vi riêng cho ngày này.',
            unitHoldsTier: 'Tổ chức của bạn có hệ thống được phân loại ở mức độ rủi ro mà ngoại lệ nêu, nên áp dụng ngày theo ngoại lệ. Nếu không có hệ thống như vậy, ngày áp dụng là {stated}.',
            status: {
                in_force: 'Đang có hiệu lực',
                upcoming: 'Sắp có hiệu lực',
                not_recorded: 'Chưa ghi nhận',
                not_enforced: 'Chưa thi hành',
            },
            reason: {
                reference_install: 'Chỉ cài đặt để tham khảo',
                not_operational: 'Không hoạt động với tổ chức này',
            },
            exportHeading: 'Xuất danh mục',
            exportIntro: 'Danh mục của toàn tổ chức dưới dạng tệp: mọi hệ thống và mục kế thừa đã nhập, kèm giới hạn đầy đủ ở phần đầu. Nền tảng không gán mức độ rủi ro nào.',
            exportButton: 'Xuất danh mục',
            exportFailed: 'Không thể xuất danh mục.',
        },
        evidenceIndex: {
            heading: 'Chỉ mục bằng chứng cho cơ quan quản lý',
            intro: 'Các bằng chứng hướng tới cơ quan quản lý mà hệ thống này đang giữ, theo từng khu vực, kèm nơi mỗi khu vực nằm.',
            colArea: 'Khu vực',
            colCount: 'Bản ghi',
            colLatest: 'Gần nhất',
            colWhere: 'Nằm ở đâu',
            none: 'Chưa ghi nhận',
            area: {
                classification: 'Lần phân loại',
                validation: 'Kiểm tra, đánh giá mô hình',
                security_tests: 'Kiểm thử bảo mật',
                interventions: 'Can thiệp',
                complaints: 'Khiếu nại',
                supplier_arrangements: 'Thỏa thuận nhà cung cấp',
            },
            where: {
                classification: 'Trang này, mục phân loại',
                validation: 'Trang này, mục kiểm tra, đánh giá mô hình',
                security_tests: 'Trang này, mục bảo mật',
                interventions: 'Trang này, mục can thiệp, và sổ can thiệp',
                complaints: 'Sổ khiếu nại',
                supplier_arrangements: 'Trang này, mục nhà cung cấp',
            },
        },
        suppliers: {
            heading: 'Thỏa thuận với nhà cung cấp',
            description: 'Thỏa thuận với một nhà cung cấp, đọc trên hồ sơ nhà cung cấp. Điều khoản không có trạng thái hiển thị chưa ghi nhận. Sổ đếm số điều khoản được ghi nhận có hiện diện trong tám điều khoản của Điều 18 khoản 3; không kết luận về hợp đồng.',
            add: 'Ghi nhận thỏa thuận',
            empty: 'Chưa có thỏa thuận nào với nhà cung cấp này.',
            vendorHint: 'Chọn nhà cung cấp để đọc các thỏa thuận của nhà cung cấp đó.',
            colPeriod: 'Kỳ',
            colClauses: 'Điều khoản',
            colCompliant: 'Điều khoản đã ghi nhận',
            colAssurance: 'Báo cáo đảm bảo',
            colTraining: 'Dữ liệu huấn luyện',
            compliantYes: 'Đủ tám điều khoản đã ghi nhận hiện diện',
            compliantNo: 'Chưa đủ tám điều khoản đã ghi nhận',
            expires: 'hết hạn',
            clause: {
                assurance_evidence: 'Bằng chứng đảm bảo',
                version_reporting: 'Báo cáo phiên bản',
                monitoring_access: 'Quyền truy cập giám sát',
                continuity_and_transition: 'Tính liên tục và chuyển đổi',
                regulatory_cooperation: 'Hợp tác với cơ quan quản lý',
                training_data_commitment: 'Cam kết về dữ liệu huấn luyện',
                it_service_contract_rules: 'Quy định về hợp đồng dịch vụ công nghệ thông tin',
                technical_information_and_limits: 'Thông tin kỹ thuật, giới hạn mô hình và biện pháp bảo mật',
            },
            clauseState: {
                present: 'Có',
                absent: 'Không có',
                pending: 'Chờ xử lý',
            },
            clauseHint: 'Chọn trạng thái; để trống nghĩa là chưa ghi nhận.',
            training: {
                commitment: 'Cam kết',
                consent: 'Đồng ý bằng văn bản',
                not_recorded: 'Chưa ghi nhận',
            },
            // Fix-sprint-20261031-1200 F32 — the supplier page's boundary statement.
            boundary: 'ComplianceOne ghi nhận nội dung hợp đồng và những gì nhà cung cấp đã báo cáo. ComplianceOne không kết nối với hệ thống của nhà cung cấp, không kiểm tra nội dung mô hình và không kết luận về hợp đồng; quyền truy cập phục vụ giám sát được chứng minh bằng bản ghi của tổ chức.',
            // F4 — the assurance warning period, and where its figure comes from.
            fWarnDays: 'Thời hạn cảnh báo (số ngày trước khi hết hạn)',
            warnDaysDefault: '30 ngày nếu tổ chức không đặt số khác. Đây là giá trị mặc định của ComplianceOne: khung tuân thủ đã cài đặt không quy định thời hạn cảnh báo.',
            warnDaysReading: 'Thời hạn cảnh báo: {days} ngày ({source})',
            warnDaysSource: {
                organisation: 'do tổ chức đặt',
                platform_default: 'giá trị mặc định của ComplianceOne',
            },
            // F35 — the training-data term read with its recorded position.
            trainingBasis: 'Điều 18 khoản 3 điểm h: Bên thứ ba cam kết không sử dụng dữ liệu của đơn vị để huấn luyện, tinh chỉnh hoặc cải thiện mô hình của bên thứ ba mà không có sự đồng ý bằng văn bản của đơn vị.',
            trainingTerm: {
                recorded: 'Đã ghi nhận cùng nội dung cam kết hoặc đồng ý',
                position_not_recorded: 'Chưa ghi nhận nội dung cam kết hoặc đồng ý: tám điều khoản chưa được xem là đã ghi nhận đủ',
                clause_not_present: 'Điều khoản chưa được ghi nhận là có',
            },
            fConsentReference: 'Mã văn bản đồng ý',
            fConsentBasis: 'Căn cứ đồng ý của tổ chức',
            consentBasisHint: 'Trường hợp có dữ liệu cá nhân, nhân sự bảo vệ dữ liệu cá nhân rà soát căn cứ này.',
            // F7 — the supplier record export per period.
            exportRecord: 'Xuất hồ sơ nhà cung cấp',
            exportTitle: 'Xuất hồ sơ nhà cung cấp',
            exportDescription: 'Các thỏa thuận có thời hạn trùng với kỳ, các điều khoản, các sự kiện có ngày trong kỳ và danh mục thành phần của từng hệ thống tại thời điểm cuối kỳ.',
            fExportPeriod: 'Kỳ',
            exportPeriodHint: 'Một năm (YYYY) hoặc một tháng (YYYY-MM).',
            fExportFormat: 'Định dạng tệp',
            exportFormat: { csv: 'CSV', xlsx: 'Excel (XLSX)', pdf: 'PDF' },
            exportSubmit: 'Xuất',
            exportFailed: 'Không thể xuất hồ sơ nhà cung cấp.',
            formTitle: 'Ghi nhận thỏa thuận với nhà cung cấp',
            submit: 'Lưu thỏa thuận',
            fVendor: 'Nhà cung cấp',
            fPeriodStart: 'Kỳ bắt đầu',
            fPeriodEnd: 'Kỳ kết thúc',
            fTrainingPosition: 'Nội dung cam kết hoặc đồng ý về dữ liệu huấn luyện',
            fTrainingScope: 'Phạm vi của sự đồng ý',
            colVersions: 'Báo cáo phiên bản',
            validationSigned: 'đã kiểm tra, đánh giá',
            validationUnknown: 'chưa rõ kết quả kiểm tra, đánh giá',
            recordedOn: 'Ghi nhận',
            fReviewCycle: 'Chu kỳ rà soát (tháng)',
            fReviewCycleHint: 'Chu kỳ rà soát của ngân hàng đối với thỏa thuận này. Để trống nếu không có chu kỳ.',
            fAssuranceRef: 'Mã báo cáo đảm bảo',
            fAssuranceStart: 'Kỳ báo cáo bắt đầu',
            fAssuranceEnd: 'Kỳ báo cáo kết thúc',
            fAssuranceExpires: 'Báo cáo hết hạn vào',
            colReadings: 'Kết luận theo ngày',
            readingReview: 'Rà soát',
            reviewNotSet: 'chưa đặt chu kỳ',
            reviewCurrent: 'đúng chu kỳ',
            reviewOverdue: 'quá hạn',
            reviewDueOn: 'đến hạn',
            assurance: {
                current: 'còn hiệu lực',
                expiring: 'sắp hết hạn',
                expired: 'đã hết hạn',
            },
            terminatedOn: 'Chấm dứt vào',
            chainFlagged: 'Thay đổi bên xử lý phụ chưa được rà soát',
            continuityTested: 'Lần thử nghiệm tính liên tục gần nhất',
            monitoringReviewed: 'Lần rà soát quyền truy cập giám sát gần nhất',
            regulatorContact: 'Đầu mối với cơ quan quản lý',
            regulatorRequests: 'Yêu cầu của cơ quan quản lý đã ghi nhận',
            addEvent: 'Ghi nhận sự kiện của nhà cung cấp',
            eventFormTitle: 'Ghi nhận sự kiện của nhà cung cấp',
            eventSubmit: 'Lưu sự kiện',
            fEventArrangement: 'Thỏa thuận',
            fEventKind: 'Sự kiện',
            eventKind: {
                model_version: 'Báo cáo phiên bản mô hình',
                sub_processor_change: 'Thay đổi bên xử lý phụ',
                termination: 'Chấm dứt',
                regulator_request: 'Yêu cầu của cơ quan quản lý',
                regulator_contact: 'Nêu tên đầu mối với cơ quan quản lý',
                continuity_test: 'Thử nghiệm tính liên tục',
                monitoring_access_review: 'Rà soát quyền truy cập giám sát',
                review: 'Rà soát thỏa thuận',
            },
            fModelVersion: 'Phiên bản mô hình',
            fSupplierReportedOn: 'Nhà cung cấp báo cáo vào',
            fSubProcessor: 'Bên xử lý phụ',
            fComponentRef: 'Thành phần thay đổi',
            fChangedOn: 'Thay đổi vào',
            fSummary: 'Tóm tắt',
            fEffectiveOn: 'Có hiệu lực từ',
            fReason: 'Lý do',
            fRequestReference: 'Mã yêu cầu',
            fReceivedOn: 'Nhận vào',
            fContactUserId: 'Đầu mối được nêu tên (người của tổ chức này)',
            fRoute: 'Đường đi của yêu cầu từ cơ quan quản lý',
            fTestedOn: 'Thử nghiệm vào',
            fReviewedOn: 'Rà soát vào',
            fOutcome: 'Kết quả',
        },
        panels: {
            heading: 'Nghĩa vụ theo loại',
            description: 'Mỗi loại liệt kê nghĩa vụ kèm trạng thái và tình trạng bằng chứng. Nghĩa vụ hoàn thành nhưng thiếu bằng chứng sẽ hiển thị cần bằng chứng.',
            kind: {
                human_oversight: 'Giám sát',
                transparency_labeling: 'Minh bạch và gắn nhãn',
                monitoring: 'Theo dõi',
                incident: 'Sự cố',
            },
            count: '{count} nghĩa vụ',
            empty: 'Chưa gắn nghĩa vụ nào thuộc loại này.',
            colDuty: 'Nghĩa vụ',
            colStatus: 'Trạng thái',
            colEvidence: 'Bằng chứng',
            evidence: {
                needs_evidence: 'Cần bằng chứng',
                evidenced: 'Đã ghi nhận bằng chứng',
                not_recorded: 'Chưa ghi nhận',
            },
            needsEvidenceWhy: 'Trạng thái không thể giữ là hoàn thành khi chưa có bản ghi bằng chứng.',
            edit: 'Chỉnh sửa',
        },
        registers: {
            backToRegister: 'Quay lại sổ đăng ký',
            inventoryGuide: 'Sử dụng trang này mỗi năm một lần: chọn kỳ, sau đó xác nhận từng hệ thống hoặc ghi nhận nội dung thay đổi. Hướng dẫn đầy đủ giải thích từng kết quả và khi nào một rà soát hiển thị quá hạn.',
            paymentGuide: 'Xem các ủy quyền thanh toán của một hệ thống AI, cùng hạn mức và nội dung còn thiếu của từng ủy quyền. Ủy quyền được ghi nhận và phê duyệt trên trang của chính hệ thống đó.',
            interventionsGuide: 'Xem các lần tạm dừng, dừng và can thiệp khác của con người được ghi nhận cho một hệ thống AI. Can thiệp được ghi nhận trên trang của chính hệ thống đó; hướng dẫn đầy đủ giải thích khi nào một can thiệp hiển thị là đã xác nhận.',
            complaintsGuide: 'Ghi nhận khiếu nại về quyết định chịu ảnh hưởng của AI, chuyển khiếu nại đến một người rà soát độc lập, ghi nhận mục được giữ lại không cung cấp cho khách hàng, sau đó ghi nhận rà soát lại và đóng khiếu nại. Bảng số lượng bên dưới cho biết khi nào một sản phẩm đạt ngưỡng do tổ chức của bạn đặt.',
            frameworkGuide: 'Ghi nhận khung quản trị rủi ro AI đã được phê duyệt và sơ đồ ba tuyến bảo vệ. Hướng dẫn đầy đủ giải thích khi nào một tuyến được coi là đầy đủ.',
            boardGuide: 'Đây là số liệu AI mà báo cáo hội đồng thể hiện, được đọc từ các sổ đăng ký tại thời điểm hiện tại. Bảng cho biết thời điểm số liệu được đọc. Để thay đổi một số liệu, hãy thay đổi sổ đăng ký mà số liệu đó được đọc từ.',
            systemsLoading: 'Đang tải danh sách hệ thống AI…',
            systemsFailed: 'Không thể đọc danh sách hệ thống AI.',
            systemsRetrySr: 'đọc lại danh sách hệ thống AI',
            systemsEmpty: 'Chưa có hệ thống AI nào được ghi nhận trong sổ đăng ký.',
            thresholdCurrent: 'Ngưỡng hiện tại',
            thresholdComplaints: '{count} khiếu nại',
            thresholdLoading: 'Đang tải ngưỡng…',
            thresholdFailed: 'Không thể đọc thiết lập ngưỡng.',
            thresholdRetrySr: 'đọc lại thiết lập ngưỡng',
            fSystem: 'Hệ thống AI',
            inventoryTitle: 'Rà soát kiểm kê hệ thống AI',
            inventorySubtitle: 'Rà soát hằng năm cho mọi hệ thống trí tuệ nhân tạo trong sổ đăng ký',
            inventorySummary: 'Mỗi hệ thống được xác nhận hoặc thay đổi bởi một người được nêu tên. Hệ thống chưa được xác nhận đến hạn sẽ hiển thị quá hạn.',
            inventoryHeading: 'Rà soát trong kỳ',
            inventoryEmpty: 'Không có hệ thống nào có rà soát cho kỳ này.',
            fPeriod: 'Kỳ',
            colSystem: 'Hệ thống',
            colPeriod: 'Kỳ',
            colDue: 'Hạn',
            colReading: 'Tình trạng',
            confirm: 'Xác nhận',
            confirmTitle: 'Xác nhận rà soát hằng năm',
            submit: 'Lưu',
            fOutcome: 'Kết quả',
            paymentTitle: 'Ủy quyền thanh toán',
            paymentSubtitle: 'Ủy quyền thanh toán tự động, theo hệ thống',
            paymentSummary: 'Chọn một hệ thống để đọc các ủy quyền thanh toán của hệ thống đó. Nền tảng ghi nhận từng ủy quyền; không thực hiện thanh toán.',
            paymentHeading: 'Ủy quyền của hệ thống',
            paymentEmpty: 'Hệ thống này chưa có ủy quyền thanh toán nào được ghi nhận.',
            openSystem: 'Mở hồ sơ hệ thống',
            interventionsTitle: 'Can thiệp',
            interventionsSubtitle: 'Bản ghi giám sát của con người, theo hệ thống',
            interventionsSummary: 'Chọn một hệ thống để đọc các can thiệp của hệ thống đó. Tạm dừng hoặc dừng hiển thị là đã yêu cầu cho đến khi một người nhập thời điểm được xác nhận.',
            interventionsHeading: 'Can thiệp của hệ thống',
            interventionsEmpty: 'Hệ thống này chưa có can thiệp nào được ghi nhận.',
            complaintsTitle: 'Khiếu nại về AI',
            complaintsSubtitle: 'Khiếu nại về quyết định chịu ảnh hưởng của AI, và việc rà soát lại bởi con người',
            complaintsSummary: 'Khiếu nại được chuyển đến một người rà soát không phải người phụ trách hệ thống cũng không phải người phát triển được nêu. Khiếu nại chỉ đóng khi đã ghi nhận rà soát lại.',
            complaintsHeading: 'Khiếu nại',
            complaintAdd: 'Ghi nhận khiếu nại',
            complaintsEmpty: 'Chưa có khiếu nại nào được ghi nhận.',
            colReceived: 'Ngày nhận',
            colProduct: 'Sản phẩm',
            colCategory: 'Loại quyết định',
            colStatus: 'Trạng thái',
            colReviewer: 'Người rà soát',
            colWithheld: 'Mục đã giữ lại',
            colReReview: 'Rà soát lại',
            reReviewRecorded: 'Đã ghi nhận',
            route: 'Chuyển',
            withhold: 'Giữ lại một mục',
            reReview: 'Rà soát lại',
            close: 'Đóng',
            countsHeading: 'Khiếu nại theo hệ thống và sản phẩm',
            countsEmpty: 'Chưa có khiếu nại nào được đếm.',
            colCount: 'Số lượng',
            colThreshold: 'Ngưỡng',
            thresholdNotSet: 'Chưa đặt',
            colCrossed: 'Vượt ngưỡng',
            crossedYes: 'Có',
            crossedNo: 'Không',
            setThreshold: 'Đặt ngưỡng',
            createTitle: 'Ghi nhận khiếu nại',
            fCategory: 'Loại quyết định',
            fReceivedOn: 'Ngày nhận',
            fSummary: 'Tóm tắt khiếu nại',
            fProduct: 'Sản phẩm',
            fStatedReason: 'Lý do đã nêu',
            fExplanation: 'Lời giải thích đã đưa',
            colBasis: 'Căn cứ quyết định',
            basisReading: {
                recorded: 'Đã ghi nhận căn cứ',
                basis_not_retained: 'Không lưu giữ căn cứ',
                reason_notified_basis_recorded: 'Đã thông báo lý do; có lưu căn cứ',
            },
            noDecision: 'Chưa liên kết quyết định',
            fDecision: 'Quyết định bị khiếu nại',
            fDecisionHint: 'Không bắt buộc. Quyết định được ghi trong sổ quyết định AI.',
            fExplanationDay: 'Ngày gửi lời giải thích',
            fExplanationChannel: 'Kênh gửi lời giải thích',
            fNotifiedMethod: 'Cách thông báo cho khách hàng',
            fNotifiedOn: 'Ngày thông báo cho khách hàng',
            exportFile: 'Xuất hồ sơ khiếu nại',
            routeTitle: 'Chuyển khiếu nại',
            fReviewer: 'Người rà soát',
            reviewerHint: 'Không phải người phụ trách hệ thống hoặc người phát triển được nêu.',
            submitRoute: 'Chuyển khiếu nại',
            withholdTitle: 'Giữ lại một mục',
            fWithheldItem: 'Mục được giữ lại',
            fWithheldReason: 'Lý do giữ lại',
            fWithheldCategory: 'Loại',
            withheldCategory: {
                source_code_algorithm_or_parameters: 'Mã nguồn, thuật toán chi tiết hoặc bộ tham số',
                business_or_technology_secret: 'Bí mật kinh doanh, bí mật công nghệ',
                third_party_information: 'Thông tin của bên thứ ba',
                security_sensitive: 'Nhạy cảm về bảo mật',
                restricted_decision: 'Quyết định bị hạn chế',
                other: 'Khác',
            },
            submitWithhold: 'Lưu mục',
            reviewTitle: 'Rà soát lại khiếu nại',
            fOutcomeSummary: 'Kết quả rà soát lại',
            reviewHint: 'Rà soát lại là căn cứ cuối cùng cho phản hồi. Kết quả rà soát lại được ghi nhận với mọi loại quyết định.',
            reviewReasonHint: 'Nội dung thông báo cho khách hàng. Với loại này, đơn vị chỉ cần thông báo lý do cho khách hàng; kết quả ở trên được lưu nội bộ.',
            submitReview: 'Lưu rà soát lại',
            thresholdTitle: 'Ngưỡng khiếu nại',
            fThresholdCount: 'Số khiếu nại làm phát sinh một công việc',
            thresholdHint: 'Tổ chức tự đặt con số này; quy định không đưa ra con số nào.',
            fSecondLine: 'Người phụ trách tuyến bảo vệ thứ hai',
            submitThreshold: 'Lưu ngưỡng',
            closeTitle: 'Đóng khiếu nại',
            closeHint: 'Máy chủ từ chối việc đóng khi chưa ghi nhận rà soát lại.',
            submitClose: 'Đóng khiếu nại',
            complaintsBoundary: 'ComplianceOne lưu giữ khiếu nại, căn cứ của quyết định và kết quả rà soát lại. ComplianceOne không đưa ra quyết định giải quyết khiếu nại và không soạn lời giải thích gửi khách hàng.',
            closeNeedsReReview: 'Khiếu nại này chưa có rà soát lại nên chưa thể đóng. Hãy ghi nhận rà soát lại trước.',
            fComplaintReason: 'Lý do khiếu nại',
            complaintReasonHint: 'Các nhóm do ComplianceOne đặt; Thông tư không quy định.',
            colComplaintReason: 'Lý do',
            complaintReason: {
                decision_outcome: 'Không đồng ý với kết quả quyết định',
                explanation: 'Yêu cầu giải thích hoặc giải thích chưa thỏa đáng',
                unfair_treatment: 'Đối xử không công bằng hoặc phân biệt đối xử',
                data_error: 'Dữ liệu sai hoặc không cập nhật',
                ai_interaction: 'Tương tác với hệ thống trí tuệ nhân tạo',
                service_failure: 'Lỗi hoặc gián đoạn của hệ thống',
                other: 'Khác',
                not_recorded: 'Chưa ghi nhận',
            },
            colAiSystem: 'Hệ thống AI',
            colCountInPeriod: 'Số khiếu nại trong kỳ',
            colByReason: 'Theo lý do',
            thresholdWithWindow: '{count} trong {months} tháng',
            thresholdNoWindow: 'tính trên mọi khiếu nại đã ghi nhận; chưa đặt khoảng thời gian',
            periodFrom: 'Từ tháng',
            periodTo: 'Đến tháng',
            periodHint: 'Mặc định là sáu tháng, tính đến hết tháng này.',
            exportTrend: 'Xuất xu hướng theo tháng',
            fThresholdWindow: 'Khoảng thời gian (tháng)',
            thresholdWindowHint: 'Không bắt buộc, từ 1 đến 12 tháng, tính đến hết tháng được đếm. Nếu để trống, mọi khiếu nại đã ghi nhận đều được đếm.',
            patternHeading: 'Phản hồi đối với một nhóm khiếu nại',
            patternLabel: 'Phản hồi của tổ chức đối với một nhóm khiếu nại. Thông tư không quy định ngưỡng hay cách phản hồi; ComplianceOne không quyết định.',
            patternEmpty: 'Chưa ghi nhận phản hồi nào đối với nhóm khiếu nại.',
            patternRespond: 'Ghi nhận phản hồi',
            patternTitle: 'Ghi nhận phản hồi đối với một nhóm khiếu nại',
            patternSubmit: 'Lưu phản hồi',
            fPatternKind: 'Việc tổ chức đã thực hiện',
            patternKind: {
                no_change_with_reason: 'Không thay đổi, có nêu lý do',
                revalidation_requested: 'Đã yêu cầu kiểm tra, đánh giá lại mô hình',
                intervention_recorded: 'Đã ghi nhận can thiệp',
                incident_recorded: 'Đã ghi nhận sự cố',
                change_recorded: 'Đã ghi nhận thay đổi',
                other: 'Khác',
            },
            fPatternLinked: 'Bản ghi liên quan',
            patternLinkedEmpty: 'Hệ thống này chưa có bản ghi loại này để liên kết.',
            patternRespondSr: 'cho {system}, {product}',
            patternRespondSrCrossed: 'cho {system}, {product}, vượt ngưỡng ngày {date}',
            patternCrossedOn: 'Vượt ngưỡng ngày {date}.',
            patternCrossingNote: 'Phản hồi này trả lời khiếu nại gần nhất làm số khiếu nại đạt ngưỡng. ComplianceOne xác định khiếu nại đó và ghi nhận ngày của khiếu nại cùng với phản hồi.',
            patternWho: 'Chỉ người phụ trách hệ thống, người phụ trách tuyến bảo vệ thứ hai được nêu trong thiết lập ngưỡng, hoặc người thuộc tuyến bảo vệ thứ hai trên sơ đồ ba tuyến bảo vệ hiện hành có vai trò trong sổ đăng ký là P-VN-42 mới ghi nhận được phản hồi.',
            patternLinkedLoading: 'Đang đọc các bản ghi của hệ thống này…',
            patternLinkedFailed: 'Không đọc được các bản ghi của hệ thống này.',
            patternLinkedRetrySr: 'đọc lại các bản ghi để liên kết',
            patternAlreadyAnswered: 'Lần vượt ngưỡng này đã có phản hồi.',
            periodInvalid: 'Một giai đoạn tối đa 60 tháng.',
            lineAddedInVersion: 'Người xác nhận được thêm vào tuyến này trong chính phiên bản họ xác nhận.',
            fPatternSummary: 'Nội dung đã thực hiện và lý do',
            fRespondedOn: 'Ngày phản hồi',
            colCrossedOn: 'Ngày vượt ngưỡng',
            colResponseKind: 'Phản hồi',
            colRespondedBy: 'Người phản hồi',
            colRespondedOn: 'Ngày phản hồi',
            colExplanations: 'Lời giải thích',
            explanationAdd: 'Ghi nhận lời giải thích',
            explanationTitle: 'Ghi nhận lời giải thích sau rà soát lại',
            explanationHint: 'Ghi nhận từng lời giải thích đã gửi cho khách hàng sau rà soát lại, đúng như đã gửi. Không bắt buộc phải có lời giải thích để đóng khiếu nại.',
            fExplanationText: 'Lời giải thích đã gửi',
            explanationSubmit: 'Lưu lời giải thích',
            explanationStage: {
                at_intake: 'Khi tiếp nhận',
                after_re_review: 'Sau rà soát lại',
            },
            frameworkTitle: 'Bản ghi khung và ba tuyến bảo vệ',
            frameworkSubtitle: 'Khung quản trị rủi ro và ba tuyến bảo vệ',
            frameworkSummary: 'Khung được phê duyệt bởi một cơ quan và người được nêu tên. Sơ đồ ba tuyến cho thấy đơn vị, con người và xác nhận của từng tuyến.',
            frameworkHeading: 'Khung quản trị rủi ro',
            frameworkAdd: 'Ghi nhận khung',
            frameworkEmpty: 'Chưa có khung nào được ghi nhận.',
            frameworkFormTitle: 'Ghi nhận khung',
            fFrameworkTitle: 'Tên khung',
            fApproverBody: 'Cơ quan phê duyệt',
            fApprover: 'Người phê duyệt',
            fApprovedOn: 'Ngày phê duyệt',
            fRiskCode: 'Mã loại rủi ro',
            fDefinition: 'Định nghĩa',
            fThresholds: 'Ngưỡng',
            fControls: 'Biện pháp kiểm soát',
            colTitle: 'Tên',
            colApprover: 'Người phê duyệt',
            colApproved: 'Phê duyệt ngày',
            colRiskTypes: 'Loại rủi ro',
            linesHeading: 'Ba tuyến bảo vệ',
            linesAdd: 'Ghi nhận sơ đồ',
            linesEmpty: 'Chưa có sơ đồ ba tuyến nào được ghi nhận.',
            linesFormTitle: 'Ghi nhận sơ đồ ba tuyến',
            linesFormDescription: 'Mỗi tuyến nêu đơn vị và những người phụ trách tuyến. Tuyến được xác nhận bởi một người có tên trong chính tuyến đó; tuyến chưa được xác nhận, hoặc được xác nhận bởi người không có tên trong tuyến, hiển thị chưa đầy đủ.',
            colVersion: 'Phiên bản',
            colIncomplete: 'Tuyến chưa đầy đủ',
            colLines: 'Các tuyến',
            attestedYes: 'đã xác nhận',
            attestedNo: 'chưa xác nhận',
            line: { first: 'Tuyến thứ nhất', second: 'Tuyến thứ hai', third: 'Tuyến thứ ba' },
            fUnit: 'Đơn vị',
            fHolder: 'Người',
            fRole: 'Vai trò',
            fPersona: 'Vai trò trong sổ đăng ký',
            fAttestation: 'Nội dung xác nhận',
            attestationHint: 'Do người ký nhập.',
            fAttested: 'Đã xác nhận',
            // Fix-sprint-20261031-1200 F32 — the framework and three-lines page's boundary statement.
            frameworkBoundary: 'ComplianceOne lưu giữ bản ghi khung, sơ đồ ba tuyến và xác nhận của từng tuyến do những người được nêu tên nhập. ComplianceOne không phê duyệt khung, không đánh giá tính độc lập của các tuyến và không xác nhận thay cho bất kỳ ai.',
            // F6 — one line per attestation, by one of that line's own holders.
            attestLine: 'Xác nhận tuyến này',
            attestTitle: 'Xác nhận {line}',
            attestDescription: 'Bạn có tên trong tuyến này. Xác nhận của bạn được ghi nhận dưới tên bạn, với ngày hôm nay.',
            submitAttest: 'Lưu xác nhận',
            lineAttestedOn: 'Đã xác nhận ngày {date}',
            lineCarried: 'Đã xác nhận ngày {date} (chuyển từ phiên bản {n})',
            lineNotAttested: 'Chưa xác nhận',
            lineNonHolder: 'Người xác nhận không có tên trong tuyến này: cần xác nhận lại.',
            sharedHolder: '{name} có tên ở {lineA} và {lineB}. Khoản 2 Điều 14 yêu cầu các tuyến bảo vệ độc lập.',
            lineLower: { first: 'tuyến thứ nhất', second: 'tuyến thứ hai', third: 'tuyến thứ ba' },
            lineJoin: ', ',
            boardTitle: 'Báo cáo hội đồng: số liệu AI',
            boardSubtitle: 'Số liệu AI trong báo cáo hội đồng, đọc từ các sổ đăng ký AI',
            boardSummary: 'Rà soát kiểm kê quá hạn tính các lần rà soát của năm dương lịch hiện tại. Một lần tạm dừng, dừng, dừng khẩn cấp, vận hành thủ công hoặc tiếp tục được tính là can thiệp đang mở từ khi được ghi nhận cho đến khi một người nhập thời điểm được xác nhận.',
            boardHeading: 'Số liệu hiện tại',
            boardEmpty: 'Sổ đăng ký không trả về số liệu AI nào.',
            colFigure: 'Số liệu',
            colValue: 'Giá trị',
            figSystems: 'Hệ thống AI',
            figLow: 'Rủi ro thấp',
            figMedium: 'Rủi ro trung bình',
            figHigh: 'Rủi ro cao',
            figUnclassified: 'Chưa phân loại',
            figOverdue: 'Rà soát kiểm kê quá hạn',
            figFindings: 'Phát hiện kiểm tra, đánh giá đang mở',
            figInterventions: 'Can thiệp đang mở',
            figDisclosures: 'Thông báo đang sử dụng',
            figAsOf: 'Tính đến',
        },
        // fix-sprint-20261031-1200 F1 and F34 — the periodic report contents, retirement and a change's significance.
        boardReport: {
            heading: 'Nội dung báo cáo định kỳ',
            intro: 'Các nội dung mà khung tuân thủ đã cài đặt nêu cho báo cáo gửi Hội đồng quản lý cấp cao, đọc từ các sổ đăng ký cho giai đoạn dưới đây. ComplianceOne đếm những gì các sổ đăng ký đang lưu; ComplianceOne không soạn và không trình báo cáo.',
            windowFrom: 'Giai đoạn từ ngày',
            windowTo: 'Giai đoạn đến ngày',
            applyWindow: 'Đọc cho giai đoạn này',
            windowInvalid: 'Nhập giai đoạn có ngày bắt đầu không sau ngày kết thúc.',
            statusComplete: 'Đọc năm nội dung khoản 6 Điều 12 nêu — tình hình vận hành, rủi ro, sự cố nghiêm trọng, khiếu nại và xu hướng sai lệch — từ các sổ đăng ký, cho giai đoạn {from} đến {to}. ComplianceOne không trình báo cáo lên Hội đồng quản lý cấp cao hoặc ngân hàng mẹ.',
            statusPartial: 'Chưa đầy đủ so với khoản 6 Điều 12: {gaps}. Số liệu dưới đây là những gì các sổ đăng ký đang lưu cho giai đoạn {from} đến {to}.',
            gapUnclassified: '{n} hệ thống chưa có mức độ rủi ro được ghi nhận nên chưa xác định được có thuộc phạm vi báo cáo hay không',
            gapSignificance: '{n} thay đổi của hệ thống rủi ro cao chưa có câu trả lời về tính đáng kể',
            gapOperationDate: '{n} hệ thống chưa ghi nhận ngày đưa vào vận hành nên chưa xác định được ngày phải báo cáo lần đầu',
            gapUnreadable: 'Không đọc được {content}',
            windowLonger: 'Giai đoạn này dài hơn sáu tháng, là tần suất tối thiểu văn bản quy định.',
            nextDue: 'Báo cáo tiếp theo đến hạn trước ngày {date} ({anchor})',
            anchorLastExport: 'tính từ lần xuất báo cáo Hội đồng gần nhất ngày {date}',
            anchorFirstApplies: 'tính từ ngày sớm nhất báo cáo áp dụng cho một hệ thống thuộc phạm vi, ngày {date}',
            nextDueNotDeclared: 'Chưa có ngày đến hạn tiếp theo: chưa có khung tuân thủ đã cài đặt đang có hiệu lực quy định chu kỳ báo cáo.',
            nextDueNoScope: 'Chưa có ngày đến hạn tiếp theo: không có hệ thống nào của tổ chức thuộc phạm vi báo cáo.',
            nextDueUnknown: 'Chưa xác định được ngày đến hạn tiếp theo: không có hệ thống nào thuộc phạm vi có ngày đưa vào vận hành.',
            autonomyNotRecorded: '{n} hệ thống thuộc phạm vi chưa ghi nhận mức tự chủ; ngày sớm hơn trong hai ngày có thể được dùng để tính.',
            colContent: 'Nội dung',
            opProduction: 'Hệ thống thuộc phạm vi đang vận hành chính thức',
            opInterventionsKind: 'Can thiệp được ghi nhận trong giai đoạn: {kind}',
            opChanges: 'Thay đổi phiên bản được ghi nhận trong giai đoạn',
            riskTier: 'Hệ thống thuộc phạm vi: {tier}',
            incSerious: 'Sự cố được xác định là nghiêm trọng trong giai đoạn',
            incUndetermined: 'Sự cố ghi nhận trong giai đoạn chưa xác định mức độ nghiêm trọng',
            incCompletion: 'Sự cố nghiêm trọng đã có báo cáo hoàn thành',
            cReceived: 'Khiếu nại tiếp nhận trong giai đoạn',
            cClosed: 'Khiếu nại đã đóng trong giai đoạn',
            cOpen: 'Khiếu nại đang mở hiện nay',
            cCrossings: 'Số lần vượt ngưỡng khiếu nại trong giai đoạn',
            driftRow: '{kind}: {now} trong giai đoạn; {before} từ {from} đến {to}',
            driftUnreadable: 'Sự kiện giám sát theo loại, trong giai đoạn và giai đoạn liền trước',
            nextDueUndated: 'Chưa có ngày đến hạn tiếp theo: khung tuân thủ đã cài đặt không nêu ngày bắt đầu áp dụng.',
            retrySr: 'đọc lại nội dung báo cáo định kỳ',
            gapRecordNotInstalled: 'Chưa có khung tuân thủ đã cài đặt nào quy định báo cáo gửi Hội đồng quản lý cấp cao nên chưa xác định được phạm vi, nội dung và chu kỳ báo cáo',
            changesHeading: 'Các thay đổi đã ghi nhận',
            changesEmpty: 'Chưa có thay đổi nào được ghi nhận.',
            colChangeRecorded: 'Ngày ghi nhận',
            significanceRecord: 'Ghi nhận tính đáng kể',
            significanceRecordSr: 'cho thay đổi ghi nhận ngày {date}',
            significanceBasisShort: 'Căn cứ',
            significanceChoose: 'Chọn có hoặc không.',
            significanceAnsweredBy: 'Do {user} trả lời ngày {date}',
            significanceAlreadyRecorded: 'Thay đổi này đã có câu trả lời về tính đáng kể.',
            significanceBasisRequired: 'Ghi nhận căn cứ cùng câu trả lời.',
            sigHeading: 'Thay đổi đáng kể của hệ thống rủi ro cao',
            sigSince: 'Được ghi nhận sau lần xuất báo cáo gần nhất ngày {date}.',
            sigSinceNone: 'Chưa có lần xuất báo cáo nào chứa các nội dung này nên mọi thay đổi đều được liệt kê.',
            sigEmpty: 'Chưa có thay đổi nào được ghi nhận là đáng kể.',
            sigRow: '{system}: {change} ({date})',
            sigNotRecorded: 'Thay đổi chưa có câu trả lời về tính đáng kể',
            retiredFigure: 'Hệ thống đã ngừng sử dụng',
            retiredOn: 'Đã ngừng sử dụng ngày {date}: không phải rà soát hằng năm sau khi ngừng sử dụng.',
            retiredNoDay: 'Đã ngừng sử dụng; chưa ghi nhận ngày ngừng sử dụng.',
            retiredReading: 'Đã ngừng sử dụng',
            significanceLabel: 'Thay đổi đáng kể',
            significanceHint: 'Thay đổi này có phải là thay đổi đáng kể theo khoản 9 Điều 2, là khoản dẫn chiếu các trường hợp phải đánh giá lại theo nghị định hướng dẫn pháp luật về trí tuệ nhân tạo, hay không. Một người ghi nhận câu trả lời và căn cứ; ComplianceOne không quyết định.',
            significanceYes: 'Có, là thay đổi đáng kể',
            significanceNo: 'Không, không phải thay đổi đáng kể',
            significanceBasis: 'Căn cứ của câu trả lời',
            significanceBasisHint: 'Bắt buộc khi có câu trả lời có hoặc không.',
        },
        incidentAi: {
            heading: 'Hệ thống AI trong sự cố này',
            description: 'Liên kết sự cố với hệ thống AI liên quan và ghi nhận các nghĩa vụ với sự cố nghiêm trọng của hồ sơ AI. Nền tảng không gửi báo cáo nào tới cơ quan Nhà nước.',
            fLink: 'Hệ thống AI',
            linkHint: 'Chọn hệ thống AI mà hoạt động của hệ thống liên quan đến sự cố này.',
            noProfiles: 'Chưa có hệ thống AI nào được ghi nhận cho tổ chức của bạn.',
            saveLink: 'Lưu liên kết',
            linkSaved: 'Đã liên kết với sự cố này.',
            recordHeading: 'Bản ghi sự cố nghiêm trọng',
            fSerious: 'Sự cố nghiêm trọng',
            seriousYes: 'Nghiêm trọng',
            seriousNo: 'Không nghiêm trọng',
            notDetermined: 'Chưa xác định',
            fSeriousBasis: 'Căn cứ xác định',
            basisHint: 'Xác định nghiêm trọng phát sinh một nhiệm vụ đánh giá lại cho người phụ trách hệ thống.',
            reassessment: 'Nhiệm vụ đánh giá lại đã phát sinh',
            reassessmentYes: 'Có, gửi người phụ trách hệ thống',
            reassessmentNo: 'Không',
            deadline: 'Hạn báo cáo',
            deadlineStatedOne: 'Chưa tính. {framework} không quy định thời hạn cho báo cáo này.',
            deadlineStatedMany: 'Chưa tính. {frameworks} không quy định thời hạn cho báo cáo này.',
            deadlineNoneDeclared: 'Chưa tính. Nền tảng không đặt ngày báo cáo cho sự cố này.',
            deadlineSeparateOne: '{framework} quy định thời hạn báo cáo đối với sự cố AI nghiêm trọng. Thời hạn áp dụng phụ thuộc vào cách xác định sự cố này, do một người ghi nhận, nên không có thời hạn nào được áp dụng tại đây.',
            deadlineSeparateMany: 'Thời hạn báo cáo đối với sự cố AI nghiêm trọng được quy định tại {frameworks}. Thời hạn áp dụng phụ thuộc vào cách xác định sự cố này, do một người ghi nhận, nên không có thời hạn nào được áp dụng tại đây.',
            deadlineRecordBelow: 'Ghi nhận báo cáo bạn đã gửi ở bên dưới.',
            notInForce: 'chưa có hiệu lực',
            stateReports: 'Báo cáo gửi cơ quan',
            authority: {
                competent_state_authority: 'Cơ quan Nhà nước có thẩm quyền',
                state_bank_it_department: 'Vụ Công nghệ thông tin Ngân hàng Nhà nước',
            },
            fRemediation: 'Khắc phục',
            fAuthority: 'Cơ quan đã nhận báo cáo',
            authorityHint: 'Ghi nhận mã tham chiếu của báo cáo do người thực hiện ngoài nền tảng lập.',
            fReportedOn: 'Ngày báo cáo',
            fReference: 'Mã tham chiếu của báo cáo',
            referenceHint: 'Mã do cơ quan cấp, hoặc mã trong hồ sơ của bạn.',
            completion: 'Báo cáo hoàn tất',
            fCause: 'Nguyên nhân',
            fDamage: 'Thiệt hại',
            fCompletedOn: 'Ngày hoàn tất',
            emergency: 'Dừng khẩn cấp hoặc vận hành thủ công',
            emergencyNote: 'Được ghi nhận như một can thiệp của hệ thống AI, kèm thời điểm và người thực hiện.',
            notification: 'Thông báo cho khách hàng',
            notificationNote: 'Đọc từ trạng thái thông báo của sự cố này, không sao chép tại đây.',
            status: 'Trạng thái sự cố nghiêm trọng',
            recordAction: 'Ghi nhận nghĩa vụ sự cố nghiêm trọng',
            recordTitle: 'Bản ghi sự cố nghiêm trọng',
            saveRecord: 'Lưu bản ghi',
        },
    },
    // Sprint 63.24.0 Slice A — controlled-testing case pages. Real copy (R-57).
    controlled_testing: {
        dossierChecklist: {
            heading: 'Tham chiếu thành phần hồ sơ theo chứng cứ',
            reference: 'Tham chiếu nguồn sửa đổi hiện hành',
            regime: 'Chưa xác định chế độ pháp lý này có áp dụng cho hồ sơ này hay không.',
            unassigned: 'Chưa xác định hướng hồ sơ. Các hướng nguồn bên dưới chỉ là tham chiếu chưa được chọn.',
            selected: 'Hướng hồ sơ theo chứng cứ đã chọn',
            unselected: 'Tham chiếu nguồn chưa chọn — không gán tình trạng chứng cứ của hồ sơ',
            observations: 'Dữ kiện chứng cứ hiện tại có thể được ghi sau ngày tham chiếu nộp hồ sơ hoặc vai trò. Các số lượng này không phản ánh hồ sơ tại thời điểm nộp và không đánh giá tính đầy đủ pháp lý.',
            recorded: 'Mục có dữ kiện đã ghi',
            partial: 'Mục có một phần dữ kiện',
            pending: 'Mục đang chờ',
            historical: 'Mục lịch sử',
            source: 'Nguồn',
            pages: 'Trang PDF',
            referenceOn: 'Ngày tham chiếu',
            filing: 'Ngày nộp dùng để xác định bối cảnh của hướng hồ sơ và vai trò',
            observedOn: 'Ngày quan sát dữ kiện hiện tại',
            as_of: 'Ngày hiện tại dùng để xác định bối cảnh của hướng hồ sơ và vai trò',
            context: 'Bối cảnh của hướng hồ sơ theo chứng cứ',
            form: 'Mẫu đơn',
            kind: 'Loại chủ thể',
            unknown: 'Chưa ghi nhận hoặc chưa xác định',
            noProjection: 'Chưa có dữ kiện đối chiếu tương ứng; cần rà soát.',
            person: 'Bản ghi nhân sự',
            factDate: 'Ngày tham chiếu dữ kiện thực tế',
            status: {
                available: 'Có tham chiếu nguồn',
                undeclared: 'Chưa khai báo danh mục thành phần hồ sơ.',
                unavailable: 'Danh mục thành phần hồ sơ chưa khả dụng; cần rà soát.',
                not_applicable: 'Không phải hướng hồ sơ đăng ký tham gia.',
            },
            codes: {
                case_anchor: 'Mẫu đơn cố định của hồ sơ',
                filed_snapshot: 'Bản chụp cố định khi nộp',
                draft_record: 'Bản ghi dự thảo hiện tại',
                reported_registry_information: 'Thông tin khai thác nguồn đã báo cáo',
                none: 'Chưa có nguồn dữ kiện được hỗ trợ',
                required: 'Thành phần được nguồn liệt kê',
                conditional_if_any: 'Thành phần theo điều kiện của nguồn',
                one_of: 'Các phương án giấy tờ thay thế',
                historical_repealed: 'Thành phần đính kèm riêng trước đây — đã bãi bỏ',
                documentary_route: 'Hướng hồ sơ theo chứng cứ',
                unknown: 'Chưa xác định điều kiện áp dụng',
                historical: 'Tham chiếu lịch sử',
                recorded_facts: 'Dữ kiện có giới hạn đã ghi',
                recorded_fact: 'Dữ kiện có giới hạn đã ghi',
                partial: 'Có một phần dữ kiện chứng cứ',
                not_recorded: 'Chưa ghi nhận',
                not_determinable: 'Chưa xác định',
                recorded: 'Đã ghi nhận',
                pending: 'Đang chờ',
                conflict: 'Dữ kiện mâu thuẫn',
                withheld: 'Không hiển thị',
                not_held: 'Không được lưu giữ',
                field_only: 'Chỉ là trường mô tả',
                filing_metadata_only: 'Chỉ là thông tin nộp hồ sơ; không chứng minh đơn đã hoàn thiện và ký',
                document_presence_only: 'Chỉ ghi nhận tài liệu đang được lưu giữ; chưa đánh giá nội dung',
                classification_reference_only: 'Chỉ là tham chiếu phân loại; phạm vi đối chiếu giới hạn ở dữ kiện được ghi',
                statement_date_only: 'Chỉ là ngày khai lý lịch; không suy ra có tài liệu được lưu giữ',
                reported_information_only: 'Chỉ là thông tin đã báo cáo',
                not_declared: 'Chưa khai báo nguồn',
                invalid_declaration: 'Khai báo nguồn không hợp lệ',
                invalid_declaration_context: 'Bối cảnh nguồn không hợp lệ',
                ambiguous_declaration: 'Nhiều khai báo nguồn chưa rõ',
                applicant_kind_required: 'Thiếu bối cảnh chủ thể được ghi rõ',
                track_not_declared: 'Chưa khai báo hướng hồ sơ tương ứng',
                ambiguous_track: 'Nhiều hướng hồ sơ tương ứng',
                not_admission_form: 'Không phải đơn đăng ký tham gia; không thay bằng hướng hồ sơ cha',
                coverage_limit_exceeded: 'Vượt giới hạn kỹ thuật khi đối chiếu chứng cứ',
                unsupported_binding: 'Chưa có liên kết chứng cứ được hỗ trợ',
                missing_record: 'Chưa ghi nhận dữ kiện cần thiết',
                missing_person: 'Chưa ghi nhận người liên quan',
                unknown_applicability: 'Chưa xác định điều kiện áp dụng',
                missing_actual_date: 'Chưa ghi nhận ngày thực tế',
                information_pending: 'Thông tin vẫn đang chờ; yêu cầu không thay thế thông tin',
                legacy_unconverted: 'Dữ kiện cũ chưa được chuyển đổi',
            },
        },
        annexGuidance: {
            heading: 'Hướng dẫn theo nguồn',
            undeclared: 'Khung tuân thủ đã cài đặt chưa khai báo hướng dẫn.',
            unavailable: 'Hướng dẫn đã khai báo chưa khả dụng; cần rà soát khai báo nguồn.',
            internalSummary: 'Tóm tắt nội bộ theo nguồn. Hướng dẫn không đánh giá tài liệu đã nộp, chữ ký hay việc nộp hồ sơ.',
            sourceDocument: 'Tài liệu nguồn',
            sourcePages: 'Trang PDF nguồn',
            legacy: 'Dữ liệu lịch sử: đã lưu dấu hiệu tạm thời về việc thiếu thể thức báo cáo. Hướng dẫn hiện tại được hiển thị riêng.',
            reasons: {
                not_declared: 'Chưa cài đặt khai báo hướng dẫn.',
                invalid_declaration: 'Khai báo hướng dẫn không hợp lệ.',
                invalid_declaration_context: 'Bối cảnh nguồn hướng dẫn không hợp lệ.',
                ambiguous_declaration: 'Cần rà soát nhiều khai báo hướng dẫn.',
            },
        },
        parentCopy: {
            operationCapturedAt: 'Thời điểm ghi nhận đề nghị tạo hồ sơ',
            acceptedAt: 'Thời điểm tiếp nhận việc tạo hồ sơ',
            initiatedBy: 'Người khởi tạo',
            operationPage: 'Trang các lần tạo đã ghi nhận',
            previous: 'Trang trước',
            next: 'Trang sau',
            listFailed: 'Không thể đọc các lần tạo hồ sơ con đã ghi nhận. Thử lại việc kiểm tra trạng thái, không gửi thêm đề nghị tạo mới.',
            reviewOperations: 'Rà soát các lần tạo hồ sơ con đã ghi nhận',
            knownOperation: 'Mã tham chiếu lần tạo đã ghi nhận',
            noResume: 'Lần tạo đã chọn không có thao tác tiếp tục khả dụng.',
            heading: 'Bằng chứng của bản sao phương án từ hồ sơ mẹ',
            capturedVersion: 'Phiên bản phương án nguồn được chụp',
            capturedAt: 'Thời điểm chụp nguồn',
            captureHint: 'Bản sao này bảo toàn phiên bản nguồn và thời điểm chụp được hiển thị.',
            copy_absent: 'Chưa ghi nhận bản sao phương án của hồ sơ mẹ.',
            not_recorded: 'Phương án đã sao chép chưa ghi nhận tệp thuyết minh kỹ thuật.',
            available: 'Tệp gốc được sao chép đang khả dụng.',
            withheld: 'Nội dung phương án của hồ sơ mẹ không được hiển thị. Cần quyền đọc hồ sơ mẹ được kiểm tra riêng.',
            legacy_lineage_unverified: 'Bản sao cũ chưa xác minh được nguồn. Không thể tải tệp qua bản sao này.',
            source_unavailable: 'Phương án nguồn không khả dụng. Tham chiếu đã sao chép được giữ nguyên.',
            lineage_invalid: 'Cần rà soát liên kết nguồn. Chưa có tệp khả dụng qua bản sao này.',
            not_held: 'Tệp đã sao chép hiện không được lưu giữ.',
            deleted: 'Tệp đã sao chép đã bị xóa. Tham chiếu gốc vẫn được ghi nhận.',
            released: 'Tệp đã sao chép đã được giải phóng theo quy định lưu giữ. Tham chiếu gốc vẫn được ghi nhận.',
            release_in_progress: 'Đang giải phóng hoặc tiêu hủy. Tệp đã sao chép chưa khả dụng.',
            loading: 'Đang kiểm tra khả năng truy cập bằng chứng đã sao chép…',
            loadFailed: 'Không thể kiểm tra khả năng truy cập bằng chứng đã sao chép.',
            refresh: 'Tải lại bằng chứng đã sao chép',
            download: 'Tải thuyết minh gốc đã sao chép',
            downloadFailed: 'Không thể tải tệp đã sao chép. Tải lại trạng thái và thử lại.',
            downloadUnavailable: 'Chưa thể tải tệp với quyền truy cập hiện tại.',
            opening: 'Đang tạo hồ sơ con…',
            creationPending: 'Đang chờ hoàn tất việc tạo hồ sơ con. Biểu mẫu giữ nguyên đề nghị ban đầu; thử lại không tạo thêm hồ sơ con.',
            creationUnknown: 'Chưa xác định được kết quả đề nghị. Kiểm tra trạng thái trước khi tạo hồ sơ con khác. Biểu mẫu ban đầu được giữ nguyên.',
            checkCreation: 'Kiểm tra trạng thái tạo hồ sơ con',
            resume: 'Hoàn tất việc tạo hồ sơ con đã ghi nhận',
            operationChoice: 'Lần tạo hồ sơ con đã ghi nhận',
            chooseOperation: 'Chọn lần tạo đã ghi nhận để rà soát',
            preparing: 'Đang chuẩn bị tạo hồ sơ',
            committed: 'Đã tiếp nhận việc tạo; đang chờ hoàn tất',
            published: 'Hồ sơ con đã khả dụng',
            cancelled: 'Việc tạo đã bị hủy',
            integrity_conflict: 'Cần rà soát tính toàn vẹn của bản ghi tạo hồ sơ',
            resumeFailed: 'Không thể hoàn tất việc tạo hồ sơ con đã ghi nhận.',
            originalRequest: 'Đề nghị tạo hồ sơ con ban đầu',
            newRequest: 'Trở lại đề nghị mới sau khi rà soát',
            recoveryHint: 'Rà soát và chọn rõ lần tạo đã ghi nhận. Không chọn dựa vào ngày hoặc tên.',
            noOperations: 'Không có lần tạo nào cần khôi phục trong danh sách. Rà soát danh sách hồ sơ con trước khi lập đề nghị mới.',
        },
        stopReasonMessages: {
            framework_not_operational: 'Khung chưa được áp dụng vận hành cho hồ sơ này. Chưa xác định trường hợp chuyển tiếp.',
            transitional_rule_ambiguous: 'Có nhiều khai báo quy định chuyển tiếp. Cần rà soát các khai báo nguồn.',
            transitional_rule_invalid: 'Tham chiếu tiếp nhận hoặc xác nhận đã khai báo cần được rà soát theo nguồn.',
            transitional_documentary_sources_conflict: 'Nguồn tiếp nhận hoặc xác nhận thực tế mâu thuẫn hoặc chưa rõ. Cần đối chiếu các bản ghi theo văn bản riêng.',
            confirmation_mapping_not_declared: 'Chưa có tham chiếu xác nhận được khai báo theo nguồn. Việc tiếp nhận không thể thay thế xác nhận.',
            legacy_confirmation_claim_not_verified: 'Có dữ liệu cũ nêu ngày xác nhận nhưng bằng chứng theo văn bản chưa được xác minh. Cần rà soát dữ liệu đó riêng với việc tiếp nhận.',
            confirmation_scope_conflict: 'Bằng chứng xác nhận và phạm vi áp dụng có mâu thuẫn. Cần rà soát các nguồn được bảo toàn.',
            historical_recording_scope_review_required: 'Quy định xử lý trong giai đoạn trước còn cần rà soát theo nguồn. Việc tiếp nhận đã xác minh không giải quyết câu hỏi về quy định áp dụng đó.',
            authored_documentary_counterpart_not_verified: 'Một dữ liệu đối chiếu về tiếp nhận hoặc xác nhận đã khai báo còn thiếu bằng chứng được xác minh. Cần rà soát từng bản ghi nguồn riêng.',
            confirmation_regime_not_verified: 'Đã ghi nhận việc xác nhận thực tế nhưng quy định xử lý hoặc mốc hiệu lực áp dụng chưa được xác minh.',
            main_and_nested_proceedings: 'Đồng thời có dữ liệu thủ tục dừng chính và riêng. Cần rà soát danh tính thủ tục.',
            stop_reference_not_declared: 'Khung đã cài đặt chưa xác định thủ tục dừng này.',
            stop_reference_invalid: 'Cần rà soát tham chiếu thủ tục dừng hoặc sự kiện tiếp nhận.',
            stored_stop_procedure_changed: 'Thủ tục đích đã cài đặt khác với thủ tục được bảo toàn. Dữ liệu đã ghi nhận chưa được chuyển.',
            stop_lifecycle_not_declared: 'Chưa có đồ thị thủ tục khả dụng. Cần rà soát khai báo nguồn.',
            receipt_occurrences_conflict: 'Nhiều dữ liệu tiếp nhận hoặc dữ liệu mâu thuẫn cần được đối chiếu văn bản.',
            receipt_not_verified: 'Bằng chứng tiếp nhận thực tế còn cần xác minh.',
            receipt_not_recorded: 'Chưa ghi nhận việc tiếp nhận thực tế. Ghi nhận theo bằng chứng khi đã biết.',
            multiple_decision_occurrences: 'Nhiều sự kiện quyết định cần được đối chiếu văn bản.',
            decision_dates_disagree: 'Ngày quyết định thực tế khác nhau giữa các nguồn văn bản.',
            decision_references_disagree: 'Số, ký hiệu quyết định khác nhau giữa các nguồn văn bản.',
            decision_evidence_conflict: 'Bằng chứng quyết định có mâu thuẫn. Giữ nguyên nguồn thực tế để rà soát.',
            completion_and_termination_recorded: 'Đồng thời ghi nhận giấy hoàn thành và dữ liệu dừng. Cần rà soát mâu thuẫn giữa các văn bản.',
            stop_context_unresolved: 'Ngữ cảnh thủ tục chưa được giải quyết. Cần rà soát trước khi lập đề nghị mới; dữ liệu thực tế vẫn được bảo toàn.',
            grant_not_declared: 'Chưa có khai báo về việc cho phép để lập đề nghị tự nguyện mới.',
            grant_not_recorded: 'Chưa ghi nhận việc cho phép theo khai báo. Không tự suy ra ngày cho phép.',
            completion_certified: 'Đã ghi nhận giấy hoàn thành thực tế. Không thể lập đề nghị dừng tự nguyện mới.',
            termination_recorded_or_unresolved: 'Dữ liệu dừng đã được ghi nhận hoặc cần rà soát. Chưa thể khởi tạo yêu cầu mới.',
            stop_already_filed: 'Đã ghi nhận đề nghị tự nguyện.',
            voluntary_ground_not_declared_or_ambiguous: 'Nguồn đã cài đặt thiếu căn cứ đề nghị tự nguyện hoặc căn cứ chưa rõ.',
            completion_already_filed: 'Đã ghi nhận đề nghị hoàn thành.',
        },
        stopProceeding: {
            documentaryEnding: 'Văn bản kết thúc áp dụng cho đồng hồ này',
            verified: 'Đã xác minh bằng chứng',
            pending_anchor: 'Chưa ghi nhận mốc cần thiết để xác định phạm vi áp dụng',
            requestFiled: 'Đã ghi nhận đề nghị của tổ chức',
            heading: 'Thủ tục dừng và văn bản quyết định',
            intro: 'Ghi nhận hành vi thực tế theo văn bản trong đúng thủ tục được khai báo. Đề nghị của tổ chức, việc tiếp nhận, quyết định của cơ quan và nghĩa vụ sau khi dừng là các bản ghi riêng.',
            context: 'Ngữ cảnh thủ tục',
            main: 'Thủ tục chính của hồ sơ',
            nested: 'Thủ tục riêng trong cùng hồ sơ',
            not_declared: 'Khung đã cài đặt chưa khai báo',
            unresolved: 'Cần rà soát khai báo thủ tục',
            ambiguous: 'Cần rà soát nhiều ngữ cảnh thủ tục',
            request: 'Đề nghị tự nguyện của tổ chức',
            notFiled: 'Chưa ghi nhận đề nghị của tổ chức',
            eligibility: 'Điều kiện lập đề nghị tự nguyện mới',
            allowed: 'Có thể lập đề nghị mới',
            refused: 'Chưa thể lập đề nghị mới',
            review: 'Rà soát dữ liệu đã ghi nhận và khai báo nguồn trước khi thực hiện.',
            receipt: 'Ngày thực tế tiếp nhận hồ sơ đề nghị dừng',
            receiptHint: 'Nhập ngày cơ quan tiếp nhận và bằng chứng. Ngày nộp, ngày xác nhận hồ sơ hợp lệ và thời điểm ghi nhận là các mốc riêng.',
            pending: 'Đang chờ bằng chứng hoặc căn cứ áp dụng',
            recorded: 'Đã ghi nhận',
            pending_evidence: 'Cần xác minh bằng chứng',
            conflict: 'Dữ liệu theo văn bản mâu thuẫn hoặc chưa rõ',
            none: 'Chưa ghi nhận quyết định theo văn bản',
            recordReceipt: 'Ghi nhận việc tiếp nhận thực tế',
            recordEvent: 'Ghi nhận sự kiện của thủ tục',
            recordTransition: 'Ghi nhận bước thực tế của thủ tục',
            recordAuthority: 'Ghi nhận quyết định thực tế của cơ quan',
            authority: 'Bản ghi quyết định dừng của cơ quan',
            legacy: 'Bản ghi thu hồi cũ được bảo toàn',
            raw: 'Bằng chứng quyết định trong lịch sử sự kiện',
            decisions: 'Đối chiếu các nguồn quyết định',
            decisionHint: 'Mỗi nguồn được giữ riêng. Việc ghi nhận quyết định không tự điền mốc kết thúc hoặc xóa nghĩa vụ còn tiếp tục.',
            protocol: 'Khả năng liên kết bằng chứng đang lưu giữ',
            ready: 'Có thể liên kết bằng chứng mới đang lưu giữ',
            not_ready: 'Chưa thể liên kết bằng chứng đang lưu giữ',
            protocolHint: 'Giữ bản nháp và thử lại khi có thể liên kết bằng chứng. Tải lên chỉ lưu tệp, không nộp đề nghị hoặc ghi nhận quyết định.',
            noInference: 'Việc tiếp nhận không xác nhận hồ sơ đã đầy đủ, hợp lệ. Giai đoạn đang chờ không thay thế ngày tiếp nhận thực tế.',
            phase: 'Trạng thái thủ tục đã ghi nhận',
            history: 'Lịch sử thủ tục được bảo toàn',
            events: 'Sự kiện thực tế của thủ tục',
            clocks: 'Đồng hồ thủ tục theo nguồn khai báo',
            noFacts: 'Chưa ghi nhận sự kiện',
            noStates: 'Chưa có bước tiếp theo được khai báo',
            event: 'Sự kiện được khai báo',
            state: 'Bước tiếp theo được khai báo',
            date: 'Ngày thực tế theo văn bản',
            receivedOn: 'Ngày tiếp nhận thực tế',
            evidence: 'Tham chiếu bằng chứng',
            evidenceHint: 'Mỗi dòng là một tham chiếu thực tế. Tham chiếu tệp nội bộ phải qua kiểm tra việc lưu giữ.',
            ground: 'Căn cứ được khai báo',
            groundNotRecorded: 'Chưa ghi nhận căn cứ',
            source: 'Trích dẫn nguồn',
            actor: 'Chủ thể theo văn bản',
            recordedBy: 'Người ghi nhận',
            recordedAt: 'Thời điểm ghi nhận',
            fileHeld: 'Đang lưu giữ',
            fileUnavailable: 'Tệp không khả dụng',
            submit: 'Ghi nhận dữ liệu theo văn bản',
            saved: 'Đã ghi nhận dữ liệu theo văn bản',
            failed: 'Không thể ghi nhận dữ liệu theo văn bản.',
            refresh: 'Tải lại thủ tục hiện tại',
            stale: 'Hồ sơ đã thay đổi. Bản nháp được giữ lại. Tải lại trước khi rà soát và gửi tiếp.',
            draftChanged: 'Thủ tục hoặc khai báo đã chọn đã thay đổi. Bản nháp được giữ nguyên, chưa chuyển sang ý nghĩa mới.',
            reset: 'Bỏ lựa chọn không còn khả dụng',
            close: 'Hủy',
            recipients: 'Người nhận thông báo thực tế',
            recipient: 'Mô tả người nhận',
            addRecipient: 'Thêm người nhận',
            removeRecipient: 'Bỏ người nhận',
            channel: 'Kênh thông báo thực tế',
            recipientsHint: 'Ghi nhận người nhận và kênh thực tế. Dữ liệu này không chứng minh đã thông báo đầy đủ cho mọi khách hàng.',
            notRecorded: 'Chưa ghi nhận',
            advisory: 'Lưu ý về thông báo theo nguồn',
            invalid_declaration: 'Cần rà soát khai báo lưu ý',
            not_determinable: 'Chưa xác định quy định áp dụng',
            received_not_confirmed: 'Đã tiếp nhận; chưa ghi nhận xác nhận hồ sơ đầy đủ, hợp lệ',
            review_required: 'Cần rà soát căn cứ áp dụng trong giai đoạn trước',
            confirmation: 'Việc xác nhận hồ sơ đầy đủ, hợp lệ thực tế',
            transitionalReceipt: 'Bằng chứng tiếp nhận hồ sơ thực tế',
            authorityHint: 'Ghi nhận hành vi thực tế của cơ quan độc lập với việc tổ chức nộp đề nghị. Các nguồn văn bản mâu thuẫn vẫn được hiển thị.',
            decisionRef: 'Số, ký hiệu quyết định của cơ quan',
            decidedOn: 'Ngày quyết định thực tế',
            decisionText: 'Nội dung quyết định của cơ quan',
            file: 'Bằng chứng quyết định đang lưu giữ',
            filingHint: 'Việc nộp tự nguyện chỉ ghi nhận đề nghị của tổ chức; tiếp nhận và quyết định được ghi nhận riêng.',
            groundRequired: 'Chọn căn cứ tự nguyện được khai báo',
            noClock: 'Chưa có kết quả đồng hồ định lượng',
            reason: 'Nội dung cần rà soát',
            confirm: 'Xác nhận nộp đề nghị tự nguyện',
            confirmationHint: 'Xác nhận đề nghị này với ngày đã nhập và các tệp đang lưu giữ. Thao tác này không ghi nhận việc cơ quan tiếp nhận hoặc ra quyết định.',
        },
        registryFacts: {
            correction: 'Đính chính dữ liệu kết quả',
            correctionHint: 'Đính chính có căn cứ xác định dữ liệu trước đó bị sai; không thay thế thông tin còn thiếu hoặc kết quả tra cứu.',
            correctionIntent: 'Thay đổi này đính chính dữ liệu trước đó bị sai',
            correctionReason: 'Lý do đính chính',
            outcomeHistory: 'Lịch sử dữ liệu kết quả tra cứu',
            person: 'Bản ghi nhân sự liên kết chính xác',
            choosePerson: 'Chọn rõ bản ghi nhân sự',
            personHint: 'Tên không xác định bản ghi. Chọn đúng mã bản ghi; không tự suy đoán nhân sự. Dòng cũ chưa gán chỉ được liên kết một lần.',
            personUnavailable: 'Không đọc được lựa chọn nhân sự hoặc chưa có vai trò phù hợp đã khai báo.',
            linkedOutcome: 'Kết quả chỉ lưu tại bản ghi nhân sự liên kết',
            outcomeHint: 'Ghi hoặc sửa kết quả này ở phần nhân sự. Dòng cơ sở dữ liệu này không ghi kết quả thứ hai.',
            legacy: 'Kết quả cơ sở dữ liệu cũ được bảo toàn, không dùng làm kết quả chính',
            retrievedOn: 'Ngày thực tế khai thác nguồn thông tin',
            suppliedOn: 'Ngày thực tế cung cấp thành phần hồ sơ',
            requestHeading: 'Văn bản yêu cầu tiếp theo có tài liệu chứng minh',
            requestHint: 'Ghi yêu cầu đã ban hành. Yêu cầu không phải thông tin đã cung cấp và không miễn thông tin còn thiếu. Chỉ bổ sung bản ghi yêu cầu vào lịch sử.',
            requestOn: 'Ngày thực tế ban hành văn bản yêu cầu',
            reference: 'Tham chiếu văn bản',
            request: 'Bổ sung bản ghi yêu cầu',
            requestMissing: 'Chưa có yêu cầu theo nguồn đã khai báo.',
            information: 'Tình trạng thông tin',
            available_as_reported: 'Có thông tin theo kết quả tại ngày đã ghi; không kết luận đủ điều kiện',
            pending: 'Thông tin vẫn đang chờ',
            undetermined: 'Chưa xác định tình trạng thông tin',
            requestRecorded: 'Đã ghi yêu cầu; điều này không xác định đã nhận thông tin',
            evidenceNoLongerHeld: 'Tệp của yêu cầu không còn được lưu giữ',
            noRequest: 'Chưa ghi văn bản yêu cầu',
            copy: 'Tệp bản sao do tổ chức cung cấp',
            copyHint: 'Tải lên chỉ lưu giữ tệp. Gắn rõ tệp vào dòng này. Bản sao được lưu giữ không thay kết quả tại nhân sự liên kết.',
            upload: 'Tải lên tệp tài liệu của dòng cơ sở dữ liệu',
            uploaded: 'Đã tải lên nhưng chưa gắn: {name}',
            bind: 'Gắn bản sao đã tải lên',
            unbind: 'Gỡ bản sao đã gắn',
            held: 'Tệp đã gắn được lưu giữ đúng cho dòng này',
            notHeld: 'Tệp đã gắn không được lưu giữ cho dòng này',
            notBound: 'Chưa gắn tệp bản sao',
            useRequestFile: 'Dùng tệp tải lên này cho văn bản yêu cầu',
            noRequestFile: 'Chưa chọn tệp cho văn bản yêu cầu',
            decisionHint: 'Quyết định ghi riêng được bảo toàn như một sự việc; không miễn yêu cầu hoặc thông tin cần có.',
            coverage: 'Mức độ bao phủ yêu cầu',
            count: 'Số dòng đã ghi: {count}; số dòng chưa gán: {unassigned}',
            people: 'Nhân sự phù hợp: {eligible}; nhân sự đã liên kết: {linked}',
            scopeUnavailable: 'Chưa khai báo phạm vi yêu cầu; chưa xác định liên kết nhân sự',
            refresh: 'Đọc dòng cơ sở dữ liệu hiện tại',
            refreshed: 'Đã đọc dòng hiện tại. Nội dung nhập được giữ lại; rà soát phạm vi, nhân sự và khai báo nguồn trước khi thử lại.',
            stale: 'Dòng đã thay đổi. Đọc lại trước khi thử lại; nội dung nhập được giữ lại.',
            unavailableDraft: 'Lựa chọn nhân sự chưa lưu không còn phù hợp hoặc khác liên kết hiện đã cố định. Bỏ lựa chọn dự thảo để giữ liên kết hiện tại.',
            keepLink: 'Dùng liên kết hiện tại đã ghi',
            failed: 'Không ghi được thay đổi tài liệu.',
            history: 'Lịch sử văn bản yêu cầu bất biến',
            date: 'Ngày thực tế',
            actor: 'Người ghi',
            recordedAt: 'Thời điểm ghi',
            classificationOn: 'Phân loại kết quả theo ngày kết quả đã ghi',
            outcomeUnresolved: 'Chưa xác định kết quả liên kết hoặc phạm vi nhân sự; không coi mã đã lưu là thông tin đã có.',
            requestDeclarationChanged: 'Khai báo yêu cầu theo nguồn đã thay đổi. Dự thảo được giữ lại và không tự ghi thành loại yêu cầu khác.',
            resetRequestDraft: 'Bỏ dự thảo yêu cầu này và dùng khai báo hiện tại',
        },
        applicantSolution: {
            kind: 'Loại tổ chức đăng ký đã ghi nhận',
            kindHint: 'Chọn rõ loại tổ chức đăng ký. Mẫu đơn dùng chung không xác định loại tổ chức. Để trống thì hướng hồ sơ chưa xác định và không tạo thêm yêu cầu nộp hồ sơ.',
            choose: 'Chưa ghi nhận',
            kindLocked: 'Loại tổ chức đăng ký bị khóa sau khi nộp hoặc ghi nhận sự việc của cơ quan. Giá trị đã ghi nhận được giữ nguyên.',
            keepRecorded: 'Dùng loại tổ chức hiện tại đã ghi nhận và bỏ thay đổi loại tổ chức chưa lưu',
            filedKind: 'Loại tổ chức trong bản ghi nội dung đã nộp bất biến',
            absentAtFiling: 'Bản ghi nội dung đã nộp trước đây chưa lưu thông tin này',
            track: 'Hướng hồ sơ đã khai báo',
            recorded: 'Đã ghi nhận theo khai báo hiện tại',
            not_recorded: 'Chưa ghi nhận loại tổ chức đăng ký',
            recorded_not_declared: 'Giá trị đã lưu chưa được khai báo hiện tại xác định',
            not_declared: 'Chưa có khai báo sử dụng được',
            invalid_declaration: 'Cần rà soát khai báo đã cài đặt',
            resolved: 'Đã xác định hướng hồ sơ từ mẫu đơn và loại tổ chức đã ghi nhận',
            applicant_kind_required: 'Ghi loại tổ chức đăng ký để xác định hướng hồ sơ',
            applicant_kind_not_declared: 'Loại tổ chức đã lưu chưa xác định được hướng hồ sơ hiện tại',
            track_not_declared: 'Chưa có hướng hồ sơ đã khai báo phù hợp',
            ambiguous: 'Có nhiều khai báo mâu thuẫn phù hợp; không tự chọn',
            conditional: 'Thành phần hồ sơ được dẫn yêu cầu giấy chứng nhận đăng ký đầu tư nếu có. Điều này không xác định tổ chức này có hoặc phải xin giấy đó.',
            notListed: 'Giấy chứng nhận đăng ký đầu tư không được liệt kê trong quy định hồ sơ được dẫn này. Đây không phải miễn trừ chung đối với nghĩa vụ đăng ký đầu tư.',
            scheme: 'Bộ cấp độ an ninh hệ thống thông tin được tham chiếu',
            declared: 'Đã cài đặt đúng bộ cấp độ được tham chiếu',
            named_not_installed: 'Đã khai báo nhưng chưa cài đặt bộ cấp độ được nêu. Cài khung được tham chiếu; không thay bằng bộ khác.',
            schemeNotDeclared: 'Chưa khai báo tham chiếu bộ cấp độ sử dụng được. Không thay bằng bộ đã cài đặt khác.',
            reference: 'Đối tượng tham chiếu đã khai báo',
            source: 'Nguồn',
            legacyLevel: 'Liên kết cấp độ gốc này được bảo toàn. Chưa chuyển đổi hoặc bổ sung nguồn còn thiếu.',
            levelHint: 'Lựa chọn mới ghi rõ khung công bố, bộ cấp độ và cấp độ theo tài liệu. Bản sao hồ sơ con đã giữ nguyên không thay đổi khi sửa giải pháp hiện tại. Đây là thông tin tham chiếu, không phải kết luận pháp lý về việc hệ thống tuân thủ.',
            loadFailed: 'Không đọc được khai báo loại tổ chức đăng ký. Chưa ghi nhận loại tổ chức; không tự suy đoán.',
        },
        filing: {
            heading: 'Thông tin nộp hồ sơ của tổ chức',
            record: 'Ghi nhận lần nộp hồ sơ đã thực hiện',
            recordHint: 'Ghi nhận lần nộp hồ sơ mà tổ chức đã thực hiện. Thao tác này không gửi tài liệu và không ghi nhận việc cơ quan đã nhận hồ sơ.',
            notDeclared: 'Thủ tục đã cài đặt chưa khai báo yêu cầu đối với việc nộp hồ sơ. Cần khai báo đã được rà soát trước khi ghi nhận lần nộp.',
            immutable: 'Bản ghi nội dung đã nộp được bảo toàn. Không thể thay đổi lần nộp đã ghi nhận tại trang này.',
            frozenGroup: 'Nhóm khách hàng dự thảo trong bản sao giải pháp của hồ sơ gốc được giữ nguyên',
            filedGroup: 'Nhóm khách hàng thực tế đã nộp',
            filedReport: 'Tham chiếu tệp báo cáo kết quả tại thời điểm nộp',
            notRecorded: 'Chưa ghi nhận',
            notRecordedAtFiling: 'Chưa ghi nhận trong bản ghi nội dung đã nộp',
            reference: 'Số tham chiếu lần nộp hồ sơ của tổ chức',
            submittedOn: 'Ngày thực tế nộp hồ sơ',
            childGroupHint: 'Điền sẵn từ bản sao giải pháp của hồ sơ gốc được giữ nguyên trong hồ sơ con. Nhập nội dung thực tế đã nộp, kể cả khi dự thảo chưa có nhóm khách hàng. Thao tác này không thay đổi bản sao đó hay giải pháp dự thảo của hồ sơ gốc.',
            parentGroupHint: 'Nhập nhóm khách hàng thực tế đã nộp. Thao tác này ghi nhận nội dung đã nộp và không thay đổi giải pháp dự thảo.',
            approvalReady: 'Xác nhận nội bộ: đã ghi nhận là hoàn thành cho hồ sơ con này.',
            approvalRequired: 'Phải ghi nhận xác nhận nội bộ của hồ sơ con là hoàn thành trước khi ghi nhận lần nộp hồ sơ.',
            draftReport: 'Báo cáo kết quả dự thảo',
            reportHint: 'Tải lên giúp lưu giữ tệp. Đính kèm tệp vào dự thảo này bằng thao tác riêng. Cả hai thao tác đều không ghi nhận lần nộp và không xác minh mẫu báo cáo kết quả.',
            reportNotBound: 'Chưa đính kèm báo cáo kết quả vào dự thảo này.',
            reportBound: 'Đã đính kèm và đang lưu giữ báo cáo dự thảo (tham chiếu tệp: {reference}).',
            reportNotHeld: 'Báo cáo dự thảo không còn được lưu giữ hoặc không thuộc hồ sơ con này. Gỡ đính kèm hoặc thay thế trước khi ghi nhận lần nộp.',
            reportUnknown: 'Chưa xác định được tình trạng lưu giữ báo cáo dự thảo. Đọc lại hồ sơ trước khi ghi nhận lần nộp.',
            reportChangeFailed: 'Không thay đổi được việc đính kèm báo cáo dự thảo.',
            uploadReport: 'Tải lên báo cáo kết quả dự thảo',
            uploadHeld: 'Đã tải lên: {name}. Chưa đính kèm vào dự thảo này.',
            bindReport: 'Đính kèm báo cáo đã tải lên vào dự thảo',
            unbindReport: 'Gỡ đính kèm báo cáo dự thảo',
            leaveUnbound: 'Giữ tệp tải lên ở trạng thái chưa đính kèm',
            saved: 'Đã lưu thông tin nộp hồ sơ.',
            failed: 'Không lưu được thông tin nộp hồ sơ.',
            refreshFailed: 'Không đọc được hồ sơ hiện tại. Tải lại hồ sơ trước khi thử lại.',
            stale: 'Hồ sơ đã thay đổi. Đã đọc phiên bản hiện tại và giữ lại nội dung bạn nhập. Rà soát báo cáo và xác nhận nội bộ hiện tại trước khi thử lại.',
        },
        lifecycle: {
            heading: 'Sự kiện có tài liệu chứng minh và ngày thực tế',
            intro: 'Ghi nhận sự việc mà tài liệu chứng minh thể hiện, kể cả sự việc nhận được sau kết quả của cơ quan. Ngày xảy ra khác với thời điểm ghi nhận mục này. Nền tảng không ra quyết định thay cơ quan.',
            record: 'Ghi nhận sự kiện có tài liệu chứng minh',
            event: 'Sự kiện đã khai báo',
            occurredOn: 'Ngày thực tế xảy ra',
            evidence: 'Tham chiếu tài liệu chứng minh',
            verification: 'Đối chiếu với điều kiện tiên quyết đã khai báo',
            recordedAt: 'Thời điểm ghi nhận mục',
            actor: 'Chủ thể thực hiện theo tài liệu: {actor}',
            actorAuthority: 'Cơ quan',
            actorOrganisation: 'Tổ chức',
            actorRelevantMinistries: 'Các bộ có liên quan',
            source: 'Nguồn: {source}',
            recordedBy: 'Người ghi nhận mục: {actor}',
            scopeVerified: 'Ngày mốc đã ghi nhận của đơn này thuộc khoảng thời gian ghi nhận đã được rà soát.',
            scopePending: 'Chưa xác định khoảng thời gian ghi nhận: ghi nhận sự kiện mốc đã khai báo cùng ngày thực tế và tài liệu chứng minh.',
            scopeReview: 'Khoảng thời gian ghi nhận của đơn này cần được rà soát. Không suy diễn chế độ áp dụng trước đây.',
            scopeConflict: 'Các ngày mốc của đơn đã ghi nhận mâu thuẫn. Rà soát ngày và tài liệu chứng minh.',
            scopeNotDeclared: 'Thủ tục đã cài đặt không khai báo khoảng thời gian ghi nhận đã được rà soát.',
            scopeAnchor: 'Ngày mốc của đơn đã ghi nhận: {date}',
            notDeclared: 'Thủ tục đã cài đặt chưa khai báo sự kiện có tài liệu chứng minh',
            empty: 'Chưa ghi nhận sự kiện có tài liệu chứng minh.',
            verified: 'Đã đối chiếu điều kiện tiên quyết từ các sự kiện đã ghi nhận',
            pending: 'Chờ sự kiện tiên quyết hoặc khoảng thời gian đã khai báo có thể tính được',
            conflict: 'Ngày hoặc sự kiện tiên quyết mâu thuẫn',
            verificationHint: 'Rà soát ngày thực tế, tài liệu chứng minh và điều kiện tiên quyết trong nguồn. Sự kiện còn chờ hoặc mâu thuẫn không đáp ứng điều kiện tiên quyết để chuyển bước.',
            choose: 'Chọn sự kiện đã khai báo',
            saved: 'Đã ghi nhận sự kiện có tài liệu chứng minh.',
            failed: 'Không ghi nhận được sự kiện có tài liệu chứng minh.',
            transitionRemedy: 'Chỉ các bước tiếp theo đã khai báo được hiển thị. Nếu thiếu điều kiện tiên quyết, ghi nhận sự kiện có tài liệu chứng minh và ngày thực tế, rồi thử ghi nhận bước này lại.',
            noNextStep: 'Không có bước tiếp theo được khai báo từ trạng thái đã ghi nhận. Vẫn có thể ghi nhận các sự kiện riêng có tài liệu chứng minh.',
            clockEnded: 'Thời hạn đã kết thúc',
            clockEndedOn: 'Kết thúc theo ngày thực tế của nguồn tương ứng: {date}',
            clockRecordedStart: 'Ngày bắt đầu đã ghi nhận: {date}',
            clockHistoricalDue: 'Ngày đến hạn được lưu trong lịch sử: {date}',
            clockConflict: 'Các ngày của thời hạn mâu thuẫn',
            clockConflictHint: 'Ngày kết thúc đã ghi nhận trước ngày bắt đầu. Rà soát tài liệu nguồn; không hiển thị ngày đến hạn đang áp dụng.',
            clockReview: 'Thời hạn cần được rà soát',
            clockReviewHint: 'Khai báo đã cài đặt yêu cầu rà soát ngày mốc trước khi tính ngày cho thời hạn này.',
            notRecorded: 'Chưa ghi nhận',
        },
        title: 'Hồ sơ thử nghiệm có kiểm soát',
        subtitle: 'Hồ sơ của tổ chức về từng đơn tham gia cơ chế thử nghiệm có kiểm soát. Cơ quan có thẩm quyền ghi nhận từng bước; nền tảng lưu các bước đó cùng chứng cứ và tính các thời hạn mà bản ghi đã cài đặt quy định. Nền tảng không đưa ra quyết định nào.',
        moduleGuideSummary: 'Lưu hồ sơ từng đơn tham gia thử nghiệm có kiểm soát: thủ tục áp dụng, các bước cơ quan có thẩm quyền đã ghi nhận và các thời hạn bản ghi đã cài đặt quy định. Nền tảng không đánh giá điều kiện tham gia và không quyết định kết quả.',
        restricted: 'Bạn cần quyền xem hồ sơ thử nghiệm có kiểm soát để xem các hồ sơ này.',
        loading: 'Đang tải',
        reload: 'Tải lại',
        notYetRecorded: 'Cơ quan chưa ghi nhận',
        notDeclared: 'Bản ghi đã cài đặt không khai báo',
        noChannel: 'Chưa ghi nhận kênh nộp hồ sơ',
        yes: 'Có',
        no: 'Không',
        list: {
            filtersLabel: 'Lọc hồ sơ',
            chooseFrameworkFirst: 'Chọn khung tuân thủ trước',
            chooseProcedureFirst: 'Chọn thủ tục trước',
            noMatch: 'Không có kết quả phù hợp',
            heading: 'Hồ sơ',
            openCase: 'Mở hồ sơ',
            filterFramework: 'Khung tuân thủ',
            filterProcedure: 'Thủ tục',
            filterStep: 'Bước đã ghi nhận',
            anyFramework: 'Mọi khung tuân thủ',
            anyProcedure: 'Mọi thủ tục',
            anyStep: 'Mọi bước',
            clearFilters: 'Xóa bộ lọc',
            colApplicant: 'Người nộp đơn',
            colProcedure: 'Thủ tục',
            colStep: 'Bước đã ghi nhận',
            colUpdated: 'Cập nhật lần cuối',
            total: '{count} hồ sơ',
            empty: 'Chưa có hồ sơ nào. Mở một hồ sơ theo thủ tục đã cài đặt để bắt đầu.',
            emptyFiltered: 'Không có hồ sơ nào khớp với bộ lọc.',
            loadError: 'Không tải được danh sách hồ sơ.',
            retrySubject: 'danh sách hồ sơ',
            pagination: 'Các trang hồ sơ',
            procedureLabelError: 'Không đọc được thủ tục từ bản ghi đã cài đặt.',
            stepLabelError: 'Không đọc được tên bước từ bản ghi đã cài đặt.',
        },
        pick: {
            frameworkHint: 'Chỉ liệt kê các khung tuân thủ có khai báo thủ tục thử nghiệm có kiểm soát.',
            noCaseFrameworks: 'Chưa có khung tuân thủ đã cài đặt nào khai báo thủ tục có thể mang hồ sơ.',
            noFormsOption: '{label} (không khai báo mẫu đơn)',
            noFormsInFramework: 'Không có thủ tục nào của khung tuân thủ này khai báo mẫu đơn, nên không thể mở hồ sơ trên khung này. Một khung tuân thủ sửa đổi khung này có thể khai báo các mẫu đơn.',
            framework: 'Khung tuân thủ đã cài đặt',
            procedure: 'Thủ tục',
            chooseFramework: 'Chọn khung tuân thủ',
            chooseProcedure: 'Chọn thủ tục',
            noProcedures: 'Khung tuân thủ này không khai báo thủ tục nào có thể mang hồ sơ.',
            noOpenableFrameworks: 'Chưa có khung tuân thủ nào có thể mở hồ sơ: khung chỉ được cài đặt để tham khảo thì không mở hồ sơ.',
            hiddenUndeclared: '{count} thủ tục trong khung tuân thủ này không khai báo vòng đời nên không được đưa ra.',
            loadFrameworksError: 'Không đọc được danh sách khung tuân thủ đã cài đặt.',
            loadProceduresError: 'Không đọc được các thủ tục của khung tuân thủ này.',
            needFrameworkRead: 'Đọc thủ tục của khung tuân thủ cần quyền xem khung tuân thủ.',
        },
        open: {
            noForms: 'Thủ tục này không khai báo mẫu đơn nên không thể mở hồ sơ theo thủ tục này. Hãy chọn thủ tục khác.',
            title: 'Mở hồ sơ',
            hint: 'Chọn thủ tục đã cài đặt mà đơn này theo. Hồ sơ được mở khi chưa có bước nào của cơ quan được ghi nhận.',
            form: 'Mẫu đơn',
            formHint: 'Các mẫu mà thủ tục này khai báo.',
            applicant: 'Tên người nộp đơn',
            notes: 'Ghi chú',
            submit: 'Mở hồ sơ',
            cancel: 'Hủy',
            saving: 'Đang lưu…',
            blocked: 'Chọn khung tuân thủ, thủ tục và mẫu đơn, rồi nhập tên người nộp đơn.',
            chooseForm: 'Chọn mẫu đơn',
            required: 'Bắt buộc',
            opened: 'Đã mở hồ sơ.',
            failed: 'Không mở được hồ sơ.',
        },
        detail: {
            back: 'Quay lại danh sách hồ sơ',
            heading: 'Hồ sơ',
            applicant: 'Người nộp đơn',
            procedure: 'Thủ tục',
            form: 'Mẫu đơn',
            framework: 'Khung tuân thủ',
            channel: 'Kênh nộp hồ sơ',
            usb: 'Bản USB',
            usbRecorded: 'Đã ghi nhận bản USB',
            usbNotRecorded: 'Chưa ghi nhận bản USB',
            receivedOn: 'Ngày nhận',
            notRecorded: 'Chưa ghi nhận',
            state: 'Bước đã ghi nhận',
            stateUndeclared: 'Bước đã ghi nhận không còn được thủ tục đã cài đặt khai báo.',
            history: 'Các bước đã ghi nhận',
            historyEmpty: 'Chưa ghi nhận bước nào.',
            colStep: 'Bước',
            colEnteredOn: 'Ngày trên văn bản của cơ quan',
            colEvidence: 'Chứng cứ',
            colRecordedAt: 'Ghi nhận ngày',
            clocks: 'Thời hạn',
            clocksNone: 'Bản ghi đã cài đặt không khai báo thời hạn nào cho hồ sơ này.',
            clockRunning: 'Đang chạy',
            clockNotStarted: 'Chưa bắt đầu',
            clockNoNumeric: 'Không có số ngày',
            clockNotStartedText: 'Bước mà thời hạn bắt đầu tính chưa có bản ghi, nên chưa tính được gì.',
            clockNoNumericText: 'Bản ghi đã cài đặt không nêu số ngày cho thời hạn này.',
            clockPeriod: '{period} {unit}',
            clockStartsOn: 'Tính từ {date}',
            clockDue: 'Đến hạn {date}',
            clockPaused: 'Tạm dừng {days} ngày',
            clockSource: 'Nguồn: tính từ mốc đã ghi nhận',
            clockOwner: 'Bên có nghĩa vụ: {owner}',
            clockName: 'Thời hạn',
            clockStatusHeading: 'Trạng thái',
            clockDueHeading: 'Đến hạn',
            clockSourceHeading: 'Nguồn',
            clockUnitCalendarDays: 'ngày lịch',
            clockUnitWorkingDays: 'ngày làm việc',
            clockUnitMonths: 'tháng',
            suppressedFrameworkNotOperational: 'Không tính thời hạn: khung tuân thủ chỉ được cài đặt để tham khảo.',
            suppressedProcedureNotDeclared: 'Không tính thời hạn: thủ tục đã cài đặt không khai báo vòng đời.',
            suppressedNotInForce: 'Không tính thời hạn: khung tuân thủ chưa có hiệu lực vào ngày {date}.',
            suppressedActivationUnknown: 'Không tính thời hạn: bản ghi đã cài đặt không nêu ngày các thời hạn bắt đầu có hiệu lực.',
            transitionalTitle: 'Tình trạng chuyển tiếp',
            transitionalNotApplicable: 'Thủ tục này không có quy tắc chuyển tiếp.',
            transitionalNotDeterminable: 'Bản ghi đã cài đặt không cho phép nền tảng xác định tình trạng chuyển tiếp.',
            transitionalAnchorNotRecorded: 'Tình trạng chuyển tiếp chờ ngày mốc được ghi nhận.',
            transitionalYes: 'Thuộc diện chuyển tiếp: ngày mốc trước {cutoff}. Không hiển thị số ngày cho thời hạn này.',
            transitionalNo: 'Không thuộc diện chuyển tiếp: ngày mốc vào hoặc sau {cutoff}.',
            completeness: 'Mục còn thiếu',
            completenessOther: 'Có một mục còn thiếu áp dụng cho hồ sơ này. Bản ghi đã cài đặt nêu nội dung đó.',
            completenessUsb: 'Kênh nộp hồ sơ này yêu cầu một bản USB của bộ hồ sơ. Ghi nhận khi đã nhận. Mục còn thiếu không chặn bước nào.',
            channelUndeclared: 'Kênh đã ghi nhận không được khung tuân thủ đã cài đặt khai báo.',
            asOf: 'Thời hạn tính đến ngày {date}',
            edit: 'Sửa ghi chú và kênh nộp',
            editNotes: 'Sửa ghi chú',
            recordStep: 'Ghi nhận một bước',
            loadError: 'Không tải được hồ sơ.',
            frameworkUnreadable: 'Không đọc được tên thủ tục và kênh của khung tuân thủ, nên bước và kênh được hiển thị theo mã định danh.',
        },
        transition: {
            title: 'Ghi nhận một bước của cơ quan có thẩm quyền',
            hint: 'Nhập bước theo đúng văn bản của cơ quan, kèm ngày trên văn bản đó và chứng cứ thể hiện bước này. Nền tảng ghi nhận bước; nền tảng không quyết định bước nào.',
            step: 'Bước',
            chooseStep: 'Chọn bước',
            enteredOn: 'Ngày trên văn bản của cơ quan',
            evidence: 'Chứng cứ, mỗi dòng một tham chiếu',
            evidenceHint: 'Nêu văn bản hoặc tệp đính kèm thể hiện bước này. Cần ít nhất một tham chiếu.',
            submit: 'Ghi nhận bước',
            cancel: 'Hủy',
            saving: 'Đang lưu…',
            recorded: 'Đã ghi nhận bước.',
            failed: 'Không ghi nhận được bước.',
            blocked: 'Chọn bước, nhập ngày và ít nhất một tham chiếu chứng cứ.',
            required: 'Bắt buộc',
        },
        edit: {
            title: 'Ghi chú và kênh nộp',
            titleNotes: 'Ghi chú',
            applicant: 'Tên người nộp đơn',
            notes: 'Ghi chú',
            channel: 'Kênh nộp hồ sơ',
            noChannel: 'Chưa chọn kênh',
            usbRecorded: 'Hồ sơ nộp kèm bản USB',
            usbNotRecorded: 'Chưa ghi nhận bản USB',
            receivedOn: 'Ngày nhận hồ sơ',
            submit: 'Lưu thay đổi',
            saving: 'Đang lưu…',
            saved: 'Đã lưu hồ sơ.',
            failed: 'Không lưu được hồ sơ.',
        },
        stale: 'Hồ sơ đã thay đổi kể từ khi bạn mở. Hồ sơ đã được tải lại và nội dung bạn nhập vẫn còn đó. Hãy kiểm tra rồi gửi lại.',
        refusedUndeclared: 'Thủ tục đã cài đặt không khai báo bước này. Chưa ghi nhận gì.',
        solution: {
            heading: 'Bằng chứng về giải pháp',
            intro: 'Giải pháp duy nhất mà hồ sơ này đề xuất thử nghiệm: loại giải pháp, nhóm khách hàng tiếp cận, bản thuyết minh kỹ thuật làm căn cứ và cấp độ an toàn được áp dụng. Nền tảng ghi lại những gì giải pháp nêu. Nền tảng không quyết định giải pháp có phù hợp hay không.',
            loading: 'Đang tải hồ sơ giải pháp…',
            loadError: 'Không thể tải hồ sơ giải pháp.',
            retrySubject: 'hồ sơ giải pháp',
            readOnly: 'Bạn có thể xem hồ sơ này. Ghi nhận, thay đổi và đính kèm bản thuyết minh kỹ thuật cần quyền quản lý.',
            add: 'Ghi nhận giải pháp',
            edit: 'Thay đổi giải pháp',
            notRecorded: 'Chưa ghi nhận',
            typeLabel: 'Loại giải pháp',
            typeChosen: 'Đã chọn: {label}',
            typeNotUsed: 'Không sử dụng: {label}',
            typeNoneDeclared: 'Hồ sơ đã cài đặt không khai báo loại giải pháp nào, nên chưa thể ghi nhận.',
            typeSingleDeclared: 'Hồ sơ đã cài đặt chỉ khai báo một loại giải pháp: {label}. Đề án mô tả giải pháp nêu việc lựa chọn giữa hai loại.',
            typeUndeclared: 'Khung tuân thủ đã cài đặt không khai báo (mã {code})',
            customerGroupLabel: 'Nhóm khách hàng tiềm năng',
            statementLabel: 'Bản thuyết minh kỹ thuật',
            statementNotAttached: 'Chưa đính kèm',
            statementAttached: 'Đã đính kèm: {name}',
            statementAttachedNoName: 'Đã đính kèm. Tên tệp cần quyền tải xuống tài liệu đính kèm.',
            statementUpload: 'Đính kèm bản thuyết minh kỹ thuật',
            statementRejected: 'Không thể đính kèm bản thuyết minh kỹ thuật.',
            statementNotBound: 'Tệp được lưu cho giải pháp này nhưng chưa được gắn vào giải pháp. {message}',
            levelLabel: 'Cấp độ an toàn',
            levelRecorded: '{label} ({scheme}; căn cứ: {basis})',
            levelUndeclaredTier: 'Hồ sơ đã cài đặt không khai báo (mã {code})',
            levelNotDeclared: 'Không có khung tuân thủ đã cài đặt nào khai báo',
            criteriaLabel: 'Tiêu chí kỹ thuật',
            criteriaTextNotInCorpus: 'Nội dung không có trong kho văn bản. Nguồn: {source}. Không tiêu chí nào được hiển thị ở đây như một yêu cầu đã xác minh.',
            criteriaNotDeclared: 'Không có khung tuân thủ đã cài đặt nào khai báo.',
            dossierLabel: 'Hồ sơ giải pháp',
            dossierComplete: 'Cả bốn mục đã được ghi nhận. Cơ quan có thẩm quyền quyết định các bước tiếp theo.',
            dossierIncomplete: 'Chưa đầy đủ. Còn thiếu: {items}.',
            item_solution_type: 'loại giải pháp',
            item_customer_group: 'nhóm khách hàng',
            item_technical_statement: 'bản thuyết minh kỹ thuật',
            item_security_level: 'cấp độ an toàn',
            editor_title: 'Ghi nhận giải pháp',
            editor_titleEdit: 'Thay đổi giải pháp',
            editor_hint: 'Chọn loại giải pháp mà hồ sơ đã cài đặt khai báo, nhập nhóm khách hàng như đề án mô tả, và chọn cấp độ an toàn do một khung tuân thủ đã cài đặt khai báo. Đính kèm bản thuyết minh kỹ thuật sau khi lưu giải pháp.',
            editor_typeChoose: 'Chọn loại giải pháp',
            editor_typeNone: 'Hồ sơ đã cài đặt không khai báo loại giải pháp nào, nên chưa thể chọn.',
            editor_customerGroup: 'Nhóm khách hàng tiềm năng',
            editor_levelChoose: 'Chọn cấp độ an toàn',
            editor_levelNone: 'Không có khung tuân thủ đã cài đặt nào khai báo cấp độ an toàn, nên chưa thể chọn.',
            editor_levelOption: '{label} ({scheme})',
            editor_submit: 'Lưu giải pháp',
            editor_saving: 'Đang lưu…',
            editor_cancel: 'Hủy',
            editor_saved: 'Đã lưu giải pháp.',
            editor_failed: 'Không thể lưu giải pháp.',
            editor_stale: 'Giải pháp đã thay đổi kể từ lần đọc gần nhất. Hồ sơ đã được tải lại và nội dung bạn nhập vẫn còn đó. Hãy kiểm tra, rồi gửi lại.',
        },
        registry: {
            heading: 'Hồ sơ tra cứu từ cơ sở dữ liệu',
            intro: 'Các tài liệu đăng ký mà hồ sơ này dựa vào. Ngân hàng Nhà nước tự khai thác từng hồ sơ từ cơ sở dữ liệu. Hệ thống không gọi cơ sở dữ liệu nào: mỗi dòng ghi nguồn của tài liệu, kết quả mà Ngân hàng Nhà nước trả lời, ngày ghi nhận và người ghi nhận, cùng bổ sung hoặc quyết định cần khi việc khai thác không thành.',
            loading: 'Đang tải các hồ sơ tra cứu…',
            loadError: 'Không tải được các hồ sơ tra cứu.',
            retrySubject: 'các hồ sơ tra cứu',
            readOnly: 'Bạn có thể xem các hồ sơ này. Ghi nhận tài liệu, thay đổi và đính kèm tệp bổ sung cần quyền quản lý.',
            add: 'Ghi nhận tài liệu',
            edit: 'Thay đổi',
            notRecorded: 'Chưa ghi nhận',
            stateBankRetrieves: 'Ngân hàng Nhà nước khai thác hồ sơ này. Hệ thống không gọi cơ sở dữ liệu, và kết quả hiển thị là kết quả đã ghi theo câu trả lời của Ngân hàng Nhà nước.',
            requirementLabel: 'Yêu cầu',
            requirementNotDeclared: 'Chưa được khung tuân thủ đã cài đặt khai báo',
            sourceLabel: 'Nguồn',
            sourceRegistry: 'Ngân hàng Nhà nước khai thác từ cơ sở dữ liệu',
            sourceApplicant: 'Bản sao do tổ chức nộp',
            outcomeLabel: 'Kết quả của Ngân hàng Nhà nước',
            outcomeClass_retrieved: 'Được tính là đã khai thác',
            outcomeClass_not_retrieved: 'Không được tính là đã khai thác',
            outcomeClass_incomplete_or_inaccurate: 'Không được tính là đã khai thác: không đầy đủ hoặc không chính xác',
            outcomeSeen: 'Ngày ghi nhận: {date}',
            outcomeNotDeclared: 'Chưa được khung tuân thủ đã cài đặt khai báo, nên chưa ghi được kết quả nào.',
            outcomeUndeclared: 'Chưa được bản ghi đã cài đặt khai báo ({code})',
            outcomeNotApplicable: 'Không áp dụng: tài liệu là bản sao do tổ chức nộp.',
            recorderLabel: 'Người ghi nhận',
            supplementLabel: 'Bổ sung hoặc quyết định',
            supplementNotNeeded: 'Không cần: kết quả được tính là đã khai thác.',
            supplementRecorded: 'Bổ sung ngày {date}: {reference}',
            supplementFileOnly: 'Bổ sung ngày {date}, đã đính kèm tệp.',
            supplementFileAttached: 'Tệp: {name}',
            supplementFileNoName: 'Đã đính kèm tệp. Tên tệp cần quyền tải xuống tệp đính kèm.',
            decisionRecorded: 'Quyết định ngày {date}: {text}',
            supplementMissing: 'Cần thiết. Ghi nhận bổ sung có ngày kèm tham chiếu hoặc tệp, hoặc quyết định có ngày rằng không cần bổ sung.',
            limbLabel: 'Phần đăng ký đầu tư',
            limbApplies: 'Áp dụng cho hồ sơ này. Nguồn: {source}.',
            item_scope_declaration: 'phạm vi yêu cầu đã khai báo',
            item_personnel_link: 'liên kết nhân sự chính xác',
            item_retrieved_on: 'ngày thực tế khai thác nguồn',
            item_failure_follow_up_declaration: 'khai báo yêu cầu tiếp theo theo nguồn',
            item_failure_follow_up_request: 'văn bản yêu cầu tiếp theo',
            item_supplement: 'thành phần thực tế đã cung cấp',
            item_applicant_copy_file: 'tệp bản sao đang được lưu giữ',
            item_information_pending: 'thông tin vẫn đang chờ',
            limbConditional: 'Thành phần hồ sơ được dẫn có giấy chứng nhận đăng ký đầu tư nếu có. Không xác định tổ chức này có hoặc phải xin giấy đó. Nguồn: {source}.',
            limbNotListed: 'Thành phần hồ sơ được dẫn không liệt kê giấy chứng nhận đăng ký đầu tư. Đây không phải miễn trừ chung về đăng ký đầu tư. Nguồn: {source}.',
            limbNotOnTrack: 'Không áp dụng cho hồ sơ này.',
            limbTrackNotDeclared: 'Chưa xác định hướng hồ sơ hoặc khai báo thành phần theo nguồn. Không suy ra nghĩa vụ tài liệu hay miễn trừ.',
            dossierLabel: 'Hồ sơ',
            dossierComplete: 'Đầy đủ: dòng có những gì nguồn và kết quả yêu cầu. Cơ quan có thẩm quyền quyết định bước tiếp theo.',
            dossierIncomplete: 'Chưa đầy đủ. Còn thiếu: {items}.',
            item_source: 'nguồn',
            item_outcome: 'kết quả của Ngân hàng Nhà nước và ngày ghi nhận',
            item_supplement_or_decision: 'bổ sung có ngày hoặc quyết định đã ghi nhận',
            editor_title: 'Ghi nhận tài liệu',
            editor_titleEdit: 'Thay đổi tài liệu',
            editor_hint: 'Chọn yêu cầu, nguồn của tài liệu và kết quả Ngân hàng Nhà nước trả lời, kèm ngày ghi nhận. Khi khai thác không thành, cần bổ sung có ngày, hoặc quyết định có ngày rằng không cần bổ sung.',
            editor_requirement: 'Yêu cầu',
            editor_requirementChoose: 'Chọn một yêu cầu',
            editor_requirementNone: 'Mọi yêu cầu khung tuân thủ đã cài đặt khai báo đều đã được ghi nhận, hoặc không có yêu cầu nào được khai báo.',
            editor_source: 'Nguồn',
            editor_sourceChoose: 'Chọn nguồn',
            editor_outcome: 'Kết quả của Ngân hàng Nhà nước',
            editor_outcomeChoose: 'Chọn kết quả',
            editor_outcomeNone: 'Bản ghi đã cài đặt không khai báo kết quả nào cho yêu cầu này, nên chưa chọn được kết quả.',
            editor_outcomeOn: 'Ngày ghi nhận kết quả',
            editor_supplementOn: 'Ngày thực tế cung cấp thành phần hồ sơ',
            editor_supplementReference: 'Tham chiếu bổ sung',
            editor_supplementReferenceHint: 'Tối đa 500 ký tự: số công văn hoặc tham chiếu tệp.',
            editor_decisionOn: 'Ngày quyết định',
            editor_decisionText: 'Nội dung quyết định',
            editor_decisionTextHint: 'Tối đa 1000 ký tự: giữ nguyên quyết định theo tài liệu và phần giải thích. Không miễn yêu cầu theo nguồn hoặc thông tin còn thiếu.',
            editor_submit: 'Lưu tài liệu',
            editor_saving: 'Đang lưu…',
            editor_cancel: 'Hủy',
            editor_saved: 'Đã lưu tài liệu.',
            editor_failed: 'Không lưu được tài liệu.',
            editor_stale: 'Tài liệu đã thay đổi sau khi được đọc. Hệ thống đã tải lại, và nội dung bạn nhập vẫn còn đây. Kiểm tra rồi gửi lại.',
            supplementUpload: 'Đính kèm tệp bổ sung',
            supplementRejected: 'Không đính kèm được tệp bổ sung.',
            supplementNotBound: 'Tệp đã được lưu cho tài liệu này nhưng chưa được đính kèm vào tài liệu. {message}',
        },
        personnel: {
            generic: {
                heading: 'Điều kiện có tài liệu chứng minh đã khai báo',
                hint: 'Ghi từng câu trả lời đã khai báo cùng tham chiếu tài liệu chứng minh riêng. Đây là bản ghi tài liệu, không phải quyết định đủ điều kiện. Khi đổi lựa chọn phải nhập lại tài liệu chứng minh.',
                evidence: 'Tham chiếu tài liệu chứng minh cho điều kiện này',
                required: 'bắt buộc khi chọn câu trả lời',
                source: 'Nguồn',
                notDeclared: 'Chưa có khai báo điều kiện sử dụng được. Không kết luận về việc đủ điều kiện.',
                not_recorded: 'Chưa ghi nhận',
                recorded_with_evidence: 'Đã ghi nhận câu trả lời và tham chiếu tài liệu riêng',
                evidence_missing: 'Câu trả lời đã ghi nhận chưa có tham chiếu tài liệu chứng minh',
                option_not_declared: 'Lựa chọn đã ghi nhận không còn được khai báo',
                does_not_apply: 'Không áp dụng cho mẫu đơn và vai trò đã khai báo của bản ghi này',
                not_declared: 'Cần rà soát khai báo điều kiện',
                clear: 'Xóa rõ ràng câu trả lời của điều kiện này',
                legacyHeading: 'Nội dung điều kiện trước đây được bảo toàn',
                legacyHint: 'Nội dung trước đây được giữ riêng và chưa chuyển thành câu trả lời điều kiện hiện tại.',
                legacyBasis: 'Trình độ theo vai trò trước đây được bảo toàn',
                clearBasis: 'Xóa trình độ theo vai trò trước đây',
                history: 'Lịch sử bất biến về trình độ theo vai trò trước đây',
                historyNone: 'Chưa ghi nhận bản chụp vai trò trước đây.',
                role: 'Vai trò',
                qualification: 'Mã trình độ trước đây',
                dates: 'Các ngày của vai trò đã ghi nhận',
                evidenceIds: 'Tham chiếu tài liệu đã ghi nhận; không khẳng định tình trạng lưu giữ hiện tại',
                actor: 'Người ghi nhận',
                time: 'Thời điểm ghi nhận',
                versions: 'Các phiên bản bản ghi',
                reload: 'Đọc bản ghi nhân sự hiện tại',
                stale: 'Bản ghi đã thay đổi. Đọc bản ghi hiện tại rồi rà soát nội dung đã giữ lại trước khi thử lại.',
                reloaded: 'Đã đọc bản ghi hiện tại. Nội dung bạn nhập được giữ nguyên; rà soát lựa chọn đã khai báo và phiên bản hiện tại trước khi thử lại.',
                retiredAnswer: 'Câu trả lời được bảo toàn chưa được bản ghi đã cài đặt khai báo',
                retainedDraft: 'Cần rà soát nội dung dự thảo đã giữ lại theo khai báo hiện tại. Nội dung này chưa được lưu.',
                discardDraft: 'Bỏ nội dung sửa dự thảo chưa lưu này',
            },
            heading: 'Tài liệu chứng minh điều kiện của nhân sự',
            intro: 'Những người mà đơn này nêu tên, các vai trò có thời hạn mà mỗi người đã giữ và tài liệu chứng minh mà mỗi vai trò dựa vào. Nền tảng ghi nhận những gì tài liệu chứng minh cho thấy. Nền tảng không quyết định ai có đủ điều kiện.',
            loading: 'Đang tải hồ sơ nhân sự…',
            loadError: 'Không tải được hồ sơ nhân sự.',
            retrySubject: 'hồ sơ nhân sự',
            vocabError: 'Không đọc được các vai trò và kết quả mà bản ghi đã cài đặt khai báo.',
            notDeclaredRoles: 'Bản ghi đã cài đặt không khai báo vai trò nào cho khung tuân thủ này, nên chưa ghi nhận được vai trò.',
            notDeclaredBases: 'Bản ghi đã cài đặt không khai báo phương án trình độ nào cho khung tuân thủ này.',
            notDeclaredOutcomes: 'Bản ghi đã cài đặt không khai báo kết quả kiểm tra lý lịch tư pháp nào cho khung tuân thủ này, nên chưa ghi nhận được kết quả.',
            empty: 'Chưa ghi nhận người nào cho hồ sơ này.',
            total: '{count} hồ sơ nhân sự',
            pagination: 'Các trang hồ sơ nhân sự',
            readOnly: 'Bạn có thể xem các hồ sơ này. Ghi nhận, sửa và đính kèm tài liệu chứng minh cần quyền quản lý.',
            add: 'Thêm người',
            personName: 'Tên người',
            personHint: 'Nhập tên đúng như trong bản khai lý lịch cá nhân.',
            statementSignedOn: 'Ngày ký bản khai lý lịch cá nhân',
            statementNotRecorded: 'Chưa ghi nhận ngày ký bản khai',
            edit: 'Sửa hồ sơ này',
            colRole: 'Vai trò',
            colBasis: 'Phương án trình độ mà tài liệu cho thấy',
            colDates: 'Thời gian giữ vai trò',
            colApplicability: 'Áp dụng cho mẫu đơn',
            colEvidence: 'Tài liệu chứng minh',
            noRoles: 'Chưa ghi nhận vai trò nào cho người này.',
            basisNotRecorded: 'Chưa ghi nhận',
            undeclaredRole: 'Vai trò không được bản ghi đã cài đặt khai báo ({code})',
            undeclaredBasis: 'Phương án không được bản ghi đã cài đặt khai báo ({code})',
            undeclaredOutcome: 'Kết quả không được bản ghi đã cài đặt khai báo ({code})',
            heldFrom: 'Từ {from}',
            heldUntil: 'đến {to}',
            heldOpen: 'vẫn đang giữ',
            applies: 'Áp dụng cho mẫu đơn này',
            doesNotApply: 'Không áp dụng cho mẫu đơn này',
            applicabilityNotDeclared: 'Bản ghi đã cài đặt không khai báo',
            evidenceNone: 'Chưa đính kèm tài liệu chứng minh cho vai trò này.',
            evidenceCount: '{count} tệp đã đính kèm. Tên tệp cần quyền tải xuống tệp đính kèm.',
            evidenceUpload: 'Đính kèm tài liệu chứng minh cho {role}',
            evidenceRejected: 'Không đính kèm được tài liệu chứng minh.',
            evidenceNotBound: 'Tệp đã được lưu cho hồ sơ này nhưng chưa gắn vào vai trò. {message}',
            currency: {
                heading: 'Hiệu lực của bản khai',
                current: 'Còn trong thời hạn đã khai báo đến {date}.',
                older: 'Tài liệu chứng minh đã cũ hơn thời hạn đã khai báo.',
                notDeterminable: 'Chưa xác định được hiệu lực: {reason}.',
                reasonNoStatementDate: 'chưa ghi nhận ngày ký bản khai',
                reasonNoLimit: 'bản ghi đã cài đặt không khai báo thời hạn hiệu lực',
                reasonNoLimitInForce: 'thời hạn đã khai báo chưa có hiệu lực vào ngày này',
                reasonActivationUnknown: 'chưa nêu ngày thời hạn đã khai báo bắt đầu có hiệu lực',
                reasonNotOperational: 'khung tuân thủ chỉ được cài đặt để tham khảo',
                basisReceipt: 'Xét theo ngày nhận hồ sơ, {date}.',
                basisAsOf: 'Xét theo ngày xem trang này, {date}.',
            },
            outcome: {
                heading: 'Kết quả kiểm tra lý lịch tư pháp',
                recordOutcome: 'Ghi nhận kết quả của cơ quan',
                changeOutcome: 'Thay đổi kết quả đã ghi nhận',
                recordedOn: '{outcome}, cơ quan báo ngày {date}',
                title: 'Ghi nhận kết quả kiểm tra lý lịch tư pháp mà cơ quan đã đưa ra',
                hint: 'Chọn kết quả mà Ngân hàng Nhà nước đã báo và nhập ngày cơ quan đưa ra kết quả đó. Nền tảng chỉ lưu kết quả. Nội dung của việc kiểm tra thuộc về cơ quan đang giữ thông tin, và không có nội dung nào được nhập tại đây.',
                code: 'Kết quả',
                chooseCode: 'Chọn kết quả',
                on: 'Ngày cơ quan đưa ra kết quả',
                submit: 'Ghi nhận kết quả',
                saving: 'Đang lưu…',
                cancel: 'Hủy',
                saved: 'Đã ghi nhận kết quả.',
                failed: 'Không ghi nhận được kết quả.',
                blocked: 'Chọn kết quả và nhập ngày cơ quan đưa ra kết quả đó.',
            },
            record: {
                addTitle: 'Thêm người',
                editTitle: 'Sửa hồ sơ nhân sự này',
                hint: 'Nhập tên người và từng vai trò cùng ngày bắt đầu và ngày kết thúc như tài liệu chứng minh ghi. Với mỗi vai trò, ghi phương án trình độ mà tài liệu cho thấy. Nền tảng ghi nhận lựa chọn đó; nền tảng không quyết định người này có đủ điều kiện hay không.',
                roleRow: 'Vai trò {n}',
                role: 'Vai trò',
                chooseRole: 'Chọn vai trò',
                basis: 'Phương án trình độ mà tài liệu cho thấy',
                basisNotRecorded: 'Chưa ghi nhận',
                from: 'Bắt đầu giữ từ',
                to: 'Đến',
                toOpen: 'Vẫn đang giữ (để trống)',
                removeRole: 'Xóa vai trò này',
                addRole: 'Thêm vai trò',
                submitAdd: 'Ghi nhận người',
                submitEdit: 'Lưu hồ sơ',
                saving: 'Đang lưu…',
                cancel: 'Hủy',
                required: 'Bắt buộc',
                blocked: 'Nhập tên người và, với mỗi vai trò, vai trò cùng ngày bắt đầu giữ.',
                added: 'Đã ghi nhận người.',
                saved: 'Đã lưu hồ sơ.',
                failed: 'Không lưu được hồ sơ.',
                stale: 'Hồ sơ đã thay đổi kể từ khi bạn đọc. Hồ sơ đã được tải lại và nội dung bạn nhập vẫn còn đó. Hãy kiểm tra rồi gửi lại.',
            },
            conditions: {
                heading: 'Điều kiện của người đại diện theo pháp luật và Tổng giám đốc (Giám đốc)',
                recordConditions: 'Ghi nhận điều kiện',
                changeConditions: 'Thay đổi điều kiện đã ghi nhận',
                notRecorded: 'Chưa ghi nhận',
                nationality: 'Quốc tịch',
                conviction: 'Án tích',
                sanction: 'Xử phạt vi phạm hành chính trong lĩnh vực tài chính, ngân hàng và an ninh mạng',
                notDeclared: 'Bản ghi đã cài đặt không khai báo điều kiện nào cho mẫu đơn này.',
                title: 'Ghi nhận điều mà bằng chứng thể hiện về từng điều kiện',
                hint: 'Với từng điều kiện, chọn điều mà bằng chứng thể hiện. Để trống nếu chưa ghi nhận. Nền tảng ghi lại lựa chọn mà bằng chứng thể hiện; nền tảng không quyết định về điều kiện.',
                chooseOption: 'Chưa ghi nhận',
                undeclared: 'Lựa chọn không nằm trong bản ghi đã cài đặt ({code})',
                submit: 'Ghi nhận điều kiện',
                saving: 'Đang lưu…',
                cancel: 'Hủy',
                saved: 'Đã ghi nhận điều kiện.',
                failed: 'Không ghi nhận được điều kiện.',
                clearRetired: 'Xóa giá trị án tích đã bãi bỏ',
                clearRetiredHint: 'Mã án tích này đã được bãi bỏ và bản ghi đã cài đặt không còn khai báo mã này. Xóa sẽ gỡ mã khỏi bản ghi. Hai điều kiện ở trên không thay đổi.',
                clearedRetired: 'Đã xóa giá trị đã bãi bỏ.',
            },
        },
        copy: {
            recordedBy: 'Ghi nhận bởi',
            notice: 'Thông báo của nền tảng',
        },
        outcome: {
            heading: 'Dừng, hoàn thành và đóng hồ sơ',
            intro: 'Dừng thử nghiệm là cách duy nhất để kết thúc hồ sơ trước thời hạn. Nền tảng ghi lại những gì tổ chức nộp và quyết định của Ngân hàng Nhà nước. Ngân hàng Nhà nước quyết định mọi việc dừng, thu hồi và hoàn thành, và ban hành mọi quyết định cùng văn bản xác nhận hoàn thành. Nền tảng chỉ giữ bản sao do cơ quan có thẩm quyền trao và ghi rõ nguồn của bản sao đó.',
            readOnly: 'Bạn có thể xem các hồ sơ này. Lập hoặc ghi nhận cần quyền quản lý.',
            // Sprint 62.51.0 (CL-3) — a procedure that declares no organisation outcome filing.
            stopNotOffered: 'Thủ tục đã cài đặt của hồ sơ này không có bước tổ chức nộp hồ sơ đề nghị dừng, nên nội dung đó không được ghi nhận tại đây.',
            completionNotOffered: 'Thủ tục đã cài đặt của hồ sơ này không có bước tổ chức nộp hồ sơ đề nghị kết thúc, nên nội dung đó không được ghi nhận tại đây.',
            recordedOnIntro: 'Kết quả được ghi nhận theo văn bản của chính cơ quan có thẩm quyền và của cơ quan liên quan tại:',
            recordedOnNone: 'Thủ tục đã cài đặt không nêu sổ ghi nhận kết quả.',
            loadError: 'Không thể đọc phần dừng, hoàn thành, đóng hồ sơ và các yêu cầu.',
            retry: 'Thử lại',
            notDeclared: 'Chưa được khai báo bởi khung tuân thủ đã cài đặt.',
            stop: {
                heading: 'Dừng thử nghiệm',
                none: 'Chưa có đơn dừng nào được nộp cho hồ sơ này.',
                filed: 'Đơn dừng đã nộp. Đang chờ quyết định của Ngân hàng Nhà nước. Nền tảng không ghi nhận quyết định nào của riêng mình.',
                decided: 'Quyết định của Ngân hàng Nhà nước đã được ghi nhận đúng như cơ quan trao.',
                stopDate: 'Ngày dừng do người thực hiện nhập: {date}.',
                groundsHeading: 'Căn cứ',
                viewGrounds: 'Xem căn cứ ({count})',
                groundsNone: 'Chưa được khai báo bởi khung tuân thủ đã cài đặt. Nền tảng không ghi căn cứ nào.',
                filesHeading: 'Các tệp kèm theo đơn dừng',
                role_application: 'Đơn đề nghị',
                role_results_report: 'Báo cáo kết quả',
                role_stop_plan: 'Kế hoạch dừng',
                held: 'Đã lưu: {name}.',
                notHeld: 'Chưa được lưu dưới hồ sơ này.',
                notFiled: 'Chưa nộp.',
                missing: 'Còn thiếu: {roles}.',
                complete: 'Đủ mọi tệp mà việc dừng cần.',
                endedByCertificate: 'Văn bản hoàn thành của cơ quan có thẩm quyền đã được ghi nhận, nên không nộp đơn dừng cho hồ sơ này.',
                decisionEndedByCertificate: 'Văn bản hoàn thành của cơ quan có thẩm quyền đã được ghi nhận, nên không ghi nhận quyết định dừng và thu hồi thử nghiệm cho hồ sơ này.',
                filedEndedByCertificate: 'Đơn dừng đã nộp. Văn bản hoàn thành của cơ quan có thẩm quyền đã được ghi nhận, nên không còn chờ quyết định về đơn dừng này.',
                decisionHeading: 'Quyết định của Ngân hàng Nhà nước',
                decisionNone: 'Chưa ghi nhận quyết định nào. Nền tảng chỉ ghi nhận từ văn bản của cơ quan.',
                decisionRef: 'Số hiệu quyết định: {ref}',
                decidedOn: 'Ngày ban hành quyết định: {date}',
                decisionText: 'Nội dung quyết định, đúng như cơ quan trao:',
                evidence: 'Tài liệu chứng minh: {names}',
            },
            completion: {
                heading: 'Hoàn thành',
                none: 'Chưa nộp đề nghị hoàn thành nào.',
                filed: 'Đề nghị hoàn thành đã nộp. Ngân hàng Nhà nước đánh giá. Nền tảng không quyết định gì.',
                role_evaluation_report: 'Báo cáo đánh giá',
                role_results_report: 'Báo cáo kết quả',
                endedByRevocation: 'Quyết định dừng và thu hồi thử nghiệm của Ngân hàng Nhà nước đã được ghi nhận, nên không ghi nhận đề nghị hoàn thành hay bản sao văn bản hoàn thành cho hồ sơ này.',
                certificateNone: 'Chưa ghi nhận bản sao văn bản hoàn thành nào. Nền tảng không lập văn bản này.',
                certificateRecorded: 'Bản sao của cơ quan có thẩm quyền đã được ghi nhận.',
                copySource: 'Nguồn: bản sao của cơ quan có thẩm quyền.',
                copyDate: 'Ngày trên bản sao của cơ quan: {date}.',
            },
            closure: {
                heading: 'Đóng hồ sơ',
                unavailable: 'Chỉ ghi nhận đóng hồ sơ sau khi quyết định của cơ quan có thẩm quyền đã được ghi nhận.',
                noticesHeading: 'Thông báo dừng',
                noticesNone: 'Chưa ghi nhận thông báo dừng nào.',
                notice: 'Thông báo đã gửi ngày {date}: {name}.',
                liquidationHeading: 'Biên bản thanh lý',
                liquidationNone: 'Chưa ghi nhận biên bản thanh lý nào.',
                liquidation: 'Biên bản thanh lý ngày {date}: {name}.',
                dutiesHeading: 'Nghĩa vụ sau khi dừng',
                dutiesIntro: 'Các nghĩa vụ này lấy từ văn bản gốc. Nền tảng ghi nhận chứ không tạo ra chúng. Mỗi nghĩa vụ được tính từ ngày mốc riêng, do người phụ trách nhập vào hồ sơ đóng. Nghĩa vụ chưa có ngày mốc thì không hiển thị ngày.',
                duty_entitlements_settled: 'Quyền và nghĩa vụ của khách hàng được giải quyết',
                duty_settlement_report: 'Kết quả giải quyết được báo cáo bằng văn bản',
                citation: 'Nguồn: {citation}',
                dutyNotDeclared: 'Chưa được khai báo bởi khung tuân thủ đã cài đặt. Không hiển thị khoảng thời gian và không tính ngày.',
                dutyAmbiguous: 'Có nhiều bản ghi đã cài đặt khai báo nghĩa vụ này. Nền tảng không tự chọn giữa các bản ghi.',
                dutyNotCountable: 'Khoảng thời gian đã cài đặt không thuộc loại nền tảng tính được. Không tính ngày.',
                dutyDueFromAnchor: 'Thời hạn: {period} {unit} kể từ {anchor}. Đến hạn {due}.',
                dutyAnchorNotRecorded: 'Chưa ghi nhận ngày mốc ({anchor}). Không hiển thị ngày.',
                dutyNotInForce: 'Thời hạn của nghĩa vụ này theo bản ghi đã cài đặt chưa có hiệu lực, hoặc bản ghi không nêu ngày bắt đầu để xác định. Không hiển thị ngày.',
                dutyContinuingNoPeriod: 'Nghĩa vụ tiếp tục. Văn bản không ghi thời hạn đối với giải pháp ngoài phạm vi của nghĩa vụ này, nên không hiển thị thời hạn và không hiển thị ngày.',
                dutySolutionPointNotRecorded: 'Chưa ghi nhận điểm giải pháp. Mẫu đơn của hồ sơ không cho biết giải pháp thuộc điểm nào, nên không tính ngày.',
                anchor_stop_decision: 'ngày quyết định dừng của Ngân hàng Nhà nước',
                anchor_settlement_completion: 'ngày hoàn tất giải quyết quyền lợi và nghĩa vụ của khách hàng',
                anchorLabel_stop_decision: 'Ngày quyết định dừng của Ngân hàng Nhà nước',
                anchorLabel_settlement_completion: 'Ngày hoàn tất giải quyết quyền lợi và nghĩa vụ của khách hàng',
                anchorsHeading: 'Các ngày mốc',
                settlementReferencePending: 'Ngày tham chiếu để giải quyết quyền lợi và nghĩa vụ của khách hàng: chờ ghi nhận ngày quyết định dừng của Ngân hàng Nhà nước.',
                settlementReferenceRecorded: 'Ngày tham chiếu để giải quyết quyền lợi và nghĩa vụ của khách hàng: {date}, ngày quyết định dừng của Ngân hàng Nhà nước đã ghi nhận.',
                anchorRecorded: '{label}: {date}. Tài liệu chứng minh: {evidence}.',
                anchorNotRecorded: '{label}: chưa ghi nhận.',
                unit_months: 'tháng',
                unit_calendar_days: 'ngày dương lịch',
                unit_working_days: 'ngày làm việc',
            },
            directions: {
                heading: 'Yêu cầu và thông báo kiểm tra tại chỗ của cơ quan có thẩm quyền',
                intro: 'Mỗi mục được ghi trong sổ đăng ký yêu cầu của cơ quan. Thời hạn trả lời được đọc từ khung tuân thủ đã cài đặt khai báo loại đó.',
                none: 'Chưa ghi nhận mục nào.',
                kindUndeclared: 'Đã ghi nhận là “{kind}”, một loại mà không khung tuân thủ đã cài đặt nào của hồ sơ này khai báo.',
                registerWithheld: 'Số hiệu, cơ quan, thời điểm nhận và thời hạn trả lời được lưu trong sổ đăng ký yêu cầu của cơ quan, và cần quyền xem riêng của sổ đó.',
                manageNeeded: 'Ghi nhận yêu cầu hoặc thông báo còn cần quyền quản lý của sổ đăng ký yêu cầu của cơ quan.',
                ref: 'Số hiệu: {ref}',
                authority: 'Cơ quan: {name}',
                received: 'Nhận ngày {date}',
                clockRunning: 'Hạn trả lời {due}, theo khung tuân thủ đã cài đặt.',
                clockNotDeclared: 'Thời hạn trả lời: chưa được khai báo bởi khung tuân thủ đã cài đặt.',
                clockOther: 'Chưa tính thời hạn trả lời: {reason}.',
                clockNotInForceFrom: 'Chưa tính thời hạn trả lời: khung tuân thủ quy định thời hạn này chỉ được áp dụng từ {date}.',
            },
            actions: {
                fileStop: 'Nộp đơn dừng',
                recordDecision: 'Ghi nhận quyết định của cơ quan',
                fileCompletion: 'Nộp đề nghị hoàn thành',
                recordCertificate: 'Ghi nhận bản sao của cơ quan',
                recordClosure: 'Ghi nhận đóng hồ sơ',
                recordDirection: 'Ghi nhận yêu cầu hoặc thông báo',
                chooseFile: 'Chọn tệp',
                uploading: 'Đang lưu tệp…',
                uploaded: 'Đã lưu dưới hồ sơ này.',
                uploadFailed: 'Không thể lưu tệp dưới hồ sơ này.',
                cancel: 'Hủy',
                saving: 'Đang lưu…',
                continue: 'Tiếp tục đến xác nhận',
            },
            stopForm: {
                title: 'Nộp đơn dừng',
                hint: 'Đơn dừng cần đơn đề nghị, báo cáo kết quả và kế hoạch dừng, mỗi tệp đã lưu dưới hồ sơ này, cùng ngày dừng theo hiểu biết của người nhập.',
                incomplete: 'Hãy lưu đủ đơn đề nghị, báo cáo kết quả và kế hoạch dừng, và nhập ngày dừng trước khi tiếp tục.',
                stopDate: 'Ngày dừng',
            },
            stopConfirm: {
                title: 'Xác nhận đơn dừng',
                text: 'Nộp đơn ghi nhận việc dừng của tổ chức. Ngân hàng Nhà nước quyết định việc dừng thử nghiệm và việc thu hồi. Trang này không quyết định thay.',
                confirm: 'Nộp đơn dừng',
                done: 'Đơn dừng đã được nộp.',
                failed: 'Không thể nộp đơn dừng.',
            },
            revoke: {
                title: 'Ghi nhận quyết định của Ngân hàng Nhà nước',
                hint: 'Chỉ ghi nhận quyết định của chính cơ quan, từ văn bản của cơ quan. Số hiệu và nội dung được giữ đúng như cơ quan trao.',
                incomplete: 'Hãy nhập số hiệu, ngày, nội dung và tệp quyết định. Mỗi mục được giữ đúng như cơ quan trao.',
                ref: 'Số hiệu quyết định',
                decidedOn: 'Ngày ban hành quyết định',
                text: 'Nội dung quyết định',
                evidence: 'Tệp quyết định',
                submit: 'Ghi nhận quyết định',
                done: 'Quyết định đã được ghi nhận.',
                failed: 'Không thể ghi nhận quyết định.',
            },
            completionForm: {
                title: 'Nộp đề nghị hoàn thành',
                hint: 'Đề nghị cần báo cáo đánh giá và báo cáo kết quả, mỗi tệp đã lưu dưới hồ sơ này.',
                incomplete: 'Hãy lưu đủ hai báo cáo trước khi nộp đề nghị.',
                submit: 'Nộp đề nghị',
                done: 'Đề nghị hoàn thành đã được nộp.',
                failed: 'Không thể nộp đề nghị hoàn thành.',
            },
            certificate: {
                title: 'Ghi nhận bản sao của cơ quan',
                hint: 'Chỉ ghi nhận bản sao do cơ quan trao. Nền tảng không lập văn bản nào.',
                incomplete: 'Hãy lưu bản sao của cơ quan và nhập ngày trên bản sao.',
                copyDate: 'Ngày trên bản sao của cơ quan',
                file: 'Bản sao của cơ quan',
                submit: 'Ghi nhận bản sao',
                done: 'Bản sao của cơ quan đã được ghi nhận.',
                failed: 'Không thể ghi nhận bản sao của cơ quan.',
            },
            anchorCorrection: {
                heading: 'Đối chiếu ngày mốc và sự kiện có tài liệu chứng minh',
                limitation: 'Chỉ đối chiếu sự kiện đã khai báo trên hồ sơ này. Sửa ngày mốc không thay đổi sự kiện vòng đời hoặc bản ghi thu hồi. Sự kiện vòng đời sai cần một quy trình sửa riêng.',
                not_declared: 'Chưa khai báo đối chiếu sự kiện trên cùng hồ sơ.',
                pending_anchor: 'Đã ghi nhận sự kiện có tài liệu chứng minh; vẫn phải ghi nhận ngày mốc rõ ràng.',
                anchor_only: 'Đã ghi nhận ngày mốc; chưa ghi nhận sự kiện đối ứng.',
                pending_fact: 'Tài liệu đối ứng đang chờ đối chiếu. Không hiển thị hạn bị ảnh hưởng.',
                agreed: 'Ngày mốc đã ghi nhận khớp với sự kiện có tài liệu chứng minh đã được đối chiếu.',
                conflict: 'Các bản ghi mâu thuẫn. Giữ nguyên cả hai ngày; không hiển thị hạn bị ảnh hưởng.',
                mappingInvalid: 'Cần rà soát khai báo đối chiếu đã cài đặt.',
                multipleEvents: 'Đã ghi nhận nhiều lần xảy ra sự kiện đối ứng. Không chọn lần nào làm căn cứ quyết định.',
                datesDisagree: 'Các ngày thực tế đã ghi nhận khác nhau.',
                evidenceReview: 'Rà soát tài liệu chứng minh và điều kiện tiên quyết đã khai báo của sự kiện đối ứng.',
                anchorDate: 'Ngày mốc đã ghi nhận rõ ràng',
                eventDate: 'Ngày thực tế xảy ra sự kiện có tài liệu chứng minh',
                event: 'Sự kiện đã khai báo',
                source: 'Nguồn',
                notRecorded: 'Chưa ghi nhận',
                anchorNotDeclared: 'Nghĩa vụ đã cài đặt chưa khai báo ngày mốc. Không tính hạn.',
                dutyConflict: 'Ngày mốc mâu thuẫn với sự kiện có tài liệu chứng minh. Không tính hạn.',
                dutyPending: 'Tài liệu đối ứng của ngày mốc đang chờ đối chiếu. Không tính hạn.',
                declaredPeriod: 'Thời hạn đã khai báo: {period} {unit}.',
                settlementConflict: 'Mốc giải quyết: các ngày trong tài liệu mâu thuẫn. Không chọn ngày mốc.',
                correct: 'Sửa ngày mốc',
                title: 'Sửa ngày mốc đã được ghi nhận rõ ràng',
                hint: 'Nhập ngày thực tế đúng, tài liệu chứng minh và lý do. Bản ghi trước được giữ trong lịch sử bất biến. Thao tác này không ghi nhận hoặc sửa quyết định của cơ quan, sự kiện vòng đời hay bản ghi thu hồi.',
                date: 'Ngày thực tế đã sửa',
                evidence: 'Tham chiếu tài liệu chứng minh việc sửa',
                reason: 'Lý do sửa',
                required: 'bắt buộc',
                submit: 'Ghi nhận việc sửa ngày mốc',
                saved: 'Đã ghi nhận việc sửa ngày mốc.',
                failed: 'Không ghi nhận được việc sửa ngày mốc.',
                stale: 'Hồ sơ đã thay đổi. Đọc lại bản ghi đóng hồ sơ trước khi thử lại. Nội dung bạn nhập được giữ lại.',
                reload: 'Đọc lại bản ghi đóng hồ sơ',
                reloaded: 'Đã đọc bản ghi đóng hồ sơ hiện tại. Rà soát ngày mốc và nội dung đã giữ lại trước khi thử lại.',
                history: 'Lịch sử sửa ngày mốc bất biến',
                historyNone: 'Chưa ghi nhận việc sửa ngày mốc.',
                previous: 'Bản ghi ngày mốc trước',
                corrected: 'Bản ghi ngày mốc đã sửa',
                recordedBy: 'Người ghi nhận',
                recordedAt: 'Thời điểm ghi nhận',
                versions: 'Các phiên bản hồ sơ',
            },
            closureForm: {
                title: 'Ghi nhận đóng hồ sơ',
                hint: 'Ghi nhận thông báo dừng, biên bản thanh lý, hoặc cả hai, theo đúng ngày mỗi việc đã diễn ra.',
                incomplete: 'Hãy lưu thông báo dừng cùng ngày gửi, biên bản thanh lý cùng ngày, hoặc cả hai.',
                noticeFile: 'Tệp thông báo dừng',
                noticeDate: 'Ngày gửi thông báo',
                liquidationFile: 'Tệp biên bản thanh lý',
                liquidationDate: 'Ngày biên bản thanh lý',
                anchorsHint: 'Nhập từng ngày đúng như hồ sơ ghi nhận, kèm tài liệu chứng minh mà ngày đó dựa vào. Nền tảng không tính ngày nào tại đây.',
                stopDecisionDate: 'Ngày quyết định dừng của Ngân hàng Nhà nước',
                stopDecisionEvidence: 'Tài liệu chứng minh của quyết định dừng',
                settlementDate: 'Ngày hoàn tất giải quyết quyền lợi và nghĩa vụ',
                settlementEvidence: 'Tài liệu chứng minh của việc hoàn tất giải quyết',
                noticeIncomplete: 'Thông báo dừng cần cả tệp và ngày gửi. Nhập đủ cả hai, hoặc để trống thông báo.',
                liquidationIncomplete: 'Biên bản thanh lý cần cả tệp và ngày. Nhập đủ cả hai, hoặc để trống biên bản.',
                anchorIncomplete: 'Mỗi ngày mốc cần cả ngày và tài liệu chứng minh. Nhập đủ cả hai, hoặc để trống ngày mốc đó.',
                anchorRecordedNote: '{label}: đã ghi nhận. Không nhập lại.',
                refusal: {
                    STOP_DECISION_IN_FUTURE: 'Ngày quyết định dừng không được sau ngày hôm nay.',
                    SETTLEMENT_BEFORE_STOP: 'Ngày hoàn tất giải quyết không được trước việc dừng mà nó tiếp nối.',
                    POST_STOP_ANCHOR_ALREADY_RECORDED: 'Ngày mốc này đã được ghi nhận. Không nhập lại.',
                },
                submit: 'Ghi nhận',
                done: 'Đóng hồ sơ đã được ghi nhận.',
                failed: 'Không thể ghi nhận đóng hồ sơ.',
            },
            directionForm: {
                kindsLoading: 'Đang đọc các loại mà khung tuân thủ đã cài đặt khai báo…',
                kindsNone: 'Không khung tuân thủ đã cài đặt nào của hồ sơ này khai báo loại yêu cầu hoặc thông báo, nên không thể ghi nhận tại đây.',
                kindsLoadError: 'Không thể đọc các loại yêu cầu hoặc thông báo.',
                kindChoose: 'Chọn loại',
                title: 'Ghi nhận yêu cầu hoặc thông báo',
                hint: 'Ghi vào sổ đăng ký yêu cầu. Thời hạn được đọc từ khung tuân thủ đã cài đặt, không đặt tại đây.',
                incomplete: 'Hãy nhập đủ từng mục và ít nhất một số hiệu chứng từ nhận.',
                kind: 'Loại',
                ref: 'Số hiệu',
                authority: 'Cơ quan',
                scope: 'Phạm vi',
                received: 'Ngày và giờ nhận',
                receivedDay: 'Ngày nhận',
                receivedTime: 'Giờ nhận',
                receipt: 'Số hiệu chứng từ nhận, mỗi dòng một số',
                submit: 'Ghi nhận',
                done: 'Yêu cầu hoặc thông báo đã được ghi nhận.',
                failed: 'Không thể ghi nhận yêu cầu hoặc thông báo.',
            },
            fieldLabels: {
                application_file_id: 'Đơn đề nghị',
                results_report_file_id: 'Báo cáo kết quả',
                stop_plan_file_id: 'Kế hoạch dừng',
                stop_date: 'Ngày dừng',
                decision_ref: 'Số hiệu quyết định',
                decided_on: 'Ngày ban hành quyết định',
                decision_text: 'Nội dung quyết định',
                evidence_file_ids: 'Tệp quyết định',
                evaluation_report_file_id: 'Báo cáo đánh giá',
                file_id: 'Bản sao của cơ quan',
                copy_dated_on: 'Ngày trên bản sao của cơ quan',
                notice: 'Thông báo dừng',
                liquidation: 'Biên bản thanh lý',
                kind: 'Loại',
                direction_ref: 'Số hiệu',
                authority_name: 'Cơ quan',
                scope_description: 'Phạm vi',
                received_at: 'Ngày và giờ nhận',
                receipt_evidence_refs: 'Chứng từ nhận',
                'anchors.stop_decision.date': 'Ngày quyết định dừng của Ngân hàng Nhà nước',
                'anchors.stop_decision.evidence_ref': 'Căn cứ của quyết định dừng',
                'anchors.settlement_completion.date': 'Ngày hoàn tất giải quyết quyền lợi và nghĩa vụ',
                'anchors.settlement_completion.evidence_ref': 'Căn cứ của việc hoàn tất giải quyết',
                'anchors.stop_decision': 'Ngày quyết định dừng của Ngân hàng Nhà nước',
                'anchors.settlement_completion': 'Ngày hoàn tất giải quyết quyền lợi và nghĩa vụ của khách hàng',
            },
        },
        children: {
            heading: 'Điều chỉnh và gia hạn',
            intro: 'Hồ sơ con thay đổi hoặc tiếp tục một đề nghị mà hồ sơ này đã có. Nền tảng ghi nhận các bước Ngân hàng Nhà nước báo cáo và tính các thời hạn mà bộ hồ sơ đã cài đặt khai báo. Ngân hàng Nhà nước quyết định từng đề nghị.',
            kindAdjustment: 'Điều chỉnh',
            kindExtension: 'Gia hạn',
            openAdjustment: 'Mở hồ sơ điều chỉnh',
            openExtension: 'Mở hồ sơ gia hạn',
            openTitleAdjustment: 'Mở hồ sơ điều chỉnh',
            openTitleExtension: 'Mở hồ sơ gia hạn',
            openHint: 'Nền tảng sao chép hồ sơ giải pháp của hồ sơ này như hiện có. Bản sao không thay đổi khi giải pháp được sửa sau đó.',
            formLabel: 'Mẫu đơn đề nghị',
            formNone: 'Bộ hồ sơ đã cài đặt không khai báo mẫu đơn nào cho loại này.',
            notesLabel: 'Ghi chú (không bắt buộc)',
            submit: 'Mở hồ sơ',
            saving: 'Đang mở…',
            cancel: 'Hủy',
            opened: 'Hồ sơ con đã được mở.',
            openFailed: 'Không thể mở hồ sơ con.',
            empty: 'Chưa có hồ sơ điều chỉnh hoặc gia hạn nào trên hồ sơ này.',
            loadError: 'Không đọc được các hồ sơ điều chỉnh và gia hạn.',
            unavailable: 'Không thể mở hồ sơ con trên hồ sơ này. {reason}',
            refusedReason: {
                grant_not_declared: 'Hồ sơ gốc chưa có quyết định cho phép nào được ghi nhận theo khai báo của bộ hồ sơ đã cài đặt.',
                grant_not_recorded: 'Hồ sơ gốc chưa ghi nhận quyết định cho phép nào.',
                parent_procedure_not_declared: 'Thủ tục của hồ sơ gốc không khai báo quy trình nên không thể mở hồ sơ con.',
                framework_not_operational: 'Bộ hồ sơ được cài đặt chỉ để tham khảo nên không thể mở hồ sơ con.',
                parent_framework_not_installed: 'Bộ hồ sơ chưa được cài đặt cho tổ chức này.',
                kind_not_declared: 'Chưa có bộ hồ sơ đã cài đặt nào khai báo loại hồ sơ con này.',
                kind_ambiguous: 'Có nhiều hơn một bộ hồ sơ đã cài đặt khai báo loại hồ sơ con này.',
                parent_stopped_and_revoked: 'Quyết định dừng và thu hồi thử nghiệm gốc của Ngân hàng Nhà nước đã được ghi nhận, nên không thể mở hồ sơ con.',
            },
            readOnly: 'Bạn có quyền xem các hồ sơ này. Mở hồ sơ con cần quyền quản lý.',
            clocksHeading: 'Thời hạn',
            noClocks: 'Theo bộ hồ sơ đã cài đặt, không có thời hạn nào áp dụng cho đề nghị này.',
            clockRunning: '{name}: đến hạn {due}. Tính {period} {unit} từ {start}.',
            clockPaused: '{name}: đến hạn {due}. Tính {period} {unit} từ {start}, cộng {paused} {unit} tạm dừng.',
            clockNotStarted: '{name}: chưa bắt đầu. Chưa ghi nhận bước khởi đầu của thời hạn này.',
            clockNoNumeric: '{name}: bộ hồ sơ đã cài đặt không khai báo số ngày cụ thể.',
            clockSource: 'Tính từ ngày bước đã ghi nhận. Đây không phải ngày do cơ quan nhà nước ấn định.',
            clockOwnerAuthority: 'Do Ngân hàng Nhà nước thực hiện.',
            clockOwnerOrganisation: 'Do tổ chức thực hiện.',
            unitWorkingDays: 'ngày làm việc',
            unitCalendarDays: 'ngày theo lịch',
            unitMonths: 'tháng',
            resultsHeading: 'Báo cáo kết quả',
            resultsProvisional: 'Định dạng tạm thời. Định dạng báo cáo kết quả nằm ở Phụ lục V Nghị định 94, không có trong kho văn bản. Không có định dạng nào được coi là đã xác minh.',
            filingHeading: 'Nộp hồ sơ',
            filingNotRecorded: 'Chưa ghi nhận. Việc nộp chỉ được ghi nhận khi xác nhận nội bộ đã được ghi nhận là hoàn thành.',
            filingRecorded: 'Tổ chức đã ghi nhận: số tham chiếu {reference}, nộp ngày {date}.',
            signoffNone: 'Chưa có xác nhận nội bộ nào được yêu cầu cho hồ sơ này.',
            signoffPending: 'Xác nhận nội bộ: đang chờ. Chưa thể ghi nhận việc nộp cho đến khi xác nhận được ghi nhận là hoàn thành.',
            signoffComplete: 'Xác nhận nội bộ: đã ghi nhận là hoàn thành.',
            signoffNotComplete: 'Xác nhận nội bộ: đã ghi nhận là chưa hoàn thành. Không thể ghi nhận việc nộp trên cơ sở này.',
            solutionHeading: 'Giải pháp sao chép từ hồ sơ gốc',
            solutionCopied: 'Sao chép từ hồ sơ giải pháp của hồ sơ gốc, phiên bản {version}.',
            solutionNone: 'Hồ sơ gốc chưa có hồ sơ giải pháp nên không có gì được sao chép.',
            recordStep: 'Ghi nhận bước',
            retry: 'Thử lại',
            currentStep: 'Bước hiện tại: {step}',
            noStep: 'Chưa ghi nhận bước nào.',
            chooseForm: 'Chọn mẫu đơn',
        },
    },
    // Sprint 63.23.0 — màn hình đồng ý OAuth tại /oauth/consent.
    oauth_consent: {
        error_request_not_found: 'Yêu cầu này đã hết hạn hoặc đã được trả lời. Hãy quay lại ứng dụng và bắt đầu kết nối lại.',
        error_request_already_decided: 'Yêu cầu này đã được trả lời. Hãy quay lại ứng dụng; nếu ứng dụng chưa được kết nối, hãy bắt đầu kết nối lại.',
        error_client_revoked: 'Ứng dụng này đã bị thu hồi nên không thể kết nối. Hãy hỏi quản trị viên của tổ chức bạn nếu bạn cần dùng ứng dụng này.',
        page_title: 'Phê duyệt ứng dụng',
        title: 'Cho phép {client} sử dụng ComplianceOne?',
        title_pending: 'Phê duyệt ứng dụng',
        loading: 'Đang tải yêu cầu…',
        intro: '{client} đề nghị được sử dụng ComplianceOne thay mặt bạn.',
        client_label: 'Ứng dụng',
        origin_label: 'Người đăng ký',
        origin_admin: 'Quản trị viên của tổ chức bạn',
        origin_dynamic: 'Ứng dụng tự đăng ký — chưa quản trị viên nào xem xét',
        redirect_label: 'Đưa bạn quay lại',
        organisation_label: 'Tổ chức',
        scopes_heading: 'Ứng dụng sẽ có thể',
        scope_read: 'Đọc bản ghi của tổ chức (mcp:read)',
        scope_write: 'Đề xuất thay đổi để phê duyệt (mcp:write)',
        scope_write_note: 'Thay đổi được đề xuất chỉ được thực hiện sau khi quản trị viên phê duyệt trong hàng đợi phê duyệt.',
        scope_other: 'Quyền khác: {scope}',
        tools_heading: 'Công cụ ứng dụng có thể dùng',
        tools_none: 'Không có công cụ nào.',
        acts_as_you: 'Ứng dụng hành động với tư cách của bạn, không vượt quá quyền mà vai trò của bạn có. Bạn có thể thu hồi bất cứ lúc nào trong mục Ứng dụng đã kết nối trên trang hồ sơ.',
        approve: 'Cho phép',
        deny: 'Từ chối',
        submitting: 'Đang gửi quyết định của bạn…',
        missing_request: 'Trang này được mở mà không có yêu cầu nào. Hãy quay lại ứng dụng và bắt đầu kết nối lại.',
        error_load: 'Không đọc được yêu cầu. Yêu cầu có thể đã hết hạn hoặc đã được trả lời; hãy quay lại ứng dụng và bắt đầu kết nối lại, hoặc tải lại yêu cầu.',
        reload: 'Tải lại yêu cầu',
        error_decide: 'Không gửi được quyết định của bạn.',
        redirecting: 'Đang đưa bạn quay lại ứng dụng…',
        // Gate E12.5 pass 1 (P2-8) — a redirect whose "host" says nothing about
        // who receives the approval.
        redirect_warning_title: 'Kiểm tra nơi nhận phê duyệt này',
        redirect_warning_loopback: 'Ứng dụng này nhận phê duyệt tại một địa chỉ trên chính máy tính của bạn ({host}). Bất kỳ chương trình nào đang chạy trên máy tính này cũng có thể đang chờ ở địa chỉ đó. Chỉ cho phép nếu chính bạn đã bắt đầu kết nối này, trên máy tính này.',
        redirect_warning_private_use_scheme: 'Ứng dụng này nhận phê duyệt qua một liên kết do một ứng dụng được cài trên thiết bị của bạn mở ({host}). Bất kỳ ứng dụng nào đã cài cũng có thể nhận loại liên kết này. Chỉ cho phép nếu chính bạn đã bắt đầu kết nối này, từ đúng ứng dụng bạn mong đợi.',
    },
    login: {
        title: 'AesirX ComplianceOne',
        subtitle: 'Đăng nhập vào tài khoản của bạn',
        email: 'Email',
        password: 'Mật khẩu',
        sign_in: 'Đăng nhập',
        signing_in: 'Đang đăng nhập...',
        mfa_code: 'Mã MFA',
        mfa_placeholder: 'Nhập mã 6 số',
        mfa_instruction: 'Nhập mã 6 số từ ứng dụng xác thực của bạn.',
        // ── Sprint 63.7.0: organisation-level MFA enforcement + IP allowlist enforcement ──
        password_change_required_title: 'Đổi mật khẩu của bạn',
        password_change_required_intro: 'Quản trị viên yêu cầu bạn chọn mật khẩu mới trước khi tiếp tục. Bạn chưa thể dùng chức năng nào khác cho đến khi đổi mật khẩu.',
        password_change_current: 'Mật khẩu hiện tại',
        password_change_current_hint: 'Mật khẩu bạn vừa dùng để đăng nhập.',
        password_change_new: 'Mật khẩu mới',
        password_change_new_hint: 'Tối thiểu 12 ký tự, gồm chữ hoa, chữ thường, chữ số và ký tự đặc biệt. Mật khẩu phải khác 12 mật khẩu gần nhất của bạn.',
        password_change_confirm: 'Xác nhận mật khẩu mới',
        password_change_mismatch: 'Hai mật khẩu mới không khớp nhau.',
        password_change_field_required: 'Trường này là bắt buộc.',
        password_change_submit: 'Đổi mật khẩu',
        password_change_failed: 'Không thể đổi mật khẩu của bạn.',
        password_change_done: 'Mật khẩu của bạn đã được đổi và bạn đã được đăng xuất khỏi mọi phiên. Hãy đăng nhập bằng mật khẩu mới.',
        password_change_sign_out: 'Đăng xuất',
        mfa_enrolment_required_title: 'Cài đặt xác thực đa yếu tố',
        mfa_enrolment_required_intro: 'Tổ chức của bạn yêu cầu tài khoản này phải có yếu tố thứ hai. Hãy cài đặt để tiếp tục — việc này mất khoảng một phút và bạn có thể hoàn tất ngay tại đây.',
        mfa_enrolment_required_sign_out: 'Đăng xuất',
        mfa_enrolment_required_continue: 'Tiếp tục vào nền tảng',
        mfa_enrolment_required_blocked: 'Cho tới khi hoàn tất cài đặt, bạn chưa truy cập được các phần còn lại của nền tảng.',
        // ── Sprint 63.6.3, gate E12.5 pass 2: the TOTP step-up page for a LIVE session held at MFA_REQUIRED ──
        mfa_step_up_title: 'Nhập mã xác minh của bạn',
        mfa_step_up_intro: 'Tổ chức của bạn yêu cầu mã từ ứng dụng xác thực của bạn trước khi phiên này có thể tiếp tục. Hãy nhập mã bên dưới để tiếp tục công việc đang làm.',
        mfa_step_up_instruction: 'Nhập mã 6 số từ ứng dụng xác thực của bạn, hoặc một trong các mã dự phòng của bạn.',
        mfa_step_up_locked: 'Bạn đã nhập sai mã quá nhiều lần. Hãy đợi vài phút rồi thử lại.',
        mfa_step_up_not_enrolled: 'Tài khoản này chưa cài đặt ứng dụng xác thực nên không có mã để nhập. Hãy đăng xuất rồi đăng nhập lại.',
        mfa_step_up_accepted: 'Đã chấp nhận mã. Đang tiếp tục.',
        mfa_step_up_code_label: 'Mã xác minh',
        mfa_step_up_placeholder: 'Mã từ ứng dụng xác thực hoặc mã dự phòng',
        mfa_step_up_refresh_failed: 'Mã của bạn đã được chấp nhận, nhưng trang chưa xác nhận được với máy chủ. Hãy thử lại để tiếp tục.',
        verify: 'Xác minh',
        verifying: 'Đang xác minh...',
        forgot_password: 'Quên mật khẩu?',
        account_locked: 'Tài khoản đã bị khóa. Vui lòng thử lại sau.',
        account_deactivated: 'Tài khoản đã bị vô hiệu hóa. Liên hệ quản trị viên.',
        invalid_mfa: 'Mã MFA không hợp lệ. Vui lòng thử lại.',
        invalid_credentials: 'Email hoặc mật khẩu không đúng.',
        login_failed: 'Đăng nhập thất bại',
        session_limit_reached: 'Tài khoản của bạn đã đạt giới hạn phiên đăng nhập đang hoạt động. Hãy đăng xuất trên thiết bị khác hoặc nhờ quản trị viên thu hồi một phiên hiện có, rồi thử lại.',
        session_expired: 'Phiên của bạn đã hết hạn. Vui lòng tải lại trang và thử lại.',
        sso_divider: 'hoặc',
        sso_sign_in_with: 'Đăng nhập bằng',
        sso_checking: 'Đang kiểm tra các phương thức đăng nhập…',
        sso_completing: 'Đang hoàn tất đăng nhập…',
        sso_failed: 'Đăng nhập một lần (SSO) chưa hoàn tất. Liên hệ quản trị viên của bạn.',
        sso_required: 'Tổ chức này yêu cầu đăng nhập một lần (SSO). Hãy dùng liên kết mà quản trị viên đã cung cấp cho bạn.',
        sso_options_label: 'Các tùy chọn đăng nhập một lần (SSO)',
        sso_provider_session_not_ended: 'Bạn đã đăng xuất khỏi ComplianceOne, nhưng phiên trên nhà cung cấp danh tính của bạn chưa được kết thúc. Nếu bạn dùng chung thiết bị, hãy đăng xuất cả trên nhà cung cấp danh tính.',
    },
    auth: {
        forgot_password: {
            title: 'Quên mật khẩu',
            subtitle: 'Nhập địa chỉ email của bạn và chúng tôi sẽ gửi liên kết đặt lại mật khẩu.',
            send: 'Gửi liên kết đặt lại',
            sending: 'Đang gửi...',
            success: 'Nếu email tồn tại, liên kết đặt lại mật khẩu đã được gửi.',
            back_to_login: 'Quay lại đăng nhập',
        },
        reset_password: {
            title: 'Đặt lại mật khẩu',
            subtitle: 'Nhập mật khẩu mới của bạn bên dưới.',
            new_password: 'Mật khẩu mới',
            confirm_password: 'Xác nhận mật khẩu',
            reset: 'Đặt lại mật khẩu',
            resetting: 'Đang đặt lại...',
            success: 'Mật khẩu của bạn đã được đặt lại thành công.',
            go_to_login: 'Đi đến đăng nhập',
            password_mismatch: 'Mật khẩu không khớp.',
            invalid_token: 'Token không hợp lệ hoặc thiếu. Vui lòng yêu cầu liên kết đặt lại mới.',
            requirements_title: 'Yêu cầu mật khẩu:',
            password_requirements: 'Mật khẩu phải đáp ứng các yêu cầu sau:',
            rules: {
                min_length: 'Ít nhất 12 ký tự',
                uppercase: 'Ít nhất một chữ hoa',
                lowercase: 'Ít nhất một chữ thường',
                digit: 'Ít nhất một chữ số',
                special: 'Ít nhất một ký tự đặc biệt',
            },
        },
        verify_email: {
            title: 'Xác minh email',
            verifying: 'Đang xác minh địa chỉ email...',
            success: 'Email của bạn đã được xác minh thành công.',
            invalid_token: 'Token xác minh không hợp lệ hoặc thiếu.',
            failed: 'Xác minh email thất bại. Token có thể không hợp lệ hoặc hết hạn.',
            go_to_login: 'Đi đến đăng nhập',
        },
        offline: {
            title: 'Bạn đang ngoại tuyến',
            message: 'Có vẻ như bạn đã mất kết nối internet. Vui lòng kiểm tra mạng và thử lại.',
        },
    },
    intake: {
        title: 'Yêu Cầu Quyền Dữ Liệu',
        subtitle: 'Gửi yêu cầu quyền của bạn đến tổ chức của chúng tôi',
        fields: {
            full_name: 'Họ và tên',
            email: 'Địa chỉ email',
            phone: 'Số điện thoại (tùy chọn)',
            request_type: 'Loại yêu cầu',
            description: 'Mô tả yêu cầu',
            preferred_language: 'Ngôn ngữ ưu tiên',
            consent: 'Tôi đồng ý với việc xử lý yêu cầu này',
        },
        submit: 'Gửi yêu cầu',
        validation: {
            name_required: 'Vui lòng nhập họ và tên',
            email_required: 'Vui lòng nhập địa chỉ email hợp lệ',
            type_required: 'Vui lòng chọn loại yêu cầu',
            description_required: 'Vui lòng mô tả yêu cầu của bạn',
            consent_required: 'Bạn phải đồng ý với việc xử lý để tiếp tục',
        },
        error_title: 'Lỗi',
        config_load_error: 'Không thể tải cấu hình. Vui lòng kiểm tra đường dẫn.',
        organization_label: 'Tổ chức',
        customer_reference: 'Mã tham chiếu khách hàng',
        country: 'Quốc gia / Khu vực pháp lý',
        preferred_channel: 'Kênh phản hồi ưu tiên',
        channels: {
            email: 'Email',
            postal: 'Bưu chính',
            phone: 'Điện thoại',
            portal: 'Cổng thông tin',
        },
        confirmation: {
            // Sprint 63.31.0 (OD-E) — an intake handled in Legal Matters.
            next_steps_legal_matter: 'Yêu cầu của bạn sẽ được xử lý như một vụ việc pháp lý: tổ chức sẽ xem xét và liên hệ với bạn về yêu cầu này. Việc ghi nhận yêu cầu này không phải là khởi kiện ra tòa án hay tố cáo đến cơ quan có thẩm quyền, và tổ chức không giải quyết việc khởi kiện hay tố cáo đó. Vui lòng lưu lại mã yêu cầu của bạn.',
            title: 'Yêu cầu đã được tiếp nhận',
            message: 'Yêu cầu của bạn đã được ghi nhận thành công. Mã yêu cầu của bạn là:',
            // fix-sprint #431 — đã nêu "Thời gian xử lý dự kiến là 30 ngày làm việc";
            // thời hạn do khung tuân thủ đã cài đặt hoặc tổ chức cấu hình, không suy ra ở đây.
            next_steps: 'Chúng tôi sẽ xử lý yêu cầu của bạn trong thời gian sớm nhất theo quy định của pháp luật và liên hệ với bạn về các bước tiếp theo. Vui lòng lưu lại mã yêu cầu của bạn.',
        },
        // fix-sprint #431 (phán quyết của chủ sản phẩm 2026-10-03) — thư xác nhận gửi
        // người yêu cầu khi bật "Gửi email xác nhận cho người yêu cầu".
        acknowledgement_email: {
            subject: 'Chúng tôi đã nhận được yêu cầu của bạn (mã tham chiếu {reference})',
            greeting: 'Xin chào,',
            body: '{organization} đã nhận được yêu cầu của bạn liên quan đến dữ liệu cá nhân của bạn.',
            reference: 'Mã tham chiếu của bạn là {reference}. Vui lòng ghi mã này trong mọi trao đổi về yêu cầu này.',
            closing: 'Chúng tôi sẽ liên hệ với bạn về các bước tiếp theo. Thư này được gửi tự động.',
        },
        request_type_not_offered: 'Tổ chức này không tiếp nhận loại yêu cầu này theo các quy định về bảo vệ dữ liệu mà tổ chức áp dụng. Vui lòng chọn loại yêu cầu khác.',
        // Sprint 63.31.0 (OD-E) — an intake handled in Legal Matters.
        legal_matter_right: 'Bạn muốn thực hiện quyền nào?',
        legal_matter_right_hint: 'Yêu cầu này được tiếp nhận như một vụ việc pháp lý. Nếu bạn biết mình muốn thực hiện quyền nào, hãy chọn; nếu chưa rõ, hãy để trống và tổ chức sẽ ghi nhận sau.',
        legal_matter_right_not_sure: 'Chưa rõ',
        error_summary: 'Yêu cầu của bạn chưa được gửi. Vui lòng sửa các mục sau:',
        request_type_not_enabled: 'Biểu mẫu này không tiếp nhận loại yêu cầu đó. Vui lòng chọn loại yêu cầu khác.',
        submit_failed: 'Không thể gửi yêu cầu của bạn: {reason}',
    },
    request_types: {
        access: 'Yêu cầu truy cập dữ liệu',
        deletion: 'Yêu cầu xóa dữ liệu',
        correction: 'Yêu cầu chỉnh sửa dữ liệu',
        objection: 'Phản đối xử lý',
        portability: 'Yêu cầu chuyển dữ liệu',
        restriction: 'Hạn chế xử lý dữ liệu',
        consent_withdrawal: 'Rút lại sự đồng ý',
        protective_measures: 'Yêu cầu thực hiện các biện pháp, giải pháp bảo vệ dữ liệu cá nhân',
        processing_information: 'Được biết về hoạt động xử lý dữ liệu cá nhân',
        consent_decision: 'Đồng ý hoặc không đồng ý cho phép xử lý dữ liệu cá nhân',
        complaint_or_compensation: 'Khiếu nại, tố cáo, khởi kiện, yêu cầu bồi thường thiệt hại',
    },
    statuses: {
        new: 'Mới',
        in_review: 'Đang xử lý',
        waiting_on_requester: 'Chờ phản hồi',
        waiting_on_internal_data: 'Chờ dữ liệu nội bộ',
        approved: 'Đã duyệt',
        closed: 'Đã đóng',
        rejected: 'Từ chối',
    },
    admin: viAdmin,
    data_mapping: {
        // Sprint 62.58.0 (Slice N) — `vi-extras.ts`.
        deployment_privacy: viDeploymentPrivacy,
        lawful_basis: {
            title: 'Căn cứ pháp luật áp dụng',
            load_failed: 'Không đọc được các căn cứ pháp luật áp dụng do các khung tuân thủ đã cài đặt quy định.',
            none_declared: 'Không có khung tuân thủ nào đã cài đặt quy định danh mục căn cứ pháp luật áp dụng. Hãy ghi nhận căn cứ và điều khoản làm cơ sở ở bên dưới.',
            declared_by: 'Do {instrument} quy định',
            citation: 'Dẫn chiếu điều khoản',
            statement_label: 'Căn cứ pháp luật áp dụng (do bạn ghi nhận)',
            statement_citation_label: 'Điều khoản làm cơ sở cho căn cứ này',
            other_ground: 'Căn cứ pháp luật áp dụng khác, do bạn ghi nhận',
            needs_redetermination: 'Bản ghi này mang giá trị "{basis}" mà không khung tuân thủ đã cài đặt nào quy định. Cần xác định lại.',
            needs_redetermination_declared: 'Bản ghi này mang giá trị "{basis}" và được đánh dấu cần xác định lại. Hãy xác nhận căn cứ này hoặc chọn căn cứ khác, rồi lưu.',
            stored_unverified: 'Bản ghi này mang giá trị "{basis}". Một số khung tuân thủ đã cài đặt chưa được xác minh, nên chưa xác định được có khung tuân thủ nào quy định căn cứ này hay không.',
            instruments_heading: 'Các văn bản đã đối chiếu',
            instrument_declares_none: '{instrument} — đã xác minh: không quy định căn cứ pháp luật áp dụng nào',
            instrument_not_verified: '{instrument} — chưa được xác minh',
            retry: 'Thử lại',
            list_needs_redetermination: 'Cần xác định lại: {basis}',
            declared_version_changed: 'Được ghi nhận theo {framework} {version}; hiện đã cài đặt: {installed}.',
            declared_version_withdrawn: 'Được ghi nhận theo {framework} {version}; hiện không khung tuân thủ đã cài đặt nào quy định căn cứ này.',
            loading: 'Đang tải các căn cứ pháp luật áp dụng do các khung tuân thủ đã cài đặt quy định.',
            save_blocked_unread: 'Cần có căn cứ pháp luật áp dụng, nhưng chưa đọc được các căn cứ do các khung tuân thủ đã cài đặt quy định.',
            citation_blank: 'Hãy nhập điều khoản làm cơ sở cho căn cứ này. Chỉ có khoảng trắng thì không phải là điều khoản.',
            citation_without_statement: 'Đã nhập điều khoản nhưng chưa ghi nhận căn cứ. Hãy ghi nhận căn cứ mà điều khoản này làm cơ sở, hoặc xóa điều khoản.',
        },
        // OD42 (fix-sprint-20261003-0625 F28) — the transfer-mechanism control and
        // its list sentences. The mechanism is what the installed frameworks declare.
        transfer_mechanism_vocabulary: {
            title: 'Cơ chế chuyển dữ liệu cá nhân xuyên biên giới',
            load_failed: 'Không đọc được các cơ chế chuyển dữ liệu cá nhân xuyên biên giới do các khung tuân thủ đã cài đặt quy định.',
            loading: 'Đang tải các cơ chế chuyển dữ liệu cá nhân xuyên biên giới do các khung tuân thủ đã cài đặt quy định.',
            retry: 'Thử lại',
            none_declared: 'Không có khung tuân thủ nào đã cài đặt quy định cơ chế chuyển dữ liệu cá nhân xuyên biên giới. Hãy mô tả việc chuyển dữ liệu ở trường chi tiết.',
            none_declared_unverified: 'Chưa có khung tuân thủ nào đã cài đặt quy định cơ chế chuyển dữ liệu cá nhân xuyên biên giới, và một số khung tuân thủ chưa được xác minh. Hãy mô tả việc chuyển dữ liệu ở trường chi tiết.',
            declared_by: 'Do {instrument} quy định',
            citation: 'Dẫn chiếu điều khoản',
            needs_redetermination: 'Bản ghi này mang giá trị "{mechanism}" mà không khung tuân thủ đã cài đặt nào quy định. Cần xác định lại.',
            needs_redetermination_declared: 'Bản ghi này mang giá trị "{mechanism}" và được đánh dấu cần xác định lại. Hãy xác nhận cơ chế này hoặc chọn cơ chế khác, rồi lưu.',
            unverified: 'Bản ghi này mang giá trị "{mechanism}". Không khung tuân thủ đã cài đặt nào đã được xác minh quy định giá trị này; chưa được xác minh: {instruments}.',
            instruments_heading: 'Các văn bản đã đối chiếu',
            instrument_declares_none: '{instrument} — đã xác minh: không quy định cơ chế chuyển dữ liệu cá nhân xuyên biên giới nào',
            instrument_not_verified: '{instrument} — chưa được xác minh',
            list_needs_redetermination: 'Cần xác định lại: {mechanism}',
            list_unverified: '{mechanism} (chưa được xác minh: {instruments})',
            stored_unmeasured: 'Bản ghi này mang giá trị "{mechanism}". Chưa có khung tuân thủ đã cài đặt nào xác định cơ chế chuyển dữ liệu cá nhân xuyên biên giới, nên chưa kiểm tra được giá trị này có được quy định hay không.',
        },
        nav: {
            systems: 'Hệ thống',
            categories: 'Danh mục Dữ liệu',
            // Sprint 45.4.0 — Data Registry nav entry.
            registry: 'Đăng ký Dữ liệu',
            purposes: 'Mục đích Xử lý',
            retention: 'Lưu trữ',
            flows: 'Luồng dữ liệu',
            activities: 'Hoạt động xử lý',
            evidence: 'Bằng chứng',
            exports: 'Xuất dữ liệu',
            governance: 'Quản trị',
            attestation: 'Chu kỳ chứng thực',
            review: 'Nhiệm vụ đánh giá',
            inventory: 'Kho dữ liệu',
            exceptions: 'Ngoại lệ',
            history: 'Lịch sử',
            ropa_completeness: 'Tính đầy đủ ROPA',
        },
        // Sprint 48.1.2 (finish) — Hành động autofix Forseti inline trên
        // trang ROPA completeness.
        ropa_completeness_autofix: {
            ask_button: 'Hỏi Forseti',
            drafting: 'Đang soạn…',
            accept: 'Chấp nhận',
            reject: 'Từ chối',
            accepted: 'Đã chấp nhận — áp dụng qua trình chỉnh sửa hoạt động.',
            rejected: 'Đã từ chối.',
            needs_human_input: 'Forseti cần thêm ngữ cảnh hoạt động (ví dụ một mục đích được ghi rõ) trước khi soạn nháp trường này.',
            ask_again: 'Hỏi lại',
            draft_failed: 'Forseti không thể soạn giá trị.',
            decision_failed: 'Không thể lưu quyết định.',
        },
        // Sprint 46.0.0 — ROPA Completeness Report (per-field hygiene)
        ropa_completeness: {
            rules: {
                nd165_scope_rationale: 'Xác định và lưu căn cứ về phạm vi chuyển dữ liệu; rà soát dữ liệu hỗn hợp trước khi chọn quy trình đánh giá áp dụng.',
                nd165_scope_condition: 'Dữ liệu quan trọng/cốt lõi chuyển xuyên biên giới có phạm vi dữ liệu cá nhân hỗn hợp hoặc chưa xác định',
                nd165_personal_dpia_rationale: 'Ghi nhận tham chiếu đánh giá tác động xử lý khi bắt buộc, bao gồm dữ liệu cá nhân cốt lõi/quan trọng được xác định rõ chuyển xuyên biên giới.',
                nd165_personal_dpia_condition: 'Dữ liệu cá nhân quan trọng/cốt lõi đã được xác định rõ + chuyển xuyên biên giới',
                nd165_personal_transfer_rationale: 'Ghi nhận tham chiếu riêng của hồ sơ đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới.',
                nd165_personal_transfer_condition: 'Dữ liệu cá nhân quan trọng/cốt lõi đã được xác định rõ + chuyển xuyên biên giới',
                nd165_nonpersonal_assessment_rationale: 'Dữ liệu cốt lõi không phải dữ liệu cá nhân cần có đánh giá do cơ quan quản lý ban hành khi chuyển xuyên biên giới.',
                nd165_nonpersonal_assessment_condition: 'Dữ liệu cốt lõi đã xác định không phải dữ liệu cá nhân + chuyển xuyên biên giới',
            },
            title: 'Báo cáo tính đầy đủ ROPA',
            subtitle: 'Kiểm tra tính đầy đủ của các trường bắt buộc trong Hồ sơ hoạt động xử lý dữ liệu (ROPA), theo khuôn khổ pháp lý.',
            framework_label: 'Khung tuân thủ',
            kpi_total: 'Hoạt động được đánh giá',
            kpi_critical: 'Nghiêm trọng',
            kpi_high: 'Cao',
            kpi_conditional: 'Có điều kiện',
            field_chart_heading: 'Các trường thiếu theo tần suất',
            drilldown_heading: 'Hoạt động có trường thiếu',
            col_activity: 'Hoạt động',
            col_field: 'Trường',
            col_severity: 'Mức độ',
            col_condition: 'Điều kiện',
            col_action: 'Sửa',
            action_fix: 'Sửa',
            severity_critical: 'Nghiêm trọng',
            severity_high: 'Cao',
            severity_conditional: 'Có điều kiện',
            severity_informational: 'Thông tin',
            include_informational: 'Bao gồm thông tin',
            export_csv: 'Tải về CSV',
            exporting: 'Đang xuất...',
            loading: 'Đang tải…',
            empty_state: 'Tất cả hoạt động đang hoạt động đều có hồ sơ ROPA đầy đủ theo khuôn khổ này.',
            error_fetch: 'Không thể tải báo cáo tính đầy đủ.',
            error_unsupported_framework: 'Khuôn khổ này không được hỗ trợ.',
            error_framework_not_installed: 'Khuôn khổ này chưa được cài đặt cho tổ chức của bạn.',
            no_misses_for_field: 'Không có hoạt động nào thiếu trường này.',
            framework_PDPL: 'PDPL (Luật 91/2025 + Nghị định 356)',
            framework_GDPR: 'GDPR Điều 30',
            framework_DECREE_165: 'Nghị định 165 (Luật Dữ liệu)',
            framework_ISO_27701: 'ISO 27701 (thông tin)',
        },
        // Sprint 45.4.0 — Data Registry (phân hệ Light-tier)
        registry: {
            /**
             * Sprint 64.72.0 — R-44. Six of these are the Compliance Manager's own
             * approved rendering, used verbatim because the English is character-for-
             * character the reviewed term (`agent-os/terminology/registry.en-vi.json`,
             * batch `2026-08-01-dpia`):
             *
             *   data_subjects                → data-subjects
             *   status                       → status
             *   legal_basis                  → legal-basis
             *   categories_of_personal_data  → categories-of-personal-data
             *   categories_of_data_subjects  → categories-of-data-subjects
             *   retention_period             → retention-period
             *
             * Those entries are scoped to `assessments`, so the linter neither
             * enforces nor reports them here. Matching them anyway is the point: the
             * reverted first attempt gave `categories_of_personal_data` the approved
             * rendering of two *other* terms (`Loại dữ liệu cá nhân`, which is
             * `data-categories` and `data-types`) while its own approved form is
             * `Loại dữ liệu cá nhân được xử lý`. Every remaining value below is
             * authored fresh and was checked against every approved and every
             * superseded rendering in the registry — no value here is another term's.
             */
            export_col: {
                registry_item_id: 'Mã mục đăng ký',
                name: 'Tên',
                description: 'Mô tả',
                field_identifiers: 'Định danh trường dữ liệu',
                category_id: 'Mã danh mục',
                category_name: 'Tên danh mục',
                // "Kiểu dữ liệu", not "Loại dữ liệu": this column is the technical
                // element type (text / number / date), while `Loại dữ liệu cá nhân` is
                // the approved rendering of the regulatory *category*. Two different
                // things, and the shorter form would read as a truncation of the term.
                data_type: 'Kiểu dữ liệu',
                effective_sensitivity: 'Mức nhạy cảm hiệu lực',
                sensitivity_override: 'Ghi đè mức nhạy cảm',
                data_subjects: 'Chủ thể dữ liệu',
                volume_band: 'Khoảng khối lượng dữ liệu',
                source_system_ids: 'Mã hệ thống nguồn',
                processing_activity_ids: 'Mã hoạt động xử lý',
                retention_policy_id: 'Mã chính sách lưu trữ',
                effective_retention_policy_id: 'Mã chính sách lưu trữ hiệu lực',
                // Not the bare `Mục đích xử lý`: that string is a *superseded*
                // rendering of `processing-purpose` and `purpose-of-processing` in the
                // registry, and reintroducing a superseded rendering is the regression
                // `lint-terminology.mjs` exists to fail on.
                purposes: 'Mục đích xử lý dữ liệu cá nhân',
                collection_method: 'Phương thức thu thập',
                legal_basis: 'Căn cứ pháp luật áp dụng',
                data_tier: 'Cấp độ dữ liệu',
                // Not `Nguồn cấp dữ liệu`, which is the lexicalised Vietnamese for a
                // *data feed* — pass 1 flagged exactly that on the first attempt.
                data_tier_source: 'Nguồn xác định cấp độ dữ liệu',
                storage_locations: 'Địa điểm lưu trữ',
                cross_border: 'Xuyên biên giới',
                status: 'Trạng thái',
                source_form_submission_id: 'Mã hồ sơ biểu mẫu nguồn',
                source_form_template_id: 'Mã mẫu biểu mẫu nguồn',
                last_reviewed_at: 'Rà soát lần cuối',
                next_review_at: 'Rà soát tiếp theo',
                created_at: 'Ngày tạo',
                updated_at: 'Ngày cập nhật',
                data_element: 'Thành phần dữ liệu',
                data_category: 'Danh mục dữ liệu',
                systems: 'Hệ thống',
                retention_policy: 'Chính sách lưu trữ',
                name_of_processing: 'Tên hoạt động xử lý',
                categories_of_personal_data: 'Loại dữ liệu cá nhân được xử lý',
                categories_of_data_subjects: 'Nhóm chủ thể dữ liệu',
                recipients: 'Bên tiếp nhận',
                third_country_transfers: 'Chuyển dữ liệu ra nước thứ ba',
                retention_period: 'Thời hạn lưu trữ dữ liệu cá nhân',
                doc_title: 'Đăng ký dữ liệu',
                doc_generated: 'Xuất dữ liệu lúc {timestamp}',
                doc_item_count: '{count} mục đăng ký',
                doc_template_full: 'Đầy đủ',
            },
            export_draft: {
                marker: 'Dự thảo — không phải nghĩa vụ',
                scheme_label: 'Danh mục phân loại',
            },
            export_vocab: {
                data_type: {
                    text: 'Văn bản',
                    number: 'Số',
                    // `Ngày tháng`, not the bare `Ngày`: the registry records `Ngày` as
                    // a superseded rendering of the `date` term (approved `Ngày lập`),
                    // and `Ngày lập` is a form's issue date, not a data element type.
                    date: 'Ngày tháng',
                    datetime: 'Ngày giờ',
                    boolean: 'Có/Không',
                    binary: 'Nhị phân',
                    structured: 'Có cấu trúc',
                    file: 'Tệp',
                    identifier: 'Định danh',
                    geolocation: 'Vị trí địa lý',
                },
                collection_method: {
                    direct_from_subject: 'Thu thập trực tiếp từ chủ thể dữ liệu',
                    third_party: 'Thu thập từ bên thứ ba',
                    derived: 'Suy ra từ dữ liệu khác',
                    observed: 'Ghi nhận từ hành vi',
                    inferred: 'Suy đoán',
                    public_source: 'Nguồn công khai',
                },
                data_subject_type: {
                    customer: 'Khách hàng',
                    employee: 'Người lao động',
                    // Gate E12.5 (Sprint 64.72.0), F5 — R-44. `Nhà thầu` is Luật Đấu thầu's
                    // procurement noun: a *bidder*, which that instrument defines as a
                    // tổ chức **or** cá nhân and which a reader takes as an organisation.
                    // A data-subject type names a natural person, so the register was
                    // categorising a counterparty where it must categorise a human being.
                    contractor: 'Cá nhân làm việc theo hợp đồng',
                    prospect: 'Khách hàng tiềm năng',
                    // Gate E12.5 (Sprint 64.72.0), F5 — R-44, and the one on this list that
                    // changes what a register asserts. `Trẻ em` is statutorily **under 16**
                    // and is the trigger vocabulary for the children's personal-data
                    // regime; `minor` means **under 18**. A DPO exporting in Vietnamese was
                    // showing an inspector a category that claims the child-data regime
                    // applies to every person in it.
                    minor: 'Người chưa thành niên',
                    patient: 'Bệnh nhân',
                    student: 'Học sinh, sinh viên',
                    beneficiary: 'Người thụ hưởng',
                    vendor_contact: 'Đầu mối liên hệ của nhà cung cấp',
                    website_visitor: 'Người truy cập trang thông tin điện tử',
                    other: 'Khác',
                },
                volume_band: {
                    lt_1k: 'Dưới 1.000 bản ghi',
                    '1k_to_10k': 'Từ 1.000 đến 10.000 bản ghi',
                    '10k_to_100k': 'Từ 10.000 đến 100.000 bản ghi',
                    '100k_to_1m': 'Từ 100.000 đến 1.000.000 bản ghi',
                    gt_1m: 'Trên 1.000.000 bản ghi',
                    unknown: 'Chưa xác định',
                },
                tier_source: {
                    assessed_and_approved: 'Đã đánh giá và phê duyệt',
                    manual_legacy: 'Kế thừa từ giá trị cũ',
                    legacy_platform_field: 'Giá trị nền tảng kế thừa',
                    scheme_scoped_only: 'Đã đánh giá theo cấp độ riêng của từng khung — không có mã cấp độ duy nhất nào bao trùm nhiều thang phân loại pháp lý',
                },
            },
            page: {
                title: 'Đăng ký dữ liệu',
                subtitle: 'Các phần tử dữ liệu cá nhân mà tổ chức của bạn đang nắm giữ, được sắp xếp theo Danh mục dữ liệu.',
                empty_state: 'Chưa có mục đăng ký nào. Thêm thủ công hoặc nhập từ mẫu đăng ký theo quy định.',
                empty_filter_state: 'Không có mục nào khớp với bộ lọc của bạn.',
            },
            filter: {
                category: 'Danh mục',
                sensitivity: 'Mức nhạy cảm',
                data_subject: 'Chủ thể dữ liệu',
                status: 'Trạng thái',
                data_tier: 'Cấp dữ liệu',
                cross_border: 'Xuyên biên giới',
                has_owner: 'Có chủ sở hữu',
                has_form_source: 'Nhập từ biểu mẫu',
                search_placeholder: 'Tìm theo tên, mô tả, hoặc mã định danh trường…',
                clear: 'Xóa bộ lọc',
                option_all: 'Tất cả',
            },
            col: {
                name: 'Tên',
                category: 'Danh mục',
                sensitivity: 'Mức nhạy cảm',
                data_subjects: 'Chủ thể dữ liệu',
                systems: 'Hệ thống',
                activities: 'Hoạt động',
                owner: 'Chủ sở hữu',
                retention: 'Lưu trữ',
                data_tier: 'Cấp dữ liệu',
                status: 'Trạng thái',
                last_reviewed: 'Lần soát gần nhất',
                actions: 'Thao tác',
            },
            action: {
                add_manual: 'Thêm mục',
                add_from_form: 'Thêm từ mẫu đăng ký',
                import_history: 'Nhập các lần nộp trước',
                export: 'Xuất',
                archive: 'Lưu trữ',
                restore: 'Khôi phục',
                edit: 'Sửa',
                assign_owner: 'Gán chủ sở hữu',
                attach_evidence: 'Đính kèm bằng chứng',
                open_lineage: 'Xem nguồn gốc',
            },
            modal_editor: {
                section_identity: 'Định danh',
                section_classification: 'Phân loại',
                section_subjects: 'Chủ thể & Khối lượng',
                section_location: 'Địa điểm & Chuyển dữ liệu',
                section_systems: 'Hệ thống & Hoạt động',
                section_retention: 'Lưu trữ & Căn cứ pháp lý',
                section_governance: 'Quản trị',
                section_notes: 'Ghi chú',
                hint_inherited: '(kế thừa từ danh mục)',
                hint_overridden: '(đã ghi đè)',
                placeholder_field_identifiers: 'ví dụ: customers.primary_email, hris.employee_id',
                validation_name_required: 'Bắt buộc nhập tên',
                validation_category_required: 'Bắt buộc chọn danh mục',
                validation_data_subjects_required: 'Cần ít nhất một loại chủ thể dữ liệu',
                label_data_type: 'Loại dữ liệu',
                label_field_identifiers: 'Định danh trường (phân tách bằng dấu phẩy)',
                label_data_subject_types: 'Loại chủ thể dữ liệu',
                label_volume_band: 'Khoảng khối lượng',
                label_storage_locations: 'Vị trí lưu trữ (phân tách bằng dấu phẩy)',
                placeholder_storage_locations: 'Mã ISO-3166 hoặc văn bản tự do (ví dụ: VN, Hetzner EU)',
                label_cross_border: 'Chuyển dữ liệu xuyên biên giới',
                label_source_systems: 'Hệ thống nguồn',
                label_processing_activities: 'Hoạt động xử lý',
                label_collection_method: 'Phương thức thu thập',
                label_purposes: 'Mục đích',
                hint_multi_select: 'Giữ Cmd/Ctrl để chọn nhiều.',
                option_inherit_category: '— (kế thừa từ danh mục)',
                option_dash: '—',
                // fix-sprint-20260925-2123 (Finding 11) — a stale save refused with 409.
                error_conflict: 'Mục đăng ký này đã được người khác thay đổi trong lúc bạn đang chỉnh sửa, nên thay đổi của bạn chưa được lưu. Hãy đóng biểu mẫu này và mở lại mục để xem phiên bản hiện tại.',
                // The form was re-read and now shows the saved version.
                error_conflict_refreshed: 'Mục đăng ký này đã được người khác thay đổi trong lúc bạn đang chỉnh sửa, nên thay đổi của bạn chưa được lưu. Biểu mẫu hiện hiển thị phiên bản hiện tại và các nội dung bạn nhập chưa lưu không được giữ lại. Hãy thực hiện lại thay đổi và lưu.',
            },
            modal_import: {
                scan_none: 'Chưa có mẫu sổ đăng ký theo quy định nào được ánh xạ.',
                scan_count: 'Quét {count} mẫu để tìm các lần nộp trước đây và nhập các mục.',
                dry_run_heading: 'Xem trước nhập dữ liệu',
                label_to_create: 'Tạo mới',
                label_to_update: 'Cập nhật',
                label_skipped_archived: 'Bỏ qua (đã lưu trữ)',
                label_conflicts: 'Xung đột',
                commit: 'Nhập',
                cancel: 'Hủy',
                conflict_new_item: 'Mục mới',
                conflict_value_own_words: 'căn cứ do một người ghi nhận bằng lời của chính người đó: “{statement}”',
                conflict_reason: 'Lý do: {reason}',
                conflict_row_kept_edit: '{field} — đã giữ giá trị bạn đã sửa: {current}. Giá trị từ biểu mẫu không được áp dụng: {mapper}.',
                conflict_row_kept_current: '{field} — đã giữ giá trị hiện tại: {current}. Giá trị từ biểu mẫu bị từ chối: {mapper}.',
                conflict_row_not_created: '{field} — mục này chưa được tạo. Giá trị từ biểu mẫu bị từ chối: {mapper}.',
                conflict_reasons: {
                    field_user_edited: 'Một người đã sửa trường này sau lần nhập trước, và việc nhập không bao giờ ghi đè nội dung do người dùng đã sửa.',
                    basis_not_declared: 'Không khung tuân thủ đã cài đặt nào quy định căn cứ pháp luật áp dụng, nên không thể ghi nhận căn cứ dưới dạng mã.',
                    basis_required: 'Bản ghi này cần có căn cứ pháp luật áp dụng, nhưng biểu mẫu không nêu căn cứ nào.',
                    basis_needs_person: 'Chỉ người dùng đã xác thực mới được ghi nhận hoặc thay đổi căn cứ pháp luật áp dụng này, và việc nhập không được thực hiện bởi một người dùng đã xác thực.',
                    basis_statement_rules: 'Căn cứ pháp luật áp dụng phải là một lựa chọn do các khung tuân thủ đã cài đặt quy định, hoặc căn cứ do bạn ghi nhận kèm điều khoản làm cơ sở; giá trị từ biểu mẫu không thuộc trường hợp nào.',
                    unknown: 'Việc nhập không áp dụng giá trị này.',
                },
                conflict_fields: {
                    description: 'Mô tả',
                    field_identifiers: 'Định danh trường',
                    data_type: 'Loại dữ liệu',
                    sensitivity_override: 'Mức độ nhạy cảm (ghi đè)',
                    data_subject_types: 'Loại chủ thể dữ liệu',
                    volume_band: 'Khoảng khối lượng',
                    source_system_ids: 'Hệ thống nguồn',
                    processing_activity_ids: 'Hoạt động xử lý',
                    retention_policy_id: 'Chính sách lưu trữ',
                    purposes: 'Mục đích',
                    collection_method: 'Phương thức thu thập',
                    legal_basis: 'Căn cứ pháp luật áp dụng',
                    data_tier: 'Cấp dữ liệu',
                    storage_locations: 'Vị trí lưu trữ',
                    cross_border: 'Chuyển dữ liệu cá nhân xuyên biên giới',
                },
            },
            drawer: {
                section_category: 'Danh mục',
                section_systems: 'Hệ thống nguồn',
                section_activities: 'Hoạt động xử lý',
                section_flows: 'Luồng dữ liệu',
                section_retention: 'Chính sách lưu trữ hiệu lực',
                section_governance: 'Quản trị',
                section_evidence: 'Bằng chứng',
                section_audit: 'Lịch sử kiểm toán gần đây',
                section_source_form: 'Biểu mẫu gốc',
                badge_inherited: 'Kế thừa',
                badge_overridden: 'Ghi đè',
            },
            toast: {
                created: 'Đã tạo mục đăng ký.',
                updated: 'Đã cập nhật mục đăng ký.',
                archived: 'Đã lưu trữ mục đăng ký.',
                imported: 'Đã nhập {count} mục.',
                conflict_warning: '{count} trường giữ nguyên theo bản sửa của bạn — xem danh sách xung đột.',
            },
            // Sprint 62.35.0 (AC6) — nguồn gốc, thông báo và chất lượng.
            evidence: {
                section_title: 'Nguồn gốc, thông báo và chất lượng',
                section_intro: 'Thông tin tổ chức ghi nhận về dữ liệu này. Đây là bản ghi, không phải kết luận: trường để trống nghĩa là chưa ghi nhận.',
                not_recorded: 'Chưa ghi nhận',
                group_provenance: 'Nguồn gốc và căn cứ',
                group_notice: 'Thông báo',
                group_quality: 'Tính xác thực và chất lượng',
                label_source_description: 'Nguồn dữ liệu',
                hint_source_description: 'Thu thập trực tiếp, tiếp nhận từ ai, hoặc do ai tạo lập.',
                label_data_owner: 'Chủ sở hữu dữ liệu',
                label_authorisation_basis: 'Căn cứ được dựa vào',
                label_authorisation_evidence_refs: 'Nơi lưu giữ tài liệu chứng minh về căn cứ (phân tách bằng dấu phẩy)',
                label_notified_purpose: 'Mục đích đã thông báo',
                label_notified_scope: 'Phạm vi đã thông báo',
                label_notice_reference: 'Tham chiếu thông báo',
                label_authenticity_checked: 'Đã kiểm tra tính xác thực',
                label_authenticity_method: 'Cách kiểm tra tính xác thực và kết quả',
                label_quality_checked: 'Đã kiểm tra chất lượng',
                label_quality_method: 'Cách kiểm tra chất lượng và kết quả',
                label_matches_source: 'Dữ liệu thu thập đúng với dữ liệu gốc',
                label_checked_on: 'Ngày kiểm tra',
                hint_checked_on: 'Ngày thực hiện việc kiểm tra. Không được sau ngày hôm nay.',
                label_checked_by: 'Người kiểm tra',
                checked_by_retry_subject: 'danh sách người có thể được ghi nhận là người kiểm tra',
                error_checked_on_in_future: 'Ngày kiểm tra không được sau ngày hôm nay theo lịch của tổ chức ({date}).',
                error_checked_by_not_found: 'Người được ghi nhận là người kiểm tra không phải là người dùng của tổ chức này.',
                label_recorded_by: 'Người ghi nhận việc kiểm tra',
                label_recorded_at: 'Thời điểm ghi nhận việc kiểm tra',
                hint_recorded_stamp: 'Được ghi tự động khi bất kỳ trường kiểm tra nào thay đổi.',
                option_yes: 'Có',
                option_no: 'Không',
                option_not_determined: 'Chưa xác định',
                vocabulary_none: 'Chưa có khung tuân thủ đã cài đặt nào quy định danh mục căn cứ, vì vậy trường này chỉ có thể để chưa ghi nhận.',
                vocabulary_not_in_force: 'Được quy định bởi khung tuân thủ chưa có hiệu lực (có hiệu lực từ {date}).',
                vocabulary_load_failed: 'Không thể tải các lựa chọn căn cứ.',
                value_undeclared: '{value} (không được khung tuân thủ đã cài đặt nào quy định)',
            },
        },
        systems: {
            title: 'Kho hệ thống',
            new: 'Hệ thống mới',
            edit: 'Sửa hệ thống',
            name: 'Tên',
            owner: 'Chủ sở hữu',
            criticality: 'Mức độ quan trọng',
            dpa_status: 'Trạng thái DPA',
            location: 'Vị trí',
            system_type: 'Loại hệ thống',
            metadata: 'Dữ liệu mở rộng (JSON)',
            department: 'Phòng ban',
            hosting_location: 'Vị trí lưu trữ',
            hosting_provider: 'Nhà cung cấp lưu trữ',
            data_residency_country: 'Quốc gia lưu trú dữ liệu',
            hosting: 'Lưu trữ',
            no_systems: 'Không tìm thấy hệ thống',
            confirm_archive: 'Lưu trữ hệ thống "{name}"?',
            count: 'hệ thống',
            count_one: 'hệ thống',
            type_internal: 'Nội bộ',
            type_external: 'Bên ngoài',
            type_cloud_service: 'Dịch vụ đám mây',
            type_on_premise: 'Tại chỗ',
            type_hybrid: 'Kết hợp',
            status_active: 'Hoạt động',
            status_decommissioning: 'Đang ngừng hoạt động',
            status_decommissioned: 'Đã ngừng hoạt động',
            status_planned: 'Đã lên kế hoạch',
            dpa_not_required: 'Không bắt buộc',
            dpa_required_missing: 'Bắt buộc - thiếu',
            dpa_in_progress: 'Đang xử lý',
            dpa_signed: 'Đã ký',
            all_criticalities: 'Tất cả mức độ quan trọng',
            status_inactive: 'Không hoạt động',
        },
        categories: {
            title: 'Danh mục dữ liệu',
            new: 'Danh mục mới',
            edit: 'Sửa danh mục',
            name: 'Tên',
            sensitivity: 'Độ nhạy cảm',
            tags: 'Nhãn',
            used_in: 'Sử dụng trong',
            examples: 'Ví dụ',
            examples_hint: 'Ví dụ (phân cách bằng dấu phẩy)',
            default: 'Mặc định',
            all_sensitivities: 'Tất cả độ nhạy cảm',
            no_categories: 'Không tìm thấy danh mục',
            confirm_delete: 'Xóa danh mục "{name}"?',
            count: 'danh mục',
            count_one: 'danh mục',
            all_statuses: 'Tất cả trạng thái',
            status_draft: 'Bản nháp',
            status_proposed: 'Đề xuất',
            status_under_review: 'Đang xem xét',
            status_approved: 'Đã phê duyệt',
            status_deprecated: 'Không còn sử dụng',
            status_updated: 'Trạng thái danh mục đã cập nhật',
            propose: 'Đề xuất',
            approve: 'Phê duyệt',
            deprecate: 'Ngừng sử dụng',
            items: 'Mục đăng ký dữ liệu',
        },
        purposes: {
            title: 'Mục đích xử lý',
            new: 'Mục đích mới',
            edit: 'Sửa mục đích',
            name: 'Tên',
            legal_basis: 'Cơ sở pháp lý',
            retention_period: 'Thời gian lưu trữ (ngày)',
            justification: 'Lý do lợi ích hợp pháp',
            legal_basis_detail: 'Chi tiết cơ sở pháp lý',
            all_legal_bases: 'Tất cả cơ sở pháp lý',
            no_purposes: 'Không tìm thấy mục đích',
            confirm_delete: 'Xóa "{name}"?',
            default: 'Mặc định',
            count: '{count} mục đích',
            count_one: '{count} mục đích',
        },
        retention: {
            title: 'Chính sách lưu trữ',
            new: 'Chính sách mới',
            edit: 'Sửa chính sách',
            name: 'Tên',
            retention_days: 'Số ngày lưu trữ',
            disposal_method: 'Phương pháp hủy',
            data_categories: 'Danh mục dữ liệu',
            activities: 'Hoạt động',
            review_frequency: 'Tần suất xem xét',
            review_frequency_days: 'Tần suất xem xét (ngày)',
            no_policies: 'Không tìm thấy chính sách lưu trữ',
            confirm_delete: 'Xóa "{name}"?',
            count: '{count} chính sách',
            count_one: '{count} chính sách',
            days: 'ngày',
            disposal_deletion: 'Xóa',
            disposal_anonymization: 'Ẩn danh hóa',
            disposal_archival: 'Lưu trữ',
            review_overdue: 'Quá hạn đánh giá',
            review_status: 'Trạng thái đánh giá',
            review_ok: 'Đúng tiến độ',
            department: 'Phòng ban',
            all_departments: 'Tất cả phòng ban',
            status_draft: 'Bản nháp',
            status_active: 'Hoạt động',
            status_superseded: 'Đã thay thế',
            status_retired: 'Đã ngừng sử dụng',
        },
        flows: {
            // fix-sprint-20260415-0434 F14
            view_tabs_aria: 'Chế độ xem luồng',
            view_list: 'Danh sách',
            view_map: 'Bản đồ',
            title: 'Luồng dữ liệu',
            new: 'Luồng mới',
            // fix-sprint-20260717-2118-followup F16
            section_basic_info: 'Thông tin cơ bản',
            section_narrative: 'Ghi chú mô tả',
            edit: 'Sửa luồng',
            name: 'Tên',
            from_system: 'Từ hệ thống',
            to_system: 'Đến hệ thống',
            flow_type: 'Loại luồng',
            cross_border: 'Xuyên biên giới',
            risk_level: 'Mức rủi ro',
            mechanism: 'Cơ chế',
            transfer_mechanism: 'Cơ chế chuyển dữ liệu',
            frequency: 'Tần suất',
            source_country: 'Quốc gia nguồn',
            destination_country: 'Quốc gia đích',
            transfer_safeguard: 'Biện pháp bảo vệ chuyển dữ liệu',
            transfer_safeguard_detail: 'Chi tiết biện pháp bảo vệ chuyển dữ liệu',
            all_risk_levels: 'Tất cả mức rủi ro',
            no_flows: 'Không tìm thấy luồng dữ liệu',
            confirm_archive: 'Lưu trữ "{name}"?',
            count: '{count} luồng',
            count_one: '{count} luồng',
            status_active: 'Hoạt động',
            status_inactive: 'Không hoạt động',
            status_under_review: 'Đang xem xét',
            mechanism_api: 'API',
            mechanism_file_transfer: 'Truyền tệp',
            mechanism_database_replication: 'Sao chép cơ sở dữ liệu',
            mechanism_manual: 'Thủ công',
            mechanism_email: 'Email',
            mechanism_other: 'Khác',
            frequency_real_time: 'Thời gian thực',
            frequency_hourly: 'Hàng giờ',
            frequency_daily: 'Hàng ngày',
            frequency_weekly: 'Hàng tuần',
            frequency_monthly: 'Hàng tháng',
            frequency_on_demand: 'Theo yêu cầu',
            frequency_one_time: 'Một lần',
            data_categories_label: 'Loại dữ liệu cá nhân',
            purposes_label: 'Mục đích',
            safeguard: 'Biện pháp bảo vệ',
            section_scope_title: 'Phạm vi xử lý',
            section_scope_description: 'Loại dữ liệu cá nhân và mục đích được luồng này mang theo.',
            jurisdiction: 'Phạm vi pháp lý',
        },
        activities: {
            title: 'Hoạt động xử lý',
            new: 'Hoạt động mới',
            edit: 'Sửa hoạt động',
            activity_title: 'Tiêu đề',
            category: 'Danh mục',
            legal_basis: 'Cơ sở pháp lý',
            dpa_required: 'Yêu cầu DPIA',
            ropa_generated: 'RoPA đã tạo',
            version: 'Phiên bản',
            generate_ropa: 'Tạo RoPA',
            controller: 'Bên kiểm soát',
            controller_name: 'Tên bên kiểm soát',
            controller_contact: 'Liên hệ bên kiểm soát',
            legal_basis_detail: 'Chi tiết cơ sở pháp lý',
            organization_info: 'Thông tin tổ chức',
            org_address: 'Địa chỉ tổ chức',
            tax_code: 'Mã số thuế',
            contact_person: 'Người liên hệ',
            contact_email: 'Email liên hệ',
            contact_phone: 'Điện thoại liên hệ',
            select_entity: 'Chọn…',
            no_entities: 'Không tìm thấy mục nào',
            dpo_name: 'Tên DPO',
            dpo_contact: 'Liên hệ DPO',
            processor_name: 'Tên bên xử lý',
            processor_contact: 'Liên hệ bên xử lý',
            data_subjects: 'Chủ thể dữ liệu',
            data_subjects_hint: 'Chủ thể dữ liệu (phân cách bằng dấu phẩy)',
            recipients: 'Người nhận',
            recipients_hint: 'Người nhận (phân cách bằng dấu phẩy)',
            security_measures: 'Biện pháp bảo mật',
            dpia_reference: 'Tham chiếu DPIA',
            no_activities: 'Không tìm thấy hoạt động xử lý',
            confirm_archive: 'Lưu trữ "{name}"?',
            count: '{count} hoạt động',
            count_one: '{count} hoạt động',
            ropa_success: 'Đã tạo bản ghi RoPA. Vào Xuất dữ liệu để tải xuống.',
            ropa_error: 'Không thể tạo RoPA',
            required_label: 'Bắt buộc',
            status_draft: 'Bản nháp',
            status_active: 'Hoạt động',
            status_under_review: 'Đang xem xét',
            status_archived: 'Đã lưu trữ',
            // Sprint 46.1.0 — Nghị định 165 phân loại dữ liệu.
            decree_165_heading: 'Phân loại dữ liệu theo Nghị định 165 (Luật Dữ liệu Việt Nam)',
            decree_165_helper: 'Ghi nhận cấp dữ liệu và việc dữ liệu được đánh giá chuyển giao có phải dữ liệu cá nhân hay không. Khoản 3 Điều 42 Nghị định 356 quy định đánh giá tác động đối với dữ liệu cá nhân cốt lõi hoặc quan trọng theo pháp luật bảo vệ dữ liệu cá nhân. Các nghĩa vụ khác theo Luật Dữ liệu vẫn cần được xem xét.',
            personal_data_scope: 'Phạm vi dữ liệu cá nhân của dữ liệu chuyển giao được đánh giá',
            personal_data_scope_personal: 'Đã xác nhận là dữ liệu cá nhân',
            personal_data_scope_non_personal: 'Đã xác nhận là dữ liệu không phải cá nhân',
            personal_data_scope_mixed: 'Hỗn hợp dữ liệu cá nhân và dữ liệu không phải cá nhân',
            personal_data_scope_unknown: 'Chưa xác định',
            personal_data_scope_hint: 'Phân loại dữ liệu chuyển giao được đánh giá và ghi nhận bằng chứng trước khi xác định lộ trình đánh giá tác động. Không suy ra phạm vi từ cấp dữ liệu.',
            personal_data_scope_evidence: 'Bằng chứng và căn cứ xác định phạm vi',
            personal_data_scope_evidence_required: 'Ghi nhận bằng chứng trước khi xác nhận phạm vi dữ liệu cá nhân hoặc dữ liệu không phải dữ liệu cá nhân.',
            cross_border_impact_assessment_reference: 'Tham chiếu đánh giá tác động chuyển xuyên biên giới',
            cross_border_impact_assessment_reference_label: 'Tham chiếu đánh giá tác động chuyển xuyên biên giới',
            cross_border_impact_assessment_reference_placeholder: 'Tham chiếu đánh giá theo lộ trình pháp lý áp dụng',
            scope_review: 'Phạm vi hỗn hợp hoặc chưa xác định cần được rà soát pháp lý trước khi chọn lộ trình đánh giá tác động. Ghi nhận cách đánh giá từng thành phần dữ liệu.',
            security_assessment_reference_help: 'Chỉ sử dụng khi áp dụng lộ trình đánh giá an toàn theo Nghị định 165. Đánh giá tác động đối với dữ liệu cá nhân cốt lõi hoặc quan trọng thực hiện theo pháp luật bảo vệ dữ liệu cá nhân, theo khoản 3 Điều 42 Nghị định 356.',
            data_tier_label: 'Phân loại dữ liệu',
            data_tier_help: 'Ghi nhận dữ liệu thông thường, quan trọng hoặc cốt lõi riêng với phạm vi dữ liệu cá nhân. Chỉ cấp dữ liệu chưa đủ để xác định lộ trình đánh giá tác động.',
            data_tier_column_header: 'Phân loại',
            data_tier_regular: 'Thông thường',
            data_tier_important: 'Quan trọng',
            data_tier_core: 'Cốt lõi',
            transfer_mechanism_label: 'Cơ chế chuyển dữ liệu xuyên biên giới',
            transfer_mechanism_placeholder: 'Ví dụ: cơ chế chuyển dữ liệu cá nhân xuyên biên giới mà các khung tuân thủ đã cài đặt quy định, kèm điều khoản',
            security_assessment_reference_label: 'Tham chiếu đánh giá an toàn theo Nghị định 165 (nếu áp dụng)',
            security_assessment_reference_placeholder: 'Ví dụ: MPS-SA-2026-001',
            data_categories_label: 'Loại dữ liệu cá nhân',
            purposes_label: 'Mục đích',
            registry_items_label: 'Mục đăng ký dữ liệu cụ thể (tuỳ chọn)',
            registry_items_hint: 'Đa số hoạt động để trống — loại dữ liệu cá nhân đã đủ cho RoPA. Hãy đặt khi thanh tra hỏi hoạt động này chạm đến đúng những trường nào.',
            registry_items_pending: 'Đang tải các mục đăng ký dữ liệu hiện liên kết với hoạt động này. Nếu lưu trước khi tải xong, các liên kết đó sẽ giữ nguyên.',
            registry_items_unavailable: 'Không tải được các mục đăng ký dữ liệu hiện liên kết với hoạt động này. Khi lưu, các liên kết đó sẽ giữ nguyên.',
            registry_items_unlisted_option: 'Mục liên kết {id} (không có trong danh sách)',
            retention_period_description: 'Mô tả thời hạn lưu trữ',
        },
        evidence: {
            title: 'Kho bằng chứng',
            new: 'Bằng chứng mới',
            edit: 'Sửa bằng chứng',
            name: 'Tên',
            evidence_type: 'Loại bằng chứng',
            linked_entities: 'Thực thể liên kết',
            uploaded: 'Đã tải lên',
            expiry: 'Ngày hết hạn',
            file_url: 'Đường dẫn tập tin',
            source_mode_label: 'Nguồn bằng chứng',
            source_mode_file: 'Tải lên tệp',
            source_mode_url: 'Liên kết URL bên ngoài',
            attachment_label: 'Tệp đính kèm',
            link_to: 'Liên kết bằng chứng đến',
            entity_type: 'Loại thực thể',
            entity_id: 'Mã thực thể',
            no_evidence: 'Không tìm thấy mục bằng chứng',
            manage_links: 'Quản lý liên kết',
            unlink: 'Hủy liên kết',
            confirm_delete: 'Xóa bằng chứng "{name}"?',
            count: '{count} mục',
            count_one: '{count} mục',
            type_document: 'Tài liệu',
            type_screenshot: 'Ảnh chụp màn hình',
            type_policy: 'Chính sách',
            type_contract: 'Hợp đồng',
            type_assessment: 'Đánh giá',
            type_correspondence: 'Thư từ',
            type_other: 'Khác',
            linked_type_system: 'Hệ thống',
            linked_type_data_flow: 'Luồng dữ liệu',
            linked_type_processing_activity: 'Hoạt động xử lý',
            linked_type_data_category: 'Danh mục dữ liệu',
            linked_type_purpose: 'Mục đích',
            linked_type_retention_policy: 'Chính sách lưu trữ',
            link_entity: 'Liên kết thực thể',
            link_success: 'Liên kết thực thể thành công',
            confirm_unlink: 'Bạn có chắc muốn hủy liên kết thực thể này không?',
            unlink_success: 'Đã hủy liên kết thực thể thành công',
            no_linked_entities: 'Không có thực thể liên kết',
            select_entity: 'Chọn…',
            no_entities: 'Không có mục nào',
        },
        exports: {
            title: 'Xuất dữ liệu',
            recent: 'Xuất gần đây',
            export_type: 'Loại xuất',
            format: 'Định dạng',
            requested_by: 'Người yêu cầu',
            requested_at: 'Thời gian yêu cầu',
            download: 'Tải xuống',
            csv_export: 'Xuất CSV',
            csv_description: 'Tải dữ liệu định dạng CSV để phân tích trên bảng tính.',
            pdf_reports: 'Báo cáo PDF',
            pdf_description: 'Tạo báo cáo định dạng cho tài liệu tuân thủ.',
            csv_systems: 'Kho hệ thống',
            csv_categories: 'Danh mục dữ liệu',
            csv_flows: 'Luồng dữ liệu',
            csv_activities: 'Hoạt động xử lý',
            csv_cross_border: 'Luồng xuyên biên giới',
            csv_retention_policies: 'Chính sách lưu trữ',
            csv_evidence: 'Mục bằng chứng',
            csv_governance_assignments: 'Phân công quản trị',
            pdf_ropa: 'Sổ đăng ký RoPA',
            pdf_systems: 'Báo cáo hệ thống',
            pdf_cross_border: 'Báo cáo xuyên biên giới',
            pdf_flow_map: 'Dữ liệu bản đồ luồng',
            export_failed: 'Xuất thất bại',
            pdf_generated: 'Tạo PDF thành công.',
            ropa: 'Sổ đăng ký ROPA',
            retention_policies: 'Chính sách Lưu trữ',
            governance_assignments: 'Gán Quản trị',
            col_entity: 'Thực thể',
            col_description: 'Mô tả',
            desc_ropa: 'Sổ đăng ký ROPA đầy đủ của tất cả hoạt động xử lý với cơ sở pháp lý, tình trạng DPIA và kiểm soát.',
            desc_systems: 'Kho hệ thống có tên, chủ sở hữu, phân loại dữ liệu và tình trạng tuân thủ.',
            desc_activities: 'Hoạt động xử lý riêng lẻ với bên kiểm soát, cơ sở pháp lý và phân loại DPIA.',
            desc_categories: 'Danh mục dữ liệu và mức độ nhạy cảm dùng cho phân loại và kiểm toán.',
            desc_purposes: 'Mục đích xử lý kèm cơ sở pháp lý đã ghi nhận cho từng mục đích.',
            desc_flows: 'Luồng dữ liệu giữa hệ thống, bao gồm nội bộ và xuyên biên giới.',
            desc_cross_border: 'Chỉ các luồng xuyên biên giới với cơ chế chuyển giao và đánh giá rủi ro.',
            desc_retention_policies: 'Chính sách lưu trữ, phương pháp xử lý và chu kỳ xem xét.',
            desc_evidence: 'Bằng chứng đính kèm hoạt động xử lý: chứng chỉ, hợp đồng DPA, báo cáo DPIA.',
            desc_governance_assignments: 'Phân công quản trị: chủ sở hữu, người phê duyệt và tham chiếu ISO 27001.',
            unified_heading: 'Xuất Dữ liệu',
            unified_description: 'Xuất bất kỳ thực thể Ánh xạ Dữ liệu nào sang CSV, XLSX, PDF hoặc DOCX. Mọi bản xuất đều được lưu vào File Browser.',
            export_button_label: 'Xuất',
            csv_download_success: 'Tải CSV thành công.',
            col_action: 'Xuất',
        },
        attestation: {
            title: 'Chu kỳ chứng thực',
            create: 'Chu kỳ mới',
            name: 'Tên chu kỳ',
            year: 'Năm',
            deadline: 'Hạn chót',
            scope: 'Phạm vi',
            status: 'Trạng thái',
            tasks: 'Nhiệm vụ phòng ban',
            assign_tasks: 'Gán nhiệm vụ',
            department: 'Phòng ban',
            assignee: 'Người được gán',
            progress: 'Tiến độ',
            stale_entries: 'Mục lỗi thời',
            detect_stale: 'Phát hiện lỗi thời',
            export_bundle: 'Xuất gói',
            no_cycles: 'Chưa có chu kỳ chứng thực nào.',
            create_success: 'Đã tạo chu kỳ chứng thực.',
            assign_success: 'Gán nhiệm vụ thành công.',
            complete_success: 'Hoàn thành nhiệm vụ.',
            stale_detected: 'Đã phát hiện mục lỗi thời.',
            stale_systems: 'Hệ thống lỗi thời',
            stale_flows: 'Luồng lỗi thời',
            no_stale: 'Không phát hiện mục lỗi thời.',
            stale_name: 'Tên',
            stale_announcement: 'Đã tìm thấy {0} hệ thống cũ và {1} luồng cũ',
            last_updated: 'Cập nhật cuối',
            status_draft: 'Nháp',
            status_active: 'Hoạt động',
            status_completed: 'Hoàn thành',
            task_status_pending: 'Chờ xử lý',
            task_status_in_progress: 'Đang thực hiện',
            task_status_completed: 'Hoàn thành',
            scope_systems: 'Hệ thống',
            scope_flows: 'Luồng dữ liệu',
            scope_activities: 'Hoạt động xử lý',
            scope_categories: 'Danh mục',
            scope_purposes: 'Mục đích',
            scope_retention: 'Lưu trữ',
            complete_cycle: 'Hoàn thành chu kỳ',
            confirm_activate: 'Bạn có chắc muốn kích hoạt chu kỳ này không?',
            confirm_complete: 'Bạn có chắc muốn hoàn thành chu kỳ này không? Không thể hoàn tác thao tác này.',
            cycle_complete_success: 'Đã hoàn thành chu kỳ',
            task_status_verified: 'Đã xác minh',
            activate_success: 'Đã kích hoạt chu kỳ.',
            activate: 'Kích hoạt chu kỳ',
        },
        governance: {
            title: 'Phân công quản trị',
            assign: 'Phân công quyền sở hữu',
            entity_type: 'Loại thực thể',
            entity: 'Thực thể',
            role: 'Vai trò',
            assigned_by: 'Người phân công',
            assigned_at: 'Thời gian phân công',
            remove: 'Xóa',
            no_assignments: 'Chưa có phân công quản trị.',
            assign_success: 'Đã phân công quyền sở hữu.',
            remove_success: 'Đã xóa phân công.',
            assignee: 'Người được giao',
            department: 'Phòng ban',
            all_departments: 'Tất cả phòng ban',
            roles: {
                data_owner: 'Chủ sở hữu dữ liệu',
                data_steward: 'Quản lý dữ liệu',
                data_custodian: 'Người giữ dữ liệu',
                informed: 'Được thông báo',
            },
            entity_types: {
                system: 'Hệ thống',
                flow: 'Luồng dữ liệu',
                activity: 'Hoạt động',
                category: 'Danh mục',
                purpose: 'Mục đích',
                retention_policy: 'Chính sách lưu trữ',
            },
        },
        risk_assessment: {
            title: 'Đánh giá rủi ro',
            create: 'Đánh giá mới',
            safeguard_type: 'Loại biện pháp bảo vệ',
            adequacy_status: 'Trạng thái đầy đủ',
            risk_factors: 'Yếu tố rủi ro',
            mitigations: 'Biện pháp giảm thiểu',
            reviewer: 'Người đánh giá',
            decision: 'Quyết định',
            approve: 'Phê duyệt',
            reject: 'Từ chối',
            no_assessments: 'Chưa có đánh giá rủi ro.',
            create_success: 'Đã tạo đánh giá rủi ro.',
            approve_success: 'Đã phê duyệt đánh giá.',
            reject_success: 'Đã từ chối đánh giá.',
            one_per_line: 'Mỗi dòng một mục',
            adequacy_adequate: 'Đầy đủ',
            adequacy_inadequate: 'Không đầy đủ',
            adequacy_under_review: 'Đang xem xét',
            adequacy_not_assessed: 'Chưa đánh giá',
            decision_approved: 'Phê duyệt',
            decision_rejected: 'Từ chối',
        },
        review: {
            title: 'Nhiệm vụ đánh giá',
            description: 'Nhiệm vụ xem xét được tạo tự động khi một danh mục dữ liệu được đề xuất. Để tạo nhiệm vụ mới, vào Danh mục dữ liệu và nhấn Đề xuất trên danh mục nháp.',
            count: 'nhiệm vụ đánh giá',
            summary: 'Tóm tắt đánh giá',
            pending: 'Chờ xử lý',
            resolved_today: 'Đã giải quyết hôm nay',
            escalated: 'Đã leo thang',
            overdue: 'Quá hạn (>5 ngày)',
            all_statuses: 'Tất cả trạng thái',
            status_pending: 'Chờ xử lý',
            status_resolved: 'Đã giải quyết',
            status_escalated: 'Đã leo thang',
            category_name: 'Danh mục',
            system_name: 'Hệ thống',
            owner: 'Chủ sở hữu',
            resolve: 'Giải quyết',
            resolve_task: 'Giải quyết nhiệm vụ đánh giá',
            resolution: 'Giải pháp',
            resolution_approve: 'Phê duyệt',
            resolution_modify: 'Sửa đổi và phê duyệt',
            resolution_reject: 'Từ chối',
            resolution_escalate: 'Leo thang',
            notes: 'Ghi chú giải quyết',
            notes_required: 'Yêu cầu ghi chú (tối thiểu 10 ký tự) cho Sửa đổi, Từ chối hoặc Leo thang',
            resolved_success: 'Nhiệm vụ đánh giá đã giải quyết',
            bulk_approve: 'Phê duyệt hàng loạt',
            bulk_reject: 'Từ chối hàng loạt',
            bulk_success: '{count} nhiệm vụ đã xử lý',
            no_tasks: 'Không tìm thấy nhiệm vụ đánh giá',
        },
        inventory: {
            title: 'Kho phân loại',
            count: 'hệ thống',
            summary: 'Tóm tắt kho dữ liệu',
            total_systems: 'Tổng số hệ thống',
            total_labels: 'Tổng số nhãn',
            system_name: 'Hệ thống',
            label_count: 'Nhãn',
            approved_count: 'Đã phê duyệt',
            pending_count: 'Chờ xử lý',
            no_items: 'Không tìm thấy mục kho dữ liệu',
        },
        exceptions: {
            title: 'Ngoại lệ phân loại',
            count: 'ngoại lệ',
            all_severities: 'Tất cả mức độ nghiêm trọng',
            all_statuses: 'Tất cả trạng thái',
            system_name: 'Hệ thống',
            severity_label: 'Mức độ nghiêm trọng',
            status_open: 'Mở',
            status_resolved: 'Đã giải quyết',
            status_accepted_risk: 'Rủi ro chấp nhận',
            resolve: 'Giải quyết',
            resolve_exception: 'Giải quyết ngoại lệ',
            resolution_type: 'Loại giải quyết',
            notes: 'Ghi chú',
            justification_required: 'Yêu cầu lý do (tối thiểu 10 ký tự) cho rủi ro chấp nhận',
            resolved_success: 'Ngoại lệ đã giải quyết',
            no_exceptions: 'Không tìm thấy ngoại lệ',
        },
        history: {
            title: 'Lịch sử phân loại',
            count: 'sự kiện',
            actor: 'Người thực hiện',
            action: 'Hành động',
            entity_type: 'Loại thực thể',
            changes: 'Thay đổi',
            view_lineage: 'Xem nguồn gốc',
            lineage_title: 'Nguồn gốc phân loại',
            no_events: 'Không tìm thấy sự kiện lịch sử',
            no_lineage: 'Không có dữ liệu nguồn gốc',
            modified: 'Đã sửa đổi',
            created: 'Đã tạo',
            removed: 'Đã xóa',
            action_created: 'Đã tạo',
            action_updated: 'Đã cập nhật',
            action_archived: 'Đã lưu trữ',
            action_approved: 'Đã phê duyệt',
            action_deprecated: 'Không còn sử dụng',
            entity_label: 'Nhãn',
            entity_taxonomy: 'Phân loại học',
            entity_review_task: 'Nhiệm vụ đánh giá',
            entity_exception: 'Ngoại lệ',
            before: 'Trước',
            after: 'Sau',
        },
    },
    governance: {
        // Sprint 41.2.0 E6 — Governance Audit Trail page keys
        audit_trail_title: 'Nhật ký kiểm toán quản trị',
        audit_trail_subtitle: 'Luồng kiểm toán liên thực thể cho các hành động quản trị — phê duyệt, thực thi playbook, liên kết bằng chứng và hơn thế.',
        audit_trail_item_count: 'sự kiện kiểm toán',
        audit_trail_fetch_error: 'Không thể lấy sự kiện kiểm toán.',
        audit_trail_no_events: 'Không tìm thấy sự kiện kiểm toán nào với bộ lọc hiện tại.',
        audit_trail_entity_type: 'Loại thực thể',
        audit_trail_entity_id: 'ID thực thể',
        audit_trail_action: 'Hành động',
        audit_trail_actor: 'Tác nhân',
        audit_trail_timestamp: 'Dấu thời gian',
        audit_trail_date_from: 'Từ',
        audit_trail_date_to: 'Đến',
        audit_trail_no_rows_to_export: 'Không có hàng để xuất.',
        // Gate E12.5 remediation A (Sprint 63.8.2) — the audit trail filter options.
        audit_trail_entity_types: {
            vendor: 'Nhà cung cấp',
            vendor_subprocessor: 'Bên xử lý phụ',
            transfer_mechanism: 'Cơ chế chuyển giao',
            drift_event: 'Sự kiện lệch',
            playbook: 'Playbook',
            execution: 'Lần thực thi',
            approval: 'Phê duyệt',
        },
        audit_trail_actions: {
            created: 'Đã tạo',
            updated: 'Đã cập nhật',
            status_changed: 'Đã đổi trạng thái',
            assigned: 'Đã giao',
            approved: 'Đã phê duyệt',
            rejected: 'Đã từ chối',
            evidence_linked: 'Đã liên kết bằng chứng',
            step_completed: 'Đã hoàn thành bước',
            executed: 'Đã thực thi',
            terminated: 'Đã chấm dứt',
            exported: 'Đã xuất',
        },
        nav: {
            vendors: 'Nhà cung cấp',
            subprocessors: 'Bên xử lý phụ',
            cross_border: 'Xuyên biên giới',
            drift: 'Giám sát lệch',
            scores: 'Điểm tuân thủ',
            playbooks: 'Quy trình xóa',
            approvals: 'Phê duyệt',
            audit_trail: 'Nhật ký kiểm toán',
            board_report: 'Báo cáo Ban Giám đốc',
            evidence: 'Bằng chứng',
            onboarding: 'Quy trình tiếp nhận',
            dpa_reviews: 'Đánh giá DPA',
            periodic_reviews: 'Đánh giá định kỳ',
            offboarding: 'Ngừng hợp tác',
        },
        vendors: {
            data_categories_processed: 'Loại dữ liệu được xử lý',
            title: 'Sổ nhà cung cấp',
            new: 'Nhà cung cấp mới',
            edit: 'Sửa nhà cung cấp',
            name: 'Tên',
            jurisdiction: 'Phạm vi pháp lý',
            dpa_status: 'Trạng thái DPA',
            risk_level: 'Mức rủi ro',
            onboarding_status: 'Trạng thái tiếp nhận',
            contact_email: 'Email liên hệ',
            contact_name: 'Tên liên hệ',
            contact_phone: 'Điện thoại liên hệ',
            website: 'Trang web',
            services_csv: 'Dịch vụ (phân cách bằng dấu phẩy)',
            country: 'Quốc gia',
            country_placeholder: 'VD: VN',
            last_reviewed: 'Xem xét lần cuối',
            offboard: 'Ngừng hợp tác',
            offboard_vendor: 'Ngừng hợp tác nhà cung cấp',
            offboard_reason: 'Lý do ngừng hợp tác',
            no_vendors: 'Không tìm thấy nhà cung cấp',
            vendor_count: '{count} nhà cung cấp',
            all_dpa_status: 'Tất cả trạng thái DPA',
            all_risk_levels: 'Tất cả mức rủi ro',
            all_onboarding: 'Tất cả trạng thái tiếp nhận',
            fetch_error: 'Thất bại. Vui lòng thử lại.',
            save_error: 'Không thể lưu nhà cung cấp',
            offboard_error: 'Không thể ngừng hợp tác',
            reach: {
                action: 'Phạm vi với bên nước ngoài',
                title: 'Phạm vi với bên nước ngoài: {name}',
                intro: 'Một khung tuân thủ đã cài đặt hỏi nhà cung cấp này có thuộc phạm vi áp dụng đối với bên nước ngoài của khung hay không. Con người ghi nhận câu trả lời và lý do; quốc gia và địa điểm xử lý dữ liệu của nhà cung cấp không quyết định điều đó.',
                none_declared: 'Không có khung tuân thủ đã cài đặt nào đặt câu hỏi về phạm vi áp dụng đối với bên nước ngoài.',
                not_determined: 'Chưa xác định',
                within: 'Thuộc phạm vi',
                not_within: 'Không thuộc phạm vi',
                decided: 'Ghi nhận ngày {date}',
                related: 'Các quy định áp dụng với bên thuộc phạm vi này: {list}',
                question: 'Câu hỏi',
                answer: 'Nhà cung cấp này có thuộc phạm vi không?',
                rationale: 'Lý do',
                citation: 'Trích dẫn (không bắt buộc)',
                save: 'Ghi nhận kết quả xác định',
                saved: 'Đã ghi nhận việc xác định phạm vi áp dụng đối với bên nước ngoài.',
                load_error: 'Không đọc được các câu hỏi về phạm vi áp dụng đối với bên nước ngoài.',
                retry: 'Tải lại',
                retry_sr: 'các câu hỏi về phạm vi áp dụng đối với bên nước ngoài',
                loading: 'Đang đọc các câu hỏi về phạm vi áp dụng đối với bên nước ngoài…',
                retry_busy: 'Đang tải lại…',
                stale: 'Người khác đã thay đổi nhà cung cấp này. Phiên bản mới nhất đã được tải; hãy xem lại và ghi nhận kết quả xác định một lần nữa.',
                stale_unreadable: 'Người khác đã thay đổi nhà cung cấp này và không đọc được phiên bản mới nhất. Hãy đóng hộp thoại này và mở lại trước khi ghi nhận.',
                save_error: 'Không ghi nhận được việc xác định. Hãy thử lại.',
                answer_required: 'Hãy chọn câu trả lời và nêu lý do.',
                country_context: 'Quốc gia đã ghi nhận: {country}',
                read_only: 'Cần quyền chỉnh sửa nhà cung cấp để ghi nhận việc xác định.',
            },
        },
        vendor_types: {
            processor: 'Bên xử lý',
            sub_processor: 'Bên xử lý phụ',
            controller: 'Bên kiểm soát',
            joint_controller: 'Đồng kiểm soát',
        },
        onboarding_statuses: {
            pending_review: 'Chờ xem xét',
            approved: 'Đã phê duyệt',
            active: 'Đang hoạt động',
            suspended: 'Tạm ngừng',
            offboarded: 'Đã ngừng hợp tác',
        },
        dpa_statuses: {
            not_started: 'Chưa bắt đầu',
            in_progress: 'Đang thực hiện',
            not_required: 'Không bắt buộc',
            required_missing: 'Bắt buộc - thiếu',
            draft: 'Bản nháp',
            under_review: 'Đang xem xét',
            signed: 'Đã ký',
            expired: 'Hết hạn',
        },
        risk_levels: {
            critical: 'Nghiêm trọng',
            high: 'Cao',
            medium: 'Trung bình',
            low: 'Thấp',
        },
        approval_statuses: {
            pending: 'Chờ xử lý',
            approved: 'Đã phê duyệt',
            rejected: 'Đã từ chối',
            expired: 'Hết hạn',
        },
        approval_action_types: {
            vendor_onboarding: 'Tiếp nhận nhà cung cấp',
            vendor_offboarding: 'Ngừng nhà cung cấp',
            cross_border_acceptance: 'Chấp nhận xuyên biên giới',
            playbook_activation: 'Kích hoạt quy trình',
            drift_accept_risk: 'Chấp nhận rủi ro lệch',
            activity_activation: 'Kích hoạt hoạt động',
        },
        drift_check_types: {
            dpa_expiry: 'DPA hết hạn',
            dpa_missing: 'Thiếu DPA',
            review_overdue: 'Xem xét quá hạn',
            cross_border_gap: 'Lỗ hổng xuyên biên giới',
            sub_processor_chain: 'Chuỗi bên xử lý phụ',
            risk_assessment_overdue: 'Đánh giá rủi ro quá hạn',
            retention_policy_missing: 'Thiếu chính sách lưu trữ',
            evidence_expiring: 'Bằng chứng sắp hết hạn',
        },
        drift_statuses: {
            open: 'Mô',
            acknowledged: 'Đã xác nhận',
            in_progress: 'Đang xử lý',
            resolved: 'Đã giải quyết',
            accepted_risk: 'Chấp nhận rủi ro',
        },
        drift_entity_types: {
            vendor: 'Nhà cung cấp',
            system: 'Hệ thống',
            data_flow: 'Luồng dữ liệu',
            processing_activity: 'Hoạt động xử lý',
            evidence_item: 'Mục bằng chứng',
        },
        playbook_statuses: {
            draft: 'Bản nháp',
            active: 'Đang hoạt động',
            archived: 'Đã lưu trữ',
        },
        playbook_action_types: {
            delete_data: 'Xóa dữ liệu',
            verify_deletion: 'Xác minh xóa',
            notify_vendor: 'Thông báo nhà cung cấp',
            confirm_receipt: 'Xác nhận nhận',
            document_evidence: 'Tài liệu bằng chứng',
            other: 'Khác',
        },
        playbook_target_types: {
            system: 'Hệ thống',
            vendor: 'Nhà cung cấp',
        },
        dpa_chain_statuses: {
            complete: 'Hoàn thành',
            incomplete: 'Chưa hoàn thành',
            unknown: 'Chưa biết',
        },
        sub_processor_statuses: {
            active: 'Đang hoạt động',
            terminated: 'Đã chấm dứt',
        },
        evidence_types: {
            dpa_agreement: 'Thỏa thuận DPA',
            risk_assessment: 'Đánh giá rủi ro',
            audit_report: 'Báo cáo kiểm toán',
            certification: 'Chứng chỉ',
            deletion_confirmation: 'Xác nhận xóa',
            training_record: 'Hồ sơ đào tạo',
            incident_report: 'Báo cáo sự cố',
            document: 'Tài liệu',
            screenshot: 'Ảnh chụp màn hình',
            policy: 'Chính sách',
            contract: 'Hợp đồng',
            assessment: 'Đánh giá',
            correspondence: 'Thứ tự',
            other: 'Khác',
        },
        linkable_entity_types: {
            vendor: 'Nhà cung cấp',
            transfer_mechanism: 'Cơ chế chuyển giao',
            playbook: 'Quy trình',
            execution: 'Thực thi',
            system: 'Hệ thống',
            activity: 'Hoạt động',
        },
        subprocessors: {
            title: 'Quan hệ bên xử lý phụ',
            new: 'Liên kết mới',
            vendor: 'Nhà cung cấp',
            subprocessor: 'Bên xử lý phụ',
            relationship_type: 'Loại quan hệ',
            countries: 'Quốc gia',
            countries_csv: 'Quốc gia (phân cách bằng dấu phẩy)',
            dpa_chain: 'Chuỗi DPA',
            dpa_chain_status: 'Trạng thái chuỗi DPA',
            no_processors: 'Không tìm thấy bộ xử lý.',
            no_subprocessors: 'Không tìm thấy bộ xử lý phụ.',
            processor_vendor: 'Nhà cung cấp bộ xử lý',
            select_processor: 'Chọn bộ xử lý',
            select_vendor: 'Chọn nhà cung cấp',
            services: 'Dịch vụ',
            sub_processor_vendor_id: 'Mã nhà cung cấp bộ xử lý phụ',
            terminate: 'Chấm dứt',
            confirm_terminate: 'Bạn có chắc chắn muốn chấm dứt mối quan hệ này không?',
            create_error: 'Không thể tạo liên kết.',
            fetch_error: 'Không thể tải bên xử lý phụ.',
            processor: 'Bên xử lý',
            services_csv: 'Dịch vụ (phân cách bằng dấu phẩy)',
            terminate_error: 'Không thể chấm dứt.',
            version_history_heading: 'Quản lý phiên bản thay đổi bên xử lý phụ',
            change_tracking_note: 'Tất cả thay đổi quan hệ bên xử lý phụ đều được quản lý phiên bản. Mỗi sửa đổi ghi lại trạng thái trước/sau để phục vụ kiểm toán.',
            history_retention_note: 'Lịch sử thay đổi được lưu giữ trong suốt thời gian lưu trữ dữ liệu. Xem nhật ký thay đổi qua trang chi tiết nhà cung cấp.',
            vendor_risk_cross_view_heading: 'Sổ đăng ký nhà xử lý phụ (Vendor Risk)',
            vendor_risk_cross_view_source: 'Nguồn: Sổ đăng ký Vendor Risk',
            vendor_risk_cross_view_empty: 'Không có mục nào trong sổ đăng ký Vendor Risk.',
            vendor_risk_cross_view_load_error: 'Không đọc được sổ đăng ký bên xử lý phụ của Vendor Risk.',
            partial_load: 'Không đọc được danh sách bên xử lý phụ của {count} bên xử lý, nên sổ đăng ký bên dưới chưa đầy đủ.',
        },
        cross_border: {
            title: 'Báo cáo quản trị xuyên biên giới',
            flows: 'Luồng xuyên biên giới',
            transfers: 'Chuyển dữ liệu xuyên biên giới',
            detected_gaps: 'Lỗi phát hiện',
            safeguards: 'Biện pháp bảo vệ',
            cross_border_vendors: 'Nhà cung cấp xuyên biên giới',
            destination: 'Đích đến',
            no_cross_border_vendors: 'Không tìm thấy nhà cung cấp xuyên biên giới.',
            no_safeguard: 'Không có biện pháp bảo vệ',
            gap_needs_redetermination: 'Cơ chế đã ghi nhận cần xác định lại',
            gap_unverified: 'Cơ chế đã ghi nhận chưa được xác minh',
            gap_recorded_mechanism: 'Đã ghi nhận: {mechanism}',
            redetermine_mechanism: 'Xác định lại',
            redetermine_mechanism_title: 'Xác định lại cơ chế chuyển dữ liệu của nhà cung cấp',
            redetermine_mechanism_intro: '{vendor} ghi nhận cơ chế chuyển dữ liệu "{mechanism}" cho tuyến {source} đến {destination}, và hiện không khung tuân thủ đã cài đặt nào quy định cơ chế này. Hãy chọn một cơ chế mà khung tuân thủ đã cài đặt quy định. Chỉ cơ chế được lưu.',
            redetermine_choose_first: 'Hãy chọn một cơ chế chuyển dữ liệu trước.',
            redetermine_success: 'Đã xác định lại cơ chế chuyển dữ liệu.',
            redetermine_error: 'Không thể xác định lại cơ chế chuyển dữ liệu. Vui lòng thử lại.',
            processing_locations: 'Địa điểm xử lý',
            export_error: 'Không thể xuất báo cáo.',
            export_pdf: 'Xuất PDF',
            export_success: 'Đã xuất báo cáo thành công.',
            exporting: 'Đang xuất...',
            fetch_error: 'Không thể tải dữ liệu xuyên biên giới.',
            source: 'Nguồn',
            pdpl_p2_heading: 'Tuân thủ chuyển dữ liệu xuyên biên giới PDPL-P2',
            dossier_prep_note: 'Chuẩn bị hồ sơ: tập hợp đánh giá tác động, cơ sở pháp lý và tài liệu biện pháp bảo vệ trước khi nộp.',
            filing_tracking_note: 'Theo dõi nộp hồ sơ: giám sát trạng thái nộp hồ sơ với cơ quan có thẩm quyền từ đơn ban đầu đến khi phê duyệt.',
            supplement_loop_note: 'Vòng bổ sung: phản hồi yêu cầu thông tin từ Cơ quan và nộp lại hồ sơ đã sửa đổi khi cần thiết.',
            official_forms_note: 'Biểu mẫu chính thức: chọn biểu mẫu chính thức áp dụng cho hồ sơ này trong ô chọn Loại biểu mẫu khi bạn tạo hồ sơ.',
            vendor_search_label: 'Tìm kiếm nhà cung cấp',
            vendor_search_placeholder: 'Tìm theo tên nhà cung cấp…',
            jurisdiction_filter_label: 'Phạm vi pháp lý',
            // --- Sprint 41.5.0 G1 — Vòng đời hồ sơ chuyển dữ liệu xuyên biên giới ---
            filings_section_heading: 'Hồ sơ chuyển dữ liệu xuyên biên giới',
            filings_empty: 'Chưa có hồ sơ. Tạo mới để bắt đầu chuẩn bị hồ sơ.',
            filings_create_button: 'Tạo hồ sơ',
            filings_table_id: 'Mã hồ sơ',
            filings_table_jurisdiction: 'Phạm vi pháp lý',
            filings_table_type: 'Loại biểu mẫu',
            filings_table_status: 'Trạng thái',
            filings_table_updated: 'Cập nhật',
            filings_table_open: 'Mở',
            filings_detail_title: 'Hồ sơ chuyển dữ liệu xuyên biên giới',
            filings_back_to_list: 'Quay lại Báo cáo quản trị xuyên biên giới',
            filings_status_heading: 'Vòng đời',
            filings_evidence_heading: 'Bằng chứng',
            filings_history_heading: 'Nhật ký kiểm toán',
            filings_field_filing_id: 'Mã hồ sơ',
            filings_field_jurisdiction: 'Phạm vi pháp lý',
            filings_field_type: 'Loại biểu mẫu',
            filings_field_status: 'Trạng thái',
            filings_field_reference: 'Số tham chiếu của Cơ quan',
            filings_field_mps_receipt: 'Biên nhận MPS',
            filings_field_submitted_at: 'Thời điểm nộp',
            filings_field_acknowledged_at: 'Thời điểm được ghi nhận',
            filings_field_archived_at: 'Thời điểm lưu trữ',
            filings_field_version: 'Phiên bản',
            filings_field_notes: 'Ghi chú',
            filings_action_advance: 'Chuyển trạng thái',
            filings_action_reject: 'Từ chối',
            filings_action_archive: 'Lưu trữ',
            filings_action_submit: 'Đánh dấu đã nộp',
            filings_action_acknowledge: 'Đánh dấu đã được ghi nhận',
            filings_action_resume_draft: 'Chuyển lại nháp',
            filings_status_draft: 'Nháp',
            filings_status_assessed: 'Đã đánh giá',
            filings_status_pending_review: 'Chờ rà soát',
            filings_status_ready_to_file: 'Sẵn sàng nộp',
            filings_status_submitted: 'Đã nộp',
            filings_status_acknowledged: 'Đã được ghi nhận',
            filings_status_rejected: 'Bị từ chối',
            filings_status_archived: 'Đã lưu trữ',
            filings_type_none_installed: 'Chưa có biểu mẫu nào đã cài đặt để nộp cho tổ chức này',
            filings_new_dialog_title: 'Tạo hồ sơ chuyển dữ liệu mới',
            filings_new_form_jurisdiction: 'Phạm vi pháp lý',
            filings_new_form_type: 'Loại biểu mẫu',
            filings_new_form_notes: 'Ghi chú (tùy chọn)',
            // Sprint 64.69.0
            filings_type_placeholder: 'Chọn loại biểu mẫu…',
            filings_new_submit: 'Tạo',
            filings_new_cancel: 'Hủy',
            filings_reason_label: 'Lý do',
            filings_reference_label: 'Số tham chiếu của Cơ quan',
            filings_mps_receipt_label: 'Biên nhận MPS',
            filings_create_error: 'Tạo hồ sơ thất bại.',
            filings_create_success: 'Đã tạo hồ sơ.',
            filings_update_error: 'Cập nhật hồ sơ thất bại.',
            filings_update_success: 'Đã cập nhật hồ sơ.',
            filings_fetch_error: 'Không lấy được danh sách hồ sơ.',
            filings_archive_confirm: 'Lưu trữ hồ sơ này? Không thể hoàn tác.',
            // Sprint 41.5.0 G9.1 / G9.3 — UX polish keys
            filings_status_rejected_detour: 'Hồ sơ đã bị từ chối sau khi rà soát. Chuyển lại nháp để bắt đầu lại quy trình.',
            recent_exports_heading: 'Bản xuất gần đây',
            recent_exports_empty: 'Chưa có bản xuất. Nhấn "Xuất PDF" để tạo mới.',
            filings_forms_empty: 'Chưa tạo biểu mẫu nào. Hãy dùng phân hệ Biểu mẫu để tạo các kết xuất cần thiết cho hồ sơ này.',
            filings_forms_heading: 'Biểu mẫu cơ quan quản lý',
        },
        drift: {
            title: 'Giám sát lệch cấu hình',
            drift_type: 'Loại lệch',
            severity: 'Mức độ',
            detected_at: 'Phát hiện lúc',
            resolve: 'Giải quyết',
            all_check_types: 'Tất cả loại kiểm tra',
            all_entity_types: 'Tất cả loại thực thể',
            event_count: 'Số sự kiện',
            accept_risk: 'Chấp nhận rủi ro',
            acknowledge: 'Xác nhận',
            assign_error: 'Không thể phân công.',
            assign_event: 'Phân công',
            assigned: 'Đã giao',
            enter_resolution_notes: 'Nhập ghi chú giải quyết...',
            enter_user_id: 'Nhập mã người dùng...',
            entity: 'Thực thể',
            fetch_error: 'Không thể tải sự kiện lệch chuẩn.',
            no_events: 'Không tìm thấy sự kiện lệch chuẩn.',
            resolution_notes: 'Ghi chú giải quyết',
            update_status_error: 'Không thể cập nhật trạng thái.',
        },
        scores: {
            title: 'Bảng điểm tuân thủ',
            overall: 'Điểm tuân thủ tổng thể',
            breakdown: 'Phân tích theo phân hệ',
            trend: 'Xu hướng lịch sử',
            module: 'Phân hệ',
            score: 'Điểm',
            grade: 'Xếp loại',
            calculated_at: 'Tính toán lúc',
            generate_board_report: 'Tạo báo cáo hội đồng',
            lang_english: 'Tiếng Anh',
            lang_vietnamese: 'Tiếng Việt',
            fetch_error: 'Không thể tải điểm tuân thủ.',
            generate_report: 'Tạo báo cáo',
            generating: 'Đang tạo...',
            recommendations: 'Khuyến nghị',
            report_error: 'Không thể tạo báo cáo.',
            factor_owner_assigned: 'Đã gán chủ sở hữu',
            factor_data_categories_linked: 'Đã liên kết danh mục dữ liệu',
            factor_purposes_linked: 'Đã liên kết mục đích',
            factor_data_flows_documented: 'Đã ghi nhận luồng dữ liệu',
            factor_processing_activity_linked: 'Đã liên kết hoạt động xử lý',
            factor_dpa_status: 'Trạng thái DPA',
            factor_retention_policy_linked: 'Đã liên kết chính sách lưu giữ',
            factor_last_reviewed: 'Đã xem xét trong ngưỡng thời gian',
            factor_risk_assessment_current: 'Đánh giá rủi ro hiện tại',
            factor_sub_processors_documented: 'Đã ghi nhận bên xử lý phụ',
            factor_cross_border_safeguards: 'Biện pháp bảo vệ xuyên biên giới',
            factor_contact_info_complete: 'Thông tin liên hệ đầy đủ',
            factor_onboarding_approved: 'Đã phê duyệt tiếp nhận',
            factor_avg_system_score: 'Điểm hệ thống trung bình',
            factor_avg_vendor_score: 'Điểm nhà cung cấp trung bình',
            factor_processing_activity_coverage: 'Phạm vi hoạt động xử lý',
            factor_ropa_completeness: 'Mức hoàn thiện RoPA',
            factor_open_drift_events: 'Sự kiện lệch chưa xử lý',
        },
        playbooks: {
            title: 'Quy trình xóa dữ liệu',
            new: 'Quy trình mới',
            edit: 'Sửa quy trình',
            steps: 'Các bước',
            add_step: 'Thêm bước',
            remove_step: 'Xóa bước',
            data_categories_csv: 'Danh mục dữ liệu (phân cách bằng dấu phẩy)',
            estimated_duration: 'Thời gian ước tính',
            estimated_duration_label: 'Thời gian ước tính',
            evidence_description: 'Mô tả bằng chứng',
            no_playbooks: 'Không tìm thấy kịch bản.',
            playbook_count: 'Số kịch bản',
            requires_evidence: 'Yêu cầu bằng chứng',
            step_label: 'Nhãn bước',
            target_type: 'Loại mục tiêu',
            action_type: 'Loại hành động',
            archive_error: 'Không thể lưu trữ.',
            confirm_archive: 'Bạn có chắc chắn muốn lưu trữ kịch bản này không?',
            data_categories: 'Danh mục dữ liệu',
            days: 'ngày',
            fetch_error: 'Không thể tải kịch bản.',
            sla_days: 'SLA (ngày)',
            target_id: 'Mã mục tiêu',
            target_name: 'Tên mục tiêu',
            template_class_heading: 'Phân loại mẫu',
            official: 'Chính thức',
            internal: 'Nội bộ',
            classification: 'Phân loại',
            official_note: 'Chính thức: mẫu bắt buộc theo quy định phù hợp với PDPL, GDPR hoặc yêu cầu ngành cụ thể.',
            internal_note: 'Nội bộ: quy trình riêng của tổ chức không bắt nguồn từ mẫu quy định.',
            active_executions_heading: 'Thực thi đang hoạt động',
            no_active_executions: 'Không có thực thi đang hoạt động.',
            playbook_label: 'Playbook',
            ticket_id_label: 'Phiếu',
            progress_label: 'Tiến độ',
            actions_label: 'Hành động',
            view_steps_label: 'Xem các bước',
            execution_detail_title: 'Chi tiết thực thi',
            playbook_missing: 'Không tìm thấy playbook.',
            evidence_required_label: 'Yêu cầu bằng chứng',
            upload_evidence_label: 'Tải lên bằng chứng',
            mark_complete_label: 'Đánh dấu hoàn tất',
            evidence_required_toast: 'Cần bằng chứng trước khi hoàn tất bước này.',
            evidence_blocking_message: 'Đính kèm tệp bằng chứng để tiếp tục.',
            step_completed_toast: 'Bước đã hoàn tất.',
            executions_fetch_error: 'Không tải được các thực thi.',
            step_evidence_default_name: 'Bằng chứng bước thực thi',
            attached_evidence_label: 'Bằng chứng đã đính kèm',
        },
        approvals: {
            // Sprint 63.30.0 (#485) — approval expiry.
            expiry_setting_heading: 'Thời hạn của đề nghị phê duyệt',
            expiry_setting_label: 'Đề nghị phê duyệt hết hạn sau (ngày)',
            expiry_setting_hint: 'Số ngày nguyên từ {min} đến {max}. Áp dụng cho các đề nghị được gửi sau khi thay đổi. Đề nghị chưa được quyết định khi đến hạn sẽ được đánh dấu Hết hạn và người đề nghị được thông báo.',
            expiry_setting_value: 'Đề nghị phê duyệt hết hạn sau {days} ngày.',
            expiry_setting_save: 'Lưu thời hạn',
            expiry_setting_saved: 'Đã đặt thời hạn phê duyệt là {days} ngày',
            expiry_setting_load_failed: 'Không thể đọc thiết lập thời hạn phê duyệt.',
            expiry_setting_save_failed: 'Không thể lưu thiết lập thời hạn phê duyệt.',
            expires_on: 'Hết hạn {date}',
            expired_undecided_note: 'Đã quá thời hạn; không thể quyết định nữa.',
            already_decided: 'Yêu cầu này đã được quyết định. Danh sách đã được cập nhật để hiển thị quyết định.',
            expired_refused: 'Yêu cầu này đã quá thời hạn và không thể quyết định nữa. Danh sách đã được cập nhật.',
            title: 'Luồng phê duyệt',
            new: 'Phê duyệt mới',
            edit: 'Sửa phê duyệt',
            request_type: 'Loại yêu cầu',
            requester: 'Người yêu cầu',
            approve: 'Phê duyệt',
            reject: 'Từ chối',
            justification: 'Lý do',
            all_action_types: 'Tất cả loại hành động',
            decided_by: 'Quyết định bởi',
            no_approvals: 'Không tìm thấy phê duyệt.',
            approval_count: 'Số phê duyệt',
            approval_notes_optional: 'Ghi chú (tùy chọn)',
            approve_error: 'Không thể phê duyệt.',
            approve_request: 'Phê duyệt yêu cầu',
            decision: 'Quyết định',
            entity: 'Thực thể',
            fetch_error: 'Không thể tải phê duyệt.',
            reject_error: 'Không thể từ chối.',
            reject_request: 'Từ chối yêu cầu',
            rejection_notes_required: 'Yêu cầu ghi chú từ chối',
            rejection_notes_required_msg: 'Vui lòng cung cấp lý do từ chối.',
            requested_at: 'Yêu cầu lúc',
            decision_rules_heading: 'Cách ghi nhận quyết định',
            decision_rule_second_person: 'Yêu cầu do một người khác với người đã gửi yêu cầu quyết định. Bạn không thể phê duyệt yêu cầu của chính mình.',
            decision_rule_notes: 'Từ chối cần có lý do bằng văn bản. Phê duyệt có thể kèm ghi chú, và cả hai quyết định đều có thể đính kèm bằng chứng hỗ trợ.',
            decision_rule_scope: 'Quyết định được ghi tại đây và trong nhật ký kiểm toán quản trị. Quyết định này không tự thực hiện hành động mà yêu cầu nêu.',
            own_request_note: 'Yêu cầu của bạn. Một người khác sẽ quyết định.',
            supporting_evidence_label: 'Bằng chứng hỗ trợ (tùy chọn)',
            decision_evidence_name: 'Bằng chứng quyết định',
        },
        evidence: {
            title: 'Bằng chứng quản trị',
            new: 'Bằng chứng mới',
            link_to: 'Liên kết đến',
            entity_id_placeholder: 'Mã thực thể',
            file_path_placeholder: '/đường-dẫn/đến/tệp',
            evidence_label: 'Nhãn bằng chứng',
            file_path: 'Đường dẫn tệp',
            source_mode_label: 'Nguồn bằng chứng',
            source_mode_file: 'Tải lên tệp',
            source_mode_url: 'Liên kết URL bên ngoài',
            attachment_label: 'Tệp đính kèm',
            item_count: 'Số mục',
            link_button: 'Liên kết bằng chứng',
            confirm_delete: 'Xóa bản ghi bằng chứng này? Chỉ bản ghi và các liên kết của nó bị xóa; tệp đã tải lên hoặc địa chỉ web mà bản ghi trỏ tới được giữ nguyên. Không thể hoàn tác.',
            enter_entity_id: 'Nhập mã thực thể...',
            entity_id: 'Mã thực thể',
            entity_type: 'Loại thực thể',
            expires: 'Hết hạn',
            expires_at: 'Hết hạn lúc',
            fetch_error: 'Không thể tải bằng chứng.',
            link_error: 'Không thể liên kết bằng chứng.',
            no_evidence: 'Không tìm thấy bằng chứng.',
            tags_csv: 'Nhãn (phân cách bằng dấu phẩy)',
            uploaded: 'Đã tải lên',
            url: 'URL',
            framework_tag_heading: 'Bằng chứng gắn thẻ khung tuân thủ',
            framework_tag_note: 'Mỗi bản ghi bằng chứng ghi lại mã khung tuân thủ, người thực hiện và dấu thời gian. Lọc theo khung tuân thủ để tách riêng các bản ghi liên quan đến kiểm toán.',
            framework_code: 'Mã khung tuân thủ',
            filter_by_framework: 'Lọc theo mã khung tuân thủ...',
            actor: 'Người thực hiện',
        },
        certification: {
            not_applicable: 'Không áp dụng',
            not_certified: 'Chưa chứng nhận',
            pending: 'Chờ xử lý',
            certified: 'Đã chứng nhận',
            revoked: 'Đã thu hồi',
        },
        onboarding_pipeline: {
            title: 'Quy trình tiếp nhận',
            new_workflow: 'Quy trình tiếp nhận mới',
            vendor_id: 'Mã nhà cung cấp',
            stages: 'Giai đoạn',
            current_stage: 'Giai đoạn hiện tại',
            advance: 'Chuyển giai đoạn',
            advance_success: 'Chuyển giai đoạn thành công',
            workflow_status: 'Trạng thái quy trình',
            initiated: 'Đã khởi tạo',
            in_progress: 'Đang thực hiện',
            completed: 'Hoàn thành',
            cancelled: 'Đã hủy',
            no_workflows: 'Không tìm thấy quy trình tiếp nhận nào',
            stages_placeholder: 'Giai đoạn 1, Giai đoạn 2, Giai đoạn 3',
            assigned_to: 'Giao cho',
            notes: 'Ghi chú',
            pdpl_lifecycle_heading: 'Vòng đời nhà cung cấp PDPL — Tiếp nhận',
            due_diligence_note: 'Giai đoạn thẩm định là bắt buộc trước khi tiếp nhận bất kỳ bên xử lý nào theo PDPL. Xác minh phạm vi xử lý dữ liệu, cơ sở pháp lý và các biện pháp bảo mật.',
            contract_review_note: 'Xem xét hợp đồng phải xác nhận các điều khoản DPA, giới hạn lưu trữ dữ liệu và hạn chế bên xử lý phụ.',
            create_dpa_review_cta: 'Tạo đánh giá DPA',
            dpa_review_linked: 'Đã liên kết đánh giá DPA',
        },
        dpa_review: {
            title: 'Đánh giá DPA',
            new_review: 'Đánh giá DPA mới',
            review_type: 'Loại đánh giá',
            findings: 'Phát hiện',
            outcome: 'Kết quả',
            complete_review: 'Hoàn thành đánh giá',
            complete_success: 'Đánh giá hoàn thành thành công',
            link_assessment: 'Liên kết đánh giá bảo mật',
            link_success: 'Liên kết đánh giá thành công',
            assessment_id: 'Mã đánh giá',
            combined_title: 'Đánh giá tổng hợp',
            no_reviews: 'Không tìm thấy đánh giá DPA nào',
            telecom_disclosure_heading: 'Quản trị tiết lộ viễn thông',
            disclosure_trigger_note: 'Các đánh giá kích hoạt bởi tiết lộ ghi lại sự kiện chia sẻ dữ liệu thuê bao viễn thông theo Luật Viễn thông Việt Nam.',
            telecom_t2_note: 'Phê duyệt cấp TELECOM-T2 là bắt buộc trước khi tiết lộ dữ liệu thuê bao cho cơ quan chức năng.',
            quarterly_log_note: 'Sử dụng nhật ký quý để ghi lại tất cả sự kiện tiết lộ và duy trì dấu vết kiểm toán liên tục.',
        },
        periodic_review: {
            title: 'Đánh giá định kỳ',
            new_review: 'Đánh giá định kỳ mới',
            review_type: 'Loại đánh giá',
            due_date: 'Ngày đến hạn',
            next_review: 'Ngày đánh giá tiếp theo',
            trigger_reassessment: 'Kích hoạt đánh giá lại',
            reassessment_reason: 'Lý do đánh giá lại',
            reassessment_success: 'Đánh giá lại được kích hoạt thành công',
            complete_success: 'Đánh giá hoàn thành thành công',
            scheduled: 'Đã lên lịch',
            in_progress: 'Đang thực hiện',
            completed: 'Hoàn thành',
            overdue: 'Quá hạn',
            material_change: 'Thay đổi trọng yếu',
            no_reviews: 'Không tìm thấy đánh giá định kỳ nào',
            mark_complete: 'Đánh dấu hoàn thành',
            pdpl_periodic_heading: 'Vòng đời nhà cung cấp PDPL — Đánh giá định kỳ',
            scheduled_review_note: 'Đánh giá định kỳ phải được lên lịch ít nhất hàng năm cho tất cả bên xử lý đang hoạt động. Đánh giá quá hạn sẽ kích hoạt cảnh báo tuân thủ.',
            material_change_note: 'Các thay đổi trọng yếu trong xử lý dữ liệu yêu cầu đánh giá lại ngay lập tức bất kể lịch trình.',
            overdue_badge: 'Quá hạn',
            overdue_aria: 'Đánh giá quá hạn',
            only_overdue_filter: 'Chỉ quá hạn',
        },
        offboarding: {
            title: 'Ngừng hợp tác nhà cung cấp',
            initiate: 'Khởi tạo ngừng hợp tác',
            initiate_success: 'Khởi tạo ngừng hợp tác thành công',
            reason: 'Lý do ngừng hợp tác',
            data_return_required: 'Yêu cầu trả lại dữ liệu',
            verify_data: 'Xác minh trả lại dữ liệu',
            verify_success: 'Xác minh trả lại dữ liệu thành công',
            sign_off: 'Ký xác nhận',
            sign_off_success: 'Ký xác nhận ngừng hợp tác thành công',
            status_initiated: 'Đã khởi tạo',
            status_data_pending: 'Chờ trả lại dữ liệu',
            status_data_verified: 'Đã xác minh dữ liệu',
            status_completed: 'Hoàn thành',
            status_cancelled: 'Đã hủy',
            task_id: 'ID nhiệm vụ',
            no_tasks: 'Không tìm thấy nhiệm vụ ngừng hợp tác nào',
            evidence_id: 'Mã bằng chứng',
            pdpl_offboarding_heading: 'Vòng đời nhà cung cấp PDPL — Ngừng hợp tác & Xóa dữ liệu',
            deletion_capture_note: 'Ngừng hợp tác phải ghi lại xác nhận xóa dữ liệu từ nhà cung cấp. Xác minh việc trả lại dữ liệu trước khi ký xác nhận.',
            evidence_attachment_note: 'Đính kèm bằng chứng xóa dữ liệu (chứng chỉ, ảnh chụp màn hình, xác nhận từ nhà cung cấp) để hoàn tất hồ sơ ngừng hợp tác.',
            verify_mode_label: 'Phương thức xác minh',
            verify_mode_upload: 'Tải lên tệp mới',
            verify_mode_link: 'Liên kết bằng chứng hiện có',
            verify_mode_none: 'Không có dữ liệu cần trả lại',
            upload_data_return_evidence: 'Tải lên bằng chứng trả lại dữ liệu',
            no_data_justification_label: 'Lý do',
            no_data_justification_placeholder: 'Giải thích tại sao không có dữ liệu cần trả lại',
            no_data_justification_hint: 'Tối thiểu 20 ký tự',
            upload_required_toast: 'Đính kèm tệp để tiếp tục',
            evidence_link_required_toast: 'Chọn bằng chứng để tiếp tục',
            no_data_justification_required_toast: 'Cung cấp lý do tối thiểu 20 ký tự',
            data_return_evidence_name: 'Bằng chứng trả lại dữ liệu',
            verify_before_signoff: 'Xác minh việc hoàn trả dữ liệu trước khi ký duyệt',
        },
        dpa_review_types: {
            initial: 'Ban đầu',
            annual: 'Hàng năm',
            renewal: 'Gia hạn',
            incident_triggered: 'Do sự cố',
        },
        periodic_review_types: {
            initial: 'Ban đầu',
            annual: 'Hàng năm',
            renewal: 'Gia hạn',
            incident_triggered: 'Kích hoạt sự cố',
            material_change: 'Thay đổi trọng yếu',
            disclosure_triggered: 'Kích hoạt tiết lộ',
            quarterly_log: 'Nhật ký quý',
        },
        dpa_review_statuses: {
            pending: 'Chờ xử lý',
            in_progress: 'Đang xử lý',
            completed: 'Hoàn thành',
            cancelled: 'Đã hủy',
        },
        onboarding_stage_names: {
            due_diligence: 'Thẩm tra',
            contract_review: 'Xem xét hợp đồng',
            security_assessment: 'Đánh giá bảo mật',
            data_mapping: 'Ánh xạ dữ liệu',
            approval: 'Phê duyệt',
            integration: 'Tích hợp',
        },
        access_denied_title: 'Truy cập bị từ chối',
        access_denied: 'Bạn không có quyền xem trang này. Vui lòng liên hệ quản trị viên của bạn.',
    },
    consent: {
        nav: {
            policies: 'Chính sách',
            purposes: 'Danh mục mục đích',
            workflows: 'Luồng công việc',
            snapshots: 'Ảnh chụp CMP',
            change_awareness: 'Phát hiện thay đổi',
            audit: 'Nhật ký đồng thuận',
            evidence: 'Tài liệu chứng minh sự đồng ý',
            marketing_consent: 'Sự đồng ý nhận quảng cáo',
            marketing_suppression: 'Sổ đăng ký chặn gửi',
            marketing_suppression_enforcement: 'Thực thi chặn gửi',
            marketing_sender_name_certificates: 'Giấy chứng nhận tên định danh',
        },
        // Sprint 48.1.4 — Trang phân tích thiếu sót đồng thuận của Forseti
        gap_analysis: {
            nav_label: 'Phân tích thiếu sót',
            page_title: 'Phân tích thiếu sót đồng thuận',
            page_subtitle: 'Forseti kiểm tra các mục đích đồng thuận đang hoạt động theo các nhóm đồng thuận của khung tuân thủ đã cài đặt, và đề xuất khắc phục cho từng thiếu sót nghiêm trọng hoặc cao. Chỉ các nhóm đã cài đặt mới được phân tích.',
            framework_picker_label: 'Khung tuân thủ',
            org_flags_label: 'Bối cảnh tổ chức',
            flag_withdrawal: 'Đã có cơ chế rút đồng thuận trên toàn tổ chức',
            flag_parental: 'Đã có luồng đồng thuận của cha mẹ cho người dưới 16 tuổi',
            flag_cross_border: 'Đã có hồ sơ chuyển dữ liệu cá nhân xuyên biên giới',
            run_label: 'Chạy phân tích thiếu sót',
            running_label: 'Đang chạy…',
            requires_advisor_label: 'Cần có quyền trò chuyện với Forseti để chạy phân tích.',
            results_heading: 'Thiếu sót được phát hiện ({count})',
            tokens_label: '≈ {count} token',
            empty_label: 'Không phát hiện thiếu sót nào cho các nhóm đã được phân tích.',
            remediation_label: 'Đề xuất khắc phục:',
            dismiss_label: 'Bỏ qua (không áp dụng)',
            resolve_label: 'Đã giải quyết',
            dismissed_label: 'Đã bỏ qua (không áp dụng)',
            resolved_label: 'Đã giải quyết',
            // Sprint 62.27.0 gate E12.5 pass 2 — xem en.ts.
            families_loading: 'Đang đọc các khung tuân thủ đã cài đặt…',
            families_load_error: 'Không đọc được các khung tuân thủ đã cài đặt, nên chưa thể đưa nhóm nào vào phân tích.',
            families_retry_subject: 'các khung tuân thủ đã cài đặt',
            families_none: 'Không khung tuân thủ đã cài đặt nào thuộc nhóm mà phân tích này đọc, nên không có gì để phân tích.',
            family_instruments: 'Đã cài đặt: {codes}',
            analysed_label: 'Đã phân tích: {families}',
            not_analysed_label: 'Chưa cài đặt nên không được phân tích: {families}',
            nothing_analysed: 'Không có gì được phân tích: không nhóm nào đã chọn được cài đặt, nên không thể báo cáo thiếu sót nào.',
            acknowledged_count_label: '{count} phát hiện đã được xác nhận, không tính là thiếu sót còn mở',
            run_failed: 'Không thể chạy phân tích thiếu sót.',
            triage_failed: 'Không thể ghi nhận quyết định.',
            purpose_scope: 'Mục đích xử lý dữ liệu cá nhân: {name}',
            org_wide_scope: 'Toàn tổ chức',
            attributes: {
                legal_basis_set: 'Đã ghi nhận căn cứ pháp luật áp dụng',
                withdrawal_mechanism: 'Cơ chế rút đồng thuận',
                granular_per_purpose: 'Đồng thuận tách riêng theo từng mục đích',
                parental_consent_for_minors: 'Đồng thuận đối với trẻ em',
                cross_border_filing: 'Hồ sơ chuyển dữ liệu cá nhân xuyên biên giới',
                retention_period: 'Thời hạn lưu trữ dữ liệu cá nhân',
                sensitive_data_ground_review: 'Rà soát điều kiện xử lý dữ liệu cá nhân nhạy cảm',
            },
            acknowledge_label: 'Xác nhận đã rà soát',
            acknowledge_title: 'Xác nhận rà soát điều kiện xử lý dữ liệu cá nhân nhạy cảm',
            acknowledge_description: 'Mục đích xử lý dữ liệu cá nhân: {name}. Ghi nhận rằng bạn đã rà soát khung tuân thủ đã cài đặt có đặt ra điều kiện nào đối với việc xử lý dữ liệu cá nhân nhạy cảm cho mục đích này ngoài căn cứ pháp luật áp dụng hay không và, nếu có, điều kiện nào. Các lần phân tích sau sẽ hiển thị phát hiện này là đã xác nhận cho đến khi mức độ nhạy cảm hoặc căn cứ đã ghi nhận của mục đích thay đổi, hoặc khi một nhóm khung tuân thủ chưa được rà soát được cài đặt.',
            acknowledge_note_label: 'Ghi chú (bắt buộc)',
            acknowledge_note_hint: 'Nội dung bạn đã rà soát, và mục đích có ghi nhận điều kiện nào hay không và, nếu có, là điều kiện nào, cùng điều khoản của điều kiện đó.',
            acknowledge_submit: 'Xác nhận',
            acknowledge_done: 'Đã xác nhận rà soát',
            acknowledge_failed: 'Không thể ghi nhận việc xác nhận.',
            acknowledged_by: 'Đã được {name} xác nhận lúc {date}: {note}',
            acknowledgement_lapsed: 'Xác nhận của {name} lúc {date} đã hết hiệu lực vì {reasons}.',
            lapse_sensitivity_changed: 'mức độ nhạy cảm của mục đích đã thay đổi',
            lapse_basis_changed: 'căn cứ đã ghi nhận đã thay đổi',
            lapse_family_added: 'đã cài đặt nhóm chưa được rà soát: {families}',
            lapse_reason_joiner: ' và ',
        },
        import: {
            title: 'Nhập luồng công việc đồng thuận',
            nav_title: 'Nhập hàng loạt',
            description: 'Tải lên tệp CSV để nhập hàng loạt các luồng công việc đồng thuận.',
            select_file: 'Chọn tệp CSV',
            file_help: 'CSV với tiêu đề khớp các trường luồng công việc.',
            column_count_help: 'Hàng có số giá trị khác với số cột trong hàng tiêu đề sẽ không được nhập và được liệt kê trong mục Lỗi kèm số hàng.',
            required_columns_help: 'Các cột bắt buộc: Loại quy trình, Chủ thể dữ liệu, Kênh.',
            file_too_large: 'Tệp quá lớn. Kích thước tối đa là 2MB.',
            preview: 'Xem trước',
            columns_detected: 'Số cột phát hiện: {count}',
            column_mapping: 'Ánh xạ cột',
            import_button: 'Nhập',
            import_complete: 'Nhập hoàn tất',
            import_error: 'Nhập thất bại',
            result: 'Kết quả nhập',
            total: 'Tổng cộng',
            imported: 'Đã nhập',
            skipped: 'Bỏ qua',
            failed: 'Thất bại',
            errors: 'Lỗi',
            error_row: 'Hàng',
            error_field: 'Trường',
            error_message: 'Thông báo',
            history: 'Lịch sử nhập',
            no_history: 'Chưa có lịch sử nhập.',
            history_file: 'Tên tệp',
            history_date: 'Ngày',
            create_profiles_label: 'Tạo hồ sơ Chủ thể dữ liệu cho các chủ thể mới',
            create_profiles_help: 'Các mục nhập không có hồ sơ khớp sẽ tự động tạo hồ sơ mới. Bỏ chọn để chỉ nhập luồng công việc.',
            profiles_created: 'Hồ sơ đã tạo',
            profiles_matched: 'Hồ sơ đã khớp',
            subject_kind_help: 'Cột tùy chọn: subject_kind, subject_email, subject_display_name, subject_phone, external_ref_key.',
            error_subject_invalid_email: 'Email không hợp lệ trong cột subject_email.',
            error_subject_unknown_kind: 'Giá trị subject_kind không hợp lệ. Mong đợi: email, visitor_uuid, employee_id, student_id, external_ref.',
            error_missing_external_ref_key: 'Yêu cầu external_ref_key khi subject_kind=external_ref',
        },
        policies: {
            title: 'Chính sách đồng thuận',
            new: 'Chính sách mới',
            edit: 'Sửa chính sách',
            name: 'Tên',
            version: 'Phiên bản',
            policy_text: 'Nội dung chính sách',
            publish: 'Xuất bản',
            versions: 'Các phiên bản',
            hide_versions: 'Ẩn phiên bản',
            submit_for_review: 'Gửi để duyệt',
            suspend: 'Tạm ngừng',
            retire: 'Ngừng sử dụng',
            jurisdictions: 'Phạm vi tài phán',
            jurisdictions_csv: 'Phạm vi tài phán (phân cách bằng dấu phẩy)',
            approval_mode: 'Chế độ phê duyệt',
            reviewer_ids: 'Mã người duyệt (phân cách bằng dấu phẩy)',
            tags_csv: 'Nhãn (phân cách bằng dấu phẩy)',
            effective_date: 'Ngày hiệu lực',
            review_date: 'Ngày xem xét',
            consent_model_statement: 'Tuyên bố mô hình đồng thuận',
            consent_model_placeholder: 'Tuyên bố mô hình đồng thuận tùy chọn...',
            default_settings: 'Cài đặt mặc định (JSON)',
            changes: 'Thay đổi',
            fetch_error: 'Không thể tải chính sách đồng thuận. Vui lòng thử lại.',
            save_error: 'Không thể lưu chính sách đồng thuận. Vui lòng thử lại.',
            submit_review_error: 'Không thể gửi chính sách để duyệt. Vui lòng thử lại.',
            activate_error: 'Không thể kích hoạt chính sách. Vui lòng thử lại.',
            suspend_error: 'Không thể tạm ngừng chính sách. Vui lòng thử lại.',
            retire_error: 'Không thể ngừng sử dụng chính sách. Vui lòng thử lại.',
            submit_review_success: 'Chính sách đã được gửi để xem xét.',
            activate_success: 'Chính sách đã được kích hoạt.',
            suspend_success: 'Chính sách đã bị tạm ngừng.',
            retire_success: 'Chính sách đã được ngừng sử dụng.',
            versions_error: 'Không thể tải các phiên bản chính sách. Vui lòng thử lại.',
            invalid_json: 'JSON không hợp lệ trong trường Cài đặt mặc định. Vui lòng thử lại.',
            json_format: 'Định dạng JSON',
            version_initial: 'Phiên bản ban đầu',
            version_updated: 'Đã cập nhật',
            sensitive: 'Nhạy cảm',
            flag_sensitive: 'Đánh dấu nhạy cảm',
            flag_sensitive_title: 'Đánh dấu chính sách là nhạy cảm',
            require_enhanced_review: 'Yêu cầu xem xét nâng cao',
            enhanced_review_success: 'Đã bật yêu cầu xem xét nâng cao.',
            return_to_draft: 'Trả về bản nháp',
            return_to_draft_hint: 'Kết thúc vòng xem xét này và cho phép sửa lại chính sách',
            return_to_draft_title: 'Trả chính sách về bản nháp',
            return_to_draft_body: 'Các quyết định đã ghi nhận trong vòng xem xét này được lưu trong lịch sử phê duyệt của chính sách. Chính sách trở thành bản nháp để được sửa và gửi xem xét lại.',
            return_to_draft_reason: 'Lý do (bắt buộc)',
            return_to_draft_reason_required: 'Nhập lý do trả chính sách này về bản nháp.',
            return_to_draft_success: 'Đã trả chính sách về bản nháp.',
            return_to_draft_error: 'Không thể trả chính sách về bản nháp.',
            in_review_locked_note: 'Đang xem xét: không thể sửa chính sách, đánh dấu nhạy cảm hoặc chuyển sang xem xét nâng cao. Hãy trả chính sách về bản nháp để thay đổi.',
            refusal_policy_in_review: 'Chính sách này đang được xem xét và không thể thay đổi. Hãy trả chính sách về bản nháp để thay đổi.',
            refusal_policy_not_in_review: 'Chính sách này không còn ở trạng thái đang xem xét. Danh sách đã được cập nhật.',
            refusal_policy_changed_concurrently: 'Chính sách đã thay đổi trong khi đang lưu. Danh sách đã được cập nhật; hãy kiểm tra chính sách và thử lại.',
            refusal_not_a_named_reviewer: 'Chỉ những người đánh giá được nêu tên trong chính sách này mới có thể quyết định chính sách.',
            select_categories: 'Chọn các danh mục dữ liệu nhạy cảm theo Điều 2 PDPL áp dụng:',
            page_title: 'Chính sách đồng thuận',
            no_policies: 'Không tìm thấy chính sách đồng thuận nào. Tạo chính sách đầu tiên để bắt đầu.',
            approval_success: 'Chính sách đã được phê duyệt.',
            reviewers_label: 'Người đánh giá',
            // Sprint 28.1.3 — Enhanced Review Workflow
            enhanced_review_title: 'Yêu cầu xem xét nâng cao',
            enhanced_review_badge: 'Yêu cầu xem xét nâng cao',
            enhanced_review_status_pending: 'Chờ xem xét',
            enhanced_review_status_approved: 'Đã phê duyệt xem xét',
            enhanced_review_status_rejected: 'Đã từ chối xem xét',
            enhanced_review_reviewed_by: 'Được xem xét bởi',
            enhanced_review_notes: 'Ghi chú xem xét',
            enhanced_review_approve: 'Phê duyệt xem xét',
            enhanced_review_reject: 'Từ chối xem xét',
            enhanced_review_notes_required: 'Ghi chú xem xét là bắt buộc',
            enhanced_review_approved: 'Xem xét nâng cao đã được phê duyệt',
            enhanced_review_rejected: 'Xem xét nâng cao bị từ chối — chính sách được đặt lại về bản nháp',
            enhanced_review_reset_to_draft: 'Xem xét nâng cao bị từ chối — chính sách được đặt lại về bản nháp',
            enhanced_review_reject_warning: 'Việc từ chối sẽ đặt lại chính sách này về trạng thái Bản nháp. DPO phải gửi lại để xem xét sau khi giải quyết các vấn đề.',
            submitted_modal_title: 'Đã gửi để xem xét nâng cao',
            submitted_modal_body: 'Chính sách này đã được gửi. Người đánh giá Pháp lý/Quyền riêng tư phải phê duyệt trước khi có thể kích hoạt.',
            activate_hint: 'Cho chính sách này có hiệu lực',
            approval_comments: 'Ý kiến (tùy chọn)',
            approve_title: 'Phê duyệt chính sách',
            flag_sensitive_hint: 'Đánh dấu là có liên quan tới dữ liệu nhạy cảm',
            reactivate_hint: 'Khôi phục chính sách đang tạm ngừng này',
            reject_hint: 'Từ chối chính sách này và trả về bản nháp',
            reject_title: 'Từ chối chính sách',
            rejection_reason: 'Lý do từ chối (bắt buộc)',
            rejection_success: 'Đã từ chối chính sách',
            require_enhanced_review_hint: 'Chuyển tới người rà soát cấp hai',
            retire_hint: 'Ngừng sử dụng vĩnh viễn chính sách này',
            review_context_description: 'Xác nhận phạm vi chính sách và các kiểm soát rà soát trước khi lưu.',
            review_context_hint: 'Người rà soát, phạm vi tài phán, ngày tháng và mặc định về sự đồng ý quyết định cách chính sách này được quản trị.',
            review_context_title: 'Bối cảnh rà soát',
            sensitive_filter: 'Nhạy cảm',
            suspend_hint: 'Tạm dừng chính sách này',
            suspend_reason_label: 'Lý do tạm ngừng (bắt buộc)',
            suspend_title: 'Tạm ngừng chính sách',
            type_content_edit: 'Sửa nội dung',
            type_status_change: 'Đổi trạng thái',
            reactivate: 'Kích hoạt lại',
            no_versions: 'Chưa có lịch sử phiên bản.',
            approval_mode_hint: 'Tất cả: mọi người phê duyệt được nêu tên phải phê duyệt, và chỉ người được nêu tên mới được quyết định. Bất kỳ: một lần phê duyệt là đủ. Trong cả hai trường hợp, một lần từ chối sẽ từ chối chính sách.',
            refusal_use_enhanced_review: 'Chính sách này được chuyển sang xem xét nâng cao, nên được quyết định ở đó, không qua phê duyệt thông thường. Danh sách đã được cập nhật.',
            refusal_reviewer_cannot_decide_named: 'Những người đánh giá được nêu tên sau đây sẽ không bao giờ quyết định được chính sách này: {names}. Mỗi người đánh giá được nêu tên phải là thành viên đang hoạt động của tổ chức và có quyền phê duyệt chính sách đồng thuận, hoặc, với chính sách được chuyển sang xem xét nâng cao, quyền thực hiện xem xét nâng cao.',
            refusal_reviewer_cannot_decide_none: 'Chính sách này chưa nêu tên người đánh giá nào, trong khi mọi người đánh giá được nêu tên đều phải phê duyệt. Hãy nêu tên ít nhất một người đánh giá trước khi gửi.',
            refusal_invalid_status_transition: 'Chính sách này không còn ở trạng thái cho phép thao tác này. Danh sách đã được cập nhật.',
            approval_waiting: 'Đã ghi nhận phê duyệt của bạn. Chính sách được phê duyệt khi thêm {count} người đánh giá được nêu tên phê duyệt.',
            enhanced_review_waiting: 'Đã ghi nhận phê duyệt xem xét nâng cao của bạn. Chính sách được phê duyệt khi thêm {count} người đánh giá được nêu tên phê duyệt.',
            decision_recorded_in_review: 'Đã ghi nhận quyết định của bạn. Chính sách vẫn đang được xem xét.',
            decision_recorded: 'Đã ghi nhận quyết định của bạn.',
            review_history: 'Lịch sử xem xét',
            review_history_current: 'Các quyết định trong vòng xem xét hiện tại',
            review_history_earlier: 'Các vòng xem xét trước',
            review_history_empty: 'Chưa có quyết định xem xét nào được ghi nhận cho chính sách này.',
            history_col_reviewer: 'Người đánh giá',
            history_col_decision: 'Quyết định',
            history_col_review_kind: 'Hình thức xem xét',
            history_col_decided_at: 'Thời điểm quyết định',
            history_col_notes: 'Ghi chú',
            history_kind_standard: 'Phê duyệt thông thường',
            history_kind_enhanced: 'Xem xét nâng cao',
            history_decision_approved: 'Đã phê duyệt',
            history_decision_rejected: 'Đã từ chối',
            history_col_ended_at: 'Thời điểm kết thúc vòng',
            history_col_outcome: 'Cách kết thúc',
            history_col_ended_by: 'Người kết thúc',
            history_col_reason: 'Lý do',
            history_col_round_decisions: 'Các quyết định trong vòng',
            history_ended_resubmitted: 'Gửi xem xét lại',
            history_ended_returned: 'Trả về bản nháp',
            history_no_decisions: 'Không có quyết định nào được ghi nhận',
            history_decision_by: '{decision} bởi {name}',
        },
        sensitive_categories: {
            health: 'Dữ liệu sức khỏe',
            biometric: 'Dữ liệu sinh trắc học',
            political: 'Quan điểm chính trị',
            ethnic: 'Nguồn gốc dân tộc',
            genetic: 'Dữ liệu di truyền',
            criminal: 'Hồ sơ tội phạm',
        },
        purposes: {
            title: 'Danh mục mục đích',
            new: 'Mục đích mới',
            edit: 'Sửa mục đích',
            name: 'Tên',
            legal_basis: 'Cơ sở pháp lý',
            retention_days: 'Thời gian lưu trữ (ngày)',
            is_active: 'Đang hoạt động',
            filter_by_category: 'Lọc theo danh mục',
            policy_ids: 'Mã chính sách (phân cách bằng dấu phẩy)',
            ropa_activity_ids: 'Mã hoạt động ROPA (phân cách bằng dấu phẩy)',
            policies: 'Chính sách',
            deprecate: 'Ngừng hỗ trợ',
            fetch_error: 'Không thể tải danh mục mục đích. Vui lòng thử lại.',
            save_error: 'Không thể lưu mục đích đồng thuận. Vui lòng thử lại.',
            deprecate_error: 'Không thể ngừng hỗ trợ mục đích đồng thuận. Vui lòng thử lại.',
            page_title: 'Danh mục mục đích',
            no_purposes: 'Không tìm thấy mục đích đồng thuận nào. Tạo mục đích đầu tiên để bắt đầu.',
            category_personal_data: 'Dữ liệu cá nhân',
            category_sensitive_data: 'Dữ liệu nhạy cảm',
            category_health_data: 'Dữ liệu sức khỏe',
            category_financial_data: 'Dữ liệu tài chính',
            category_biometric_data: 'Dữ liệu sinh trắc học',
            category_children_data: 'Dữ liệu trẻ em',
            category_location_data: 'Dữ liệu vị trí',
            category_communications_data: 'Dữ liệu truyền thông',
            category_other: 'Khác',
        },
        workflows: {
            title: 'Luồng công việc đồng thuận',
            new: 'Luồng mới',
            edit: 'Sửa luồng',
            workflow_type: 'Loại luồng',
            user_id: 'Mã người dùng',
            purpose_id: 'Mã mục đích',
            purpose_ids_csv: 'Mã mục đích (phân cách bằng dấu phẩy)',
            reason: 'Lý do',
            process: 'Xử lý',
            data_subject_ref: 'Tham chiếu chủ thể dữ liệu',
            data_subject: 'Chủ thể dữ liệu',
            channel: 'Kênh',
            policy_id: 'Mã chính sách',
            scope: 'Phạm vi',
            legal_grounds: 'Căn cứ pháp lý',
            assessment: 'Đánh giá',
            select_outcome: 'Chọn kết quả',
            partially_approved: 'Duyệt một phần',
            denied: 'Từ chối',
            outcome_upheld: 'Duy trì',
            outcome_pending: 'Chờ xử lý',
            outcome_denied: 'Từ chối',
            status_count: 'Số lượng theo trạng thái',
            channel_filter: 'Lọc theo kênh',
            add_action: '+ Hành động',
            by_type: 'Theo loại',
            by_status: 'Theo trạng thái',
            downstream_actions: 'Hành động tiếp theo',
            downstream_actions_for: 'Hành động tiếp theo cho {subject} ({type})',
            add_downstream_action: 'Thêm hành động tiếp theo',
            assigned_to: 'Phân công cho',
            fetch_error: 'Không thể tải luồng công việc đồng thuận. Vui lòng thử lại.',
            dashboard_error: 'Không thể tải tổng quan luồng công việc. Vui lòng thử lại.',
            save_error: 'Không thể lưu luồng công việc đồng thuận. Vui lòng thử lại.',
            status_update_error: 'Không thể cập nhật trạng thái luồng công việc. Vui lòng thử lại.',
            assessment_error: 'Không thể cập nhật đánh giá luồng công việc. Vui lòng thử lại.',
            add_action_error: 'Không thể thêm hành động luồng công việc. Vui lòng thử lại.',
            update_action_error: 'Không thể cập nhật hành động luồng công việc. Vui lòng thử lại.',
            type_refusal: 'Từ chối',
            type_withdrawal: 'Rút lại',
            type_restriction: 'Hạn chế',
            type_objection: 'Phản đối',
            status_received: 'Đã nhận',
            status_processing: 'Đang xử lý',
            status_under_assessment: 'Đang đánh giá',
            status_implemented: 'Đã thực hiện',
            // Sprint 41.8.0 I1 — workflow evidence attachments
            evidence_button: 'Bằng chứng',
            evidence_modal_title: 'Bằng chứng quy trình',
            no_evidence: 'Chưa có bằng chứng đính kèm cho quy trình này.',
            upload_evidence_label: 'Tải lên bằng chứng quy trình',
            completed_at: 'Hoàn thành lúc',
            effective_date: 'Ngày hiệu lực',
            page_title: 'Luồng công việc đồng thuận',
            no_workflows: 'Không tìm thấy quy trình đồng thuận nào. Quy trình được tạo khi chủ thể dữ liệu thực hiện quyền của họ.',
            type_grant: 'Cấp',
            propagation_none: 'Không có',
            propagation_pending: 'Chờ xử lý',
            propagation_completed: 'Hoàn thành',
            propagation_partial: 'Một phần',
            propagation_incomplete_error: 'Không thể hoàn thành luồng công việc khi lan truyền rút lại đồng thuận vẫn đang chờ xử lý',
            propagation_pending_warning: 'Không thể hoàn thành — việc lan truyền rút lại vẫn đang chờ xử lý',
            propagation_status: 'Trạng thái lan truyền',
        },
        snapshots: {
            title: 'Ảnh chụp CMP',
            new: 'Ảnh chụp mới',
            label: 'Nhãn',
            snapshot_date: 'Ngày chụp',
            purposes_count: 'Số mục đích',
            compare: 'So sánh',
            snapshot_data: 'Dữ liệu ảnh chụp (JSON)',
            select_left: 'Chọn ảnh chụp bên trái',
            select_right: 'Chọn ảnh chụp bên phải',
            comparison_results: 'Kết quả so sánh',
            field: 'Trường',
            left: 'Trái',
            right: 'Phải',
            close_comparison: 'Đóng so sánh',
            trigger: 'Kích hoạt',
            trigger_manual: 'Thủ công',
            trigger_policy_approval: 'Phê duyệt chính sách',
            cmp_version: 'Phiên bản CMP',
            policy_version_id: 'Mã phiên bản chính sách',
            banner_config: 'Cấu hình banner (JSON)',
            active_purposes: 'Mục đích đang hoạt động (JSON)',
            active_legal_bases: 'Cơ sở pháp lý đang hoạt động (JSON)',
            domain_scope: 'Phạm vi tên miền',
            domain_scope_csv: 'Phạm vi tên miền (phân cách bằng dấu phẩy)',
            raw_config: 'Cấu hình gốc (JSON)',
            checksum: 'Mã kiểm tra',
            created: 'Ngày tạo',
            fetch_error: 'Không thể tải ảnh chụp CMP. Vui lòng thử lại.',
            save_error: 'Không thể lưu ảnh chụp CMP. Vui lòng thử lại.',
            compare_error: 'Không thể so sánh ảnh chụp. Vui lòng thử lại.',
            changed_field: 'Trường đã thay đổi: ',
            json_array_format: 'Định dạng mảng JSON',
            manual_snapshot_note: 'Chỉ dành cho quản trị viên/nhà phát triển. Trong vận hành bình thường, ảnh chụp được tạo tự động qua webhook CMP hoặc khi phê duyệt chính sách. Dán JSON xuất trực tiếp từ nhà cung cấp CMP của bạn (ví dụ: OneTrust, Cookiebot).',
            banner_config_hint: 'Dán đối tượng cấu hình banner từ bản xuất CMP của bạn.',
            active_purposes_hint: 'Mảng JSON các đối tượng mục đích đang hoạt động từ bản xuất CMP.',
            active_legal_bases_hint: 'Mảng JSON các đối tượng cơ sở pháp lý đang hoạt động từ bản xuất CMP.',
            raw_config_hint: 'JSON cấu hình thô đầy đủ từ CMP. Các trường JSON khác được trích xuất từ đây. Mã kiểm tra SHA-256 được tính tự động.',
            json_format: 'Định dạng JSON',
            page_title: 'Ảnh chụp đồng thuận',
            no_snapshots: 'Không tìm thấy ảnh chụp CMP nào. Ảnh chụp được tạo khi chính sách được phê duyệt hoặc được kích hoạt thủ công.',
            detail_title: 'Chi tiết ảnh chụp',
            view_snapshot_detail: 'Xem chi tiết ảnh chụp',
            policy_version: 'Phiên bản chính sách',
            removed: 'Trước',
            added: 'Sau',
        },
        change_awareness: {
            title: 'Phát hiện thay đổi đồng thuận',
            change_type: 'Loại thay đổi',
            entity_type: 'Loại thực thể',
            entity_id: 'Mã thực thể',
            detected_at: 'Phát hiện lúc',
            acknowledge: 'Xác nhận',
            new_alert: 'Cảnh báo mới',
            new_alert_form: 'Cảnh báo thay đổi đồng thuận mới',
            total_open: 'Tổng số mở',
            by_severity: 'Theo mức độ',
            snapshot_id: 'Mã ảnh chụp',
            update_status: 'Cập nhật trạng thái',
            resolution_notes: 'Ghi chú giải quyết',
            resolution_required: 'Ghi chú giải quyết (bắt buộc)',
            resolution_required_msg: 'Ghi chú giải quyết là bắt buộc khi giải quyết mục.',
            status_open: 'Mở',
            status_under_review: 'Đang xem xét',
            status_resolved: 'Đã giải quyết',
            status_accepted: 'Đã chấp nhận',
            severity_informational: 'Thông tin',
            severity_requires_review: 'Cần xem xét',
            severity_policy_violation: 'Vi phạm chính sách',
            fetch_error: 'Không thể tải mục phát hiện thay đổi. Vui lòng thử lại.',
            dashboard_error: 'Không thể tải tổng quan phát hiện thay đổi. Vui lòng thử lại.',
            create_reconciliation: 'Tạo tác vụ đối chiếu',
            reconciliation_created: 'Tác vụ đối chiếu đã được tạo thành công.',
            reconciliation_error: 'Không thể tạo tác vụ đối chiếu. Vui lòng thử lại.',
            create_error: 'Không thể tạo mục phát hiện thay đổi. Vui lòng thử lại.',
            status_update_error: 'Không thể cập nhật trạng thái phát hiện thay đổi. Vui lòng thử lại.',
            page_title: 'Nhận biết thay đổi',
            no_items: 'Không tìm thấy mục nhận biết thay đổi nào. Các mục được tạo khi phát hiện thay đổi cấu hình đồng thuận.',
            affected_policies: 'Chính sách bị ảnh hưởng',
            affected_purposes: 'Mục đích bị ảnh hưởng',
            estimated_affected_subjects: 'Số chủ thể dữ liệu bị ảnh hưởng ước tính',
            impact_scope: 'Phạm vi tác động',
            affected_policies_short: 'Chính sách',
            affected_purposes_short: 'Mục đích',
            affected_subjects_short: 'Chủ thể dữ liệu',
        },
        audit: {
            title: 'Nhật ký đồng thuận',
            event_type: 'Loại sự kiện',
            user_id: 'Mã người dùng',
            timestamp: 'Thời gian',
            details: 'Chi tiết',
            actor: 'Tác nhân',
            filter_by_entity_type: 'Lọc theo loại thực thể',
            filter_by_action: 'Lọc theo hành động',
            fetch_error: 'Không thể tải nhật ký đồng thuận. Vui lòng thử lại.',
            page_title: 'Nhật ký đồng thuận',
            export_csv: 'Xuất CSV',
            exporting: 'Đang xuất\u2026',
            export_success: 'Đã xuất nhật ký kiểm toán thành công.',
            export_error: 'Không thể xuất nhật ký kiểm toán đồng thuận. Vui lòng thử lại.',
            no_entries: 'Không tìm thấy mục kiểm toán nào. Sự kiện kiểm toán được ghi tự động khi dữ liệu đồng thuận thay đổi.',
            entity_policy: 'Chính sách',
            entity_purpose: 'Mục đích',
            entity_workflow: 'Quy trình',
            entity_consent_record: 'Bản ghi đồng thuận',
            entity_change_awareness: 'Nhận thức thay đổi',
            entity_cmp_snapshot: 'Ảnh chụp CMP',
            action_created: 'Đã tạo',
            action_updated: 'Đã cập nhật',
            action_status_changed: 'Đã thay đổi trạng thái',
            action_drift_detected: 'Phát hiện trôi dạt',
            action_snapshot_created: 'Đã tạo ảnh chụp',
            action_approval_submitted: 'Đã gửi phê duyệt',
            action_archived: 'Đã lưu trữ',
            action_purpose_auto_mapped: 'Tự động ánh xạ mục đích',
            action_purpose_mapping_updated: 'Đã cập nhật ánh xạ mục đích',
            action_webhook_configured: 'Đã cấu hình webhook',
            entity_propagation: 'Lan truyền',
            entity_reconciliation: 'Đối chiếu',
            entity_marketing_consent: 'Sự đồng ý nhận quảng cáo',
            entity_marketing_suppression: 'Chặn gửi quảng cáo',
            entity_marketing_suppression_enforcement: 'Lần đối soát chặn gửi',
            action_propagation_confirmed: 'Đã xác nhận lan truyền',
            action_propagation_failed: 'Lan truyền thất bại',
            action_consent_captured: 'Đã thu thập đồng thuận',
            action_reconciliation_created: 'Đã tạo đối chiếu',
            action_reconciliation_resolved: 'Đã giải quyết đối chiếu',
            action_submitted_for_review: 'Đã gửi để xem xét',
            action_activated: 'Đã kích hoạt',
            action_suspended: 'Đã tạm ngừng',
            action_retired: 'Đã ngừng sử dụng',
            action_enhanced_review_required: 'Yêu cầu xem xét nâng cao',
            action_enhanced_review_approved: 'Xem xét nâng cao đã được phê duyệt',
            action_enhanced_review_rejected: 'Xem xét nâng cao bị từ chối — chính sách được đặt lại về bản nháp',
            action_consented: 'Đã đồng ý',
            action_consented_customize: 'Đã đồng ý có tuỳ chỉnh',
            action_revoked: 'Đã thu hồi',
            action_rejected: 'Đã từ chối',
        },
        web_records: {
            title: 'Bản ghi đồng thuận web',
            page_title: 'Bản ghi đồng thuận web',
            domain: 'Tên miền',
            visitor_id: 'ID khách truy cập',
            consent_action: 'Hành động đồng thuận',
            received_at: 'Thời điểm tiếp nhận',
            admin_status: 'Trạng thái quản trị',
            revoke: 'Thu hồi',
            reject: 'Từ chối',
            reason: 'Lý do',
            reason_placeholder: 'Lý do cho thao tác này (tùy chọn)',
            revoke_confirm: 'Thu hồi bản ghi đồng thuận này?',
            reject_confirm: 'Từ chối bản ghi đồng thuận này?',
            override_success: 'Đã cập nhật trạng thái bản ghi thành công.',
            override_error: 'Không thể cập nhật trạng thái bản ghi.',
            no_records: 'Không tìm thấy bản ghi đồng thuận web nào.',
            fetch_error: 'Không thể tải bản ghi đồng thuận web.',
            filter_by_domain: 'Lọc theo tên miền',
            filter_by_action: 'Lọc theo hành động',
            active: 'Đang hoạt động',
        },
        legal_bases: {
            all: 'Tất cả cơ sở pháp lý',
        },
        common_statuses: {
            suspended: 'Tạm ngừng',
            retired: 'Đã ngừng sử dụng',
            deprecated: 'Ngừng hỗ trợ',
        },
        approval_modes: {
            all: 'Tất cả',
            any: 'Bất kỳ',
        },
        cmp_integration: {
            title: 'Tích hợp AesirX CMP',
            back_to_consent: 'Quay lại đồng thuận',
            back_to_integration: 'Quay lại tích hợp',
            webhook_status: 'Trạng thái Webhook',
            events_received: 'Sự kiện đã nhận',
            web_consent_records: 'Bản ghi đồng thuận web',
            unmapped_purposes: 'Mục đích chưa ánh xạ',
            integration_management: 'Quản lý tích hợp',
            webhook_configuration: 'Cấu hình Webhook',
            webhook_config_desc: 'Cấu hình điểm cuối webhook CMP và quản lý bí mật HMAC.',
            purpose_mapping: 'Ánh xạ mục đích',
            purpose_mapping_desc: 'Ánh xạ mã mục đích CMP sang mục đích GRC.',
            bulk_sync: 'Đồng bộ hàng loạt',
            bulk_sync_desc: 'Áp dụng lại ánh xạ mục đích cho tất cả bản ghi đồng thuận chưa được ánh xạ.',
            consent_analytics: 'Phân tích đồng thuận web (30 ngày gần nhất)',
            consent_grant_rate: 'Tỷ lệ cấp đồng thuận',
            top_domain: 'Tên miền hàng đầu',
            records: 'bản ghi',
            banner_interactions: 'Tương tác banner',
            consent_actions: 'Hành động đồng ý',
            opt_in_trend: 'Xu hướng đồng ý/từ chối',
            records_by_domain: 'Bản ghi theo tên miền',
            date: 'Ngày',
            grants: 'Đồng ý',
            denials: 'Từ chối',
            not_configured: 'Chưa cấu hình',
            load_error: 'Không thể tải dữ liệu tích hợp',
            webhook_not_configured: 'Webhook chưa được cấu hình.',
            webhook_not_configured_msg: 'Vui lòng {link} trước.',
            configure_webhook_link: 'cấu hình webhook',
            setup_wizard: 'Trình hướng dẫn cài đặt',
            step_configure_webhook: 'Cấu hình Webhook',
            step_map_purposes: 'Ánh xạ mục đích',
            step_run_sync: 'Chạy đồng bộ hàng loạt ban đầu',
            step_verify_data: 'Xác minh dữ liệu trong tổng quan',
            configure: 'Cấu hình',
            view_dashboard: 'Xem tổng quan',
            syncing: 'Đang đồng bộ...',
            sync_now: 'Đồng bộ ngay',
            sync_completed: 'Đồng bộ hoàn tất: {imported} đã nhập, {skipped} bỏ qua, {failed} thất bại.',
            sync_failed: 'Đồng bộ thất bại',
            last_sync_result: 'Kết quả đồng bộ cuối',
            imported: 'Đã nhập',
            skipped: 'Bỏ qua',
            errors: 'Lỗi',
            index: 'Chỉ mục',
            error: 'Lỗi',
            sync_history: 'Lịch sử đồng bộ',
            no_sync_jobs: 'Chưa có công việc đồng bộ nào.',
            load_sync_error: 'Không thể tải dữ liệu đồng bộ',
            purpose_mapping_title: 'Ánh xạ mục đích CMP',
            auto_mapping: 'Đang tự động ánh xạ...',
            auto_map_purposes: 'Tự động ánh xạ mục đích',
            unmapped_warning: '{count} mục đích chưa ánh xạ -- các mục đích CMP này cần được ánh xạ sang mục đích GRC.',
            mapping_saved: 'Đã lưu ánh xạ.',
            mapping_deleted: 'Đã xóa ánh xạ.',
            auto_map_complete: 'Tự động ánh xạ hoàn tất: {mapped} đã ánh xạ, {unmatched} chưa khớp.',
            auto_map_failed: 'Tự động ánh xạ thất bại',
            save_mapping_error: 'Không thể lưu ánh xạ',
            delete_mapping_error: 'Không thể xóa ánh xạ',
            load_data_error: 'Không thể tải dữ liệu',
            cmp_purpose: 'Mục đích CMP',
            grc_purpose: 'Mục đích GRC',
            select_grc_purpose: '-- Chọn mục đích GRC --',
            auto_mapped: 'Tự động ánh xạ',
            mapped: 'Đã ánh xạ',
            unmapped: 'Chưa ánh xạ',
            no_mappings: 'Không tìm thấy ánh xạ mục đích nào. Ánh xạ được tạo tự động khi nhận sự kiện đồng thuận.',
            total_mappings: 'Tổng: {count} ánh xạ',
            webhook_config_title: 'Cấu hình Webhook',
            current_configuration: 'Cấu hình hiện tại',
            setup_webhook: 'Cài đặt Webhook',
            setup_webhook_desc: 'Cấu hình webhook AesirX CMP để nhận sự kiện đồng thuận.',
            allowed_domains: 'Tên miền được phép (mỗi dòng một tên)',
            webhook_secret_warning: 'Bí mật Webhook (lưu ngay -- sẽ không hiển thị lại):',
            last_event: 'Sự kiện cuối',
            none_received: 'Không có',
            update_domains: 'Cập nhật tên miền',
            pause_webhook: 'Tạm dừng Webhook',
            resume_webhook: 'Tiếp tục Webhook',
            regenerate_secret: 'Tạo lại bí mật',
            configuring: 'Đang cấu hình...',
            create_webhook_config: 'Tạo cấu hình Webhook',
            webhook_endpoint: 'Điểm cuối Webhook',
            webhook_endpoint_desc: 'Cấu hình AesirX CMP của bạn để gửi sự kiện đồng thuận đến:',
            webhook_signature_note: 'Bao gồm chữ ký HMAC-SHA256 trong tiêu đề {header}.',
            configured_success: 'Webhook đã được cấu hình thành công.',
            config_updated: 'Đã cập nhật cấu hình.',
            config_error: 'Không thể cấu hình webhook',
            update_error: 'Không thể cập nhật cấu hình',
            toggle_error: 'Không thể bật/tắt webhook',
            deactivated: 'Webhook đã hủy kích hoạt.',
            deactivate_error: 'Không thể hủy kích hoạt webhook',
            data_loaded: 'Đã tải dữ liệu tích hợp CMP',
            purpose_mapping_page_title: 'Ánh xạ mục đích',
            bulk_sync_page_title: 'Ánh xạ lại bản ghi',
            webhook_config_page_title: 'Cấu hình Webhook CMP',
            page_title: 'Tích hợp CMP',
            sync_all: 'Đồng bộ tất cả',
            sync_selected: 'Đồng bộ đã chọn',
            sync_status: 'Trạng thái đồng bộ',
            last_sync: 'Đồng bộ lần cuối',
            no_records: 'Không tìm thấy bản ghi nào.',
            sync_in_progress: 'Đang đồng bộ...',
            sync_complete: 'Đồng bộ hoàn tất.',
            sync_error: 'Đồng bộ thất bại. Vui lòng thử lại.',
            map_purpose: 'Liên kết mục đích',
            unmap: 'Hủy liên kết',
            mapping_status: 'Trạng thái liên kết',
            save_mapping: 'Lưu liên kết',
            remap_unmapped_records: 'Ánh xạ lại bản ghi chưa liên kết',
            remap_records: 'Ánh xạ lại bản ghi',
            add_mappings_first: 'Thêm ánh xạ mục đích trước (Bước 2)',
            remap_result: 'Kết quả ánh xạ lại',
            remap_result_desc: 'Đã xử lý tất cả bản ghi đồng thuận có mục đích chưa được ánh xạ hoặc ánh xạ một phần.',
            total_processed: 'Tổng đã xử lý',
            newly_mapped: 'Mới được ánh xạ',
            still_unmapped_label: 'Vẫn chưa ánh xạ',
            still_unmapped_msg: '{count} bản ghi vẫn có mục đích chưa được ánh xạ. {link} rồi nhấn Ánh xạ lại.',
            add_more_mappings: 'Thêm ánh xạ',
            remap_complete: 'Ánh xạ lại hoàn tất: {remapped} mới được ánh xạ, {still_unmapped} vẫn chưa ánh xạ.',
            add_mapping: 'Thêm ánh xạ',
            cmp_purpose_id_label: 'Mã mục đích CMP *',
            cmp_purpose_id_required: 'Mã mục đích CMP là bắt buộc',
            cmp_purpose_name_label: 'Tên mục đích CMP',
            grc_purpose_label: 'Mục đích GRC',
        },
        propagation: {
            title: 'Lan truyền thu hồi',
            systems: 'Hệ thống liên kết',
            status: 'Trạng thái',
            confirmed: 'Đã xác nhận',
            pending: 'Chờ xử lý',
            failed: 'Thất bại',
            confirm: 'Xác nhận thu hồi',
            fail: 'Đánh dấu thất bại',
            failure_reason: 'Lý do thất bại',
            can_close: 'Tất cả hệ thống đã xác nhận — có thể đóng quy trình',
            cannot_close: 'Đang chờ xác nhận từ các hệ thống',
            no_tasks: 'Không có tác vụ lan truyền.',
            confirm_success: 'Đã xác nhận thu hồi hệ thống.',
            fail_success: 'Hệ thống đã được đánh dấu thất bại.',
            propagate_success: 'Đã lan truyền thu hồi đến các hệ thống liên kết.',
            propagate: 'Lan truyền đến các hệ thống',
            add_system: 'Thêm hệ thống',
            remove_system: 'Xóa',
            system_id: 'Mã hệ thống',
            system_name: 'Tên hệ thống',
            owner_id: 'Mã chủ sở hữu',
            propagate_error: 'Không thể lan truyền thu hồi. Vui lòng thử lại.',
            no_systems: 'Thêm ít nhất một hệ thống.',
            workflow_id: 'Chọn luồng thu hồi',
            system_id_hint: 'vd. crm-001, erp-prod',
            owner_id_hint: 'Chủ sở hữu hệ thống',
            page_title: 'Lan truyền thu hồi',
            elapsed: 'Đã trôi qua',
        },
        sensitive: {
            title: 'Chính sách dữ liệu nhạy cảm',
            flag: 'Đánh dấu là nhạy cảm',
            categories: 'Danh mục nhạy cảm',
            enhanced_review: 'Yêu cầu xem xét nâng cao',
            enhanced_review_success: 'Đã yêu cầu xem xét nâng cao.',
            flag_success: 'Chính sách đã được đánh dấu là nhạy cảm.',
            no_sensitive: 'Không có chính sách dữ liệu nhạy cảm.',
        },
        reconciliation: {
            title: 'Đối chiếu sai lệch',
            create: 'Tác vụ đối chiếu mới',
            system: 'Hệ thống',
            owner: 'Chủ sở hữu',
            description: 'Mô tả',
            resolution: 'Giải pháp',
            resolve: 'Giải quyết',
            update_grc: 'Cập nhật GRC',
            update_cmp: 'Cập nhật CMP',
            accept_difference: 'Chấp nhận sai lệch',
            escalate: 'Chuyển cấp',
            resolution_notes: 'Ghi chú giải pháp',
            no_tasks: 'Không có tác vụ đối chiếu.',
            resolve_success: 'Đã giải quyết tác vụ đối chiếu.',
            create_success: 'Đã tạo tác vụ đối chiếu.',
            open: 'Mở',
            resolved: 'Đã giải quyết',
            escalated: 'Đã chuyển cấp',
            dashboard_open: 'Tác vụ đang mở',
            dashboard_resolved: 'Tác vụ đã giải quyết',
            dashboard_escalated: 'Tác vụ đã chuyển cấp',
            page_title: 'Đối chiếu sai lệch',
            my_tasks: 'Tác vụ của tôi',
            all_tasks: 'Tất cả tác vụ',
            severity: 'Mức độ nghiêm trọng',
        },
        sync: {
            title: 'Đồng bộ CMP',
            direction: 'Hướng',
            cmp_to_grc: 'CMP → GRC',
            grc_to_cmp: 'GRC → CMP',
            conflict: 'Xung đột',
            resolve_conflict: 'Giải quyết xung đột',
            no_events: 'Không có sự kiện đồng bộ.',
            resolve_success: 'Đã giải quyết xung đột đồng bộ.',
            create_success: 'Đã ghi nhận sự kiện đồng bộ.',
            page_title: 'Đồng bộ CMP',
            detect_drift: 'Phát hiện xung đột',
            detecting: 'Đang phát hiện...',
            drift_result: 'Phát hiện {detected} xung đột trong {total} mục đích so sánh.',
            no_drift: 'Không phát hiện xung đột mới.',
            drift_error: 'Không thể chạy phát hiện xung đột.',
            resolve_modal_title: 'Giải quyết xung đột',
            resolve_field: 'Trường',
            resolve_grc_value: 'Giá trị GRC',
            resolve_cmp_value: 'Giá trị CMP',
            accept_cmp: 'Chấp nhận giá trị CMP',
            accept_cmp_desc: 'Cập nhật GRC để khớp CMP — giá trị CMP trở thành giá trị GRC mới.',
            keep_grc: 'Giữ giá trị GRC',
            keep_grc_desc: 'Đóng xung đột này mà không thay đổi GRC — thông báo chủ sở hữu CMP để đồng bộ.',
            resolve_applied: 'Xung đột đã giải quyết. Mục đích GRC đã cập nhật để khớp CMP.',
        },
    },
    assessments: {
        /*
         * Sprint 65.4.0 (AC5) — the DPIA review-reminder task body.
         *
         * It used to be an English sentence concatenated inside
         * `dpia-review-scheduler-service.ts`, asserting a "6-month review" over a
         * record free to declare any cadence at all. The period is gone from the
         * wording because the record owns it, and the string lives here so a
         * Vietnamese tenant does not read one English line in its task list.
         */
        review_reminder: {
            task_title: 'Đến hạn rà soát Đánh giá tác động xử lý dữ liệu cá nhân: {title}',
            task_description: 'Lần rà soát đã lên lịch cho hồ sơ này đến hạn vào ngày {date}. Vui lòng xác nhận các biện pháp bảo vệ vẫn phù hợp hoặc nộp bản đánh giá cập nhật.',
        },
        // ── Sprint 65.4.0 (AC2) — the operator-recorded commencement moment ──
        //
        // Shared by the DPIA and cross-border transfer surfaces: one fact, one
        // vocabulary. The undated wording is deliberately explicit that a
        // lifecycle timestamp is NOT the answer, because a blank date field
        // reads as "nobody filled this in" while the truth is "the clock cannot
        // lawfully start yet".
        commencement: {
            section_title_dpia: 'Thời điểm bắt đầu xử lý dữ liệu',
            section_title_transfer: 'Thời điểm bắt đầu chuyển dữ liệu',
            loading: 'Đang tải thời điểm đã ghi nhận',
            load_failed: 'Không tải được thời điểm bắt đầu đã ghi nhận.',
            reload: 'Tải lại',
            reloading: 'Đang tải lại…',
            retry_subject: 'thời điểm bắt đầu đã ghi nhận',
            undated_label: 'Chưa có mốc tính thời hạn luật định',
            undated_icon: 'Chưa có mốc thời gian',
            undated_reason: 'Chưa có ai ghi nhận thời điểm bắt đầu, nên thời hạn luật định không có mốc hợp pháp để tính. Hệ thống không bao giờ tính từ ngày tạo, ngày phê duyệt hay ngày chỉnh sửa gần nhất của bản ghi này — đó là thời điểm ai đó mở biểu mẫu trên hệ thống, không phải thời điểm hoạt động thực sự bắt đầu.',
            recorded_label: 'Đã có mốc tính thời hạn luật định',
            recorded_icon: 'Đã gắn với thời điểm được ghi nhận',
            occurred_at_label: 'Bắt đầu từ',
            recorded_by_label: 'Người ghi nhận',
            recorded_at_label: 'Ghi nhận lúc',
            source_field_label: 'Được lưu tại',
            correction_note_label: 'Lý do ghi nhận lại',
            instant_label: 'Ngày và giờ bắt đầu',
            instant_hint: 'Nhập theo múi giờ của bạn. Thời hạn luật định được tính từ thời điểm này, không phải từ lúc bạn nhập.',
            note_label: 'Vì sao ghi nhận lại thời điểm này?',
            note_hint: 'Bắt buộc. Bản ghi phải giải thích được vì sao thời hạn của nó thay đổi.',
            save: 'Ghi nhận thời điểm',
            save_correction: 'Ghi nhận lại thời điểm',
            saving: 'Đang lưu',
            saved: 'Đã ghi nhận thời điểm bắt đầu',
            saved_correction: 'Đã ghi nhận lại thời điểm bắt đầu',
            saved_unchanged: 'Bản ghi đã ghi nhận đúng thời điểm này. Không có thay đổi nào.',
            error_not_iso: 'Vui lòng nhập đầy đủ ngày và giờ. Thời điểm được lưu dưới dạng mốc thời gian chính xác, nên giờ không kèm múi giờ sẽ không được chấp nhận.',
            error_future: 'Thời điểm này nằm trong tương lai. Không thể tính thời hạn luật định từ một sự kiện chưa xảy ra.',
            error_note_required: 'Bản ghi đã ghi nhận thời điểm bắt đầu. Vui lòng nêu lý do ghi nhận lại trước khi lưu.',
            error_note_not_correction: 'Chưa có thời điểm nào được ghi nhận nên không có gì để sửa. Vui lòng xóa phần lý do và ghi nhận thời điểm.',
            error_generic: 'Không ghi nhận được thời điểm bắt đầu.',
        },
        // Sprint 48.1.9 — Bảng kiểm tra pre-flight + tự lắp ráp dossier
        // ── Sprint 65.7.0 — the two moments a FILED dossier carries ──
        //
        // Shared by the DPIA and cross-border transfer surfaces, like the
        // commencement vocabulary above: one fact, one wording. The first filing is
        // write-once, so this block carries NO edit copy for it — a "Change the
        // filing date" control would offer an act the server refuses, and the
        // sentence that explains why is the affordance instead.
        dossier_update: {
            section_title_dpia: 'Hồ sơ đã nộp của bản đánh giá này',
            section_title_transfer: 'Hồ sơ đã nộp của hoạt động chuyển dữ liệu cá nhân xuyên biên giới này',
            loading: 'Đang tải các mốc thời gian đã ghi nhận của hồ sơ',
            load_failed: 'Không tải được các mốc thời gian đã ghi nhận của hồ sơ.',
            reload: 'Tải lại',
            reloading: 'Đang tải lại…',
            retry_subject: 'các mốc thời gian đã ghi nhận của hồ sơ',
            filing_heading: 'Lần nộp đầu tiên',
            filing_absent_label: 'Chưa ghi nhận lần nộp đầu tiên',
            filing_absent_icon: 'Chưa ghi nhận lần nộp',
            filing_absent_reason: 'Chưa có ai ghi nhận thời điểm hồ sơ này được nộp lần đầu, nên mọi thời hạn tính từ lần nộp đó đều không có mốc để tính. Hệ thống không bao giờ tính từ ngày tạo, ngày phê duyệt hay ngày chỉnh sửa gần nhất của bản ghi này — hồ sơ do một người nộp, vào một ngày cụ thể, bên ngoài hệ thống, rồi mới được ghi nhận lại tại đây.',
            filing_recorded_label: 'Đã ghi nhận lần nộp đầu tiên',
            filing_recorded_icon: 'Đã gắn với lần nộp được ghi nhận',
            filing_write_once_notice: 'Chỉ ghi nhận một lần và không được thay đổi. Chu kỳ cập nhật được tính từ lần nộp đầu tiên, nên sửa mốc này sẽ âm thầm dịch chuyển mọi ngày được suy ra từ đó. Nếu hồ sơ được nộp lại, hãy ghi nhận nội dung đã thay đổi ở phần dưới.',
            filed_at_label: 'Nộp ngày',
            filing_instant_label: 'Ngày và giờ nộp lần đầu',
            filing_instant_hint: 'Nhập theo múi giờ của bạn. Đây là thời điểm hồ sơ được nộp, không phải thời điểm bạn nhập vào đây.',
            filing_save: 'Ghi nhận lần nộp đầu tiên',
            filing_saving: 'Đang lưu',
            filing_saved: 'Đã ghi nhận lần nộp đầu tiên',
            filing_saved_unchanged: 'Bản ghi đã ghi nhận đúng nội dung này. Không có thay đổi nào.',
            change_heading: 'Thay đổi thông tin đã đăng ký trong hồ sơ',
            change_blocked_label: 'Chưa nộp hồ sơ nào',
            change_blocked_reason: 'Chưa có thông tin đăng ký nào để thay đổi khi hồ sơ chưa được nộp. Hãy ghi nhận lần nộp đầu tiên ở phần trên, sau đó ghi nhận nội dung đã thay đổi.',
            change_absent_label: 'Chưa ghi nhận thay đổi nào',
            change_absent_reason: 'Hồ sơ đã được nộp và chưa có ai ghi nhận thay đổi nào đối với thông tin đã đăng ký trong hồ sơ.',
            change_recorded_label: 'Đã ghi nhận thay đổi',
            change_latest_notice: 'Đây là thay đổi gần nhất đang có hiệu lực. Ghi nhận một thay đổi mới sẽ thay thế nội dung này, và mỗi lần ghi nhận vẫn được giữ lại như một dữ kiện riêng trong lịch sử bản ghi.',
            changed_at_label: 'Thay đổi ngày',
            change_description_value_label: 'Nội dung đã thay đổi',
            change_instant_label: 'Ngày và giờ thông tin đăng ký thay đổi',
            change_instant_hint: 'Nhập theo múi giờ của bạn.',
            change_description_label: 'Đã thay đổi những gì?',
            change_description_hint: 'Bắt buộc. Hãy mô tả nội dung đã thay đổi bằng lời của bạn. Những thay đổi nào làm phát sinh nghĩa vụ cập nhật là do các khung tuân thủ bạn đã cài đặt quy định, còn người xử lý tiếp theo cần chính mô tả của bạn về những gì đã xảy ra.',
            change_note_label: 'Vì sao ghi nhận lại nội dung này?',
            change_note_hint: 'Không bắt buộc. Hãy dùng khi nội dung này thay thế một ghi nhận đã có trước đó.',
            change_save: 'Ghi nhận thay đổi',
            change_save_restate: 'Thay thế thay đổi đã ghi nhận',
            change_saving: 'Đang lưu',
            change_saved: 'Đã ghi nhận thay đổi thông tin đăng ký trong hồ sơ',
            change_saved_unchanged: 'Bản ghi đã ghi nhận đúng nội dung này. Không có thay đổi nào.',
            recorded_by_label: 'Người ghi nhận',
            recorded_at_label: 'Ghi nhận lúc',
            source_field_label: 'Được lưu tại',
            correction_note_label: 'Lý do ghi nhận lại',
            error_not_iso: 'Vui lòng nhập đầy đủ ngày và giờ. Thời điểm được lưu dưới dạng mốc thời gian chính xác, nên giờ không kèm múi giờ sẽ không được chấp nhận.',
            error_future: 'Thời điểm này nằm trong tương lai. Không thể tính bất kỳ thời hạn nào từ một sự kiện chưa xảy ra.',
            error_already_recorded: 'Bản ghi đã ghi nhận thời điểm hồ sơ được nộp lần đầu và mốc đó không thể thay đổi — mọi ngày được tính từ đó cũng sẽ dịch chuyển theo. Nếu hồ sơ được nộp lại, hãy ghi nhận nội dung đã thay đổi.',
            error_before_first_filing: 'Bản ghi này chưa nộp hồ sơ nào nên chưa có thông tin đăng ký để thay đổi. Vui lòng ghi nhận lần nộp đầu tiên trước.',
            error_description_required: 'Vui lòng cho biết nội dung đã thay đổi. Một thay đổi không có mô tả thì người phải rà soát không thể xử lý được.',
            error_generic: 'Không ghi nhận được mốc thời gian của hồ sơ.',
        },
        dossier_preflight: {
            advisory_notice: 'Báo cáo mức độ sẵn sàng này chỉ mang tính tư vấn. Báo cáo không phê duyệt, tập hợp, hiện thực hóa, nộp hoặc gửi hồ sơ.',
            run_label: 'Chạy kiểm tra pre-flight',
            running: 'Đang kiểm tra…',
            assemble_label: 'Tự lắp ráp gói nộp',
            assembling: 'Đang lắp ráp…',
            verdict_label: 'Kết luận pre-flight',
            tokens_label: '≈ {count} token',
            remediation_label: 'Khắc phục',
            no_gaps: 'Không phát hiện thiếu sót. Filing sẵn sàng để lắp ráp.',
            override_label: 'Bỏ qua kết luận block — việc lắp ráp sẽ được ghi audit.',
            accept_label: 'Chấp nhận báo cáo',
            reject_label: 'Từ chối báo cáo',
            assembled_label: 'Gói nộp đã được lắp ráp',
            package_id_label: 'Id gói',
            package_filename_label: 'Tên file',
            package_hash_label: 'Hash gói',
            evidence_count_label: 'Đã đính kèm {count} mục bằng chứng',
            error_generic: 'Không thể chạy pre-flight hoặc lắp ráp gói. Hãy thử lại hoặc kiểm tra trạng thái filing.',
        },
        errors: {
            fetch: 'Không thể tải đánh giá.',
            save: 'Không thể lưu đánh giá.',
            fetch_gap_report_failed: 'Không thể tải báo cáo lỗi.',
            fetch_transfers_failed: 'Không thể tải chuyển dữ liệu.',
            save_transfer_failed: 'Không thể lưu chuyển dữ liệu.',
            submit_review_failed: 'Không thể gửi để xem xét.',
            process_decision_failed: 'Không thể xử lý quyết định.',
            deprecate_failed: 'Không thể ngừng sử dụng.',
            evaluate_risk_failed: 'Không thể đánh giá rủi ro.',
            fetch_safeguards_failed: 'Không thể tải biện pháp bảo vệ.',
            save_safeguard_failed: 'Không thể lưu biện pháp bảo vệ.',
            update_safeguard_status_failed: 'Không thể cập nhật trạng thái biện pháp bảo vệ.',
        },
        nav: {
            dpias: 'Đánh giá tác động xử lý dữ liệu cá nhân',
            transfers: 'Đánh giá chuyển dữ liệu',
            dashboard: 'Tổng quan',
            gap_report: 'Báo cáo lỗi',
        },
        risk_level_critical: 'Rủi ro nghiêm trọng',
        risk_level_high: 'Rủi ro cao',
        risk_level_medium: 'Rủi ro trung bình',
        risk_level_low: 'Rủi ro thấp',
        severity_critical: 'Mức nghiêm trọng',
        severity_high: 'Mức cao',
        severity_medium: 'Mức trung bình',
        severity_low: 'Mức thấp',
        overdue: 'Quá hạn',
        framework_filter_label: 'Khung tuân thủ',
        aria_filter_by_framework: 'Lọc theo khung tuân thủ',
        dashboard: {
            page_title: 'Bảng điều khiển đánh giá',
            announce_loaded: 'Bảng điều khiển đánh giá đã tải',
            announce_chart_view: 'Hiển thị dạng biểu đồ',
            announce_table_view: 'Hiển thị dạng bảng dữ liệu',
            aria_metrics_table: 'Số liệu bảng điều khiển đánh giá',
            metric_col: 'Chỉ số',
            value_col: 'Giá trị',
            dpia_prefix: 'DPIA',
            transfer_prefix: 'Chuyển giao',
            risk_prefix: 'Rủi ro',
            aria_dpias_by_status: 'DPIA theo trạng thái',
            aria_transfers_by_status: 'Chuyển giao theo trạng thái',
            aria_top_risks: 'Rủi ro hàng đầu',
            aria_top_risks_table: 'Rủi ro hàng đầu trong các DPIA',
            overdue_dpias_attention: '{count} DPIA quá hạn cần chú ý',
            no_overdue_dpias: 'Không có DPIA quá hạn',
            overdue_transfers_attention: '{count} chuyển giao quá hạn cần chú ý',
            no_overdue_transfers: 'Không có chuyển giao quá hạn',
            title: 'Tổng quan đánh giá',
            dpias_overview: 'Tổng quan DPIA',
            transfers_overview: 'Tổng quan đánh giá chuyển',
            overdue_items: 'Hạng mục quá hạn',
            overdue_dpias: 'DPIA quá hạn',
            overdue_transfers: 'Chuyển giao quá hạn',
            count: 'Số lượng',
            no_data: 'Không có dữ liệu.',
            no_risks: 'Chưa có rủi ro nào.',
            no_dashboard_data: 'Không có dữ liệu tổng quan.',
            fetch_error: 'Không thể tải dữ liệu tổng quan. Vui lòng thử lại.',
        },
        dpias: {
            // fix-sprint-20260905-2135 F33/F34 — keys that tKey() call sites asked for and
            // no locale declared, so each fell through to its hardcoded English third
            // argument and rendered English in all 16 locales. The two DPIA row-action
            // tooltips were worse: their fallbacks are themselves translated keys, so the
            // primary CTA read 'Edit' where the code intends 'Continue', and the in-review
            // action read 'Approve/Reject' where it intends 'Review'.
            continue: 'Tiếp tục',
            review: 'Rà soát',
            section_basic_info: 'Thông tin cơ bản',
            page_title: 'Đánh giá tác động xử lý dữ liệu cá nhân',
            announce_submitted_for_review: 'DPIA đã gửi xem xét',
            announce_deprecated: 'DPIA đã ngừng sử dụng',
            announce_risks_loaded: 'Đã tải {count} rủi ro',
            announce_mitigations_loaded: 'Đã tải {count} biện pháp giảm thiểu',
            announce_risk_deleted: 'Đã xóa rủi ro',
            announce_mitigation_status_updated: 'Đã cập nhật trạng thái biện pháp',
            aria_filter: 'Lọc DPIA',
            aria_filter_by_status: 'Lọc theo trạng thái',
            aria_filter_by_lead: 'Lọc theo trưởng nhóm đánh giá',
            aria_table: 'Đánh giá tác động bảo vệ dữ liệu',
            announce_found: 'Tìm thấy {count} DPIA',
            announce_decision: 'DPIA {decision}',
            mitigation_start: 'Bắt đầu',
            mitigation_mark_implemented: 'Đánh dấu đã triển khai',
            mitigation_verify: 'Xác minh',
            title: 'Đánh giá tác động bảo vệ dữ liệu',
            new: 'DPIA mới',
            edit: 'Sửa DPIA',
            dpia_title: 'Tiêu đề',
            edit_dpia_aria: 'Sửa DPIA: {title}',
            approve_or_reject_aria: 'Phê duyệt hoặc không phê duyệt: {title}',
            more_actions_for_aria: 'Thao tác khác cho {title}',
            risk_details_aria: 'Chi tiết rủi ro của {title}',
            edit_risk_aria: 'Sửa rủi ro: {title}',
            delete_risk_aria: 'Xóa rủi ro: {title}',
            mitigation_details_aria: 'Chi tiết biện pháp giảm thiểu rủi ro của {title}',
            edit_mitigation_aria: 'Sửa biện pháp giảm thiểu rủi ro: {title}',
            dossier_filing_details_aria: 'Chi tiết hồ sơ nộp của {title}',
            activity: 'Hoạt động',
            risk_score: 'Điểm rủi ro',
            risks: 'Rủi ro',
            mitigations: 'Biện pháp giảm thiểu rủi ro',
            add_risk: 'Thêm rủi ro',
            add_mitigation: 'Thêm biện pháp',
            necessity: 'Tính cần thiết / tương xứng',
            likelihood: 'Khả năng xảy ra',
            impact: 'Tác động',
            severity_label: 'Mức độ nghiêm trọng',
            purpose: 'Mục đích xử lý dữ liệu cá nhân',
            consultation_notes: 'Ghi chú tư vấn',
            dpo_opinion: 'Ý kiến của nhân sự bảo vệ dữ liệu cá nhân',
            processing_activity_ids: 'Mã hoạt động xử lý (phân cách bằng dấu phẩy)',
            system_ids: 'Mã hệ thống (phân cách bằng dấu phẩy)',
            vendor_ids: 'Mã nhà cung cấp (phân cách bằng dấu phẩy)',
            data_types: 'Loại dữ liệu (phân cách bằng dấu phẩy)',
            data_types_short: 'Loại dữ liệu cá nhân',
            data_subjects: 'Chủ thể dữ liệu (phân cách bằng dấu phẩy)',
            assessment_lead_id: 'Mã người phụ trách đánh giá',
            assessment_lead: 'Người phụ trách đánh giá',
            dpo_id: 'Mã DPO',
            reviewer_ids: 'Mã người xem xét (phân cách bằng dấu phẩy)',
            approval_mode: 'Chế độ phê duyệt',
            approval_all: 'Tất cả',
            approval_any: 'Bất kỳ',
            require_dpo_signoff: 'Yêu cầu DPO ký duyệt',
            review_frequency_days: 'Chu kỳ rà soát (ngày)',
            review_frequency_days_hint: 'Không bắt buộc. Số ngày giữa các lần rà soát lại DPIA này sau khi được phê duyệt. Để trống thì DPIA không có ngày rà soát.',
            error_dpo_required: 'DPIA này yêu cầu DPO ký duyệt. Hãy chọn DPO trước khi gửi để rà soát.',
            error_dpo_invalid: 'DPO được nêu trong DPIA này không phải là người dùng đang hoạt động của tổ chức. Hãy chọn một DPO đang hoạt động trước khi gửi để rà soát.',
            error_dpo_cannot_approve: 'DPO được nêu trong DPIA này không có quyền phê duyệt DPIA, nên việc ký duyệt sẽ không bao giờ thực hiện được. Hãy chọn một DPO có quyền này trước khi gửi để rà soát.',
            decision_awaiting_dpo: 'Đã ghi quyết định của bạn. DPIA vẫn đang được xem xét cho đến khi DPO ký duyệt.',
            withdraw_review: 'Rút khỏi vòng rà soát',
            withdraw_review_hint: 'Đưa DPIA về bản nháp để chỉnh sửa',
            withdraw_review_error: 'Không thể rút DPIA khỏi vòng rà soát. Vui lòng thử lại.',
            announce_withdrawn: 'DPIA đã được rút khỏi vòng rà soát',
            review_date: 'Ngày rà soát',
            submit_for_review: 'Gửi để rà soát',
            approve_reject: 'Phê duyệt/Từ chối',
            reopen: 'Mở lại thành bản nháp',
            reopen_hint: 'Bắt đầu một vòng xem xét mới. Quyết định không phê duyệt được ghi trên bản ghi và không còn được tính.',
            reopen_error: 'Không thể mở lại DPIA. Vui lòng thử lại.',
            announce_reopened: 'Đã mở lại DPIA thành bản nháp',
            decision_named_reviewers_note: 'DPIA này đã chỉ định người xem xét. Quyết định của người khác vẫn được ghi vào nhật ký phê duyệt, nhưng không được tính là phê duyệt hay không phê duyệt.',
            decision_not_counted: 'Quyết định của bạn đã được ghi nhận nhưng không được tính: chỉ những người xem xét được chỉ định mới quyết định DPIA này.',
            approval_incomplete_badge: 'Phê duyệt chưa đầy đủ',
            approval_incomplete_note: 'DPIA này được đánh dấu là đã phê duyệt, nhưng nhật ký phê duyệt không cho thấy phê duyệt của những người xem xét được chỉ định. DPIA vẫn giữ nguyên trạng thái. Việc có rà soát lại hay không do tổ chức của bạn quyết định.',
            approval_rounds_count: 'Số vòng xem xét trước đó được ghi trên bản ghi này: {count}',
            deprecate: 'Ngừng sử dụng',
            deprecated: 'Không còn áp dụng',
            hide_risks: 'Ẩn rủi ro',
            hide_mitigations: 'Ẩn biện pháp giảm thiểu',
            comments: 'Bình luận',
            submit_decision: 'Gửi quyết định',
            category_label: 'Danh mục',
            category_data_breach: 'Vi phạm dữ liệu',
            category_unauthorized_access: 'Truy cập trái phép',
            category_function_creep: 'Mở rộng chức năng',
            category_re_identification: 'Tái nhận dạng',
            category_discrimination: 'Phân biệt đối xử',
            category_surveillance: 'Giám sát',
            category_other: 'Khác',
            affected_rights: 'Quyền bị ảnh hưởng (phân cách bằng dấu phẩy)',
            no_risks: 'Chưa có rủi ro nào.',
            no_mitigations: 'Chưa có biện pháp giảm thiểu nào.',
            no_dpias: 'Không tìm thấy DPIA.',
            mitigation_type: 'Loại biện pháp',
            mitigation_technical: 'Kỹ thuật',
            mitigation_organizational: 'Tổ chức',
            mitigation_contractual: 'Hợp đồng',
            risk_ids: 'Mã rủi ro (phân cách bằng dấu phẩy)',
            responsible_party: 'Bên chịu trách nhiệm',
            responsible_party_placeholder: 'Hoặc nhập tên thủ công',
            affected_rights_placeholder: 'Quyền được chọn xuất hiện ở đây',
            affected_rights_freetext_placeholder: 'Nhập quyền bị ảnh hưởng (cách nhau bằng dấu phẩy)',
            responsible: 'Người chịu trách nhiệm',
            target_date: 'Thời hạn hoàn thành',
            created: 'Ngày tạo',
            fetch_error: 'Không thể tải danh sách DPIA. Vui lòng thử lại.',
            save_error: 'Không thể lưu DPIA. Vui lòng thử lại.',
            submit_review_error: 'Không thể gửi DPIA để xem xét. Vui lòng thử lại.',
            decision_error: 'Không thể xử lý quyết định. Vui lòng thử lại.',
            deprecate_error: 'Không thể ngừng sử dụng DPIA. Vui lòng thử lại.',
            fetch_risks_error: 'Không thể tải rủi ro. Vui lòng thử lại.',
            save_risk_error: 'Không thể lưu rủi ro. Vui lòng thử lại.',
            delete_risk_error: 'Không thể xóa rủi ro. Vui lòng thử lại.',
            fetch_mitigations_error: 'Không thể tải biện pháp giảm thiểu. Vui lòng thử lại.',
            save_mitigation_error: 'Không thể lưu biện pháp giảm thiểu. Vui lòng thử lại.',
            update_mitigation_status_error: 'Không thể cập nhật trạng thái biện pháp. Vui lòng thử lại.',
            link_form_template: 'Liên kết Mẫu biểu quy định',
            link_form_template_placeholder: 'Chọn mẫu biểu DPIA (tùy chọn)',
            link_form_template_none: 'Không',
            linked_form: 'Biểu mẫu đã liên kết',
            linked_form_creating: 'Đang tạo biểu mẫu liên kết...',
            linked_form_error: 'Không thể tạo biểu mẫu liên kết. DPIA đã được tạo mà không có biểu mẫu liên kết.',
            view_linked_form: 'Xem biểu mẫu',
            announce_created_with_form: 'DPIA đã được tạo với biểu mẫu liên kết',
            creation_mode: 'Chế độ tạo DPIA',
            mode_standard: 'DPIA tiêu chuẩn',
            mode_template: 'Sử dụng Mẫu biểu quy định',
            select_form_template: 'Chọn Mẫu biểu',
            create_and_fill_form: 'Tạo & Điền biểu mẫu',
            template_sections_title: 'Các phần mẫu biểu',
            field_singular: 'trường',
            field_plural: 'trường',
            no_sections: 'Không tìm thấy phần nào trong mẫu biểu này.',
            template_mode_hint: 'Sau khi tạo, bạn sẽ được chuyển hướng để điền biểu mẫu quy định đầy đủ.',
            linked_dossier_filings: 'Hồ sơ nộp có liên kết',
            no_linked_dossier_filings: 'Chưa có hồ sơ nộp nào được liên kết với Đánh giá tác động xử lý dữ liệu cá nhân này.',
            view_dossier_filing: 'Xem hồ sơ',
            hide_dossier_filings: 'Ẩn hồ sơ nộp',
            // Sprint 41.8.0 I1 — supporting evidence
            supporting_evidence: 'Tài liệu chứng minh',
            hide_supporting_evidence: 'Ẩn bằng chứng',
            no_supporting_evidence: 'Chưa đính kèm tài liệu chứng minh.',
            upload_supporting_evidence: 'Tải lên tài liệu chứng minh',
            view_form_responses: 'Xem phản hồi biểu mẫu',
            regulatory_framework: 'Khung tuân thủ',
            all_frameworks: 'Tất cả khung tuân thủ',
            no_templates_for_market: 'Không có mẫu nào cho thị trường đã chọn. Vui lòng chọn thị trường khác hoặc tạo mẫu mới.',
            affected_rights_freetext_hint: 'Không có quyền nào từ khung tuân thủ — nhập thủ công (phân tách bằng dấu phẩy)',
            ai_draft_eyebrow: 'Trợ lý AI',
            deprecate_hint: 'Ngừng sử dụng hồ sơ đánh giá tác động này mà không xóa',
            inherent_risk_level: 'Rủi ro ban đầu',
            mitigation_contractual_hint: 'Điều khoản hợp đồng xử lý dữ liệu, điều khoản hợp đồng mẫu, nghĩa vụ hợp đồng',
            mitigation_description_placeholder: 'Mô tả chi tiết biện pháp giảm thiểu',
            mitigation_organizational_hint: 'Chính sách, đào tạo, quy trình, nhận thức của nhân viên',
            mitigation_technical_hint: 'Mã hóa, giả danh hóa, kiểm soát truy cập, tăng cường bảo mật hệ thống',
            mitigation_title_placeholder: 'ví dụ: Mã hóa dữ liệu lưu trữ',
            no_risks_to_link: 'Không tìm thấy rủi ro nào cho hồ sơ đánh giá tác động này. Hãy thêm rủi ro trước.',
            score_high: 'Cao',
            score_low: 'Thấp',
            score_medium: 'Trung bình',
            score_very_high: 'Rất cao',
            score_very_low: 'Rất thấp',
            section_assessment_details: 'Chi tiết đánh giá',
            section_implementation: 'Triển khai',
            section_processing: 'Chi tiết hoạt động xử lý',
            section_scoring: 'Chấm điểm rủi ro',
            section_team: 'Nhóm phụ trách và phê duyệt',
            selected_rights_count: 'Đã chọn',
            submit_for_review_hint: 'Chuyển hồ sơ Đánh giá tác động xử lý dữ liệu cá nhân này sang bước rà soát',
        },
        transfers: {
            // fix-sprint-20260905-2135 F33/F34 — keys that tKey() call sites asked for and
            // no locale declared, so each fell through to its hardcoded English third
            // argument and rendered English in all 16 locales. The two DPIA row-action
            // tooltips were worse: their fallbacks are themselves translated keys, so the
            // primary CTA read 'Edit' where the code intends 'Continue', and the in-review
            // action read 'Approve/Reject' where it intends 'Review'.
            description_placeholder: 'Tóm tắt ngắn gọn về hoạt động chuyển dữ liệu này',
            title_placeholder: 'Ví dụ: Chuyển dữ liệu CRM giữa EU và Hoa Kỳ',
            vendor_id_placeholder: 'Mã nhà cung cấp (không bắt buộc)',
            page_title: 'Chuyển dữ liệu',
            announce_found: 'Tìm thấy {count} đánh giá chuyển dữ liệu',
            announce_submitted_for_review: 'Chuyển giao đã gửi xem xét',
            announce_deprecated: 'Chuyển giao đã ngừng sử dụng',
            announce_decision: 'Chuyển giao {decision}',
            announce_risk_eval_completed: 'Đánh giá rủi ro hoàn tất',
            announce_safeguard_status_updated: 'Đã cập nhật trạng thái biện pháp bảo vệ',
            announce_safeguards_loaded: 'Đã tải {count} biện pháp bảo vệ',
            aria_filter: 'Lọc đánh giá chuyển dữ liệu',
            aria_filter_by_status: 'Lọc theo trạng thái',
            aria_filter_by_mechanism: 'Lọc theo cơ chế chuyển',
            aria_table: 'Đánh giá chuyển dữ liệu',
            title: 'Đánh giá chuyển dữ liệu xuyên biên giới',
            new: 'Đánh giá mới',
            edit: 'Sửa đánh giá',
            create_success: 'Đã tạo đánh giá chuyển dữ liệu.',
            update_success: 'Đã cập nhật đánh giá chuyển dữ liệu.',
            name: 'Tên',
            from_country: 'Từ quốc gia',
            to_country: 'Đến quốc gia',
            safeguards: 'Biện pháp bảo vệ dữ liệu cá nhân',
            risk_level: 'Mức độ rủi ro',
            assessment_notes: 'Ghi chú đánh giá',
            mechanism: 'Cơ chế',
            transfer_mechanism: 'Cơ chế chuyển dữ liệu',
            transfer_mechanism_detail: 'Chi tiết cơ chế chuyển dữ liệu',
            all_mechanisms: 'Tất cả cơ chế',
            mechanism_other: 'Khác',
            data_types: 'Loại dữ liệu (phân cách bằng dấu phẩy)',
            data_subjects: 'Chủ thể dữ liệu (phân cách bằng dấu phẩy)',
            purpose: 'Mục đích xử lý dữ liệu cá nhân',
            recipient_name: 'Tên người nhận',
            recipient_details: 'Chi tiết bên nhận',
            recipient_details_placeholder: 'Vai trò, địa điểm, hệ thống và thông tin chuyển tiếp của bên nhận',
            vendor_id: 'Mã nhà cung cấp',
            processing_activity_ids: 'Mã hoạt động xử lý (phân cách bằng dấu phẩy)',
            reviewer_ids: 'Mã người xem xét (phân cách bằng dấu phẩy)',
            approval_mode: 'Chế độ phê duyệt',
            approval_all: 'Tất cả',
            approval_any: 'Bất kỳ',
            require_dpo_signoff: 'Yêu cầu DPO ký duyệt',
            review_date: 'Ngày rà soát',
            created: 'Ngày tạo',
            deprecated: 'Không còn áp dụng',
            submit_for_review: 'Gửi để rà soát',
            approve_reject: 'Phê duyệt/Từ chối',
            reopen: 'Mở lại thành bản nháp',
            reopen_hint: 'Bắt đầu một vòng xem xét mới. Quyết định không phê duyệt được ghi trên bản ghi và không còn được tính.',
            reopen_error: 'Không thể mở lại đánh giá chuyển dữ liệu. Vui lòng thử lại.',
            announce_reopened: 'Đã mở lại đánh giá chuyển dữ liệu thành bản nháp',
            redetermine_mechanism: 'Xác định lại cơ chế',
            redetermine_mechanism_title: 'Xác định lại cơ chế chuyển dữ liệu',
            redetermine_mechanism_intro: 'Bản ghi này đang ở trạng thái {status} nên không thể sửa, nhưng cơ chế chuyển dữ liệu của bản ghi đang chờ một người xác định lại. Hãy chọn một cơ chế mà khung tuân thủ đã cài đặt quy định. Chỉ cơ chế được lưu; trạng thái và hồ sơ phê duyệt không thay đổi.',
            redetermine_choose_first: 'Hãy chọn một cơ chế chuyển dữ liệu trước.',
            redetermine_success: 'Đã xác định lại cơ chế chuyển dữ liệu.',
            redetermine_error: 'Không thể xác định lại cơ chế chuyển dữ liệu. Vui lòng thử lại.',
            withdraw_review: 'Rút khỏi vòng rà soát',
            withdraw_review_hint: 'Đưa đánh giá chuyển dữ liệu về bản nháp. Vòng xem xét được đóng lại và các quyết định trong vòng đó không còn được tính. Dùng khi một người xem xét được chỉ định không còn có thể quyết định.',
            withdraw_review_error: 'Không thể rút đánh giá chuyển dữ liệu khỏi vòng rà soát. Vui lòng thử lại.',
            announce_withdrawn: 'Đánh giá chuyển dữ liệu đã được rút khỏi vòng rà soát',
            decision_named_reviewers_note: 'Đánh giá chuyển dữ liệu này đã chỉ định người xem xét. Quyết định của người khác vẫn được ghi vào nhật ký phê duyệt, nhưng không được tính là phê duyệt hay không phê duyệt.',
            decision_not_counted: 'Quyết định của bạn đã được ghi nhận nhưng không được tính: chỉ những người xem xét được chỉ định mới quyết định đánh giá chuyển dữ liệu này.',
            approval_incomplete_badge: 'Phê duyệt chưa đầy đủ',
            approval_incomplete_note: 'Đánh giá chuyển dữ liệu này được đánh dấu là đã phê duyệt, nhưng nhật ký phê duyệt không cho thấy phê duyệt của những người xem xét được chỉ định. Đánh giá vẫn giữ nguyên trạng thái, nhưng luồng trao đổi định danh xuyên biên giới không thể dựa vào đánh giá này. Việc có rà soát lại hay không do tổ chức của bạn quyết định.',
            approval_rounds_count: 'Số vòng xem xét trước đó được ghi trên bản ghi này: {count}',
            deprecate: 'Ngừng sử dụng',
            risk_eval: 'Đánh giá rủi ro',
            hide_safeguards: 'Ẩn biện pháp bảo vệ',
            // Sprint 41.8.0 I1 — mechanism proof
            mechanism_proof: 'Bằng chứng cơ chế chuyển',
            hide_mechanism_proof: 'Ẩn bằng chứng cơ chế',
            mechanism_proof_hint: 'Tải lên văn bản đã ký làm cơ sở cho việc chuyển dữ liệu (ví dụ hợp đồng, hoặc hồ sơ đánh giá tác động mà các khung tuân thủ đã cài đặt yêu cầu) để chứng minh đánh giá chuyển dữ liệu này.',
            no_mechanism_proof: 'Chưa có bằng chứng cơ chế đính kèm.',
            upload_mechanism_proof: 'Tải lên bằng chứng cơ chế',
            comments: 'Bình luận',
            submit_decision: 'Gửi quyết định',
            data_sensitivity: 'Độ nhạy cảm dữ liệu (1-5)',
            country_risk: 'Rủi ro quốc gia (1-5)',
            safeguard_adequacy: 'Mức độ đầy đủ của biện pháp bảo vệ dữ liệu cá nhân (1 = yếu, 5 = mạnh; mức càng cao thì rủi ro càng thấp)',
            volume_factor: 'Hệ số khối lượng (1-5)',
            evaluate: 'Đánh giá',
            add_safeguard: 'Thêm biện pháp bảo vệ',
            responsible_party: 'Bên chịu trách nhiệm',
            responsible_party_placeholder: 'Hoặc nhập tên thủ công',
            responsible: 'Người chịu trách nhiệm',
            implementation_date: 'Ngày thực hiện',
            implementation: 'Thực hiện',
            expiry_date: 'Ngày hết hạn',
            expiry: 'Hết hạn',
            expire: 'Hết hạn',
            activate_unavailable_expired: 'Biện pháp bảo vệ đã hết hạn không thể kích hoạt lại. Hãy ghi nhận một biện pháp bảo vệ mới.',
            no_safeguards: 'Không tìm thấy biện pháp bảo vệ.',
            no_transfers: 'Không tìm thấy đánh giá chuyển dữ liệu.',
            fetch_error: 'Không thể tải đánh giá chuyển dữ liệu. Vui lòng thử lại.',
            save_error: 'Không thể lưu đánh giá chuyển dữ liệu. Vui lòng thử lại.',
            submit_review_error: 'Không thể gửi để xem xét. Vui lòng thử lại.',
            decision_error: 'Không thể xử lý quyết định. Vui lòng thử lại.',
            deprecate_error: 'Không thể ngừng sử dụng đánh giá. Vui lòng thử lại.',
            risk_eval_error: 'Không thể đánh giá rủi ro. Vui lòng thử lại.',
            fetch_safeguards_error: 'Không thể tải biện pháp bảo vệ. Vui lòng thử lại.',
            save_safeguard_error: 'Không thể lưu biện pháp bảo vệ. Vui lòng thử lại.',
            update_safeguard_status_error: 'Không thể cập nhật trạng thái biện pháp bảo vệ. Vui lòng thử lại.',
            safeguard_type_encryption_in_transit: 'Mã hóa khi truyền',
            safeguard_type_encryption_at_rest: 'Mã hóa khi lưu trữ',
            safeguard_type_access_controls: 'Kiểm soát truy cập',
            safeguard_type_contractual_clauses: 'Điều khoản hợp đồng',
            safeguard_type_data_minimization: 'Tối thiểu hóa dữ liệu',
            safeguard_type_pseudonymization: 'Giả danh hóa',
            safeguard_type_audit_rights: 'Quyền kiểm toán',
            safeguard_type_breach_notification: 'Thông báo vi phạm',
            safeguard_type_data_localization: 'Địa phương hóa dữ liệu',
            safeguard_type_other: 'Khác',
            activate: 'Kích hoạt',
            all_statuses: 'Tất cả trạng thái',
            any: 'Bất kỳ',
            mechanism_detail: 'Chi tiết cơ chế',
            safeguard_types: {
                encryption_in_transit: 'Mã hóa khi truyền',
                encryption_at_rest: 'Mã hóa khi lưu trữ',
                access_controls: 'Kiểm soát truy cập',
                contractual_clauses: 'Điều khoản hợp đồng',
                data_minimization: 'Tối thiểu hóa dữ liệu',
                pseudonymization: 'Giả danh hóa',
                audit_rights: 'Quyền kiểm toán',
                breach_notification: 'Thông báo vi phạm',
                data_localization: 'Nội địa hóa dữ liệu',
                other: 'Khác',
            },
            activity_ids_placeholder: 'Mã hoạt động xử lý (tùy chọn)',
            deprecate_hint: 'Ngừng sử dụng đánh giá này mà không xóa',
            file_dossier: 'Nộp hồ sơ',
            file_dossier_hint: 'Bắt đầu một hồ sơ nộp cơ quan quản lý từ đánh giá này',
            mark_implemented: 'Triển khai',
            mark_verified: 'Xác minh',
            mechanism_detail_placeholder: 'ví dụ: hợp đồng hoặc văn bản làm cơ sở cho việc chuyển dữ liệu',
            purpose_placeholder: 'ví dụ: CRM, phân tích, hỗ trợ',
            csv_hint: '(phân tách bằng dấu phẩy)',
            data_subjects_placeholder: 'ví dụ: nhân viên, khách hàng',
            data_types_placeholder: 'ví dụ: tên, email, số điện thoại',
            from_country_placeholder: 'ví dụ: EU',
            to_country_placeholder: 'ví dụ: Hoa Kỳ',
            recipient_placeholder: 'ví dụ: Salesforce Inc.',
            reviewers_placeholder: 'Chọn người rà soát…',
            risk_eval_hint: 'Chấm điểm mức nhạy cảm của dữ liệu, quốc gia và biện pháp bảo vệ',
            section_mechanism: 'Cơ chế và dữ liệu',
            section_review: 'Rà soát và phê duyệt',
            section_route: 'Tuyến chuyển dữ liệu',
        },
        gap_report: {
            page_title: 'Báo cáo thiếu sót đánh giá',
            announce_loaded: 'Báo cáo thiếu sót đã tải. Tìm thấy {count} thiếu sót',
            aria_activities_without_dpia: 'Hoạt động chưa có đánh giá DPIA',
            // Sprint 44.7.0 — phần chưa phân loại yêu cầu DPIA
            aria_activities_unclassified: 'Hoạt động chưa phân loại yêu cầu DPIA',
            activities_unclassified_section_title: 'Hoạt động chưa phân loại yêu cầu DPIA',
            activities_unclassified_description: 'Những hoạt động này chưa được xem xét để xác định có bắt buộc phải thực hiện DPIA hay không. Hãy phân loại từng hoạt động để xử lý cảnh báo này.',
            activities_unclassified_empty: 'Tất cả hoạt động đang vận hành đã được phân loại.',
            aria_unmitigated_risks: 'Rủi ro cao và nghiêm trọng chưa được giảm thiểu',
            aria_transfers_without_safeguards: 'Chuyển giao thiếu biện pháp bảo vệ',
            aria_expired_assessments: 'Đánh giá hết hạn cần gia hạn',
            title: 'Báo cáo lỗi đánh giá',
            no_dpia: 'Hoạt động chưa có DPIA',
            no_assessment: 'Chuyển dữ liệu chưa có đánh giá',
            unmitigated: 'DPIA có rủi ro chưa giảm thiểu',
            activity_id: 'Mã hoạt động',
            dpia_id: 'Mã DPIA',
            assessment_id: 'Mã đánh giá',
            expired_assessments: 'Đánh giá hết hạn',
            no_gaps_activities: 'Không có lỗi. Tất cả hoạt động đều có DPIA.',
            no_unmitigated_risks: 'Không có rủi ro cao/nghiêm trọng chưa giảm thiểu.',
            no_gaps_safeguards: 'Không có lỗi. Tất cả chuyển dữ liệu đều có biện pháp bảo vệ.',
            no_expired: 'Không có đánh giá hết hạn.',
            no_report_data: 'Không có dữ liệu báo cáo lỗi.',
            fetch_error: 'Không thể tải báo cáo lỗi. Vui lòng thử lại.',
            no_expired_assessments: 'Không có đánh giá hết hạn.',
            no_gaps_dpia: 'Không tìm thấy khoảng trống DPIA.',
            no_data: 'Không có dữ liệu.',
            all_clear: 'Không phát hiện khoảng trống tuân thủ nào.',
            list_truncated_notice: 'Chỉ liệt kê 50 hoạt động đầu tiên; còn nhiều hoạt động khác khớp. Hãy xử lý các hoạt động này, rồi tải lại báo cáo để xem phần còn lại.',
            subtitle: 'Xác định các thiếu sót tuân thủ trong DPIA, rủi ro, chuyển giao dữ liệu và các đánh giá.',
        },
        dossier_filings: {
            // fix-sprint-20260905-2135 F33/F34 — keys that tKey() call sites asked for and
            // no locale declared, so each fell through to its hardcoded English third
            // argument and rendered English in all 16 locales. The two DPIA row-action
            // tooltips were worse: their fallbacks are themselves translated keys, so the
            // primary CTA read 'Edit' where the code intends 'Continue', and the in-review
            // action read 'Approve/Reject' where it intends 'Review'.
            aria_filters: 'Lọc hồ sơ nộp',
            description_placeholder: 'Tóm tắt về hồ sơ này (không bắt buộc)',
            title_placeholder: 'Ví dụ: Hồ sơ DPIA – Phụ lục I',
            page_title_detail: 'Chi tiết hồ sơ nộp',
            page_title_list: 'Danh sách hồ sơ nộp',
            announce_filings_found: 'Tìm thấy {count} hồ sơ',
            announce_results: '{count} kết quả',
            aria_filter_by_status: 'Lọc theo trạng thái',
            title: 'Danh sách hồ sơ nộp',
            nav_label: 'Hồ sơ nộp',
            create: 'Tạo hồ sơ nộp',
            form_type: 'Loại biểu mẫu',
            phu_luc_i_label: 'Quy trình đánh giá tiêu chuẩn (nội bộ)',
            phu_luc_ii_label: 'Quy trình đánh giá xuyên biên giới / rủi ro cao (nội bộ)',
            dpia_reference: 'Tham chiếu DPIA',
            transfer_reference: 'Tham chiếu đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới',
            transfer_select_placeholder: 'Liên kết tới một đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới',
            arrived_parent_heading: 'Nộp hồ sơ cho',
            prior_filing_heading: 'Tổ chức đã nộp hồ sơ này',
            prior_filing_body: 'Khung tuân thủ đã cài đặt quy định mỗi tổ chức có một hồ sơ thuộc loại này, sau đó được cập nhật ({citation}). Tổ chức đã nộp một hồ sơ: {filing}. Khi phát sinh mục đích mới hoặc thay đổi khác về nội dung hồ sơ, hãy bắt đầu Thông báo thay đổi nội dung hồ sơ trên đánh giá này. Bạn vẫn có thể mở một hồ sơ nộp lần đầu, chẳng hạn để nộp lại sau khi cơ quan chuyên trách bảo vệ dữ liệu cá nhân đánh giá hồ sơ trước đó không đạt yêu cầu.',
            prior_filing_start_update: 'Bắt đầu cập nhật: {form}',
            prior_filing_no_update_form: 'Chưa cài đặt biểu mẫu cập nhật cho loại hồ sơ này.',
            arrived_parent_loading: 'Đang tra cứu hồ sơ đánh giá…',
            arrived_parent_unresolved: 'Không tìm thấy hồ sơ đánh giá mà hồ sơ nộp này được khởi tạo từ đó. Hồ sơ đánh giá có thể đã bị xoá hoặc thuộc về một tổ chức khác. Hãy chọn hồ sơ đánh giá gốc bên dưới trước khi nộp.',
            parent_none: 'Chưa liên kết hồ sơ đánh giá nào',
            parent_unresolved: 'không tìm thấy bản ghi được liên kết ({id})',
            error_parent_required: 'Hãy chọn hồ sơ đánh giá mà hồ sơ nộp này thực hiện nghĩa vụ — đánh giá tác động xử lý dữ liệu cá nhân hoặc đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới.',
            error_transfer_parent_not_found: 'Đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới mà hồ sơ nộp này tham chiếu không còn tồn tại. Hãy chọn hồ sơ khác, hoặc mở lại hồ sơ nộp từ sổ đăng ký chuyển dữ liệu cá nhân xuyên biên giới.',
            error_dpia_parent_not_found: 'Đánh giá tác động xử lý dữ liệu cá nhân mà hồ sơ nộp này tham chiếu không còn tồn tại. Hãy chọn hồ sơ khác.',
            submitted_date: 'Ngày nộp',
            outcome: 'Kết quả',
            parent_filing: 'Hồ sơ gốc',
            no_filings: 'Không tìm thấy hồ sơ nộp.',
            fetch_error: 'Không thể tải hồ sơ nộp. Vui lòng thử lại.',
            save_error: 'Không thể tạo hồ sơ nộp. Vui lòng thử lại.',
            created: 'Đã tạo hồ sơ nộp.',
            loaded: 'Đã tải hồ sơ nộp.',
            not_found: 'Không tìm thấy hồ sơ nộp.',
            back_to_list: 'Quay lại danh sách',
            section_assignments: 'Phân công phần',
            assign_sections: 'Phân công phần',
            section_id: 'Phần',
            department: 'Phòng ban',
            assignee: 'Người được giao',
            deadline: 'Hạn chót',
            no_assignments: 'Chưa có phân công phần nào.',
            sections_assigned_msg: 'Đã phân công phần.',
            assign_error: 'Không thể phân công phần. Vui lòng thử lại.',
            lifecycle: 'Vòng đời hồ sơ',
            submission: 'Chi tiết nộp hồ sơ',
            submission_channel: 'Kênh nộp hồ sơ',
            confirmation_number: 'Số xác nhận',
            // Fix sprint #447 (round 2) — the Submit dialog offers the declared channels.
            select_channel: 'Chọn kênh',
            submission_note: 'Mục này ghi nhận việc nộp mà tổ chức của bạn đã thực hiện. Nền tảng không nộp bất kỳ hồ sơ nào cho cơ quan có thẩm quyền.',
            channels_load_failed: 'Không đọc được các kênh nộp.',
            channel_refusal_no_framework: 'Không có khung tuân thủ đã cài đặt nào khai báo việc nộp hồ sơ cho cơ quan có thẩm quyền, nên không thể ghi nhận việc nộp.',
            channel_refusal_no_channels: 'Khung tuân thủ điều chỉnh việc nộp hồ sơ không khai báo kênh nộp nào, nên không thể ghi nhận việc nộp.',
            channel_refusal_no_authority: 'Khung tuân thủ điều chỉnh việc nộp hồ sơ không nêu cơ quan nào tiếp nhận hồ sơ, nên không thể ghi nhận việc nộp.',
            status_submitted: 'Đã nộp — chưa ghi nhận kết quả',
            submit_for_review: 'Gửi để rà soát',
            submitted_for_review: 'Đã gửi để xem xét nội bộ.',
            submit_review_error: 'Không thể gửi để xem xét. Vui lòng thử lại.',
            legal_signoff: 'Ký duyệt pháp lý',
            legal_signoff_done: 'Đã hoàn thành ký duyệt pháp lý.',
            legal_signoff_error: 'Không thể hoàn thành ký duyệt pháp lý. Vui lòng thử lại.',
            approve: 'Phê duyệt nội bộ',
            approved_msg: 'Đã phê duyệt hồ sơ trong nội bộ. Hồ sơ chưa được nộp cho cơ quan có thẩm quyền.',
            approve_error: 'Không thể phê duyệt hồ sơ. Vui lòng thử lại.',
            // Sprint 44.4.0 — trạng thái tạo tài liệu nộp + thử lại
            materialisation_status_column: 'Tài liệu nộp',
            materialisation_na: 'Không áp dụng',
            materialisation_pending: 'Chờ xử lý',
            materialisation_success: 'Đã tạo',
            materialisation_failed: 'Không thành công',
            materialisation_banner_title: 'Không thể tạo tài liệu nộp',
            materialisation_banner_body: 'Hồ sơ đã được phê duyệt nội bộ, nhưng bản ghi dossier làm nền không tạo được. Thư xin phép và bản xuất nộp sẽ không khả dụng cho đến khi bạn thử lại.',
            materialisation_retry_button: 'Thử lại',
            materialisation_retry_count: 'Số lần thử lại trước đây:',
            materialisation_retry_success: 'Đã tạo tài liệu nộp thành công.',
            materialisation_retry_announce: 'Thử lại thành công',
            filter_materialisation_failed: 'Chỉ hiển thị các trường hợp lỗi tạo tài liệu',
            column_title: 'Tiêu đề',
            column_form_type: 'Biểu mẫu',
            submit_to_mps: 'Ghi nhận việc nộp cho cơ quan có thẩm quyền',
            submitted_to_mps_msg: 'Đã ghi nhận việc tổ chức của bạn nộp hồ sơ cho cơ quan có thẩm quyền.',
            submit_mps_error: 'Không thể ghi nhận việc nộp cho cơ quan có thẩm quyền. Vui lòng thử lại.',
            supplement_request: 'Yêu cầu bổ sung',
            supplement_requests: 'Yêu cầu bổ sung',
            supplement_response: 'Phản hồi bổ sung',
            record_supplement: 'Ghi nhận yêu cầu bổ sung',
            supplement_recorded: 'Đã ghi nhận yêu cầu bổ sung.',
            supplement_absence_declaring_framework_unreadable: 'Không có thời hạn: không đọc được khung tuân thủ quy định thời hạn này.',
            supplement_absence_declaring_framework_not_in_force: 'Không có thời hạn: khung tuân thủ quy định thời hạn này chưa có hiệu lực.',
            supplement_absence_uncomputable_period: 'Không có thời hạn: không thể tính thời hạn đã cài đặt thành một ngày cụ thể.',
            supplement_absence_multiple_candidate_clocks: 'Không có thời hạn: có nhiều thời hạn đã cài đặt có thể áp dụng và nền tảng không tự chọn. Hãy nhập thời hạn nêu trong văn bản của cơ quan.',
            supplement_absence_no_installed_clock: 'Không có thời hạn: không có khung tuân thủ đã cài đặt nào quy định thời hạn phản hồi.',
            supplement_absence_receipt_not_evidenced: 'Không có thời hạn: chưa ghi nhận ngày người nộp hồ sơ nhận được kết quả của cơ quan.',
            supplement_absence_declaring_framework_reference_mode: 'Không có thời hạn: khung tuân thủ quy định thời hạn này được cài đặt ở chế độ Chỉ tham khảo nên không chạy bộ đếm thời hạn.',
            supplement_absence_declaring_framework_not_operational: 'Không có thời hạn: khung tuân thủ quy định thời hạn này đã được thay thế hoặc ngừng áp dụng nên không còn đặt ra thời hạn.',
            supplement_deadline_warning_differs_from_installed: 'Ngày bạn nhập rơi vào một ngày khác với ngày theo thời hạn đã cài đặt. Ngày nêu trong văn bản của cơ quan được giữ nguyên.',
            supplement_deadline_warning_in_the_past: 'Ngày bạn nhập đã qua tại thời điểm được ghi nhận.',
            supplement_deadline_platform_estimate: 'Ước tính của nền tảng được ghi nhận trước đây: không phải thời hạn do khung tuân thủ đã cài đặt hay văn bản của cơ quan nêu.',
            supplement_deadline_installed_due: 'Theo thời hạn đã cài đặt, ngày này là {date}.',
            supplement_deadline_none: 'Chưa ghi nhận thời hạn cho yêu cầu này.',
            supplement_deadline_source_unknown: 'Chưa ghi nhận nguồn của thời hạn này',
            supplement_deadline_source_operator_anon: 'Nêu trong văn bản của cơ quan; do một người dùng nhập',
            supplement_deadline_source_operator: 'Nêu trong văn bản của cơ quan; do {user} nhập',
            supplement_deadline_source_installed: 'Tính từ ngày nhận, theo thời hạn quy định trong khung tuân thủ đã cài đặt',
            supplement_response_received: 'Đã phản hồi',
            supplement_response_pending: 'Đang chờ phản hồi',
            supplement_response_deadline: 'Hạn phản hồi',
            supplement_items_requested: 'Nội dung yêu cầu',
            supplement_received_future: 'Ngày nhận không được nằm trong tương lai.',
            supplement_deadline_help: 'Thời hạn hoàn thiện hồ sơ được tính từ một văn bản tổ chức bạn đã ghi nhận, khi bạn xác nhận văn bản đó yêu cầu hoàn thiện hồ sơ, hoặc nêu hồ sơ chưa đầy đủ, chưa hợp lệ hoặc chưa đúng quy định. Khi có thời hạn nêu trong văn bản của cơ quan, nền tảng ghi nhận thời hạn đó cùng người nhập. Nếu không có cả hai, yêu cầu không có thời hạn và trang sẽ nêu lý do.',
            supplement_response_deadline_input: 'Thời hạn nêu trong văn bản của cơ quan (không bắt buộc)',
            supplement_received_at: 'Ngày người nộp hồ sơ nhận được kết quả của cơ quan',
            supplement_items: 'Nội dung cơ quan yêu cầu bổ sung (mỗi dòng một nội dung)',
            supplement_error: 'Không thể ghi nhận yêu cầu bổ sung. Vui lòng thử lại.',
            submit_supplement: 'Gửi phản hồi bổ sung',
            supplement_submitted_msg: 'Đã gửi phản hồi bổ sung.',
            supplement_submit_error: 'Không thể gửi phản hồi bổ sung. Vui lòng thử lại.',
            response_status: 'Trạng thái phản hồi',
            response_notes: 'Ghi chú phản hồi',
            resubmit: 'Nộp lại',
            resubmitted_msg: 'Đã nộp lại hồ sơ.',
            resubmit_error: 'Không thể nộp lại hồ sơ. Vui lòng thử lại.',
            outcome_error: 'Không thể ghi nhận kết quả. Vui lòng thử lại.',
            accepted: 'Chấp nhận',
            rejected: 'Không chấp nhận',
            close: 'Đóng',
            closed_msg: 'Đã đóng hồ sơ.',
            close_error: 'Không thể đóng hồ sơ. Vui lòng thử lại.',
            change_filing: 'Thay đổi hồ sơ nộp này',
            change_filing_created: 'Đã tạo bản sửa đổi hồ sơ nộp.',
            change_filing_error: 'Không thể tạo hồ sơ thay đổi. Vui lòng thử lại.',
            change_reason: 'Lý do thay đổi',
            filing_lineage: 'Lịch sử hồ sơ',
            timers: 'Bộ hẹn giờ hoạt động',
            timer_mps_review: 'Xem xét của cơ quan có thẩm quyền',
            timer_supplement_response: 'Hạn bổ sung',
            timer_resubmission_review: 'Hạn nộp lại',
            timer_department_input: 'Hạn phòng ban',
            days_remaining: 'ngày còn lại',
            days_overdue: 'ngày quá hạn',
            cover_letter: 'Thư xin phép',
            checklist: 'Danh mục kiểm tra',
            evidence_index: 'Chỉ mục bằng chứng',
            status_draft: 'Bản nháp',
            status_internal_review: 'Xem xét nội bộ',
            status_legal_signoff: 'Ký duyệt pháp lý',
            status_approved: 'Đã phê duyệt nội bộ — chưa nộp',
            status_supplement_requested: 'Yêu cầu bổ sung',
            status_supplement_submitted: 'Đã gửi bổ sung',
            status_resubmitted: 'Đã nộp lại',
            status_accepted: 'Đã ghi nhận kết quả: Chấp nhận',
            status_rejected: 'Đã ghi nhận kết quả: Không chấp nhận',
            status_closed: 'Đã đóng',
            // Sprint 62.57.0 (gate E12.5 pass 1) — tên các bước trên thanh vòng đời hồ sơ.
            step_draft: 'Bản nháp',
            step_internal_review: 'Xem xét nội bộ',
            step_legal_signoff: 'Ký duyệt pháp lý',
            step_approved: 'Đã phê duyệt nội bộ',
            step_submitted: 'Đã nộp',
            step_supplement_requested: 'Yêu cầu bổ sung',
            step_supplement_submitted: 'Đã gửi bổ sung',
            step_resubmitted: 'Đã nộp lại',
            step_accepted: 'Đã ghi nhận kết quả: Chấp nhận',
            step_rejected: 'Đã ghi nhận kết quả: Không chấp nhận',
            step_closed: 'Đã đóng',
            linked_dpia: 'DPIA liên kết',
            linked_dpia_none: 'Không có DPIA nào được liên kết với hồ sơ này.',
            view_linked_dpia: 'Xem DPIA',
            linked_dpia_label: 'Hồ sơ nộp này được liên kết với DPIA sau:',
            all_sections_must_complete: 'Tất cả các phần phải được hoàn thành hoặc rà soát trước khi nộp',
            change_section_status: 'Đổi trạng thái cho',
            dpia_select_placeholder: 'Liên kết tới một hồ sơ đánh giá tác động xử lý dữ liệu cá nhân (tùy chọn)',
            no_departments_hint: 'Không có phòng ban nào. Bạn vẫn có thể giao việc bằng cách chọn một người dùng bên dưới.',
            no_users_hint: 'Không tải được danh sách người dùng. Vui lòng kiểm tra kết nối và thử lại.',
            phu_luc_i_hint: 'Nhóm quy trình nội bộ. Thông báo nộp hồ sơ xử lý chính thức dùng Mẫu số 02a cho tổ chức và 02b cho cá nhân, kèm báo cáo 10; thông báo chuyển dữ liệu xuyên biên giới dùng 01a/01b, kèm báo cáo 09. Chọn biểu mẫu chính thức riêng.',
            phu_luc_ii_hint: 'Nhóm quy trình nội bộ. Thông báo nộp hồ sơ xử lý chính thức dùng Mẫu số 02a cho tổ chức và 02b cho cá nhân, kèm báo cáo 10; thông báo chuyển dữ liệu xuyên biên giới dùng 01a/01b, kèm báo cáo 09. Chọn biểu mẫu chính thức riêng.',
            section_add_new: 'Thêm phần mới...',
            section_assignments_explanation: 'Giao các phần của hồ sơ nộp này cho các phòng ban để hoàn thành. Mỗi phần được giao sẽ tạo một nhiệm vụ kèm thời hạn cho người được giao. Tất cả các phần phải hoàn thành trước khi hồ sơ chuyển sang rà soát nội bộ.',
            section_consultation: 'Tham vấn và các bên liên quan',
            section_custom_placeholder: 'Nhập tên phần tùy chỉnh',
            section_data_categories: 'Loại dữ liệu và hoạt động xử lý',
            section_data_subject_rights: 'Quyền của chủ thể dữ liệu',
            section_impact_assessment: 'Đánh giá tác động',
            section_legal_basis: 'Cơ sở pháp lý và tính cần thiết',
            section_risk_mitigation: 'Biện pháp giảm thiểu rủi ro',
            section_status_label: 'Trạng thái phần',
            section_status_updated: 'Trạng thái phần đã đổi thành',
            transition_to: 'Chuyển sang...',
            view_filing: 'Xem',
            linked_parents: 'Hồ sơ đánh giá đã liên kết',
            linked_parents_none: 'Hồ sơ nộp này không nêu hồ sơ đánh giá nào.',
            parent_kind_dpia: 'Đánh giá tác động xử lý dữ liệu cá nhân',
            parent_kind_transfer: 'Đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới',
            // Sprint 63.37.0 (Stream J) — the forms a filing files, and the dossier assembled from it.
            filing_forms: 'Biểu mẫu của hồ sơ nộp',
            filing_forms_none: 'Hồ sơ nộp này chưa liên kết biểu mẫu nào.',
            filing_forms_failed: 'Không thể đọc biểu mẫu của hồ sơ nộp này.',
            filing_form_label: 'Biểu mẫu hồ sơ nộp ghi nhận',
            assembled_dossier: 'Hồ sơ đã tập hợp {reference}',
            dossier_role_primary_application: 'Biểu mẫu chính của hồ sơ',
            dossier_role_supporting_document: 'Tài liệu kèm theo',
            dossier_role_authority_response: 'Phản hồi của cơ quan',
            dossier_role_supplement: 'Hồ sơ bổ sung',
            // Sprint 63.37.0 (Stream K, UC-VN-01) — the person who recorded the submission; the platform records, the organisation files.
            submission_recorded_by: 'Người ghi nhận',
            submission_notes: 'Ghi chú',
            // Sprint 63.37.0 (Stream K, UC-VN-01) — the four section statuses (DossierSectionStatus); the table printed the stored code.
            section_status_assigned: 'Đã giao',
            section_status_in_progress: 'Đang thực hiện',
            section_status_completed: 'Đã hoàn thành',
            section_status_reviewed: 'Đã xem xét',
            timer_estimate_passed: 'Quá ước tính {days} ngày',
            timer_platform_estimate: 'Ước tính của nền tảng — không phải thời hạn theo quy định',
            reload: 'Tải lại',
            reloading: 'Đang tải lại…',
            timers_load_failed: 'Không đọc được các bộ hẹn giờ của hồ sơ nên chưa hiển thị bộ nào. Điều này không có nghĩa là hồ sơ không có bộ hẹn giờ.',
            retry_subject_timers: 'các bộ hẹn giờ của hồ sơ',
            lineage_load_failed: 'Không đọc được lịch sử hồ sơ nên chưa hiển thị các hồ sơ trước và sau.',
            retry_subject_lineage: 'lịch sử hồ sơ',
            form_status_load_failed: 'Không đọc được trạng thái các biểu mẫu nên cột Biểu mẫu có thể chưa đầy đủ.',
            form_status_not_read: 'Chưa đọc được',
            retry_subject_form_status: 'trạng thái biểu mẫu',
            supplement_absence_declaring_framework_phase_reference_unresolved: 'Không có thời hạn: thời hạn áp dụng từ một giai đoạn của khung tuân thủ, và khung tuân thủ không xác định ngày của giai đoạn đó.',
            // Sprint 62.57.0 (Slice R) — authority communications on a filing, recorded as
            // documents; the limitation notice; the latest-communication column and filter.
            result_recorded_qualifier: 'theo ghi nhận của tổ chức bạn từ thông báo của cơ quan',
            limitation_heading: 'Những gì ComplianceOne ghi nhận về cơ quan có thẩm quyền',
            limitation_body: 'ComplianceOne ghi nhận các văn bản của cơ quan có thẩm quyền dưới dạng tài liệu, và ghi nhận cơ quan xử lý hồ sơ, kết quả, yêu cầu hoàn thiện hồ sơ (nếu có) theo nội dung tổ chức bạn nêu từ các văn bản của cơ quan, cũng như nơi nộp và cơ quan có thẩm quyền giải quyết hồ sơ cập nhật theo ghi nhận của tổ chức bạn. Ngày kết thúc thời hạn hoàn thiện hồ sơ là ngày tạm tính khi sự kiện bắt đầu tính thời hạn theo văn bản áp dụng còn chờ xác nhận pháp lý, và ComplianceOne không bao giờ tự xác định cơ quan nào xử lý hồ sơ hoặc hồ sơ cập nhật.',
            comms_heading: 'Văn bản của cơ quan có thẩm quyền',
            comms_intro: 'Các văn bản tổ chức của bạn nhận được từ cơ quan có thẩm quyền về hồ sơ này, theo ghi nhận của một người trong tổ chức. Việc ghi nhận văn bản không thay đổi nội dung nào khác của hồ sơ: không thay đổi trạng thái, kết quả hay thời hạn.',
            comms_record: 'Ghi nhận văn bản',
            comms_export: 'Xuất văn bản đã ghi nhận',
            comms_export_done: 'Đã xuất các văn bản đã ghi nhận.',
            comms_export_failed: 'Không thể xuất các văn bản đã ghi nhận.',
            comms_none: 'Chưa có văn bản nào được ghi nhận cho hồ sơ này.',
            comms_loading: 'Đang tải các văn bản…',
            comms_load_failed: 'Không đọc được các văn bản nên không có văn bản nào được hiển thị. Điều này không có nghĩa là chưa có văn bản nào được ghi nhận.',
            retry_subject_comms: 'các văn bản của cơ quan',
            comms_pagination: 'Các trang văn bản của cơ quan',
            comms_col_kind: 'Loại văn bản',
            comms_col_sender: 'Cơ quan gửi',
            comms_col_communication_date: 'Ngày văn bản',
            comms_col_received_at: 'Ngày nhận',
            comms_col_wording: 'Nội dung nguyên văn của cơ quan',
            comms_col_evidence: 'Tài liệu chứng minh',
            comms_col_correction: 'Đính chính',
            comms_col_recorded: 'Ghi nhận',
            comms_row_statement: 'Do {person} ghi nhận từ văn bản của cơ quan — ComplianceOne chưa xác minh nội dung này.',
            comms_reference: 'Số, ký hiệu: {reference}',
            comms_stated_items: 'Các nội dung văn bản nêu',
            comms_stated_period: 'Thời hạn văn bản nêu: {period}',
            comms_notes: 'Ghi chú: {notes}',
            comms_no_wording: 'Chưa ghi nhận nội dung',
            comms_not_evidenced: 'Chưa có tài liệu chứng minh',
            comms_evidence_count: '{count} tệp',
            comms_evidence_open: 'Tệp',
            comms_evidence_open_label: 'Tệp tài liệu chứng minh của văn bản nhận ngày {date}',
            comms_evidence_load_failed: 'Không đọc được các tệp tài liệu chứng minh.',
            comms_corrects: 'Đính chính mục ghi nhận ngày {date}',
            comms_corrects_unknown: 'Đính chính một mục ghi nhận trước',
            comms_corrected_by: 'Đã được đính chính bởi một mục ghi nhận sau',
            comms_export_corrects: 'Đính chính mục ghi nhận văn bản nhận ngày {date} ({kind})',
            comms_export_corrected_by: 'Đã được đính chính bởi một mục ghi nhận sau (văn bản nhận ngày {date})',
            comms_correction_note: 'Lý do: {note}',
            comm_kind_receipt_acknowledgement: 'Văn bản xác nhận đã tiếp nhận',
            comm_kind_transfer_notice: 'Thông báo chuyển hồ sơ',
            comm_kind_result_notice: 'Thông báo kết quả',
            comm_kind_supplement_request: 'Yêu cầu bổ sung hồ sơ',
            comm_kind_refusal: 'Văn bản từ chối',
            comm_kind_other_written_communication: 'Văn bản khác',
            comms_form_intro: 'Ghi nhận văn bản cơ quan đã gửi, đúng như nội dung văn bản. Việc ghi nhận này không thay đổi trạng thái, kết quả hay thời hạn nào của hồ sơ.',
            comms_form_evidence_hint: 'Tệp tài liệu chứng minh được đính kèm sau khi ghi nhận văn bản, từ dòng tương ứng trong lịch sử.',
            comms_field_kind: 'Loại văn bản',
            comms_field_kind_placeholder: 'Chọn loại văn bản',
            comms_field_sender: 'Cơ quan gửi, theo tên ghi trên văn bản',
            comms_field_reference: 'Số, ký hiệu văn bản',
            comms_field_communication_date: 'Ngày ghi trên văn bản',
            comms_field_received_at: 'Ngày tổ chức của bạn nhận được văn bản',
            comms_field_wording: 'Nội dung nguyên văn của cơ quan',
            comms_field_wording_hint: 'Tối đa {max} ký tự. Bắt buộc đối với thông báo kết quả hoặc văn bản từ chối.',
            comms_field_wording_count: 'Đã dùng {count}/{max} ký tự',
            comms_field_items: 'Các nội dung văn bản nêu',
            comms_field_item: 'Nội dung {n}',
            comms_add_item: 'Thêm nội dung',
            comms_remove_item: 'Xóa nội dung {n}',
            comms_items_none: 'Chưa thêm nội dung nào.',
            comms_field_period: 'Thời hạn văn bản nêu, ghi nguyên văn',
            comms_field_period_hint: 'Được ghi nhận nguyên văn. Hệ thống không tính thời hạn nào từ nội dung này.',
            comms_field_notes: 'Ghi chú nội bộ',
            comms_field_corrects: 'Đính chính một mục ghi nhận trước',
            comms_field_corrects_none: 'Không phải đính chính',
            comms_field_corrects_option: '{kind}, nhận ngày {date}',
            comms_field_corrects_truncated: 'Chỉ liệt kê {count} mục ghi nhận gần nhất.',
            comms_field_corrects_failed: 'Không đọc được các mục ghi nhận trước nên không thể chọn mục nào.',
            comms_field_correction_note: 'Lý do đính chính mục ghi nhận trước',
            comms_error_required: 'Hãy nhập thông tin này trước khi ghi nhận.',
            comms_error_kind_required: 'Hãy chọn loại văn bản.',
            comms_error_wording_required: 'Hãy nhập nội dung nguyên văn của cơ quan đối với thông báo kết quả hoặc văn bản từ chối.',
            comms_error_correction_note_required: 'Hãy nêu lý do đính chính mục ghi nhận trước.',
            comms_error_receipt_invalid: 'Ngày nhận không được sau ngày hôm nay theo múi giờ của tổ chức bạn.',
            comms_error_not_submitted: 'Hồ sơ này chưa được nộp nên chưa thể ghi nhận văn bản. Trang đã cập nhật lại thông tin hồ sơ; nội dung bạn đã nhập vẫn được giữ nguyên.',
            comms_record_failed: 'Không thể ghi nhận văn bản. Nội dung bạn đã nhập vẫn được giữ nguyên.',
            comms_recorded: 'Đã ghi nhận văn bản.',
            comms_recording: 'Đang ghi nhận…',
            comms_files_heading: 'Tệp tài liệu chứng minh',
            comms_files_intro: 'Các tệp làm căn cứ cho văn bản này, do tổ chức của bạn đính kèm. ComplianceOne chưa xác minh các tệp này.',
            comms_files_slot: 'Tệp của văn bản này',
            comms_files_none: 'Chưa đính kèm tệp nào. Văn bản này chưa có tài liệu chứng minh.',
            comms_file_hash: 'SHA-256: {hash}',
            comms_file_not_held: 'Tệp không còn được lưu giữ',
            comms_file_download: 'Tải xuống',
            comms_file_remove: 'Gỡ bỏ',
            comms_file_upload: 'Đính kèm tệp',
            comms_file_bound: 'Đã đính kèm tệp.',
            comms_file_removed: 'Đã gỡ bỏ tệp.',
            comms_file_bind_failed: 'Không thể đính kèm tệp.',
            comms_file_remove_failed: 'Không thể gỡ bỏ tệp.',
            comms_file_not_owned: 'Không tìm thấy văn bản mà tệp này thuộc về.',
            comms_file_remove_confirm: 'Gỡ tệp này khỏi văn bản và xóa tệp?',
            latest_communication: 'Văn bản gần nhất',
            latest_communication_none: 'Chưa ghi nhận',
            latest_communication_value: '{kind}, nhận ngày {date}',
            aria_filter_by_communication: 'Lọc theo văn bản gần nhất',
            filter_communication_none: 'Chưa ghi nhận văn bản',
            comms_export_heading: 'Văn bản do tổ chức ghi nhận',
            comms_export_filing: 'Hồ sơ: {filing}',
            comms_export_entries: 'Số mục ghi nhận: {count}',
            comms_export_col_reference: 'Số, ký hiệu',
            comms_export_col_statement: 'Ghi nhận',
            comms_export_truncated: 'Chỉ gồm {shown} mục ghi nhận mới nhất trong tổng số {total} mục ghi nhận.',
            // Sprint 62.57.0 (Slices A and B) — the governing text and receipt, the handling
            // authority, the result from pack options, the post-result supplement and follow-up,
            // the provisional authority period and its legal reservation.
            status_result_recorded: 'Đã ghi nhận kết quả',
            status_result_supplement_required: 'Đã ghi nhận kết quả — cần bổ sung',
            status_result_supplement_submitted: 'Đã ghi nhận kết quả — đã nộp bổ sung',
            step_result_recorded: 'Đã ghi nhận kết quả',
            step_result_supplement_required: 'Cần bổ sung sau kết quả',
            step_result_supplement_submitted: 'Đã nộp bổ sung sau kết quả',
            timer_authority_review: 'Xem xét của cơ quan có thẩm quyền',
            timer_provisional: 'Tạm tính — chờ xác nhận pháp lý',
            timer_obligation_authority: 'Thời hạn của cơ quan, không phải của tổ chức bạn',
            timer_calendar: 'Tính theo lịch ngày làm việc, ngày nghỉ lễ, Tết của cơ quan nhà nước (lịch đã cài đặt)',
            timer_authority_stated: 'Ngày trả kết quả do cơ quan nêu',
            timer_provisional_passed: 'Đã qua thời hạn tạm tính — chưa ghi nhận kết quả',
            timer_absence_complete_receipt: 'Chưa có ngày tạm tính — chưa ghi nhận ngày tiếp nhận hồ sơ đầy đủ, hợp lệ',
            timer_absence_calendar: 'Chưa có ngày tạm tính — chưa cài đặt lịch làm việc của cơ quan nhà nước năm {year}',
            timer_absence_no_period: 'Không có thời hạn của cơ quan được khai báo',
            timer_absence_governing_text: 'Chưa có ngày tạm tính — chưa xác định văn bản áp dụng',
            timer_absence_multiple_periods: 'Chưa có ngày tạm tính — nội dung đã cài đặt khai báo nhiều thời hạn và không thời hạn nào được chọn',
            timer_absence_uncomputable: 'Chưa có ngày tạm tính — thời hạn được khai báo không thể tính thành ngày',
            timer_absence_calendar_not_declared: 'Chưa có ngày tạm tính — thời hạn được khai báo không nêu lịch để tính',
            timer_absence_calendar_unavailable: 'Chưa có ngày tạm tính — chưa cài đặt lịch làm việc của cơ quan nhà nước',
            timer_absence_reference_mode: 'Chưa có ngày tạm tính — nội dung nêu thời hạn chỉ được cài đặt để tham khảo',
            timer_absence_unreadable: 'Chưa có ngày tạm tính — không đọc được nội dung nêu thời hạn',
            timer_absence_reappraisal_not_declared: 'Không có ngày tạm tính sau khi nộp hồ sơ hoàn thiện — văn bản áp dụng không quy định',
            timer_absence_completed_receipt: 'Chưa có ngày tạm tính — chưa ghi nhận ngày cơ quan tiếp nhận hồ sơ đã hoàn thiện',
            timer_period_closed: 'Đã ghi nhận kết quả; thời hạn không còn được tính',
            timer_absence_heading: 'Xem xét của cơ quan có thẩm quyền',
            reservation_pending: 'Chờ xác nhận pháp lý',
            comm_pick_empty: 'Hồ sơ nộp này chưa có văn bản nào được ghi nhận. Hãy ghi nhận văn bản tại mục Văn bản của cơ quan có thẩm quyền trước.',
            comm_pick_failed: 'Không đọc được các văn bản của hồ sơ nộp này.',
            comm_pick_manual_label: 'Mã bản ghi văn bản',
            comm_pick_manual_hint: 'Nhập mã của một văn bản đã ghi nhận trên hồ sơ nộp này; mã sẽ được kiểm tra khi lưu.',
            comm_pick_off_list: 'Văn bản {value} (không có trong danh sách)',
            comm_pick_none: 'Không chọn văn bản',
            comm_pick_option_reference: '{kind}, nhận ngày {date}, số hiệu {reference}',
            error_communication_invalid: 'Hãy chọn một văn bản đã được ghi nhận trên hồ sơ nộp này.',
            error_corrected_entry_not_found: 'Không tìm thấy mục được đính chính trên hồ sơ nộp này. Hãy chọn lại.',
            error_entry_already_corrected: 'Mục này đã được đính chính. Hãy đính chính mục sau đó.',
            correction_target_moved: 'Mục bạn chọn đã được đính chính bằng một mục khác; giờ đây bạn đính chính mục đó. Hãy kiểm tra trước khi lưu.',
            correction_target_required: 'Hãy chọn mục được đính chính.',
            receipt_error_already_recorded: 'Đã có mục ghi nhận cùng loại tiếp nhận này. Để thay đổi, hãy đính chính mục đó.',
            error_assignee_not_in_organisation: 'Người được chọn không thuộc tổ chức của bạn. Hãy chọn người khác.',
            error_filing_changed: 'Hồ sơ nộp đã thay đổi trong khi bạn nhập thông tin. Trang đã đọc lại hồ sơ; nội dung bạn nhập vẫn được giữ. Hãy lưu lại.',
            error_not_submitted: 'Hồ sơ nộp này chưa được nộp nên không thể ghi nhận nội dung này. Trang đã cập nhật thông tin hồ sơ; nội dung bạn nhập vẫn được giữ.',
            error_field_refused: 'Giá trị này không được chấp nhận. Hãy kiểm tra lại và thử lại.',
            gov_heading: 'Văn bản áp dụng',
            gov_intro: 'Văn bản điều chỉnh hồ sơ này tại thời điểm cơ quan tiếp nhận, được xác định theo ngày tiếp nhận do tổ chức bạn ghi nhận. Văn bản này không được xác định theo ngày tạo hoặc ngày nộp hồ sơ.',
            gov_not_determined: 'Chưa xác định văn bản áp dụng — hãy ghi nhận ngày tiếp nhận hồ sơ',
            gov_reason_receipt_not_evidenced: 'Chưa ghi nhận ngày tiếp nhận hồ sơ.',
            gov_reason_no_declaration: 'Nội dung đã cài đặt không khai báo văn bản áp dụng cho loại hồ sơ này.',
            gov_reason_receipt_outside_declared_windows: 'Ngày tiếp nhận nằm ngoài mọi giai đoạn do nội dung đã cài đặt khai báo.',
            gov_reason_declaration_unreadable: 'Không đọc được nội dung khai báo đã cài đặt.',
            gov_requirement: 'Yêu cầu thực hành: {title}',
            gov_requirement_framework: 'Yêu cầu thực hành: {title} ({framework})',
            gov_receipt_date: 'Ngày tiếp nhận được dùng để xác định',
            gov_evidenced_by: 'Người ghi nhận ngày tiếp nhận',
            gov_end_label: 'Kết thúc giai đoạn này',
            gov_declared_by: 'Nguồn khai báo',
            gov_declared_by_not_installed: 'Không thuộc nội dung đã cài đặt',
            gov_review_required: 'Văn bản áp dụng đã lưu không còn khớp với nội dung khai báo đã cài đặt — cần rà soát.',
            receipt_heading: 'Việc cơ quan tiếp nhận hồ sơ',
            receipt_record: 'Ghi nhận ngày tiếp nhận',
            receipt_correct: 'Đính chính ngày tiếp nhận',
            receipt_form_intro: 'Ghi nhận ngày cơ quan tiếp nhận hồ sơ theo giấy tiếp nhận của cơ quan hoặc bằng chứng của tổ chức bạn. Ngày này quyết định văn bản áp dụng cho hồ sơ. Việc đính chính được ghi thành một mục mới; mục trước vẫn được lưu trong lịch sử.',
            receipt_field_event: 'Nội dung cơ quan tiếp nhận',
            receipt_event_dossier_received: 'Cơ quan đã tiếp nhận hồ sơ',
            receipt_event_complete_dossier_received: 'Cơ quan đã tiếp nhận hồ sơ đầy đủ, hợp lệ',
            receipt_field_received_on: 'Ngày cơ quan tiếp nhận',
            receipt_field_postmarked_on: 'Ngày đóng dấu bưu điện (hồ sơ gửi qua bưu chính)',
            receipt_field_postmarked_hint: 'Chỉ dành cho hồ sơ gửi qua bưu chính. Được lưu cùng ngày tiếp nhận và chỉ được sử dụng khi văn bản đã cài đặt tính theo dấu bưu điện.',
            receipt_field_communication: 'Văn bản làm bằng chứng (không bắt buộc)',
            receipt_field_corrects: 'Mục được đính chính',
            receipt_field_corrects_none: 'Không phải đính chính',
            receipt_corrects_option: '{event}, {date}',
            receipt_error_date_invalid: 'Ngày không được sau ngày hôm nay và phải theo đúng thứ tự: ngày đóng dấu bưu điện, ngày tiếp nhận hồ sơ, rồi ngày tiếp nhận hồ sơ đầy đủ, hợp lệ.',
            receipt_error_event_required: 'Hãy chọn nội dung cơ quan tiếp nhận.',
            receipt_error_event_mismatch: 'Mục đính chính phải ghi cùng nội dung cơ quan tiếp nhận với mục được đính chính.',
            receipt_record_failed: 'Không thể ghi nhận ngày tiếp nhận. Nội dung bạn nhập vẫn được giữ.',
            receipt_recorded: 'Đã ghi nhận ngày tiếp nhận.',
            receipt_history: 'Các mục ghi nhận ngày tiếp nhận',
            receipt_col_event: 'Sự kiện',
            receipt_col_received_on: 'Ngày tiếp nhận',
            receipt_col_postmarked_on: 'Dấu bưu điện',
            receipt_col_communication: 'Văn bản',
            receipt_col_correction: 'Đính chính',
            receipt_col_recorded: 'Ghi nhận',
            receipt_source_submission_acknowledgment: 'Lấy từ ngày cơ quan xác nhận đã tiếp nhận hồ sơ, được ghi cùng thông tin nộp hồ sơ',
            receipt_row_statement: 'Do {person} ghi nhận — ComplianceOne chưa xác minh.',
            handling_heading: 'Cơ quan xử lý hồ sơ',
            handling_intro: 'Nơi nộp hồ sơ là cơ quan được nêu trong biểu mẫu đã cài đặt. Cơ quan xử lý hồ sơ chỉ do người trong tổ chức bạn ghi nhận từ văn bản của chính cơ quan đó; ComplianceOne không tự xác định hoặc đề xuất cơ quan xử lý.',
            handling_filed_with: 'Nơi nộp hồ sơ',
            handling_filed_with_unknown: 'Biểu mẫu đã cài đặt không khai báo',
            handling_handled_by: 'Cơ quan xử lý hồ sơ',
            handling_not_known: 'Chưa rõ — chưa ghi nhận việc chuyển hồ sơ',
            handling_other_body: 'Cơ quan khác được nêu',
            handling_option_not_named: 'Cơ quan không còn được nêu trong nội dung đã cài đặt',
            handling_class_label: 'Cơ quan',
            handling_named_as: 'Tên trong văn bản',
            handling_undeclared: 'Biểu mẫu đã cài đặt cho hồ sơ nộp này không khai báo cơ quan xử lý hồ sơ, nên không thể ghi nhận tại đây.',
            handling_transfer_basis: 'Căn cứ chuyển hồ sơ',
            handling_transfer_none_stated: 'Văn bản này không quy định việc chuyển hồ sơ',
            handling_transfer_awaiting_receipt: 'Căn cứ chuyển hồ sơ sẽ hiển thị sau khi ghi nhận ngày tiếp nhận',
            handling_criteria: 'Tiêu chí chuyển hồ sơ',
            handling_may_transfer_to: 'Các cơ quan được nêu trong biểu mẫu đã cài đặt',
            handling_applies_from: 'Biểu mẫu đã cài đặt nêu nội dung này áp dụng cho hồ sơ được tiếp nhận từ ngày {date}.',
            handling_record: 'Ghi nhận cơ quan xử lý hồ sơ',
            handling_history: 'Các nội dung đã ghi nhận',
            handling_none: 'Chưa có nội dung ghi nhận nào.',
            handling_loading: 'Đang tải các nội dung ghi nhận…',
            handling_load_failed: 'Không đọc được các nội dung ghi nhận nên không có nội dung nào được hiển thị. Điều đó không có nghĩa là chưa có nội dung nào được ghi nhận.',
            retry_subject_handling: 'các nội dung ghi nhận cơ quan xử lý hồ sơ',
            handling_pagination: 'Các trang nội dung ghi nhận cơ quan xử lý hồ sơ',
            handling_col_body: 'Cơ quan',
            handling_col_basis: 'Căn cứ',
            handling_col_communication: 'Văn bản',
            handling_col_evidence: 'Tài liệu chứng minh',
            handling_col_correction: 'Đính chính',
            handling_col_recorded: 'Ghi nhận',
            handling_basis_transfer_notice: 'Thông báo chuyển hồ sơ',
            handling_basis_authority_result: 'Kết quả của cơ quan',
            handling_basis_other_written_communication: 'Văn bản khác',
            handling_source_corrected: 'Văn bản nguồn đã được đính chính — cần rà soát',
            handling_communication_value: '{kind}, nhận ngày {date}',
            handling_communication_unknown: 'Một văn bản không nằm ở trang đầu của lịch sử',
            handling_form_intro: 'Ghi nhận cơ quan xử lý hồ sơ theo tên nêu trong văn bản của cơ quan. Chọn từ các cơ quan được nêu trong biểu mẫu đã cài đặt hoặc nêu một cơ quan khác. Hệ thống không tự điền nội dung nào.',
            handling_field_basis: 'Căn cứ ghi nhận',
            handling_field_basis_placeholder: 'Chọn căn cứ',
            handling_field_communication: 'Văn bản làm căn cứ',
            handling_field_option: 'Cơ quan',
            handling_field_option_placeholder: 'Chọn cơ quan',
            handling_option_other: 'Cơ quan khác (nêu tên bên dưới)',
            handling_field_body_name: 'Tên cơ quan theo văn bản',
            handling_field_body_name_hint: 'Tối đa {max} ký tự, chép đúng theo văn bản.',
            handling_field_corrects: 'Nội dung ghi nhận được đính chính',
            handling_field_corrects_none: 'Không phải đính chính',
            handling_corrects_option: '{body}, ghi nhận ngày {date}',
            handling_error_basis_required: 'Hãy chọn căn cứ ghi nhận.',
            handling_error_option_required: 'Hãy chọn cơ quan, hoặc chọn cơ quan khác và nêu tên.',
            handling_error_option_not_declared: 'Cơ quan này không nằm trong các cơ quan được nêu trong biểu mẫu đã cài đặt. Hãy chọn cơ quan khác hoặc nêu tên như một cơ quan khác.',
            handling_record_failed: 'Không thể ghi nhận nội dung. Nội dung bạn nhập vẫn được giữ.',
            handling_recorded: 'Đã ghi nhận cơ quan xử lý hồ sơ.',
            result_heading: 'Kết quả của cơ quan',
            result_frame: 'Đã ghi nhận kết quả: {label} — theo ghi nhận của tổ chức bạn từ thông báo của cơ quan',
            result_legacy_frame: 'Đã ghi nhận kết quả: {label} — được ghi nhận trước khi kết quả được ghi theo văn bản áp dụng',
            result_none: 'Chưa ghi nhận kết quả.',
            result_label_not_installed: 'Đã ghi nhận kết quả — nhãn kết quả không có trong nội dung đã cài đặt',
            result_different_text: 'Được ghi nhận theo văn bản áp dụng khác — cần rà soát',
            result_date: 'Ngày trên thông báo',
            result_notice_received: 'Ngày tổ chức bạn nhận thông báo',
            result_communication: 'Văn bản',
            result_notes: 'Ghi chú',
            result_record: 'Ghi nhận kết quả của cơ quan',
            result_needs_receipt: 'Cần ghi nhận ngày tiếp nhận trước khi ghi nhận kết quả: các lựa chọn kết quả là của văn bản áp dụng tại thời điểm cơ quan tiếp nhận hồ sơ.',
            result_absent: 'Không có nội dung khai báo đã cài đặt nào đưa ra lựa chọn kết quả cho hồ sơ nộp này, nên không thể ghi nhận kết quả tại đây. Hãy ghi nhận thông báo của cơ quan tại mục Văn bản của cơ quan có thẩm quyền.',
            result_absent_update: 'Không ghi nhận kết quả đối với hồ sơ cập nhật. Hãy ghi nhận thông báo của cơ quan tại mục Văn bản của cơ quan có thẩm quyền.',
            result_form_intro: 'Ghi nhận kết quả theo nội dung thông báo của cơ quan. Các lựa chọn là của văn bản áp dụng tại thời điểm cơ quan tiếp nhận hồ sơ.',
            result_field_option: 'Kết quả theo thông báo',
            result_field_option_placeholder: 'Chọn kết quả',
            result_field_communication: 'Văn bản nêu kết quả',
            result_error_option_required: 'Hãy chọn kết quả nêu trong thông báo.',
            result_error_option_not_offered: 'Kết quả này không có trong các lựa chọn của văn bản áp dụng cho hồ sơ nộp này.',
            result_error_date_invalid: 'Ngày này không được sau ngày hôm nay hoặc trước ngày hồ sơ được nộp.',
            result_error_notice_before_result: 'Ngày tổ chức bạn nhận thông báo không được trước ngày trên thông báo.',
            result_error_not_determined: 'Chưa xác định văn bản áp dụng. Hãy ghi nhận ngày tiếp nhận trước.',
            result_error_declaration_absent: 'Không có nội dung khai báo đã cài đặt nào đưa ra lựa chọn kết quả cho hồ sơ nộp này.',
            result_error_status: 'Không thể ghi nhận kết quả ở trạng thái hiện tại của hồ sơ nộp. Trang đã đọc lại hồ sơ; nội dung bạn nhập vẫn được giữ.',
            result_record_failed: 'Không thể ghi nhận kết quả. Nội dung bạn nhập vẫn được giữ.',
            result_saved: 'Đã lưu kết quả.',
            result_correct: 'Sửa kết quả này',
            result_correct_intro: 'Ghi nhận lại kết quả theo đúng thông báo của cơ quan và nêu lý do. Bản ghi trước vẫn được lưu trong lịch sử. Chỉ sửa được kết quả khi đó là kết quả mới nhất, hồ sơ chưa đóng và chưa ghi nhận yêu cầu bổ sung, việc nộp bổ sung hay nội dung xử lý tiếp theo nào cho kết quả đó.',
            result_correcting_target: 'Bạn đang sửa: {result}, ngày {date}',
            result_field_correction_note: 'Lý do sửa kết quả',
            result_corrects_earlier: 'Sửa một bản ghi trước đó. Lý do: {note}',
            result_earlier_heading: 'Các bản ghi trước đó',
            result_corrected: 'Đã sửa kết quả.',
            result_error_correction_not_open: 'Không thể sửa kết quả này nữa: đây không phải là kết quả mới nhất, hồ sơ đã đóng, hoặc đã ghi nhận yêu cầu bổ sung, việc nộp bổ sung hay nội dung xử lý tiếp theo cho kết quả này. Trang đã đọc lại hồ sơ.',
            result_error_not_found: 'Không tìm thấy kết quả cần sửa trong hồ sơ nộp này. Trang đã đọc lại hồ sơ; nội dung bạn nhập vẫn được giữ.',
            result_error_already_corrected: 'Kết quả này đã được sửa bởi một bản ghi khác. Trang đang đọc lại hồ sơ.',
            result_error_correction_blocked: 'Không thể lưu từ hộp thoại này. Hãy đóng hộp thoại; nội dung bạn nhập sẽ không được ghi nhận. Nếu trang vẫn cho phép sửa, hãy bắt đầu lại từ kết quả hiện hành.',
            result_row_statement: 'Do {person} ghi nhận từ thông báo của cơ quan — ComplianceOne chưa xác minh.',
            post_result_citation: 'Quy định của văn bản áp dụng sau kết quả này: {citation}',
            stated_date_heading: 'Ngày trả kết quả do cơ quan nêu',
            stated_date_record: 'Ghi nhận ngày trả kết quả do cơ quan nêu',
            stated_date_form_intro: 'Ghi nhận ngày trả kết quả do chính cơ quan nêu trên giấy tiếp nhận hoặc trong thông báo sau đó. Ngày này thay thế ngày tạm tính. Việc đính chính được ghi thành một mục mới.',
            stated_date_field_date: 'Ngày trả kết quả nêu trong văn bản',
            stated_date_field_communication: 'Văn bản nêu ngày này',
            stated_date_field_corrects: 'Mục được đính chính',
            stated_date_corrects_option: '{date}, ghi nhận ngày {recorded}',
            stated_date_value: 'Cơ quan nêu: {date}',
            stated_date_recorded: 'Đã ghi nhận ngày trả kết quả do cơ quan nêu.',
            stated_date_record_failed: 'Không thể ghi nhận ngày do cơ quan nêu. Nội dung bạn nhập vẫn được giữ.',
            rsupp_heading: 'Bổ sung sau kết quả',
            rsupp_intro: 'Kết quả và yêu cầu bổ sung cụ thể là hai bản ghi riêng. Hãy ghi nhận các nội dung và thời hạn (nếu có) nêu trong thông báo; ComplianceOne không tính ngày nào từ kết quả.',
            rsupp_no_request: 'Cần bổ sung — chưa ghi nhận yêu cầu bổ sung',
            rsupp_requested: 'Đã có yêu cầu bổ sung — chưa nộp bổ sung',
            rsupp_submitted: 'Đã nộp bổ sung',
            rsupp_record: 'Ghi nhận yêu cầu bổ sung',
            rsupp_no_period: 'Thông báo không nêu thời hạn',
            rsupp_stated_deadline: 'Ngày nêu trong thông báo: {date}',
            rsupp_item_owner: 'Người phụ trách: {person}',
            rsupp_item_task: 'Đã giao nhiệm vụ',
            rsupp_col_items: 'Nội dung yêu cầu',
            rsupp_col_communication: 'Văn bản',
            rsupp_col_period: 'Thời hạn',
            rsupp_col_recorded: 'Ghi nhận',
            rsupp_form_intro: 'Ghi nhận từng nội dung thông báo yêu cầu bổ sung. Nội dung có người phụ trách sẽ trở thành nhiệm vụ của người đó. Chỉ ghi nhận ngày do chính thông báo nêu; hệ thống không tự tính ngày.',
            rsupp_field_communication: 'Văn bản nêu yêu cầu',
            rsupp_field_items: 'Các nội dung thông báo yêu cầu',
            rsupp_field_item: 'Nội dung {n}',
            rsupp_field_item_owner: 'Người phụ trách nội dung {n} (không bắt buộc)',
            rsupp_add_item: 'Thêm nội dung',
            rsupp_remove_item: 'Xóa nội dung {n}',
            rsupp_field_period: 'Thời hạn nêu trong thông báo, chép nguyên văn',
            rsupp_field_deadline: 'Ngày nêu trong thông báo (không bắt buộc)',
            rsupp_field_deadline_hint: 'Chỉ nhập ngày do chính thông báo nêu. Mỗi nội dung có người phụ trách trở thành nhiệm vụ có hạn vào ngày này, hoặc không có hạn khi thông báo không nêu ngày.',
            rsupp_error_items_required: 'Hãy thêm ít nhất một nội dung thông báo yêu cầu.',
            rsupp_error_not_open: 'Không có yêu cầu bổ sung nào đang mở sau kết quả này. Trang đã đọc lại hồ sơ; nội dung bạn nhập vẫn được giữ.',
            rsupp_record_failed: 'Không thể ghi nhận yêu cầu bổ sung. Nội dung bạn nhập vẫn được giữ.',
            rsupp_recorded: 'Đã ghi nhận yêu cầu bổ sung.',
            followup_heading: 'Xử lý tiếp theo sau kết quả',
            followup_intro: 'Kết quả này để hồ sơ nộp ở trạng thái mở. Hãy ghi nhận lý do cơ quan nêu, biện pháp khắc phục do tổ chức bạn lựa chọn và rủi ro bị xử lý vi phạm (nếu có). Không bản ghi nào khác bị thay đổi.',
            followup_not_recorded: 'Chưa ghi nhận nội dung xử lý tiếp theo',
            followup_refusal: 'Văn bản của cơ quan',
            followup_reasons: 'Lý do được nêu',
            followup_remediation: 'Biện pháp khắc phục',
            followup_actions: 'Các hành động khắc phục',
            followup_action_due: 'Ngày do tổ chức bạn tự đặt: {date}',
            followup_action_owner: 'Người phụ trách: {person}',
            followup_enforcement_risk: 'Rủi ro có thể bị xử lý vi phạm',
            followup_enforcement_risk_none: 'Không nêu',
            followup_revision: 'Do {person} ghi nhận ngày {date}',
            followup_record: 'Ghi nhận nội dung xử lý tiếp theo',
            followup_revise: 'Điều chỉnh nội dung xử lý tiếp theo',
            followup_form_intro: 'Ghi nhận lý do nêu trong thông báo và biện pháp khắc phục do tổ chức bạn lựa chọn. Người phụ trách và ngày của từng hành động do tổ chức bạn tự quyết định; ComplianceOne không tự tính ngày.',
            followup_field_reasons: 'Lý do nêu trong thông báo',
            followup_field_summary: 'Biện pháp khắc phục',
            followup_field_actions: 'Các hành động khắc phục',
            followup_field_action: 'Hành động {n}',
            followup_field_action_title: 'Việc cần làm (hành động {n})',
            followup_field_action_owner: 'Người phụ trách (hành động {n})',
            followup_field_action_due: 'Ngày do tổ chức bạn tự đặt (hành động {n})',
            followup_add_action: 'Thêm hành động',
            followup_remove_action: 'Xóa hành động {n}',
            followup_actions_none: 'Chưa thêm hành động nào.',
            followup_field_enforcement: 'Rủi ro có thể bị xử lý vi phạm (không bắt buộc)',
            followup_field_enforcement_hint: 'Để trống nếu không có; bản ghi sẽ nêu rõ điều đó.',
            followup_field_correction_note: 'Lý do điều chỉnh nội dung xử lý tiếp theo',
            followup_error_not_open: 'Hồ sơ nộp này không có nội dung xử lý tiếp theo nào đang mở. Trang đã đọc lại hồ sơ; nội dung bạn nhập vẫn được giữ.',
            followup_record_failed: 'Không thể ghi nhận nội dung xử lý tiếp theo. Nội dung bạn nhập vẫn được giữ.',
            followup_recorded: 'Đã ghi nhận nội dung xử lý tiếp theo.',
            close_title: 'Đóng hồ sơ nộp',
            close_intro: 'Việc đóng hồ sơ ghi nhận rằng tổ chức bạn đã hoàn tất với hồ sơ nộp này. Đây không phải quyết định của cơ quan.',
            close_field_reason: 'Lý do đóng hồ sơ',
            close_field_reason_hint: 'Bắt buộc khi trang yêu cầu; các trường hợp khác không bắt buộc.',
            close_refusal_DOSSIER_RESULT_SUPPLEMENT_OPEN: 'Yêu cầu bổ sung sau kết quả vẫn đang mở. Hãy ghi nhận việc nộp bổ sung trước khi đóng hồ sơ.',
            close_refusal_DOSSIER_FAILURE_FOLLOW_UP_OPEN: 'Chưa ghi nhận nội dung xử lý tiếp theo cho kết quả này. Hãy ghi nhận nội dung xử lý tiếp theo hoặc nêu lý do đóng hồ sơ khi chưa có.',
            close_refusal_DOSSIER_CLOSE_REASON_REQUIRED: 'Hãy nêu lý do đóng hồ sơ nộp này.',
            close_closing: 'Đang đóng…',
            close_failed: 'Không thể đóng hồ sơ nộp. Nội dung bạn nhập vẫn được giữ.',
            closing_reason_value: 'Lý do đóng hồ sơ: {reason}',
            column_handled_by: 'Cơ quan xử lý hồ sơ',
            aria_filter_by_handling: 'Lọc theo cơ quan xử lý hồ sơ',
            filter_handling_not_known: 'Chưa rõ — chưa ghi nhận việc chuyển hồ sơ',
            filter_handling_other: 'Cơ quan khác được nêu',
            prior_filing_open_follow_up: 'Đang mở — đã ghi nhận nội dung xử lý tiếp theo',
            prior_filing_open_no_follow_up: 'Đang mở — kết quả không đạt, chưa ghi nhận nội dung xử lý tiếp theo',
            prior_filing_body_open: 'Khung tuân thủ đã cài đặt quy định mỗi tổ chức có một hồ sơ thuộc loại này, sau đó được cập nhật ({citation}). Tổ chức đã nộp một hồ sơ: {filing}. Hồ sơ đã có kết quả được ghi nhận. Khi phát sinh mục đích mới hoặc thay đổi khác về nội dung hồ sơ, hãy bắt đầu Thông báo thay đổi nội dung hồ sơ trên đánh giá này.',
            // Sprint 62.57.0 (Slices A, B, F; A-1) — the filing record export’s labels.
            record_export_receipt_heading: 'Việc tiếp nhận hồ sơ và văn bản áp dụng',
            record_export_receipt_none: 'Chưa ghi nhận việc tiếp nhận hồ sơ.',
            record_export_col_event: 'Sự kiện tiếp nhận',
            record_export_col_received_on: 'Ngày cơ quan tiếp nhận',
            record_export_col_postmarked_on: 'Dấu bưu điện',
            record_export_col_status: 'Mục ghi nhận',
            record_export_entry_standing: 'Đang có hiệu lực',
            record_export_entry_corrected: 'Đã được đính chính bởi mục sau',
            record_export_governing_text: 'Văn bản áp dụng: {label}',
            record_export_governing_end: 'Kết thúc giai đoạn: {label}',
            governing_text_not_determined: 'Chưa xác định văn bản áp dụng — hãy ghi nhận ngày tiếp nhận hồ sơ',
            record_export_governing_review: 'Văn bản áp dụng đã ghi nhận không còn khớp với nội dung khai báo đã cài đặt — cần rà soát',
            record_export_reservation: 'Chờ xác nhận pháp lý: {note}',
            record_export_handling_heading: 'Cơ quan xử lý hồ sơ',
            record_export_filed_with: 'Nơi nộp hồ sơ: {body}',
            record_export_handled_by_unknown: 'Cơ quan xử lý hồ sơ: chưa rõ — chưa ghi nhận việc chuyển hồ sơ',
            record_export_transfer_basis: 'Căn cứ chuyển hồ sơ: {text}',
            record_export_transfer_none_stated: 'Văn bản này không quy định việc chuyển hồ sơ',
            record_export_transfer_no_stamp: 'Căn cứ chuyển hồ sơ sẽ hiển thị sau khi ghi nhận ngày tiếp nhận',
            record_export_col_body: 'Cơ quan được nêu trong văn bản',
            record_export_col_option: 'Cơ quan được khai báo',
            record_export_col_basis: 'Căn cứ',
            record_export_col_source: 'Văn bản nguồn',
            record_export_other_body: 'Cơ quan khác được nêu',
            record_export_source_corrected: 'Văn bản nguồn đã được đính chính — cần rà soát',
            record_export_result_heading: 'Kết quả đã ghi nhận',
            record_export_result_none: 'Chưa ghi nhận kết quả.',
            record_export_result_corrected_by: 'Đã được sửa bởi một bản ghi sau',
            record_export_result_corrects: 'Sửa một bản ghi trước đó. Lý do: {note}',
            record_export_result_label: 'Đã ghi nhận kết quả: {label} — theo ghi nhận của tổ chức bạn từ thông báo của cơ quan',
            record_export_result_legacy: 'Đã ghi nhận kết quả: {legacy} — được ghi nhận trước khi kết quả được ghi theo văn bản áp dụng',
            record_export_result_dates: 'Ngày trên thông báo: {result_date}. Ngày tổ chức nhận: {received}.',
            result_recorded_under_different_governing_text: 'Được ghi nhận theo văn bản áp dụng khác — cần rà soát',
            record_export_result_follow_up: 'Nội dung phát sinh sau kết quả: {citation}',
            record_export_supplement_heading: 'Các yêu cầu bổ sung sau kết quả',
            result_supplement_no_request: 'Cần bổ sung — chưa ghi nhận yêu cầu bổ sung',
            record_export_supplement_period: 'Thời hạn nêu trong thông báo: {period}',
            no_period_stated_in_notice: 'Thông báo không nêu thời hạn',
            record_export_follow_up_heading: 'Xử lý tiếp theo sau kết quả',
            record_export_follow_up_none: 'Chưa ghi nhận nội dung xử lý tiếp theo.',
            record_export_follow_up_reasons: 'Lý do được nêu: {text}',
            record_export_follow_up_remediation: 'Biện pháp khắc phục: {text}',
            record_export_follow_up_risk: 'Rủi ro có thể bị xử lý vi phạm: {text}',
            record_export_col_action: 'Hành động khắc phục',
            record_export_col_owner: 'Người phụ trách',
            record_export_col_own_date: 'Ngày do tổ chức bạn tự đặt',
            record_export_period_heading: 'Thời hạn của cơ quan',
            record_export_period_stated: 'Ngày trả kết quả do cơ quan nêu: {date}',
            record_export_period_counted: 'Tính từ ngày {start} theo lịch {calendar}: {date}',
            record_export_period_passed: 'Đã qua thời hạn tạm tính — chưa ghi nhận kết quả',
            record_export_period_not_dated: 'Chưa có ngày tạm tính ({reason})',
            // Sprint 62.57.0 (Slices C and D, list half of AC-F5) — the completion period, the
            // completion request and submission, the update's recipient and competent authority,
            // the list's governing-text column and filters, the requirement link.
            status_result_completion_submitted: 'Đã nộp hồ sơ hoàn thiện — chưa ghi nhận kết quả tiếp theo',
            step_result_completion_submitted: 'Đã nộp hồ sơ hoàn thiện',
            receipt_event_completed_dossier_received: 'Cơ quan đã tiếp nhận hồ sơ đã hoàn thiện',
            receipt_field_completion_submission: 'Lần nộp hồ sơ hoàn thiện được tiếp nhận',
            receipt_completion_option: 'Hồ sơ hoàn thiện nộp ngày {date}',
            receipt_completion_option_recorded: 'Hồ sơ hoàn thiện ghi nhận ngày {date}',
            receipt_error_completion_invalid: 'Hãy chọn lần nộp hồ sơ hoàn thiện mà cơ quan đã tiếp nhận.',
            completion_heading: 'Thời hạn hoàn thiện hồ sơ',
            completion_intro: 'Thời hạn hoàn thiện hồ sơ chỉ bắt đầu khi tổ chức bạn ghi nhận một văn bản yêu cầu hoàn thiện hồ sơ, hoặc ghi nhận một kết quả mà văn bản áp dụng quy định thời hạn này. Các ngày được tính theo nội dung pháp lý đã cài đặt mỗi lần hồ sơ nộp được mở.',
            completion_none: 'Hồ sơ nộp này chưa có thời hạn hoàn thiện hồ sơ.',
            completion_current: 'Thời hạn hiện tại',
            completion_history: 'Các thời hạn trước',
            completion_date_provisional: 'Ngày tạm tính — sự kiện bắt đầu tính thời hạn còn chờ xác nhận pháp lý',
            completion_date_confirmed: 'Hạn hoàn thiện hồ sơ',
            completion_date_label: 'Ngày kết thúc thời hạn hoàn thiện hồ sơ',
            completion_passed_provisional: 'Đã qua ngày kết thúc thời hạn hoàn thiện hồ sơ (tạm tính)',
            completion_passed_confirmed: 'Đã hết thời hạn hoàn thiện hồ sơ',
            completion_running: 'Đang trong thời hạn',
            completion_completed: 'Đã nộp hồ sơ hoàn thiện ngày {date}',
            completion_completed_no_date: 'Đã nộp hồ sơ hoàn thiện',
            completion_not_dated: 'Chưa có ngày kết thúc thời hạn hoàn thiện hồ sơ',
            completion_state: 'Tình trạng',
            completion_notice_date: 'Ngày của văn bản',
            completion_received_on: 'Ngày tổ chức bạn nhận',
            completion_authority_stated: 'Ngày do cơ quan nêu',
            completion_trigger: 'Bắt đầu từ',
            completion_trigger_completion_request: 'Yêu cầu hoàn thiện hồ sơ do tổ chức bạn ghi nhận',
            completion_trigger_result: 'Kết quả do tổ chức bạn ghi nhận',
            completion_source: 'Văn bản làm căn cứ',
            completion_deficiency: 'Quy định của văn bản áp dụng',
            completion_citation: 'Căn cứ',
            completion_start_event: 'Sự kiện bắt đầu tính thời hạn',
            completion_period_length: 'Thời hạn: {period} {unit}',
            completion_unit_calendar_days: 'ngày theo lịch',
            completion_unit_working_days: 'ngày làm việc',
            completion_end_roll_none: 'ComplianceOne hiển thị ngày kết thúc theo cách tính và không dời sang ngày làm việc tiếp theo khi ngày đó rơi vào ngày nghỉ.',
            completion_end_roll_next_statutory_working_day: 'Nếu ngày kết thúc rơi vào ngày nghỉ thì được dời sang ngày làm việc tiếp theo.',
            completion_obligation: 'Thời hạn của tổ chức bạn, không phải của cơ quan',
            completion_task_raised: 'Đã tạo một công việc khi qua ngày này.',
            completion_col_period: 'Thời hạn',
            completion_absence_trigger_not_documented: 'Chưa có thời hạn hoàn thiện hồ sơ — yêu cầu không dẫn chiếu văn bản đã ghi nhận',
            completion_absence_trigger_not_declared: 'Văn bản áp dụng không quy định thời hạn hoàn thiện hồ sơ đối với kết quả này',
            completion_absence_governing_text_not_determined: 'Chưa có ngày kết thúc thời hạn hoàn thiện hồ sơ — chưa xác định văn bản áp dụng; hãy ghi nhận ngày tiếp nhận hồ sơ',
            completion_absence_no_period_declared: 'Nội dung đã cài đặt không khai báo thời hạn hoàn thiện hồ sơ cho hồ sơ này',
            completion_absence_multiple_candidate_periods: 'Chưa có ngày kết thúc thời hạn hoàn thiện hồ sơ — nội dung đã cài đặt khai báo nhiều thời hạn và không thời hạn nào được chọn',
            completion_absence_statutory_calendar_unavailable: 'Chưa có ngày kết thúc thời hạn hoàn thiện hồ sơ — chưa cài đặt lịch làm việc của cơ quan nhà nước',
            completion_absence_receipt_not_evidenced: 'Chưa có ngày kết thúc thời hạn hoàn thiện hồ sơ — chưa ghi nhận ngày tổ chức bạn nhận văn bản',
            completion_absence_declaring_framework_reference_mode: 'Chưa có ngày kết thúc thời hạn hoàn thiện hồ sơ — nội dung nêu thời hạn chỉ được cài đặt để tham khảo',
            completion_absence_declaring_framework_not_in_force: 'Chưa có ngày kết thúc thời hạn hoàn thiện hồ sơ — nội dung nêu thời hạn chưa có hiệu lực tại thời điểm tiếp nhận hồ sơ',
            completion_absence_declaring_framework_unreadable: 'Chưa có ngày kết thúc thời hạn hoàn thiện hồ sơ — không đọc được nội dung nêu thời hạn',
            completion_absence_no_installed_clock: 'Nội dung đã cài đặt không khai báo thời hạn hoàn thiện hồ sơ cho hồ sơ này',
            completion_absence_multiple_candidate_clocks: 'Chưa có ngày kết thúc thời hạn hoàn thiện hồ sơ — nội dung đã cài đặt khai báo nhiều thời hạn và không thời hạn nào được chọn',
            completion_absence_uncomputable_period: 'Chưa có ngày kết thúc thời hạn hoàn thiện hồ sơ — thời hạn được khai báo không thể tính thành ngày',
            completion_absence_declaring_framework_phase_reference_unresolved: 'Chưa có ngày kết thúc thời hạn hoàn thiện hồ sơ — nội dung nêu thời hạn không xác định ngày của giai đoạn được nêu',
            completion_absence_declaring_framework_not_operational: 'Chưa có ngày kết thúc thời hạn hoàn thiện hồ sơ — nội dung nêu thời hạn chưa được áp dụng',
            completion_consequence_heading: 'Rủi ro bị xử lý vi phạm có thể phát sinh',
            completion_body_handled_by: '{name} — theo ghi nhận của tổ chức bạn về cơ quan xử lý hồ sơ',
            completion_body_filed_with: '{name} — nơi nộp hồ sơ; chưa ghi nhận cơ quan xử lý',
            completion_fine_area_absent: 'Khung tuân thủ về xử phạt quy định nội dung này chưa được cài đặt cho tổ chức bạn',
            completion_fine_area_articles: 'Điều khoản: {articles}',
            completion_fine_area_reference: 'Chỉ được cài đặt để tham khảo',
            completion_fine_area_link: 'Mở {area} trong Mức độ sẵn sàng trước chế tài',
            completion_requests_heading: 'Các yêu cầu hoàn thiện hồ sơ đã ghi nhận',
            completion_requests_none: 'Chưa ghi nhận yêu cầu hoàn thiện hồ sơ nào.',
            completion_col_communication: 'Văn bản',
            completion_col_recorded: 'Thời điểm ghi nhận',
            completion_col_correction: 'Đính chính',
            completion_request_record: 'Ghi nhận yêu cầu hoàn thiện hồ sơ',
            completion_request_correct: 'Đính chính yêu cầu này',
            completion_request_intro: 'Chọn văn bản và xác nhận nội dung văn bản yêu cầu. ComplianceOne không dựa vào lời văn của văn bản để tự xác định điều này.',
            completion_field_communication: 'Văn bản',
            completion_statement: 'Văn bản yêu cầu tổ chức bạn hoàn thiện hồ sơ, hoặc nêu hồ sơ chưa đầy đủ, chưa hợp lệ hoặc chưa đúng quy định',
            completion_statement_required: 'Hãy đánh dấu xác nhận để ghi nhận yêu cầu.',
            completion_context_heading: 'Quy định của văn bản áp dụng (để tham khảo)',
            completion_field_corrects: 'Yêu cầu được đính chính',
            completion_field_corrects_none: 'Không đính chính — yêu cầu mới',
            completion_corrects_option: '{communication}, ghi nhận ngày {date}',
            completion_request_recorded: 'Đã ghi nhận yêu cầu hoàn thiện hồ sơ.',
            completion_request_failed: 'Không ghi nhận được yêu cầu hoàn thiện hồ sơ. Nội dung bạn nhập vẫn được giữ.',
            completion_error_not_open: 'Chỉ ghi nhận yêu cầu hoàn thiện hồ sơ tại đây khi hồ sơ nộp đã có yêu cầu bổ sung hoặc kết quả. Trước khi có kết quả, hãy ghi nhận cùng với yêu cầu bổ sung.',
            completion_request_row: '{person} ghi nhận ngày {date}',
            completion_request_withdraw: 'Rút lại mục ghi nhận',
            completion_request_withdraw_title: 'Rút lại mục ghi nhận yêu cầu hoàn thiện hồ sơ',
            completion_request_withdraw_intro: 'Rút lại ghi nhận một yêu cầu đã được ghi nhận nhầm: thời hạn hoàn thiện hồ sơ không còn được tính từ yêu cầu này. Mục ghi nhận vẫn được giữ trong lịch sử cùng ghi chú của bạn. Nếu một văn bản khác yêu cầu tổ chức bạn hoàn thiện hồ sơ, hãy ghi nhận một yêu cầu mới.',
            completion_request_withdraw_target: 'Mục ghi nhận được rút lại',
            completion_request_withdraw_note: 'Lý do rút lại mục ghi nhận này',
            completion_request_withdraw_note_required: 'Hãy nêu lý do rút lại mục ghi nhận.',
            completion_request_withdrawing: 'Đang rút lại…',
            completion_request_withdrawn_msg: 'Đã rút lại mục ghi nhận yêu cầu hoàn thiện hồ sơ.',
            completion_request_withdraw_failed: 'Không ghi nhận được việc rút lại. Nội dung bạn nhập vẫn được giữ.',
            completion_request_withdraw_gone: 'Mục ghi nhận này đã được đính chính hoặc rút lại trong lúc bạn thao tác, hoặc không còn trên hồ sơ nộp này. Trang đã đọc lại hồ sơ nộp.',
            completion_request_withdrawn: 'Đã rút lại ghi nhận',
            completion_request_withdraws: 'Rút lại mục ghi nhận ngày {date}',
            completion_request_withdrawn_by: 'Đã được rút lại ghi nhận bởi một mục sau',
            supplement_field_communication: 'Văn bản yêu cầu bổ sung',
            supplement_communication_hint: 'Thời hạn hoàn thiện hồ sơ chỉ được tính từ một văn bản đã ghi nhận. Hãy ghi nhận văn bản tại mục Văn bản của cơ quan có thẩm quyền trước.',
            supplement_error_completion_needs_communication: 'Hãy chọn văn bản trước khi đánh dấu xác nhận.',
            supplement_request_failed: 'Không ghi nhận được yêu cầu bổ sung. Nội dung bạn nhập vẫn được giữ.',
            result_completion_hint: 'Chỉ đánh dấu nếu văn bản này yêu cầu tổ chức bạn hoàn thiện hồ sơ, hoặc nêu hồ sơ chưa đầy đủ, chưa hợp lệ hoặc chưa đúng quy định. Bản thân kết quả chỉ làm phát sinh thời hạn hoàn thiện hồ sơ khi văn bản áp dụng có quy định.',
            completion_submit: 'Ghi nhận đã nộp hồ sơ hoàn thiện',
            completion_submitted_on: 'Ngày nộp',
            completion_submit_intro: 'Ghi nhận ngày tổ chức bạn nộp hồ sơ đã hoàn thiện cho cơ quan. Sau đó có thể ghi nhận kết quả tiếp theo trên hồ sơ nộp này.',
            completion_submit_intro_supplement: 'Ghi nhận ngày tổ chức bạn nộp hồ sơ đã hoàn thiện để trả lời yêu cầu bổ sung, và nội dung đã nộp.',
            supplement_submit_intro: 'Ghi nhận nội dung tổ chức bạn đã nộp để trả lời yêu cầu bổ sung.',
            completion_submitted_msg: 'Đã ghi nhận việc nộp hồ sơ hoàn thiện.',
            completion_submit_failed: 'Không ghi nhận được việc nộp. Nội dung bạn nhập vẫn được giữ.',
            completion_error_date_invalid: 'Ngày nộp không được sau ngày hiện tại hoặc trước ngày tổ chức bạn nhận văn bản yêu cầu.',
            completion_error_status: 'Tình trạng hồ sơ nộp không còn cho phép thao tác này. Trang đã đọc lại hồ sơ; nội dung bạn nhập vẫn được giữ.',
            column_governing_text: 'Văn bản áp dụng',
            aria_filter_by_governing_text: 'Lọc theo văn bản áp dụng',
            filter_governing_not_determined: 'Chưa xác định',
            filter_completion_passed: 'Thời hạn hoàn thiện hồ sơ: đã qua ngày kết thúc',
            list_completion_due_provisional: 'Ngày kết thúc thời hạn hoàn thiện hồ sơ (tạm tính): {date}',
            list_completion_due: 'Hạn hoàn thiện hồ sơ: {date}',
            chip_governed_by_requirement: 'Hồ sơ nộp áp dụng quy định bạn vừa mở',
            chip_governed_by_requirement_title: 'Hồ sơ nộp áp dụng quy định: {title}',
            chip_updates_of: 'Hồ sơ cập nhật của hồ sơ gốc',
            chip_remove: 'Bỏ bộ lọc: {label}',
            requirement_filings_link: 'Hồ sơ nộp áp dụng quy định này: {n}',
            requirement_filings_link_failed: 'Không đếm được số hồ sơ nộp áp dụng quy định này.',
            change_revise: 'Sửa đổi hồ sơ nộp này',
            change_update: 'Lập hồ sơ cập nhật',
            change_mode_legend: 'Bạn muốn làm gì?',
            change_update_form: 'Biểu mẫu cập nhật',
            change_update_loading: 'Đang đọc hồ sơ gốc và các biểu mẫu cập nhật đã cài đặt…',
            change_update_load_failed: 'Không đọc được hồ sơ gốc hoặc các biểu mẫu cập nhật đã cài đặt.',
            change_update_intro: 'Hồ sơ cập nhật là một hồ sơ nộp mới trong ComplianceOne gắn với hồ sơ này; việc lập hồ sơ không gửi gì tới cơ quan có thẩm quyền. Hãy tự chọn từng cơ quan; hệ thống không chọn thay bạn.',
            update_sent_to: 'Nơi nộp hồ sơ cập nhật',
            update_sent_to_help: 'Cơ quan mà tổ chức bạn nộp hồ sơ cập nhật này tới; thư gửi kèm được gửi tới cơ quan này khi cơ quan đó không phải là nơi nộp hồ sơ gốc.',
            update_competent: 'Cơ quan có thẩm quyền giải quyết hồ sơ',
            update_competent_help: 'Cơ quan mà tổ chức bạn ghi nhận, căn cứ văn bản của cơ quan có thẩm quyền, là cơ quan có thẩm quyền giải quyết hồ sơ. ComplianceOne không xác định cơ quan này.',
            update_context: 'Hồ sơ gốc — nơi nộp hồ sơ: {filed_with}. Cơ quan xử lý hồ sơ: {handled_by}.',
            update_context_not_known: 'Chưa rõ — chưa ghi nhận việc chuyển hồ sơ',
            update_context_filed_with_not_known: 'chưa được biểu mẫu đã cài đặt khai báo',
            update_choice_filed_with: 'Nơi nộp hồ sơ gốc: {name}',
            update_choice_handled_by: 'Cơ quan xử lý hồ sơ gốc theo ghi nhận: {name}',
            update_choice_named: 'Cơ quan khác (ghi tên theo văn bản)',
            update_named_label: 'Tên cơ quan, theo đúng văn bản',
            update_reason: 'Lý do khác với cơ quan đang xử lý hồ sơ gốc',
            update_reason_now_required: 'Cần nêu lý do: Lý do khác với cơ quan đang xử lý hồ sơ gốc',
            update_error_choice_required: 'Hãy chọn cơ quan.',
            update_error_name_required: 'Hãy nhập tên cơ quan.',
            update_error_reason_required: 'Hãy nêu lý do khác với cơ quan đang xử lý hồ sơ gốc.',
            update_error_body_invalid: 'Không thể chọn cơ quan này vì hồ sơ gốc chưa ghi nhận cơ quan xử lý. Hãy chọn cơ quan khác.',
            update_error_not_declared: 'Không có biểu mẫu cập nhật đã cài đặt nào cho loại hồ sơ này quy định việc ghi nhận nơi nộp và cơ quan có thẩm quyền.',
            update_error_form_invalid: 'Không dùng được biểu mẫu cập nhật cho hồ sơ nộp này. Hãy bắt đầu lại.',
            update_error_target_invalid: 'Không thể lập hồ sơ cập nhật từ một hồ sơ cập nhật. Hãy mở hồ sơ gốc.',
            update_error_locked: 'Không thể thay đổi nữa vì hồ sơ cập nhật đã được lập để nộp hoặc đã được nộp.',
            update_error_original_not_found: 'Không tìm thấy hồ sơ gốc. Hãy chọn lại.',
            update_error_original_invalid: 'Không thể chọn hồ sơ nộp này làm hồ sơ gốc. Hãy chọn hồ sơ khác.',
            update_error_forms_denied: 'Vai trò của bạn không có quyền truy cập biểu mẫu, nên không thể lập hồ sơ cập nhật tại đây. Hãy đề nghị quản trị viên cấp quyền truy cập biểu mẫu.',
            update_original_choose_first: 'Hãy chọn hồ sơ gốc trước.',
            update_error_not_submitted: 'Hồ sơ gốc chưa được nộp nên chưa thể lập hồ sơ cập nhật.',
            update_create_failed: 'Không tạo được hồ sơ cập nhật. Nội dung bạn nhập vẫn được giữ.',
            update_form_kept: 'Một biểu mẫu cập nhật đã được tạo nhưng chưa gắn với hồ sơ nộp này. Hãy lập lại hồ sơ cập nhật từ hồ sơ nộp này để dùng biểu mẫu đó; không hoàn tất biểu mẫu từ mục biểu mẫu của đánh giá, vì như vậy sẽ tạo hồ sơ cập nhật không gắn với hồ sơ gốc.',
            update_form_reused: 'Hồ sơ cập nhật này dùng lại biểu mẫu cập nhật đã được tạo từ hồ sơ nộp này: {form}.',
            completion_mode_changed: 'Thời hạn hoàn thiện hồ sơ trên hồ sơ nộp này đã thay đổi trong khi bạn nhập thông tin. Hộp thoại này giờ đây chỉ ghi nhận phản hồi bổ sung; nội dung bạn nhập vẫn được giữ.',
            completion_mode_changed_completion: 'Thời hạn hoàn thiện hồ sơ trên hồ sơ nộp này đã thay đổi trong khi bạn nhập thông tin. Hộp thoại này giờ đây ghi nhận đã nộp hồ sơ hoàn thiện và cần nhập ngày nộp; nội dung bạn nhập vẫn được giữ.',
            supplement_request_no_longer_open: 'Không thể ghi nhận yêu cầu bổ sung trên hồ sơ nộp này nữa: trạng thái hồ sơ đã thay đổi trong lúc bạn thao tác (ví dụ, người khác đã ghi nhận yêu cầu). Trang đã đọc lại hồ sơ. Hãy đóng hộp thoại này.',
            update_form_no_longer_offered: 'Biểu mẫu cập nhật đã tạo trước đó không còn được nội dung đã cài đặt cung cấp; hãy chọn biểu mẫu.',
            update_created: 'Đã tạo hồ sơ cập nhật. Hãy điền biểu mẫu cập nhật.',
            update_creating: 'Đang tạo…',
            update_section_heading: 'Nơi nộp và cơ quan có thẩm quyền giải quyết hồ sơ',
            update_section_intro: 'Tổ chức bạn ghi nhận nơi nộp hồ sơ cập nhật, và căn cứ văn bản của cơ quan để ghi nhận cơ quan có thẩm quyền giải quyết hồ sơ cập nhật. ComplianceOne không bao giờ tự xác định cơ quan nào xử lý hồ sơ hoặc hồ sơ cập nhật.',
            update_not_recorded: 'Chưa ghi nhận.',
            update_record: 'Ghi nhận nơi nộp và cơ quan có thẩm quyền',
            update_edit: 'Thay đổi nơi nộp và cơ quan có thẩm quyền',
            update_saving: 'Đang lưu…',
            update_recorded_msg: 'Đã ghi nhận nơi nộp và cơ quan có thẩm quyền.',
            update_record_failed: 'Không ghi nhận được nơi nộp và cơ quan có thẩm quyền. Nội dung bạn nhập vẫn được giữ.',
            update_history: 'Các lần ghi nhận trước',
            update_recorded_by: '{person} ghi nhận ngày {date}',
            update_source_filed_with: 'Nơi nộp hồ sơ gốc',
            update_source_handled_by: 'Cơ quan xử lý hồ sơ gốc theo ghi nhận',
            update_source_named: 'Do tổ chức bạn ghi tên',
            update_addressee_review_prompt: 'Cơ quan xử lý hồ sơ gốc đã thay đổi kể từ khi ghi nhận — hãy xem lại',
            update_window_rule_flag: 'Văn bản áp dụng đối với hồ sơ cập nhật này quy định nộp về {body}; tổ chức bạn đã ghi nhận {sent_to} — hãy xem lại',
            update_window_rule_flag_unnamed: 'Văn bản áp dụng đối với hồ sơ cập nhật này quy định nộp về một cơ quan khác với cơ quan tổ chức bạn đã ghi nhận ({sent_to}) — hãy xem lại',
            update_bases_disclosure: 'Nơi nộp hồ sơ cập nhật tùy thuộc ngày cơ quan tiếp nhận hồ sơ',
            update_basis_own_window: 'Quy định của văn bản áp dụng đối với hồ sơ cập nhật này',
            update_original: 'Cập nhật cho hồ sơ',
            update_original_open: 'Mở hồ sơ gốc',
            updates_of_this: 'Hồ sơ cập nhật của hồ sơ này ({n})',
            gov_update_own_receipt: 'Hồ sơ cập nhật được xác định theo ngày tiếp nhận của chính hồ sơ cập nhật, không theo ngày tiếp nhận hồ sơ gốc.',
            completion_task_title_provisional: 'Đã qua ngày kết thúc thời hạn hoàn thiện hồ sơ (tạm tính): {filing}',
            completion_task_title_confirmed: 'Đã hết thời hạn hoàn thiện hồ sơ: {filing}',
            update_original_pick_loading: 'Đang đọc các hồ sơ nộp…',
            update_original_pick_empty: 'Không có hồ sơ nộp đã nộp nào để chọn làm hồ sơ gốc.',
            update_original_pick_failed: 'Không đọc được các hồ sơ nộp.',
            update_original_pick_manual_label: 'Mã bản ghi hồ sơ gốc',
            update_original_pick_manual_hint: 'Nhập mã của một hồ sơ nộp đã nộp; mã sẽ được kiểm tra khi lưu.',
            update_original_pick_off_list: 'Hồ sơ nộp {value} (không có trong danh sách)',
            followup_completion_link: 'Xem thời hạn hoàn thiện hồ sơ',
            record_export_completion_heading: 'Thời hạn hoàn thiện hồ sơ',
            record_export_completion_none: 'Chưa ghi nhận yêu cầu hoàn thiện hồ sơ nào.',
            record_export_completion_trigger_request: 'Yêu cầu hoàn thiện hồ sơ được ghi nhận từ văn bản {reference}',
            record_export_completion_trigger_result: 'Kết quả đã ghi nhận: {label}',
            record_export_completion_dates: 'Ngày của văn bản: {notice}. Ngày tổ chức bạn nhận: {received}.',
            record_export_completion_provisional: 'Ngày tạm tính — sự kiện bắt đầu tính thời hạn còn chờ xác nhận pháp lý: {date}',
            record_export_completion_confirmed: 'Hạn hoàn thiện hồ sơ: {date}',
            record_export_completion_stated: 'Ngày do cơ quan nêu: {date}',
            record_export_completion_passed_provisional: 'Đã qua ngày kết thúc thời hạn hoàn thiện hồ sơ (tạm tính)',
            record_export_completion_passed: 'Đã hết thời hạn hoàn thiện hồ sơ',
            record_export_completion_completed: 'Đã nộp hồ sơ hoàn thiện: {date}',
            record_export_completion_body_not_recorded: 'cơ quan có thẩm quyền giải quyết hồ sơ (chưa được ghi nhận trên hồ sơ này)',
            record_export_completion_area: 'Lĩnh vực xử phạt: {name} ({articles})',
            record_export_completion_area_absent: 'Khung tuân thủ về xử phạt quy định nội dung này chưa được cài đặt cho tổ chức bạn',
            record_export_update_heading: 'Nơi nộp và cơ quan có thẩm quyền giải quyết hồ sơ',
            record_export_update_sent_to: 'Nơi nộp hồ sơ cập nhật: {body}',
            record_export_update_competent: 'Cơ quan có thẩm quyền giải quyết hồ sơ: {body}',
            record_export_update_reason: 'Lý do khác với cơ quan đang xử lý hồ sơ gốc: {reason}',
            record_export_update_basis: '{window}: {basis}',
            record_export_update_window_flag: 'Văn bản áp dụng đối với hồ sơ cập nhật này quy định nộp về cơ quan khác với cơ quan đã ghi nhận — hãy xem lại',
        },
        // Sprint 44.4.0 — trang tình trạng tài liệu nộp (dành cho quản trị)
        materialisation_health: {
            nav_label: 'Tình trạng tài liệu nộp',
            page_title: 'Tình trạng tài liệu nộp',
            page_description: 'Phát hiện và xử lý sự cố tạo dossier. Danh sách giới hạn trong phạm vi tổ chức của bạn.',
            failed_title: 'Các lần tạo tài liệu thất bại',
            failed_empty: 'Không có trường hợp thất bại — tốt.',
            pending_title: 'Đã phê duyệt nhưng chưa tạo',
            pending_empty: 'Tất cả hồ sơ đã phê duyệt đều có dossier tương ứng.',
            orphan_title: 'Dossier mồ côi',
            orphan_description: 'Các dossier được tạo bởi quá trình materialisation nhưng không còn được tham chiếu bởi bất kỳ hồ sơ nào — thường là bên thua trong một tình huống chạy đua. Liệt kê để kiểm tra; việc dọn dẹp được thực hiện thủ công.',
            orphan_empty: 'Không phát hiện dossier mồ côi nào.',
            materialise_button: 'Tạo ngay',
            column_failure_reason: 'Lý do thất bại',
            column_failed_at: 'Thời điểm thất bại',
            column_retries: 'Số lần thử lại',
            column_approved_at: 'Thời điểm phê duyệt',
            column_dossier_id: 'Dossier ID',
            column_source_filing_id: 'Hồ sơ nguồn',
            column_dossier_type: 'Loại',
            column_created_at: 'Thời điểm tạo',
        },
        // Sprint 62.35.0 (Slice C) — đánh giá trước khi thu thập. Các thuật ngữ
        // được quản lý (Bản nháp, Đã phê duyệt, Không còn áp dụng, Trạng thái,
        // Thao tác, Chỉnh sửa, Tổng số) dùng nguyên văn theo registry R-44.
        pre_collection: {
            nav_label: 'Đánh giá biện pháp bảo vệ dữ liệu trước khi thu thập',
            page_title: 'Đánh giá biện pháp bảo vệ dữ liệu trước khi thu thập',
            page_description: 'Đánh giá các biện pháp bảo vệ đối với một mục đăng ký dữ liệu, được thực hiện trước khi dữ liệu đó được thu thập lần đầu. Ngày hoàn thành đánh giá không được sau ngày thu thập lần đầu.',
            module_guide: 'Ghi nhận, cho từng mục đăng ký dữ liệu, đánh giá các biện pháp bảo vệ được thực hiện trước khi bắt đầu thu thập: quy trình thu thập và phiên bản của quy trình, nội dung đánh giá, các biện pháp đã áp dụng, ngày hoàn thành đánh giá và ngày dữ liệu được thu thập lần đầu. Việc có bắt buộc đánh giá hay không do các khung tuân thủ đã cài đặt quy định.',
            new_button: 'Thêm đánh giá biện pháp bảo vệ',
            create_title: 'Đánh giá biện pháp bảo vệ dữ liệu trước khi thu thập mới',
            edit_title: 'Chỉnh sửa đánh giá biện pháp bảo vệ dữ liệu trước khi thu thập',
            edit: 'Chỉnh sửa',
            field_registry_item: 'Mục đăng ký dữ liệu',
            registry_item_placeholder: 'Chọn mục đăng ký dữ liệu',
            registry_item_unresolved: 'Không tìm thấy mục đăng ký dữ liệu',
            registry_load_error: 'Không thể đọc sổ đăng ký dữ liệu, nên không có mục đăng ký dữ liệu nào để chọn.',
            registry_empty: 'Sổ đăng ký dữ liệu chưa có mục nào.',
            field_procedure_reference: 'Mã quy trình thu thập',
            field_procedure_version: 'Phiên bản quy trình',
            field_summary: 'Nội dung đánh giá',
            field_measures: 'Biện pháp đã áp dụng',
            field_measures_hint: 'Mỗi dòng một biện pháp.',
            field_completed_on: 'Ngày hoàn thành đánh giá',
            field_first_collection_on: 'Ngày thu thập lần đầu',
            date_hint: 'Đánh giá phải được hoàn thành vào hoặc trước ngày thu thập lần đầu. Để trống ngày thu thập lần đầu nếu chưa bắt đầu thu thập.',
            error_after_first_collection: 'Đánh giá phải được thực hiện trước khi dữ liệu được thu thập lần đầu: ngày hoàn thành đánh giá sau ngày thu thập lần đầu.',
            field_status: 'Trạng thái',
            status_draft: 'Bản nháp',
            status_approved: 'Đã phê duyệt',
            status_deprecated: 'Không còn áp dụng',
            column_registry_item: 'Mục đăng ký dữ liệu',
            column_procedure: 'Quy trình thu thập',
            column_actions: 'Thao tác',
            not_recorded: 'Chưa ghi nhận',
            empty: 'Chưa có đánh giá biện pháp bảo vệ dữ liệu trước khi thu thập nào được ghi nhận.',
            list_load_error: 'Không thể đọc danh sách đánh giá biện pháp bảo vệ dữ liệu trước khi thu thập.',
            reload: 'Tải lại',
            reload_sr: 'tải lại danh sách đánh giá biện pháp bảo vệ dữ liệu trước khi thu thập',
            registry_reload_sr: 'tải lại sổ đăng ký dữ liệu',
            save: 'Lưu',
            saving: 'Đang lưu…',
            cancel: 'Hủy',
            created_toast: 'Đã ghi nhận đánh giá biện pháp bảo vệ dữ liệu trước khi thu thập.',
            updated_toast: 'Đã cập nhật đánh giá biện pháp bảo vệ dữ liệu trước khi thu thập.',
            save_error: 'Không thể lưu đánh giá biện pháp bảo vệ.',
            total: 'Tổng số',
            section_scope: 'Đối tượng được đánh giá',
            section_assessment: 'Nội dung đánh giá và các mốc ngày',
            approved_locked: 'Đánh giá này đã được phê duyệt nên không thể thay đổi nội dung. Chỉ có thể ngừng sử dụng đánh giá.',
            error_conflict: 'Đánh giá này đã được người khác thay đổi trong lúc bạn đang chỉnh sửa, nên thay đổi của bạn chưa được lưu. Hãy đóng biểu mẫu này và mở lại đánh giá để xem phiên bản hiện tại.',
            error_conflict_refreshed: 'Đánh giá này đã được người khác thay đổi trong lúc bạn đang chỉnh sửa, nên thay đổi của bạn chưa được lưu. Biểu mẫu hiện hiển thị phiên bản hiện tại và các nội dung bạn nhập chưa lưu không được giữ lại. Hãy thực hiện lại thay đổi và lưu.',
            registry_not_readable: 'Vai trò của bạn không có quyền đọc sổ đăng ký dữ liệu, nên không có mục đăng ký dữ liệu nào để chọn tại đây.',
            create_needs_registry_read: 'Vai trò của bạn không có quyền đọc sổ đăng ký dữ liệu, nên không thể chọn mục đăng ký dữ liệu mà một đánh giá biện pháp bảo vệ mới cần có. Bạn vẫn có thể chỉnh sửa các đánh giá biện pháp bảo vệ đã có.',
            registry_item_name_hidden: 'Vai trò của bạn không được xem tên mục này',
        },
    },
    classification: {
        access_denied_title: 'Truy cập bị từ chối',
        access_denied: 'Bạn không có quyền cần thiết để truy cập phân hệ Phân loại. Liên hệ quản trị viên.',
        nav: {
            taxonomies: 'Phân loại',
            labeling: 'Gán nhãn',
            lifecycle: 'Vòng đời',
            gaps: 'Báo cáo lỗi',
            exports: 'Xuất dữ liệu',
        },
        taxonomies: {
            title: 'Phân loại dữ liệu',
            new: 'Phân loại mới',
            edit: 'Sửa phân loại',
            name: 'Tên',
            levels: 'Cấp độ phân loại',
            seed_defaults: 'Tạo dữ liệu mặc định',
            scope: 'Phạm vi',
            scope_organization: 'Tổ chức',
            scope_module_specific: 'Riêng phân hệ',
            deprecate: 'Ngừng sử dụng',
            hide_levels: 'Ẩn cấp độ',
            versions: 'Phiên bản',
            hide_versions: 'Ẩn phiên bản',
            add_level: 'Thêm cấp độ',
            new_level: 'Cấp độ mới',
            edit_level: 'Sửa cấp độ',
            code: 'Mã',
            label: 'Nhãn',
            color: 'Màu sắc',
            ordinal: 'Thứ tự',
            handling_requirements: 'Yêu cầu xử lý',
            version_history: 'Lịch sử phiên bản',
            changes: 'Thay đổi',
            failed_fetch: 'Không thể tải phân loại. Vui lòng thử lại.',
            failed_save: 'Không thể lưu phân loại. Vui lòng thử lại.',
            failed_activate: 'Không thể kích hoạt phân loại. Vui lòng thử lại.',
            failed_deprecate: 'Không thể ngừng sử dụng phân loại. Vui lòng thử lại.',
            failed_seed: 'Không thể tạo dữ liệu mặc định. Vui lòng thử lại.',
            failed_fetch_levels: 'Không thể tải cấp độ phân loại. Vui lòng thử lại.',
            failed_save_level: 'Không thể lưu cấp độ phân loại. Vui lòng thử lại.',
            failed_delete_level: 'Không thể xóa cấp độ phân loại. Vui lòng thử lại.',
            failed_fetch_versions: 'Không thể tải phiên bản phân loại. Vui lòng thử lại.',
            loaded_count: 'Đã tải {count} phân loại',
            defaults_seeded: 'Phân loại mặc định đã được khởi tạo.',
            no_levels: 'Chưa có cấp độ phân loại — thêm cấp độ để xây dựng hệ thống phân loại.',
            no_versions: 'Chưa có lịch sử phiên bản — phiên bản được tạo khi phân loại đang hoạt động được cập nhật.',
        },
        labeling: {
            title: 'Gán nhãn dữ liệu',
            new: 'Nhãn mới',
            edit: 'Sửa nhãn',
            entity_type: 'Loại thực thể',
            entity_id: 'Mã thực thể',
            taxonomy: 'Phân loại',
            classification_level: 'Cấp độ phân loại',
            applied_by: 'Người gán',
            applied_at: 'Thời gian gán',
            bulk_apply: 'Gán hàng loạt',
            bulk_remove: 'Xóa hàng loạt',
            all_taxonomies: 'Tất cả phân loại',
            system: 'Hệ thống',
            dataset: 'Tập dữ liệu',
            level_code_placeholder: 'Mã cấp độ...',
            select_taxonomy: 'Chọn phân loại...',
            select_level: 'Chọn cấp độ...',
            rationale: 'Lý do',
            review_date: 'Ngày xem xét',
            review: 'Xem xét',
            selected: 'đã chọn',
            select_all_labels: 'Chọn tất cả nhãn',
            loaded_count: 'Đã tải {count} nhãn',
            hide_stale_labels: 'Ẩn nhãn lỗi thời',
            show_conflicts: 'Hiện xung đột',
            hide_conflicts: 'Ẩn xung đột',
            label_conflicts: 'Xung đột nhãn',
            conflict_reason: 'Lý do xung đột',
            labels: 'Nhãn',
            failed_fetch: 'Không thể tải nhãn. Vui lòng thử lại.',
            failed_fetch_taxonomies: 'Không thể tải phân loại. Vui lòng thử lại.',
            failed_fetch_levels: 'Không thể tải cấp độ phân loại. Vui lòng thử lại.',
            failed_save: 'Không thể lưu nhãn. Vui lòng thử lại.',
            failed_review: 'Không thể xem xét nhãn. Vui lòng thử lại.',
            failed_bulk: 'Không thể gán nhãn hàng loạt. Vui lòng thử lại.',
            failed_stale: 'Không thể tải nhãn lỗi thời. Vui lòng thử lại.',
            failed_conflicts: 'Không thể tải xung đột nhãn. Vui lòng thử lại.',
            review_permission_denied: 'Bạn không có quyền xem xét nhãn này.',
            review_not_found: 'Không tìm thấy nhãn — nhãn có thể đã bị xóa.',
            approved: 'Đã duyệt',
            rejected: 'Đã từ chối',
            labels_count: 'nhãn',
            failed_count: 'thất bại',
            approve_selected: 'Duyệt mục đã chọn',
            reject_selected: 'Từ chối mục đã chọn',
            confirm_approve: 'Xác nhận duyệt',
            confirm_reject: 'Xác nhận từ chối',
            approve_n_labels: 'Duyệt {count} nhãn?',
            reject_n_labels: 'Từ chối {count} nhãn?',
            submit_for_review: 'Gửi để xem xét',
            approve: 'Phê duyệt',
            reject: 'Từ chối',
            parent_system: 'Hệ thống cha',
            parent_system_placeholder: 'Chọn hệ thống cha...',
            parent_system_help: 'Dùng để phát hiện xung đột.',
            dataset_level: 'Cấp bộ dữ liệu',
            parent_level: 'Cấp cha',
            bulk_created: 'Đã tạo {created} nhãn',
            bulk_skipped: '{skipped} bỏ qua (đã gán nhãn)',
            bulk_all_skipped: 'Tất cả {skipped} bỏ qua',
            ids_hint: 'Nhập ID cách nhau bằng dấu phẩy',
            delete_confirm: 'Xóa nhãn cho "{id}"?',
        },
        lifecycle: {
            title: 'Giám sát vòng đời dữ liệu',
            new: 'Mục mới',
            current_stage: 'Giai đoạn hiện tại',
            last_transition: 'Chuyển đổi gần nhất',
            transition: 'Chuyển đổi',
            view_history: 'Xem lịch sử',
            stages: {
                creation: 'Tạo',
                collection: 'Thu thập',
                processing: 'Xử lý',
                storage: 'Lưu trữ',
                retention: 'Bảo lưu',
                disposal: 'Tiêu hủy',
                archived: 'Lưu trữ',
                active: 'Hoạt động',
                pending_deletion: 'Chờ xóa',
                deleted: 'Đã xóa',
                on_hold: 'Tạm giữ',
            },
            all_stages: 'Tất cả giai đoạn',
            object_id: 'Mã đối tượng',
            object_type: 'Loại đối tượng',
            policy_reference: 'Tham chiếu chính sách',
            retention_period_days: 'Thời gian bảo lưu (ngày)',
            retention_basis: 'Cơ sở bảo lưu',
            deletion_method: 'Phương pháp xóa',
            deletion_secure_erase: 'Xóa an toàn',
            deletion_anonymization: 'Ẩn danh hóa',
            deletion_physical_destruction: 'Tiêu hủy vật lý',
            deletion_other: 'Khác',
            responsible_party: 'Bên chịu trách nhiệm',
            responsible_user_id: 'Mã người chịu trách nhiệm',
            retention_expiry: 'Hết hạn bảo lưu',
            hold_reason: 'Lý do tạm giữ',
            hold: 'Tạm giữ',
            release: 'Giải phóng',
            hide_events: 'Ẩn sự kiện',
            events_timeline: 'Dòng thời gian sự kiện',
            add_event: 'Thêm sự kiện',
            event_type: 'Loại sự kiện',
            create_event: 'Tạo sự kiện',
            from_stage: 'Từ giai đoạn',
            to_stage: 'Đến giai đoạn',
            actor: 'Người thực hiện',
            reason_placeholder: 'Lý do...',
            go: 'Thực hiện',
            show_expired_retentions: 'Hiện bảo lưu hết hạn',
            hide_expired_retentions: 'Ẩn bảo lưu hết hạn',
            expired_retentions_alert: 'Cảnh báo bảo lưu hết hạn',
            failed_fetch: 'Không thể tải bản ghi vòng đời. Vui lòng thử lại.',
            failed_save: 'Không thể lưu bản ghi vòng đời. Vui lòng thử lại.',
            failed_transition: 'Không thể chuyển đổi giai đoạn. Vui lòng thử lại.',
            failed_hold: 'Không thể tạm giữ. Vui lòng thử lại.',
            failed_release: 'Không thể giải phóng. Vui lòng thử lại.',
            failed_fetch_events: 'Không thể tải sự kiện vòng đời. Vui lòng thử lại.',
            failed_create_event: 'Không thể tạo sự kiện vòng đời. Vui lòng thử lại.',
            failed_expired: 'Không thể tải bảo lưu hết hạn. Vui lòng thử lại.',
            hold_reason_prompt: 'Nhập lý do tạm giữ:',
            loaded_count: 'Đã tải {count} bản ghi vòng đời',
            stage_transition_for: 'Chuyển giai đoạn cho {id}',
            event_created: 'Đã tạo',
            event_updated: 'Đã cập nhật',
            event_approved: 'Đã duyệt',
            event_deprecated: 'Ngừng sử dụng',
            event_proposed: 'Đề xuất',
            event_reviewed: 'Đã xem xét',
            event_archived: 'Đã lưu trữ',
            event_restored: 'Đã khôi phục',
        },
        gap_report: {
            title: 'Báo cáo lỗi phân loại',
            unlabeled: 'Dữ liệu chưa gán nhãn',
            missing_lifecycle: 'Thiếu vòng đời',
            stale_labels: 'Nhãn lỗi thời',
            run_detection: 'Chạy phát hiện lỗi',
            detecting: 'Đang phát hiện...',
            detection_complete: 'Phát hiện lỗi hoàn tất. {count} lỗi đã phát hiện.',
            detection_failed: 'Phát hiện lỗi thất bại.',
            by_severity: 'Theo mức độ',
            by_gap_type: 'Theo loại lỗi',
            all_gap_types: 'Tất cả loại lỗi',
            conflicting_labels: 'Nhãn xung đột',
            expired_retention: 'Bảo lưu hết hạn',
            missing_handling: 'Thiếu xử lý',
            info: 'Thông tin',
            gap_type: 'Loại lỗi',
            object_id: 'Mã đối tượng',
            object_type: 'Loại đối tượng',
            detected_at: 'Phát hiện lúc',
            open: 'Mở',
            acknowledged: 'Đã xác nhận',
            remediated: 'Đã khắc phục',
            accepted: 'Đã chấp nhận',
            acknowledge: 'Xác nhận',
            remediate: 'Khắc phục',
            accept_risk: 'Chấp nhận rủi ro',
            accept_risk_prompt: 'Nhập lý do chấp nhận rủi ro:',
            failed_fetch: 'Không thể tải lỗi. Vui lòng thử lại.',
            failed_acknowledge: 'Không thể xác nhận lỗi. Vui lòng thử lại.',
            failed_remediate: 'Không thể khắc phục lỗi. Vui lòng thử lại.',
            failed_accept_risk: 'Không thể chấp nhận rủi ro. Vui lòng thử lại.',
            failed_detect: 'Không thể chạy phát hiện lỗi. Vui lòng thử lại.',
            loaded_count: 'Đã tải {count} lỗ hổng phân loại',
            related_object_id: 'Mã đối tượng liên quan',
            related_object_type: 'Loại đối tượng liên quan',
            gap_types: {
                unlabeled_asset: 'Tài sản chưa gán nhãn',
                missing_lifecycle: 'Thiếu vòng đời',
                expired_retention: 'Lưu giữ hết hạn',
                extended_pending_deletion: 'Chờ xóa kéo dài',
            },
        },
        label_workflow: {
            title: 'Quy trình nhãn',
            proposed: 'Đề xuất',
            under_review: 'Đang xem xét',
            approved: 'Đã duyệt',
            deprecated: 'Ngừng sử dụng',
            submit_review: 'Gửi để xem xét',
            approve: 'Duyệt nhãn',
            deprecate: 'Ngừng sử dụng',
            bulk_approve: 'Duyệt hàng loạt',
            bulk_approve_success: 'Các nhãn đã được duyệt thành công.',
            submit_success: 'Nhãn đã được gửi để xem xét.',
            approve_success: 'Nhãn đã được duyệt.',
            deprecate_success: 'Nhãn đã ngừng sử dụng.',
        },
        review_tasks: {
            title: 'Nhiệm vụ xem xét',
            create: 'Nhiệm vụ xem xét mới',
            system: 'Hệ thống',
            owner: 'Chủ sở hữu',
            description: 'Mô tả',
            resolution: 'Giải quyết',
            resolve: 'Giải quyết',
            approve: 'Duyệt',
            modify: 'Chỉnh sửa',
            reject: 'Từ chối',
            escalate: 'Leo thang',
            escalated: 'Nhiệm vụ leo thang',
            no_tasks: 'Không có nhiệm vụ xem xét.',
            resolve_success: 'Nhiệm vụ xem xét đã được giải quyết.',
            status_pending: 'Chờ xử lý',
            status_resolved: 'Đã giải quyết',
            status_escalated: 'Đã leo thang',
            notes: 'Ghi chú',
            create_success: 'Nhiệm vụ xem xét đã được tạo.',
            no_tasks_detail: 'Chưa có nhiệm vụ xem xét — tạo nhiệm vụ để giao việc xem xét nhãn cho chủ hệ thống.',
            label_id: 'Mã nhãn',
            system_id: 'Mã hệ thống',
            system_name: 'Tên hệ thống',
            owner_id: 'Mã chủ sở hữu',
            resolution_col: 'Giải quyết',
            notes_col: 'Ghi chú',
        },
        exceptions: {
            title: 'Hàng đợi ngoại lệ',
            create: 'Ngoại lệ mới',
            severity: 'Mức độ nghiêm trọng',
            system: 'Hệ thống',
            owner: 'Chủ sở hữu',
            resolve: 'Giải quyết',
            no_exceptions: 'Không tìm thấy ngoại lệ.',
            resolve_success: 'Ngoại lệ đã được giải quyết.',
            dashboard_open: 'Ngoại lệ đang mở',
            dashboard_resolved: 'Ngoại lệ đã giải quyết',
            dashboard_total: 'Tổng',
            dashboard_by_severity: 'Theo mức độ nghiêm trọng',
            status_open: 'Mở',
            status_resolved: 'Đã giải quyết',
            status_accepted_risk: 'Rủi ro chấp nhận',
            create_success: 'Ngoại lệ đã được tạo.',
            no_exceptions_detail: 'Chưa có ngoại lệ — ngoại lệ được tạo từ lỗ hổng nghiêm trọng cần xử lý đặc biệt.',
            gap_id: 'Mã lỗ hổng',
            system_id: 'Mã hệ thống',
            system_name: 'Tên hệ thống',
            owner_id: 'Mã chủ sở hữu',
            resolution_notes: 'Ghi chú giải quyết',
            resolution_notes_placeholder: 'Mô tả cách ngoại lệ này được giải quyết...',
            dashboard_accepted_risk: 'Rủi ro chấp nhận',
            resolution_outcome: 'Kết quả',
            resolve_success_accepted_risk: 'Ngoại lệ đã được đóng với rủi ro chấp nhận.',
        },
        enterprise_map: {
            title: 'Bản đồ dữ liệu doanh nghiệp',
            inventory: 'Kho dữ liệu',
            total_systems: 'Tổng số hệ thống',
            total_labels: 'Tổng số nhãn',
            approved_count: 'Nhãn đã duyệt',
            proposed_count: 'Nhãn đề xuất',
            no_data: 'Không có dữ liệu phân loại.',
            loaded_count: 'Đã tải bản đồ dữ liệu doanh nghiệp',
            no_approved_labels: 'Chưa có đối tượng nào được gắn nhãn — một đối tượng xuất hiện trên bản đồ dữ liệu ngay khi có nhãn phân loại, dù nhãn đang ở trạng thái đề xuất, đang xem xét hay đã duyệt.',
        },
        discovery: {
            title: 'Chu kỳ Khám phá',
            create: 'Chu kỳ mới',
            cycle_name: 'Tên Chu kỳ',
            run_delta: 'Chạy Phát hiện Thay đổi',
            delta_success: 'Phát hiện thay đổi hoàn tất.',
            create_success: 'Chu kỳ khám phá đã được tạo.',
            no_cycles: 'Không có chu kỳ khám phá.',
            status_created: 'Đã tạo',
            status_scanning: 'Đang quét',
            status_review: 'Đang xem xét',
            status_approved: 'Đã duyệt',
            status_published: 'Đã xuất bản',
            status_draft: 'Bản nháp',
            running: 'Đang chạy',
            completed: 'Hoàn tất',
            cancelled: 'Đã hủy',
            delta_result_summary: 'Tìm thấy {added} thêm, {removed} xóa, {changed} thay đổi nhãn.',
            delta_results: 'Kết quả Thay đổi',
            view_results: 'Xem Kết quả',
            scope_type: 'Loại Phạm vi',
            scope_type_all: 'Tất cả',
            scope_type_systems: 'Hệ thống',
            scope_type_datasets: 'Bộ dữ liệu',
            scope_ids: 'ID Phạm vi',
            scope_ids_placeholder: 'Nhập ID cách nhau bởi dấu phẩy',
            cycle_explanation: 'Chu kỳ khám phá quét hạ tầng dữ liệu để nhận diện, phân loại và theo dõi tài sản dữ liệu. Cấu hình phạm vi để nhắm đến hệ thống hoặc bộ dữ liệu cụ thể.',
            empty_state_title: 'Chưa có Chu kỳ Khám phá',
            empty_state_description: 'Tạo chu kỳ khám phá đầu tiên để bắt đầu quét và phân loại tài sản dữ liệu.',
            empty_state_cta: 'Tạo Chu kỳ Đầu tiên',
            validation_name_required: 'Tên chu kỳ là bắt buộc',
            validation_scope_type_required: 'Loại phạm vi là bắt buộc',
            validation_scope_ids_required: 'Cần ít nhất một ID phạm vi',
        },
        exports: {
            title: 'Xuất phân loại',
            csv_section: 'Xuất CSV',
            pdf_section: 'Báo cáo PDF',
            inventory: 'Kho dữ liệu',
            classification_register: 'Sổ đăng ký phân loại',
            raci: 'Ma trận RACI',
            exceptions: 'Ngoại lệ',
            evidence_pack: 'Gói bằng chứng',
            delta_report: 'Báo cáo delta',
            executive_summary: 'Tóm tắt điều hành',
            exporting: 'Đang xuất…',
            export_success: 'Xuất hoàn tất thành công.',
            export_error: 'Xuất thất bại. Vui lòng thử lại.',
            csv_download: 'Tải CSV sẵn sàng.',
            pdf_download: 'Đã bắt đầu tạo PDF.',
            no_data: 'Không có dữ liệu để xuất.',
        },
        delta: {
            title: 'Chi tiết thay đổi',
            added: 'Đã thêm',
            removed: 'Đã xóa',
            changed: 'Đã thay đổi',
            added_count: 'Đã thêm ({count})',
            removed_count: 'Đã xóa ({count})',
            changed_count: 'Đã thay đổi ({count})',
            object_id: 'ID đối tượng',
            object_type: 'Loại đối tượng',
            taxonomy: 'Phân loại',
            level: 'Cấp độ',
            previous: 'Trước đó',
            current: 'Hiện tại',
            no_records: 'Không có bản ghi trong phần này.',
            empty_section: 'Phần này trống.',
        },
        schedule: {
            title: 'Lịch trình chu kỳ khám phá',
            enabled: 'Đã bật',
            interval_days: 'Khoảng cách (ngày)',
            interval_label: 'Chạy mỗi N ngày',
            manual_only: 'Chỉ thủ công',
            every_n_days: 'Mỗi {n} ngày',
            save: 'Lưu lịch trình',
            cancel: 'Hủy',
            schedule_updated: 'Cập nhật lịch trình thành công.',
        },
        regulatory: {
            sensitivity_importance_info: 'Luật Dữ liệu (Luật 60/2024/QH15, yc. 18e4bfd1) yêu cầu phân loại theo cả độ nhạy cảm và mức độ quan trọng như hai chiều riêng biệt. Tạo một phân loại cho mỗi chiều để đáp ứng yêu cầu này.',
            handling_rules_info: 'Mỗi cấp độ phân loại cần xác định quy tắc xử lý theo yc. b89981ac ("Xác định quy tắc xử lý theo cấp độ phân loại").',
            template_internal_ids_info: 'Tất cả mẫu phân loại đều dùng mã định danh nội bộ (ví dụ: vn_data_law_data_classification_record). Không mẫu nào được trình bày như biểu mẫu chính thức của bộ.',
            ai_risk_tiers_info: 'Luật AI (Luật 134/2025/QH15, yc. 3a87ad63) xác định bốn cấp độ rủi ro hệ thống AI: tối thiểu, hạn chế, cao và không chấp nhận được. Tạo phân loại Rủi ro AI với các cấp độ này.',
            ai_risk_tier_minimal: 'Tối thiểu',
            ai_risk_tier_limited: 'Hạn chế',
            ai_risk_tier_high: 'Cao',
            ai_risk_tier_unacceptable: 'Không chấp nhận được',
            ai_register_info: 'Bản ghi phân loại AI cần liên kết tới một mục trong Sổ đăng ký Hệ thống AI (yc. 0f4475d3) ghi nhận: tên hệ thống, chủ sở hữu, mục đích, bối cảnh triển khai, mức độ rủi ro và sự tham gia của nhà cung cấp.',
            ai_template_internal_info: 'Mẫu phân loại AI dùng mã định danh nội bộ (ví dụ: AI-RISK-01). Không sử dụng mã tạm chính thức nào của AI (từ AI-HC-01 đến AI-HC-08).',
            ai_audit_trail_info: 'Thay đổi phân loại AI tạo ra nhật ký kiểm toán có phiên bản theo UC-VN-06: người thực hiện, thời gian, giá trị trước, giá trị mới và lý do.',
            lifecycle_data_d1_info: 'Các chuyển đổi vòng đời ánh xạ tới các bước của quy trình DATA-D1 theo Luật Dữ liệu: lập danh mục, phân loại, xác định quy tắc xử lý, ghi nhận bằng chứng và lên lịch rà soát.',
            lifecycle_deletion_link_info: 'Tài sản dữ liệu đã phân loại đến cuối vòng đời cần kích hoạt bản ghi lịch xóa thông qua phân hệ Điều phối Xóa.',
            lifecycle_evidence_info: 'Mỗi thay đổi trạng thái vòng đời (nháp, hoạt động, đang xem xét, lưu trữ, đã xóa) ghi nhận người thực hiện, thời gian và lý do như một mục nhật ký kiểm toán.',
            escalation_timers_info: 'Thời hạn leo thang UC-VN-10: 5 ngày làm việc cho xem xét của chủ sở hữu, 48 giờ cho leo thang ngoại lệ, 72 giờ cho các mục rủi ro cao/nhạy cảm.',
            escalation_owner_review: '5 ngày làm việc',
            escalation_exception: '48 giờ',
            escalation_high_risk: '72 giờ',
            gap_risk_areas_info: 'Yêu cầu Luật Dữ liệu f6c3060a ("Đánh giá rủi ro dữ liệu") yêu cầu phân tích khoảng trống trên 4 lĩnh vực rủi ro: quyền riêng tư, an ninh mạng, kiểm soát truy cập và rủi ro vận hành.',
            gap_risk_area_privacy: 'Quyền riêng tư',
            gap_risk_area_cybersecurity: 'An ninh mạng',
            gap_risk_area_access: 'Kiểm soát truy cập',
            gap_risk_area_operational: 'Vận hành',
            gap_framework_filter_info: 'Lọc khoảng trống theo khung tuân thủ (VN_DATA_LAW hoặc VN_AI_LAW_2026) để xem các khoảng trống liên quan cho từng phạm vi quy định.',
            framework_vn_data_law: 'Luật Dữ liệu VN',
            framework_vn_ai_law: 'Luật AI VN 2026',
            enterprise_map_approved_info: 'Bản đồ dữ liệu này chỉ hiển thị các bản ghi phân loại đã phê duyệt theo bước 10 quy trình UC-VN-10 ("Nhãn đã phê duyệt trở thành sự thật doanh nghiệp hiện tại"). Các bản ghi nháp và đề xuất bị loại trừ.',
            exports_bundle_info: 'Gói xuất bao gồm: sổ đăng ký phân loại, quy tắc xử lý, quyền sở hữu/RACI và gói bằng chứng — phù hợp với yêu cầu xuất UC-VN-10 và định dạng bảng bằng chứng DATA-EVD-01.',
        },
    },
    monitoring: {
        no_permission_title: 'Không đủ quyền',
        no_permission_message: 'Bạn không có quyền truy cập phân hệ giám sát này.',
        errors: {
            fetch: 'Không thể tải.',
            save: 'Không thể lưu.',
            fetch_programs_failed: 'Không thể tải chương trình.',
            fetch_kpi_failed: 'Không thể tải dữ liệu KPI.',
            create_snapshot_failed: 'Không thể tạo bản chụp.',
            fetch_periods_failed: 'Không thể tải kỳ kiểm tra.',
            create_period_failed: 'Không thể tạo kỳ kiểm tra.',
            auto_generate_failed: 'Không thể tự động tạo kỳ kiểm tra.',
            start_period_failed: 'Không thể bắt đầu kỳ kiểm tra.',
            close_period_failed: 'Không thể đóng kỳ kiểm tra.',
            save_program_failed: 'Không thể lưu chương trình.',
            activate_program_failed: 'Không thể kích hoạt chương trình.',
            pause_program_failed: 'Không thể tạm dừng chương trình.',
            complete_program_failed: 'Không thể hoàn thành chương trình.',
            archive_program_failed: 'Không thể lưu trữ chương trình.',
            fetch_ric_templates_failed: 'Không thể tải mẫu RIC.',
            fetch_ric_cases_failed: 'Không thể tải vụ việc RIC.',
            create_ric_case_failed: 'Không thể tạo vụ việc RIC.',
            transition_ric_failed: 'Không thể chuyển trạng thái RIC.',
            add_follow_up_failed: 'Không thể thêm theo dõi.',
            respond_follow_up_failed: 'Không thể phản hồi theo dõi.',
            link_evidence_failed: 'Không thể liên kết bằng chứng.',
            fetch_task_templates_failed: 'Không thể tải mẫu nhiệm vụ.',
            save_task_template_failed: 'Không thể lưu mẫu nhiệm vụ.',
            delete_task_template_failed: 'Không thể xóa mẫu nhiệm vụ.',
            delete_framework_link_failed: 'Không thể xóa liên kết khung tuân thủ.',
            seed_defaults_failed: 'Không thể tạo dữ liệu mặc định.',
            fetch_tasks_failed: 'Không thể tải nhiệm vụ.',
            create_task_failed: 'Không thể tạo nhiệm vụ.',
            instantiate_tasks_failed: 'Không thể khởi tạo nhiệm vụ.',
            start_task_failed: 'Không thể bắt đầu nhiệm vụ.',
            complete_task_failed: 'Không thể hoàn thành nhiệm vụ.',
            defer_task_failed: 'Không thể hoãn nhiệm vụ.',
            block_task_failed: 'Không thể chặn nhiệm vụ.',
            override_complete_failed: 'Không thể ghi đè hoàn thành.',
            assign_task_failed: 'Không thể giao nhiệm vụ.',
            update_checklist_failed: 'Không thể cập nhật danh sách kiểm tra.',
        },
        nav: {
            programs: 'Chương trình',
            periods: 'Kỳ kiểm tra',
            task_templates: 'Mẫu nhiệm vụ',
            tasks: 'Nhiệm vụ',
            kpi: 'KPI',
            ric: 'Yêu cầu cơ quan',
            framework_link: 'Giám sát theo khung',
            authority_readiness: 'Sẵn sàng cơ quan',
            change_review: 'Xem xét thay đổi',
            raci: 'Ma trận RACI',
        },
        programs: {
            page_title: 'Chương trình Giám sát',
            title: 'Chương trình giám sát',
            new: 'Chương trình mới',
            edit: 'Sửa chương trình',
            name: 'Tên',
            scope: 'Phạm vi',
            frequency: 'Tần suất',
            owner: 'Chủ sở hữu',
            activate: 'Kích hoạt',
            pause: 'Tạm dừng',
            resume: 'Tiếp tục',
            complete: 'Hoàn thành',
            archive: 'Lưu trữ',
            custom_frequency_days: 'Tần suất tùy chỉnh (ngày)',
            select_user: 'Chọn người dùng…',
            assign_training: 'Phân công đào tạo',
            linked_forms: 'Biểu mẫu liên kết',
            linked_forms_none: 'Chưa có biểu mẫu liên kết',
            loaded_count: 'Đã tải {0} chương trình',
            scope_labels: {
                full: 'Toàn bộ',
                partial: 'Một phần',
                targeted: 'Có mục tiêu',
                consent: 'Đồng ý',
                dpia: 'DPIA',
                vendors: 'Nhà cung cấp',
                classification: 'Phân loại',
                rights_requests: 'Yêu cầu quyền',
                data_mapping: 'Ánh xạ dữ liệu',
                transfers: 'Chuyển giao',
                security_monitoring: 'Giám sát bảo mật',
                authority_response: 'Phản hồi cơ quan chức năng',
                evidence_preservation: 'Bảo quản bằng chứng',
                localization_review: 'Đánh giá bản địa hóa',
                ai_system_registration: 'Đăng ký hệ thống AI',
                ai_pre_deployment: 'Đánh giá trước triển khai AI',
                ai_transparency: 'Kiểm tra minh bạch AI',
                ai_incident_review: 'Đánh giá sự cố AI',
            },
            framework_cadence_info: 'Chương trình Luật An ninh mạng thường sử dụng nhịp giám sát liên tục, hàng tháng hoặc hàng quý. Chương trình Luật AI thường sử dụng nhịp đánh giá hàng năm để cập nhật đăng ký hệ thống.',
        },
        periods: {
            page_title: 'Kỳ Giám sát',
            title: 'Kỳ kiểm tra',
            new: 'Kỳ mới',
            label: 'Tên kỳ',
            start_date: 'Ngày bắt đầu',
            end_date: 'Ngày kết thúc',
            reviewers: 'Người kiểm tra',
            auto_generate: 'Tự động tạo kỳ',
            start: 'Bắt đầu',
            close: 'Đóng',
            change_digest: 'Nhật ký thay đổi',
            no_digest: 'Không có bản tóm tắt.',
            reviewers_count: 'Số người đánh giá',
            select_program: 'Chọn chương trình',
            select_program_prompt: 'Chọn chương trình để xem kỳ đánh giá.',
            hide_digest: 'Ẩn tóm tắt',
            loaded_count: 'Đã tải {0} kỳ',
            periods_auto_generated: 'Đã tự động tạo kỳ',
            label_placeholder: 'ví dụ: 2026-Q1',
        },
        task_templates: {
            page_title: 'Mẫu Nhiệm vụ',
            title: 'Mẫu nhiệm vụ',
            new: 'Mẫu mới',
            edit: 'Sửa mẫu',
            category: 'Danh mục',
            priority: 'Ưu tiên',
            checklist_items: 'Mục kiểm tra',
            effort: 'Thời gian ước tính (giờ)',
            pre_seeded: 'Đã cài sẵn',
            seed_defaults: 'Cài mẫu mặc định',
            add_checklist: 'Thêm mục kiểm tra',
            guidance: 'Hướng dẫn',
            all_categories: 'Tất cả danh mục',
            loaded_count: 'Đã tải {0} mẫu nhiệm vụ',
            defaults_seeded: 'Đã tạo mẫu nhiệm vụ mặc định',
            checklist_item_label: 'Mục kiểm tra {0}',
            remove_checklist_item: 'Xóa mục kiểm tra {0}',
            category_info: 'Danh mục bao gồm tuân thủ PDPL (Đồng ý, DPIA, Nhà cung cấp, v.v.), nhiệm vụ Luật An ninh mạng (Giám sát bảo mật, Phản hồi cơ quan, v.v.) và nhiệm vụ Luật AI (Đăng ký hệ thống, Đánh giá trước triển khai, v.v.).',
        },
        tasks: {
            page_title: 'Nhiệm vụ Đánh giá',
            title: 'Nhiệm vụ kiểm tra',
            new: 'Nhiệm vụ mới',
            assigned_to: 'Phân công cho',
            due_date: 'Hạn hoàn thành',
            checklist: 'Danh sách kiểm tra',
            start: 'Bắt đầu',
            complete: 'Hoàn thành',
            defer: 'Hoãn lại',
            block: 'Chặn',
            override_complete: 'Buộc hoàn thành',
            link_evidence: 'Liên kết bằng chứng',
            // Sprint 41.3.0 F4 — direct file attachments on a monitoring task
            direct_upload_label: 'Tải lên tệp bằng chứng',
            instantiate: 'Tạo từ mẫu',
            defer_reason: 'Lý do hoãn',
            override_justification: 'Lý do buộc hoàn thành',
            filter_assignee: 'Lọc theo người phụ trách',
            select_period: 'Chọn kỳ',
            select_program: 'Chọn chương trình',
            select_program_period_prompt: 'Chọn chương trình và kỳ để xem nhiệm vụ.',
            assign_placeholder: 'Phân công cho...',
            loaded_count: 'Đã tải {0} nhiệm vụ',
            tasks_instantiated: 'Đã tạo nhiệm vụ từ mẫu',
            overdue: 'Quá hạn',
            checklist_for: 'danh sách kiểm tra cho',
            manage_checklist: 'Quản lý danh sách kiểm tra',
            add_checklist_item: 'Thêm mục',
            checklist_item_label: 'Mục',
            checklist_item_description: 'Mô tả',
            remove_checklist_item: 'Xóa mục',
            save_checklist: 'Lưu danh sách kiểm tra',
            no_checklist_items: 'Chưa có mục kiểm tra nào.',
            // fix-sprint-20260411-D F6 — confirm dialog before deleting audit evidence
            confirm_delete_attachment: 'Bạn có chắc chắn muốn xóa tệp bằng chứng này không? Hành động này không thể hoàn tác.',
        },
        kpi: {
            page_title: 'Bảng điều khiển KPI',
            title: 'Bảng KPI',
            kpi_name: 'Tên KPI',
            current_value: 'Giá trị hiện tại',
            target: 'Mục tiêu',
            trends: 'Xu hướng',
            capture_snapshot: 'Chụp ảnh',
            select_program: 'Chọn chương trình',
            select_program_prompt: 'Chọn chương trình để xem KPI.',
            snapshot: 'Ảnh chụp',
            kpi_labels: {
                on_track: 'Đúng tiến độ',
                at_risk: 'Có rủi ro',
                behind: 'Chậm tiến độ',
                rights_request_sla_rate: 'Tỷ lệ SLA yêu cầu quyền',
                vendor_review_currency: 'Mức cập nhật đánh giá nhà cung cấp',
                dpia_completion_rate: 'Tỷ lệ hoàn thành DPIA',
                classification_coverage: 'Phạm vi phân loại',
                consent_policy_currency: 'Mức cập nhật chính sách đồng ý',
                security_event_detection_rate: 'Tỷ lệ phát hiện sự kiện bảo mật',
                evidence_preservation_compliance_rate: 'Tỷ lệ tuân thủ bảo quản bằng chứng',
                authority_response_timeliness: 'Thời gian phản hồi cơ quan chức năng',
                localization_readiness_score: 'Điểm sẵn sàng bản địa hóa',
                ai_register_completeness: 'Mức hoàn thiện đăng ký hệ thống AI',
                pre_deployment_gate_pass_rate: 'Tỷ lệ vượt qua cổng trước triển khai',
                transparency_disclosure_coverage: 'Phạm vi công bố minh bạch',
                ai_incident_readiness_score: 'Điểm sẵn sàng sự cố AI',
            },
            pdpl_kpi_info: 'Các mã KPI định sẵn (Tỷ lệ SLA yêu cầu quyền, Tỷ lệ hoàn thành DPIA, Mức cập nhật đánh giá nhà cung cấp, Phạm vi phân loại, Mức cập nhật chính sách đồng ý) là các chỉ số riêng của PDPL. Đối với giám sát Luật An ninh mạng hoặc Luật AI, sử dụng mã KPI theo khung tuân thủ.',
            cybersec_kpi_info: 'KPI Luật An ninh mạng: Tỷ lệ phát hiện sự kiện bảo mật, Tỷ lệ tuân thủ bảo quản bằng chứng, Thời gian phản hồi cơ quan chức năng, Điểm sẵn sàng bản địa hóa.',
            ai_law_kpi_info: 'KPI Luật AI: Mức hoàn thiện đăng ký hệ thống AI, Tỷ lệ vượt qua cổng trước triển khai, Phạm vi công bố minh bạch, Điểm sẵn sàng sự cố AI.',
            no_data: 'Không có dữ liệu.',
            snapshot_date: 'Ngày chụp',
            loaded_count: 'Đã tải {0} ảnh chụp KPI',
            snapshot_captured: 'Đã chụp ảnh KPI',
            showing_chart: 'Đang hiển thị biểu đồ',
            showing_table: 'Đang hiển thị bảng dữ liệu',
            aria_current_values: 'Giá trị hiện tại KPI',
            kpi_label: 'KPI',
            actual: 'Thực tế',
            trend: 'Xu hướng',
            notes: 'Ghi chú',
            trend_up: 'Tăng',
            trend_down: 'Giảm',
            trend_stable: 'Ổn định',
        },
        ric: {
            page_title: 'Vụ việc RIC',
            title: 'Yêu cầu cơ quan quản lý',
            new: 'Yêu cầu mới',
            reference: 'Mã tham chiếu',
            regulator: 'Cơ quan',
            inquiry_type: 'Loại yêu cầu',
            deadline: 'Hạn trả lời',
            lead: 'Người phụ trách',
            follow_ups: 'Theo dõi',
            add_follow_up: 'Thêm theo dõi',
            respond: 'Trả lời',
            question: 'Câu hỏi',
            response: 'Trả lời',
            asked_at: 'Hỏi lúc',
            no_follow_ups: 'Chưa có theo dõi.',
            received_date: 'Ngày nhận',
            responded_at: 'Trả lời lúc',
            hide_follow_ups: 'Ẩn theo dõi',
            inquiry_types: {
                general: 'Chứng',
                investigation: 'Điều tra',
                audit: 'Kiểm toán',
                complaint: 'Khiếu nại',
                general_audit: 'Kiểm toán tổng hợp',
                rights_requests_review: 'Rà soát yêu cầu quyền',
                cross_border_transfer_review: 'Rà soát chuyển giao xuyên biên giới',
                vendor_governance_review: 'Rà soát quản trị nhà cung cấp',
                consent_management_review: 'Rà soát quản lý đồng ý',
                data_mapping_ropa_review: 'Rà soát ánh xạ dữ liệu / ROPA',
                incident_readiness_review: 'Rà soát sẵn sàng sự cố',
                security_access_control_review: 'Rà soát bảo mật & kiểm soát truy cập',
                targeted_processing_review: 'Rà soát xử lý có mục tiêu',
                bank_readiness_pack: 'Gói sẵn sàng ngân hàng',
            },
            status_labels: {
                received: 'Đã nhận',
                in_triage: 'Đang phân loại',
                evidence_gathering: 'Thu thập bằng chứng',
                response_drafting: 'Soạn thảo phản hồi',
                internal_review: 'Rà soát nội bộ',
                submitted: 'Đã nộp',
                follow_up: 'Theo dõi',
                closed: 'Đã đóng',
            },
            link_evidence: 'Liên kết bằng chứng',
            loaded_count: 'Đã tải {0} vụ việc RIC',
            to_follow_up: 'câu hỏi theo dõi',
            overdue: 'Quá hạn',
            overdue_indicator: 'Đã quá hạn phản hồi',
            template_info: 'Mẫu RIC là mẫu nội bộ của nền tảng để cấu trúc phản hồi yêu cầu. Đây không phải là biểu mẫu chính thức do chính phủ quy định.',
        },
        framework_link: {
            title: 'Giám sát liên kết khung',
            link_program: 'Liên kết chương trình với khung',
            framework_code: 'Mã khung',
            select_framework: 'Chọn khung tuân thủ...',
            select_program: 'Chọn chương trình...',
            readiness_score: 'Điểm sẵn sàng',
            no_links: 'Không tìm thấy chương trình liên kết khung',
            seed_defaults: 'Tạo mẫu mặc định',
            program_id: 'Mã chương trình',
            program: 'Chương trình',
        },
        authority_readiness: {
            title: 'Sẵn sàng yêu cầu cơ quan',
            create_entry: 'Mục sẵn sàng mới',
            select_framework: 'Chọn khung tuân thủ...',
            framework_code: 'Khung tuân thủ',
            readiness_status: 'Trạng thái sẵn sàng',
            readiness_package: 'Gói sẵn sàng',
            run_drill: 'Chạy diễn tập sẵn sàng',
            drill_success: 'Đã ghi nhận diễn tập sẵn sàng',
            last_drill: 'Diễn tập gần nhất',
            never_drilled: 'Chưa từng',
            no_readiness: 'Không tìm thấy dữ liệu sẵn sàng cơ quan',
            entry_created: 'Mục sẵn sàng đã tạo',
            ready: 'Sẵn sàng',
            partial: 'Một phần',
            not_ready: 'Chưa sẵn sàng',
            items: 'mục',
        },
        change_review: {
            title: 'Xem xét thay đổi quy định',
            new_review: 'Xem xét thay đổi mới',
            change_id: 'Mã thay đổi',
            select_change: 'Chọn thay đổi...',
            select_framework: 'Chọn khung tuân thủ...',
            impact_assessment: 'Đánh giá tác động',
            decision: 'Quyết định',
            no_action: 'Không hành động',
            internal_update: 'Cập nhật nội bộ',
            authority_filing: 'Nộp cơ quan',
            no_reviews: 'Không tìm thấy xem xét thay đổi',
            auto_cycle: 'Tự động kích hoạt chu kỳ xem xét',
            cadence: 'Tần suất xem xét',
            framework: 'Khung tuân thủ',
        },
        export_csv: 'Xuất CSV',
        exporting: 'Đang xuất…',
        export_success: 'Xuất CSV thành công.',
        export_failed: 'Xuất CSV thất bại.',
        export_attestation_pack: 'Xuất gói chứng thực',
        staleness: {
            badge_label: '{0} mục cũ',
            days_since: '{0} ngày kể từ cập nhật cuối',
            detail_title: 'Mục cũ',
            accept_justification: 'Chấp nhận với lý do',
            justification_label: 'Lý do',
            no_stale: 'Không tìm thấy mục cũ.',
            threshold_label: 'Ngưỡng cũ (ngày)',
            threshold_min: 'Tối thiểu 30 ngày',
            threshold_max: 'Tối đa 730 ngày',
            threshold_saved: 'Đã cập nhật ngưỡng cũ.',
        },
        csv_columns: {
            name: 'Tên',
            status: 'Trạng thái',
            owner: 'Chủ sở hữu',
            created_at: 'Ngày tạo',
            updated_at: 'Ngày cập nhật',
            scope: 'Phạm vi',
            frameworks: 'Khung tuân thủ',
            period_label: 'Nhãn kỳ',
            start_date: 'Ngày bắt đầu',
            end_date: 'Ngày kết thúc',
            task_count: 'Số nhiệm vụ',
            completion_rate: 'Tỷ lệ hoàn thành',
            title: 'Tiêu đề',
            assigned_to: 'Giao cho',
            due_date: 'Hạn',
            priority: 'Ưu tiên',
            completed_at: 'Hoàn thành lúc',
            kpi_code: 'Mã KPI',
            kpi_label: 'Nhãn KPI',
            target: 'Mục tiêu',
            actual: 'Thực tế',
            trend: 'Xu hướng',
            reference: 'Tham chiếu',
            regulator: 'Cơ quan',
            inquiry_type: 'Loại yêu cầu',
            lead: 'Người phụ trách',
            received_date: 'Ngày nhận',
            deadline: 'Hạn chót',
            framework_code: 'Mã khung',
            readiness_status: 'Trạng thái sẵn sàng',
            package_count: 'Số gói',
            change_id: 'Mã thay đổi',
            impact_assessment: 'Đánh giá tác động',
            decision: 'Quyết định',
            program: 'Chương trình',
            readiness_score: 'Điểm sẵn sàng',
            category: 'Danh mục',
            checklist_count: 'Số mục kiểm tra',
            effort_hours: 'Công sức (giờ)',
            version: 'Phiên bản',
            department: 'Phòng ban',
            function_area: 'Lĩnh vực chức năng',
            role: 'Vai trò',
            assignee: 'Người được giao',
            frequency: 'Tần suất',
        },
        raci: {
            page_title: 'Ma trận RACI quản trị',
            title: 'Ma trận RACI quản trị',
            department: 'Phòng ban',
            function_area: 'Lĩnh vực chức năng',
            responsible: 'Chịu trách nhiệm',
            accountable: 'Giải trình',
            consulted: 'Tham vấn',
            informed: 'Thông báo',
            assign_role: 'Gán vai trò RACI',
            select_program: 'Chọn chương trình',
            select_program_prompt: 'Chọn chương trình để xem ma trận RACI.',
            no_assignments: 'Không tìm thấy phân công RACI.',
            role_updated: 'Đã cập nhật phân công RACI.',
            role_labels: {
                R: 'Chịu trách nhiệm',
                A: 'Giải trình',
                C: 'Tham vấn',
                I: 'Thông báo',
            },
            loaded_count: 'Đã tải {0} phân công RACI',
            single_accountability_warning: 'Chỉ được phép một vai trò Chịu trách nhiệm (A) cho mỗi lĩnh vực chức năng. Gán vai trò Chịu trách nhiệm mới sẽ thay thế vai trò hiện có.',
            cybersec_function_areas: 'Lĩnh vực chức năng Luật An ninh mạng: Ứng phó sự cố, Bảo quản bằng chứng, Hợp tác cơ quan chức năng, Đánh giá bản địa hóa.',
            ai_law_function_areas: 'Lĩnh vực chức năng Luật AI: Đăng ký hệ thống, Đánh giá trước triển khai, Minh bạch, Xử lý sự cố.',
            suggested_function_areas: 'Lĩnh vực chức năng đề xuất',
        },
        prior_cycle: {
            link_label: 'Liên kết chu kỳ trước',
            select_prior: 'Chọn chu kỳ trước…',
            linked: 'Năm qua năm',
            no_prior: 'Không có chu kỳ trước.',
            linked_success: 'Đã liên kết chu kỳ trước.',
        },
        digest_table: {
            module: 'Phân hệ',
            entity_type: 'Loại thực thể',
            change_type: 'Loại thay đổi',
            description: 'Mô tả',
            changed_at: 'Thay đổi lúc',
        },
        view_related_ric: 'Xem RIC liên quan',
        linked_program: 'Chương trình liên kết',
        nav_raci: 'Ma trận RACI',
    },
    incidents: {
        // Sprint 48.1.6 — Bản nháp phản hồi yêu cầu cơ quan của Forseti
        authority_response_draft: {
            draft_label: 'Soạn phản hồi',
            drafting: 'Đang soạn…',
            results_heading: 'Câu trả lời đã soạn ({count})',
            tokens_label: '≈ {count} token',
            counsel_label: 'Cần xem xét pháp lý:',
            counsel_default: 'Ít nhất một câu trả lời cần xem xét pháp lý trước khi gửi.',
            requires_counsel_label: 'Cần xem xét pháp lý.',
            accept_label: 'Chấp nhận nháp',
            reject_label: 'Bỏ nháp',
            error_generic: 'Không soạn được phản hồi. Hãy thử lại hoặc bổ sung văn bản yêu cầu.',
            question_action_accepted: 'Chấp nhận câu trả lời',
            question_action_rejected: 'Từ chối câu trả lời',
            question_action_needs_counsel: 'Cần xem xét pháp lý',
            question_action_aria: '{action} ({question})',
            question_decision_label: 'Quyết định về câu trả lời này: {decision}',
            question_decision_accepted: 'đã chấp nhận',
            question_decision_rejected: 'đã từ chối',
            question_decision_needs_counsel: 'chuyển xem xét pháp lý',
            download_docx_label: 'Tải mẫu phản hồi (DOCX)',
            draft_resolved_accepted: 'Mọi câu trả lời đã được quyết định. Bản nháp đã được chấp nhận.',
            draft_resolved_rejected: 'Mọi câu trả lời đã được quyết định. Bản nháp đã bị từ chối.',
        },
        // Sprint 48.1.5 — Bảng thời hạn thông báo vi phạm của Forseti
        breach_timeline: {
            compute_label: 'Tính thời hạn thông báo vi phạm',
            computing: 'Đang tính…',
            results_heading: 'Thời hạn thông báo vi phạm ({count})',
            tokens_label: '≈ {count} token',
            handoff_label: 'Forseti đề xuất:',
            empty_label: 'Không có khung tuân thủ đã cài đặt nào công bố nghĩa vụ thông báo cho sự cố này.',
            mandatory_label: 'Trường bắt buộc:',
            draft_label: 'Bản nháp thông báo',
            remaining_label: 'Còn {count}h',
            overdue_label: 'Quá hạn {count}h',
            acknowledge_label: 'Xác nhận thời hạn thông báo',
            acknowledging: 'Đang xác nhận…',
            error_generic: 'Không tính được thời hạn vi phạm. Hãy thử lại.',
            tasks_note: 'Các nhiệm vụ khẩn đã được tạo cho những nghĩa vụ khớp với phạm vi pháp lý của sự cố này. Tính lại sẽ dùng lại chúng thay vì tạo thêm.',
        },
        breach_determination: {
            yes: 'Vi phạm đã xác nhận',
            no: 'Không phải vi phạm',
            uncertain: 'Chưa xác định',
        },
        errors: {
            fetch: 'Không thể tải sự cố.',
            save: 'Không thể lưu sự cố.',
            fetch_failed: 'Không thể tải sự cố.',
            save_failed: 'Không thể lưu sự cố.',
            transition_failed: 'Không thể chuyển trạng thái sự cố.',
            close_failed: 'Không thể đóng sự cố.',
            fetch_timeline_failed: 'Không thể tải dòng thời gian.',
            fetch_decisions_failed: 'Không thể tải quyết định.',
            triage_failed: 'Không thể cập nhật phân loại.',
            impact_update_failed: 'Không thể cập nhật đánh giá tác động.',
            breach_update_failed: 'Không thể cập nhật đánh giá vi phạm.',
            create_timeline_failed: 'Không thể tạo mục dòng thời gian.',
            create_decision_failed: 'Không thể tạo quyết định.',
            notification_update_failed: 'Không thể cập nhật thông báo.',
            // Sprint 62.35.0 gate E12.5 pass 2 (P2-1)
            breach_conflict: 'Yêu cầu thông báo của sự cố này đã được thay đổi bởi một lần lưu khác sau lần trang này tải chúng gần nhất, nên đánh giá vi phạm chưa được lưu. Phiên bản mới nhất của sự cố đang được tải và các thông tin bạn đã nhập vẫn được giữ: hãy kiểm tra và lưu lại.',
            notification_status_conflict: 'Yêu cầu thông báo của sự cố này đã được thay đổi bởi một lần lưu khác sau lần trang này tải chúng gần nhất, nên trạng thái thông báo chưa được thay đổi. Phiên bản mới nhất của sự cố đang được tải: hãy kiểm tra trạng thái và thay đổi lại nếu vẫn cần.',
            fetch_tasks_failed: 'Không thể tải nhiệm vụ.',
            create_task_failed: 'Không thể tạo nhiệm vụ.',
            update_task_status_failed: 'Không thể cập nhật trạng thái nhiệm vụ.',
            update_checklist_failed: 'Không thể cập nhật danh sách kiểm tra.',
            assign_task_failed: 'Không thể giao nhiệm vụ.',
            escalate_task_failed: 'Không thể leo thang nhiệm vụ.',
            fetch_templates_failed: 'Không thể tải mẫu.',
            permission_denied: 'Bạn không có quyền truy cập phần này. Liên hệ quản trị viên để yêu cầu quyền truy cập.',
        },
        harm_likelihood: {
            unlikely: 'Khó xảy ra',
            possible: 'Có thể',
            likely: 'Có khả năng',
            very_likely: 'Rất có khả năng',
        },
        // Sprint 63.37.0 (legal second read S12) — the impact assessment's two vocabularies as words.
        data_category_options: {
            personal_data: 'Dữ liệu cá nhân',
            sensitive_personal_data: 'Dữ liệu cá nhân nhạy cảm',
            financial_data: 'Dữ liệu tài chính',
            health_data: 'Dữ liệu sức khỏe',
            childrens_data: 'Dữ liệu cá nhân của trẻ em',
            other: 'Dữ liệu cá nhân khác',
        },
        consequence_options: {
            identity_theft: 'Bị đánh cắp danh tính',
            financial_loss: 'Tổn thất tài chính',
            reputational_damage: 'Tổn hại uy tín',
            discrimination: 'Phân biệt đối xử',
            emotional_distress: 'Tổn thương tinh thần',
            physical_harm: 'Tổn hại thể chất',
            loss_of_confidentiality: 'Mất tính bảo mật',
            loss_of_access: 'Mất quyền truy cập dữ liệu',
        },
        reported_via: {
            email: 'Email',
            phone: 'Điện thoại',
            internal_system: 'Hệ thống nội bộ',
            third_party: 'Bên thứ ba',
            automated_detection: 'Phát hiện tự động',
        },
        task_transition_labels: {
            start: 'Bắt đầu',
            complete: 'Hoàn thành',
            block: 'Chặn',
            defer: 'Hoãn lại',
            cancel: 'Hủy',
            unblock: 'Bỏ chặn',
        },
        transition_labels: {
            start: 'Bắt đầu',
            complete: 'Hoàn thành',
            block: 'Chặn',
            defer: 'Hoãn lại',
        },
        nav: {
            all: 'Tất cả sự cố',
            tasks: 'Nhiệm vụ xử lý',
            reports: 'Báo cáo',
            breach_notifications: 'Thông báo Vi phạm',
            supplements: 'Bổ sung',
            remediation: 'Khắc phục',
            authority_requests: 'Yêu cầu Cơ quan',
            disclosure_register: 'Sổ Công khai',
        },
        list: {
            page_title: 'Sự cố',
            title: 'Sự cố',
            new: 'Sự cố mới',
            edit: 'Sửa sự cố',
            incident_title: 'Tiêu đề',
            severity: 'Mức độ nghiêm trọng',
            reported_at: 'Thời gian báo cáo',
            reported_by: 'Người báo cáo',
            assigned_to: 'Phân công cho',
            view_detail: 'Xem chi tiết',
            reference: 'Mã tham chiếu',
            lead: 'Trưởng nhóm',
            reported_via: 'Báo cáo qua',
            discovery_date: 'Ngày phát hiện',
            // fix-sprint #447 W10 — discovery is a date and time
            discovery_hint: 'Ngày và giờ phát hiện sự cố. Các thời hạn thông báo tính theo giờ được tính từ thời điểm này.',
            discovery_no_time: '(không ghi nhận giờ)',
            discovery_day_only_hint: 'Thời điểm phát hiện được ghi nhận là ngày {day}, không có giờ. Nhập ngày và giờ để ghi nhận, hoặc để trống để giữ nguyên ngày.',
            hide_details: 'Ẩn chi tiết',
            close_incident: 'Đóng sự cố',
            close_justification_prompt: 'Vui lòng cung cấp lý do đóng sự cố này.',
            justification: 'Lý do',
            lead_id: 'Mã trưởng nhóm',
            lead_not_assigned: 'Chưa phân công',
            date_not_recorded: 'Chưa ghi nhận',
            contact: 'Liên hệ',
            category: 'Danh mục',
            not_assessed: 'Chưa đánh giá',
            // fix-sprint-20260717-2118-followup F11
            section_incident_details: 'Chi tiết sự cố',
        },
        detail: {
            page_title: 'Chi tiết Sự cố',
            title: 'Chi tiết sự cố',
            page_description: 'Toàn bộ thông tin của một sự cố: tổng quan, phân loại, đánh giá tác động và đánh giá vi phạm, dòng thời gian, quyết định, bằng chứng và nhật ký kiểm toán.',
            forseti_heading: 'Forseti cho sự cố này',
            tabs: {
                overview: 'Tổng quan',
                triage: 'Phân loại',
                impact: 'Đánh giá tác động',
                breach: 'Đánh giá vi phạm',
                timeline: 'Dòng thời gian',
                decisions: 'Quyết định',
                // Sprint 41.3.0 F3 — evidence attachments tab
                evidence: 'Bằng chứng',
                audit_trail: 'Nhật ký kiểm toán',
            },
            // Sprint 41.3.0 F3 — evidence attachments strings
            evidence_upload_label: 'Đính kèm tệp bằng chứng',
            evidence_uploaded: 'Đã tải lên bằng chứng',
            evidence_deleted: 'Đã xóa bằng chứng',
            evidence_delete_error: 'Không thể xóa bằng chứng',
            evidence_uploaded_at: 'Đã tải lên',
            evidence_empty: 'Chưa có tệp bằng chứng nào được đính kèm vào sự cố này.',
            evidence_size: 'Kích thước',
            triage_notes: 'Ghi chú phân loại',
            initial_classification: 'Phân loại ban đầu',
            individuals_affected: 'Số cá nhân bị ảnh hưởng',
            data_categories: 'Danh mục dữ liệu liên quan',
            systems_compromised: 'Hệ thống bị ảnh hưởng',
            geographic_scope: 'Phạm vi địa lý',
            breach_determination: 'Xác định vi phạm',
            // fix-sprint #447 W10 — the notification clock runs from discovery
            notification_clock: {
                label: 'Thời hạn thông báo',
                started_from_discovery: 'Đang tính từ thời điểm phát hiện đã ghi nhận: {date}',
                started_at_triage: 'Đang tính từ {date}, thời điểm xác định có vi phạm; khi đó chưa ghi nhận thời điểm phát hiện. Ghi nhận thời điểm phát hiện sẽ tính lại thời hạn từ thời điểm đó.',
                started_from_earlier_discovery: 'Đang tính từ {date}, thời điểm phát hiện được ghi nhận khi xác định có vi phạm. Thời điểm phát hiện ghi nhận hiện nay khác; thời hạn không bị dời.',
                not_started_no_discovery: 'Chưa bắt đầu: đã xác định có vi phạm nhưng chưa ghi nhận ngày và giờ phát hiện. Thời hạn được tính từ thời điểm phát hiện, không bao giờ tính từ lúc phân loại. Hãy ghi nhận thời điểm phát hiện sự cố để bắt đầu tính.',
                not_started_no_determination: 'Chưa bắt đầu: chưa xác định có vi phạm. Khi đã xác định, thời hạn được tính từ thời điểm phát hiện đã ghi nhận.',
            },
            notification_required: 'Yêu cầu thông báo',
            notification_deadline: 'Hạn thông báo',
            pdpc_reportable: 'Báo cáo PDPC',
            add_timeline: 'Thêm mốc thời gian',
            add_decision: 'Thêm quyết định',
            not_found: 'Không tìm thấy sự cố.',
            team_members: 'Thành viên nhóm',
            checklist: 'Danh sách kiểm tra',
            completed: 'Hoàn thành',
            impact_severity_score: 'Điểm mức độ nghiêm trọng',
            records_affected: 'Số bản ghi bị ảnh hưởng',
            potential_consequences: 'Hậu quả tiềm tàng',
            harm_likelihood: 'Khả năng gây hại',
            legal_basis: 'Cơ sở pháp lý',
            legal_basis_not_recorded: 'Chưa ghi nhận',
            jurisdictions: 'Quyền tài phán',
            jurisdictions_comma: 'Quyền tài phán (phân cách bằng dấu phẩy)',
            jurisdiction: 'Quyền tài phán',
            authority_status: 'Trạng thái cơ quan',
            subject_status: 'Trạng thái đối tượng',
            authority_deadline: 'Hạn cơ quan',
            subject_deadline: 'Hạn đối tượng',
            mark_authority_done: 'Đánh dấu cơ quan hoàn thành',
            mark_subject_done: 'Đánh dấu đối tượng hoàn thành',
            // Sprint 62.35.0 gate E12.5 pass 2 (P2-2)
            requirement_statuses: {
                not_required: 'Không cần thông báo',
                required: 'Cần thông báo',
                in_progress: 'Đang thực hiện',
                completed: 'Hoàn thành',
                overdue: 'Quá hạn',
            },
            status_contradiction: {
                declared_required: 'Đánh giá hiện xác định {notification} là cần thiết; trạng thái đã ghi nhận là {status}.',
                declared_not_required: 'Đánh giá hiện xác định {notification} là không cần thiết; trạng thái đã ghi nhận là {status}.',
                notifications: {
                    authority_status: 'việc thông báo cho cơ quan',
                    subject_status: 'việc thông báo cho chủ thể dữ liệu',
                    other_status: 'việc thông báo cho các bên khác',
                },
            },
            // Sprint 62.35.0 (AC9) — affected parties beyond the data subjects
            affected_parties: {
                title: 'Tổ chức, cá nhân có liên quan được thông báo',
                intro: 'Các tổ chức, cá nhân có liên quan, ngoài chủ thể dữ liệu, đã được thông báo về sự cố này theo yêu cầu thông báo này, còn phải được thông báo, hoặc không cần thông báo.',
                requirement_heading: 'Yêu cầu thông báo: {jurisdiction}',
                no_requirements: 'Sự cố này chưa ghi nhận yêu cầu thông báo nào, vì vậy chưa có yêu cầu để ghi nhận tổ chức, cá nhân có liên quan.',
                empty: 'Chưa ghi nhận tổ chức, cá nhân có liên quan nào cho yêu cầu này.',
                not_recorded: 'Chưa ghi nhận',
                add: 'Thêm tổ chức, cá nhân có liên quan',
                add_aria: 'Thêm tổ chức, cá nhân có liên quan cho yêu cầu {jurisdiction}',
                edit: 'Chỉnh sửa',
                edit_aria: 'Chỉnh sửa tổ chức, cá nhân có liên quan: {name}',
                remove: 'Xóa',
                remove_aria: 'Xóa tổ chức, cá nhân có liên quan: {name}',
                remove_confirm_title: 'Xóa tổ chức, cá nhân có liên quan này?',
                remove_confirm_message: 'Dòng này sẽ bị xóa khỏi yêu cầu thông báo. Nhật ký kiểm toán vẫn lưu nội dung đã ghi nhận.',
                modal_add_title: 'Thêm tổ chức, cá nhân có liên quan',
                modal_edit_title: 'Chỉnh sửa tổ chức, cá nhân có liên quan',
                table_label: 'Tổ chức, cá nhân có liên quan cho yêu cầu {jurisdiction}',
                col_party: 'Tổ chức, cá nhân',
                col_type: 'Loại',
                col_status: 'Trạng thái',
                col_date: 'Ngày thông báo',
                field_party_name: 'Tên tổ chức, cá nhân',
                field_party_type: 'Loại tổ chức, cá nhân',
                field_contact: 'Liên hệ',
                field_status: 'Trạng thái thông báo',
                field_notified_on: 'Ngày thông báo',
                field_reason: 'Lý do không cần thông báo',
                field_note: 'Ghi chú',
                types: {
                    data_owner: 'Chủ sở hữu dữ liệu',
                    partner: 'Đối tác',
                    handover_recipient: 'Bên nhận bàn giao',
                    other: 'Khác',
                },
                statuses: {
                    pending: 'Chờ xử lý',
                    notified: 'Đã thông báo',
                    not_required: 'Không cần thông báo',
                },
                errors: {
                    party_name_required: 'Nhập tên tổ chức, cá nhân.',
                    notified_on_required: 'Nhập ngày đã thông báo.',
                    notified_on_in_future: 'Ngày thông báo không được ở tương lai.',
                    reason_required: 'Nhập lý do không cần thông báo.',
                    save_failed: 'Không thể lưu tổ chức, cá nhân có liên quan.',
                    remove_failed: 'Không thể xóa tổ chức, cá nhân có liên quan.',
                    conflict: 'Yêu cầu thông báo của sự cố này đã được thay đổi bởi một lần lưu khác sau lần trang này tải chúng gần nhất, nên chưa có nội dung nào được lưu. Phiên bản mới nhất của sự cố đang được tải và các thông tin bạn đã nhập vẫn được giữ: hãy kiểm tra và lưu lại.',
                    remove_conflict: 'Yêu cầu thông báo của sự cố này đã được thay đổi bởi một lần lưu khác sau lần trang này tải chúng gần nhất, nên tổ chức, cá nhân có liên quan chưa bị xóa. Phiên bản mới nhất của sự cố đang được tải: hãy kiểm tra danh sách và xóa lại nếu tổ chức, cá nhân đó vẫn còn.',
                    conflict_party_changed: 'Một lần lưu khác đã thay đổi tổ chức, cá nhân có liên quan này sau khi bạn mở biểu mẫu, nên chưa có nội dung nào được lưu. Biểu mẫu hiện hiển thị các giá trị mà lần lưu đó đã ghi nhận và các thông tin bạn đã nhập không được giữ lại: hãy xem lại các giá trị và nhập lại thay đổi của bạn trước khi lưu.',
                    conflict_party_gone: 'Một lần lưu khác đã xóa tổ chức, cá nhân có liên quan này sau khi bạn mở biểu mẫu, nên chưa có nội dung nào được lưu và biểu mẫu đã được đóng.',
                    conflict_requirement_gone: 'Một lần lưu khác đã xóa yêu cầu thông báo này khỏi sự cố sau khi bạn mở biểu mẫu, nên chưa có nội dung nào được lưu và biểu mẫu đã được đóng.',
                },
                saved: 'Đã lưu tổ chức, cá nhân có liên quan',
                removed: 'Đã xóa tổ chức, cá nhân có liên quan',
            },
            // Sprint 62.45.0 — the service-interruption window on the incident record
            interruption_window: {
                title: 'Khoảng thời gian gián đoạn',
                intro: 'Thời điểm hệ thống hoặc dịch vụ bị ngừng, thời điểm hoạt động trở lại và thời điểm hoàn thành khắc phục. Chỉ ghi nhận một lần tại đây, để mọi nội dung phát sinh từ các thời điểm này đọc từ hồ sơ này và không nhập lại. Hoàn thành khắc phục không đồng nghĩa với đóng sự cố.',
                // Gate E12.5 pass 3 (QA P2) — shown only to a viewer who can read the register.
                intro_register: 'Thời điểm hệ thống hoặc dịch vụ thuộc diện giám sát bị ngừng, thời điểm hoạt động trở lại và thời điểm hoàn thành khắc phục. Chỉ ghi nhận một lần tại đây: sổ đăng ký Báo cáo giám sát đọc các thời điểm này cho thông báo gián đoạn và báo cáo sự cố, và không nhập lại. Hoàn thành khắc phục không đồng nghĩa với đóng sự cố.',
                started_at: 'Thời điểm bắt đầu gián đoạn',
                ended_at: 'Thời điểm kết thúc gián đoạn',
                remediation_completed_at: 'Thời điểm hoàn thành khắc phục',
                not_recorded: 'Chưa ghi nhận',
                ongoing: 'Chưa ghi nhận thời điểm kết thúc, nên gián đoạn được coi là vẫn đang diễn ra.',
                edit: 'Chỉnh sửa khoảng thời gian gián đoạn',
                save: 'Lưu khoảng thời gian gián đoạn',
                saving: 'Đang lưu…',
                cancel: 'Hủy',
                local_time_hint: 'Ngày giờ theo múi giờ của bạn. Để trống một trường để xóa giá trị.',
                unchanged: 'Hãy thay đổi một thời điểm để lưu.',
                saved: 'Đã lưu khoảng thời gian gián đoạn',
                save_failed: 'Không lưu được khoảng thời gian gián đoạn.',
                errors: {
                    start_first: 'Hãy ghi nhận thời điểm bắt đầu gián đoạn trước.',
                    before_start: 'Thời điểm này không thể sớm hơn thời điểm bắt đầu gián đoạn.',
                    invalid: 'Khoảng thời gian gián đoạn không đúng trình tự, nên chưa có gì được lưu.',
                },
            },
            not_assessed: 'Chưa đánh giá',
            event_type: 'Loại sự kiện',
            timestamp: 'Thời gian',
            actor: 'Người thực hiện',
            no_timeline_events: 'Chưa có sự kiện nào.',
            decision_type: 'Loại quyết định',
            decision: 'Quyết định',
            rationale: 'Lý do',
            decision_made: 'Quyết định đã đưa ra',
            no_decisions: 'Chưa có quyết định nào.',
            no_audit_events: 'Chưa có sự kiện kiểm toán nào.',
            export_pdf: 'Xuất PDF',
            pdf_title: 'Báo cáo Tóm tắt Sự cố',
            description: 'Mô tả',
            linked_records: 'Bản ghi Liên kết',
            export_success: 'Đã xuất báo cáo sự cố',
        },
        tasks: {
            page_title: 'Nhiệm vụ Xử lý Sự cố',
            title: 'Nhiệm vụ xử lý sự cố',
            new: 'Nhiệm vụ mới',
            edit: 'Sửa nhiệm vụ',
            task_type: 'Loại nhiệm vụ',
            assignee: 'Người thực hiện',
            due_date: 'Hạn hoàn thành',
            dependencies: 'Phụ thuộc',
            mark_complete: 'Đánh dấu hoàn thành',
            templates: 'Mẫu nhiệm vụ',
            select_incident: 'Chọn sự cố',
            all_statuses: 'Tất cả trạng thái',
            all_categories: 'Tất cả danh mục',
            new_response_task: 'Nhiệm vụ xử lý mới',
            category: 'Danh mục',
            priority: 'Mức độ ưu tiên',
            depends_on: 'Phụ thuộc (ID nhiệm vụ phân cách bằng dấu phẩy)',
            checklist_items: 'Danh sách kiểm tra',
            remove: 'Xóa',
            add: 'Thêm',
            new_checklist_item: 'Mục kiểm tra mới',
            no_templates: 'Không có mẫu nào.',
            assign_task: 'Phân công nhiệm vụ',
            assign_to: 'Phân công cho',
            assign: 'Phân công',
            select_incident_prompt: 'Vui lòng chọn sự cố để xem nhiệm vụ xử lý.',
            checklist: 'Danh sách kiểm tra',
            hide_checklist: 'Ẩn danh sách kiểm tra',
            escalate: 'Leo thang',
            escalations: 'Leo thang',
            no_checklist_items: 'Không có mục kiểm tra nào.',
        },
        reports: {
            page_title: 'Báo cáo Sự cố',
            title: 'Báo cáo sự cố',
            summary: 'Thống kê tổng hợp',
            by_severity: 'Theo mức độ',
            by_status: 'Theo trạng thái',
            recent: 'Sự cố gần đây',
            total_incidents: 'Tổng số sự cố',
            open: 'Đang mở',
            closed: 'Đã đóng',
            export_csv: 'Xuất CSV',
            export_pdf: 'Xuất PDF',
            export_success: 'Xuất báo cáo thành công.',
            export_error: 'Không thể xuất báo cáo.',
            reference: 'Mã tham chiếu',
            view_report: 'Xem báo cáo',
        },
        statuses: {
            reported: 'Đã báo cáo',
            triage: 'Phân loại',
            contained: 'Đã ngăn chặn',
            investigation: 'Điều tra',
            remediation: 'Khắc phục',
            closed: 'Đã đóng',
            false_positive: 'Báo động giả',
        },
        task_statuses: {
            pending: 'Chờ xử lý',
            in_progress: 'Đang thực hiện',
            completed: 'Hoàn thành',
            blocked: 'Bị chặn',
            cancelled: 'Đã hủy',
        },
        severity: {
            low: 'Thấp',
            medium: 'Trung bình',
            high: 'Cao',
            critical: 'Nghiêm trọng',
        },
        task_types: {
            containment: 'Ngăn chặn',
            investigation: 'Điều tra',
            remediation: 'Khắc phục',
            communication: 'Truyền thông',
            documentation: 'Tài liệu',
            notification: 'Thông báo',
        },
        categories: {
            ai_system: 'Hệ thống AI',
            data_breach: 'Vi phạm dữ liệu',
            unauthorized_access: 'Truy cập trái phép',
            data_loss: 'Mất dữ liệu',
            system_compromise: 'Hệ thống bị xâm nhập',
            malware: 'Phần mềm độc hại',
            phishing: 'Lừa đảo',
            insider_threat: 'Mối đe dọa nội bộ',
            other: 'Khác',
        },
        reported_via_options: {
            email: 'Email',
            phone: 'Điện thoại',
            internal_system: 'Hệ thống nội bộ',
            third_party: 'Bên thứ ba',
            automated_detection: 'Phát hiện tự động',
        },
        harm_likelihood_options: {
            unlikely: 'Khó xảy ra',
            possible: 'Có thể',
            likely: 'Có khả năng',
            very_likely: 'Rất có khả năng',
        },
        breach_determination_options: {
            confirmed_breach: 'Vi phạm đã xác nhận',
            suspected_breach: 'Nghi ngờ vi phạm',
            not_a_breach: 'Không vi phạm',
            pending: 'Chờ xử lý',
        },
        timeline_event_types: {
            detection: 'Phát hiện',
            escalation: 'Leo thang',
            containment: 'Ngăn chặn',
            investigation_start: 'Bắt đầu điều tra',
            evidence_collected: 'Thu thập bằng chứng',
            notification_sent: 'Đã gửi thông báo',
            remediation_action: 'Hành động khắc phục',
            status_change: 'Thay đổi trạng thái',
            communication: 'Truyền thông',
            other: 'Khác',
        },
        decision_types: {
            containment: 'Ngăn chặn',
            notification: 'Thông báo',
            remediation: 'Khắc phục',
            escalation: 'Leo thang',
            closure: 'Đóng',
            other: 'Khác',
        },
        task_transitions: {
            start: 'Bắt đầu',
            complete: 'Hoàn thành',
            block: 'Chặn',
            cancel: 'Hủy',
            unblock: 'Bỏ chặn',
        },
        announce: {
            loaded: 'Đã tải {count} sự cố',
            reports_loaded: 'Đã tải {count} báo cáo sự cố',
            tasks_loaded: 'Đã tải {count} nhiệm vụ',
            created: 'Đã tạo sự cố thành công',
            updated: 'Đã cập nhật sự cố thành công',
            closed: 'Đã đóng sự cố thành công',
            status_changed: 'Đã thay đổi trạng thái sự cố',
            triage_completed: 'Đã hoàn thành phân loại',
            impact_updated: 'Đã cập nhật đánh giá tác động',
            breach_updated: 'Đã cập nhật đánh giá vi phạm',
            timeline_added: 'Đã thêm sự kiện dòng thời gian',
            decision_recorded: 'Đã ghi nhận quyết định',
            notification_updated: 'Đã cập nhật trạng thái thông báo',
            task_created: 'Đã tạo nhiệm vụ thành công',
            task_status_changed: 'Đã thay đổi trạng thái nhiệm vụ',
            checklist_completed: 'Đã hoàn thành mục kiểm tra',
            checklist_unchecked: 'Đã bỏ đánh dấu mục kiểm tra',
            task_assigned: 'Đã phân công nhiệm vụ thành công',
            task_escalated: 'Đã leo thang nhiệm vụ',
            export_initiated: 'Đã bắt đầu xuất',
        },
        disclosure_register: {
            page_title: 'Sổ Công khai',
            title: 'Sổ Công khai',
            new_entry: 'Mục mới',
            no_entries: 'Không tìm thấy mục sổ công khai',
            disclosure_type: 'Loại công khai',
            disclosure_date: 'Ngày công khai',
            recipient: 'Người nhận',
            authority_name: 'Tên cơ quan',
            channel: 'Kênh',
            content_summary: 'Tóm tắt nội dung',
            incident_id_optional: 'Mã sự cố (tùy chọn)',
            channel_in_person: 'Trực tiếp',
            channel_mps_portal: 'Cổng thông tin Bộ Công an',
            channel_postal: 'Đường bưu điện',
            type_court_order: 'Cung cấp theo lệnh của tòa án',
            type_data_breach: 'Thông báo vi phạm dữ liệu',
            type_regulatory_response: 'Phản hồi cơ quan quản lý',
            type_voluntary: 'Cung cấp tự nguyện',
            channel_email: 'Email',
        },
        authority_requests: {
            page_title: 'Yêu cầu Cơ quan',
            title: 'Yêu cầu Cơ quan',
            new_request: 'Yêu cầu mới',
            no_requests: 'Không tìm thấy yêu cầu cơ quan',
            authority_name: 'Tên cơ quan',
            request_details: 'Chi tiết yêu cầu',
            response_package: 'Gói phản hồi',
            submission_channel: 'Kênh nộp',
            submit_response: 'Gửi phản hồi',
            deadline: 'Hạn chót',
            confirmation: 'Xác nhận',
            incident_id_optional: 'Mã sự cố (tùy chọn)',
            // Sprint 44.5.0 — ngữ cảnh phản hồi + trạng thái tạo tài liệu nộp
            response_context_label: 'Ngữ cảnh phản hồi (để tạo tài liệu nộp)',
            response_context_none: '(bỏ qua tạo tài liệu)',
            response_context_supplement: 'Phản hồi yêu cầu bổ sung',
            response_context_information: 'Phản hồi yêu cầu cung cấp thông tin',
            response_context_inspection: 'Phản hồi yêu cầu thanh tra',
            materialisation_status_column: 'Tài liệu nộp',
            materialisation_pending: 'Chờ xử lý',
            materialisation_success: 'Đã tạo',
            materialisation_failed: 'Thất bại',
            materialisation_retry_button: 'Thử lại',
            ar_statuses: {
                received: 'Đã nhận',
                verified: 'Đã xác minh',
                assembling: 'Đang tổng hợp',
                submitted: 'Đã nộp',
                closed: 'Đã đóng',
                response_packaged: 'Đã đóng gói phản hồi',
                scope_assessed: 'Đã đánh giá phạm vi',
                legal_review: 'Rà soát pháp lý',
            },
            channel_in_person: 'Trực tiếp',
            channel_mps_portal: 'Cổng thông tin Bộ Công an',
            channel_postal: 'Đường bưu điện',
            channel_email: 'Email',
            verification_checklist_title: 'Danh mục kiểm tra xác minh',
            checklist: 'Danh mục kiểm tra',
            no_checklist_items: 'Chưa có mục kiểm tra nào. Thêm mục ở bên dưới.',
            add_checklist_item: 'Thêm mục kiểm tra...',
            advance_to_verified: 'Chuyển sang Đã xác minh',
            advance_to_scope_assessed: 'Chuyển sang Đã đánh giá phạm vi',
            advance_to_assembling: 'Chuyển sang Đang tổng hợp',
            advance_to_response_packaged: 'Chuyển sang Đã đóng gói phản hồi',
            advance_to_legal_review: 'Chuyển sang Rà soát pháp lý',
            advance_to_submitted: 'Chuyển sang Đã nộp',
            advance_to_closed: 'Chuyển sang Đã đóng',
        },
        remediation: {
            page_title: 'Hành động Khắc phục',
            title: 'Hành động Khắc phục',
            new_action: 'Hành động mới',
            no_actions: 'Không tìm thấy hành động khắc phục',
            description: 'Mô tả',
            owner: 'Chủ sở hữu',
            department: 'Phòng ban',
            deadline: 'Thời hạn',
            statuses: {
                planned: 'Đã lên kế hoạch',
                in_progress: 'Đang thực hiện',
                completed: 'Đã hoàn thành',
                verified: 'Đã xác minh',
            },
            verify: 'Xác minh',
            incident_id: 'Mã sự cố',
            enter_incident_id: 'Nhập mã sự cố để xem hành động khắc phục.',
            start: 'Bắt đầu',
            complete_action: 'Hoàn thành',
        },
        supplements: {
            page_title: 'Yêu cầu Bổ sung',
            title: 'Yêu cầu Bổ sung',
            new_supplement: 'Bổ sung mới',
            no_supplements: 'Không tìm thấy yêu cầu bổ sung',
            request_details: 'Chi tiết yêu cầu',
            response_package: 'Gói phản hồi',
            submit_response: 'Gửi phản hồi',
            deadline: 'Thời hạn',
            notification_id: 'Mã thông báo',
            computed_deadline: 'Thời hạn đã tính',
            computed_deadline_none: 'Không tính được',
            computed_deadline_pending: 'Chưa bắt đầu',
            enter_notification_id: 'Nhập mã thông báo để xem bổ sung.',
            supplement_statuses: {
                requested: 'Đã yêu cầu',
                drafting: 'Đang soạn thảo',
                submitted: 'Đã nộp',
                accepted: 'Đã chấp nhận',
                rejected: 'Đã từ chối',
            },
        },
        breach_notifications: {
            page_title: 'Thông báo Vi phạm',
            title: 'Thông báo Vi phạm',
            new_notification: 'Thông báo mới',
            no_notifications: 'Không tìm thấy thông báo vi phạm',
            status: 'Trạng thái',
            submit_to_mps: 'Nộp cho MPS',
            decision: 'Quyết định',
            decision_maker: 'Người quyết định',
            notify: 'Thông báo',
            do_not_notify: 'Không thông báo',
            rationale: 'Lý do',
            filing_deadline: 'Hạn nộp',
            overdue: 'Quá hạn',
            due_soon: 'Sắp đến hạn',
            on_track: 'Đúng tiến độ',
            // Sprint 62.0.3 — các mốc thời hạn pháp lý độc lập (AC3–AC6)
            regulatory_clocks: 'Thời hạn theo quy định',
            no_regulatory_clocks: 'Không có bản ghi thời hạn nào của khung áp dụng cho thông báo này',
            clock_counts_from: 'Tính từ',
            clock_undated: 'Chưa ghi nhận thời điểm cho sự kiện kích hoạt này',
            clock_no_period: 'Khung này không ghi nhận thời hạn cho nghĩa vụ này',
            clock_provisional: 'Tạm thời',
            clock_lapse_label: 'Nếu quá hạn',
            clock_lapse_sanction_exposure: 'có nguy cơ bị xử phạt — nghĩa vụ vẫn còn, chỉ là thực hiện chậm',
            clock_lapse_right_extinguished: 'quyền CHẤM DỨT vĩnh viễn — không có cách nào thực hiện muộn',
            clock_trigger_awareness: 'Thời điểm biết được',
            clock_trigger_discovery: 'Thời điểm phát hiện',
            clock_trigger_containment: 'Thời điểm khoanh vùng',
            clock_trigger_authority_request: 'Yêu cầu của cơ quan có thẩm quyền',
            clock_trigger_assessment_complete: 'Hoàn tất đánh giá',
            clock_trigger_framework_specific: 'Sự kiện kích hoạt riêng của khung',
            clock_trigger_unrecognised: '{event} — nền tảng không mô hình hóa sự kiện kích hoạt này',
            clock_provisional_reconstructed_trigger_timestamp: 'Được suy ra từ thời điểm kích hoạt được tái dựng',
            clock_provisional_disputed_trigger_timestamp: 'Được suy ra từ thời điểm kích hoạt còn tranh chấp',
            clock_provisional_transposition_unavailable: 'Chưa cài đặt văn bản nội luật hoá điều chỉnh thời hạn này',
            legal_review: 'Rà soát pháp lý',
            incident_id: 'Mã sự cố',
            // Fix sprint #447 W1 — the decision moves the status; submission through /submit.
            decision_hint: 'Chọn Thông báo sẽ chuyển thông báo sang trạng thái Quyết định thông báo để soạn thảo. Chọn Không thông báo sẽ đóng thông báo; quyết định cùng lý do, căn cứ vẫn được lưu.',
            rationale_required: 'Nhập lý do, căn cứ cho quyết định này.',
            mark_drafted: 'Đánh dấu đã soạn thông báo',
            submission_channel: 'Kênh nộp',
            submission_confirmation: 'Mã xác nhận hoặc số tham chiếu',
            submission_note: 'Mục này ghi nhận việc nộp mà tổ chức của bạn đã thực hiện. Nền tảng không nộp bất kỳ hồ sơ nào cho cơ quan có thẩm quyền.',
            select_channel: 'Chọn kênh',
            channels_load_failed: 'Không đọc được các kênh nộp.',
            channel_refusal_no_framework: 'Không có khung tuân thủ đã cài đặt nào khai báo việc nộp hồ sơ cho cơ quan có thẩm quyền, nên không thể ghi nhận việc nộp.',
            channel_refusal_no_channels: 'Khung tuân thủ điều chỉnh việc nộp hồ sơ không khai báo kênh nộp nào, nên không thể ghi nhận việc nộp.',
            channel_refusal_no_authority: 'Khung tuân thủ điều chỉnh việc nộp hồ sơ không nêu cơ quan nào tiếp nhận hồ sơ, nên không thể ghi nhận việc nộp.',
            notification_statuses: {
                assessment: 'Đánh giá',
                decision_to_notify: 'Quyết định thông báo',
                notification_drafted: 'Đã soạn thông báo',
                legal_review: 'Rà soát pháp lý',
                submitted_to_authority: 'Đã nộp cơ quan',
                supplement_requested: 'Đã yêu cầu bổ sung',
                supplement_submitted: 'Đã nộp bổ sung',
                acknowledged: 'Đã xác nhận',
                closed: 'Đã đóng',
            },
            select_incident: 'Sự cố liên kết',
            // Breach notifications page layout — summary band, details dialog, forms dialog.
            page_description: 'Quyết định từng vi phạm dữ liệu cá nhân có phải thông báo hay không, ghi nhận quyết định cùng lý do, căn cứ, và theo dõi mọi hạn nộp cho đến khi tổ chức của bạn nộp cho cơ quan có thẩm quyền.',
            kpi_total: 'Thông báo',
            kpi_awaiting_decision: 'Chờ quyết định',
            kpi_deadline_at_risk: 'Sắp đến hạn hoặc quá hạn',
            kpi_submitted: 'Đã nộp',
            filter_toolbar: 'Lọc thông báo vi phạm',
            results_count: 'Hiển thị {shown} trên {total} thông báo',
            incident: 'Sự cố',
            forms: 'Biểu mẫu',
            forms_count_one: '1 biểu mẫu',
            forms_count: '{count} biểu mẫu',
            no_forms: 'Chưa có biểu mẫu',
            forms_dialog_title: 'Biểu mẫu đã lập cho {incident}',
            view_details: 'Xem chi tiết',
            details_title: 'Chi tiết thông báo vi phạm',
            details_decision_section: 'Quyết định và việc nộp',
            created_at: 'Ngày tạo',
            submitted_at: 'Ngày nộp',
        },
        log_disclosure: 'Ghi nhận việc cung cấp dữ liệu',
    },
    onboarding: {
        nav: {
            wizard: 'Thiết lập ban đầu',
            tours: 'Tour phân hệ',
            sample_data: 'Dữ liệu mẫu',
        },
        wizard: {
            title: 'Thiết lập ban đầu',
            welcome: 'Chào mừng đến AesirX ComplianceOne',
            welcome_message: 'Hãy cùng thiết lập tổ chức của bạn. Trình hướng dẫn này sẽ giúp bạn cấu hình ban đầu.',
            setup_complete: 'Thiết lập hoàn tất',
            skipped_message: 'Trình hướng dẫn thiết lập đã bị bỏ qua. Bạn có thể chạy lại bất kỳ lúc nào để cấu hình tổ chức.',
            start_setup: 'Bắt đầu thiết lập',
            skip_wizard: 'Bỏ qua thiết lập',
            go_to_admin: 'Vào trang quản trị',
            skip_for_now: 'Bỏ qua tạm thời',
            next_step: 'Bước tiếp theo',
            previous_step: 'Bước trước',
            finish_setup: 'Hoàn tất thiết lập',
            rerun: 'Chạy lại thiết lập',
            step_label: 'Bước {number}',
            progress_label: 'Tiến trình thiết lập: Bước {number} trên {total}',
            validation_org_name_required: 'Tên tổ chức là bắt buộc.',
            validation_admin_email_required: 'Email quản trị viên là bắt buộc.',
            validation_admin_email_invalid: 'Vui lòng nhập địa chỉ email hợp lệ.',
            validation_cmp_endpoint_required: 'Điểm cuối CMP là bắt buộc khi CMP được kích hoạt.',
            steps: {
                license_activation: 'Kích hoạt giấy phép',
                org_profile: 'Hồ sơ tổ chức',
                module_selection: 'Chọn phân hệ',
                cmp_integration: 'Tích hợp CMP',
                notification_preferences: 'Thông báo',
                review: 'Xem lại và xác nhận',
            },
            step_descriptions: {
                license_activation: 'Nhập khóa giấy phép để kích hoạt gói của bạn và xác định các phân hệ khả dụng.',
                org_profile: 'Thiết lập tên tổ chức, phạm vi pháp lý, ngành nghề, quy mô và ngôn ngữ ưu tiên.',
                module_selection: 'Chọn các phân hệ tuân thủ để kích hoạt cho tổ chức của bạn.',
                cmp_integration: 'Cấu hình tích hợp Nền tảng Quản lý Đồng thuận (tùy chọn).',
                notification_preferences: 'Cấu hình cách bạn nhận thông báo cho các sự kiện tuân thủ.',
                review: 'Xem lại cấu hình của bạn và hoàn tất thiết lập.',
            },
            license_step: {
                validate_button: 'Xác thực giấy phép',
                skip_warning: 'Quyền truy cập phân hệ sẽ bị giới hạn theo gói mặc định. Bạn có thể kích hoạt giấy phép sau trong Nền tảng > Cài đặt giấy phép.',
            },
            module_descriptions: {
                rights_requests: 'Xử lý các yêu cầu truy cập và xóa dữ liệu của chủ thể dữ liệu.',
                data_mapping: 'Lập bản đồ hệ thống, luồng dữ liệu và hoạt động xử lý.',
                governance: 'Giám sát nhà cung cấp, phê duyệt, sai lệch và các sổ đăng ký bằng chứng.',
                consent: 'Quản lý chính sách đồng thuận và danh mục mục đích.',
                assessments: 'Thực hiện đánh giá tác động và chuyển dữ liệu xuyên biên giới.',
                classification: 'Phân loại và gán nhãn tài sản dữ liệu với theo dõi vòng đời.',
                monitoring: 'Đánh giá tuân thủ định kỳ và theo dõi KPI.',
                incidents: 'Báo cáo và quản lý các sự cố bảo mật và quyền riêng tư.',
                connectors: 'Kết nối với các hệ thống bên ngoài để trao đổi dữ liệu tự động.',
                vendor_risk: 'Chấm điểm nhà cung cấp, theo dõi hợp đồng và quản lý thẩm định.',
                deletion_orchestration: 'Điều phối xóa dữ liệu trên các hệ thống và nhà cung cấp.',
                discovery: 'Khám phá và phân loại dữ liệu trên toàn bộ hạ tầng của bạn.',
                incident_ops: 'Kịch bản sự cố nâng cao, theo dõi SLA và leo thang.',
                program_governance: 'Đánh giá độ chín, báo cáo điều hành và sẵn sàng kiểm toán.',
                access_accountability: 'Giám sát truy cập người dùng, phiên và quy trình giải trình.',
                localization: 'Gói tuân thủ theo thị trường và khung tuân thủ.',
                sector_overlays: 'Cài đặt lớp phủ ngành và mở các sổ đăng ký mà một lớp phủ đã kích hoạt đưa vào sử dụng, theo ngành.',
                partner_workspace: 'Không gian làm việc quản lý đối tác và đại lý.',
                privacy_scanner: 'Giám sát quyền riêng tư theo thời gian thực các tài sản số.',
                onboarding: 'Thiết lập ban đầu, hướng dẫn tương tác và quản lý dữ liệu mẫu.',
                compliance_forms: 'Mẫu biểu tuân thủ tương tác và tạo tài liệu.',
                audit_trail: 'Ghi nhật ký kiểm toán bất biến toàn diện và lưu trữ.',
                organizations: 'Quản lý đa tổ chức và nhóm.',
                task_management: 'Lập kế hoạch nhiệm vụ thống nhất, công cụ quy trình và lịch.',
                consent_properties: 'Quản lý đồng thuận đa thuộc tính trên các tài sản số.',
            },
            module_categories: {
                data_privacy_rights: 'Quyền riêng tư & dữ liệu',
                vendor_third_party: 'Quản lý nhà cung cấp & bên thứ ba',
                risk_assessment: 'Rủi ro & đánh giá',
                operations_automation: 'Vận hành & tự động hóa',
                platform_admin: 'Nền tảng & quản trị',
            },
            package_tier_label: 'Gói của bạn',
            package_module_unavailable: 'Không bao gồm trong gói của bạn',
            select_all: 'Chọn tất cả',
            deselect_all: 'Bỏ chọn tất cả',
            load_sample_data: 'Tải dữ liệu mẫu sau khi thiết lập',
            load_sample_data_description: 'Cài đặt dữ liệu demo thực tế, mang tính mô phỏng, để khám phá nền tảng. Có thể xóa sau từ Khởi tạo > Dữ liệu mẫu.',
            language_label: 'Ngôn ngữ ưu tiên',
            language_description: 'Chọn ngôn ngữ mặc định cho tổ chức của bạn.',
            admin_account_title: 'Tài khoản Quản trị viên',
            admin_account_created: 'Tài khoản quản trị viên đã được tạo',
            admin_full_name: 'Họ và tên',
            admin_email: 'Địa chỉ email',
            admin_password: 'Mật khẩu',
            admin_confirm_password: 'Xác nhận mật khẩu',
            admin_show_password: 'Hiện mật khẩu',
            admin_hide_password: 'Ẩn mật khẩu',
            admin_name_placeholder: 'vd. Nguyễn Văn A',
            admin_email_placeholder: 'admin@example.com',
            admin_password_placeholder: 'Tối thiểu 8 ký tự',
            admin_password_confirm_placeholder: 'Nhập lại mật khẩu',
            validation_admin_name_required: 'Tên quản trị viên là bắt buộc',
            validation_admin_password_required: 'Mật khẩu là bắt buộc',
            validation_admin_password_min_length: 'Mật khẩu phải có ít nhật 8 ký tự',
            validation_passwords_mismatch: 'Mật khẩu không khớp',
            notification_email_enabled: 'Bật thông báo qua Email',
            notification_email_description: 'Nhận thông báo email cho phân công nhiệm vụ, vi phạm SLA và sự kiện tuân thủ.',
            notification_digest_frequency: 'Tần suất tổng hợp',
            notification_digest_daily: 'Hàng ngày',
            notification_digest_weekly: 'Hàng tuần',
            notification_digest_none: 'Không tổng hợp',
            notification_in_app_enabled: 'Bật thông báo trên nền tảng',
            notification_in_app_description: 'Hiển thị huy hiệu thông báo và ngăn kéo cho cảnh báo thời gian thực.',
            jurisdictions: {
                vietnam: 'Việt Nam',
                asean: 'ASEAN',
                eu_eea: 'EU/EEA',
                global: 'Toàn cầu',
            },
            languages: {
                en: 'English',
                vi: 'Tiếng Việt',
                da: 'Dansk',
                sv: 'Svenska',
                nb: 'Norsk Bokmål',
                nn: 'Norsk Nynorsk',
                de: 'Deutsch',
                fi: 'Suomi',
                nl: 'Nederlands',
                fr: 'Français',
                lb: 'Lëtzebuergesch',
                ga: 'Gaeilge',
                es: 'Español',
                ca: 'Català',
                eu: 'Euskara',
                pt: 'Português',
            },
            industries: {
                financial_services: 'Dịch vụ tài chính',
                healthcare: 'Y tế',
                technology: 'Công nghệ',
                telecommunications: 'Viễn thông',
                government: 'Chính phủ',
                education: 'Giáo dục',
                manufacturing: 'Sản xuất',
                retail: 'Bán lẻ',
                other: 'Khác',
            },
            placeholders: {
                org_name: 'vd. Công ty TNHH ABC',
                admin_email: 'admin@company.vn',
                team_emails: 'user1@company.vn, user2@company.vn',
                cmp_endpoint: 'https://cmp.example.com/api',
            },
            fields: {
                org_name: 'Tên tổ chức',
                jurisdiction: 'Phạm vi pháp lý',
                industry: 'Ngành nghề',
                org_size: 'Quy mô tổ chức',
                admin_email: 'Email quản trị viên',
                team_emails: 'Email thành viên (phân cách bằng dấu phẩy)',
                enable_cmp: 'Kích hoạt tích hợp CMP',
                cmp_endpoint: 'Điểm cuối API CMP',
                language: 'Ngôn ngữ ưu tiên',
                email_notifications: 'Thông báo Email',
                in_app_notifications: 'Thông báo trên nền tảng',
                digest_frequency: 'Tần suất tổng hợp',
            },
            validation_jurisdiction_required: 'Phạm vi pháp lý là bắt buộc.',
        },
        tours: {
            title: 'Tour làm quen phân hệ',
            start: 'Bắt đầu hướng dẫn',
            continue_tour: 'Tiếp tục hướng dẫn',
            replay: 'Xem lại hướng dẫn',
            exit: 'Thoát hướng dẫn',
            skip: 'Bỏ qua hướng dẫn',
            next: 'Tiếp',
            previous: 'Trước',
            finish: 'Hoàn tất hướng dẫn',
            step_of: 'Bước {current} / {total}',
            info: 'Khám phá các phân hệ qua hướng dẫn tương tác. Có thể xem lại bất kỳ lúc nào.',
            autoplay: 'Tự động phát',
            interactive: 'Tương tác',
            play_all: 'Phát tất cả',
            search_tours: 'Tìm kiếm hướng dẫn...',
            duration: 'Thời lượng',
            steps_label: '{count} bước',
            mode: 'Chế độ',
            pause: 'Tạm dừng',
            resume: 'Tiếp tục',
            speed: 'Tốc độ',
            restart: 'Khởi động lại',
            reset: 'Đặt lại',
            reset_success: 'Tiến độ hướng dẫn đã được đặt lại.',
            category_core_privacy: 'Quyền riêng tư cơ bản',
            category_governance: 'Quản trị',
            category_operations: 'Vận hành',
            category_platform: 'Nền tảng',
            category_advanced: 'Nâng cao',
            category_data_privacy_rights: 'Quyền riêng tư & dữ liệu',
            category_vendor_third_party: 'Quản lý nhà cung cấp & bên thứ ba',
            category_risk_assessment: 'Rủi ro & đánh giá',
            category_operations_automation: 'Vận hành & tự động hóa',
            category_platform_admin: 'Nền tảng & quản trị',
            steps_count: '{count} bước',
            autoplay_mode: 'Chế độ tự động chạy',
            interactive_mode: 'Chế độ tương tác',
            mode_switch_name: '{current}: chuyển sang {other}',
            revision_conflict: 'Hướng dẫn này đã thay đổi kể từ khi bạn bắt đầu. Hãy bắt đầu lại hướng dẫn để xem phiên bản hiện tại.',
        },
        sample_data: {
            evaluation_title: 'Đánh giá Forseti — 100 tình huống Việt Nam',
            evaluation_info: 'Cài đặt các bản ghi đánh giá liên kết với dữ liệu mô phỏng để kiểm thử lặp lại. Việc tải không gọi AI. Dữ liệu mẫu thông thường không thay đổi. Chạy đánh giá riêng; vẫn cần chuyên gia pháp lý thẩm định.',
            evaluation_loaded: 'Đã cài đặt {count} trong {total} tình huống',
            evaluation_load: 'Cài đặt tình huống đánh giá',
            evaluation_clear: 'Đặt lại tình huống đánh giá',
            evaluation_confirm_load: 'Cài đặt đủ 100 tình huống mô phỏng Việt Nam mà không thay thế công việc đánh giá hiện có? Việc cài đặt không chạy AI.',
            evaluation_confirm_clear: 'Chỉ xóa các bản ghi hoạt động xử lý và đánh giá thuộc bộ dữ liệu này? Lịch sử chạy AI và nhật ký kiểm toán vẫn được giữ lại.',
            title: 'Quản lý dữ liệu mẫu',
            select_modules: 'Chọn phân hệ',
            current_status: 'Trạng thái hiện tại',
            operation_history: 'Lịch sử thao tác',
            load: 'Tải dữ liệu mẫu',
            clear: 'Xóa dữ liệu mẫu',
            processing: 'Đang xử lý...',
            loaded: 'Đã tải',
            not_loaded: 'Chưa tải',
            records: 'Bản ghi mẫu',
            confirm_clear_all: 'Xóa dữ liệu mẫu của tất cả các phân hệ? Chỉ các bản ghi mẫu dùng chung cho mọi ngành bị xóa; dữ liệu thực không bị ảnh hưởng. Các gói dữ liệu mẫu theo ngành được giữ lại: hãy gỡ bỏ một gói từ thẻ của gói đó.',
            confirm_clear: 'Chỉ xóa dữ liệu mẫu dùng chung cho mọi ngành của các phân hệ sau: {list}? Dữ liệu mẫu của các phân hệ khác được giữ lại, và dữ liệu thực không bị ảnh hưởng. Các gói dữ liệu mẫu theo ngành được giữ lại: hãy gỡ bỏ một gói từ thẻ của gói đó.',
            confirm_clear_title: 'Xóa dữ liệu mẫu',
            confirm_load_title: 'Tải dữ liệu mẫu',
            confirm_load: 'Bạn có chắc chắn muốn tải dữ liệu mẫu cho các phân hệ đã chọn không?',
            action_load: 'Tải',
            action_clear: 'Xóa',
            info: 'Tải dữ liệu demo thực tế, mang tính mô phỏng, cho đào tạo và trình diễn. Dữ liệu mẫu được đánh dấu và có thể xóa an toàn mà không ảnh hưởng dữ liệu thực.',
            clear_success: 'Đã xóa dữ liệu mẫu',
            load_success: 'Đã nạp dữ liệu mẫu',
            action_install: 'Cài đặt gói',
            action_remove: 'Gỡ gói',
            // Sprint 63.37.0 (I2) — the forms module's standing counts in the cross-industry status table.
            status_forms_counts: '{official} chính thức, {internal} nội bộ',
            cross_industry_title: 'Dữ liệu mẫu dùng chung cho mọi ngành',
            cross_industry_info: 'Bản ghi mô phỏng cho mọi phân hệ, dùng chung cho mọi ngành. Chọn các phân hệ cần tải hoặc xóa ở bên dưới.',
            packages: {
                title: 'Dữ liệu mẫu theo ngành',
                info: 'Mỗi gói là một kịch bản mô phỏng liền mạch, được đặt tên theo ngành, không bao giờ theo tên khách hàng. Việc cài đặt chỉ ghi bản ghi mẫu vào tổ chức này và không gửi thông báo, e-mail, webhook, lần chạy trình kết nối hay lệnh gọi AI nào.',
                list_aria: 'Các gói dữ liệu mẫu theo ngành',
                list_failed: 'Không thể đọc danh sách gói dữ liệu mẫu theo ngành.',
                list_retry_subject: 'danh sách gói theo ngành',
                list_forbidden: 'Cần quyền {permission} để xem các gói dữ liệu mẫu theo ngành.',
                empty: 'Nền tảng này chưa có gói dữ liệu mẫu theo ngành nào.',
                synthetic_badge: 'Dữ liệu mô phỏng',
                industry: 'Ngành',
                line_of_business: 'Nghiệp vụ',
                version: 'Phiên bản',
                reference_prefix: 'Tiền tố mã tham chiếu',
                contents_heading: 'Nội dung',
                contents_item: '{area}: {count} bản ghi',
                branches_heading: 'Phần tùy chọn',
                branch_default: 'được chọn mặc định',
                branches_none: 'Không có',
                prerequisites_heading: 'Điều kiện tiên quyết',
                prerequisite_frameworks: 'Khung tuân thủ mà gói sử dụng',
                prerequisite_modules: 'Phân hệ mà gói ghi dữ liệu',
                prerequisite_present: 'Đã cài đặt',
                prerequisite_missing: 'Chưa cài đặt',
                prerequisite_module_available: 'Có trong gói dịch vụ của bạn',
                prerequisite_module_unavailable: 'Không có trong gói dịch vụ của bạn',
                prerequisite_note: 'Bản ghi cần khung tuân thủ hoặc phân hệ còn thiếu sẽ bị bỏ qua khi cài đặt và được liệt kê kèm lý do.',
                status_heading: 'Trạng thái',
                status_not_installed: 'Chưa cài đặt',
                status_installed: 'Đã cài đặt',
                installed_language: 'Ngôn ngữ nội dung',
                installed_branches: 'Phần tùy chọn',
                installed_at: 'Ngày cài đặt',
                installed_by: 'Người cài đặt',
                installed_records: 'Số bản ghi đã ghi',
                evidence_pack: 'Gói bằng chứng kiểm toán',
                evidence_pack_link: 'Mở danh sách gói bằng chứng kiểm toán (gói {id})',
                evidence_pack_none: 'Chưa tập hợp',
                attachments: 'Tệp mô phỏng đã lưu',
                upgrade_available: 'Đã có phiên bản {version}. Cài đặt lại để thay thế phiên bản {installed} đang cài.',
                install: 'Cài đặt',
                reinstall: 'Cài đặt lại',
                remove: 'Gỡ bỏ',
                installing: 'Đang cài đặt…',
                removing: 'Đang gỡ bỏ…',
                load_needs: 'Cần quyền {permission} để cài đặt.',
                clear_needs: 'Cần quyền {permission} để gỡ bỏ.',
                dialog_install_title: 'Cài đặt {name}',
                dialog_reinstall_title: 'Cài đặt lại {name}',
                language_legend: 'Ngôn ngữ nội dung',
                language_en: 'Tiếng Anh',
                language_vi: 'Tiếng Việt',
                language_required: 'Hãy chọn ngôn ngữ nội dung.',
                branches_legend: 'Phần tùy chọn',
                branches_none_declared: 'Gói này không có phần tùy chọn.',
                will_write: 'Ghi tối đa {count} bản ghi mẫu vào các phân hệ sau:',
                will_drop: 'Bản ghi có khung tuân thủ chưa được cài đặt, hoặc thuộc phân hệ không có trong gói dịch vụ của bạn, sẽ bị bỏ qua và được liệt kê kèm lý do.',
                nothing_sent: 'Không gửi thông báo, e-mail, webhook, lần chạy trình kết nối hay lệnh gọi AI nào. Khi Nhật ký kiểm toán bất biến được bật, các mục nhật ký kiểm toán của tệp đã lưu và gói bằng chứng được neo như mọi mục nhật ký kiểm toán khác.',
                no_accounts: 'Không tạo tài khoản đăng nhập nào.',
                reinstall_note: 'Nếu giữ nguyên ngôn ngữ và các phần tùy chọn, sẽ không có thay đổi. Nếu chọn khác, các bản ghi của gói sẽ được xóa và ghi lại.',
                remove_confirm_title: 'Gỡ bỏ {name}',
                remove_confirm: 'Gỡ bỏ {name}? Thao tác này xóa {count} bản ghi do gói ghi vào các phân hệ và {files} tệp mô phỏng đã lưu. Gói bằng chứng kiểm toán của gói cũng bị xóa, trừ khi đã có người rà soát hoặc một gói bằng chứng theo khung tuân thủ đã thu thập gói này: khi đó gói được giữ lại làm bản ghi của chính tổ chức bạn. Các mục nhật ký kiểm toán ghi lại việc cài đặt và gỡ bỏ được giữ nguyên. Dữ liệu mẫu dùng chung và các bản ghi thực của bạn được giữ nguyên.',
                install_failed: 'Không thể cài đặt gói.',
                remove_failed: 'Không thể gỡ bỏ gói.',
                result_heading: 'Kết quả của thao tác gần nhất',
                result_installed: 'Đã cài đặt {name}.',
                result_reinstalled: 'Đã cài đặt lại {name}.',
                result_unchanged: 'Không có thay đổi: {name} đã được cài đặt ở phiên bản này, với ngôn ngữ và các phần tùy chọn này.',
                result_removed: 'Đã gỡ bỏ {name}.',
                result_written: 'Số bản ghi đã ghi: {count}',
                result_removed_first: 'Số bản ghi đã xóa trước khi ghi: {count}',
                result_attachments: 'Số tệp mô phỏng đã lưu: {count}',
                result_dropped_heading: 'Bản ghi bị bỏ qua ({count})',
                result_dropped_none: 'Không có bản ghi nào bị bỏ qua.',
                drop_framework_not_installed: 'khung tuân thủ cần thiết chưa được cài đặt ({detail})',
                drop_requirement_not_installed: 'yêu cầu được ánh xạ không có trong khung tuân thủ đã cài đặt ({detail})',
                drop_module_not_available: 'gói dịch vụ của bạn không có phân hệ này ({detail})',
                drop_reference_dropped: 'bản ghi này tham chiếu tới một bản ghi đã bị bỏ qua ({detail})',
                dropped_item: '{record} ({area}): {reason}',
                // Sprint 63.37.0 (I2) — the Forms sub-section of a package card and the install result.
                forms_heading: 'Biểu mẫu',
                forms_counts: '{official} chính thức, {internal} nội bộ, {not_installed} chưa cài đặt trên tổ chức này',
                forms_list_aria: 'Biểu mẫu của {name}',
                form_official: 'Chính thức',
                form_internal: 'Nội bộ — không có biểu mẫu chính thức nào khai báo nội dung này',
                form_not_installed: 'Chưa cài đặt trên tổ chức này; cần {framework}',
                form_not_installed_unnamed: 'Chưa cài đặt trên tổ chức này',
                form_restricted: 'Không dùng được trên tổ chức này: biểu mẫu cần dùng bị hạn chế truy cập',
                form_not_fileable: 'Không dùng được trên tổ chức này: biểu mẫu đã cài đặt không nộp được',
                forms_failed: 'Không đọc được các biểu mẫu của gói này.',
                forms_retry_subject: 'các biểu mẫu của gói',
                result_forms_written: 'Biểu mẫu đã ghi ({count})',
                result_forms_dropped: 'Biểu mẫu không được ghi ({count})',
                result_form_written_item: '{record}: {form} ({standing})',
                drop_form_not_installed: 'không có biểu mẫu đã cài đặt nào đáp ứng ({detail})',
                drop_form_restricted: 'biểu mẫu cần dùng bị hạn chế truy cập trên tổ chức này ({detail})',
                drop_form_not_fileable: 'biểu mẫu đã cài đặt không nộp được ({detail})',
                evidence_pack_assembled: 'Đã tập hợp gói bằng chứng kiểm toán, chưa xác minh: {id}.',
                evidence_pack_failed: 'Không thể tập hợp gói bằng chứng kiểm toán: {error}. Các bản ghi vẫn được giữ nguyên.',
                evidence_pack_not_assembled: 'Không có gói bằng chứng kiểm toán nào được tập hợp.',
                guide_heading: 'Hướng dẫn kịch bản',
                guide_intro: 'Trình tự trình diễn. Mỗi bước mở bản ghi hoặc danh sách chứa bản ghi đó.',
                guide_language: 'Ngôn ngữ hướng dẫn: {language}',
                guide_no_accounts: 'Dữ liệu mẫu không bao gồm tài khoản đăng nhập nào. Hãy trình diễn bằng tài khoản của chính bạn; bản ghi nêu tên người theo tài khoản sẽ nêu người dùng đã cài đặt gói.',
                guide_reviewers: 'Các phê duyệt đang chờ và hồ sơ đánh giá tác động xử lý dữ liệu cá nhân do chính người rà soát của tổ chức bạn quyết định, không quyết định trong buổi trình diễn.',
                guide_point: 'Nội dung cần nêu',
                guide_do_not_claim: 'Không được khẳng định',
                guide_step_unavailable: 'Bản ghi của bước này chưa được cài đặt.',
                guide_failed: 'Không thể đọc hướng dẫn kịch bản.',
                guide_retry_subject: 'hướng dẫn kịch bản',
                result_removed_records: 'Số bản ghi đã xóa khỏi các phân hệ: {count}',
                result_removed_pack: 'Đã xóa gói bằng chứng kiểm toán ({count} dòng đã lưu)',
                kept_heading: 'Phiên bản gói bằng chứng kiểm toán được giữ lại ({count})',
                kept_reviewed: 'Gói {pack_id}, phiên bản {version}: được giữ lại vì đã được rà soát. Từ nay đây là bản ghi của chính tổ chức bạn. Các sự kiện trong gói là dòng dữ liệu mẫu và đã bị xóa cùng gói dữ liệu mẫu, nên chức năng Kiểm tra thay đổi kể từ khi tập hợp sẽ báo các sự kiện này không còn tồn tại ở nguồn, hoặc đã thay đổi nếu việc cài đặt lại đã ghi lại chúng.',
                kept_collected: 'Gói {pack_id}, phiên bản {version}: được giữ lại vì một gói bằng chứng theo khung tuân thủ đã thu thập phiên bản này. Từ nay đây là bản ghi của chính tổ chức bạn. Các sự kiện trong gói là dòng dữ liệu mẫu và đã bị xóa cùng gói dữ liệu mẫu, nên chức năng Kiểm tra thay đổi kể từ khi tập hợp sẽ báo các sự kiện này không còn tồn tại ở nguồn, hoặc đã thay đổi nếu việc cài đặt lại đã ghi lại chúng.',
                reinstall_failed_removed: 'Cài đặt lại không thành công sau khi bản cài đặt trước đã bị gỡ bỏ: đã xóa {count} bản ghi và không ghi bản ghi nào. Gói không còn được cài đặt.',
                kept_outputs_heading: 'Bản xuất của biểu mẫu dữ liệu mẫu được giữ lại ({count})',
                kept_output_item: 'Bản xuất {output_id} (tệp {file_id}): được giữ lại vì {cited_by} dẫn chiếu đến tệp này. Từ nay đây là tệp của chính tổ chức bạn. Biểu mẫu dữ liệu mẫu dùng để tạo bản xuất đã bị xóa cùng gói dữ liệu mẫu.',
                kept_output_by_compliance_execution_proof: 'bằng chứng thực hiện {id}',
                kept_output_by_cross_border_filing_evidence: 'hồ sơ chuyển dữ liệu xuyên biên giới {id}',
                kept_output_by_handbook_assessment_evidence: 'đánh giá theo cẩm nang {id}',
                kept_output_by_ai_obligation_evidence: 'hồ sơ nghĩa vụ của hệ thống AI {id}',
                kept_output_by_evidence_pack_dispatch_proof: 'bản gửi gói bằng chứng {id}',
                kept_output_by_legal_hold: 'lệnh lưu giữ pháp lý {id}',
                kept_output_by_other: 'bản ghi {id}',
                kept_output_by_legal_hold_policy: 'lệnh lưu giữ pháp lý áp dụng cho loại tệp {id}',
                kept_held_files_heading: 'Tệp dữ liệu mẫu được giữ lại, không bị xóa ({count})',
                kept_held_file_item: 'Tệp {file_id}: được giữ lại, không bị xóa, vì {cited_by} dẫn chiếu đến tệp này. Tệp vẫn là tệp của tổ chức bạn và có thể xóa trong mục Tệp khi không còn bản ghi nào dẫn chiếu đến tệp.',
            },
            // Sprint 63.37.0 (rehearsal J2) — the forms row when the load left forms out because their framework is not installed.
            status_forms_counts_not_installed: '{official} chính thức, {internal} nội bộ, {not_installed} chưa cài đặt trên tổ chức này',
        },
        help: {
            title: 'Trung tâm trợ giúp',
            search: 'Tìm kiếm',
            search_placeholder: 'Tìm kiếm bài viết trợ giúp...',
            clear: 'Xóa',
            all_categories: 'Tất cả danh mục',
            all_modules: 'Tất cả phân hệ',
            back: 'Quay lại trung tâm trợ giúp',
            callout_important: 'Quan trọng',
            callout_tip: 'Mẹo',
            no_results: 'Không tìm thấy bài viết phù hợp.',
            no_articles: 'Chưa có bài viết trợ giúp. Bài viết sẽ xuất hiện khi nội dung được thêm.',
            results_for: '{count} kết quả cho "{query}"',
            quick_links: {
                getting_started: 'Bắt đầu',
                getting_started_desc: 'Hướng dẫn cài đặt, thiết lập và sử dụng nhánh.',
                user_guide: 'Hướng dẫn người dùng',
                user_guide_desc: 'Tài liệu sử dụng theo từng phân hệ.',
                admin_guide: 'Hướng dẫn quản trị',
                admin_guide_desc: 'Cấu hình, bảo trì và xử lý sự cố.',
                faq: 'Câu hỏi thường gặp',
                faq_desc: 'Câu hỏi và trả lời thường gặp.',
            },
            opening_article: 'Đang mở bài viết: {title}',
            // fix-sprint-20260504-2137 F20 — HelpCenterPage aria-labels.
            read_article_aria: 'Đọc bài viết: {title}',
            pagination_nav_aria: 'Phân trang bài viết',
            error_unavailable: 'Trung tâm trợ giúp hiện không khả dụng. Vui lòng thử lại sau.',
            retry: 'Thử lại',
            returned_to_list: 'Đã quay lại danh sách bài viết',
            quick_links_aria: 'Liên kết nhanh đến danh mục trợ giúp',
            category_nav_aria: 'Điều hướng danh mục',
            articles_list_aria: 'Bài viết trợ giúp',
            article_metadata_aria: 'Siêu dữ liệu bài viết',
            faq_editor_title: 'Trình chỉnh sửa Câu hỏi thường gặp của Trung tâm Trợ giúp',
            faq_editor_description: 'Thêm, chỉnh sửa và xóa các cặp câu hỏi – câu trả lời trên bất kỳ bài viết nào của Trung tâm Trợ giúp. Trình chỉnh sửa chưa khả dụng; địa chỉ này được dành riêng cho nó.',
            faq_editor_empty: 'Trình chỉnh sửa Câu hỏi thường gặp chưa khả dụng. Trong thời gian chờ đợi, hãy đề nghị quản trị viên của bạn thêm mục Câu hỏi thường gặp vào bài viết của Trung tâm Trợ giúp.',
            search_articles_aria: 'Tìm kiếm bài viết trợ giúp',
            list_truncated: 'Chỉ hiển thị {shown} trong tổng số {total} bài trợ giúp. Hãy dùng ô tìm kiếm để tìm các bài còn lại.',
        },
        // Sprint 63.11.0 (#34) — the persona and use-case detail pages. Every
        // value these pages show ABOUT a persona or a use case is read from the
        // shared registries; these strings are only the frame around it.
        persona_detail: {
            page_title: 'Vai trò',
            text_loading: 'Đang tải nội dung vai trò…',
            text_failed: 'Không tải được nội dung vai trò.',
            not_found_title: 'Không tìm thấy vai trò',
            not_found_body: 'Không có vai trò nào trong bộ tham chiếu mang mã định danh "{slug}". Hãy chọn một vai trò trong danh sách đường dẫn vai trò.',
            back_to_list: 'Quay lại đường dẫn vai trò',
            open_path: 'Mở lộ trình khởi tạo',
            profile_heading: 'Hồ sơ',
            field_persona_id: 'Mã vai trò',
            field_market: 'Thị trường',
            field_quick_start: 'Nhiệm vụ đầu tiên được đề xuất',
            modules_heading: 'Phân hệ chính',
            modules_description: 'Các phân hệ mà vai trò này sử dụng nhiều nhất, chỉ gồm những phân hệ đã được bật cho tổ chức của bạn.',
            modules_checking: 'Đang kiểm tra những phân hệ nào đã được bật cho tổ chức của bạn…',
            modules_unchecked: 'Không kiểm tra được những phân hệ nào đã được bật cho tổ chức của bạn, nên tất cả đều được liệt kê.',
            modules_not_permitted: 'Tài khoản của bạn không có quyền xem những phân hệ nào đã được bật cho tổ chức của bạn, nên tất cả đều được liệt kê.',
            modules_not_enabled: 'Chưa được bật cho tổ chức của bạn: {names}',
            modules_none_enabled: 'Không có phân hệ chính nào của vai trò này được bật cho tổ chức của bạn.',
            use_cases_heading: 'Tình huống sử dụng',
            use_cases_description: 'Các tình huống sử dụng đã được kiểm chứng xác định vai trò này là vai trò chính.',
            use_cases_none: 'Chưa có tình huống sử dụng đã kiểm chứng nào xác định vai trò này là vai trò chính.',
            availability_heading: 'Khả năng sử dụng',
            availability_checking: 'Đang kiểm tra vai trò này có khả dụng cho tổ chức của bạn hay không…',
            availability_available: 'Khả dụng cho tổ chức của bạn.',
            availability_ungated: 'Khả dụng cho mọi tổ chức — vai trò này không gắn với một thị trường cụ thể.',
            availability_unavailable: 'Vai trò này thuộc một thị trường mà tổ chức của bạn chưa cài đặt ({market}). Lộ trình khởi tạo, hướng dẫn bắt đầu nhanh và các đề xuất của vai trò này chưa được cung cấp cho tổ chức của bạn cho đến khi gói thị trường tương ứng được cài đặt.',
            availability_failed: 'Không thể kiểm tra vai trò này có khả dụng cho tổ chức của bạn hay không, vì vậy trang này không khẳng định điều nào.',
            retry: 'Thử lại',
            retrying: 'Đang kiểm tra…',
            market_vn: 'Việt Nam',
            market_eu: 'Liên minh châu Âu / EEA',
            market_uk: 'Vương quốc Anh',
            market_gl: 'Toàn cầu — không gắn với một thị trường',
        },
        use_case_detail: {
            page_title: 'Tình huống sử dụng {id}',
            description: 'Một tình huống sử dụng đã được kiểm chứng trong bộ tham chiếu và vai trò mà tình huống đó được xây dựng cho. Phần tường thuật đầy đủ nằm trong tài liệu tham chiếu nêu bên dưới; trang này không diễn đạt lại.',
            not_found_title: 'Không tìm thấy tình huống sử dụng',
            not_found_body: 'Không có tình huống sử dụng nào trong bộ tham chiếu mang mã định danh "{id}". Hãy mở một vai trò để xem các tình huống sử dụng được xây dựng cho vai trò đó.',
            back_to_list: 'Quay lại đường dẫn vai trò',
            open_path: 'Mở lộ trình khởi tạo của vai trò chính',
            details_heading: 'Chi tiết',
            field_use_case_id: 'Mã tình huống sử dụng',
            field_primary_persona: 'Vai trò chính',
            field_persona_id: 'Mã vai trò',
            field_market: 'Thị trường',
            availability_heading: 'Khả năng sử dụng',
            availability_checking: 'Đang kiểm tra tình huống sử dụng này có khả dụng cho tổ chức của bạn hay không…',
            availability_available: 'Khả dụng cho tổ chức của bạn.',
            availability_ungated: 'Khả dụng cho mọi tổ chức — vai trò chính của tình huống này không gắn với một thị trường cụ thể.',
            availability_unavailable: 'Tình huống sử dụng này thuộc một thị trường mà tổ chức của bạn chưa cài đặt ({market}). Vai trò chính và lộ trình khởi tạo của tình huống này chưa được cung cấp cho tổ chức của bạn cho đến khi gói thị trường tương ứng được cài đặt.',
            availability_failed: 'Không thể kiểm tra tình huống sử dụng này có khả dụng cho tổ chức của bạn hay không, vì vậy trang này không khẳng định điều nào.',
            retry: 'Thử lại',
            retrying: 'Đang kiểm tra…',
        },
    },
    common: {
        vendor: 'Nhà cung cấp',
        list_truncation: {
            loading: 'Đang tải danh sách…',
            failed: 'Không thể tải danh sách, nên hiện chưa thể chọn mục nào.',
            // `partner_marketplace.selector_truncated`'s reviewed rendering, verbatim.
            partial_with_total: 'Đang hiển thị {shown} trong tổng số {total}. Hãy thu hẹp tìm kiếm để xem phần còn lại.',
            partial_without_total: 'Đang hiển thị {shown} mục đầu tiên. Hãy thu hẹp tìm kiếm để xem phần còn lại; chưa rõ còn bao nhiêu mục nữa.',
        },
        // fix-sprint-20261013-0200 R1 — the remedy a failed directory read offers, said once for every
        // DirectoryNotice and UserSelect (components/register/DirectoryNotice.tsx `directoryRetry`).
        directory_retry: 'Tải lại',
        directory_retrying: 'Đang tải lại…',
        directory_retry_subject: 'danh bạ người dùng',
        // fix-sprint-20260905-2135 F33/F34 — keys that tKey() call sites asked for and
        // no locale declared, so each fell through to its hardcoded English third
        // argument and rendered English in all 16 locales. The two DPIA row-action
        // tooltips were worse: their fallbacks are themselves translated keys, so the
        // primary CTA read 'Edit' where the code intends 'Continue', and the in-review
        // action read 'Approve/Reject' where it intends 'Review'.
        change: 'Thay đổi',
        current: 'hiện tại',
        next_page: 'Trang sau',
        selected: 'đã chọn',
        // Fix sprint F30 — the shared "for example" wrapper. Three pages built
        // `e.g. ${code}` as a template literal, so the words rendered in English in
        // all 16 locales; the abbreviation differs per language (see
        // `escalation_contact_placeholder`, which already had it right).
        example_value: 'ví dụ: {value}',
        /*
         * Sprint 64.40.0's partially-redacted-export notice, moved here from the
         * `{ en, vi }` table that shipped beside `ExportFormatMenu` while this
         * directory was held by another agent. That table selected its text with
         * `locale.startsWith('vi')` — both patterns are named as banned in
         * I18N.md — and `ExportFormatMenu` is mounted on ~145 admin pages, so every
         * operator on the 14 other locales was told in English that their artefact
         * was incomplete. Per R-57 the real translations are EN and VI; the other
         * 14 bundles carry the English text for structural parity.
         */
        export_incomplete_heading: 'Bản xuất này chưa đầy đủ',
        export_incomplete_body: '{count} giá trị trong {fieldCount} trường ({fields}) đã được giữ kín vì bạn không có quyền xem. Tệp đánh dấu từng giá trị đó.',
        export_not_scanned: 'Bản xuất này được tạo từ nội dung đã định dạng sẵn nên tính đầy đủ của nó chưa được kiểm tra.',
        save: 'Lưu',
        cancel: 'Hủy',
        system_actor: 'Hệ thống',
        delete: 'Xóa',
        edit: 'Sửa',
        create: 'Tạo',
        update: 'Cập nhật',
        loading: 'Đang tải...',
        error: 'Có lỗi xảy ra',
        success: 'Thành công',
        logout: 'Đăng xuất',
        actions: 'Thao tác',
        retrying: 'Đang thử lại…',
        permission_denied: 'Bạn không có quyền truy cập trang này.',
        status: 'Trạng thái',
        description: 'Mô tả',
        name: 'Tên',
        created_at: 'Ngày tạo',
        updated_at: 'Ngày cập nhật',
        yes: 'Có',
        no: 'Không',
        confirm: 'Xác nhận',
        confirm_dialog_title: 'Xác nhận thao tác',
        back: 'Quay lại',
        next: 'Tiếp',
        previous: 'Trước',
        search: 'Tìm kiếm',
        filter: 'Lọc',
        // Sprint 47.9.1a — shared pagination labels (EN+VI only; other
        // locales fan out in 51.0.0).
        page_x_of_y: 'Trang {page} / {total}',
        pagination_label: 'Phân trang',
        view_mode_label: 'Chế độ xem',
        export: 'Xuất',
        // fix-sprint-20260415-0434 F11/F12/F16/F17
        exporting: 'Đang xuất…',
        sidebar_navigation: 'Thanh điều hướng quản trị',
        items_count: '{count} mục',
        items_count_one: '{count} mục',
        export_success: 'Tạo tài liệu thành công.',
        generate_pdf: 'Tạo PDF',
        import: 'Nhập',
        download: 'Tải xuống',
        upload: 'Tải lên',
        view: 'Xem',
        close: 'Đóng',
        close_notification: 'Đóng thông báo',
        discard_prompt: {
            title: 'Bỏ các thay đổi chưa lưu?',
            message: 'Hộp thoại này có các thay đổi chưa được lưu. Đóng lại bây giờ sẽ bỏ các thay đổi đó.',
            confirm: 'Bỏ thay đổi',
            cancel: 'Tiếp tục chỉnh sửa',
        },
        submit: 'Gửi',
        saved: 'Đã lưu thành công',
        saving: 'Đang lưu...',
        submitting: 'Đang gửi...',
        created: 'Đã tạo thành công',
        all: 'Tất cả',
        none: 'Không có',
        select: 'Chọn',
        select_user: 'Chọn người dùng...',
        custom_input: 'Nhập thủ công',
        required: 'Bắt buộc',
        optional: 'Tùy chọn',
        notes: 'Ghi chú',
        tags: 'Nhãn',
        archive: 'Lưu trữ',
        clone: 'Nhân bản',
        refresh: 'Làm mới',
        retry: 'Thử lại',
        // fix-sprint-20260810-2128 residue (finding A8's class) — a failed
        // option read stated as such, never shown as an empty list.
        options_unreadable: 'Không đọc được các lựa chọn cho trường này. Điều đó không có nghĩa là không có lựa chọn nào.',
        // Inside a picker's empty menu, where the full sentence is already stated
        // as an alert beside it; says nothing that could read as "none".
        options_unreadable_pointer: 'Không đọc được — xem thông báo bên dưới.',
        reset: 'Đặt lại',
        add: 'Thêm',
        remove: 'Xóa',
        // fix-sprint-20260410-0410 F5/F6 — shared AttachmentField + EntityReferenceSelect
        removing: 'Đang xóa…',
        attachment: 'Tệp đính kèm',
        upload_file: 'Tải tệp lên',
        upload_file_required: 'Tải tệp lên (bắt buộc)',
        // fix-sprint-20260808-0511-followup-2 F1 — FileUpload.tsx drop-zone,
        // progress and validation-toast strings (were hardcoded EN in a shared
        // component reached from every file_upload form field).
        upload_drag_or_browse: 'Kéo và thả hoặc nhấp để duyệt',
        upload_max_size: 'Kích thước tối đa: {size} MB',
        upload_accepted_types: 'Chấp nhận: {types}',
        upload_in_progress: 'Đang tải lên {name}...',
        upload_size_exceeded: 'Kích thước tệp vượt quá kích thước tối đa cho phép là {size} MB.',
        upload_type_not_accepted: 'Loại tệp không được chấp nhận. Các loại được chấp nhận: {types}',
        upload_succeeded: 'Đã tải lên tệp "{name}" thành công.',
        upload_failed: 'Tải lên tệp thất bại.',
        select_entity_type_first: 'Vui lòng chọn loại thực thể trước',
        // fix-sprint-20260411-0337 H10/M12/M13/M14
        failed_to_remove_file: 'Không thể xóa tệp.',
        entity_type_label: 'Loại thực thể',
        entity_label: 'Thực thể',
        entity_reference: 'Tham chiếu thực thể',
        failed_to_load_entities: 'Không thể tải thực thể',
        enable: 'Bật',
        disable: 'Tắt',
        no_data: 'Không có dữ liệu',
        confirm_delete: 'Bạn có chắc chắn muốn xóa mục này?',
        confirm_action: 'Bạn có chắc chắn muốn tiếp tục?',
        save_success: 'Đã lưu thành công',
        save_error: 'Không thể lưu',
        delete_success: 'Đã xóa thành công',
        delete_error: 'Không thể xóa',
        hour: 'giờ',
        hours: 'giờ',
        load_error: 'Không thể tải dữ liệu',
        operation_error: 'Thao tác thất bại',
        something_went_wrong: 'Có lỗi xảy ra',
        go_home: 'Về trang tổng quan',
        access_denied: 'Từ chối truy cập',
        no_permission: 'Bạn không có quyền truy cập trang này.',
        no_permission_title: 'Không đủ quyền',
        no_permission_message: 'Bạn không có quyền truy cập trang này.',
        unknown: 'Không xác định',
        back_to_dashboard: 'Quay lại tổng quan',
        id: 'ID',
        type: 'Loại',
        date: 'Ngày',
        created_by: 'Tạo bởi',
        updated_by: 'Cập nhật bởi',
        page_of: 'Trang {page} / {total}',
        showing_items: 'Hiển thị {count} mục',
        items_per_page: 'Mục mỗi trang',
        sr_urgent: 'Khẩn cấp',
        n_per_page: '{n} / trang',
        select_user_placeholder: '-- Chọn người dùng --',
        field_required: 'Trường này là bắt buộc',
        results_found: 'kết quả tìm thấy',
        select_placeholder: '-- Chọn --',
        unknown_user: 'Người dùng không xác định',
        // fix-sprint #431 F7 — tên các tác nhân của chính nền tảng (`SystemActorId`).
        system_actors: {
            intake: 'Hệ thống tiếp nhận',
            sla_engine: 'Quy trình kiểm tra SLA',
            export_job: 'Tác vụ xuất dữ liệu',
            cmp_gateway: 'Cổng CMP',
            notification: 'Hệ thống thông báo',
            migration: 'Chuyển đổi dữ liệu hệ thống',
            other: 'Hệ thống: {name}',
        },
        export_csv: 'Xuất CSV',
        not_applicable: 'N/A',
        aria_overdue_since: 'Quá hạn từ {date}',
        no_results: 'Không có bản ghi phù hợp',
        no_items: 'Không tìm thấy mục nào',
        sort_by: 'Sắp xếp theo',
        ascending: 'Tăng dần',
        descending: 'Giảm dần',
        all_statuses: 'Tất cả trạng thái',
        all_types: 'Tất cả loại',
        all_categories: 'Tất cả danh mục',
        all_severities: 'Tất cả mức độ',
        date_range: 'Khoảng thời gian',
        from_date: 'Từ',
        to_date: 'Đến',
        clear_filters: 'Xóa bộ lọc',
        apply_filters: 'Áp dụng bộ lọc',
        save_changes: 'Lưu thay đổi',
        discard_changes: 'Hủy thay đổi',
        confirm_discard: 'Bạn có thay đổi chưa lưu. Hủy chúng?',
        copy: 'Sao chép',
        duplicate: 'Nhân bản',
        move: 'Di chuyển',
        assign: 'Phân công',
        unassign: 'Bỏ phân công',
        approve: 'Phê duyệt',
        reject: 'Từ chối',
        deleting: 'Đang xóa...',
        processing: 'Đang xử lý...',
        loading_page: 'Đang tải trang...',
        operation_success: 'Thao tác hoàn tất thành công',
        operation_failed: 'Thao tác thất bại. Vui lòng thử lại.',
        /*
         * Sprint 64.x-batch-17 — moved out of two inline `{ en, vi }` maps.
         *
         * `CHECKED_DOWNLOAD_FAILED_COPY` lived in `useCheckedDownload.ts` and is
         * the fallback toast for EVERY one of the 26 migrated download surfaces;
         * `RETRIEVAL_DENIED_COPY` lived in `EvidencePackDetailPage.tsx`. I18N.md
         * names `{ en, vi }` lookup objects as the documented root cause of "14
         * languages showing only English" and bans them outright, and neither
         * string had a key in any of the 16 bundles — so both were invisible to
         * the Phase 25 translation batches and could never reach parity.
         *
         * The hook's docblock justified the inline map with "a key earns its place
         * when more than one surface needs the same string", a rule that is not in
         * I18N.md; the string was in fact read by every migrated call site.
         */
        download_failed: 'Tải xuống không thành công.',
        download_forbidden: 'Không tải được tệp: việc tải tệp xuống cần một quyền mà vai trò của bạn chưa có.',
        export_needs_download: 'Việc xuất tệp cần quyền tải tệp xuống, mà vai trò của bạn chưa có.',
        export_download_forbidden: 'Đã xuất tệp nhưng không tải được tệp xuống: việc tải tệp xuống cần một quyền mà vai trò của bạn chưa có.',
        retrieval_denied: 'Tải xuống phiên bản này yêu cầu quyền mà vai trò của bạn không có.',
        retrieval_denied_generic: 'Tải xuống tệp này yêu cầu quyền mà vai trò của bạn không có.',
        /* Sprint 62.58.0 PR 3 (product-qa walk N-2) — tệp bị từ chối vì có phần
           được in theo quyền mà vai trò không có đủ. */
        download_refusal_sections: 'Không tải được tệp: tệp có những phần cần các quyền sau, mà vai trò của bạn chưa có: {permissions}.',
        /* Sprint 62.58.0 PR 3 (step-2 confirmation P3-4) — cùng các lần từ chối đó
           trong *Chi tiết tệp*, nơi người đọc chỉ mở xem: không có gì được tải xuống. */
        details_refusal_sections: 'Không hiển thị được chi tiết tệp: tệp có những phần cần các quyền sau, mà vai trò của bạn chưa có: {permissions}.',
        details_refused_generic: 'Không hiển thị được chi tiết tệp: việc xem tệp này cần một quyền mà vai trò của bạn chưa có.',
        download_permission_names: {
            privacy_notice_read: 'xem thông báo về bảo vệ dữ liệu cá nhân',
            dm_activity_read: 'xem hoạt động xử lý dữ liệu cá nhân',
            dm_system_read: 'xem hệ thống trong bản đồ dữ liệu',
            biometric_capture_read: 'xem thành phần thu nhận sinh trắc học',
        },
        date_cleared: 'Đã xóa ngày',
        clear_date: 'Xóa ngày',
        date_picker: 'Bộ chọn ngày',
        date_selected: 'Đã chọn',
        not_measured: 'Chưa đo lường',
        empty_dash: '—',
        network_error: 'Lỗi mạng. Kiểm tra kết nối.',
        session_expired: 'Phiên hết hạn. Vui lòng đăng nhập lại.',
        test: 'Kiểm tra',
        pause: 'Tạm dừng',
        resume: 'Tiếp tục',
        activate: 'Kích hoạt',
        last_sync: 'Đồng bộ cuối',
        health: 'Sức khỏe',
        email: 'Email',
        role: 'Vai trò',
        title: 'Tiêu đề',
        owner: 'Chủ sở hữu',
        priority: 'Ưu tiên',
        category: 'Danh mục',
        details: 'Chi tiết',
        overview: 'Tổng quan',
        configuration: 'Cấu hình',
        history: 'Lịch sử',
        new_item: 'Mới',
        edit_item: 'Sửa',
        select_option: 'Chọn...',
        total: 'Tổng',
        active: 'Hoạt động',
        inactive: 'Không hoạt động',
        enabled: 'Đã bật',
        disabled: 'Đã tắt',
        last_login: 'Đăng nhập cuối',
        never: 'Không',
        password_changed: 'Mật khẩu đã đổi. Bạn sẽ được đăng xuất.',
        password_change_failed: 'Không thể đổi mật khẩu',
        passwords_mismatch: 'Mật khẩu không khớp',
        install: 'Cài đặt',
        install_named: 'Cài đặt {name}',
        uninstall: 'Gỡ cài đặt',
        installed: 'Đã cài đặt',
        available: 'Khả dụng',
        catalog: 'Danh mục',
        published: 'Đã xuất bản',
        version: 'Phiên bản',
        market: 'Thị trường',
        language: 'Ngôn ngữ',
        framework: 'Khung tuân thủ',
        template: 'Mẫu',
        connector_type: 'Loại kết nối',
        polling_interval: 'Khoảng thời gian kiểm tra (phút)',
        new_instance: 'Phiên bản mới',
        change_password: 'Đổi mật khẩu',
        current_password: 'Mật khẩu hiện tại',
        new_password: 'Mật khẩu mới',
        confirm_password: 'Xác nhận mật khẩu',
        comments: 'Bình luận',
        completed: 'Hoàn thành',
        contact: 'Liên hệ',
        hide: 'Ẩn',
        hide_details: 'Ẩn chi tiết',
        label: 'Nhãn',
        max: 'Tối đa',
        min: 'Tối thiểu',
        na: 'K/A',
        of: 'của',
        showing: 'Hiển thị',
        page: 'Trang',
        preview: 'Xem trước',
        print: 'In',
        show: 'Hiện',
        status_active: 'Hoạt động',
        status_completed: 'Hoàn thành',
        status_draft: 'Nháp',
        status_in_progress: 'Đang thực hiện',
        status_pending: 'Chờ xử lý',
        view_details: 'Xem chi tiết',
        all_priorities: 'Tất cả mức ưu tiên',
        pipeline: 'Quy trình',
        all_requests: 'Tất cả yêu cầu',
        schedule: 'Lên lịch',
        deploy: 'Triển khai',
        rollback: 'Hoàn tác',
        advance_stage: 'Chuyển giai đoạn',
        submit_for_approval: 'Gửi phê duyệt',
        approval_log: 'Nhật ký phê duyệt',
        approver: 'Người phê duyệt',
        decision: 'Quyết định',
        decided_at: 'Quyết định lúc',
        rollout_stages: 'Giai đoạn triển khai',
        approval_comment: 'Bình luận phê duyệt',
        optional_comment: 'Bình luận tùy chọn...',
        impact_summary: 'Tóm tắt tác động',
        target_property_ids: 'ID Tài sản mục tiêu (phân cách bằng dấu phẩy)',
        policy_id: 'ID Chính sách',
        target_version: 'Phiên bản mục tiêu',
        target_version_placeholder: 'ví dụ: 2.0.0',
        scheduled_label: 'Đã lên lịch',
        scheduled_start: 'Bắt đầu theo lịch',
        scheduled_end: 'Kết thúc theo lịch',
        properties_count: '{count} tài sản',
        results: 'Kết quả',
        comparison_results: 'Kết quả so sánh',
        past_comparison_reports: 'Báo cáo so sánh trước',
        scanning: 'Đang quét...',
        run_inconsistency_scan: 'Chạy quét bất nhất quán',
        property_ids_label: 'ID Tài sản (phân cách bằng dấu phẩy, tối thiểu 2)',
        comparison_type: 'Loại so sánh',
        golden_template_id: 'ID Mẫu vàng (tùy chọn)',
        leave_blank_compare: 'Để trống để so sánh các tài sản với nhau',
        add_notes_placeholder: 'Thêm ghi chú phân tích tại đây...',
        covered_of_active: '{covered} trong {active} tài sản hoạt động được bao phủ',
        fetch_error: 'Không thể tải dữ liệu. Vui lòng thử lại.',
        run_comparison_error: 'Không thể chạy so sánh. Vui lòng thử lại.',
        save_notes_error: 'Không thể lưu ghi chú. Vui lòng thử lại.',
        scan_complete: 'Quét bất nhất quán hoàn tất thành công.',
        scan_error: 'Không thể chạy quét bất nhất quán. Vui lòng thử lại.',
        min_two_properties: 'Vui lòng cung cấp ít nhất 2 ID tài sản để so sánh.',
        comma_separated: 'phân cách bằng dấu phẩy',
        language_english: 'Tiếng Anh',
        language_vietnamese: 'Tiếng Việt',
        language_vietnamese_native: 'Tiếng Việt',
        author: 'Tác giả',
        dependencies: 'Phụ thuộc',
        checksum: 'Mã kiểm tra',
        changelog: 'Nhật ký thay đổi',
        tier: 'Cấp',
        phone: 'Điện thoại',
        launch: 'Khởi chạy',
        complete: 'Hoàn thành',
        back_to_list: 'Quay lại danh sách',
        clear_selection: 'Xóa lựa chọn',
        deactivate: 'Vô hiệu hóa',
        scope: 'Phạm vi',
        deadline: 'Hạn chót',
        progress: 'Tiến độ',
        frequency: 'Tần suất',
        reviewer: 'Người đánh giá',
        user: 'Người dùng',
        campaign: 'Chiến dịch',
        items: 'Mục',
        next_run: 'Lần chạy tiếp',
        last_run: 'Lần chạy cuối',
        overdue: 'QUÁ HẠN',
        creating: 'Đang tạo...',
        launching: 'Đang khởi chạy...',
        all_data: 'Tất cả dữ liệu',
        non_compliant_status: 'Không tuân thủ',
        compliant: 'Tuân thủ',
        policies: 'Chính sách',
        showing_table_view: 'Đang hiển thị chế độ xem bảng dữ liệu',
        showing_chart_view: 'Đang hiển thị chế độ xem biểu đồ',
        country: 'Quốc gia',
        value: 'Giá trị',
        metric: 'Chỉ số',
        pagination: 'Phân trang',
        urgent: 'Khẩn cấp',
        per_page: '/ trang',
        page_size: 'Kích thước trang',
        loaded: 'đã tải',
        placeholders: {
            enter_justification: 'Nhập lý do',
            justification: 'Lý do',
            campaign_name_example: 'Đánh giá quyền truy cập Q1 2026',
            optional_description: 'Mô tả tùy chọn',
            enter_user_id: 'Nhập ID người dùng của người đánh giá',
            enter_user_id_short: 'Nhập ID người dùng',
            schedule_name_example: 'Xác nhận truy cập hàng quý',
            enter_property_id: 'Nhập ID thuộc tính',
            enter_policy_id: 'Nhập ID chính sách',
            property_or_group_id: 'ID thuộc tính hoặc nhóm',
            describe_template_purpose: 'Mô tả mục đích mẫu...',
            step_title: 'Tiêu đề bước...',
            detailed_instructions: 'Hướng dẫn chi tiết...',
            filter_by_taxonomy_id: 'Lọc theo ID phân loại...',
            describe_classification_rule: 'Mô tả quy tắc phân loại...',
            describe_dedup_rule: 'Mô tả quy tắc loại trùng...',
            describe_import_template: 'Mô tả mẫu nhập...',
            reason_for_rejection: 'Lý do từ chối...',
            jurisdiction_codes_example: 'VN, SG, EU',
            filter_by_locale: 'Lọc theo ngôn ngữ...',
            filter_by_event_type: 'Lọc theo loại sự kiện',
            filter_by_actor_id: 'Lọc theo ID tác nhân',
            filter_by_market_code: 'Lọc theo mã thị trường...',
            filter_by_framework_id: 'Lọc theo ID khung...',
            add_comment: 'Thêm bình luận...',
            provide_rejection_reason: 'Cung cấp lý do từ chối đơn gửi này...',
            filter_by_jurisdiction: 'Lọc theo mã quyền tài phán...',
            enter_report_title: 'Nhập tiêu đề báo cáo',
            enter_name: 'Nhập tên',
            enter_description: 'Nhập mô tả',
            enter_org_id: 'Nhập ID tổ chức để thêm',
            describe_evidence_gap: 'Mô tả lỗ hổng bằng chứng...',
            expected_evidence: 'Bằng chứng mong đợi',
            entity_identifier: 'Định danh thực thể',
            remediation_steps: 'Các bước khắc phục lỗ hổng này',
            user_id_or_name: 'Tìm theo tên',
            reporting_period_id: 'ID kỳ báo cáo',
            maturity_model_id: 'Chọn một mô hình trưởng thành',
            describe_maturity_model: 'Mô tả mô hình trưởng thành này...',
            describe_role_purpose: 'Mô tả mục đích của vai trò này...',
            provide_deny_reason: 'Cung cấp lý do từ chối yêu cầu này',
            describe_emergency: 'Mô tả tình huống khẩn cấp yêu cầu quyền truy cập nâng cao (tối thiểu 20 ký tự)',
            enter_delegate_id: 'Nhập ID người dùng được ủy quyền',
            provide_delegation_reason: 'Cung cấp lý do cho việc ủy quyền này',
            client_identifier: 'Mã định danh khách hàng',
            client_secret: 'Bí mật khách hàng',
            time_format: 'GG:PP',
            describe_sod_rule: 'Mô tả mục đích của quy tắc SoD này...',
            enter_role_id: 'Nhập ID vai trò',
            explain_exception: 'Giải thích lý do cần ngoại lệ này...',
            describe_compensating_controls: 'Mô tả các biện pháp kiểm soát bù đắp...',
            full_name: 'Họ và tên',
            min_chars: 'Tối thiểu 12 ký tự',
            enter_override_justification: 'Nhập lý do ghi đè đánh giá cổng này',
            enter_evidence_id: 'Nhập ID bằng chứng để liên kết:',
            date_format: 'NN/TT/NNNN',
            describe_pack_contents: 'Mô tả nội dung và mục đích của gói',
            select_reviewers: 'Chọn người đánh giá...',
        },
        aria_previous_page: 'Trang trước',
        aria_next_page: 'Trang sau',
        aria_results_per_page: 'Kết quả mỗi trang',
        per_page_25: '25 / trang',
        per_page_50: '50 / trang',
        per_page_100: '100 / trang',
        select_language: 'Chọn ngôn ngữ',
        today: 'Hôm nay',
        tomorrow: 'Ngày mai',
        dashboard_load_error: 'Không thể tải bảng điều khiển. Vui lòng thử lại.',
        enum_grade: {
            red: 'Đỏ',
            amber: 'Cấm',
            yellow: 'Vàng',
            green: 'Xanh lá',
        },
        enum_severity: {
            critical: 'Nghiêm trọng',
            high: 'Cao',
            medium: 'Trung bình',
            low: 'Thấp',
        },
        enum_priority: {
            critical: 'Nghiêm trọng',
            high: 'Cao',
            medium: 'Trung bình',
            low: 'Thấp',
        },
        enum_status: {
            pending: 'Chờ xử lý',
            in_progress: 'Đang thực hiện',
            completed: 'Hoàn thành',
            blocked: 'Bị chặn',
            escalated: 'Đã leo thang',
            cancelled: 'Đã hủy',
            overdue: 'Quá hạn',
            not_started: 'Chưa bắt đầu',
            new: 'Mới',
            open: 'Đang mở',
            closed: 'Đã đóng',
            acknowledged: 'Đã xác nhận',
            resolved: 'Đã giải quyết',
        },
        enum_department: {
            unassigned: 'Chưa phân công',
        },
        enum_form_category: {
            assessment: 'Đánh giá',
            assessment_report: 'Báo cáo đánh giá',
            dpia: 'DPIA',
            authority_submission: 'Nộp cho cơ quan',
            cross_border_transfer: 'Chuyển dữ liệu xuyên biên giới',
            vendor: 'Nhà cung cấp',
            breach: 'Vi phạm',
            consent: 'Đồng ý',
            governance: 'Quản trị',
            register: 'Sổ đăng ký',
            monitoring: 'Giám sát',
            dpa: 'Cơ quan BVDL',
            dsr: 'Yêu cầu quyền',
            privacy: 'Quyền riêng tư',
            incident: 'Sự cố',
            org: 'Tổ chức',
            sector: 'Ngành',
            classification: 'Phân loại',
            discovery: 'Khám phá',
            // Sprint 63.37.0 (Stream J) — the pack categories the forms dashboard showed as raw codes.
            evidence_record: 'Hồ sơ bằng chứng',
            application: 'Đơn đề nghị',
            report: 'Báo cáo',
            data_mapping: 'Bản đồ dữ liệu',
            record: 'Bản ghi',
            evidence: 'Bằng chứng',
            certificate: 'Giấy chứng nhận',
            log: 'Nhật ký',
            sandbox: 'Thử nghiệm có kiểm soát',
            decision: 'Quyết định',
            licence: 'Giấy phép',
            declaration: 'Bản khai',
            administrative_notice: 'Thông báo hành chính',
            plan: 'Kế hoạch',
            dossier: 'Hồ sơ',
            training: 'Đào tạo',
            checklist: 'Danh mục kiểm tra',
            training_report: 'Báo cáo đào tạo',
            reference_list: 'Danh mục tham chiếu',
            evidence_pack: 'Gói bằng chứng',
            forms: 'Biểu mẫu',
            authority_response_record: 'Hồ sơ phản hồi cơ quan',
            request: 'Yêu cầu',
            attestation: 'Xác nhận',
            notification: 'Thông báo',
            evidence_pack_manifest: 'Danh mục gói bằng chứng',
            email_submission_record: 'Hồ sơ nộp qua thư điện tử',
            evidence_file: 'Tệp bằng chứng',
            worksheet: 'Bảng tính',
            uncategorized: 'Chưa phân loại',
        },
        enum_module: {
            rights_requests: 'Yêu cầu quyền',
            assessments: 'Đánh giá tác động',
            incidents: 'Sự cố',
            incident_ops: 'Vận hành sự cố',
            monitoring: 'Giám sát',
            vendor_risk: 'Rủi ro nhà cung cấp',
            governance: 'Quản trị',
            deletion_orchestration: 'Xóa dữ liệu',
            access_review: 'Xem xét truy cập',
            consent: 'Đồng ý',
            consent_properties: 'Thuộc tính đồng ý',
            forms: 'Biểu mẫu',
            localization: 'Bản địa hóa',
            program_governance: 'Quản trị chương trình',
            privacy_scanner: 'Quét quyền riêng tư',
            classification: 'Phân loại',
            discovery: 'Khám phá',
            manual: 'Thủ công',
            data_mapping: 'Bản đồ dữ liệu',
        },
        enum_risk_level: {
            critical: 'Nghiêm trọng',
            high: 'Cao',
            medium: 'Trung bình',
            low: 'Thấp',
        },
        enum_request_type: {
            all: 'Tất cả',
            access: 'Truy cập (DSAR)',
            deletion: 'Xóa',
            correction: 'Chỉnh sửa',
            objection: 'Phản đối',
            portability: 'Chuyển dữ liệu',
            restriction: 'Hạn chế',
            consent_withdrawal: 'Rút lại sự đồng ý',
            protective_measures: 'Biện pháp, giải pháp bảo vệ dữ liệu cá nhân',
            processing_information: 'Được biết về xử lý dữ liệu',
            consent_decision: 'Đồng ý hoặc không đồng ý',
            complaint_or_compensation: 'Khiếu nại, tố cáo, khởi kiện, yêu cầu bồi thường thiệt hại',
        },
        enum_locale: {
            en: 'Tiếng Anh',
            vi: 'Tiếng Việt',
            all: 'Cả hai',
        },
        enum_event_type: {
            case_created: 'Tạo yêu cầu',
            status_changed: 'Thay đổi trạng thái',
            case_assigned: 'Phân công yêu cầu',
            note_added: 'Thêm ghi chú',
            attachment_added: 'Thêm đính kèm',
            attachment_deleted: 'Xóa đính kèm',
            reference_added: 'Thêm tham chiếu',
            checklist_updated: 'Cập nhật danh mục',
            identity_verified: 'Xác minh danh tính',
            closure_summary_added: 'Tóm tắt đóng',
            approval_granted: 'Phê duyệt',
            template_applied: 'Áp dụng mẫu biểu',
            export_generated: 'Xuất dữ liệu',
            sla_warning: 'Cảnh báo SLA',
            sla_overdue: 'SLA quá hạn',
            sla_flag_revisited: 'Rà soát lại đánh dấu SLA',
            third_party_involvement_changed: 'Thay đổi việc bên xử lý dữ liệu cá nhân hoặc bên thứ ba tham gia',
        },
        more: 'thêm',
        use: 'Sử dụng',
        ok: 'OK',
        back_to: 'Quay lại',
        click_to_copy: 'nhấn để sao chép',
        copied: 'Đã sao chép',
        more_actions: 'Thao tác khác',
        actions_for: 'Thao tác cho {title}',
        previous_page: 'Trang trước',
        lookup_read_failed: 'Không thể tải một danh sách dùng để chọn trên trang này, nên ô chọn có thể trống hoặc chưa đầy đủ.',
        lookup_read_subject: 'các danh sách dùng để chọn',
        export_error: 'Xuất thất bại',
        you: 'Bạn',
        export_failed: 'Xuất thất bại. Vui lòng thử lại.',
        filters: 'Bộ lọc',
        failed: 'Không thành công',
        attachment_release_action: 'Giải phóng và tiêu hủy tệp',
        attachment_release_title: 'Giải phóng tệp tài liệu chứng minh này',
        attachment_release_body: 'Việc giải phóng sẽ tiêu hủy tệp và ghi nhận việc tiêu hủy vào chuỗi bằng chứng xóa dữ liệu. Sau đó, mọi mục tham chiếu tệp này sẽ ghi rằng tệp đã bị tiêu hủy và thời điểm tiêu hủy. Không thể hoàn tác thao tác này.',
        attachment_release_basis_legend: 'Vì sao tệp được giải phóng?',
        attachment_release_basis_retention: 'Đã hết thời hạn lưu trữ',
        attachment_release_basis_erasure: 'Một yêu cầu xóa dữ liệu áp dụng cho tệp này',
        attachment_release_reason: 'Lý do (bắt buộc)',
        attachment_release_retention_date: 'Ngày hết thời hạn lưu trữ (bắt buộc)',
        attachment_release_retention_date_hint: 'Chưa có thời hạn lưu trữ nào được cài đặt cho tài liệu chứng minh này, nên hãy nêu ngày hết thời hạn lưu trữ. Không thể giải phóng tệp trước ngày đó.',
        attachment_release_erasure_request: 'Yêu cầu xóa dữ liệu (bắt buộc)',
        attachment_release_erasure_placeholder: 'Chọn yêu cầu xóa dữ liệu',
        attachment_release_erasure_none: 'Chưa ghi nhận yêu cầu xóa dữ liệu nào.',
        attachment_release_erasure_none_not_decided: 'Đã ghi nhận yêu cầu xóa dữ liệu về người này nhưng yêu cầu đó chưa được quyết định thực hiện, nên chưa có yêu cầu nào được liệt kê. Hãy giải phóng tệp khi việc xóa đã được quyết định.',
        attachment_release_erasure_none_not_qualifying: 'Không có yêu cầu xóa dữ liệu nào đã ghi nhận về người này đáp ứng điều kiện.',
        attachment_release_confirm: 'Giải phóng và tiêu hủy',
        attachment_release_releasing: 'Đang giải phóng…',
        attachment_release_done: 'Tệp đã được giải phóng và tiêu hủy.',
        attachment_release_failed: 'Tệp chưa được giải phóng.',
        attachment_release_not_ended: 'Thời hạn lưu trữ kết thúc vào ngày {date}, nên không thể giải phóng tệp trước ngày đó.',
        attachment_release_under_hold: 'Tệp đang bị tạm giữ, nên không được giải phóng.',
        attachment_release_not_needed: 'Không có mục tài liệu chứng minh nào dựa trên tệp này, nên tệp không được giải phóng: hãy xóa tệp theo cách thông thường.',
        attachment_release_decided_by_register: 'Tệp này là tài liệu chứng minh trong một sổ đăng ký có quy tắc lưu trữ riêng quyết định thời điểm giải phóng, nên không được giải phóng theo ngày được nêu.',
        attachment_release_date_installed: 'Thời hạn lưu trữ đã cài đặt kết thúc vào ngày {date}; không thể nêu một ngày khác.',
        attachment_released_retention: 'Tài liệu chứng minh đã được tiêu hủy khi hết thời hạn lưu trữ vào ngày {date}',
        attachment_released_erasure: 'Tài liệu chứng minh đã được tiêu hủy theo yêu cầu xóa dữ liệu {request}',
        attachment_released_erasure_unnamed: 'Tài liệu chứng minh đã được tiêu hủy theo một yêu cầu xóa dữ liệu',
        attachment_release_erasure_label_none: 'Yêu cầu xóa dữ liệu',
        attachment_released_on: 'Tiêu hủy ngày {date}',
        attachment_released_heading: 'Các tệp đã được tiêu hủy khi hết thời hạn lưu trữ hoặc theo yêu cầu xóa dữ liệu',
        attachment_released_retention_stated: 'Tài liệu chứng minh đã được tiêu hủy khi hết thời hạn lưu trữ vào ngày {date}, là ngày do người giải phóng tệp nêu',
        attachment_release_installed_date: 'Ngày kết thúc thời hạn lưu trữ đã cài đặt',
        attachment_release_installed_date_hint: 'Ngày này lấy từ thời hạn lưu trữ đã cài đặt cho tài liệu chứng minh này, nên không nêu tại đây.',
        attachment_release_installed_floor_hint: 'Thời hạn lưu trữ đã cài đặt cho tài liệu chứng minh khác dẫn chiếu tệp này kết thúc vào ngày {date}; ngày được nêu không được trước ngày đó.',
        attachment_release_date_before_installed: 'Thời hạn lưu trữ đã cài đặt cho tài liệu chứng minh dẫn chiếu tệp này kết thúc vào ngày {date}; không thể nêu một ngày trước ngày đó.',
        attachment_release_in_progress: 'Tệp này đang được giải phóng bởi một yêu cầu khác, nên không được giải phóng hai lần.',
        // fix-sprint-20261026-0900 F10 — the 502 the release returns when the stored object cannot be deleted.
        attachment_release_storage_delete_failed: 'Không thể tiêu hủy tệp đã lưu trữ, nên tệp chưa được giải phóng. Hãy gửi lại yêu cầu giải phóng để thử lại.',
        attachment_release_not_computable: 'Đã cài đặt thời hạn lưu trữ cho tài liệu chứng minh này nhưng không tính được ngày kết thúc, nên tệp không được giải phóng.',
        attachment_release_erasure_hint: 'Chỉ liệt kê các yêu cầu xóa dữ liệu về người mà tài liệu chứng minh này liên quan: đã được quyết định thực hiện, không bị từ chối, rút lại hoặc đóng mà chưa được thực hiện, và đã xác minh danh tính người yêu cầu.',
        attachment_release_erasure_subject_not_named: 'Sổ đăng ký chứa tài liệu chứng minh này không ghi nhận người mà tài liệu liên quan, nên không thể giải phóng tệp theo yêu cầu xóa dữ liệu.',
        attachment_release_erasure_subject_not_linked: 'Mục chứa tài liệu chứng minh này chưa được liên kết với hồ sơ chủ thể dữ liệu, nên không thể giải phóng tệp theo yêu cầu xóa dữ liệu.',
        attachment_release_erasure_different_subjects: 'Tệp này là tài liệu chứng minh cho các mục về những người khác nhau, nên không thể giải phóng theo một yêu cầu xóa dữ liệu.',
        attachment_release_erasure_other_subject: 'Yêu cầu xóa dữ liệu đó liên quan đến một người khác với người mà tài liệu chứng minh này liên quan.',
        attachment_release_erasure_not_actionable: 'Yêu cầu xóa dữ liệu đó đã bị từ chối, rút lại hoặc đóng mà chưa được thực hiện, hoặc danh tính người yêu cầu chưa được xác minh.',
        attachment_release_erasure_not_decided: 'Yêu cầu xóa dữ liệu đó chưa được quyết định thực hiện, nên chưa áp dụng cho tài liệu chứng minh này. Hãy giải phóng tệp khi việc xóa đã được quyết định.',
        attachment_release_erasure_read_required: 'Để nêu một yêu cầu quyền làm lý do giải phóng, cần quyền xem các yêu cầu quyền, mà bạn chưa có.',
        attachment_release_erasure_withheld: 'Bạn chưa có quyền xem các yêu cầu quyền, nên không thể liệt kê hoặc nêu yêu cầu xóa dữ liệu nào tại đây. Người có quyền này có thể giải phóng tệp theo yêu cầu xóa dữ liệu.',
        attachment_release_preview_load_error: 'Không thể đọc các thông tin mà việc giải phóng tệp này dựa vào.',
    },
    common_statuses: {
        removed: 'Đã xóa',
        draft: 'Nháp',
        active: 'Hoạt động',
        inactive: 'Không hoạt động',
        pending: 'Chờ xử lý',
        in_progress: 'Đang thực hiện',
        completed: 'Hoàn thành',
        archived: 'Đã lưu trữ',
        published: 'Đã xuất bản',
        approved: 'Đã duyệt',
        rejected: 'Từ chối',
        cancelled: 'Đã hủy',
        blocked: 'Bị chặn',
        deferred: 'Đã hoãn',
        not_started: 'Chưa bắt đầu',
        dismissed: 'Đã bỏ qua',
        failed: 'Thất bại',
        in_review: 'Đang xem xét',
        deprecated: 'Ngừng sử dụng',
        scheduled: 'Đã lên lịch',
        deploying: 'Đang triển khai',
        deployed: 'Đã triển khai',
        paused: 'Tạm dừng',
        rolled_back: 'Đã hoàn tác',
        received: 'Đã nhận',
        processing: 'Đang xử lý',
        under_assessment: 'Đang đánh giá',
        implemented: 'Đã thực hiện',
        pending_approval: 'Chờ phê duyệt',
        pending_deletion: 'Chờ xóa',
        on_hold: 'Tạm giữ',
        deleted: 'Đã xóa',
        expired: 'Đã hết hạn',
        outdated: 'Lỗi thời',
        drifted: 'Đã lệch',
        decommissioned: 'Đã ngừng hoạt động',
        match: 'Khớp',
        different: 'Khác',
        missing: 'Thiếu',
        confirmed: 'Đã xác nhận',
        revoked: 'Đã thu hồi',
        escalated: 'Đã chuyển cấp',
        system: 'Hệ thống',
        custom: 'Tùy chỉnh',
        warning: 'Cảnh báo',
        blocking: 'Chặn',
        analyst: 'Phân tích viên',
        viewer: 'Người xem',
        daily: 'Hàng ngày',
        weekly: 'Hàng tuần',
        policies: 'Chính sách',
        denied: 'Từ chối',
        verified: 'Đã xác minh',
        detected: 'Đã phát hiện',
        ignored: 'Đã bỏ qua',
        open: 'Mở',
        resolved: 'Đã giải quyết',
        suspended: 'Tạm ngừng',
        retired: 'Đã ngừng',
        review: 'Đang xem xét',
        generated: 'Đã tạo',
        exported: 'Đã xuất',
        // Sprint 63.37.0 (Stream J) — the embedded form statuses a page prints.
        finalized: 'Đã chốt',
        superseded: 'Đã thay thế',
    },
    severity: {
        low: 'Thấp',
        medium: 'Trung bình',
        high: 'Cao',
        critical: 'Nghiêm trọng',
    },
    sensitivity: {
        standard: 'Tiêu chuẩn',
        sensitive: 'Nhạy cảm',
        special_category: 'Danh mục đặc biệt',
        // fix-sprint-20260410-0410 F7 — moved from consent.policies
        badge_sensitive: 'Nhạy cảm',
    },
    change_types: {
        policy_update: 'Cập nhật chính sách',
        new_binding: 'Ràng buộc mới',
        remove_binding: 'Xóa ràng buộc',
        configuration_change: 'Thấy đổi cấu hình',
        banner_update: 'Cập nhật banner',
    },
    comparison_types: {
        full: 'Đầy đủ',
        banner_only: 'Chỉ banner',
        purposes_only: 'Chỉ mục đích',
        legal_bases_only: 'Chỉ cơ sở pháp lý',
        consent_settings: 'Cài đặt đồng ý',
    },
    lifecycle_stages: {
        active: 'Hoạt động',
        archived: 'Đã lưu trữ',
        pending_deletion: 'Chờ xóa',
        deleted: 'Đã xóa',
        on_hold: 'Tạm giữ',
        creation: 'Tạo',
        exception_hold: 'Tạm giữ',
    },
    object_types: {
        personal_data: 'Dữ liệu cá nhân',
        consent_record: 'Bản ghi đồng ý',
        user_account: 'Tài khoản người dùng',
        audit_log: 'Nhật ký kiểm toán',
        document: 'Tài liệu',
        backup: 'Sao lưu',
    },
    risk_categories: {
        data_breach: 'Vi phạm dữ liệu',
        unauthorized_access: 'Truy cập trái phép',
        data_loss: 'Mất dữ liệu',
        regulatory_non_compliance: 'Không tuân thủ quy định',
        third_party_risk: 'Rủi ro bên thứ ba',
        operational: 'Vận hành',
        technical: 'Kỹ thuật',
        legal: 'Pháp lý',
    },
    mitigation_types: {
        technical: 'Kỹ thuật',
        organizational: 'Tổ chức',
        contractual: 'Hợp đồng',
        procedural: 'Thủ tục',
    },
    safeguard_types: {
        encryption_in_transit: 'Mã hóa khi truyền',
        encryption_at_rest: 'Mã hóa khi lưu trữ',
        access_controls: 'Kiểm soát truy cập',
        contractual_clauses: 'Điều khoản hợp đồng',
        data_minimization: 'Tối thiểu hóa dữ liệu',
        pseudonymization: 'Giả danh hóa',
        audit_rights: 'Quyền kiểm toán',
        breach_notification: 'Thông báo vi phạm',
        data_localization: 'Bản địa hóa dữ liệu',
        other: 'Khác',
    },
    scoring_methods: {
        weighted_average: 'Trung bình có trọng',
        simple_average: 'Trung bình đơn giản',
        maximum: 'Tối đa',
        manual: 'Thủ công',
    },
    dpa_status: {
        not_required: 'Không yêu cầu',
        required: 'Yêu cầu',
        in_progress: 'Đang thực hiện',
        completed: 'Hoàn thành',
        signed: 'Đã ký',
    },
    disposal_methods: {
        anonymize: 'Ẩn danh hóa',
        pseudonymize: 'Giả danh hóa',
        aggregate: 'Tổng hợp',
        delete: 'Xóa',
    },
    dashboard: {
        workspace: {
            tabs_label: 'Các phần của bảng điều khiển',
            overview_heading: 'Tình trạng tuân thủ của tổ chức',
            overview_description: 'Điểm số, khuyến nghị, mức bao phủ và tình hình vận hành.',
            tasks_heading: 'Thực hiện các công việc ưu tiên',
            tasks_description: 'Người phụ trách, công việc quá hạn, nhiệm vụ sắp tới và tiến độ của phòng ban.',
            insights_heading: 'Bức tranh tuân thủ toàn diện',
            insights_description: 'Hồ sơ nộp, rủi ro bên thứ ba, đánh giá tác động, sự cố và hoạt động quản lý tuân thủ.',
            visible_widgets: 'Đang hiển thị {count} tiện ích',
            widgets_view: 'Tiện ích',
            config_description: 'Chọn tiện ích cần hiển thị và thứ tự của chúng. Các thay đổi được lưu khi bạn áp dụng.',
            search_widgets: 'Tìm tiện ích',
            search_widgets_placeholder: 'Tìm kiếm tiện ích',
            density: 'Khoảng cách giữa các tiện ích',
            density_comfortable: 'Thoáng',
            density_compact: 'Gọn',
            default_tab: 'Mở bảng điều khiển tại',
            apply_configuration: 'Áp dụng cấu hình',
            cancel_configuration: 'Hủy',
            move_up: 'Di chuyển {widget} lên',
            move_down: 'Di chuyển {widget} xuống',
            enabled_count: 'Đã bật {enabled} trong tổng số {total} mục',
            empty_section: 'Không có tiện ích nào được hiển thị trong phần này. Dùng Cấu hình Trang tổng quan để chọn các tiện ích hiện có.',
        },
        title: 'Tổng quan',
        /* Sprint 43.5.0 E1 — hero-tile metrics */
        consent_coverage: 'Tỷ lệ chấp thuận đồng ý',
        ctia_filings: 'Hồ sơ CTIA',
        next_dpia_review: 'Rà soát DPIA tiếp theo',
        next_review_none: 'Chưa lên lịch',
        /*
         * Sprint 65.4.0 (AC5) — why the next-review tile has four states.
         *
         * A blank date reads as "nothing due soon". Measured, it almost always
         * meant something else: the only production writer of
         * `grc_dpia_records.next_review_at` was the demo seed, so every real
         * tenant saw the same dash. The tile now says which absence it is.
         */
        next_review_no_dpias: 'Chưa có hồ sơ đánh giá tác động',
        next_review_cadence_absent: 'Chưa khai báo chu kỳ rà soát',
        next_review_not_scheduled: 'Chưa lên lịch rà soát',
        incident_mps_filings: 'Hồ sơ MPS sự cố',
        no_data: 'Không có dữ liệu tổng quan.',
        no_data_heading: 'Chưa có dữ liệu trực tuyến',
        no_data_detail: 'Không thể tải số liệu trực tuyến. Bố cục vẫn được hiển thị; các giá trị sẽ xuất hiện khi kết nối được khôi phục.',
        compliance_score: 'Điểm tuân thủ',
        grade: 'Xếp hạng',
        no_score: 'Chưa tính điểm tuân thủ.',
        rights_requests: 'Yêu cầu quyền',
        open: 'Mở',
        sla_breached: 'Vi phạm SLA',
        sla_approaching: 'Sắp đến hạn SLA',
        closed_month: 'Đóng (tháng)',
        incidents: 'Sự cố & Vi phạm',
        active: 'Đang hoạt động',
        breaches: 'Vi phạm',
        overdue_tasks: 'Quá hạn',
        breach_72h_notice: 'Thời hạn thông báo quy định 72 giờ áp dụng cho các vi phạm đang hoạt động',
        recommendations: 'Khuyến nghị',
        take_action: 'Thực hiện',
        drift_events: 'Lệch chuẩn & Phê duyệt',
        open_events: 'Sự kiện đang mở',
        pending_approvals: 'Chờ phê duyệt',
        monitoring: 'Nhiệm vụ giám sát',
        programs: 'Chương trình',
        overdue: 'Quá hạn',
        pending: 'Chờ xử lý',
        ric_cases: 'Vụ kiện RIC',
        coverage: 'Độ bao phủ dữ liệu',
        systems: 'Hệ thống',
        activities: 'Hoạt động',
        vendors: 'Nhà cung cấp',
        dpias: 'DPIAs',
        open_gaps: 'lỗ hổng mở',
        view_as_table: 'Xem dạng bảng',
        view_as_chart: 'Xem dạng biểu đồ',
        table_metric_header: 'Chỉ số',
        table_value_header: 'Giá trị',
        announce_chart_view: 'Hiển thị dạng biểu đồ',
        announce_table_view: 'Hiển thị dạng bảng dữ liệu',
        section_core_metrics: 'Chỉ số Chính',
        section_task_management: 'Quản lý Nhiệm vụ',
        section_compliance_insights: 'Thông tin Tuân thủ',
        configure_dashboard: 'Cấu hình Trang tổng quan',
        config_col_active: 'Hoạt động',
        config_col_widget: 'Tiện ích',
        collapse_section: 'Thử gọn',
        expand_section: 'Mở rộng',
        reset_to_defaults: 'Đặt lại mặc định',
        preferences_saved: 'Đã lưu tùy chỉnh bảng điều khiển',
        preferences_reset: 'Bảng điều khiển đã đặt lại theo vai trò',
        preferences_load_error: 'Không thể tải tùy chỉnh bảng điều khiển',
        preferences_save_error: 'Không thể lưu tùy chỉnh bảng điều khiển.',
        factor_avg_system_score: 'Điểm trung bình hệ thống',
        factor_avg_vendor_score: 'Điểm trung bình nhà cung cấp',
        factor_processing_coverage: 'Độ bao phủ hoạt động xử lý',
        factor_ropa_completeness: 'Mức hoàn thiện RoPA',
        factor_drift_penalty: 'Trừ điểm sự kiện lệch chuẩn',
        rec_improve_system_gov: 'Cải thiện tài liệu quản trị hệ thống',
        rec_improve_vendor_gov: 'Cải thiện tài liệu quản trị nhà cung cấp',
        rec_document_processing: 'Lập tài liệu hoạt động xử lý cho các hệ thống chưa được bao phủ',
        rec_generate_ropa: 'Tạo hồ sơ RoPA cho các hoạt động xử lý đang hoạt động',
        rec_resolve_drift: 'Giải quyết các sự kiện lệch chuẩn nghiêm trọng và cao đang mở',
        score_good: 'Tốt',
        score_fair: 'Khá',
        score_poor: 'Kém',
        score_critical: 'Nghiêm trọng',
        drag_to_reorder: 'Kéo để sắp xếp lại',
        widget_moved: 'Đã di chuyển widget',
        press_space_to_grab: 'Nhấn Space để chọn, phím mũi tên để di chuyển, Space để thả',
        reorder_instructions: 'Sử dụng kéo thả hoặc phím tắt để sắp xếp lại các widget',
        page_title: 'Bảng điều khiển tuân thủ',
        welcome_back: 'Chào mừng trở lại, {name}',
        subtitle: 'Góc nhìn theo thời gian thực về tình trạng tuân thủ, rủi ro và tiến độ trên toàn tổ chức của bạn.',
        section_overview: 'Tổng quan',
        kpi_strip_label: 'Dải chỉ số KPI tổng quan',
        today_label: 'Hôm nay',
        avatar_aria: 'Đã đăng nhập với tên {name}',
        no_prior_period: 'Chưa có kỳ trước',
        period_current: 'Kỳ hiện tại',
        gauge_aria: '{score} trên 100, {label}',
        donut_aria: '{total} nhà cung cấp theo mức độ rủi ro',
        bar_aria: '{label}: {value} phần trăm',
        config_saving: 'Đang lưu…',
        task_widgets: {
            tasks_overview: 'Tổng quan Nhiệm vụ',
            pending: 'Chờ xử lý',
            in_progress: 'Đang thực hiện',
            overdue: 'Quá hạn',
            done_7d: 'Hoàn thành (7 ngày)',
            by_priority: 'Theo Mức ưu tiên',
            view_all_tasks: 'Xem Tất cả Nhiệm vụ',
            upcoming_tasks: 'Nhiệm vụ Sắp tới (7 Ngày)',
            no_upcoming: 'Không có nhiệm vụ đến hạn trong 7 ngày tới.',
            view_calendar: 'Xem Lịch',
            overdue_alerts: 'Quá hạn',
            no_overdue: 'Không có nhiệm vụ quá hạn. Mọi thứ đang đúng tiến độ.',
            assigned_to: 'Được giao cho',
            unassigned_actor: 'Chưa phân công',
            untitled_task: 'Công việc chưa có tiêu đề',
            view_all_overdue: 'Xem Tất cả Quá hạn',
            notifications: 'Thông báo Gần đây',
            unread: 'chưa đọc',
            no_notifications: 'Không có thông báo. Bạn đã cập nhật tất cả!',
            view_all_notifications: 'Xem Tất cả Thông báo',
            load_error: 'Không thể tải dữ liệu.',
            day_late: 'ngày trễ hạn',
            days_late_plural: 'ngày trễ hạn',
            due_today: 'Đến hạn hôm nay',
            just_now: 'vừa xong',
            minutes_short: ' phút',
            hours_short: ' giờ',
            days_short: ' ngày',
            cross_org_stats: 'Thống kê Liên tổ chức',
            by_organization: 'Theo Tổ chức',
            overdue_across_orgs: 'nhiệm vụ quá hạn trên các tổ chức',
            overdue_count_label: '{count} nhiệm vụ quá hạn',
            total: 'Tổng',
            tasks: 'nhiệm vụ',
            organization: 'Tổ chức',
            current_org: 'Tổ chức Hiện tại',
            all_orgs: 'Tất cả tổ chức',
            all_organizations: 'Tất cả Tổ chức',
            filter_by_org: 'Lọc theo tổ chức',
            cross_org: 'Liên tổ chức',
            empty_calendar: 'Không có nhiệm vụ cho giai đoạn này. Tạo nhiệm vụ đầu tiên hoặc kiểm tra bộ lọc.',
            empty_my_tasks: 'Bạn không có nhiệm vụ nào được giao. Tuyệt vời!',
            empty_overdue: 'Không có nhiệm vụ quá hạn. Mọi thứ đang đúng tiến độ.',
            empty_notifications: 'Không có thông báo. Bạn đã cập nhật tất cả!',
            empty_workflows: 'Chưa cấu hình quy trình. Duyệt mẫu để bắt đầu.',
            remediation_pipeline: 'Nhiệm vụ & Quy trình khắc phục',
            no_open_tasks: 'Không có nhiệm vụ đang mở — không còn việc tồn đọng trong quy trình khắc phục.',
            open_tasks: 'Nhiệm vụ đang mở',
        },
        my_tasks_widget: {
            title: 'Nhiệm vụ của tôi',
            no_tasks: 'Không có nhiệm vụ nào được giao cho bạn.',
            load_error: 'Không thể tải nhiệm vụ.',
            overdue: 'quá hạn',
            remaining: 'còn lại',
            view_all: 'Xem Tất cả Nhiệm vụ',
        },
        my_section_status_widget: {
            title: 'Trạng thái Mục của tôi',
            overall_completion: 'Tổng thể',
            sections_count: 'Mục',
            no_sections: 'Không có mục nào được giao cho phòng ban của bạn.',
            load_error: 'Không thể tải trạng thái mục.',
            department_tasks_title: 'Nhiệm vụ của phòng ban',
            no_department_tasks: 'Phòng ban của bạn chưa có nhiệm vụ nào.',
            department_tasks_error: 'Không thể tải nhiệm vụ của phòng ban.',
            no_department: 'Bạn chưa được gán vào phòng ban nào.',
        },
        revision_requests_widget: {
            title: 'Yêu cầu Chỉnh sửa',
            no_revisions: 'Không có yêu cầu chỉnh sửa. Tất cả các mục đang đúng tiến độ.',
            load_error: 'Không thể tải yêu cầu chỉnh sửa.',
        },
        // Sprint 43.5.6 Epic B — widget tầng Light mới.
        consent_summary: {
            title: 'Đồng ý',
            active: 'Hiệu lực',
            withdrawn_30d: 'Đã rút (30 ngày)',
            expiring_7d: 'Sắp hết hạn (7 ngày)',
        },
        transfer_assessments: {
            title: 'Đánh giá Chuyển giao Dữ liệu',
            open: 'Đang mở',
            approved: 'Đã phê duyệt',
            gaps_flagged: 'Gắn cờ thiếu sót',
        },
        breach_notifications: {
            title: 'Thông báo Vi phạm',
            deadline_72h: 'Thời hạn 72h',
            submitted: 'Đã gửi',
            pending: 'Chờ xử lý',
        },
        authority_requests: {
            title: 'Yêu cầu từ Cơ quan Chức năng',
            pending: 'Chờ phản hồi',
            overdue: 'Quá hạn',
            responded_30d: 'Đã phản hồi (30 ngày)',
        },
        data_subjects_widget: {
            title: 'Chủ thể Dữ liệu',
            total: 'Tổng số',
            high_risk: 'Rủi ro cao',
            active_30d: 'Hoạt động (30 ngày)',
        },
        // Sprint 45.1.0 — AUDIT_TRAIL + ONBOARDING Light-tier widgets.
        audit_activity_summary: {
            title: 'Hoạt động Kiểm toán',
            events_today: 'Sự kiện hôm nay',
            events_7d: 'Sự kiện (7 ngày)',
            unique_actors_30d: 'Người thao tác (30 ngày)',
        },
        onboarding_progress: {
            title: 'Tiến độ Khởi tạo',
            completion_pct: 'Hoàn thành',
            status_label: 'Trạng thái',
            current_step: 'Bước hiện tại',
            status: {
                in_progress: 'Đang thực hiện',
                completed: 'Đã hoàn thành',
                skipped: 'Đã bỏ qua',
                not_started: 'Chưa bắt đầu',
            },
        },
        sector_overlay_reports_due: {
            title: 'Báo cáo theo lớp phủ ngành sắp đến hạn',
        },
        kpi: {
            framework_coverage: 'Độ bao phủ khung tuân thủ',
            open_actions: 'Hành động đang mở',
            high_priority: '{count} ưu tiên cao',
            vendor_health: 'Tình trạng nhà cung cấp',
            at_risk: '{count} có rủi ro',
            open_count: '{count} đang mở',
            active_count: '{count} đang hoạt động',
            grade_label: 'Xếp hạng: {grade}',
            consent_coverage_hint: 'tỷ lệ đồng ý, 30 ngày gần nhất',
            consent_coverage_source_web_consent_records: 'trên số bản ghi đồng ý trên web, 30 ngày gần nhất',
            consent_coverage_source_web_consent_events: 'trên số sự kiện đồng ý trên web, 30 ngày gần nhất',
            consent_coverage_source_consent_records: 'trên số bản ghi đồng ý, 30 ngày gần nhất',
            of_installed_frameworks: 'của khung tuân thủ đã cài đặt',
            no_frameworks_installed: 'Chưa cài khung tuân thủ bắt buộc',
            unavailable: 'Không có dữ liệu',
            consent_no_records: 'Không có bản ghi đồng ý trong 30 ngày gần nhất',
            tile_hint: {
                no_score: 'Chưa tính điểm',
                load_error: 'Không tải được',
                no_frameworks_installed: 'Chưa cài khung tuân thủ bắt buộc',
                vendor_at_risk: '{at_risk}/{total} cao hoặc nghiêm trọng',
                vendor_load_error: 'Không đọc được',
                no_vendor_data: 'Không có dữ liệu',
                consent_no_records: 'Không có bản ghi trong 30 ngày',
                consent_source_web_consent_records: 'trên bản ghi đồng ý web',
                consent_source_web_consent_events: 'trên sự kiện đồng ý web',
                consent_source_consent_records: 'trên bản ghi đồng ý',
                not_reported: 'Không được báo cáo',
                delta_since: 'điểm so với {period}',
            },
        },
        summary_reloaded: 'Đã tải lại bảng điều khiển.',
        scope_incidents: 'Các sự cố còn mở. Vi phạm là nhóm nhỏ được đánh dấu là vi phạm dữ liệu cá nhân.',
        scope_breach_response: 'Cùng nhóm vi phạm còn mở, theo trạng thái thông báo và khắc phục.',
        scope_breach_notifications: 'Các hồ sơ thông báo. Đến hạn trong 72 giờ đếm những hồ sơ có hạn nộp trong 72 giờ tới; đã nộp và đang chờ đếm mọi hồ sơ ở trạng thái đó, không xét hạn nộp.',
        vendor_health_hint: '{at_risk} trên {total} nhà cung cấp ở mức rủi ro cao hoặc nghiêm trọng',
        vendor_health_load_error: 'Không đọc được dữ liệu nhà cung cấp.',
        figure_not_reported: 'Số liệu này không được báo cáo trong lần đọc bảng điều khiển gần nhất.',
        framework_coverage: {
            title: 'Độ bao phủ khung tuân thủ',
            overall: 'Độ bao phủ tổng thể',
            none: 'Các khung tuân thủ đã cài đặt chưa khai báo yêu cầu nào.',
            none_installed: 'Chưa cài khung tuân thủ bắt buộc. Khung tuân thủ chỉ cài đặt để tham khảo, hoặc ở trạng thái Bản nháp hay Cũ, không được tính ở đây.',
            requirements_mapped: 'Đã ánh xạ {mapped} trong {total} yêu cầu',
            no_requirements: 'Chưa khai báo yêu cầu',
            overall_denominator: 'trên {count} khung tuân thủ có khai báo yêu cầu',
            no_requirements_count: '{count} khung tuân thủ đã cài đặt chưa khai báo yêu cầu nào',
            no_requirements_count_one: '1 khung tuân thủ đã cài đặt chưa khai báo yêu cầu nào',
            showing_lowest: 'Đang hiển thị {shown} khung tuân thủ có mức bao phủ thấp nhất trong {total}',
            gaps: '{count} lỗ hổng mở',
            view_all: 'Xem khung tuân thủ',
            load_error: 'Không thể tải độ bao phủ khung tuân thủ.',
        },
        automation_impact: {
            title: 'Tác động của tự động hóa',
            scope: 'Các biện pháp kiểm soát mà khung tuân thủ đã cài đặt khai báo là áp dụng cho tổ chức này, và số biện pháp kiểm soát đã được ghi nhận có công việc tự động.',
            load_error: 'Không thể tải tác động của tự động hóa.',
            no_frameworks_installed: 'Không có khung tuân thủ đã cài đặt nào mà tổ chức này phải tuân thủ',
            not_declared: 'Chưa có khung tuân thủ đã cài đặt nào nêu rõ biện pháp kiểm soát nào của khung áp dụng cho tổ chức này',
            profile_incomplete: 'Hãy khai báo hồ sơ tổ chức để xem biện pháp kiểm soát nào được áp dụng',
            none_applicable: 'Không có biện pháp kiểm soát đã khai báo nào áp dụng cho tổ chức này',
            no_emitter: 'Chưa đo lường — chưa có tác vụ tự động nào được đăng ký là thực hiện một biện pháp kiểm soát được khai báo',
            no_point: 'Chưa có tháng đã kết thúc nào có số liệu để hiển thị',
            figure_hint: '{automated} trên {applicable} biện pháp kiểm soát áp dụng đã được tự động hóa trong {period}',
            figure_hint_one: '{automated} trên 1 biện pháp kiểm soát áp dụng đã được tự động hóa trong {period}',
            delta_since: 'điểm phần trăm so với {period}',
            bucket_applicable: 'Áp dụng',
            bucket_out_of_scope: 'Được khai báo là không áp dụng cho tổ chức',
            bucket_not_declared: 'Chưa khai báo phạm vi áp dụng',
            bucket_profile_incomplete: 'Chờ khai báo hồ sơ tổ chức',
            applicable_from: 'Các biện pháp kiểm soát áp dụng thuộc {count} khung tuân thủ đã cài đặt',
            applicable_from_one: 'Các biện pháp kiểm soát áp dụng thuộc 1 khung tuân thủ đã cài đặt',
            review_profile: 'Xem lại hồ sơ tổ chức',
            /** Sprint 63.13.0 (live read D1) — the tile's visible hint; see en.ts. */
            tile_hint: {
                load_error: 'Không tải được',
                no_frameworks_installed: 'Chưa cài khung tuân thủ bắt buộc',
                not_declared: 'Chưa khai báo phạm vi áp dụng',
                profile_incomplete: 'Chờ khai báo hồ sơ tổ chức',
                none_applicable: 'Được khai báo là không áp dụng',
                no_emitter: 'Chưa đo lường',
                no_point: 'Chưa có tháng nào để hiển thị',
                figure: 'Tháng {period}: {automated}/{applicable}',
                figure_one: 'Tháng {period}: {automated}/1',
            },
        },
        recommendations_widget: {
            title: 'Khuyến nghị chính',
            view_all: 'Xem tất cả ({count})',
            priority_high: 'Cao',
            priority_medium: 'Trung bình',
            priority_low: 'Thấp',
            none: 'Không có khuyến nghị. Mọi yếu tố điểm đều nằm trong ngưỡng lành mạnh.',
        },
        rights_status: {
            title: 'Yêu cầu quyền',
            open_requests: 'Số yêu cầu đang mở',
        },
        module_status: {
            title: 'Trạng thái phân hệ',
            enabled: 'Đã bật',
            modules_count: '{count} phân hệ',
            modules_count_one: '{count} phân hệ',
            none: 'Chưa có phân hệ nào được bật cho tổ chức này.',
        },
        recent_activity: {
            title: 'Hoạt động gần đây',
            view_all: 'Xem tất cả',
            empty: 'Không có hoạt động gần đây.',
            load_error: 'Không thể tải hoạt động gần đây.',
        },
        persona_widgets: {
            framework_filter: 'Lọc theo Khung tuân thủ',
            all_frameworks: 'Tất cả Khung tuân thủ',
            filing_lifecycle: 'Vòng đời Hồ sơ',
            filing_pipeline: 'Quy trình Hồ sơ',
            draft: 'Nháp',
            internal_review: 'Xem xét Nội bộ',
            approved: 'Đã Phê duyệt',
            submitted: 'Đã Nộp',
            supplement_requested: 'Yêu cầu Bổ sung',
            resubmitted: 'Đã Nộp lại',
            accepted: 'Đã Chấp nhận',
            rejected: 'Đã Từ chối',
            closed: 'Đã Đóng',
            deadline: 'Hạn chót',
            days_remaining: 'ngày còn lại',
            days_overdue: 'ngày quá hạn',
            no_filings: 'Không có hồ sơ đang hoạt động.',
            department_consolidation: 'Tổng hợp Phòng ban',
            departments_completed: 'Phòng ban Hoàn thành',
            departments_pending: 'Phòng ban Chờ xử lý',
            departments_overdue: 'Phòng ban Quá hạn',
            no_consolidation_cases: 'Không có vụ việc đa phòng ban nào đang xử lý.',
            vendor_risk: 'Rủi ro Nhà cung cấp & Bên thứ ba',
            pending_assessment: 'Chờ Đánh giá',
            overdue_questionnaires: 'Bảng câu hỏi Quá hạn',
            dpa_review_queue: 'Hàng đợi Xem xét DPA',
            risk_distribution: 'Phân bổ Rủi ro',
            total_vendors: 'Tổng số Nhà cung cấp',
            by_risk_level: 'Theo Mức độ Rủi ro',
            no_vendor_data: 'Không có dữ liệu rủi ro nhà cung cấp.',
            discovery_summary: 'Khám phá Dữ liệu',
            discovery_classification: 'Khám phá & Phân loại Dữ liệu',
            active_scans: 'Quét Đang hoạt động',
            labels_pending: 'Nhãn Chờ xem xét',
            exceptions_unresolved: 'Ngoại lệ Chưa giải quyết',
            pending_review: 'Chờ Xem xét',
            exceptions: 'Ngoại lệ',
            approved_labels: 'Nhãn đã Phê duyệt',
            total_classified: 'Tổng đã Phân loại',
            no_discovery_data: 'Không có dữ liệu khám phá.',
            ai_governance: 'Quản trị Hệ thống AI',
            systems_inventory: 'Hệ thống trong Kho',
            systems_in_inventory: 'Hệ thống trong Kho',
            classification_breakdown: 'Phân loại Chi tiết',
            dossier_completion: 'Hoàn thành Hồ sơ',
            by_classification: 'Theo Phân loại',
            labeling_status: 'Trạng thái Gán nhãn',
            not_started: 'Chưa bắt đầu',
            no_ai_data: 'Không có dữ liệu quản trị AI.',
            obligations_complete: 'Nghĩa vụ đã hoàn thành',
            obligations_complete_of: '{complete}/{applicable} nghĩa vụ áp dụng',
            no_obligations_apply: 'Chưa ghi nhận nghĩa vụ áp dụng nào',
            ai_register_restricted: 'Vai trò của bạn không có quyền xem sổ đăng ký hệ thống AI.',
            breach_response: 'Xử lý Vi phạm & Sự cố',
            active_breaches: 'Vi phạm Đang hoạt động',
            notification_status: 'Trạng thái Thông báo',
            remediation_progress: 'Tiến độ Khắc phục',
            supplement_loops: 'Vòng Bổ sung',
            no_breach_data: 'Không có vụ vi phạm nào đang hoạt động.',
            audit_readiness: 'Sẵn sàng Kiểm toán & Đánh giá',
            assessments: 'Đánh giá',
            gap_findings: 'Phát hiện Khoảng trống',
            evidence_completion: 'Hoàn thành Bằng chứng',
            export_ready: 'Sẵn sàng Xuất',
            export_ready_yes: 'Sẵn sàng',
            export_ready_no: 'Chưa sẵn sàng',
            unspecified_framework_group: 'Chưa ghi nhận khung tuân thủ',
            not_ready: 'Chưa Sẵn sàng',
            no_audit_data: 'Không có dữ liệu sẵn sàng kiểm toán.',
            framework_label_vn_pdpl: 'VN PDPL 2025',
            framework_label_vn_cybersecurity: 'VN An ninh mạng 2018',
            framework_label_vn_ecommerce: 'VN Thương mại điện tử 2023',
            framework_label_vn_telecom: 'VN Viễn thông 2023',
            framework_label_vn_ai: 'VN Luật AI 2025',
            framework_label_gdpr: 'GDPR',
            framework_label_unspecified: 'Chưa xác định',
            my_department: 'Phòng ban của Tôi',
            my_tasks: 'Nhiệm vụ của Tôi',
            section_status: 'Trạng thái Phần',
            revision_requests: 'Yêu cầu Sửa đổi',
            completion: 'Hoàn thành',
            reason: 'Lý do',
            requested_at: 'Yêu cầu lúc',
            no_tasks_assigned: 'Không có nhiệm vụ nào được giao cho bạn.',
            no_sections: 'Không có phần nào được giao cho phòng ban của bạn.',
            no_revisions: 'Không có yêu cầu sửa đổi.',
            load_error: 'Tải dữ liệu thất bại.',
            vendor_health_needs_attention: '{count} nhà cung cấp cần được xử lý ngay',
            review_vendors: 'Xem xét nhà cung cấp',
            total_vendors_label: 'Tổng số Nhà cung cấp',
        },
    },
    connectors: {
        nav: {
            instances: 'Phiên bản',
            credentials: 'Kho xác thực',
            event_bus: 'Bus sự kiện',
            definitions: 'Định nghĩa',
            brds: 'Thu thập BRD',
            security_reviews: 'Đánh giá bảo mật',
            poc_scorecards: 'Thẻ điểm POC',
            automation_planning: 'Lập kế hoạch tự động hóa',
            system_inventory: 'Kho hệ thống',
            traceability_matrix: 'Ma trận truy xuất',
            gap_register: 'Sổ đăng ký khoảng trống',
        },
        instances: {
            title: 'Phiên bản kết nối',
            page_title: 'Trình kết nối',
            add: 'Thêm phiên bản',
            test: 'Kiểm tra kết nối',
            sync_now: 'Đồng bộ ngày',
            new_instance: 'Phiên bản kết nối mới',
            no_instances: 'Không tìm thấy phiên bản kết nối',
            instance_count: '{count} phiên bản',
            confirm_delete: 'Xóa phiên bản kết nối "{name}"?',
            all_connector_types: 'Tất cả loại kết nối',
            select_connector: 'Chọn một kết nối...',
            fetch_error: 'Không thể tải danh sách phiên bản kết nối. Vui lòng thử lại.',
            fetch_definitions_error: 'Không thể tải danh sách định nghĩa kết nối. Vui lòng thử lại.',
            create_error: 'Không thể tạo phiên bản kết nối',
            test_error: 'Không thể kiểm tra kết nối. Vui lòng thử lại.',
            status_error: 'Không thể cập nhật trạng thái kết nối. Vui lòng thử lại.',
            delete_error: 'Không thể xóa phiên bản kết nối. Vui lòng thử lại.',
            confirm_disable: 'Vô hiệu hóa "{name}"? Việc đồng bộ sẽ dừng cho đến khi kết nối được kích hoạt lại.',
            credentials_label: 'Thông tin xác thực',
            instance_created: 'Đã tạo kết nối',
            base_url_label: 'URL gốc',
            base_url_hint: 'Địa chỉ https của điểm cuối kết nối này. Thao tác Kiểm tra gửi yêu cầu kiểm tra tình trạng mà loại kết nối khai báo tới một đường dẫn trên địa chỉ này.',
            base_url_invalid: 'Nhập một địa chỉ https, ví dụ https://api.example.com.',
            edit_instance: 'Chỉnh sửa phiên bản kết nối',
            edit_instance_action: 'Chỉnh sửa',
            instance_updated: 'Đã cập nhật phiên bản kết nối',
            update_error: 'Không thể cập nhật phiên bản kết nối.',
            no_credentials_hint: 'Chưa có thông tin xác thực nào. Hãy tạo một mục trong Kho thông tin xác thực trước.',
            test_passed: 'Kiểm tra đạt',
            test_failed: 'Kiểm tra không thành công',
            status_changed: 'Đã cập nhật trạng thái',
            reactivate: 'Kích hoạt lại',
            mark_ready_for_testing: 'Đánh dấu sẵn sàng kiểm thử',
            marked_ready: 'Đã đánh dấu sẵn sàng kiểm thử. Không có kiểm tra kết nối nào được thực hiện: loại trình kết nối này không khai báo kiểm tra tình trạng.',
            test_healthy: 'Kiểm tra tình trạng đạt ({detail})',
            test_unhealthy: 'Kiểm tra tình trạng không đạt ({detail})',
            probe_detail_expected_status: 'điểm cuối trả về đúng mã trạng thái mong đợi',
            probe_detail_unexpected_status: 'điểm cuối trả về mã trạng thái khác với mã mong đợi',
            probe_detail_timeout: 'không có phản hồi trước thời hạn chờ',
            probe_detail_network_error: 'không thể kết nối tới điểm cuối',
            probe_detail_target_refused: 'địa chỉ của điểm cuối không được phép',
            record_sync: 'Ghi nhận kết quả đồng bộ',
            record_sync_title: 'Ghi nhận kết quả đồng bộ: {name}',
            record_sync_note: 'Ghi nhận kết quả của một lần đồng bộ đã chạy bên ngoài nền tảng. Nền tảng không tự chạy việc đồng bộ.',
            sync_outcome: 'Kết quả',
            sync_outcome_success: 'Thành công',
            sync_outcome_partial: 'Một phần',
            sync_outcome_failure: 'Thất bại',
            records_processed: 'Số bản ghi đã xử lý',
            records_created: 'Số bản ghi đã tạo',
            records_failed: 'Số bản ghi lỗi',
            sync_recorded: 'Đã ghi nhận kết quả đồng bộ.',
            sync_record_error: 'Không thể ghi nhận kết quả đồng bộ.',
            recording: 'Đang ghi nhận…',
            refusal_base_url_invalid: 'Không thể dùng URL gốc này: hãy nhập địa chỉ https của một điểm cuối mà nền tảng được phép gọi, ví dụ https://api.example.com. Không chấp nhận địa chỉ nội bộ hoặc cục bộ.',
            refusal_base_url_missing: 'Kết nối này chưa có URL gốc, nên không có nơi để gửi kiểm tra tình trạng. Hãy dùng Chỉnh sửa để thêm URL gốc, rồi kiểm tra lại.',
            refusal_base_url_missing_ask_admin: 'Kết nối này chưa có URL gốc, nên không có nơi để gửi kiểm tra tình trạng. Hãy đề nghị một quản trị viên có quyền chỉnh sửa kết nối thêm URL gốc, rồi kiểm tra lại.',
            refusal_base_url_invalid_ask_admin: 'Không thể dùng URL gốc của kết nối này: đó phải là địa chỉ https của một điểm cuối mà nền tảng được phép gọi, và không chấp nhận địa chỉ nội bộ hoặc cục bộ. Hãy đề nghị một quản trị viên có quyền chỉnh sửa kết nối sửa lại, rồi kiểm tra lại.',
        },
        credentials: {
            title: 'Kho xác thực',
            page_title: 'Thông tin xác thực trình kết nối',
            add: 'Thêm xác thực',
            rotate: 'Xoay vòng',
            expired: 'Đã hết hạn',
            expiring: 'Sắp hết hạn',
            orphaned: 'Mồ côi',
            new_credential: 'Xác thực mới',
            no_credentials: 'Không tìm thấy xác thực',
            no_expiry: 'Không hết hạn',
            linked_connectors: 'Kết nối liên kết',
            expires_at: 'Hết hạn lúc',
            value_label: 'Giá trị * (chỉ ghi)',
            confirm_delete_title: 'Xác nhận xóa',
            confirm_delete_message: 'Xóa thông tin xác thực này? Các kết nối liên kết sẽ mất quyền truy cập.',
            rotate_title: 'Xoay thông tin xác thực',
            new_credential_value: 'Giá trị thông tin xác thực mới',
            fetch_error: 'Không thể tải danh sách xác thực. Vui lòng thử lại.',
            health_error: 'Không thể tải tình trạng. Vui lòng thử lại.',
            create_error: 'Không thể tạo xác thực',
            rotate_error: 'Không thể xoay vòng xác thực',
            delete_error: 'Không thể xóa xác thực',
        },
        event_bus: {
            title: 'Bus sự kiện',
            page_title: 'Bus sự kiện',
            events: 'Sự kiện',
            subscriptions: 'Đăng ký',
            dlq: 'Hàng đợi lỗi',
            publish: 'Phát sự kiện',
            retry: 'Thử lại',
            dismiss: 'Bỏ qua',
            search_events: 'Tìm kiếm sự kiện...',
            filter_event_type: 'Lọc theo loại sự kiện...',
            event_type: 'Loại sự kiện',
            source_module: 'Phân hệ nguồn',
            timestamp: 'Thời gian',
            delivery_status: 'Trạng thái gửi',
            correlation_id: 'Mã tương quản',
            tracking_id: 'Mã theo dõi',
            delivery_status_hint: 'Trạng thái giao hàng được cập nhật tự động khi sự kiện được xử lý.',
            no_events: 'Không tìm thấy sự kiện',
            total_with_count: '{count} tổng cộng',
            prev: 'Trước',
            new_subscription: '+ Đăng ký mới',
            subscriber_type: 'Loại người đăng ký',
            subscriber_id: 'Mã người đăng ký',
            event_type_pattern: 'Mẫu loại sự kiện',
            event_type_pattern_placeholder: 'Ví dụ: incident.*',
            filter_expression: 'Biểu thức lọc',
            filter_expression_placeholder: 'Bộ lọc tùy chọn',
            subscriber_type_hint: 'Chọn cách giao sự kiện: webhook gửi yêu cầu HTTP, email gửi thông báo, hàng đợi chuyển đến hàng đợi tin nhắn.',
            subscriber_id_hint: 'Nhập đích cho sự kiện. Đối với webhook, dùng URL. Đối với email, dùng địa chỉ. Đối với hàng đợi, dùng tên hàng đợi.',
            event_type_pattern_hint: 'Khớp sự kiện theo loại bằng ký tự đại diện. Dùng * để khớp bất kỳ phân đoạn nào (ví dụ: incident.* khớp incident.created, incident.resolved).',
            filter_expression_hint: 'Tùy chọn. Lọc thêm sự kiện theo nội dung (ví dụ: severity=high).',
            subscriber_id_placeholder_webhook: 'vd: https://ung-dung.com/webhook',
            subscriber_id_placeholder_email: 'vd: canh-bao@cong-ty.com',
            subscriber_id_placeholder_queue: 'vd: hang-doi-su-kien',
            event_pattern: 'Mẫu sự kiện',
            filter: 'Bộ lọc',
            enabled: 'Đã bật',
            delivery_stats: 'Thống kê gửi',
            no_subscriptions: 'Không tìm thấy đăng ký',
            on: 'Bật',
            off: 'Tắt',
            delivered_failed: '{delivered} đã gửi / {failed} thất bại',
            confirm_delete_subscription: 'Xóa đăng ký này?',
            unresolved: 'Chưa giải quyết',
            resolved: 'Đã giải quyết',
            event_id: 'Mã sự kiện',
            subscription_id: 'Mã đăng ký',
            error_code: 'Mã lỗi',
            error_message: 'Thông báo lỗi',
            attempts: 'Số lần thử',
            last_failed: 'Lần lỗi cuối',
            no_dlq_entries: 'Không tìm thấy mục lỗi',
            dlq_count: '{count} mục tổng cộng',
            fetch_events_error: 'Không thể tải danh sách sự kiện. Vui lòng thử lại.',
            fetch_subscriptions_error: 'Không thể tải danh sách đăng ký. Vui lòng thử lại.',
            fetch_dlq_error: 'Không thể tải danh sách hàng đợi lỗi. Vui lòng thử lại.',
            create_subscription_error: 'Không thể tạo đăng ký',
            toggle_subscription_error: 'Không thể chuyển đổi đăng ký',
            delete_subscription_error: 'Không thể xóa đăng ký',
            retry_error: 'Thử lại thất bại',
            dismiss_error: 'Bỏ qua thất bại',
            // fix-sprint-20260411-D F14 — semantic toast keys (replaces tKey fallbacks)
            event_published: 'Đã phát hành sự kiện',
            publish_event_error: 'Không thể phát hành sự kiện. Vui lòng thử lại.',
            priority_label: 'Mức ưu tiên',
            priority_low: 'Thấp',
            priority_normal: 'Bình thường',
            priority_high: 'Cao',
            payload_helper_text: 'Nhập dữ liệu sự kiện dưới dạng JSON. Ví dụ: {"incident_id": "INC-001", "severity": "high"}',
            subscription_created: 'Đã tạo đăng ký',
            subscription_toggled: 'Đã chuyển đổi đăng ký',
            subscription_deleted: 'Đã xóa đăng ký',
            dlq_retried: 'Đã thử lại tin nhắn DLQ',
            dlq_dismissed: 'Đã loại bỏ tin nhắn DLQ',
        },
        definitions: {
            title: 'Định nghĩa kết nối',
            page_title: 'Định nghĩa trình kết nối',
            add: 'Thêm định nghĩa',
            new_definition: 'Định nghĩa kết nối mới',
            edit_definition: 'Sửa định nghĩa kết nối',
            no_definitions: 'Không tìm thấy định nghĩa kết nối',
            definition_count: '{count} định nghĩa',
            all_categories: 'Tất cả danh mục',
            select_category: 'Chọn danh mục...',
            capabilities: 'Khả năng',
            capabilities_hint: 'Khả năng (phân cách bằng dấu phẩy)',
            capabilities_placeholder: 'vd. read, write, sync',
            created: 'Đã tạo định nghĩa kết nối',
            updated: 'Đã cập nhật định nghĩa kết nối',
            fetch_error: 'Không thể tải định nghĩa kết nối. Vui lòng thử lại.',
            create_error: 'Không thể tạo định nghĩa kết nối',
            update_error: 'Không thể cập nhật định nghĩa trình kết nối',
            health_check: 'Kiểm tra tình trạng',
            health_check_none: 'Không khai báo',
            health_check_declare: 'Loại trình kết nối này khai báo kiểm tra tình trạng',
            health_check_method: 'Phương thức',
            health_check_path: 'Đường dẫn',
            health_check_expected_status: 'Mã trạng thái HTTP mong đợi',
            health_check_timeout: 'Thời hạn chờ (giây)',
            health_check_hint: 'Thao tác Kiểm tra gửi đúng một yêu cầu này tới URL gốc của kết nối (thiết lập base_url) và chỉ ghi nhận đạt khi phản hồi có mã trạng thái mong đợi. Không có kiểm tra tình trạng, thao tác Kiểm tra chỉ đánh dấu kết nối sẵn sàng kiểm thử.',
        },
        brds: {
            title: 'Thu thập BRD',
            page_title: 'Thu thập BRD',
            create_brd: 'Tạo BRD',
            brd_title: 'Tiêu đề BRD',
            description: 'Mô tả',
            requirements: 'Yêu cầu',
            status: 'Trạng thái',
            stakeholders: 'Các bên liên quan',
            connector_label: 'Trình kết nối',
            select_connector: 'Chọn trình kết nối...',
            approval: 'Phê duyệt',
            no_brds_found: 'Không tìm thấy BRD',
            decision_records: 'Hồ sơ quyết định',
            create_decision: 'Tạo quyết định',
            alternatives_considered: 'Các phương án đã xem xét',
            alternative_name: 'Tên phương án',
            reason_rejected: 'Lý do từ chối',
            add_alternative: 'Thêm phương án',
            remove_alternative: 'Xóa phương án {name}',
            alternatives: 'Phương án thay thế',
            rationale: 'Lý do',
            selected_connector: 'Kết nối đã chọn',
            aria_archive: 'Lưu trữ {name}',
            aria_approve: 'Phê duyệt {name}',
            aria_decision_records_table: 'Bản ghi quyết định',
            aria_brds_table: 'BRD',
            no_decision_records_found: 'Không tìm thấy bản ghi quyết định',
            decision_record_created: 'Bản ghi quyết định đã tạo',
            brd_created: 'BRD đã tạo',
            comma_separated_names: 'Tên phân cách bằng dấu phẩy',
            brd_title_help: 'Tên ngắn gọn, dễ đọc cho BRD này — ví dụ "Tích hợp ticket Jira", "Triển khai Okta SSO".',
            brd_title_placeholder: 'vd. Tích hợp ticket Jira',
            description_help: 'Vấn đề kinh doanh mà trình kết nối này giải quyết. Bạn mong đợi kết quả gì khi nó được triển khai?',
            description_placeholder: 'vd. Tự động tạo ticket sự cố từ cảnh báo giám sát để on-call được gọi trong vòng 60 giây.',
            connector_help: 'Tùy chọn. Chọn trình kết nối mà BRD này áp dụng — để trống nếu chưa chọn trình kết nối.',
            requirements_help: 'Danh sách các tính năng bắt buộc, phân cách bằng dấu phẩy — vd. "Đăng nhập OAuth2, webhook, xuất audit".',
            requirements_placeholder: 'Đăng nhập OAuth2, webhook, xuất audit',
            stakeholders_help: 'Tên hoặc email của những người cần phê duyệt, phân cách bằng dấu phẩy.',
            selected_connector_help: 'Chọn trình kết nối mà quyết định này áp dụng.',
            rationale_help: 'Lý do chọn trình kết nối này. Nêu rõ các yếu tố quyết định để người đọc sau hiểu được lựa chọn.',
            rationale_placeholder: 'vd. Chọn Jira vì đã lưu lịch sử ticket và đội đã quen sử dụng.',
            alternatives_considered_help: 'Các trình kết nối khác đã được xem xét và lý do không chọn. Tăng tính thuyết phục khi audit.',
            alternative_name_placeholder: 'vd. ServiceNow',
            reason_rejected_placeholder: 'vd. Chi phí cao gấp 3 lần, không có lợi thế cho nhu cầu của chúng tôi',
        },
        security_reviews: {
            title: 'Đánh giá bảo mật',
            page_title: 'Đánh giá bảo mật',
            create_review: 'Tạo đánh giá',
            connector_name: 'Tên kết nối',
            connector_label: 'Trình kết nối',
            select_connector: 'Chọn trình kết nối...',
            reviewer: 'Người đánh giá',
            select_reviewer: 'Chọn người đánh giá...',
            findings: 'Phát hiện (mỗi dòng một)',
            risk_level: 'Mức độ rủi ro',
            risk_level_placeholder: 'vd. cao, trung bình, thấp',
            notes: 'Ghi chú',
            review_status: 'Trạng thái đánh giá',
            checklist: 'Danh sách kiểm tra',
            privacy_impact: 'Tác động quyền riêng tư',
            approval_gate: 'Cổng phê duyệt',
            no_reviews_found: 'Không tìm thấy đánh giá',
            aria_reject: 'Từ chối {name}',
            aria_approve: 'Phê duyệt {name}',
            control_name_label: 'Tên kiểm soát',
            control_id_label: 'ID kiểm soát',
            connector_id_label: 'ID trình kết nối',
            control_mapping_created: 'Ánh xạ kiểm soát đã tạo',
            create_control_mapping: 'Tạo ánh xạ kiểm soát',
            review_created: 'Đánh giá bảo mật đã tạo',
            scan_imported: 'Quét đã nhập thành công',
            import_scan: 'Nhập quét',
            scan_format: 'Định dạng quét',
            scan_data: 'Dữ liệu quét',
            import_results: 'Kết quả nhập',
            recommendations: 'Khuyến nghị',
            auto_populated_from: 'Tự động điền từ {tool}',
            manual_entry: 'Nhập thủ công',
            automation_type: 'Mức độ tự động hoá',
            select_automation_type: 'Chọn mức độ tự động hoá...',
            automation_full: 'Toàn phần — trình kết nối tự động hoá hoàn toàn kiểm soát này',
            automation_partial: 'Một phần — trình kết nối cung cấp bằng chứng; vẫn cần con người xử lý',
            automation_monitoring: 'Chỉ giám sát — trình kết nối quan sát, không cưỡng chế',
            control_id_help: 'Dùng mã từ khung tuân thủ của bạn (vd. ISO-27001-A.12.1, SOC2-CC6.1, hoặc mã kiểm soát nội bộ).',
            control_name_help: 'Tên ngắn dễ đọc (vd. "Hạn chế truy cập mạng").',
            description_label: 'Mô tả',
            load_sarif_example: 'Tải ví dụ SARIF',
            load_json_example: 'Tải ví dụ JSON tuỳ chỉnh',
            scan_format_help: 'SARIF là chuẩn OASIS được hầu hết các công cụ quét xuất ra (Snyk, CodeQL, Semgrep). Dùng JSON tuỳ chỉnh cho các công cụ không xuất SARIF.',
            scan_data_help: 'Dán toàn bộ kết quả quét, tải lên tệp .sarif/.json, hoặc bấm "Tải ví dụ" để xem định dạng.',
            upload_file_label: 'Tải lên tệp .sarif hoặc .json',
            invalid_scan_json: 'Không phân tích được dữ liệu quét dưới dạng JSON. Kiểm tra lỗi cú pháp gần ký tự được đánh dấu.',
            save_as_review: 'Lưu thành Đánh giá bảo mật',
            discard_preview: 'Bỏ bản xem trước',
            preview_hint: 'Đây là bản xem trước — chưa có gì được lưu. Bấm "Lưu thành Đánh giá bảo mật" để tạo đánh giá đang chờ với các giá trị đã điền sẵn.',
            reviewer_required_for_save: 'Chọn người đánh giá để lưu lần quét này thành đánh giá bảo mật.',
        },
        poc_scorecards: {
            title: 'Thẻ điểm POC',
            page_title: 'Bảng điểm POC',
            create_scorecard: 'Tạo thẻ điểm',
            connector_label: 'Trình kết nối',
            select_connector: 'Chọn trình kết nối...',
            vendor_name: 'Tên nhà cung cấp',
            recommendation: 'Khuyến nghị',
            recommendation_placeholder: 'vd. Tiếp tục, Không tiếp tục, Cần đánh giá thêm',
            criteria: 'Tiêu chí đánh giá',
            criterion_name: 'Tên tiêu chí',
            score: 'Điểm',
            max_score: 'Điểm tối đa',
            notes: 'Ghi chú',
            add_criterion: 'Thêm tiêu chí',
            remove_criterion: 'Xóa tiêu chí {name}',
            total_score: 'Tổng điểm',
            api_quality: 'Chất lượng API',
            reliability: 'Độ tin cậy',
            support_quality: 'Chất lượng hỗ trợ',
            cost_score: 'Điểm chi phí',
            overall_score: 'Điểm tổng thể',
            evidence: 'Bằng chứng',
            no_scorecards_found: 'Không tìm thấy thẻ điểm',
            scorecard_created: 'Bảng điểm POC đã tạo',
            connector_help: 'Chọn trình kết nối mà bản đánh giá POC này áp dụng.',
            vendor_name_help: 'Nhà cung cấp hoặc sản phẩm đang được đánh giá — ví dụ "Okta", "Datadog", "Snowflake".',
            vendor_name_placeholder: 'vd. Okta, Datadog, Snowflake',
            recommendation_help: 'Kết luận cuối cùng của bạn sau khi đánh giá. Ngắn gọn và rõ ràng.',
            criteria_help: 'Chấm điểm nhà cung cấp theo từng tiêu chí đánh giá. Mỗi tiêu chí một hàng (chất lượng API, độ tin cậy, hỗ trợ, chi phí, ...).',
            criterion_name_help: 'Hạng mục bạn đang chấm điểm — vd. "Chất lượng API", "Độ tin cậy", "Hỗ trợ", "Chi phí".',
            criterion_name_placeholder: 'vd. Chất lượng API',
            score_help: 'Điểm cho tiêu chí này. Không được vượt quá Điểm tối đa.',
            max_score_help: 'Điểm tối đa cho tiêu chí này. Dùng cùng một thang điểm giữa các hàng để tổng điểm có thể so sánh được.',
            notes_help: 'Tùy chọn. Thêm bằng chứng, lưu ý hoặc liên kết — bất cứ điều gì giải thích cho điểm số.',
        },
        common_labels: {
            aria_filter_instances: 'Lọc phiên bản trình kết nối',
            aria_filter_definitions: 'Lọc định nghĩa trình kết nối',
            aria_filter_credentials: 'Lọc thông tin xác thực',
            aria_filter_events: 'Lọc sự kiện',
            aria_filter_dlq: 'Lọc hàng đợi thư chết',
            aria_instance_summary: 'Tóm tắt phiên bản trình kết nối',
            aria_active_connectors: 'Trình kết nối hoạt động',
            aria_error_connectors: 'Trình kết nối lỗi',
            aria_credential_health: 'Tóm tắt tình trạng thông tin xác thực',
            aria_items_per_page: 'Mục mỗi trang',
            show_password: 'Hiện mật khẩu',
            hide_password: 'Ẩn mật khẩu',
            payload_json_label: 'Tải trọng (JSON)',
            payload_invalid_json: 'Tải trọng phải là JSON hợp lệ',
            placeholder_event_type: 'vd. incident.created',
            placeholder_source_module: 'vd. monitoring',
            placeholder_version: 'vd. 1.0',
        },
        statuses: {
            configuring: 'Đang cấu hình',
            testing: 'Đang kiểm thử',
            active: 'Hoạt động',
            paused: 'Tạm dừng',
            error: 'Lỗi',
            disabled: 'Đã tắt',
            draft: 'Bản nháp',
            approved: 'Đã phê duyệt',
            archived: 'Đã lưu trữ',
            pending: 'Chờ xử lý',
            rejected: 'Đã từ chối',
        },
        system_types: {
            application: 'Ứng dụng',
            database: 'Cơ sở dữ liệu',
            service: 'Dịch vụ',
            infrastructure: 'Hạ tầng',
            third_party: 'Bên thứ ba',
        },
        hosting_types: {
            on_premise: 'Tại chỗ',
            cloud: 'Đám mây',
            hybrid: 'Hỗn hợp',
            managed: 'Được quản lý',
        },
        system_statuses: {
            active: 'Hoạt động',
            decommissioned: 'Ngừng hoạt động',
            planned: 'Đã lên kế hoạch',
            under_review: 'Đang xem xét',
        },
        automation_statuses: {
            planning: 'Lập kế hoạch',
            in_progress: 'Đang thực hiện',
            completed: 'Hoàn thành',
            on_hold: 'Tạm dừng',
        },
        gap_types: {
            functional: 'Chức năng',
            technical: 'Kỹ thuật',
            security: 'Bảo mật',
            compliance: 'Tuân thủ',
            process: 'Quy trình',
        },
        severity_labels: {
            critical: 'Nghiêm trọng',
            high: 'Cao',
            medium: 'Trung bình',
            low: 'Thấp',
        },
        gap_statuses: {
            open: 'Mở',
            in_progress: 'Đang thực hiện',
            mitigated: 'Đã giảm thiểu',
            closed: 'Đã đóng',
            accepted: 'Đã chấp nhận',
        },
        verification_statuses: {
            not_started: 'Chưa bắt đầu',
            in_progress: 'Đang thực hiện',
            verified: 'Đã xác minh',
            failed: 'Thất bại',
        },
        subscriber_types: {
            webhook: 'Webhook',
            internal: 'Nội bộ',
            email: 'Email',
            queue: 'Hàng đợi',
        },
        credential_types: {
            password: 'Mật khẩu',
            api_key: 'Khóa API',
            oauth2_client: 'Ứng dụng khách OAuth2',
            certificate: 'Chứng chỉ',
            token: 'Token',
            ssh_key: 'Khóa SSH',
            imap_credentials: 'Thông tin IMAP',
        },
        categories: {
            hr: 'Nhân sự',
            crm: 'CRM',
            erp: 'ERP',
            cloud: 'Đám mây',
            security: 'Bảo mật',
            itsm: 'ITSM',
            custom: 'Tùy chỉnh',
        },
        delivery_statuses: {
            pending: 'Chờ xử lý',
            delivered: 'Đã gửi',
            partial: 'Một phần',
            failed: 'Thất bại',
        },
        automation_planning: {
            title: 'Lập kế hoạch tự động hóa',
            page_title: 'Lập kế hoạch tự động hóa',
            program_name: 'Tên chương trình',
            program_status: 'Trạng thái',
            description: 'Mô tả',
            linked_artifacts: 'Tạo phẩm liên kết',
            create_program: 'Tạo chương trình',
            edit_program: 'Sửa chương trình',
            no_programs_found: 'Không tìm thấy chương trình',
            program_created: 'Đã tạo chương trình',
            program_updated: 'Đã cập nhật chương trình',
            target_date: 'Ngày mục tiêu',
            owner: 'Chủ sở hữu',
            select_status: 'Chọn trạng thái...',
            aria_programs_table: 'Chương trình tự động hóa',
            aria_edit: 'Sửa {name}',
            export_programs: 'Xuất chương trình',
            title_label: 'Tên chương trình',
            title_help: 'Tên ngắn gọn, dễ đọc cho chương trình tự động hóa — vd. "Triển khai incident-to-Jira Q3", "Tự động hóa yêu cầu truy cập PDPL".',
            title_placeholder: 'vd. Triển khai incident-to-Jira Q3',
            description_help: 'Phạm vi chương trình và kết quả mong đợi khi triển khai. Tùy chọn nhưng nên có.',
            description_placeholder: 'vd. Kết nối cảnh báo giám sát vào Jira để on-call được gọi trong vòng 60 giây.',
            owner_label: 'Chủ sở hữu chương trình',
            owner_help: 'Người chịu trách nhiệm về chương trình này. Họ sẽ nhận thông báo về tiến độ và các cổng phê duyệt.',
            select_owner: 'Chọn chủ sở hữu...',
            frameworks_in_scope: 'Khung tuân thủ áp dụng',
            frameworks_in_scope_help: 'Các khung tuân thủ mà chương trình này hỗ trợ. Giúp audit trail thể hiện rõ tự động hóa được điều chỉnh bởi quy định nào.',
            select_frameworks: 'Chọn khung tuân thủ...',
            status_draft: 'Nháp',
            status_active: 'Đang hoạt động',
            status_completed: 'Hoàn thành',
            status_archived: 'Đã lưu trữ',
            change_status: 'Đổi trạng thái',
            status_updated: 'Đã cập nhật trạng thái',
            aria_change_status: 'Đổi trạng thái cho {name}',
        },
        system_inventory: {
            title: 'Kho hệ thống',
            page_title: 'Kho hệ thống',
            system_name: 'Tên hệ thống',
            system_type: 'Loại hệ thống',
            hosting: 'Lưu trữ',
            status: 'Trạng thái',
            description: 'Mô tả',
            create_system: 'Tạo hệ thống',
            edit_system: 'Sửa hệ thống',
            no_systems_found: 'Không tìm thấy hệ thống',
            system_created: 'Đã tạo hệ thống',
            system_updated: 'Đã cập nhật hệ thống',
            select_type: 'Chọn loại...',
            select_hosting: 'Chọn lưu trữ...',
            select_status: 'Chọn trạng thái...',
            owner: 'Chủ sở hữu',
            department: 'Phòng ban',
            data_categories: 'Danh mục dữ liệu',
            data_categories_placeholder: 'Phân cách bằng dấu phẩy, vd. PII, Tài chính, Sức khỏe',
            jurisdiction: 'Quyền tài phán',
            jurisdiction_placeholder: 'vd. EU, VN, Toàn cầu',
            interfaces: 'Giao diện',
            interfaces_placeholder: 'Phân cách bằng dấu phẩy, vd. REST API, SFTP, JDBC',
            owner_placeholder: 'Chọn một chủ sở hữu chịu trách nhiệm...',
            department_placeholder: 'Chọn đơn vị tổ chức chịu trách nhiệm...',
            system_name_hint: 'Sử dụng tên hệ thống hoặc ứng dụng được doanh nghiệp công nhận.',
            system_type_hint: 'Phân loại hệ thống để các báo cáo có thể nhóm các tài sản tương tự.',
            hosting_hint: 'Xác định nơi hệ thống vận hành để phục vụ lưu trữ, bảo mật và rà soát nhà cung cấp.',
            status_hint: 'Thiết lập trạng thái vòng đời được sử dụng bởi rà soát, xuất báo cáo và bằng chứng kiểm toán.',
            owner_hint: 'Chọn người dùng đang hoạt động chịu trách nhiệm quản trị hệ thống và các nhiệm vụ theo dõi.',
            department_hint: 'Sử dụng đơn vị tổ chức chịu trách nhiệm vận hành hoặc quản trị hệ thống này.',
            data_categories_hint: 'Liệt kê các loại dữ liệu được hệ thống này xử lý, phân cách bằng dấu phẩy.',
            jurisdiction_hint: 'Ghi lại quyền tài phán pháp lý hoặc lưu trữ chính cho việc ánh xạ tuân thủ.',
            interfaces_hint: 'Liệt kê các trình kết nối hoặc đường dẫn tích hợp được sử dụng để trao đổi dữ liệu.',
            description_hint: 'Tóm tắt chức năng của hệ thống và lý do nó quan trọng đối với bản đồ dữ liệu.',
            owner_department_required: 'Chủ sở hữu và Phòng ban là bắt buộc.',
            aria_systems_table: 'Kho hệ thống',
            aria_edit: 'Sửa {name}',
            export_systems: 'Xuất hệ thống',
            aria_filter_systems: 'Lọc hệ thống',
            governance_context: 'Bối cảnh quản trị',
            governance_context_hint: 'Xác nhận đơn vị chịu trách nhiệm, phạm vi tài phán, loại dữ liệu và giao diện trước khi lưu.',
            governance_context_summary: 'Bối cảnh này chi phối việc lập bản đồ dữ liệu, rà soát nơi lưu trữ và trách nhiệm giải trình của kết nối.',
        },
        traceability_matrix: {
            title: 'Ma trận truy xuất',
            page_title: 'Ma trận truy xuất',
            brd_selector: 'Chọn BRD',
            requirement: 'Yêu cầu',
            linked_artifact: 'Tạo phẩm liên kết',
            verification_status: 'Trạng thái xác minh',
            verified_by: 'Xác minh bởi',
            create_entry: 'Tạo mục',
            edit_entry: 'Sửa mục',
            no_entries_found: 'Không tìm thấy mục',
            entry_created: 'Đã tạo mục',
            entry_updated: 'Đã cập nhật mục',
            select_brd: 'Chọn BRD...',
            select_status: 'Chọn trạng thái...',
            aria_matrix_table: 'Ma trận truy xuất',
            aria_edit: 'Sửa mục cho {name}',
            export_matrix: 'Xuất ma trận',
            brd_selector_hint: 'Chọn Tài liệu yêu cầu nghiệp vụ (BRD) mà mục này thuộc về.',
            fetch_brds_error: 'Không tải được danh sách BRD',
            requirement_id_hint: 'Mã tham chiếu duy nhất từ BRD hoặc nguồn quy định (ví dụ: REQ-001).',
            requirement_text: 'Nội dung yêu cầu',
            requirement_text_hint: 'Mô tả chi tiết của yêu cầu như được nêu trong tài liệu nguồn.',
            verification_method: 'Phương pháp xác minh',
            verification_method_hint: 'Quy trình dùng để xác nhận yêu cầu đã được đáp ứng (ví dụ: kiểm thử đơn vị, kiểm toán).',
            verification_method_placeholder: 'ví dụ: kiểm thử, kiểm tra, rà soát',
            verification_status_hint: 'Tình trạng xác minh hiện tại của việc triển khai yêu cầu.',
            requirement_id: 'ID yêu cầu',
        },
        gap_register: {
            title: 'Sổ đăng ký khoảng trống',
            page_title: 'Sổ đăng ký khoảng trống',
            gap_title: 'Tiêu đề',
            gap_type: 'Loại',
            severity: 'Mức độ',
            status: 'Trạng thái',
            description: 'Mô tả',
            remediation_plan: 'Kế hoạch khắc phục',
            assigned_to: 'Giao cho',
            due_date: 'Ngày hạn',
            create_gap: 'Tạo khoảng trống',
            edit_gap: 'Sửa khoảng trống',
            no_gaps_found: 'Không tìm thấy',
            gap_created: 'Đã tạo',
            gap_updated: 'Đã cập nhật',
            select_type: 'Chọn loại...',
            select_severity: 'Chọn mức độ...',
            select_status: 'Chọn trạng thái...',
            aria_gaps_table: 'Sổ đăng ký',
            aria_edit: 'Sửa {name}',
            export_gaps: 'Xuất khoảng trống',
            gap_title_hint: 'Cung cấp một tên ngắn gọn cho khoảng trống đã xác định.',
            gap_type_hint: 'Chọn bản chất của khoảng trống (ví dụ: thiếu phạm vi hoặc lỗi tích hợp).',
            severity_hint: 'Mức độ ảnh hưởng của khoảng trống này đối với tuân thủ và vận hành.',
            status_hint: 'Giai đoạn hiện tại của vòng đời giải quyết khoảng trống.',
            owner_hint: 'Người chịu trách nhiệm theo dõi và khắc phục khoảng trống này.',
            description_hint: 'Ngữ cảnh chi tiết về khoảng trống, nguyên nhân gốc rễ và tác động.',
            mitigation_plan_hint: 'Các bước được lập kế hoạch hoặc đã thực hiện để khắc phục và thu hẹp khoảng trống.',
            linked_requirement_ids_hint: 'Các mã yêu cầu phân cách bằng dấu phẩy mà khoảng trống này ảnh hưởng.',
            linked_system_ids_hint: 'Các mã hệ thống phân cách bằng dấu phẩy liên quan đến khoảng trống này.',
            gap_types: {
                coverage: 'Phạm vi',
                capability: 'Khả năng',
                integration: 'Tích hợp',
                compliance: 'Tuân thủ',
            },
            linked_ids_placeholder: 'Các mã phân tách bằng dấu phẩy',
            linked_requirement_ids: 'Mã yêu cầu liên kết',
            linked_system_ids: 'Mã hệ thống liên kết',
            mitigation_plan: 'Kế hoạch giảm thiểu rủi ro',
            select_owner: 'Chọn chủ sở hữu',
        },
        regulatory: {
            system_inventory_governance_info: 'Mỗi hệ thống trong bảng kê này phù hợp với mô hình quản trị doanh nghiệp theo Luật Dữ liệu. Các loại hệ thống (Ứng dụng, Cơ sở dữ liệu, Phần mềm trung gian, Hạ tầng, SaaS) ánh xạ đến các danh mục quy định, và phân loại lưu trữ (Tại chỗ, Đám mây, Lai, Được quản lý) xác định các biện pháp kiểm soát theo vùng lãnh thổ áp dụng. Sử dụng trường liên kết khung tuân thủ để kết nối mỗi hệ thống với các khung quy định hiện hành.',
            automation_planning_workflow_info: 'Các chương trình tự động hóa phù hợp với các nghĩa vụ quy trình tuân thủ được xác định bởi các khung quy định hiện hành. Trường phạm vi khung tuân thủ xác định yêu cầu khung mà chương trình giải quyết, và liên kết thủ tục kết nối mỗi chương trình với các quy trình tuân thủ đã được ghi nhận.',
            traceability_regulatory_source_info: 'Mỗi mục truy xuất kết nối yêu cầu BRD với nguồn quy định của nó. Trường nguồn quy định xác định quy định, chỉ thị hoặc tiêu chuẩn cụ thể yêu cầu. Trạng thái xác minh theo dõi liệu việc triển khai đã được xác nhận đáp ứng nghĩa vụ quy định.',
            security_reviews_control_mapping_info: 'Các đánh giá bảo mật đánh giá các biện pháp kiểm soát theo khung cụ thể áp dụng cho mỗi kết nối. Trường mức độ rủi ro ghi nhận mức độ phơi nhiễm đã đánh giá, và các phát hiện ghi lại sai lệch so với yêu cầu kiểm soát. Sử dụng tính năng ánh xạ kiểm soát để liên kết mỗi đánh giá với các kiểm soát khung cụ thể đã được đánh giá.',
            gap_register_framework_info: 'Sổ đăng ký Khoảng trống ghi nhận các khoảng trống tuân thủ theo từng khung quy định. Sử dụng bộ lọc khung tuân thủ để xem các khoảng trống cho một khung cụ thể. Mức độ nghiêm trọng phù hợp với phân loại rủi ro của khung, và quy trình trạng thái theo dõi tiến trình khắc phục qua vòng đời tuân thủ.',
            poc_scorecards_criteria_info: 'Thẻ điểm POC đánh giá các kết nối theo tiêu chí quy định cụ thể cho khung áp dụng. Cấu trúc tiêu chí hỗ trợ chấm điểm có trọng số với ghi chú bằng chứng. Trường liên kết nhà cung cấp kết nối đánh giá với hồ sơ nhà cung cấp, và trường khuyến nghị cung cấp quyết định mua sắm dựa trên tuân thủ.',
            evidence_trail_info: 'Tất cả các hành động phân hệ kết nối tạo ra các sự kiện kiểm toán để đảm bảo tính toàn vẹn chuỗi bằng chứng xuyên phân hệ. Xuất CSV bảo toàn tính toàn vẹn tham chiếu bằng cách bao gồm các mã định danh thực thể liên kết.',
        },
        system_inventory_extra: {
            framework_linkage: 'Liên kết khung tuân thủ',
            framework_linkage_placeholder: 'vd. GDPR, ISO 27001, NIS2',
        },
        automation_planning_extra: {
            framework_scope: 'Phạm vi khung tuân thủ',
            framework_scope_placeholder: 'vd. GDPR, PCI-DSS',
            procedure_linkage: 'Liên kết thủ tục',
            procedure_linkage_placeholder: 'vd. SOP-001, PROC-DATA-003',
        },
        traceability_matrix_extra: {
            regulatory_source: 'Nguồn quy định',
            regulatory_source_placeholder: 'vd. GDPR Điều 30, ISO 27001 A.8',
        },
        security_reviews_extra: {
            control_mapping_col: 'Ánh xạ kiểm soát',
            control_mappings_section: 'Ánh xạ kiểm soát',
            no_control_mappings: 'Chưa có ánh xạ kiểm soát nào. Bấm "Tạo ánh xạ kiểm soát" để thêm.',
            automation_type_col: 'Tự động hoá',
        },
        gap_register_extra: {
            framework_filter: 'Khung tuân thủ',
            framework_id: 'Mã khung tuân thủ',
            framework_id_placeholder: 'vd. GDPR, ISO 27001',
            all_frameworks: 'Tất cả khung tuân thủ',
        },
        poc_scorecards_extra: {
            criteria_count: 'Tiêu chí',
        },
        export_labels: {
            export_brds: 'Xuất BRD',
            export_decision_records: 'Xuất hồ sơ quyết định',
            export_security_reviews: 'Xuất đánh giá bảo mật',
            export_poc_scorecards: 'Xuất thẻ điểm POC',
            export_instances: 'Xuất phiên bản',
            export_definitions: 'Xuất định nghĩa',
            export_credentials: 'Xuất thông tin xác thực',
            export_events: 'Xuất sự kiện',
            exporting: 'Đang xuất...',
            export_success: 'Xuất hoàn tất',
            export_error: 'Xuất thất bại',
        },
    },
    // fix-sprint-20260506-2121-followup F16 — the contracts module's own
    // section (it was filed under vendor_risk).
    contracts: {
        obligation_extraction: {
            extract_label: 'Trích xuất nghĩa vụ',
            extracting: 'Đang trích xuất…',
            results_heading: 'Nghĩa vụ đã trích xuất ({count})',
            tokens_label: '≈ {count} token',
            no_obligations: 'Không phát hiện mẫu nghĩa vụ nào trong văn bản hợp đồng.',
            col_class: 'Loại',
            col_summary: 'Tóm tắt (có thể sửa)',
            col_excerpt: 'Trích đoạn điều khoản',
            col_due_date: 'Hạn (có thể sửa)',
            col_priority: 'Mức ưu tiên',
            due_date_placeholder: 'YYYY-MM-DD',
            class_notice: 'Thời hạn thông báo',
            class_audit: 'Quyền audit',
            class_insurance: 'Bảo hiểm',
            class_sla: 'SLA phản hồi',
            class_breach: 'Thông báo sự cố',
            class_renewal: 'Cửa sổ gia hạn',
            citations_label: 'Trích dẫn',
            accept_hint: 'Chấp nhận sẽ tạo một task cho mỗi nghĩa vụ (tối đa 8) với priority + hạn hiển thị.',
            accept_label: 'Chấp nhận nghĩa vụ',
            reject_label: 'Từ chối báo cáo',
            resolve_summary: 'Kết quả: {status} · đã tạo {tasks} task',
            error_generic: 'Không thể trích xuất nghĩa vụ. Hãy thử lại hoặc kiểm tra văn bản hợp đồng.',
            summary_input_label: 'Tóm tắt nghĩa vụ {n}: {classification}',
            due_date_input_label: 'Hạn hoàn thành nghĩa vụ {n}: {classification}',
            tasks_dropped: 'Không thể tạo {count} nhiệm vụ. Vui lòng tạo các nhiệm vụ này từ các nghĩa vụ ở trên.',
        },
    },
    vendor_risk: {
        // Sprint 48.2.4 — Trợ lý lập luận chấp nhận rủi ro
        risk_acceptance_reasoning: {
            draft_label: 'Soạn lập luận',
            drafting: 'Đang soạn lập luận…',
            results_heading: 'Lập luận do AI soạn ({risk_level})',
            tokens_label: '≈ {count} token',
            narrative_label: 'Tường thuật biện luận',
            controls_heading: 'Biện pháp kiểm soát bù đắp',
            no_controls: 'Chưa có biện pháp kiểm soát bù đắp được đề xuất.',
            citations_label: 'Trích dẫn',
            accept_label: 'Chấp nhận lập luận',
            reject_label: 'Từ chối draft',
            accept_hint: 'Chấp nhận ghi lập luận vào draft cho lineage IAT. Tường thuật + kiểm soát không tự cập nhật acceptance — operator phải paste lại.',
            resolve_summary: 'Kết quả: {status}',
            error_generic: 'Không thể soạn lập luận. Thử lại hoặc kiểm tra trạng thái risk acceptance.',
        },
        // Sprint 48.2.3 — Trợ lý redline hợp đồng + thư viện điều khoản
        redline_assistant: {
            run_label: 'Chạy redline với thư viện',
            running: 'Đang chạy redline…',
            results_heading: 'Đề xuất redline ({count})',
            tokens_label: '≈ {count} token',
            no_suggestions: 'Không phát hiện thiếu sót so với điều khoản chuẩn.',
            jurisdiction_label: 'Quyền tài phán',
            col_kind: 'Loại',
            col_severity: 'Mức độ',
            col_title: 'Đề xuất',
            col_excerpt: 'Trích đoạn khớp',
            col_apply: 'Áp dụng',
            kind_missing: 'Thiếu điều khoản chuẩn',
            kind_weaker: 'Yếu hơn chuẩn',
            kind_jurisdiction: 'Yêu cầu theo quyền tài phán',
            proposed_label: 'Văn bản đề xuất',
            citations_label: 'Trích dẫn',
            accept_label: 'Chấp nhận đã chọn',
            reject_label: 'Từ chối báo cáo',
            partial_label: 'Áp dụng lựa chọn',
            accept_hint: 'Áp dụng lựa chọn ghi các đề xuất được chọn vào draft cho lineage IAT. Không tự sửa văn bản hợp đồng — operator chủ động.',
            resolve_summary: 'Kết quả: {status} · {count} đề xuất đã áp dụng',
            error_generic: 'Không thể tạo redline. Thử lại hoặc kiểm tra trạng thái hợp đồng.',
            clause_library_link: 'Quản lý thư viện điều khoản',
            text_source_extracted: 'văn bản trích xuất từ hợp đồng',
            text_source_inline: 'văn bản cung cấp cho lần quét này',
            text_source_summary: 'phần mô tả hợp đồng',
            scanned_text_note: 'Đã quét {source} ({count} ký tự). Tệp hợp đồng đã tải lên không được đọc.',
            rescan_button: 'Quét lại',
            rescan_label: 'Quét theo quyền tài phán khác (mã quốc gia)',
            jurisdiction_provided: '{code} (chọn cho lần quét này)',
            jurisdiction_no_overlay: '{code} (chưa có lớp bổ sung theo quyền tài phán cho mã này; chỉ thư viện điều khoản của bạn được kiểm tra)',
            jurisdiction_assumed: '{code} (giả định: hợp đồng không ghi nhận quyền tài phán)',
        },
        // Sprint 48.2.3 — Trang quản trị thư viện điều khoản
        clause_library: {
            page_title: 'Thư viện điều khoản',
            add_label: 'Thêm điều khoản',
            edit_label: 'Sửa',
            delete_label: 'Xóa',
            slug_label: 'Slug',
            title_label: 'Tiêu đề',
            body_label: 'Nội dung',
            jurisdiction_label: 'Quyền tài phán',
            tags_label: 'Tags (cách nhau bằng dấu phẩy)',
            must_contain_label: 'Markers bắt buộc (cách nhau bằng dấu phẩy)',
            severity_label: 'Mức độ khi thiếu',
            no_clauses: 'Chưa có điều khoản nào. Thêm để cấp dữ liệu cho redline assistant.',
            save_label: 'Lưu',
            cancel_label: 'Hủy',
            load_error: 'Không thể tải thư viện.',
            save_error: 'Không thể lưu điều khoản.',
            delete_error: 'Không thể xóa điều khoản.',
            delete_confirm: 'Xóa điều khoản "{slug}"? Hành động này không thể hoàn tác.',
        },
        // Sprint 48.2.2 — Bảng trích xuất nghĩa vụ hợp đồng của Forseti
        // Sprint 48.2.1 — Bảng đánh giá tác động thay đổi sub-processor của Forseti
        subprocessor_impact: {
            assess_label: 'Đánh giá tác động',
            assessing: 'Đang đánh giá…',
            results_heading: 'Tác động sub-processor ({severity})',
            tokens_label: '≈ {count} token',
            risk_delta_label: 'Thay đổi rủi ro',
            notification_heading: 'Thông báo khách hàng',
            subject_label: 'Tiêu đề',
            deadline_label: 'Hạn thông báo',
            body_label: 'Nội dung thông báo',
            required_fields_label: 'Trường thông báo (Điều 28(2))',
            mitigation_heading: 'Bước giảm thiểu',
            citations_label: 'Trích dẫn',
            accept_label: 'Chấp nhận đánh giá',
            reject_label: 'Từ chối đánh giá',
            accept_hint: 'Chấp nhận sẽ tạo task thông báo khách hàng với hạn SLA làm due date.',
            resolve_summary: 'Kết quả: {status}{task}',
            error_generic: 'Không thể đánh giá thay đổi này. Hãy thử lại hoặc kiểm tra change record.',
        },
        // Sprint 48.2.0 — Trình thu thập bằng chứng onboarding của Forseti
        onboarding_evidence: {
            collect_label: 'Chạy thu thập bằng chứng AI',
            collecting: 'Đang thu thập bằng chứng…',
            results_heading: 'Thu thập bằng chứng ({tier})',
            tokens_label: '≈ {count} token',
            findings_heading: 'Bằng chứng hiện có',
            missing_heading: 'Bằng chứng còn thiếu',
            no_findings: 'Không phát hiện bằng chứng hiện có.',
            no_missing: 'Không có bằng chứng bắt buộc bị thiếu cho mức rủi ro này.',
            next_step_label: 'Bước tiếp theo',
            class_dpa: 'Hợp đồng xử lý dữ liệu',
            class_soc2: 'Báo cáo SOC 2',
            class_iso27001: 'Chứng nhận ISO 27001',
            class_insurance: 'Bảo hiểm an ninh mạng',
            class_incident_history: 'Sự cố trước đây',
            accept_hint: 'Chấp nhận sẽ tạo một task cho từng bằng chứng còn thiếu (tối đa 5) và ghi nhận từng tài liệu tìm thấy làm bằng chứng nháp trên nhà cung cấp. Bằng chứng nháp chưa được duyệt cho tới khi người có quyền duyệt bằng chứng xem xét. Các sự cố trước đây chỉ được liệt kê để bạn xem xét.',
            accept_label: 'Chấp nhận báo cáo',
            reject_label: 'Từ chối báo cáo',
            resolve_summary: 'Kết quả: {status} · đã tạo {tasks} task · đã đính kèm {evidence} bằng chứng nháp',
            error_generic: 'Không thể chạy thu thập bằng chứng AI. Hãy thử lại hoặc kiểm tra case.',
        },
        no_permission_title: 'Quyền không đủ',
        no_permission_message: 'Bạn không có quyền truy cập quản lý rủi ro nhà cung cấp.',
        unknown_vendor: 'Nhà cung cấp không xác định',
        nav: {
            dashboard: 'Tổng quan rủi ro',
            scoring: 'Chấm điểm rủi ro',
            questionnaires: 'Bảng câu hỏi',
            contracts: 'Hợp đồng',
            gates: 'Cổng phê duyệt',
            reviews: 'Đánh giá nhà cung cấp',
            signals: 'Tín hiệu rủi ro',
            reassessments: 'Đánh giá lại',
            portfolio: 'Danh mục rủi ro',
            acceptances: 'Chấp nhận rủi ro',
            review_routing: 'Định tuyến đánh giá',
            onboarding_cases: 'Hồ sơ tiếp nhận',
            sub_processor_register: 'Sổ đăng ký Bên xử lý phụ',
        },
        dashboard: {
            title: 'Tổng quan Rủi ro Nhà cung cấp',
            loading: 'Đang tải dữ liệu...',
            load_error: 'Không thể tải tổng quan rủi ro nhà cung cấp',
            risk_distribution: 'Phân bố Rủi ro',
            recent_tier_changes: 'Thay đổi Mức rủi ro Gần đây',
            no_tier_changes: 'Không có thay đổi mức rủi ro gần đây.',
            review_kpis: 'KPI Đánh giá',
            total_vendors_reviewed: 'Tổng Nhà cung cấp Đã đánh giá',
            reviews_by_outcome: 'Đánh giá theo Kết quả',
            contract_coverage: 'Phạm vi Hợp đồng',
            total_vendors: 'Tổng Nhà cung cấp',
            with_active_dpa: 'Có DPA Hoạt động',
            without_dpa: 'Không có DPA',
            dpa_coverage: 'Phạm vi DPA',
            active_contracts_by_type: 'Hợp đồng Hoạt động theo Loại',
            expiring_contracts: 'Hợp đồng Sắp hết hạn (90 ngày tới)',
            no_expiring_contracts: 'Không có hợp đồng hết hạn trong 90 ngày tới.',
            vendor: 'Nhà cung cấp',
            previous_tier: 'Mức trước',
            current_tier: 'Mức hiện tại',
            changed_at: 'Thay đổi lúc',
            expires_at: 'Hết hạn lúc',
            days_remaining: 'Số ngày còn lại',
            days: 'ngày',
            vendors_label: 'nhà cung cấp',
            no_data: 'Không có dữ liệu',
            critical: 'Nghiêm trọng',
            high: 'Cao',
            medium: 'Trung bình',
            low: 'Thấp',
            page_title: 'Bảng điều khiển rủi ro nhà cung cấp',
            risk_tier_header: 'Cấp độ rủi ro',
            count_header: 'Số lượng',
            percentage_header: 'Tỷ lệ phần trăm',
            sections_nav: 'Mục rủi ro nhà cung cấp',
            urgent_expiry: 'Khẩn cấp: hết hạn trong 14 ngày',
            no_previous_tier: 'Không có cấp trước đó',
            view_as_chart: 'Xem dạng biểu đồ',
            view_as_table: 'Xem dạng bảng',
            showing_chart: 'Đang hiển thị dạng biểu đồ',
            showing_table: 'Đang hiển thị dạng bảng',
            expiring_acceptances_heading: 'Chấp nhận rủi ro sắp hết hạn',
            expiring_30d_label: 'Hết hạn trong 30 ngày',
            expiring_60d_label: 'Hết hạn trong 60 ngày',
            expiring_90d_label: 'Hết hạn trong 90 ngày',
        },
        scoring: {
            title: 'Chấm điểm Rủi ro',
            config_title: 'Cấu hình chấm điểm',
            scores_title: 'Điểm rủi ro nhà cung cấp',
            new_score_title: 'Chấm điểm nhà cung cấp',
            new: 'Điểm mới',
            vendor_id: 'Mã Nhà cung cấp',
            risk_tier: 'Mức Rủi ro',
            score: 'Điểm',
            scored_at: 'Chấm điểm lúc',
            no_scores: 'Không tìm thấy điểm rủi ro.',
            all_tiers: 'Tất cả Mức',
            load_config_error: 'Không thể tải cấu hình chấm điểm rủi ro',
            update_config: 'Cập nhật cấu hình chấm điểm',
            update_config_error: 'Không thể cập nhật cấu hình chấm điểm rủi ro',
            load_scores_error: 'Không thể tải điểm rủi ro nhà cung cấp',
            calculate_error: 'Không thể tính điểm rủi ro nhà cung cấp',
            weight: 'trọng số',
            score_range: 'Điểm (1-5)',
            method: 'Phương pháp',
            page_title: 'Chấm điểm rủi ro nhà cung cấp',
            filter_scores: 'Lọc điểm rủi ro',
            filter_by_tier: 'Lọc theo cấp rủi ro',
            scores_pagination: 'Phân trang điểm rủi ro',
            config_dimensions: 'Cấu hình chiều chấm điểm',
            scores_loaded: 'Đã tải {count} điểm rủi ro',
            weight_must_equal_100: 'Tổng trọng số phải bằng 100 (hiện tại: {current})',
            out_of_10: 'trên 10, xếp hạng {tier}',
            dimension_name: 'Tên chiều {index}',
            dimension_weight: 'Trọng số {name} (phần trăm)',
            must_equal_100: 'phải bằng 100',
        },
        questionnaires: {
            title: 'Bảng câu hỏi',
            templates_tab: 'Mẫu',
            instances_tab: 'Phiên bản',
            new: 'Bảng câu hỏi mới',
            new_template: 'Mẫu mới',
            new_instance: 'Phiên bản mới',
            vendor_id: 'Mã Nhà cung cấp',
            template_id: 'Mã mẫu',
            assigned_to: 'Giao cho',
            due_date: 'Hạn chót',
            responses: 'Phản hồi',
            risk_score: 'Điểm rủi ro',
            no_questionnaires: 'Không tìm thấy bảng câu hỏi.',
            load_templates_error: 'Không thể tải mẫu bảng câu hỏi',
            load_instances_error: 'Không thể tải bảng câu hỏi',
            create_template_error: 'Không thể tạo mẫu bảng câu hỏi',
            initiate_error: 'Không thể khởi tạo bảng câu hỏi',
            submit_error: 'Không thể gửi bảng câu hỏi',
            review_error: 'Không thể xem xét bảng câu hỏi',
            resubmit: 'Gửi lại',
            approve_error: 'Không thể phê duyệt bảng câu hỏi',
            reject_error: 'Không thể từ chối bảng câu hỏi',
            resubmit_error: 'Không thể gửi lại bảng câu hỏi',
            page_title: 'Bảng câu hỏi nhà cung cấp',
            filter_questionnaires: 'Bộ lọc bảng câu hỏi',
            questionnaire_views: 'Chế độ xem bảng câu hỏi',
            templates_list: 'Danh sách mẫu bảng câu hỏi',
            instances_list: 'Danh sách phiên bảng câu hỏi',
            filter_by_status: 'Lọc theo trạng thái bảng câu hỏi',
            templates_per_page: 'Mẫu mỗi trang',
            instances_per_page: 'Phiên bản mỗi trang',
            select_template: 'Chọn mẫu bảng câu hỏi',
            template_category: 'Danh mục mẫu',
            templates_loaded: 'Đã tải {count} mẫu bảng câu hỏi',
            instances_loaded: 'Đã tải {count} phiên bản bảng câu hỏi',
            fill_responses_cta: 'Điền câu trả lời',
            fill_responses_title: 'Điền câu trả lời bảng câu hỏi',
            template_missing: 'Không tìm thấy mẫu.',
            responses_saved: 'Đã lưu câu trả lời.',
            load_template_error: 'Không tải được mẫu.',
            version_history: 'Lịch sử phiên bản',
            download_previous_version: 'Tải xuống phiên bản trước',
            // Sprint 43.6.0 W1 — Trigger label rename, Reviewer selector, choice renderers
            trigger: 'Kích hoạt',
            template_label: 'Mẫu',
            reviewer: 'Người duyệt',
            reviewer_required: 'Phải chỉ định người duyệt cho bảng câu hỏi {trigger} (tách biệt trách nhiệm).',
            select_option: 'Chọn một lựa chọn',
            multi_choice_hint: 'Chọn tất cả các mục áp dụng',
            category_initial_onboarding: 'Tiếp nhận ban đầu',
            category_annual_review: 'Rà soát hàng năm',
            category_incident_triggered: 'Kích hoạt do sự cố',
            category_contract_renewal: 'Gia hạn hợp đồng',
            // Sprint 43.6.0 W2 — Template Builder UI
            template_editor: {
                page_title: 'Chỉnh sửa mẫu bảng câu hỏi',
                preview_page_title: 'Xem trước mẫu bảng câu hỏi',
                edit_structure: 'Chỉnh sửa cấu trúc',
                preview: 'Xem trước',
                actions: 'Hành động',
                back_to_list: 'Quay lại danh sách mẫu',
                load_error: 'Không thể tải mẫu',
                save_error: 'Không thể lưu cấu trúc mẫu',
                saved: 'Đã lưu cấu trúc mẫu.',
                sections_heading: 'Các phần',
                questions_heading: 'Câu hỏi',
                add_section: 'Thêm phần',
                edit_section: 'Chỉnh sửa phần',
                delete_section: 'Xóa phần',
                move_section_up: 'Di chuyển phần lên',
                move_section_down: 'Di chuyển phần xuống',
                confirm_delete_section: 'Xóa phần "{title}"? Tất cả câu hỏi trong phần sẽ bị xóa.',
                section_title: 'Tiêu đề phần',
                section_description: 'Mô tả phần',
                section_id: 'Mã phần',
                section_id_hint: 'Tự sinh nếu để trống.',
                no_sections: 'Chưa có phần nào. Thêm phần để bắt đầu.',
                no_questions: 'Phần này chưa có câu hỏi.',
                add_question: 'Thêm câu hỏi',
                edit_question: 'Chỉnh sửa câu hỏi',
                delete_question: 'Xóa câu hỏi',
                move_question_up: 'Di chuyển câu hỏi lên',
                move_question_down: 'Di chuyển câu hỏi xuống',
                confirm_delete_question: 'Xóa câu hỏi "{text}"?',
                question_text: 'Nội dung câu hỏi',
                question_type: 'Loại câu hỏi',
                question_id: 'Mã câu hỏi',
                evidence_required: 'Yêu cầu bằng chứng',
                risk_weight: 'Trọng số rủi ro',
                scoring_map: 'Bản đồ điểm',
                scoring_map_json_hint: 'Đối tượng JSON ánh xạ giá trị trả lời sang điểm số.',
                scoring_map_invalid_json: 'Bản đồ điểm phải là JSON hợp lệ.',
                options_heading: 'Các lựa chọn',
                add_option: 'Thêm lựa chọn',
                remove_option: 'Xóa lựa chọn',
                option_label: 'Nhãn',
                option_value: 'Giá trị',
                option_risk_weight: 'Trọng số rủi ro',
                min_options_error: 'Câu hỏi lựa chọn phải có ít nhất 2 lựa chọn.',
                option_label_required: 'Mỗi lựa chọn cần có nhãn.',
                option_value_required: 'Mỗi lựa chọn cần có giá trị.',
                option_value_unique: 'Giá trị lựa chọn phải duy nhất.',
                branching_rules_heading: 'Quy tắc nhánh',
                branching_rules_hint: 'Hiển thị hoặc ẩn câu hỏi này dựa trên câu trả lời của câu hỏi trước đó.',
                add_branching_rule: 'Thêm quy tắc nhánh',
                remove_branching_rule: 'Xóa quy tắc nhánh',
                branching_condition_question: 'Nếu câu hỏi',
                branching_condition_value: 'có giá trị',
                branching_action: 'thì',
                branching_action_show: 'hiển thị câu hỏi này',
                branching_action_hide: 'ẩn câu hỏi này',
                branching_select_condition_question: 'Chọn câu hỏi trước đó',
                branching_select_condition_value: 'Chọn giá trị',
                save: 'Lưu cấu trúc',
                saving: 'Đang lưu...',
                cancel: 'Hủy',
                close: 'Đóng',
                question_text_required: 'Nội dung câu hỏi là bắt buộc.',
                section_title_required: 'Tiêu đề phần là bắt buộc.',
                type_single_choice: 'Lựa chọn duy nhất',
                type_multi_choice: 'Lựa chọn nhiều',
                type_free_text: 'Văn bản tự do',
                type_numeric: 'Số',
                type_date: 'Ngày',
                type_file_upload: 'Tải tệp lên',
                type_yes_no: 'Có / Không',
                preview_heading: 'Xem trước mẫu',
                preview_subtitle: 'Bản xem trước chỉ đọc giống như vendor sẽ thấy.',
                preview_no_content: 'Mẫu này chưa có phần hoặc câu hỏi nào.',
                preview_branching_notice: 'Quy tắc nhánh được đánh giá trong quá trình điền; bản xem trước hiển thị toàn bộ câu hỏi.',
            },
            // Sprint 43.6.0 W3 — Giao diện xét duyệt
            review_modal: {
                title: 'Xét duyệt câu trả lời bảng câu hỏi',
                open_cta: 'Xét duyệt',
                loading: 'Đang tải bảng câu hỏi...',
                template_missing: 'Không tìm thấy mẫu.',
                load_error: 'Không thể tải bảng câu hỏi để xét duyệt.',
                annotation_heading: 'Ghi chú',
                annotation_placeholder: 'Thêm ghi chú của người duyệt cho câu hỏi này...',
                annotation_status_label: 'Trạng thái ghi chú',
                annotation_status_acceptable: 'Chấp nhận được',
                annotation_status_concern: 'Cần lưu ý',
                annotation_status_requires_action: 'Cần hành động',
                review_comments_label: 'Nhận xét tổng thể',
                review_comments_placeholder: 'Tóm tắt kết quả xét duyệt của bạn...',
                justification_label: 'Lý do quyết định',
                justification_placeholder: 'Giải thích căn cứ cho quyết định của bạn...',
                reject_requires_comments: 'Từ chối bảng câu hỏi yêu cầu phải có nhận xét xét duyệt.',
                decision_heading: 'Quyết định',
                decision: {
                    approved: 'Phê duyệt',
                    rejected: 'Từ chối',
                    additional_info_requested: 'Yêu cầu bổ sung thông tin',
                },
                submit: 'Gửi xét duyệt',
                submitting: 'Đang gửi xét duyệt...',
                cancel: 'Hủy',
                submit_success: 'Đã gửi xét duyệt.',
                submit_error: 'Không thể gửi xét duyệt.',
                separation_of_duties_error: 'Bạn không thể xét duyệt bảng câu hỏi mà mình được giao hoàn thành. Nguyên tắc tách biệt trách nhiệm yêu cầu một người duyệt khác.',
                decision_required: 'Vui lòng chọn quyết định xét duyệt.',
                announce_opened: 'Đã mở cửa sổ xét duyệt.',
                announce_submitted: 'Đã gửi xét duyệt.',
            },
            // Sprint 43.6.0 W3 — Nhãn chi tiết phiên bản
            instance_detail: {
                submitted_at: 'Đã nộp',
                reviewed_at: 'Đã xét duyệt',
                reviewer: 'Người duyệt',
                review_decision: 'Quyết định',
                review_comments: 'Nhận xét xét duyệt',
                decision_approved: 'Đã phê duyệt',
                decision_rejected: 'Đã từ chối',
                decision_additional_info_requested: 'Yêu cầu thêm thông tin',
                decision_pending: 'Chờ xét duyệt',
                expand_comments: 'Xem đầy đủ nhận xét',
                collapse_comments: 'Ẩn nhận xét đầy đủ',
                no_reviewer: 'Chưa giao người duyệt',
                earlier_reviews: 'Các lần xét duyệt trước',
                earlier_review_entry: '{decision} bởi {name} vào {date}.',
                earlier_review_comments: 'Nhận xét: {comments}',
                earlier_review_question_note: 'Ghi chú về {question}: {comments}',
                earlier_review_note: 'Ghi chú cho câu hỏi: {comments}',
                earlier_review_unknown_person: 'một người duyệt không được ghi nhận',
                earlier_review_unknown_date: 'một ngày không được ghi nhận',
                // Sprint 62.58.0 gate E12.5 pass 1 (P3-4) — dòng của một lần xét duyệt trước trong tệp xuất.
                earlier_review_export_line: 'Lần xét duyệt trước thứ {index}: {entry}',
                earlier_review_no_decision: 'Chưa ghi nhận quyết định',
            },
            // Sprint 43.6.0 W4 — Xuất tập tin + nhánh
            instance_statuses: {
                draft: 'Nháp',
                in_progress: 'Đang thực hiện',
                submitted: 'Đã nộp',
                under_review: 'Đang xét duyệt',
                approved: 'Đã phê duyệt',
                rejected: 'Đã từ chối',
                expired: 'Đã hết hạn',
            },
            export: {
                portfolio_label: 'Xuất danh mục',
                instance_label: 'Xuất',
                portfolio_success: 'Đã sẵn sàng xuất danh mục.',
                instance_success: 'Đã sẵn sàng xuất bảng câu hỏi.',
                portfolio_error: 'Không thể xuất danh mục bảng câu hỏi.',
                instance_error: 'Không thể xuất bảng câu hỏi.',
                header_line: '{label}: {value}',
                default_title: 'Bảng câu hỏi nhà cung cấp',
                unassigned: 'Chưa giao',
                risk_score_none: 'Chưa có điểm',
                column_question: 'Câu hỏi',
                column_answer: 'Câu trả lời',
                column_evidence: 'Bằng chứng',
                column_annotation: 'Ghi chú của người duyệt',
                section_no_questions: 'Phần này không có câu hỏi.',
                portfolio_title: 'Danh mục bảng câu hỏi nhà cung cấp',
                portfolio_generated: 'Thời điểm tạo',
                portfolio_rows: 'Số dòng',
                portfolio_status_filter: 'Lọc theo trạng thái',
                portfolio_vendor_filter: 'Lọc theo nhà cung cấp',
                portfolio_assignee_filter: 'Lọc theo người được giao',
            },
            branching: {
                hidden_notice: 'Một số câu hỏi đang bị ẩn bởi quy tắc phân nhánh.',
                cycle_warning: 'Phát hiện chu trình trong quy tắc phân nhánh. Các câu hỏi bị ảnh hưởng sẽ mặc định hiển thị.',
            },
        },
        contracts: {
            edit_error: 'Không thể cập nhật hợp đồng',
            edit_success: 'Đã cập nhật hợp đồng',
            edit_contract: 'Sửa chi tiết hợp đồng',
            record_signature: 'Ghi nhận chữ ký',
            signature_section: 'Chữ ký trên hợp đồng này',
            signature_none: 'Chưa ghi nhận chữ ký nào cho hợp đồng này.',
            signatory_name: 'Tên người ký',
            signatory_title: 'Chức danh người ký',
            signatory_party: 'Bên ký',
            signatory_party_organization: 'Tổ chức của chúng ta',
            signatory_party_counterparty: 'Bên đối tác',
            signed_on: 'Ngày ký',
            signature_evidence: 'Tham chiếu bằng chứng',
            signature_evidence_none: 'Hợp đồng này chưa có tham chiếu bằng chứng nào. Hãy đính kèm tài liệu đã ký bên dưới.',
            signature_evidence_attachment: 'Tài liệu đã ký',
            signature_evidence_attachment_hint: 'Tải lên tài liệu đã ký khi không có tham chiếu bằng chứng nào để chọn.',
            signature_evidence_hint: 'Hợp đồng chỉ có hiệu lực khi đã ghi nhận chữ ký, nên chữ ký phải có bằng chứng: chọn tham chiếu bằng chứng đã có trên hợp đồng này hoặc đính kèm tài liệu đã ký.',
            signature_saved: 'Đã ghi nhận chữ ký',
            signature_error: 'Ghi nhận chữ ký thất bại',
            title: 'Hợp đồng',
            new: 'Hợp đồng mới',
            // fix-sprint-20260717-2118-followup F17
            section_contract_details: 'Chi tiết hợp đồng',
            vendor_id: 'Mã Nhà cung cấp',
            document_type: 'Loại tài liệu',
            expiry_date: 'Ngày hết hạn',
            no_contracts: 'Không tìm thấy hợp đồng.',
            all_document_types: 'Tất cả Loại tài liệu',
            load_error: 'Không thể tải hợp đồng',
            create_error: 'Không thể tạo hợp đồng',
            delete_error: 'Không thể xóa hợp đồng',
            update_error: 'Không thể cập nhật trạng thái',
            confirm_delete: 'Xóa hợp đồng "{title}"?',
            renewal_date: 'Ngày gia hạn',
            effective_date: 'Ngày có hiệu lực',
            parties: 'Các bên',
            summary: 'Tóm tắt',
            page_title: 'Hợp đồng nhà cung cấp',
            filter_contracts: 'Lọc hợp đồng',
            filter_by_document_type: 'Lọc theo loại tài liệu',
            filter_by_status: 'Lọc theo trạng thái hợp đồng',
            per_page: 'Hợp đồng mỗi trang',
            expired_notice: 'Hợp đồng này đã hết hạn',
            transition_reason: 'Lý do thay đổi',
            transition_reason_required: 'Phải nêu lý do khi đưa hợp đồng này ra khỏi hiệu lực.',
            transition_reason_placeholder: 'Vì sao hợp đồng này đổi trạng thái?',
            transition_none_available: 'Trạng thái này là trạng thái cuối. Hợp đồng thay thế là một bản ghi mới.',
            n_contracts: '{count} hợp đồng',
            n_contract: '{count} hợp đồng',
            contracts_loaded: '{count} hợp đồng đã tải',
            doc_type_dpa: 'DPA',
            doc_type_security_addendum: 'Phụ lục bảo mật',
            doc_type_scc_annex: 'Phụ lục SCC',
            doc_type_sub_processor_list: 'Danh sách bên xử lý phụ',
            doc_type_bcr: 'BCR',
            doc_type_nda: 'NDA',
            doc_type_msa: 'MSA',
            doc_type_sla: 'SLA',
            doc_type_other: 'Khác',
            status_draft: 'Bản nháp',
            status_under_negotiation: 'Đang đàm phán',
            status_pending_signature: 'Chờ ký',
            status_active: 'Đang hoạt động',
            status_expired: 'Đã hết hạn',
            status_terminated: 'Đã chấm dứt',
            status_superseded: 'Đã thay thế',
            contract_file: 'Tệp',
            upload_contract_file: 'Tệp hợp đồng',
            auto_renew: 'Tự động gia hạn',
            auto_renew_hint: 'Vào ngày hết hạn, hợp đồng được gia hạn thêm một kỳ có cùng độ dài và được ghi vào lịch sử. Hợp đồng không được gia hạn nếu thiếu ngày hiệu lực hoặc thời hạn báo trước gia hạn, hoặc nếu hợp đồng không ở trạng thái hiệu lực.',
            renewal_period_days: 'Báo trước gia hạn (ngày)',
            renewal_period_days_hint: 'Một nhiệm vụ nhắc gia hạn được tạo trước ngày hết hạn đúng số ngày này.',
            clauses_heading: 'Điều khoản',
            clause_title: 'Tiêu đề điều khoản',
            clause_title_required: 'Điều khoản có nội dung cần có tiêu đề.',
            clause_content: 'Nội dung điều khoản',
            clause_mandatory: 'Điều khoản bắt buộc',
            add_clause: 'Thêm điều khoản',
            remove_clause: 'Xóa điều khoản',
            contract_file_save_first: 'Hãy lưu hợp đồng trước. Tệp hợp đồng có thể được đính kèm sau khi hợp đồng đã được tạo.',
            expiry_date_keep_hint: 'Ngày hết hạn, khi đã đặt, có thể được thay đổi nhưng không thể bị xóa.',
            renewal_history: 'Lịch sử gia hạn',
            renewal_history_note: 'Mỗi dòng là một lần gia hạn tự động mà nền tảng thực hiện vì hợp đồng được đặt tự động gia hạn: ngày hết hạn được dời thêm một kỳ hạn.',
            renewal_col_previous_expiry: 'Ngày hết hạn trước',
            renewal_col_new_expiry: 'Ngày hết hạn mới',
            renewal_col_term: 'Kỳ hạn',
            renewal_col_renewed_on: 'Ngày gia hạn',
            renewal_term_months: '{count} tháng',
            renewal_term_days: '{count} ngày',
            clause_field_label: 'Điều khoản {n}, {field}',
            field_other: 'Một trường khác',
        },
        gates: {
            title: 'Cổng Phê duyệt',
            new: 'Đánh giá Cổng mới',
            vendor_id: 'Mã Nhà cung cấp',
            gate_name: 'Tên Cổng',
            outcome: 'Kết quả',
            evaluator: 'Người đánh giá',
            no_gates: 'Không tìm thấy đánh giá cổng.',
            load_error: 'Không thể tải đánh giá cổng',
            evaluate_error: 'Không thể đánh giá cổng nhà cung cấp',
            detail_error: 'Không thể tải chi tiết đánh giá',
            override_error: 'Không thể ghi đè đánh giá cổng',
            criteria_results: 'Kết quả tiêu chí',
            passed: 'Đạt',
            failed: 'Không đạt',
            override: 'Ghi đè',
            override_justification: 'Lý do ghi đè',
            override_placeholder: 'Nhập lý do ghi đè đánh giá cổng này',
            approval_id: 'Mã phê duyệt',
            overall_passed: 'Đạt',
            overall_failed: 'Không đạt',
            overall_overridden: 'Đã ghi đè',
            evaluations_loaded: '{count} đánh giá cổng đã tải',
            page_title: 'Đánh giá cổng',
            evaluate_form: 'Đánh giá cổng nhà cung cấp',
            per_page: 'Đánh giá mỗi trang',
            create_approval_cta: 'Tạo phê duyệt',
        },
        reviews: {
            title: 'Đánh giá Nhà cung cấp',
            new: 'Đánh giá mới',
            vendor_id: 'Mã Nhà cung cấp',
            reviewer: 'Người đánh giá',
            review_type: 'Loại đánh giá',
            outcome: 'Kết quả',
            findings: 'Phát hiện',
            no_reviews: 'Không tìm thấy đánh giá nhà cung cấp.',
            load_kpis_error: 'Không thể tải KPI đánh giá nhà cung cấp',
            load_error: 'Không thể tải đánh giá nhà cung cấp',
            update_error: 'Không thể cập nhật đánh giá nhà cung cấp',
            create_error: 'Không thể tạo đánh giá nhà cung cấp',
            total_reviewed: 'Tổng nhà cung cấp đã đánh giá',
            total_reviews: 'Tổng đánh giá',
            satisfactory: 'Đạt yêu cầu',
            concerns_identified: 'Đã xác định mối lo ngại',
            remediation_required: 'Yêu cầu khắc phục',
            escalated: 'Đã chuyển cấp',
            program_id: 'Mã chương trình',
            period_id: 'Mã kỳ',
            task_id: 'Mã nhiệm vụ',
            recommendations: 'Khuyến nghị',
            // fix-sprint-20260717-2118-followup F9
            section_assignment: 'Phân công',
            section_findings_recommendations: 'Phát hiện và khuyến nghị',
            page_title: 'Đánh giá nhà cung cấp',
            filter_by_outcome: 'Lọc theo kết quả đánh giá',
            per_page: 'Đánh giá mỗi trang',
            kpi_summary: 'Tóm tắt KPI đánh giá',
            review_outcome_label: 'Kết quả đánh giá',
            program_unresolved: 'Chương trình {id} (không có tên)',
            programs_unavailable: 'Không thể liệt kê các chương trình. Hãy nhập mã chương trình.',
            edit_outcome: 'Sửa kết quả đánh giá',
            reviews_loaded: 'Đã tải {count} đánh giá nhà cung cấp',
            reviewed_at: 'Thời điểm rà soát',
        },
        risk_signals: {
            title: 'Tín hiệu Rủi ro',
            new_signal: 'Tín hiệu rủi ro mới',
            signal_type: 'Loại tín hiệu',
            severity: 'Mức độ nghiêm trọng',
            description: 'Mô tả',
            source: 'Nguồn',
            certification_expiry: 'Hết hạn chứng nhận',
            breach_notification: 'Thông báo vi phạm',
            financial_instability: 'Bất ổn tài chính',
            compliance_change: 'Thay đổi tuân thủ',
            custom: 'Tùy chỉnh',
            active: 'Đang hoạt động',
            acknowledged: 'Đã ghi nhận',
            resolved: 'Đã giải quyết',
            no_signals: 'Không tìm thấy tín hiệu rủi ro',
            source_external_feed: 'Nguồn cấp bên ngoài',
            source_manual: 'Thủ công',
            source_integration: 'Tích hợp',
            source_regulatory: 'Quy định',
            source_media: 'Truyền thông',
            page_title: 'Tín hiệu rủi ro',
            vendor_id: 'Mã nhà cung cấp',
            trigger_reassessment_prompt: 'Tín hiệu này có mức độ nghiêm trọng cao. Bắt đầu đánh giá lại nhà cung cấp ngay?',
            reassessment_triggered: 'Đã bắt đầu đánh giá lại.',
            reassessment_trigger_error: 'Không thể bắt đầu đánh giá lại.',
        },
        reassessments: {
            title: 'Nhiệm vụ Đánh giá lại',
            trigger: 'Kích hoạt Đánh giá lại',
            trigger_success: 'Đã kích hoạt đánh giá lại thành công',
            reason: 'Lý do',
            deadline: 'Hạn chót',
            assigned_to: 'Giao cho',
            outcome: 'Kết quả',
            new_risk_level: 'Mức rủi ro mới',
            deadline_hint: 'Hạn chót là cuối ngày đã chọn (giờ UTC).',
            reason_required: 'Nhập lý do.',
            vendor_required: 'Chọn nhà cung cấp.',
            already_completed: 'Lần đánh giá lại này đã được hoàn thành.',
            complete: 'Hoàn thành Đánh giá lại',
            complete_success: 'Đã hoàn thành đánh giá lại thành công',
            pending: 'Chờ xử lý',
            in_progress: 'Đang thực hiện',
            completed: 'Đã hoàn thành',
            cancelled: 'Đã hủy',
            no_tasks: 'Không tìm thấy nhiệm vụ đánh giá lại',
            risk_trend: 'Xu hướng rủi ro',
            notes: 'Ghi chú',
            page_title: 'Nhiệm vụ đánh giá lại',
            vendor_id: 'Mã nhà cung cấp',
        },
        portfolio: {
            title: 'Danh mục Rủi ro',
            dashboard: 'Tổng quan Danh mục',
            total_vendors: 'Tổng Nhà cung cấp',
            average_score: 'Điểm Rủi ro Trung bình',
            high_risk_count: 'Nhà cung cấp Rủi ro Cao',
            trend_direction: 'Hướng Xu hướng',
            improved: 'Cải thiện',
            stable: 'Ổn định',
            degraded: 'Suy giảm',
            vendor_trend: 'Xu hướng Nhà cung cấp',
            outstanding_questionnaires: 'Bảng câu hỏi chưa hoàn thành',
            overdue_assessments: 'Đánh giá quá hạn',
            no_outstanding: 'Không có bảng câu hỏi chưa hoàn thành',
            no_overdue: 'Không có đánh giá quá hạn',
            due_date: 'Ngày đến hạn',
            page_title: 'Danh mục rủi ro',
            vendor_id: 'Mã nhà cung cấp',
        },
        risk_acceptance: {
            expiring_within: 'Hết hạn trong {days} ngày',
            title: 'Sổ Chấp nhận Rủi ro',
            new_acceptance: 'Chấp nhận rủi ro mới',
            risk_level: 'Mức rủi ro',
            conditions: 'Điều kiện',
            justification: 'Lý do chấp nhận',
            expiry_date: 'Ngày hết hạn',
            create_success: 'Đã tạo chấp nhận rủi ro thành công',
            review_condition: 'Xem xét Điều kiện',
            condition_met: 'Điều kiện đạt',
            condition_not_met: 'Điều kiện không đạt',
            review_success: 'Đã xem xét điều kiện thành công',
            export_register: 'Xuất Sổ đăng ký',
            active: 'Đang hoạt động',
            expired: 'Đã hết hạn',
            revoked: 'Đã thu hồi',
            no_acceptances: 'Không tìm thấy chấp nhận rủi ro',
            page_title: 'Sổ chấp nhận rủi ro',
            vendor_id: 'Mã nhà cung cấp',
            met_count: '{met}/{total} đạt',
        },
        review_routing: {
            title: 'Định tuyến Đánh giá',
            route_to_reviewers: 'Chuyển đến Người đánh giá',
            route_success: 'Đã chuyển đến người đánh giá thành công',
            reviewer_id: 'Mã Người đánh giá',
            reviewer_role: 'Vai trò Người đánh giá',
            questionnaire_id: 'Mã Bảng câu hỏi',
            review_status: 'Trạng thái Đánh giá',
            pending: 'Chờ xử lý',
            in_review: 'Đang đánh giá',
            completed: 'Đã hoàn thành',
            no_routing: 'Không tìm thấy định tuyến đánh giá',
            primary_reviewer: 'Người đánh giá chính',
            secondary_reviewer: 'Người đánh giá phụ',
            approver: 'Người phê duyệt',
            page_title: 'Định tuyến đánh giá',
            vendor_id: 'Mã nhà cung cấp',
            reviewers_label: 'Người đánh giá (user_id, vai trò mỗi dòng)',
        },
        onboarding: {
            title: 'Hồ sơ Tiếp nhận Nhà cung cấp',
            page_title: 'Hồ sơ Tiếp nhận Nhà cung cấp',
            new_case: 'Hồ sơ tiếp nhận mới',
            case_detail: 'Hồ sơ Tiếp nhận',
            // Sprint 41.2.0 E8 — UC-VN-14 Step 10 MPS dossier filing from case
            open_mps_dossier_filing: 'Mở hồ sơ MPS',
            dossier_filing_description: 'Tạo hồ sơ MPS mới được điền sẵn từ trường hợp onboarding này. Hồ sơ sẽ được liên kết lại với trường hợp.',
            dossier_filing_dpia_id: 'Mã DPIA',
            dossier_filing_dpia_id_placeholder: 'ví dụ dpia_01TEST000000000000000001',
            dossier_filing_title: 'Tiêu đề hồ sơ',
            dossier_filing_form_type: 'Loại biểu mẫu',
            dossier_filing_submit: 'Tạo hồ sơ',
            dossier_filing_validation_error: 'Cần mã DPIA và tiêu đề.',
            dossier_filing_created: 'Đã tạo hồ sơ MPS',
            dossier_filing_error: 'Không thể tạo hồ sơ MPS.',
            // Sprint 41.2.0 E10 — Enhanced tab summary metadata
            linked_questionnaire_due_date: 'Hạn chót',
            linked_questionnaire_assignee: 'Người được giao',
            linked_questionnaire_submitted_at: 'Đã nộp lúc',
            score_last_scored: 'Lần chấm gần nhất',
            score_dimensions: 'Khía cạnh',
            linked_contract_document_type: 'Loại tài liệu',
            linked_contract_effective_date: 'Ngày hiệu lực',
            linked_contract_expiry_date: 'Ngày hết hạn',
            linked_sub_processor_countries: 'Quốc gia xử lý',
            linked_sub_processor_last_assessment: 'Đánh giá gần nhất',
            linked_sub_processor_next_assessment: 'Đánh giá tiếp theo',
            case_id: 'Mã hồ sơ',
            vendor: 'Nhà cung cấp',
            case_type: 'Loại hồ sơ',
            service_description: 'Mô tả dịch vụ',
            data_categories: 'Danh mục dữ liệu',
            systems_accessed: 'Hệ thống truy cập',
            jurisdiction: 'Khu vực pháp lý',
            hosting_model: 'Mô hình lưu trữ',
            controller_role: 'Vai trò Kiểm soát/Xử lý',
            status_pipeline: 'Quy trình trạng thái',
            tabs_label: 'Các phần hồ sơ tiếp nhận',
            per_page: 'Hồ sơ mỗi trang',
            filter_cases: 'Lọc hồ sơ tiếp nhận',
            cases_count: 'hồ sơ',
            cases_loaded: 'hồ sơ tiếp nhận đã tải',
            no_cases: 'Không tìm thấy hồ sơ tiếp nhận.',
            vendor_lookup_placeholder: 'Nhập mã nhà cung cấp để tra cứu',
            data_categories_placeholder: 'VD: dữ liệu cá nhân, tài chính, sức khỏe',
            systems_placeholder: 'VD: CRM, ERP, Hệ thống HR',
            status_open: 'Mở',
            status_in_progress: 'Đang xử lý',
            status_awaiting_approval: 'Chờ phê duyệt',
            status_approved: 'Đã phê duyệt',
            status_remediation_required: 'Cần khắc phục',
            status_closed: 'Đã đóng',
            type_new_vendor: 'Nhà cung cấp mới',
            type_service_change: 'Thay đổi dịch vụ',
            type_renewal: 'Gia hạn',
            type_reassessment: 'Đánh giá lại',
            tab_overview: 'Tổng quan',
            tab_due_diligence: 'Thẩm định',
            tab_security_assessment: 'Đánh giá bảo mật',
            tab_contractual_controls: 'Kiểm soát hợp đồng',
            tab_sub_processors: 'Bên xử lý phụ',
            tab_approval_gates: 'Cổng phê duyệt',
            tab_evidence: 'Bằng chứng',
            tab_placeholder: 'Nội dung phần này sẽ được điền trong quá trình tiếp nhận.',
            completion_not_started: 'Chưa bắt đầu',
            completion_in_progress: 'Đang thực hiện',
            completion_completed: 'Đã hoàn thành',
            completion_requiring_attention: 'Cần chú ý',
            gate_name: 'Tên cổng',
            approver: 'Người phê duyệt',
            decision: 'Quyết định',
            comments: 'Nhận xét',
            decide: 'Đưa ra quyết định',
            decision_approved: 'Đã phê duyệt',
            decision_rejected: 'Đã từ chối',
            decision_deferred: 'Đã hoãn',
            decision_pending: 'Chờ xử lý',
            no_approvals: 'Chưa có cổng phê duyệt nào cho hồ sơ này.',
            approval_success: 'Đã ghi nhận quyết định phê duyệt',
            approval_error: 'Không thể ghi nhận quyết định phê duyệt',
            transition_status: 'Chuyển trạng thái',
            confirm_transition: 'Chuyển hồ sơ từ "{from}" sang "{to}"?',
            transition_success: 'Đã chuyển trạng thái hồ sơ thành công',
            transition_error: 'Không thể chuyển trạng thái hồ sơ',
            create_success: 'Đã tạo hồ sơ tiếp nhận thành công',
            create_error: 'Không thể tạo hồ sơ tiếp nhận',
            load_error: 'Không thể tải hồ sơ tiếp nhận',
            detail_error: 'Không thể tải chi tiết hồ sơ',
            export: 'Xuất',
            export_error: 'Không thể xuất hồ sơ tiếp nhận',
            evidence_tab_description: 'Tải lên và xuất bằng chứng cho trường hợp onboarding.',
            upload_evidence_label: 'Tải lên bằng chứng',
            attached_evidence_heading: 'Bằng chứng đã đính kèm',
            no_evidence_attached: 'Chưa có bằng chứng nào được đính kèm.',
            export_bundle_button: 'Xuất gói bằng chứng',
            load_attachments_error: 'Không tải được bằng chứng.',
            linked_questionnaires_heading: 'Bảng câu hỏi liên kết',
            no_linked_questionnaires: 'Không có bảng câu hỏi liên kết.',
            linked_scores_heading: 'Điểm rủi ro liên kết',
            no_linked_scores: 'Không có điểm liên kết.',
            latest_score_label: 'Điểm mới nhất',
            linked_contracts_heading: 'Hợp đồng liên kết',
            no_linked_contracts: 'Không có hợp đồng liên kết.',
            linked_sub_processors_heading: 'Nhà xử lý phụ liên kết',
            no_linked_sub_processors: 'Không có nhà xử lý phụ liên kết.',
            approval_created: 'Đã tạo phê duyệt',
            create_approval: 'Tạo phê duyệt',
            export_bundle_success: 'Đã tạo gói bằng chứng',
            gate_type: 'Loại cổng kiểm soát',
            no_recent_bundles: 'Chưa tạo gói bằng chứng nào.',
            recent_bundles: 'Gói gần đây',
            tab_completed: 'Đã đánh dấu hoàn thành phần này',
            tab_gate_not_met: 'Phần này đã được đánh dấu hoàn thành.',
            tab_linked_records_missing: 'Chưa thể đánh dấu hoàn thành phần này: cần ít nhất một {kind}.',
            linked_kind_questionnaire: 'bảng câu hỏi thẩm định chưa hết hạn của nhà cung cấp này',
            linked_kind_risk_score: 'điểm rủi ro của nhà cung cấp này',
            linked_kind_contract: 'hợp đồng đang hoạt động với nhà cung cấp này và có hiệu lực vào hôm nay',
            linked_kind_sub_processor: 'mục bên xử lý phụ được ghi nhận cho hồ sơ này',
            decide_again: 'Quyết định lại',
            resolve_rejection: 'Giải quyết việc từ chối',
            resolution_notes: 'Nội dung giải quyết',
            resolution_notes_hint: 'Bắt buộc. Nêu cách lý do từ chối đã được khắc phục. Quyết định từ chối được lưu trong lịch sử của cổng, và cổng trở về trạng thái chưa quyết định để được quyết định lại.',
            resolution_notes_required: 'Nhập nội dung giải quyết trước khi mở lại cổng.',
            resolve_success: 'Đã giải quyết việc từ chối. Cổng có thể được quyết định lại.',
            resolve_error: 'Không thể giải quyết việc từ chối.',
            prior_gate_blocked: 'Một cổng trước đó đang bị từ chối hoặc hoãn. Hãy quyết định lại cổng đó, hoặc giải quyết việc từ chối, trước.',
            case_gate_blocked: 'Không thể phê duyệt hồ sơ khi có cổng bị từ chối hoặc hoãn.',
            case_gate_undecided: 'Không thể phê duyệt hồ sơ khi còn cổng chưa được quyết định. Hãy quyết định mọi cổng trước.',
            case_final_gate_missing: 'Không thể phê duyệt hồ sơ cho đến khi cổng cuối cùng được tạo và phê duyệt.',
            case_status_changed: 'Hồ sơ hoặc các cổng của hồ sơ đã thay đổi trong khi đang lưu. Thông tin hồ sơ đã được cập nhật; hãy kiểm tra và thử lại.',
            gate_already_decided: 'Cổng này đã được quyết định. Hãy tải lại để xem quyết định.',
            deferred_gate_hint: 'Đã hoãn: cổng này và mọi cổng sau nó chờ đến khi cổng được quyết định lại.',
            mark_complete: 'Đánh dấu hoàn thành',
            earlier_decisions: 'Các quyết định trước đây của cổng này',
            history_entry: '{decision} bởi {name} vào {date}.',
            history_notes: 'Ghi chú: {notes}.',
            history_conditions: 'Điều kiện: {conditions}.',
            history_redecided: 'Được quyết định lại vào {date}.',
            history_resolved: 'Việc từ chối được {name} giải quyết vào {date}: {notes}',
            history_unknown_person: 'một người không được ghi nhận',
            history_unknown_date: 'một ngày không được ghi nhận',
        },
        sub_processors: {
            appointment_decision: 'Quyết định vẫn chỉ định',
            appointment_decision_required: 'Chuỗi DPA chưa hoàn tất. Hãy ghi rõ ai chấp nhận điều đó và vì sao.',
            appointment_decision_placeholder: 'Vì sao chỉ định đơn vị xử lý dữ liệu này trước khi hoàn tất chuỗi DPA?',
            title: 'Sổ đăng ký Bên xử lý phụ',
            page_title: 'Sổ đăng ký Bên xử lý phụ',
            new_record: 'Bên xử lý phụ mới',
            edit_record: 'Sửa Bên xử lý phụ',
            onboarding_case: 'Hồ sơ tiếp nhận',
            services: 'Dịch vụ cung cấp',
            data_categories: 'Danh mục dữ liệu',
            processing_countries: 'Quốc gia xử lý',
            dpa_chain_status: 'Trạng thái chuỗi DPA',
            certifications: 'Chứng nhận',
            last_assessment: 'Đánh giá lần cuối',
            next_assessment: 'Đánh giá tiếp theo',
            change_history: 'Lịch sử thay đổi',
            history: 'Lịch sử',
            changed_by: 'Thay đổi bởi',
            comma_separated: 'Giá trị phân cách bằng dấu phẩy',
            filter_records: 'Lọc bản ghi bên xử lý phụ',
            filter_by_dpa: 'Lọc theo trạng thái chuỗi DPA',
            all_dpa_statuses: 'Tất cả trạng thái DPA',
            per_page: 'Bản ghi mỗi trang',
            records_count: 'bên xử lý phụ',
            records_loaded: 'bản ghi bên xử lý phụ đã tải',
            no_records: 'Không tìm thấy bản ghi bên xử lý phụ.',
            no_history: 'Chưa có lịch sử thay đổi.',
            dpa_active: 'Đang hoạt động',
            dpa_pending: 'Chờ xử lý',
            dpa_expired: 'Đã hết hạn',
            dpa_not_required: 'Không yêu cầu',
            create_success: 'Đã tạo bên xử lý phụ thành công',
            create_error: 'Không thể tạo bên xử lý phụ',
            update_success: 'Đã cập nhật bên xử lý phụ thành công',
            update_error: 'Không thể cập nhật bên xử lý phụ',
            load_error: 'Không thể tải sổ đăng ký bên xử lý phụ',
            history_error: 'Không thể tải lịch sử thay đổi',
            export_csv: 'Xuất CSV',
            export_json: 'Xuất JSON',
            export_error: 'Không thể xuất dữ liệu bên xử lý phụ',
        },
    },
    deletion_orchestration: {
        nav: {
            dashboard: 'Tổng quan điều phối',
            runs: 'Phiên điều phối',
            tasks: 'Nhiệm vụ thực thi',
            templates: 'Mẫu danh sách kiểm tra',
            vendor_requests: 'Yêu cầu nhà cung cấp',
            proof_chain: 'Chuỗi chứng minh',
            dsr_integration: 'Tích hợp DSR',
            vendor_verification: 'Xác minh Nhà cung cấp',
            completeness: 'Tổng quan Hoàn thiện',
        },
        dashboard: {
            title: 'Tổng quan Điều phối',
            loading: 'Đang tải dữ liệu...',
            active_runs: 'Phiên Hoạt động',
            completion_rate: 'Tỷ lệ Hoàn thành',
            avg_completion_time: 'Thời gian TB Hoàn thành',
            overdue_tasks: 'Nhiệm vụ Quá hạn',
            vendor_compliance: 'Tuân thủ Nhà cung cấp',
            vendor_compliance_none: 'Không có yêu cầu nào gửi nhà cung cấp trong 90 ngày qua',
            recent_runs: 'Phiên Gần đây',
            no_recent_runs: 'Không có phiên điều phối gần đây.',
            run_id: 'Mã Phiên',
            ticket_id: 'Mã Yêu cầu',
            progress: 'Tiến độ',
            systems: 'Hệ thống',
            vendors: 'Nhà cung cấp',
            load_error: 'Không thể tải bảng điều khiển điều phối. Vui lòng thử lại.',
            aria_table: 'Các lần chạy điều phối gần đây',
        },
        runs: {
            title: 'Phiên Điều phối',
            new: 'Phiên mới',
            title_label: 'Tiêu đề',
            run_type: 'Loại phiên',
            run_id: 'Mã Phiên',
            ticket_id: 'Mã Yêu cầu',
            progress: 'Tiến độ',
            systems: 'Hệ thống',
            vendors: 'Nhà cung cấp',
            data_subject_ref: 'Tham chiếu Chủ thể dữ liệu',
            data_categories: 'Danh mục Dữ liệu',
            enable_proof_chain: 'Bật Chuỗi chứng minh',
            run_type_labels: {
                data_subject_request: 'Yêu cầu của Chủ thể dữ liệu',
                retention_expiry: 'Hết hạn lưu trữ',
                manual: 'Thủ công',
                scheduled: 'Định kỳ',
            },
            field_guidelines: {
                title: 'Tên mô tả cho phiên điều phối xóa này.',
                run_type: 'Nguồn gốc hoặc lý do kích hoạt quy trình xóa.',
                ticket_id: 'Mã yêu cầu liên quan từ hệ thống DSR hoặc hỗ trợ.',
                data_subject_ref: 'Định danh duy nhất cho chủ thể dữ liệu (vd. ID nội bộ, mã băm email).',
                data_categories: 'Các danh mục dữ liệu cá nhân cụ thể cần xóa (phân cách bằng dấu phẩy).',
                proof_enabled: 'Duy trì chuỗi bằng chứng mật mã không thể thay đổi cho phiên này.',
            },
            start: 'Bắt đầu',
            started: 'Đã bắt đầu chạy',
            mark_ready: 'Đánh dấu sẵn sàng',
            marked_ready: 'Đã đánh dấu sẵn sàng',
            complete: 'Hoàn tất',
            complete_exceptions: 'Hoàn thành với ngoại lệ',
            pause: 'Tạm dừng',
            resume: 'Tiếp tục',
            cancel: 'Hủy',
            no_runs: 'Không tìm thấy phiên điều phối.',
            load_error: 'Không thể tải phiên điều phối. Vui lòng thử lại.',
            create_error: 'Không thể tạo phiên điều phối',
            aria_filter_status: 'Lọc theo trạng thái chạy',
            aria_table: 'Lần chạy điều phối',
            actions: 'Thao tác',
            progress_guideline: 'Được tính dựa trên các nhiệm vụ hệ thống và yêu cầu nhà cung cấp đã hoàn thành.',
            placeholder_title: 'vd. Phiên xóa khách hàng Q2 2026',
            placeholder_ticket_id: 'vd. TKT-000123',
            placeholder_data_subject_ref: 'vd. DS-REF-001',
            placeholder_data_categories: 'vd. personal_data, financial, health',
            cancel_confirm_title: 'Hủy phiên điều phối này?',
            cancel_confirm_body: 'Phiên điều phối {run} sẽ bị hủy. Phiên đã hủy không thể bắt đầu hoặc tiếp tục lại.',
            cancel_reason_label: 'Lý do (không bắt buộc)',
            cancel_reason_hint: 'Được ghi lại cùng việc hủy.',
            cancel_keep: 'Giữ phiên điều phối',
            cancel_confirm: 'Hủy phiên điều phối',
            cancelling: 'Đang hủy…',
            cancelled_success: 'Đã hủy phiên điều phối',
            cancel_error: 'Không thể hủy phiên điều phối.',
            refusal_run_executing: 'Phiên điều phối này đang thực thi và không thể hủy. Hãy tạm dừng trước, rồi hủy.',
            refusal_invalid_status_transition: 'Phiên này không còn ở trạng thái cho phép thay đổi này. Danh sách đã được cập nhật.',
            refusal_run_status_changed: 'Trạng thái của phiên đã thay đổi trong khi đang lưu. Danh sách đã được cập nhật; hãy kiểm tra phiên và thử lại.',
            refusal_cancel_permission_required: 'Việc hủy một phiên xóa cần quyền hủy phiên xóa, và bạn không có quyền này.',
        },
        tasks: {
            title: 'Nhiệm vụ Thực thi',
            task_id: 'Mã Nhiệm vụ',
            run_id: 'Mã Phiên',
            system_name: 'Tên Hệ thống',
            assigned_to: 'Giao cho',
            sla_deadline: 'Hạn SLA',
            progress: 'Tiến độ',
            enter_run_id: 'Nhập Mã Phiên để lọc...',
            select_run: 'Chọn phiên để xem nhiệm vụ',
            unassigned: 'Chưa giao',
            overdue: 'Quá hạn',
            assign_task: 'Giao Nhiệm vụ',
            assignee_id: 'Mã Người nhận',
            update_status: 'Cập nhật Trạng thái',
            new_status: 'Trạng thái mới',
            no_transitions: 'Tác vụ này đang ở trạng thái cuối và không thể đổi trạng thái.',
            select_status_placeholder: 'Chọn trạng thái mới',
            skip_justification: 'Lý do bỏ qua',
            failure_reason: 'Lý do thất bại',
            no_tasks: 'Không tìm thấy nhiệm vụ thực thi.',
            aria_table: 'Nhiệm vụ thực thi',
            aria_filter_status: 'Lọc theo trạng thái nhiệm vụ',
            no_tasks_for_run: 'Phiên xóa dữ liệu này chưa có nhiệm vụ thực thi nào.',
            aria_filter_run_id: 'Lọc theo mã lần chạy',
            status_error: 'Không thể cập nhật trạng thái nhiệm vụ',
            assign_error: 'Không thể giao nhiệm vụ',
            load_error: 'Không thể tải nhiệm vụ thực thi. Vui lòng thử lại.',
            data_classification: 'Phân loại dữ liệu',
            system_id: 'Mã hệ thống',
            new_task: 'Nhiệm vụ mới',
            // Sprint 41.3.0 F2 — step-level evidence
            view_steps: 'Xem các bước',
            steps_modal_title: 'Các bước thực thi',
            step_title: 'Bước',
            step_status: 'Trạng thái bước',
            step_notes: 'Ghi chú',
            step_evidence: 'Tệp bằng chứng',
            step_evidence_required: 'Bước này yêu cầu bằng chứng',
            step_evidence_missing: 'Chưa tải lên bằng chứng',
            step_save: 'Lưu bước',
            step_saved: 'Đã cập nhật bước',
            step_save_error: 'Không thể cập nhật bước',
            create_success: 'Đã tạo nhiệm vụ thực thi',
            create_error: 'Không thể tạo nhiệm vụ thực thi',
            step_upload_label: 'Đính kèm bằng chứng',
            // fix-sprint #431 (gate E12.5 remediation 1) — separation of duties on verification.
            verify_own_task: 'Bạn là người được giao nhiệm vụ này nên một người khác sẽ xác minh.',
            verify_separation_of_duties: 'Bạn không thể xác minh nhiệm vụ mà bạn được giao: một người khác phải xác minh.',
        },
        templates: {
            title: 'Mẫu Danh sách Kiểm tra',
            new: 'Mẫu mới',
            template_id: 'Mã Mẫu',
            system_type: 'Loại Hệ thống',
            est_duration: 'Thời gian ước tính',
            steps: 'Bước',
            action_type: 'Loại Hành động',
            instructions: 'Hướng dẫn',
            mandatory: 'Bắt buộc',
            add_step: 'Thêm Bước',
            step_n: 'Bước',
            no_templates: 'Không tìm thấy mẫu danh sách kiểm tra.',
            all_system_types: 'Tất cả Loại hệ thống',
            load_error: 'Không thể tải mẫu danh sách kiểm tra. Vui lòng thử lại.',
            create_error: 'Không thể tạo mẫu danh sách kiểm tra',
            aria_filter_system_type: 'Lọc theo loại hệ thống',
            aria_filter_status: 'Lọc theo trạng thái mẫu',
            aria_table: 'Mẫu danh sách kiểm tra',
            placeholder_name: 'vd. Danh sách kiểm tra xóa cơ sở dữ liệu',
            guideline_name: 'Dùng tên vận hành rõ ràng, ví dụ “Danh sách kiểm tra xóa cơ sở dữ liệu”.',
            guideline_system_type: 'Chọn nhóm hệ thống mà danh sách kiểm tra này thường được chạy trên đó.',
            guideline_status: 'Mẫu ở trạng thái nháp có thể được rà soát trước khi kích hoạt; mẫu đang hoạt động có thể tái sử dụng trong các lượt chạy.',
            guideline_description: 'Tóm tắt phạm vi, bối cảnh lưu trữ và thời điểm các đội nên chọn mẫu này.',
            update_success: 'Cập nhật mẫu thành công',
            create_success_msg: 'Tạo mẫu thành công',
            update_error: 'Cập nhật mẫu thất bại',
            activate_success: 'Kích hoạt mẫu thành công',
            activate_error: 'Kích hoạt mẫu thất bại',
            archive_success: 'Lưu trữ mẫu thành công',
            archive_error: 'Lưu trữ mẫu thất bại',
            clone_success: 'Nhân bản mẫu thành công',
            clone_error: 'Nhân bản mẫu thất bại',
        },
        vendor_requests: {
            title: 'Yêu cầu Xóa Nhà cung cấp',
            new: 'Yêu cầu mới',
            run: 'Phiên điều phối',
            no_run: 'Không thuộc phiên nào',
            run_hint: 'Không bắt buộc. Yêu cầu gắn với một phiên được tính vào tiến độ của phiên đó.',
            request_id: 'Mã Yêu cầu',
            vendor_name: 'Tên Nhà cung cấp',
            vendor_id: 'Mã Nhà cung cấp',
            data_subject_ref: 'Tham chiếu Chủ thể dữ liệu',
            data_categories: 'Danh mục Dữ liệu',
            legal_basis: 'Cơ sở pháp lý',
            sla_days: 'Số ngày SLA',
            requested_completion: 'Ngày hoàn thành yêu cầu',
            communications: 'Liên lạc',
            total_requests: 'Tổng Yêu cầu',
            no_requests: 'Không tìm thấy yêu cầu xóa nhà cung cấp.',
            filter_vendor_id: 'Lọc theo Mã Nhà cung cấp...',
            change_status: 'Thay đổi Trạng thái',
            new_status: 'Trạng thái Mới',
            actions: 'Hành động',
            load_error: 'Không thể tải yêu cầu xóa nhà cung cấp. Vui lòng thử lại.',
            create_error: 'Không thể tạo yêu cầu xóa nhà cung cấp',
            dashboard_error: 'Không thể tải bảng điều khiển xóa nhà cung cấp. Vui lòng thử lại.',
            aria_filter_status: 'Lọc theo trạng thái yêu cầu',
            aria_filter_vendor_id: 'Lọc theo mã nhà cung cấp',
            aria_table: 'Yêu cầu xóa nhà cung cấp',
            placeholder_vendor_id: 'vd. VND-001',
            placeholder_vendor_name: 'vd. Acme Analytics',
            placeholder_data_subject_ref: 'vd. DS-REF-001',
            placeholder_data_categories: 'vd. personal_data, analytics',
            placeholder_legal_basis: 'vd. Điều 19 PDPL',
            // fix-sprint #431 (gate E12.5 remediation 1) — record the vendor’s confirmation; a failed runs read.
            runs_read_error: 'Không thể đọc danh sách phiên điều phối nên chưa thể chọn phiên. Hãy thử lại, hoặc ghi nhận yêu cầu mà không gắn với phiên nào.',
            confirm_action: 'Ghi nhận xác nhận đã xóa',
            confirm_title: 'Ghi nhận xác nhận đã xóa của nhà cung cấp',
            confirm_intro: 'Ghi nhận việc {vendor} đã xác nhận hoàn tất việc xóa đối với yêu cầu {request}. Khi được ghi nhận, yêu cầu chuyển sang trạng thái Hoàn thành.',
            confirm_date: 'Ngày xác nhận',
            confirm_method: 'Hình thức xác nhận của nhà cung cấp',
            confirm_method_choose: 'Chọn hình thức…',
            confirm_methods: {
                email: 'Email',
                portal: 'Cổng thông tin của nhà cung cấp',
                letter: 'Thư',
                phone: 'Điện thoại',
                other: 'Khác',
            },
            confirm_contact: 'Người liên hệ của nhà cung cấp',
            confirm_systems: 'Các hệ thống bị ảnh hưởng',
            confirm_systems_hint: 'Không bắt buộc. Phân tách các hệ thống bằng dấu phẩy.',
            confirm_notes: 'Ghi chú',
            confirm_submit: 'Ghi nhận xác nhận đã xóa',
            confirm_success: 'Đã ghi nhận xác nhận của nhà cung cấp; yêu cầu đã Hoàn thành.',
            confirm_refused_status: 'Không thể ghi nhận xác nhận cho yêu cầu này: yêu cầu đang là bản nháp, đã bị hủy hoặc đã hoàn thành.',
            confirm_missing_fields: 'Hãy nhập ngày xác nhận, hình thức xác nhận và người liên hệ của nhà cung cấp.',
            confirm_not_found: 'Yêu cầu này không còn tồn tại.',
            confirm_error: 'Không thể ghi nhận xác nhận.',
            confirm_changed: 'Chưa có gì được ghi nhận: yêu cầu đã thay đổi trên máy chủ trong lúc xác nhận này đang được lưu. Danh sách phía sau hộp thoại được đọc lại; hãy kiểm tra yêu cầu ở đó và ghi nhận lại xác nhận nếu yêu cầu vẫn cần.',
        },
        proof_chain: {
            title: 'Trình xem Chuỗi Chứng minh',
            enter_run_id: 'Nhập Mã Phiên...',
            load_chain: 'Tải Chuỗi',
            verify_chain: 'Xác minh Chuỗi',
            verifying: 'Đang xác minh...',
            chain_valid: 'Chuỗi hợp lệ',
            chain_invalid: 'Chuỗi bị đứt',
            chain_length: 'Độ dài Chuỗi',
            broken_at_index: 'Đứt tại vị trí',
            no_proof_records: 'Không tìm thấy bản ghi chứng minh cho phiên này.',
            proof_id: 'Mã Chứng minh',
            entity_type: 'Loại Thực thể',
            entity_id: 'Mã Thực thể',
            event_hash: 'Hash Sự kiện',
            previous_hash: 'Hash Trước đó',
            attestation: 'Chứng thực',
            attestation_actor: 'Được thực hiện bởi',
            attestation_signed_at: 'Thời điểm ký',
            attestation_signature: 'Chữ ký',
            attestation_evidence_refs: 'Tham chiếu bằng chứng',
            run_field_label: 'Phiên xóa dữ liệu',
            select_run: 'Chọn một phiên xóa dữ liệu…',
            aria_select_run: 'Phiên xóa dữ liệu để tra cứu chuỗi bằng chứng',
            chain_broken_here: 'Chuỗi đứt tại đây',
            load_error: 'Không thể tải chuỗi chứng minh. Vui lòng thử lại.',
            verify_error: 'Không thể xác minh chuỗi chứng minh. Vui lòng thử lại.',
            aria_run_id: 'Mã lần chạy để tra cứu chuỗi chứng minh',
            // Một giá trị hiển thị mà giá trị băm của sự kiện không bảo vệ.
            not_covered_by_hash: 'không được bảo vệ bằng giá trị băm',
            // Sprint 62.35.0 (AC8) — thông tin xác định trên hồ sơ tiêu hủy.
            destruction: {
                action: 'Ghi nhận tiêu hủy',
                modal_title: 'Ghi nhận tiêu hủy',
                intro: 'Xác định dữ liệu mà phiên xóa này đã tiêu hủy. Hồ sơ được thêm vào chuỗi chứng minh và được bảo vệ bằng giá trị băm của chuỗi, nên không thể thay đổi sau khi lưu.',
                section_title: 'Hồ sơ tiêu hủy',
                name: 'Tên',
                type: 'Loại',
                size: 'Dung lượng (byte)',
                format: 'Định dạng',
                locations: 'Vị trí lưu trữ',
                locations_hint: 'Mỗi dòng một vị trí. Liệt kê mọi bản sao, bao gồm bản sao lưu, bản nhân bản và bản xuất.',
                identifier: 'Mã định danh',
                hash: 'Giá trị băm (hash)',
                hash_algorithm: 'Thuật toán băm',
                hash_algorithm_hint: 'Bắt buộc khi có giá trị băm, ví dụ SHA-256.',
                lawful_data_unaffected: 'Dữ liệu hợp pháp không bị ảnh hưởng',
                lawful_yes: 'Có, dữ liệu hợp pháp không bị ảnh hưởng',
                lawful_no: 'Không, dữ liệu hợp pháp đã bị ảnh hưởng',
                lawful_not_recorded: 'Chưa ghi nhận',
                lawful_data_note: 'Ghi chú về dữ liệu hợp pháp',
                lawful_data_note_hint: 'Bắt buộc khi dữ liệu hợp pháp bị ảnh hưởng.',
                yes: 'Có',
                no: 'Không',
                not_recorded: 'Chưa ghi nhận',
                submit: 'Ghi nhận tiêu hủy',
                saving: 'Đang ghi nhận…',
                saved: 'Đã thêm hồ sơ tiêu hủy vào chuỗi chứng minh.',
                save_error: 'Không thể lưu hồ sơ tiêu hủy.',
                err_required: 'Trường này là bắt buộc.',
                err_locations: 'Nhập ít nhất một vị trí lưu trữ.',
                err_size: 'Nhập số byte, từ 0 trở lên.',
                err_hash_algorithm: 'Nhập thuật toán đã dùng để tính giá trị băm này.',
                err_algorithm_without_hash: 'Xóa thuật toán, hoặc nhập giá trị băm tương ứng.',
                err_lawful_note: 'Giải thích dữ liệu hợp pháp đã bị ảnh hưởng như thế nào.',
            },
        },
        dsr_integration: {
            change_status: 'Đổi trạng thái',
            request_type: 'Loại yêu cầu',
            data_subject_hint: 'Mã định danh của chủ thể dữ liệu sẽ bị xóa (ví dụ: email hoặc mã khách hàng). Thường trùng với người yêu cầu trên hồ sơ DSR đã chọn.',
            title: 'Tích hợp Xóa DSR',
            create_run: 'Tạo Phiên xóa DSR',
            dsr_case_id: 'Mã Vụ việc DSR',
            data_subject_id: 'Mã Chủ thể dữ liệu',
            systems: 'Hệ thống Mục tiêu',
            route_to_department: 'Chuyển đến Phòng ban',
            confirm_deletion: 'Xác nhận Xóa',
            no_runs: 'Không tìm thấy phiên xóa DSR',
            status: 'Trạng thái Xóa',
            deadline: 'Hạn chót',
            no_further_status_changes: 'Không thể đổi trạng thái thêm',
            refusal_run_executing: 'Phiên xóa này đang được thực hiện và không thể hủy. Thay vào đó, hãy hoàn thành phiên, có hoặc không có ngoại lệ.',
        },
        vendor_verification: {
            title: 'Xác minh Xóa Nhà cung cấp',
            create_followup: 'Tạo Theo dõi',
            deadline: 'Hạn Xác nhận',
            escalation_contact: 'Liên hệ Leo thang',
            escalate: 'Leo thang',
            confirm_escalate_followup: 'Leo thang theo dõi này? Trạng thái chuyển thành Đã leo thang. Không có gì được gửi đến nhà cung cấp hoặc người liên hệ leo thang.',
            no_followups: 'Không tìm thấy theo dõi nhà cung cấp',
            vendor_request: 'Yêu cầu nhà cung cấp',
            vendor: 'Nhà cung cấp',
            unknown_vendor: 'Nhà cung cấp không xác định',
            overdue_badge: 'Quá hạn',
            mark_confirmed: 'Đánh dấu Đã xác nhận',
            mark_confirmed_for: 'Đánh dấu đã xác nhận xóa cho {vendor}',
            confirm_mark_followup_confirmed: 'Đánh dấu theo dõi này là đã xác nhận? Yêu cầu xóa gửi nhà cung cấp không thay đổi; hãy ghi nhận cả xác nhận của nhà cung cấp tại Yêu cầu nhà cung cấp.',
            confirmation_success: 'Đã đánh dấu theo dõi là đã xác nhận',
            confirmation_failed: 'Không thể đánh dấu theo dõi là đã xác nhận',
            select_request: 'Chọn một yêu cầu nhà cung cấp…',
            escalation_contact_placeholder: 'ví dụ: dpo@vendor.example',
            create_success: 'Đã tạo theo dõi nhà cung cấp thành công',
            create_failed: 'Không thể tạo theo dõi nhà cung cấp',
            deadline_help: 'Ngày bạn mong nhà cung cấp xác nhận. Mọi theo dõi đều được liệt kê; theo dõi đang chờ xử lý đã qua ngày này được đánh dấu Quá hạn.',
            // fix-sprint-20260411-D F7 — semantic toast/announce keys
            escalation_success: 'Đã leo thang theo dõi',
            escalation_failed: 'Không thể leo thang theo dõi',
            overdue_filter: 'Quá hạn (chờ xử lý, đã qua hạn)',
            status_labels: {
                pending: 'Chờ xử lý',
                confirmed: 'Đã xác nhận',
                escalated: 'Đã leo thang',
            },
        },
        completeness: {
            title: 'Hoàn thiện Xóa',
            check_conflicts: 'Kiểm tra Xung đột Lưu giữ',
            no_conflicts: 'Không tìm thấy xung đột lưu giữ',
            conflict_resolution: 'Giải quyết Xung đột',
            extend_retention: 'Gia hạn Lưu giữ',
            proceed_deletion: 'Tiến hành Xóa',
            escalate_conflict: 'Leo thang',
            resolve: 'Giải quyết Xung đột',
            data_subject_id: 'Mã chủ thể dữ liệu',
            placeholder_data_subject_id: 'Nhập mã chủ thể dữ liệu',
            data_subject_hint: 'Mã định danh của người mà bạn đang kiểm tra việc xóa dữ liệu (ví dụ: email, mã khách hàng hoặc mã hồ sơ DSR). Chọn một đối tượng đã có hoặc tự nhập.',
            guidance: 'Nhập hoặc chọn mã đối tượng dữ liệu, tùy chọn chọn hệ thống, rồi chạy kiểm tra để xem mức độ hoàn tất xóa và xung đột lưu giữ.',
            completion: 'Mức độ hoàn tất xóa',
            pending_items: 'Mục đang chờ',
            system: 'Hệ thống',
            policy: 'Chính sách',
            retention_end: 'Hết thời hạn lưu trữ',
            completed_items: 'Mục đã Hoàn thành',
            days_ago: 'ngày trước',
            last_review_label: 'Lần rà soát cuối',
            review_overdue: 'Chu kỳ rà soát đã vượt quá. Cần rà soát lại.',
            conflicts_not_checked: 'Chưa kiểm tra xung đột lưu giữ vì chưa chọn hệ thống nào. Hãy chọn ít nhất một hệ thống rồi chạy lại phép kiểm tra để xem.',
        },
        run_status_labels: {
            pending: 'Chờ xử lý',
            planning: 'Lập kế hoạch',
            ready: 'Sẵn sàng',
            in_progress: 'Đang thực hiện',
            paused: 'Tạm dừng',
            completed: 'Hoàn thành',
            completed_with_exceptions: 'Hoàn thành có ngoại lệ',
            cancelled: 'Đã hủy',
        },
        task_status_labels: {
            pending: 'Chờ xử lý',
            assigned: 'Đã giao',
            in_progress: 'Đang thực hiện',
            awaiting_verification: 'Chờ xác minh',
            verified: 'Đã xác minh',
            failed: 'Thất bại',
            skipped: 'Bỏ qua',
        },
        system_type_labels: {
            database: 'Cơ sở dữ liệu',
            saas_application: 'Ứng dụng SaaS',
            file_storage: 'Lưu trữ Tệp',
            email_system: 'Hệ thống Email',
            analytics_platform: 'Nền tảng Phân tích',
            backup_system: 'Hệ thống Sao lưu',
            vendor_managed: 'Nhà cung cấp Quản lý',
            custom: 'Tùy chỉnh',
        },
        template_status_labels: {
            draft: 'Bản nháp',
            active: 'Hoạt động',
        },
        action_type_labels: {
            manual_check: 'Kiểm tra Thủ công',
            api_call: 'Gọi API',
            sql_query: 'Truy vấn SQL',
            script_execution: 'Thực thi Script',
            file_deletion: 'Xóa Tệp',
            verification: 'Xác minh',
            notification: 'Thông báo',
            approval: 'Phê duyệt',
        },
        request_status_labels: {
            draft: 'Bản nháp',
            sent: 'Đã gửi',
            acknowledged: 'Đã xác nhận tiếp nhận',
            in_progress: 'Đang thực hiện',
            completed: 'Hoàn thành',
            overdue: 'Quá hạn',
            escalated: 'Đã leo thang',
            disputed: 'Tranh chấp',
            cancelled: 'Đã hủy',
        },
        event_type_labels: {
            initiation: 'Khởi tạo',
            data_deletion: 'Xóa Dữ liệu',
            completion: 'Hoàn thành',
            verification: 'Xác minh',
            rollback: 'Hoàn tác',
        },
        count_labels: {
            one_template: '1 mẫu',
            n_templates: '{n} mẫu',
            one_run: '1 phiên',
            n_runs: '{n} phiên',
            one_task: '1 nhiệm vụ',
            n_tasks: '{n} nhiệm vụ',
            one_request: '1 yêu cầu',
            n_requests: '{n} yêu cầu',
        },
        aria: {
            completion_rate: 'Tỷ lệ hoàn thành: {pct}%',
            vendor_compliance: 'Tuân thủ nhà cung cấp: {pct}%',
            run_progress: 'Tiến độ phiên: {pct}%',
            run_progress_systems: 'Tiến độ phiên: {completed} trên {total} hệ thống đã xử lý',
            chain_broken: 'Chuỗi đứt tại bản ghi này',
            chain_valid: 'Chuỗi hợp lệ tại bản ghi này',
            chain_unknown: 'Trạng thái chuỗi không xác định',
            escalate_vendor: 'Leo thang {id}',
            resolve_conflict: 'Giải quyết xung đột cho {system}',
        },
        regulatory: {
            annual_review_cycle_info: 'Tính đầy đủ của việc xóa phải được xem xét ít nhất mỗi 365 ngày. Các bản ghi vượt ngưỡng được đánh dấu xem xét lại bắt buộc.',
            runs_data_d1_lifecycle_info: 'Trạng thái phên ánh xạ tới vòng đời DATA-D1: lập kế hoạch = danh mục, sẵn sàng = phân loại, đang thực hiện = áp dụng quy tắc, hoàn thành = bằng chứng đã tạo.',
            vendor_record_linkage_info: 'Mỗi yêu cầu xóa nhà cung cấp được liên kết với bản ghi nhà cung cấp qua vendor_id. Xác nhận hoàn thành yêu cầu bằng chứng mật mã từ chuỗi chứng minh.',
            templates_internal_classification_info: 'Tất cả mẫu danh sách kiểm tra xóa là tài liệu nội bộ tổ chức. Không mang mã biểu mẫu pháp quy và không nên nộp làm hồ sơ pháp quy.',
            proof_chain_evidence_info: 'Mỗi bản ghi ghi lại chủ thể/danh mục dữ liệu, dấu thời gian, tác nhân, cơ sở pháp lý và mã băm SHA-256. Tạo bằng chứng xóa mật mã đáp ứng yêu cầu kiểm toán.',
            retention_data_law_info: 'Lịch lưu giữ được rút ra từ phân loại Luật Dữ liệu. Khi phân loại thay đổi, quy tắc lưu giữ liên kết tự động cập nhật.',
            dsr_erasure_route_info: 'Phiên xóa DSR liên kết với yêu cầu quyền gốc. Thời hạn pháp quy (30 ngày theo GDPR Điều 17) được theo dõi tự động. Trường hợp quá hạn được leo thang.',
        },
    },
    discovery: {
        nav: {
            dashboard: 'Tổng quan khám phá',
            scans: 'Quét khám phá',
            staging_area: 'Khu vực tạm',
            dedup_rules: 'Quy tắc trùng lặp',
            classification_rules: 'Quy tắc phân loại',
            suggestions: 'Hàng đợi đề xuất',
            analytics: 'Phân tích đề xuất',
            import_templates: 'Mẫu nhập',
            connectors: 'Quản lý kết nối',
            discovery_cycles: 'Chu kỳ Khám phá',
            owner_review: 'Xem xét Chủ sở hữu',
            classification_lineage: 'Lịch sử Phân loại',
        },
        dashboard: {
            title: 'Tổng quan Khám phá',
            loading: 'Đang tải dữ liệu...',
            total_scans: 'Tổng Quét',
            active_scans: 'Quét Hoạt động',
            completed_30d: 'Hoàn thành (30 ngày)',
            failed_30d: 'Thất bại (30 ngày)',
            systems_discovered: 'Hệ thống Phát hiện',
            pending_staged_records: 'Bản ghi Tạm Đang chờ',
            recent_scans: 'Quét Gần đây',
            no_recent_scans: 'Không có quét gần đây.',
            scan_id: 'Mã Quét',
            discovered: 'Phát hiện',
            view_all_scans: 'Xem tất cả Quét',
            staging_area: 'Khu vực Tạm',
            suggestion_queue: 'Hàng đợi Đề xuất',
            records_reviewed: 'Bản ghi đã xem xét',
            records_approved: 'Bản ghi đã duyệt',
            exceptions_pending: 'Ngoại lệ chờ xử lý',
            view_as_chart: 'Xem dạng biểu đồ',
            view_as_table: 'Xem dạng bảng',
        },
        common_labels: {
            n_rules: '{n} quy tắc',
            one_rule: '1 quy tắc',
            n_scans: '{n} lần quét',
            one_scan: '1 lần quét',
            n_syncs: '{n} lần đồng bộ',
            one_sync: '1 lần đồng bộ',
            n_records: '{n} bản ghi',
            one_record: '1 bản ghi',
            n_templates: '{n} mẫu',
            one_template: '1 mẫu',
            n_suggestions: '{n} đề xuất',
            one_suggestion: '1 đề xuất',
            n_selected: '{n} đã chọn',
            dashboard_loaded: 'Đã tải bảng điều khiển khám phá',
            n_scans_loaded: 'Đã tải {n} lần quét',
            n_staged_records_loaded: 'Đã tải {n} bản ghi tạm',
            confirm_delete_import_template: 'Bạn có chắc chắn muốn xóa mẫu nhập này không?',
            invalid_json_source_config: 'JSON không hợp lệ trong source_config',
            scope_organization: 'Tổ chức',
            scope_department: 'Phòng ban',
            scope_system: 'Hệ thống',
            aria_filter_scans: 'Lọc lần quét',
            aria_filter_staged_records: 'Lọc bản ghi tạm',
            aria_filter_suggestions: 'Bộ lọc',
            aria_filter_by_taxonomy_id: 'Lọc theo mã phân loại',
            aria_filter_by_enabled_status: 'Lọc theo trạng thái bật',
            aria_filter_by_source_type: 'Lọc theo loại nguồn',
            aria_filter_by_promotion_status: 'Lọc theo trạng thái thăng cấp',
            aria_filter_by_dedup_status: 'Lọc theo trạng thái trùng lặp',
            aria_filter_by_scan_type: 'Lọc theo loại quét',
            aria_filter_by_status: 'Lọc theo trạng thái',
            aria_filter_by_confidence: 'Lọc theo dải độ tin cậy',
            aria_select_all_records: 'Chọn tất cả bản ghi',
            aria_select_record: 'Chọn bản ghi {id}',
            aria_select_all_suggestions: 'Chọn tất cả đề xuất',
            aria_select_suggestion: 'Chọn đề xuất {id}',
            aria_promote_record: 'Thăng cấp bản ghi {id}',
            aria_discard_record: 'Loại bỏ bản ghi {id}',
            aria_merge_record: 'Hợp nhất bản ghi {id}',
            aria_review_record: 'Xem xét bản ghi {id}',
            aria_accept_suggestion: 'Chấp nhận đề xuất {id}',
            aria_reject_record: 'Từ chối bản ghi',
            aria_merge_record_dialog: 'Hợp nhất bản ghi',
            aria_create_new_scan: 'Tạo lần quét mới',
            aria_sync_progress: 'Tiến độ đồng bộ: {processed}/{total} mục đã xử lý',
            aria_scan_progress: 'Tiến độ quét: {processed}/{total} mục đã xử lý',
            aria_confidence: 'Độ tin cậy: {pct}%',
            aria_effectiveness: 'Hiệu quả: {pct}',
            aria_promote_n_records: 'Thăng cấp {n} bản ghi đã chọn',
            aria_discard_n_records: 'Loại bỏ {n} bản ghi đã chọn',
            placeholder_pii_detection_rule: 'vd. Quy tắc phát hiện PII',
            placeholder_tax_id: 'vd. TAX-001',
            placeholder_lvl_id: 'vd. LVL-001',
            placeholder_service_type: 'vd. service_type',
            placeholder_database: 'vd. database',
            placeholder_hostname_match: 'vd. Khớp chính xác Hostname',
            placeholder_hostname: 'vd. hostname',
            placeholder_hr_systems_csv: 'vd. Nhập CSV Hệ thống HR',
            placeholder_server_name: 'vd. Tên Máy chủ',
            placeholder_hostname_field: 'vd. hostname',
            placeholder_lowercase: 'vd. lowercase',
            placeholder_source_config: '{"host": "...", "port": 443}',
            placeholder_stg_id: 'vd. STG-000123',
            placeholder_lvl_002: 'vd. LVL-002',
            placeholder_usr_id: 'vd. USR-000123',
            decision_for: 'Quyết định cho {id}',
        },
        scans: {
            title: 'Quét Khám phá',
            new: 'Quét mới',
            scan_id: 'Mã Quét',
            scan_type: 'Loại Quét',
            progress: 'Tiến độ',
            discovered: 'Phát hiện',
            no_scans: 'Không tìm thấy quét khám phá.',
            all_scan_types: 'Tất cả Loại quét',
            source_config: 'Cấu hình nguồn (JSON)',
            invalid_json: 'JSON không hợp lệ trong cấu hình nguồn',
            load_error: 'Không thể tải quét khám phá. Vui lòng thử lại.',
            create_error: 'Không thể tạo quét khám phá',
            actions: 'Thao tác',
            new_status: 'Trạng thái mới',
            change_status: 'Đổi trạng thái',
            type_endpoint: 'Điểm cuối',
            type_spreadsheet_import: 'Nhập bảng tính',
            type_cmdb_sync: 'Đồng bộ CMDB',
            type_cloud_sync: 'Đồng bộ đám mây',
            status_pending: 'Chờ xử lý',
            status_running: 'Đang chạy',
            status_completed: 'Hoàn thành',
            status_failed: 'Thất bại',
            status_cancelled: 'Đã hủy',
            source_config_placeholder: '{"host": "...", "port": 443}',
            adapter_not_implemented_toast: 'Loại quét này chưa khả dụng. Chỉ có thể tạo quét điểm cuối.',
            adapter_not_implemented_warning: 'Chưa khả dụng. Không thể tạo quét loại này cho đến khi tính năng được phát hành.',
            source_config_endpoint_help: 'Cung cấp danh sách tên miền đầy đủ (FQDN) trong mảng "domains". Tiến trình sẽ phân giải DNS (CNAME / MX / TXT / A) và dò HTTPS / HTTP cho từng tên miền.',
            source_config_example_label: 'Ví dụ:',
            source_config_spreadsheet_help: 'Cung cấp file_id của tệp CSV / XLSX đã tải lên trước đó và template_id của mẫu nhập liệu có ánh xạ cột tương ứng.',
            placeholder_source_config: '{"domains": ["example.com"]}',
        },
        staging_area: {
            title: 'Khu vực Tạm',
            record_id: 'Mã Bản ghi',
            source_scan: 'Quét Nguồn',
            entity_type: 'Loại Thực thể',
            suggested_name: 'Tên Đề xuất',
            confidence: 'Độ tin cậy',
            no_records: 'Không tìm thấy bản ghi tạm.',
            promote: 'Thăng cấp',
            discard: 'Loại bỏ',
            review: 'Xem xét',
            merge: 'Gộp',
            merge_target_id: 'Mã đích gộp',
            reject_reason_placeholder: 'Lý do từ chối...',
            promotion_status: 'Trạng thái thăng cấp',
            dedup_status: 'Trạng thái loại trùng',
            all_source_types: 'Tất cả loại nguồn',
            all_promotion_statuses: 'Tất cả trạng thái thăng cấp',
            all_dedup_statuses: 'Tất cả trạng thái loại trùng',
            load_error: 'Không thể tải bản ghi tạm. Vui lòng thử lại.',
            promote_error: 'Không thể thăng cấp bản ghi',
            reject_error: 'Không thể từ chối bản ghi',
            merge_error: 'Không thể gộp bản ghi',
            review_error: 'Không thể đánh dấu bản ghi để xem xét',
            bulk_promote_error: 'Không thể thăng cấp hàng loạt bản ghi',
            bulk_reject_error: 'Không thể từ chối hàng loạt bản ghi',
            service_type_web_server: 'Máy chủ web',
            service_type_database: 'Cơ sở dữ liệu',
            service_type_api_gateway: 'Cổng API',
            service_type_storage: 'Lưu trữ',
            service_type_authentication: 'Xác thực',
            service_type_analytics: 'Phân tích',
            service_type_unknown: 'Không xác định',
            merge_title: 'Hợp nhất bản ghi',
            source_type_endpoint_scan: 'Quét điểm cuối',
            source_type_spreadsheet: 'Bảng tính',
            source_type_cmdb: 'CMDB',
            source_type_cloud_inventory: 'Kho đám mây',
            promotion_status_new: 'Mới',
            promotion_status_under_review: 'Đang xem xét',
            promotion_status_promoted: 'Đã thăng cấp',
            promotion_status_rejected: 'Đã từ chối',
            promotion_status_merged: 'Đã gộp',
            dedup_status_unmatched: 'Không khớp',
            dedup_status_potential_match: 'Khớp tiềm năng',
            dedup_status_exact_match: 'Khớp chính xác',
            dedup_status_resolved: 'Đã giải quyết',
            confirm_bulk_reject: 'Bạn có chắc chắn muốn từ chối các bản ghi đã chọn không?',
            scan_batch_id: 'Mã lô',
            promote_to_registry_title: 'Thăng cấp vào Đăng ký Dữ liệu',
            promote_modal_instructions: 'Tạo một mục Đăng ký Dữ liệu với collection_method: observed và liên kết xuất xứ với bản ghi khám phá này. Mục này bắt đầu ở trạng thái draft để xem xét.',
            promote_label_category: 'Danh mục',
            promote_label_name_override: 'Tên (ghi đè tùy chọn)',
            placeholder_name_override: 'Mặc định là tên/hostname của bản ghi khám phá',
            promote_label_sensitivity: 'Mức độ nhạy cảm đề xuất',
            inherit_from_category: 'Kế thừa từ danh mục',
            dedup_status_help: 'Cho biết mục được phát hiện này đã có trong danh mục hay chưa. Không khớp = có thể đưa vào danh mục; Có thể trùng / Trùng khớp = hãy rà soát hoặc hợp nhất trước.',
            promote_to_registry: 'Đưa vào danh mục',
            promotion_status_help: 'Vị trí của bản ghi này trong quy trình rà soát: Mới → Đang rà soát → Đã đưa vào danh mục (hoặc Bị từ chối / Đã hợp nhất).',
            route_to_owner: 'Chuyển cho người phụ trách',
            route_to_owner_error: 'Không chuyển được cho người phụ trách.',
            route_to_owner_success: 'Đã tạo nhiệm vụ rà soát cho người phụ trách. Mở mục Rà soát của người phụ trách để xử lý.',
            service_type: 'Loại dịch vụ',
        },
        dedup_rules: {
            title: 'Quy tắc Loại trùng',
            new: 'Quy tắc mới',
            rule_name: 'Tên Quy tắc',
            match_fields: 'Trường Khớp',
            threshold: 'Ngưỡng',
            no_rules: 'Không tìm thấy quy tắc loại trùng.',
            seed_defaults: 'Nạp mặc định',
            match_type: 'Loại khớp',
            similarity_threshold: 'Ngưỡng tương đồng',
            field_name: 'Tên trường',
            load_error: 'Không thể tải quy tắc loại trùng. Vui lòng thử lại.',
            create_error: 'Không thể tạo quy tắc loại trùng',
            toggle_error: 'Không thể bật/tắt quy tắc loại trùng',
            seed_error: 'Không thể nạp mặc định',
            priority: 'Mức ưu tiên',
            enabled_status: 'Đã bật',
            disabled_status: 'Đã tắt',
            default_badge: 'Mặc định',
            enable: 'Bật',
            disable: 'Tắt',
            match_type_exact: 'Chính xác',
            match_type_fuzzy: 'Mờ',
            match_type_regex: 'Biểu thức chính quy',
            match_type_ip_range: 'Dải IP',
            threshold_validation: 'Phải là một số trong khoảng từ 0 đến 1',
        },
        classification_rules: {
            title: 'Quy tắc Phân loại',
            new: 'Quy tắc mới',
            rule_name: 'Tên Quy tắc',
            pattern: 'Mẫu',
            classification: 'Phân loại',
            no_rules: 'Không tìm thấy quy tắc phân loại.',
            seed_defaults: 'Nạp mặc định',
            run_rules_now: 'Chạy quy tắc ngay',
            run_rules_success: 'Đã tạo {count} đề xuất phân loại mới',
            run_rules_no_results: 'Không có đề xuất mới — tất cả quy tắc khớp đã có đề xuất đang chờ',
            run_rules_error: 'Không thể chạy quy tắc phân loại. Vui lòng thử lại.',
            taxonomy_id: 'Mã phân loại',
            level_id: 'Mã cấp độ',
            condition_logic: 'Logic điều kiện',
            weight: 'Trọng số',
            conditions: 'Điều kiện',
            condition_field: 'Trường',
            condition_operator: 'Toán tử',
            condition_value: 'Giá trị',
            effectiveness: 'Hiệu quả',
            match_count: 'Số khớp',
            approval_count: 'Phê duyệt',
            rejection_count: 'Từ chối',
            filter_taxonomy: 'Lọc theo mã phân loại...',
            load_error: 'Không thể tải quy tắc phân loại. Vui lòng thử lại.',
            create_error: 'Không thể tạo quy tắc phân loại',
            seed_error: 'Không thể nạp mặc định',
            toggle_error: 'Không thể bật/tắt quy tắc. Vui lòng thử lại.',
            priority: 'Mức ưu tiên',
            enabled_status: 'Đã bật',
            disabled_status: 'Đã tắt',
            enable: 'Bật',
            disable: 'Tắt',
            logic_and: 'VÀ',
            logic_or: 'HOẶC',
            operator_equals: 'Bằng',
            operator_contains: 'Chứa',
            operator_matches_regex: 'Khớp Regex',
            operator_in_list: 'Trong danh sách',
            operator_not_equals: 'Không bằng',
            operator_not_contains: 'Không chứa',
            enabled_label: 'Đã bật',
            disabled_label: 'Đã tắt',
            taxonomy_label: 'Phân loại',
            operator_label: 'Toán tử',
            value_label: 'Giá trị',
            conditions_description: 'Xác định các dấu hiệu phải khớp trước khi áp dụng phân loại này.',
        },
        suggestions: {
            title: 'Hàng đợi Đề xuất',
            entity_type: 'Loại Thực thể',
            suggested_name: 'Tên Đề xuất',
            source: 'Nguồn',
            confidence: 'Độ tin cậy',
            accept: 'Chấp nhận',
            reject: 'Từ chối',
            no_suggestions: 'Không có đề xuất trong hàng đợi.',
            modify_approve: 'Chỉnh sửa & Phê duyệt',
            delegate: 'Ủy quyền',
            delegate_user_id: 'Mã người dùng được ủy quyền',
            new_level_id: 'Mã cấp độ mới',
            reject_reason_placeholder: 'Lý do từ chối...',
            current_level: 'Cấp độ hiện tại',
            suggested_level: 'Cấp độ đề xuất',
            filter_taxonomy: 'Lọc theo mã phân loại...',
            all_confidence: 'Tất cả mức tin cậy',
            load_error: 'Không thể tải đề xuất. Vui lòng thử lại.',
            approve_error: 'Không thể phê duyệt đề xuất',
            reject_error: 'Không thể từ chối đề xuất',
            modify_error: 'Không thể chỉnh sửa & phê duyệt đề xuất',
            delegate_error: 'Không thể ủy quyền đề xuất',
            bulk_approve_error: 'Không thể phê duyệt hàng loạt đề xuất',
            bulk_reject_error: 'Không thể từ chối hàng loạt đề xuất',
            suggestion_type_new_label: 'Nhãn mới',
            suggestion_type_validation: 'Xác thực',
            suggestion_type_reclassification: 'Phân loại lại',
            status_pending: 'Chờ xử lý',
            status_approved: 'Đã duyệt',
            status_rejected: 'Đã từ chối',
            status_superseded: 'Đã thay thế',
            confidence_high: 'Cao',
            confidence_medium: 'Trung bình',
            confidence_low: 'Thấp',
            confirm_bulk_reject: 'Bạn có chắc chắn muốn từ chối các gợi ý đã chọn không?',
            unknown_level_tooltip: 'Quy tắc này tham chiếu tới một mức không còn được định nghĩa trong bộ phân loại.',
            all_taxonomies: 'Tất cả phân loại',
        },
        analytics: {
            title: 'Phân tích Đề xuất',
            total_suggestions: 'Tổng Đề xuất',
            accepted: 'Đã chấp nhận',
            rejected: 'Đã từ chối',
            pending: 'Chờ xử lý',
            acceptance_rate: 'Tỷ lệ Chấp nhận',
            by_entity_type: 'Theo Loại thực thể',
            by_source: 'Theo Nguồn',
            avg_decision_time: 'Thời gian quyết định TB',
            rule_effectiveness: 'Hiệu quả quy tắc',
            by_status: 'Theo trạng thái',
            by_confidence: 'Theo mức tin cậy',
            load_error: 'Không thể tải phân tích đề xuất. Vui lòng thử lại.',
            confidence_high: 'Cao',
            confidence_medium: 'Trung bình',
            confidence_low: 'Thấp',
            by_confidence_band: 'Theo mức độ tin cậy',
            approval_rate: 'Tỷ lệ phê duyệt',
            by_label_state: 'Theo trạng thái nhãn',
            no_data_hint: 'Chưa có đề xuất nào. Hãy đưa một bản ghi trong khu vực chờ vào danh mục, hoặc nhấn "Chạy quy tắc ngay" trên trang Quy tắc phân loại để tạo lô đầu tiên.',
            rejection_rate: 'Tỷ lệ từ chối',
        },
        import_templates: {
            title: 'Mẫu Nhập',
            new: 'Mẫu mới',
            template_name: 'Tên Mẫu',
            file_format: 'Định dạng Tệp',
            column_mappings: 'Ánh xạ Cột',
            no_templates: 'Không tìm thấy mẫu nhập.',
            source_column: 'Cột nguồn',
            target_field: 'Trường đích',
            transform: 'Chuyển đổi',
            confirm_delete: 'Bạn có chắc chắn muốn xóa mẫu nhập này không?',
            load_error: 'Không thể tải mẫu nhập. Vui lòng thử lại.',
            save_error: 'Không thể lưu mẫu nhập',
            delete_error: 'Không thể xóa mẫu nhập',
            file_type_csv: 'CSV',
            file_type_xlsx: 'XLSX',
            source_column_label: 'Cột nguồn',
            target_field_label: 'Trường đích',
            transform_label: 'Phép biến đổi',
        },
        connectors: {
            title: 'Quản lý Kết nối',
            new: 'Kết nối mới',
            connector_name: 'Tên Kết nối',
            connector_type: 'Loại',
            last_sync: 'Đồng bộ lần cuối',
            no_connectors: 'Không tìm thấy kết nối.',
            cmdb_syncs: 'Đồng bộ CMDB',
            cloud_syncs: 'Đồng bộ đám mây',
            new_sync: 'Đồng bộ mới',
            no_syncs: 'Không tìm thấy đồng bộ.',
            cmdb_error: 'Không thể tải quét CMDB. Vui lòng thử lại.',
            cloud_error: 'Không thể tải quét đám mây. Vui lòng thử lại.',
            trigger_error: 'Không thể kích hoạt đồng bộ',
            trigger_sync_error: 'Không thể trigger {type}',
            cmdb_section_title: 'Đồng bộ CMDB',
            cloud_section_title: 'Đồng bộ đám mây',
            column_connector: 'Kết nối',
            action_start: 'Bắt đầu',
            confirm_cancel_sync: 'Hủy đồng bộ này?',
            start_error: 'Không thể bắt đầu đồng bộ',
            cancel_error: 'Không thể hủy đồng bộ',
            type_endpoint: 'Quét điểm cuối',
            type_spreadsheet_import: 'Nhập bảng tính',
            type_cmdb_sync: 'Đồng bộ CMDB',
            type_cloud_sync: 'Đồng bộ đám mây',
        },
        discovery_cycles: {
            title: 'Chu kỳ Khám phá',
            new_cycle: 'Chu kỳ Khám phá Mới',
            cycle_name: 'Tên Chu kỳ',
            scope_type: 'Loại Phạm vi',
            scope_ids: 'Mã Phạm vi',
            cadence_days: 'Tần suất (Ngày)',
            status: 'Trạng thái',
            no_cycles: 'Không tìm thấy chu kỳ khám phá',
            compare: 'So sánh Chu kỳ',
            delta_report: 'Báo cáo Thay đổi',
            new_records: 'Bản ghi Mới',
            changed_records: 'Bản ghi Thay đổi',
            removed_records: 'Bản ghi Đã xóa',
            schedule: 'Lên lịch Quét',
            scope_organization: 'Tổ chức',
            scope_department: 'Phòng ban',
            scope_system: 'Hệ thống',
            scope_systems: 'Hệ thống',
            bulk_actions: 'Hành động hàng loạt',
            selected: '{count} đã chọn',
            bulk_create: 'Tạo hàng loạt',
            bulk_assign_scope: 'Gán phạm vi hàng loạt',
            bulk_advance: 'Chuyển trạng thái hàng loạt',
            confirm_bulk_action: 'Xác nhận hành động hàng loạt',
            bulk_confirm_message: 'Bạn có chắc muốn thực hiện hành động này?',
            cycles_affected: '{count} chu kỳ sẽ bị ảnh hưởng',
            select_all: 'Chọn tất cả',
            select_cycle: 'Chọn chu kỳ {name}',
            from_template: 'từ mẫu',
            bulk_results: 'Kết quả hàng loạt',
            failed_label: 'thất bại',
            template_id: 'Mã mẫu',
            count: 'Số lượng',
            advance_to: 'Trạng thái mục tiêu',
            bulk_success: 'Hoàn thành thao tác hàng loạt',
        },
        owner_review: {
            title: 'Nhiệm vụ Xem xét Chủ sở hữu',
            assign_owner: 'Giao cho Chủ sở hữu',
            owner_id: 'Chủ sở hữu',
            decision: 'Quyết định',
            approve: 'Phê duyệt',
            modify: 'Sửa đổi',
            reject: 'Từ chối',
            escalate: 'Leo thang',
            no_tasks: 'Không tìm thấy nhiệm vụ xem xét',
            bulk_resolve: 'Giải quyết Hàng loạt',
            exceptions: 'Mục Ngoại lệ',
            no_exceptions: 'Không tìm thấy mục ngoại lệ',
            record_id_label: 'Mã bản ghi',
            selected: 'đã chọn',
            notes: 'Ghi chú',
            select_all: 'Chọn Tất cả',
            select: 'Chọn',
            confirm_resolve: 'Xác nhận',
        },
        classification_lineage: {
            title: 'Lịch sử Phân loại',
            link_suggestion: 'Liên kết Nhãn Đề xuất',
            suggestion_id: 'Đề xuất',
            proposed_label_id: 'Nhãn Đề xuất',
            no_lineage: 'Không tìm thấy dữ liệu lịch sử',
            full_lineage: 'Lịch sử Đầy đủ',
            record_id_label: 'Mã bản ghi',
            staged_record_label: 'Bản ghi tạm',
            enter_staged_record_id: 'Nhập mã bản ghi tạm',
            scan_id_label: 'Mã lần quét',
            select_record: 'Chọn một bản ghi',
            select_suggestion: 'Chọn một đề xuất',
            select_label: 'Chọn một nhãn',
        },
        exports: {
            title: 'Xuất',
            inventory: 'Kho dữ liệu',
            classification_register: 'Sổ đăng ký phân loại',
            raci: 'Ma trận RACI',
            exceptions: 'Báo cáo ngoại lệ',
            evidence_pack: 'Gói bằng chứng',
            delta_report: 'Báo cáo thay đổi',
            executive_summary: 'Tóm tắt điều hành',
            export_button: 'Xuất',
            downloading: 'Đang tải xuống...',
            download_complete: 'Tải xuống hoàn tất.',
            download_error: 'Không thể tải xuống bản xuất. Vui lòng thử lại.',
        },
        flags: {
            title: 'Đánh dấu hạ nguồn',
            pending: 'Đánh dấu đang chờ',
            cross_border_review_needed: 'Cần xem xét xuyên biên giới',
            sharing_disclosure_needed: 'Cần công bố chia sẻ',
            dpia_review_needed: 'Cần xem xét ĐGTĐ',
            acknowledge: 'Xác nhận',
            resolve: 'Giải quyết',
            no_flags: 'Không có đánh dấu hạ nguồn.',
        },
        delta: {
            title: 'Tóm tắt thay đổi',
            new_count: '{n} mới',
            removed_count: '{n} đã xóa',
            changed_count: '{n} đã thay đổi',
            re_review_triggered: 'Xem xét lại đã kích hoạt',
            create_re_review: 'Tạo xem xét lại',
            recent_alerts: 'Cảnh báo thay đổi gần đây',
            no_alerts: 'Không có cảnh báo thay đổi gần đây.',
            threshold_exceeded: 'Vượt ngưỡng thay đổi (>10%)',
        },
        regulatory: {
            dashboard_governance_info: 'Bảng điều khiển hiển thị trạng thái quản trị cấp chu kỳ: hệ thống đã quét, bản ghi đã dựng, đã xem xét, đã duyệt và ngoại lệ đang chờ.',
            export_artifacts_info: 'Xuất khám phá bao gồm tất cả loại hiện vật theo UC-VN-10 và DATA-EVD-01: kiểm kê dữ liệu, sổ phân loại, ánh xạ RACI, hàng đợi ngoại lệ, tóm tắt điều hành, gói bằng chứng và báo cáo chênh lệch.',
            scan_inventory_pipeline_info: 'Mỗi quét hoàn thành tạo bản ghi tương thích với mẫu vn_data_law_data_inventory_register. Tài sản dữ liệu khám phá tự động điền vào sổ kiểm kê.',
            connector_linkage_info: 'Cấu hình kết nối phải bao gồm: loại hệ thống, tham chiếu kho dữ liệu và liên kết quy trình kinh doanh (UC-VN-10).',
            owner_routing_info: 'Nhiệm vụ xem xét được chuyển đến đúng phòng ban hoặc chủ sở hữ dựa trên quyền sở hữ hệ thống/dữ liệu (UC-VN-10 bước 5).',
            owner_actions_audit_info: 'Chủ sở hữ có thể duyệt, chỉnh sửa, từ chối hoặc leo thang mỗi phân loại (UC-VN-10 bước 6). Mọi hành động ghi lại tác nhân, dấu thời gian và lý do.',
            escalation_timers_info: 'Bộ đếm: hạn xem xét chủ sở hữ 5 ngày làm việc; leo thang ngoại lệ 48 giờ. Mục chưa giải quyết tự động leo thang khi hết hạn.',
            original_suggestion_preserved_info: 'Gợi ý phân loại gốc được giữ nguyên cùng mọi ghi đè của chủ sở hữ (UC-VN-10). Gợi ý gốc không bị ghi đè và vẫn hiển thị cho kiểm toán.',
            dedup_lineage_info: 'Quy tắc trùng lặp ngăn mục kiểm kê trùng khi cùng tài sản được khám phá qua nhiều lần quét. Bản ghi mới nhất là chính, duy trì dòng dõi đến các khám phá trước.',
            label_states_info: 'Phân tích phân biệt 4 trạng thái nhãn: máy gợi ý (đang chờ), chủ sở hữ duyệt, chủ sở hữ chỉnh sửa và từ chối.',
            import_pipeline_info: 'Mẫu nhập phải tạo bản ghi tương thích với quy trình khám phá. Bản ghi nhập vào vùng dựng với cùng yêu cầu siêu dữ liệu.',
            lineage_full_path_info: 'Dòng dõi phân loại truy xuất đường đầy đủ: quét/nhập -> dựng -> xem xét chủ sở hữ -> nhãn duyệt -> mục sổ đăng ký (UC-VN-10 bước 1-10).',
            staging_workflow_info: 'Bản ghi dựng được phân biệt với kiểm kê duyệt bằng huy hiệu trạng thái thăng hạng (UC-VN-10 bước 3).',
            suggestion_data_d1_info: 'Đề xuất phù hợp quy trình DATA-D1: (1) lập danh mục tài sản, (2) phân loại theo độ nhạy cảm, (3) xác định quy tắc xử lý.',
            downstream_flags_info: 'Mục đánh dấu chia sẻ, chuyển xuyên biên giới hoặc rủi ro cao kích hoạt quy trình hạ nguồn: đánh giá chuyển xuyên biên giới, rủi ro chia sẻ và xem xét DPIA.',
            delta_detection_info: 'Chu kỳ khám phá hỗ trợ phát hiện chênh lệch (UC-VN-10 bước 11): mỗi chu kỳ cho thấy bản ghi mới, thay đổi hoặc xóa. Thay đổi >10% tự động kích hoạt xem xét lại.',
        },
    },
    incident_ops: {
        errors: {
            fetch: 'Không thể tải.',
            save: 'Không thể lưu.',
            fetch_escalation_log_failed: 'Không thể tải nhật ký leo thang.',
            fetch_activations_failed: 'Không thể tải kích hoạt.',
            deactivate_failed: 'Không thể hủy kích hoạt.',
            complete_activation_failed: 'Không thể hoàn thành kích hoạt.',
            fetch_playbook_templates_failed: 'Không thể tải mẫu playbook.',
            create_playbook_template_failed: 'Không thể tạo mẫu playbook.',
            clone_template_failed: 'Không thể sao chép mẫu.',
            update_status_failed: 'Không thể cập nhật trạng thái.',
            deprecate_template_failed: 'Không thể ngừng sử dụng mẫu.',
            seed_defaults_failed: 'Không thể tạo dữ liệu mặc định.',
            fetch_regulator_exports_failed: 'Không thể tải xuất cơ quan.',
            create_regulator_export_failed: 'Không thể tạo xuất cơ quan.',
            update_submission_status_failed: 'Không thể cập nhật trạng thái nộp.',
            fetch_response_metrics_failed: 'Không thể tải chỉ số phản hồi.',
            fetch_sla_dashboard_failed: 'Không thể tải bảng điều khiển SLA.',
            fetch_sla_definitions_failed: 'Không thể tải định nghĩa SLA.',
            create_sla_definition_failed: 'Không thể tạo định nghĩa SLA.',
            seed_sla_defaults_failed: 'Không thể tạo dữ liệu SLA mặc định.',
            fetch_vendor_coordination_failed: 'Không thể tải phối hợp nhà cung cấp.',
            fetch_vendor_detail_failed: 'Không thể tải chi tiết nhà cung cấp.',
            create_vendor_coordination_failed: 'Không thể tạo phối hợp nhà cung cấp.',
            add_communication_failed: 'Không thể thêm liên lạc.',
            add_info_request_failed: 'Không thể thêm yêu cầu thông tin.',
            add_action_request_failed: 'Không thể thêm yêu cầu hành động.',
        },
        nav: {
            playbooks: 'Mẫu Playbook',
            sla_definitions: 'Định nghĩa SLA',
            sla_dashboard: 'Bảng điều khiển SLA',
            escalation_log: 'Nhật ký Leo thang',
            regulator_exports: 'Xuất Cơ quan',
            deadlines: 'Hạn Thông báo',
            vendor_coordination: 'Phối hợp Nhà cung cấp',
            metrics: 'Chỉ số Phản hồi',
            playbook_links: 'Liên kết Playbook',
            regulatory_sla: 'SLA Quy định',
            coordination_dashboard: 'Phối hợp',
            evidence_chain: 'Chuỗi Bằng chứng',
            post_review: 'Đánh giá Hậu sự cố',
        },
        playbooks: {
            title: 'Mẫu Playbook',
            page_title: 'Mẫu quy trình',
            activations_page_title: 'Kích hoạt Playbook',
            new: 'Mẫu mới',
            seed_defaults: 'Nạp Mặc định',
            scenario_type: 'Loại Kịch bản',
            severity_applicability: 'Mức độ Áp dụng',
            all_scenario_types: 'Tất cả Loại kịch bản',
            new_playbook: 'Mẫu Playbook mới',
            clone: 'Nhân bản',
            clone_template: 'Nhân bản Mẫu',
            template_name: 'Tên mẫu',
            deprecate: 'Ngừng sử dụng',
            confirm_deprecate: 'Ngừng sử dụng mẫu "{name}"?',
            create_template: 'Tạo Mẫu',
            update_status: 'Cập nhật Trạng thái',
            no_templates: 'Không tìm thấy mẫu playbook',
            deactivation_reason_placeholder: 'Lý do ngừng hoạt động...',
            description_placeholder: 'Mô tả playbook...',
            name_placeholder: 'Tên playbook...',
            procedure_steps: 'Các bước của quy trình',
        },
        sla_definitions: {
            title: 'Định nghĩa SLA',
            page_title: 'Định nghĩa SLA',
            new: 'Định nghĩa SLA mới',
            sla_name: 'Tên SLA',
            target_hours: 'Số giờ Mục tiêu',
            escalation_after: 'Leo thang Sau',
            applies_to: 'Áp dụng cho',
            no_definitions: 'Không tìm thấy định nghĩa SLA.',
            target_value_placeholder: 'Giá trị mục tiêu',
            name_placeholder: 'Tên SLA...',
            threshold_hours_label: 'Số giờ Ngưỡng',
            severity_label: 'Mức độ nghiêm trọng',
            all_types: 'Tất cả loại',
            all_severities: 'Tất cả mức độ',
            default_label: 'Mặc định',
            bound_heading: 'Các thời hạn theo quy định làm căn cứ cho mục tiêu thông báo mặc định',
            bound_capped: 'Mục tiêu thời gian thông báo mặc định được giới hạn ở {hours} giờ — thời hạn thông báo ngắn nhất trong số các thời hạn đã cài đặt đang có hiệu lực.',
            bound_not_capped: 'Không có thời hạn thông báo nào đã cài đặt và đang có hiệu lực nêu khoảng thời gian cụ thể, nên mục tiêu thời gian thông báo mặc định không bị giới hạn.',
            bound_bounding_label: 'Làm căn cứ giới hạn — đang có hiệu lực',
            bound_upcoming_label: 'Không tính — chưa có hiệu lực',
            bound_unreadable_label: 'Không tính — chưa xác định thời điểm áp dụng',
            bound_date_not_stated_label: 'Không tính — chưa nêu ngày có hiệu lực',
            bound_hours: '{hours} giờ',
            bound_unreadable: 'Không đọc được các thời hạn theo quy định làm căn cứ cho mục tiêu thông báo mặc định.',
            bound_retry_subject: 'các thời hạn thông báo',
            load_retry_subject: 'các định nghĩa SLA',
            bound_phase_unresolved_label: 'Không tính — chưa xác định ngày bắt đầu giai đoạn',
        },
        sla_dashboard: {
            compliant: 'Tuân thủ',
            title: 'Bảng điều khiển SLA',
            page_title: 'Bảng điều khiển SLA',
            loading: 'Đang tải dữ liệu SLA...',
            compliance_rate: 'Tỷ lệ Tuân thủ',
            breached: 'Vi phạm',
            at_risk: 'Có rủi ro',
            on_track: 'Đúng tiến độ',
            by_severity: 'Theo Mức độ',
            total_records: 'Tổng bản ghi',
            met: 'Đạt',
            sla_records: 'Bản ghi SLA',
            sla_reference: 'Tham chiếu SLA',
            record_id: 'Mã bản ghi',
            metric_type: 'Loại chỉ số',
            severity: 'Mức độ',
            elapsed: 'Đã trôi qua',
            clock_start: 'Bắt đầu đồng hồ',
            statutory_baseline: 'Mốc luật định: thời hạn thông báo theo yêu cầu của các khung tuân thủ mà tổ chức này đã cài đặt.',
            statutory_baseline_heading: 'Mốc luật định',
        },
        escalation_log: {
            title: 'Nhật ký Leo thang',
            page_title: 'Nhật ký Leo thang',
            incident_id: 'Mã Sự cố',
            escalated_by: 'Leo thang bởi',
            escalated_to: 'Leo thang đến',
            reason: 'Lý do',
            escalated_at: 'Thời gian Leo thang',
            no_escalations: 'Không tìm thấy leo thang.',
            filter_incident_id: 'Lọc theo Mã sự cố',
            escalation_id: 'Mã leo thang',
            level: 'Cấp độ',
            level_range: 'Cấp độ (L1–L4)',
            create_escalation: 'Tạo Leo thang',
            select_placeholder: '— chọn —',
            target_role_placeholder: 'ví dụ: dpo, incident_manager',
            incident_id_placeholder: 'ví dụ: INC-001',
        },
        regulator_exports: {
            title: 'Xuất Cơ quan Quản lý',
            page_title: 'Xuất Cơ quan',
            new: 'Xuất mới',
            incident_id: 'Mã Sự cố',
            regulator: 'Cơ quan',
            export_format: 'Định dạng',
            exported_at: 'Xuất lúc',
            no_exports: 'Không tìm thấy xuất cơ quan.',
            enter_incident_id: 'Nhập Mã sự cố',
            export_id: 'Mã xuất',
            watermark: 'Dấu nước',
            submission_status: 'Trạng thái nộp',
            all_jurisdictions: 'Tất cả khu vực pháp lý',
            no_transitions: 'Không có chuyển đổi nào khác từ',
            sections_included: 'Phần bao gồm',
            select_new_status: '— chọn trạng thái mới —',
            form_classification: 'Phân loại',
            submission_channel: 'Kênh nộp',
        },
        deadlines: {
            title: 'Hạn Thông báo',
            incident_id: 'Mã Sự cố',
            deadline: 'Hạn chót',
            regulator: 'Cơ quan',
            remaining: 'Còn lại',
            no_deadlines: 'Không tìm thấy hạn thông báo.',
        },
        vendor_coordination: {
            title: 'Phối hợp Nhà cung cấp',
            page_title: 'Phối hợp Nhà cung cấp',
            new: 'Phối hợp mới',
            incident_id: 'Mã Sự cố',
            vendor_name: 'Tên Nhà cung cấp',
            contact: 'Liên hệ',
            coordination_status: 'Trạng thái Phối hợp',
            status_labels: {
                initiated: 'Đã khởi tạo',
                in_progress: 'Đang thực hiện',
                awaiting_vendor: 'Chờ nhà cung cấp',
                vendor_responded: 'Nhà cung cấp đã phản hồi',
                resolved: 'Đã giải quyết',
                closed: 'Đã đóng',
                escalated: 'Đã chuyển cấp',
            },
            no_items: 'Không tìm thấy mục phối hợp nhà cung cấp.',
            assessment_placeholder: 'Đánh giá ban đầu từ nhà cung cấp...',
            channel_email: 'Email',
            channel_meeting: 'Cuộc họp',
            channel_phone: 'Điện thoại',
            channel_portal: 'Cổng thông tin',
            incident_id_placeholder: 'Lọc theo Mã sự cố...',
            priority_critical: 'Nghiêm trọng',
            priority_high: 'Cao',
            priority_low: 'Thấp',
            priority_medium: 'Trung bình',
            vendor_id_placeholder: 'Lọc theo Mã nhà cung cấp...',
            description_placeholder: 'Mô tả...',
            filter_vendor_id: 'Lọc theo mã nhà cung cấp',
            coordination_id: 'Mã điều phối',
            communications: 'Liên lạc',
            info_requests: 'Yêu cầu thông tin',
            action_requests: 'Yêu cầu hành động',
            direction: 'Hướng',
            channel_label: 'Kênh',
            no_transitions: 'Không có chuyển đổi tiếp theo.',
            vendor_ref_number: 'Số tham chiếu',
            report_date: 'Ngày báo cáo',
            contact_email: 'Email',
            contact_phone: 'Điện thoại',
            inbound: 'Đến',
            outbound: 'Đi',
            summary_placeholder: 'Tóm tắt...',
            content_label: 'Nội dung',
            select_incident: 'Chọn sự cố',
            select_vendor: 'Chọn nhà cung cấp',
            discovery_date: 'Ngày phát hiện',
            action_request_desc: 'Mô tả yêu cầu hành động',
            info_request_desc: 'Mô tả yêu cầu thông tin',
            due_date_label: 'Hạn chót',
            priority_label: 'Mức ưu tiên',
            contact_role: 'Vai trò đầu mối liên hệ',
            processor_role: 'Vai trò bên xử lý dữ liệu',
            sla_elapsed: 'Thời gian SLA đã trôi qua',
            overdue: 'Quá hạn',
            actor: 'Người thực hiện',
        },
        metrics: {
            title: 'Chỉ số Phản hồi',
            page_title: 'Chỉ số Phản hồi',
            loading: 'Đang tải dữ liệu chỉ số...',
            avg_response_time: 'Thời gian Phản hồi TB',
            avg_resolution_time: 'Thời gian Giải quyết TB',
            total_incidents: 'Tổng Sự cố',
            by_severity: 'Theo Mức độ',
            by_status: 'Theo Trạng thái',
            trend: 'Xu hướng',
            start_sla_clock: 'Bắt đầu đồng hồ SLA',
            sla_records: 'Bản ghi SLA',
            no_sla_records: 'Chưa có bản ghi SLA.',
            record_id: 'Mã bản ghi',
            severity: 'Mức độ nghiêm trọng',
            progress: 'Tiến trình',
            incident_id_required: 'Mã sự cố là bắt buộc',
            sla_definition_required: 'Định nghĩa SLA là bắt buộc',
            metric_type_required: 'Loại chỉ số là bắt buộc',
            threshold_required: 'Số giờ ngưỡng là bắt buộc',
            sla_clock_started: 'Đã bắt đầu đồng hồ SLA',
            sla_definition: 'Định nghĩa SLA',
            no_definitions: 'Không tìm thấy định nghĩa SLA.',
            select_definition: 'Chọn định nghĩa SLA...',
            select_metric_type: 'Chọn loại chỉ số...',
            select_severity: 'Chọn mức độ...',
            threshold_hours: 'Ngưỡng (giờ)',
            warning_threshold_pct: 'Ngưỡng cảnh báo (%)',
            start_clock: 'Bắt đầu đồng hồ',
            starting: 'Đang bắt đầu...',
            metric_label: 'Chỉ số',
            value_label: 'Giá trị',
            incident_id: 'Mã sự cố',
            threshold_placeholder: 'vd. 24',
            metric_types: {
                triage_time: 'Thời gian phân loại',
                containment_time: 'Thời gian ngăn chặn',
                notification_time: 'Thời gian thông báo',
                resolution_time: 'Thời gian giải quyết',
            },
            severities: {
                critical: 'Nghiêm trọng',
                high: 'Cao',
                medium: 'Trung bình',
                low: 'Thấp',
            },
            sla_reference: 'Tham chiếu SLA',
        },
        playbook_links: {
            title: 'Liên kết Playbook với Thông báo',
            page_title: 'Liên kết Playbook',
            new_link: 'Liên kết Playbook với Thông báo',
            activation_id: 'Mã Kích hoạt',
            notification_id: 'Mã Thông báo',
            select_activation: 'Chọn một kích hoạt...',
            select_notification: 'Chọn một thông báo...',
            no_links: 'Không tìm thấy liên kết playbook',
            seed_pdpl: 'Thêm liên kết playbook mẫu',
            // fix-sprint-20260411-D F7 — semantic toast keys
            created: 'Đã tạo liên kết playbook',
            seeded: 'Đã thêm liên kết playbook mẫu',
            create_failed: 'Không thể tạo liên kết playbook',
            seed_failed: 'Không thể thêm liên kết playbook mẫu',
            seed_already: 'Các liên kết playbook mẫu đã có sẵn; không có gì được thêm',
            template_activation: 'Mẫu (không phải lần kích hoạt của tổ chức bạn)',
            template_notification: 'Mẫu (không phải thông báo của tổ chức bạn)',
        },
        regulatory_sla: {
            // fix-sprint-20260811-2123-followup — keyed on the route's
            // `skipped_reason_code`. The English prose the route also returns is a
            // fallback for an unrecognised code, never the operator's explanation.
            // fix-sprint-20260808-2111 (finding #35) — the declared incident-notification
            // deadlines a seed did not turn into a mapping, and why.
            not_seeded_heading: 'Thời hạn đã quy định nhưng chưa được thêm',
            not_seeded_intro: 'Các thời hạn thông báo sự cố này được quy định trong các khung tuân thủ đã cài đặt, nhưng chưa có ánh xạ nào được thêm cho chúng:',
            not_seeded_reason: {
                unclassified: 'loại thời hạn này không thuộc các loại mà bảng này ghi nhận',
                no_numeric_period: 'thời hạn được nêu bằng lời, không phải bằng một số giờ hoặc ngày, nên không thể lưu thành ánh xạ',
                not_yet_in_force: 'thời hạn này chưa có hiệu lực: thời hạn bắt đầu áp dụng từ ngày {date}',
                activation_not_determinable: 'cả khung tuân thủ lẫn giai đoạn mà thời hạn viện dẫn đều không nêu thời điểm thời hạn bắt đầu áp dụng',
            },
            seed_skipped: {
                no_governing_framework: 'Không có khung tuân thủ nào đã cài đặt điều chỉnh ứng phó sự cố, nên không có thời hạn nào để thêm.',
                declared_but_none_active: 'Một khung tuân thủ điều chỉnh ứng phó sự cố đã được cài đặt nhưng chưa có hiệu lực.',
                no_declared_deadlines: 'Các khung tuân thủ ứng phó sự cố đã cài đặt không quy định thời hạn thông báo nào.',
                declared_deadlines_withheld: 'Các khung tuân thủ đã cài đặt có quy định thời hạn thông báo, nhưng chưa thể thêm thời hạn nào. Các thời hạn này được liệt kê bên dưới trong danh sách thời hạn chưa được thêm.',
                already_seeded: 'Mọi thời hạn thông báo mà các khung tuân thủ đã cài đặt quy định đều đã có ánh xạ. Không có ánh xạ mới nào được thêm.',
            },
            // Fix sprint F25 — the period is rendered WITH the unit the framework
            // declared. The table hardcoded an `h` suffix, so a deadline the pack
            // states as 15 working days was shown to the operator as "15h": a
            // misstated statutory period on a regulator-facing screen. `deadline_unit`
            // had one writer and zero readers; this is the reader.
            //
            // The pack unit vocabulary is open (26 distinct values in the corpus), so
            // `unit_unknown` carries anything not listed rather than guessing hours.
            deadline_period_label: 'Hạn chót',
            deadline_units: {
                hours: '{count} giờ',
                working_days: '{count} ngày làm việc',
                calendar_days: '{count} ngày theo lịch',
                days: '{count} ngày',
                weeks: '{count} tuần',
                months: '{count} tháng',
                years: '{count} năm',
            },
            deadline_unit_unknown: '{count} {unit}',
            // fix-sprint #447 W6 (owner ruling OR2) — a reference table: it sets no clock,
            // and a row is refused without the unit its period is stated in.
            reference_notice: 'Đây là bảng tham chiếu. Ánh xạ không khởi động đồng hồ thời hạn nào và không leo thang việc gì: không sự cố, thông báo vi phạm hay SLA nào đọc các dòng này. Mọi thời hạn theo quy định trong sản phẩm đều lấy từ các bản ghi thời hạn mà các khung tuân thủ đã cài đặt của bạn khai báo.',
            seed_only_conditional: 'Các khung tuân thủ đã cài đặt chỉ khai báo thời hạn thông báo cho một số hoạt động hoặc điều kiện cụ thể, nên không có thời hạn nào được thêm tự động.',
            seed_conditional_heading: 'Các thời hạn không được thêm tự động',
            seed_conditional_intro: 'Các thời hạn đã cài đặt này chỉ áp dụng cho một hoạt động hoặc điều kiện được nêu. Nền tảng không thể biết tổ chức của bạn có thuộc trường hợp đó hay không, nên cần một người quyết định: nếu có, hãy thêm ánh xạ từ đây.',
            seed_conditional_scope_activity: 'Áp dụng cho hoạt động: {value}',
            seed_conditional_scope_condition: 'Chỉ áp dụng nếu: {value}',
            seed_conditional_add: 'Thêm ánh xạ này',
            deadline_amount: 'Thời hạn',
            deadline_unit: 'Đơn vị',
            select_deadline_unit: 'Chọn một đơn vị...',
            deadline_unit_options: {
                hours: 'Giờ',
                working_days: 'Ngày làm việc',
                calendar_days: 'Ngày theo lịch',
                days: 'Ngày',
                weeks: 'Tuần',
                months: 'Tháng',
                years: 'Năm',
            },
            title: 'Ánh xạ SLA Quy định',
            page_title: 'Ánh xạ SLA Quy định',
            new_mapping: 'Ánh xạ SLA mới',
            sla_definition: 'Định nghĩa SLA',
            select_sla_definition: 'Chọn một định nghĩa SLA...',
            framework_code: 'Mã Khung',
            deadline_type: 'Loại Hạn chót',
            deadline_hours: 'Số giờ Hạn chót',
            // Fix sprint #447 (round 2) — was "Seed PDPL Defaults"; the action reads whatever
            // installed framework declares the deadlines, not one law. (Key name kept: every
            // language pack carries it.)
            seed_pdpl: 'Thêm ánh xạ từ các thời hạn đã cài đặt',
            no_mappings: 'Không tìm thấy ánh xạ SLA quy định',
            dashboard: 'Bảng điều khiển SLA Quy định',
            deadline_types: {
                initial_notification: 'Thông báo ban đầu',
                supplement_response: 'Phản hồi bổ sung',
                authority_response: 'Phản hồi cơ quan',
                remediation_report: 'Báo cáo khắc phục',
                subject_notification: 'Thông báo cho chủ thể dữ liệu',
            },
            statutory_reference: 'Tham chiếu pháp luật',
        },
        coordination_dashboard: {
            title: 'Bảng điều khiển Phối hợp',
            page_title: 'Bảng điều khiển Phối hợp',
            incident_id: 'Mã Sự cố',
            select_incident: 'Chọn một sự cố...',
            team_role: 'Vai trò Nhóm',
            members: 'Thành viên',
            tasks: 'Nhiệm vụ',
            sla_status: 'Trạng thái SLA',
            no_teams: 'Không tìm thấy nhóm phối hợp',
            new_team: 'Nhóm Phối hợp mới',
            member_ids_placeholder: 'user1, user2',
            edit_team: 'Sửa nhóm',
            task_count: 'Số nhiệm vụ',
            tasks_completed: 'Hoàn thành',
            team_roles: {
                security: 'Bảo mật',
                legal: 'Pháp lý',
                it: 'CNTT',
                management: 'Quản lý',
                department_owner: 'Chủ phòng ban',
                external: 'Bên ngoài',
            },
            enter_incident_id: 'Nhập mã sự cố để xem nhóm phối hợp.',
        },
        evidence_chain: {
            title: 'Chuỗi Quản lý Bằng chứng',
            page_title: 'Chuỗi Bằng chứng',
            new_entry: 'Mục Bằng chứng mới',
            select_incident: 'Chọn một sự cố...',
            actor: 'Tác nhân',
            select_actor: 'Chọn một tác nhân...',
            evidence_id: 'Mã Bằng chứng',
            action: 'Hành động',
            recipient: 'Người nhận',
            no_entries: 'Không tìm thấy mục chuỗi bằng chứng',
            enter_incident_id: 'Nhập mã sự cố để xem chuỗi bằng chứng.',
            evidence_id_placeholder: 'ví dụ: EVD-2026-0001',
            evidence_id_help: 'Mã tham chiếu duy nhất cho hạng mục bằng chứng — tệp nhật ký, ảnh đĩa hoặc ảnh chụp màn hình. Một gợi ý đã được điền sẵn; hãy chỉnh sửa để khớp với danh mục bằng chứng của bạn.',
            select_incident_first: 'Hãy chọn một sự cố ở trên trước khi thêm mục bằng chứng.',
            for_incident: 'Cho sự cố',
            actions: {
                collected: 'Đã thu thập',
                shared: 'Đã chia sẻ',
                exported: 'Đã xuất',
                archived: 'Đã lưu trữ',
            },
        },
        post_review: {
            title: 'Đánh giá Hậu sự cố',
            page_title: 'Đánh giá Hậu sự cố',
            new_review: 'Đánh giá mới',
            select_incident: 'Chọn một sự cố...',
            lessons_learned: 'Bài học Kinh nghiệm',
            recommendations: 'Khuyến nghị',
            improvement_actions: 'Hành động Cải tiến',
            submit_for_review: 'Gửi để xem xét',
            aria_submit_review: 'Gửi đánh giá {name} để xem xét',
            aria_sign_off: 'Phê duyệt đánh giá {name}',
            sign_off: 'Phê duyệt',
            no_reviews: 'Không tìm thấy đánh giá hậu sự cố',
            enter_incident_id: 'Nhập mã sự cố để xem đánh giá hậu sự cố.',
            one_per_line: 'Mỗi dòng một mục',
            statuses: {
                draft: 'Nháp',
                in_review: 'Đang xem xét',
                signed_off: 'Đã phê duyệt',
                closed: 'Đã đóng',
            },
        },
        activations: {
            title: 'Kích hoạt quy trình',
            activation_id: 'Mã kích hoạt',
            phases: 'Giai đoạn',
            activated_at: 'Kích hoạt lúc',
            activated_by: 'Kích hoạt bởi',
            deactivate: 'Vô hiệu hóa',
            complete: 'Hoàn thành',
            deactivation_reason: 'Lý do vô hiệu hóa',
            // Sprint 41.6.0 V12 — evidence modal keys (backfill from 41.3.0 F5-F9)
            evidence_button: 'Bằng chứng',
            evidence_modal_title: 'Bằng chứng kích hoạt',
            no_evidence: 'Chưa có bằng chứng đính kèm cho kích hoạt này.',
            upload_evidence_label: 'Tải lên bằng chứng kích hoạt',
            procedure_followed: 'Quy trình đã thực hiện',
            phases_completed_sr: 'Đã hoàn thành {completed}/{total} giai đoạn',
        },
    },
    program_governance: {
        // ── Sprint 65.8.0 (AC9) — sổ đăng ký cuộc kiểm toán ─────────
        audit_engagements: {
            title: 'Cuộc kiểm toán',
            description: 'Lập kế hoạch một cuộc kiểm toán, ghi nhận phạm vi và người thực hiện, ghi nhận phát hiện bên trong cuộc kiểm toán đó, và đóng lại khi mọi phát hiện đã được xử lý.',
            module_guide_summary: 'Mỗi cuộc kiểm toán ghi nhận phạm vi, kỳ được kiểm toán, người thực hiện và một vòng đời chạy từ lập kế hoạch, kiểm toán thực địa, lập báo cáo cho đến khi đóng. Phát hiện luôn được ghi nhận bên trong một cuộc kiểm toán, và không thể đóng cuộc kiểm toán khi vẫn còn phát hiện chưa được xử lý.',
            load_error: 'Không thể tải danh sách cuộc kiểm toán. Vui lòng thử lại.',
            counts_error: 'Không thể đọc số liệu tổng hợp, vì vậy không hiển thị tổng số nào.',
            counts_label: 'Cuộc kiểm toán theo trạng thái',
            total: 'Tất cả cuộc kiểm toán',
            filter_state: 'Trạng thái',
            filter_all_states: 'Tất cả trạng thái',
            filter_auditor_kind: 'Loại kiểm toán',
            filter_all_auditor_kinds: 'Tất cả loại kiểm toán',
            filters_label: 'Lọc cuộc kiểm toán',
            col_title: 'Cuộc kiểm toán',
            col_period: 'Kỳ được kiểm toán',
            col_auditor: 'Người thực hiện kiểm toán',
            col_state: 'Trạng thái',
            no_engagements: 'Chưa có cuộc kiểm toán nào được lập kế hoạch.',
            no_engagements_filtered: 'Không có cuộc kiểm toán nào khớp với bộ lọc này.',
            select_hint: 'Chọn một cuộc kiểm toán để xem các phát hiện và những thao tác có thể thực hiện.',
            open_engagement: 'Mở cuộc kiểm toán này',
            selected_label: 'Cuộc kiểm toán đang chọn',
            new_engagement: 'Lập kế hoạch kiểm toán',
            create_title: 'Lập kế hoạch một cuộc kiểm toán',
            section_scope: 'Nội dung được kiểm toán',
            section_auditor: 'Người thực hiện kiểm toán',
            field_title: 'Tiêu đề',
            field_scope: 'Phạm vi',
            field_scope_hint: 'Nội dung mà cuộc kiểm toán này bao trùm, theo cách người xác định phạm vi mô tả.',
            field_period_start: 'Ngày bắt đầu kỳ',
            field_period_end: 'Ngày kết thúc kỳ',
            period_hint: 'Ngày theo lịch. Kỳ được kiểm toán là một khoảng ngày do con người ghi lại, nên không kèm giờ.',
            period_invalid: 'Ngày kết thúc kỳ không được sớm hơn ngày bắt đầu kỳ.',
            period_required: 'Bắt buộc nhập cả hai mốc của kỳ, mỗi mốc là một ngày theo lịch.',
            field_auditor_kind: 'Loại kiểm toán',
            auditor_internal: 'Nội bộ',
            auditor_external: 'Bên ngoài',
            field_auditor_name: 'Người thực hiện kiểm toán',
            auditor_name_hint_internal: 'Cá nhân hoặc bộ phận thực hiện cuộc kiểm toán.',
            auditor_name_hint_external: 'Đơn vị bên ngoài thực hiện cuộc kiểm toán. Đơn vị bên ngoài không có tài khoản trên nền tảng này nên không chỉ định người dùng.',
            field_auditor_user: 'Người dùng trên nền tảng thực hiện cuộc kiểm toán',
            auditor_user_placeholder: 'Chọn người dùng…',
            auditor_user_required: 'Kiểm toán nội bộ bắt buộc phải chỉ định người dùng trên nền tảng thực hiện cuộc kiểm toán.',
            created: 'Đã lập kế hoạch cuộc kiểm toán',
            create_error: 'Không thể tạo cuộc kiểm toán.',
            lifecycle: 'Vòng đời',
            lifecycle_actions: 'Thao tác trên cuộc kiểm toán này',
            advance_to: 'Chuyển sang {state}',
            transitioned: 'Cuộc kiểm toán đã chuyển sang {state}',
            transition_error: 'Không thể chuyển trạng thái cuộc kiểm toán.',
            terminal_notice: 'Cuộc kiểm toán này đang ở trạng thái {state}. Không thể thay đổi phạm vi, kỳ và người thực hiện nữa.',
            cancel_engagement: 'Hủy cuộc kiểm toán',
            cancel_title: 'Hủy cuộc kiểm toán này',
            cancel_reason: 'Lý do hủy là gì?',
            cancel_reason_required: 'Hủy một cuộc kiểm toán bắt buộc phải có lý do.',
            cancel_confirm: 'Hủy cuộc kiểm toán',
            cancellation_reason: 'Lý do hủy',
            close_engagement: 'Đóng cuộc kiểm toán',
            close_gate_label: 'Cuộc kiểm toán này có thể đóng hay chưa',
            close_blocked: 'Chưa thể đóng cuộc kiểm toán này: còn {count} phát hiện chưa được xử lý. Hãy đóng hoặc từ chối từng phát hiện trước.',
            close_ready: 'Mọi phát hiện trong cuộc kiểm toán này đã được đóng hoặc từ chối, nên có thể đóng cuộc kiểm toán.',
            close_gate_unknown: 'Không đọc được số phát hiện chưa xử lý, nên nền tảng chưa thể xác định cuộc kiểm toán này có được đóng hay không.',
            closed_on: 'Đóng ngày',
            cancelled_on: 'Hủy ngày',
            created_on: 'Lập kế hoạch ngày',
            states: {
                planned: 'Đã lên kế hoạch',
                in_fieldwork: 'Đang kiểm toán thực địa',
                reporting: 'Đang lập báo cáo',
                closed: 'Đã đóng',
                cancelled: 'Đã hủy',
            },
            directory_truncated: 'Chỉ hiển thị {count} người dùng đầu tiên.',
            directory_unavailable: 'Không thể tải danh bạ người dùng, nên hiện chưa thể chọn người dùng nào.',
            directory_reload: 'Tải lại',
            directory_reloading: 'Đang tải lại…',
            directory_retry_subject_auditor: 'danh bạ người dùng cho kiểm toán viên',
            directory_retry_subject_owner: 'danh bạ người dùng cho chủ sở hữu phát hiện',
            reload: 'Tải lại',
            list_retry_subject: 'danh sách cuộc kiểm toán',
            findings_retry_subject: 'các phát hiện',
            findings: {
                title: 'Phát hiện kiểm toán',
                section_label: 'Các phát hiện được ghi nhận trong cuộc kiểm toán này',
                unresolved: 'Chưa xử lý',
                load_error: 'Không thể tải các phát hiện. Vui lòng thử lại.',
                no_findings: 'Chưa có phát hiện nào được ghi nhận trong cuộc kiểm toán này.',
                new_finding: 'Ghi nhận phát hiện',
                create_title: 'Ghi nhận một phát hiện trong cuộc kiểm toán này',
                engagement: 'Cuộc kiểm toán',
                anchor_hint: 'Phát hiện luôn được ghi nhận bên trong một cuộc kiểm toán và không thể tồn tại độc lập.',
                field_title: 'Tiêu đề',
                field_observation: 'Nội dung quan sát được',
                field_severity: 'Mức độ',
                field_owner: 'Chủ sở hữu',
                owner_placeholder: 'Chọn người dùng…',
                col_title: 'Phát hiện',
                col_severity: 'Mức độ',
                col_owner: 'Chủ sở hữu',
                col_state: 'Trạng thái',
                created: 'Đã ghi nhận phát hiện',
                create_error: 'Không thể ghi nhận phát hiện.',
                transitioned: 'Phát hiện đã chuyển sang {state}',
                transition_error: 'Không thể chuyển trạng thái phát hiện.',
                accept: 'Tiếp nhận',
                start_remediation: 'Bắt đầu khắc phục',
                close: 'Đóng phát hiện',
                reject: 'Từ chối',
                reject_title: 'Từ chối phát hiện này',
                reject_reason: 'Vì sao đây không phải là một phát hiện?',
                reject_reason_required: 'Từ chối một phát hiện kiểm toán bắt buộc phải có lý do.',
                reject_confirm: 'Từ chối phát hiện',
                rejection_reason: 'Lý do từ chối',
                reject_only_from_open: 'Chỉ có thể từ chối phát hiện khi phát hiện đó còn đang mở. Sau khi đã tiếp nhận, tổ chức đã xác nhận đây là một phát hiện.',
                states: {
                    open: 'Đang mở',
                    accepted: 'Đã tiếp nhận',
                    remediating: 'Đang khắc phục',
                    closed: 'Đã đóng',
                    rejected: 'Đã từ chối',
                },
            },
        },
        // Sprint 48.2.5 — Bảng walkthrough đánh giá độ trưởng thành
        maturity_walkthrough: {
            run_label: 'Hướng dẫn qua các gap',
            running: 'Đang phân tích…',
            results_heading: 'Lộ trình cải thiện ({count} gap{plural})',
            tokens_label: '≈ {count} token',
            no_gaps: 'Không có gap — mọi domain đạt hoặc vượt target.',
            col_priority: 'Ưu tiên',
            col_domain: 'Lĩnh vực',
            col_levels: 'Hiện tại → Mục tiêu',
            col_severity: 'Mức độ',
            col_actions: 'Hành động khắc phục',
            citations_label: 'Trích dẫn',
            accept_label: 'Chấp nhận lộ trình',
            reject_label: 'Từ chối draft',
            export_label: 'Xuất DOCX',
            exported_label: 'Đã xuất lộ trình',
            accept_hint: 'Chấp nhận sẽ ghi quyết định của bạn vào bản nháp đã lưu và không thay đổi đánh giá. Dùng Xuất DOCX để tải lộ trình, rồi đưa các hành động bạn chọn vào công việc hoặc kế hoạch của riêng bạn.',
            resolve_summary: 'Kết quả: {status}',
            resolve_status_accepted: 'Đã chấp nhận',
            resolve_status_rejected: 'Đã từ chối',
            error_generic: 'Không thể chạy walkthrough. Thử lại hoặc kiểm tra trạng thái assessment.',
        },
        // Sprint 48.2.6 — Bảng phát hiện gap chính sách
        policy_gap: {
            run_label: 'Phát hiện gap chính sách',
            running: 'Đang phát hiện gap…',
            results_heading: 'Gap chính sách ({count})',
            tokens_label: '≈ {count} token',
            no_gaps: 'Không phát hiện gap coverage.',
            col_severity: 'Mức độ',
            col_kind: 'Loại',
            col_clause: 'Điều khoản / yêu cầu',
            kind_missing: 'Thiếu điều khoản',
            kind_weak: 'Coverage yếu',
            kind_stale: 'Quá hạn review',
            remediation_label: 'Đề xuất khắc phục',
            citations_label: 'Trích dẫn',
            accept_label: 'Chấp nhận báo cáo',
            reject_label: 'Từ chối báo cáo',
            export_label: 'Xuất DOCX',
            accept_hint: 'Chấp nhận ghi báo cáo vào draft. Dùng Xuất DOCX để tạo Policy Audit Report; operator tự sửa chính sách.',
            resolve_summary: 'Kết quả: {status}',
            error_generic: 'Không thể phát hiện gap chính sách. Thử lại hoặc kiểm tra trạng thái tài liệu.',
        },
        // Sprint 48.2.7 — Bảng tạo kế hoạch khắc phục
        remediation_plan_generator: {
            run_label: 'Tạo kế hoạch từ gaps',
            running: 'Đang tạo kế hoạch…',
            results_heading: 'Kế hoạch khắc phục ({phase_count} giai đoạn{plural})',
            tokens_label: '≈ {count} token',
            phase_label: 'Giai đoạn {index}',
            window_label: 'Khung thời gian',
            owner_label: 'Vai trò chủ',
            evidence_label: 'Loại evidence yêu cầu',
            tasks_label: 'Nhiệm vụ',
            no_phases: 'Không có giai đoạn — gap-set đầu vào có thể rỗng.',
            citations_label: 'Trích dẫn',
            accept_label: 'Chấp nhận kế hoạch',
            reject_label: 'Từ chối kế hoạch',
            export_label: 'Xuất DOCX',
            accept_hint: 'Chấp nhận tạo một task cho mỗi nhiệm vụ được liệt kê (tối đa 5 mỗi giai đoạn, 12 tất cả). Mô tả mỗi task nêu tên kế hoạch này; các task không liên kết với bản ghi nào trong sổ Kế hoạch Khắc phục và chưa có người phụ trách, vì vậy hãy gán người phụ trách cho từng task trong danh sách task. Dùng Xuất DOCX để lấy bản đầy đủ.',
            resolve_summary: 'Kết quả: {status} · {tasks} task được tạo',
            error_generic: 'Không thể tạo kế hoạch khắc phục. Thử lại hoặc kiểm tra gap-set đầu vào.',
            // Sprint 48.2.7 fix — bộ điều khiển nhập gap-set chéo module.
            source_picker_label: 'Nguồn',
            source_all: 'Tất cả',
            source_consent: 'Phân tích gap đồng ý',
            source_policy: 'Phát hiện gap chính sách',
            source_vendor: 'Onboarding nhà cung cấp',
            load_upstream_label: 'Tải từ upstream',
            loading_upstream: 'Đang tải…',
            upstream_count: 'Đã tải {count} gap',
            export_done: 'Đã lưu {filename} vào thư mục tải xuống của bạn.',
            no_gaps_in_source: 'Nguồn đã chọn không có gap nào nên chưa tạo gì và không thể tạo task. Hãy chạy phân tích đó trước, hoặc chọn nguồn khác.',
            no_gaps: 'Chưa tải gap nào nên chưa có gì để lập kế hoạch. Hãy chọn nguồn và bấm Tải từ upstream.',
        },
        nav: {
            audit_engagements: 'Cuộc kiểm toán',
            handbook_assessments: 'Đánh giá theo cẩm nang',
            maturity_models: 'Mô hình trưởng thành',
            maturity_assessments: 'Đánh giá trưởng thành',
            trend_dashboard: 'Bảng xu hướng',
            reporting_periods: 'Kỳ báo cáo',
            executive_summaries: 'Tóm tắt điều hành',
            audit_readiness: 'Sẵn sàng kiểm toán',
            evidence_gaps: 'Khoảng trống bằng chứng',
            program_health: 'Sức khỏe chương trình',
            obligation_mappings: 'Ánh xạ Nghĩa vụ',
            governance_documents: 'Tài liệu Quản trị',
            remediation_plans: 'Kế hoạch Khắc phục',
            governance_model: 'Mô hình Quản trị',
            document_drafting: 'Soạn thảo Tài liệu',
            document_issuance: 'Ban hành Tài liệu',
            acknowledgment_tracking: 'Theo dõi Xác nhận',
            change_log: 'Nhật ký Thay đổi',
            review_cadence: 'Lịch Xem xét',
        },
        maturity_models: {
            title: 'Mô hình Trưởng thành',
            new: 'Mô hình mới',
            seed_defaults: 'Nạp Mặc định',
            domains: 'Lĩnh vực',
            activate: 'Kích hoạt',
            no_models: 'Không tìm thấy mô hình trưởng thành',
            new_maturity_model: 'Mô hình Trưởng thành mới',
            create_model: 'Tạo Mô hình',
            load_error: 'Không thể tải các mô hình trưởng thành. Vui lòng thử lại.',
            create_error: 'Không thể tạo mô hình trưởng thành',
            status_error: 'Không thể cập nhật trạng thái mô hình',
            seed_error: 'Không thể tạo giá trị mặc định',
            aria_seed_defaults: 'Tạo mô hình trưởng thành mặc định',
            aria_create_new: 'Tạo mô hình trưởng thành mới',
            loading_sr: 'Đang tải mô hình trưởng thành',
            model_name_placeholder: 'vd., Mô hình trưởng thành quyền riêng tư',
            status_changed: 'Trạng thái mô hình đã thay đổi thành {status}',
        },
        maturity_assessments: {
            models_load_error: 'Không tải được danh sách mô hình trưởng thành, nên tên mô hình có thể hiển thị là không xác định.',
            no_models_action: 'Mở Mô hình trưởng thành',
            no_models_body: 'Một hồ sơ đánh giá chấm điểm chương trình theo một mô hình trưởng thành, và tổ chức này chưa có mô hình nào. Hãy tạo mô hình trước.',
            no_models_title: 'Chưa có mô hình trưởng thành nào',
            title: 'Đánh giá Trưởng thành',
            new: 'Đánh giá mới',
            model: 'Mô hình',
            assessor: 'Người đánh giá',
            overall_score: 'Điểm Tổng thể',
            overall_score_help: 'Xếp hạng mức độ trưởng thành có trọng số từ 0–5, được tính tự động khi một đánh giá được hoàn tất. Tăng điểm bằng cách chấm điểm cao hơn cho từng lĩnh vực trong quá trình đánh giá, rồi chuyển đánh giá qua Gửi để xem xét → Hoàn tất.',
            assessed_at: 'Đánh giá lúc',
            no_assessments: 'Không tìm thấy đánh giá trưởng thành.',
            load_error: 'Không thể tải đánh giá trưởng thành. Vui lòng thử lại.',
            create_error: 'Không thể tạo đánh giá',
            start_error: 'Không thể bắt đầu đánh giá',
            archive_error: 'Không thể lưu trữ đánh giá',
            eval_error: 'Không thể tải đánh giá để đánh giá',
            eval_min_score: 'Vui lòng chấm điểm ít nhất một lĩnh vực',
            eval_save_error: 'Không thể lưu đánh giá lĩnh vực',
            review_error: 'Không thể gửi để xem xét',
            finalize_error: 'Không thể hoàn tất đánh giá',
            start: 'Bắt đầu',
            start_confirm_title: 'Bắt đầu đánh giá',
            start_confirm_message: 'Bạn có chắc chắn muốn bắt đầu đánh giá này?',
            archive_confirm_title: 'Lưu trữ đánh giá',
            archive_confirm_message: 'Bạn có chắc chắn muốn lưu trữ đánh giá này?',
            evaluate_domains: 'Đánh giá',
            evaluate_domains_title: 'Đánh giá lĩnh vực',
            submit_for_review: 'Gửi để xem xét',
            finalize: 'Hoàn tất',
            archive: 'Lưu trữ',
            all_reviewers: 'Tất cả người đánh giá phải phê duyệt',
            any_reviewer: 'Bất kỳ người đánh giá nào có thể phê duyệt',
            select_level: 'Chọn mức độ trưởng thành...',
            findings_placeholder: 'Phát hiện, ghi chú, tham chiếu bằng chứng...',
            no_domains: 'Không tìm thấy lĩnh vực nào cho mô hình này.',
        },
        trend_dashboard: {
            title: 'Bảng Xu hướng',
            loading: 'Đang tải dữ liệu xu hướng...',
            score_trend: 'Xu hướng Điểm',
            domain_comparison: 'So sánh Lĩnh vực',
            period: 'Kỳ',
            load_error: 'Không thể tải tóm tắt xu hướng. Vui lòng thử lại.',
            metrics_load_error: 'Không thể tải chỉ số xu hướng. Vui lòng thử lại.',
            module: 'Phân hệ',
            metric: 'Chỉ số',
            value: 'Giá trị',
            trend: 'Xu hướng',
            aria_filters: 'Bộ lọc chỉ số xu hướng',
            showing_chart: 'Đang hiển thị dạng biểu đồ',
            showing_table: 'Đang hiển thị dạng bảng',
            create_metric: 'Tạo chỉ số',
            data_points: 'Điểm dữ liệu',
            trend_direction: 'Hướng xu hướng',
            unit: 'Đơn vị',
        },
        reporting_periods: {
            title: 'Kỳ Báo cáo',
            new: 'Kỳ mới',
            period_name: 'Tên Kỳ',
            start_date: 'Ngày bắt đầu',
            end_date: 'Ngày kết thúc',
            no_periods: 'Không tìm thấy kỳ báo cáo.',
            load_error: 'Không thể tải kỳ báo cáo. Vui lòng thử lại.',
            create_error: 'Không thể tạo kỳ báo cáo',
            auto_generate_error: 'Không thể tự động tạo kỳ báo cáo',
            status_error: 'Không thể cập nhật trạng thái kỳ',
            start_collecting: 'Bắt đầu thu thập',
            mark_as_draft: 'Đánh dấu là bản nháp',
            submit_for_review: 'Gửi để xem xét',
            publish: 'Xuất bản',
            auto_generate: 'Tự động tạo kỳ báo cáo',
            period_label_placeholder: 'vd., Q1 2026',
            status_updated: 'Trạng thái kỳ đã cập nhật',
        },
        executive_summaries: {
            title: 'Tóm tắt Điều hành',
            new: 'Tóm tắt mới',
            period: 'Kỳ',
            generated_at: 'Tạo lúc',
            generated_by: 'Tạo bởi',
            no_summaries: 'Không tìm thấy tóm tắt điều hành.',
            generate: 'Tạo',
            load_error: 'Không thể tải tóm tắt điều hành. Vui lòng thử lại.',
            generate_error: 'Không thể tạo tóm tắt điều hành',
            save_error: 'Không thể lưu tóm tắt điều hành',
        },
        audit_readiness: {
            title: 'Sẵn sàng Kiểm toán',
            loading: 'Đang tải dữ liệu sẵn sàng kiểm toán...',
            overall_readiness: 'Sẵn sàng Tổng thể',
            by_domain: 'Theo Lĩnh vực',
            evidence_coverage: 'Phạm vi Bằng chứng',
            gaps: 'Khoảng trống',
            load_error: 'Không thể tải mức sẵn sàng mới nhất. Vui lòng thử lại.',
            history_error: 'Không thể tải lịch sử sẵn sàng. Vui lòng thử lại.',
            calculate_error: 'Không thể tính toán mức sẵn sàng kiểm toán',
            aria_recalculate: 'Tính lại điểm sẵn sàng kiểm toán',
            aria_current_readiness: 'Mức sẵn sàng kiểm toán hiện tại',
            aria_history: 'Lịch sử điểm sẵn sàng',
            recalculated: 'Mức sẵn sàng kiểm toán đã tính lại',
            loading_sr: 'Đang tải dữ liệu sẵn sàng kiểm toán',
        },
        evidence_gaps: {
            title: 'Khoảng trống Bằng chứng',
            // fix-sprint-20260717-2118-followup F14
            section_ownership_timeline: 'Chủ sở hữu và thời gian',
            domain: 'Lĩnh vực',
            control: 'Kiểm soát',
            gap_type: 'Loại Khoảng trống',
            severity: 'Mức độ',
            no_gaps: 'Không tìm thấy khoảng trống bằng chứng.',
            load_error: 'Không thể tải khoảng trống bằng chứng. Vui lòng thử lại.',
            stats_error: 'Không thể tải thống kê. Vui lòng thử lại.',
            create_error: 'Không thể tạo khoảng trống bằng chứng',
            update_error: 'Không thể cập nhật khoảng trống',
            status_error: 'Không thể cập nhật trạng thái',
            aria_create_new: 'Tạo khoảng trống bằng chứng mới',
            aria_statistics: 'Thống kê khoảng trống bằng chứng',
            loading_sr: 'Đang tải khoảng trống bằng chứng',
            status_updated: 'Trạng thái khoảng trống đã cập nhật',
            entity_type_placeholder: 'vd., nhà cung cấp, hệ thống',
            all_modules: 'Tất cả lĩnh vực',
            all_severities: 'Tất cả mức độ',
        },
        program_health: {
            title: 'Sức khỏe Chương trình',
            loading: 'Đang tải dữ liệu sức khỏe chương trình...',
            overall_health: 'Sức khỏe Tổng thể',
            by_module: 'Theo phân hệ',
            risk_areas: 'Khu vực Rủi ro',
            recommendations: 'Khuyến nghị',
            load_error: 'Không thể tải dữ liệu sức khỏe chương trình. Vui lòng thử lại.',
            aria_key_metrics: 'Chỉ số chính sức khỏe chương trình',
            aria_module_scorecard: 'Chi tiết bảng điểm phân hệ',
            loading_sr: 'Đang tải dữ liệu sức khỏe chương trình',
            trending_up: 'Xu hướng tăng',
            trending_down: 'Xu hướng giảm',
            trending_stable: 'Ổn định',
            data_loaded: 'Dữ liệu sức khỏe chương trình đã tải',
        },
        obligation_mappings: {
            title: 'Ánh xạ Nghĩa vụ',
            create_mapping: 'Tạo Ánh xạ Nghĩa vụ',
            // fix-sprint-20260717-2118-followup F12
            section_ownership: 'Chủ sở hữu',
            framework: 'Khung tuân thủ',
            select_framework: 'Chọn khung tuân thủ...',
            obligation: 'Nghĩa vụ',
            obligation_ref: 'Tham chiếu Nghĩa vụ',
            obligation_description: 'Mô tả Nghĩa vụ',
            role: 'Vai trò',
            assigned_role: 'Vai trò được giao',
            select_role: 'Chọn vai trò...',
            assigned_department: 'Phòng ban được giao',
            select_department: 'Chọn phòng ban...',
            control_ids: 'Mã kiểm soát',
            control_ids_placeholder: 'ví dụ: A.5.1, CC6.1',
            control_ids_hint: 'Các mã tham chiếu kiểm soát, phân tách bằng dấu phẩy.',
            raci_assignments: 'Phân công RACI',
            create_raci: 'Tạo Phân công RACI',
            activity: 'Hoạt động',
            activity_name: 'Tên hoạt động',
            activity_description: 'Mô tả hoạt động',
            responsible: 'Chịu trách nhiệm',
            select_users: 'Chọn người dùng...',
            accountable: 'Giải trình',
            select_user: 'Chọn người dùng...',
            consulted: 'Tham vấn',
            informed: 'Thông báo',
            review_frequency: 'Tần suất xem xét',
            frequency_monthly: 'Hàng tháng',
            frequency_quarterly: 'Hàng quý',
            frequency_semi_annual: 'Nửa năm',
            frequency_annual: 'Hàng năm',
            no_mappings_found: 'Không tìm thấy ánh xạ nghĩa vụ.',
            no_raci_found: 'Không tìm thấy phân công RACI.',
            mapping_created: 'Ánh xạ nghĩa vụ đã tạo',
            mapping_updated: 'Ánh xạ nghĩa vụ đã cập nhật',
            mapping_deleted: 'Ánh xạ nghĩa vụ đã xóa',
            raci_created: 'Phân công RACI đã tạo',
            raci_updated: 'Phân công RACI đã cập nhật',
            raci_deleted: 'Phân công RACI đã xóa',
            aria_edit_mapping: 'Sửa ánh xạ {name}',
            aria_delete_mapping: 'Xóa ánh xạ {name}',
            aria_edit_raci: 'Sửa RACI {name}',
            aria_delete_raci: 'Xóa RACI {name}',
            confirm_delete_mapping: 'Xóa ánh xạ nghĩa vụ này?',
            confirm_delete_raci: 'Xóa phân công RACI này?',
            table_view: 'Xem bảng',
            matrix_view: 'Xem ma trận',
            print_export: 'In / Xuất',
            filter_framework: 'Lọc theo khung',
            no_matrix_data: 'Không có phân công RACI để hiển thị dạng ma trận.',
            aria_print_export: 'In hoặc xuất ma trận RACI',
        },
        governance_documents: {
            title: 'Tài liệu Quản trị',
            create_document: 'Tạo Tài liệu Quản trị',
            document_title: 'Tiêu đề Tài liệu',
            document_type: 'Loại Tài liệu',
            content_url: 'URL nội dung',
            content_url_placeholder: 'https://...',
            framework_codes: 'Mã khung tuân thủ',
            select_frameworks: 'Chọn khung tuân thủ...',
            effective_date: 'Ngày hiệu lực',
            review_date: 'Ngày xem xét',
            status: 'Trạng thái',
            version: 'Phiên bản',
            acknowledgments: 'Xác nhận',
            acknowledge: 'Xác nhận',
            acknowledged_by: 'Xác nhận bởi',
            department: 'Phòng ban',
            no_documents_found: 'Không tìm thấy tài liệu quản trị.',
            draft: 'Bản nháp',
            review: 'Xem xét',
            approved: 'Đã phê duyệt',
            issued: 'Đã ban hành',
            superseded: 'Đã thay thế',
            document_created: 'Tài liệu đã tạo',
            document_acknowledged: 'Tài liệu đã xác nhận',
            policy: 'Chính sách',
            procedure: 'Thủ tục',
            standard: 'Tiêu chuẩn',
            guideline: 'Hướng dẫn',
        },
        governance_model: {
            title: 'Mô hình Quản trị',
            create_model: 'Tạo Mô hình Quản trị',
            edit_model: 'Sửa Mô hình Quản trị',
            model_name: 'Tên Mô hình',
            description: 'Mô tả',
            governance_type: 'Loại Quản trị',
            type_centralized: 'Tập trung',
            type_federated: 'Liên bang',
            type_hybrid: 'Hỗn hợp',
            framework_codes: 'Mã khung tuân thủ',
            select_frameworks: 'Chọn khung tuân thủ...',
            review_frequency: 'Tần suất Xem xét',
            freq_monthly: 'Hàng tháng',
            freq_quarterly: 'Hàng quý',
            freq_semi_annual: 'Nửa năm',
            freq_annual: 'Hàng năm',
            committees: 'Ủy ban',
            committee_name: 'Tên Ủy ban',
            committee_members: 'Thành viên (phân tách bằng dấu phẩy)',
            committee_mandate: 'Nhiệm vụ',
            add_committee: 'Thêm Ủy ban',
            no_committees: 'Chưa có ủy ban nào.',
            delegation_rules: 'Quy tắc Ủy quyền',
            from_role: 'Từ Vai trò',
            to_role: 'Đến Vai trò',
            scope: 'Phạm vi',
            add_delegation_rule: 'Thêm Quy tắc Ủy quyền',
            control_owner_summary: 'Tóm tắt Chủ sở hữu Kiểm soát',
            no_raci_data: 'Không có dữ liệu RACI liên kết với mô hình này.',
            activity: 'Hoạt động',
            responsible: 'Chịu trách nhiệm',
            accountable: 'Chịu giải trình',
            consulted: 'Được tham vấn',
            informed: 'Được thông báo',
            no_models_found: 'Không tìm thấy mô hình quản trị.',
            model_created: 'Đã tạo mô hình quản trị',
            model_updated: 'Đã cập nhật mô hình quản trị',
            model_deleted: 'Đã xóa mô hình quản trị',
            confirm_delete: 'Xóa mô hình quản trị này?',
            expand: 'Mở rộng',
            collapse: 'Thu gọn',
            aria_expand: 'Mở rộng chi tiết cho {name}',
            aria_edit: 'Sửa mô hình quản trị {name}',
            aria_delete: 'Xóa mô hình quản trị {name}',
            aria_export_csv: 'Xuất {name} dạng CSV',
            aria_export_json: 'Xuất {name} dạng JSON',
            // Sprint 43.7.0 Wave 5 — bộ chọn có kiểu + cảnh báo quyền khung tuân thủ
            framework_read_permission_warning: 'Bạn cần quyền regulatory_framework:read để chọn khung tuân thủ. Hãy yêu cầu quản trị viên cấp quyền.',
            select_members: 'Chọn thành viên ủy ban',
            select_from_role: 'Chọn vai trò ủy quyền',
            select_to_role: 'Chọn vai trò được nhận ủy quyền',
            // Sprint 43.7.1 Wave 4 — nhiệm vụ markdown + bộ chọn phạm vi có tab.
            mandate_markdown_hint: 'Hỗ trợ Markdown: **đậm**, danh sách, liên kết.',
            scope_tab_obligation: 'Nghĩa vụ',
            scope_tab_framework: 'Khung tuân thủ',
            scope_tab_free_text: 'Văn bản tự do',
            select_obligation: 'Chọn một nghĩa vụ',
            select_framework: 'Chọn một khung tuân thủ',
            aria_remove_committee: 'Xóa ủy ban {n}',
            aria_remove_delegation_rule: 'Xóa quy tắc ủy quyền {n}',
            no_frameworks_available: 'Không có khung nào khả dụng. Hãy thêm khung tuân thủ trước.',
            confirm_discard_changes: 'Bỏ các thay đổi chưa lưu của mô hình quản trị?',
        },
        document_drafting: {
            title: 'Soạn thảo & Phê duyệt Tài liệu',
            document_title: 'Tiêu đề Tài liệu',
            document_type: 'Loại Tài liệu',
            status: 'Trạng thái',
            drafter: 'Người soạn thảo',
            deadline: 'Hạn chót',
            assign_drafter: 'Chỉ định Người soạn thảo',
            select_drafter: 'Chọn người soạn thảo...',
            assign: 'Chỉ định',
            submit_for_review: 'Gửi Xem xét',
            legal_review: 'Xem xét Pháp lý',
            reviewer: 'Người xem xét',
            select_reviewer: 'Chọn người xem xét...',
            comments: 'Nhận xét',
            review_action: 'Hành động Xem xét',
            approve: 'Phê duyệt',
            request_changes: 'Yêu cầu Thay đổi',
            submit_review: 'Gửi Xem xét',
            executive_approval: 'Phê duyệt Lãnh đạo',
            no_drafts_found: 'Không có tài liệu ở giai đoạn soạn thảo, xem xét hoặc phê duyệt.',
            drafter_assigned: 'Đã chỉ định người soạn thảo',
            status_updated: 'Đã cập nhật trạng thái tài liệu',
            review_approved: 'Xem xét đã phê duyệt',
            changes_requested: 'Đã yêu cầu thay đổi',
            document_approved: 'Tài liệu đã phê duyệt',
            aria_assign: 'Chỉ định người soạn thảo cho {name}',
            aria_submit_review: 'Gửi {name} để xem xét',
            aria_review: 'Xem xét {name}',
            aria_approve: 'Phê duyệt {name}',
        },
        document_issuance: {
            title: 'Ban hành & Phân phối Tài liệu',
            document_title: 'Tiêu đề Tài liệu',
            document_type: 'Loại Tài liệu',
            status: 'Trạng thái',
            version: 'Phiên bản',
            effective_date: 'Ngày hiệu lực',
            distribution_scope: 'Phạm vi Phân phối',
            distribution_placeholder: 'VD: Tất cả phòng ban, Đội pháp lý',
            issuance_number: 'Số Ban hành',
            issuance_number_placeholder: 'VD: ISS-2026-001',
            supersedes: 'Thay thế Tài liệu',
            none: 'Không có',
            issue_document: 'Ban hành Tài liệu',
            ready_for_issuance: 'Sẵn sàng Ban hành',
            issued_documents: 'Tài liệu Đã Ban hành',
            no_issued_documents: 'Không tìm thấy tài liệu đã ban hành.',
            view_lineage: 'Xem Dòng kế thừa',
            supersession_lineage: 'Dòng kế thừa Thay thế',
            document_issued: 'Tài liệu đã ban hành',
            document_superseded: 'Tài liệu đã thay thế',
            aria_issue: 'Ban hành {name}',
            aria_view_lineage: 'Xem dòng kế thừa thay thế cho {name}',
            no_approved_documents: 'Không có tài liệu đã phê duyệt nào để ban hành.',
        },
        acknowledgment_tracking: {
            title: 'Theo dõi Xác nhận',
            document_title: 'Tài liệu',
            acknowledged_count: 'Đã xác nhận',
            pending_count: 'Chờ xử lý',
            percentage: 'Hoàn thành',
            details: 'Chi tiết',
            send_reminder: 'Gửi Nhắc nhở',
            acknowledgment_details: 'Chi tiết Xác nhận',
            user: 'Người dùng',
            department: 'Phòng ban',
            acknowledged_at: 'Xác nhận lúc',
            status: 'Trạng thái',
            acknowledged: 'Đã xác nhận',
            no_issued_documents: 'Không có tài liệu đã ban hành để theo dõi.',
            no_acknowledgments: 'Chưa có xác nhận nào được ghi nhận.',
            reminder_sent: 'Đã gửi nhắc nhở cho xác nhận đang chờ',
            aria_expand: 'Xem chi tiết xác nhận cho {name}',
            aria_send_reminder: 'Gửi nhắc nhở cho {name}',
            // Fix sprint #447 W3 — recipients, acknowledging, and the reminder count.
            recipients: 'Người nhận',
            record_recipients: 'Ghi nhận người nhận',
            aria_record_recipients: 'Ghi nhận người nhận cho {name}',
            recipients_dialog_title: 'Người nhận tài liệu {name}',
            recipients_dialog_help: 'Chọn những người được yêu cầu xác nhận tài liệu này. Chỉ những người có vai trò mở được trang Theo dõi Xác nhận mới được liệt kê, vì chỉ họ mới có thể xác nhận.',
            recipients_none_eligible: 'Không có ai trong tổ chức của bạn giữ vai trò có thể xác nhận tài liệu.',
            recipients_saved: 'Đã ghi nhận người nhận',
            recipients_not_recorded: 'Chưa ghi nhận',
            acknowledge: 'Xác nhận',
            aria_acknowledge: 'Xác nhận {name}',
            acknowledge_dialog_title: 'Xác nhận {name}',
            acknowledge_dialog_body: 'Bạn xác nhận đã đọc tài liệu này. Tên của bạn và thời điểm xác nhận được ghi lại.',
            acknowledge_department: 'Phòng ban (không bắt buộc)',
            reminder_sent_count: 'Đã gửi nhắc nhở tới {count} trên {pending} người chưa xác nhận',
            export_documents_count: 'Tài liệu',
            export_acknowledgments_count: 'Lượt xác nhận',
        },
        change_log: {
            title: 'Nhật ký Thay đổi Tài liệu',
            date: 'Ngày',
            document: 'Tài liệu',
            change_type: 'Loại Thay đổi',
            actor: 'Người thực hiện',
            summary: 'Tóm tắt',
            export_csv: 'Xuất CSV',
            filters: 'Bộ lọc nhật ký thay đổi',
            filter_document: 'Lọc theo tài liệu',
            all_documents: 'Tất cả tài liệu',
            filter_change_type: 'Lọc theo loại thay đổi',
            all_types: 'Tất cả loại',
            date_from: 'Từ ngày',
            date_to: 'Đến ngày',
            version_history: 'Lịch sử Phiên bản',
            version_archive: 'Kho lưu trữ Phiên bản',
            no_entries: 'Không tìm thấy mục nhật ký thay đổi.',
            no_history: 'Không có lịch sử phiên bản.',
            exported: 'Đã xuất nhật ký thay đổi',
            aria_export: 'Xuất nhật ký thay đổi dạng CSV',
            aria_view_history: 'Xem lịch sử phiên bản cho {name}',
            // fix-sprint #447 W6 — `DocumentChangeType` labels; the page showed raw codes.
            type_created: 'Đã tạo',
            type_status_transition: 'Đã đổi trạng thái',
            type_fields_updated: 'Đã cập nhật trường thông tin',
            type_superseded: 'Đã thay thế',
            type_acknowledged: 'Đã xác nhận',
            // fix-sprint #447 round 2 — metadata line of the server-rendered export.
            export_generated_at: 'Tạo lúc',
        },
        review_cadence: {
            title: 'Lịch Xem xét',
            configure_cadence: 'Cấu hình Lịch Xem xét',
            edit_cadence: 'Sửa Lịch Xem xét',
            document: 'Tài liệu',
            select_document: 'Chọn tài liệu...',
            review_frequency: 'Tần suất Xem xét',
            freq_30: '30 ngày',
            freq_60: '60 ngày',
            freq_90: '90 ngày',
            freq_180: '180 ngày',
            freq_365: '365 ngày',
            last_reviewed: 'Xem xét Lần cuối',
            next_review: 'Xem xét Tiếp theo',
            status: 'Trạng thái',
            overdue: 'Quá hạn',
            on_track: 'Đúng tiến độ',
            days: 'ngày',
            horizon: 'Tầm nhìn Xem xét',
            overdue_warning: 'Xem xét Quá hạn',
            overdue_count: '{count} tài liệu có xem xét quá hạn.',
            no_cadences: 'Chưa có lịch xem xét nào được cấu hình.',
            cadence_created: 'Đã tạo lịch xem xét',
            cadence_updated: 'Đã cập nhật lịch xem xét',
            aria_edit: 'Sửa lịch xem xét cho {name}',
        },
        remediation_plans: {
            title: 'Kế hoạch Khắc phục',
            create_plan: 'Tạo Kế hoạch Khắc phục',
            gap_id: 'Tham chiếu khoảng trống',
            select_gap: 'Chọn khoảng trống...',
            plan_title: 'Tiêu đề',
            description: 'Mô tả',
            priority: 'Mức ưu tiên',
            priority_critical: 'Nghiêm trọng',
            priority_high: 'Cao',
            priority_medium: 'Trung bình',
            priority_low: 'Thấp',
            assigned_to: 'Giao cho',
            select_user: 'Chọn người dùng...',
            target_date: 'Ngày mục tiêu',
            framework_code: 'Khung tuân thủ',
            select_framework: 'Chọn khung tuân thủ...',
            gap_finding: 'Phát hiện Khoảng trống',
            action_items: 'Hạng mục Hành động',
            owner: 'Chủ sở hữu',
            deadline: 'Hạn chót',
            planned: 'Đã lên kế hoạch',
            in_progress: 'Đang thực hiện',
            completed: 'Hoàn thành',
            verified: 'Đã xác minh',
            no_plans_found: 'Không tìm thấy kế hoạch khắc phục.',
            evidence: 'Bằng chứng',
            plan_created: 'Kế hoạch khắc phục đã tạo',
            action_items_hint: 'Mục hành động (mỗi dòng một mục)',
        },
        statuses: {
            identified: 'Đã xác định',
            assigned: 'Đã giao',
            in_remediation: 'Đang khắc phục',
            resolved: 'Đã giải quyết',
            accepted_risk: 'Chấp nhận rủi ro',
            planned: 'Đã lên kế hoạch',
            in_progress: 'Đang thực hiện',
            under_review: 'Đang xem xét',
            finalized: 'Đã hoàn thành',
            archived: 'Đã lưu trữ',
            draft: 'Bản nháp',
            active: 'Đang hoạt động',
            upcoming: 'Sắp tới',
            collecting: 'Đang thu thập',
            published: 'Đã xuất bản',
            review: 'Xem xét',
            approved: 'Đã phê duyệt',
            issued: 'Đã ban hành',
            superseded: 'Đã thay thế',
            completed: 'Hoàn thành',
            verified: 'Đã xác minh',
        },
        severities: {
            critical: 'Nghiêm trọng',
            high: 'Cao',
            medium: 'Trung bình',
            low: 'Thấp',
        },
        priorities: {
            critical: 'Nghiêm trọng',
            high: 'Cao',
            medium: 'Trung bình',
            low: 'Thấp',
        },
        gap_types: {
            missing: 'Thiếu',
            expired: 'Hết hạn',
            insufficient: 'Không đủ',
        },
        document_types: {
            policy: 'Chính sách',
            procedure: 'Quy trình',
            standard: 'Tiêu chuẩn',
            guideline: 'Hướng dẫn',
            template: 'Mẫu (Nội bộ)',
        },
        maturity_levels: {
            level_1: 'Cấp 1 — Khởi đầu',
            level_2: 'Cấp 2 — Phát triển',
            level_3: 'Cấp 3 — Xác định',
            level_4: 'Cấp 4 — Quản lý',
            level_5: 'Cấp 5 — Tối ưu hóa',
        },
        grades: {
            excellent: 'Xuất sắc',
            good: 'Tốt',
            fair: 'Khá',
            poor: 'Kém',
            critical: 'Nghiêm trọng',
            needs_improvement: 'Cần cải thiện',
            not_assessed: 'Chưa đánh giá',
        },
        modules: {
            data_mapping: 'Ánh xạ dữ liệu',
            consent: 'Đồng ý',
            governance: 'Quản trị',
            incidents: 'Sự cố',
            monitoring: 'Giám sát',
            classification: 'Phân loại',
            vendor_risk: 'Rủi ro nhà cung cấp',
            discovery: 'Khám phá',
            deletion: 'Xóa',
        },
        cadences: {
            monthly: 'Hàng tháng',
            quarterly: 'Hàng quý',
            semi_annual: 'Nửa năm',
            annual: 'Hàng năm',
        },
        section_labels: {
            opening: 'Mở đầu',
            key_metrics: 'Chỉ số chính',
            highlights: 'Điểm nổi bật',
            concerns: 'Mối quan tâm',
            recommendations: 'Khuyến nghị',
            outlook: 'Triển vọng',
        },
        out_of_100: '/ 100',
        count_gaps: '{count} lỗ hổng',
        count_gaps_plural: '{count} lỗ hổng',
        count_summaries: '{count} bản tóm tắt',
        count_summaries_plural: '{count} bản tóm tắt',
        count_assessments: '{count} đánh giá',
        count_assessments_plural: '{count} đánh giá',
        count_models: '{count} mô hình',
        count_models_plural: '{count} mô hình',
        count_periods: '{count} kỳ',
        count_periods_plural: '{count} kỳ',
        count_metrics: '{count} chỉ số',
        count_metrics_plural: '{count} chỉ số',
        unknown_user: 'Người dùng không xác định',
        unknown_gap: 'Lỗ hổng không xác định',
        no_permission_title: 'Không đủ quyền',
        no_permission_message: 'Bạn không có quyền truy cập trang này.',
        // --- AC info boxes (Sprint 32.2.0 QA) ---
        ac_vn_frameworks_title: 'Phạm vi khung tuân thủ VN',
        ac_vn_frameworks_body: 'Đánh giá trưởng thành bao gồm tất cả 6 khung tuân thủ Việt Nam với tiêu chí riêng theo từng khung: Luật Dữ liệu (VNDL), Luật An ninh mạng (VNCSL), Luật Bảo vệ người tiêu dùng (VNCPL), Luật Giao dịch điện tử (VNETL), Luật Viễn thông (VNTL), và Luật Sở hữu trí tuệ (VNIPL).',
        ac_controller_processor_title: 'Bên kiểm soát vs. Bên xử lý',
        ac_controller_processor_body: 'Ánh xạ nghĩa vụ phân biệt giữa trách nhiệm của bên kiểm soát dữ liệu và bên xử lý dữ liệu. Sử dụng ma trận RACI để đảm bảo mỗi nghĩa vụ có người chịu trách nhiệm rõ ràng.',
        ac_versioned_evidence_title: 'Bằng chứng có phiên bản',
        ac_versioned_evidence_body: 'Mỗi chuyển đổi trạng thái (Nháp, Xem xét, Phê duyệt, Ban hành) tạo ra bản ghi có dấu thời gian và phiên bản, dùng làm bằng chứng kiểm toán. Nhật ký thay đổi ghi lại toàn bộ lịch sử vòng đời tài liệu.',
        ac_remediation_gap_link_title: 'Liên kết với lỗ hổng đánh giá',
        ac_remediation_gap_link_body: 'Mỗi kế hoạch khắc phục liên kết trực tiếp với một lỗ hổng đánh giá đã xác định. Chỉ định người phụ trách và đặt hạn chót để theo dõi tiến độ giải quyết.',
        ac_annual_attestation_title: 'Chu kỳ chứng nhận hàng năm',
        ac_annual_attestation_body: 'Kỳ báo cáo phù hợp với yêu cầu chứng nhận hàng năm của Luật Dữ liệu Việt Nam. Sử dụng tần suất "Hàng năm" (chu kỳ 365 ngày) để tạo các kỳ tự động phù hợp với chứng nhận.',
        ac_evidence_per_obligation_title: 'Bằng chứng theo nghĩa vụ',
        ac_evidence_per_obligation_body: 'Lỗ hổng bằng chứng xác định các bằng chứng thiếu, hết hạn hoặc không đầy đủ cho mỗi nghĩa vụ theo khung tuân thủ. Lọc theo lĩnh vực để xem yêu cầu nào thiếu tài liệu hỗ trợ.',
        ac_cross_framework_title: 'Mức độ hoàn thiện đa khung',
        ac_cross_framework_body: 'Sẵn sàng kiểm toán cung cấp cái nhìn về mức độ hoàn thiện đa khung. Điểm thành phần phản ánh phạm vi bao phủ trên tất cả các khung đã ánh xạ.',
        ac_cadence_default_title: 'Tần suất xem xét mặc định',
        ac_cadence_default_body: 'Tần suất xem xét mặc định là 180 ngày. Các lần xem xét quá hạn được tự động đánh dấu. Điều chỉnh tần suất theo tài liệu khi cần — từ 30 đến 365 ngày.',
        ac_templates_internal_title: 'Phân loại mẫu',
        ac_templates_internal_body: 'Các mẫu được phân loại là tài liệu nội bộ. Sử dụng loại tài liệu "Mẫu" để đánh dấu các tài liệu quản trị có thể tái sử dụng với phạm vi phân phối nội bộ.',
        // fix-sprint-20260822-2115 F1/F3 — this panel used to carry a module-local
        // `const COPY = { en: {…}, vi: {…} }` and pick a branch with
        // `locale.startsWith('vi') ? 'vi' : 'en'`. Both shapes are named in
        // I18N.md §2 and §3 as the root cause of 14 locales rendering English, and
        // the strings were registered in no bundle at all, so deepMerge had nothing
        // to fall back to. The four enum label maps below close F3: `status`,
        // `legal_review_status`, `evidence_state` and `answer_state` were rendering
        // raw slugs next to an already-labelled badge on the same row.
        handbook_assessment: {
            ask_forseti: 'Hỏi Forseti về checklist này',
            candidate_link: 'Liên kết bản ghi này',
            candidate_linked: 'Đã liên kết',
            candidate_linking: 'Đang liên kết…',
            candidate_no_date: 'Không có ngày ghi nhận',
            candidate_open: 'Mở bản ghi',
            evidence_kind_manual: 'Nhập thủ công',
            evidence_kind_platform: 'Bản ghi trên nền tảng',
            link_manual_fallback: 'Nếu không mục nào ở trên phù hợp, hãy ghi nhận bằng chứng thủ công.',
            reason_module_not_readable: 'Gói pháp lý khai báo một phân hệ mà bản dựng nền tảng này chưa đọc được để lấy bằng chứng. Hãy liên kết bản ghi thủ công.',
            reason_module_not_permitted: 'Vai trò của bạn không được đọc phân hệ chứa bằng chứng này. Hãy đề nghị quản trị viên cấp quyền, hoặc liên kết bản ghi thủ công.',
            reason_no_matching_record: 'Tổ chức này chưa có bản ghi nào thuộc loại này.',
            reason_record_not_accepted: 'Đã có bản ghi nhưng chưa ở trạng thái được chấp nhận. Hãy hoàn tất hoặc phê duyệt bản ghi rồi đối chiếu lại.',
            source_form: 'Biểu mẫu',
            source_module: 'Phân hệ',
            source_role: 'Vai trò bằng chứng',
            sources_error: 'Không thể tải nguồn dữ liệu trên nền tảng cho câu hỏi này.',
            sources_heading: 'Bằng chứng nền tảng có thể cung cấp',
            sources_intro: 'Gói pháp lý khai báo những bản ghi nào của chính bạn có thể đáp ứng câu hỏi này. Dưới đây là các bản ghi phù hợp mà tổ chức này đang có.',
            sources_loading: 'Đang tải nguồn dữ liệu trên nền tảng…',
            unreconciled_question: 'C\u00e2u h\u1ecfi n\u00e0y kh\u00f4ng c\u00f3 tr\u00ean h\u1ed3 s\u01a1 c\u1ee7a \u0111\u1ee3t \u0111\u00e1nh gi\u00e1 n\u00e0y v\u00e0 kh\u00f4ng th\u1ec3 tr\u1ea3 l\u1eddi t\u1ea1i \u0111\u00e2y: {question}',
            sources_toggle: 'Hiện nguồn dữ liệu trên nền tảng',
            collapse_all: 'Thu gọn tất cả câu hỏi',
            crosslink_action: 'Mở đánh giá theo cẩm nang',
            crosslink_body: 'Đánh giá mức độ trưởng thành chấm điểm chương trình theo một mô hình trưởng thành. Checklist theo cẩm nang chính thức là một bản ghi riêng: nó thu thập bằng chứng theo cẩm nang pháp lý và cố ý không tạo ra điểm số.',
            crosslink_title: 'Checklist bằng chứng theo cẩm nang chính thức',
            expand_all: 'Mở tất cả câu hỏi',
            group_progress: 'Đã trả lời {answered}/{total}',
            module_guide_summary: 'Hoàn thành checklist bằng chứng theo cẩm nang pháp lý chính thức. Mỗi câu hỏi ghi nhận câu trả lời, trạng thái bằng chứng và các bản ghi hỗ trợ đang lưu trên nền tảng. Checklist này không tạo ra điểm tuân thủ — việc rà soát pháp lý của con người mới kết thúc hồ sơ.',
            page_description: 'Checklist bằng chứng theo cẩm nang pháp lý chính thức. Mỗi câu hỏi ghi nhận câu trả lời, trạng thái bằng chứng và các bản ghi trên nền tảng dùng để chứng minh.',
            page_title: 'Đánh giá theo cẩm nang',
            question_fields: 'Nội dung trả lời câu hỏi',
            loading: 'Đang tải đánh giá theo cẩm nang chính thức',
            load_error: 'Không thể tải đánh giá theo cẩm nang chính thức.',
            start: 'Bắt đầu đánh giá theo cẩm nang chính thức',
            empty: 'Tổ chức chưa bắt đầu đánh giá theo cẩm nang chính thức.',
            progress: 'câu hỏi đã trả lời',
            no_score: 'Checklist bằng chứng này không tính hoặc khẳng định điểm tuân thủ pháp luật. Cần có rà soát pháp lý của con người.',
            save: 'Lưu câu trả lời',
            saving: 'Đang lưu…',
            resolve: 'Đối chiếu bằng chứng hiện có',
            resolving: 'Đang đối chiếu…',
            evidence: 'Trạng thái bằng chứng',
            answer: 'Câu trả lời',
            notes: 'Ghi chú và lý do áp dụng',
            linked: 'Bằng chứng đã liên kết',
            no_evidence: 'Chưa có bằng chứng được liên kết.',
            manual: 'Liên kết bằng chứng thủ công',
            description: 'Mô tả bằng chứng',
            source: 'Nguồn bằng chứng',
            owner: 'Chủ sở hữu bằng chứng',
            date: 'Ngày bằng chứng',
            url: 'URL bằng chứng',
            invalid_url: 'Nhập URL đầy đủ bắt đầu bằng http:// hoặc https://.',
            link: 'Liên kết bằng chứng',
            linking: 'Đang liên kết…',
            remediate: 'Tạo nhiệm vụ khắc phục',
            remediating: 'Đang tạo nhiệm vụ…',
            review_question: 'Đánh dấu câu hỏi đã rà soát',
            reviewing: 'Đang rà soát…',
            submit: 'Gửi đủ 30 câu hỏi để rà soát',
            finalize: 'Hoàn tất rà soát pháp lý',
            return_revision: 'Trả lại để chỉnh sửa',
            export: 'Xuất báo cáo bằng chứng đã rà soát',
            exporting: 'Đang xuất…',
            status: 'Trạng thái đánh giá',
            legal_review: 'Rà soát pháp lý',
            saved: 'Đã lưu câu trả lời.',
            resolved: 'Đã hoàn tất đối chiếu bằng chứng hiện có.',
            linked_done: 'Đã liên kết bằng chứng để rà soát.',
            remediation_done: 'Đã tạo nhiệm vụ khắc phục.',
            review_done: 'Đã cập nhật trạng thái rà soát.',
            exported: 'Đã xuất báo cáo bằng chứng được rà soát.',
            export_format: 'Định dạng',
            export_language: 'Ngôn ngữ',
            export_format_pdf: 'PDF',
            export_format_docx: 'DOCX',
            export_language_en: 'English',
            export_language_vi: 'Tiếng Việt',
            export_language_bilingual: 'English / Tiếng Việt',
            answer_state: {
                unanswered: 'Chưa trả lời',
                yes: 'Có',
                no: 'Không',
                unknown: 'Chưa rõ',
                not_applicable: 'Không áp dụng',
            },
            assessment_status: {
                in_progress: 'Đang thực hiện',
                under_review: 'Đang rà soát',
                reviewed: 'Đã rà soát',
                archived: 'Đã lưu trữ',
            },
            legal_review_status: {
                pending: 'Chờ xử lý',
                reviewed: 'Đã rà soát',
                revision_requested: 'Đã yêu cầu chỉnh sửa',
            },
            evidence_state: {
                resolved: 'Đã đối chiếu',
                missing: 'Còn thiếu',
                stale: 'Đã cũ',
                unsupported: 'Không hỗ trợ',
                manual_pending_review: 'Thủ công — chờ rà soát',
            },
        },
    },
    // ---------- MCP Phase 2 — Pending writes queue (Sprint 48.3.0) ----------
    mcp_pending: {
        title: 'MCP — Yêu cầu ghi đang chờ',
        subtitle: 'Các client Claude bên ngoài đề xuất ghi tại đây. Phê duyệt hoặc từ chối từng mục — Forseti chỉ thực thi sau khi admin xác nhận.',
        no_pending: 'Không có yêu cầu chờ.',
        filter_status_label: 'Lọc theo trạng thái',
        filter_all: 'Tất cả',
        no_results_for_status: 'Không có yêu cầu ghi nào ở trạng thái này.',
        col_tool: 'Công cụ',
        col_preview: 'Xem trước',
        col_key: 'Khóa API',
        col_requested: 'Đã yêu cầu',
        col_expires: 'Hết hạn',
        col_status: 'Trạng thái',
        status_pending: 'Chờ xử lý',
        status_approved: 'Đã phê duyệt',
        status_declined: 'Đã từ chối',
        status_expired: 'Đã hết hạn',
        status_executed: 'Đã thực thi',
        status_failed: 'Thất bại — không ghi được gì',
        approve_failed: 'Đã phê duyệt, nhưng thao tác ghi KHÔNG diễn ra — {tool} không được thực thi ({code}). Không có gì được tạo ra hoặc thay đổi.',
        approve_executed: '{tool} đã được thực thi.',
        approve_label: 'Phê duyệt',
        decline_label: 'Từ chối',
        refresh_label: 'Làm mới',
        error_generic: 'Không thể tải các yêu cầu chờ.',
        confirm_approve: 'Phê duyệt sẽ thực thi công cụ với tổ chức của bạn dùng quyền của chủ API key. Tiếp tục?',
        confirm_decline: 'Từ chối yêu cầu này? Không thể hoàn tác.',
        // Sprint 64.123.0 — approving a queued MCP write now mints the human
        // confirmation the tool manifest requires, so the surface has to say what
        // that approval is worth, and when it is self-attestation.
        confirmation_note: 'Phê duyệt sẽ ghi nhận xác nhận của con người mà các công cụ này yêu cầu, và thao tác ghi sau đó được thực thi bằng quyền của chủ khóa API — không phải quyền của bạn. Nếu chính bạn đã đề xuất thao tác ghi này, phê duyệt của bạn được ghi nhận là tự phê duyệt và không phải là một lần rà soát độc lập.',
        self_approval_badge: 'Bạn đã đề xuất thao tác ghi này — phê duyệt nó là tự xác nhận, không phải một lần rà soát thứ hai.',
        confirm_approve_self: 'Bạn đã đề xuất thao tác ghi này. Phê duyệt sẽ ghi nhận xác nhận CỦA CHÍNH BẠN — không có người thứ hai rà soát. Nhật ký kiểm toán sẽ ghi là tự phê duyệt. Tiếp tục?',
        advisory_banner: 'Yêu cầu chờ hết hạn sau 24 giờ. Tác vụ quét hàng giờ đánh dấu các yêu cầu hết hạn là Đã hết hạn; thao tác ghi đã hết hạn sẽ không bao giờ được thực hiện.',
        consequential_label: 'Hồ sơ nộp có hệ quả pháp lý',
        consequential_target: 'Bản ghi đích',
        consequential_authority: 'Cơ quan có thẩm quyền',
        consequential_authority_unknown: 'Mẫu đã cài đặt không khai báo',
        consequential_prior: 'Trước đó',
        consequential_proposed: 'Đề xuất',
        consequential_empty: '(không có)',
        consequential_unresolved: 'Không thể đọc bản ghi đích khi mục này được đưa vào hàng đợi —',
        consequential_captured_at: 'Giá trị được đọc lúc',
        // fix-sprint-20261003-1200 F5 — the approve refusals, by server code.
        refusal_proposer_lacks_forseti: 'Thao tác ghi này không được thực hiện: vai trò của người đề xuất không còn được phép dùng Forseti, nên không thể thực thi thay họ. Không có gì bị thay đổi. Hãy từ chối để gỡ mục này khỏi hàng đợi.',
        refusal_proposer_inactive: 'Thao tác ghi này không được thực hiện: người đề xuất không còn là thành viên đang hoạt động của tổ chức. Không có gì bị thay đổi. Hãy từ chối để gỡ mục này khỏi hàng đợi.',
        refusal_key_inactive: 'Thao tác ghi này không được thực hiện: khóa API hoặc ứng dụng đã kết nối đề xuất nó không còn được phép thực hiện. Không có gì bị thay đổi. Hãy từ chối để gỡ mục này khỏi hàng đợi.',
        refusal_already_resolved: 'Thao tác ghi này đã được người khác xử lý. Hãy làm mới để xem trạng thái hiện tại.',
        refusal_expired: 'Thao tác ghi này đã hết hạn và không thể phê duyệt nữa.',
        refusal_state_changed: 'Thao tác ghi này đã thay đổi trạng thái trong khi bạn đang phê duyệt. Hãy làm mới để xem trạng thái hiện tại.',
        decline_dialog_title: 'Từ chối thao tác ghi đang chờ',
        decline_reason_label: 'Lý do từ chối',
        decline_reason_hint: 'Bắt buộc, tối đa 500 ký tự. Lý do được ghi lại cùng quyết định của bạn.',
        decline_submit: 'Từ chối thao tác ghi',
        decline_cancel: 'Giữ ở trạng thái chờ',
        col_actions: 'Thao tác',
    },
    // ---------- Audit walkthrough + Privilege creep (Sprint 48.2.9) ----------
    audit_walkthrough: {
        title: 'Forseti — Trình tạo kịch bản kiểm toán',
        subtitle: 'Tạo kịch bản có cấu trúc cho buổi kickoff kiểm toán: câu hỏi mở đầu, bằng chứng kỳ vọng, câu hỏi tiếp theo, khoảng trống tiềm năng.',
        audit_picker_label: 'Cuộc kiểm toán',
        audit_picker_hint: 'Chọn cuộc kiểm toán đã lên kế hoạch.',
        run_label: 'Tạo kịch bản',
        running: 'Đang tạo…',
        results_heading: 'Kịch bản — {count} kiểm soát',
        tokens_label: '≈ {count} token',
        no_controls: 'Không có kiểm soát trong phạm vi. Thêm kiểm soát vào hồ sơ kiểm toán.',
        col_control: 'Kiểm soát',
        col_question: 'Câu hỏi mở đầu',
        col_evidence: 'Bằng chứng',
        col_gaps: 'Khoảng trống tiềm năng',
        expected_evidence_label: 'Bằng chứng kỳ vọng',
        followup_probes_label: 'Câu hỏi tiếp theo',
        accept_label: 'Chấp nhận kịch bản',
        reject_label: 'Từ chối',
        export_label: 'Xuất DOCX',
        resolve_summary: 'Kết quả: {status}',
        resolve_status_accepted: 'Đã chấp nhận',
        resolve_status_rejected: 'Đã từ chối',
        controls_range: 'Kiểm soát {from}–{to} / {total}',
        next_page_label: 'Tạo kịch bản cho các kiểm soát tiếp theo',
        error_generic: 'Không thể tạo kịch bản. Hãy thử lại hoặc kiểm tra trạng thái cuộc kiểm toán.',
    },
    privilege_creep: {
        title: 'Forseti — Phát hiện đặc quyền lan rộng',
        subtitle: 'Quét định kỳ các phân công vai trò. Kết quả mang tính tư vấn — Forseti không bao giờ tự thu hồi quyền.',
        run_label: 'Quét ngay',
        running: 'Đang quét…',
        findings_heading: '{count} phát hiện',
        no_findings: 'Không phát hiện đặc quyền lan rộng.',
        col_user: 'Người dùng',
        col_job_function: 'Chức năng',
        col_severity: 'Mức độ',
        col_unexpected: 'Quyền không mong muốn',
        col_remediation: 'Khắc phục đề xuất',
        col_status: 'Trạng thái',
        severity_critical: 'Nghiêm trọng',
        severity_high: 'Cao',
        severity_medium: 'Trung bình',
        severity_low: 'Thấp',
        status_open: 'Mở',
        status_dismissed: 'Bỏ qua',
        status_remediated: 'Đã khắc phục',
        dismiss_label: 'Bỏ qua',
        remediate_label: 'Đánh dấu đã khắc phục',
        note_label: 'Ghi chú (tùy chọn)',
        error_generic: 'Không thể quét đặc quyền lan rộng. Hãy thử lại sau.',
        advisory_banner: 'Các phát hiện chỉ mang tính tư vấn. Forseti không tự thu hồi quyền — hãy xem xét cùng chủ vai trò trước khi hành động.',
    },
    // ---------- Compliance Rules (Sprint 48.2.8) ----------
    compliance_rules: {
        rule_mapping: {
            title: 'Tự động ánh xạ quy tắc tuân thủ',
            subtitle: 'Forseti duyệt một gói pháp lý đã cài đặt và đề xuất quy tắc mới hoặc cần làm mới, dựa trên các điều khoản nguồn.',
            pack_picker_label: 'Gói pháp lý',
            pack_picker_hint: 'Chọn gói đã cài đặt để ánh xạ.',
            run_label: 'Ánh xạ từ gói',
            running: 'Đang ánh xạ…',
            results_heading: '{count} đề xuất',
            tokens_label: '≈ {count} token',
            no_suggestions: 'Không có đề xuất — nội dung gói có thể đã được các quy tắc hiện có bao phủ đầy đủ.',
            kind_new: 'Quy tắc mới',
            kind_refresh: 'Đã có quy tắc (chỉ để xem)',
            kind_no_change: 'Không cần thay đổi',
            col_kind: 'Loại',
            col_title: 'Tiêu đề đề xuất',
            col_existing: 'Quy tắc hiện có',
            col_source: 'Nguồn',
            proposed_body_label: 'Nội dung đề xuất',
            source_quote_label: 'Trích dẫn nguồn',
            accept_selected: 'Chấp nhận mục đã chọn',
            reject_all: 'Từ chối tất cả',
            accept_all: 'Chấp nhận tất cả',
            resolve_summary: 'Kết quả: {status} · đã tạo {created} quy tắc nháp · {skipped} đề xuất giữ nguyên vì đã có quy tắc bao phủ yêu cầu',
            error_generic: 'Không thể chạy ánh xạ quy tắc. Hãy thử lại hoặc kiểm tra mã gói.',
            write_permission_hint: 'Chấp nhận đề xuất cần quyền chỉnh sửa khung quy định. Bạn vẫn có thể từ chối lượt chạy này.',
            examined_label: 'Đã đọc các đoạn {from}–{to} trong tổng số {total} đoạn mà lượt tìm kiếm của gói này trả về, xếp theo một lượt tìm kiếm cố định. Lần chạy mới bắt đầu lại từ đoạn 1.',
            examined_remaining: 'Còn {remaining} đoạn chưa được đọc. Dùng “Đọc các đoạn tiếp theo” để đọc tiếp từ chỗ lần chạy này dừng.',
            read_next_label: 'Đọc các đoạn tiếp theo',
            read_next_blocked: 'Hãy chấp nhận hoặc từ chối các đề xuất ở trên trước; các đoạn tiếp theo được đọc sau khi bản nháp này được xử lý.',
            run_blocked: 'Hãy chấp nhận hoặc từ chối các đề xuất ở trên trước; chạy ánh xạ lại từ gói này sẽ thay thế bản nháp đang hiển thị.',
            drafts_hint: 'Các đề xuất được chấp nhận sẽ được lưu thành quy tắc nháp trong thư viện quy tắc. Quy tắc nháp chưa có hiệu lực cho đến khi có người kích hoạt, và sản phẩm hiện chưa có trang dành cho quy tắc tuân thủ. Đoạn đã được một quy tắc hiện có bao phủ chỉ hiển thị để xem và không tạo thêm gì.',
        },
    },
    access_accountability: {
        nav: {
            session_dashboard: 'Bảng phiên làm việc',
            access_log: 'Nhật ký truy cập',
            justification_review: 'Xem xét lý do',
            investigations: 'Điều tra',
            pattern_analysis: 'Phân tích khuôn mẫu',
            anchoring_status: 'Trạng thái neo',
            configuration: 'Cấu hình',
            access_policies: 'Chính sách truy cập',
            review_campaigns: 'Chiến dịch rà soát',
            evidence_packages: 'Gói bằng chứng',
        },
        session_dashboard: {
            title: 'Bảng Phiên làm việc',
            loading: 'Đang tải dữ liệu...',
            total_sessions: 'Tổng Phiên',
            active_sessions: 'Phiên Hoạt động',
            avg_duration: 'Thời gian TB',
            peak_day_sessions: 'Ngày cao điểm',
            auth_method_breakdown: 'Phân tích Phương thức Xác thực',
            geo_country_breakdown: 'Phân tích theo Quốc gia',
            recent_session_events: 'Sự kiện Phiên Gần đây',
            user_id: 'Mã Người dùng',
            session_id: 'Mã Phiên',
            ip_address: 'Địa chỉ IP',
            auth_method: 'Phương thức Xác thực',
            started_at: 'Bắt đầu lúc',
            event_type: 'Loại Sự kiện',
            all_event_types: 'Tất cả Loại sự kiện',
            filter_by_user: 'Lọc theo người dùng',
            no_active_sessions: 'Không có phiên hoạt động',
            no_session_events: 'Không tìm thấy sự kiện phiên',
            revoke: 'Thu hồi',
            revoke_session: 'Thu hồi Phiên',
            aria_revoke_session: 'Thu hồi phiên {user}',
            revoke_reason: 'Lý do',
            revoke_placeholder: 'Cung cấp lý do thu hồi phiên này...',
            session_label: 'Phiên:',
            load_failed: 'Không thể tải bảng phiên. Vui lòng thử lại.',
            events_load_failed: 'Không thể tải sự kiện phiên. Vui lòng thử lại.',
            revoke_failed: 'Không thể thu hồi phiên',
            session_events_loaded: 'Đã tải {n} sự kiện phiên',
            event_types: {
                session_started: 'Phiên bắt đầu',
                session_refreshed: 'Phiên làm mới',
                session_expired: 'Phiên hết hạn',
                session_revoked: 'Phiên thu hồi',
                session_terminated: 'Phiên kết thúc',
            },
        },
        access_log: {
            title: 'Nhật ký Truy cập',
            user_id: 'Mã Người dùng',
            resource: 'Tài nguyên',
            action: 'Hành động',
            ip_address: 'Địa chỉ IP',
            timestamp: 'Thời gian',
            no_logs: 'Không tìm thấy nhật ký truy cập.',
            filter_by_user: 'Lọc theo Mã người dùng...',
            load_failed: 'Không thể tải nhật ký truy cập. Vui lòng thử lại.',
            export_success: 'Xuất dữ liệu thành công',
            export_failed: 'Không thể xuất nhật ký truy cập',
            record_count: 'bản ghi',
            record_count_plural: 'bản ghi',
            classification_missing: 'Thiếu phân loại',
            classification_level: 'Cấp độ phân loại',
            unclassified: 'Chưa phân loại',
            response_code: 'Mã phản hồi',
            access_surface: 'Kênh truy cập',
            api_key: 'Khóa API',
            classification_levels: {
                public: 'Công khai',
                internal: 'Nội bộ',
                confidential: 'Bảo mật',
                restricted: 'Hạn chế',
                unclassified: 'Chưa phân loại',
            },
        },
        justification_review: {
            title: 'Xem xét Lý do',
            user_id: 'Mã Người dùng',
            resource: 'Tài nguyên',
            justification: 'Lý do',
            submitted_at: 'Gửi lúc',
            reviewer: 'Người xem xét',
            no_reviews: 'Không tìm thấy xem xét lý do.',
            load_failed: 'Không thể tải lý do. Vui lòng thử lại.',
            review_failed: 'Không thể xem xét lý do',
            decline_failed: 'Không thể từ chối truy cập',
            justification_count: 'lý do',
            justification_count_plural: 'lý do',
            reviewed: 'Đã xem xét',
            concerning: 'Đáng lo ngại',
            escalated: 'Đã chuyển cấp',
            link_investigation_placeholder: 'Liên kết đến điều tra (tùy chọn)',
            review_queue: 'Hàng đợi xem xét',
            unclassified: 'Chưa phân loại',
            create_failed: 'Không thể create justification',
            reason_placeholder: 'Lý do truy cập tài nguyên này...',
            resource_id_placeholder: 'Định danh tài nguyên',
            resource_id_label: 'ID tài nguyên',
            resource_type_placeholder: 'vd. document, database',
            resource_type_label: 'Loại tài nguyên',
            access_id_placeholder: 'ID mục nhật ký truy cập',
            access_id_label: 'ID truy cập',
            reason_codes: {
                administrative: 'Hành chính',
                audit_requirement: 'Yêu cầu kiểm toán',
                business_need: 'Nhu cầu kinh doanh',
                data_subject_request: 'Yêu cầu chủ thể dữ liệu',
                incident_response: 'Ứng phó sự cố',
                legal_obligation: 'Nghĩa vụ pháp lý',
                other: 'Khác',
                research: 'Nghiên cứu',
            },
            review_statuses: {
                concerning: 'Đáng lo ngại',
                escalated: 'Đã leo thang',
                pending: 'Chờ xử lý',
                reviewed: 'Đã xem xét',
            },
            classification_level: 'Cấp độ phân loại',
            review_decision: 'Quyết định xem xét',
        },
        investigations: {
            title: 'Không gian Điều tra',
            new: 'Điều tra mới',
            subject: 'Chủ đề',
            investigator: 'Điều tra viên',
            opened_at: 'Mở lúc',
            findings: 'Phát hiện',
            no_investigations: 'Không tìm thấy điều tra.',
            load_failed: 'Không thể tải điều tra. Vui lòng thử lại.',
            create_failed: 'Không thể tạo điều tra',
            timeline_add_failed: 'Không thể thêm mốc thời gian',
            link_access_failed: 'Không thể liên kết mã truy cập',
            link_justification_failed: 'Không thể liên kết mã lý do',
            close_failed: 'Không thể đóng điều tra',
            export_success: 'Xuất dữ liệu thành công',
            export_failed: 'Không thể xuất điều tra',
            refresh_failed: 'Không thể làm mới chi tiết điều tra. Vui lòng thử lại.',
            update_failed: 'Không thể cập nhật điều tra',
            investigation_count: 'điều tra',
            investigation_count_plural: 'điều tra',
            title_placeholder: 'Tiêu đề điều tra',
            description_placeholder: 'Mô tả chi tiết về điều tra...',
            assignee_placeholder: 'Mã người dùng của người được giao (tùy chọn)',
            timeline_action_placeholder: 'Ví dụ: Đã xem xét nhật ký truy cập',
            timeline_note_placeholder: 'Ghi chú tùy chọn',
            access_ids_placeholder: 'mã-truy-cập-1, mã-truy-cập-2',
            justification_ids_placeholder: 'mã-lý-do-1, mã-lý-do-2',
            findings_placeholder: 'Tóm tắt phát hiện của điều tra...',
            by_actor: 'bởi',
            close_investigation: 'Đóng Điều tra',
            add_timeline_failed: 'Không thể thêm mốc thời gian.',
            fetch_failed: 'Không thể tải điều tra.',
            add_justification_ids: 'Thêm ID biện minh',
            add_access_ids: 'Thêm ID truy cập',
            add_timeline_entry: 'Thêm mục dòng thời gian',
            status_changed_to: 'Trạng thái đã đổi thành {status}',
            investigations_loaded: 'Đã tải {n} investigations',
            justification_ids_link_placeholder: 'mã-biện-minh-1, mã-biện-minh-2',
            access_ids_link_placeholder: 'mã-truy-cập-1, mã-truy-cập-2',
            justification_ids_label: 'Các ID biện minh',
            access_ids_label: 'Các ID truy cập',
            link_justifications: 'Liên kết biện minh',
            link_evidence: 'Liên kết bằng chứng',
            details: 'Chi tiết điều tra',
            change_status: 'Thay đổi trạng thái điều tra',
            investigation_types: {
                anomaly_review: 'Rà soát bất thường',
                complaint_driven: 'Theo khiếu nại',
                scheduled_review: 'Rà soát định kỳ',
                whistleblower_report: 'Báo cáo tố giác',
            },
            severity_labels: {
                low: 'Thấp',
                medium: 'Trung bình',
                high: 'Cao',
                critical: 'Nghiêm trọng',
            },
            status_labels: {
                open: 'Mở',
                in_progress: 'Đang tiến hành',
                pending_review: 'Chờ xem xét',
                closed_substantiated: 'Đã đóng (Có căn cứ)',
                closed_unsubstantiated: 'Đã đóng (Không có căn cứ)',
                closed_inconclusive: 'Đã đóng (Không kết luận)',
            },
            disposition_labels: {
                substantiated: 'Có căn cứ',
                unsubstantiated: 'Không có căn cứ',
                inconclusive: 'Không kết luận',
            },
        },
        pattern_analysis: {
            accesses_count: '{n} lượt truy cập',
            title: 'Phân tích Khuôn mẫu',
            resource_type_header: 'Loại tài nguyên',
            resource_id_header: 'ID tài nguyên',
            loading: 'Đang tải dữ liệu khuôn mẫu...',
            anomalies_detected: 'Bất thường Phát hiện',
            patterns: 'Khuôn mẫu',
            by_user: 'Theo Người dùng',
            by_resource: 'Theo Tài nguyên',
            time_range: 'Khoảng Thời gian',
            load_failed: 'Không thể phân tích khuôn mẫu. Vui lòng thử lại.',
            top_resources: 'Top 10',
            access_by_hour: 'Truy cập theo Giờ trong ngày',
            access_by_day: 'Truy cập theo Ngày trong tuần',
            fetch_failed: 'Không thể tải phân tích khuôn mẫu.',
            days: {
                sunday: 'Chủ Nhật',
                monday: 'Thứ Hai',
                tuesday: 'Thứ Ba',
                wednesday: 'Thứ Tư',
                thursday: 'Thứ Năm',
                friday: 'Thứ Sáu',
                saturday: 'Thứ Bảy',
            },
            user_access_summary: 'Tóm tắt truy cập người dùng',
            top_accessed_resources: 'Tài nguyên được truy cập nhiều nhất',
            by_classification: 'Theo mức phân loại',
            access_by_day_heading: 'Truy cập theo ngày trong tuần',
            access_by_hour_heading: 'Truy cập theo giờ trong ngày',
            date_format_placeholder: 'DD/MM/YYYY',
            analysis_loaded: 'Phân tích mẫu đã tải cho {user}, tìm thấy {n} phiên',
            accesses_in_period: 'Lượt truy cập trong kỳ',
            sessions_label: 'Phiên',
            recent_accesses: 'Lượt truy cập gần đây trong kỳ',
            recent_accesses_desc: 'Các mục nhật ký truy cập gần đây nhất của người dùng này trong kỳ được phân tích, mới nhất trước (tối đa {n}).',
        },
        anchoring_status: {
            kpi_summary_label: 'Tóm tắt trạng thái neo',
            title: 'Trạng thái Neo',
            loading: 'Đang tải dữ liệu neo...',
            anchored: 'Đã neo',
            pending: 'Chờ xử lý',
            failed: 'Thất bại',
            last_anchor: 'Neo lần cuối',
            no_records: 'Không tìm thấy bản ghi neo.',
            status_load_failed: 'Không thể tải trạng thái neo. Vui lòng thử lại.',
            proofs_load_failed: 'Không thể tải chứng minh truy cập. Vui lòng thử lại.',
            verify_failed: 'Không thể xác minh chuỗi chứng minh. Vui lòng thử lại.',
            anchor_failed: 'Không thể neo chứng minh truy cập',
            batch_anchor_failed: 'Không thể neo hàng loạt chứng minh truy cập',
            proof_count: 'chứng minh',
            proof_count_plural: 'chứng minh',
            anchor_single: 'Neo đơn',
            anchor_batch: 'Neo hàng loạt',
            access_id_placeholder: 'Nhập mã truy cập để neo',
            batch_ids_placeholder: 'mã-truy-cập-1, mã-truy-cập-2, mã-truy-cập-3',
            verify_chain: 'Xác minh Chuỗi',
            chain_breaks: 'Đứt Chuỗi',
            total_checked: 'Tổng đã kiểm tra',
            anchor_placeholder: 'Nhập mã truy cập để neo',
            fetch_failed: 'Không thể tải trạng thái neo.',
            select_to_anchor: 'Chọn mục nhật ký truy cập để neo',
            select_to_anchor_batch: 'Chọn các mục để neo',
            no_unanchored_entries: 'Không tìm thấy mục nhật ký truy cập chưa được neo.',
            loading_unanchored: 'Đang tải các mục nhật ký truy cập...',
            fetch_unanchored_failed: 'Không thể tải các mục nhật ký truy cập chưa được neo.',
            fetch_proofs_failed: 'Không thể tải chứng minh.',
            proofs_loaded: 'Đã tải {n} access proofs',
            proof_version_label: 'Phiên bản',
            proof_version_value: 'Phiên bản {n}',
            verify_valid_summary: 'Chuỗi còn nguyên vẹn. Mọi liên kết và giá trị hash đều tính lại khớp.',
            verify_invalid_summary: 'Chuỗi không xác minh được. Các chứng minh liệt kê bên dưới không còn khớp với nội dung đã neo.',
            verify_proofs_v1: 'Chứng minh phiên bản 1',
            verify_proofs_v2: 'Chứng minh phiên bản 2',
            verify_content_verified: 'Dòng nhật ký khớp với chứng minh',
            verify_content_destroyed: 'Nội dung đã bị hủy sau thời hạn lưu giữ',
            verify_content_destroyed_note: 'Chuỗi vẫn xác minh được đối với các chứng minh này. Đợt quét lưu giữ của nền tảng đã ghi nhận việc hủy dòng nhật ký truy cập mà mỗi chứng minh neo sau khi dòng đó qua ngày hết hạn lưu giữ, nên không còn chứng minh được nội dung của dòng đó.',
            verify_content_removed_sample: 'Dòng nhật ký mẫu đã bị xóa khi xóa dữ liệu mẫu',
            verify_content_removed_sample_note: 'Chuỗi vẫn xác minh được đối với các chứng minh này. Mỗi chứng minh neo một dòng nhật ký truy cập mẫu đã bị xóa khi xóa dữ liệu mẫu; việc xóa này được nền tảng ghi nhận. Đây không phải là việc hủy theo thời hạn lưu giữ.',
            verify_v1_note: 'Chứng minh phiên bản 1 bảo vệ thứ tự của chuỗi và việc một sự kiện truy cập đã tồn tại. Chúng không bao phủ nội dung của dòng nhật ký.',
            verify_v2_note: 'Chứng minh phiên bản 2 còn bao phủ nội dung của dòng nhật ký, chừng nào dòng đó còn tồn tại.',
            verify_breaks_heading: 'Các chứng minh không đạt',
            verify_break_types: {
                field_mismatch: 'Dòng nhật ký đã thay đổi sau khi được neo',
                hash_mismatch: 'Giá trị hash của chứng minh không tính lại khớp',
                chain_link_mismatch: 'Liên kết tới chứng minh trước đã bị đứt',
                unsupported_proof_version: 'Phiên bản chứng minh không được hỗ trợ',
                content_missing: 'Thiếu dòng nhật ký — nền tảng không có bản ghi nào về việc đã xóa dòng này',
            },
            anchor_statuses: {
                chained: 'Đã liên kết chuỗi',
                confirmed: 'Đã xác nhận',
                failed: 'Thất bại',
                pending: 'Chờ xử lý',
            },
            anchor_types: {
                blockchain_anchor: 'Neo chuỗi khối',
                sha256_chain: 'Chuỗi SHA-256',
                zkp_stub: 'Mẫu ZKP',
            },
            batch_id: 'ID lô',
            proof_hash_label: 'Hash bằng chứng',
            chain_sequence: 'Seq. chuỗi',
            access_id: 'ID truy cập',
        },
        configuration: {
            title: 'Cấu hình',
            session_settings: 'Cài đặt Phiên',
            log_retention: 'Lưu trữ Nhật ký (ngày)',
            anomaly_threshold: 'Ngưỡng Bất thường',
            anchoring_enabled: 'Bật Neo',
            save_config: 'Lưu Cấu hình',
            load_failed: 'Không thể tải cấu hình. Vui lòng thử lại.',
            save_success: 'Lưu cấu hình thành công',
            save_failed: 'Không thể lưu cấu hình. Vui lòng thử lại.',
            justification_rules: 'Quy tắc Lý do',
            reason_codes: 'Mã Lý do',
            anchoring_settings: 'Cài đặt Neo',
            anchoring_method: 'Phương thức Neo',
            anchoring_frequency: 'Tần suất Neo',
            batch_interval: 'Khoảng cách lót (phút)',
            eligibility_criteria: 'Tiêu chí đủ điều kiện',
            add_criterion_placeholder: 'Thêm tiêu chí đủ điều kiện...',
            retention_settings: 'Cài đặt Lưu trữ',
            standard_retention: 'Lưu trữ Tiêu chuẩn (ngày)',
            sensitive_retention: 'Lưu trữ Nhạy cảm (ngày)',
            working_hours: 'Giờ làm việc',
            work_start: 'Thời gian Bắt đầu',
            work_end: 'Thời gian Kết thúc',
            timezone: 'Múi giờ',
            timezone_placeholder: 'Ví dụ: Asia/Hồ_Chi_Minh',
            working_days: 'Ngày làm việc',
            concurrent_sessions: 'Giới hạn Phiên đồng thời',
            concurrent_threshold: 'Ngưỡng Phiên đồng thời',
            classification_level: 'Cấp độ Phân loại',
            prompt_mode: 'Chế độ Nhắc nhở',
            grace_period: 'Thời gian gia hạn (giây)',
            code_placeholder: 'mã',
            is_custom: 'Tùy chỉnh',
            label_placeholder: 'Nhãn',
            description_placeholder: 'Mô tả',
            custom: 'Tùy chỉnh',
            fetch_failed: 'Không thể tải cấu hình.',
            classification_levels: {
                public: 'Công khai',
                internal: 'Nội bộ',
                confidential: 'Bảo mật',
                restricted: 'Hạn chế',
                unclassified: 'Chưa phân loại',
            },
            prompt_modes: {
                reason_only: 'Chỉ lý độ',
                reason_text: 'Lý độ + Văn bản',
                reason_text_supervisor: 'Lý độ + Văn bản + Giám sát',
            },
            anchoring_methods: {
                sha256_chain: 'Chuỗi SHA-256',
                blockchain_anchor: 'Neo blockchain',
                zkp_stub: 'Mẫu ZKP',
            },
            anchoring_frequencies: {
                realtime: 'Thời gian thực',
                batched: 'Theo lô',
                on_demand: 'Theo yêu cầu',
            },
            retention_position: {
                title: 'Vị thế lưu giữ nhật ký',
                description: 'Những gì đợt quét lưu giữ sẽ hủy và những gì sẽ giữ lại. Việc xem trang này không thay đổi điều gì.',
                as_of: 'Tính đến',
                window_in_force: 'Khoảng thời gian đang áp dụng',
                days: '{n} ngày',
                swept: 'Đã quá khoảng thời gian',
                retained_held: 'Giữ lại — lệnh phong tỏa pháp lý hoặc quy tắc lưu giữ',
                retained_anchored: 'Giữ lại — đã neo bởi bằng chứng phiên bản cũ',
                retained_investigation: 'Giữ lại — liên kết với một cuộc điều tra truy cập chưa đóng',
                unstamped: 'Không ghi nhận ngày lưu giữ',
                skipped_swept: 'Đã được xử lý',
                eligible_sample: 'Các bản ghi cũ nhất đã quá khoảng thời gian',
                resource: 'Tài nguyên',
                expires_at: 'Kết thúc khoảng thời gian',
                run_sweep: 'Chạy đợt quét lưu giữ',
                running: 'Đang chạy...',
                sweep_success: 'Hoàn tất đợt quét lưu giữ: đã hủy {swept}, giữ lại {retained}.',
                sweep_failed: 'Không thể chạy đợt quét lưu giữ. Vui lòng thử lại.',
                load_failed: 'Không thể đọc vị thế lưu giữ. Vui lòng thử lại.',
                reload: 'Tải lại',
                empty: 'Không có bản ghi nhật ký truy cập nào quá khoảng thời gian lưu giữ.',
                unstamped_note: 'Bản ghi không có ngày lưu giữ sẽ không bao giờ bị hủy. Số lượng được hiển thị ở trên để có thể nhìn thấy thay vì phải phỏng đoán.',
                anchored_note: 'Bản ghi đã neo bởi bằng chứng phiên bản 1 (lập trước khi bằng chứng bao phủ nội dung) được giữ lại quá khoảng thời gian, vì hủy nó sẽ để lại một bằng chứng trỏ vào chỗ trống. Bản ghi neo bởi bằng chứng mới bị hủy khi đến hạn và chuỗi vẫn xác minh được.',
            },
        },
        access_policies: {
            title: 'Chính sách truy cập',
            create_policy: 'Tạo chính sách truy cập',
            framework_code: 'Khung tuân thủ',
            review_frequency: 'Tần suất rà soát',
            scope: 'Phạm vi',
            select_framework: 'Chọn một khung tuân thủ...',
            no_policies_found: 'Không tìm thấy chính sách truy cập nào.',
            frequency_labels: {
                monthly: 'Hàng tháng',
                quarterly: 'Hàng quý',
                semi_annual: 'Nửa năm',
                annual: 'Hàng năm',
            },
            policy_name: 'Tên chính sách',
            policy_created: 'Chính sách truy cập đã tạo',
        },
        review_campaigns: {
            title: 'Chiến dịch rà soát truy cập',
            create_campaign: 'Tạo chiến dịch rà soát',
            reviewer: 'Người rà soát',
            due_date: 'Ngày hết hạn',
            certify: 'Xác nhận',
            no_campaigns_found: 'Không tìm thấy chiến dịch rà soát truy cập nào.',
            status_open: 'Mở',
            status_in_review: 'Đang rà soát',
            status_completed: 'Hoàn thành',
            status_labels: {
                open: 'Mở',
                in_review: 'Đang xem xét',
                in_progress: 'Đang thực hiện',
                cancelled: 'Đã hủy',
                completed: 'Đã hoàn thành',
            },
            select_policy: 'Chọn một chính sách...',
            reviewer_ids_label: 'Người đánh giá',
            select_reviewers: 'Chọn người đánh giá...',
            policy_id: 'ID chính sách',
            certify_campaign: 'Chứng nhận chiến dịch {id}',
            review_certified: 'Đánh giá truy cập đã chứng nhận',
            campaign_created: 'Chiến dịch đánh giá đã tạo',
        },
        evidence_packages: {
            title: 'Gói bằng chứng',
            generate_package: 'Tạo gói bằng chứng',
            package_type: 'Loại gói',
            framework_scope: 'Phạm vi khung tuân thủ',
            period: 'Kỳ',
            generated_by: 'Tạo bởi',
            generated_at: 'Tạo lúc',
            export_type: 'Loại xuất',
            no_packages_found: 'Không tìm thấy gói bằng chứng nào.',
            export_type_full: 'Xuất đầy đủ',
            export_type_summary: 'Tóm tắt',
            export_type_certification_only: 'Chỉ chứng nhận',
            period_end: 'Kết thúc kỳ',
            period_start: 'Bắt đầu kỳ',
            package_type_authority_request: 'Yêu cầu cơ quan',
            package_type_certification: 'Chứng nhận',
            package_type_investigation: 'Điều tra',
            package_type_access_review: 'Xem xét truy cập',
            package_generated: 'Gói bằng chứng đã tạo',
            select_frameworks: 'Chọn khung tuân thủ...',
            completeness_col: 'Mức hoàn thiện',
            status_col: 'Trạng thái',
            generated_by_col: 'Người tạo',
        },
        evidence_package_detail: {
            title: 'Chi tiết Gói bằng chứng',
            not_found: 'Không tìm thấy gói bằng chứng.',
            package_metadata: 'Thông tin gói',
            status: 'Trạng thái',
            item_count: 'Số lượng mục',
            disposition: 'Kết luận',
            closed_at: 'Đóng lúc',
            completeness_dashboard: 'Bảng mức hoàn thiện',
            no_completeness_data: 'Không có dữ liệu mức hoàn thiện.',
            controls_covered: 'kiểm soát đã bao phủ',
            missing: 'Thiếu',
            sign_off_tracker: 'Theo dõi phê duyệt',
            stage_framework_owner: 'Chủ sở hữu khung',
            stage_legal_compliance: 'Pháp lý & Tuân thủ',
            stage_internal_audit: 'Kiểm toán nội bộ',
            approved: 'Đã phê duyệt',
            returned: 'Đã trả lại',
            pending: 'Chờ xử lý',
            approve: 'Phê duyệt',
            return_btn: 'Trả lại',
            sign_off_submitted: 'Đã gửi phê duyệt',
            artifacts: 'Tài liệu chứng cứ',
            no_artifacts: 'Không tìm thấy tài liệu chứng cứ.',
            template_id: 'Mã mẫu',
            description: 'Mô tả',
            classification: 'Phân loại',
            evidence_type: 'Loại chứng cứ',
            framework_section: 'Phần khung tuân thủ',
            history: 'Lịch sử phê duyệt',
            expand: 'Mở rộng',
            collapse: 'Thu gọn',
            action: 'Hành động',
            actor: 'Người thực hiện',
            timestamp: 'Thời gian',
            comment: 'Nhận xét',
            close_case: 'Đóng hồ sơ',
            confirm_close: 'Xác nhận đóng',
            closure_notes: 'Ghi chú đóng',
            disposition_compliant: 'Tuân thủ',
            disposition_non_compliant: 'Không tuân thủ',
            disposition_partial: 'Tuân thủ một phần',
            case_closed: 'Gói bằng chứng đã đóng',
            export_package: 'Xuất gói',
            export_complete: 'Gói bằng chứng đã xuất',
            completeness_explainer: 'Mỗi kiểm soát là một chính sách truy cập đang hoạt động của tổ chức cho khung tuân thủ. Kiểm soát được coi là đã bao phủ khi có ít nhất một chứng nhận rà soát quyền truy cập được ghi nhận trong kỳ của gói theo một chiến dịch của chính sách đó.',
            completeness_not_measured: 'Chưa có chính sách truy cập đang hoạt động nào được khai báo cho khung tuân thủ này, nên không có kiểm soát nào để đo mức độ bao phủ.',
            artifacts_explainer: 'Mỗi tài liệu là một chứng nhận rà soát quyền truy cập được ghi nhận trong kỳ của gói theo một chiến dịch của một chính sách truy cập của khung tuân thủ.',
            policy: 'Chính sách truy cập',
            decision: 'Quyết định',
            certified_at: 'Thời điểm chứng nhận',
            certified_by: 'Người chứng nhận',
            decision_approved: 'Phê duyệt quyền truy cập',
            decision_revoked: 'Thu hồi quyền truy cập',
            evidence_type_access_certification: 'Chứng nhận quyền truy cập',
        },
    },
    consent_properties: {
        nav: {
            dashboard: 'Tổng quan',
            properties: 'Thuộc tính',
            groups: 'Nhóm',
            bindings: 'Liên kết',
            change_requests: 'Yêu cầu thay đổi',
            comparison: 'So sánh',
            inconsistencies: 'Bất nhất quán',
            snapshot_schedules: 'Lịch chụp nhanh',
            golden_templates: 'Mẫu vàng',
            evidence_packs: 'Gói bằng chứng',
            audit: 'Kiểm toán',
        },
        select_property: 'Chọn thuộc tính…',
        select_policy: 'Chọn chính sách…',
        select_properties: 'Chọn thuộc tính…',
        select_target_properties: 'Chọn thuộc tính mục tiêu…',
        select_owner: 'Chọn chủ sở hữu…',
        select_technical_contact: 'Chọn liên hệ kỹ thuật…',
        property_statuses: {
            active: 'Hoạt động',
            inactive: 'Không hoạt động',
            pending: 'Chờ xử lý',
            decommissioned: 'Ngừng hoạt động',
        },
        dashboard: {
            title: 'Tổng quan Thuộc tính Đồng ý',
            loading: 'Đang tải dữ liệu...',
            total_properties: 'Tổng Thuộc tính',
            active_properties: 'Thuộc tính Hoạt động',
            snapshot_coverage: 'Độ phủ Snapshot',
            properties_covered: 'thuộc tính được phủ',
            total_bindings: 'Tổng Liên kết',
            deployed_bindings: 'Đã triển khai',
            pending_bindings: 'Chờ triển khai',
            deployment_progress: 'Tiến độ Triển khai',
            on_target: 'Đạt mục tiêu',
            below_target: 'Chưa đạt mục tiêu',
            target_label: 'Mục tiêu',
            total_groups: 'Tổng Nhóm',
            pending_changes: 'Thay đổi Đang chờ',
            inconsistencies: 'Bất nhất quán',
            recent_activity: 'Hoạt động Gần đây',
            no_recent_activity: 'Không có hoạt động gần đây.',
            fetch_error: 'Không thể tải tổng quan. Vui lòng thử lại.',
        },
        properties: {
            title: 'Sổ Thuộc tính',
            new: 'Thuộc tính mới',
            edit: 'Sửa Thuộc tính',
            // fix-sprint-20260717-2118-followup F15
            section_property_details: 'Chi tiết thuộc tính',
            section_ownership: 'Quyền sở hữu',
            section_withdrawal_detail: 'Chi tiết rút lại',
            property_name: 'Tên',
            property_type: 'Loại',
            identifier: 'Định danh',
            environment: 'Môi trường',
            owner_id: 'Mã Chủ sở hữu',
            technical_contact_id: 'Mã Liên hệ Kỹ thuật',
            decommission: 'Ngừng hoạt động',
            confirm_decommission: 'Bạn có chắc chắn muốn ngừng hoạt động thuộc tính này?',
            no_properties: 'Không tìm thấy thuộc tính.',
            all_environments: 'Tất cả Môi trường',
            all_types: 'Tất cả Loại',
            cmp_instance_id: 'Mã phiên bản CMP',
            deployment_date: 'Ngày triển khai',
            identifier_placeholder: 'vd. www.example.com hoặc com.example.app',
            owner_name: 'Chủ sở hữu',
            technical_contact_name: 'Liên hệ kỹ thuật',
            sensitive_data_categories: 'Danh mục dữ liệu nhạy cảm',
            sensitive_data_categories_placeholder: 'Chọn danh mục dữ liệu nhạy cảm',
            requires_enhanced_review: 'Yêu cầu xem xét nâng cao',
            sensitive_review_status: 'Xem xét Dữ liệu Nhạy cảm',
            sensitive_review_pending: 'Chờ Xem xét',
            sensitive_review_approved: 'Đã Phê duyệt',
            sensitive_review_rejected: 'Đã Từ chối',
            sensitive_review_submit: 'Gửi Xem xét',
            sensitive_review_approve: 'Phê duyệt',
            sensitive_review_reject: 'Từ chối',
            sensitive_review_notes: 'Ghi chú Xem xét',
            sensitive_review_notes_placeholder: 'Nhập ghi chú xem xét...',
            record_withdrawal: 'Ghi nhận thu hồi',
            withdrawal_affected_activities: 'Hoạt động xử lý bị ảnh hưởng',
            withdrawal_affected_bindings: 'Liên kết bị ảnh hưởng',
            withdrawal_consent_id: 'Mã đồng thuận',
            withdrawal_consent_record_id: 'Mã bản ghi đồng thuận',
            withdrawal_consent_record_id_placeholder: 'ví dụ: consent_xyz789',
            withdrawal_data_subject_id: 'Mã chủ thể dữ liệu',
            withdrawal_data_subject_id_placeholder: 'ví dụ: usr_abc123',
            withdrawal_downstream_placeholder: 'hệ-thống-1, hệ-thống-2',
            withdrawal_downstream_systems: 'Hệ thống hạ nguồn',
            withdrawal_error: 'Không thể lan truyền thu hồi.',
            withdrawal_history: 'Lịch sử thu hồi',
            withdrawal_purposes: 'Mục đích đã thu hồi',
            withdrawal_purposes_placeholder: 'Chọn mục đích để thu hồi đồng thuận...',
            withdrawal_reason: 'Lý do',
            withdrawal_subject_id: 'Mã chủ thể',
            withdrawal_success: 'Đã lan truyền thu hồi thành công.',
            withdrawal_tasks_created: 'Tác vụ đã tạo',
            withdrawal_withdrawn_at: 'Ngày thu hồi',
        },
        groups: {
            title: 'Nhóm Thuộc tính',
            new: 'Nhóm mới',
            group_name: 'Tên Nhóm',
            member_count: 'Thành viên',
            no_groups: 'Không tìm thấy nhóm thuộc tính.',
            policies: 'Chính sách',
            confirm_delete: 'Bạn có chắc chắn muốn xóa nhóm này?',
        },
        bindings: {
            title: 'Ma trận Liên kết',
            property: 'Thuộc tính',
            purpose: 'Mục đích',
            legal_basis: 'Cơ sở pháp lý',
            bound: 'Đã liên kết',
            no_bindings: 'Không tìm thấy liên kết.',
            bind_policy: 'Liên kết Chính sách',
            bulk_bind: 'Liên kết Hàng loạt',
            bind_policy_to_property: 'Liên kết Chính sách với Thuộc tính',
            bulk_bind_policy: 'Liên kết Chính sách Hàng loạt',
            unbound: 'Chưa liên kết',
            policy_id: 'ID chính sách',
            version_placeholder: 'vd. 1.0.0',
            property_ids_placeholder: 'prop-id-1, prop-id-2, prop-id-3',
            binding_name: 'Liên kết',
            property_name: 'Tên thuộc tính',
            policy_name: 'Tên chính sách',
            bindings_list: 'Danh sách liên kết',
            binding_actions: {
                start_deploy: 'Bắt đầu triển khai',
                mark_deployed: 'Đánh dấu đã triển khai',
                rollback: 'Hoàn tác',
            },
        },
        change_requests: {
            title: 'Yêu cầu Thay đổi',
            new: 'Yêu cầu Thay đổi mới',
            requester: 'Người yêu cầu',
            change_type: 'Loại Thay đổi',
            property: 'Thuộc tính',
            submitted_at: 'Gửi lúc',
            no_requests: 'Không tìm thấy yêu cầu thay đổi.',
            fetch_pipeline_error: 'Không thể tải quy trình. Vui lòng thử lại.',
            fetch_list_error: 'Không thể tải danh sách yêu cầu thay đổi. Vui lòng thử lại.',
            create_error: 'Không thể tạo yêu cầu thay đổi. Vui lòng thử lại.',
            action_error: 'Không thể thực hiện thao tác. Vui lòng thử lại.',
            approver_name: 'Người phê duyệt',
            placeholder_target_props: 'prop-id-1, prop-id-2',
            view_all: 'Tất cả',
            view_my_properties: 'Thuộc tính của tôi',
            stage_requests: 'Yêu cầu {stage}',
            policy_required: 'Chọn chính sách mà thay đổi này áp dụng. Cập nhật chính sách, ràng buộc mới hoặc xóa ràng buộc đều thay đổi các ràng buộc của chính sách đó.',
        },
        comparison: {
            title: 'Không gian So sánh',
            select_properties: 'Chọn Thuộc tính để So sánh',
            compare: 'So sánh',
            no_comparison: 'Chọn ít nhất hai thuộc tính để so sánh.',
            fetch_error: 'Không thể tải báo cáo so sánh. Vui lòng thử lại.',
            run_error: 'Không thể chạy so sánh. Vui lòng thử lại.',
            save_notes_error: 'Không thể lưu ghi chú. Vui lòng thử lại.',
            scan_complete: 'Quét bất nhất quán hoàn tất thành công.',
            scan_error: 'Không thể chạy quét bất nhất quán. Vui lòng thử lại.',
            min_two_properties: 'Vui lòng cung cấp ít nhất 2 ID tài sản để so sánh.',
            view_inconsistencies: 'Xem Bất nhất quán',
            click_to_select: 'Nhấp để chọn hai hoặc nhiều thuộc tính',
            no_properties_available: 'Không có thuộc tính nào',
            no_matching_properties: 'Không có thuộc tính phù hợp',
            select_at_least_two_props: 'Chọn ít nhất hai thuộc tính từ danh sách thả xuống ở trên.',
            no_differences_found: 'Không tìm thấy sự khác biệt giữa các thuộc tính đã chọn.',
            found_inconsistencies: 'Tìm thấy {count} bất nhất quán trên {properties} thuộc tính và {bindings} liên kết.',
        },
        inconsistencies: {
            view_all: 'Tất cả',
            view_my_properties: 'Thuộc tính của tôi',
            title: 'Danh sách Bất nhất quán',
            property: 'Thuộc tính',
            field: 'Trường',
            expected: 'Mong đợi',
            actual: 'Thực tế',
            severity: 'Mức độ',
            no_inconsistencies: 'Không tìm thấy bất nhất quán.',
            acknowledge: 'Xác nhận',
            resolve: 'Giải quyết',
            suppress: 'Bỏ qua',
            cr_id_placeholder: 'Mã CR',
            trend: 'Xu hướng Bất nhất quán',
            trend_chart_label: 'Biểu đồ xu hướng bất nhất quán theo thời gian',
            view_dpo_review: 'Hàng đợi xem xét DPO',
            change_request_id_required: 'Cần mã yêu cầu thay đổi để giải quyết bất nhất quán này.',
        },
        snapshot_schedules: {
            title: 'Lịch Chụp nhanh',
            new: 'Lịch mới',
            schedule_name: 'Tên Lịch',
            frequency: 'Tần suất',
            next_run: 'Lần chạy tới',
            last_run: 'Lần chạy cuối',
            no_schedules: 'Không tìm thấy lịch chụp nhanh.',
            target_type: 'Loại Mục tiêu',
            target_id: 'Mã Mục tiêu',
            custom_frequency_days: 'Tần suất Tùy chỉnh (ngày)',
            time_of_day: 'Thời gian trong ngày',
            time: 'Thời gian',
            retention_days: 'Lưu giữ (ngày)',
            execute_now: 'Thực hiện Ngay',
            placeholder_days: 'vd. 10',
            target_name: 'Tên mục tiêu',
        },
        golden_templates: {
            title: 'Mẫu Vàng',
            new: 'Mẫu mới',
            template_name: 'Tên Mẫu',
            property_type: 'Loại Thuộc tính',
            no_templates: 'Không tìm thấy mẫu vàng.',
            apply_to_property: 'Áp dụng cho Thuộc tính',
            apply_to_group: 'Áp dụng cho Nhóm',
            apply_success: 'Áp dụng mẫu thành công.',
            applications: 'Lịch sử Áp dụng',
            no_applications: 'Chưa có lần áp dụng mẫu nào.',
            applicable_group_ids: 'Mã Nhóm áp dụng (phân cách bằng dấu phẩy)',
            applicable_groups: 'Nhóm áp dụng',
            purposes: 'Mục đích',
            legal_bases: 'Cơ sở pháp lý',
            banner_config: 'Cấu hình Banner',
            consent_settings: 'Cài đặt đồng thuận',
            group_ids_placeholder: 'group-id-1, group-id-2',
            no_configuration_details: 'Mẫu không có chi tiết cấu hình. Chỉnh sửa mẫu để thêm mục đích, cơ sở pháp lý, cài đặt banner hoặc cài đặt đồng ý.',
        },
        rollouts: {
            title: 'Triển khai Mẫu',
            rollout_status: 'Trạng thái Triển khai',
            confirmed: 'Đã xác nhận',
            pending: 'Chờ xử lý',
            failed: 'Thất bại',
            confirm: 'Xác nhận Thuộc tính',
            confirm_success: 'Thuộc tính đã được xác nhận trong đợt triển khai.',
            can_close: 'Tất cả thuộc tính đã xác nhận — triển khai hoàn tất',
            cannot_close: 'Đang chờ xác nhận thuộc tính',
            no_rollouts: 'Không tìm thấy đợt triển khai.',
            in_progress: 'Đang tiến hành',
            completed: 'Hoàn thành',
            cancelled: 'Đã hủy',
            reject: 'Từ chối Thuộc tính',
            reject_success: 'Thuộc tính đã bị từ chối khỏi đợt triển khai.',
            confirm_all: 'Xác nhận Tất cả',
            reject_all: 'Từ chối Tất cả',
            confirm_label: 'Xác nhận triển khai cho',
            reject_label: 'Từ chối triển khai cho',
            confirm_all_label: 'Xác nhận Tất cả Triển khai Đang chờ',
            reject_all_label: 'Từ chối Tất cả Triển khai Đang chờ',
            no_properties_in_rollout: 'Đợt triển khai này không có thuộc tính nào.',
        },
        analytics: {
            title: 'Phân tích Thuộc tính',
            opt_in_rate: 'Liên kết đã triển khai (%)',
            opt_out_rate: 'Liên kết đã hoàn tác (%)',
            withdrawal_rate: 'Liên kết chờ hoàn tác (%)',
            total_consents: 'Tổng số liên kết',
            total_withdrawals: 'Liên kết đã hoàn tác',
            compliance_score: 'Điểm Tuân thủ',
            non_compliant: 'Thuộc tính Không tuân thủ',
            no_non_compliant: 'Tất cả thuộc tính đều tuân thủ.',
            threshold: 'Ngưỡng Tuân thủ',
            property_id: 'Mã Thuộc tính',
            compliant: 'Tuân thủ',
            non_compliant_status: 'Không Tuân thủ',
            compliance_help_summary: 'Điểm tuân thủ được tính như thế nào và làm thế nào để khắc phục?',
            compliance_help_intro: 'Một thuộc tính được đánh dấu là Không Tuân Thủ khi điểm số dưới 80%. Điểm số được tính như sau:',
            compliance_help_with_template_label: 'Nếu áp dụng Golden Template:',
            compliance_help_with_template_text: '% khóa cấu hình (purposes, legal_bases, banner_config, consent_settings) khớp chính xác với mẫu.',
            compliance_help_no_template_label: 'Nếu không áp dụng Golden Template:',
            compliance_help_no_template_text: '% binding (loại đồng ý gán cho thuộc tính) có deployment_status = deployed. Thuộc tính không có binding mặc định 100%.',
            compliance_help_fix_intro: 'Để xóa thuộc tính khỏi danh sách này, hãy thực hiện một trong các thao tác sau:',
            compliance_help_fix_deploy_label: 'Triển khai binding của nó',
            compliance_help_fix_deploy_text: 'mở trang Ma trận Binding và đặt trạng thái triển khai của mỗi binding thành deployed.',
            compliance_help_fix_template_label: 'Áp dụng Golden Template',
            compliance_help_fix_template_text: 'sử dụng Apply to Group trên mẫu, sau đó xác nhận đợt triển khai cho thuộc tính này. Đảm bảo cấu hình của thuộc tính khớp với mẫu.',
            compliance_help_fix_decommission_label: 'Ngừng sử dụng thuộc tính',
            compliance_help_fix_decommission_text: 'sử dụng nút Decommission trong modal chi tiết thuộc tính nếu không còn sử dụng.',
            compliance_help_fix_no_bindings_label: 'Xóa tất cả binding',
            compliance_help_fix_no_bindings_text: 'nếu một thuộc tính không có template và không có binding, nó mặc định đạt 100%.',
        },
        evidence_packs: {
            title: 'Gói Bằng chứng',
            new: 'Gói mới',
            pack_name: 'Tên Gói',
            properties: 'Thuộc tính',
            generated_at: 'Tạo lúc',
            no_packs: 'Không tìm thấy gói bằng chứng.',
            generate: 'Tạo',
            content_type_consent_records: 'Bản ghi đồng thuận',
            content_type_policy_versions: 'Phiên bản chính sách',
            content_type_binding_history: 'Lịch sử liên kết',
            content_type_change_requests: 'Yêu cầu thay đổi',
            content_type_inconsistency_reports: 'Báo cáo bất nhất quán',
            content_type_snapshot_data: 'Dữ liệu chụp nhanh',
            content_type_audit_trail: 'Nhật ký kiểm toán',
        },
        audit: {
            title: 'Kiểm toán Thuộc tính Đồng ý',
            event_type: 'Loại Sự kiện',
            entity_type: 'Loại Thực thể',
            entity_id: 'Mã Thực thể',
            actor: 'Tác nhân',
            timestamp: 'Thời gian',
            no_events: 'Không tìm thấy sự kiện kiểm toán.',
            entity_type_property: 'Thuộc tính',
            entity_type_group: 'Nhóm',
            entity_type_binding: 'Liên kết',
            entity_type_change_request: 'Yêu cầu thay đổi',
            entity_type_golden_template: 'Mẫu vàng',
            entity_type_snapshot_schedule: 'Lịch chụp nhanh',
            entity_type_inconsistency: 'Bất nhất quán',
            entity_type_evidence_pack: 'Gói bằng chứng',
            action_created: 'Đã tạo',
            action_updated: 'Đã cập nhật',
            action_deleted: 'Đã xóa',
            action_decommissioned: 'Đã ngừng hoạt động',
            action_status_changed: 'Đã thay đổi trạng thái',
            action_submitted: 'Đã gửi',
            action_approved: 'Đã phê duyệt',
            action_rejected: 'Đã từ chối',
            action_deployed: 'Đã triển khai',
            action_rolled_back: 'Đã hoàn tác',
            action_paused: 'Đã tạm dừng',
            action_resumed: 'Đã tiếp tục',
            action_cancelled: 'Đã hủy',
            action_acknowledged: 'Đã xác nhận',
            action_resolved: 'Đã giải quyết',
            action_suppressed: 'Đã ẩn',
            action_executed: 'Đã thực thi',
        },
        property_types: {
            website: 'Trang web',
            mobile_app: 'Ứng dụng di động',
            ott: 'OTT',
            iot_device: 'Thiết bị IoT',
            kiosk: 'Ki-ốt',
            api_service: 'Dịch vụ API',
            sdk: 'SDK',
        },
        environments: {
            production: 'Sản xuất',
            staging: 'Thử nghiệm',
            development: 'Phát triển',
            testing: 'Kiểm thử',
        },
        group_types: {
            brand: 'Thương hiệu',
            region: 'Khu vực',
            product_line: 'Dòng sản phẩm',
            business_unit: 'Đơn vị kinh doanh',
            custom: 'Tùy chỉnh',
        },
        target_types: {
            property: 'Thuộc tính',
            group: 'Nhóm',
            all: 'Tất cả',
        },
        frequencies: {
            hourly: 'Hàng giờ',
            daily: 'Hàng ngày',
            weekly: 'Hàng tuần',
            monthly: 'Hàng tháng',
            custom: 'Tùy chỉnh',
        },
        binding_statuses: {
            current: 'Hiện tại',
            outdated: 'Lỗi thời',
            pending: 'Chờ xử lý',
            deploying: 'Đang triển khai',
            rolled_back: 'Đã hoàn tác',
        },
        sensitive_categories: {
            health: 'Dữ liệu sức khỏe',
            biometric: 'Dữ liệu sinh trắc học',
            genetic: 'Dữ liệu di truyền',
            racial_ethnic: 'Nguồn gốc chủng tộc / dân tộc',
            political_opinions: 'Quan điểm chính trị',
            religious_beliefs: 'Tín ngưỡng tôn giáo',
            trade_union: 'Thành viên công đoàn',
            sexual_orientation: 'Xu hướng tính dục',
            criminal_records: 'Hồ sơ hình sự',
            financial: 'Dữ liệu tài chính',
            children: 'Dữ liệu trẻ em',
            geolocation: 'Vị trí chính xác',
        },
        export_csv: 'Xuất CSV',
        exporting: 'Đang xuất...',
        page_x_of_y: 'Trang {page} / {total}',
        regulatory: {
            capture_method_guidance: 'PDPL yêu cầu bằng chứng đồng thuận khớp kênh thu thập. Loại thuộc tính ánh xạ tới phương thức: trang web/OTT = banner, ứng dụng/SDK = trong ứng dụng, ki-ốt = trực tiếp, API = lập trình, IoT = cấp thiết bị.',
            dashboard_metrics_info: 'Bảng điều khiển cung cấp cho DPO cái nhìn toàn cảnh về đồng thuận: phạm vi liên kết, tuân thủ mẫu, yêu cầu thay đổi đang chờ và phân tích trạng thái thuộc tính.',
            change_request_impact_info: 'Yêu cầu thay đổi ảnh hưởng thuộc tính đồng thuận phải ghi nhận tác động pháp quy: yêu cầu PDPL nào bị ảnh hưởng và có cần thu lại đồng thuận không.',
            outdated_binding_warning: 'Liên kết "lỗi thời" cho thấy thuộc tính chạy phiên bản chính sách không hiện hành. Cập nhật kịp thời để duy trì tuân thủ PDPL.',
        },
    },
    localization: {
        // fix-sprint-20260827-2129 residue (B-F18 class) — failure fallbacks for the
        // localization pages, which ended catch blocks in `err?.message || '<English>'`.
        errors: {
            install_from_zip_failed: 'Không thể cài đặt gói từ tệp ZIP. Vui lòng thử lại.',
            load_installed_packs_failed: 'Không thể tải các gói đã cài đặt. Vui lòng thử lại.',
            load_catalog_failed: 'Không thể tải danh mục gói. Vui lòng thử lại.',
            load_market_packs_failed: 'Không thể tải các gói thị trường. Vui lòng thử lại.',
            install_pack_failed: 'Không thể cài đặt gói. Vui lòng thử lại.',
            uninstall_pack_failed: 'Không thể gỡ cài đặt gói. Vui lòng thử lại.',
            install_cluster_failed: 'Không thể cài đặt cụm gói thị trường. Vui lòng thử lại.',
            install_market_pack_failed: 'Không thể cài đặt gói thị trường. Vui lòng thử lại.',
            uninstall_market_pack_failed: 'Không thể gỡ cài đặt gói thị trường. Vui lòng thử lại.',
            details_partial: 'Không thể tải đầy đủ chi tiết. Đang hiển thị dữ liệu hiện có.',
            load_dashboard_failed: 'Không thể tải dữ liệu tổng quan bản địa hóa. Vui lòng thử lại.',
            load_market_pack_failed: 'Không thể tải gói thị trường. Vui lòng thử lại.',
            save_mapping_failed: 'Không thể lưu ánh xạ phân hệ. Vui lòng thử lại.',
            delete_mapping_failed: 'Không thể xóa ánh xạ phân hệ. Vui lòng thử lại.',
            load_language_packs_failed: 'Không thể tải các gói ngôn ngữ. Vui lòng thử lại.',
            activate_language_pack_failed: 'Không thể kích hoạt gói ngôn ngữ. Vui lòng thử lại.',
            deactivate_language_pack_failed: 'Không thể vô hiệu hóa gói ngôn ngữ. Vui lòng thử lại.',
            uninstall_language_pack_failed: 'Không thể gỡ cài đặt gói ngôn ngữ. Vui lòng thử lại.',
            load_completeness_failed: 'Không thể tải dữ liệu mức hoàn thiện. Vui lòng thử lại.',
            update_featured_failed: 'Không thể cập nhật trạng thái nổi bật. Vui lòng thử lại.',
            load_available_language_packs_failed: 'Không thể tải các gói ngôn ngữ có sẵn. Vui lòng thử lại.',
            install_language_pack_failed: 'Không thể cài đặt gói ngôn ngữ. Vui lòng thử lại.',
            load_audit_failed: 'Không thể tải các sự kiện nhật ký bản địa hóa. Vui lòng thử lại.',
            save_translation_failed: 'Không thể lưu bản dịch. Vui lòng thử lại.',
        },
        nav: {
            dashboard: 'Tổng quan',
            market_packs: 'Gói thị trường',
            language_packs: 'Gói ngôn ngữ',
            frameworks: 'Khung tuân thủ',
            mappings: 'Ánh xạ phân hệ',
            submissions: 'Gói gửi duyệt',
            sector_overlay_catalog: 'Danh mục lớp phủ',
            translations: 'Xem trước bản dịch',
            audit: 'Nhật ký',
        },
        dashboard: {
            title: 'Tổng quan Bản địa hóa',
            loading: 'Đang tải dữ liệu...',
            active_market_packs: 'Gói Thị trường Hoạt động',
            published_packs_available: 'Gói thị trường đã xuất bản',
            language_packs: 'Gói Ngôn ngữ',
            total_language_packs: 'Tổng gói ngôn ngữ đã đăng ký',
            active_regulatory_frameworks: 'Khung tuân thủ đang hoạt động',
            frameworks_active: 'Khung có trạng thái hoạt động',
            pending_pack_submissions: 'Gói Gửi Đang chờ',
            submissions_awaiting_review: 'Gói gửi chờ duyệt',
            recent_audit_events: 'Sự kiện Kiểm toán Gần đây',
            no_recent_audit: 'Không có sự kiện kiểm toán gần đây.',
            event_type: 'Loại Sự kiện',
            entity_type: 'Loại Thực thể',
            entity_id: 'Mã Thực thể',
            actor: 'Tác nhân',
            timestamp: 'Thời gian',
        },
        market_packs: {
            title: 'Danh mục Gói Thị trường',
            new: 'Gói Thị trường mới',
            pack_name: 'Tên Gói',
            market: 'Thị trường',
            locale: 'Ngôn ngữ',
            no_packs: 'Không tìm thấy gói thị trường.',
        },
        language_packs: {
            title: 'Gói Ngôn ngữ',
            new: 'Gói Ngôn ngữ mới',
            language: 'Ngôn ngữ',
            locale_code: 'Mã Ngôn ngữ',
            completeness: 'Hoàn thiện',
            translated: 'Đã dịch',
            namespace: 'Không gian tên',
            namespace_breakdown: 'Phân tích không gian tên',
            missing_keys: 'Khóa thiếu',
            translated_keys: 'Khóa đã dịch',
            total_keys: 'Tổng số khóa',
            overall_completeness: 'Mức hoàn thiện tổng thể',
            completeness_detail: 'Chi tiết mức hoàn thiện',
            no_packs: 'Không tìm thấy gói ngôn ngữ.',
            install_language_pack: 'Cài đặt gói ngôn ngữ',
            available_packs: 'Gói ngôn ngữ có sẵn',
            install: 'Cài đặt',
            all_installed: 'Tất cả gói ngôn ngữ đã được cài đặt.',
            install_success: 'Cài đặt gói ngôn ngữ thành công.',
            market: 'Thị trường',
            featured: 'Nổi bật',
        },
        frameworks: {
            // Sprint 63.32.0 (#543) — every framework_type code, in the reader's language.
            type_national_law: 'Luật quốc gia',
            type_parent_framework: 'Khung gốc',
            type_child_decree: 'Nghị định hướng dẫn',
            type_child_decision: 'Quyết định hướng dẫn',
            type_child_procedure_decree: 'Nghị định về thủ tục',
            type_conditional_child_decree: 'Nghị định hướng dẫn có điều kiện',
            type_implementing_decree: 'Nghị định quy định chi tiết',
            type_enforcement_decree: 'Nghị định xử phạt',
            type_sanctions_reference: 'Văn bản tham chiếu về xử phạt',
            type_official_guidance: 'Hướng dẫn chính thức',
            type_guidance_overlay: 'Lớp phủ hướng dẫn',
            type_sector_overlay: 'Lớp phủ ngành',
            type_security_overlay: 'Lớp phủ an ninh',
            type_security_control_overlay: 'Lớp phủ biện pháp bảo mật',
            type_temporary_procedural_overlay: 'Lớp phủ thủ tục tạm thời',
            type_cross_sector: 'Liên ngành',
            type_directive: 'Chỉ thị',
            type_regulation: 'Quy định',
            type_national_transposition: 'Văn bản nội luật hóa',
            type_international_standard: 'Tiêu chuẩn quốc tế',
            title: 'Khung tuân thủ',
            new: 'Khung mới',
            framework_name: 'Tên Khung',
            jurisdiction: 'Khu vực pháp lý',
            effective_date: 'Ngày có hiệu lực',
            no_frameworks: 'Không tìm thấy khung tuân thủ.',
            view_requirements: 'Xem yêu cầu',
            hide_requirements: 'Ẩn yêu cầu',
            show_legacy: 'Hiển thị khung tuân thủ cũ',
            effective_until: 'Có hiệu lực đến',
            effective_on: 'Có hiệu lực từ',
            replaced_by: 'Được thay thế bởi',
            replaces_label: 'Thay thế',
            status_active: 'Hoạt động',
            status_draft: 'Dự thảo',
            status_unclassified: 'Tr\u1ea1ng th\u00e1i kh\u00f4ng nh\u1eadn d\u1ea1ng \u0111\u01b0\u1ee3c',
            status_legacy: 'Cũ',
            status_upcoming: 'Sắp tới',
            status_active_reference: 'Có hiệu lực, chỉ tham khảo',
            status_temporary_active: 'Có hiệu lực tạm thời',
            watchlist: 'Danh sách theo dõi',
            watchlist_empty: 'Không có khung tuân thủ dự thảo hoặc sắp tới',
            watchlist_empty_desc: 'Các khung tuân thủ có trạng thái "dự thảo" hoặc "sắp tới" sẽ hiển thị ở đây để theo dõi.',
            expected_effective: 'Ngày có hiệu lực dự kiến',
            effective_date_tbd: 'Ngày có hiệu lực: Chưa xác định',
            activate: 'Kích hoạt',
            ai_law_title: 'Luật Trí tuệ nhân tạo Việt Nam',
            ai_risk_classification: 'Phân loại rủi ro AI',
            ai_system_dossier: 'Hồ sơ hệ thống AI',
            ai_labeling_checklist: 'Ghi nhãn & Công khai AI',
            ai_incident_report: 'Báo cáo sự cố AI',
            ai_impact_assessment: 'Đánh giá tác động AI',
            ai_sandbox_application: 'Đơn thử nghiệm có kiểm soát',
            ai_sandbox_monitoring: 'Giám sát thử nghiệm',
            ai_sandbox_completion: 'Hoàn thành thử nghiệm',
            ai_submission_tracker: 'Theo dõi hồ sơ nộp',
            ai_evidence_capture: 'Ghi nhận bằng chứng',
            risk_level_minimal: 'Rủi ro tối thiểu',
            risk_level_limited: 'Rủi ro hạn chế',
            risk_level_high: 'Rủi ro cao',
            risk_level_unacceptable: 'Rủi ro không chấp nhận được',
            submission_status_draft: 'Nháp',
            submission_status_submitted: 'Đã nộp',
            submission_status_returned: 'Trả lại để bổ sung',
            submission_status_accepted: 'Được chấp nhận',
            submission_status_rejected: 'Bị từ chối',
            submission_status_closed: 'Đóng',
            ecommerce_law_title: 'Luật Thương mại điện tử Việt Nam',
            ecommerce_platform_classification: 'Phân loại nền tảng',
            ecommerce_seller_register: 'Sổ đăng ký người bán',
            ecommerce_complaint_register: 'Sổ khiếu nại',
            ecommerce_takedown_register: 'Sổ gỡ bỏ nội dung',
            ecommerce_submission_tracking: 'Theo dõi nộp hồ sơ',
            ecommerce_dossier_checklist: 'Danh sách kiểm tra hồ sơ',
            ecommerce_cross_border: 'Tuân thủ xuyên biên giới',
            ecommerce_trustmark: 'Chương trình tín nhiệm',
            ecommerce_notification: 'Thông báo',
            ecommerce_registration: 'Đăng ký',
            ecommerce_termination: 'Chấm dứt',
            ecommerce_reporting_readiness: 'Sẵn sàng báo cáo',
            ecommerce_evidence_capture: 'Ghi nhận bằng chứng',
            submission_status_approved: 'Được chấp thuận',
            cybersec_law_2025_title: 'Luật An ninh mạng Việt Nam (2025)',
            cybersec_system_classification: 'Phân loại hệ thống',
            cybersec_risk_assessment: 'Đánh giá rủi ro',
            cybersec_incident_report: 'Báo cáo sự cố',
            cybersec_authority_cooperation: 'Phối hợp cơ quan chức năng',
            cybersec_data_localization: 'Bản địa hóa dữ liệu',
            cybersec_vendor_security: 'An ninh nhà cung cấp',
            cybersec_submission_tracker: 'Theo dõi hồ sơ nộp',
            cybersec_evidence_capture: 'Ghi nhận bằng chứng',
            cybersec_dossier_checklist: 'Danh sách kiểm tra hồ sơ',
            cybersec_classification_general: 'Bình thường',
            cybersec_classification_important: 'Quan trọng',
            cybersec_classification_critical: 'Đặc biệt quan trọng',
            data_law_title: 'Luật Dữ liệu Việt Nam',
            data_inventory: 'Kiểm kê dữ liệu',
            data_classification: 'Phân loại dữ liệu',
            data_sharing: 'Chia sẻ dữ liệu',
            data_governance: 'Quản trị dữ liệu',
            data_submission_tracker: 'Theo dõi hồ sơ nộp',
            data_evidence_capture: 'Ghi nhận bằng chứng',
            data_dossier_checklist: 'Danh sách kiểm tra hồ sơ',
            telecom_law_title: 'Luật Viễn thông Việt Nam',
            telecom_authority_request: 'Yêu cầu cơ quan chức năng',
            telecom_disclosure: 'Tiết lộ thông tin',
            telecom_confidentiality: 'Bảo mật thông tin',
            telecom_submission_tracker: 'Theo dõi hồ sơ nộp',
            telecom_evidence_capture: 'Ghi nhận bằng chứng',
            telecom_dossier_checklist: 'Danh sách kiểm tra hồ sơ',
            pdpl_law_title: 'Luật Bảo vệ dữ liệu cá nhân Việt Nam',
            pdpl_breach_notification: 'Thông báo vi phạm dữ liệu',
            pdpl_dpo_notification: 'Thông báo bổ nhiệm DPO',
            pdpl_data_subject_notification: 'Thông báo cho chủ thể dữ liệu',
            pdpl_submission_tracker: 'Theo dõi hồ sơ nộp',
            pdpl_evidence_capture: 'Ghi nhận bằng chứng',
            pdpl_dossier_checklist: 'Danh sách kiểm tra hồ sơ',
            pdpl_authority_filing: 'Nộp hồ sơ cơ quan chức năng',
            pdpl_mops_filing: 'Nộp hồ sơ Bộ Công an',
        },
        mappings: {
            title: 'Ánh xạ phân hệ',
            new: 'Ánh xạ mới',
            module: 'Phân hệ',
            // fix-sprint #447 W8 — module labels, from the bundle (no `{en, vi}` map on the page).
            module_consent: 'Đồng ý',
            module_dpia: 'DPIA',
            module_incident: 'Sự cố',
            module_rights_request: 'Yêu cầu quyền',
            module_data_mapping: 'Bản đồ dữ liệu',
            module_classification: 'Phân loại',
            module_monitoring: 'Giám sát',
            module_governance: 'Quản trị',
            module_vendor: 'Nhà cung cấp',
            module_risk: 'Rủi ro',
            module_sector_licensing: 'Giấy phép ngành',
            module_investor_verification: 'Xác minh nhà đầu tư',
            module_account_data_governance: 'Quản trị dữ liệu tài khoản',
            module_regulatory_disclosure: 'Công bố thông tin',
            module_authority_direction: 'Yêu cầu của cơ quan có thẩm quyền',
            module_issued_record: 'Hồ sơ đã phát hành',
            module_publication_assessment: 'Thẩm định xuất bản phẩm',
            module_legal_deposit: 'Lưu chiểu',
            module_legal_representative: 'Người đại diện theo pháp luật',
            market_pack: 'Gói Thị trường',
            mapping_status: 'Trạng thái Ánh xạ',
            // fix-sprint #431 — the list count, chosen by `count === 1` (the bundle's `count_one` convention).
            count: '{count} ánh xạ',
            count_one: '{count} ánh xạ',
            no_mappings: 'Không tìm thấy ánh xạ phân hệ.',
            incomplete_entries_warning: '{count} ánh xạ bị ẩn do thiếu ID khung, ID yêu cầu hoặc phân hệ.',
            // fix-sprint #431 — seeding is a person's action, never a side effect of opening the page.
            seed_action: 'Tạo ánh xạ từ các khung tuân thủ đã cài đặt',
            seed_hint: 'Tạo một ánh xạ trực tiếp cho mỗi yêu cầu có nêu phân hệ, trong mọi khung tuân thủ đã cài đặt chưa có ánh xạ nào. Việc mở trang này không tạo gì.',
            seed_confirm_title: 'Tạo ánh xạ từ các khung tuân thủ đã cài đặt?',
            seed_confirm: 'Thao tác này tạo một ánh xạ cho mỗi yêu cầu có nêu phân hệ, trong từng khung tuân thủ đã cài đặt chưa có ánh xạ nào. Thao tác có thể thêm nhiều dòng; mỗi dòng có thể sửa hoặc xóa sau đó.',
            seed_done: 'Đã tạo {count} ánh xạ.',
            seed_none: 'Không tạo ánh xạ nào: mọi khung tuân thủ đã cài đặt đều đã có ánh xạ, hoặc không yêu cầu nào nêu phân hệ.',
            seed_error: 'Không tạo được ánh xạ.',
            // fix-sprint #431 (gate E12.5 remediation 1) — a failed list read says so, and nothing else.
            load_error: 'Không đọc được các ánh xạ phân hệ nên không có ánh xạ nào được hiển thị và chưa thể tạo ánh xạ từ các khung tuân thủ đã cài đặt tại đây.',
        },
        submissions: {
            title: 'Gói Gửi Duyệt',
            new: 'Gửi mới',
            submitter: 'Người gửi',
            pack: 'Gói',
            submitted_at: 'Gửi lúc',
            no_submissions: 'Không tìm thấy gói gửi duyệt.',
            installed_sector_overlays_title: 'Lớp phủ ngành ({count})',
            installed_sector_overlays_aria: 'Lớp phủ ngành đã cài đặt',
            installed_col_name: 'Tên',
            installed_col_code: 'Mã',
            installed_col_sector: 'Lĩnh vực',
            installed_col_mode: 'Chế độ',
            installed_col_status: 'Trạng thái',
            installed_refresh: 'Làm mới',
            installed_count_one: '1 gói đã cài đặt',
            installed_count: '{count} gói đã cài đặt',
            installed_market_packs_title: 'Gói thị trường ({count})',
            installed_market_packs_aria: 'Gói thị trường đã cài đặt',
            installed_language_packs_title: 'Gói ngôn ngữ ({count})',
            installed_language_packs_aria: 'Gói ngôn ngữ đã cài đặt',
            installed_frameworks_title: 'Khung tuân thủ ({count})',
            installed_frameworks_aria: 'Khung tuân thủ đã cài đặt',
            installed_col_market_code: 'Mã thị trường',
            installed_col_display_name: 'Tên hiển thị',
            installed_col_locale: 'Ngôn ngữ',
            installed_col_version: 'Phiên bản',
            tab_submissions: 'Gói gửi duyệt',
            tab_install_zip: 'Cài đặt từ tệp Zip',
            tab_installed: 'Gói đã cài đặt',
        },
        translations: {
            title: 'Xem trước Bản dịch',
            select_locale: 'Chọn Ngôn ngữ',
            select_module: 'Chọn phân hệ',
            key: 'Khóa',
            value: 'Giá trị',
            no_translations: 'Không tìm thấy bản dịch.',
        },
        audit: {
            title: 'Nhật ký Kiểm toán Bản địa hóa',
            event_type: 'Loại Sự kiện',
            // Gate E12.5 remediation 1 (fix-sprint #431) — Module Mappings audit events: the key is
            // `event_type_` + the recorded action with `.` read as `_`.
            event_type_regulatory_mapping_created: 'Đã tạo ánh xạ phân hệ',
            event_type_regulatory_mapping_updated: 'Đã cập nhật ánh xạ phân hệ',
            event_type_regulatory_mapping_deleted: 'Đã xóa ánh xạ phân hệ',
            event_type_regulatory_mapping_seeded_from_frameworks: 'Đã tạo ánh xạ từ các khung tuân thủ đã cài đặt',
            // Gate E12.5 remediation 2 — every other event the localization services record (event_type, else action).
            event_type_market_pack_created: 'Đã tạo gói thị trường',
            event_type_market_pack_updated: 'Đã cập nhật gói thị trường',
            event_type_market_pack_status_changed: 'Đã thay đổi trạng thái gói thị trường',
            event_type_market_pack_installed: 'Đã cài đặt gói thị trường',
            event_type_market_pack_uninstalled: 'Đã gỡ cài đặt gói thị trường',
            event_type_pack_created: 'Đã tạo gói thị trường',
            event_type_pack_updated: 'Đã cập nhật gói thị trường',
            event_type_pack_status_changed: 'Đã thay đổi trạng thái gói thị trường',
            event_type_pack_installed: 'Đã cài đặt gói thị trường',
            event_type_pack_uninstalled: 'Đã gỡ cài đặt gói thị trường',
            event_type_cluster_installed: 'Đã cài đặt cụm gói thị trường',
            event_type_pack_installed_from_zip: 'Đã cài đặt gói từ tệp tải lên',
            event_type_pack_zip_install_refused: 'Đã từ chối gói tải lên: gói không có chữ ký',
            event_type_pack_submission_created: 'Đã tạo gói gửi duyệt',
            event_type_pack_submission_review_started: 'Đã bắt đầu xem xét gói gửi duyệt',
            event_type_pack_submission_comment_added: 'Đã thêm nhận xét vào gói gửi duyệt',
            event_type_pack_submission_approved: 'Đã phê duyệt gói gửi duyệt',
            event_type_pack_submission_rejected: 'Đã từ chối gói gửi duyệt',
            event_type_pack_artifact_created: 'Đã tạo tạo phẩm gói',
            event_type_pack_artifact_updated: 'Đã cập nhật tạo phẩm gói',
            event_type_pack_artifact_deleted: 'Đã xóa tạo phẩm gói',
            event_type_regulatory_framework_updated: 'Đã cập nhật khung tuân thủ',
            event_type_regulatory_framework_status_changed: 'Đã thay đổi trạng thái khung tuân thủ',
            event_type_regulatory_framework_requirement_added: 'Đã thêm yêu cầu vào khung tuân thủ',
            event_type_regulatory_framework_requirement_removed: 'Đã xóa yêu cầu khỏi khung tuân thủ',
            event_type_regulatory_framework_stack_layer_status_changed: 'Đã thay đổi trạng thái một lớp trong cấu trúc khung tuân thủ',
            event_type_regulatory_framework_transition_review_updated: 'Đã cập nhật rà soát chuyển tiếp',
            event_type_language_pack_created: 'Đã tạo gói ngôn ngữ',
            event_type_language_pack_updated: 'Đã cập nhật gói ngôn ngữ',
            event_type_language_pack_activated: 'Đã kích hoạt gói ngôn ngữ',
            event_type_language_pack_deactivated: 'Đã hủy kích hoạt gói ngôn ngữ',
            event_type_language_pack_installed: 'Đã cài đặt gói ngôn ngữ',
            event_type_language_pack_uninstalled: 'Đã gỡ cài đặt gói ngôn ngữ',
            event_type_sector_overlay_installed: 'Đã cài đặt lớp phủ ngành',
            event_type_sector_overlay_uninstalled: 'Đã gỡ cài đặt lớp phủ ngành',
            event_type_regulatory_overlay_installed: 'Đã cài đặt lớp phủ pháp lý',
            event_type_regulatory_overlay_uninstalled: 'Đã gỡ cài đặt lớp phủ pháp lý',
            event_type_installed_framework_mode_changed: 'Đã thay đổi chế độ của khung tuân thủ đã cài đặt',
            event_type_phased_obligation_early_implemented: 'Đã ghi nhận nghĩa vụ áp dụng sớm',
            entity_type: 'Loại Thực thể',
            entity_id: 'Mã Thực thể',
            entity_name: 'Tên thực thể',
            actor: 'Tác nhân',
            timestamp: 'Thời gian',
            all_entity_types: 'Tất cả loại thực thể',
            expand: 'Mở rộng',
            collapse: 'Thu gọn',
            expand_payload: 'Mở rộng chi tiết tải trọng',
            collapse_payload: 'Thu gọn chi tiết tải trọng',
            payload_none: 'Chưa ghi nhận chi tiết',
            payload_one_field_recorded: 'Đã ghi nhận 1 trường',
            payload_fields_recorded: 'Đã ghi nhận {count} trường',
            payload_one_field_changed: 'Đã thay đổi 1 trường',
            payload_fields_changed: 'Đã thay đổi {count} trường',
            payload_one_field_removed: 'Đã xóa 1 trường',
            payload_fields_removed: 'Đã xóa {count} trường',
            payload_col_field: 'Trường',
            payload_col_value: 'Giá trị',
            payload_col_before: 'Trước',
            payload_col_after: 'Sau',
            payload_empty_value: '(trống)',
            payload_not_set: 'Chưa đặt',
            proof_not_anchored: 'Chưa được neo',
            proof_not_anchored_tooltip: 'Chưa có bản ghi bằng chứng cho sự kiện này. Sự kiện được ghi trước khi bật Nhật ký kiểm toán bất biến thì không được neo; sự kiện ở chế độ theo lô sẽ hiển thị tại đây sau khi lô được niêm phong.',
            payload: 'Tải trọng',
            no_events: 'Không tìm thấy sự kiện kiểm toán.',
        },
        regulatory_updates: {
            statuses: {
                pending: 'Chờ xử lý',
                assessed: 'Đã đánh giá',
                applied: 'Đã áp dụng',
                dismissed: 'Đã bỏ qua',
            },
            title: 'Cập nhật quy định và bảng điều khiển khung',
            page_description: 'Tổng quan phạm vi cho từng khung tuân thủ đã cài đặt, kèm nhật ký cập nhật trong sản phẩm: sửa đổi, ngày hiệu lực và đánh giá tác động.',
            coverage_dashboard: 'Bảng điều khiển phạm vi khung',
            no_frameworks: 'Không tìm thấy khung',
            framework: 'Khung tuân thủ',
            modules: 'Phân hệ',
            templates: 'Mẫu',
            forms: 'Biểu mẫu',
            channels: 'Kênh',
            deadlines: 'Hạn chót',
            pending: 'Cập nhật đang chờ',
            updates: 'Cập nhật quy định',
            create_update: 'Tạo bản cập nhật',
            framework_id: 'ID khung',
            update_title: 'Tiêu đề',
            description: 'Mô tả',
            effective_date: 'Ngày hiệu lực',
            amendment_ref: 'Tham chiếu sửa đổi',
            create: 'Tạo',
            no_updates: 'Không có cập nhật quy định',
            status: 'Trạng thái',
            impact: 'Tác động',
            change_summary: 'Tóm tắt thay đổi',
            assess: 'Đánh giá',
            failed_load: 'Không thể load data',
            update_created: 'Cập nhật đã tạo',
            update_created_announce: 'Cập nhật quy định đã tạo',
            failed_create: 'Không thể create update',
            update_assessed: 'Cập nhật đã đánh giá',
            failed_assess: 'Không thể assess update',
            col_pack_version: 'Phiên bản gói',
            amendment_ref_inline: 'Tham chiếu sửa đổi: {reference}',
            default_assess_note: 'Đã đánh giá tác động — hoàn tất rà soát',
        },
        module_links: {
            title: 'Liên kết khung',
            modules: 'Phân hệ liên kết',
            add_module: 'Thêm phân hệ',
            module_code: 'Mã phân hệ',
            required: 'Bắt buộc',
            link: 'Liên kết',
            no_modules: 'Chưa liên kết phân hệ',
            notes: 'Ghi chú',
            personas: 'Persona liên kết',
            add_persona: 'Thêm persona',
            persona_id: 'ID persona',
            role_description: 'Mô tả vai trò',
            no_personas: 'Chưa liên kết persona',
            failed_load: 'Không thể load framework links',
            module_linked: 'Phân hệ đã liên kết',
            module_linked_announce: 'Phân hệ đã liên kết thành công',
            failed_link_module: 'Không thể liên kết phân hệ',
            persona_linked: 'Persona đã liên kết',
            persona_linked_announce: 'Persona đã liên kết thành công',
            failed_link_persona: 'Không thể link persona',
        },
        channels: {
            title: 'Kênh gửi và hạn chót',
            channels: 'Kênh gửi',
            add_channel: 'Thêm kênh',
            channel_type: 'Loại',
            name: 'Tên',
            instructions: 'Hướng dẫn',
            active: 'Hoạt động',
            no_channels: 'Chưa cấu hình kênh gửi',
            portal: 'Cổng thông tin',
            in_person: 'Trực tiếp',
            postal: 'Bưu chính',
            email: 'Email',
            add: 'Thêm',
            deadlines: 'Hạn chót quy định',
            add_deadline: 'Thêm hạn chót',
            label: 'Nhãn',
            days: 'Ngày',
            day_type: 'Loại ngày',
            calendar_days: 'Ngày theo lịch',
            working_days: 'Ngày làm việc',
            no_deadlines: 'Chưa cấu hình hạn chót',
            description: 'Mô tả',
            failed_load: 'Không thể load channel data',
            channel_added: 'Kênh đã thêm',
            channel_added_announce: 'Kênh gửi đã thêm',
            failed_add_channel: 'Không thể add channel',
            deadline_added: 'Hạn chót đã thêm',
            deadline_added_announce: 'Hạn chót quy định đã thêm',
            failed_add_deadline: 'Không thể add deadline',
            channel_code: 'Kênh đã công bố',
            channel_code_none: 'Chưa gắn với kênh đã công bố',
            channel_code_hint: 'Kênh do văn bản quy phạm pháp luật quy định. Chỉ kênh được gắn ở đây mới dùng được khi nộp hồ sơ.',
            framework_declares_no_channels: 'Khung tuân thủ này không công bố kênh nộp hồ sơ nào',
            framework_not_installed: 'Khung tuân thủ này chưa được cài đặt cho tổ chức của bạn',
        },
        frameworks_detail: {
            // fix-sprint-20260923-2136 — trạng thái riêng của trang chi tiết.
            page_title_fallback: 'Khung tuân thủ',
            page_unavailable_heading: 'Không hiển thị được khung tuân thủ',
            page_missing_code: 'Địa chỉ không chứa mã khung tuân thủ.',
            page_not_found: 'Không tìm thấy khung tuân thủ {code}.',
            page_not_found_generic: 'Không tìm thấy khung tuân thủ.',
            page_load_failed: 'Không tải được khung tuân thủ.',
            tab_frameworks: 'Khung tuân thủ',
            tab_watchlist: 'Danh sách theo dõi',
            authority: 'Cơ quan',
            requirements_count: 'Yêu cầu',
            all_types: 'Tất cả các loại',
            collapse_all: 'Thu gọn tất cả',
            expand_all: 'Mở rộng tất cả',
            all_sectors: 'Tất cả lĩnh vực',
            filter_by_sector: 'Lọc theo lĩnh vực',
            search_frameworks: 'Tìm theo tên hoặc mã...',
            sef_url_label: 'URL của khung tuân thủ',
            sef_url_copy: 'Sao chép',
            sef_url_copy_label: 'Sao chép URL của khung tuân thủ',
            sef_url_copied: 'Đã sao chép URL của khung tuân thủ',
            sef_url_copy_failed: 'Không sao chép được URL của khung tuân thủ',
            filtered_to: 'Đã lọc thành',
            clear_filter: 'Xóa bộ lọc',
            no_requirements: 'Không tìm thấy yêu cầu cho khung này.',
            requirements_label: 'Yêu cầu',
            status_updated: 'Trạng thái đã cập nhật thành công',
            overview_tab: 'Tổng quan',
            forms_tab: 'Biểu mẫu',
            procedures_tab: 'Thủ tục',
            fines_risks_tab: 'Phạt & Rủi ro',
            deadlines_tab: 'Thời hạn',
            // Sprint 46.9.0: Guidance tab + actions
            guidance_tab: 'Hướng dẫn',
            guidance_empty: 'Không có nội dung hướng dẫn cho khung tuân thủ này.',
            guidance_loading: 'Đang tải hướng dẫn…',
            guidance_section: 'Mục hướng dẫn',
            guidance_view: 'Xem hướng dẫn',
            guidance_map_to_workflow: 'Liên kết quy trình',
            guidance_link_evidence: 'Đính bằng chứng',
            guidance_filter_type: 'Loại',
            guidance_filter_category: 'Danh mục',
            guidance_filter_module: 'Phân hệ',
            guidance_filter_status: 'Trạng thái',
            guidance_filter_search: 'Tìm kiếm hướng dẫn',
            guidance_filter_all: 'Tất cả',
            guidance_table_reference: 'Tham chiếu',
            guidance_table_name: 'Tên hướng dẫn',
            guidance_table_type: 'Loại',
            guidance_table_category: 'Danh mục',
            guidance_table_effective_date: 'Ngày hiệu lực',
            guidance_table_modules: 'Phân hệ liên quan',
            guidance_table_actions: 'Thao tác',
            guidance_reference_only_banner: 'Chỉ tham chiếu — áp dụng cho lĩnh vực {{sector}} nhưng không áp dụng cho tổ chức của bạn.',
            guidance_open_official_source: 'Mở nguồn chính thức',
            guidance_no_detail: 'Không có thông tin chi tiết bổ sung cho hướng dẫn này.',
            enum_guidance_type_cross_framework_note: 'Ghi chú liên khung',
            enum_guidance_type_draft_status_note: 'Ghi chú trạng thái dự thảo',
            enum_guidance_type_framework_hierarchy_note: 'Ghi chú phân cấp khung',
            enum_guidance_type_framework_overlay_note: 'Ghi chú lớp phủ khung',
            enum_guidance_type_implementing_decree_summary: 'Tóm tắt nghị định hướng dẫn',
            enum_guidance_type_practical_unofficial_practice: 'Thực tiễn (không chính thức)',
            enum_guidance_category_auction: 'Đấu giá',
            enum_guidance_category_complaint_dispute: 'Khiếu nại và tranh chấp',
            enum_guidance_category_draft_governance: 'Quản trị dự thảo',
            enum_guidance_category_email_zip_submission: 'Nộp qua email/ZIP',
            enum_guidance_category_exchange_classification: 'Phân loại sàn giao dịch',
            enum_guidance_category_framework_hierarchy: 'Phân cấp khung',
            enum_guidance_category_high_risk_ai: 'AI rủi ro cao',
            enum_guidance_category_lifecycle_controls: 'Kiểm soát vòng đời',
            enum_guidance_category_listing_review: 'Rà soát niêm yết',
            enum_guidance_category_national_database_access: 'Truy cập cơ sở dữ liệu quốc gia',
            enum_guidance_category_outsourced_processing: 'Xử lý thuê ngoài',
            enum_guidance_category_participant_registration: 'Đăng ký thành viên tham gia',
            enum_guidance_category_personal_data_linkage: 'Liên kết dữ liệu cá nhân',
            enum_guidance_category_personnel_conditions: 'Điều kiện nhân sự',
            enum_guidance_category_pricing_and_public_asset: 'Định giá và tài sản công',
            enum_guidance_category_procedural_overlay: 'Lớp phủ thủ tục',
            enum_guidance_category_public_sector_ai: 'AI khu vực công',
            enum_guidance_category_requirement_detail: 'Chi tiết yêu cầu',
            enum_guidance_category_responsibilities: 'Trách nhiệm',
            enum_guidance_category_risk_and_remediation: 'Rủi ro và khắc phục',
            enum_guidance_category_sandbox: 'Môi trường thử nghiệm (sandbox)',
            enum_guidance_category_scope: 'Phạm vi',
            enum_guidance_category_security_drills_incidents: 'Diễn tập và sự cố an ninh',
            enum_guidance_category_submission_channel: 'Kênh nộp hồ sơ',
            enum_guidance_category_transaction_evidence: 'Bằng chứng giao dịch',
            enum_guidance_category_transparency_labeling: 'Ghi nhãn minh bạch',
            enum_module_evidence_management: 'Quản lý bằng chứng',
            enum_module_security: 'An ninh',
            form_category_access: 'Truy cập',
            form_category_application: 'Đơn đăng ký',
            form_category_authority_response_record: 'Hồ sơ phản hồi cơ quan',
            form_category_business_plan: 'Kế hoạch kinh doanh',
            form_category_capital_adequacy: 'An toàn vốn',
            form_category_capital_adequacy_report: 'Báo cáo an toàn vốn',
            form_category_certificate: 'Chứng nhận',
            form_category_classification: 'Phân loại',
            form_category_compliance: 'Tuân thủ',
            form_category_cross_border_transfer: 'Chuyển dữ liệu xuyên biên giới',
            form_category_decision: 'Quyết định',
            form_category_email_submission_record: 'Hồ sơ nộp qua email',
            form_category_evidence: 'Bằng chứng',
            form_category_evidence_pack: 'Gói bằng chứng',
            form_category_evidence_pack_manifest: 'Bản kê gói bằng chứng',
            form_category_forms: 'Biểu mẫu',
            form_category_information_system: 'Hệ thống thông tin',
            form_category_internal_audit: 'Kiểm toán nội bộ',
            form_category_internal_audit_report: 'Báo cáo kiểm toán nội bộ',
            form_category_internal_control: 'Kiểm soát nội bộ',
            form_category_internal_control_report: 'Báo cáo kiểm soát nội bộ',
            form_category_model_risk: 'Rủi ro mô hình',
            form_category_notification: 'Thông báo',
            form_category_official_certificate: 'Chứng nhận chính thức',
            form_category_official_reference: 'Tham chiếu chính thức',
            form_category_policy: 'Chính sách',
            form_category_record: 'Hồ sơ',
            form_category_remediation: 'Khắc phục',
            form_category_report: 'Báo cáo',
            form_category_reporting: 'Báo cáo',
            form_category_risk: 'Rủi ro',
            form_category_risk_data: 'Dữ liệu rủi ro',
            form_category_risk_management_report: 'Báo cáo quản lý rủi ro',
            form_category_sandbox: 'Môi trường thử nghiệm (sandbox)',
            form_category_security_plan: 'Kế hoạch an ninh',
            form_category_technical_plan: 'Kế hoạch kỹ thuật',
            form_category_training: 'Đào tạo',
            unit_absolute_date: 'Ngày cụ thể',
            unit_annual: 'Hằng năm',
            unit_before_transfer: 'Trước khi chuyển',
            unit_before_use: 'Trước khi sử dụng',
            unit_calendar_days_after_event: 'Ngày theo lịch sau sự kiện',
            unit_calendar_days_before_event: 'Ngày theo lịch trước sự kiện',
            unit_date: 'Ngày',
            unit_days: 'Ngày',
            unit_event: 'Sự kiện',
            unit_hours_from_authentication: 'Giờ kể từ khi xác thực',
            unit_month: 'Tháng',
            unit_months: 'Tháng',
            unit_months_from_future_effective_date: 'Tháng kể từ ngày hiệu lực tương lai',
            unit_on_request: 'Theo yêu cầu',
            unit_quarterly: 'Hằng quý',
            unit_upon_request: 'Khi có yêu cầu',
            unit_weeks: 'Tuần',
            unit_without_undue_delay: 'Không chậm trễ quá mức',
            unit_working_days_before_event: 'Ngày làm việc trước sự kiện',
            unit_year: 'Năm',
            unit_year_or_material_change: 'Năm hoặc khi có thay đổi trọng yếu',
            unit_years: 'Năm',
            unit_years_minimum: 'Năm (tối thiểu)',
            unit_day: 'Ngày',
            unit_week: 'Tuần',
            sla_type_phased_installation_obligation: 'Nghĩa vụ lắp đặt theo lộ trình',
            sla_type_transitional_window_end: 'Kết thúc thời gian chuyển tiếp',
            sla_type_data_retention_minimum: 'Thời hạn lưu trữ dữ liệu tối thiểu',
            sla_type_authority_appraisal_result_d356_as_issued: 'Thời hạn trả kết quả thẩm định của cơ quan (văn bản ban hành ban đầu)',
            sla_type_authority_appraisal_result_amended: 'Thời hạn trả kết quả thẩm định của cơ quan (văn bản sửa đổi)',
            sla_type_authority_appraisal_result_nq22: 'Thời hạn trả kết quả thẩm định của cơ quan (văn bản chuyển tiếp)',
            sla_type_transitional_end_date: 'Kết thúc giai đoạn chuyển tiếp ghi nợ tự động',
            sla_type_pre_launch_report_submission: 'Báo cáo trước khi triển khai gửi Ngân hàng Nhà nước',
            sla_type_testing_term_ceiling: 'Thời hạn thử nghiệm tối đa',
            sla_type_end_of_purpose_disposition: 'Hoàn trả, xóa hoặc tiêu hủy dữ liệu khi hết mục đích sử dụng',
            sla_type_publicity_on_regulator_requirement: 'Thông báo, công khai theo yêu cầu của cơ quan quản lý',
            sla_type_information_on_regulator_request: 'Cung cấp thông tin theo yêu cầu của cơ quan quản lý',
            sla_type_depositor_mismatch_handling_period: 'Thời hạn xử lý thông tin tra cứu không khớp đúng của khách hàng gửi tiền',
            sla_type_depositor_lookup_start: 'Thời điểm bắt đầu tra cứu thông tin liên quan đến tiền gửi',
            sla_type_periodic_security_assessment: 'Kiểm tra, đánh giá an toàn, bảo mật hằng năm',
            sla_type_periodic_software_list_review: 'Rà soát danh mục phần mềm được phê duyệt',
            sla_type_periodic_risk_review: 'Rà soát tình hình rủi ro',
            sla_type_periodic_continuity_drill: 'Diễn tập duy trì hoạt động',
            sla_type_periodic_staff_training: 'Đào tạo an toàn, bảo mật cho nhân viên',
            sla_type_record_retention_minimum: 'Thời gian lưu nhật ký trực tuyến tối thiểu',
            sla_type_record_backup_minimum: 'Thời gian lưu bản sao nhật ký tối thiểu',
            sla_type_periodic_vulnerability_scan: 'Dò quét lỗ hổng thành phần kết nối trực tiếp với Internet',
            sla_type_remediation_patch_window_critical_internet_facing: 'Vá lỗ hổng bảo mật mức nghiêm trọng, thành phần kết nối trực tiếp với Internet',
            sla_type_remediation_patch_window_critical_other: 'Vá lỗ hổng bảo mật mức nghiêm trọng, các thành phần còn lại',
            sla_type_remediation_patch_window_high_internet_facing: 'Vá lỗ hổng bảo mật mức cao, thành phần kết nối trực tiếp với Internet',
            sla_type_remediation_patch_window_high_other: 'Vá lỗ hổng bảo mật mức cao, các thành phần còn lại',
            sla_type_periodic_security_review: 'Rà soát bảo mật ứng dụng di động',
            sla_type_credential_max_validity: 'Thời hạn tối đa của mã PIN và mật khẩu',
            sla_type_credential_default_validity: 'Thời hạn mặc định của thông tin xác thực',
            sla_type_otp_max_validity_sms: 'Hiệu lực tối đa của SMS OTP',
            sla_type_otp_max_validity_voice: 'Hiệu lực tối đa của Voice OTP',
            sla_type_otp_max_validity_email: 'Hiệu lực tối đa của Email OTP',
            sla_type_otp_max_validity_matrix_card: 'Hiệu lực tối đa của OTP từ thẻ ma trận OTP',
            sla_type_otp_max_validity_soft: 'Hiệu lực tối đa của mã Soft OTP',
            sla_type_otp_max_validity_token: 'Hiệu lực tối đa của Token OTP',
            sla_type_card_max_usable_life: 'Thời gian sử dụng tối đa của thẻ ma trận OTP',
            sla_type_confirmation_request_validity: 'Hiệu lực của yêu cầu xác nhận qua hai kênh',
            sla_type_biometric_match_time_limit_device: 'Thời gian tối đa khớp đúng thông tin sinh trắc học thiết bị',
            sla_type_biometric_match_time_limit_stored_by_organisation: 'Thời gian tối đa khớp đúng thông tin sinh trắc học lưu trữ tại đơn vị',
            sla_type_ai_risk_classification_before_use: 'Phân loại rủi ro AI (trước khi sử dụng)',
            sla_type_annual_risk_assessment_report: 'Báo cáo đánh giá rủi ro hằng năm',
            sla_type_annual_training_readiness: 'Sẵn sàng đào tạo hằng năm',
            sla_type_art_30_records_availability_to_dpa: 'Cung cấp hồ sơ theo Điều 30 cho cơ quan bảo vệ dữ liệu',
            sla_type_audit_window_type_i: 'Khung thời gian kiểm toán (Loại I)',
            sla_type_audit_window_type_ii_min: 'Khung thời gian kiểm toán (Loại II, tối thiểu)',
            sla_type_audit_window_type_ii_typical: 'Khung thời gian kiểm toán (Loại II, thông thường)',
            sla_type_authentication_result_retention_readiness: 'Sẵn sàng lưu trữ kết quả xác thực',
            sla_type_breach_communication_to_data_subjects: 'Thông báo vi phạm cho chủ thể dữ liệu',
            sla_type_breach_notification_to_supervisory_authority: 'Thông báo vi phạm cho cơ quan giám sát',
            sla_type_classification_lifecycle_review: 'Rà soát vòng đời phân loại',
            sla_type_consultation_end: 'Kết thúc tham vấn',
            sla_type_annual_activity_report_proposed: 'Báo cáo hoạt động hằng năm (dự kiến)',
            sla_type_approved_list_publication_proposed: 'Công bố danh sách được công nhận (dự kiến)',
            sla_type_course_result_report_proposed: 'Báo cáo kết quả khóa tập huấn (dự kiến)',
            sla_type_foreign_certificate_application_proposed: 'Đề nghị công nhận chứng chỉ nước ngoài (dự kiến)',
            sla_type_network_registration_review_proposed: 'Thẩm định đăng ký tham gia Mạng lưới (dự kiến)',
            sla_type_recognised_body_change_notice_proposed: 'Thông báo thay đổi của tổ chức được công nhận (dự kiến)',
            sla_type_agency_label_publication_proposed: 'Cục công bố thông tin nhãn và mã định danh (dự kiến)',
            sla_type_label_dpid_update_proposed: 'Cập nhật mã định danh vào nhãn (dự kiến)',
            sla_type_inspection_annual_report_proposed: 'Báo cáo kết quả kiểm tra hằng năm gửi Bộ (dự kiến)',
            sla_type_content_takedown_response: 'Phản hồi gỡ bỏ nội dung',
            sla_type_cookie_consent_reconfirmation: 'Xác nhận lại đồng ý cookie',
            sla_type_corrective_action_default: 'Hành động khắc phục (mặc định)',
            sla_type_cross_border_core_authority_review_complex: 'Rà soát của cơ quan đối với dữ liệu cốt lõi xuyên biên giới (phức tạp)',
            sla_type_cross_border_core_authority_review_standard: 'Rà soát của cơ quan đối với dữ liệu cốt lõi xuyên biên giới (tiêu chuẩn)',
            sla_type_cross_border_exception_postfiling: 'Ngoại lệ chuyển dữ liệu xuyên biên giới (nộp sau)',
            sla_type_cross_border_important_prefiling: 'Dữ liệu quan trọng xuyên biên giới (nộp trước)',
            sla_type_ctia_dossier_filing: 'Nộp hồ sơ CTIA',
            sla_type_cross_border_dossier_applicant_completion: 'Bên nộp hồ sơ hoàn thiện hồ sơ đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới',
            sla_type_database_update: 'Cập nhật cơ sở dữ liệu',
            sla_type_decision_effective_date: 'Ngày hiệu lực của quyết định',
            sla_type_decree_effective_date: 'Ngày hiệu lực của nghị định',
            sla_type_circular_effective_date: 'Ngày hiệu lực của thông tư',
            sla_type_system_upgrade_completion: 'Hoàn thành nâng cấp hệ thống',
            sla_type_incident_recovery_resumption: 'Khôi phục việc gửi báo cáo sau khi khắc phục sự cố',
            sla_type_report_correction_resubmission: 'Chỉnh sửa và gửi lại báo cáo',
            sla_type_regulator_review_period: 'Thời hạn kiểm duyệt của cơ quan quản lý',
            sla_type_submission_window_lock: 'Khóa việc gửi báo cáo',
            sla_type_transitional_reporting_regime: 'Chế độ báo cáo chuyển tiếp',
            sla_type_staged_commencement_date: 'Ngày hiệu lực theo giai đoạn',
            sla_type_decree_issued: 'Ngày ban hành nghị định',
            sla_type_direct_marketing_opt_out_honor: 'Thực hiện yêu cầu từ chối tiếp thị trực tiếp (quy định EU)',
            sla_type_document_review_annual: 'Rà soát tài liệu (hằng năm)',
            sla_type_dpia_prior_consultation_dpa_response: 'Phản hồi của cơ quan bảo vệ dữ liệu về tham vấn trước DPIA',
            sla_type_dsar_refusal_notification: 'Thông báo từ chối yêu cầu của chủ thể dữ liệu',
            sla_type_dsar_response: 'Phản hồi yêu cầu của chủ thể dữ liệu',
            sla_type_dsar_response_extension: 'Gia hạn phản hồi yêu cầu của chủ thể dữ liệu',
            sla_type_emergency_drill_cadence: 'Chu kỳ diễn tập khẩn cấp',
            sla_type_entrusted_processing_record_retention: 'Lưu trữ hồ sơ xử lý được ủy thác',
            sla_type_event_review: 'Rà soát sự kiện',
            // Sprint 62.49.1 (DB-10) — the consumer-rights pack's acknowledgement-of-receipt row.
            sla_type_consumer_complaint_receipt_acknowledgement: 'Thông báo cho người tiêu dùng về việc tiếp nhận phản ánh, yêu cầu, khiếu nại',
            sla_type_food_traceability_records_request: 'Yêu cầu cung cấp hồ sơ truy xuất nguồn gốc thực phẩm (24 giờ)',
            sla_type_food_traceability_system_update: 'Cập nhật hệ thống truy xuất nguồn gốc thực phẩm',
            sla_type_evidence_currency_limit: 'Thời hạn hiệu lực của bản khai lý lịch (không quá 06 tháng trước khi nộp)',
            sla_type_framework_effective_date: 'Ngày hiệu lực của khung tuân thủ',
            sla_type_high_risk_conformity_assessment_before_use: 'Đánh giá sự phù hợp rủi ro cao (trước khi sử dụng)',
            sla_type_ict_systems_yearly_testing: 'Kiểm thử hệ thống CNTT-TT hằng năm',
            sla_type_important_core_transfer_approval_readiness: 'Sẵn sàng phê duyệt chuyển dữ liệu quan trọng/cốt lõi',
            sla_type_incident_early_warning: 'Cảnh báo sớm sự cố',
            sla_type_incident_final_report: 'Báo cáo cuối cùng về sự cố',
            sla_type_incident_initial_notification: 'Thông báo ban đầu về sự cố',
            sla_type_cybersecurity_law_art45_1_assigned_level_protection_transition: 'Hệ thống thông tin đã được xác định cấp độ — chuyển tiếp điều kiện bảo vệ',
            sla_type_incident_initial_notification_outer_limit: 'Thông báo ban đầu về sự cố — giới hạn tối đa kể từ khi biết',
            sla_type_incident_intermediate_report: 'Báo cáo trung gian về sự cố',
            sla_type_incident_notification: 'Thông báo sự cố',
            sla_type_information_sharing_arrangement_notification: 'Thông báo thỏa thuận chia sẻ thông tin',
            sla_type_internal_audit_annual: 'Kiểm toán nội bộ (hằng năm)',
            sla_type_internal_post_consultation_review: 'Rà soát nội bộ sau tham vấn',
            sla_type_internal_post_session_review: 'Rà soát nội bộ sau phiên',
            sla_type_internal_review: 'Rà soát nội bộ',
            sla_type_law_effective_date: 'Ngày hiệu lực của luật',
            sla_type_lawful_deletion_request: 'Yêu cầu xóa hợp pháp',
            sla_type_management_body_training_cycle: 'Chu kỳ đào tạo cơ quan quản lý',
            sla_type_management_review_annual: 'Rà soát của ban lãnh đạo (hằng năm)',
            sla_type_national_assembly_session: 'Kỳ họp Quốc hội',
            sla_type_national_assembly_plenary_submission: 'Quốc hội nghe Tờ trình của Chính phủ',
            sla_type_national_synthetic_database_response: 'Phản hồi cơ sở dữ liệu tổng hợp quốc gia',
            sla_type_personnel_reassessment_readiness: 'Sẵn sàng đánh giá lại nhân sự',
            sla_type_platform_registration_amendment: 'Sửa đổi đăng ký nền tảng',
            sla_type_processing_log_retention: 'Lưu trữ nhật ký xử lý',
            sla_type_recertification_annual: 'Tái chứng nhận (hằng năm)',
            sla_type_recertification_cycle: 'Chu kỳ tái chứng nhận',
            sla_type_reclassification_authority_notification: 'Thông báo cho cơ quan về việc phân loại lại',
            sla_type_recurring_review: 'Rà soát định kỳ',
            sla_type_reference_issued: 'Ngày ban hành tài liệu tham chiếu',
            sla_type_remediation_default: 'Khắc phục (mặc định)',
            sla_type_risk_management_review_cycle: 'Chu kỳ rà soát quản lý rủi ro',
            sla_type_risk_management_self_assessment_cycle: 'Chu kỳ tự đánh giá quản lý rủi ro',
            sla_type_roadmap_issued: 'Ngày ban hành lộ trình',
            sla_type_ropa_review_cycle: 'Chu kỳ rà soát hồ sơ hoạt động xử lý (RoPA)',
            sla_type_sandbox_certificate_review_ministry: 'Rà soát chứng nhận sandbox (cấp bộ)',
            sla_type_sandbox_certificate_review_multi_authority: 'Rà soát chứng nhận sandbox (đa cơ quan)',
            sla_type_sandbox_certificate_review_provincial: 'Rà soát chứng nhận sandbox (cấp tỉnh)',
            sla_type_sandbox_completion_report: 'Báo cáo hoàn thành sandbox',
            sla_type_sandbox_completion_certificate_review: 'Xem xét cấp giấy xác nhận hoàn thành thử nghiệm',
            sla_type_sandbox_dossier_validity_check: 'Kiểm tra tính hợp lệ của hồ sơ sandbox',
            sla_type_sandbox_extension_application: 'Nộp đơn đề nghị gia hạn thử nghiệm',
            sla_type_sandbox_extension_decision: 'Quyết định gia hạn thử nghiệm',
            sla_type_sandbox_transitional_extension_request: 'Đề nghị gia hạn vận hành chuyển tiếp',
            sla_type_sandbox_transitional_extension_decision: 'Quyết định gia hạn vận hành chuyển tiếp',
            sla_type_sandbox_periodic_report_level_1_2: 'Báo cáo định kỳ sandbox (cấp 1–2)',
            sla_type_sandbox_periodic_report_level_3: 'Báo cáo định kỳ sandbox (cấp 3)',
            sla_type_sandbox_serious_incident_report: 'Báo cáo sự cố nghiêm trọng trong sandbox',
            sla_type_self_sovereign_log_sync_readiness: 'Sẵn sàng đồng bộ nhật ký tự chủ',
            sla_type_serious_incident_final_report: 'Báo cáo cuối cùng về sự cố nghiêm trọng',
            sla_type_serious_incident_preliminary_other: 'Báo cáo sơ bộ về sự cố nghiêm trọng (khác)',
            sla_type_serious_incident_preliminary_severe: 'Báo cáo sơ bộ về sự cố nghiêm trọng (mức nghiêm trọng)',
            sla_type_state_agency_ai_impact_assessment_before_use: 'Đánh giá tác động AI của cơ quan nhà nước (trước khi sử dụng)',
            sla_type_supply_chain_reassessment_cycle: 'Chu kỳ đánh giá lại chuỗi cung ứng',
            sla_type_surveillance_audit_annual: 'Kiểm toán giám sát (hằng năm)',
            sla_type_telecom_breach_authority_notification: 'Vi phạm viễn thông — thông báo cơ quan',
            sla_type_telecom_breach_authority_supplement: 'Vi phạm viễn thông — bổ sung cho cơ quan',
            sla_type_telecom_breach_subject_notification: 'Vi phạm viễn thông — thông báo chủ thể',
            sla_type_third_party_register_annual_reporting: 'Báo cáo hằng năm sổ đăng ký bên thứ ba',
            sla_type_tlpt_cycle: 'Chu kỳ kiểm thử thâm nhập dựa trên mối đe dọa (TLPT)',
            sla_type_traceability_system_connection_start: 'Bắt đầu kết nối hệ thống truy xuất nguồn gốc',
            sla_type_traffic_data_erasure_review: 'Rà soát xóa dữ liệu lưu lượng',
            sla_type_transition_existing_systems: 'Chuyển tiếp — hệ thống hiện có',
            sla_type_transition_new_systems: 'Chuyển tiếp — hệ thống mới',
            sla_type_transition_readiness: 'Sẵn sàng chuyển tiếp',
            guidance_related_link: 'Hướng dẫn liên quan',
            deadlines_empty: 'Không tìm thấy thời hạn quy định cho khung tuân thủ này.',
            deadlines_sla_type: 'Loại SLA',
            deadlines_value: 'Thời hạn',
            deadlines_unit: 'Đơn vị',
            deadlines_extension: 'Gia hạn',
            deadlines_last_day: 'Ngày cuối: {date}',
            deadlines_date_basis_computed: 'tính từ thời hạn {period} theo quy tắc tính thời hạn mà căn cứ pháp lý nêu; văn bản không in ngày này',
            deadlines_date_basis_printed: 'được in trong văn bản đã ký',
            deadlines_date_basis_next_working_day: 'nếu kết thúc vào ngày không làm việc thì chuyển sang ngày làm việc tiếp theo',
            deadlines_reference: 'Căn cứ pháp lý',
            framework_stack: 'Cấu trúc khung tuân thủ',
            layer_parent_law: 'Luật gốc',
            layer_implementing_decree: 'Nghị định hướng dẫn',
            layer_enforcement_decree: 'Nghị định xử phạt',
            layer_admin_procedures: 'Thủ tục hành chính',
            // fix-sprint-20260912-1003 — Framework Stack layer groups and row states.
            layer_prime_minister_decision: 'Quyết định của Thủ tướng Chính phủ',
            layer_official_roadmap: 'Tham chiếu',
            layer_child_instrument: 'Văn bản trực thuộc',
            stack_status_in_force: 'Đang có hiệu lực',
            stack_status_in_force_reference: 'Đang có hiệu lực (tham chiếu)',
            stack_status_in_force_until: 'Có hiệu lực đến {date}',
            stack_status_from_date: 'Từ {date}',
            stack_status_draft: 'Dự thảo',
            stack_status_promulgated: 'Đã ban hành {date}',
            stack_status_superseded: 'Đã được thay thế {date}',
            stack_status_reference: 'Tham chiếu',
            stack_status_unknown: 'Không nhận dạng được trạng thái',
            stack_show_lineage: 'Hiện lịch sử văn bản',
            stack_became: 'được ban hành thành văn bản này vào ngày {date}',
            stack_replaced_by: 'được thay thế bởi văn bản này vào ngày {date}',
            stack_became_law: 'được ban hành thành luật này vào ngày {date}',
            stack_replaced_by_law: 'được thay thế bởi luật này vào ngày {date}',
            stack_has_lineage_promulgated: 'được ban hành từ dự thảo',
            stack_has_lineage_superseded: 'đã thay thế một văn bản trước đó',
            stack_no_framework_page: 'không có trang văn bản pháp lý',
            status_active: 'Đang hiệu lực',
            status_draft: 'Dự thảo',
            draft_enforcement_badge: 'Dự thảo — chưa ban hành',
            effective_date_draft: 'Dự thảo — chưa có hiệu lực',
            effective_date: 'Ngày có hiệu lực',
            forms_table_id: 'Mã biểu mẫu',
            forms_table_name: 'Tên biểu mẫu',
            forms_table_source: 'Nguồn',
            forms_table_category: 'Danh mục',
            forms_table_type: 'Loại',
            fill_form: 'Điền biểu mẫu',
            view_reference: 'Xem tài liệu tham chiếu',
            forms_empty: 'Không tìm thấy biểu mẫu cho khung tuân thủ này.',
            forms_loading: 'Đang tải biểu mẫu...',
            procedures_id: 'Mã thủ tục',
            procedures_name: 'Thủ tục',
            procedures_trigger: 'Điều kiện kích hoạt',
            procedures_steps: 'Các bước',
            procedures_outputs: 'Kết quả',
            procedures_related_forms: 'Biểu mẫu liên quan',
            procedures_empty: 'Không tìm thấy thủ tục cho khung tuân thủ này.',
            fines_area: 'Lĩnh vực vi phạm',
            fines_articles: 'Điều khoản',
            fines_individual: 'Phạt (cá nhân)',
            fines_organization: 'Phạt (tổ chức)',
            fines_revenue: 'Tỷ lệ doanh thu',
            fines_deadlines: 'Thời hạn',
            fines_remediation: 'Biện pháp khắc phục',
            fines_related: 'Thủ tục liên quan',
            fines_empty: 'Chưa có dữ liệu xử phạt cho khung tuân thủ này.',
            // fix-sprint D1 F22 — `fetchWatchlistFrameworks`'s catch set an empty
            // watchlist with no flag, so a failed read printed "No draft or upcoming
            // frameworks" — a POSITIVE finding about the regulatory horizon, and the
            // most consequential thing that tab can say wrongly.
            watchlist_load_failed: 'Không đọc được danh sách khung tuân thủ dự thảo và sắp có hiệu lực. Hãy tải lại để thử lại.',
            watchlist_retry_subject: 'danh sách theo dõi khung tuân thủ',
            /*
              fix-sprint D1 F9 — the six regulatory-content tabs on the framework
              detail view swallowed every read failure into an empty array and then
              STATED absence: "No requirements found for this framework.", "No forms
              found…", "No procedures found…", "No guidance content…". On a
              regulatory surface "this framework declares no requirements" is a claim
              an operator acts on, and a failed read is not that claim. Each tab now
              states the failure instead, beside the reload that clears it.
            */
            content_reload: 'Tải lại',
            content_reloading: 'Đang tải lại…',
            requirements_load_failed: 'Không đọc được danh sách yêu cầu của khung tuân thủ này. Hãy tải lại để thử lại.',
            forms_load_failed: 'Không đọc được danh sách biểu mẫu của khung tuân thủ này. Hãy tải lại để thử lại.',
            procedures_load_failed: 'Không đọc được danh sách thủ tục của khung tuân thủ này. Hãy tải lại để thử lại.',
            deadlines_load_failed: 'Không đọc được danh sách thời hạn của khung tuân thủ này. Hãy tải lại để thử lại.',
            fines_load_failed: 'Không đọc được dữ liệu xử phạt của khung tuân thủ này. Hãy tải lại để thử lại.',
            guidance_load_failed: 'Không đọc được nội dung hướng dẫn của khung tuân thủ này. Hãy tải lại để thử lại.',
            content_partial_failed: 'Một phần nội dung không đọc được nên danh sách hiển thị có thể chưa đầy đủ. Hãy tải lại để thử lại.',
            requirements_retry_subject: 'danh sách yêu cầu của khung tuân thủ này',
            forms_retry_subject: 'danh sách biểu mẫu của khung tuân thủ này',
            procedures_retry_subject: 'danh sách thủ tục của khung tuân thủ này',
            deadlines_retry_subject: 'danh sách thời hạn của khung tuân thủ này',
            fines_retry_subject: 'dữ liệu xử phạt của khung tuân thủ này',
            guidance_retry_subject: 'nội dung hướng dẫn của khung tuân thủ này',
            fines_risk_type: 'Loại rủi ro',
            fines_risk_triggers: 'Yếu tố kích hoạt',
            fines_risk_only_note: 'Các mục này mô tả rủi ro tuân thủ và vận hành, không phải hình phạt tiền. Khi có mức phạt, chúng được quy định trong khung tuân thủ gốc.',
            fines_enforcement_pending: 'Khung xử phạt chưa được ban hành. Dữ liệu xử phạt sẽ được bổ sung khi văn bản hướng dẫn thi hành được công bố.',
            view_details: 'Xem chi tiết',
            back_to_list: 'Quay lại danh sách',
            description: 'Mô tả',
            jurisdiction: 'Phạm vi áp dụng',
            lineage: 'Lịch sử',
            replaces: 'Thay thế',
            replaced_by: 'Được thay thế bởi',
            requirements: 'Yêu cầu',
            tab_navigation: 'Các tab chi tiết khung tuân thủ',
            forms_table_actions: 'Hành động',
            create_form: 'Tạo biểu mẫu',
            mark_promulgated: 'Đánh dấu đã ban hành',
            status_promulgated: 'Đã ban hành',
            promulgated_success: 'Trạng thái lớp đã cập nhật thành đã ban hành',
            transition_review: 'Rà soát chuyển tiếp',
            transition_review_desc: 'Khung tuân thủ này có rà soát chuyển tiếp đang chờ xử lý cho việc áp dụng luật kế thừa.',
            transition_review_by: 'Hạn rà soát',
            transition_review_status: 'Trạng thái rà soát',
            transition_review_notes: 'Ghi chú',
            transition_review_pending: 'Chờ xử lý',
            transition_review_in_progress: 'Đang thực hiện',
            transition_review_completed: 'Hoàn thành',
            transition_review_successor: 'Khung tuân thủ kế thừa',
            transition_review_lead_time: 'Thời gian chuẩn bị',
            transition_review_lead_time_days: '{days} ngày trước ngày có hiệu lực',
            transition_review_overdue: 'quá hạn',
            transition_review_forms_heading: 'Rà soát chuyển tiếp biểu mẫu',
            transition_review_forms_desc: 'Rà soát từng mẫu hoạt động về mức độ phù hợp theo khung tuân thủ kế thừa.',
            transition_review_outcome: 'Kết quả',
            transition_review_outcome_carry_forward: 'Chuyển tiếp nguyên trạng',
            transition_review_outcome_carry_forward_revised: 'Chuyển tiếp (sửa đổi)',
            transition_review_outcome_retire: 'Ngừng sử dụng',
            transition_review_outcome_split: 'Tách biểu mẫu',
            transition_review_outcome_awaiting_decree: 'Chờ nghị định',
            transition_review_no_forms: 'Chưa cấu hình rà soát chuyển tiếp biểu mẫu.',
            transition_review_update_success: 'Cập nhật rà soát chuyển tiếp thành công',
            transition_review_operational_note: 'Đây là các mẫu hoạt động hỗ trợ quy trình, không phải số lượng biểu mẫu theo luật định. Quy thuộc pháp lý vẫn thuộc khung tuân thủ cũ cho đến khi luật kế thừa có hiệu lực.',
            rights_tab: 'Quyền',
            rights_empty: 'Không có quyền chủ thể dữ liệu được xác định cho khung tuân thủ này.',
            rights_code: 'Mã',
            rights_name: 'Quyền',
            rights_legal_basis: 'Cơ sở pháp lý',
            rights_elaborating_articles: 'Điều khoản chi tiết',
            rights_description: 'Mô tả',
            filter_by_source_layer: 'Lọc theo nguồn',
            all_layers: 'Tất cả các lớp',
            procedures_submission_channels: 'Kênh nộp hồ sơ',
            // Sprint 62.0.3 (AC8) — khung không có cơ quan tiếp nhận hồ sơ
            no_filing_authority_title: 'Không có cơ quan tiếp nhận hồ sơ',
            no_filing_authority_body: 'Không có cơ quan nào tiếp nhận hồ sơ theo khung này, do đó không có luồng nộp hồ sơ và không có thời hạn nào bị coi là quá hạn. Nghĩa vụ ở đây được chứng minh bằng bằng chứng, không phải bằng việc nộp hồ sơ.',
            no_filing_authority_basis_certification_body: 'Sự phù hợp được đánh giá bởi tổ chức chứng nhận được công nhận.',
            no_filing_authority_basis_commercially_engaged_auditor: 'Việc bảo đảm do kiểm toán viên được thuê theo hợp đồng thương mại thực hiện.',
            no_filing_authority_basis_internal_governance_only: 'Khung này chỉ được thực hiện thông qua quản trị nội bộ.',
            // Requirement table columns
            requirements_reference: 'Tham chiếu',
            requirements_mandatory: 'Bắt buộc',
            // Sprint 62.58.0 (AC-B1, AC-B3) — whom each requirement addresses, and the filter over the declared classes.
            requirements_addressed_to: 'Đối tượng hướng tới',
            requirements_addressee_filter_hint: 'Hiển thị các yêu cầu hướng tới bất kỳ đối tượng nào bạn chọn. Hệ thống không chọn sẵn đối tượng nào.',
            requirements_addressee_count: 'Đang hiển thị {shown} trên {total} yêu cầu',
            requirements_addressee_clear: 'Hiển thị tất cả yêu cầu',
            requirements_basis_note_show: 'Đọc toàn bộ ghi chú',
            requirements_basis_note_hide: 'Thu gọn',
            requirements_yes: 'Có',
            requirements_no: 'Không',
            requirements_source: 'Nguồn',
            // Requirement category labels
            category_legal_basis: 'Cơ sở pháp lý',
            category_data_subject_rights: 'Quyền chủ thể dữ liệu',
            category_notification: 'Thông báo',
            category_assessment: 'Đánh giá',
            category_governance: 'Quản trị',
            category_record_keeping: 'Lưu trữ hồ sơ',
            category_cross_border: 'Chuyển dữ liệu xuyên biên giới',
            category_technical_measures: 'Biện pháp kỹ thuật',
            category_incident_reporting: 'Báo cáo sự cố',
            category_risk_management: 'Quản lý rủi ro',
            category_supply_chain: 'Chuỗi cung ứng',
            category_certification: 'Chứng nhận',
            // Framework list labels
            child_frameworks: '{count} khung còn',
            child_frameworks_plural: '{count} khung còn',
            replaces_prefix: 'Thay thế:',
            replaced_by_prefix: 'Được thay thế bởi:',
            responsible_prefix: 'Chịu trách nhiệm:',
            watchlist_empty_hint: 'Các khung tuân thủ có trạng thái "dự thảo" hoặc "sắp tới" sẽ hiển thị ở đây để theo dõi.',
            framework_count: '{count} khung tuân thủ',
            framework_count_plural: '{count} khung tuân thủ',
            hiding_legacy: '(ẩn {count} khung cũ)',
            // Framework code display labels
            label_VN_PDPD_DECREE_13: 'Nghị định PDPD 13/2023',
            label_VN_PDPL_LAW_2025: 'Luật BVDLCN 91/2025',
            label_VN_PDPL_DECREE_356_2025: 'Nghị định 356/2025/NĐ-CP',
            label_VN_PDPL_ADMIN_PROCEDURES_778_2026: 'QĐ 778/QĐ-BCA-A05',
            label_VN_PDPL_ENFORCEMENT_DRAFT_2026: 'Dự thảo Xử phạt Cyber+PDPL 2026',
            label_VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: 'Lớp phủ tạm thời NQ22 2026',
            label_VN_DATA_LAW: 'Luật Dữ liệu',
            label_VN_DATA_LAW_DECREE_165_2025: 'Nghị định Luật Dữ liệu 165/2025',
            label_VN_DATA_EXCHANGES_DRAFT_2026: 'Dự thảo Sàn dữ liệu 2026',
            label_VN_TELECOM_LAW_2023: 'Luật Viễn thông 2023',
            label_VN_TELECOM_DECREE_163_2024: 'Nghị định Viễn thông 163/2024',
            label_VN_CYBERSEC_LAW: 'Luật An ninh mạng (24/2018)',
            label_VN_CYBERSEC_DECREE_53: 'Nghị định An ninh mạng 53/2022',
            label_VN_CYBERSEC_LAW_2025: 'Luật An ninh mạng 116/2025',
            label_VN_ECOMMERCE_LAW_2025: 'Luật Thương mại điện tử 122/2025',
            label_VN_AI_LAW_2026: 'Luật Trí tuệ nhân tạo 2026',
            label_VN_AI_DECREE_142_2026: 'Nghị định AI 142/2026/NĐ-CP',
            // Issuer labels
            issuer_company: 'Công ty',
            issuer_authority_a05_mps: 'BCA/A05',
            issuer_authority_mic: 'Bộ TT&TT',
            issuer_authority_mps_ndc: 'BCA/NDC',
            issuer_other_authority: 'Cơ quan',
            // Deadline SLA type labels
            sla_type_rights_request_ack: 'Xác nhận yêu cầu quyền',
            'sla_type_Access control review': 'Rà soát kiểm soát truy cập',
            'sla_type_Annual governance attestation': 'Xác nhận quản trị hằng năm',
            'sla_type_Audit review cycle': 'Chu kỳ rà soát kiểm toán',
            'sla_type_Authority request response': 'Phản hồi yêu cầu của cơ quan',
            'sla_type_Change notification processing': 'Xử lý thông báo thay đổi',
            'sla_type_Complaint acknowledgment': 'Xác nhận khiếu nại',
            'sla_type_Complaint resolution': 'Giải quyết khiếu nại',
            'sla_type_Confidentiality policy review': 'Rà soát chính sách bảo mật',
            'sla_type_Cybersecurity incident full report': 'Báo cáo đầy đủ sự cố an ninh mạng',
            'sla_type_Cybersecurity incident initial report': 'Báo cáo ban đầu sự cố an ninh mạng',
            'sla_type_Data inventory review': 'Rà soát kiểm kê dữ liệu',
            'sla_type_Disclosure log review cycle': 'Chu kỳ rà soát nhật ký tiết lộ',
            'sla_type_Incident classification decision': 'Quyết định phân loại sự cố',
            'sla_type_Information system classification review': 'Rà soát phân loại hệ thống thông tin',
            'sla_type_Notification processing (sales website/app)': 'Xử lý thông báo (website/ứng dụng bán hàng)',
            'sla_type_Pen test cycle': 'Chu kỳ kiểm thử xâm nhập',
            'sla_type_Registration processing (service platform)': 'Xử lý đăng ký (nền tảng dịch vụ)',
            'sla_type_Risk assessment cycle': 'Chu kỳ đánh giá rủi ro',
            'sla_type_Takedown decision (after review)': 'Quyết định gỡ bỏ (sau rà soát)',
            'sla_type_Termination notice (public)': 'Thông báo chấm dứt (công khai)',
            sla_type_ai_impact_assessment_completion: 'Hoàn thành đánh giá tác động AI',
            sla_type_ai_sandbox_application_review: 'Rà soát đơn xin sandbox AI',
            sla_type_ai_serious_incident_report: 'Báo cáo sự cố nghiêm trọng AI',
            sla_type_ai_system_registration: 'Đăng ký hệ thống AI',
            sla_type_authority_request_response: 'Phản hồi yêu cầu của cơ quan',
            sla_type_certificate_issuance_review: 'Rà soát cấp chứng nhận',
            sla_type_complaint_handling_approach_notice: 'Thông báo phương án xử lý khiếu nại',
            sla_type_complaint_incomplete_info_request: 'Yêu cầu bổ sung thông tin khiếu nại',
            sla_type_data_governance_attestation: 'Xác nhận quản trị dữ liệu',
            sla_type_dsr_acknowledgment: 'Xác nhận yêu cầu quyền chủ thể dữ liệu',
            sla_type_dsr_cl2_withdraw_restrict_object: 'Yêu cầu DSR (Khoản 2) — Rút / hạn chế / phản đối',
            sla_type_dsr_cl2_withdraw_restrict_object_third_party: 'Yêu cầu DSR (Khoản 2) — Rút lại sự đồng ý / phản đối, bên thứ ba',
            sla_type_dsr_cl3_access_correct_provide: 'Yêu cầu DSR (Khoản 3) — Truy cập / chỉnh sửa / cung cấp',
            sla_type_dsr_cl3_access_correct_provide_third_party: 'Yêu cầu DSR (Khoản 3) — Chỉnh sửa, bên thứ ba',
            sla_type_dsr_cl3_access_third_party: 'Yêu cầu DSR (Khoản 3) — Truy cập, bên thứ ba',
            sla_type_chemical_incident_system_declaration: 'Sự cố hóa chất — khai báo lên Hệ thống',
            sla_type_code_termination_explanation_window: 'Chấm dứt mã — thời hạn giải trình',
            sla_type_code_restoration_by_managing_body: 'Khôi phục mã bởi cơ quan quản lý',
            sla_type_traceability_data_update_frequency: 'Dữ liệu truy xuất nguồn gốc — tần suất cập nhật',
            sla_type_authority_decision_deadline: 'Quyết định của cơ quan — thời hạn',
            sla_type_authority_list_update_cycle: 'Danh mục của cơ quan — chu kỳ cập nhật',
            sla_type_dsr_cl4_deletion: 'Yêu cầu DSR (Khoản 4) — Xóa',
            sla_type_dsr_cl4_deletion_third_party: 'Yêu cầu DSR (Khoản 4) — Xóa, bên thứ ba',
            sla_type_dsr_cl4_provide_restrict_third_party: 'Yêu cầu DSR (Khoản 4) — Hạn chế xử lý, bên thứ ba',
            sla_type_dsr_cl5_protective_measures: 'Yêu cầu DSR (Khoản 5) — Biện pháp bảo vệ',
            sla_type_telecom_authority_request_response: 'Phản hồi yêu cầu của cơ quan viễn thông',
            sla_type_rights_request_completion: 'Hoàn thành yêu cầu quyền',
            sla_type_incident_authority_notification: 'Thông báo sự cố cho cơ quan',
            sla_type_incident_subject_notification: 'Thông báo sự cố cho chủ thể',
            sla_type_dpia_completion: 'Hoàn thành DPIA',
            sla_type_data_retention_review: 'Rà soát lưu trữ dữ liệu',
            sla_type_authority_filing_review: 'Cơ quan xem xét hồ sơ',
            sla_type_authority_supplement_response: 'Phản hồi bổ sung của cơ quan',
            sla_type_authority_resubmission: 'Nộp lại cho cơ quan',
            sla_type_authority_filing_supplement_response: 'Phản hồi bổ sung hồ sơ của cơ quan',
            sla_type_authority_filing_resubmission: 'Nộp lại hồ sơ cho cơ quan',
            sla_type_authority_delivery_window: 'Thời hạn cơ quan gửi văn bản',
            sla_type_authority_examination_window: 'Thời hạn cơ quan kiểm tra',
            sla_type_authority_notice_trigger: 'Mốc thông báo của cơ quan',
            sla_type_authority_processing_window: 'Thời hạn cơ quan xử lý hồ sơ',
            sla_type_before_event: 'Trước sự kiện',
            sla_type_instalment_maximum_period: 'Thời hạn nộp dần tối đa',
            sla_type_lead_time_before_event: 'Thời gian trước sự kiện',
            sla_type_reporting_cycle: 'Chu kỳ báo cáo',
            sla_type_reporting_period: 'Kỳ báo cáo',
            sla_type_statutory_filing_window: 'Thời hạn nộp hồ sơ theo quy định',
            sla_type_statutory_payment_deadline: 'Thời hạn nộp thuế theo quy định',
            sla_type_taxpayer_filing_window: 'Thời hạn người nộp thuế nộp hồ sơ',
            sla_type_taxpayer_notification_window: 'Thời hạn người nộp thuế thông báo',
            sla_type_taxpayer_response_window: 'Thời hạn người nộp thuế phản hồi',
            sla_type_taxpayer_supplementation_window: 'Thời hạn người nộp thuế bổ sung hồ sơ',
            sla_type_transition_deadline: 'Thời hạn chuyển tiếp',
            sla_type_provision_end_date: 'Ngày quy định hết áp dụng',
            sla_type_authority_notification_window: 'Thời hạn cơ quan có thẩm quyền thông báo',
            sla_type_enforcement_trigger: 'Thời điểm bị áp dụng cưỡng chế',
            sla_type_authority_advance_notice: 'Thời hạn cơ quan có thẩm quyền thông báo trước',
            sla_type_refund_limitation_period: 'Thời hạn không còn được hoàn trả',
            sla_type_reinspection_limitation_period: 'Thời hiệu kiểm tra lại',
            sla_type_violation_classification_threshold: 'Ngưỡng xác định hành vi vi phạm',
            sla_type_write_off_eligibility_threshold: 'Ngưỡng đủ điều kiện xóa nợ',
            // Deadline unit labels
            unit_working_days: 'ngày làm việc',
            unit_calendar_days: 'ngày theo lịch',
            unit_hours: 'giờ',
            // Form category labels
            form_category_dpa: 'Cơ quan BVDL',
            form_category_dsr: 'Yêu cầu quyền chủ thể',
            form_category_consent: 'Đồng ý',
            form_category_privacy: 'Quyền riêng tư',
            form_category_breach: 'Vi phạm dữ liệu',
            form_category_dpia: 'Đánh giá tác động',
            form_category_register: 'Sổ đăng ký',
            form_category_monitoring: 'Giám sát',
            form_category_vendor: 'Nhà cung cấp',
            form_category_org: 'Tổ chức',
            form_category_sector: 'Lĩnh vực',
            form_category_data_mapping: 'Bản đồ dữ liệu',
            form_category_governance: 'Quản trị',
            form_category_incident: 'Sự cố',
            form_category_authority_submission: 'Nộp hồ sơ cơ quan',
            form_category_notice: 'Thông báo',
            form_category_assessment_report: 'Báo cáo đánh giá',
            form_category_request: 'Yêu cầu',
            form_category_dossier: 'Hồ sơ',
            form_category_filing: 'Hồ sơ nộp',
            // Module code labels
            module_consent: 'Đồng ý',
            module_rights_request: 'Yêu cầu quyền',
            module_classification: 'Phân loại',
            module_dpia: 'DPIA',
            module_governance: 'Quản trị',
            module_monitoring: 'Giám sát',
            module_register: 'Sổ đăng ký',
            module_risk: 'Rủi ro',
            module_data_mapping: 'Bản đồ dữ liệu',
            module_incident: 'Sự cố',
            module_assessment: 'Đánh giá',
            module_vendor: 'Nhà cung cấp',
            module_policy: 'Chính sách',
            module_audit: 'Kiểm toán',
            module_training: 'Đào tạo',
            module_discovery: 'Phát hiện',
            // Sprint 62.58.0 (walk O-2) — requirement applicable_module values with no label
            module_sector_licensing: 'Giấy phép ngành',
            module_electronic_transactions: 'Giao dịch điện tử',
            module_consumer_protection: 'Bảo vệ người tiêu dùng',
            module_ecommerce_governance: 'Quản trị thương mại điện tử',
            module_identity_verification: 'Xác minh danh tính',
            module_program_governance: 'Quản trị chương trình',
            module_compliance_operations: 'Vận hành tuân thủ',
            module_vendor_governance: 'Quản trị nhà cung cấp',
            module_cybersecurity: 'An ninh mạng',
            module_authority_direction: 'Yêu cầu của cơ quan có thẩm quyền',
            module_incident_response: 'Ứng phó sự cố',
            module_data_governance: 'Quản trị dữ liệu',
            module_incident_operations: 'Vận hành sự cố',
            module_regulatory_disclosure: 'Công bố thông tin',
            module_customer_protection: 'Bảo vệ khách hàng',
            module_regulatory_change: 'Thay đổi quy định',
            module_third_party_risk: 'Rủi ro bên thứ ba',
            module_legal_register: 'Danh mục văn bản pháp luật',
            module_change_control: 'Kiểm soát thay đổi',
            module_records: 'Hồ sơ',
            // Sprint 47.3.0 — Guidance enum maps + requirement category
            // headers + per-tab Related-Guidance advisories. See
            // FrameworkDetailView.humanizeEnum() for the lookup contract.
            enum_guidance_type_calculation_guidance: 'Hướng dẫn tính toán',
            enum_guidance_type_implementation_guidance: 'Hướng dẫn triển khai',
            enum_guidance_type_interpretive_note: 'Ghi chú diễn giải',
            enum_guidance_type_legal_guidance: 'Hướng dẫn pháp lý',
            enum_guidance_type_procedural_guidance: 'Hướng dẫn thủ tục',
            enum_guidance_type_sector_guidance: 'Hướng dẫn theo lĩnh vực',
            enum_guidance_type_technical_methodology: 'Phương pháp kỹ thuật',
            enum_guidance_category_annual_reporting: 'Báo cáo hằng năm',
            enum_guidance_category_authority_cooperation: 'Hợp tác với cơ quan chức năng',
            enum_guidance_category_authority_coordination: 'Phối hợp với cơ quan chức năng',
            enum_guidance_category_business_continuity: 'Tính liên tục hoạt động',
            enum_guidance_category_capital_adequacy: 'Mức đủ vốn',
            enum_guidance_category_complaint_handling: 'Xử lý khiếu nại',
            enum_guidance_category_consent: 'Đồng thuận',
            enum_guidance_category_consent_management: 'Quản lý đồng thuận',
            enum_guidance_category_consumer_protection: 'Bảo vệ người tiêu dùng',
            enum_guidance_category_control_environment: 'Môi trường kiểm soát',
            enum_guidance_category_cross_border: 'Xuyên biên giới',
            enum_guidance_category_cross_border_transfers: 'Chuyển dữ liệu xuyên biên giới',
            enum_guidance_category_data_classification: 'Phân loại dữ liệu',
            enum_guidance_category_data_localization: 'Lưu trữ dữ liệu trong nước',
            enum_guidance_category_data_protection_impact_assessment: 'Đánh giá tác động bảo vệ dữ liệu',
            enum_guidance_category_direct_marketing: 'Tiếp thị trực tiếp (quy định EU)',
            enum_guidance_category_dpia: 'DPIA',
            enum_guidance_category_governance: 'Quản trị',
            enum_guidance_category_ict_risk_management: 'Quản lý rủi ro CNTT',
            enum_guidance_category_incident_management: 'Quản lý sự cố',
            enum_guidance_category_internal_audit: 'Kiểm toán nội bộ',
            enum_guidance_category_isms_documentation: 'Tài liệu hệ thống ISMS',
            enum_guidance_category_lawful_basis: 'Cơ sở pháp lý',
            enum_guidance_category_licensing: 'Cấp phép',
            enum_guidance_category_local_presence: 'Hiện diện trong nước',
            enum_guidance_category_logging_and_retention: 'Ghi nhật ký và lưu trữ',
            enum_guidance_category_logical_and_physical_access: 'Truy cập logic và vật lý',
            enum_guidance_category_operational_resilience_testing: 'Kiểm thử khả năng phục hồi vận hành',
            enum_guidance_category_outsourcing: 'Thuê ngoài',
            enum_guidance_category_platform_registration: 'Đăng ký nền tảng',
            enum_guidance_category_quality_of_service: 'Chất lượng dịch vụ',
            enum_guidance_category_risk_classification: 'Phân loại rủi ro',
            enum_guidance_category_risk_management: 'Quản lý rủi ro',
            enum_guidance_category_scope_definition: 'Định nghĩa phạm vi',
            enum_guidance_category_sectoral_localisation: 'Lưu trữ theo lĩnh vực',
            enum_guidance_category_subscriber_protection: 'Bảo vệ thuê bao',
            enum_guidance_category_supply_chain: 'Chuỗi cung ứng',
            enum_guidance_category_system_classification: 'Phân loại hệ thống',
            enum_guidance_category_system_operations: 'Vận hành hệ thống',
            enum_guidance_category_telecommunications_data: 'Dữ liệu viễn thông',
            enum_guidance_category_third_party_risk: 'Rủi ro bên thứ ba',
            enum_guidance_category_transitional_provisions: 'Điều khoản chuyển tiếp',
            enum_guidance_category_vulnerability_management: 'Quản lý lỗ hổng',
            enum_guidance_status_active: 'Đang hiệu lực',
            enum_guidance_status_draft: 'Bản dự thảo',
            // Sprint 62.58.0 (walk D-1) — every guidance status a pack declares
            enum_guidance_status_deprecated: 'Ngừng sử dụng',
            enum_guidance_status_superseded: 'Đã được thay thế',
            enum_guidance_status_upcoming: 'Sắp có hiệu lực',
            enum_guidance_status_legacy: 'Cũ',
            enum_guidance_status_temporary_active: 'Có hiệu lực tạm thời',
            enum_guidance_status_active_reference: 'Có hiệu lực, chỉ tham khảo',
            enum_module_access_management: 'Quản lý truy cập',
            enum_module_ai_governance: 'Quản trị AI',
            enum_module_asset_management: 'Quản lý tài sản',
            enum_module_audit_trail: 'Nhật ký kiểm toán',
            enum_module_breach_notification: 'Thông báo vi phạm',
            enum_module_capital_adequacy: 'Mức đủ vốn',
            enum_module_classification: 'Phân loại',
            enum_module_consent: 'Đồng thuận',
            enum_module_consent_management: 'Quản lý đồng thuận',
            enum_module_cross_border_transfers: 'Chuyển dữ liệu xuyên biên giới',
            enum_module_data_localization: 'Lưu trữ dữ liệu trong nước',
            enum_module_data_mapping: 'Lập sơ đồ dữ liệu',
            enum_module_data_protection: 'Bảo vệ dữ liệu',
            enum_module_data_subject_rights: 'Quyền của chủ thể dữ liệu',
            enum_module_dpia: 'DPIA',
            enum_module_encryption: 'Mã hoá',
            enum_module_governance: 'Quản trị',
            enum_module_incident: 'Sự cố',
            enum_module_incident_management: 'Quản lý sự cố',
            enum_module_internal_audit: 'Kiểm toán nội bộ',
            enum_module_isms_documentation: 'Tài liệu ISMS',
            enum_module_isms_governance: 'Quản trị ISMS',
            enum_module_logging_and_monitoring: 'Ghi nhật ký và giám sát',
            enum_module_monitoring: 'Giám sát',
            enum_module_policy_management: 'Quản lý chính sách',
            enum_module_risk: 'Rủi ro',
            enum_module_risk_management: 'Quản lý rủi ro',
            enum_module_training: 'Đào tạo',
            enum_module_vendor: 'Nhà cung cấp',
            enum_module_vendor_management: 'Quản lý nhà cung cấp',
            enum_module_vendor_risk: 'Rủi ro nhà cung cấp',
            enum_module_vulnerability_management: 'Quản lý lỗ hổng',
            // Sprint 62.58.0 (walk O-6, 2026-11-01) — every guidance_type, category and
            // related_modules value in packs/regulatory/**/guidances.json has a label;
            // a hyphenated value is looked up with underscores.
            enum_guidance_type_annex_reference: 'Tham chiếu phụ lục',
            enum_guidance_type_boundary_guidance: 'Hướng dẫn về ranh giới',
            enum_guidance_type_calculation_methodology: 'Phương pháp tính toán',
            enum_guidance_type_classification_guidance: 'Hướng dẫn phân loại',
            enum_guidance_type_cross_framework_mapping: 'Ánh xạ liên khung tuân thủ',
            enum_guidance_type_enforcement_mechanics: 'Cơ chế xử phạt',
            enum_guidance_type_follow_on_instrument_watchlist: 'Danh sách theo dõi văn bản tiếp theo',
            enum_guidance_type_framework_overview: 'Tổng quan khung tuân thủ',
            enum_guidance_type_framework_relationship: 'Quan hệ giữa các khung tuân thủ',
            enum_guidance_type_framework_relationship_note: 'Ghi chú quan hệ giữa các khung tuân thủ',
            enum_guidance_type_handling_guidance: 'Hướng dẫn xử lý',
            enum_guidance_type_implementation_note: 'Ghi chú triển khai',
            enum_guidance_type_implementation_timeline: 'Lộ trình triển khai',
            enum_guidance_type_obligation_map: 'Bản đồ nghĩa vụ',
            enum_guidance_type_official_reference_artifact: 'Tài liệu tham chiếu chính thức',
            enum_guidance_type_operational_boundary: 'Ranh giới vận hành',
            enum_guidance_type_operational_guidance: 'Hướng dẫn vận hành',
            enum_guidance_type_platform_boundary: 'Ranh giới của nền tảng',
            enum_guidance_type_readiness_mapping: 'Ánh xạ mức độ sẵn sàng',
            enum_guidance_type_reference_note: 'Ghi chú tham chiếu',
            enum_guidance_type_regulatory_overview: 'Tổng quan quy định',
            enum_guidance_type_requirement_detail: 'Chi tiết yêu cầu',
            enum_guidance_type_scope_and_applicability: 'Phạm vi và đối tượng áp dụng',
            enum_guidance_type_scope_guidance: 'Hướng dẫn về phạm vi áp dụng',
            enum_module_compliance: 'Tuân thủ',
            enum_guidance_type_source_limitation: 'Giới hạn của văn bản nguồn',
            enum_guidance_type_source_limits: 'Giới hạn của văn bản nguồn',
            enum_guidance_type_source_note: 'Ghi chú nguồn',
            enum_guidance_type_technical_reference: 'Tham chiếu kỹ thuật',
            enum_guidance_type_timeline: 'Lộ trình',
            enum_guidance_type_transition_guidance: 'Hướng dẫn chuyển tiếp',
            enum_guidance_type_transition_note: 'Ghi chú chuyển tiếp',
            enum_guidance_category_access: 'Truy cập',
            enum_guidance_category_account_eligibility: 'Điều kiện được cấp tài khoản',
            enum_guidance_category_account_linkage: 'Liên kết tài khoản',
            enum_guidance_category_ai_functions: 'Chức năng AI',
            enum_guidance_category_amendments: 'Sửa đổi, bổ sung',
            enum_guidance_category_annex: 'Phụ lục',
            enum_guidance_category_assessment: 'Đánh giá',
            enum_guidance_category_audit: 'Kiểm toán',
            enum_guidance_category_authority: 'Thẩm quyền',
            enum_guidance_category_authority_submission: 'Nộp cho cơ quan có thẩm quyền',
            enum_guidance_category_boundary: 'Ranh giới',
            enum_guidance_category_certification: 'Chứng nhận',
            enum_guidance_category_claims: 'Tuyên bố của nền tảng',
            enum_guidance_category_classification: 'Phân loại',
            enum_guidance_category_confidentiality: 'Tính bảo mật',
            enum_guidance_category_connection_procedure: 'Thủ tục kết nối',
            enum_guidance_category_coordination: 'Phối hợp',
            enum_guidance_category_data_disclosure: 'Cung cấp dữ liệu',
            enum_guidance_category_data_lifecycle: 'Vòng đời dữ liệu',
            enum_guidance_category_data_protection_and_security: 'Bảo vệ và bảo mật dữ liệu',
            enum_guidance_category_database_regime: 'Chế độ cơ sở dữ liệu',
            enum_guidance_category_deadlines: 'Thời hạn',
            enum_guidance_category_dispute_support: 'Hỗ trợ giải quyết tranh chấp',
            enum_guidance_category_document_reuse: 'Tái sử dụng tài liệu',
            enum_guidance_category_duty_allocation: 'Phân định nghĩa vụ',
            enum_guidance_category_effective_date: 'Ngày có hiệu lực',
            enum_guidance_category_electronic_enforcement: 'Xử phạt điện tử',
            enum_guidance_category_electronic_submission: 'Nộp hồ sơ điện tử',
            enum_guidance_category_enforcement: 'Xử phạt',
            enum_guidance_category_enforcement_authority: 'Thẩm quyền xử phạt',
            enum_guidance_category_enforcement_measures: 'Biện pháp cưỡng chế',
            enum_guidance_category_evidence: 'Bằng chứng',
            enum_guidance_category_exploitation_duties: 'Nghĩa vụ của chủ thể khai thác',
            enum_guidance_category_forms_and_transition: 'Biểu mẫu và chuyển tiếp',
            enum_guidance_category_framework_map: 'Bản đồ khung tuân thủ',
            enum_guidance_category_framework_mapping: 'Ánh xạ khung tuân thủ',
            enum_guidance_category_framework_relationships: 'Quan hệ giữa các khung tuân thủ',
            enum_guidance_category_handling_measures: 'Biện pháp xử lý',
            enum_guidance_category_identification: 'Định danh',
            enum_guidance_category_identification_code: 'Mã định danh',
            enum_guidance_category_implementation: 'Triển khai',
            enum_guidance_category_incident: 'Sự cố',
            enum_guidance_category_legal_basis: 'Cơ sở pháp lý',
            enum_guidance_category_lifecycle: 'Vòng đời',
            enum_guidance_category_listing: 'Niêm yết',
            enum_guidance_category_mapping: 'Ánh xạ',
            enum_guidance_category_marketing_communications_boundary: 'Ranh giới liên lạc quảng cáo',
            enum_guidance_category_methodology: 'Phương pháp',
            enum_guidance_category_monitoring: 'Giám sát',
            enum_guidance_category_obligations: 'Nghĩa vụ',
            enum_guidance_category_penalties: 'Mức phạt',
            enum_guidance_category_personal_data: 'Dữ liệu cá nhân',
            enum_guidance_category_personal_data_protection: 'Bảo vệ dữ liệu cá nhân',
            enum_guidance_category_phase_in_timeline: 'Lộ trình áp dụng',
            enum_guidance_category_platform_boundary: 'Ranh giới của nền tảng',
            enum_guidance_category_platform_duties: 'Nghĩa vụ của nền tảng số',
            enum_guidance_category_platform_operation: 'Vận hành nền tảng số',
            enum_guidance_category_pricing: 'Định giá',
            enum_guidance_category_privacy: 'Quyền riêng tư',
            enum_guidance_category_procedures: 'Thủ tục',
            enum_guidance_category_product_scope: 'Phạm vi sản phẩm',
            enum_guidance_category_provenance: 'Nguồn gốc',
            enum_guidance_category_public_sector: 'Khu vực công',
            enum_guidance_category_readiness: 'Mức độ sẵn sàng',
            enum_guidance_category_record_keeping: 'Lưu trữ hồ sơ',
            enum_guidance_category_reference_data: 'Dữ liệu tham chiếu',
            enum_guidance_category_regulatory_watch: 'Theo dõi thay đổi quy định',
            enum_guidance_category_related_instruments: 'Văn bản liên quan',
            enum_guidance_category_remediation: 'Khắc phục',
            enum_guidance_category_reporting: 'Báo cáo',
            enum_guidance_category_sanctions: 'Chế tài',
            enum_guidance_category_source: 'Nguồn',
            enum_guidance_category_status: 'Trạng thái',
            enum_guidance_category_system_connection: 'Kết nối hệ thống',
            enum_guidance_category_technical_measures: 'Biện pháp kỹ thuật',
            enum_guidance_category_testing: 'Thử nghiệm',
            enum_guidance_category_timeline: 'Lộ trình',
            enum_guidance_category_transition: 'Chuyển tiếp',
            enum_guidance_category_transitional: 'Quy định chuyển tiếp',
            enum_module_access: 'Truy cập',
            enum_module_access_review: 'Xem xét truy cập',
            enum_module_ai_advisor: 'Cố vấn AI',
            enum_module_assessment: 'Đánh giá',
            enum_module_audit: 'Kiểm toán',
            enum_module_authority_operations: 'Làm việc với cơ quan có thẩm quyền',
            enum_module_authority_direction: 'Yêu cầu của cơ quan có thẩm quyền',
            enum_module_continuity: 'Tính liên tục hoạt động',
            enum_module_deidentification: 'Phi định danh',
            enum_module_deletion_orchestration: 'Điều phối xóa dữ liệu',
            enum_module_identity_verification: 'Xác minh danh tính',
            enum_module_legal_matters: 'Vụ việc pháp lý',
            enum_module_program_governance: 'Quản trị chương trình',
            enum_module_rights_request: 'Yêu cầu quyền',
            enum_module_sector_licensing: 'Giấy phép ngành',
            enum_module_technical_measures: 'Biện pháp kỹ thuật',
            category_access: 'Truy cập',
            category_availability: 'Tính sẵn sàng',
            category_change_management: 'Quản lý thay đổi',
            category_classification: 'Phân loại',
            category_communication_and_information: 'Thông tin và truyền thông',
            category_compliance: 'Tuân thủ',
            category_confidentiality: 'Tính bảo mật',
            category_control_activities: 'Hoạt động kiểm soát',
            category_control_environment: 'Môi trường kiểm soát',
            category_incident: 'Sự cố',
            category_internal_audit: 'Kiểm toán nội bộ',
            category_internal_control: 'Kiểm soát nội bộ',
            category_logical_and_physical_access: 'Truy cập logic và vật lý',
            category_mis_data: 'Hệ thống thông tin quản lý (MIS)',
            category_monitoring: 'Giám sát',
            category_monitoring_activities: 'Hoạt động giám sát',
            category_outsourcing: 'Thuê ngoài',
            category_privacy: 'Quyền riêng tư',
            category_processing_integrity: 'Tính toàn vẹn xử lý',
            category_reporting: 'Báo cáo',
            category_risk_assessment: 'Đánh giá rủi ro',
            category_risk_mitigation: 'Giảm thiểu rủi ro',
            category_sector_applicability: 'Phạm vi áp dụng theo lĩnh vực',
            category_system_operations: 'Vận hành hệ thống',
            category_training: 'Đào tạo',
            category_vendor: 'Nhà cung cấp',
            guidance_related_forms_advisory: 'Một số biểu mẫu có hướng dẫn liên quan — xem trong tab',
            guidance_related_procedures_advisory: 'Một số thủ tục có hướng dẫn liên quan — xem trong tab',
            guidance_related_requirements_advisory: 'Một số yêu cầu có hướng dẫn liên quan — xem trong tab',
        },
        translations_detail: {
            source_locale: 'Ngôn ngữ nguồn',
            target_locale: 'Ngôn ngữ đích',
            locales_must_differ: 'Ngôn ngữ nguồn và đích phải khác nhau.',
            all_keys_translated: 'Tất cả khóa đã dịch',
            keys_missing: '{count} khóa thiếu',
            show_missing_only: 'Chỉ hiện mục thiếu',
            namespace: 'Không gian tên',
            source: 'Nguồn',
            target: 'Đích',
        },
        catalog_detail: {
            packs_installed_of: 'trong {total} gói đã cài đặt',
            install_all: 'Cài đặt tất cả',
            installing: 'Đang cài đặt...',
            removing: 'Đang xóa...',
            install_all_named: 'Cài đặt tất cả gói trong {name}',
            installing_named: 'Đang cài đặt... {name}',
            uninstall_named: 'Gỡ cài đặt {name}',
            removing_named: 'Đang xóa... {name}',
            manage_no_permission: 'Cần có quyền quản lý gói thị trường để cài đặt hoặc gỡ cài đặt gói thị trường.',
            available: 'Có sẵn',
            cluster_installed_count: '(đã cài đặt {installed}/{total})',
            frameworks_count_one: '1 khung tuân thủ',
            frameworks_count: '{count} khung tuân thủ',
            languages_count_one: '1 ngôn ngữ',
            languages_count: '{count} ngôn ngữ',
            forms_count_one: '1 biểu mẫu',
            forms_count: '{count} biểu mẫu',
            artifacts_count_one: '1 tạo phẩm',
            artifacts_count: '{count} tạo phẩm',
            market_packs_count_one: '1 gói thị trường',
            market_packs_count: '{count} gói thị trường',
            install_success: 'Đã cài đặt {market}: {frameworks}, {items}.',
            cluster_install_success: 'Đã cài đặt cụm: {frameworks}, {forms}.',
            uninstall_success: 'Đã gỡ cài đặt {market}: đã xóa {frameworks} và {artifacts}.',
            uninstall_confirm: 'Gỡ cài đặt {market}? Thao tác này xóa mọi khung tuân thủ, tạo phẩm và gói ngôn ngữ của thị trường này.',
            dependents_exist: 'Không thể gỡ cài đặt {market}: các gói đã cài đặt khác phụ thuộc vào gói này.',
            dependencies_required: 'Cần cài đặt {dependencies} trước khi cài đặt {market}.',
            dependencies_required_unnamed: 'Cần cài đặt một gói thị trường khác trước khi cài đặt {market}.',
            requires: 'Yêu cầu',
            tab_catalog: 'Danh mục',
            tab_installed: 'Đã cài đặt',
            details: 'Chi tiết',
        },
        // Sprint 63.33.0 (#594) — standards packs installed on their own.
        standalone_packs: {
            title: 'Tiêu chuẩn',
            description: 'Các tiêu chuẩn quốc tế được cài đặt riêng: không gói thị trường nào bao gồm chúng. Khi cài đặt, khung tuân thủ, yêu cầu và biểu mẫu của tiêu chuẩn được thêm cho tổ chức của bạn.',
            install: 'Cài đặt',
            install_named: 'Cài đặt {name}',
            installing: 'Đang cài đặt…',
            installing_named: 'Đang cài đặt… {name}',
            installed: 'Đã cài đặt',
            installed_other_route: 'Đã cài đặt theo cách khác',
            installed_other_route_hint: 'Khung tuân thủ của tiêu chuẩn này đã có trong tổ chức của bạn nhưng không do tiêu chuẩn này cài đặt, mà do một gói khác hoặc một bản ghi được tạo thủ công. Tại đây không có nội dung nào để gỡ cài đặt.',
            confirm_title: 'Cài đặt {name}?',
            confirm_message: 'Thao tác này cài đặt {name} cho tổ chức của bạn, cùng khung tuân thủ, yêu cầu và biểu mẫu đi kèm.',
            confirm_label: 'Cài đặt',
            install_success: 'Đã cài đặt {name}: {frameworks}, {forms}.',
            install_failed: 'Không thể cài đặt tiêu chuẩn.',
            install_no_permission: 'Cần có quyền chỉnh sửa Khung tuân thủ để cài đặt tiêu chuẩn.',
            remove: 'Gỡ cài đặt',
            remove_named: 'Gỡ cài đặt {name}',
            removing: 'Đang gỡ cài đặt…',
            removing_named: 'Đang gỡ cài đặt… {name}',
            remove_confirm_title: 'Gỡ cài đặt {name}?',
            remove_confirm_message: 'Thao tác này gỡ {name} khỏi tổ chức của bạn, cùng khung tuân thủ, yêu cầu, thời hạn và biểu mẫu mà tiêu chuẩn đã cài đặt, và mọi bản ghi Ánh xạ phân hệ gắn với các khung tuân thủ đó, kể cả ánh xạ do tổ chức của bạn tạo hoặc sửa. Cài lại tiêu chuẩn không khôi phục các ánh xạ đó. Các biểu mẫu tổ chức của bạn đã điền vẫn được giữ lại. Không thể hoàn tác việc gỡ.',
            remove_confirm_label: 'Gỡ cài đặt',
            remove_success: 'Đã gỡ cài đặt {name}: {frameworks}, {forms}.',
            remove_failed: 'Không thể gỡ cài đặt tiêu chuẩn.',
            remove_no_permission: 'Cần có quyền chỉnh sửa Khung tuân thủ để gỡ cài đặt tiêu chuẩn.',
            refusal_already_installed: 'Tiêu chuẩn này đã được cài đặt cho tổ chức của bạn.',
            refusal_not_installable_alone: 'Gói này không được cài đặt riêng tại đây: gói được cài đặt cùng thị trường của gói, hoặc qua Danh mục lớp phủ trong nhóm Lớp phủ ngành.',
            refusal_not_found: 'Tiêu chuẩn này không còn trong danh mục. Hãy tải lại trang.',
            refusal_not_installed: 'Tiêu chuẩn này chưa được cài đặt cho tổ chức của bạn, nên không có nội dung nào để gỡ.',
            refusal_installed_by_another_route: 'Tiêu chuẩn này không cài đặt các khung tuân thủ của mình cho tổ chức của bạn, nên không có nội dung nào để gỡ. Hãy gỡ các khung tuân thủ đó tại nơi đã cài đặt.',
            refusal_forbidden: 'Bạn không có quyền chỉnh sửa khung tuân thủ.',
            refusal_custody: 'Tiêu chuẩn này cài đặt sổ đăng ký hạn chế; muốn cài đặt cần quyền lưu giữ hồ sơ pháp quy.',
        },
        submissions_detail: {
            submission_id: 'ID gửi',
            validation: 'Xác thực',
            reviewers: 'Người đánh giá',
            start_review: 'Bắt đầu đánh giá',
            hide_comments: 'Ẩn bình luận',
            start_review_named: 'Bắt đầu đánh giá {name}',
            approve_submission_named: 'Phê duyệt bản gửi {name}',
            reject_submission_named: 'Từ chối bản gửi {name}',
            comments_named: 'Bình luận của {name}',
            hide_comments_named: 'Ẩn bình luận của {name}',
            review_comments: 'Bình luận đánh giá',
            loading_comments: 'Đang tải bình luận...',
            no_comments: 'Chưa có bình luận nào.',
            add_comment: 'Thêm bình luận',
            reject_submission: 'Từ chối gửi',
            reason_for_rejection: 'Lý do từ chối',
            reviewer_ids: 'ID người đánh giá (phân cách bằng dấu phẩy)',
            submit_new_pack: 'Gửi gói mới',
            pack_type: 'Loại gói',
            market_code: 'Mã thị trường',
            target_locales: 'Các ngôn ngữ đích',
            pack_file: 'Tệp gói',
            pack_format_info: 'Định dạng gói: Gói thị trường nên bao gồm các tệp JSON theo ngôn ngữ với bản dịch namespace/key. Gói ngôn ngữ cần cung cấp bản dịch cho các ngôn ngữ đích được chỉ định. Xem tài liệu để biết chi tiết lược đồ.',
            accepted_formats: 'Định dạng được chấp nhận: .json hoặc .zip. Tệp JSON cần chứa một đối tượng phẳng hoặc theo namespace gồm các cặp khóa-giá trị bản dịch. Tệp ZIP cần chứa một hoặc nhiều tệp JSON theo ngôn ngữ.',
            comma_separated_locales: 'Mã ngôn ngữ phân cách bằng dấu phẩy cho gói ngôn ngữ này',
            confirm_approval: 'Xác nhận phê duyệt',
            approve_message: 'Phê duyệt gửi gói này?',
            submission_label: 'Gửi',
            all_pack_types: 'Tất cả loại gói',
            passed: 'đạt',
            failed_label: 'thất bại',
            market_code_required: 'Mã thị trường là bắt buộc',
            version_required: 'Phiên bản là bắt buộc',
            pack_type_regulatory: 'Quy định',
            framework_code: 'Mã khung tuân thủ',
            jurisdiction_code: 'Mã khu vực pháp lý',
            pack_source: 'Nguồn',
            pack_source_manual: 'Thủ công',
            pack_version: 'Phiên bản gói',
            install_regulatory_pack: 'Cài đặt gói pháp lý',
            regulatory_pack_desc: 'Tải lên gói khung tuân thủ (.zip)',
            framework_required: 'Mã khung tuân thủ là bắt buộc',
            jurisdiction_required: 'Mã vùng tài phán là bắt buộc',
        },
        mappings_form: {
            framework_id: 'ID khung',
            requirement_id: 'ID yêu cầu',
            module_label: 'Phân hệ',
            mapping_type: 'Loại ánh xạ',
            configuration_json: 'Cấu hình (JSON)',
            conflict_resolution: 'Giải quyết xung đột',
            is_override: 'Là ghi đè',
            all_modules: 'Tất cả phân hệ',
            all_mapping_types: 'Tất cả loại ánh xạ',
        },
        market_packs_detail: {
            installed_at: 'Cài đặt lúc',
            pack_details_label: 'Chi tiết gói',
            market_code: 'Mã thị trường',
            supported_locales: 'Ngôn ngữ được hỗ trợ',
            min_platform_version: 'Phiên bản nền tảng tối thiểu',
            pack_information: 'Thông tin gói',
            included_frameworks: 'Khung tuân thủ bao gồm',
            pack_artifacts: 'Tạo phẩm gói',
            no_artifacts: 'Không tìm thấy tạo phẩm cho gói này',
            pack_not_found: 'Không tìm thấy gói',
            pack_contents: 'Nội dung gói',
        },
        // ---------- Sprint 46.2.0 — Sector overlay pattern ----------
        framework_relationships: {
            panel_title: 'Khung tuân thủ liên quan',
            panel_intro: 'Mối quan hệ giữa khung này với các khung khác. Một lớp phủ có thể áp dụng dưới nhiều khung cha cùng lúc; mỗi khung chỉ xuất hiện một lần.',
            outgoing_heading: 'Khung này áp dụng cho',
            permalink_aria: 'Liên kết tới {name} trong danh sách này',
            incoming_heading: 'Áp dụng dưới khung này',
            outgoing_caption: 'Các khung mà khung này trỏ tới',
            incoming_caption: 'Các khung nằm dưới khung này',
            col_framework: 'Khung tuân thủ',
            col_relationship: 'Quan hệ',
            col_scope: 'Nguồn',
            scope_global: 'Từ nội dung gói',
            scope_org: 'Riêng cho tổ chức',
            load_failed: 'Không tải được các khung tuân thủ liên quan',
            relationship_kinds: {
                parent: 'Khung cha',
                applies_to: 'Áp dụng cho',
                cross_reference: 'Tham chiếu chéo',
                supersedes: 'Thay thế',
            },
        },
        sector_overlay: {
            sector_labels: {
                banking: 'Ngân hàng',
                insurance: 'Bảo hiểm',
                healthcare: 'Y tế',
                education: 'Giáo dục',
                ict_critical: 'CNTT-TT trọng yếu',
                telecom: 'Viễn thông',
                energy: 'Năng lượng',
                transport: 'Giao thông vận tải',
                digital_services: 'Dịch vụ số',
                digital_technology_industry: 'Công nghiệp công nghệ số',
                manufacturing: 'Sản xuất',
                public_administration: 'Hành chính công',
                payments: 'Thanh toán',
                publishing: 'Xuất bản',
                crypto_assets: 'Tài sản mã hóa',
                other: 'Khác',
            },
            scope_labels: {
                cross_sector: 'Liên ngành',
                security_overlay: 'Lớp phủ an ninh',
                security_control_overlay: 'Lớp phủ biện pháp bảo mật',
                activity_scope: 'Phạm vi theo hoạt động',
                process_scope: 'Phạm vi theo quy trình',
                consumer_facing_process_scope: 'Quy trình hướng tới người tiêu dùng',
                platform_and_einvoice_process_scope: 'Quy trình nền tảng và hóa đơn điện tử',
                regulatory_overlay: 'Lớp phủ pháp lý',
            },
            sector_label: 'Lĩnh vực',
            direct_scope_label: 'Phạm vi áp dụng trực tiếp',
            chip_direct: 'Áp dụng trực tiếp',
            chip_reference: 'Chỉ tham khảo',
            banner_direct_copy: 'Áp dụng trực tiếp cho tổ chức của bạn. Báo cáo và thời hạn thuộc lĩnh vực này đang hoạt động.',
            banner_reference_copy: 'Chỉ tham khảo — tổ chức của bạn không thuộc lĩnh vực này. Báo cáo và thời hạn thuộc lĩnh vực này không hoạt động.',
            edit_mode_button: 'Chỉnh sửa chế độ',
            edit_form_title: 'Thay đổi chế độ cài đặt',
            mode_direct_label: 'Trực tiếp — áp dụng theo pháp luật',
            mode_direct_help: 'Gói áp dụng cho tổ chức bạn: các thời hạn, sổ và tiện ích bảng điều khiển mà gói khai báo được kích hoạt.',
            mode_reference_label: 'Chỉ tham khảo',
            mode_reference_help: 'Có thể đọc và soạn thảo để tham khảo: các thời hạn, sổ và tiện ích bảng điều khiển mà gói khai báo không được kích hoạt.',
            reason_note_label: 'Lý do (tùy chọn)',
            reason_note_placeholder: 'ví dụ: Mua lại công ty con là ngân hàng',
            cancel: 'Hủy',
            confirm: 'Xác nhận',
            confirming: 'Đang lưu…',
            save: 'Lưu',
            saving: 'Đang lưu…',
            toast_mode_changed: 'Đã cập nhật chế độ của lớp phủ ngành.',
            toast_installed: 'Đã cài đặt lớp phủ ngành.',
            toast_sectors_saved: 'Đã lưu lĩnh vực hoạt động của tổ chức.',
            install_modal_title: 'Cài đặt lớp phủ ngành',
            install_modal_intro: 'Lớp phủ ngành là gói pháp lý tùy chọn áp dụng cho một ngành công nghiệp duy nhất. Hãy chọn cách gói này áp dụng cho tổ chức của bạn.',
            install_modal_footer: 'Bạn có thể thay đổi chế độ cài đặt sau từ trang chi tiết khung tuân thủ.',
            install_button: 'Cài đặt',
            installed_label: 'Đã cài đặt',
            uninstall_button: 'Gỡ cài đặt',
            uninstall_confirm: 'Xác nhận gỡ cài đặt',
            uninstall_cancel: 'Hủy',
            suggested_label: 'Khuyến nghị',
            catalog_page_title: 'Lớp phủ pháp lý tùy chọn',
            catalog_page_intro: 'Các gói pháp lý tùy chọn, không bao giờ được cài đặt tự động. Một số gói giới hạn theo ngành, số khác áp dụng liên ngành hoặc được kích hoạt bởi một hoạt động cụ thể. Chọn Trực tiếp nếu gói áp dụng cho tổ chức của bạn, hoặc Tham khảo để chỉ duyệt — không phát sinh thời hạn, điểm tuân thủ hay quy trình tự động.',
            catalog_empty_title: 'Chưa có lớp phủ tùy chọn',
            catalog_empty_description: 'Các gói lớp phủ pháp lý tùy chọn đã xuất bản sẽ hiển thị ở đây.',
            authority_label: 'Cơ quan ban hành',
            org_sectors_title: 'Lĩnh vực hoạt động',
            org_sectors_intro: 'Chọn lĩnh vực mà tổ chức của bạn hoạt động. Cài đặt này quyết định chế độ cài đặt mặc định (Trực tiếp hoặc Tham khảo) cho lớp phủ ngành. Thay đổi lĩnh vực không ảnh hưởng đến các bản cài đặt hiện tại — bạn cần chuyển từng khung tuân thủ theo cách thủ công từ trang chi tiết khung tuân thủ.',
            widget_title: 'Báo cáo theo lớp phủ ngành sắp đến hạn',
            widget_aria_label: 'Báo cáo theo lớp phủ ngành sắp đến hạn',
            widget_empty: 'Không có thời hạn sắp tới của lớp phủ ngành.',
            audit_event_mode_changed: 'Đã thay đổi chế độ cài đặt lớp phủ ngành',
            audit_event_installed: 'Đã cài đặt lớp phủ ngành',
            view_details_button: 'Xem chi tiết →',
            banner_aria_label: 'Trạng thái lớp phủ ngành',
            toast_load_failed: 'Không tải được danh sách lớp phủ tùy chọn',
            toast_install_failed: 'Không cài đặt được lớp phủ ngành',
            toast_uninstall_confirm_required: 'Nhập "{packCode}" để xác nhận gỡ cài đặt.',
            toast_uninstalled: 'Đã gỡ cài đặt {packCode}.',
            toast_uninstall_failed: 'Không gỡ cài đặt được lớp phủ ngành',
            uninstall_warning_destructive_label: 'Thao tác phá huỷ.',
            uninstall_warning_body: 'Gỡ cài đặt sẽ xoá bản ghi khung tuân thủ cùng mọi thời hạn pháp lý đã lưu gắn với {frameworkCode} của tổ chức này.',
            uninstall_warning_type_to_confirm: 'Nhập {packCode} để xác nhận.',
            uninstall_in_progress: 'Đang gỡ cài đặt…',
            widget_view_all: 'Xem tất cả lớp phủ ngành →',
            widget_due_in_days: 'Còn {days} ngày',
            widget_overdue_days: 'Quá hạn {days} ngày',
            widget_due_today: 'Đến hạn hôm nay',
            widget_due_unknown: '—',
            // Catalog overview, filters and feature-views modal
            catalog_summary_total: 'Tổng số lớp phủ',
            catalog_summary_installed: 'Đã cài đặt',
            catalog_summary_direct: 'Trực tiếp',
            catalog_summary_reference: 'Chỉ tham khảo',
            catalog_summary_available: 'Chưa cài đặt',
            filter_toolbar_label: 'Lọc danh mục lớp phủ',
            filter_search_label: 'Tìm lớp phủ',
            filter_search_placeholder: 'Tìm theo tên, mã hoặc cơ quan ban hành',
            filter_sector_all: 'Tất cả lĩnh vực và phạm vi',
            filter_status_all: 'Tất cả trạng thái',
            filter_status_installed: 'Đã cài đặt',
            filter_status_not_installed: 'Chưa cài đặt',
            filter_mode_label: 'Chế độ cài đặt',
            filter_mode_all: 'Tất cả chế độ',
            filter_clear: 'Xóa bộ lọc',
            filter_results: 'Hiển thị {shown}/{total} lớp phủ',
            filter_no_match_title: 'Không có lớp phủ nào khớp với bộ lọc',
            filter_no_match_description: 'Thay đổi hoặc xóa bộ lọc để xem thêm danh mục.',
            col_overlay: 'Lớp phủ',
            col_scope: 'Lĩnh vực hoặc phạm vi',
            col_mode: 'Chế độ',
            col_authority: 'Cơ quan ban hành',
            col_dates: 'Ngày',
            col_version: 'Phiên bản',
            col_status: 'Trạng thái',
            col_views: 'Màn hình chức năng',
            col_actions: 'Thao tác',
            date_effective: 'Hiệu lực',
            date_issued: 'Ngày ban hành',
            date_released: 'Phát hành',
            desc_expand: 'Xem mô tả',
            desc_collapse: 'Ẩn mô tả',
            status_not_installed: 'Chưa cài đặt',
            views_none: 'Không có',
            views_none_title: 'Lớp phủ này không khai báo nội dung nào mà một màn hình riêng đọc.',
            views_button: '{enabled}/{total} đang bật',
            views_button_aria: 'Xem các màn hình chức năng mà {name} đưa vào sử dụng ({enabled}/{total} đang bật)',
            views_modal_title: 'Màn hình chức năng của {name}',
            views_modal_intro: 'Các sổ đăng ký và trang đọc những gì gói của lớp phủ này khai báo. Một màn hình được bật khi lớp phủ được cài đặt ở chế độ Trực tiếp và phân hệ chứa màn hình đó đang bật.',
            views_col_view: 'Màn hình',
            views_col_menu: 'Vị trí trong menu',
            views_col_state: 'Trạng thái',
            views_open: 'Mở',
            views_state_enabled: 'Đã bật',
            views_state_reference: 'Chỉ tham khảo — không hiển thị gì cho đến khi cài đặt ở chế độ Trực tiếp',
            views_state_not_installed: 'Chưa bật — lớp phủ chưa được cài đặt',
            views_state_module_off: 'Chưa bật — phân hệ đang tắt',
            views_no_access: 'Vai trò của bạn không mở được màn hình này',
            views_module_state_unconfirmed: 'Không đọc được cấu hình phân hệ nên không hiển thị được phân hệ nào đang tắt.',
            views_unclaimed_heading: 'Được khai báo nhưng không có màn hình riêng',
            views_unclaimed_description: 'Gói này còn khai báo các loại bản ghi sau, nhưng không có màn hình riêng nào đọc chúng cho lớp phủ này: {kinds}.',
            declared_kind_labels: {
                biometric_technical_regulation_commencement: 'Bắt đầu áp dụng quy chuẩn kỹ thuật quốc gia về sinh trắc học giọng nói, mống mắt',
                chemical_traceability_code_termination: 'Chấm dứt mã truy xuất nguồn gốc hóa chất',
                chemical_traceability_commencement: 'Bắt đầu truy xuất nguồn gốc hóa chất',
                chemical_traceability_incident_declaration: 'Khai báo sự cố truy xuất nguồn gốc hóa chất',
                consumer_complaint_receipt_acknowledgement: 'Thông báo cho người tiêu dùng về việc tiếp nhận phản ánh, yêu cầu, khiếu nại',
                cybersecurity_fee_schedule_commencement: 'Bắt đầu áp dụng mức thu phí, lệ phí trong lĩnh vực an ninh mạng',
                food_database_traceability_commencement: 'Bắt đầu truy xuất nguồn gốc trên cơ sở dữ liệu thực phẩm',
                food_traceability_connection_start: 'Bắt đầu kết nối truy xuất nguồn gốc thực phẩm',
                food_traceability_records_request: 'Yêu cầu cung cấp hồ sơ truy xuất nguồn gốc thực phẩm',
                food_traceability_system_update: 'Cập nhật hệ thống truy xuất nguồn gốc thực phẩm',
            },
            views_declared_only: 'Không có màn hình riêng',
            views_declared_only_aria: 'Xem nội dung {name} khai báo nhưng không có màn hình riêng',
            views_basis_records: 'Đọc các bản ghi mà gói khai báo',
            views_basis_regime: 'Đọc chế độ mà gói khai báo',
            views_basis_fine_areas: 'Dùng các nhóm hành vi mà gói khai báo',
            views_open_framework: 'Mở trang Khung tuân thủ',
            views_independent_note: 'Các màn hình hoạt động như nhau dù có hay không có lớp phủ, ví dụ Lệnh phong tỏa pháp lý, không được liệt kê.',
            menu_payments_evidence: 'Bằng chứng thanh toán và eKYC',
            menu_trust_evidence: 'Bằng chứng danh tính và dịch vụ tin cậy',
            menu_platform_evidence: 'Bằng chứng nền tảng',
            menu_public_data: 'Trao đổi dữ liệu công',
            menu_product_compliance: 'Tuân thủ sản phẩm và truy xuất nguồn gốc',
            menu_producer_substance: 'Nghĩa vụ nhà sản xuất và hóa chất',
            menu_trade_customs: 'Bằng chứng thương mại và hải quan',
            menu_parcel_delivery: 'Bằng chứng bưu gửi và giao hàng',
            view_labels: {
                controlled_testing_cases: 'Hồ sơ thử nghiệm có kiểm soát',
                credit_information_supply: 'Sổ cung cấp thông tin tín dụng',
                authority_directions: 'Yêu cầu của cơ quan có thẩm quyền',
                regulated_accounts: 'Tài khoản chịu quản lý',
                sector_licences: 'Giấy phép ngành',
                licence_applications: 'Hồ sơ đề nghị cấp phép và phí, lệ phí',
                fee_lines_by_period: 'Các khoản phí, lệ phí theo kỳ',
                data_service_providers: 'Hồ sơ nhà cung cấp dịch vụ dữ liệu',
                pcf_shared_information: 'Thông tin, báo cáo được chia sẻ',
                pcf_branch_publicity: 'Thông báo, công khai theo yêu cầu của chi nhánh',
                pcf_branch_information_requests: 'Yêu cầu cung cấp thông tin của chi nhánh',
                pcf_depositor_enquiries: 'Câu hỏi của khách hàng gửi tiền',
                pcf_supervision_system_records: 'Hồ sơ Hệ thống thông tin giám sát',
                data_exploitation_routes: 'Cơ chế khai thác',
                data_exploitation_requests: 'Yêu cầu và kết quả giải quyết',
                data_exploitation_testing: 'Bản ghi thử nghiệm có kiểm soát',
                data_exploitation_notices: 'Thông báo sự cố, vi phạm',
                data_exploitation_dispositions: 'Hoàn trả, xóa, tiêu hủy dữ liệu',
                data_exploitation_incubator: 'Ươm tạo dữ liệu',
                data_exploitation_foreign_cooperation: 'Đánh giá rủi ro hợp tác với bên nước ngoài',
                cybersecurity_assurance_index_periods: 'Kỳ đánh giá',
                cybersecurity_assurance_index_statistics: 'Số liệu phục vụ chỉ đạo, điều hành',
                cybersecurity_assurance_index_supplier_requests: 'Yêu cầu nhà cung cấp cung cấp tài liệu chứng minh',
                food_traceability_establishment: 'Hồ sơ cơ sở thực phẩm',
                food_traceability_lot_results: 'Kết quả kiểm nghiệm theo lô',
                food_traceability_inspections: 'Kiểm tra an toàn thực phẩm',
                food_traceability_warnings: 'Cảnh báo thực phẩm',
                food_traceability_notices: 'Thông báo và số lượng',
                food_traceability_decisions: 'Quyết định xử lý vi phạm',
                food_traceability_corrections: 'Hiệu chỉnh dữ liệu và hiệu chỉnh của nhà cung cấp',
                food_traceability_complaints: 'Khiếu nại về thực phẩm',
                food_traceability_routes: 'Tuyến kết nối dữ liệu',
                biometric_capture_components: 'Thành phần thu nhận sinh trắc học',
                biometric_chain_of_custody: 'Hồ sơ chuỗi lưu giữ dữ liệu sinh trắc học',
                biometric_readiness: 'Rà soát mức độ sẵn sàng về sinh trắc học',
                biometric_supervision_records: 'Hồ sơ hướng dẫn, theo dõi và kiểm tra về sinh trắc học',
                product_classifications: 'Phân loại sản phẩm',
                conformity_certificates: 'Giấy chứng nhận hợp quy',
                student_records: 'Học bạ số',
                publications: 'Xuất bản phẩm',
                publication_assessments: 'Đánh giá xuất bản phẩm',
                regulatory_placeholders: 'Nội dung dự liệu theo quy định',
                supervisory_reporting: 'Báo cáo giám sát',
                aml_programme: 'Chương trình phòng, chống rửa tiền',
                aml_cases: 'Vụ việc giao dịch đáng ngờ',
                identity_exchanges: 'Trao đổi định danh xuyên biên giới',
                marketing_approvals: 'Phê duyệt tiếp thị',
                investor_verifications: 'Xác minh nhà đầu tư',
                account_data_disclosures: 'Cung cấp dữ liệu tài khoản',
                regulatory_disclosures: 'Công bố thông tin',
                legal_representatives: 'Người đại diện theo pháp luật',
                penalty_readiness: 'Mức độ sẵn sàng trước chế tài',
                exposure_inputs: 'Dữ kiện tính mức phạt',
                enforcement_register: 'Sổ theo dõi chế tài',
                enforcement_cases: 'Vụ việc xử phạt',
                identity_register: 'Sổ đăng ký danh tính',
                trust_providers: 'Tổ chức cung cấp dịch vụ tin cậy',
                electronic_submissions: 'Hồ sơ nộp điện tử',
                electronic_agreements: 'Thỏa thuận điện tử',
                payment_services: 'Dịch vụ thanh toán',
                ekyc_evidence: 'Bằng chứng eKYC',
                exception_review: 'Rà soát ngoại lệ',
                retention_reconciliation: 'Đối chiếu nghĩa vụ lưu trữ',
                seller_register: 'Sổ đăng ký người bán',
                transaction_reconciliation: 'Đối soát giao dịch',
                authority_correspondence: 'Trao đổi với cơ quan có thẩm quyền',
                dataset_catalog: 'Danh mục tập dữ liệu',
                sharing_register: 'Sổ đăng ký chia sẻ',
                open_data_releases: 'Công bố dữ liệu mở',
                product_register: 'Sổ đăng ký sản phẩm',
                batch_register: 'Sổ đăng ký lô và số sê-ri',
                trace_timeline: 'Dòng thời gian truy xuất',
                conformity_evidence: 'Bằng chứng hợp quy',
                epr_reconciliation: 'Đối chiếu EPR',
                chemical_register: 'Sổ đăng ký hóa chất',
                chemical_traceability_declarations: 'Kê khai truy xuất nguồn gốc hóa chất',
                customs_evidence: 'Bằng chứng hải quan',
                customs_tax_dossiers: 'Hồ sơ thuế và văn bản nhận được từ cơ quan hải quan',
                customs_tax_payments: 'Nộp thuế và thời hạn nộp thuế',
                customs_tax_duty_free_lists: 'Danh mục miễn thuế và thông báo tình hình sử dụng hàng hóa miễn thuế',
                customs_tax_examinations: 'Kiểm tra thuế',
                customs_tax_transition: 'Chuyển tiếp và quy định áp dụng',
                parcel_claims: 'Khiếu nại',
                postal_authorisations: 'Giấy phép và thông báo hoạt động bưu chính',
            },
        },
        // ---------- Sprint 46.3.0 — Phased deadline engine ----------
        phased_obligations: {
            panel_title: 'Nghĩa vụ áp dụng theo lộ trình',
            panel_aria_label: 'Nghĩa vụ áp dụng theo lộ trình',
            panel_intro: 'Một số điều khoản của khung tuân thủ này có hiệu lực muộn hơn ngày hiệu lực chung. Theo dõi trạng thái kích hoạt và ghi nhận việc áp dụng sớm tại đây.',
            phased_effective_date_label: 'Ngày hiệu lực theo lộ trình:',
            status_pending: 'Chờ kích hoạt',
            status_active: 'Đang áp dụng',
            status_early: 'Đang áp dụng (áp dụng sớm)',
            notice_window_label: 'Thời hạn thông báo cơ quan:',
            days_label: 'ngày',
            recipient_label: 'Đơn vị nhận:',
            early_implement_button: 'Ghi nhận áp dụng sớm',
            early_implement_closed: 'Chỉ ghi nhận được việc áp dụng sớm trước ngày hiệu lực theo lộ trình, {date}.',
            effective_at_before_hint: 'Chọn ngày trước ngày hiệu lực theo lộ trình, {date}.',
            effective_at_too_late: 'Ngày phải trước ngày hiệu lực theo lộ trình, {date}.',
            early_implement_modal_title: 'Ghi nhận nghĩa vụ áp dụng sớm',
            early_implement_modal_intro: 'Việc ghi nhận áp dụng sớm lưu ngày tổ chức của bạn bắt đầu thực hiện nghĩa vụ này. Sau đó, bảng này hiển thị nghĩa vụ là đang áp dụng từ ngày đó và hiển thị hạn gửi thông báo, tính từ ngày đã ghi nhận. Nền tảng không gửi thông báo và không lưu hồ sơ về việc đã gửi.',
            effective_at_label: 'Có hiệu lực từ',
            reason_label: 'Lý do (tùy chọn)',
            reason_placeholder: 'ví dụ: Hội đồng quản trị phê duyệt áp dụng sớm 01/09/2026',
            confirm: 'Xác nhận',
            toast_early_implemented: 'Đã ghi nhận việc áp dụng sớm.',
            early_read_failed: 'Không đọc được các ghi nhận áp dụng sớm của Khung tuân thủ này. Cho đến khi đọc được, trạng thái của từng nghĩa vụ không được hiển thị và không thể ghi nhận áp dụng sớm.',
            early_read_subject: 'các ghi nhận áp dụng sớm',
            audit_event_early_implemented: 'Đã ghi nhận nghĩa vụ áp dụng sớm',
            widget_rolling_window_label: 'Kích hoạt theo lộ trình trong 90 ngày',
            notice_due_label: 'Hạn gửi thông báo: hết ngày',
            notice_due_time_suffix: '(theo giờ của tổ chức)',
            notice_rolled_note: 'Ngày cuối cùng trùng ngày nghỉ cuối tuần hoặc ngày nghỉ lễ nên được chuyển sang ngày làm việc tiếp theo.',
            notice_platform_sends_nothing: 'Nền tảng không gửi thông báo và không lưu hồ sơ về việc đã gửi.',
            notice_basis: {
                day_after_is_day_one_last_day_rolls_past_non_working_day: 'Cách tính: ngày tiếp theo ngày thực hiện là ngày thứ nhất; ngày cuối cùng trùng ngày nghỉ cuối tuần hoặc ngày nghỉ lễ thì chuyển sang ngày làm việc tiếp theo.',
                day_after_is_day_one: 'Cách tính: ngày tiếp theo ngày thực hiện là ngày thứ nhất.',
            },
            notice_gap: {
                no_notice_clock_declared: 'Chưa có hạn gửi thông báo: không bản ghi đã cài đặt nào nêu thời hạn thông báo.',
                notice_clock_ambiguous: 'Chưa có hạn gửi thông báo: có nhiều bản ghi đã cài đặt nêu thời hạn thông báo, và không bản ghi nào cho biết bản ghi nào áp dụng.',
                notice_clock_not_computable: 'Chưa có hạn gửi thông báo: nền tảng không tính thời hạn mà bản ghi đã cài đặt nêu.',
                implemented_on_unreadable: 'Chưa có hạn gửi thông báo: không đọc được ngày đã ghi nhận.',
                notice_clock_not_in_force: 'Chưa có hạn gửi thông báo: khung tuân thủ chưa có hiệu lực vào ngày thông báo đến hạn.',
                framework_installed_for_reference: 'Chưa có hạn gửi thông báo: khung tuân thủ chỉ được cài đặt để tham chiếu nên các thời hạn của khung tuân thủ không được tính.',
                notice_clock_activation_unknown: 'Chưa có hạn gửi thông báo: chưa xác định được thời hạn có áp dụng hay không, vì bản ghi khung tuân thủ không nêu ngày hoặc không đọc được.',
                implemented_on_not_before_phased_date: 'Không có hạn gửi thông báo: ngày đã ghi nhận trùng hoặc sau ngày hiệu lực theo lộ trình, nên nghĩa vụ áp dụng từ ngày đó và không phải là áp dụng sớm.',
            },
        },
        deadline_activation: {
            token_live: 'Đang có hiệu lực',
            token_upcoming: 'Chưa có hiệu lực',
            in_force_from: 'Có hiệu lực từ {date}',
            start_date_not_stated: 'Chưa nêu ngày bắt đầu có hiệu lực',
            token_unknown: 'Chưa xác định thời điểm áp dụng',
            unknown_sentence: 'Không đọc được hồ sơ khung tuân thủ chứa thời hạn này, nên chưa xác định được thời hạn này đã áp dụng hay chưa.',
            retry: 'Thử lại',
            retry_busy: 'Đang thử lại…',
            // Gate E12.5 pass 1 (P2-3) — the framework record was read and states no date.
            token_phase_unresolved: 'Chưa xác định ngày bắt đầu giai đoạn',
            phase_unresolved_sentence: 'Thời hạn này áp dụng từ một giai đoạn mà khung tuân thủ không nêu ngày, nên thời hạn này không được coi là đang có hiệu lực.',
            token_not_stated: 'Chưa nêu ngày có hiệu lực',
            not_stated_sentence: 'Khung tuân thủ không nêu ngày bắt đầu áp dụng thời hạn này, nên thời hạn này không được coi là đang có hiệu lực.',
            retry_subject: 'các thời hạn theo quy định',
            column_heading: 'Thời điểm áp dụng',
            widget_overlays_failed: 'Không đọc được danh sách lớp phủ ngành đã cài đặt.',
            widget_reads_failed: 'Không đọc được thời hạn của {count} lớp phủ ngành.',
            widget_retry_subject: 'các thời hạn của lớp phủ ngành',
            settings_sources_label: 'Các thời hạn làm căn cứ cho đề xuất này',
            settings_upcoming_not_counted: 'Chưa được dùng cho đề xuất cho đến khi có hiệu lực.',
            settings_unknown_not_counted: 'Không được dùng cho đề xuất.',
            settings_not_calendar_days_not_counted: 'Không được dùng cho đề xuất: thời hạn của bản ghi này không tính theo ngày lịch.',
            settings_retry_subject: 'các thời hạn của khung tuân thủ',
            channels_retry_subject: 'các kênh gửi và hạn chót',
            // Sprint 62.49.1 (DB-2, DB-4) — dòng không phát sinh nghĩa vụ (`duty_not_owed`).
            token_not_owed: 'Không phát sinh nghĩa vụ',
            not_owed_framework_status: 'Khung tuân thủ không có hiệu lực.',
            not_owed_row_suspended: 'Nghĩa vụ này đang tạm ngừng áp dụng.',
            not_owed_superseded_by: 'Đã được thay thế bởi {framework}.',
            not_owed_superseded_unnamed: 'Đã được thay thế bởi một khung tuân thủ khác.',
            not_owed_row_legacy: 'Quy định cũ — không còn hiệu lực.',
            not_owed_unrecognised: 'Hồ sơ ghi nhận không phát sinh nghĩa vụ này.',
            settings_not_owed_not_counted: 'Không được dùng cho đề xuất: không phát sinh nghĩa vụ này.',
        },
        // Sprint 62.58.0 (Slice C) — tóm tắt khung tuân thủ và ghi nhận phổ biến thông tin, góp ý.
        framework_briefings: viFrameworkBriefings,
        // Sprint 62.58.0 (Slice F) — so sánh cập nhật quy định và rà soát bản so sánh.
        update_comparison: viRegulatoryUpdateComparison,
        // Sprint 62.49.1 (DB-2) — mục Tạm ngừng áp dụng trên trang chi tiết Khung tuân thủ.
        framework_suspension: {
            heading: 'Tạm ngừng áp dụng',
            intro: 'Theo nội dung hồ sơ: thời điểm bắt đầu tạm ngừng áp dụng khung tuân thủ này, từng văn bản quy định việc tạm ngừng và thời điểm hoặc sự kiện chấm dứt việc tạm ngừng.',
            start_label: 'Bắt đầu',
            start_value: 'Tạm ngừng áp dụng từ ngày {date}',
            basis_label: 'Căn cứ xác định ngày này',
            steps_caption: 'Các văn bản tạm ngừng áp dụng khung tuân thủ này, theo thứ tự có hiệu lực',
            col_instrument: 'Văn bản',
            col_issued: 'Ngày ban hành',
            col_effective: 'Ngày có hiệu lực',
            col_until: 'Tạm ngừng đến',
            col_replaces: 'Thay thế',
            replaces_none: 'Không có',
            until_date: 'Đến ngày {date}',
            source_line: 'Căn cứ: {source}',
            end_label: 'Kết thúc',
            end_date: 'Vào ngày {date}',
            end_event: 'Khi xảy ra sự kiện: {event}',
            event_not_occurred: 'Chưa xảy ra',
            event_occurred_on: 'Đã xảy ra ngày {date}',
        },
        // fix-sprint-20260719-0024-followup — HelpContentPacksPage
        help_content_packs: {
            page_title: 'Gói nội dung trợ giúp',
            permission_denied: 'Bạn không có quyền quản lý các gói nội dung trợ giúp.',
            page_description: 'Quản lý bộ bài viết trung tâm trợ giúp đi kèm nền tảng. Cài đặt lại sau khi chỉnh sửa các bài viết trong packs/help-content/articles/, hoặc gỡ cài đặt để loại bỏ trợ giúp trong sản phẩm cho tổ chức này.',
            tabs_aria_label: 'Gói nội dung trợ giúp',
            tab_installed: 'Đã cài đặt ({count})',
            tab_catalog: 'Danh mục ({count})',
            upgrade_available_badge: 'Có bản nâng cấp: v{version} trên đĩa',
            reinstall: 'Cài đặt lại',
            reinstalling: 'Đang cài đặt lại…',
            uninstall: 'Gỡ cài đặt',
            uninstalling: 'Đang gỡ cài đặt…',
            confirm_uninstall: 'Xác nhận gỡ cài đặt',
            cancel: 'Hủy',
            installed: 'Đã cài đặt (v{version})',
            install: 'Cài đặt',
            installing: 'Đang cài đặt…',
            meta_articles: 'Bài viết',
            meta_locale_coverage: 'Ngôn ngữ bao phủ',
            meta_locale_none: '(không có)',
            meta_installed: 'Đã cài đặt',
            meta_source: 'Nguồn',
            empty_installed: 'Chưa có gói nội dung trợ giúp nào được cài đặt. Mở tab Danh mục để cài gói help-center-core chính thức.',
            empty_catalog: 'Không tìm thấy gói nội dung trợ giúp trên đĩa. Gói chính thức phải nằm ở packs/help-content/.',
            destructive_intro: 'Hành động phá hủy. Việc gỡ cài đặt sẽ xóa toàn bộ {count} bài viết trợ giúp được gắn nhãn {pack_code} khỏi tổ chức này. Khách hàng sẽ mất trợ giúp trong sản phẩm cho đến khi bạn cài đặt lại. Nhập {pack_code} để xác nhận.',
            toast_reinstall_success: 'Đã cài đặt lại gói nội dung trợ giúp — cập nhật {installed} bài viết, dọn dẹp {orphaned} bài mồ côi.',
            toast_uninstall_success: 'Đã gỡ cài đặt {pack_code} — đã xóa {deleted} bài viết.',
            toast_reinstall_error: 'Cài đặt lại thất bại',
            toast_uninstall_error: 'Gỡ cài đặt thất bại',
            toast_load_error: 'Không thể tải các gói nội dung trợ giúp',
            toast_confirm_required: 'Nhập "{pack_code}" để xác nhận gỡ cài đặt.',
            announce_reinstalled: 'Đã cài đặt lại gói nội dung trợ giúp',
            announce_uninstalled: 'Đã gỡ cài đặt gói nội dung trợ giúp {pack_code}',
        },
        market_pack_installed: 'Đã cài đặt gói thị trường',
        missing_market_code: 'Không thể gỡ cài đặt: thiếu mã thị trường',
        pack_installed_announce: 'Đã cài đặt gói thành công',
        install_zip_refused_title: 'Tệp gói tải lên không được cài đặt',
        install_zip_refused_body: 'Tệp .zip của gói tải lên phải được ký, và bản cài đặt này chưa cấu hình khóa ký gói, nên mọi tệp zip tải lên đều bị từ chối. Các gói đi kèm bản phát hành được cài đặt từ phần Bản địa hóa (Gói thị trường, Gói ngôn ngữ và Danh mục lớp phủ), và mỗi gói được kiểm tra với bản phát hành trước khi cài đặt.',
        pack_uninstalled: 'Đã gỡ cài đặt gói ngôn ngữ',
    },
    partner_marketplace: {
        /**
         * fix-sprint-20260828-2118 F20 — promoted out of
         * `pages/admin/partner-marketplace/strings.ts`.
         *
         * That file is an inline `{ en, vi }` pair resolved by `extractLocale`, so
         * the 14 non-EN/VI locales received the English sentence at all 25 of this
         * module's call sites — on pages whose every other string comes from `t.*`.
         * The wording is 62.5.0's, unchanged.
         */
        selector_truncated: 'Đang hiển thị {shown} trong tổng số {total}. Hãy thu hẹp tìm kiếm để xem phần còn lại.',
        nav: {
            dashboard: 'Tổng quan',
            partner_orgs: 'Tổ chức đối tác',
            service_tiers: 'Cấp dịch vụ',
            deliverable_templates: 'Mẫu sản phẩm',
            deliverables: 'Sản phẩm',
            brand_profiles: 'Hồ sơ thương hiệu',
            support_tickets: 'Phiếu hỗ trợ',
            workflow_templates: 'Mẫu quy trình',
            workflows: 'Quy trình',
            escalation: 'Leo thang',
            reports: 'Báo cáo',
            audit: 'Nhật ký',
        },
        dashboard: {
            title: 'Tổng quan Đối tác',
            loading: 'Đang tải dữ liệu...',
            total_managed_tenants: 'Tổng Thuê bao Quản lý',
            avg_health_score: 'Điểm Sức khỏe TB',
            programme_health_score: 'Sức khỏe Chương trình Đối tác',
            health_band_green: 'Tốt',
            health_band_amber: 'Cần chú ý',
            health_band_red: 'Nghiêm trọng',
            health_coverage_note: 'Được chấm từ chính hoạt động đối tác của bạn: phiếu hỗ trợ đang mở, thời gian xử lý so với mục tiêu, tiến độ sản phẩm bàn giao và các trường hợp chuyển cấp. Điểm này không bao gồm mức độ tuân thủ hay độ mới của dữ liệu ở các tổ chức bạn quản lý.',
            open_tickets: 'Phiếu Mở',
            upcoming_deliverables: 'Sản phẩm Sắp tới',
            escalated_tickets: 'Phiếu Leo thang',
            managed_tenants: 'Thuê bao Quản lý',
            partner_tier: 'Cấp Đối tác',
            managed_tenants_count: 'Số Thuê bao Quản lý',
            onboarding_date: 'Ngày Tiếp nhận',
            view_details: 'Xem Chi tiết',
            no_partner_orgs: 'Không tìm thấy tổ chức đối tác.',
        },
        partner_orgs: {
            title: 'Tổ chức Đối tác',
            new: 'Tổ chức Đối tác mới',
            contact_name: 'Tên Liên hệ',
            contact_email: 'Email Liên hệ',
            partner_tier: 'Cấp Đối tác',
            managed_orgs: 'Tổ chức Quản lý',
            onboarding_date: 'Ngày Tiếp nhận',
            no_orgs: 'Không tìm thấy tổ chức đối tác.',
            partner_type: 'Loại Đối tác',
            type_consulting: 'Tư vấn',
            type_technology: 'Nhà cung cấp Công nghệ',
            type_legal: 'Pháp lý',
            type_audit: 'Kiểm toán & Đảm bảo',
            type_managed_services: 'Nhà cung cấp Dịch vụ Quản lý',
            type_reseller: 'Nhà phân phối',
            contact_phone: 'Điện thoại liên hệ',
            metadata_json: 'Siêu dữ liệu (JSON)',
            change_status: 'Đổi trạng thái',
            new_status: 'Trạng thái mới',
            invalid_json_metadata: 'JSON không hợp lệ trong trường siêu dữ liệu',
            suspended: 'Tạm ngừng',
            offboarded: 'Đã rời khỏi',
            all_tiers: 'Tất cả cấp',
            silver: 'Bạc',
            gold: 'Vàng',
            platinum: 'Bạch kim',
            status_offboarded: 'Đã rời khỏi',
            status_suspended: 'Tạm ngừng',
            tier_gold: 'Vàng',
            tier_platinum: 'Bạch kim',
            tier_silver: 'Bạc',
            org_status_updated: 'Đã cập nhật trạng thái tổ chức',
        },
        service_tiers: {
            title: 'Cấp Dịch vụ',
            new: 'Cấp mới',
            tier_name: 'Tên Cấp',
            monthly_fee: 'Phí Hàng tháng',
            features: 'Tính năng',
            no_tiers: 'Không tìm thấy cấp dịch vụ.',
            tier_code: 'Mã cấp',
            response_time_hrs: 'Thời gian phản hồi (giờ)',
            resolution_time_hrs: 'Thời gian giải quyết (giờ)',
            review_frequency: 'Tần suất đánh giá',
            sla_response_time: 'Thời gian phản hồi SLA (giờ)',
            sla_resolution_time: 'Thời gian giải quyết SLA (giờ)',
            module_profile: 'Phân hệ bao gồm',
            module_profile_hint: 'Các phân hệ mà cấp dịch vụ này bao gồm. Chỉ mang tính mô tả — ghi nhận phạm vi bán của cấp dịch vụ, không cấp hoặc hạn chế quyền truy cập.',
            module_profile_selected: 'Đã chọn {count} trên {total}',
            module_profile_select_all: 'Chọn tất cả',
            module_profile_clear_all: 'Bỏ chọn tất cả',
            module_profile_unknown: 'Không xác định — giữ lại từ phiên bản trước của cấp dịch vụ này',
            comparing: 'Đang so sánh...',
            compare: 'So sánh',
            comparison: 'So sánh cấp dịch vụ',
            attribute: 'Thuộc tính',
            deprecate: 'Ngừng sử dụng',
            deprecated: 'Đã ngừng sử dụng',
            select_compare: 'Chọn ít nhất 2 cấp để so sánh',
            comparison_title: 'So sánh gói dịch vụ',
            status_deprecated: 'Ngừng sử dụng',
            activate: 'Kích hoạt',
            resolution_time: 'Thời gian giải quyết',
            response_time: 'Thời gian phản hồi',
            select_at_least_two: 'Chọn ít nhất 2 cấp',
        },
        deliverable_templates: {
            title: 'Mẫu Sản phẩm',
            new: 'Mẫu mới',
            template_name: 'Tên Mẫu',
            deliverable_type: 'Loại Sản phẩm',
            no_templates: 'Không tìm thấy mẫu sản phẩm.',
            frequency: 'Tần suất',
            est_effort_hrs: 'Công sức ước tính (giờ)',
            estimated_effort: 'Công sức ước tính (giờ)',
            associated_module: 'Phân hệ liên quan',
            linked_tiers_count: 'Số cấp liên kết',
            evidence_requirements: 'Yêu cầu bằng chứng (phân cách bằng dấu phẩy)',
            tier_ids: 'Mã cấp (phân cách bằng dấu phẩy)',
            module_none: 'Không có phân hệ',
            module_unrecognised: '{value} — không phải phân hệ của nền tảng; giữ nguyên như đã lưu',
            frequency_one_time: 'Một lần',
            frequency_monthly: 'Hàng tháng',
            frequency_quarterly: 'Hàng quý',
            frequency_annually: 'Hàng năm',
            type_report: 'Báo cáo',
            type_review: 'Xem xét',
            type_assessment: 'Đánh giá',
            type_meeting: 'Cuộc họp',
            type_configuration: 'Cấu hình',
            freq_one_time: 'Một lần',
            freq_monthly: 'Hàng tháng',
            freq_quarterly: 'Hàng quý',
            freq_annually: 'Hàng năm',
            status_deprecated: 'Ngừng sử dụng',
        },
        deliverables: {
            title: 'Sản phẩm',
            new: 'Sản phẩm mới',
            partner: 'Đối tác',
            deliverable_type: 'Loại Sản phẩm',
            due_date: 'Hạn chót',
            no_deliverables: 'Không tìm thấy sản phẩm.',
            assigned_to: 'Giao cho',
            completion_date: 'Ngày hoàn thành',
            update_status: 'Cập nhật trạng thái',
            hide_details: 'Ẩn chi tiết',
            view_details: 'Xem chi tiết',
            evidence_ids: 'Mã bằng chứng',
            evidence_expected: 'Bằng chứng cần có',
            evidence_expected_none: 'Sản phẩm này không ghi nhận yêu cầu bằng chứng nào.',
            client_approval: 'Phê duyệt khách hàng',
            bulk_update: 'Cập nhật hàng loạt',
            bulk_update_status: 'Cập nhật trạng thái hàng loạt',
            generate_schedule: 'Tạo lịch',
            generate_deliverable_schedule: 'Tạo lịch sản phẩm',
            // 'Chưa phân công', not the 'Chưa giao' this key shipped with a round ago:
            // the Assign button renders `common.assign` = 'Phân công' and Unassign
            // renders 'Bỏ phân công', so a column reading 'Chưa giao' used a different
            // verb for the same act. The rest of the product already says 'Chưa phân
            // công' (vi.ts:4963).
            unassigned: 'Chưa phân công',
            assigned_to_user: 'Đã phân công cho {name}.',
            assignee_cleared: 'Sản phẩm hiện chưa được phân công.',
            edit_notes: 'Chỉnh sửa ghi chú',
            // 'bằng chứng', matching this module's existing `evidence_ids` ('Mã bằng
            // chứng'). The R-44 registry's 'Tài liệu chứng minh' for Evidence is
            // scoped to `assessments` (scope-map.json:31), so it does not reach here;
            // a term reviewed under one module is not applied inside another's key
            // paths. Consistency within the module wins over borrowing across one.
            edit_evidence: 'Chỉnh sửa bằng chứng',
            evidence_select_label: 'Chọn mục bằng chứng',
            evidence_none_available: 'Không có mục bằng chứng nào. Hãy thêm vào kho bằng chứng trước.',
            approval_note_label: 'Ghi chú (tuỳ chọn)',
            approval_status_approved: 'Đã phê duyệt',
            // 'Không phê duyệt' is the governed term for Rejected
            // (registry.en-vi.json). `common.reject` renders the verb 'Từ chối'; this
            // key is the resulting *state*, which the registry words differently.
            approval_status_rejected: 'Không phê duyệt',
            approval_by_at: 'bởi {name} vào {date}',
            approval_recorded: 'Đã ghi nhận phê duyệt của khách hàng.',
            approval_rejection_recorded: 'Đã ghi nhận việc khách hàng không phê duyệt.',
            notes_saved: 'Đã lưu ghi chú.',
            evidence_saved: 'Đã cập nhật bằng chứng.',
            generated_count: 'Đã tạo {count} sản phẩm.',
            generated_none: 'Không có sản phẩm nào được tạo. Chưa có mẫu sản phẩm nào đang hoạt động được liên kết với cấp dịch vụ này — hãy tạo mẫu trong mục Mẫu Sản phẩm và liên kết với mã cấp dịch vụ này trước.',
            organization_id: 'Mã tổ chức',
            service_tier_id: 'Mã cấp dịch vụ',
            filter_assigned_to: 'Lọc theo người được giao',
            select_status: 'Chọn trạng thái...',
            new_status: 'Trạng thái mới',
            upcoming: 'Sắp tới',
            overdue: 'Quá hạn',
            status_deferred: 'Hoãn lại',
            status_overdue: 'Quá hạn',
            status_upcoming: 'Sắp tới',
        },
        brand_profiles: {
            title: 'Hồ sơ Thương hiệu',
            new: 'Hồ sơ Thương hiệu mới',
            partner: 'Đối tác',
            brand_name: 'Tên Thương hiệu',
            primary_color: 'Màu Chính',
            logo_url: 'URL Logo',
            no_profiles: 'Không tìm thấy hồ sơ thương hiệu.',
            secondary_color: 'Màu phụ',
            header_text: 'Văn bản tiêu đề',
            footer_text: 'Văn bản chân trang',
            contact_email: 'Email liên hệ',
            contact_phone: 'Điện thoại liên hệ',
            contact_website: 'Trang web liên hệ',
            contact_address: 'Địa chỉ liên hệ',
            is_default: 'Là mặc định',
            set_default: 'Đặt mặc định',
            preview: 'Xem trước',
            report_header_preview: 'Xem trước tiêu đề báo cáo',
            report_footer_preview: 'Xem trước chân trang báo cáo',
            preview_description: 'Đây là bản xem trước tiêu đề báo cáo với màu thương hiệu đã chọn.',
            contact_website_short: 'Trang web',
            logo_preview: 'Xem trước logo',
        },
        support_tickets: {
            title: 'Phiếu Hỗ trợ',
            new: 'Phiếu mới',
            partner: 'Đối tác',
            subject: 'Chủ đề',
            assigned_to: 'Giao cho',
            no_tickets: 'Không tìm thấy phiếu hỗ trợ.',
            category: 'Danh mục',
            priority: 'Mức ưu tiên',
            escalation_tier: 'Cấp leo thang',
            sla_status: 'Trạng thái SLA',
            update_status: 'Cập nhật trạng thái',
            escalate: 'Leo thang',
            add_note: 'Thêm ghi chú',
            escalate_ticket: 'Leo thang phiếu',
            escalate_to_tier: 'Leo thang đến cấp',
            notes_timeline: 'Dòng thời gian ghi chú',
            no_notes: 'Chưa có ghi chú.',
            attachments: 'Tệp đính kèm',
            no_attachments: 'Không có tệp đính kèm.',
            client_org_id: 'Mã tổ chức khách hàng',
            content: 'Nội dung',
            note_type: 'Loại',
            view_detail: 'Xem chi tiết',
            hide: 'Ẩn',
            new_status: 'Trạng thái mới',
            all_categories: 'Tất cả danh mục',
            all_priorities: 'Tất cả mức ưu tiên',
            all_tiers: 'Tất cả cấp',
            ticket_not_found: 'Không tìm thấy phiếu',
            ticket_id: 'Mã phiếu',
            client_org: 'Tổ chức khách hàng',
            deescalate: 'Hạ cấp leo thang',
            deescalate_ticket: 'Hạ cấp leo thang phiếu',
            deescalate_to_tier: 'Hạ cấp đến cấp',
            add_attachment: 'Thêm tệp đính kèm',
            file: 'Tệp',
            linked_entity: 'Thực thể liên kết',
            sla_target: 'Mục tiêu',
            breached: 'Vi phạm',
            remaining_hours: 'còn lại',
            na: 'N/A',
            tickets_found: 'phiếu tìm thấy',
            reason: 'Lý do',
            target: 'Mục tiêu',
            upload: 'Tải lên',
        },
        workflow_templates: {
            title: 'Mẫu Quy trình',
            new: 'Mẫu mới',
            template_name: 'Tên Mẫu',
            steps: 'Bước',
            no_templates: 'Không tìm thấy mẫu quy trình.',
            category: 'Danh mục',
            view_steps: 'Xem bước',
            hide_steps: 'Ẩn bước',
            step: 'Bước',
            step_title: 'Tiêu đề',
            step_description: 'Mô tả',
            assignee_role: 'Vai trò người nhận',
            sla_hours: 'Số giờ SLA',
            evidence_required: 'Yêu cầu bằng chứng',
            guidance_notes: 'Ghi chú hướng dẫn',
            add_step: 'Thêm bước',
            no_steps: 'Chưa định nghĩa bước nào.',
            no_steps_defined: 'Chưa định nghĩa bước nào.',
            templates_found: 'mẫu tìm thấy',
            all_categories: 'Tất cả danh mục',
        },
        workflows: {
            client_org: 'Tổ chức khách hàng',
            title: 'Phiên Quy trình',
            new: 'Quy trình mới',
            template: 'Mẫu',
            partner: 'Đối tác',
            current_step: 'Bước Hiện tại',
            progress: 'Tiến độ',
            no_workflows: 'Không tìm thấy phiên quy trình.',
            instances_found: 'phiên bản tìm thấy',
        },
        escalation: {
            title: 'Bảng Leo thang',
            ticket: 'Phiếu',
            partner: 'Đối tác',
            escalated_at: 'Leo thang lúc',
            reason: 'Lý do',
            no_escalations: 'Không tìm thấy leo thang.',
            time_in_tier: 'Thời gian trong cấp',
            auto_evaluate: 'Tự động đánh giá',
            priority_critical: 'Nghiêm trọng',
            priority_high: 'Cao',
            priority_medium: 'Trung bình',
            priority_low: 'Thấp',
            deescalated_from_dashboard: 'Đã hạ cấp từ bảng điều khiển',
            sla_breached: 'Vi phạm SLA',
            sla_remaining: 'SLA còn lại: {hours} giờ',
            sr_total_escalated: 'Tổng số đã leo thang',
            sr_by_tier: 'Theo cấp độ',
            sr_by_priority: 'Theo mức ưu tiên',
        },
        reports: {
            client_org: 'Tổ chức khách hàng',
            title: 'Báo cáo',
            partner: 'Đối tác',
            report_type: 'Loại Báo cáo',
            generated_at: 'Tạo lúc',
            no_reports: 'Không tìm thấy báo cáo.',
            generate: 'Tạo Báo cáo',
        },
        audit: {
            title: 'Nhật ký Kiểm toán Đối tác',
            event_type: 'Loại Sự kiện',
            entity_type: 'Loại Thực thể',
            entity: 'Thực thể',
            entity_id: 'Mã Thực thể',
            actor: 'Tác nhân',
            timestamp: 'Thời gian',
            no_events: 'Không tìm thấy sự kiện kiểm toán.',
            events_found: 'sự kiện tìm thấy',
            client_org: 'Tổ chức khách hàng',
            all_actors: 'Tất cả người thực hiện',
            event_type_search: 'Tìm loại sự kiện',
            event_type_created: 'Đã tạo',
            event_type_updated: 'Đã cập nhật',
            event_type_deleted: 'Đã xóa',
            event_type_set_default: 'Đặt làm mặc định',
            event_type_status_changed: 'Đã thay đổi trạng thái',
            event_type_status_updated: 'Đã cập nhật trạng thái',
            event_type_generated: 'Đã tạo lập',
            event_type_export_generated: 'Đã tạo bản xuất',
            event_type_escalated: 'Đã leo thang',
            event_type_auto_escalated: 'Tự động leo thang',
            event_type_deescalated: 'Đã hạ cấp',
            event_type_managed_org_added: 'Đã thêm khách hàng quản lý',
            event_type_managed_org_removed: 'Đã gỡ khách hàng quản lý',
            event_type_versioned: 'Phiên bản mới',
            event_type_attachment_added: 'Đã thêm tệp đính kèm',
            event_type_note_added: 'Đã thêm ghi chú',
            event_type_step_advanced: 'Đã chuyển bước',
            event_type_cancelled: 'Đã hủy',
            entity_type_partner_org: 'Tổ chức đối tác',
            entity_type_service_tier: 'Cấp dịch vụ',
            entity_type_deliverable_template: 'Mẫu sản phẩm',
            entity_type_deliverable_instance: 'Phiên bản sản phẩm',
            entity_type_brand_profile: 'Hồ sơ thương hiệu',
            entity_type_support_ticket: 'Phiếu hỗ trợ',
            entity_type_workflow_template: 'Mẫu quy trình',
            entity_type_workflow_instance: 'Phiên bản quy trình',
            entity_type_generated_report: 'Báo cáo đã tạo',
            entity_type_audit_export: 'Xuất nhật ký kiểm toán',
        },
        no_permission_title: 'Không đủ Quyền truy cập',
        no_permission_message: 'Bạn không có quyền truy cập vào không gian làm việc đối tác.',
        status_active: 'Đang hoạt động',
        status_suspended: 'Tạm ngừng',
        status_offboarded: 'Đã rời khỏi',
        status_completed: 'Đã hoàn thành',
        status_cancelled: 'Đã hủy',
        status_deprecated: 'Đã ngừng sử dụng',
        status_new: 'Mới',
        status_triaged: 'Đã phân loại',
        status_in_progress: 'Đang tiến hành',
        status_waiting_on_client: 'Đang chờ khách hàng',
        status_waiting_on_vendor: 'Đang chờ nhà cung cấp',
        status_escalated: 'Đã leo thang',
        status_resolved: 'Đã giải quyết',
        status_closed: 'Đã đóng',
        status_pending: 'Chờ xử lý',
        status_skipped: 'Đã bỏ qua',
        client_org_column: 'Tổ chức khách hàng',
        client_org_unresolved: 'Chưa ghi nhận tổ chức khách hàng',
        category_onboarding: 'Khởi tạo',
        category_incident_escalation: 'Leo thang sự cố',
        category_config_change: 'Thay đổi cấu hình',
        category_periodic_review: 'Đánh giá định kỳ',
        category_offboarding: 'Ngừng hợp tác',
        category_custom: 'Tùy chỉnh',
        category_configuration: 'Cấu hình',
        category_incident: 'Sự cố',
        category_compliance_question: 'Câu hỏi tuân thủ',
        category_feature_request: 'Yêu cầu tính năng',
        category_bug_report: 'Báo lỗi',
        priority_critical: 'Nghiêm trọng',
        priority_high: 'Cao',
        priority_medium: 'Trung bình',
        priority_low: 'Thấp',
        tier_silver: 'Bạc',
        tier_gold: 'Vàng',
        tier_platinum: 'Bạch kim',
        report_type_compliance_summary: 'Tóm tắt tuân thủ',
        report_type_risk_overview: 'Tổng quan rủi ro',
        report_type_incident_report: 'Báo cáo sự cố',
        report_type_consent_status: 'Trạng thái đồng thuận',
        report_type_program_maturity: 'Độ trưởng thành chương trình',
        report_type_executive_pack: 'Gói báo cáo điều hành',
        note_type_internal: 'Nội bộ',
        note_type_client_visible: 'Hiển thị cho khách hàng',
        status_updated: 'Cập nhật trạng thái thành công',
        deliverable_status_updated: 'Cập nhật trạng thái sản phẩm thành công',
        ticket_status_updated: 'Cập nhật trạng thái phiếu thành công',
        ticket_escalated: 'Leo thang phiếu thành công',
        note_added: 'Thêm ghi chú thành công',
        attachment_uploaded: 'Tải lên tệp đính kèm thành công',
        ticket_deescalated: 'Hạ cấp leo thang phiếu thành công',
        auto_evaluation_completed: 'Đánh giá tự động hoàn tất',
        template_created: 'Tạo mẫu quy trình thành công',
        template_updated: 'Cập nhật mẫu quy trình thành công',
        brand_set_default: 'Đặt hồ sơ thương hiệu làm mặc định thành công',
        brand_created: 'Tạo hồ sơ thương hiệu thành công',
        brand_updated: 'Cập nhật hồ sơ thương hiệu thành công',
        tier_created: 'Tạo cấp dịch vụ thành công',
        tier_updated: 'Cập nhật cấp dịch vụ thành công',
        tier_deprecated: 'Ngừng sử dụng cấp dịch vụ thành công',
        tier_activated: 'Kích hoạt cấp dịch vụ thành công',
        period: 'Kỳ hạn',
        format: 'Định dạng',
        period_start: 'Bắt đầu kỳ',
        period_end: 'Kết thúc kỳ',
        reports_count: '{count} báo cáo',
        reports_count_one: '{count} báo cáo',
        metric: 'Chỉ số',
        value: 'Giá trị',
        showing_chart_view: 'Đang hiển thị chế độ biểu đồ',
        showing_table_view: 'Đang hiển thị chế độ bảng dữ liệu',
        evidence_ids_placeholder: 'ví dụ ev-001, ev-002',
        confirm_cancel_workflow: 'Bạn có chắc chắn muốn hủy quy trình này không? Hành động này không thể hoàn tác.',
        export_csv: 'Xuất CSV',
        compliance_qualifications_title: 'Trình độ dịch vụ tuân thủ',
        compliance_qualifications_desc: 'Cấp đối tác (Bạc, Vàng hoặc Bạch kim) là một nhãn trên hồ sơ đối tác. Nền tảng chỉ đọc nhãn này ở một chỗ: một phiếu hỗ trợ được mở cho một tổ chức do đối tác quản lý lấy mục tiêu thời gian giải quyết từ cấp dịch vụ đang hoạt động của đối tác có cùng mã, hoặc 24 giờ nếu không có cấp nào như vậy. Cấp đối tác không cấp quyền truy cập và không làm cho đối tác đủ điều kiện cho bất kỳ loại cam kết nào.',
        regulatory_output_title: 'Liên kết đầu ra pháp quy',
        regulatory_output_desc: 'Mỗi loại mẫu ánh xạ tới danh mục đầu ra pháp quy: Báo cáo tạo tài liệu tuân thủ, Xem xét xác nhận hiệu quả kiểm soát, Đánh giá bao gồm DPIA và phân tích khoảng trống, Cuộc họp ghi lại phiên quản trị.',
        sla_compliance_title: 'Theo dõi SLA cho giao dịch tuân thủ',
        sla_compliance_desc: 'SLA thời gian phản hồi và giải quyết ràng buộc hợp đồng. Tần suất đánh giá xác định mức độ đánh giá sản phẩm tuân thủ đối tác. Vi phạm SLA kích hoạt leo thang tự động và được ghi trong Nhật ký kiểm toán.',
        regulatory_engagement_title: 'Mẫu cam kết pháp quy',
        regulatory_engagement_desc: 'Danh mục quy trình ánh xạ tới loại cam kết pháp quy: Khởi tạo bao gồm thiết lập tuân thủ ban đầu, Đánh giá định kỳ xử lý đánh giá lặp lại, Leo thang sự cố quản lý phản ứng vi phạm, Ngừng hợp tác đảm bảo nghĩa vụ lưu giữ dữ liệu.',
        compliance_escalation_title: 'Thủ tục leo thang nghiêm trọng về tuân thủ',
        compliance_escalation_desc: 'L1 xử lý vấn đề tiêu chuẩn. L2 bao gồm lỗi ảnh hưởng tuân thủ. L3 dành cho vi phạm pháp quy cần sự chú ý lãnh đạo. Tất cả hành động leo thang được ghi nhận vĩnh viễn.',
        audit_regulatory_title: 'Đường dẫn bằng chứng pháp quy',
        audit_regulatory_desc: 'Nhật ký kiểm toán cung cấp bản ghi chống giả mạo. Mọi hành động đối tác được ghi với danh tính tác nhân, dấu thời gian và diff tải trọng đầy đủ.',
        evidence_trail_title: 'Đường dẫn bằng chứng xuyên phân hệ',
        evidence_trail_desc: 'Mỗi bước quy trình có thể thu thập ID bằng chứng liên kết với sản phẩm và hiện vật tuân thủ. Quy trình hoàn thành với chuỗi bằng chứng đầy đủ là bằng chứng cam kết tuân thủ.',
        evidence_ids_label: 'ID bằng chứng',
    },
    org_groups: {
        title: 'Nhóm Tổ chức',
        new: 'Tạo Nhóm',
        group_name: 'Tên Nhóm',
        member_count: 'Số Thành viên',
        root_org: 'Tổ chức Gốc',
        no_groups: 'Không tìm thấy nhóm tổ chức.',
        add_organization: 'Thêm Tổ chức',
        select_organization: 'Chọn một tổ chức...',
        no_available_orgs: 'Không có tổ chức nào khả dụng để thêm.',
        no_members: 'Không có tổ chức thành viên trong nhóm này.',
        member_added: 'Đã thêm tổ chức vào nhóm.',
        member_removed: 'Đã xóa tổ chức khỏi nhóm.',
        already_in_group: 'Tổ chức này đã thuộc một nhóm.',
        org_not_found: 'Không tìm thấy tổ chức.',
        add_member_error: 'Không thể thêm tổ chức vào nhóm.',
        remove_member_error: 'Không thể xóa tổ chức khỏi nhóm.',
        confirm_remove_member: 'Bạn có chắc muốn xóa "{name}" khỏi nhóm này?',
        load_error: 'Không thể tải chi tiết nhóm tổ chức.',
        dashboard: {
            title: 'Tổng quan Nhóm',
            loading: 'Đang tải dữ liệu...',
            total_groups: 'Tổng Nhóm',
            total_members: 'Tổng Thành viên',
            active_groups: 'Nhóm Hoạt động',
            overall_compliance_score: 'Điểm tuân thủ tổng thể',
            group_risk_level: 'Mức rủi ro nhóm',
            sla_compliance: 'Tuân thủ SLA',
            compliance_posture: 'Tình trạng tuân thủ',
            risk_heatmap: 'Bản đồ nhiệt rủi ro',
            sla_performance: 'Hiệu suất SLA',
            recent_incidents: 'Sự cố gần đây',
            recent_activity: 'Hoạt động gần đây',
            refresh_label: 'Làm mới dữ liệu bảng điều khiển',
            score_good: 'Tốt',
            score_needs_attention: 'Cần chú ý',
            score_critical: 'Nghiêm trọng',
            trend_up: 'Xu hướng tăng',
            trend_down: 'Xu hướng giảm',
            trend_stable: 'Ổn định',
            risk_low: 'Thấp',
            risk_medium: 'Trung bình',
            risk_high: 'Cao',
            risk_critical: 'Nghiêm trọng',
            risk_unknown: 'Không xác định',
            col_organization: 'Tổ chức',
            col_score: 'Điểm',
            col_trend: 'Xu hướng',
            col_open_issues: 'Vấn đề mở',
            col_critical_issues: 'Vấn đề nghiêm trọng',
            col_health: 'Sức khỏe',
            col_vendor_risk: 'Rủi ro nhà cung cấp',
            col_data_risk: 'Rủi ro dữ liệu',
            col_compliance_risk: 'Rủi ro tuân thủ',
            col_total_cases: 'Tổng số vụ',
            col_on_time: 'Đúng hạn',
            col_breached: 'Vi phạm',
            col_sla_percent: 'SLA %',
            col_avg_days: 'Ngày TB',
            sr_vendor_risk: 'Điểm rủi ro nhà cung cấp: {score}',
            sr_data_risk: 'Điểm rủi ro dữ liệu: {score}',
            sr_compliance_risk: 'Điểm rủi ro tuân thủ: {score}',
            sr_sla_breaches: 'Cảnh báo: {count} vi phạm SLA',
            sr_severity: 'Mức độ: {severity}',
        },
        detail: {
            title: 'Chi tiết Nhóm',
            members: 'Thành viên',
            settings: 'Cài đặt',
            audit: 'Kiểm toán',
            sr_loading: 'Đang tải chi tiết nhóm tổ chức',
            sr_loading_hierarchy: 'Đang tải phân cấp',
            tab_tasks: 'Nhiệm vụ dùng chung',
            tasks_intro: 'Nhiệm vụ của mọi tổ chức trong nhóm này, được đọc trên toàn nhóm vì việc chia sẻ nhiệm vụ đang được bật trong cài đặt của nhóm.',
            tasks_total: '{count} nhiệm vụ trong toàn nhóm',
            tasks_overdue: '{count} quá hạn',
            tasks_by_status: 'Theo trạng thái',
            tasks_by_org: 'Theo tổ chức',
            tasks_latest: 'Nhiệm vụ gần nhất',
            tasks_showing: 'Đang hiển thị {shown} nhiệm vụ gần nhất trong tổng số {total}.',
            tasks_empty: 'Chưa có tổ chức nào trong nhóm này có nhiệm vụ.',
            col_title: 'Tiêu đề',
            col_org: 'Tổ chức',
            col_status: 'Trạng thái',
            col_priority: 'Mức ưu tiên',
            col_due: 'Hạn',
            tasks_load_failed: 'Không đọc được nhiệm vụ dùng chung của nhóm, nên không có gì được hiển thị cho mục này.',
            tasks_subject: 'nhiệm vụ dùng chung',
            sr_loading_tasks: 'Đang tải nhiệm vụ dùng chung',
            member_org: 'tổ chức thành viên',
            root_org_label: 'tổ chức gốc',
            hierarchy: 'Cấu trúc phân cấp',
        },
        users: {
            title: 'Người dùng Nhóm',
            add_user: 'Thêm Người dùng',
            no_users: 'Không có người dùng trong nhóm này.',
            role_group_admin: 'Quản trị nhóm',
            role_group_reader: 'Đọc viên nhóm',
            sr_loading: 'Đang tải người dùng nhóm',
        },
        reports: {
            title: 'Báo cáo Nhóm',
            no_reports: 'Không tìm thấy báo cáo.',
            generate_report: 'Tạo báo cáo mới',
            report_type_compliance: 'Tóm tắt tuân thủ',
            report_type_risk: 'Tổng quan rủi ro',
            report_type_sla: 'Hiệu suất SLA',
            report_type_incident: 'Báo cáo sự cố',
            report_type_executive: 'Tóm tắt điều hành',
            report_type_board: 'Báo cáo ban điều hành',
            status_queued: 'Đang chờ',
            status_generating: 'Đang tạo',
            status_completed: 'Hoàn thành',
            status_failed: 'Thất bại',
            period_start: 'Bắt đầu kỳ',
            period_end: 'Kết thúc kỳ',
            sr_loading: 'Đang tải báo cáo nhóm',
            /*
             * The two row actions' accessible names, interpolated rather than built
             * as English template literals.
             *
             * They shipped as `aria-label={`Delete report ${…}`}` and
             * `aria-label={`Download ${…} as ${…}`}` — an `aria-label` is
             * user-visible text, so 15 non-English locales heard these in English.
             * The same defect was fixed by hand one page over in the same commit
             * that touched these two lines and left them.
             */
            download_report_aria: 'Tải xuống {title} dạng {format}',
            delete_report_aria: 'Xóa báo cáo {title}',
        },
        shared_vendors: {
            title: 'Nhà cung cấp Chung',
            no_vendors: 'Không tìm thấy nhà cung cấp chung.',
            merged_vendors: 'Nhà cung cấp Đã hợp nhất',
            publish_form_label: 'Công bố nhà cung cấp chia sẻ',
            sr_loading: 'Đang tải nhà cung cấp chia sẻ',
            sr_loading_merged: 'Đang tải nhà cung cấp hợp nhất',
            local_vendors: 'Nhà cung cấp nội bộ',
            source_shared: 'Chia sẻ từ nhóm',
            source_local: 'Nhà cung cấp nội bộ',
            category_technology: 'Công nghệ',
            category_consulting: 'Tư vấn',
            category_outsourcing: 'Thuê ngoài',
            category_cloud: 'Đám mây',
            category_data_processing: 'Xử lý dữ liệu',
            category_other: 'Khác',
            risk_tier_low: 'Thấp',
            risk_tier_medium: 'Trung bình',
            risk_tier_high: 'Cao',
            risk_tier_critical: 'Nghiêm trọng',
            compliance_compliant: 'Tuân thủ',
            compliance_non_compliant: 'Không tuân thủ',
            compliance_pending: 'Chờ xử lý',
            compliance_under_review: 'Đang xem xét',
            status_active: 'Hoạt động',
            status_retired: 'Đã ngừng',
        },
        shared_frameworks: {
            // Fix sprint F28 (WCAG 3.3.2) — the framework-code field was labelled
            // `common.type` ("Type"), so its accessible name said nothing about what
            // it takes. With no installed framework the placeholder resolves to '',
            // leaving a required field with neither a meaningful name nor a hint.
            framework_code_label: 'Mã khung tuân thủ',
            title: 'Khung Chung',
            no_frameworks: 'Không tìm thấy khung chung.',
            publish_form_label: 'Công bố khung chia sẻ',
            sr_loading: 'Đang tải khung chia sẻ',
            status_active: 'Hoạt động',
            status_retired: 'Đã ngừng',
        },
        shared_forms: {
            title: 'Mẫu biểu Chung',
            no_forms: 'Không tìm thấy mẫu biểu chung.',
            publish_form_label: 'Công bố mẫu biểu chia sẻ',
            sr_loading: 'Đang tải mẫu biểu chia sẻ',
            status_active: 'Hoạt động',
            status_retired: 'Đã ngừng',
        },
        audit: {
            title: 'Kiểm toán Nhóm',
            consolidated_title: 'Nhật ký Kiểm toán Tổng hợp',
            consolidated_subtitle: 'Sự kiện kiểm toán liên tổ chức cho nhóm này',
            audit_log_title: 'Nhật ký Kiểm toán Nhóm',
            event_type: 'Loại Sự kiện',
            actor: 'Tác nhân',
            timestamp: 'Thời gian',
            source_org: 'Tổ chức Nguồn',
            org: 'Tổ chức',
            summary: 'Tóm tắt',
            details: 'Chi tiết',
            no_events: 'Không tìm thấy sự kiện kiểm toán.',
            all_events: 'Tất cả Sự kiện',
            all_orgs: 'Tất cả Tổ chức',
            organization: 'Tổ chức',
            from: 'Từ',
            to: 'Đến',
            search_events: 'Tìm kiếm sự kiện...',
            clear: 'Xóa',
            events_24h: 'Sự kiện (24h)',
            events_7d: 'Sự kiện (7 ngày)',
            active_orgs: 'Tổ chức Hoạt động',
            exporting: 'Đang xuất...',
            export_csv: 'Xuất CSV',
            export_json: 'Xuất JSON',
            back_to_group: 'Quay lại Nhóm',
            back_to_detail: 'Quay lại Chi tiết',
            sr_loading: 'Đang tải sự kiện kiểm toán',
            sr_loading_summary: 'Đang tải tóm tắt kiểm toán',
            disabled_by_settings: 'Nhật ký kiểm toán tổng hợp đang bị tắt trong cài đặt của nhóm này. Tổ chức gốc của nhóm có thể bật lại trong phần Cài đặt.',
        },
        settings: {
            title: 'Cài đặt Nhóm',
            shared_tasks: 'Chia sẻ danh sách nhiệm vụ, thống kê và lịch giữa các tổ chức thành viên của nhóm này',
            inheritance: 'Kế thừa Cài đặt',
            inheritance_subtitle: 'Cấu hình danh mục cài đặt nào kế thừa từ nhóm so với sử dụng ghi đè cục bộ',
            sla_settings: 'Cài đặt SLA',
            calendar_settings: 'Cài đặt Lịch',
            notification_settings: 'Cài đặt Thông báo',
            intake_settings: 'Cài đặt Tiếp nhận',
            cmp_integration: 'Tích hợp CMP',
            overridden: 'Đã ghi đè',
            inheriting: 'Đang kế thừa',
            hide_defaults: 'Ẩn Mặc định',
            show_group_defaults: 'Hiện Mặc định Nhóm',
            group_defaults: 'Mặc định Nhóm',
            inherit_from_group: 'Kế thừa từ Nhóm',
            use_local_override: 'Sử dụng Ghi đè Cục bộ',
            local_override_json: 'Ghi đè Cục bộ (JSON)',
            save_override: 'Lưu Ghi đè',
            saving: 'Đang lưu...',
            sr_loading: 'Đang tải kế thừa cài đặt',
            sr_loading_settings: 'Đang tải cài đặt nhóm',
            sr_enabled: 'Đã bật',
            sr_disabled: 'Đã tắt',
            sr_override_active: 'Ghi đè cục bộ đang hoạt động',
            sr_inherited: 'Kế thừa từ tổ chức cha',
            danger_zone: 'Khu vực nguy hiểm',
            sharing_options: 'Tùy chọn chia sẻ',
            advanced_options: 'Tùy chọn nâng cao',
            // fix-sprint-20260717-2118-followup F3
            configuration_heading: 'Cấu hình cài đặt nhóm',
            max_member_orgs: 'Số tổ chức thành viên tối đa',
        },
        page_title_list: 'Nhóm tổ chức',
        page_title_detail: 'Chi tiết nhóm tổ chức',
        page_title_create: 'Tạo nhóm tổ chức',
        page_title_settings: 'Cài đặt nhóm tổ chức',
        page_title_users: 'Người dùng nhóm',
        page_title_reports: 'Báo cáo nhóm',
        page_title_dashboard: 'Bảng điều khiển nhóm',
        page_title_audit: 'Kiểm toán nhóm',
        page_title_org_audit: 'Kiểm toán nhóm tổ chức',
        page_title_shared_vendors: 'Nhà cung cấp chia sẻ',
        page_title_shared_frameworks: 'Khung chia sẻ',
        page_title_shared_forms: 'Mẫu biểu chia sẻ',
        page_title_merged_vendors: 'Nhà cung cấp hợp nhất',
        page_title_settings_inheritance: 'Kế thừa cài đặt',
        announce_loaded_groups: 'Đã tải {count} nhóm tổ chức',
        announce_loaded_group: 'Đã tải nhóm {name}',
        announce_loaded_users: 'Đã tải {count} người dùng nhóm',
        announce_loaded_reports: 'Đã tải {count} báo cáo',
        announce_loaded_vendors: 'Đã tải {count} nhà cung cấp chia sẻ',
        announce_loaded_frameworks: 'Đã tải {count} khung chia sẻ',
        announce_loaded_templates: 'Đã tải {count} mẫu biểu chia sẻ',
        announce_loaded_audit: 'Đã tải {count} sự kiện kiểm toán',
        announce_loaded_merged: 'Đã tải {shared} chia sẻ và {local} nhà cung cấp nội bộ',
        announce_dashboard_loaded: 'Đã tải bảng điều khiển.',
        announce_dashboard_refreshed: 'Đã làm mới bảng điều khiển.',
        announce_dashboard_refresh_failed: 'Không thể làm mới bảng điều khiển.',
        announce_refreshing: 'Đang làm mới bảng điều khiển...',
        announce_settings_loaded: 'Đã tải kế thừa cài đặt.',
        announce_settings_saved: 'Đã lưu cài đặt thành công.',
        announce_saving_settings: 'Đang lưu cài đặt...',
        announce_error_saving: 'Lỗi khi lưu cài đặt.',
        announce_group_dissolved: 'Đã giải tán nhóm.',
        announce_creating_group: 'Đang tạo nhóm tổ chức...',
        announce_group_created: 'Tạo nhóm tổ chức thành công.',
        announce_error_creating: 'Lỗi khi tạo nhóm tổ chức.',
        announce_vendor_published: 'Công bố nhà cung cấp thành công.',
        announce_vendor_retired: 'Đã ngừng nhà cung cấp.',
        announce_framework_published: 'Công bố khung thành công.',
        announce_framework_retired: 'Đã ngừng khung.',
        announce_template_published: 'Công bố mẫu biểu thành công.',
        announce_template_retired: 'Đã ngừng mẫu biểu.',
        announce_role_assigned: 'Phân quyền thành công.',
        announce_error_assign_role: 'Lỗi khi phân quyền.',
        announce_role_revoked: 'Thu hồi quyền thành công.',
        announce_report_generating: 'Đang tạo báo cáo...',
        announce_report_requested: 'Đã yêu cầu tạo báo cáo.',
        announce_error_report: 'Lỗi khi yêu cầu báo cáo.',
        announce_report_deleted: 'Đã xóa báo cáo.',
        announce_search_applied: 'Đã áp dụng tìm kiếm.',
        announce_search_cleared: 'Đã xóa tìm kiếm.',
        announce_tab_selected: 'Đã chọn tab {tab}',
        announce_error_add_member: 'Lỗi khi thêm thành viên vào nhóm.',
        announce_category_reverted: '{category} đã hoàn lại kế thừa từ tổ chức cha.',
        announce_category_overridden: '{category} đã đặt ghi đè cục bộ.',
        announce_override_saved: 'Đã lưu ghi đè {category}.',
        announce_export_started: 'Đang xuất kiểm toán dạng {format}...',
        announce_export_completed: 'Xuất dạng {format} hoàn tất.',
        announce_export_failed: 'Xuất thất bại.',
        announce_filter_org: 'Đã lọc theo tổ chức {name}',
        announce_filter_org_cleared: 'Đã xóa bộ lọc tổ chức',
        announce_filter_event: 'Đã lọc theo loại sự kiện {type}',
        announce_filter_cleared: 'Đã xóa bộ lọc',
        announce_download: 'Đang tải {name} dạng {format}',
        error_load_groups: 'Không thể tải nhóm tổ chức. Vui lòng thử lại.',
        error_load_users: 'Không thể tải người dùng nhóm.',
        error_load_reports: 'Không thể tải báo cáo nhóm.',
        error_load_dashboard: 'Không thể tải bảng điều khiển nhóm.',
        error_load_settings: 'Không thể tải cài đặt nhóm.',
        error_load_vendors: 'Không thể tải nhà cung cấp hợp nhất.',
        error_save_settings: 'Không thể lưu cài đặt.',
        error_dissolve_group: 'Không thể giải tán nhóm.',
        error_assign_role: 'Không thể phân quyền.',
        error_create_group: 'Không thể tạo nhóm tổ chức. Vui lòng thử lại.',
        error_request_report: 'Không thể yêu cầu báo cáo.',
        error_group_name_required: 'Tên nhóm là bắt buộc.',
        success_settings_saved: 'Đã lưu cài đặt thành công.',
        confirm_retire_vendor: 'Bạn có chắc muốn ngừng nhà cung cấp "{name}"?',
        confirm_retire_framework: 'Bạn có chắc muốn ngừng khung "{name}"?',
        confirm_retire_template: 'Bạn có chắc muốn ngừng mẫu biểu "{name}"?',
        confirm_dissolve_group: 'Bạn có chắc muốn giải tán "{name}"? Hành động này không thể hoàn tác.',
        confirm_revoke_role: 'Bạn có chắc muốn thu hồi vai trò "{role}" từ "{name}"?',
        confirm_delete_report: 'Bạn có chắc muốn xóa báo cáo "{name}"?',
        dissolve_group: 'Giải tán nhóm',
        dissolve_warning: 'Hành động này sẽ giải tán vĩnh viễn nhóm tổ chức. Tất cả tổ chức thành viên sẽ bị xóa.',
        count_groups: '{count} nhóm',
        count_groups_plural: '{count} nhóm',
        count_users: '{count} người dùng',
        count_users_plural: '{count} người dùng có vai trò nhóm',
        count_events: '{count} sự kiện',
        count_events_plural: '{count} sự kiện',
        count_reports: '{count} báo cáo',
        count_reports_plural: '{count} báo cáo',
        count_vendors: '{count} nhà cung cấp chia sẻ trong nhóm',
        count_vendors_plural: '{count} nhà cung cấp chia sẻ trong nhóm',
        count_frameworks: '{count} khung chia sẻ trong nhóm',
        count_frameworks_plural: '{count} khung chia sẻ trong nhóm',
        count_templates: '{count} mẫu biểu chia sẻ trong nhóm',
        count_templates_plural: '{count} mẫu biểu chia sẻ trong nhóm',
        count_shared_vendors: '{count} nhà cung cấp chia sẻ',
        count_local_vendors: '{count} nhà cung cấp nội bộ',
        merged_combined_view: 'Chế độ xem kết hợp {shared} chia sẻ và {local} nhà cung cấp nội bộ',
        status_active: 'Hoạt động',
        status_dissolved: 'Đã giải tán',
        status_pending: 'Chờ xử lý',
        status_suspended: 'Tạm ngừng',
    },
    integrations: {
        nav: {
            webhooks: 'Webhook',
            domains: 'Tên miền',
            export_schedules: 'Lịch xuất dữ liệu',
            email_log: 'Nhật ký email',
        },
    },
    platform: {
        abandoned_uploads: {
            title: 'Tệp tải lên bị bỏ dở',
            description: 'Các tệp được tải lên trên biểu mẫu không ai lưu, đã quá thời gian chờ. Việc xem trang này không thay đổi điều gì.',
            grace_window: 'Thời gian chờ',
            hours: '{n} giờ',
            as_of: 'Tính đến',
            candidates: 'Tệp tải lên không hồ sơ nào nhận',
            retained_held: 'Giữ lại — lệnh phong tỏa pháp lý',
            file: 'Tệp',
            uploaded_for: 'Tải lên cho',
            uploaded_by: 'Người tải lên',
            uploaded_at: 'Thời điểm tải lên',
            past_window_by: 'Quá hạn',
            hours_short: '{n} giờ',
            run_sweep: 'Xóa các tệp tải lên bị bỏ dở',
            running: 'Đang xóa...',
            sweep_success: 'Đã xóa {swept} tệp tải lên, giữ lại {held} theo lệnh phong tỏa pháp lý.',
            sweep_failed: 'Không thể chạy đợt quét. Vui lòng thử lại.',
            load_failed: 'Không thể đọc sổ đăng ký tệp tải lên bị bỏ dở. Vui lòng thử lại.',
            reload: 'Tải lại',
            empty: 'Không có tệp tải lên nào quá thời gian chờ mà chưa được nhận.',
            restore_note: 'Tệp đã xóa có thể khôi phục: tệp được xóa mềm và có thể phục hồi từ trang này.',
        },
        nav: {
            users: 'Người dùng',
            roles: 'Vai trò',
            profile: 'Hồ sơ của tôi',
        },
        security: {
            mfa: 'Cài đặt MFA',
            sso: 'Cấu hình SSO',
            api_keys: 'Khóa API',
            service_accounts: 'Tài khoản dịch vụ',
            ip_allowlist: 'Danh sách IP cho phép',
            delegations: 'Ủy quyền',
            break_glass: 'Truy cập khẩn cấp',
            session_settings: 'Cài đặt phiên',
            active_sessions: 'Phiên hoạt động',
            access_reviews: 'Xem xét truy cập',
            my_reviews: 'Xem xét của tôi',
            role_analytics: 'Phân tích vai trò',
            attestation_schedules: 'Lịch chứng thực',
            sod_rules: 'Quy tắc SoD',
            sod_violations: 'Vi phạm SoD',
        },
        module_config: {
            title: 'Cấu hình phân hệ',
            subtitle: 'Bật hoặc tắt các phân hệ tính năng cho toàn bộ bản cài đặt: thiết lập áp dụng cho mọi tổ chức trên bản cài đặt này. Phân hệ bị tắt sẽ ẩn khỏi thanh điều hướng.',
            enabled: 'Đã bật',
            disabled: 'Đã tắt',
            save: 'Lưu cấu hình',
            saving: 'Đang lưu...',
            saved: 'Cấu hình đã được lưu thành công',
            nav_label: 'Cấu hình phân hệ',
            settings: 'Cài đặt',
            webhooks: 'Webhooks',
            domains: 'Tên miền',
            export_schedules: 'Lịch xuất',
            email_log: 'Nhật ký email',
            announce_loaded: 'Đã tải cấu hình phân hệ',
        },
        // Sprint 41.4.0 F14 — Cấu hình & Trình duyệt Tệp Nền tảng
        // Bản dịch tiếng Việt. 14 ngôn ngữ khác được hoãn sang Sprint 51.0.0.
        files_nav: {
            section: 'Tệp tin',
            configuration: 'Cấu hình',
            browser: 'Trình duyệt tệp',
            dashboard: 'Bảng điều khiển tệp',
        },
        // Nhật ký kiểm toán bất biến — chuỗi khung trang dùng chung cho bốn
        // trang phụ (Cài đặt, Trạng thái bằng chứng, Trung tâm toàn vẹn, Sử
        // dụng & Tín dụng). EN + VI được biên soạn ở đây; 14 ngôn ngữ còn lại
        // tự rơi về EN qua deepMerge trong i18n/index.ts.
        immutable_audit_trails: {
            nav_group_label: 'Kiểm toán & Chứng cứ',
            nav_settings: 'Cài đặt',
            nav_status: 'Trạng thái bằng chứng',
            nav_integrity_center: 'Trung tâm toàn vẹn',
            nav_usage: 'Sử dụng & Tín dụng',
            settings_title: 'Nhật ký kiểm toán bất biến — Cài đặt',
            settings_subtitle: 'Cài đặt cho mỗi tổ chức của tiện ích Nhật ký kiểm toán bất biến.',
            settings_banner: 'Tiện ích Nhật ký kiểm toán bất biến chưa được bật cho tổ chức của bạn. Bật tại đây để bắt đầu neo bằng chứng cho các sự kiện kiểm toán Hạng A và Hạng B.',
            status_title: 'Nhật ký kiểm toán bất biến — Trạng thái bằng chứng',
            status_subtitle: 'Mối quan hệ bằng chứng cho từng sự kiện qua các phân hệ.',
            status_banner: 'Tiện ích Nhật ký kiểm toán bất biến chưa được bật cho tổ chức của bạn. Vào Cài đặt để bật.',
            integrity_center_title: 'Nhật ký kiểm toán bất biến — Trung tâm toàn vẹn',
            integrity_center_subtitle: 'Xác minh bằng chứng và xuất Gói toàn vẹn.',
            integrity_center_banner: 'Tiện ích Nhật ký kiểm toán bất biến chưa được bật cho tổ chức của bạn. Vào Cài đặt để bật trước khi chạy xác minh hoặc xuất Gói toàn vẹn.',
            usage_title: 'Nhật ký kiểm toán bất biến — Sử dụng & Tín dụng',
            usage_subtitle: 'Số dư tín dụng, mua gói và lịch sử sử dụng.',
            usage_banner: 'Bật Nhật ký kiểm toán bất biến trong Cài đặt để bắt đầu sử dụng tín dụng bằng chứng.',
            module_tips_placeholder: 'Mẹo và hướng dẫn cho giao diện này có trong trung tâm trợ giúp.',
            column_label: 'Bằng chứng',
            no_proof_aria: 'Chưa có bằng chứng',
            proof_status_receipt_label: 'biên nhận {id}',
            in_progress_hint: 'Đang xử lý — tự động cập nhật',
            status_pills: {
                pending: 'Chờ xử lý',
                submitted: 'Đã gửi',
                anchored: 'Đã neo',
                confirmed: 'Đã xác nhận',
                retrying: 'Đang thử lại',
                paused_cap: 'Tạm dừng (hết hạn mức)',
                failed: 'Thất bại',
                failed_auth: 'Lỗi xác thực',
            },
            status_tooltips: {
                pending: 'Đang chờ — đã xếp hàng để gửi tới dịch vụ bằng chứng. Trạng thái sẽ chuyển sang Đã gửi trong giây lát; bạn không cần thao tác gì.',
                submitted: 'Đã gửi — sự kiện của bạn đã được gửi tới dịch vụ bằng chứng. Với chế độ Lô (Batch), hệ thống đang chờ niêm phong và neo lên blockchain. Tự động cập nhật, không cần thao tác.',
                anchored: 'Đã neo — lô đã được ghi lên blockchain và đang chờ xác nhận cuối cùng. Tự động cập nhật, không cần thao tác.',
                confirmed: 'Đã xác nhận — bằng chứng đã được neo lên blockchain và có thể xác minh.',
                retrying: 'Đang thử lại — đã xảy ra lỗi tạm thời. Bộ điều phối đang tự động thử lại; bạn không cần thao tác.',
                paused_cap: 'Tạm dừng — đã đạt hạn mức tín dụng bằng chứng hàng tháng. Hãy nạp thêm tín dụng hoặc chờ tới kỳ thanh toán tiếp theo.',
                failed: 'Thất bại — việc neo không thành công. Hệ thống không tự động thử lại; hãy liên hệ hỗ trợ.',
                failed_auth: 'Lỗi xác thực — dịch vụ bằng chứng từ chối thông tin xác thực. Vui lòng kiểm tra trang Cài đặt Nhật ký kiểm toán bất biến.',
            },
            mode_pills: {
                direct: 'Trực tiếp',
                batch: 'Theo lô',
            },
            drawer: {
                title: 'Chi tiết bằng chứng',
                close: 'Đóng',
                section_proof: 'Bằng chứng',
                section_batch: 'Thành viên lô',
                status: 'Trạng thái',
                proof_reference: 'Mã tham chiếu bằng chứng',
                receipt_id: 'Mã biên nhận',
                taxonomy_class: 'Lớp phân loại',
                units_consumed: 'Đơn vị đã dùng',
                created_at: 'Ngày tạo',
                verification_ref: 'Tham chiếu xác minh trên chuỗi',
                chain: 'Chuỗi',
                tx_hash: 'Mã băm giao dịch',
                block_ref: 'Tham chiếu khối',
                batch_reference: 'Mã tham chiếu lô',
                leaf_index: 'Vị trí lá',
                local_event_hash: 'Mã băm sự kiện cục bộ',
                show_inclusion: 'Hiển thị đường dẫn bao hàm',
                hide_inclusion: 'Ẩn đường dẫn bao hàm',
                privacy_note: 'Tải trọng đã được băm; không có dữ liệu cá nhân nào rời khỏi ComplianceOne cho sự kiện này.',
                verify_now: 'Xác minh ngay',
                verify_pending: 'Đang xác minh…',
                verify_verified: 'Đã xác minh — kiểm tra cục bộ và trên chuỗi đều đạt.',
                verify_issue_prefix: 'Vấn đề xác minh: ',
                verify_failed: 'Cuộc gọi xác minh thất bại.',
                verify_result_prefix: 'Kết quả xác minh: ',
                verify_pending_note: 'Chưa thể xác minh: chứng minh này vẫn đang chờ neo lên chuỗi. Hãy thử lại sau khi lô (batch) được niêm phong.',
                awaiting_anchor_note: 'Chứng minh này thuộc một lô đang mở. Việc xác minh sẽ khả dụng sau khi lô được niêm phong và neo trên chuỗi — thường trong khoảng cửa sổ lô đã cấu hình cho tổ chức. Trạng thái sẽ tự động cập nhật.',
                terminal_error_note: 'Chứng minh này không neo được và hệ thống không tự động thử lại; xác minh thủ công hiện chưa có dữ liệu để đối chiếu.',
            },
            integrity_center: {
                section_run: 'Chạy xác minh',
                section_progress: 'Tiến độ chạy',
                section_issues: 'Vấn đề',
                period_start: 'Ngày bắt đầu',
                period_end: 'Ngày kết thúc',
                module_filter: 'Phân hệ (cách nhau bằng dấu phẩy, tùy chọn)',
                modules_placeholder: 'rights-requests, incidents',
                run_button: 'Chạy xác minh',
                export_button: 'Xuất Gói toàn vẹn',
                export_success: 'Đã xuất Gói toàn vẹn.',
                export_failed: 'Xuất thất bại.',
                empty_disabled: 'Bật Nhật ký kiểm toán bất biến trong Cài đặt để chạy các đợt xác minh.',
                error_period_required: 'Hãy chọn ngày bắt đầu và kết thúc.',
                error_start_run: 'Không khởi chạy được.',
                processed: 'Đã xử lý: {processed} trên {total}',
                col_verdict: 'Kết quả',
                col_count: 'Số lượng',
                col_proof_link: 'Liên kết bằng chứng',
                col_module: 'Phân hệ',
                col_event_type: 'Loại sự kiện',
                col_expected: 'Mã băm mong đợi',
                col_recomputed: 'Mã băm tính lại',
                col_raised_at: 'Phát sinh lúc',
                any_verdict: 'Mọi kết quả',
                no_issues: 'Không có vấn đề nào.',
            },
            settings_page: {
                load_error: 'Không tải được cài đặt.',
                save: 'Lưu',
                save_success: 'Đã lưu cài đặt.',
                save_error: 'Lưu thất bại.',
                discard: 'Hủy thay đổi',
                read_only_banner: 'Bạn chỉ có quyền xem. Liên hệ Quản trị nền tảng để thực hiện thay đổi.',
                section_status: 'Trạng thái & kích hoạt',
                enabled_label: 'Bật tiện ích',
                enabled_help: 'Khi bật, mọi sự kiện kiểm toán Tier-A và Tier-B sẽ được băm và neo.',
                section_mode: 'Chế độ bằng chứng mặc định',
                mode_direct: 'Trực tiếp (mỗi sự kiện một neo)',
                mode_batch: 'Theo lô (neo gốc Merkle cho mỗi nhóm)',
                mode_hybrid: 'Kết hợp (mặc định theo lớp trong registry)',
                batch_window_label: 'Cửa sổ lô (phút, 1–60)',
                section_taxonomy: 'Phân loại sự kiện được bảo vệ',
                taxonomy_help: 'Ghi đè theo từng lớp sự kiện. Tier A → chế độ trực tiếp, Tier B → chế độ lô, Tắt → không bằng chứng.',
                taxonomy_search: 'Tìm ghi đè',
                taxonomy_reset: 'Đặt lại mặc định',
                taxonomy_event_class: 'Lớp sự kiện',
                taxonomy_override: 'Ghi đè',
                taxonomy_actions: 'Thao tác',
                taxonomy_clear: 'Xóa',
                taxonomy_no_overrides: 'Không có ghi đè — đang dùng mặc định từ registry.',
                taxonomy_add_class: 'event_class.code',
                taxonomy_add: 'Thêm ghi đè',
                section_caps: 'Hạn mức & giới hạn',
                cap_label: 'Hạn mức tháng (đơn vị; trống = không giới hạn)',
                warn_label: 'Ngưỡng cảnh báo (đơn vị; phải nhỏ hơn hạn mức)',
                auto_pause_label: 'Tự động tạm dừng bằng chứng mới khi đạt hạn mức',
                section_credentials: 'Thông tin xác thực',
                credential_id: 'Mã thông tin xác thực',
                credential_rotated_at: 'Lần xoay vòng cuối',
                rotate_button: 'Xoay vòng thông tin xác thực',
                rotate_success: 'Đã xoay vòng. Thông tin xác thực cũ còn hiệu lực thêm {n} phút.',
                rotate_failed: 'Xoay vòng thất bại.',
                rotate_modal_title: 'Xoay vòng thông tin xác thực AesirX?',
                rotate_modal_body: 'Xoay vòng tạo thông tin xác thực mới. Thông tin xác thực cũ vẫn được AesirX chấp nhận trong cửa sổ ân hạn 60 phút để các worker đang chạy hoàn tất công việc. Sau 60 phút, thông tin cũ bị thu hồi.',
                rotate_modal_confirm: 'Xoay vòng ngay',
                tier_a_off_modal_title: 'Tắt bằng chứng cho lớp sự kiện này?',
                tier_a_off_modal_body: 'Đặt một lớp sự kiện thành "Tắt" sẽ ngừng việc neo các sự kiện đó. §6 trong tài liệu kiến trúc giải thích hệ quả pháp lý: sự kiện Tier-A liên quan đến cơ quan quản lý; tắt chúng có thể phá vỡ tính phòng vệ của nhật ký kiểm toán.',
                tier_a_off_modal_confirm: 'Tôi hiểu — áp dụng ghi đè',
                error_warn_lt_cap: 'Ngưỡng cảnh báo phải nhỏ hơn hạn mức tháng.',
                error_window_range: 'Cửa sổ lô phải nằm trong khoảng 1–60 phút.',
                error_run_in_progress: 'Một đợt xác minh đang chạy; chưa thể tắt tiện ích lúc này.',
            },
            status_page: {
                filter_status: 'Trạng thái',
                filter_mode: 'Chế độ bằng chứng',
                filter_module: 'Phân hệ',
                filter_source_collection: 'Nguồn',
                filter_from_date: 'Từ',
                filter_to_date: 'Đến',
                filter_search: 'Tìm kiếm',
                any_status: 'Mọi trạng thái',
                any_mode: 'Mọi chế độ',
                col_module: 'Phân hệ',
                col_event_type: 'Loại sự kiện',
                col_proof_status: 'Trạng thái',
                col_proof_mode: 'Chế độ',
                col_created_at: 'Ngày tạo',
                col_units: 'Đơn vị',
                empty_disabled: 'Tiện ích Nhật ký kiểm toán bất biến chưa được bật cho tổ chức của bạn. Vào Cài đặt để bật.',
                empty_enabled_no_rows: 'Không có bằng chứng nào khớp với bộ lọc hiện tại.',
                export_csv: 'Xuất CSV',
                export_xlsx: 'Xuất XLSX',
                export_success: 'Xuất hoàn tất',
                export_failed: 'Xuất thất bại',
            },
            usage_page: {
                section_alerts: 'Cảnh báo',
                alert_dismiss: 'Bỏ qua',
                alert_dismiss_aria: 'Bỏ qua cảnh báo {id}',
                alert_dismissed: 'Đã bỏ qua cảnh báo',
                alert_dismiss_failed: 'Bỏ qua cảnh báo thất bại',
                section_balance: 'Số dư tín dụng',
                balance_label: 'Tín dụng còn lại',
                balance_hint: 'Số đơn vị còn lại (1 đơn vị = 1 bằng chứng cho sự kiện được bảo vệ).',
                section_current_month: 'Tháng hiện tại',
                consumed_label: 'Đã tiêu thụ',
                granted_label: 'Đã cấp',
                refunded_label: 'Đã hoàn',
                net_label: 'Ròng',
                section_history: 'Lịch sử sử dụng',
                history_kind: 'Loại',
                history_units: 'Đơn vị',
                history_balance_after: 'Số dư sau',
                history_notes: 'Ghi chú',
                history_at: 'Thời điểm',
                cap_warning_banner: 'Bạn đã vượt ngưỡng cảnh báo cho tháng thanh toán này. Hãy xem xét nạp thêm tín dụng.',
                cap_paused_banner: 'Đã đạt hạn mức tháng. Việc gửi bằng chứng tạm dừng cho đến tháng sau hoặc cho đến khi hạn mức được tăng.',
                section_redeem: 'Đổi gói tín dụng',
                redeem_purchase_id: 'Số hóa đơn',
                redeem_package: 'Gói',
                redeem_button: 'Đổi',
                redeem_pending: 'Đang đổi…',
                redeem_success: 'Đã đổi tín dụng',
                redeem_failed: 'Đổi không thành công',
                redeem_option_template: '{name} — {units} {units_label} — {price}',
                redeem_option_units: 'đơn vị',
                alert_dismissing: 'Đang đóng…',
                // fix-sprint-20260515-2129
                alert_kind: {
                    cap_reached: 'Đã đạt hạn mức tháng',
                    low_balance: 'Số dư thấp',
                    auth_failure: 'Xác thực thất bại',
                    merkle_mismatch: 'Sai lệch Merkle',
                    batch_terminal_failure: 'Lô gặp lỗi vĩnh viễn',
                    direct_terminal_failure: 'Gửi trực tiếp gặp lỗi vĩnh viễn',
                },
                usage_kind: {
                    consume: 'Tiêu thụ',
                    refund: 'Hoàn lại',
                    grant: 'Cấp',
                    adjustment: 'Điều chỉnh',
                    reservation: 'Tạm giữ',
                    credit_grant: 'Cấp tín dụng',
                    consumption: 'Tiêu thụ cho bằng chứng',
                    refund_failed_proof: 'Hoàn lại (bằng chứng không thành công)',
                },
                package_starter: 'Khởi đầu',
                package_growth: 'Tăng trưởng',
                package_enterprise: 'Doanh nghiệp',
                // Sprint 48.5.x — self-service "Buy More" billing (Flow A + B).
                buy_more: {
                    buy_button: 'Mua thêm tín dụng',
                    purchase_title: 'Mua thêm tín dụng',
                    purchase_subtitle: 'Chọn một gói. Bạn sẽ được chuyển đến trang thanh toán an toàn của Stripe và hóa đơn sẽ được gửi qua email.',
                    checkout_button: 'Tiếp tục thanh toán',
                    checkout_pending: 'Đang mở trang thanh toán…',
                    cancel_button: 'Hủy',
                    purchase_error: 'Không thể bắt đầu thanh toán. Vui lòng thử lại sau giây lát.',
                    redeem_subtitle: 'Đã thanh toán? Chọn gói bạn đã mua và nhập mã hóa đơn từ email của bạn để thêm tín dụng.',
                    error_not_found: 'Không tìm thấy hóa đơn nào với số đó. Vui lòng kiểm tra Số hóa đơn và thử lại.',
                    error_not_paid: 'Hóa đơn này chưa được đánh dấu là đã thanh toán.',
                    error_org_mismatch: 'Hóa đơn này không được phát hành cho tổ chức của bạn.',
                    error_package_mismatch: 'Hóa đơn này không khớp với gói đã chọn.',
                    error_billing_unavailable: 'Không thể kết nối đến dịch vụ thanh toán. Vui lòng thử lại sau giây lát.',
                },
                cap_over_banner: 'Đã đạt hạn mức tháng. Việc gửi bằng chứng vẫn tiếp tục vì chế độ tạm dừng khi đạt hạn mức đang tắt.',
                resume_paused_button: 'Tiếp tục các bằng chứng đang tạm dừng',
                resume_paused_hint: 'Các bằng chứng bị giữ lại khi đạt hạn mức tháng sẽ tự được giải phóng khi hạn mức được tăng hoặc bỏ, hoặc khi tắt chế độ tạm dừng khi đạt hạn mức. Hãy dùng nút này khi tháng mới đã bắt đầu.',
                resume_paused_success: 'Đã giải phóng {count} bằng chứng đang tạm dừng.',
                resume_paused_none: 'Không có bằng chứng tạm dừng nào để giải phóng.',
                resume_paused_failed: 'Không thể giải phóng các bằng chứng đang tạm dừng.',
            },
        },
        files_config: {
            title: 'Cấu hình tệp tin',
            subtitle: 'Cấu hình giới hạn tải tệp, chính sách lưu trữ và ghi đè theo từng loại chủ sở hữu cho hệ thống tệp đính kèm của nền tảng.',
            section_global: 'Mặc định toàn tổ chức',
            section_global_help: 'Các giới hạn này áp dụng cho mọi tệp do người dùng trong tổ chức của bạn tải lên, trừ khi có ghi đè theo loại chủ sở hữu bên dưới.',
            section_overrides: 'Ghi đè theo loại chủ sở hữu',
            section_overrides_help: 'Ghi đè giới hạn toàn cục cho một loại chủ sở hữu cụ thể. Giá trị theo loại chủ sở hữu luôn được ưu tiên hơn cài đặt toàn cục.',
            max_file_size_label: 'Kích thước tệp tối đa',
            max_file_size_hint: 'Cho mỗi lần tải lên (MiB)',
            max_total_attachments_label: 'Tổng số tệp đính kèm tối đa',
            max_total_attachments_hint: 'Tính trên toàn tổ chức',
            max_total_size_label: 'Tổng dung lượng tối đa',
            max_total_size_hint: 'Tính trên toàn tổ chức (MiB)',
            allowed_mime_types_label: 'Loại tệp được phép',
            allowed_mime_types_placeholder: 'Chọn loại MIME',
            retention_days_label: 'Thời hạn lưu trữ (ngày)',
            retention_days_hint: 'Thời gian phải giữ tệp trước khi đủ điều kiện xóa. Để trống nếu không có chính sách lưu trữ.',
            legal_hold_label: 'Lưu giữ theo pháp lý',
            legal_hold_hint: 'Khi bật, việc xóa vĩnh viễn tệp thuộc loại chủ sở hữu này sẽ yêu cầu quyền ghi đè lưu giữ pháp lý và sự đồng ý rõ ràng của người vận hành.',
            save: 'Lưu thay đổi',
            saving: 'Đang lưu…',
            reset: 'Đặt lại',
            save_success: 'Đã lưu cài đặt',
            save_version_conflict: 'Một người vận hành khác đã cập nhật các cài đặt này trong khi bạn đang chỉnh sửa nên thay đổi này bị từ chối. Các giá trị đã lưu của họ đã được đọc lại và nội dung bạn nhập vẫn còn nguyên — hãy áp dụng lại thay đổi của bạn để ghi đè lên giá trị của họ.',
            save_version_conflict_unreadable: 'Một người vận hành khác đã cập nhật các cài đặt này trong khi bạn đang chỉnh sửa nên thay đổi này bị từ chối, và cũng không đọc lại được các giá trị đã lưu của họ. Nội dung bạn nhập vẫn còn nguyên; việc tải lại trang trong trình duyệt sẽ hiển thị giá trị của họ và loại bỏ của bạn.',
            empty_state_title: 'Đang dùng mặc định nền tảng',
            empty_state_body: 'Tổ chức của bạn hiện đang chạy trên chính sách tệp mặc định của nền tảng. Hãy chỉnh sửa bất kỳ giá trị nào bên dưới để tạo ghi đè cấp tổ chức.',
            read_only_banner: 'Bạn có quyền chỉ đọc đối với cấu hình tệp. Liên hệ Quản trị viên Nền tảng để thực hiện thay đổi.',
            owner_type_default_badge: 'Mặc định',
            owner_type_overridden_badge: 'Đã ghi đè',
            owner_type_label: 'Loại chủ sở hữu',
            owner_type_collapse: 'Thu gọn',
            owner_type_expand: 'Mở rộng',
            override_save: 'Lưu ghi đè',
            override_remove: 'Xóa ghi đè',
            mime_labels: {
                'application/pdf': 'Tài liệu PDF',
                'image/png': 'Hình ảnh PNG',
                'image/jpeg': 'Hình ảnh JPEG',
                'image/jpg': 'Hình ảnh JPG',
                'application/msword': 'Tài liệu Word (cũ)',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Tài liệu Word',
                'application/vnd.ms-excel': 'Bảng tính Excel (cũ)',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Bảng tính Excel',
                'text/csv': 'Tệp CSV',
                'text/plain': 'Văn bản thuần',
                'message/rfc822': 'Thư điện tử',
            },
            global_legal_hold_label: 'Phong toả pháp lý toàn tổ chức',
            global_legal_hold_hint: 'Khi bật, KHÔNG tệp nào thuộc bất kỳ loại chủ sở hữu nào có thể bị xóa vĩnh viễn, trừ khi người vận hành có quyền legal_hold_override và xác nhận thực hiện.',
            global_retention_days_label: 'Thời hạn lưu trữ mặc định (ngày)',
            global_retention_days_hint: 'Thời gian tệp phải được lưu giữ trước khi đủ điều kiện xóa. Để trống nếu không áp dụng chính sách lưu trữ. Các thiết lập riêng theo loại chủ sở hữu bên dưới có thể quy định chặt hơn.',
            global_abandoned_grace_label: 'Thời gian chờ trước khi dọn tệp tải lên bị bỏ dở (giờ)',
            global_abandoned_grace_hint: 'Khoảng thời gian một tệp chưa được bản ghi nào đã lưu nhận làm của mình được giữ nguyên trước khi tác vụ dọn tệp tải lên bị bỏ dở xóa mềm tệp đó. Tối thiểu 24 giờ, để biểu mẫu đang mở không bị ảnh hưởng.',
            global_abandoned_grace_invalid: 'Nhập số giờ nguyên từ {min} đến {max}.',
        },
        files_browser: {
            title: 'Trình duyệt tệp',
            subtitle: 'Tìm kiếm, lọc và quản lý mọi tệp đính kèm đã được tải lên trên toàn tổ chức.',
            filter_owner_type: 'Loại chủ sở hữu',
            filter_uploader: 'Người tải lên',
            filter_from: 'Tải lên sau',
            filter_to: 'Tải lên trước',
            filter_size_min: 'Kích thước tối thiểu (MiB)',
            filter_size_max: 'Kích thước tối đa (MiB)',
            filter_mime: 'Loại tệp',
            filter_deleted_state: 'Trạng thái xóa',
            filter_deleted_any: 'Tất cả tệp',
            filter_deleted_only: 'Chỉ tệp đã xóa',
            filter_deleted_exclude: 'Loại trừ tệp đã xóa',
            filter_orphaned: 'Chỉ tệp mồ côi',
            filter_search_placeholder: 'Tìm theo tên tệp…',
            filter_apply: 'Áp dụng bộ lọc',
            filter_clear: 'Xóa bộ lọc',
            col_filename: 'Tên tệp',
            col_owner_type: 'Loại chủ sở hữu',
            col_owner_entity: 'Chủ sở hữu',
            col_uploader: 'Người tải lên',
            col_uploaded_at: 'Ngày tải lên',
            col_size: 'Kích thước',
            col_mime: 'Loại',
            col_state: 'Trạng thái',
            col_actions: 'Hành động',
            state_active: 'Đang hoạt động',
            state_deleted: 'Đã xóa',
            state_orphaned: 'Mồ côi',
            action_view_detail: 'Xem chi tiết',
            action_download: 'Tải xuống',
            // Sprint 47.5.3b — Forseti AI redline review link.
            action_ai_edits: 'Chỉnh sửa AI',
            action_soft_delete: 'Xóa mềm',
            action_restore: 'Khôi phục',
            action_hard_delete: 'Xóa vĩnh viễn',
            bulk_soft_delete: 'Xóa mềm các mục đã chọn',
            bulk_export_csv: 'Xuất CSV',
            bulk_select_all: 'Chọn tất cả',
            reason_label: 'Lý do',
            reason_min_10_chars: 'Bắt buộc phải nhập lý do (ít nhất 10 ký tự)',
            reason_min_20_chars: 'Bắt buộc phải nhập lý do (ít nhất 20 ký tự)',
            legal_hold_override_label: 'Ghi đè lưu giữ pháp lý',
            legal_hold_override_warning: 'Tệp này đang trong tình trạng lưu giữ pháp lý. Việc xóa vĩnh viễn sẽ được ghi nhận trong nhật ký kiểm toán cùng với lý do và cờ ghi đè của bạn.',
            empty_state_title: 'Không có tệp nào khớp với bộ lọc',
            empty_state_body: 'Hãy điều chỉnh bộ lọc để xem kết quả, hoặc xóa bộ lọc để xem tất cả tệp.',
            pagination_prev: 'Trước',
            pagination_next: 'Tiếp',
            pagination_page: 'Trang {page} / {total}',
            pagination_size_label: 'Mỗi trang',
            pagination_total: 'Tổng: {count}',
            toast_soft_deleted: 'Đã xóa mềm tệp',
            toast_restored: 'Đã khôi phục tệp',
            toast_hard_deleted: 'Đã xóa vĩnh viễn tệp',
            toast_bulk_deleted: 'Đã xóa {count} tệp',
            toast_error: 'Thao tác thất bại',
            confirm_soft_delete_title: 'Xóa mềm tệp',
            confirm_restore_title: 'Khôi phục tệp',
            confirm_hard_delete_title: 'Xóa vĩnh viễn tệp',
            confirm_bulk_soft_delete_title: 'Xóa mềm các tệp đã chọn',
            confirm_submit: 'Xác nhận',
            confirm_cancel: 'Hủy',
            col_view_entity: 'Xem',
        },
        files_detail: {
            modal_title: 'Chi tiết tệp',
            close: 'Đóng',
            meta_filename: 'Tên tệp',
            meta_size: 'Kích thước',
            meta_mime: 'Loại',
            meta_owner_type: 'Loại chủ sở hữu',
            meta_owner_entity: 'Thực thể sở hữu',
            meta_uploader: 'Người tải lên',
            meta_uploaded_at: 'Ngày tải lên',
            meta_storage_path: 'Đường dẫn lưu trữ',
            meta_deleted_state: 'Trạng thái xóa',
            audit_section_title: 'Nhật ký kiểm toán',
            audit_load_more: 'Tải thêm sự kiện',
            audit_empty: 'Không có sự kiện kiểm toán nào được ghi nhận cho tệp này.',
            audit_config_changed: 'Đã thay đổi cấu hình',
            audit_soft_deleted: 'Đã xóa mềm',
            audit_restored: 'Đã khôi phục',
            audit_hard_deleted: 'Đã xóa vĩnh viễn',
            audit_downloaded: 'Đã tải xuống',
            audit_quota_breached: 'Đã thử vượt quá hạn ngạch',
            audit_owner_type_download_denied: 'Đã từ chối truy xuất',
            /*
             * The audit row as ONE composed string, not three JSX fragments glued
             * with English.
             *
             * The row used to render `{' by '}` and `{' on '}` as literals, so every
             * locale read "Endgültig gelöscht by Anna Schmidt on 11. Apr 2026" — the
             * event label and the actor came from `t` and the user map, the
             * connective words did not. A locale that orders these differently
             * cannot be rendered correctly by concatenation at all, which is why
             * this is a template rather than two `by`/`on` keys.
             *
             * `{actor}` is a link, so the page splits this on the placeholders and
             * substitutes nodes rather than calling `.replace`.
             */
            audit_row: '{event} bởi {actor} vào {at}',
            action_download: 'Tải xuống',
            action_soft_delete: 'Xóa mềm',
            action_restore: 'Khôi phục',
            action_hard_delete: 'Xóa vĩnh viễn',
            effective_settings_title: 'Chính sách hiệu lực',
            effective_max_file_size: 'Kích thước tệp tối đa',
            effective_retention_days: 'Lưu trữ',
            effective_legal_hold: 'Lưu giữ pháp lý',
            effective_legal_hold_yes: 'Đang áp dụng',
            effective_legal_hold_no: 'Không',
        },
        files_dashboard: {
            title: 'Bảng điều khiển tệp',
            subtitle: 'Sử dụng dung lượng, tăng trưởng và các tệp mồ côi trên toàn tổ chức.',
            kpi_total_files: 'Tổng số tệp',
            kpi_total_size: 'Tổng dung lượng',
            kpi_near_quota: 'Sử dụng hạn ngạch',
            kpi_orphaned: 'Tệp mồ côi',
            chart_by_owner_type: 'Tệp theo loại chủ sở hữu',
            chart_growth_30d: 'Tăng trưởng 30 ngày',
            toggle_count: 'Theo số lượng',
            toggle_size: 'Theo dung lượng',
            orphaned_panel_title: 'Tệp mồ côi (top 20)',
            orphaned_view_all: 'Xem tất cả tệp mồ côi',
            orphaned_empty: 'Không tìm thấy tệp mồ côi nào.',
            growth_empty: 'Không có hoạt động tải lên trong 30 ngày qua.',
            retention_n_days: '{days} ngày',
            retention_none: 'Không có chính sách',
        },
    },
    // ---------- Nhãn danh mục bài viết trợ giúp (Sprint 44.1.9.5) ----------
    category_labels: {
        'user-guide': 'Hướng dẫn người dùng',
        'admin-guide': 'Hướng dẫn quản trị',
        'getting-started': 'Bắt đầu',
        faq: 'Câu hỏi thường gặp',
    },
    tag_labels: {
        faq: 'Câu hỏi thường gặp',
        dsar: 'DSAR',
        dsr: 'DSR',
        cmp: 'CMP',
        hmac: 'HMAC',
        sso: 'SSO',
        mfa: 'MFA',
        rbac: 'RBAC',
        api: 'API',
        'api-keys': 'Khóa API',
        webhook: 'Webhook',
        webhooks: 'Webhook',
        admin: 'Quản trị',
        aesirx: 'AesirX',
        purposes: 'Mục đích',
        preferences: 'Tùy chọn',
        onboarding: 'Hướng dẫn sử dụng',
        'first-steps': 'Bước đầu tiên',
        login: 'Đăng nhập',
        navigation: 'Điều hướng',
        users: 'Người dùng',
        user: 'Người dùng',
        roles: 'Vai trò',
        role: 'Vai trò',
        'access-control': 'Kiểm soát truy cập',
        'access-management': 'Quản lý truy cập',
        permissions: 'Quyền',
        permission: 'Quyền',
        consent: 'Đồng thuận',
        'consent-management': 'Quản lý đồng thuận',
        privacy: 'Quyền riêng tư',
        pdpl: 'PDPL',
        gdpr: 'GDPR',
        iso27001: 'ISO 27001',
        audit: 'Kiểm toán',
        auditing: 'Kiểm toán',
        breach: 'Vi phạm',
        incident: 'Sự cố',
        incidents: 'Sự cố',
        notification: 'Thông báo',
        notifications: 'Thông báo',
        reporting: 'Báo cáo',
        risk: 'Rủi ro',
        vendor: 'Nhà cung cấp',
        vendors: 'Nhà cung cấp',
        'vendor-risk': 'Rủi ro nhà cung cấp',
        assessment: 'Đánh giá',
        assessments: 'Đánh giá',
        dpia: 'DPIA',
        'cross-border': 'Xuyên biên giới',
        transfer: 'Chuyển giao',
        transfers: 'Chuyển giao',
        deletion: 'Xóa',
        retention: 'Lưu trữ',
        'data-mapping': 'Bản đồ dữ liệu',
        discovery: 'Khám phá',
        classification: 'Phân loại',
        workflow: 'Quy trình',
        workflows: 'Quy trình',
        template: 'Mẫu',
        templates: 'Mẫu',
        catalog: 'Danh mục',
        monitoring: 'Giám sát',
        tasks: 'Nhiệm vụ',
        task: 'Nhiệm vụ',
        'task-management': 'Quản lý nhiệm vụ',
        organizations: 'Tổ chức',
        org: 'Tổ chức',
        governance: 'Quản trị',
        compliance: 'Tuân thủ',
        forms: 'Biểu mẫu',
        form: 'Biểu mẫu',
        connectors: 'Kết nối',
        connector: 'Kết nối',
        integration: 'Tích hợp',
        integrations: 'Tích hợp',
        security: 'Bảo mật',
        encryption: 'Mã hóa',
        backup: 'Sao lưu',
        recovery: 'Khôi phục',
        maintenance: 'Bảo trì',
        settings: 'Cài đặt',
        configuration: 'Cấu hình',
        sla: 'SLA',
        escalation: 'Leo thang',
        remediation: 'Khắc phục',
        evidence: 'Bằng chứng',
        'case-management': 'Quản lý vụ việc',
        profile: 'Hồ sơ',
        delegation: 'Ủy quyền',
        'service-accounts': 'Tài khoản dịch vụ',
        license: 'Giấy phép',
        'license-management': 'Quản lý giấy phép',
        plan: 'Gói',
        plans: 'Gói',
        dashboard: 'Bảng điều khiển',
        'web-consent': 'Đồng thuận web',
        'partner-marketplace': 'Không gian đối tác',
        partner: 'Đối tác',
        partners: 'Đối tác',
        deliverables: 'Sản phẩm bàn giao',
        'service-tiers': 'Cấp dịch vụ',
        'support-tickets': 'Phiếu hỗ trợ',
        'audit-trail': 'Nhật ký kiểm toán',
        'first-time-setup': 'Cài đặt lần đầu',
        setup: 'Cài đặt',
        quickstart: 'Bắt đầu nhanh',
        tour: 'Tour hướng dẫn',
        tours: 'Tour hướng dẫn',
        'sample-data': 'Dữ liệu mẫu',
        'data-subject': 'Chủ thể dữ liệu',
        'data-subjects': 'Chủ thể dữ liệu',
        pseudonymous: 'Bí danh',
        identified: 'Được xác định',
        'help-center': 'Trung tâm trợ giúp',
        article: 'Bài viết',
        articles: 'Bài viết',
        search: 'Tìm kiếm',
        'platform-settings': 'Cài đặt nền tảng',
        'platform-config': 'Cấu hình nền tảng',
        'module-config': 'Cấu hình phân hệ',
        'module-configuration': 'Cấu hình phân hệ',
        'rights-requests': 'Yêu cầu quyền',
        'access-accountability': 'Trách nhiệm truy cập',
        'data-discovery': 'Khám phá dữ liệu',
        'incident-ops': 'Vận hành sự cố',
        'deletion-orchestration': 'Điều phối xóa',
        'compliance-forms': 'Biểu mẫu tuân thủ',
        'program-governance': 'Quản trị chương trình',
        localization: 'Bản địa hóa',
        'privacy-scanner': 'Quét quyền riêng tư',
        'consent-properties': 'Thuộc tính đồng thuận',
        acceptances: 'Chấp thuận',
        access: 'Truy cập',
        'access-review': 'Rà soát truy cập',
        'access-reviews': 'Rà soát truy cập',
        accountability: 'Trách nhiệm giải trình',
        acknowledgment: 'Xác nhận',
        'action-plans': 'Kế hoạch hành động',
        activation: 'Kích hoạt',
        activations: 'Kích hoạt',
        'active-response': 'Phản ứng chủ động',
        activity: 'Hoạt động',
        adequacy: 'Mức độ đầy đủ',
        'admin-guide': 'Hướng dẫn quản trị',
        aggregation: 'Tổng hợp',
        agreements: 'Thỏa thuận',
        ai: 'AI',
        alerts: 'Cảnh báo',
        analytics: 'Phân tích',
        anchoring: 'Neo gắn',
        approval: 'Phê duyệt',
        approvals: 'Phê duyệt',
        apps: 'Ứng dụng',
        assets: 'Tài sản',
        assignments: 'Phân công',
        attestation: 'Chứng thực',
        'audit-log': 'Nhật ký kiểm toán',
        'audit-pack': 'Gói kiểm toán',
        authentication: 'Xác thực',
        authority: 'Cơ quan có thẩm quyền',
        'auto-play': 'Tự động phát',
        automated: 'Tự động',
        automation: 'Tự động hóa',
        baseline: 'Cơ sở',
        batches: 'Lô',
        bidirectional: 'Hai chiều',
        bilingual: 'Song ngữ',
        bindings: 'Ràng buộc',
        blockchain: 'Chuỗi khối',
        board: 'Ban điều hành',
        brand: 'Thương hiệu',
        brds: 'BRDs',
        'break-glass': 'Truy cập khẩn cấp',
        builder: 'Trình tạo',
        bulk: 'Hàng loạt',
        'bulk-sync': 'Đồng bộ hàng loạt',
        bundles: 'Gói',
        calendar: 'Lịch',
        campaigns: 'Chiến dịch',
        cases: 'Vụ việc',
        categories: 'Danh mục',
        category: 'Danh mục',
        certification: 'Chứng nhận',
        chain: 'Chuỗi',
        change: 'Thay đổi',
        'change-awareness': 'Nhận thức thay đổi',
        'change-log': 'Nhật ký thay đổi',
        'change-management': 'Quản lý thay đổi',
        'change-requests': 'Yêu cầu thay đổi',
        'cmp-validation': 'Xác thực CMP',
        collection: 'Thu thập',
        comparison: 'So sánh',
        completeness: 'Tính đầy đủ',
        completion: 'Hoàn thành',
        'compliance-posture': 'Tư thế tuân thủ',
        'compliance-proof': 'Bằng chứng tuân thủ',
        'compliance-reviews': 'Rà soát tuân thủ',
        config: 'Cấu hình',
        confirmation: 'Xác nhận',
        conflicts: 'Xung đột',
        consolidation: 'Hợp nhất',
        continuous: 'Liên tục',
        contracts: 'Hợp đồng',
        controls: 'Kiểm soát',
        cookies: 'Cookie',
        cooperation: 'Hợp tác',
        coordination: 'Phối hợp',
        'corporate-governance': 'Quản trị doanh nghiệp',
        'corrective-actions': 'Hành động khắc phục',
        coverage: 'Phạm vi',
        'credential-vault': 'Kho thông tin đăng nhập',
        credentials: 'Thông tin đăng nhập',
        cycles: 'Chu kỳ',
        dashboards: 'Bảng điều khiển',
        'data-assets': 'Tài sản dữ liệu',
        'data-flows': 'Luồng dữ liệu',
        'data-sensitivity': 'Độ nhạy cảm dữ liệu',
        'data-steward': 'Người quản trị dữ liệu',
        deadlines: 'Thời hạn',
        'decree-356': 'Nghị định 356',
        dedup: 'Khử trùng lặp',
        definitions: 'Định nghĩa',
        deliverable: 'Sản phẩm bàn giao',
        departments: 'Phòng ban',
        'dependency-order': 'Thứ tự phụ thuộc',
        deployment: 'Triển khai',
        detection: 'Phát hiện',
        diff: 'Khác biệt',
        'digital-properties': 'Tài sản số',
        dimensions: 'Chiều',
        disable: 'Vô hiệu hóa',
        'disaster-recovery': 'Khôi phục sau thảm họa',
        disclosure: 'Tiết lộ',
        documentation: 'Tài liệu',
        documents: 'Tài liệu',
        domains: 'Miền',
        dossier: 'Hồ sơ',
        dpa: 'DPA',
        drift: 'Lệch chuẩn',
        'drift-detection': 'Phát hiện lệch chuẩn',
        'due-diligence': 'Thẩm định',
        email: 'Email',
        emergency: 'Khẩn cấp',
        enable: 'Bật',
        'enterprise-map': 'Bản đồ doanh nghiệp',
        erasure: 'Xóa',
        evaluation: 'Đánh giá',
        'event-bus': 'Bus sự kiện',
        exceptions: 'Ngoại lệ',
        execution: 'Thực thi',
        executive: 'Điều hành',
        exercises: 'Bài tập',
        export: 'Xuất',
        exports: 'Xuất',
        filing: 'Nộp hồ sơ',
        filter: 'Bộ lọc',
        filtering: 'Lọc',
        findings: 'Phát hiện',
        flows: 'Luồng',
        'follow-up': 'Theo dõi',
        forensic: 'Pháp chứng',
        forensics: 'Pháp chứng',
        'form-filler': 'Trình điền biểu mẫu',
        framework: 'Khung tuân thủ',
        frameworks: 'Khung tuân thủ',
        'gap-analysis': 'Phân tích khoảng trống',
        'gap-report': 'Báo cáo khoảng trống',
        gaps: 'Khoảng trống',
        gates: 'Cổng kiểm',
        'getting-started': 'Bắt đầu',
        'golden-templates': 'Mẫu vàng',
        grc: 'GRC',
        'group-management': 'Quản lý nhóm',
        groups: 'Nhóm',
        'guided-tours': 'Tour có hướng dẫn',
        guides: 'Hướng dẫn',
        handling: 'Xử lý',
        'hands-on': 'Thực hành',
        health: 'Tình trạng',
        help: 'Trợ giúp',
        hierarchy: 'Phân cấp',
        history: 'Lịch sử',
        i18n: 'i18n',
        iam: 'IAM',
        'identity-provider': 'Nhà cung cấp định danh',
        implementation: 'Triển khai',
        import: 'Nhập',
        improvement: 'Cải tiến',
        'incident-response': 'Ứng phó sự cố',
        inconsistencies: 'Bất nhất',
        instances: 'Phiên bản',
        intake: 'Tiếp nhận',
        'intake-key': 'Khóa tiếp nhận',
        interactive: 'Tương tác',
        international: 'Quốc tế',
        inventory: 'Kiểm kê',
        investigation: 'Điều tra',
        investigations: 'Điều tra',
        'ip-allowlist': 'Danh sách IP cho phép',
        issues: 'Vấn đề',
        justification: 'Lý do biện minh',
        justifications: 'Lý do biện minh',
        kanban: 'Kanban',
        keyboard: 'Bàn phím',
        keys: 'Khóa',
        'knowledge-base': 'Cơ sở tri thức',
        koncernstyring: 'Quản trị tập đoàn',
        kpi: 'KPI',
        labeling: 'Gán nhãn',
        language: 'Ngôn ngữ',
        'language-packs': 'Gói ngôn ngữ',
        languages: 'Ngôn ngữ',
        lawfulness: 'Tính hợp pháp',
        layout: 'Bố cục',
        'legal-basis': 'Cơ sở pháp lý',
        'lessons-learned': 'Bài học kinh nghiệm',
        levels: 'Mức độ',
        library: 'Thư viện',
        lifecycle: 'Vòng đời',
        lineage: 'Nguồn gốc',
        links: 'Liên kết',
        listings: 'Niêm yết',
        live: 'Trực tiếp',
        locale: 'Ngôn ngữ-địa phương',
        log: 'Nhật ký',
        logging: 'Ghi nhật ký',
        'managed-service': 'Dịch vụ được quản lý',
        mapping: 'Lập bản đồ',
        mappings: 'Lập bản đồ',
        'market-packs': 'Gói thị trường',
        marketplace: 'Thị trường',
        maturity: 'Mức độ trưởng thành',
        metrics: 'Chỉ số',
        models: 'Mô hình',
        module: 'Phân hệ',
        modules: 'Phân hệ',
        mps: 'Bộ Công an',
        'multi-factor': 'Đa yếu tố',
        'multi-market': 'Đa thị trường',
        'multi-org': 'Đa tổ chức',
        'multi-property': 'Đa tài sản',
        'my-tasks': 'Nhiệm vụ của tôi',
        obligations: 'Nghĩa vụ',
        offboarding: 'Rời hệ thống',
        oidc: 'OIDC',
        orchestration: 'Điều phối',
        'org-groups': 'Nhóm tổ chức',
        organization: 'Tổ chức',
        overdue: 'Quá hạn',
        overview: 'Tổng quan',
        'owner-review': 'Chủ sở hữu rà soát',
        package: 'Gói',
        packages: 'Gói',
        packs: 'Gói',
        pagination: 'Phân trang',
        'parent-child': 'Cha-con',
        patterns: 'Mẫu hình',
        performance: 'Hiệu suất',
        periodic: 'Định kỳ',
        periods: 'Kỳ',
        personal: 'Cá nhân',
        'personal-data': 'Dữ liệu cá nhân',
        personas: 'Vai trò sử dụng',
        planning: 'Lập kế hoạch',
        platform: 'Nền tảng',
        playbooks: 'Sổ tay hướng dẫn',
        poc: 'PoC',
        'point-in-time': 'Điểm thời gian',
        policies: 'Chính sách',
        portfolio: 'Danh mục',
        'post-incident': 'Sau sự cố',
        'power-user': 'Người dùng nâng cao',
        practice: 'Thực hành',
        pricing: 'Định giá',
        'privacy-impact': 'Tác động quyền riêng tư',
        procedures: 'Thủ tục',
        processes: 'Quy trình',
        processing: 'Xử lý',
        'processing-activities': 'Hoạt động xử lý',
        procurement: 'Mua sắm',
        productivity: 'Năng suất',
        profiles: 'Hồ sơ',
        programs: 'Chương trình',
        progress: 'Tiến độ',
        proof: 'Bằng chứng',
        propagation: 'Lan truyền',
        properties: 'Thuộc tính',
        'pub-sub': 'Pub-Sub',
        'public-form': 'Biểu mẫu công khai',
        quality: 'Chất lượng',
        questionnaires: 'Bảng câu hỏi',
        'quick-links': 'Liên kết nhanh',
        'quick-start': 'Bắt đầu nhanh',
        'quick-starts': 'Bắt đầu nhanh',
        raci: 'RACI',
        readiness: 'Sẵn sàng',
        'real-time': 'Thời gian thực',
        reassessments: 'Đánh giá lại',
        reconciliation: 'Đối soát',
        record: 'Bản ghi',
        records: 'Bản ghi',
        recurring: 'Lặp lại',
        register: 'Sổ đăng ký',
        registry: 'Kho đăng ký',
        regulations: 'Quy định',
        regulator: 'Cơ quan quản lý',
        regulatory: 'Quy định',
        'regulatory-frameworks': 'Khung tuân thủ',
        remap: 'Ánh xạ lại',
        reminders: 'Nhắc nhở',
        reports: 'Báo cáo',
        requests: 'Yêu cầu',
        requirements: 'Yêu cầu',
        response: 'Phản hồi',
        'response-plans': 'Kế hoạch phản hồi',
        'response-team': 'Đội phản hồi',
        'response-templates': 'Mẫu phản hồi',
        'response-time': 'Thời gian phản hồi',
        responses: 'Phản hồi',
        responsibility: 'Trách nhiệm',
        results: 'Kết quả',
        review: 'Rà soát',
        reviews: 'Rà soát',
        'right-to-delete': 'Quyền được xóa',
        rights: 'Quyền',
        'risk-tiers': 'Cấp rủi ro',
        rollouts: 'Triển khai',
        rollup: 'Tổng hợp',
        ropa: 'ROPA',
        routing: 'Định tuyến',
        rpo: 'RPO',
        rto: 'RTO',
        rules: 'Quy tắc',
        runs: 'Lần chạy',
        saml: 'SAML',
        scan: 'Quét',
        scanning: 'Quét',
        scc: 'SCC',
        schedule: 'Lịch trình',
        scheduled: 'Đã lên lịch',
        schedules: 'Lịch trình',
        scheduling: 'Lập lịch',
        scores: 'Điểm số',
        scoring: 'Chấm điểm',
        scripts: 'Kịch bản',
        'security-reviews': 'Rà soát an ninh',
        'sensitive-data': 'Dữ liệu nhạy cảm',
        sensitivity: 'Độ nhạy cảm',
        'separation-of-duties': 'Phân tách nhiệm vụ',
        service: 'Dịch vụ',
        sessions: 'Phiên',
        'setup-wizard': 'Trình thiết lập',
        severity: 'Mức độ nghiêm trọng',
        'shared-governance': 'Quản trị chung',
        'shared-settings': 'Cài đặt chung',
        shortcuts: 'Phím tắt',
        sidebar: 'Thanh bên',
        signals: 'Tín hiệu',
        'single-sign-on': 'Đăng nhập một lần',
        snapshots: 'Bản chụp',
        sod: 'SoD',
        sorting: 'Sắp xếp',
        sources: 'Nguồn',
        staging: 'Môi trường thử nghiệm',
        standards: 'Tiêu chuẩn',
        status: 'Trạng thái',
        structure: 'Cấu trúc',
        'sub-processor': 'Bên xử lý phụ',
        'sub-processors': 'Bên xử lý phụ',
        submissions: 'Nộp hồ sơ',
        subprocessors: 'Bên xử lý phụ',
        subscription: 'Đăng ký',
        suggestions: 'Gợi ý',
        summaries: 'Tóm tắt',
        supplements: 'Bổ sung',
        support: 'Hỗ trợ',
        sync: 'Đồng bộ',
        system: 'Hệ thống',
        systems: 'Hệ thống',
        tables: 'Bảng',
        tagging: 'Gắn thẻ',
        'tamper-proof': 'Chống giả mạo',
        taxonomies: 'Phân loại',
        taxonomy: 'Phân loại',
        tenants: 'Tenant',
        termination: 'Chấm dứt',
        'third-party': 'Bên thứ ba',
        'ticket-sync': 'Đồng bộ phiếu',
        tickets: 'Phiếu',
        tiers: 'Cấp',
        tokens: 'Token',
        totp: 'TOTP',
        traceability: 'Khả năng truy vết',
        tracking: 'Theo dõi',
        trail: 'Dấu vết',
        training: 'Đào tạo',
        translation: 'Dịch thuật',
        translations: 'Dịch thuật',
        transparency: 'Tính minh bạch',
        trends: 'Xu hướng',
        unified: 'Thống nhất',
        updates: 'Cập nhật',
        validation: 'Xác thực',
        vault: 'Kho',
        'vendor-requests': 'Yêu cầu nhà cung cấp',
        verification: 'Xác minh',
        versioning: 'Phiên bản hóa',
        versions: 'Phiên bản',
        vietnam: 'Việt Nam',
        violations: 'Vi phạm',
        visualization: 'Trực quan hóa',
        waivers: 'Miễn trừ',
        'web-records': 'Bản ghi web',
        website: 'Trang web',
        websites: 'Trang web',
        weights: 'Trọng số',
        'white-label': 'Nhãn trắng',
        withdrawal: 'Rút lại',
    },
    module_labels: {
        // Sprint 63.25.0 (spec G2) — the source modules that had no label.
        compliance_rules: 'Quy tắc tuân thủ',
        access_review: 'Rà soát truy cập',
        consolidation: 'Hợp nhất',
        case_audit: 'Nhật ký kiểm toán phân hệ',
        rights_requests: 'Yêu cầu quyền',
        data_mapping: 'Bản đồ dữ liệu',
        governance: 'Quản trị',
        consent: 'Quản trị đồng thuận',
        assessments: 'Đánh giá tác động',
        classification: 'Phân loại dữ liệu',
        monitoring: 'Chương trình giám sát',
        program: 'Chương trình giám sát',
        incidents: 'Ứng phó sự cố',
        onboarding: 'Khởi tạo',
        compliance_forms: 'Biểu mẫu tuân thủ',
        audit_trail: 'Nhật ký kiểm toán',
        data_subjects: 'Chủ thể dữ liệu',
        organizations: 'Tổ chức',
        incident_ops: 'Vận hành sự cố',
        vendor_risk: 'Rủi ro nhà cung cấp',
        deletion_orchestration: 'Điều phối xóa',
        program_governance: 'Quản trị chương trình',
        consent_properties: 'Thuộc tính đồng thuận',
        task_management: 'Quản lý công việc',
        forms: 'Biểu mẫu tuân thủ',
        discovery: 'Khám phá dữ liệu',
        connectors: 'Kết nối',
        access_accountability: 'Trách nhiệm truy cập',
        localization: 'Bản địa hóa',
        sector_overlays: 'Lớp phủ ngành',
        partner_workspace: 'Không gian đối tác',
        privacy_scanner: 'Quét quyền riêng tư',
        deletion_orch: 'Điều phối xóa',
        partner_marketplace: 'Sàn đối tác',
        dashboard: 'Bảng điều khiển',
        platform_settings: 'Cài đặt nền tảng',
        help_center: 'Trung tâm trợ giúp',
    },
    module_descriptions: {
        rights_requests: 'Quản lý yêu cầu quyền của chủ thể dữ liệu bao gồm truy cập, xóa và chuyển đổi. Theo dõi vòng đời yêu cầu, phân công xử lý và đảm bảo thời hạn pháp lý.',
        data_mapping: 'Lập bản đồ luồng dữ liệu trong tổ chức. Theo dõi hoạt động xử lý, danh mục dữ liệu, mục đích, chính sách lưu trữ và tích hợp hệ thống.',
        governance: 'Giám sát và bằng chứng đi kèm. Quản lý sổ đăng ký nhà cung cấp cùng vòng đời của nó, phê duyệt các quyết định mà phân hệ này kiểm soát, theo dõi sai lệch tuân thủ, và lưu giữ các sổ đăng ký bằng chứng danh tính và dịch vụ tin cậy, tài liệu pháp lý, thanh toán và eKYC, và bằng chứng nền tảng.',
        consent: 'Quản lý thu thập, lưu trữ và rút lại đồng thuận. Theo dõi bản ghi đồng thuận, mục đích và tích hợp với nền tảng quản lý đồng thuận.',
        consent_properties: 'Cấu hình thuộc tính đồng thuận, nhóm và mẫu vàng. Định nghĩa cấu hình đồng thuận tái sử dụng để triển khai nhất quán.',
        assessments: 'Thực hiện Đánh giá Tác động Bảo vệ Dữ liệu (DPIA) và đánh giá rủi ro quyền riêng tư. Đánh giá hoạt động xử lý về rủi ro tuân thủ.',
        classification: 'Phân loại tài sản dữ liệu theo mức độ nhạy cảm. Áp dụng nhãn phân loại, theo dõi hồ sơ vòng đời và xác định lỗ hổng phân loại.',
        monitoring: 'Thiết lập chương trình giám sát để theo dõi chỉ số tuân thủ, chỉ số rủi ro chính và hiệu quả kiểm soát theo thời gian.',
        incidents: 'Báo cáo và quản lý sự cố quyền riêng tư và vi phạm dữ liệu. Theo dõi quy trình điều tra, thông báo và khắc phục.',
        connectors: 'Cấu hình kết nối nguồn dữ liệu và tích hợp. Kết nối hệ thống bên ngoài để tự động khám phá và giám sát dữ liệu.',
        vendor_risk: 'Đánh giá và giám sát rủi ro nhà cung cấp bên thứ ba. Chấm điểm nhà cung cấp, theo dõi giảm thiểu rủi ro và quản lý cấu hình rủi ro.',
        deletion_orchestration: 'Điều phối xóa dữ liệu trên các hệ thống. Theo dõi yêu cầu xóa, xác minh chuỗi bằng chứng và đảm bảo xóa dữ liệu hoàn toàn.',
        discovery: 'Khám phá dữ liệu cá nhân trên các hệ thống kết nối. Quét nguồn dữ liệu để xây dựng kho dữ liệu toàn diện.',
        incident_ops: 'Quản lý vận hành sự cố với sổ tay hướng dẫn, quy trình leo thang và theo dõi SLA để giải quyết sự cố.',
        program_governance: 'Theo dõi mức độ trưởng thành chương trình quyền riêng tư, điểm tuân thủ, lỗ hổng bằng chứng và báo cáo điều hành.',
        access_accountability: 'Điều tra và kiểm toán mô hình truy cập người dùng. Theo dõi cấu hình truy cập, giám sát hoạt động đáng ngờ và thực thi trách nhiệm.',
        localization: 'Cài đặt và quản lý gói bản địa hóa thị trường. Thêm khung tuân thủ, gói ngôn ngữ và nội dung tuân thủ theo vùng.',
        sector_overlays: 'Cài đặt và quản lý các lớp phủ ngành tùy chọn, và mở các sổ đăng ký ngành mà một lớp phủ đã kích hoạt đưa vào sử dụng, sắp xếp theo ngành. Có trong gói Enterprise.',
        partner_workspace: 'Hợp tác với đối tác bên ngoài. Chia sẻ dữ liệu tuân thủ, theo dõi nghĩa vụ đối tác và quản lý mối quan hệ đối tác.',
        privacy_scanner: 'Quét trang web để phát hiện vấn đề tuân thủ quyền riêng tư. Giám sát cookie, script theo dõi và chính sách quyền riêng tư theo thời gian thực.',
        onboarding: 'Hướng dẫn tổ chức mới thiết lập nền tảng. Trình hướng dẫn từng bước để cấu hình ban đầu và nhập dữ liệu.',
        compliance_forms: 'Tạo và quản lý biểu mẫu tuân thủ từ danh mục mẫu. Điền biểu mẫu quy định, theo dõi nộp và tạo báo cáo.',
        audit_trail: 'Xem nhật ký kiểm toán đầy đủ của tất cả hành động hệ thống. Theo dõi ai đã làm gì, khi nào và ở đâu trên tất cả các phân hệ.',
        organizations: 'Quản lý tổ chức và cài đặt đa đối tượng. Cấu hình hồ sơ tổ chức, phân cấp và mối quan hệ liên tổ chức.',
    },
    privacy_scanner: {
        // Sprint 48.1.7 — Bảng giải thích bất thường của Forseti
        anomaly_explain: {
            explain_label: 'Giải thích bất thường',
            explaining: 'Đang giải thích…',
            results_heading: 'Giải thích bất thường ({severity})',
            tokens_label: '≈ {count} token',
            items_label: '{count} mục',
            remediation_label: 'Các bước khắc phục',
            items_detail_label: 'Các mục bị ảnh hưởng',
            accept_label: 'Chấp nhận giải thích',
            reject_label: 'Bỏ giải thích',
            error_generic: 'Không giải thích được bất thường. Hãy thử lại hoặc kiểm tra scan đã hoàn tất.',
        },
        // Sprint 48.1.8 — Phân tích AI cho từng cookie / tracker
        cookie_insight: {
            insight_label: 'Phân tích AI cookie & tracker',
            producing: 'Đang phân tích…',
            results_heading: 'Phân tích cookie & tracker ({severity})',
            tokens_label: '≈ {count} token',
            items_label: '{count} mục',
            classification_label: 'Phân loại',
            severity_label: 'Mức độ',
            banner_copy_label: 'Nội dung banner đề xuất',
            retention_label: 'Đề xuất thời gian lưu',
            citations_label: 'Trích dẫn',
            kind_cookie: 'Cookie',
            kind_tracker: 'Trình theo dõi',
            class_necessary: 'Cần thiết',
            class_analytics: 'Phân tích',
            class_marketing: 'Tiếp thị',
            class_social: 'Mạng xã hội',
            accept_label: 'Chấp nhận phân tích',
            reject_label: 'Bỏ phân tích',
            no_items: 'Không phát hiện cookie hoặc tracker nào trong lần quét này.',
            error_generic: 'Không tạo được phân tích cookie. Hãy thử lại hoặc kiểm tra scan đã hoàn tất.',
        },
        monitoring: {
            title: 'Giám sát quyền riêng tư',
            new_scan: 'Quét mới',
            scan_url: 'URL cần quét',
            scan_frequency: 'Tần suất quét',
            last_scan: 'Quét cuối',
            score: 'Điểm quyền riêng tư',
            issues: 'Vấn đề phát hiện',
            history: 'Lịch sử quét',
            settings: 'Cài đặt giám sát',
        },
        real_time: {
            title: 'Quét thời gian thực',
            scan_now: 'Quét ngày',
            scanning: 'Đang quét...',
            results: 'Kết quả quét',
            no_results: 'Chưa có kết quả quét.',
            cookies: 'Cookie',
            trackers: 'Trình theo dõi',
            consent_banners: 'Banner đồng thuận',
            third_party: 'Script bên thứ ba',
            archive: 'Kho kết quả',
            settings: 'Cài đặt quét',
        },
        dashboard: {
            page_title: 'Bảng điều khiển giám sát quyền riêng tư',
            privacy_monitoring: 'Giám sát quyền riêng tư',
            plan_label: 'Gói {package}',
            expires_label: 'hết hạn {date}',
            settings: 'Cài đặt',
            refresh: 'Làm mới',
            refreshing_dashboard: 'Đang làm mới bảng điều khiển giám sát',
            refresh_aria: 'Làm mới bảng điều khiển giám sát',
            not_configured_title: 'Chưa cấu hình giám sát quyền riêng tư',
            not_configured_desc: 'Kết nối dịch vụ Giám sát Quyền riêng tư AesirX để bắt đầu theo dõi tuân thủ trang web.',
            configure_monitoring: 'Cấu hình giám sát',
            license_expired_title: 'Giấy phép đã hết hạn',
            license_expired_desc: 'Giấy phép Giám sát Quyền riêng tư AesirX của bạn đã hết hạn. Vui lòng gia hạn để tránh gián đoạn dịch vụ.',
            compliance_score: 'Điểm tuân thủ',
            cookies_detected: 'Cookie phát hiện',
            trackers_label: 'Trình theo dõi',
            open_issues: 'Vấn đề mở',
            score_good: 'Tốt',
            score_needs_improvement: 'Cần cải thiện',
            score_critical: 'Nghiêm trọng',
            action_required: 'Cần hành động',
            cookies_sr: 'cookie phát hiện',
            trackers_sr: 'trình theo dõi phát hiện',
            open_issues_sr: 'vấn đề mở',
            action_required_sr: 'cần hành động',
            metric_label: 'Chỉ số',
            value_label: 'Giá trị',
            status_label: 'Trạng thái',
            aria_metrics: 'Chỉ số giám sát quyền riêng tư',
            plan_limit_warning: 'URL quét: {current}/{max} — bạn đã đạt giới hạn gói.',
            manage_domains: 'Quản lý tên miền hoặc nâng cấp gói của bạn.',
            monitored_domains: 'Tên miền giám sát',
            domain_added: 'Đã thêm tên miền {domain}',
            domain_removed: 'Đã xóa tên miền {domain}',
            failed_add_domain: 'Không thể thêm tên miền',
            failed_remove_domain: 'Không thể xóa tên miền',
            failed_load: 'Không thể tải bảng điều khiển giám sát',
            new_domain_aria: 'URL tên miền mới',
            add_domain: 'Thêm tên miền',
            adding_domain: 'Đang thêm…',
            no_domains: 'Chưa cấu hình tên miền giám sát nào.',
            aria_domains_table: 'Tên miền giám sát',
            col_domain: 'Tên miền',
            col_compliance_score: 'Điểm tuân thủ',
            col_status: 'Trạng thái',
            col_cookies: 'Cookie',
            col_trackers: 'Trình theo dõi',
            col_issues: 'Vấn đề',
            col_last_scan: 'Quét cuối',
            col_action: 'Thao tác',
            compliance_status_sr: 'trạng thái tuân thủ',
            showing_chart: 'Đang hiển thị dạng biểu đồ',
            showing_table: 'Đang hiển thị dạng bảng dữ liệu',
            loading_sr: 'Đang tải bảng điều khiển giám sát',
            col_framework_tags: 'Thẻ khung tuân thủ',
            col_last_monitored: 'Lần giám sát cuối',
            framework_tags_sr: 'các khung tuân thủ áp dụng',
            last_monitored_sr: 'dấu thời gian giám sát liên tục',
            audit_trail_heading: 'Nhật ký kiểm toán',
            audit_trail_info: 'Mỗi lần quét giám sát đều được ghi dấu thời gian và ghi nhật ký. Các thay đổi tuân thủ cấp tên miền tạo ra bản ghi kiểm toán bất biến có thể xuất để xem xét quy định.',
            cybersecurity_law_info_heading: 'Phát hiện Luật An ninh mạng',
            cybersecurity_law_info: 'Các tên miền được giám sát tự động kiểm tra theo yêu cầu luật an ninh mạng (ví dụ: Luật An ninh mạng Việt Nam, Chỉ thị NIS2). Thẻ khung tuân thủ cho biết quy định nào áp dụng. Vấn đề được phân loại theo khung tuân thủ để khắc phục có mục tiêu.',
        },
        scan: {
            page_title: 'Quét thời gian thực',
            title: 'Máy quét quyền riêng tư thời gian thực',
            settings: 'Cài đặt',
            results_archive: 'Kho kết quả',
            launch_scan: 'Khởi chạy quét',
            target_url: 'URL đích',
            protocol_aria: 'Giao thức',
            url_required: 'URL là bắt buộc',
            url_whitespace: 'Vui lòng xóa khoảng trắng khỏi URL',
            url_invalid: 'Vui lòng nhập tên miền hợp lệ (VD: example.com)',
            add_subpages: 'Thêm trang con',
            add_subpages_aria: 'Thêm trang con, đã thêm {count}',
            start_scan: 'Bắt đầu quét',
            launching: 'Đang khởi chạy…',
            scan_launched: 'Đã khởi chạy quét thành công',
            scan_failed: 'Không thể khởi chạy quét',
            scan_progress: 'Tiến độ quét',
            scanning_in_progress: 'Đang quét…',
            scan_id: 'Mã lần quét',
            status_label: 'Trạng thái',
            status_unknown: 'không xác định',
            progress_label: 'Tiến độ',
            pages_label: 'Trang',
            refresh_status: 'Làm mới trạng thái',
            new_scan: 'Quét mới',
            scan_completed: 'Quét hoàn tất, kết quả có sẵn',
            failed_check_status: 'Không thể kiểm tra trạng thái quét',
            scan_results: 'Kết quả quét',
            main_page: 'Trang chính',
            page_n: 'Trang {n}',
            result_pages_nav: 'Trang kết quả',
            page_url: 'URL trang',
            risk_score: 'Điểm rủi ro',
            risk_score_sr: 'điểm rủi ro',
            cookies_label: 'Cookie',
            cookies_sr: 'cookie phát hiện',
            scripts_label: 'Script',
            scripts_sr: 'script phát hiện',
            issues_label: 'Vấn đề',
            issues_sr: 'vấn đề phát hiện',
            issues_found: 'Vấn đề phát hiện',
            aria_issues_table: 'Vấn đề phát hiện trong quá trình quét',
            col_severity: 'Mức độ',
            col_category: 'Danh mục',
            col_title: 'Tiêu đề',
            col_remediation: 'Khắc phục',
            severity_sr: 'mức độ',
            scan_result_metrics: 'Chỉ số kết quả quét',
            view_full_detail: 'Xem chi tiết đầy đủ',
            subpages_modal_title: 'Thêm trang con',
            subpages_modal_desc: 'Thêm tối đa 5 URL trang con để quét cùng với tên miền chính.',
            subpage_n: 'Trang con {n}',
            col_consent_category: 'Danh mục đồng thuận',
            consent_category_sr: 'phân loại đồng thuận',
            compliance_evidence_heading: 'Bằng chứng tuân thủ',
            compliance_evidence_info: 'Kết quả quét được liên kết tự động với vụ việc tuân thủ. Mỗi vấn đề có thể truy nguyên đến danh mục đồng thuận (thiết yếu, chức năng, phân tích, tiếp thị) và tạo bằng chứng sẵn sàng kiểm toán để xem xét quy định.',
            rule_config_heading: 'Cấu hình quy tắc',
            rule_config_info: 'Quy tắc quét có thể cấu hình theo từng khung tuân thủ. Kiểm tra cookie, phát hiện script và phân tích nhà cung cấp có thể bật hoặc tắt qua Cài đặt. Quy tắc tùy chỉnh có thể được định nghĩa để phù hợp với yêu cầu tuân thủ của tổ chức.',
            case_linkage_heading: 'Liên kết vụ việc tuân thủ',
            case_linkage_info: 'Vấn đề phát hiện trong quá trình quét thời gian thực có thể được liên kết với vụ việc tuân thủ để theo dõi và khắc phục. Chuyển đến trang Chi tiết kết quả quét để xem các liên kết vụ việc.',
        },
        result_detail: {
            page_title: 'Chi tiết kết quả quét',
            title: 'Kết quả quét',
            back_to_archive: 'Quay lại kho kết quả',
            failed_load: 'Không thể tải kết quả quét',
            loading_sr: 'Đang tải kết quả quét…',
            scan_id: 'Mã lần quét',
            target_url: 'URL đích',
            status_label: 'Trạng thái',
            status_sr: 'trạng thái',
            started: 'Bắt đầu',
            completed: 'Hoàn tất',
            pages_scanned: 'Số trang đã quét',
            https_label: 'HTTPS',
            highest_risk_score: 'Điểm rủi ro cao nhất',
            most_cookies: 'Nhiều cookie nhất',
            most_vendors: 'Nhiều nhà cung cấp bên thứ ba nhất',
            most_issues: 'Nhiều vấn đề nhất',
            across_pages: 'trên các trang',
            highest_values_aria: 'Giá trị cao nhất trên tất cả trang',
            scanned_pages_nav: 'Trang đã quét',
            main_page: 'Trang chính',
            page_n: 'Trang {n}',
            page_url: 'URL trang',
            risk_score: 'Điểm rủi ro',
            overall_risk_sr: 'điểm rủi ro tổng thể',
            cookies_label: 'Cookie',
            cookies_sr: 'cookie phát hiện',
            vendors_label: 'Nhà cung cấp bên thứ ba',
            vendors_sr: 'nhà cung cấp bên thứ ba phát hiện',
            issues_label: 'Vấn đề',
            issues_sr: 'vấn đề phát hiện',
            risk_breakdown_aria: 'Phân tích điểm rủi ro',
            issues_found: 'Vấn đề phát hiện',
            aria_issues_table: 'Vấn đề phát hiện trong quá trình quét',
            col_severity: 'Mức độ',
            col_category: 'Danh mục',
            col_title: 'Tiêu đề',
            col_remediation: 'Khắc phục',
            severity_sr: 'mức độ',
            cookies_heading: 'Cookie ({count})',
            aria_cookies_table: 'Cookie phát hiện',
            col_name: 'Tên',
            col_domain: 'Tên miền',
            col_path: 'Đường dẫn',
            col_secure: 'Bảo mật',
            col_httponly: 'HttpOnly',
            col_samesite: 'SameSite',
            vendors_heading: 'Nhà cung cấp bên thứ ba ({count})',
            aria_vendors_table: 'Nhà cung cấp bên thứ ba phát hiện',
            col_hostname: 'Tên máy chủ',
            scripts_heading: 'Script / Beacon ({count})',
            aria_scripts_table: 'Script và beacon phát hiện',
            col_url: 'URL',
            col_type: 'Loại',
            links_heading: 'Liên kết',
            first_party: 'Bên thứ nhất',
            third_party: 'Bên thứ ba',
            col_risk_category: 'Danh mục rủi ro',
            col_regulatory_framework: 'Khung tuân thủ',
            col_actionable_detail: 'Chi tiết khắc phục',
            risk_category_sr: 'danh mục rủi ro quy định',
            risk_category_mapping_heading: 'Ánh xạ danh mục rủi ro',
            risk_category_mapping_info: 'Mỗi phát hiện quét được ánh xạ đến danh mục rủi ro quy định (thu thập dữ liệu, chuyển xuyên biên giới, quản lý đồng thuận, lưu trữ dữ liệu, kiểm soát bảo mật). Ánh xạ này cho phép khắc phục có mục tiêu ưu tiên theo tác động quy định.',
            compliance_case_heading: 'Liên kết vụ việc tuân thủ',
            compliance_case_info: 'Kết quả quét được liên kết với vụ việc tuân thủ để theo dõi đầu cuối. Vấn đề có thể được chuyển cấp trực tiếp từ kết quả quét vào luồng vụ việc tuân thủ.',
        },
        results_archive: {
            page_title: 'Kho kết quả quét',
            title: 'Kho kết quả quét',
            back_to_scanner: 'Quay lại máy quét',
            failed_load: 'Không thể tải kết quả quét',
            results_loaded: 'Đã tải kết quả quét, {count} bản ghi',
            total_label: 'Tổng: {count}',
            aria_table: 'Kho kết quả quét',
            col_scan_date: 'Ngày quét',
            col_target_url: 'URL đích',
            col_duration: 'Thời lượng',
            col_issues_found: 'Vấn đề phát hiện',
            col_risk_score: 'Điểm rủi ro',
            col_status: 'Trạng thái',
            col_actions: 'Thao tác',
            scan_status_sr: 'trạng thái quét',
            view_result: 'Xem',
            no_results: 'Không tìm thấy kết quả quét.',
            loading_sr: 'Đang tải kết quả quét',
            pagination_aria: 'Phân trang kết quả quét',
            col_risk_category: 'Danh mục rủi ro',
            risk_category_sr: 'danh mục rủi ro quy định',
            archive_retention_heading: 'Lưu giữ kho lưu trữ',
            archive_retention_info: 'Kết quả quét được lưu giữ trong thời gian quy định trong chính sách lưu trữ dữ liệu của tổ chức. Kết quả lưu trữ bao gồm ngữ cảnh quét đầy đủ (thẻ khung tuân thủ, danh mục rủi ro, hướng dẫn khắc phục) và có thể xuất dạng CSV làm bằng chứng quy định.',
            export_context_info: 'Tệp CSV xuất bao gồm ngữ cảnh quy định: danh mục rủi ro, khung tuân thủ áp dụng và chi tiết khắc phục có thể thực hiện cho mỗi phát hiện.',
        },
        scanner_settings: {
            page_title: 'Cài đặt máy quét',
            title: 'Cài đặt máy quét',
            back_to_scanner: 'Quay lại máy quét',
            failed_load: 'Không thể tải cấu hình máy quét',
            endpoint_url: 'URL điểm cuối',
            save_success: 'Đã lưu cấu hình máy quét thành công.',
            save_failed: 'Không thể lưu cấu hình máy quét',
            test_connection: 'Kiểm tra kết nối',
            testing: 'Đang kiểm tra...',
            saving: 'Đang lưu...',
            loading_sr: 'Đang tải cài đặt máy quét',
            endpoint_fixed_hint: 'Địa chỉ máy quét do nền tảng cố định và không thể thay đổi tại đây. Kiểm tra kết nối sẽ kiểm tra thông tin xác thực AesirX đã lưu trong cài đặt giám sát.',
        },
        monitoring_settings: {
            page_title: 'Cài đặt giám sát quyền riêng tư',
            title: 'Cài đặt giám sát',
            back_to_dashboard: 'Quay lại bảng điều khiển',
            failed_load: 'Không thể tải cấu hình giám sát',
            credentials_heading: 'Thông tin xác thực AesirX',
            connected_as: 'Đã kết nối với {username}',
            credentials_desc: 'Nhập thông tin xác thực tài khoản AesirX để kết nối Giám sát Quyền riêng tư. Tìm ID thành viên trong trang hồ sơ tài khoản AesirX.',
            client_id: 'Mã khách hàng',
            client_secret: 'Khóa bí mật',
            username: 'Tên người dùng AesirX (email)',
            password: 'Mật khẩu AesirX',
            placeholder_keep: '(để trống để giữ giá trị hiện tại)',
            credential_form_aria: 'Biểu mẫu xác thực AesirX',
            test_connection: 'Kiểm tra kết nối',
            testing: 'Đang kiểm tra…',
            test_aria: 'Kiểm tra kết nối AesirX',
            testing_aria: 'Đang kiểm tra kết nối',
            save_configuration: 'Lưu cấu hình',
            saving: 'Đang lưu…',
            save_aria: 'Lưu thông tin xác thực',
            saving_aria: 'Đang lưu thông tin xác thực',
            credentials_saved: 'Đã lưu thông tin xác thực AesirX thành công.',
            credentials_saving: 'Đã lưu thông tin xác thực AesirX. Đang tải lại cấu hình…',
            credentials_save_failed: 'Không thể lưu thông tin xác thực',
            client_id_required: 'Mã khách hàng và tên người dùng là bắt buộc.',
            all_fields_required: 'Tất cả trường xác thực là bắt buộc.',
            email_heading: 'Thông báo qua Email',
            receive_emails: 'Nhận email báo cáo quét',
            email_toggle_aria: 'Bật/tắt email báo cáo quét',
            only_on_change: 'Chỉ gửi email khi trạng thái rủi ro thay đổi',
            only_on_change_aria: 'Bật/tắt chỉ gửi email khi trạng thái rủi ro thay đổi',
            emails_enabled: 'Đã bật email báo cáo quét',
            emails_disabled: 'Đã tắt email báo cáo quét',
            only_change_on: 'Chỉ gửi email khi rủi ro thay đổi',
            only_change_off: 'Gửi email mỗi lần quét',
            email_failed: 'Không thể cập nhật cài đặt email',
            email_settings_aria: 'Cài đặt thông báo email',
            loading_sr: 'Đang tải cài đặt giám sát',
        },
        entity_types: {
            user: 'Người dùng',
            case: 'Vụ việc',
            incident: 'Sự cố',
            assessment: 'Đánh giá',
            vendor: 'Nhà cung cấp',
            consent: 'Đồng thuận',
            policy: 'Chính sách',
            data_map: 'Bản đồ dữ liệu',
        },
        actions: {
            create: 'Tạo',
            update: 'Cập nhật',
            delete: 'Xóa',
            view: 'Xem',
            export: 'Xuất',
            status_change: 'Thay đổi trạng thái',
        },
    },
    forms: {
        // fix-sprint-20260905-2135 F33/F34 — keys that tKey() call sites asked for and
        // no locale declared, so each fell through to its hardcoded English third
        // argument and rendered English in all 16 locales. The two DPIA row-action
        // tooltips were worse: their fallbacks are themselves translated keys, so the
        // primary CTA read 'Edit' where the code intends 'Continue', and the in-review
        // action read 'Approve/Reject' where it intends 'Review'.
        title: 'Biểu mẫu',
        dashboard: {
            title: 'Tổng quan biểu mẫu',
            total_templates: 'Tổng số mẫu',
            installed: 'Đã cài đặt',
            available: 'Khả dụng',
            by_market: 'Theo thị trường',
            back_dashboard: 'Quay lại bảng điều khiển',
            browse_templates: 'Duyệt mẫu',
            catalog_coverage: 'Phạm vi danh mục',
            quick_start: 'Bắt đầu nhanh',
            recent_instances: 'Phiên bản gần đây',
            total_instances: 'Tổng phiên bản',
            fetch_failed: 'Không thể tải dữ liệu tổng quan.',
            no_instances: 'Không tìm thấy phiên bản.',
            templates_in_category: 'mẫu trong {category}',
            installed_of_available: '{installed}/{available} đã cài đặt',
            instances_total: 'tổng số phiên bản',
            templates_total: 'tổng số mẫu',
            form_metrics: 'Tổng quan chỉ số biểu mẫu',
            uncategorized: 'Chưa phân loại',
            other_framework: 'Khác',
            category_templates_aria: 'Mẫu {category}',
            no_templates: 'Không có mẫu biểu mẫu nào.',
        },
        templates: {
            title: 'Mẫu biểu mẫu',
            new: 'Mẫu mới',
            edit: 'Sửa mẫu',
            name: 'Tên mẫu',
            form_type: 'Loại biểu mẫu',
            market: 'Thị trường',
            language: 'Ngôn ngữ',
            schema: 'Schema biểu mẫu',
            preview: 'Xem trước',
            duplicate: 'Nhân bản mẫu',
            grid_view: 'Xem dạng lưới',
            list_view: 'Xem dạng danh sách',
            fetch_failed: 'Không thể tải mẫu.',
            view_mode: 'Chế độ xem',
            all_frameworks: 'Tất cả các khung',
            issuer: 'Nhà phát hành',
            source_instrument: 'Công cụ nguồn',
            form_id: 'ID biểu mẫu',
            filter_templates: 'Lọc mẫu',
            version_history: 'Lịch sử phiên bản',
            no_version_history: 'Không có lịch sử phiên bản — đây là phiên bản đầu tiên.',
            classification: 'Phân loại',
        },
        catalog: {
            title: 'Danh mục biểu mẫu',
            install: 'Cài đặt',
            uninstall: 'Gỡ cài đặt',
            open_form: 'Mở biểu mẫu',
            install_all: 'Cài đặt tất cả',
            installed_tab: 'Đã cài đặt',
            catalog_tab: 'Danh mục',
            search_placeholder: 'Tìm kiếm mẫu...',
            no_templates: 'Không tìm thấy mẫu nào.',
            template_count: '{count} mẫu',
            all_markets: 'Tất cả thị trường',
            sections: 'Phần',
            all_categories: 'Tất cả danh mục',
            category: 'Danh mục',
            category_install_failed: 'Không thể cài đặt mẫu danh mục.',
            category_install_success: 'Đã cài đặt mẫu danh mục.',
            fetch_failed: 'Không thể tải mẫu.',
            fetch_installed_failed: 'Không thể tải mẫu đã cài đặt.',
            fields: 'Trường',
            install_failed: 'Không thể cài đặt mẫu.',
            install_success: 'Đã cài đặt mẫu thành công.',
            installing: 'Đang cài đặt...',
            removing: 'Đang gỡ...',
            uninstall_confirm: 'Bạn có chắc chắn muốn gỡ cài đặt mẫu này không?',
            uninstall_failed: 'Không thể gỡ cài đặt mẫu.',
            uninstall_success: 'Đã gỡ cài đặt mẫu thành công.',
            catalog_tabs: 'Tab danh mục biểu mẫu',
            issuer: 'Nhà phát hành',
            form_id: 'ID biểu mẫu',
            all_already_installed: 'Tất cả mẫu trong danh mục này đã được cài đặt',
            category_install_partial: 'Đã cài đặt {installed}/{requested} mẫu. {refused} sổ đăng ký hạn chế không được cài đặt — muốn thêm các sổ này cần quyền lưu giữ hồ sơ pháp quy.',
            category_install_none: 'Không có mẫu nào được cài đặt. {refused} sổ đăng ký hạn chế trong danh mục này cần quyền lưu giữ hồ sơ pháp quy.',
            templates_installed_count: '{count} mẫu đã được cài đặt thành công',
            all_frameworks: 'Tất cả các khung',
            filter_catalog: 'Lọc danh mục',
            installation_summary: 'Tóm tắt cài đặt',
        },
        filler: {
            back_templates: 'Quay lại mẫu',
            no_sections: 'Không tìm thấy phần nào.',
            draft_created: 'Đã tạo bản nháp.',
            draft_saved: 'Đã lưu bản nháp.',
            fetch_template_failed: 'Không thể tải mẫu.',
            save_draft: 'Lưu bản nháp',
            save_draft_failed: 'Không thể lưu bản nháp.',
            saving: 'Đang lưu...',
            select_option: 'Chọn một tùy chọn',
            submit: 'Gửi',
            submit_failed: 'Không thể gửi.',
            submitting: 'Đang gửi...',
            title: 'Trình hướng dẫn biểu mẫu',
            go_to_next: 'Đi đến phần tiếp theo, phần {current} trên {total}',
            go_to_previous: 'Đi đến phần trước, phần {current} trên {total}',
            added_item: 'Đã thêm mục mới vào {field}',
            removed_item: 'Đã xóa mục {index} khỏi {field}',
            form_progress: 'Tiến trình biểu mẫu: Phần {current} trên {total}',
            form_navigation: 'Điều hướng biểu mẫu',
            section_of: 'Phần {current} trên {total}',
            market_label: 'Thị trường',
            source_label: 'Nguồn',
            issuer_label: 'Nhà phát hành',
            framework_label: 'Khung tuân thủ',
            schema_label: 'Lược đồ',
            form_id_label: 'ID biểu mẫu',
            form_number_label: 'Biểu mẫu',
            risk_matrix_placeholder: '1–5',
        },
        filing: {
            title: 'Trạng thái nộp hồ sơ',
            advance: 'Cập nhật trạng thái nộp...',
            not_started: 'Chưa bắt đầu',
            drafting: 'Đang soạn',
            internal_review: 'Duyệt nội bộ',
            // Sprint 62.57.0 (gate E12.5 pass 3) — the organisation's own acts, in the
            // dossier filing's step words (AC-R3).
            approved_for_submission: 'Đã phê duyệt nội bộ',
            submitted_to_authority: 'Đã nộp',
            supplement_requested: 'Yêu cầu bổ sung',
            supplement_in_progress: 'Đang bổ sung',
            resubmitted: 'Đã nộp lại',
            accepted: 'Được chấp nhận',
            rejected: 'Bị từ chối',
            closed: 'Đã đóng',
            // Sprint 63.37.0 (Stream J) — the filing milestones the instance page lists.
            milestone_submitted_at: 'Ngày nộp',
            milestone_supplement_requested_at: 'Ngày yêu cầu bổ sung',
            milestone_supplement_submitted_at: 'Ngày nộp bổ sung',
            milestone_accepted_at: 'Ngày được chấp nhận',
            milestone_rejected_at: 'Ngày bị từ chối',
            milestone_closed_at: 'Ngày đóng',
        },
        instances: {
            approved_by: 'Phê duyệt bởi',
            form_answers: 'Câu trả lời biểu mẫu',
            column_header: 'Biểu mẫu',
            no_answers: 'Không tìm thấy câu trả lời.',
            view_outputs: 'Xem đầu ra',
            approve: 'Phê duyệt',
            approve_failed: 'Không thể phê duyệt.',
            approving: 'Đang phê duyệt...',
            detail_title: 'Chi tiết phiên bản',
            fetch_failed: 'Không thể tải phiên bản.',
            generate_failed: 'Không thể tạo đầu ra.',
            generate_output: 'Tạo đầu ra',
            generating: 'Đang tạo...',
            submitted_at: 'Gửi lúc',
            filing_status_update_failed: 'Không thể cập nhật trạng thái hồ sơ',
            // Sprint 63.37.0 (I1) — the export buttons and the sample notice of an instance.
            form_number: 'Số hiệu biểu mẫu',
            export_pdf: 'Xuất PDF',
            export_docx: 'Xuất Word (DOCX)',
            exporting: 'Đang xuất {format}…',
            export_done: 'Đã xuất {format}. Tệp đang được tải xuống.',
            export_failed: 'Không thể xuất {format}.',
            export_not_approved: 'Chưa thể xuất biểu mẫu này. Hãy phê duyệt biểu mẫu trước; biểu mẫu nằm trong một hồ sơ chỉ xuất được khi đã hoàn thành hoặc đã chốt.',
            sample_notice: 'Biểu mẫu này là dữ liệu mẫu. Mọi trang của tệp xuất đều mang dấu "{stamp}".',
            current_status: 'trạng thái hiện tại',
            filing_status_steps: 'Các bước trạng thái nộp hồ sơ',
            instance_metadata: 'Siêu dữ liệu phiên bản biểu mẫu',
            // Sprint 63.37.0 (Stream J) — the finalize action and the form actions a parent record's row offers.
            finalize: 'Chốt',
            finalized: 'Đã chốt biểu mẫu.',
            finalize_failed: 'Không thể chốt biểu mẫu.',
            edit_form: 'Sửa',
            view_form: 'Xem',
            open_instance: 'Mở {form}',
            // Sprint 63.40.0 (decision 8) — the page description and the notification dossier.
            detail_description: 'Câu trả lời của một biểu mẫu, các bản xuất và, khi biểu mẫu mở hồ sơ, hồ sơ thông báo được chuẩn bị từ biểu mẫu đó.',
            notice_dossier: {
                title: 'Hồ sơ thông báo',
                description: 'Nền tảng chuẩn bị hồ sơ này từ biểu mẫu đã hoàn thành. Nền tảng không nộp hồ sơ: tổ chức của bạn tự nộp hồ sơ cho cơ quan tiếp nhận.',
                prepare: 'Chuẩn bị hồ sơ cho {form}',
                preparing: 'Đang chuẩn bị hồ sơ cho {form}…',
                prepared: 'Đã chuẩn bị hồ sơ cho {form}.',
                prepare_failed: 'Không thể chuẩn bị hồ sơ.',
                prepare_after_final: 'Hoàn thành và phê duyệt biểu mẫu để chuẩn bị hồ sơ.',
                load_failed: 'Không thể tải hồ sơ.',
                reload: 'Tải lại hồ sơ',
                loading: 'Đang tải hồ sơ…',
                reference: 'Số tham chiếu hồ sơ',
                receiving_authority: 'Cơ quan tiếp nhận',
                receiving_authority_hint: 'Theo nội dung biểu mẫu đã cài đặt.',
                addressee_label: 'Tên cơ quan tiếp nhận',
                addressee_hint: 'Biểu mẫu đã cài đặt nêu một loại cơ quan, không phải một cơ quan cụ thể. Nhập tên cơ quan mà bạn gửi hồ sơ này. Nếu biểu mẫu đã hoàn thành ghi tên cơ quan tại dòng Kính gửi của chính biểu mẫu, hồ sơ dùng tên đó. Tên bạn nhập hoặc xóa tại đây được giữ nguyên và không làm thay đổi biểu mẫu. Bạn có thể để trống cho đến khi xác định.',
                addressee_recorded: 'Tên đã ghi nhận',
                not_recorded: 'Chưa ghi nhận',
                statements_title: 'Nội dung bạn xác nhận',
                statements_description: 'Chỉ bạn, với tư cách bên nộp hồ sơ, mới có thể xác nhận các nội dung này. Nền tảng ghi nhận câu trả lời của bạn và không quyết định thay bạn.',
                statement_basis: 'Căn cứ: {basis}',
                stated_yes: 'Áp dụng',
                stated_no: 'Không áp dụng',
                stated_unanswered: 'Chưa trả lời',
                authority_step_title: 'Bước của cơ quan tiếp nhận',
                authority_step_note: 'Đây là bước của cơ quan tiếp nhận. Không có thời hạn nào được đặt cho tổ chức của bạn.',
                save: 'Lưu hồ sơ',
                saving: 'Đang lưu hồ sơ…',
                saved: 'Đã lưu hồ sơ.',
                save_failed: 'Không thể lưu hồ sơ.',
                export_title: 'Xuất hồ sơ',
                export_hint: 'Giấy trình nộp hồ sơ in tên cơ quan tiếp nhận đã lưu trong hồ sơ. Khi chưa lưu tên, dòng "Kính gửi" được để trống.',
                export_open: 'Xem trước giấy trình nộp hồ sơ',
            },
        },
        outputs: {
            back_instance: 'Quay lại phiên bản',
            no_outputs_msg: 'Chưa có đầu ra nào được tạo.',
            no_outputs_title: 'Không có đầu ra',
            output_name: 'Tên đầu ra',
            download: 'Tải xuống',
            download_failed: 'Không thể tải xuống.',
            fetch_failed: 'Không thể tải đầu ra.',
            format: 'Định dạng',
            generated_at: 'Tạo lúc',
            generated_by: 'Tạo bởi',
            size: 'Kích thước',
            title: 'Đầu ra biểu mẫu',
            preview_in_new_window: 'Xem trước {name} ({format}) trong cửa sổ mới',
            // Sprint 62.45.0 AC9 — column headers of the form print export (PDF table).
            print_col_field: 'Trường',
            print_col_value: 'Giá trị',
            // Sprint 62.45.0 AC9 — metadata lines of the form print export.
            print_meta_instance: 'Mã phiên bản: {id}',
            print_meta_status: 'Trạng thái: {status}',
            print_meta_generated: 'Tạo lúc: {timestamp}',
            // Sprint 63.37.0 (H2) — the header lines of a printed official form.
            official_header_form_number: 'Số hiệu biểu mẫu',
            official_header_instrument: 'Văn bản quy định',
            official_header_issuer: 'Cơ quan ban hành',
            official_header_authority: 'Cơ quan có thẩm quyền',
            // Sprint 62.58.0 (AC-A4) — the draft-instrument notice an output prints before its title.
            draft_notice_frame: 'Được lập theo một văn bản dự thảo chưa có hiệu lực. Không nội dung nào trong tài liệu này là nghĩa vụ.',
            draft_notice_framework: '{name} — phiên bản gói {version}',
            draft_notice_regenerate: 'Được tạo trước khi có thông báo về văn bản dự thảo — hãy tạo lại.',
            // Sprint 62.58.0 gate E12.5 pass 2 (P3-5) — an output whose printed notices no longer match the frameworks' state.
            draft_notice_status_changed: 'Trạng thái của khung tuân thủ đã thay đổi kể từ khi tài liệu này được tạo — hãy tạo lại.',
            downloading: 'Đang tải xuống {name}',
            pdf_preview: 'Xem trước PDF',
            printing: 'Đang in đầu ra biểu mẫu',
            print_outputs: 'In đầu ra biểu mẫu',
            print: 'In',
        },
        // Sprint 62.58.0 (AC-A3) — what an instance surface of a draft instrument's template adds.
        draft_notice: {
            instance_note: 'Việc điền biểu mẫu này không làm cho bất kỳ nội dung nào trong biểu mẫu trở thành nghĩa vụ.',
        },
        cybersec_domains: {
            scope: 'Phạm vi và khả năng áp dụng',
            risk: 'Đánh giá rủi ro và lập bản đồ kiểm soát',
            policy: 'Chính sách an ninh tổ chức',
            localization: 'Nội địa hóa dữ liệu và hiện diện địa phương',
            vendor: 'Bên thứ ba và chuỗi cung ứng',
            authority: 'Xử lý yêu cầu cơ quan chức năng',
            incident: 'Ứng phó sự cố và bằng chứng',
            training: 'Đào tạo và sẵn sàng',
        },
        market_finalization_domains: {
            data_law: 'Luật Dữ liệu — Quản trị & Kiểm soát vận hành',
            pdpl_2025: 'PDPL 2025 — Quản trị quyền riêng tư & Quyền chủ thể dữ liệu',
            decree_356: 'Nghị định 356/2025 — Kiểm soát nhà cung cấp & Xuyên biên giới',
            telecom: 'Luật Viễn thông — Bảo mật & Yêu cầu cơ quan chức năng',
        },
        nav: {
            filing_case_links: 'Liên kết hồ sơ nộp',
            section_routing: 'Phân công mục',
            submission_packages: 'Gói nộp hồ sơ',
        },
        filing_case_links: {
            title: 'Liên kết hồ sơ nộp',
            link_form: 'Liên kết biểu mẫu với hồ sơ nộp',
            filing_case_type: 'Loại hồ sơ nộp',
            form_instance: 'Phiên bản biểu mẫu',
            select_form_instance: 'Chọn một phiên bản biểu mẫu...',
            select_filing_case: 'Chọn một hồ sơ nộp...',
            no_links_found: 'Không tìm thấy liên kết hồ sơ nộp nào.',
            linked: 'Đã liên kết',
            link_created: 'Liên kết hồ sơ lưu trữ đã tạo',
            link_deleted: 'Liên kết hồ sơ nộp đã xóa',
            aria_delete_link: 'Xóa liên kết {name}',
            case_type_dpia_dossier: 'Hồ sơ DPIA',
            case_type_cross_border_filing: 'Hồ sơ xuyên biên giới',
            case_type_breach_notification: 'Thông báo vi phạm',
            filing_case_id: 'ID hồ sơ lưu trữ',
            no_instances_guidance: 'Chưa có phiên bản biểu mẫu. Tạo từ Mẫu biểu.',
            no_filings_guidance: 'Chưa có hồ sơ nộp. Tạo từ Đánh giá.',
        },
        section_routing: {
            title: 'Phân công mục',
            assign_section: 'Phân công mục',
            department: 'Phòng ban',
            select_department: 'Chọn một phòng ban...',
            assignee: 'Người được phân công',
            select_assignee: 'Chọn người được phân công...',
            section: 'Mục',
            select_section: 'Chọn một mục...',
            select_form_instance: 'Chọn một phiên bản biểu mẫu...',
            no_assignments_found: 'Không tìm thấy phân công mục nào.',
            select_instance_prompt: 'Chọn phiên bản biểu mẫu để xem phân công mục.',
            complete_section: 'Hoàn thành mục',
            status_pending: 'Chờ xử lý',
            status_in_progress: 'Đang thực hiện',
            status_completed: 'Đã hoàn thành',
            status_reviewed: 'Đã xem xét',
            status_updated: 'Trạng thái phần đã cập nhật',
            assignment_created: 'Phân công phần đã tạo',
            assignment_deleted: 'Phân công mục đã xóa',
            form_instance_id: 'ID phiên bản biểu mẫu',
            aria_delete_assignment: 'Xóa phân công {name}',
            deadline: 'Hạn chót',
            deadline_help: 'Tùy chọn. Các phân công quá ngày này sẽ hiển thị là quá hạn.',
            overdue: 'Quá hạn',
            days_remaining: 'ngày còn lại',
            approval_requested: 'Đã gửi để xem xét',
            form_approved: 'Biểu mẫu đã phê duyệt',
            form_rejected: 'Biểu mẫu bị từ chối',
            no_departments_guidance: 'Chưa cấu hình phòng ban. Thiết lập trong Cài đặt tổ chức.',
            no_sections_guidance: 'Mẫu biểu chưa có mục nào. Đảm bảo mẫu biểu có các mục.',
            select_instance_first: 'Chọn phiên bản biểu mẫu trước để tải các mục có sẵn.',
        },
        submission_packages: {
            supporting_documents: 'Tài liệu kèm theo',
            supporting_documents_help: 'Các tệp nộp kèm gói này. Mỗi tệp được lưu theo gói và hiển thị trên hồ sơ của gói.',
            no_supporting_documents: 'Chưa có tài liệu kèm theo nào.',
            attach_supporting_document: 'Đính kèm tài liệu',
            supporting_document_attached: 'Đã đính kèm tài liệu',
            title: 'Gói nộp hồ sơ',
            assemble_package: 'Lập gói nộp hồ sơ',
            dossier: 'Hồ sơ',
            select_dossier: 'Chọn một hồ sơ...',
            package_label: 'Nhãn gói',
            cover_letter: 'Thư xin phép',
            checklist: 'Danh mục kiểm tra',
            evidence_index: 'Mục lục bằng chứng',
            completeness: 'Mức độ hoàn thiện',
            incomplete_warning: 'Không thể tập hợp: biểu mẫu có mục chưa hoàn thành.',
            no_packages_found: 'Không tìm thấy gói nộp hồ sơ nào.',
            version: 'Phiên bản',
            package_assembled: 'Gói gửi đã tập hợp',
            package_deleted: 'Gói nộp hồ sơ đã xóa',
            aria_delete_package: 'Xóa gói {name}',
            status_draft: 'Bản nháp',
            status_complete: 'Hoàn thành',
            status_submitted: 'Đã nộp',
            status_accepted: 'Đã chấp nhận',
            status_rejected: 'Đã từ chối',
            package_updated: 'Gói nộp hồ sơ đã cập nhật',
            document_generated: 'Tài liệu đã tạo',
            documents: 'Tài liệu',
            generate: 'Tạo',
            preview: 'Xem trước',
            download: 'Tải xuống',
            download_all: 'Tải tất cả',
            no_dossiers_guidance: 'Chưa có hồ sơ. Tạo từ Đánh giá.',
            package_plan_help: 'Bao gồm trong kế hoạch gói (hỗ trợ tự động tạo tài liệu):',
            cover_letter_help: 'Thư xin phép chính thức gửi cơ quan tiếp nhận',
            checklist_help: 'Danh mục kiểm tra tuân thủ xác minh tất cả yêu cầu nộp hồ sơ',
            evidence_index_help: 'Mục lục tài liệu bằng chứng hỗ trợ được tham chiếu trong hồ sơ nộp',
            completeness_skipped: 'Bỏ qua kiểm tra hoàn thiện — không có phiên bản biểu mẫu liên kết với hồ sơ này.',
            completeness_unavailable: 'Không thể kiểm tra hoàn thiện — tiếp tục lập gói nộp hồ sơ.',
            duplicate_package_error: 'Hồ sơ này đã có một gói nộp hồ sơ đang mở. Chỉ lập được gói mới sau khi gói đó bị từ chối.',
            doc_cover_letter: 'Thư xin việc',
            doc_checklist: 'Danh mục kiểm tra',
            doc_evidence_index: 'Mục lục bằng chứng',
            export_csv: 'Xuất CSV',
            export_success: 'Liên kết hồ sơ nộp đã được xuất thành công',
            no_assignments_guidance: 'Chưa có phân công phần nào. Phân công các phần cho phòng ban và thành viên nhóm để bắt đầu định tuyến.',
            completeness_hint: 'Mức độ đầy đủ là tỷ lệ trong sáu trường của hồ sơ mà thiếu thì không thể nộp gói, gồm: loại hồ sơ, khung tuân thủ, cơ quan tiếp nhận, phương thức nộp, tổ chức nộp hồ sơ và thông tin liên hệ của người nộp, mà hồ sơ đã có.',
            completeness_not_measured: 'Chưa đo: gói được tập hợp trước khi mức độ đầy đủ được tính',
            missing_fields_label: 'Hồ sơ còn thiếu',
            dossier_field_dossier_type: 'Loại hồ sơ',
            dossier_field_regulatory_framework_code: 'Khung tuân thủ',
            dossier_field_authority: 'Cơ quan tiếp nhận',
            dossier_field_submission_method: 'Phương thức nộp',
            dossier_field_applicant_org_name: 'Tổ chức nộp hồ sơ',
            dossier_field_applicant_contact: 'Thông tin liên hệ của người nộp',
        },
        // Sprint 63.37.0 (D4) — the one official-standing badge (`OfficialFormBadge`).
        official_standing: {
            official: 'Biểu mẫu chính thức',
            internal: 'Biểu mẫu nội bộ',
        },
        template_picker: {
            title: 'Chọn mẫu biểu',
            hint: 'Chọn mẫu biểu pháp lý hoặc bắt đầu với biểu mẫu trống.',
            market_filter: 'Lọc theo thị trường',
            framework_filter: 'Lọc theo khung tuân thủ',
            all_markets: 'Tất cả thị trường',
            all_frameworks: 'Tất cả khung tuân thủ',
            search_placeholder: 'Tìm kiếm mẫu biểu...',
            blank_form: 'Biểu mẫu trống / Chung',
            blank_form_desc: 'Tạo mà không cần mẫu — điền các trường thủ công.',
            no_templates: 'Không tìm thấy mẫu biểu cho bộ lọc này.',
            // fix-sprint-20260411-0440-followup F6 — a failed template read is stated, never shown as "none found".
            templates_unreadable: 'Không tải được đầy đủ các mẫu biểu cho biểu mẫu này, nên danh sách bên dưới có thể trống hoặc thiếu. Điều đó không có nghĩa là không có mẫu nào.',
            templates_read_subject: 'các mẫu biểu',
            filters_unreadable: 'Không hiển thị bộ lọc thị trường và khung tuân thủ vì không tải được các lựa chọn của chúng.',
            select: 'Chọn',
            link_error: 'Liên kết mẫu biểu thất bại — bạn có thể liên kết sau từ chế độ Chỉnh sửa.',
            internal_badge: 'Mẫu nội bộ',
            legacy_badge: 'Đã lỗi thời',
            draft_badge: 'Dự thảo',
            upcoming_badge: 'Sắp hiệu lực',
            hidden_badge: 'Ẩn',
            show_hidden_toggle: 'Hiển thị mẫu đã ẩn / lỗi thời',
            show_hidden_toggle_hint: 'Chế độ quản trị — hiển thị cả mẫu được đánh dấu internal_only, hidden, legacy hoặc draft.',
        },
        // FU2b — Cover-letter preview-and-edit modal
        cover_letter_modal: {
            title: 'Thư trình — xem trước và chỉnh sửa',
            iframe_title: 'Xem trước thư trình',
            stage_label: 'Giai đoạn',
            stage_initial: 'Nộp lần đầu',
            stage_supplement: 'Bổ sung',
            stage_resubmission: 'Nộp lại',
            subject_label: 'Tiêu đề',
            body_label: 'Nội dung chính',
            notes_label: 'Ghi chú bổ sung',
            refresh_preview: 'Cập nhật xem trước',
            confirm: 'Xác nhận & lưu',
            regenerate: 'Tạo lại',
            snapshot_saved: 'Đã lưu thư trình',
        },
        related_panel: {
            title: 'Biểu mẫu pháp lý liên quan',
            open_form: 'Điền biểu mẫu',
            no_forms: 'Không tìm thấy biểu mẫu liên quan.',
            hint_vn: 'Biểu mẫu pháp lý Việt Nam có sẵn — chọn biểu mẫu để mở trình tạo biểu mẫu tuân thủ.',
            internal_badge: 'Nội bộ',
            official_badge: 'Chính thức',
            loading: 'Đang tải biểu mẫu liên quan...',
            error: 'Không thể tải biểu mẫu liên quan.',
            form_id: 'Mã biểu mẫu',
            form_name: 'Tên biểu mẫu',
            framework: 'Khung tuân thủ',
        },
        view_form: 'Xem biểu mẫu',
        edit_form: 'Sửa biểu mẫu',
        save_draft: 'Lưu nháp',
        module_settings: 'Cài đặt phân hệ',
        validation_errors: 'Vui lòng sửa các lỗi xác thực',
        custom_name_help: 'Tùy chọn — mặc định là tên biểu mẫu nếu để trống',
        select_placeholder: 'Chọn...',
        // Gate E12.5 pass 3 (QA nit) — the stored-text fallback of a date-and-time field.
        datetime_stored_text_hint: 'Được ghi nhận trước khi trường này nhận ngày và giờ; được giữ nguyên như đã ghi.',
        previous_section: 'Trước',
        next_section: 'Tiếp',
        // fix-sprint-20260411-B F7
        loading: 'Đang tải...',
        array_add: 'Thêm',
        array_remove: 'Xóa',
        array_item_label: 'Mục {index} của {label}',
        array_add_item: 'Thêm mục vào {label}',
        array_remove_item: 'Xóa mục {index} khỏi {label}',
        legacy_banner: 'Bản ghi này được tạo trước khi sử dụng biểu mẫu hợp nhất. Một số dữ liệu có thể khác nhau giữa đối tượng và phiên bản biểu mẫu.',
        field_required: '{label} là bắt buộc',
        // fix-sprint-20260411-0417 Findings 1, 2, 3 — i18n keys for
        // FormSectionRenderer + UnifiedCreationModal section navigation.
        section_announcement: 'Phần {current} trên {total}: {title}',
        sections_nav_label: 'Các phần biểu mẫu',
        no_sections: 'Không có phần biểu mẫu nào.',
        section_label_tpl: 'Phần {index}: {title}',
        field_shown_announcement: '{field} hiện đã hiển thị.',
        field_required_announcement: '{field} hiện là bắt buộc.',
        submit_blocked_hint_one: '1 trường bắt buộc vẫn chưa có câu trả lời.',
        submit_blocked_hint_many: '{count} trường bắt buộc vẫn chưa có câu trả lời.',
        module_settings_auto_applied: 'Cấu hình theo từng phân hệ được áp dụng tự động.',
        // fix-sprint-20260411-0417 Finding 17 — extractErrorMessage fallbacks.
        operation_failed: 'Thao tác thất bại',
        failed_to_load_form: 'Không tải được biểu mẫu',
        failed_to_save_form: 'Không lưu được biểu mẫu',
        failed_to_submit_form: 'Không gửi được biểu mẫu',
        failed_to_load_template: 'Không tải được mẫu',
        failed_to_save_draft: 'Không lưu được bản nháp',
        failed_to_create: 'Không tạo được',
        no_content_generated: 'Chưa tạo được nội dung',
    },
    pack_catalog: {
        title: 'Danh mục gói',
        install: 'Cài đặt gói',
        uninstall: 'Gỡ cài đặt gói',
        install_batch: 'Cài đặt cụm',
        installed_tab: 'Đã cài đặt',
        catalog_tab: 'Danh mục',
        pack_details: 'Chi tiết gói',
        frameworks: 'Khung tuân thủ',
        requirements: 'Yêu cầu',
        artifacts: 'Tài liệu',
        language_pack: 'Gói ngôn ngữ',
        dependencies: 'Phụ thuộc',
        no_packs: 'Không tìm thấy gói nào.',
    },
    platform_pages: {
        users: {
            title: 'Người dùng',
            new: 'Người dùng mới',
            invite: 'Mời người dùng',
            edit: 'Sửa người dùng',
            name: 'Tên',
            email: 'Email',
            role: 'Vai trò',
            status: 'Trạng thái',
            identity_type: 'Loại danh tính',
            initial_password: 'Mật khẩu ban đầu',
            require_password_change_action: 'Yêu cầu đổi mật khẩu',
            require_password_change_confirm: '{name} sẽ chỉ truy cập được bước đổi mật khẩu, kể từ yêu cầu tiếp theo, cho đến khi chọn mật khẩu mới. Tiếp tục?',
            require_password_change_done: 'Người dùng hiện phải đổi mật khẩu.',
            require_password_change_failed: 'Không thể đặt yêu cầu đổi mật khẩu.',
            password_change_pending: 'Phải đổi mật khẩu',
            initial_password_note: 'Hãy gửi mật khẩu qua kênh an toàn. Người dùng phải đổi mật khẩu này ở lần đăng nhập đầu tiên và không thể làm gì khác cho đến khi đổi.',
            last_login: 'Đăng nhập cuối',
            failed_login_attempts: 'Số lần đăng nhập sai',
            never_signed_in: 'Chưa bao giờ',
            deactivate: 'Vô hiệu hóa',
            reactivate: 'Kích hoạt lại',
            unlock: 'Mở khóa',
            reset_password: 'Đặt lại mật khẩu',
            remove: 'Xóa',
            remove_confirm: 'Xóa "{name}"? Hành động này là vĩnh viễn và người dùng sẽ mất mọi quyền truy cập. Bản ghi được giữ lại cho mục đích kiểm toán.',
            user_details_loaded: 'Đã tải thông tin người dùng',
            password_required: 'Vui lòng nhập mật khẩu',
            password_min_length: 'Mật khẩu phải có ít nhất 12 ký tự',
            password_uppercase: 'Mật khẩu phải có ít nhất một chữ cái viết hoa',
            password_lowercase: 'Mật khẩu phải có ít nhất một chữ cái viết thường',
            password_digit: 'Mật khẩu phải có ít nhất một chữ số',
            password_special: 'Mật khẩu phải có ít nhất một ký tự đặc biệt',
            deactivate_failed: 'Không thể vô hiệu hóa người dùng',
            reactivate_failed: 'Không thể kích hoạt lại người dùng',
            remove_failed: 'Không thể xóa người dùng',
            // fix-sprint-20261017-1500 F4 — UserDetailPage's error toasts read these, not English literals.
            update_failed: 'Không thể cập nhật người dùng',
            unlock_failed: 'Không thể mở khóa người dùng',
            assign_role_failed: 'Không thể gán vai trò',
            revoke_role_failed: 'Không thể thu hồi vai trò',
            create_failed: 'Không thể tạo người dùng',
            count_one: '{total} người dùng',
            count_other: '{total} người dùng',
            announce_loaded: 'Đã tải danh sách người dùng',
        },
        roles: {
            title: 'Vai trò',
            new: 'Vai trò mới',
            edit: 'Sửa vai trò',
            name: 'Tên vai trò',
            description: 'Mô tả',
            permissions: 'Quyền',
            users_count: 'Người dùng',
            detail: 'Chi tiết vai trò',
            all_tiers: 'Tất cả các bậc',
            tier: 'Bậc',
            type_system: 'Hệ thống',
            type_custom: 'Tùy chỉnh',
            role_name_placeholder: 'ví dụ: Trưởng nhóm tuân thủ khu vực',
            permissions_heading: 'Quyền',
            permissions_selected: '(đã chọn {count})',
            select_all_offered: 'Chọn tất cả',
            clear_all: 'Bỏ chọn tất cả',
            grant_bounds_hint: 'Bạn chỉ có thể cấp các quyền mà chính bạn đang nắm giữ. Các quyền mà theo thiết kế không vai trò hệ thống nào nắm giữ, như quyền truy cập hồ sơ phòng, chống rửa tiền, chỉ có thể được cấp bởi người tự nắm giữ quyền gán vai trò.',
            permission_not_held_summary: 'Bạn không nắm giữ các quyền sau nên không thể cấp chúng:',
            permission_not_held_item: 'Bạn không nắm giữ quyền này',
            system_role_fixed: 'Quyền của vai trò hệ thống là cố định. Hãy tạo vai trò tùy chỉnh để cấp quyền khác.',
            permission_required: 'Cần ít nhất một quyền.',
            system_role_no_delete: 'Không thể xóa vai trò hệ thống.',
            create_failed: 'Không thể tạo vai trò',
            delete_failed: 'Không thể xóa vai trò',
            update_failed: 'Không thể cập nhật vai trò',
            delete_blocked_active_users: 'Vai trò này vẫn đang được gán cho {count} người dùng. Hãy chuyển họ sang vai trò khác rồi mới xóa vai trò này.',
            delete_blocked_sso_config: 'Đăng nhập một lần (SSO) vẫn đang dùng vai trò này ({names}), làm vai trò mặc định cho người dùng mới hoặc trong phần ánh xạ nhóm. Hãy đổi cài đặt đó trước, rồi mới xóa vai trò này.',
            announce_loaded: 'Đã tải danh sách vai trò',
            announce_detail_loaded: 'Đã tải chi tiết vai trò',
        },
        profile: {
            title: 'Hồ sơ của tôi',
            name: 'Tên',
            email: 'Email',
            role: 'Vai trò',
            last_login: 'Đăng nhập cuối',
            change_password: 'Đổi mật khẩu',
            current_password: 'Mật khẩu hiện tại',
            new_password: 'Mật khẩu mới',
            confirm_password: 'Xác nhận mật khẩu',
            accessibility: 'Trợ năng',
            high_contrast: 'Chế độ tương phản cao',
            high_contrast_desc: 'Tăng tương phản để đọc rõ hơn. Đạt tiêu chuẩn WCAG 2.1 AAA.',
            passwords_no_match: 'Mật khẩu không khớp',
            password_changed_logout: 'Đã đổi mật khẩu. Bạn sẽ bị đăng xuất.',
            failed_update: 'Cập nhật hồ sơ thất bại',
            failed_change_password: 'Đổi mật khẩu thất bại',
            none: 'Không có',
            never: 'Chưa bao giờ',
            password_requirements: 'Tối thiểu 12 ký tự, chữ hoa, chữ thường, số, ký tự đặc biệt',
            display_name: 'Tên hiển thị',
            phone: 'Điện thoại',
            department: 'Phòng ban',
            job_title: 'Chức danh',
            language: 'Ngôn ngữ',
            persona: 'Vai trò phát hiện',
            save: 'Lưu thay đổi',
            save_success: 'Cập nhật hồ sơ thành công',
            module_tips_section: 'Mẹo phân hệ',
            tips_toggle: 'Hiển thị mẹo quy định trong các phân hệ',
            dismissed_tips: 'Mẹo đã bỏ qua',
            reset_dismissed: 'Đặt lại tất cả mẹo đã bỏ qua',
            notification_prefs: 'Tùy chọn thông báo',
            notification_prefs_link: 'Quản lý tùy chọn thông báo →',
            announce_updated: 'Đã cập nhật hồ sơ',
            announce_loaded: 'Đã tải hồ sơ',
        },
        security: {
            mfa_title: 'Cài đặt MFA',
            mfa_enable: 'Bật MFA',
            mfa_disable: 'Tắt MFA',
            mfa_setup: 'Quét mã QR bằng ứng dụng xác thực',
            sso_title: 'Cấu hình SSO',
            sso_provider: 'Nhà cung cấp',
            sso_client_id: 'ID khách hàng',
            sso_redirect: 'URI chuyển hướng',
            sso_idp_section: 'Nhà cung cấp danh tính',
            sso_idp_entity_id: 'ID thực thể của nhà cung cấp danh tính',
            sso_idp_sso_url: 'URL đăng nhập của nhà cung cấp danh tính',
            sso_idp_binding: 'Ràng buộc yêu cầu',
            sso_binding_redirect: 'HTTP Redirect',
            sso_binding_post: 'HTTP POST',
            sso_allow_idp_initiated: 'Chấp nhận đăng nhập bắt đầu từ nhà cung cấp danh tính',
            sso_jit_provisioning: 'Tạo người dùng khi đăng nhập lần đầu',
            sso_default_role: 'Vai trò cho người dùng được tạo khi đăng nhập lần đầu',
            sso_default_role_none: 'Không có mặc định — từ chối đăng nhập',
            sso_assertions_signed: 'Luôn yêu cầu xác nhận (assertion) có chữ ký.',
            sso_acs_hint: 'Cung cấp cho nhà cung cấp danh tính của bạn URL tiếp nhận xác nhận này:',
            // ── Sprint 63.6.1 — OpenID Connect ────────────────────────────
            sso_oidc_issuer: 'Đơn vị phát hành',
            sso_oidc_issuer_hint: 'Định danh đơn vị phát hành mà nhà cung cấp của bạn công bố, đúng như trong tài liệu khám phá của họ. Nền tảng đọc tài liệu đó từ địa chỉ này và từ chối cấu hình có đơn vị phát hành không khớp.',
            sso_oidc_redirect_uri: 'Địa chỉ chuyển hướng cần đăng ký',
            sso_oidc_redirect_uri_hint: 'Hãy đăng ký chính xác địa chỉ này với nhà cung cấp của bạn. Nền tảng tự xác định địa chỉ từ cấu hình nên không thể sửa tại đây.',
            sso_oidc_redirect_uri_pending: 'Có sau khi lưu cấu hình',
            sso_oidc_client_auth: 'Xác thực ứng dụng khách',
            sso_oidc_client_auth_basic: 'Mã bí mật ứng dụng khách, trong tiêu đề Authorization',
            sso_oidc_client_auth_post: 'Mã bí mật ứng dụng khách, trong phần thân yêu cầu',
            sso_oidc_scopes: 'Phạm vi',
            sso_oidc_scopes_hint: 'Phân tách bằng dấu cách. Để trống để dùng openid, profile và email. Phạm vi openid luôn được yêu cầu: nếu thiếu, nhà cung cấp sẽ không trả về mã định danh.',
            sso_oidc_scopes_placeholder: 'openid profile email',
            sso_oidc_identity_claim_note: 'Danh tính được lấy từ thông tin email, và địa chỉ đó phải được nhà cung cấp của bạn xác nhận là đã xác minh. Không đọc thông tin nào khác, và không thông tin nào cấp quyền.',
            sso_certificates: 'Chứng thư ký',
            sso_certificates_empty: 'Chưa có chứng thư ký. Không thể xác minh đăng nhập cho đến khi thêm một chứng thư.',
            sso_certificate_pem: 'Chứng thư (PEM)',
            sso_certificate_add: 'Thêm chứng thư',
            sso_certificate_expires: 'Hết hạn',
            sso_certificate_remove: 'Gỡ chứng thư',
            sso_certificate_limit: 'Tối đa hai chứng thư được lưu giữ, nên việc luân chuyển không cần thời gian ngừng hoạt động.',
            sso_verify: 'Xác minh cấu hình',
            sso_verify_hint: 'Chạy một lần đăng nhập đầy đủ với cấu hình này và báo cáo từng bước kiểm tra. Nó không tạo phiên và không tạo người dùng, nên bạn vẫn đang đăng nhập.',
            sso_verify_report: 'Báo cáo xác minh',
            sso_verify_passed: 'Tất cả các bước kiểm tra đều đạt.',
            sso_verify_failed: 'Một số bước kiểm tra không đạt.',
            sso_check_passed: 'Đạt',
            sso_check_failed: 'Không đạt',
            sso_enforcement: 'Chỉ đăng nhập bằng SSO',
            sso_enforcement_off: 'Tắt — mọi người đều có thể đăng nhập bằng mật khẩu.',
            sso_enforcement_on: 'Bật — chỉ quản trị viên được miễn trừ mới có thể đăng nhập bằng mật khẩu.',
            sso_enforcement_activate: 'Bật chế độ chỉ đăng nhập bằng SSO',
            sso_enforcement_deactivate: 'Tắt chế độ chỉ đăng nhập bằng SSO',
            sso_enforcement_exempt: 'Quản trị viên vẫn giữ đăng nhập bằng mật khẩu',
            sso_enforcement_before: 'Trước khi bạn có thể bật tính năng này:',
            sso_enforcement_need_verify: 'Xác minh cấu hình này và hoàn tất một lần đăng nhập qua nó, trong vòng 15 phút gần đây.',
            sso_enforcement_need_exempt: 'Chỉ định ít nhất một quản trị viên đang hoạt động có mật khẩu.',
            sso_enforcement_recovery: 'Nếu nhà cung cấp danh tính ngừng hoạt động, một quản trị viên được miễn trừ có thể đăng nhập bằng mật khẩu và tắt tính năng này; việc vô hiệu hóa cấu hình cũng khôi phục đăng nhập bằng mật khẩu cho mọi người.',
            sso_mfa_heading: 'Chấp nhận MFA của nhà cung cấp này',
            sso_mfa_intro: 'Theo mặc định, nền tảng yêu cầu MFA của chính nó sau mỗi lần đăng nhập qua nhà cung cấp này. Chỉ bật tính năng này nếu bạn tin tưởng MFA của nhà cung cấp này có thể thay cho MFA của nền tảng.',
            sso_mfa_accept: 'Chấp nhận MFA của nhà cung cấp này thay cho MFA của nền tảng',
            sso_mfa_state_off: 'Tắt. MFA của chính nền tảng áp dụng cho mọi lần đăng nhập qua nhà cung cấp này.',
            sso_mfa_state_on: 'Bật. Một lần đăng nhập chỉ được tính là đã xác minh MFA khi các giá trị nhà cung cấp báo cáo khớp với các giá trị bạn liệt kê bên dưới. Mọi lần đăng nhập khác vẫn phải qua MFA của chính nền tảng.',
            sso_mfa_no_meaning: 'Nền tảng không gán ý nghĩa nào cho bất kỳ giá trị nào. Chỉ các giá trị bạn nhập tại đây, khớp chính xác và đúng chữ hoa chữ thường, mới được tính. Giá trị bạn chưa liệt kê, lần đăng nhập cũ hơn tuổi tối đa và giá trị bị thiếu đều quay về MFA của chính nền tảng.',
            sso_mfa_amr: 'Giá trị phương thức xác thực được chấp nhận (amr)',
            sso_mfa_amr_hint: 'Các giá trị amr chính xác mà nhà cung cấp của bạn báo cáo cho một lần đăng nhập có MFA, phân tách bằng dấu cách hoặc dấu phẩy. Chỉ áp dụng cho OpenID Connect.',
            sso_mfa_acr_oidc: 'Giá trị ngữ cảnh xác thực được chấp nhận (acr)',
            sso_mfa_acr_saml: 'Giá trị ngữ cảnh xác thực được chấp nhận (AuthnContextClassRef)',
            sso_mfa_acr_hint: 'Các giá trị chính xác mà nhà cung cấp của bạn báo cáo cho một lần đăng nhập có MFA, phân tách bằng dấu cách hoặc dấu phẩy.',
            sso_mfa_lists_rule: 'Hãy liệt kê ít nhất một giá trị, nếu không sẽ không có lần đăng nhập nào được tính. Khi bạn liệt kê nhiều loại giá trị, một lần đăng nhập phải khớp với mọi loại.',
            sso_mfa_empty_warning: 'Chưa liệt kê giá trị nào, nên không có lần đăng nhập nào qua nhà cung cấp này được tính là đã xác minh MFA.',
            sso_mfa_max_age: 'Tuổi xác thực tối đa (giây)',
            sso_mfa_max_age_hint: 'Lần đăng nhập tại nhà cung cấp cũ hơn mức này sẽ không được tính. Để trống nếu không kiểm tra tuổi.',
            sso_mfa_max_age_invalid: 'Nhập một số nguyên giây lớn hơn 0, hoặc để trống.',
            sso_revoke_sessions: 'Kết thúc các phiên của nhà cung cấp này',
            sso_revoke_confirm_title: 'Kết thúc các phiên của nhà cung cấp này?',
            sso_revoke_confirm_message: 'Mọi người đang đăng nhập qua {name} sẽ bị đăng xuất và phải đăng nhập lại. Các phiên đăng nhập bằng mật khẩu hoặc qua nhà cung cấp khác không bị kết thúc. Các phiên đăng nhập một lần (SSO) được tạo trước khi hệ thống bắt đầu ghi lại cấu hình mà mỗi phiên xuất phát không thể gán cho một nhà cung cấp, nên cũng sẽ bị kết thúc.',
            sso_revoke_confirm_button: 'Kết thúc phiên',
            sso_revoke_working: 'Đang kết thúc phiên…',
            sso_revoke_result_heading: 'Các phiên đã kết thúc',
            sso_revoke_result_for: 'Nhà cung cấp: {name}',
            sso_revoke_count_total: 'Số phiên đã kết thúc',
            sso_revoke_count_legacy: 'Trong đó, số phiên không thể gán cho một cấu hình',
            sso_revoke_legacy_note: 'Các phiên này có trước trường ghi lại cấu hình mà phiên xuất phát, nên chúng bị kết thúc dù bạn kết thúc phiên của nhà cung cấp nào.',
            sso_revoke_announce: 'Số phiên đã kết thúc: {count}. Trong đó {legacy} phiên không thể gán cho một cấu hình vì có trước trường ghi lại cấu hình đó.',
            sso_revoke_failed: 'Không thể kết thúc các phiên của nhà cung cấp này.',
            sso_mfa_accepted_badge: 'Đã chấp nhận MFA của nhà cung cấp',
            api_keys_title: 'Khóa API',
            api_keys_new: 'Khóa API mới',
            api_keys_name: 'Tên khóa',
            api_keys_last_used: 'Sử dụng cuối',
            api_keys_expires: 'Hết hạn',
            api_keys_revoke: 'Thu hồi',
            service_accounts_title: 'Tài khoản dịch vụ',
            ip_allowlist_title: 'Danh sách IP cho phép',
            ip_add: 'Thêm địa chỉ IP',
            ip_address: 'Địa chỉ IP',
            ip_description: 'Mô tả',
            delegations_title: 'Ủy quyền',
            delegations_new: 'Ủy quyền mới',
            delegations_from: 'Từ người dùng',
            delegations_to: 'Đến người dùng',
            delegations_expires: 'Hết hạn',
            break_glass_title: 'Truy cập khẩn cấp',
            break_glass_requester_only: 'Bạn có thể yêu cầu truy cập khẩn cấp tại đây và theo dõi các yêu cầu của chính bạn bên dưới. Yêu cầu của người khác, phiên đang hoạt động và lịch sử chỉ hiển thị cho người phê duyệt.',
            break_glass_my_requests: 'Yêu cầu của bạn',
            break_glass_request: 'Yêu cầu truy cập',
            break_glass_reason: 'Lý do truy cập',
            break_glass_duration: 'Thời lượng',
            session_settings_title: 'Cài đặt phiên',
            eviction_policy_section: 'Chính sách loại bỏ phiên',
            session_timeout: 'Thời gian chờ phiên (phút)',
            session_max_concurrent: 'Số phiên đồng thời tối đa',
            session_inactivity_warning: 'Cảnh báo không hoạt động (phút)',
            session_timeout_hint: 'Phiên sẽ hết hạn sau tổng thời gian này. Phạm vi hợp lệ: 5-480 phút.',
            session_max_concurrent_hint: 'Số phiên đang hoạt động tối đa cho mỗi người dùng. Phạm vi hợp lệ: 1-20.',
            session_inactivity_warning_hint: 'Hiển thị cảnh báo sau số phút không hoạt động này. Phải nhỏ hơn thời gian chờ phiên.',
            session_timeout_range_error: 'Thời gian chờ phiên phải nằm trong khoảng từ 5 đến 480 phút.',
            session_max_concurrent_range_error: 'Số phiên đồng thời tối đa phải nằm trong khoảng từ 1 đến 20.',
            session_inactivity_warning_range_error: 'Cảnh báo không hoạt động phải từ 1 phút trở lên và nhỏ hơn thời gian chờ phiên.',
            session_settings_load_error: 'Không thể tải cài đặt phiên.',
            session_settings_save_error: 'Không thể lưu cài đặt phiên.',
            eviction_policy_hint: 'Điều gì xảy ra khi người dùng vượt quá giới hạn số phiên đồng thời.',
            eviction_policy_reject: 'Từ chối đăng nhập mới - Ngăn đăng nhập mới cho đến khi một phiên hiện có được kết thúc',
            eviction_policy_evict_oldest: 'Loại bỏ phiên cũ nhất - Tự động kết thúc phiên cũ nhất để cho phép đăng nhập mới',
            active_sessions_title: 'Phiên hoạt động',
            active_sessions_device: 'Thiết bị',
            active_sessions_ip: 'Địa chỉ IP',
            active_sessions_started: 'Bắt đầu',
            active_sessions_revoke: 'Thu hồi phiên',
            active_sessions_confirm_terminate: 'Bạn có chắc chắn muốn kết thúc phiên này không?',
            active_sessions_confirm_terminate_current: 'Đây là phiên hiện tại của bạn. Kết thúc sẽ đăng xuất bạn ngay lập tức. Tiếp tục?',
            active_sessions_confirm_terminate_all: 'Bạn có chắc chắn muốn kết thúc tất cả phiên khác? Chỉ phiên hiện tại của bạn được giữ lại.',
            active_sessions_terminated: 'Đã kết thúc phiên thành công.',
            active_sessions_all_terminated: 'Tất cả các phiên khác đã được kết thúc.',
            active_sessions_terminate_all: 'Kết thúc tất cả phiên khác',
            active_sessions_last_activity: 'Hoạt động cuối',
            active_sessions_current: 'Phiên hiện tại',
            active_sessions_revoke_selected: 'Thu hồi đã chọn',
            active_sessions_confirm_terminate_selected: 'Bạn có chắc muốn kết thúc các phiên đã chọn không?',
            active_sessions_selected_terminated: 'Đã kết thúc các phiên đã chọn thành công.',
            ip_allowlist_desc: 'Quản lý địa chỉ IP được phép truy cập API.',
            ip_no_entries: 'Chưa có địa chỉ IP nào được cấu hình.',
            session_settings_desc: 'Cấu hình thời gian hết hạn phiên và giới hạn phiên đồng thời.',
            session_settings_save_policy: 'Lưu chính sách phiên',
            session_settings_saved: 'Cấu hình phiên đã được cập nhật thành công.',
            session_settings_idle_timeout: 'Thời gian chờ (phút)',
            session_settings_absolute_timeout: 'Thời gian tuyệt đối (phút)',
            session_settings_help_idle: 'Phiên sẽ hết hạn sau khoảng thời gian không hoạt động này.',
            session_settings_help_absolute: 'Phiên sẽ hết hạn sau tổng thời gian này bất kể hoạt động.',
            session_settings_help_max: 'Số lượng phiên đồng thời tối đa cho mỗi người dùng.',
            sso_note: 'Thay đổi cấu hình SSO có thể yêu cầu người dùng xác thực lại.',
            service_accounts_warning: 'Khóa API này chỉ được hiển thị một lần. Sao chép và lưu trữ an toàn.',
            service_accounts_new: 'Tài khoản dịch vụ mới',
            service_accounts_name: 'Tên tài khoản',
            service_accounts_role: 'Vai trò',
            service_accounts_created: 'Đã tạo',
            service_accounts_desc: 'Quản lý tài khoản dịch vụ máy-máy cho tích hợp API.',
            break_glass_warning: 'Truy cập khẩn cấp được kiểm toán và ghi nhận. Chỉ sử dụng cho trường hợp khẩn cấp thực sự.',
            break_glass_min_chars: '{count} / {min} ký tự tối thiểu',
            break_glass_permission_count: '{count} quyền đã chọn',
            break_glass_submitted: 'Yêu cầu truy cập khẩn cấp đã gửi. Đang chờ phê duyệt.',
            break_glass_approved: 'Yêu cầu truy cập khẩn cấp đã được phê duyệt.',
            break_glass_denied: 'Yêu cầu truy cập khẩn cấp đã bị từ chối.',
            break_glass_confirm_activate: 'Phê duyệt yêu cầu này? Việc phê duyệt được ghi lại cùng các quyền đã yêu cầu và thời điểm hết hạn. Bản thân việc phê duyệt không làm thay đổi những gì người yêu cầu có thể thực hiện.',
            break_glass_confirm_title: 'Xác nhận kích hoạt',
            break_glass_pending: 'Yêu cầu đang chờ',
            break_glass_active_sessions: 'Yêu cầu truy cập khẩn cấp đã được phê duyệt',
            break_glass_time_remaining: 'Thời gian còn lại',
            break_glass_expired: 'Đã hết hạn',
            break_glass_approved_denied_by: 'Phê duyệt/Từ chối bởi',
            delegations_desc: 'Quản lý ủy quyền tạm thời giữa các người dùng.',
            delegations_my: 'Ủy quyền của tôi',
            delegations_to_me: 'Được ủy quyền cho tôi',
            delegations_scope_hint: 'Ủy quyền “tất cả quyền của tôi” mang theo các quyền bạn đang nắm giữ hôm nay. Ủy quyền này không thay đổi nếu vai trò của bạn thay đổi sau đó.',
            delegations_window_hint: 'Người được ủy quyền nắm giữ các quyền này từ 00:00 ngày bắt đầu đến 23:59 ngày kết thúc, theo múi giờ của bạn, hoặc đến khi bạn thu hồi ủy quyền, và điều này được kiểm tra ở mỗi yêu cầu. Mỗi lần sử dụng được ghi vào nhật ký kiểm toán bảo mật.',
            delegations_start_in_past: 'Thời điểm bắt đầu không được trước hôm nay.',
            delegations_end_before_start: 'Thời điểm kết thúc phải sau thời điểm bắt đầu.',
            delegations_legacy_all: 'Không cấp quyền nào: được tạo trước khi ủy quyền ghi lại các quyền mang theo. Hãy thu hồi và tạo ủy quyền mới.',
            delegations_not_delegable_hint: 'Các quyền chỉ được nắm giữ qua một vai trò tùy chỉnh được chỉ định hoặc không tổ chức nào nắm giữ, cùng quyền quản trị đăng nhập một lần và quyền quản trị người dùng nhóm, không thể ủy quyền và không được liệt kê.',
            delegations_reason: 'Lý do',
            delegations_start: 'Bắt đầu',
            delegations_end: 'Kết thúc',
            delegations_scope_all: 'Tất cả quyền của tôi tại thời điểm hôm nay',
            delegations_scope_specific: 'Các quyền được chọn',
            delegations_created: 'Đã tạo ủy quyền thành công.',
            delegations_revoked: 'Đã thu hồi ủy quyền.',
            delegations_confirm_revoke: 'Bạn có chắc chắn muốn thu hồi ủy quyền này?',
            delegations_confirm_revoke_title: 'Xác nhận thu hồi',
            delegations_permission_count: '{count} quyền',
            delegations_no_longer_delegable: 'Không còn được phép ủy quyền nên không được cấp: {permissions}',
            api_keys_status: 'Trạng thái',
            api_keys_prefix: 'Tiền tố khóa',
            api_keys_permissions_count: 'Quyền',
            api_keys_ip_count: 'Hạn chế IP',
            api_keys_created: 'Đã tạo',
            api_keys_confirm_revoke_title: 'Xác nhận thu hồi',
            api_keys_confirm_revoke_message: 'Bạn có chắc chắn muốn thu hồi khóa API "{name}"? Hành động này không thể hoàn tác.',
            api_keys_confirm_rotate_title: 'Xác nhận xoay khóa',
            api_keys_confirm_rotate_message: 'Xoay khóa API "{name}"? Một khóa mới được cấp ngay; khóa hiện tại vẫn hoạt động thêm 24 giờ để bạn kịp thay thế, sau đó ngừng hoạt động. Nếu khóa có thể đã bị lộ, hãy thu hồi khóa thay vì xoay.',
            api_keys_created_success: 'Khóa API đã được tạo thành công.',
            api_keys_revoked_success: 'Khóa API "{name}" đã bị thu hồi.',
            api_keys_rotated_success: 'Khóa API "{name}" đã được xoay. Sao chép khóa mới bên dưới.',
            api_keys_load_error: 'Không thể tải danh sách khóa API.',
            api_keys_create_error: 'Không thể tạo khóa API.',
            api_keys_revoke_error: 'Không thể thu hồi khóa API.',
            api_keys_rotate_error: 'Không thể xoay khóa API.',
            api_keys_allowed_origins: 'Origin được phép',
            api_keys_allowed_origins_hint: 'Mỗi dòng một origin: giao thức, tên máy chủ và cổng (không bắt buộc), ví dụ https://app.example.com. Khi đã đặt, yêu cầu phải mang header Origin khớp chính xác với một mục, nếu không sẽ bị từ chối. Để trống với khóa dùng giữa các máy chủ.',
            api_keys_rate_limit: 'Số yêu cầu mỗi phút',
            api_keys_rate_limit_hint: 'Để trống nếu không giới hạn. Khi vượt giới hạn, yêu cầu bị từ chối với mã 429 và header Retry-After cho đến khi phút tiếp theo bắt đầu.',
            api_keys_rate_limit_invalid: 'Số yêu cầu mỗi phút phải là số nguyên từ 1 đến 10.000.',
            api_keys_status_at_creation: 'Trạng thái khi tạo',
            api_keys_status_option_active: 'Hoạt động: khóa dùng được ngay khi tạo',
            api_keys_status_option_inactive: 'Không hoạt động: khóa không xác thực yêu cầu nào cho đến khi bạn kích hoạt',
            api_keys_col_origins: 'Origin',
            api_keys_col_rate_limit: 'Giới hạn mỗi phút',
            api_keys_no_limit: 'Không giới hạn',
            api_keys_edit_title: 'Sửa khóa API',
            api_keys_save: 'Lưu thay đổi',
            api_keys_updated_success: 'Đã cập nhật khóa API "{name}".',
            api_keys_update_error: 'Không thể cập nhật khóa API.',
            api_keys_edit_action: 'Sửa khóa {name}',
            api_keys_activate_action: 'Kích hoạt khóa {name}',
            api_keys_pause_action: 'Tạm dừng khóa {name}',
            api_keys_rotate_action: 'Xoay khóa {name}',
            api_keys_revoke_action: 'Thu hồi khóa {name}',
            api_keys_copy_raw_key: 'Sao chép khóa API vào bộ nhớ tạm',
            api_keys_activated_success: 'Khóa API "{name}" đang hoạt động.',
            api_keys_paused_success: 'Khóa API "{name}" đã tạm dừng. Khóa không xác thực yêu cầu nào cho đến khi được kích hoạt lại.',
            api_keys_status_error: 'Không thể thay đổi trạng thái khóa API.',
            api_keys_status_rotated: 'Đã xoay',
            api_keys_rotated_grace_until: 'Vẫn hoạt động đến {time}. Thu hồi khóa để dừng ngay.',
            service_accounts_load_error: 'Không thể tải các tài khoản dịch vụ.',
            service_accounts_created_success: 'Đã tạo tài khoản dịch vụ.',
            service_accounts_create_error: 'Không thể tạo tài khoản dịch vụ.',
            service_accounts_confirm_deactivate_title: 'Xác nhận vô hiệu hóa',
            service_accounts_confirm_deactivate_message: 'Bạn có chắc muốn vô hiệu hóa tài khoản dịch vụ "{name}"? Mọi khóa API liên kết sẽ ngừng hoạt động.',
            service_accounts_deactivated_success: 'Tài khoản dịch vụ "{name}" đã bị vô hiệu hóa.',
            service_accounts_deactivate_error: 'Không thể vô hiệu hóa tài khoản dịch vụ.',
            service_accounts_deactivate_action: 'Vô hiệu hóa tài khoản dịch vụ {name}',
            service_accounts_table_label: 'Tài khoản dịch vụ',
            service_accounts_name_placeholder: 'Ví dụ: Bot đồng bộ dữ liệu',
            service_accounts_purpose_placeholder: 'Ví dụ: Đồng bộ dữ liệu tự động',
            permission_picker_selected_count: 'Đã chọn {count}',
            permission_picker_result_count: 'Đang hiển thị {count}/{total} quyền',
            permission_picker_selected_heading: 'Quyền đã chọn',
            permission_picker_remove: 'Bỏ chọn {permission}',
            break_glass_duration_15: '15 phút',
            break_glass_duration_30: '30 phút',
            break_glass_duration_60: '60 phút (1 giờ)',
            break_glass_duration_120: '120 phút (2 giờ)',
            break_glass_duration_240: '240 phút (4 giờ)',
            sod_rules_title: 'Quy tắc phân tách nhiệm vụ',
            sod_violations_report: 'Báo cáo vi phạm',
            sod_create_rule: 'Tạo quy tắc',
            sod_col_name: 'Tên',
            sod_col_description: 'Mô tả',
            sod_col_conflict_count: 'Số xung đột',
            sod_col_severity: 'Mức độ',
            sod_col_status: 'Trạng thái',
            sod_col_actions: 'Hành động',
            sod_no_rules: 'Không tìm thấy quy tắc SoD nào',
            sod_severity_warning: 'Cảnh báo',
            sod_severity_blocking: 'Chặn',
            sod_active: 'Hoạt động',
            sod_inactive: 'Không hoạt động',
            sod_edit: 'Sửa',
            sod_exceptions: 'Ngoại lệ',
            sod_deactivate: 'Vô hiệu hóa',
            sod_confirm_deactivate_title: 'Xác nhận vô hiệu hóa',
            sod_confirm_deactivate_message: 'Vô hiệu hóa quy tắc "{name}"? Nó sẽ không còn đánh dấu vi phạm.',
            sod_deactivate_error: 'Không thể vô hiệu hóa quy tắc',
            sod_rule_count: '{count} quy tắc',
            active_sessions_loaded: 'Đã tải các phiên đang hoạt động',
            api_keys_loaded: 'Đã tải các khóa API',
            backup_codes_regenerated: 'Đã tạo lại mã dự phòng.',
            break_glass_loaded: 'Đã tải dữ liệu truy cập khẩn cấp',
            delegations_loaded: 'Đã tải các ủy quyền',
            ip_added: 'Đã thêm địa chỉ IP.',
            ip_allowlist_loaded: 'Đã tải danh sách IP được phép',
            ip_removed: 'Đã gỡ địa chỉ IP.',
            mfa_disabled: 'Đã tắt xác thực đa yếu tố.',
            mfa_status_loaded: 'Đã tải trạng thái xác thực đa yếu tố',
            service_accounts_loaded: 'Đã tải các tài khoản dịch vụ',
            session_settings_loaded: 'Đã tải cài đặt phiên',
            // ── Sprint 63.7.0: organisation-level MFA enforcement + IP allowlist enforcement ──
            mfa_org_enforcement_heading: 'Áp dụng cho tổ chức',
            // fix-sprint-20261017-1500 F6 — a failed policy read is stated, with a retry.
            mfa_org_policy_read_failed: 'Không thể đọc chính sách xác thực đa yếu tố của tổ chức, nên mức hiện tại chưa được hiển thị.',
            mfa_org_policy_retry_subject: 'chính sách xác thực đa yếu tố của tổ chức',
            mfa_org_enforcement_intro: 'Chọn việc tổ chức này có bắt buộc xác thực đa yếu tố hay không. Mặc định là Tùy chọn, đúng như nền tảng vẫn hoạt động từ trước: người đã cài ứng dụng xác thực thì được hỏi mã, người chưa cài thì không. Nâng mức không bao giờ khóa ai ra ngoài — người thuộc diện bắt buộc mà chưa có yếu tố thứ hai sẽ được yêu cầu cài đặt ở lần đăng nhập kế tiếp và có thể tự hoàn tất.',
            mfa_level_optional: 'Tùy chọn',
            mfa_level_optional_desc: 'Mỗi người tự quyết định. Ai đã cài ứng dụng xác thực thì được hỏi mã; ai chưa cài thì đăng nhập chỉ bằng mật khẩu.',
            mfa_level_admin_required: 'Bắt buộc với quản trị viên',
            mfa_level_admin_required_desc: 'Người có vai trò được phép thay đổi cài đặt bảo mật của tổ chức này phải có yếu tố thứ hai. Điều này căn cứ vào quyền của vai trò chứ không căn cứ vào tên vai trò, nên các vai trò tùy chỉnh của tổ chức cũng thuộc diện áp dụng.',
            mfa_level_all_required: 'Bắt buộc với tất cả',
            mfa_level_all_required_desc: 'Mọi người trong tổ chức này đều phải có yếu tố thứ hai.',
            mfa_enforcement_current: 'Đang áp dụng',
            mfa_enforcement_apply: 'Dùng mức này',
            mfa_unenrolled_count: '{count} người sẽ được yêu cầu cài ứng dụng xác thực ở lần đăng nhập kế tiếp.',
            mfa_enforcement_confirm_title: 'Thay đổi mức áp dụng?',
            mfa_enforcement_confirm_message: 'Thao tác này đặt mức thành {level}. {count} người sẽ được yêu cầu cài ứng dụng xác thực ở lần đăng nhập kế tiếp. Họ có thể tự hoàn tất và không ai bị khóa ra ngoài.',
            mfa_enforcement_saved: 'Đã cập nhật mức áp dụng.',
            mfa_enforcement_save_failed: 'Không thể thay đổi mức áp dụng.',
            mfa_enforcement_no_lockout: 'Nâng mức không thể khóa tổ chức này ra ngoài. Người thuộc diện bắt buộc mà chưa có yếu tố thứ hai vẫn đăng nhập được; họ được đưa tới màn hình cài đặt và có thể tự hoàn tất.',
            mfa_admin_heading: 'Xác thực đa yếu tố',
            mfa_admin_enrolled: 'Đã cài đặt',
            mfa_admin_not_enrolled: 'Chưa cài đặt',
            mfa_admin_backup_codes_remaining: '{count} mã dự phòng chưa dùng',
            mfa_admin_reason_label: 'Lý do',
            mfa_admin_reason_hint: 'Tối thiểu 20 ký tự. Nội dung này được ghi vào nhật ký kiểm toán và là ghi nhận duy nhất còn lại về lý do.',
            mfa_admin_reset: 'Đặt lại',
            mfa_admin_disable: 'Tắt',
            mfa_admin_revoke_codes: 'Thu hồi mã dự phòng',
            mfa_admin_action_done: 'Đã xong. Người này đã được thông báo.',
            mfa_admin_action_failed: 'Không thể hoàn tất thao tác.',
            // ── fix-sprint-20260921-2110: the self-service TOTP flow and the backup-codes file ──
            mfa_page_intro: 'Cài đặt và quản lý bước xác minh thứ hai cho tài khoản của bạn. Nếu tổ chức của bạn yêu cầu, mức áp dụng được hiển thị bên dưới.',
            mfa_not_enrolled_intro: 'Bảo vệ tài khoản của bạn bằng một bước xác minh thứ hai.',
            mfa_scan_instruction: 'Quét mã QR bằng ứng dụng xác thực của bạn, sau đó nhập mã 6 số mà ứng dụng hiển thị để xác nhận.',
            mfa_qr_alt: 'Mã QR chứa khóa cài đặt cho ứng dụng xác thực của bạn. Nếu không quét được, khóa đó cũng được ghi đầy đủ ở ô bên dưới.',
            mfa_secret_manual_label: 'Hoặc nhập khóa cài đặt này theo cách thủ công',
            mfa_confirm_code_label: 'Nhập mã 6 số từ ứng dụng xác thực của bạn',
            mfa_enrolled_description: 'Tài khoản này đang được bảo vệ bằng một bước xác minh thứ hai.',
            mfa_enabled_since: 'Đang sử dụng từ {date}.',
            mfa_status_load_failed: 'Không thể tải trạng thái xác thực đa yếu tố của bạn.',
            mfa_enroll_failed: 'Không thể bắt đầu cài đặt yếu tố thứ hai.',
            mfa_invalid_code: 'Mã không được chấp nhận. Hãy kiểm tra ứng dụng xác thực và nhập mã đang hiển thị.',
            mfa_regenerate_failed: 'Không thể tạo mã dự phòng mới.',
            mfa_disable_confirm_title: 'Tắt xác thực đa yếu tố?',
            mfa_disable_confirm_message: 'Tài khoản của bạn sẽ chỉ còn được bảo vệ bằng mật khẩu, khiến người khác dễ đăng nhập vào tài khoản của bạn hơn. Bạn có thể cài đặt lại yếu tố thứ hai bất cứ lúc nào.',
            mfa_disable_failed: 'Không thể tắt xác thực đa yếu tố.',
            mfa_backup_codes_heading: 'Mã dự phòng của bạn',
            mfa_backup_codes_save_now: 'Các mã này chỉ hiển thị một lần và không thể hiển thị lại. Hãy lưu vào nơi an toàn ngay bây giờ — mỗi mã giúp bạn đăng nhập khi mất ứng dụng xác thực và mỗi mã chỉ dùng được một lần.',
            mfa_backup_codes_file_heading: 'AesirX ComplianceOne — Mã dự phòng MFA',
            mfa_backup_codes_file_notice: 'Hãy lưu các mã này ở nơi an toàn. Mỗi mã chỉ có thể dùng một lần.',
            mfa_backup_codes_file_generated: 'Tạo lúc: {date}',
            mfa_enforcement_apply_named: 'Dùng mức này: {level}',
            mfa_admin_no_read_notice: 'Bạn có thể xem người này đã có yếu tố thứ hai hay chưa và có thể thu hồi nó. Bạn không thể xem nội dung của nó và không thể cài đặt thay cho họ.',
            ip_enforcement_heading: 'Áp dụng',
            ip_enforcement_dry_run: 'Danh sách này hiện chưa từ chối gì. Nó được đối chiếu với mọi yêu cầu đã đăng nhập và kết quả được ghi nhận, để bạn thấy ai sẽ bị từ chối trước khi có ai thực sự bị từ chối.',
            ip_enforcement_active: 'Đang áp dụng từ {date}.',
            ip_enforcement_would_block: '{count} lần được ghi nhận trong 30 ngày qua, khi một yêu cầu đã đăng nhập đến từ địa chỉ không nằm trong danh sách này.',
            ip_enforcement_would_block_zero: 'Trong 30 ngày qua không ghi nhận yêu cầu đã đăng nhập nào đến từ địa chỉ ngoài danh sách này. Điều đó cũng có thể có nghĩa là chưa ai đăng nhập, nên hãy xem lại thay vì coi là đã an toàn.',
            ip_enforcement_confirm_button: 'Bắt đầu áp dụng',
            ip_enforcement_withdraw_button: 'Ngừng áp dụng',
            ip_enforcement_confirm_title: 'Bắt đầu từ chối yêu cầu từ ngoài danh sách này?',
            ip_enforcement_confirm_message: 'Từ thời điểm này, yêu cầu đã đăng nhập đến từ địa chỉ không nằm trong danh sách sẽ bị từ chối.',
            ip_enforcement_confirmed: 'Danh sách này hiện đang được áp dụng.',
            ip_enforcement_withdrawn: 'Danh sách này không còn được áp dụng.',
            ip_enforcement_sessions_note: 'Bật tính năng này không đăng xuất ai cả. Mỗi yêu cầu được xét khi đến, nên phiên làm việc từ địa chỉ không còn thuộc danh sách sẽ đơn giản là ngừng hoạt động. Để kết thúc các phiên ngay, hãy dùng Phiên đang hoạt động.',
            ip_enforcement_edit_withdraws: 'Chỉnh sửa dải địa chỉ sẽ ngừng áp dụng cho tới khi bạn xác nhận lại, vì các số liệu bạn đã xác nhận là về danh sách cũ.',
            ip_configure: 'Cấu hình',
            ip_configure_title: 'Cấu hình danh sách IP được phép',
            ip_configure_enabled_hint: 'Khi bật, chỉ các yêu cầu từ những địa chỉ IP có trong danh sách mới được chấp nhận.',
            ip_enforcement_mode_label: 'Chế độ áp dụng',
            ip_enforcement_mode_all_access: 'Toàn bộ truy cập — hạn chế cả giao diện và API',
            ip_enforcement_mode_api_keys_only: 'Chỉ khóa API — chỉ hạn chế truy cập bằng khóa API',
            ip_address_placeholder: '203.0.113.1 hoặc 192.168.1.0/24',
            ip_description_placeholder: 'ví dụ: Mạng văn phòng',
            ip_entries_table_label: 'Các mục trong danh sách IP được phép',
            ip_remove_action: 'Xóa {cidr} khỏi danh sách được phép',
            ip_remove_confirm_title: 'Xác nhận xóa',
            ip_remove_confirm_message: 'Bạn có chắc muốn xóa {cidr} khỏi danh sách được phép không?',
            ip_load_failed: 'Không thể tải cài đặt danh sách IP được phép.',
            ip_cidr_invalid: 'Định dạng không hợp lệ. Hãy nhập một địa chỉ IP (203.0.113.1) hoặc một dải CIDR (192.168.1.0/24)',
            ip_cidr_duplicate: 'Dải CIDR này đã có trong danh sách được phép.',
            ip_add_failed: 'Không thể thêm địa chỉ IP.',
            ip_remove_failed: 'Không thể xóa địa chỉ IP.',
            ip_save_failed: 'Không thể lưu cài đặt.',
            ip_enforcement_confirm_caller_covered: 'Bạn đang kết nối từ {ip}, và danh sách này có bao gồm địa chỉ đó, nên bạn sẽ không mất quyền truy cập màn hình này.',
            ip_enforcement_confirm_caller_not_covered: 'Bạn đang kết nối từ {ip}, địa chỉ không nằm trong danh sách này. Việc xác nhận sẽ bị từ chối thay vì khóa bạn ra ngoài, vì vậy hãy thêm địa chỉ này vào danh sách trước.',
            ip_enforcement_confirm_caller_unknown: 'Màn hình này chưa xác định được danh sách có bao gồm địa chỉ bạn đang kết nối hay không. Điều đó sẽ được kiểm tra lại khi bạn xác nhận, và một xác nhận có thể khóa bạn ra ngoài sẽ bị từ chối.',
            ip_enforcement_readiness_unreadable: 'Không đọc được số liệu 30 ngày về những gì danh sách này lẽ ra đã từ chối, nên màn hình này không hiển thị được con số đó.',
            sso_metadata_url: 'URL tài liệu mô tả (metadata/discovery)',
            sso_metadata_url_hint: 'Tài liệu discovery hoặc metadata OpenID Connect do nhà cung cấp danh tính công bố. Đây không phải là URI chuyển hướng: URI chuyển hướng cần đăng ký với nhà cung cấp được hiển thị ở trên, do nền tảng tạo ra và không thể nhập ở đây.',
            sso_client_secret: 'Client Secret',
            sso_issuer_placeholder: 'https://login.example.com',
            sso_sp_entity_id_placeholder: 'https://grc.example.com/saml/metadata',
            sso_configs_table_label: 'Cấu hình đăng nhập một lần',
            sso_configs_unreadable: 'Không đọc được các cấu hình đăng nhập một lần, nên màn hình này không thể cho biết tổ chức có cấu hình nào hay không.',
            sso_configs_retry: 'Tải lại',
            sso_configs_retry_busy: 'Đang tải lại…',
            sso_configs_retry_subject: 'các cấu hình đăng nhập một lần',
            sso_load_failed: 'Không thể tải các cấu hình đăng nhập một lần.',
            sso_report_read_failed: 'Không thể đọc báo cáo xác minh.',
            sso_save_failed: 'Không thể lưu cấu hình đăng nhập một lần.',
            sso_delete_failed: 'Không thể xóa cấu hình đăng nhập một lần.',
            sso_certificate_add_failed: 'Không thể thêm chứng thư.',
            sso_verify_start_failed: 'Không thể bắt đầu lượt xác minh.',
            sso_enforcement_on_failed: 'Không thể bật chế độ chỉ đăng nhập bằng SSO.',
            sso_enforcement_off_failed: 'Không thể tắt chế độ chỉ đăng nhập bằng SSO.',
            sso_updated: 'Đã cập nhật cấu hình đăng nhập một lần.',
            sso_created: 'Đã tạo cấu hình đăng nhập một lần.',
            sso_delete_confirm_title: 'Xác nhận xóa',
            sso_delete_confirm_message: 'Bạn có chắc muốn xóa cấu hình đăng nhập một lần "{name}" không?',
            sso_deleted: 'Đã xóa cấu hình đăng nhập một lần "{name}".',
            sso_delete_end_sessions: 'Đồng thời kết thúc các phiên của nhà cung cấp này',
            sso_delete_end_sessions_hint: 'Xóa một cấu hình sẽ chặn các lần đăng nhập mới qua cấu hình đó nhưng không kết thúc các phiên mà nó đã tạo. Giữ ô này được chọn để kết thúc các phiên đó ngay. Nếu bỏ chọn, bạn có thể kết thúc chúng sau tại "Cấu hình đã xóa".',
            sso_delete_sessions_not_ended: 'Cấu hình đã được xóa nhưng không thể kết thúc các phiên của nó. Hãy kết thúc các phiên đó tại "Cấu hình đã xóa".',
            sso_deleted_heading: 'Cấu hình đã xóa',
            sso_deleted_intro: 'Các cấu hình này không còn chấp nhận đăng nhập. Việc xóa một cấu hình không kết thúc các phiên mà nó đã tạo; hãy kết thúc chúng tại đây bằng "Kết thúc các phiên của nhà cung cấp này".',
            sso_deleted_table_label: 'Các cấu hình đăng nhập một lần đã xóa',
            sso_deleted_unreadable: 'Không đọc được các cấu hình đăng nhập một lần đã xóa.',
            sso_deleted_retry_subject: 'các cấu hình đăng nhập một lần đã xóa',
            sso_configs_loaded: 'Đã tải cấu hình đăng nhập một lần',
            active_sessions_select_aria: 'Chọn phiên từ {ip}',
            active_sessions_terminate_aria: 'Kết thúc phiên từ {ip}',
            active_sessions_terminate_current_aria: 'Kết thúc phiên từ {ip} (phiên hiện tại)',
            active_sessions_unknown_ip: 'IP không xác định',
            active_sessions_select_all_aria: 'Chọn tất cả phiên',
        },
        access_reviews: {
            title: 'Xem xét truy cập',
            campaigns: 'Chiến dịch xem xét',
            new_campaign: 'Chiến dịch mới',
            campaign_name: 'Tên chiến dịch',
            scope: 'Phạm vi',
            reviewers: 'Người xem xét',
            due_date: 'Hạn hoàn thành',
            progress: 'Tiến độ',
            my_reviews: 'Xem xét của tôi',
            approve: 'Phê duyệt',
            revoke: 'Thu hồi',
            analytics: 'Phân tích vai trò',
            analytics_title: 'Phân tích vai trò',
            permission_usage: 'Sử dụng quyền',
            role_coverage: 'Độ bao phủ vai trò',
            campaign_detail: 'Chi tiết chiến dịch',
            campaign_description: 'Mô tả',
            campaign_status: 'Trạng thái',
            campaign_deadline: 'Hạn chót',
            campaign_scope_type: 'Loại phạm vi',
            campaign_completion: 'Hoàn thành',
            campaign_total_items: 'Tổng mục',
            campaign_pending_items: 'Chờ xử lý',
            campaign_confirmed_items: 'Đã xác nhận',
            campaign_revoked_items: 'Đã thu hồi',
            campaign_escalated_items: 'Đã leo thang',
            campaign_launch: 'Khởi chạy chiến dịch',
            campaign_cancel: 'Hủy chiến dịch',
            campaign_confirm_launch: 'Bạn có chắc chắn muốn khởi chạy chiến dịch này?',
            campaign_confirm_cancel: 'Bạn có chắc chắn muốn hủy chiến dịch này?',
            campaign_launched: 'Chiến dịch đã được khởi chạy thành công.',
            campaign_cancelled: 'Chiến dịch đã bị hủy.',
            review_items: 'Mục xem xét',
            review_item_user: 'Người dùng',
            review_item_role: 'Vai trò',
            review_item_reviewer: 'Người đánh giá',
            review_item_decision: 'Quyết định',
            review_item_justify: 'Lý do',
            review_item_confirm: 'Xác nhận',
            review_item_revoke: 'Thu hồi',
            review_item_escalate: 'Leo thang',
            all_decisions: 'Tất cả quyết định',
            bulk_action: 'Hành động hàng loạt',
            bulk_confirm: 'Xác nhận hàng loạt',
            bulk_revoke: 'Thu hồi hàng loạt',
            selected_count: '{count} đã chọn',
            justify_required: 'Cần có lý do',
            scope_all_users: 'Tất cả người dùng',
            scope_role_owner: 'Chủ vai trò',
            scope_department: 'Phòng ban',
            back_to_campaigns: 'Quay lại danh sách chiến dịch',
            recommendations: 'Đề xuất',
            refreshing: 'Đang làm mới...',
            decide: 'Quyết định',
            decision_by: 'Quyết định bởi',
            loading_items: 'Đang tải mục...',
            loading_review_items: 'Đang tải mục xem xét...',
            campaign_not_found: 'Không tìm thấy chiến dịch',
            loading_campaign: 'Đang tải chi tiết chiến dịch...',
            campaign_completed: 'Chiến dịch đã hoàn thành thành công.',
            confirm_cancel_title: 'Xác nhận hủy',
            justify_bulk_confirm: 'Lý do cho xác nhận hàng loạt:',
            justify_bulk_revoke: 'Lý do cho thu hồi hàng loạt:',
            items_selected: '{count} mục đã chọn',
            justify_bulk_required: 'Cần có lý do cho hành động hàng loạt',
            create_campaign_title: 'Tạo chiến dịch xem xét truy cập',
            name_required: 'Tên là bắt buộc',
            scope_type_required: 'Loại phạm vi là bắt buộc',
            reviewer_strategy_required: 'Chiến lược người đánh giá là bắt buộc',
            deadline_required: 'Hạn chót là bắt buộc',
            reviewer_id_required: 'ID người đánh giá là bắt buộc cho chiến lược người dùng cụ thể',
            invalid_json: 'JSON không hợp lệ',
            scope_filter_label: 'Bộ lọc phạm vi (JSON)',
            reviewer_strategy_label: 'Chiến lược người đánh giá',
            reviewer_id_label: 'ID người đánh giá',
            deadline_label: 'Hạn chót',
            create_campaign_btn: 'Tạo chiến dịch',
            scope_type_label: 'Loại phạm vi',
            scope_by_role: 'Theo vai trò',
            scope_by_department: 'Theo phòng ban',
            scope_custom: 'Tùy chỉnh',
            reviewer_manager: 'Quản lý',
            reviewer_specific_user: 'Người dùng cụ thể',
            enter_json_filter: 'Nhập bộ lọc JSON',
            hint_label: 'Gợi ý:',
            role_usage: 'Sử dụng vai trò',
            over_privileged_users: 'Người dùng có quá nhiều quyền',
            role_name_col: 'Tên vai trò',
            assigned_users: 'Người dùng được gán',
            active_users_30d: 'Người dùng hoạt động (30 ngày)',
            total_perms: 'Tổng quyền',
            used_perms: 'Quyền đã dùng',
            unused_perms: 'Quyền chưa dùng',
            no_data_available: 'Không có dữ liệu',
            roles_col: 'Vai trò',
            total_col: 'Tổng',
            used_col: 'Đã dùng',
            unused_pct: '% chưa dùng',
            current_count: 'Số lượng hiện tại',
            recommended_count: 'Số lượng đề xuất',
            rationale: 'Lý do',
            loading_analytics: 'Đang tải phân tích...',
            loading_role_analytics: 'Đang tải dữ liệu phân tích vai trò...',
            computed_at: 'Tính toán lúc:',
            form_errors: 'Biểu mẫu có {count} lỗi. Vui lòng sửa.',
            scope_filter_invalid_json: 'Bộ lọc phạm vi chứa JSON không hợp lệ',
            scope_hint_all_users: 'Không cần bộ lọc -- tất cả người dùng sẽ được bao gồm.',
            review_type_label: 'Loại xem xét',
            review_type_required: 'Loại xem xét là bắt buộc',
            reviewer_ids_label: 'ID người xem xét',
            reviewer_ids_hint: 'Nhập ID người dùng, phân cách bằng dấu phẩy',
            reviewer_ids_required: 'Cần ít nhất một ID người xem xét',
            start_date_label: 'Ngày bắt đầu',
            start_date_required: 'Ngày bắt đầu là bắt buộc',
            end_date_label: 'Ngày kết thúc',
            end_date_required: 'Ngày kết thúc là bắt buộc',
            review_type_user_access: 'Quyền truy cập người dùng',
            review_type_role_permissions: 'Quyền theo vai trò',
            review_type_service_accounts: 'Tài khoản dịch vụ',
            review_type_privileged_access: 'Quyền truy cập đặc quyền',
            review_type_application_access: 'Quyền truy cập ứng dụng',
            auto_revoke_label: 'Tự động thu hồi khi từ chối',
            campaigns_title: 'Chiến dịch xem xét truy cập',
            create_campaign_label: '+ Tạo chiến dịch',
            no_campaigns_found: 'Không tìm thấy chiến dịch nào',
            loading_campaigns: 'Đang tải chiến dịch...',
            no_reviews_assigned: 'Không có xem xét nào được gán cho bạn',
            loading_reviews: 'Đang tải xem xét...',
            review_decision_title: 'Quyết định xem xét',
            justification_label: 'Lý do',
            announce_loaded_review_items: 'Đã tải {count} mục xem xét',
            announce_loaded_campaigns: 'Đã tải {count} chiến dịch',
            announce_decision_submitted: 'Đã gửi quyết định "{decision}" cho mục xem xét',
            announce_decision_submitted_for: 'Đã gửi quyết định "{decision}" cho {name}',
            announce_bulk_decision: 'Đã áp dụng {decision} hàng loạt cho {count} mục',
        },
        attestation: {
            training_ids_label: 'Khóa đào tạo được xác nhận',
            training_ids_help: 'Các khóa đào tạo mà lần xác nhận này bao gồm. Liên kết được chuyển sang từng chiến dịch do lịch này tạo ra.',
            training_ids_none: 'Chưa liên kết khóa đào tạo',
            training_ids_count: '{count} khóa',
            training_ids_load_error: 'Không đọc được danh sách khóa đào tạo. Danh sách có thể chưa đầy đủ.',
            title: 'Lịch chứng thực',
            new: 'Lịch mới',
            edit: 'Sửa lịch',
            create_title: 'Tạo lịch chứng thực',
            edit_title: 'Sửa lịch chứng thực',
            schedule_history: 'Lịch sử lịch trình',
            next_run_date: 'Ngày chạy tiếp theo',
            schedule_name: 'Tên lịch',
            frequency: 'Tần suất',
            next_run: 'Lần chạy tiếp',
            last_run: 'Lần chạy cuối',
            history: 'Lịch sử chứng thực',
            description: 'Mô tả',
            scope: 'Phạm vi',
            status: 'Trạng thái',
            created_at: 'Đã tạo',
            updated_at: 'Đã cập nhật',
            trigger_now: 'Kích hoạt ngay',
            back_to_schedules: 'Quay lại danh sách lịch',
            confirm_trigger: 'Bạn có chắc chắn muốn kích hoạt lịch này ngay bây giờ?',
            confirm_delete: 'Bạn có chắc chắn muốn xóa lịch này?',
            triggered: 'Lịch đã được kích hoạt thành công.',
            deleted: 'Lịch đã được xóa.',
            saved: 'Lịch đã được lưu thành công.',
            campaigns_generated: 'Chiến dịch đã tạo',
            run_date: 'Ngày chạy',
            run_status: 'Trạng thái chạy',
            create_schedule: 'Tạo lịch',
            view_history: 'Xem lịch sử',
            deactivate: 'Vô hiệu hóa',
            overdue: 'QUÁ HẠN',
            overdue_sr: 'Lịch đã quá hạn',
            confirm_trigger_title: 'Xác nhận hành động',
            confirm_trigger_message: 'Bạn có chắc chắn muốn kích hoạt lịch này ngay bây giờ? Điều này sẽ tạo một chiến dịch xem xét truy cập mới.',
            confirm_deactivate_title: 'Xác nhận vô hiệu hóa',
            confirm_deactivate_message: 'Bạn có chắc chắn muốn vô hiệu hóa lịch này?',
            triggered_success: 'Lịch đã được kích hoạt thành công.',
            triggered_unmapped_reviewer: 'Đã bắt đầu chu kỳ, nhưng quy tắc người đánh giá "{strategy}" không có nguồn trong nền tảng nên chiến dịch không chỉ định người đánh giá: người khởi chạy chiến dịch sẽ đánh giá các mục.',
            trigger_scope_unresolvable: 'Không thể chuyển phạm vi của lịch này thành chiến dịch xem xét. Hãy sửa lịch để bộ lọc phạm vi nêu ít nhất một vai trò, phòng ban hoặc người dùng, hoặc chọn phạm vi được hỗ trợ.',
            trigger_reviewer_not_found: 'Người đánh giá được nêu trong lịch này không còn là người dùng đang hoạt động của tổ chức. Hãy sửa lịch và chọn người đánh giá khác.',
            reviewer_not_found: 'ID người đánh giá không thuộc người dùng đang hoạt động nào của tổ chức',
            scope_unsupported: 'Loại phạm vi này không được hỗ trợ: chiến dịch xem xét chỉ có phạm vi theo người dùng, vai trò và phòng ban',
            deactivated_success: 'Lịch đã được vô hiệu hóa.',
            name_label: 'Tên *',
            frequency_label: 'Tần suất *',
            scope_type_label: 'Loại phạm vi *',
            scope_filter_label: 'Bộ lọc phạm vi (JSON)',
            reviewer_strategy_label: 'Chiến lược người đánh giá *',
            reviewer_id_label: 'ID người đánh giá *',
            frequency_quarterly: 'Hàng quý',
            frequency_semi_annual: 'Nửa năm',
            frequency_annual: 'Hàng năm',
            scope_all_users: 'Tất cả người dùng',
            scope_by_role: 'Theo vai trò',
            scope_by_department: 'Theo phòng ban',
            scope_custom: 'Tùy chỉnh',
            reviewer_manager: 'Quản lý',
            reviewer_role_owner: 'Chủ sở hữu vai trò',
            reviewer_specific_user: 'Người dùng cụ thể',
            computed_next_run_date: 'Ngày chạy tiếp theo dự kiến',
            current_scheduled_date: 'Ngày đã lên lịch hiện tại',
            recomputed_frequency_changed: '(tính lại -- tần suất đã thay đổi)',
            estimated_days_hint: 'Ước tính dựa trên {days} ngày từ hôm nay',
            validation_name_required: 'Tên là bắt buộc',
            validation_frequency_required: 'Tần suất là bắt buộc',
            validation_scope_type_required: 'Loại phạm vi là bắt buộc',
            validation_reviewer_strategy_required: 'Chiến lược người đánh giá là bắt buộc',
            validation_reviewer_id_required: 'ID người đánh giá là bắt buộc cho chiến lược người dùng cụ thể',
            validation_invalid_json: 'JSON không hợp lệ',
            validation_scope_filter_invalid_json: 'Bộ lọc phạm vi chứa JSON không hợp lệ',
            form_errors: 'Biểu mẫu có {count} lỗi. Vui lòng sửa.',
            create_schedule_btn: 'Tạo lịch',
            schedule_history_title: 'Lịch sử lịch trình',
            campaign_name_col: 'Tên chiến dịch',
            items_col: 'Mục',
            no_campaigns_yet: 'Chưa có chiến dịch nào được tạo',
            loading_history: 'Đang tải lịch sử...',
            loading_schedule: 'Đang tải lịch...',
            total_campaigns: 'Tổng chiến dịch: {count}',
            results_per_page: 'Kết quả mỗi trang',
            page_size_option: '{size} / trạng',
        },
        sod: {
            title: 'Quy tắc tách biệt nhiệm vụ',
            new: 'Quy tắc mới',
            edit: 'Sửa quy tắc',
            create_title: 'Tạo quy tắc SoD',
            edit_title: 'Sửa quy tắc SoD',
            rule_name: 'Tên quy tắc',
            conflicting_permissions: 'Quyền xung đột',
            permission_a: 'Quyền A',
            permission_b: 'Quyền B',
            violations: 'Vi phạm SoD',
            violation_user: 'Người dùng',
            violation_rule: 'Quy tắc vi phạm',
            violation_date: 'Phát hiện lúc',
            exceptions: 'Ngoại lệ SoD',
            exception_reason: 'Lý do ngoại lệ',
            exception_approver: 'Phê duyệt bởi',
            exception_status: 'Trạng thái ngoại lệ',
            has_exception: 'Có ngoại lệ',
            no_exception: 'Không có ngoại lệ',
            grant_exception: 'Cấp ngoại lệ',
            granting: 'Đang cấp...',
            grant_new_exception: 'Cấp ngoại lệ mới',
            exceptions_for: 'Ngoại lệ cho: {name}',
            back_to_rules: 'Quay lại quy tắc',
            no_violations: 'Không tìm thấy vi phạm',
            no_exceptions_found: 'Không tìm thấy ngoại lệ cho quy tắc này',
            all_exception_statuses: 'Tất cả trạng thái ngoại lệ',
            user_id_label: 'Mã người dùng',
            justification_label: 'Lý do',
            compensating_controls_label: 'Biện pháp kiểm soát bù đắp',
            expires_at_label: 'Hết hạn lúc',
            granting_exception_for: 'Cấp ngoại lệ cho quy tắc: {name}',
            severity: 'Mức độ nghiêm trọng',
            severity_warning: 'Cảnh báo',
            severity_blocking: 'Chặn',
            violation_count: '{count} vi phạm',
            exception_count: '{count} ngoại lệ',
            rule_description: 'Mô tả',
            confirm_delete: 'Bạn có chắc chắn muốn xóa quy tắc này không?',
            deleted: 'Đã xóa quy tắc.',
            framework_code: 'Khung tuân thủ',
            name_label: 'Tên *',
            severity_label: 'Mức độ nghiêm trọng *',
            conflict_pairs_legend: 'Cặp quyền xung đột',
            // fix-sprint-20260717-2118-followup F4/F5
            section_conflict_pairs_configuration: 'Cấu hình cặp quyền xung đột',
            conflict_pairs_hint: 'Mỗi cặp xác định hai quyền không được cùng một người dùng nắm giữ.',
            placeholder_permission_a: '-- Quyền A --',
            placeholder_permission_b: '-- Quyền B --',
            permission_a_for_pair: 'Quyền A cho cặp {index}',
            permission_b_for_pair: 'Quyền B cho cặp {index}',
            conflict_pair_label: 'Cặp xung đột {index}',
            remove_conflict_pair: 'Xóa cặp xung đột {index}',
            add_pair: '+ Thêm cặp',
            placeholder_name: 'vd. Tách biệt phê duyệt thanh toán',
            create_rule: 'Tạo quy tắc',
            loading_rule: 'Đang tải quy tắc SoD...',
            failed_load_rule: 'Không thể tải quy tắc.',
            failed_create_rule: 'Không thể tạo quy tắc SoD.',
            failed_update_rule: 'Không thể cập nhật quy tắc SoD.',
            validation_name_required: 'Tên là bắt buộc.',
            validation_pair_required: 'Cần ít nhật một cấp quyền xung đợt.',
            validation_pair_both_required: 'Cấp {index}: Cá hại quyền đều phải được chọn.',
            validation_pair_must_differ: 'Cấp {index}: Quyền A và Quyền B phải khác nhau.',
            added_conflict_pair: 'Đã thêm cấp xung đợt {index}',
            removed_conflict_pair: 'Đã xóa cấp xung đợt {index}',
            announce_loaded_violations: 'Đã tải {count} vi phạm',
            announce_loaded_exceptions: 'Đã tải {count} ngoại lệ',
            announce_loaded_rules: 'Đã tải {count} quy tắc SoD',
            announce_loading_exceptions: 'Đang tải ngoại lệ…',
            regulatory_info: {
                sod_context: 'Quy tắc SoD thực thi yêu cầu tách biệt vai trò theo quy định PDPL (vai trò bên kiểm soát và bên xử lý không được kết hợp). Vi phạm liên kết framework_code có thể đưa vào gói bằng chứng kiểm toán đa khung (UC-VN-09). Mức độ nghiêm trọng phân biệt vi phạm quy định với vi phạm chính sách vận hành theo fines-risks.json.',
                violation_export_context: 'Xuất vi phạm SoD bao gồm framework_code, vai trò xung đột, mức độ nghiêm trọng, người tạo và thời điểm phát hiện. Dữ liệu này đưa vào gói bằng chứng đa khung được Trưởng Kiểm toán Nội bộ (P-VN-10) xem xét trong quá trình kiểm toán.',
                exception_context: 'Ngoại lệ SoD tạo bằng chứng cấp kiểm toán: danh tính người phê duyệt, lý do, biện pháp kiểm soát bù đắp và ngày hết hạn. Ngoại lệ hết hạn vẫn hiển thị để đảm bảo tính liên tục đường kiểm toán. Các bản ghi này hỗ trợ xác định khoảng trống và ngoại lệ trong gói kiểm toán đa khung (UC-VN-09 Bước 5).',
            },
        },
        regulatory_info: {
            attestation_context: 'Lịch chứng thực lặp lại một đợt xem xét truy cập theo chu kỳ (hằng quý, nửa năm hoặc hằng năm). Mỗi chu kỳ tạo một chiến dịch xem xét cho tất cả người dùng, cho các vai trò hoặc phòng ban được nêu, hoặc cho những người dùng được nêu, và một người đánh giá được chỉ định sẽ trả lời. Quy tắc người đánh giá mà mô hình chiến dịch không diễn đạt được (quản lý hoặc chủ sở hữu vai trò) được hiển thị khi bắt đầu chu kỳ, và người khởi chạy chiến dịch sẽ đánh giá các mục. Lịch sử của lịch liệt kê các chiến dịch mà lịch đã tạo ra.',
            api_keys_context: 'Dữ liệu đo lường khóa API cấu thành bằng chứng tài khoản theo VN_CYBERSEC_LAW_2025 Mục B.5. Mỗi bản ghi khóa bao gồm last_used_at, ip_allowlist, permissions, status, và expires_at.',
            session_context: 'Quản lý phiên thực thi kiểm soát truy cập theo yêu cầu bảo mật của Luật Viễn thông (Mục B.4). Sự kiện phiên tạo các mục nhật ký kiểm toán.',
            break_glass_context: 'Quy trình truy cập khẩn cấp tạo bằng chứng biện minh pháp quy: danh tính người yêu cầu, lý do, quyền, thời lượng, danh tính người phê duyệt, và thời gian phê duyệt/từ chối.',
            license_context: 'Cài đặt giấy phép phân cấp phân hệ theo cấp sử dụng PACKAGE_DEFINITIONS. Phân hệ theo khung tuân thủ yêu cầu cấp giấy phép phù hợp. Thay đổi cấp tạo các mục nhật ký kiểm toán.',
            module_config_context: 'Cấu hình phân hệ hỗ trợ kích hoạt theo khung tuân thủ. Vô hiệu hóa phân hệ được yêu cầu bởi khung tuân thủ đang hoạt động có thể phá vỡ tính hoàn thiện bằng chứng.',
            notification_context: 'Thông báo quan trọng về tuân thủ (hạn chót vi phạm, hạn chứng thực) được đánh dấu compliance_critical và không thể bị tắt hoàn toàn.',
            delegation_context: 'Quản trị ủy quyền tạo bằng chứng cấp kiểm toán: delegator_id, delegate_id, phạm vi quyền, ngày bắt đầu/kết thúc, và trạng thái. Ủy quyền hết hạn vẫn hiển thị.',
            access_control_context: 'Cấu hình kiểm soát truy cập đáp ứng yêu cầu Luật An ninh mạng (VN_CYBERSEC_LAW_2025): danh sách IP cho phép, MFA, tài khoản dịch vụ và thay đổi SSO đều được ghi nhật ký kiểm toán.',
        },
    },
    cmp: {
        integration: {
            title: 'Tích hợp CMP',
            status: 'Trạng thái kết nối',
            endpoint: 'Điểm cuối CMP',
            last_sync: 'Đồng bộ cuối',
            configure: 'Cấu hình',
        },
        purpose_mapping: {
            title: 'Ánh xạ mục đích',
            cmp_purpose: 'Mục đích CMP',
            grc_purpose: 'Mục đích GRC',
            mapping_status: 'Trạng thái ánh xạ',
            auto_map: 'Tự động ánh xạ',
            new_mapping: 'Ánh xạ mới',
        },
        webhook: {
            title: 'Cấu hình Webhook',
            webhook_url: 'URL Webhook',
            secret: 'Bí mật Webhook',
            events: 'Loại sự kiện',
            test_webhook: 'Kiểm tra Webhook',
        },
        bulk_sync: {
            title: 'Đồng bộ hàng loạt',
            sync_now: 'Đồng bộ ngày',
            last_run: 'Lần chạy cuối',
            records_synced: 'Bản ghi đã đóng bỏ',
            sync_history: 'Lịch sử đồng bộ',
            syncing: 'Đang đồng bộ...',
        },
        sync_settings: {
            sync_failures: 'Đồng bộ thất bại',
            sync_secret_warning: 'Khóa bí mật đồng bộ (lưu ngay — sẽ không hiển thị lại):',
            push_description: 'Cấu hình GRC Suite để đẩy cập nhật trạng thái sang AesirX CMP.',
            technical_description: 'Cấu hình này kiểm soát cách GRC Suite đẩy cập nhật trạng thái sang AesirX CMP.',
            direction_label: 'Hướng',
            direction_value: 'GRC Suite → AesirX CMP (đi)',
            auth_label: 'Xác thực',
            auth_value: 'Chữ ký HMAC-SHA256 trong header X-GRC-Signature',
            retry_label: 'Chính sách thử lại',
            retry_value: '3 lần thử lại với backoff lũy thừa (30s, 2 phút, 10 phút)',
            inbound_label: 'Cấu hình đến',
            inbound_value: 'Webhook đến (CMP → GRC) được cấu hình tại',
            cmp_webhook_settings: 'Cài đặt Webhook CMP',
            page_title: 'Cài đặt Đồng bộ CMP',
            outbound_sync_configured: 'Đồng bộ đi đã được cấu hình.',
            configure_sync_failed: 'Không thể cấu hình đồng bộ',
            configuration_updated: 'Cấu hình đã được cập nhật.',
            update_configuration_failed: 'Không thể cập nhật cấu hình',
            connection_test_failed: 'Kiểm tra kết nối thất bại',
            test_result_message: 'Đã gửi kiểm tra đến {endpoint}. Trạng thái: {status}',
            endpoint_placeholder: 'https://your-cmp-domain/api/grc-sync',
            events: {
                new_to_under_review: 'Mới → Đang xem xét (đã phân công)',
                under_review_to_identity_verification: 'Đang xem xét → Xác minh danh tính',
                under_review_to_in_progress: 'Đang xem xét → Đang xử lý',
                in_progress_to_completed: 'Đang xử lý → Hoàn thành',
                in_progress_to_denied: 'Đang xử lý → Từ chối',
                any_to_closed: 'Bat ky → Dong',
            },
        },
    },
    settings_pages: {
        webhooks: {
            title: 'Webhook',
            new: 'Webhook mới',
            url: 'URL',
            url_placeholder: 'https://example.com/webhook',
            events: 'Sự kiện',
            secret: 'Bị mật',
            active: 'Hoạt động',
            test: 'Kiểm tra',
            create_failed: 'Không thể tạo webhook.',
            create_success: 'Đã tạo webhook thành công.',
            deactivate_failed: 'Không thể hủy kích hoạt webhook.',
            deactivate_success: 'Đã hủy kích hoạt webhook.',
            fetch_failed: 'Không thể tải webhook.',
            send_test_failed: 'Không thể gửi kiểm tra.',
            test_failed: 'Kiểm tra webhook thất bại.',
            test_success: 'Kiểm tra webhook thành công.',
            edit_title: 'Chỉnh sửa Webhook',
            announce_loaded: 'Đã tải webhook',
            update_success: 'Đã cập nhật webhook thành công.',
            update_failed: 'Không thể cập nhật webhook.',
            activate_success: 'Đã kích hoạt webhook.',
            activate_failed: 'Không thể kích hoạt webhook.',
        },
        domains: {
            title: 'Tên miền',
            new: 'Tên miền mới',
            domain_name: 'Tên miền',
            verified: 'Đã xác minh',
            verify: 'Xác minh',
            add_failed: 'Không thể thêm tên miền.',
            add_success: 'Đã thêm tên miền thành công.',
            domain_placeholder: 'VD: grc.example.com',
            fetch_failed: 'Không thể tải tên miền.',
            remove_failed: 'Không thể xóa tên miền.',
            remove_success: 'Đã xóa tên miền thành công.',
            txt_record: 'Bản ghi TXT',
            verify_dns_failed: 'Xác minh DNS thất bại.',
            verify_failed: 'Không thể xác minh tên miền.',
            verify_success: 'Đã xác minh tên miền thành công.',
            announce_loaded: 'Đã tải danh sách tên miền',
        },
        export_schedules: {
            title: 'Lịch xuất dữ liệu',
            new: 'Lịch mới',
            schedule_name: 'Tên',
            frequency: 'Tần suất',
            format: 'Định dạng',
            last_run: 'Lần chạy cuối',
            next_run: 'Lần chạy tiếp',
            create_failed: 'Không thể tạo lịch.',
            create_success: 'Đã tạo lịch thành công.',
            day_of_month: 'Ngày trong tháng',
            day_of_week: 'Ngày trong tuần',
            deactivate_failed: 'Không thể hủy kích hoạt lịch.',
            deactivate_success: 'Đã hủy kích hoạt lịch.',
            fetch_failed: 'Không thể tải lịch.',
            freq_daily: 'Hàng ngày',
            freq_monthly: 'Hàng tháng',
            freq_weekly: 'Hàng tuần',
            recipients: 'Người nhận',
            time_utc: 'Thời gian (UTC)',
            trigger_failed: 'Không thể kích hoạt xuất.',
            trigger_success: 'Đã kích hoạt xuất thành công.',
            type_audit_trail: 'Nhật ký kiểm toán',
            type_compliance_report: 'Báo cáo tuân thủ',
            type_custom: 'Tùy chỉnh',
            type_incident_report: 'Báo cáo sự cố',
            type_ropa: 'ROPA',
            announce_loaded: 'Đã tải lịch xuất',
            execution_note: 'Mỗi lần chạy tạo tệp với tư cách người chạy của lịch, hiển thị ở cột Chạy với tư cách: người đã tạo lịch, hoặc người gần nhất đã thay đổi nội dung lịch tạo ra, theo quyền hiện tại của người đó. Mỗi lần chạy được ghi nhận bên dưới. Người nhận được gửi email kèm liên kết tới trang này; tệp được tải xuống theo quyền của chính người đọc.',
            paused_reason_label: 'Nền tảng đã tạm dừng',
            type_withdrawn: 'Loại đã rút bỏ',
            runs: 'Các lần chạy',
            runs_for: 'Các lần chạy của {name}',
            runs_empty: 'Lịch này chưa chạy lần nào.',
            runs_fetch_failed: 'Không thể tải các lần chạy.',
            close_runs: 'Đóng danh sách lần chạy',
            run_status: 'Trạng thái',
            run_scheduled_for: 'Thời điểm chạy',
            run_trigger: 'Khởi chạy bởi',
            run_attempts: 'Số lần thử',
            run_reason: 'Lý do',
            run_file: 'Tệp',
            run_status_running: 'Đang chạy',
            run_status_completed: 'Hoàn thành',
            run_status_failed: 'Thất bại',
            run_trigger_scheduled: 'Lịch',
            run_trigger_manual: 'Kích hoạt thủ công',
            run_will_retry: 'Hệ thống sẽ thử lại.',
            download: 'Tải xuống',
            triggering: 'Đang xuất…',
            disabling: 'Đang tắt…',
            trigger_completed: 'Đã xuất xong. Tệp nằm trong danh sách lần chạy.',
            trigger_run_failed: 'Lần xuất đã chạy và thất bại: {reason}',
            failure_actor_inactive: 'Người mà lịch này chạy thay mặt không còn là thành viên đang hoạt động, nên không thể chạy xuất với tư cách người đó.',
            failure_actor_lacks_permission: 'Người mà lịch này chạy thay mặt không còn có quyền mà lần xuất này cần.',
            failure_export_type_withdrawn: 'Loại xuất này đã bị rút bỏ nên lịch không thể tạo ra nó. Để xuất lại, cần tạo lịch mới với loại xuất khác.',
            failure_export_too_large: 'Lần xuất chọn nhiều dòng hơn mức một tệp có thể chứa.',
            failure_generation_failed: 'Không thể tạo tệp.',
            failure_interrupted: 'Lần chạy bị gián đoạn trước khi hoàn tất.',
            failure_never_executed: 'Lần chạy này được yêu cầu trước khi các bản xuất theo lịch được thực thi, nên chưa từng chạy và không tạo ra tệp nào.',
            report: {
                incident_title: 'Báo cáo sự cố',
                compliance_title: 'Báo cáo tuân thủ — mức độ bao phủ khung tuân thủ',
                window: 'Kỳ: từ {start} đến {end}',
                count: 'Số dòng: {count}',
                overall: 'Mức độ bao phủ đã ánh xạ chung: {pct}',
                overall_none: 'Mức độ bao phủ đã ánh xạ chung: không đo được (không khung tuân thủ đã cài đặt nào khai báo yêu cầu)',
                col_reference: 'Mã tham chiếu',
                col_title: 'Tiêu đề',
                col_status: 'Trạng thái',
                col_severity: 'Mức độ nghiêm trọng',
                col_created: 'Ngày tạo',
                col_closed: 'Ngày đóng',
                col_framework: 'Khung tuân thủ',
                col_requirements: 'Yêu cầu',
                col_mapped: 'Đã ánh xạ',
                col_coverage: 'Mức độ bao phủ',
                col_open_gaps: 'Khoảng trống còn mở',
            },
            email: {
                subject: 'Bản xuất theo lịch đã sẵn sàng: {name}',
                body: 'Bản xuất theo lịch "{name}" đã chạy cho thời điểm {date}. Mở danh sách lần chạy để tải tệp: {link}',
                body_html: 'Bản xuất theo lịch "{name}" đã chạy cho thời điểm {date}. Mở danh sách lần chạy để tải tệp:',
            },
            type_none_held: 'Bạn không có quyền nào mà một loại xuất cần, nên không thể tạo lịch: lịch chạy với tư cách người tạo lịch.',
            type_offered_hint: 'Chỉ hiển thị các loại xuất mà bạn tự mình được phép xuất: lịch chạy với tư cách của bạn.',
            grant_ropa: 'quyền xuất hồ sơ hoạt động xử lý dưới dạng PDF',
            grant_audit_trail: 'quyền xuất sự kiện kiểm toán',
            grant_compliance_report: 'quyền xem khung tuân thủ',
            grant_incident_report: 'quyền thực hiện xuất dữ liệu sự cố',
            refusal_permission_not_held: 'Bạn không có {permission}, là quyền mà lần xuất này cần, nên không thể để lịch này tạo ra nó.',
            refusal_permission_not_held_generic: 'Bạn không có quyền mà lần xuất này cần.',
            refusal_schedule_inactive: 'Lịch này đang tắt nên không thể chạy. Hãy bật lịch trước.',
            refusal_export_type_withdrawn: 'Loại xuất của lịch này đã bị rút bỏ nên không thể chạy hoặc bật lịch. Để tiếp tục xuất, hãy tạo lịch với loại xuất khác bằng Lịch mới.',
            col_runs_as: 'Chạy với tư cách',
            run_executed_as: 'Đã chạy với tư cách',
            run_delivered_to: 'Email đã vào hàng đợi gửi tới',
            run_delivered_none: 'Không có email nào vào hàng đợi',
            run_delivered_hint: 'Một địa chỉ trong cột Email đã vào hàng đợi gửi tới nghĩa là email đã được đưa vào hàng đợi gửi, không có nghĩa là email đã đến nơi. Trang Hàng đợi quản trị thông báo, dành cho quản trị viên thông báo, cho biết từng email đã được gửi hay chưa.',
            enable: 'Bật',
            enabling: 'Đang bật…',
            enable_success: 'Đã bật lịch. Lần chạy tiếp theo được tính từ bây giờ.',
            enable_failed: 'Không thể bật lịch.',
            refusal_run_actor_cannot_run: 'Lịch này chạy với tư cách {name}, người hiện không thể chạy lịch: họ không còn là thành viên đang hoạt động, hoặc không còn có quyền mà lần xuất này cần. Lịch có thể được bật khi {name} chạy được lịch trở lại: hãy đề nghị quản trị viên khôi phục tư cách thành viên hoặc quyền của họ. Để xuất ngay, hãy tạo lịch bằng Lịch mới: lịch đó chạy với tư cách của bạn.',
            refusal_run_actor_inactive: 'Lịch này chạy với tư cách {name}, người không còn là thành viên đang hoạt động của tổ chức, nên các lần chạy sẽ bị từ chối và không thể bật lịch. Lịch có thể được bật khi {name} là thành viên đang hoạt động trở lại: hãy đề nghị quản trị viên khôi phục tư cách thành viên của họ. Để xuất ngay, hãy tạo lịch bằng Lịch mới: lịch đó chạy với tư cách của bạn.',
            refusal_run_actor_lacks_permission: 'Lịch này chạy với tư cách {name}, người không còn có {permission}, là quyền mà lần xuất này cần, nên không thể bật lịch. Lịch có thể được bật khi {name} có lại quyền đó: hãy đề nghị quản trị viên cấp quyền đó cho {name}. Để xuất ngay, hãy tạo lịch bằng Lịch mới: lịch đó chạy với tư cách của bạn.',
            run_actor_unnamed: 'người được hiển thị ở cột Chạy với tư cách',
            people_names_failed: 'Không thể tải danh bạ người dùng, nên một người có thể được hiển thị bằng mã tài khoản thay vì tên.',
        },
        email_log: {
            title: 'Nhật ký email',
            recipient: 'Người nhận',
            subject: 'Chủ đề',
            sent_at: 'Gửi lúc',
            status: 'Trạng thái',
            resend: 'Gửi lại',
            fetch_failed: 'Không thể tải nhật ký email.',
            announce_loaded: 'Đã tải nhật ký email',
        },
    },
    organizations: {
        title: 'Tổ chức',
        create: 'Tạo tổ chức',
        edit: 'Sửa tổ chức',
        name: 'Tên',
        slug: 'Đường dẫn',
        timezone: 'Múi giờ',
        locale: 'Ngôn ngữ mặc định',
        parent: 'Tổ chức cha',
        group: 'Nhóm',
        org_group: 'Nhóm Tổ chức',
        no_group: '(Không - không thuộc nhóm nào)',
        created: 'Ngày tạo',
        no_parent: '(Không - độc lập)',
        no_orgs: 'Không tìm thấy tổ chức',
        load_error: 'Không thể tải danh sách tổ chức',
        save_error: 'Không thể lưu tổ chức',
        created_msg: 'Đã tạo tổ chức',
        updated: 'Đã cập nhật tổ chức',
        deactivate: 'Vô hiệu hóa',
        deactivated: 'Đã vô hiệu hóa tổ chức',
        confirm_deactivate: 'Bạn có chắc muốn vô hiệu hóa tổ chức này?',
        locale_en_us: 'Tiếng Anh (en-US)',
        // fix-sprint #431 — the organisation's country (ISO 3166-1 alpha-2).
        country: 'Quốc gia',
        country_not_recorded: 'Chưa ghi nhận',
        country_hint: 'Quốc gia nơi tổ chức được thành lập. Việc kiểm tra chuyển dữ liệu cá nhân xuyên biên giới đối với yêu cầu thực hiện quyền so sánh quốc gia của chủ thể dữ liệu với quốc gia này; khi chưa ghi nhận, việc kiểm tra không được thực hiện.',
        // Gate E12.5 remediation 2 (fix-sprint #431) — the row Edit reads the record first.
        edit_reading: 'Đang đọc bản ghi của tổ chức…',
        edit_read_error: 'Không đọc được bản ghi của tổ chức nên các giá trị hiện tại không được hiển thị và không thể lưu tại đây.',
        locale_vi_vn: 'Tiếng Việt (vi-VN)',
        form_loaded: 'Biểu mẫu Organization đã tải',
        loaded_results: 'Đã tải Organizations, {count} kết quả',
        no_head: 'Chưa có người đứng đầu',
        all_frameworks: 'Tất cả khung tuân thủ',
        assigned_at: 'Thời gian phân công',
    },
    intake_configs: {
        title: 'Cấu hình tiếp nhận công khai',
        create: 'Tạo cấu hình',
        edit: 'Sửa cấu hình tiếp nhận',
        label_col: 'Nhãn',
        key: 'Khóa tiếp nhận',
        key_hint: 'Đường dẫn công khai: /rights-request?key=',
        mapped_org: 'Tổ chức đích',
        status: 'Trạng thái',
        enabled: 'Đã bật',
        disabled: 'Đã tắt',
        request_types: 'Loại yêu cầu cho phép',
        language: 'Ngôn ngữ mặc định',
        public_url: 'Đường dẫn công khai',
        no_configs: 'Không tìm thấy cấu hình tiếp nhận. Tạo một cấu hình để kích hoạt biểu mẫu yêu cầu quyền công khai.',
        load_error: 'Không thể tải cấu hình tiếp nhận',
        save_error: 'Không thể lưu',
        delete_error: 'Không thể xóa',
        created_msg: 'Đã tạo cấu hình',
        updated: 'Đã cập nhật cấu hình',
        deleted: 'Đã xóa cấu hình tiếp nhận',
        confirm_delete: 'Xóa cấu hình tiếp nhận này?',
        select_types: 'Chọn ít nhất một loại yêu cầu',
        select_org: 'Chọn tổ chức đích',
        routing_mode: 'Chế độ Định tuyến',
        single_org: 'Tổ chức Đơn lẻ',
        org_group_mode: 'Nhóm Tổ chức',
        org_group: 'Nhóm Tổ chức',
        select_group: 'Chọn một nhóm tổ chức...',
        group_root_hint: 'Tự động đặt thành tổ chức gốc của nhóm khi chọn nhóm.',
        form_loaded: 'Biểu mẫu Intake configuration đã tải',
        loaded_results: 'Đã tải Intake configurations, {count} kết quả',
    },
    frequency: {
        weekly: 'Hàng tuần',
        monthly: 'Hàng tháng',
        quarterly: 'Hàng quý',
        semi_annually: 'Nửa năm',
        annually: 'Hàng năm',
        custom: 'Tùy chỉnh',
    },
    /**
     * Sprint 65.6.0 — DT-01 training and awareness.
     *
     * R-57: EN and VI are authored. The other fourteen locales carry the EN
     * string for structural parity and are translated by the Phase 25 batch —
     * stated here rather than left to be inferred from the text.
     */
    /**
     * Sprint 65.6.0 (AC8) — DPO-01 and PUB-01, the privacy office's two registers.
     *
     * R-44: "Data Protection Officer" is a governed term and is used verbatim as
     * `Nhân sự bảo vệ dữ liệu cá nhân`; so are `Bản nháp` (Draft),
     * `Phê duyệt` / `Đã phê duyệt` (Approval / Approved), `Người phê duyệt`
     * (Approved By) and `Trạng thái` (Status).
     */
    privacy_office: {
        publication_states: {
            not_published: 'Chưa công bố',
            published: 'Đã công bố',
            withdrawn: 'Đã gỡ bỏ',
        },
        channels: {
            public_website: 'Trang thông tin điện tử công khai',
            mobile_app: 'Ứng dụng di động',
            intranet: 'Mạng nội bộ',
            physical_notice: 'Niêm yết tại trụ sở',
            direct_notice: 'Thông báo trực tiếp đến từng người',
            other: 'Hình thức khác',
        },
        filter_publication_state: 'Công bố',
        targets_label: 'Nơi đã công bố',
        targets_hint: 'Ít nhất một nơi mà một người có thể đến và đọc được. Một lần công bố không có địa chỉ là điều không ai kiểm chứng được.',
        target_channel: 'Hình thức công bố',
        target_locator: 'Địa chỉ hoặc vị trí',
        target_locator_hint: 'Địa chỉ trang web đối với trang thông tin điện tử, tên màn hình đối với ứng dụng, hoặc mô tả vị trí đối với bảng niêm yết.',
        target_locale: 'Ngôn ngữ (không bắt buộc)',
        target_add: 'Thêm một nơi công bố',
        target_remove: 'Xóa nơi công bố này',
        field_published_on: 'Ngày công bố',
        field_published_on_hint: 'Ngày thực tế nội dung được công khai, không phải ngày bạn nhập vào đây.',
        appointments: {
            title: 'Quyết định cử nhân sự bảo vệ dữ liệu cá nhân',
            subtitle: 'Ghi nhận người được cử, quyết định cử người đó, và nơi đã công bố công khai việc cử này.',
            module_guide: 'Ghi nhận việc cử nhân sự bảo vệ dữ liệu cá nhân dưới dạng một mục trong sổ đăng ký, chứ không phải một biểu mẫu đã điền: ai được cử, ai quyết định và quyết định khi nào, quyết định có hiệu lực từ khi nào, và bạn đã công bố việc đó ở đâu. Bản ghi được lưu ở dạng bản nháp và chưa phát sinh nghĩa vụ nào cho đến khi bạn đưa nó vào hiệu lực — đó mới là bước xác nhận tổ chức của bạn đã có nhân sự đảm nhiệm. Chỉ quyết định đang có hiệu lực mới có thể công bố, và mỗi lần công bố phải nêu rõ nơi một người có thể đến đọc được.',
            nav: 'Quyết định cử nhân sự bảo vệ dữ liệu cá nhân',
            record: 'Ghi nhận quyết định cử',
            table_label: 'Danh sách quyết định cử nhân sự bảo vệ dữ liệu cá nhân',
            sr_loading: 'Đang tải danh sách quyết định cử',
            announce_loaded: 'Đã tải {count} quyết định cử',
            none: 'Không có quyết định cử nào phù hợp với bộ lọc này.',
            filters_label: 'Lọc danh sách quyết định cử',
            filter_status: 'Trạng thái',
            col_appointee: 'Người được cử',
            col_position: 'Chức danh, vị trí công tác',
            col_decision: 'Quyết định cử',
            col_takes_effect: 'Có hiệu lực từ',
            col_status: 'Trạng thái',
            col_publication: 'Công bố',
            takes_effect_unknown: 'Chưa nêu',
            statuses: {
                draft: 'Bản nháp',
                in_effect: 'Đang có hiệu lực',
                ended: 'Đã kết thúc',
                superseded: 'Đã được thay thế',
            },
            action_take_effect: 'Đưa vào hiệu lực',
            action_publish: 'Ghi nhận việc công bố',
            action_end: 'Kết thúc quyết định cử',
            modal_record_title: 'Ghi nhận quyết định cử nhân sự bảo vệ dữ liệu cá nhân',
            modal_record_hint: 'Ghi nhận một quyết định mà tổ chức của bạn đã ban hành. Bản ghi được lưu ở dạng bản nháp và chưa phát sinh nghĩa vụ nào cho đến khi bạn đưa nó vào hiệu lực.',
            field_full_name: 'Họ và tên',
            field_position_title: 'Chức danh, vị trí công tác',
            field_contact_email: 'Địa chỉ thư điện tử liên hệ',
            field_contact_email_hint: 'Ghi theo dạng ten@vidu.com. Đây là địa chỉ mà công chúng nhìn thấy.',
            field_contact_phone: 'Số điện thoại liên hệ (không bắt buộc)',
            field_decided_by: 'Cấp quyết định',
            field_decided_by_hint: 'Cơ quan hoặc người có thẩm quyền ban hành quyết định cử.',
            field_decided_on: 'Ngày ban hành quyết định',
            field_decision_reference: 'Số hiệu quyết định của tổ chức (không bắt buộc)',
            field_takes_effect_on: 'Có hiệu lực từ ngày (không bắt buộc)',
            field_takes_effect_hint: 'Để trống nếu chưa xác định được ngày bắt đầu. Khi đó nghĩa vụ sẽ được ghi nhận là chưa có mốc thời gian kèm lý do, thay vì lấy ngày bạn nhập liệu làm mốc.',
            field_ends_on: 'Kết thúc vào ngày (không bắt buộc)',
            modal_take_effect_title: 'Đưa quyết định cử vào hiệu lực',
            modal_take_effect_hint: 'Từ thời điểm này, tổ chức của bạn đã có nhân sự đảm nhiệm được nêu tên. Hãy nêu ngày bắt đầu nếu chưa được ghi nhận.',
            field_correction_note: 'Ghi chú về việc đính chính (không bắt buộc)',
            modal_publish_title: 'Ghi nhận nơi đã công bố quyết định cử',
            modal_publish_hint: 'Chỉ quyết định đang có hiệu lực mới có thể công bố — không nêu tên công khai một người là nhân sự đảm nhiệm trước khi tổ chức của bạn xác nhận điều đó.',
            modal_end_title: 'Kết thúc quyết định cử',
            modal_end_hint: 'Một quyết định cử hết thời hạn và một quyết định cử bị thay thế bởi quyết định mới là hai câu trả lời khác nhau cho câu hỏi vì sao người này không còn đảm nhiệm. Cả hai đều được giữ lại.',
            field_end_outcome: 'Hình thức kết thúc',
            field_end_reason: 'Lý do',
            field_end_date: 'Ngày kết thúc (không bắt buộc)',
            toast_recorded: 'Đã ghi nhận quyết định cử.',
            toast_in_effect: 'Quyết định cử đã có hiệu lực.',
            toast_published: 'Đã ghi nhận việc công bố.',
            toast_ended: 'Đã kết thúc quyết định cử.',
        },
        notices: {
            title: 'Thông báo về bảo vệ dữ liệu cá nhân',
            subtitle: 'Soạn một phiên bản thông báo về bảo vệ dữ liệu cá nhân, dành cho công chúng hoặc cho các chủ thể dữ liệu được xác định, trình phê duyệt, và ghi nhận nơi đã công bố.',
            module_guide: 'Giữ một sổ đăng ký thông báo về bảo vệ dữ liệu cá nhân mà tổ chức của bạn cung cấp, cho công chúng hoặc cho các chủ thể dữ liệu được xác định của các hoạt động xử lý dữ liệu cá nhân: phiên bản nào đang hiệu lực, ai đã phê duyệt nội dung, và một người có thể đọc ở đâu. Phê duyệt và công bố là hai hành vi tách biệt, thường do hai người khác nhau thực hiện, nên sổ đăng ký có thể cho thấy một thông báo đã được phê duyệt nhưng chưa từng được công bố — đúng điều mà bản ghi này sinh ra để làm cho nhìn thấy được. Một thông báo không thể đi thẳng từ bản nháp sang đã công bố, và một thông báo đã công bố rồi bị gỡ xuống vẫn giữ lại lịch sử công bố kèm lý do gỡ bỏ.',
            nav: 'Thông báo về bảo vệ dữ liệu cá nhân',
            draft: 'Phiên bản mới',
            table_label: 'Danh sách thông báo về bảo vệ dữ liệu cá nhân',
            sr_loading: 'Đang tải danh sách thông báo',
            announce_loaded: 'Đã tải {count} thông báo',
            none: 'Không có thông báo nào phù hợp với bộ lọc này.',
            filters_label: 'Lọc danh sách thông báo',
            filter_status: 'Trạng thái',
            col_title: 'Tiêu đề',
            col_revision: 'Phiên bản',
            col_locales: 'Ngôn ngữ',
            col_status: 'Trạng thái',
            col_approval: 'Người phê duyệt',
            col_publication: 'Công bố',
            approval_none: 'Chưa phê duyệt',
            statuses: {
                draft: 'Bản nháp',
                approved: 'Đã phê duyệt',
                published: 'Đã công bố',
                withdrawn: 'Đã gỡ bỏ',
                superseded: 'Đã được thay thế',
            },
            action_approve: 'Phê duyệt',
            action_publish: 'Công bố',
            action_withdraw: 'Gỡ bỏ',
            action_supersede: 'Thay thế',
            modal_draft_title: 'Phiên bản thông báo mới',
            modal_draft_hint: 'Phiên bản là số hiệu mà bản công bố của bạn hiển thị. Đây không phải số phiên bản do hệ thống tự đếm.',
            field_notice_title: 'Tiêu đề',
            field_revision: 'Phiên bản',
            field_content_url: 'Nơi lưu nội dung thông báo',
            field_content_url_hint: 'Địa chỉ của chính nội dung thông báo — trang, tài liệu hoặc tệp mà người đọc sẽ mở.',
            field_locales: 'Ngôn ngữ',
            field_locales_hint: 'Mỗi dòng một mã ngôn ngữ, hoặc phân tách bằng dấu phẩy.',
            field_supersedes: 'Thay thế cho thông báo nào (không bắt buộc)',
            modal_approve_title: 'Phê duyệt thông báo',
            modal_approve_hint: 'Phê duyệt là ghi nhận ai đã duyệt nội dung. Việc này chưa đưa thông báo đến đối tượng tiếp nhận — công bố là một hành vi riêng.',
            field_approved_by: 'Người phê duyệt (không bắt buộc)',
            field_approved_by_hint: 'Để trống nếu chính bạn là người phê duyệt.',
            field_approval_reference: 'Số hiệu phê duyệt của tổ chức (không bắt buộc)',
            modal_publish_title: 'Công bố thông báo',
            modal_publish_hint: 'Ghi nhận rằng nội dung đã phê duyệt nay đã được cung cấp cho đối tượng tiếp nhận, và nơi một người có thể đọc được.',
            publish_needs_approval: 'Thông báo này chưa có phê duyệt được ghi nhận nên chưa thể công bố. Hãy ghi nhận người đã phê duyệt nội dung trước.',
            modal_withdraw_title: 'Gỡ bỏ thông báo',
            modal_withdraw_hint: 'Việc gỡ bỏ vẫn giữ lại lịch sử công bố: đã công bố rồi gỡ xuống là câu trả lời khác với chưa từng công bố.',
            field_withdraw_reason: 'Lý do gỡ bỏ',
            modal_supersede_title: 'Thay thế thông báo',
            modal_supersede_hint: 'Thay thế sẽ khép lại phiên bản này vì đã có phiên bản mới hơn, và đây là trạng thái cuối cùng của nó trong sổ đăng ký.',
            field_supersede_reason: 'Lý do thay thế',
            toast_drafted: 'Đã tạo phiên bản thông báo mới.',
            toast_approved: 'Đã phê duyệt thông báo.',
            toast_published: 'Đã công bố thông báo.',
            toast_withdrawn: 'Đã gỡ bỏ thông báo.',
            toast_superseded: 'Đã thay thế thông báo.',
        },
    },
    /* Sprint 65.18.0 — continuity plans and exercises (toolkit row IRP-01). */
    /* Sprint 65.19.0 -- legal matters (toolkit row LEG-01). */
    /* 2026-09-24 owner ruling — legacy instrument notice (R-44 lint run before and after). */
    framework_lifecycle_notice: {
        legacy_chip: 'Cũ — không còn hiệu lực',
        legacy_notice_label: 'Thông báo về văn bản không còn hiệu lực',
        legacy_body: 'Văn bản này đã hết hiệu lực hoặc đã được thay thế. Kết quả đã xác định theo văn bản này có thể vẫn được áp dụng theo quy định chuyển tiếp. Hãy kiểm tra văn bản hiện hành trước khi dựa vào kết quả đó.',
        suspended_chip: 'Tạm ngừng áp dụng — không phải nghĩa vụ',
        suspended_notice_label: 'Thông báo về văn bản đang tạm ngừng áp dụng',
        suspended_body: 'Việc áp dụng văn bản này đang bị tạm ngừng, vì vậy các nghĩa vụ theo văn bản này không phát sinh trong thời gian tạm ngừng. Hãy kiểm tra thời điểm hoặc sự kiện chấm dứt việc tạm ngừng trước khi dựa vào bất kỳ nội dung nào được ghi nhận theo văn bản này.',
    },
    framework_articles: {
        title: 'Điều khoản',
        article: 'Điều',
        heading: 'Tiêu đề',
        state: 'Mức độ nền tảng đáp ứng',
        totals_summary: 'Văn bản này có {total} điều — {mapped} điều đã có yêu cầu tuân thủ tương ứng, {declared} điều được ghi nhận là không đặt ra nghĩa vụ, {unmapped} điều chưa được ánh xạ.',
        not_article_structured: 'Văn bản này không được chia theo điều mà sử dụng mã định danh biện pháp kiểm soát, do đó không có danh mục điều để hiển thị. Đây là điều đúng với khung tuân thủ này, không phải một thiếu sót.',
        structure_unverified: 'Ch\u01b0a c\u00f3 ai \u0111\u1ecdc v\u0103n b\u1ea3n ch\u00ednh th\u1ee9c c\u1ee7a v\u0103n b\u1ea3n n\u00e0y, n\u00ean n\u1ec1n t\u1ea3ng ch\u01b0a bi\u1ebft v\u0103n b\u1ea3n \u0111\u01b0\u1ee3c chia th\u00e0nh c\u00e1c \u0111i\u1ec1u kho\u1ea3n nh\u01b0 th\u1ebf n\u00e0o v\u00e0 ch\u01b0a th\u1ec3 cho bi\u1ebft nh\u1eefng quy \u0111\u1ecbnh n\u00e0o \u0111\u00e3 \u0111\u01b0\u1ee3c tri\u1ec3n khai. \u0110\u00e2y l\u00e0 th\u00f4ng tin v\u1ec1 n\u1ec1n t\u1ea3ng, kh\u00f4ng ph\u1ea3i v\u1ec1 v\u0103n b\u1ea3n.',
        structure_not_declared: 'Bản ghi này không nêu văn bản được chia các quy định như thế nào, nên nền tảng chưa biết văn bản có danh mục điều hay không. Đây là thiếu sót của gói đã cài đặt, không phải nhận định về văn bản.',
        structure_not_required: 'Bản ghi này đến từ một gói thị trường, mà gói thị trường không bắt buộc nêu văn bản được chia các quy định như thế nào, nên nền tảng không có danh mục điều để hiển thị cho bản ghi này. Đây không phải là thiếu sót của gói đã cài đặt.',
        structure_origin_unknown: 'Bản ghi này không nêu văn bản được chia các quy định như thế nào, và nền tảng không xác định được loại gói mà bản ghi được cài đặt từ đó, nên chưa biết có cần danh mục điều hay không.',
        coverage_line: 'Mức độ bao phủ điều: {coverage}',
        coverage_levels: {
            mapped: 'Mọi điều đều đã được xử lý',
            partial: 'Một số điều chưa được ánh xạ',
            not_assessed: 'Chưa đánh giá',
        },
        not_mapped_yet: 'Văn bản này được chia theo điều nhưng gói đã cài đặt chưa mang danh mục điều. Khi chưa có danh mục đó, nền tảng không thể cho biết những quy định nào đã được đáp ứng.',
        load_failed: 'Không thể đọc danh mục điều của khung tuân thủ này.',
        recorded_text: {
            column: 'Văn bản gốc',
            read: 'Đọc',
            read_aria: 'Đọc văn bản gốc của Điều {article}',
            dialog_title: 'Điều {article} — văn bản gốc',
            load_failed: 'Không thể đọc văn bản gốc của điều này.',
            load_more: 'Xem tiếp',
            source_line: 'Nguồn: {title}',
            page_single: 'trang {page} của văn bản nguồn',
            pages_range: 'trang {start}–{end} của văn bản nguồn',
            extraction: {
                ocr: 'nhận dạng ký tự (OCR) từ bản quét có chữ ký',
                pdf_text_layer: 'trích xuất từ lớp văn bản của tệp PDF',
                docx_text: 'trích xuất từ bản gốc DOCX',
                html_text: 'trích xuất từ trang thông tin chính thức',
                unrecorded: 'chưa ghi nhận phương pháp trích xuất',
            },
            missing: 'Văn bản nguồn đã ghi nhận không có nội dung của điều này nên không hiển thị nội dung. Chỉ biết tiêu đề của điều.',
            partial: 'Văn bản nguồn kết thúc mà không có dấu hiệu khép lại sau điều này, nên nội dung có thể bao gồm phần tiếp theo sau điều.',
            notice: 'Đây là nguyên văn tiếng Việt của văn bản, được ghi nhận từ bản có chữ ký. Nội dung có thể có lỗi nhận dạng, không xác nhận hiệu lực pháp lý hiện hành và không kèm bản dịch.',
        },
        source_tab: {
            title: 'Văn bản nguồn',
            intro: 'Toàn văn văn bản đã được ghi nhận: chương, điều, phụ lục và số trang theo đúng bản có chữ ký.',
            source_select: 'Văn bản nguồn đã ghi nhận',
            page_mark: 'Trang {page}',
            progress: 'Đang hiển thị {shown}/{total} ký tự',
            load_more: 'Xem tiếp',
            load_all: 'Xem toàn bộ phần còn lại',
            load_failed: 'Không thể đọc văn bản nguồn đã ghi nhận.',
            no_recorded_source: 'Chưa có văn bản nguồn được ghi nhận cho khung tuân thủ này. Các yêu cầu và điều khoản nằm ở các thẻ khác.',
            composite: 'Khung tuân thủ này tập hợp các văn bản khác và không có nội dung riêng. Hãy đọc văn bản nguồn của từng văn bản:',
            superseded_draft: 'Dự thảo lấy ý kiến này sau đó đã được ban hành, và nội dung riêng của dự thảo không được lưu giữ. Hãy đọc văn bản thay thế:',
            open_in_source: 'Trong văn bản nguồn',
            open_in_source_aria: 'Xem Điều {article} trong toàn văn văn bản nguồn',
            article_not_in_source: 'Văn bản nguồn đã ghi nhận không có tiêu đề của Điều {article}, nên không thể hiển thị điều này tại vị trí của nó.',
        },
        states: {
            mapped: 'Đã đáp ứng',
            no_duty_declared: 'Không đặt ra nghĩa vụ cho bên kiểm soát',
            not_yet_mapped: 'Chưa ánh xạ',
        },
    },
    credit_information: {
        title: 'Sử dụng thông tin tín dụng',
        scope_note: 'Điều 27 khoản 1 điểm b Luật 91/2025/QH15 nghiêm cấm sử dụng thông tin tín dụng của chủ thể dữ liệu để chấm điểm, xếp hạng tín dụng, đánh giá thông tin tín dụng hoặc đánh giá mức độ tín nhiệm về tín dụng khi chưa có sự đồng ý của chủ thể dữ liệu đó. Điều 8 Nghị định 356/2025/NĐ-CP quy định chi tiết Điều này: sự đồng ý phải nêu rõ các mục đích xử lý — bao gồm bốn mục đích nêu trên nếu có thực hiện — nguồn thu thập và các bên chia sẻ dữ liệu, thời gian lưu trữ và cách thức rút lại sự đồng ý; việc tuân thủ được đánh giá định kỳ 01 năm một lần; và khi lộ, mất dữ liệu nhạy cảm trong lĩnh vực này phải thông báo cho cơ quan chuyên trách và chủ thể dữ liệu trong thời hạn không quá 72 giờ.',
        boundary_heading: 'Phạm vi và ranh giới — theo khung tuân thủ đã cài đặt',
        boundary_frame: 'Các tuyên bố này đến từ khung tuân thủ đã cài đặt cho tổ chức của bạn và được hiển thị đúng như từng khung nêu. Sổ đăng ký này ghi nhận rằng một lần sử dụng đã diễn ra, cho mục đích nào và dựa trên sự đồng ý nào. Nền tảng không tính điểm tín dụng, không xếp hạng, không đánh giá mức độ tín nhiệm và không đưa ra quyết định cho vay. Một lần sử dụng không có sự đồng ý bao phủ sẽ bị từ chối tại đây thay vì được ghi nhận kèm cảnh báo.',
        boundary_none: 'Không có khung tuân thủ đã cài đặt nào khai báo tuyên bố về ranh giới cho sổ đăng ký này. Câu này mô tả nội dung đã cài đặt cho tổ chức của bạn, không phải phạm vi của tổ chức của bạn.',
        boundary_load_error: 'Không đọc được tuyên bố về ranh giới của khung tuân thủ đã cài đặt nên không hiển thị tuyên bố nào. Điều này không có nghĩa là không có khung nào khai báo.',
        boundary_retry_subject: 'các tuyên bố ranh giới',
        purposes_load_failed: 'Không đọc được các mục đích do khung tuân thủ đã cài đặt quy định, nên chưa thể ghi nhận lần sử dụng. Điều này không có nghĩa là không có mục đích nào được quy định.',
        purposes_retry_subject: 'các mục đích đã quy định',
        consent_check_timing: 'Sự đồng ý được kiểm tra theo tình trạng tại thời điểm bạn ghi nhận lần sử dụng, không phải tại thời điểm sử dụng. Sự đồng ý được rút lại, hoặc được đưa ra, giữa hai thời điểm đó sẽ được xét theo tình trạng hiện tại.',
        kpi_label: 'Tóm tắt sổ đăng ký',
        kpi_total: 'Tổng số',
        kpi_total_hint: 'toàn bộ lần sử dụng đã ghi nhận trong sổ đăng ký này',
        kpi_on_this_page: 'trên trang này',
        kpi_not_loaded: 'chưa tải',
        uses: 'Các lần sử dụng đã ghi nhận',
        record: 'Ghi nhận một lần sử dụng',
        data_subject_ref: 'Mã tham chiếu chủ thể dữ liệu',
        information_description: 'Thông tin tín dụng đã sử dụng',
        purpose: 'Mục đích',
        used_at: 'Thời điểm sử dụng',
        consent_evidence_id: 'Bằng chứng về sự đồng ý',
        consent_evidence_hint: 'Bản ghi bằng chứng về sự đồng ý mà lần sử dụng này dựa vào. Nội dung được đối chiếu và kiểm tra trên máy chủ — nếu bằng chứng không bao phủ mục đích này thì yêu cầu sẽ bị từ chối.',
        consent_purpose_id: 'Mục đích nào trên sự đồng ý đó',
        consent_purpose_hint: 'Mục đích nào được nêu trên sự đồng ý đó bao phủ lần sử dụng này. Tổ chức của bạn quyết định mục đích nào của mình tương ứng; nền tảng kiểm tra rằng mục đích bạn nêu thực sự có trên sự đồng ý đó.',
        consent_state: 'Sự đồng ý',
        record_withdrawal: 'Ghi nhận việc rút lại sự đồng ý',
        withdrawn_at: 'Ngày rút lại',
        no_purposes_installed: 'Không có khung tuân thủ nào đã cài đặt cho tổ chức của bạn quy định mục đích sử dụng thông tin tín dụng, do đó không thể ghi nhận lần sử dụng nào tại đây.',
        empty_uses: 'Chưa ghi nhận lần sử dụng thông tin tín dụng nào.',
        load_failed: 'Không thể đọc sổ đăng ký sử dụng thông tin tín dụng.',
        record_failed: 'Không thể ghi nhận lần sử dụng này.',
        recorded: 'Đã ghi nhận lần sử dụng.',
        withdrawal_recorded: 'Đã ghi nhận việc rút lại sự đồng ý.',
        withdrawal_failed: 'Không thể ghi nhận việc rút lại sự đồng ý.',
        states: {
            consent_in_force: 'Còn hiệu lực',
            consent_withdrawn: 'Đã rút lại',
        },
    },
    legal_matters: {
        title: 'Vụ việc pháp lý',
        scope_note: 'Không có văn bản pháp luật nào đã cài đặt yêu cầu bên kiểm soát dữ liệu vận hành sổ đăng ký này. Luật 91/2025/QH15 Điều 4(1)(đ) tuyên bố chủ thể dữ liệu cá nhân có quyền khiếu nại và tố cáo, còn Nghị định 356/2025/NĐ-CP Điều 36(6) giao việc giải quyết khiếu nại, tố cáo cho cơ quan nhà nước — nghĩa là quyền được tuyên bố, nhưng nghĩa vụ tiếp nhận không thuộc về bạn. Vận hành sổ đăng ký này là năng lực tổ chức của bạn tự chọn, và mọi nhịp độ hiển thị ở đây là nhịp độ của riêng bạn, không phải thời hạn luật định.',
        matters: 'Vụ việc',
        receive: 'Ghi nhận một vụ việc',
        kind: 'Loại',
        origin: 'Căn cứ',
        right_code: 'Quyền nào',
        raised_by: 'Người nêu',
        subject: 'Nội dung',
        state_label: 'Trạng thái',
        received_at: 'Ngày tiếp nhận',
        acknowledged_at: 'Ngày xác nhận',
        acknowledge: 'Ghi nhận việc xác nhận',
        resolve: 'Ghi nhận kết luận',
        resolution_summary: 'Kết luận',
        concluded_at: 'Ngày kết luận',
        not_acknowledged: 'Chưa xác nhận',
        // Sprint 63.31.0 (OD-E) — an intake handled in Legal Matters.
        intake_from: 'Từ yêu cầu quyền {reference}',
        right_not_recorded: 'Yêu cầu tiếp nhận không nêu quyền được thực hiện; người phụ trách sẽ ghi nhận quyền này.',
        record_right: 'Ghi nhận quyền',
        record_right_hint: 'Chọn quyền mà vụ việc này căn cứ, trong số các quyền mà khung tuân thủ đã cài đặt quy định tại điều khoản của yêu cầu tiếp nhận.',
        right_recorded: 'Đã ghi nhận quyền',
        // fix-sprint-20261026-0900 Finding 6 — what a matter awaiting its right rests on,
        // the related-matters column, and the refusals of Record the right.
        rests_on_provision: 'Tại {basis} của {framework}',
        rests_on_provision_no_basis: 'Theo {framework}; không nêu điều khoản',
        related_matters: 'Vụ việc liên quan',
        no_related_matters: 'Không có',
        record_right_closed: 'Vụ việc này đã đóng, nên không thể ghi nhận quyền mà vụ việc căn cứ nữa.',
        record_right_not_at_provision: 'Quyền này không căn cứ trên điều khoản của yêu cầu tiếp nhận. Hãy chọn một trong các quyền được đưa ra.',
        record_right_not_declared: 'Không có khung tuân thủ nào đã cài đặt quy định quyền này. Hãy chọn quyền khác.',
        record_right_already_recorded: 'Quyền mà vụ việc này căn cứ đã được ghi nhận.',
        suggested_link: 'Có thể là cùng vụ việc với “{subject}”: một yêu cầu trước đó dùng cùng địa chỉ email, và địa chỉ này chưa được xác minh.',
        suggested_link_open: 'Mở vụ việc đó',
        suggested_link_accept: 'Cùng vụ việc',
        suggested_link_dismiss: 'Không cùng vụ việc',
        suggested_link_accepted: 'Đã được ghi nhận là cùng vụ việc với “{subject}”.',
        suggested_link_dismissed: 'Đã được ghi nhận là không cùng vụ việc với “{subject}”.',
        suggested_link_decided: 'Đã ghi nhận quyết định',
        linked_matter_not_found: 'Không đọc được vụ việc pháp lý mà liên kết này trỏ tới.',
        linked_matter_shown: 'Vụ việc pháp lý mà liên kết trỏ tới được hiển thị đầu tiên.',
        no_rights_installed: 'Không có khung tuân thủ nào đã cài đặt cho tổ chức của bạn tuyên bố quyền, nên một vụ việc không thể căn cứ trên quyền tại đây.',
        rights_loading: 'Đang đọc các quyền mà khung tuân thủ đã cài đặt tuyên bố…',
        rights_load_failed: 'Không đọc được các quyền mà khung tuân thủ đã cài đặt tuyên bố, nên chưa thể ghi nhận một vụ việc căn cứ trên quyền cho đến khi đọc được.',
        rights_retry_subject: 'các quyền được tuyên bố',
        matters_retry_subject: 'sổ đăng ký vụ việc pháp lý',
        loading: 'Đang tải sổ đăng ký vụ việc pháp lý',
        right_placeholder: 'Chọn quyền',
        withdrawn_on_by: 'Rút lại lúc {at}, do {by} ghi nhận.',
        withdrawal_reason_not_recorded: 'Không có lý do nào được ghi lại cho lần rút lại này.',
        timeline_acknowledged_before_received: 'Thời điểm xác nhận không thể sớm hơn thời điểm tiếp nhận.',
        timeline_concluded_before_received: 'Thời điểm kết luận không thể sớm hơn thời điểm tiếp nhận.',
        timeline_concluded_before_acknowledged: 'Thời điểm kết luận không thể sớm hơn thời điểm xác nhận.',
        kpi_row_label: 'Tóm tắt sổ đăng ký vụ việc pháp lý',
        kpi_not_loaded: 'Chưa tải',
        kpi_total: 'Vụ việc',
        kpi_total_hint: 'trong sổ đăng ký',
        kpi_on_this_page: 'trên trang này',
        withdraw: 'Ghi nhận việc rút lại',
        withdrawal_reason: 'Lý do rút lại',
        withdrawn: 'Đã ghi nhận việc rút lại.',
        empty_matters: 'Chưa có vụ việc nào được ghi nhận.',
        load_failed: 'Không đọc được sổ đăng ký vụ việc pháp lý.',
        create_failed: 'Không lưu được bản ghi.',
        created: 'Đã ghi nhận.',
        acknowledged: 'Đã ghi nhận việc xác nhận.',
        resolved: 'Đã ghi nhận kết luận.',
        kinds: {
            complaint: 'Khiếu nại',
            denunciation: 'Tố cáo',
            claim: 'Yêu cầu bồi thường',
            litigation: 'Tố tụng',
            regulatory_penalty: 'Xử phạt hành chính',
            other: 'Khác',
        },
        origins: {
            statutory_right: 'Quyền do một khung tuân thủ đã cài đặt tuyên bố',
            elective: 'Vụ việc tổ chức của bạn tự chọn theo dõi',
        },
        states: {
            received: 'Đã tiếp nhận',
            acknowledged: 'Đã xác nhận',
            resolved: 'Đã giải quyết',
            withdrawn: 'Đã rút lại',
        },
        raised_by_options: {
            data_subject: 'Chủ thể dữ liệu cá nhân',
            employee: 'Người lao động',
            regulator: 'Cơ quan quản lý',
            counterparty: 'Đối tác',
            other: 'Khác',
        },
    },
    continuity: {
        title: 'Diễn tập liên tục',
        scope_note: 'Không có văn bản nào đã cài đặt yêu cầu diễn tập liên tục. Luật 91/2025/QH15 và Nghị định 356/2025/NĐ-CP đã được đọc toàn văn và không văn bản nào áp đặt biện pháp kiểm soát này, nên mọi nhịp độ hiển thị ở đây là nhịp độ nội bộ của tổ chức, không phải thời hạn theo luật định. Một đợt diễn tập làm phát sinh hành động cải thiện chưa hoàn tất cho đến khi từng hành động được kiểm thử lại.',
        plans: 'Kế hoạch liên tục',
        exercises: 'Các đợt diễn tập',
        plan_name: 'Tên kế hoạch',
        plan_scope: 'Phạm vi',
        plan_owner: 'Người phụ trách',
        scope_note_label: 'Nêu rõ phạm vi',
        create_plan: 'Thêm kế hoạch',
        schedule: 'Lên lịch diễn tập',
        kind: 'Hình thức',
        status_label: 'Trạng thái',
        outcome_label: 'Kết quả',
        held_at: 'Ngày thực hiện',
        participants: 'Người tham gia',
        open_loops: 'Hành động cải thiện chờ kiểm thử lại',
        no_open_loops: 'Đã kiểm thử lại toàn bộ',
        last_reviewed: 'Rà soát lần cuối',
        never_reviewed: 'Chưa rà soát lần nào',
        empty_plans: 'Chưa ghi nhận kế hoạch liên tục nào.',
        empty_exercises: 'Chưa ghi nhận đợt diễn tập nào.',
        complete: 'Hoàn tất đợt diễn tập',
        cancel: 'Hủy đợt diễn tập',
        cancel_reason: 'Lý do hủy',
        completed: 'Đã hoàn tất đợt diễn tập.',
        cancelled: 'Đã hủy đợt diễn tập.',
        retested: 'Đã ghi nhận việc kiểm tra lại.',
        record_retest: 'Ghi nhận kiểm tra lại',
        retested_at: 'Ngày kiểm tra lại',
        retest_note: 'Kết quả kiểm tra lại',
        participant_name: 'Người chủ trì',
        participant_role: 'Vai trò',
        summary: 'Điều đã xảy ra',
        improvement_action: 'Hành động cải thiện (tùy chọn)',
        action_owner: 'Người phụ trách hành động',
        load_failed: 'Không đọc được sổ đăng ký liên tục.',
        create_failed: 'Không lưu được bản ghi.',
        created: 'Đã ghi nhận.',
        retry_plans_subject: 'danh sách kế hoạch liên tục',
        retry_exercises_subject: 'danh sách đợt diễn tập',
        complete_for: 'Hoàn tất đợt diễn tập: {exercise}',
        cancel_for: 'Hủy đợt diễn tập: {exercise}',
        record_retest_for: 'Ghi nhận kiểm tra lại cho {exercise}: {action}',
        completing_heading: 'Đang hoàn tất đợt diễn tập: {exercise}',
        cancelling_heading: 'Đang hủy đợt diễn tập: {exercise}',
        retest_heading: 'Đang ghi nhận kiểm tra lại cho {exercise}: {action}',
        scopes: {
            systems: 'Hệ thống',
            premises: 'Cơ sở vật chất',
            people: 'Nhân sự',
            suppliers: 'Nhà cung cấp',
            data_recovery: 'Khôi phục dữ liệu',
            other: 'Khác',
        },
        kinds: {
            tabletop: 'Diễn tập trên giấy',
            simulation: 'Mô phỏng',
            live: 'Thực địa',
            other: 'Khác',
        },
        outcomes: {
            objectives_met: 'Đạt mục tiêu',
            objectives_partially_met: 'Đạt một phần mục tiêu',
            objectives_not_met: 'Không đạt mục tiêu',
            not_completed: 'Chưa hoàn thành',
        },
        statuses: {
            scheduled: 'Đã lên lịch',
            completed: 'Đã hoàn thành',
            cancelled: 'Đã hủy',
        },
    },
    /* Sprint 65.17.0 — de-identification runs (toolkit row ANON-01). */
    deidentification: {
        title: 'Các đợt phi định danh',
        scope_note: 'Nghị định 356/2025/NĐ-CP Điều 10 khoản 6 quy định chủ thể dữ liệu cá nhân phải có quyền chỉnh sửa, ẩn danh, xóa hồ sơ nhận dạng trong hệ thống trí tuệ nhân tạo và vũ trụ ảo. Ngoài phạm vi đó, đây là biện pháp kiểm soát do tổ chức tự lựa chọn thực hiện. Một đợt chưa hoàn tất cho đến khi có người đánh giá phần còn có thể tái định danh.',
        population: 'Phạm vi dữ liệu đã xử lý',
        method: 'Phương pháp',
        method_note: 'Nêu rõ phương pháp',
        create: 'Ghi nhận một đợt',
        created: 'Đã ghi nhận đợt phi định danh.',
        empty: 'Chưa ghi nhận đợt phi định danh nào.',
        status_label: 'Trạng thái',
        sample_label: 'Mẫu kiểm tra',
        residual_risk_label: 'Rủi ro tái định danh còn lại',
        load_failed: 'Không đọc được danh sách đợt phi định danh.',
        create_failed: 'Không ghi nhận được đợt phi định danh.',
        residual_risk_absent: 'Chưa được đánh giá',
        record_judgement: 'Ghi nhận mẫu kiểm tra và đánh giá',
        record_judgement_for: 'Ghi nhận mẫu kiểm tra và đánh giá cho {population}',
        sample_outcome: 'Kết quả mẫu kiểm tra',
        records_examined: 'Số bản ghi đã kiểm tra',
        sample_finding: 'Nội dung mẫu kiểm tra phát hiện',
        residual_risk_reasoning: 'Rủi ro tái định danh còn lại — lập luận của bạn',
        residual_risk_hint: 'Nền tảng không tự tính ra con số nào. Phần còn có thể tái định danh phụ thuộc vào dữ liệu mà tổ chức của bạn không nắm giữ, nên đây được ghi nhận là đánh giá của bạn, gắn với tài khoản của bạn và thời điểm bạn lưu.',
        updated: 'Đã cập nhật đợt phi định danh.',
        update_failed: 'Không cập nhật được đợt phi định danh.',
        approve_for: 'Phê duyệt đợt phi định danh cho {population}',
        reject: 'Từ chối đợt phi định danh',
        reject_for: 'Từ chối đợt phi định danh cho {population}',
        reject_heading_for: 'Đang từ chối đợt phi định danh cho {population}',
        decision_note: 'Lý do từ chối',
        approved: 'Đã phê duyệt đợt phi định danh.',
        rejected: 'Đã từ chối đợt phi định danh.',
        decide_failed: 'Không ghi nhận được quyết định.',
        total_runs: 'Đã ghi nhận {count} đợt',
        methods: {
            suppression: 'Loại bỏ trường dữ liệu',
            generalisation: 'Khái quát hóa',
            pseudonymisation: 'Bút danh hóa',
            aggregation: 'Tổng hợp',
            noise_addition: 'Thêm nhiễu',
            hashing_with_deleted_key: 'Băm và xóa khóa',
            other: 'Khác',
        },
        sample_outcomes: {
            not_sampled: 'Chưa lấy mẫu',
            sample_clean: 'Mẫu không phát hiện yếu tố định danh',
            sample_found_identifiers: 'Mẫu phát hiện yếu tố định danh',
        },
        statuses: {
            draft: 'Bản nháp',
            awaiting_approval: 'Chờ phê duyệt',
            approved: 'Đã phê duyệt',
            rejected: 'Đã từ chối',
        },
    },
    training: {
        title: 'Đào tạo và nâng cao nhận thức',
        subtitle: 'Phân công đào tạo cho từng người cụ thể và ghi nhận mỗi lần hoàn thành kèm bằng chứng chứng minh việc đó đã diễn ra.',
        module_guide: 'Xác định chương trình đào tạo mà tổ chức của bạn yêu cầu, phân công cho từng người kèm thời hạn, và đóng mỗi phân công dựa trên bằng chứng — một biểu mẫu đã điền, một chứng chỉ đã tải lên hoặc một xác nhận đã ghi nhận. Không thể đánh dấu một phân công là hoàn thành nếu không có bằng chứng; việc miễn trừ cho một người là quyết định được ghi nhận kèm người đưa ra quyết định và lý do. Tỷ lệ hoàn thành ở đây được đưa vào thành phần đào tạo trong điểm sẵn sàng kiểm toán của bạn.',
        nav_assignments: 'Đào tạo và nhận thức',
        new_course: 'Khoá đào tạo mới',
        assign: 'Phân công đào tạo',
        summary_open: 'Đang mở',
        summary_completed: 'Đã hoàn thành',
        summary_overdue: 'Quá hạn',
        summary_exempted: 'Được miễn',
        filters_label: 'Lọc phân công đào tạo',
        filter_status: 'Trạng thái',
        filter_overdue_only: 'Chỉ hiện quá hạn',
        focused_heading: 'Phân công:',
        sr_loading: 'Đang tải danh sách phân công đào tạo',
        no_assignments: 'Không có phân công đào tạo nào khớp với bộ lọc này.',
        table_label: 'Phân công đào tạo',
        col_course: 'Khoá đào tạo',
        col_assignee: 'Người được phân công',
        col_due: 'Hạn',
        col_status: 'Trạng thái',
        col_evidence: 'Tài liệu chứng minh',
        overdue_badge: 'Quá hạn',
        evidence_none: 'Chưa ghi nhận',
        exempted_by_label: 'Người miễn trừ',
        cancelled_by_label: 'Người thu hồi',
        cancellation_reason_not_recorded: 'Đã thu hồi — lý do không được lưu lại',
        action_start: 'Bắt đầu',
        action_complete: 'Ghi nhận hoàn thành',
        action_exempt: 'Miễn trừ',
        action_cancel: 'Thu hồi',
        modal_course_title: 'Khoá đào tạo mới',
        field_course_title: 'Tên khoá đào tạo',
        field_course_description: 'Mô tả',
        field_recurrence_months: 'Lặp lại mỗi (tháng)',
        field_recurrence_hint: 'Để trống nếu đào tạo chỉ diễn ra một lần. Đây là nhịp độ nội bộ, không phải thời hạn theo luật định.',
        modal_assign_title: 'Phân công đào tạo',
        field_course: 'Khoá đào tạo',
        no_courses_hint: 'Chưa có khoá đào tạo nào đang hoạt động. Hãy tạo khoá đào tạo trước khi phân công.',
        courses_heading: 'Khoá đào tạo',
        courses_table_label: 'Các khoá đào tạo đang hoạt động',
        no_courses: 'Chưa có khoá đào tạo nào đang hoạt động.',
        col_description: 'Mô tả',
        col_recurrence: 'Lặp lại',
        recurrence_one_off: 'Một lần',
        recurrence_every: 'Mỗi {count} tháng',
        action_assign_course: 'Phân công',
        field_assignees: 'Người tham gia',
        field_assignees_hint: 'Mỗi dòng một mã người dùng, hoặc phân tách bằng dấu phẩy. Mỗi người nhận một phân công riêng và một nhiệm vụ riêng.',
        field_due_at: 'Ngày đến hạn',
        modal_complete_title: 'Ghi nhận hoàn thành',
        modal_complete_hint: 'Việc ghi nhận hoàn thành phải dẫn chiếu bằng chứng cho thấy khoá đào tạo đã được thực hiện — một biểu mẫu đã nộp, một tệp đã tải lên hoặc một xác nhận đã ghi nhận. Không thể đóng phân công nếu thiếu bằng chứng.',
        field_evidence_kind: 'Loại bằng chứng',
        field_evidence_reference: 'Mã tham chiếu bằng chứng',
        modal_exempt_title: 'Miễn trừ đào tạo',
        modal_exempt_hint: 'Việc miễn trừ được ghi nhận kèm tên bạn và lý do bạn nêu. Nó không bao giờ được tính là hoàn thành.',
        field_exemption_reason: 'Lý do miễn trừ',
        modal_cancel_title: 'Thu hồi phân công',
        field_cancel_reason: 'Lý do thu hồi',
        toast_started: 'Đã bắt đầu phân công đào tạo.',
        toast_course_created: 'Đã tạo khoá đào tạo.',
        toast_assigned: 'Đã phân công đào tạo.',
        toast_completed: 'Đã ghi nhận hoàn thành.',
        toast_exempted: 'Đã ghi nhận miễn trừ.',
        toast_cancelled: 'Đã thu hồi phân công.',
        announce_loaded: 'Đã tải {count} phân công đào tạo',
        statuses: {
            assigned: 'Đã phân công',
            in_progress: 'Đang thực hiện',
            completed: 'Đã hoàn thành',
            exempted: 'Được miễn',
            cancelled: 'Đã thu hồi',
        },
        evidence_kinds: {
            form_instance: 'Biểu mẫu đã điền',
            attachment: 'Tệp đã tải lên',
            attestation: 'Xác nhận đã ghi nhận',
        },
    },
    task_management: {
        // Sprint 63.32.0 (#543) — the module a task came from, in the reader's language.
        source_modules: {
            rights_requests: 'Yêu cầu quyền',
            assessments: 'Đánh giá tác động',
            incidents: 'Ứng phó sự cố',
            incident_ops: 'Vận hành sự cố',
            monitoring: 'Chương trình giám sát',
            vendor_risk: 'Rủi ro nhà cung cấp',
            governance: 'Quản trị',
            deletion_orchestration: 'Điều phối xóa',
            access_review: 'Rà soát truy cập',
            consent: 'Quản trị đồng thuận',
            consent_properties: 'Thuộc tính đồng thuận',
            forms: 'Biểu mẫu tuân thủ',
            localization: 'Bản địa hóa',
            program_governance: 'Quản trị chương trình',
            privacy_scanner: 'Quét quyền riêng tư',
            classification: 'Phân loại dữ liệu',
            discovery: 'Khám phá dữ liệu',
            data_mapping: 'Bản đồ dữ liệu',
            compliance_operations: 'Chương trình công việc tuân thủ',
            training: 'Đào tạo',
            privacy_office: 'Văn phòng quyền riêng tư',
            authority_operations: 'Làm việc với cơ quan có thẩm quyền',
            ai_governance: 'Quản trị AI',
            regulatory_classification: 'Phân loại theo quy định',
            org_settings: 'Hồ sơ tổ chức',
            customs_tax_administration: 'Quản lý thuế hải quan',
            manual: 'Thủ công',
        },
        nav: {
            calendar: 'Lịch',
            all_tasks: 'Tất cả tác vụ',
            my_tasks: 'Tác vụ của tôi',
            overdue: 'Quá hạn',
            board: 'Bảng',
            workflows: 'Quy trình',
        },
        list: {
            title: 'Tất cả tác vụ',
            my_title: 'Tác vụ của tôi',
            overdue_title: 'Tác vụ quá hạn',
            new_task: 'Tạo tác vụ',
            no_tasks: 'Không tìm thấy tác vụ.',
            empty_state: 'Không tìm thấy nhiệm vụ nào. Nhiệm vụ được tạo từ quy trình công việc của phân hệ như đánh giá, sự cố và chiến dịch đánh giá.',
            total: 'Tổng tác vụ',
            search_placeholder: 'Tìm kiếm tác vụ...',
            bulk_actions: 'Hành động hàng loạt',
            change_status: 'Đổi trạng thái',
            change_priority: 'Đổi mức ưu tiên',
            assign: 'Chỉ định',
            sla_label: 'SLA',
            sr_days_overdue: '{count} ngày quá hạn',
            sr_my_tasks_count: '{count} tác vụ được giao cho bạn',
        },
        detail: {
            workflow_step: 'Bước quy trình',
            title: 'Chi tiết tác vụ',
            description: 'Mô tả',
            workflow_progress: 'Tiến trình quy trình',
            checklist: 'Danh sách kiểm tra',
            dependencies: 'Phụ thuộc',
            comments: 'Nhận xét',
            activity_timeline: 'Dòng thời gian hoạt động',
            assignees: 'Người được giao',
            add_assignee: 'Thêm người được giao',
            remove_assignee: 'Xóa người được giao',
            due_date: 'Ngày hết hạn',
            start_date: 'Ngày bắt đầu',
            sla_status: 'Trạng thái SLA',
            sla_on_track: 'Đúng tiến độ',
            sla_at_risk: 'Có rủi ro',
            sla_breached: 'Vi phạm',
            tags: 'Nhãn',
            source_entity: 'Thực thể nguồn',
            view_source: 'Xem nguồn',
            add_dependency: 'Thêm phụ thuộc',
            remove_dependency: 'Xóa phụ thuộc',
            write_comment: 'Viết nhận xét...',
            post_comment: 'Đăng',
            edit_comment: 'Chỉnh sửa',
            delete_comment: 'Xóa',
            add_checklist_item: 'Thêm mục',
            no_dependencies: 'Không có phụ thuộc',
            no_comments: 'Chưa có nhận xét',
            blocks: 'Chặn',
            blocked_by: 'Bị chặn bởi',
            related: 'Liên quan',
            working_days_remain: 'ngày làm việc còn lại',
            created_by: 'Tạo bởi',
            completed_at: 'Hoàn thành lúc',
            remove_assignee_aria: 'Xóa người được giao: {name}',
            // Sprint 63.32.0 (#543) — the seeded role names an assignment can carry.
            assignee_role_labels: {
                platform_admin: 'Quản trị nền tảng',
                compliance_owner: 'Chủ sở hữu tuân thủ',
                case_manager: 'Người quản lý vụ việc',
                auditor: 'Kiểm toán viên',
                approver: 'Người phê duyệt',
                partner_external_counsel: 'Luật sư bên ngoài (đối tác)',
                processor_liaison: 'Đầu mối bên xử lý',
            },
            remove_dependency_aria: 'Xóa phụ thuộc: {name}',
            no_assignees: 'Không có người được giao',
            add_assignee_placeholder: 'Nhập ID người dùng...',
            edited: 'đã chỉnh sửa',
            timeline: 'Dòng thời gian hoạt động',
            no_timeline: 'Chưa có hoạt động',
            timeline_reason: 'Lý do',
            no_workflow: 'Chưa gán quy trình',
            add_dependency_placeholder: 'Nhập ID tác vụ...',
            sr_status_updated: 'Trạng thái đã cập nhật thành {status}',
            sr_priority_updated: 'Ưu tiên đã cập nhật thành {priority}',
            // Sprint 63.30.0 (#590, #574) — due date edit and Escalate.
            save_due_date: 'Lưu ngày hết hạn',
            due_date_saved: 'Đã đặt ngày hết hạn là {date}',
            due_date_save_failed: 'Không thể lưu ngày hết hạn.',
            escalate: 'Leo thang',
            escalate_title: 'Leo thang tác vụ này',
            escalate_description: 'Leo thang sẽ chuyển tác vụ sang trạng thái Đã leo thang. Lý do của bạn được ghi cùng thay đổi trạng thái và hiển thị bên cạnh thay đổi đó trong dòng thời gian hoạt động của tác vụ.',
            escalate_reason: 'Lý do leo thang',
            escalate_reason_required: 'Hãy nhập lý do leo thang.',
            escalating: 'Đang leo thang...',
            sr_escalated: 'Đã leo thang tác vụ',
            escalate_failed: 'Không thể leo thang tác vụ.',
            // Sprint 47.5.8.5 — task → workflow-run conversion + linked chip
            convert_to_workflow: 'Chạy như Quy trình AI',
            convert_modal_title: 'Chuyển nhiệm vụ thành lượt chạy quy trình',
            convert_workflow_label: 'Quy trình',
            convert_workflow_placeholder: 'Chọn một quy trình…',
            convert_attachments_label: 'Tệp đính kèm',
            convert_attachments_empty: 'Nhiệm vụ này chưa có tệp đính kèm.',
            convert_persona_label: 'Ghi đè vai (tùy chọn)',
            convert_submit: 'Bắt đầu chạy quy trình',
            convert_starting: 'Đang khởi chạy quy trình…',
            convert_started: 'Đã bắt đầu chạy quy trình — đang mở lượt chạy…',
            convert_disabled_in_flight: 'Một lượt chạy quy trình từ nhiệm vụ này đang diễn ra.',
            linked_workflow_chip: 'Từ {workflow_title}',
            linked_chat_chip: 'Từ Trò chuyện AI',
            linked_more: '+{count} mục khác',
        },
        calendar: {
            title: 'Lịch tác vụ',
            month: 'Tháng',
            week: 'Tuần',
            day: 'Ngày',
            today: 'Hôm nay',
            more_tasks: '+{count} thêm',
            no_tasks_day: 'Không có tác vụ ngày này',
            all_day: 'Cả ngày',
            quick_create_tooltip: 'Tạo tác vụ cho ngày này',
            tasks_in_view: '{count} tác vụ đang hiển thị',
            task_in_view: '{count} tác vụ đang hiển thị',
            filter_my_tasks: 'Công việc của tôi',
            filter_overdue: 'Quá hạn',
            filter_high_priority: 'Ưu tiên cao',
            filter_all: 'Tất cả',
            view_changed: 'Chế độ xem lịch đã chuyển sang {view}',
            page_title: 'Lịch',
            create_task: 'Tạo tác vụ',
        },
        filters: {
            assignee: 'Người được giao',
            me: 'Tôi',
            role: 'Vai trò',
            status: 'Trạng thái',
            priority: 'Mức ưu tiên',
            task_type: 'Loại tác vụ',
            source_module: 'Phân hệ nguồn',
            organization: 'Tổ chức',
            sla_breached_only: 'Chỉ hiển thị SLA vi phạm',
            clear_filters: 'Xóa bộ lọc',
            apply_filters: 'Áp dụng',
            // Sprint 47.5.8.5 — source-kind chip on TaskListPage
            source_label: 'Nguồn',
            source_manual: 'Thủ công',
            source_module_kind: 'Sinh từ phân hệ',
            source_chat: 'Từ Trò chuyện AI',
            source_workflow_run: 'Từ Lượt chạy Quy trình AI',
        },
        status: {
            pending: 'Chờ xử lý',
            in_progress: 'Đang tiến hành',
            blocked: 'Bị chặn',
            completed: 'Hoàn thành',
            overdue: 'Quá hạn',
            escalated: 'Đã leo thang',
            cancelled: 'Đã hủy',
        },
        priority: {
            critical: 'Nghiêm trọng',
            high: 'Cao',
            medium: 'Trung bình',
            low: 'Thấp',
        },
        task_types: {
            manual_task: 'Tác vụ thủ công',
            dsr_case: 'Vụ DSR',
            dsr_review: 'Xem xét DSR',
            dsr_escalation: 'Leo thang DSR',
            dpia_review: 'Xem xét DPIA',
            dpia_approval: 'Phê duyệt DPIA',
            transfer_review: 'Xem xét chuyển giao',
            incident_task: 'Tác vụ sự cố',
            incident_notification: 'Thông báo sự cố',
            playbook_step: 'Bước playbook',
            regulator_deadline: 'Hạn chót cơ quan quản lý',
            monitoring_task: 'Tác vụ giám sát',
            kpi_alert: 'Cảnh báo KPI',
            vendor_review: 'Xem xét nhà cung cấp',
            vendor_questionnaire: 'Bảng câu hỏi nhà cung cấp',
            governance_review: 'Xem xét quản trị',
            drift_alert: 'Cảnh báo lệch chuẩn',
            governance_approval: 'Phê duyệt quản trị',
            deletion_task: 'Tác vụ xóa',
            deletion_verification: 'Xác minh xóa',
            access_review: 'Xem xét quyền truy cập',
            sod_alert: 'Cảnh báo SoD',
            consent_workflow: 'Quy trình đồng ý',
            consent_alert: 'Cảnh báo đồng ý',
            property_review: 'Xem xét thuộc tính',
            inconsistency_alert: 'Cảnh báo không nhất quán',
            form_review: 'Xem xét biểu mẫu',
            dossier_deadline: 'Hạn chót hồ sơ',
            submission_task: 'Tác vụ nộp',
            translation_review: 'Xem xét bản dịch',
            governance_task: 'Tác vụ quản trị',
            reporting_deadline: 'Hạn chót báo cáo',
            scanner_alert: 'Cảnh báo quét',
            classification_review: 'Xem xét phân loại',
            lifecycle_task: 'Tác vụ vòng đời',
            discovery_review: 'Xem xét khám phá',
            forseti_task: 'Nhiệm vụ Forseti',
        },
        training_assignment: 'Phân công đào tạo',
        task_type_groups: {
            training: 'Đào tạo',
            manual: 'Thủ công',
            dsr: 'DSR / Yêu cầu quyền',
            assessments: 'Đánh giá',
            incidents: 'Sự cố',
            incident_ops: 'Vận hành sự cố',
            monitoring: 'Giám sát',
            vendor_risk: 'Rủi ro nhà cung cấp',
            governance: 'Quản trị',
            deletion: 'Xóa',
            access_review: 'Xem xét quyền truy cập',
            consent: 'Đồng ý',
            consent_properties: 'Thuộc tính đồng ý',
            forms: 'Biểu mẫu',
            localization: 'Bản địa hóa',
            program_governance: 'Quản trị chương trình',
            privacy_scanner: 'Quét quyền riêng tư',
            classification: 'Phân loại',
            discovery: 'Khám phá',
            forseti: 'Forseti',
        },
        create: {
            title: 'Tạo tác vụ',
            task_title: 'Tiêu đề',
            task_description: 'Mô tả',
            task_type: 'Loại tác vụ',
            task_type_label: 'Loại tác vụ',
            task_type_placeholder: 'Chọn loại tác vụ',
            priority: 'Độ ưu tiên',
            assignees: 'Người thực hiện',
            assignee_search_placeholder: 'Tìm người dùng...',
            assignee_search_no_results: 'Không tìm thấy người dùng.',
            assignee_search_loading: 'Đang tải…',
            tags_placeholder: 'nhãn1, nhãn2',
            remove_assignee: 'Xóa {name}',
            due_date: 'Ngày đến hạn',
            start_date: 'Ngày bắt đầu',
            checklist: 'Danh sách kiểm tra',
            tags: 'Nhãn',
            add_checklist_item: 'Thêm mục kiểm tra',
            validation: {
                title_required: 'Tiêu đề là bắt buộc',
                title_max_length: 'Tiêu đề tối đa 500 ký tự',
                description_max_length: 'Mô tả tối đa 5000 ký tự',
                due_date_before_start: 'Ngày đến hạn phải sau ngày bắt đầu',
                max_reminders: 'Tối đa 5 lời nhắc cho mỗi tác vụ',
            },
            reminders: {
                title: 'Nhắc nhở',
                add: 'Thêm nhắc nhở',
                at_due_date: 'Vào ngày đến hạn',
                minutes_before: '{count} phút trước',
                hours_before: '{count} giờ trước',
                days_before: '{count} ngày trước',
                weeks_before: '{count} tuần trước',
                custom: 'Tùy chỉnh',
                channel_platform: 'Nền tảng',
                channel_email: 'Email',
                channel_both: 'Cả hai',
                offset_label: 'Thời điểm nhắc nhở {n}',
                channel_label: 'Kênh nhắc nhở {n}',
                remove_label: 'Xóa nhắc nhở {n}',
            },
            workflow: {
                label: 'Quy trình',
                none: 'Không (quản lý trạng thái thủ công)',
                steps_count: '{count} bước',
                preview_label: 'Các bước quy trình',
            },
        },
        errors: {
            fetch_failed: 'Không thể tải tác vụ.',
            save_failed: 'Không thể lưu tác vụ.',
            delete_failed: 'Không thể xóa tác vụ.',
            status_change_failed: 'Không thể đổi trạng thái tác vụ.',
            assign_failed: 'Không thể chỉ định tác vụ.',
            comment_failed: 'Không thể lưu nhận xét.',
            checklist_failed: 'Không thể cập nhật danh sách kiểm tra.',
            dependency_failed: 'Không thể cập nhật phụ thuộc.',
            workflow_failed: 'Không thể lưu quy trình.',
            workflow_activate_failed: 'Không thể kích hoạt quy trình.',
            workflow_delete_failed: 'Không thể xóa quy trình.',
            template_install_failed: 'Không thể cài đặt mẫu.',
            search_failed: 'Không thể tìm tác vụ.',
            // Sprint 47.5.8.5
            convert_failed: 'Không thể bắt đầu lượt chạy quy trình.',
            convert_quota_exhausted: 'Hạn mức token thấp. Hãy nạp thêm trước khi chạy lại.',
        },
        dependency_types: {
            blocks: 'Chặn',
            blocked_by: 'Bị chặn bởi',
            related: 'Liên quan',
        },
        workflow: {
            current_step: 'Bước hiện tại',
            transition: 'Chuyển tiếp',
            history: 'Lịch sử bước',
            no_workflow: 'Chưa gán quy trình',
            detail_title: 'Chi tiết quy trình',
            list_title: 'Định nghĩa quy trình',
            create_workflow: 'Tạo quy trình',
            browse_templates: 'Duyệt mẫu',
            template_catalog_title: 'Danh mục mẫu quy trình',
            name: 'Tên',
            description: 'Mô tả',
            task_types: 'Loại tác vụ',
            steps: 'Bước',
            version: 'Phiên bản',
            created: 'Đã tạo',
            actions: 'Hành động',
            status_draft: 'Nháp',
            status_active: 'Đang hoạt động',
            status_archived: 'Đã lưu trữ',
            activate: 'Kích hoạt',
            archive: 'Lưu trữ',
            save: 'Lưu',
            edit: 'Chỉnh sửa',
            delete: 'Xóa',
            clone: 'Nhân bản',
            install: 'Cài đặt',
            installed: 'Đã cài đặt',
            system: 'Hệ thống',
            general_settings: 'Cài đặt chung',
            default_assignment: 'Phân công mặc định',
            default_sla: 'SLA mặc định',
            workflow_steps: 'Bước quy trình',
            add_step: 'Thêm bước',
            step_name: 'Tên bước',
            step_status: 'Giá trị trạng thái',
            assignment_strategy: 'Chiến lược phân công',
            assignment_role: 'Vai trò phân công',
            sla_hours: 'Giờ SLA',
            sla_calendar_type: 'Loại lịch',
            working_days: 'Ngày làm việc',
            calendar_days: 'Ngày lịch',
            is_terminal: 'Bước cuối',
            required_fields: 'Trường bắt buộc',
            checklist_template: 'Mẫu danh sách kiểm tra',
            transitions: 'Chuyển tiếp',
            add_transition: 'Thêm chuyển tiếp',
            from_step: 'Từ',
            to_step: 'Đến',
            permission: 'Quyền',
            sla_action: 'Hành động SLA',
            notify: 'Thông báo',
            escalation_rules: 'Quy tắc leo thang',
            add_rule: 'Thêm quy tắc',
            trigger: 'Kích hoạt',
            threshold: 'Ngưỡng',
            action: 'Hành động',
            target_role: 'Vai trò đích',
            trigger_sla_threshold: 'Ngưỡng SLA',
            trigger_sla_breach: 'Vi phạm SLA',
            trigger_blocked_duration: 'Thời gian bị chặn',
            trigger_manual: 'Thủ công',
            action_notify: 'Thông báo',
            action_escalate: 'Leo thang cấp',
            action_reassign: 'Phân công lại',
            sla_start: 'Bắt đầu',
            sla_pause: 'Tạm dừng',
            sla_resume: 'Tiếp tục',
            sla_stop: 'Dừng',
            strategy_manual: 'Thủ công',
            strategy_role_based: 'Dựa trên vai trò',
            strategy_round_robin: 'Luân phiên',
            strategy_least_loaded: 'Ít tải nhất',
            strategy_creator: 'Người tạo',
            confirm_delete: 'Bạn có chắc muốn xóa quy trình này?',
            confirm_archive: 'Bạn có chắc muốn lưu trữ quy trình này?',
            cannot_delete_active: 'Không thể xóa quy trình đang hoạt động. Lưu trữ trước.',
            validation_errors: 'Lỗi xác thực quy trình',
            step_count: '{count} bước',
            no_workflows: 'Không tìm thấy quy trình.',
            no_templates: 'Không có mẫu.',
            sr_templates_count: '{count} mẫu có sẵn',
            template_installed: 'Mẫu đã cài đặt thành công.',
            activate_success: 'Quy trình đã kích hoạt.',
            archive_success: 'Quy trình đã lưu trữ.',
            save_success: 'Quy trình đã lưu.',
            delete_success: 'Quy trình đã xóa.',
            applicable_task_types: 'Loại công việc áp dụng',
            steps_column: 'Bước',
            status_value_hint: 'Khóa trạng thái quy trình dùng cho các chuyển tiếp. Chỉ dùng chữ thường, số và dấu gạch dưới.',
            from_status: 'Từ trạng thái',
            to_status: 'Đến trạng thái',
            required_permissions: 'Quyền bắt buộc',
            transition_required_fields: 'Trường bắt buộc (chuyển tiếp)',
            auto_assign: 'Tự động phân công',
            auto_assign_role: 'Vai trò tự động phân công',
            threshold_percent: 'Ngưỡng (%)',
            blocked_hours: 'Số giờ bị chặn',
            notify_roles: 'Vai trò nhận thông báo',
            escalate_to_role: 'Chuyển lên vai trò',
            notification_template: 'Mẫu thông báo',
            action_escalate_tier: 'Cấp leo thang',
            create_modal_title: 'Tạo quy trình',
            create_modal_description: 'Xác định các bước, chuyển tiếp và quy tắc leo thang. Quy trình được tạo ở trạng thái nháp.',
            create_modal_footer_note: 'Được tạo ở dạng nháp. Kích hoạt khi biểu đồ hợp lệ.',
            validation_name_required: 'Tên quy trình là bắt buộc.',
            validation_task_types_required: 'Chọn ít nhất một loại công việc áp dụng.',
            validation_min_one_step: 'Thêm ít nhất một bước.',
            validation_min_one_transition: 'Thêm ít nhất một chuyển tiếp.',
            validation_step_name_required: 'Tên bước là bắt buộc.',
            validation_status_value_required: 'Giá trị trạng thái là bắt buộc.',
            validation_status_value_duplicate: 'Giá trị trạng thái phải duy nhất trên các bước.',
            validation_transition_endpoints_required: 'Chọn cả trạng thái nguồn và trạng thái đích.',
            validation_transition_unknown_status: 'Chuyển tiếp này tham chiếu đến một trạng thái không có bước nào định nghĩa.',
            validation_sla_positive: 'Số giờ SLA phải lớn hơn không. Để trống nếu không có SLA.',
            validation_threshold_percent_range: 'Ngưỡng phải nằm trong khoảng từ 0 đến 100.',
            validation_blocked_hours_positive: 'Số giờ bị chặn phải lớn hơn không.',
            warning_no_terminal_step: 'Không có bước kết thúc. Kích hoạt sẽ thất bại cho đến khi một bước được đánh dấu là kết thúc.',
            warning_step_no_outgoing: 'Các bước không kết thúc mà không có chuyển tiếp đi ra: {statuses}',
            warning_unreachable_steps: 'Các bước không thể tiếp cận từ bước đầu tiên: {statuses}',
            orphaned_transitions_warning: '{count} chuyển tiếp tham chiếu đến một bước đã xóa.',
            remove_orphaned_transitions: 'Xóa các chuyển tiếp mồ côi',
            transitions_renamed_announcement: '{count} chuyển tiếp đã cập nhật theo giá trị trạng thái mới.',
            add_checklist_item: 'Thêm mục danh sách kiểm tra',
            checklist_item_label: 'Mục danh sách kiểm tra',
        },
        columns: {
            priority: 'Mức ưu tiên',
            title: 'Tiêu đề',
            status: 'Trạng thái',
            type: 'Loại',
            assignees: 'Người được giao',
            due_date: 'Ngày hết hạn',
            source: 'Nguồn',
            actions: 'Hành động',
        },
        groups: {
            overdue: 'Quá hạn',
            due_today: 'Đến hạn hôm nay',
            due_this_week: 'Đến hạn tuần này',
            due_later: 'Đến hạn sau',
            no_due_date: 'Không có ngày hạn',
            closed: 'Đã hoàn thành hoặc đã hủy',
        },
        board: {
            title: 'Bảng tác vụ',
            drag_hint: 'Kéo tác vụ giữa các cột để thay đổi trạng thái',
            empty_column: 'Không có tác vụ',
            sr_over_column: 'Trên {column}',
            sr_move_cancelled: 'Đã hủy di chuyển',
            sr_dropped: 'Đã thả {title} vào {column}, vị trí {position} trên {total}',
            sr_returned: '{title} returned tổ {column}',
            sr_picked_up: 'Đã nhấc {title}',
            sr_tasks_shown: '{count} tác vụ hiển thị',
            sr_moving: 'Đang di chuyển {title}. Trên {column}. Nhấn Enter để thả, Escape để hủy.',
            keyboard_hint: 'Bàn phím: phím mũi tên để điều hướng, phím cách để nhấc tác vụ, mũi tên trái/phải để chọn cột, Enter để thả, Escape để hủy.',
            sr_moved_to: '{title} đã di chuyển sang {column}',
            invalid_transition: 'Không thể chuyển tác vụ từ {from} sang {to}.',
            terminal_status: 'Tác vụ này ở trạng thái kết thúc và không thể di chuyển.',
            invalid_drop_target: 'Đích thả không hợp lệ',
        },
        team: {
            title: 'Khối lượng công việc nhóm',
            assignee: 'Người được giao',
            active: 'Đang hoạt động',
            overdue: 'Quá hạn',
            blocked: 'Bị chặn',
            completed_7d: 'Hoàn thành (7 ngày)',
            load: 'Tải',
            load_high: 'Cao',
            load_medium: 'Trung bình',
            load_normal: 'Bình thường',
        },
        graph: {
            title: 'Đồ thị phụ thuộc',
            list_view: 'Chế độ danh sách',
            graph_view: 'Chế độ đồ thị',
            zoom_in: 'Phóng to',
            zoom_out: 'Thu nhỏ',
            reset_zoom: 'Đặt lại',
            blocks_label: 'chặn',
            related_label: 'liên quan',
            no_dependencies: 'Không có phụ thuộc để hiển thị.',
        },
        add_dependency_modal: {
            title: 'Thêm phụ thuộc',
            search_placeholder: 'Tìm kiếm nhiệm vụ theo tiêu đề hoặc ID...',
            no_results: 'Không tìm thấy tác vụ.',
            this_blocks: 'Nhiệm vụ này chặn mục đã chọn',
            this_blocked_by: 'Nhiệm vụ này bị chặn bởi mục đã chọn',
            related: 'Liên quan',
            max_dependencies: 'Tối đa 10 phụ thuộc mỗi nhiệm vụ.',
            circular_error: 'Không thể thêm: sẽ tạo phụ thuộc vòng.',
        },
        section_assignments: {
            title: 'Phân công phần',
            assign_section: 'Gán phần',
            section_ref: 'Tham chiếu phần',
            section_label: 'Nhãn phần',
            department_id: 'ID phòng ban',
            department: 'Phòng ban',
            assignee_id: 'ID người được gán',
            assignee: 'Người được gán',
            mandatory: 'Bắt buộc',
            assign: 'Gán',
            no_assignments: 'Chưa có phân công phần',
            status: 'Trạng thái',
            completion: 'Hoàn thành',
            mark_complete: 'Hoàn thành',
            load_failed: 'Không thể tải phân công phần',
            assign_success: 'Phần đã gán thành công',
            assign_failed: 'Không thể gán phần',
            status_updated: 'Trạng thái đã cập nhật',
            status_update_failed: 'Không thể cập nhật trạng thái',
            section_ref_placeholder: 'vd. 3.2',
            status_completed: 'Hoàn thành',
            status_in_progress: 'Đang thực hiện',
            status_pending: 'Chờ xử lý',
            select_department: 'Chọn phòng ban',
            select_assignee: 'Chọn người được gán',
        },
        consolidation: {
            title: 'Tiến độ hợp nhất',
            add_child: 'Thêm tác vụ con',
            child_task_id: 'ID tác vụ con',
            department_id: 'ID phòng ban',
            link: 'Liên kết',
            overall_completion: 'Hoàn thành tổng thể',
            departments_complete: 'Phòng ban hoàn thành',
            overdue: 'Quá hạn',
            ready: 'Sẵn sàng',
            not_ready: 'Chưa sẵn sàng',
            master_status: 'Trạng thái chính',
            department_breakdown: 'Phân tích theo phòng ban',
            department: 'Phòng ban',
            status: 'Trạng thái',
            completion: 'Hoàn thành',
            due_date: 'Ngày đến hạn',
            overdue_flag: 'Quá hạn',
            child_tasks: 'Tác vụ con',
            task: 'Tác vụ',
            load_failed: 'Không thể load consolidation data',
            child_linked: 'Tác vụ con đã liên kết thành công',
            link_failed: 'Không thể link child task',
            // fix-sprint-20260411-D F8 — confirm + semantic toast keys for unlink
            confirm_unlink: 'Bạn có chắc chắn muốn hủy liên kết tác vụ con này không?',
            child_unlinked: 'Đã hủy liên kết tác vụ con',
            unlink_failed: 'Không thể hủy liên kết tác vụ con',
            unlink: 'Hủy liên kết',
            status_completed: 'Hoàn thành',
            status_in_progress: 'Đang thực hiện',
            status_pending: 'Chờ xử lý',
            select_child_task: 'Chọn tác vụ con',
            select_department: 'Chọn phòng ban',
        },
        conflict_detection: {
            title: 'Phát hiện xung đột',
            unresolved: 'chưa giải quyết',
            no_conflicts: 'Không phát hiện xung đột',
            section: 'Phần',
            field: 'Trường',
            dept_a: 'Phòng ban A',
            value_a: 'Giá trị A',
            dept_b: 'Phòng ban B',
            value_b: 'Giá trị B',
            severity: 'Mức độ nghiêm trọng',
            status: 'Trạng thái',
            resolved: 'Đã giải quyết',
            open: 'Mở',
            resolve: 'Giải quyết',
            load_failed: 'Không thể load conflicts',
            resolve_success: 'Xung đột đã giải quyết thành công',
            resolve_failed: 'Không thể giải quyết xung đột',
            severity_critical: 'Nghiêm trọng',
            severity_warning: 'Cảnh báo',
            severity_info: 'Thông tin',
        },
        overdue_columns: {
            days_overdue: 'Số ngày quá hạn',
        },
        regulatory_info: {
            deadline_context: 'Khi tạo công việc liên quan đến DPIA, ngày đến hạn cần phù hợp với thời hạn nộp hồ sơ PDPL: đầu vào từ phòng ban = 10 ngày làm việc (theo vn-pdpl/deadlines.json). Cảnh báo quá hạn sẽ kích hoạt khi vượt quá thời hạn này. Thời hạn phản hồi cơ quan An ninh mạng (48 giờ xem xét pháp lý, 72 giờ chuẩn bị phản hồi) và thời hạn Viễn thông (5 ngày làm việc phản hồi, 2 ngày làm việc phê duyệt pháp lý) cũng được áp dụng.',
            overdue_deadline_context: 'Thời hạn quy định từ dữ liệu gói: đầu vào phòng ban PDPL = 10 ngày làm việc, phản hồi bổ sung = 15 ngày làm việc, nộp lại = 10 ngày làm việc. Thời hạn phản hồi cơ quan An ninh mạng và thời hạn chuẩn bị Viễn thông cũng được thực thi. Các công việc vi phạm SLA được phân biệt trực quan.',
            section_assignment_context: 'Quy trình DPIA đa phòng ban (PDPL-P1): DPO Doanh nghiệp gán các phần hồ sơ cho các phòng ban (ví dụ: Ngân hàng bán lẻ, Nhân sự, Marketing). Mỗi phân công ghi nhận: tham chiếu phần, nhãn phần, phòng ban, người được gán, cờ bắt buộc và tỷ lệ hoàn thành. Chủ dữ liệu phòng ban chỉ thấy các phần được gán cho họ trong Công việc của tôi. Thời hạn đầu vào phòng ban: 10 ngày làm việc (có thể cấu hình theo vn-pdpl/deadlines.json).',
            template_catalog_context: 'Các mẫu quy trình hệ thống bao gồm: nộp DPIA theo PDPL, chứng nhận quản trị hàng năm theo Luật Dữ liệu, ứng phó sự cố An ninh mạng, yêu cầu cơ quan Viễn thông và đăng ký hệ thống AI. Mỗi mẫu bao gồm step_count, sla_summary và task_types phù hợp với dữ liệu thủ tục gói. Các mẫu hệ thống (is_system = true) không thể chỉnh sửa để bảo toàn tính toàn vẹn quy trình pháp lý.',
            workflow_instantiation_context: 'Các mẫu quy trình đã cài đặt có thể được khởi tạo thành quy trình trực tiếp từ trang này. Khi khởi tạo, các công việc được tạo tự động với ngày đến hạn tính từ SLA quy trình và ngày hiện tại. Quy trình hoạt động thực thi chuyển đổi trạng thái từng bước qua bảng công việc.',
        },
        overdue: {
            days_overdue: 'Số ngày quá hạn',
        },
    },
    notifications: {
        bell: {
            title: 'Thông báo',
            unread_count: 'chưa đọc',
        },
        drawer: {
            title: 'Thông báo',
            mark_all_read: 'Đánh dấu tất cả đã đọc',
            no_notifications: 'Không có thông báo',
            filter: {
                all: 'Tất cả',
                unread: 'Chưa đọc',
                tasks: 'Công việc',
                approvals: 'Phê duyệt',
                alerts: 'Cảnh báo',
            },
        },
        preferences: {
            title: 'Tùy chọn thông báo',
            description: 'Cấu hình cách bạn nhận thông báo',
            category: {
                label: 'Danh mục',
                task_assigned: 'Công việc được giao',
                task_sla_approaching: 'Sắp hết hạn SLA',
                task_overdue: 'Công việc quá hạn',
                task_completed: 'Công việc hoàn thành',
                task_escalated: 'Công việc leo thang',
                workflow_transition: 'Chuyển đổi quy trình',
                approval_requested: 'Yêu cầu phê duyệt',
                comment_added: 'Bình luận mới',
                weekly_digest: 'Tóm tắt tuần',
                sla_breach_report: 'Báo cáo vi phạm SLA',
                system_alert: 'Cảnh báo hệ thống',
                rights_request_received: 'Yêu cầu thực hiện quyền mới',
                acknowledgment_reminder: 'Nhắc nhở xác nhận tài liệu',
                approval_expired: 'Đề nghị phê duyệt đã hết hạn',
                scheduled_export_delivered: 'Đã gửi bản xuất theo lịch',
                cross_border_transfer_added: 'Đã thêm chuyển dữ liệu cá nhân xuyên biên giới',
            },
            channel: {
                platform: 'Nền tảng',
                email: 'Email',
            },
            quiet_hours: {
                title: 'Giờ yên tĩnh',
                start: 'Bắt đầu',
                end: 'Kết thúc',
                timezone: 'Múi giờ',
            },
            digest: {
                title: 'Tần suất tóm tắt',
                daily: 'Hàng ngày',
                weekly: 'Hàng tuần',
                none: 'Không',
            },
            watched: {
                title: 'Thực thể theo dõi',
                empty: 'Không có thực thể theo dõi',
            },
            save: 'Lưu tùy chọn',
            saving: 'Đang lưu...',
            saved_success: 'Đã lưu tùy chọn thành công',
            load_error: 'Không thể tải tùy chọn đã lưu. Hiển thị mặc định \u2014 thay đổi sẽ được lưu khi bạn nhấn Lưu.',
            enabled: 'Đã bật',
            disabled: 'Đã tắt',
            unwatch: 'Bỏ theo dõi',
            announce_loaded: 'Đã tải tùy chọn thông báo',
            save_error: 'Không thể lưu tùy chọn thông báo. Các thay đổi vẫn còn trên trang; hãy thử lưu lại.',
        },
        admin_queue: {
            title: 'Hàng đợi quản trị thông báo',
            description: 'Theo dõi trạng thái gửi email và thử lại các tin nhắn thất bại',
            load_error: 'Không thể tải dữ liệu hàng đợi email',
            retry_error: 'Không thể thử lại email',
            filter_status: 'Lọc theo trạng thái',
            all_statuses: 'Tất cả',
            refresh: 'Làm mới',
            status_queued: 'Đang chờ',
            status_sent: 'Đã gửi',
            status_failed: 'Thất bại',
            status_bounced: 'Bị trả lại',
            status_sending: 'Đang gửi',
            col_recipient: 'Người nhận',
            col_category: 'Danh mục',
            col_template: 'Mẫu',
            col_status: 'Trạng thái',
            col_retries: 'Số lần thử lại',
            col_created: 'Ngày tạo',
            col_sent: 'Ngày gửi',
            col_actions: 'Hành động',
            no_items: 'Không tìm thấy mục nào trong hàng đợi email',
            retry: 'Thử lại',
            retrying: 'Đang thử lại...',
            prev: 'Trước',
            next: 'Tiếp',
            access_denied_title: 'Yêu cầu quyền quản trị',
            access_denied: 'Trang này chỉ dành cho quản trị viên. Vui lòng liên hệ quản trị viên nếu bạn cần quyền truy cập.',
            announce_queue_loaded: 'Đã tải hàng đợi email, {count} mục',
            announce_processed: 'Đã xử lý {count} email',
            process_now: 'Xử lý ngay',
            processing_ellipsis: 'Đang xử lý…',
        },
    },
    ui_assist: {
        toolbar: {
            title: 'Trợ lý UI',
            activate: 'Kích hoạt',
            deactivate: 'Hủy kích hoạt',
            connected: 'Đã kết nối',
            disconnected: 'Mất kết nối',
            disconnected_hint: 'Mất kết nối — chạy `npm run relay` để kết nối với Claude CLI',
            open_panel: 'Mở bảng Trợ lý UI',
            history: 'Lịch sử',
            settings: 'Cài đặt',
        },
        prompt: {
            placeholder: 'Mô tả thay đổi bạn muốn thực hiện…',
            send: 'Gửi',
            cancel: 'Hủy',
            char_count: '{count} / {max}',
        },
        session: {
            streaming: 'Đang xử lý…',
            complete: 'Hoàn tất',
            error: 'Lỗi',
            abort: 'Hủy bỏ',
            abort_confirm: 'Bạn có chắc muốn hủy bỏ?',
            aborted_hint: 'Phiên đã bị gián đoạn — bạn có thể tiếp tục từ đây.',
            undo: 'Hoàn tác',
            redo: 'Làm lại',
            retry: 'Thử lại',
            dismiss: 'Bỏ qua',
        },
        label: {
            component: 'Thành phần',
            element: 'Phần tử',
            file: 'Tệp',
        },
        response: {
            you: 'Bạn',
            claude: 'Claude',
            empty: 'Chưa có tin nhắn. Chọn phần tử và gửi yêu cầu để bắt đầu.',
        },
        panel: {
            tab_conversation: 'Trò chuyện',
            tab_tasks: 'Công việc',
            tab_sprint: 'Sprint',
            tab_sessions: 'Phiên',
            tab_lobby: 'Sảnh',
            follow_up: 'Theo dõi',
            followup_placeholder: 'Đặt câu hỏi tiếp theo…',
            interrupt_placeholder: 'Nhập để ngắt và chuyển hướng…',
            send_interrupt: 'Gửi & Ngắt',
            will_interrupt: 'Sẽ hủy phản hồi hiện tại và gửi tin nhắn này thay thế',
            expand: 'Mở rộng toàn màn hình',
            collapse: 'Thu gọn về bảng bên',
            no_sessions: 'Chưa có phiên nào. Chọn các phần tử và gửi yêu cầu để bắt đầu.',
            session_active: 'Đang hoạt động',
            session_ended: 'Đã kết thúc',
            session_messages: '{count} tin nhắn',
            switch_session: 'Chuyển sang phiên này',
            load_session: 'Tải lịch sử phiên',
            session_restored: 'Phiên đã khôi phục từ lịch sử',
            archive_session: 'Lưu trữ phiên',
            archive_confirm: 'Lưu trữ phiên này? Tệp phiên sẽ bị xóa.',
            new_session: 'Phiên mới',
            new_session_desc: 'Dùng Kích hoạt để chọn phần tử UI và bắt đầu phiên mới',
            start_new_session: 'Bắt đầu phiên mới',
            no_active_session_chat: 'Bắt đầu phiên mới hoặc dùng Kích hoạt để chọn phần tử UI trên trang để bắt đầu.',
            no_active_session_tasks: 'Bắt đầu phiên mới hoặc chọn phiên hiện có để tạo công việc.',
            no_active_session_sprint: 'Bắt đầu phiên mới hoặc chọn phiên hiện có để lập kế hoạch sprint.',
            previous_sessions: 'Phiên trước',
        },
        tasks: {
            none_found: 'Không tìm thấy công việc trong phản hồi. Yêu cầu Claude đề xuất công việc.',
            selected: 'đã chọn',
            create_selected: 'Tạo nhiệm vụ',
            execute_tasks: 'Thực thi công việc',
            creating: 'Đang tạo…',
            created: 'nhiệm vụ đã tạo',
            create_error: 'Không thể tạo công việc',
            plan_sprint: 'Lập kế hoạch sprint',
            priority_critical_desc: 'Chặn — phải sửa ngay',
            priority_high_desc: 'Quan trọng — giải quyết trong sprint này',
            priority_medium_desc: 'Bình thường — lên kế hoạch cho sprint tiếp',
            priority_low_desc: 'Tùy chọn — ứng viên backlog',
            add_custom: 'Thêm công việc',
            add_title_placeholder: 'Tiêu đề công việc…',
            add_desc_placeholder: 'Mô tả (không bắt buộc)',
            add_save: 'Thêm',
            add_cancel: 'Hủy',
        },
        sprint: {
            title: 'Công cụ lập kế hoạch sprint',
            assigned: 'đã giao',
            new_placeholder: 'Tên sprint (VD: Sprint 18.1.0)',
            add: 'Thêm',
            backlog: 'Danh sách chờ',
            move_to: 'Chuyển đến…',
            empty: 'Tạo nhóm sprint và giao công việc vào đó.',
            create_all: 'Tạo tất cả nhiệm vụ',
            remove: 'Xóa',
            drop_here: 'Giao công việc từ danh sách chờ bên dưới',
            add_task: 'Thêm công việc từ danh sách chờ…',
        },
        feature_disabled: 'Trợ lý UI chưa được bật',
        permission_denied: 'Bạn không có quyền sử dụng Trợ lý UI',
    },
    license: {
        title: 'Giấy phép & Gói',
        current_license: 'Giấy phép hiện tại',
        license_key: 'Khóa giấy phép',
        activate: 'Kích hoạt giấy phép',
        deactivate: 'Hủy kích hoạt giấy phép',
        validate_now: 'Xác thực ngay',
        status: 'Trạng thái giấy phép',
        active: 'Đang hoạt động',
        expired: 'Hết hạn',
        suspended: 'Tạm ngừng',
        invalid: 'Không hợp lệ',
        pending: 'Chờ xử lý',
        no_license: 'Không có giấy phép',
        expires_at: 'Hết hạn',
        last_validated: 'Xác thực lần cuối',
        domain: 'Tên miền được cấp phép',
        activation_success: 'Kích hoạt giấy phép thành công.',
        activation_failed: 'Kích hoạt giấy phép thất bại.',
        deactivation_success: 'Đã hủy kích hoạt giấy phép.',
        validation_success: 'Xác thực giấy phép thành công.',
        validation_failed: 'Xác thực giấy phép thất bại.',
        enter_key: 'Nhập khóa giấy phép của bạn',
        domain_mismatch: 'Tên miền giấy phép không khớp với tên miền hiện tại.',
        confirm_deactivate: 'Bạn có chắc chắn muốn hủy kích hoạt giấy phép này? Các hạn chế phân hệ sẽ được áp dụng dựa trên gói mặc định.',
        announce_loaded: 'Đã tải cài đặt giấy phép',
        verification_stale: 'Giấy phép này chưa được xác thực với dịch vụ giấy phép trong hơn {days} ngày, nên được coi là chưa xác thực. Giấy phép được coi là hợp lệ trở lại khi một lần xác thực lại thành công.',
        scope_installation: 'Giấy phép và gói của giấy phép áp dụng cho toàn bộ bản cài đặt: mọi tổ chức trên bản cài đặt này. Chỉ quản trị viên nền tảng mới có thể kích hoạt, hủy kích hoạt hoặc thay đổi chúng.',
    },
    package_mgmt: {
        title: 'Gói',
        module_column: 'Phân hệ',
        current_tier: 'Gói hiện tại',
        light: 'Cơ bản',
        standard: 'Tiêu chuẩn',
        enterprise_unlimited: 'Doanh nghiệp không giới hạn',
        change_package: 'Thay đổi gói',
        upgrade: 'Nâng cấp',
        downgrade: 'Hạ cấp',
        target_tier: 'Gói mục tiêu',
        new_license_key: 'Khóa giấy phép cho gói mục tiêu',
        confirm_change: 'Xác nhận thay đổi gói',
        change_success: 'Thay đổi gói thành công.',
        change_failed: 'Thay đổi gói thất bại.',
        modules_included: 'Phân hệ bao gồm',
        modules_restricted: 'Không có sẵn trong gói hiện tại',
        upgrade_to_enable: 'Nâng cấp để kích hoạt phân hệ này.',
        module_availability: 'Khả dụng phân hệ',
        comparison: 'So sánh gói',
        power_users: 'Người dùng nâng cao',
        unlimited: 'Không giới hạn',
        impact_warning: 'Hạ cấp sẽ vô hiệu hóa các phân hệ sau:',
        invalid_license: 'Khóa giấy phép được cung cấp không hợp lệ cho gói này.',
        tier_mismatch: 'Khóa giấy phép dành cho một gói khác.',
    },
    board_report: {
        title: 'Báo cáo Tuân thủ cho Ban Giám đốc',
        subtitle: 'Tóm tắt tuân thủ điều hành trên tất cả các phân hệ',
        date_from: 'Từ ngày',
        date_to: 'Đến ngày',
        language: 'Ngôn ngữ báo cáo',
        generate: 'Tạo báo cáo',
        generating: 'Đang tạo báo cáo...',
        generate_requires_export: 'Việc tạo báo cáo cần quyền xuất báo cáo quản trị. Hãy đề nghị quản trị viên cấp quyền này.',
        download_pdf: 'Tải xuống PDF',
        close: 'Đóng báo cáo',
        open_board_report: 'Tạo Báo cáo Ban Giám đốc',
        close_board_report: 'Đóng Báo cáo Ban Giám đốc',
        report_period: 'Kỳ báo cáo',
        generated_at: 'Tạo lúc',
        generated_by: 'Tạo bởi',
        organization: 'Tổ chức',
        section_rights_requests: 'Yêu cầu quyền',
        section_vendors: 'Nhà cung cấp',
        section_dpias: 'ĐGTĐ',
        section_consent: 'Chính sách đồng ý',
        section_data_mapping: 'Bản đồ dữ liệu',
        section_incidents: 'Sự cố',
        section_classification: 'Phân loại dữ liệu',
        section_governance: 'Quản trị',
        open: 'Mở',
        closed: 'Đã đóng',
        sla_compliance: 'Tuân thủ SLA',
        total: 'Tổng',
        expired_dpa: 'DPA hết hạn',
        high_risk: 'Rủi ro cao',
        completed: 'Hoàn thành',
        overdue: 'Quá hạn',
        policies_active: 'Chính sách đang hoạt động',
        coverage: 'Phạm vi',
        systems: 'Hệ thống',
        completeness: 'Hoàn thiện',
        avg_resolution_days: 'TB giải quyết (ngày)',
        labeled: 'Đã gán nhãn',
        unlabeled_systems: 'Hệ thống chưa gán nhãn',
        compliance_score: 'Điểm tuân thủ',
        drift_events_open: 'Sự kiện lệch mở',
        no_data: 'Không có dữ liệu cho khoảng thời gian đã chọn.',
        error_date_range: 'Vui lòng chọn cả ngày bắt đầu và kết thúc.',
        table_category: 'Danh mục',
        table_metric: 'Chỉ số',
        table_value: 'Giá trị',
        showing_chart_view: 'Đang hiển thị chế độ biểu đồ',
        showing_table_view: 'Đang hiển thị chế độ bảng dữ liệu',
        error_generate: 'Không thể tạo báo cáo ban giám đốc.',
        playbook_evidence_title: 'Bằng chứng thực thi playbook',
        playbook_evidence_description: 'Hoạt động thực thi theo từng playbook và các tệp bằng chứng đính kèm cho giai đoạn báo cáo.',
        playbook_name: 'Playbook',
        playbook_execution_count: 'Số lần thực thi',
        playbook_steps_total: 'Số bước',
        playbook_steps_required: 'Yêu cầu bằng chứng',
        playbook_steps_attached: 'Bằng chứng đã đính kèm',
        playbook_coverage_pct: 'Độ bao phủ',
        playbook_evidence_files: 'Tệp bằng chứng',
        playbook_no_evidence: 'Không có lần thực thi playbook nào trong giai đoạn này.',
        playbook_download_file: 'Tải xuống tệp',
    },
    framework_module_links: {
        title: 'Liên kết Khung tuân thủ',
        modules: 'Phân hệ Đã liên kết',
        add_module: 'Thêm phân hệ',
        module_code: 'Mã phân hệ',
        required: 'Bắt buộc',
        notes: 'Ghi chú',
        link: 'Liên kết',
        no_modules: 'Không có phân hệ nào được liên kết',
        personas: 'Chân dung Đã liên kết',
        add_persona: 'Thêm Chân dung',
        persona_id: 'ID Chân dung',
        role_description: 'Mô tả Vai trò',
        no_personas: 'Không có chân dung nào được liên kết',
    },
    framework_channels: {
        title: 'Kênh Nộp hồ sơ & Thời hạn',
        channels: 'Kênh Nộp hồ sơ',
        add_channel: 'Thêm Kênh',
        channel_type: 'Loại',
        name: 'Tên',
        instructions: 'Hướng dẫn',
        active: 'Đang hoạt động',
        no_channels: 'Chưa cấu hình kênh nộp hồ sơ',
        portal: 'Cổng thông tin',
        in_person: 'Trực tiếp',
        postal: 'Bưu điện',
        email: 'Email',
        add: 'Thêm',
        deadlines: 'Thời hạn Quy định',
        add_deadline: 'Thêm Thời hạn',
        label: 'Nhãn',
        days: 'Ngày',
        day_type: 'Loại Ngày',
        calendar_days: 'Ngày lịch',
        working_days: 'Ngày làm việc',
        description: 'Mô tả',
        no_deadlines: 'Chưa cấu hình thời hạn',
    },
    regulatory_updates: {
        title: 'Cập nhật Quy định & Bảng điều khiển Khung tuân thủ',
        coverage_dashboard: 'Bảng điều khiển Phạm vi Khung tuân thủ',
        no_frameworks: 'Không tìm thấy khung tuân thủ',
        framework: 'Khung tuân thủ',
        status: 'Trạng thái',
        modules: 'Phân hệ',
        templates: 'Mẫu',
        forms: 'Biểu mẫu',
        channels: 'Kênh',
        deadlines: 'Thời hạn',
        pending: 'Cập nhật Đang chờ',
        updates: 'Cập nhật Quy định',
        create_update: 'Tạo Cập nhật',
        framework_id: 'ID Khung tuân thủ',
        update_title: 'Tiêu đề',
        description: 'Mô tả',
        effective_date: 'Ngày Hiệu lực',
        create: 'Tạo',
        no_updates: 'Không có cập nhật quy định',
        impact: 'Tác động',
        assess: 'Đánh giá',
    },
    module_tips: viModuleTips,
    framework_rights: {
        be_informed: 'Quyền được thông báo',
        consent: 'Quyền đồng ý',
        refuse_consent: 'Quyền từ chối đồng ý',
        withdraw_consent: 'Quyền rút lại sự đồng ý',
        access: 'Quyền truy cập',
        rectification: 'Quyền chỉnh sửa',
        data_provision: 'Quyền yêu cầu cung cấp dữ liệu',
        deletion: 'Quyền xóa dữ liệu',
        restriction_of_processing: 'Quyền hạn chế xử lý',
        object_to_processing: 'Quyền phản đối xử lý',
        complaint: 'Quyền khiếu nại',
        denunciation: 'Quyền tố cáo',
        lawsuit: 'Quyền khởi kiện',
        claim_damages: 'Quyền yêu cầu bồi thường thiệt hại',
        request_protection_measures: 'Quyền yêu cầu biện pháp bảo vệ',
    },
    // ---------- Nội dung khung tuân thủ i18n (Sprint 30.1.0) ----------
    framework_content: {
        EU_EPRIVACY_DIRECTIVE: {
            display_name: 'Chỉ thị 2002/58/EC (Chỉ thị ePrivacy)',
            description: 'Chỉ thị gốc cho việc chuyển đổi ePrivacy quốc gia. Bao gồm cookie, quyền riêng tư trong truyền thông điện tử, tiếp thị trực tiếp. Mỗi quốc gia thành viên phải chuyển đổi thành luật quốc gia.',
        },
        EU_GDPR: {
            display_name: 'Quy định Bảo vệ Dữ liệu Chung (EU) 2016/679',
            description: 'Quy định Bảo vệ Dữ liệu Chung (GDPR) là quy định của EU về bảo vệ dữ liệu và quyền riêng tư. Quy định này được áp dụng trực tiếp tại tất cả các quốc gia thành viên EU/EEA.',
        },
        EU_NIS2_DIRECTIVE: {
            display_name: 'Chỉ thị (EU) 2022/2555 (NIS2)',
            description: 'Chỉ thị gốc cho việc chuyển đổi NIS2 quốc gia. Bao gồm quản lý rủi ro an ninh mạng, báo cáo sự cố, an ninh chuỗi cung ứng cho các thực thể thiết yếu và quan trọng.',
        },
        VN_AI_LAW_2026: {
            display_name: 'Luật Trí tuệ nhân tạo Việt Nam (134/2025/QH15) — Có hiệu lực 01/03/2026',
            description: 'Luật Trí tuệ nhân tạo Việt Nam (134/2025/QH15) điều chỉnh việc phát triển, triển khai và sử dụng các hệ thống trí tuệ nhân tạo. Thiết lập phân loại rủi ro, nghĩa vụ minh bạch và ghi nhãn, yêu cầu báo cáo sự cố, nghĩa vụ đánh giá tác động, và cơ chế thử nghiệm có kiểm soát (sandbox) cho các hoạt động trí tuệ nhân tạo tại Việt Nam.',
        },
        VN_AI_DECREE_142_2026: {
            display_name: 'Nghị định 142/2026/NĐ-CP — Hướng dẫn thi hành Luật Trí tuệ nhân tạo',
            description: 'Nghị định số 142/2026/NĐ-CP quy định chi tiết một số điều và biện pháp thi hành Luật Trí tuệ nhân tạo (Luật 134/2025/QH15). Ban hành 2026-04-30, có hiệu lực 2026-05-01. Cơ quan chủ trì: Bộ Khoa học và Công nghệ. Vận hành phân loại rủi ro hệ thống AI, hồ sơ phân loại, đánh giá lại phân loại, đánh giá sự phù hợp AI rủi ro cao, hệ thống quản lý rủi ro AI rủi ro cao, minh bạch / giải thích / dấu kỹ thuật / nhãn nhìn thấy, báo cáo sự cố AI nghiêm trọng (72 giờ / 5 ngày làm việc / 15 ngày), đánh giá tác động AI cơ quan nhà nước (Mẫu AI02) và quy trình thử nghiệm có kiểm soát / hộp cát AI (Mẫu AI03a-AI09b). Nộp qua Cổng AI một cửa hoặc kênh chuyển tiếp của Bộ Khoa học và Công nghệ. Không có hình phạt tiền.',
        },
        VN_CYBERSEC_LAW: {
            display_name: 'Luật An ninh mạng Việt Nam (giai đoạn 24/2018)',
            description: 'Luật An ninh mạng Việt Nam (Luật số 24/2018/QH14) thiết lập các yêu cầu về an ninh mạng, lưu trữ dữ liệu trong nước, và báo cáo sự cố. Có hiệu lực cho đến khi được thay thế bởi Luật 116/2025/QH15 có hiệu lực từ 01/07/2026.',
        },
        VN_CYBERSEC_DECREE_53: {
            display_name: 'Nghị định 53 — Hướng dẫn thi hành Luật An ninh mạng',
            description: 'Nghị định 53/2022/NĐ-CP hướng dẫn thi hành Luật An ninh mạng, bao gồm xác định đối tượng thuộc phạm vi điều chỉnh, điều kiện lưu trữ dữ liệu trong nước, yêu cầu đặt văn phòng đại diện, và quy trình phối hợp với cơ quan chức năng.',
        },
        VN_CYBERSEC_LAW_2025: {
            display_name: 'Luật An ninh mạng (116/2025/QH15)',
            description: 'Luật An ninh mạng hợp nhất của Việt Nam (Luật 116/2025/QH15), thay thế Luật 24/2018/QH14, có hiệu lực từ ngày 01/07/2026. Hợp nhất phạm vi của Nghị định 53/2022/NĐ-CP (xem VN_CYBERSEC_DECREE_53).',
        },
        VN_DATA_LAW: {
            display_name: 'Luật Dữ liệu Việt Nam',
            description: 'Luật Dữ liệu Việt Nam (Luật 60/2024/QH15) thiết lập các yêu cầu quản trị dữ liệu toàn diện bao gồm kiểm kê dữ liệu, phân loại, quản trị chia sẻ dữ liệu, và quản trị chuyển dữ liệu xuyên biên giới. Có sự giao thoa với VN_PDPL_LAW_2025 (khía cạnh dữ liệu cá nhân) và VN_CYBERSEC_LAW_2025 (lưu trữ/phân loại dữ liệu trong nước).',
        },
        VN_DATA_LAW_DECREE_165_2025: {
            display_name: 'Nghị định 165/2025/NĐ-CP (Hướng dẫn thi hành Luật Dữ liệu)',
            description: 'Nghị định 165/2025/NĐ-CP hướng dẫn thi hành Luật Dữ liệu Việt Nam (Luật 60/2024/QH15). Cung cấp các biểu mẫu chính thức cho đánh giá tác động chuyển dữ liệu xuyên biên giới, báo cáo đánh giá rủi ro hằng năm, và truy cập cơ sở dữ liệu quốc gia. Quy định 11 Mẫu số chính thức.',
        },
        VN_DATA_EXCHANGES_DRAFT_2026: {
            display_name: 'Dự thảo Nghị định về Sàn dữ liệu 2026',
            description: 'Dự thảo Nghị định quy định về hoạt động của sàn dữ liệu. Quy định về phân loại nền tảng, điều kiện tham gia, kiểm soát niêm yết sản phẩm và dịch vụ dữ liệu, thử nghiệm môi trường cách ly (sandbox), quy trình giao dịch, hợp đồng điện tử, giấy chứng nhận quyền sở hữu đối với dữ liệu, và xử lý khiếu nại/tranh chấp. Hiện đang trong giai đoạn lấy ý kiến công khai; chưa được ban hành. Căn cứ Luật Dữ liệu 60/2024/QH15, Luật Bảo vệ dữ liệu cá nhân 91/2025/QH15, Luật An ninh mạng 116/2025/QH15, và Luật Giao dịch điện tử 20/2023/QH15.',
        },
        VN_ECOMMERCE_LAW_2025: {
            display_name: 'Luật Thương mại điện tử (122/2025/QH15)',
            description: 'Luật Thương mại điện tử Việt Nam (122/2025/QH15) thiết lập chế độ quốc gia thống nhất về thương mại điện tử, bao gồm hoạt động nền tảng trong nước và xuyên biên giới, quản trị và trách nhiệm giải trình của nền tảng, bảo vệ người tiêu dùng, kiểm soát người bán và tiếp thị liên kết, xử lý khiếu nại, kiểm duyệt nội dung và thực thi gỡ bỏ, và sẵn sàng thủ tục hành chính cho hệ thống quản lý thương mại điện tử quốc gia.',
        },
        VN_PDPD_DECREE_13: {
            display_name: 'Nghị định 13/2023/NĐ-CP về bảo vệ dữ liệu cá nhân (2023–2025)',
            description: 'Nghị định 13/2023/NĐ-CP, văn bản hướng dẫn vận hành các nghĩa vụ bảo vệ dữ liệu cá nhân bao gồm nộp hồ sơ, tài liệu quản trị, cơ chế chuyển dữ liệu xuyên biên giới, và thủ tục hành chính của Bộ Công an. Hết hiệu lực từ ngày 01/01/2026 theo khoản 2 Điều 42 Nghị định 356/2025/NĐ-CP; Luật 91/2025/QH15 hiện điều chỉnh việc bảo vệ dữ liệu cá nhân.',
        },
        VN_PDPL_LAW_2025: {
            display_name: 'Luật Bảo vệ Dữ liệu Cá nhân (91/2025/QH15)',
            description: 'Luật Bảo vệ Dữ liệu Cá nhân Việt Nam (Luật 91/2025/QH15) thiết lập khung bảo vệ dữ liệu cá nhân toàn diện, có hiệu lực từ ngày 01/01/2026. Bao gồm các chủ đề tuân thủ A–J: cơ sở pháp lý xử lý dữ liệu, đồng ý xử lý dữ liệu nhạy cảm, quyền của chủ thể dữ liệu (truy cập/chỉnh sửa/xóa/hạn chế/phản đối/chuyển giao), thông báo vi phạm cho cơ quan chức năng và chủ thể dữ liệu, DPIA cho xử lý rủi ro cao, quản trị chuyển dữ liệu xuyên biên giới, chỉ định DPO, hồ sơ hoạt động xử lý, nghĩa vụ hợp đồng của bên xử lý. Nghĩa vụ nộp hồ sơ cho cơ quan chức năng qua MoPS (VN_PDPL_ADMIN_PROCEDURES_778_2026). Tham chiếu chéo: VN_PDPL_DECREE_356_2025 (nghị định hướng dẫn), VN_CYBERSEC_LAW_2025 (giao thoa an ninh mạng), VN_DATA_LAW (quản trị dữ liệu).',
        },
        VN_PDPL_DECREE_356_2025: {
            display_name: 'Nghị định 356/2025/NĐ-CP (Hướng dẫn thi hành Luật Bảo vệ Dữ liệu Cá nhân)',
            description: 'Nghị định 356/2025/NĐ-CP hướng dẫn thi hành Luật Bảo vệ Dữ liệu Cá nhân (Luật số 91/2025/QH15). Bao gồm nộp hồ sơ, tài liệu quản trị, cơ chế chuyển dữ liệu xuyên biên giới, và chứng nhận nhà cung cấp dịch vụ. Danh mục biểu mẫu phụ lục: Phụ lục I–VIII (đánh giá tác động, chuyển dữ liệu xuyên biên giới, chứng nhận). Thủ tục hành chính qua MoPS theo VN_PDPL_ADMIN_PROCEDURES_778_2026 (Quyết định 778/QĐ-BCA-A05). Quy trình chứng nhận: nộp đơn → cấp → yêu cầu thay đổi → cấp lại → thu hồi. Tham chiếu chéo: VN_PDPL_LAW_2025 (luật gốc), VN_CYBERSEC_LAW_2025 (lưu trữ dữ liệu trong nước), VN_DATA_LAW (giao thoa quản trị dữ liệu).',
        },
        VN_PDPL_ADMIN_PROCEDURES_778_2026: {
            display_name: 'Thủ tục hành chính A05 Bộ Công an (Quyết định 778/QĐ-BCA-A05)',
            description: 'Quyết định 778/QĐ-BCA-A05 (tháng 02/2026) — Thủ tục hành chính về bảo vệ dữ liệu cá nhân thuộc Cục A05 (Bộ Công an). Quy định thủ tục nộp hồ sơ, xử lý, và trả kết quả bao gồm các biểu mẫu DLCN-HC và Mẫu số theo quy định.',
        },
        VN_PDPL_ENFORCEMENT_DRAFT_2026: {
            display_name: 'Dự thảo Nghị định Xử phạt An ninh mạng + PDPL 2026',
            description: 'Dự thảo nghị định xử phạt 116 trang hợp nhất chế tài đối với vi phạm Luật Bảo vệ Dữ liệu Cá nhân (91/2025/QH15) VÀ Luật An ninh mạng (116/2025/QH15). Mã chuẩn VN_CYBER_PDPL_ENFORCEMENT_DRAFT_2026; mã cũ VN_PDPL_ENFORCEMENT_DRAFT_2026 được giữ làm alias. Chỉ là lớp phủ thực thi dự thảo — các mức phạt KHÔNG được trình bày là pháp luật cuối cùng cho đến khi ban hành.',
        },
        VN_MOPS_ADMIN_SIMPLIFICATION_NQ22_2026: {
            display_name: 'Nghị quyết NQ22/2026 — Đơn giản hóa Thủ tục Hành chính của Bộ Công an (Lớp phủ Tạm thời)',
            description: 'Lớp phủ thủ tục tạm thời (có hiệu lực 2026-04-29, hết hạn 2027-03-01) giới thiệu ba kênh chính thức (Cổng dịch vụ công quốc gia, nộp trực tiếp tại Bộ Công an, nộp qua bưu điện đến Bộ Công an) cho nộp hồ sơ Nghị định 356/2025 PDPL và Quyết định 778/2026. Email KHÔNG phải là kênh chính thức của NQ22 — một hướng dẫn nộp ZIP qua email không chính thức riêng (VN_PDPL_GUIDANCE_EMAIL_ZIP_DOSSIER_SUBMISSION_2026) được vận chuyển với requires_legal_review: true. Chỉ là lớp phủ thủ tục — KHÔNG thay đổi các nghĩa vụ thực chất, các khoảng phạt hoặc hiệu lực ràng buộc của các khung cơ sở. Nhiệm vụ rà soát được lên lịch 2027-02-01.',
        },
        VN_TELECOM_LAW_2023: {
            display_name: 'Luật Viễn thông Việt Nam 2023',
            description: 'Luật Viễn thông Việt Nam 2023 (Luật Viễn thông), là lớp phủ ngành cho các doanh nghiệp viễn thông/ISP/nền tảng với các nghĩa vụ về bảo mật thông tin, kiểm soát tiết lộ, và xử lý yêu cầu từ cơ quan chức năng. Tham chiếu chéo: VN_CYBERSEC_LAW_2025 (an ninh hệ thống thông tin), VN_PDPL_LAW_2025 (xử lý dữ liệu người dùng), VN_DATA_LAW (quản trị dữ liệu).',
        },
        VN_TELECOM_DECREE_163_2024: {
            display_name: 'Nghị định 163/2024/NĐ-CP (Hướng dẫn thi hành Luật Viễn thông)',
            description: 'Nghị định 163/2024/NĐ-CP hướng dẫn thi hành Luật Viễn thông (Luật 24/2023/QH15). Cung cấp các biểu mẫu chính thức cho thông báo cung cấp dịch vụ viễn thông, cấp phép, đăng ký, và kế hoạch phát triển trung tâm dữ liệu. Quy định 7 Mẫu số chính thức.',
        },
    },
    framework_requirements: viFrameworkRequirements,
    framework_rights_descriptions: {
        be_informed: 'Chủ thể dữ liệu có quyền được thông báo về các hoạt động xử lý dữ liệu cá nhân.',
        consent: 'Chủ thể dữ liệu có quyền đồng ý với việc xử lý dữ liệu cá nhân của mình.',
        refuse_consent: 'Chủ thể dữ liệu có quyền không đồng ý với việc xử lý dữ liệu cá nhân của mình.',
        withdraw_consent: 'Chủ thể dữ liệu có quyền yêu cầu rút lại sự đồng ý đã cho trước đó.',
        access: 'Chủ thể dữ liệu có quyền xem và truy cập dữ liệu cá nhân do bên kiểm soát dữ liệu nắm giữ.',
        rectification: 'Chủ thể dữ liệu có quyền chỉnh sửa hoặc yêu cầu chỉnh sửa dữ liệu cá nhân không chính xác.',
        data_provision: 'Chủ thể dữ liệu có quyền yêu cầu cung cấp dữ liệu cá nhân của mình.',
        deletion: 'Chủ thể dữ liệu có quyền yêu cầu xóa hoặc hủy dữ liệu cá nhân, tuân theo các ngoại lệ của pháp luật.',
        restriction_of_processing: 'Chủ thể dữ liệu có quyền yêu cầu hạn chế xử lý dữ liệu cá nhân của mình.',
        object_to_processing: 'Chủ thể dữ liệu có quyền gửi yêu cầu phản đối việc xử lý dữ liệu cá nhân của mình.',
        complaint: 'Chủ thể dữ liệu có quyền khiếu nại về việc xử lý dữ liệu cá nhân.',
        denunciation: 'Chủ thể dữ liệu có quyền tố cáo về các hành vi vi phạm bảo vệ dữ liệu cá nhân.',
        lawsuit: 'Chủ thể dữ liệu có quyền khởi kiện đối với các hành vi vi phạm quyền bảo vệ dữ liệu cá nhân.',
        claim_damages: 'Chủ thể dữ liệu có quyền yêu cầu bồi thường thiệt hại do vi phạm bảo vệ dữ liệu cá nhân gây ra.',
        request_protection_measures: 'Chủ thể dữ liệu có quyền yêu cầu cơ quan có thẩm quyền hoặc tổ chức, cá nhân liên quan thực hiện các biện pháp bảo vệ dữ liệu cá nhân của mình.',
    },
    framework_procedures: {
        VN_DP_DRAFT_P7: {
            name: 'Quản lý rủi ro và giám sát (dự thảo)',
            steps: {
                '1': 'Nhận diện các loại rủi ro',
                '2': 'Duy trì các kiểm soát cảnh báo sớm',
                '3': 'Rà soát rủi ro thu thập, lưu trữ, xử lý, chia sẻ và giao dịch dữ liệu',
                '4': 'Ghi nhận rủi ro về quyền riêng tư, an ninh mạng và quản lý truy cập',
                '5': 'Kích hoạt các hành động khắc phục',
                '6': 'Lưu lại lịch sử rà soát',
            },
        },
        VN_DP_DRAFT_P6: {
            name: 'Khiếu nại và tranh chấp (dự thảo)',
            steps: {
                '1': 'Tiếp nhận khiếu nại / tranh chấp',
                '2': 'Kiểm tra tính đầy đủ của thông tin bắt buộc; yêu cầu bổ sung trong vòng 24 giờ nếu chưa đầy đủ',
                '3': 'Trong vòng 3 ngày làm việc sau khi nhận được yêu cầu đầy đủ, thông báo cho các bên về phương án xử lý và thời hạn dự kiến',
                '4': 'Yêu cầu phản hồi và tài liệu bổ trợ',
                '5': 'Đánh giá tình tiết tranh chấp và trách nhiệm của sàn',
                '6': 'Ghi nhận kết quả giải quyết',
                '7': 'Lưu trữ bằng chứng và đóng vụ việc',
            },
        },
        VN_DP_DRAFT_P5: {
            name: 'Giao hàng và giấy chứng nhận quyền sở hữu đối với dữ liệu (dự thảo)',
            steps: {
                '1': 'Giao sản phẩm/dịch vụ theo phương thức quy định trong hợp đồng',
                '2': 'Ghi nhận sự kiện và thời điểm giao hàng',
                '3': 'Cấp giấy chứng nhận quyền sở hữu đối với dữ liệu',
                '4': 'Đăng ký hoàn tất giao dịch',
                '5': 'Cho phép tra cứu / xác minh sau khi được yêu cầu',
            },
        },
        VN_DP_DRAFT_P4: {
            name: 'Khởi tạo giao dịch và ký kết hợp đồng (dự thảo)',
            steps: {
                '1': 'Rà soát niêm yết và kết quả đánh giá',
                '2': 'Khởi tạo quy trình mua, thương lượng hoặc đấu giá',
                '3': 'Tạo hợp đồng điện tử',
                '4': 'Bảo đảm sự chấp nhận của cả hai bên',
                '5': 'Ghi nhận hoàn tất thanh toán',
                '6': 'Cho phép giao hàng',
            },
        },
        VN_DP_DRAFT_P3: {
            name: 'Truy cập môi trường thử nghiệm (dự thảo)',
            steps: {
                '1': 'Nộp yêu cầu sử dụng môi trường thử nghiệm',
                '2': 'Xác định phạm vi, dữ liệu cho phép, thời gian và quyền xử lý',
                '3': 'Cấp phát môi trường kỹ thuật cách ly',
                '4': 'Giám sát an ninh và truy cập trong quá trình thử nghiệm',
                '5': 'Rà soát kết quả đầu ra trước khi trích xuất',
                '6': 'Chỉ phê duyệt trích xuất khi được phép',
                '7': 'Đóng phiên thử nghiệm và dọn sạch môi trường',
            },
        },
        VN_DP_DRAFT_P2: {
            name: 'Niêm yết sản phẩm / dịch vụ dữ liệu (dự thảo)',
            steps: {
                '1': 'Tạo đơn đăng ký niêm yết',
                '2': 'Thu thập bằng chứng nguồn và quyền sở hữu / quyền sử dụng',
                '3': 'Ghi nhận đặc tính kỹ thuật, định dạng, chi tiết API và các hạn chế',
                '4': 'Ghi nhận công bố chất lượng',
                '5': 'Nộp hồ sơ niêm yết để sàn rà soát',
                '6': 'Sàn dữ liệu kiểm tra tính đầy đủ, hợp pháp và kỹ thuật',
                '7': 'Phê duyệt hoặc từ chối niêm yết',
                '8': 'Nếu được phê duyệt, công bố niêm yết kèm kết quả đánh giá',
            },
        },
        VN_DP_DRAFT_P1: {
            name: 'Tiếp nhận bên tham gia (dự thảo)',
            steps: {
                '1': 'Xác định loại bên tham gia: bên bán hoặc bên mua',
                '2': 'Kiểm tra tư cách pháp lý và năng lực pháp lý',
                '3': 'Kiểm tra điều kiện bổ sung nếu áp dụng ngành nghề kinh doanh có điều kiện',
                '4': 'Đăng ký tài khoản giao dịch',
                '5': 'Liên kết tài khoản thanh toán',
                '6': 'Phê duyệt tham gia sàn dữ liệu',
                '7': 'Lưu trữ hồ sơ bên tham gia và nhật ký kiểm toán',
            },
        },
        AI_A1: {
            name: 'Đăng ký / Thông báo hệ thống AI',
            steps: {
                '1': 'Kiểm tra phạm vi áp dụng và phân loại hệ thống AI',
                '2': 'Lập hồ sơ đăng ký/thông báo',
                '3': 'Phê duyệt nội bộ',
                '4': 'Nộp qua kênh tiếp nhận',
                '5': 'Vòng bổ sung — nếu bị trả lại, cập nhật và nộp lại',
                '6': 'Đóng hồ sơ và lưu trữ xác nhận',
            },
        },
        AI_A2: {
            name: 'Quy trình phân loại rủi ro AI',
            steps: {
                '1': 'Tạo mục trong Sổ đăng ký hệ thống AI',
                '2': 'Chạy trình hướng dẫn phân loại',
                '3': 'Đính kèm bằng chứng',
                '4': 'Phê duyệt phân loại',
                '5': 'Liên kết kết quả đầu ra với hồ sơ hệ thống',
            },
        },
        AI_A3: {
            name: 'Tuân thủ ghi nhãn và công khai',
            steps: {
                '1': 'Xác định nghĩa vụ ghi nhãn theo từng hệ thống và trường hợp sử dụng',
                '2': 'Triển khai các thông báo ghi nhãn',
                '3': 'Thu thập bằng chứng — ảnh chụp màn hình, nội dung giao diện, siêu dữ liệu kỹ thuật',
                '4': 'Xử lý miễn trừ và ghi nhận lý do',
                '5': 'Phê duyệt và đánh phiên bản',
            },
        },
        AI_A4: {
            name: 'Báo cáo sự cố nghiêm trọng',
            steps: {
                '1': 'Tạo Bản ghi sự cố AI',
                '2': 'Phân loại mức độ nghiêm trọng',
                '3': 'Thực hiện các biện pháp ngăn chặn và thu thập bằng chứng',
                '4': 'Tạo mẫu xuất Báo cáo sự cố nghiêm trọng',
                '5': 'Nộp cho cơ quan có thẩm quyền qua kênh tiếp nhận',
                '6': 'Theo dõi phản hồi của cơ quan có thẩm quyền và đóng hồ sơ',
            },
        },
        AI_A5: {
            name: 'Đánh giá tác động AI',
            steps: {
                '1': 'Tạo bản ghi đánh giá',
                '2': 'Điền các phần bắt buộc',
                '3': 'Đính kèm bằng chứng — luồng dữ liệu, tài liệu mô hình, biện pháp kiểm soát',
                '4': 'Phê duyệt nội bộ',
                '5': 'Xuất báo cáo và lưu vào hồ sơ',
            },
        },
        AI_A6: {
            name: 'Tham gia thử nghiệm có kiểm soát / Sandbox',
            steps: {
                '1': 'Hoàn thành bản ghi đủ điều kiện và sẵn sàng',
                '2': 'Chuẩn bị hồ sơ đăng ký và xuất',
                '3': 'Nộp qua kênh tiếp nhận',
                '4': 'Theo dõi phê duyệt',
                '5': 'Thực hiện các mốc giám sát và ghi nhật ký',
                '6': 'Hoàn thành báo cáo kết thúc và gói đóng hồ sơ',
            },
        },
        CYBERSEC_C1: {
            name: 'Đánh giá an ninh hệ thống thông tin trọng yếu',
            steps: {
                '1': 'Phân loại hệ thống thông tin theo yêu cầu an ninh mạng quốc gia',
                '2': 'Tiến hành đánh giá an ninh và đánh giá rủi ro cho các hệ thống đã phân loại',
                '3': 'Triển khai các biện pháp an ninh bắt buộc và kiểm soát cơ sở',
                '4': 'Lập tài liệu bằng chứng tuân thủ và lên lịch rà soát định kỳ',
            },
        },
        CYBERSEC_C2: {
            name: 'Thông báo sự cố an ninh mạng',
            steps: {
                '1': 'Phát hiện, phân loại và đánh giá sự cố an ninh mạng',
                '2': 'Thực hiện các biện pháp ứng phó tức thời và bảo quản bằng chứng',
                '3': 'Báo cáo cho cơ quan có thẩm quyền và tham gia phối hợp ứng phó sự cố quốc gia',
                '4': 'Tiến hành rà soát sau sự cố và lập tài liệu bài học kinh nghiệm',
            },
        },
        CYBERSEC_C3: {
            name: 'Xác minh tuân thủ lưu trữ dữ liệu trong nước',
            steps: {
                '1': 'Đánh giá xem yêu cầu lưu trữ dữ liệu trong nước có áp dụng hay không dựa trên loại dịch vụ và danh mục dữ liệu',
                '2': 'Xác minh kiến trúc lưu trữ tại chỗ và các biện pháp kiểm soát luồng dữ liệu xuyên biên giới đã sẵn sàng',
                '3': 'Đánh giá yêu cầu hiện diện tại địa phương (chi nhánh / văn phòng đại diện) nếu áp dụng',
                '4': 'Lập tài liệu bằng chứng tuân thủ và lưu giữ để cơ quan có thẩm quyền rà soát',
            },
        },
        CYBERSEC_C4: {
            name: 'Phản hồi yêu cầu hợp tác với cơ quan có thẩm quyền',
            steps: {
                '1': 'Tiếp nhận và xác minh tính hợp pháp cũng như phạm vi của yêu cầu từ cơ quan có thẩm quyền',
                '2': 'Thu thập và chuẩn bị thông tin được yêu cầu hoặc thực hiện các hành động cần thiết',
                '3': 'Nộp phản hồi cho cơ quan có thẩm quyền trong thời hạn quy định',
                '4': 'Ghi nhật ký việc cung cấp thông tin và đóng hồ sơ',
            },
        },
        CYBERSEC_C5: {
            name: 'Xác minh trình độ nhân sự an ninh mạng',
            steps: {
                '1': 'Đánh giá năng lực an ninh của nhà cung cấp sử dụng khung đánh giá an ninh mạng',
                '2': 'Xác minh phạm vi truy cập dữ liệu của nhà cung cấp và đăng ký trong nhật ký truy cập dữ liệu',
                '3': 'Rà soát điều khoản thông báo sự cố và yêu cầu an ninh mạng trong hợp đồng của nhà cung cấp',
                '4': 'Lên lịch rà soát an ninh nhà cung cấp định kỳ và giám sát tuân thủ',
            },
        },
        DATA_D1: {
            name: 'Thiết lập kiểm kê và phân loại dữ liệu',
            steps: {
                '1': 'Lập danh mục tất cả tài sản dữ liệu với loại và nguồn trong sổ kiểm kê dữ liệu',
                '2': 'Phân loại từng tài sản theo mức độ nhạy cảm',
                '3': 'Xác định quy tắc xử lý theo từng cấp độ phân loại',
                '4': 'Thu thập bằng chứng — ảnh chụp màn hình, sơ đồ kiến trúc, kiểm soát truy cập',
                '5': 'Lên lịch rà soát định kỳ',
            },
        },
        DATA_D2: {
            name: 'Quản trị chia sẻ dữ liệu',
            steps: {
                '1': 'Đánh giá các thỏa thuận chia sẻ mới thông qua đánh giá rủi ro chia sẻ dữ liệu',
                '2': 'Hoàn thành quy trình phê duyệt nội bộ',
                '3': 'Ghi nhận sự kiện chia sẻ trong nhật ký chia sẻ/cung cấp dữ liệu',
                '4': 'Thu thập bằng chứng — hồ sơ phê duyệt, tài liệu hợp đồng',
                '5': 'Rà soát định kỳ các thỏa thuận chia sẻ',
            },
        },
        DATA_D3: {
            name: 'Đánh giá chuyển dữ liệu xuyên biên giới',
            steps: {
                '1': 'Xác định các hoạt động chuyển dữ liệu xuyên biên giới trong kiểm kê dữ liệu',
                '2': 'Tiến hành đánh giá rủi ro chuyển dữ liệu',
                '3': 'Áp dụng các biện pháp bảo vệ và quản trị',
                '4': 'Lập tài liệu trong phần chuyển dữ liệu xuyên biên giới của bản xác nhận quản trị',
                '5': 'Xuất gói đánh giá để kiểm toán',
            },
        },
        DATA_D4: {
            name: 'Xác nhận quản trị hàng năm',
            steps: {
                '1': 'Rà soát ma trận RACI quản trị',
                '2': 'Xác minh trạng thái chính sách (quản trị, phân loại, chia sẻ, lưu trữ)',
                '3': 'Hoàn thành gói xác nhận',
                '4': 'Lấy phê duyệt nội bộ',
                '5': 'Xuất và lưu trữ bản xác nhận',
            },
        },
        DATA_D5: {
            name: 'Xử lý sự cố dữ liệu',
            steps: {
                '1': 'Phân loại sự cố bằng bản ghi quyết định',
                '2': 'Thực hiện ứng phó sự cố theo sổ tay hướng dẫn',
                '3': 'Thu thập bằng chứng — nhật ký, ảnh chụp màn hình, thông tin liên lạc',
                '4': 'Tiến hành rà soát sau sự cố',
                '5': 'Nếu cần thông báo cho cơ quan có thẩm quyền: tạo hồ sơ nộp và gửi cho Bộ TT&TT',
                '6': 'Đóng và lưu trữ hồ sơ',
            },
        },
        ECOM_P1: {
            name: 'Thông báo (Website/Ứng dụng bán hàng)',
            steps: {
                '1': 'Xác định phân loại: website/ứng dụng bán hàng hay sàn giao dịch/nền tảng dịch vụ',
                '2': 'Tạo hồ sơ nội bộ với thông tin doanh nghiệp, thông tin website/ứng dụng và các nội dung công bố bắt buộc',
                '3': 'Tạo gói bằng chứng — ảnh chụp màn hình nội dung công bố, URL chính sách, lịch sử phiên bản',
                '4': 'Nộp qua Online.gov.vn — tải lên tài liệu, ghi nhận thời gian và xác nhận',
                '5': 'Theo dõi xử lý — nếu bị trả lại để bổ sung, ghi nhận lý do và nộp lại',
                '6': 'Đóng hồ sơ — lưu trữ xác nhận, liên kết bằng chứng và dấu vết kiểm toán',
            },
        },
        ECOM_P2: {
            name: 'Đăng ký (Sàn giao dịch / Nền tảng dịch vụ)',
            steps: {
                '1': 'Xác định mô hình nền tảng và nghĩa vụ — sàn giao dịch, mô hình kết hợp hay thương mại xã hội',
                '2': 'Lập hồ sơ đăng ký — đơn đăng ký, đề án cung cấp dịch vụ, điều khoản sử dụng, quy chế nền tảng',
                '3': 'Phê duyệt nội bộ — chỉ định người phụ trách pháp lý/tuân thủ, phê duyệt để nộp',
                '4': 'Nộp qua Online.gov.vn — tải lên hồ sơ, ghi nhận thời gian',
                '5': 'Vòng xử lý — nếu bị trả lại để bổ sung, cập nhật và nộp lại',
                '6': 'Phê duyệt và triển khai — lưu trữ xác nhận, duy trì các sổ tuân thủ liên tục',
            },
        },
        ECOM_P3: {
            name: 'Thông báo cập nhật/thay đổi',
            steps: {
                '1': 'Xác định sự kiện kích hoạt thay đổi — thay đổi trọng yếu đối với các mục trong hồ sơ',
                '2': 'Tạo gói thay đổi — tóm tắt thay đổi, tài liệu cập nhật, bằng chứng cập nhật',
                '3': 'Nộp bản cập nhật và ghi nhận trạng thái nộp',
                '4': 'Theo dõi xử lý và đóng hồ sơ',
            },
        },
        ECOM_P4: {
            name: 'Chấm dứt / Ngừng hoạt động',
            steps: {
                '1': 'Chuẩn bị gói chấm dứt — ngày ngừng hoạt động, lý do, kế hoạch bảo vệ người tiêu dùng, bằng chứng thông báo công khai',
                '2': 'Nộp thông báo chấm dứt — ghi nhận thời gian và xác nhận',
                '3': 'Đóng hồ sơ — lưu trữ trạng thái cuối cùng và bằng chứng',
            },
        },
        ECOM_P5: {
            name: 'Chương trình nhãn hiệu tin cậy / Xếp hạng uy tín',
            steps: {
                '1': 'Rà soát đủ điều kiện và sẵn sàng',
                '2': 'Chuẩn bị hồ sơ theo mẫu chính thức',
                '3': 'Nộp và theo dõi',
                '4': 'Duy trì bằng chứng tuân thủ liên tục',
            },
        },
        PDPL_P1: {
            name: 'Nộp hồ sơ DPIA cho Bộ Công an',
            steps: {
                '1': 'Lập báo cáo đánh giá tác động xử lý (Mẫu số 10) và thông báo nộp hồ sơ (02a cho tổ chức; 02b cho cá nhân)',
                '2': 'Tập hợp tài liệu bìa và bằng chứng hỗ trợ',
                '5': 'Lưu giữ hồ sơ và bằng chứng nộp cho dấu vết kiểm toán',
            },
        },
        PDPL_P2: {
            name: 'Hồ sơ chuyển dữ liệu xuyên biên giới',
            steps: {
                '1': 'Hoàn thành hồ sơ chuyển dữ liệu xuyên biên giới theo biểu mẫu Nghị định 356 (Mẫu số 01a/01b, Mẫu số 09)',
            },
        },
        PDPL_P3: {
            name: 'Đăng ký cấp Giấy chứng nhận dịch vụ xử lý dữ liệu',
            steps: {
                '1': 'Chuẩn bị hồ sơ đăng ký chứng nhận theo yêu cầu Nghị định 356',
                '2': 'Nộp hồ sơ cho MPS kèm các tài liệu hỗ trợ bắt buộc',
                '3': 'Phản hồi ý kiến rà soát và yêu cầu bổ sung từ MPS',
            },
        },
        PDPL_P4: {
            name: 'Xử lý yêu cầu quyền chủ thể dữ liệu',
            steps: {
                '1': 'Tiếp nhận và ghi nhận yêu cầu; xác minh danh tính chủ thể dữ liệu trong 2 ngày làm việc',
                '2': 'Đánh giá loại yêu cầu và xác định thời hạn áp dụng (10/15/20 ngày theo loại)',
                '3': 'Thực hiện các hành động đáp ứng yêu cầu trên các hệ thống và phòng ban liên quan',
                '4': 'Chuẩn bị và gửi phản hồi cho chủ thể dữ liệu kèm kết quả và lý do',
                '5': 'Đóng hồ sơ và lưu giữ bằng chứng để kiểm toán; lập tài liệu lý do từ chối nếu có',
            },
        },
        PDPL_P5: {
            name: 'Thông báo vi phạm dữ liệu cho Bộ Công an',
            steps: {
                '1': 'Phát hiện và đánh giá vi phạm; xác định nghĩa vụ thông báo có phát sinh hay không và tra cứu thời hạn thông báo áp dụng từ các bản ghi thời hạn sự cố đã cài đặt',
                '2': 'Chuẩn bị gói thông báo theo yêu cầu PDPL',
                '3': 'Nộp thông báo cho MPS trong thời hạn thông báo được tra cứu từ các bản ghi thời hạn sự cố đã cài đặt, tính từ thời điểm phát hiện',
                '4': 'Phản hồi yêu cầu theo dõi từ MPS; nộp bổ sung và bằng chứng phối hợp',
            },
        },
        TELECOM_T1: {
            name: 'Xử lý yêu cầu từ cơ quan có thẩm quyền',
            steps: {
                '1': 'Tiếp nhận và ghi nhận yêu cầu từ cơ quan có thẩm quyền qua bản ghi tiếp nhận',
                '2': 'Xác minh danh tính cơ quan, căn cứ pháp lý và phạm vi yêu cầu',
                '3': 'Tiến hành rà soát pháp lý nội bộ và lấy phê duyệt của ban lãnh đạo',
                '4': 'Chuẩn bị gói phản hồi kèm bằng chứng đã tập hợp',
                '5': 'Soạn thảo và phê duyệt công văn phản hồi',
                '6': 'Tạo hồ sơ nộp và gửi phản hồi qua kênh tiếp nhận',
                '7': 'Ghi nhật ký cung cấp thông tin và theo dõi xác nhận từ cơ quan có thẩm quyền',
                '8': 'Đóng hồ sơ và lưu giữ bằng chứng cho dấu vết kiểm toán',
            },
        },
        TELECOM_T2: {
            name: 'Quản lý cung cấp thông tin',
            steps: {
                '1': 'Tiếp nhận yêu cầu cung cấp thông tin (sự đồng ý của người dùng, nghĩa vụ pháp lý, hoặc yêu cầu từ cơ quan có thẩm quyền)',
                '2': 'Hoàn thành quy trình phê duyệt cung cấp thông tin',
                '3': 'Thực hiện cung cấp thông tin và ghi nhận vào sổ đăng ký',
                '4': 'Thu thập bằng chứng — hồ sơ phê duyệt, hồ sơ liên lạc',
                '5': 'Rà soát định kỳ nhật ký cung cấp thông tin',
            },
        },
        TELECOM_T3: {
            name: 'Thiết lập chính sách bảo mật và kiểm soát truy cập',
            steps: {
                '1': 'Soạn thảo và phê duyệt chính sách bảo mật',
                '2': 'Soạn thảo và phê duyệt chính sách kiểm soát truy cập và ghi nhật ký',
                '3': 'Lập tài liệu các hoạt động xử lý trong sổ xử lý thông tin người dùng',
                '4': 'Thu thập bằng chứng — tài liệu chính sách, bằng chứng triển khai',
                '5': 'Lên lịch rà soát định kỳ',
            },
        },
        TELECOM_T4: {
            name: 'Đánh giá sự cố viễn thông',
            steps: {
                '1': 'Phân loại và đánh giá sự cố',
                '2': 'Xác định yêu cầu thông báo',
                '3': 'Nếu cần thông báo cho cơ quan có thẩm quyền: tạo hồ sơ nộp',
                '4': 'Thu thập và bảo quản bằng chứng',
                '5': 'Giải quyết và đóng hồ sơ',
            },
        },
        TELECOM_T5: {
            name: 'Quản lý lưu trữ và xóa dữ liệu',
            steps: {
                '1': 'Xác định lịch lưu trữ và xóa theo từng danh mục dữ liệu',
                '2': 'Triển khai quy trình xóa dữ liệu',
                '3': 'Thu thập bằng chứng — hồ sơ xóa dữ liệu',
                '4': 'Rà soát định kỳ lịch trình',
            },
        },
    },
    framework_fines: {
        VN_CYBERSEC_LAW: {},
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-A': 'Đăng ký / Thông báo / Sẵn sàng thủ tục hành chính',
            'ECOM-FINE-B': 'Khiếu nại và bảo vệ người tiêu dùng',
            'ECOM-FINE-C': 'Giám sát và thực thi gỡ bỏ nội dung',
            'ECOM-FINE-D': 'Hoạt động xuyên biên giới',
            'ECOM-FINE-E': 'Quy chế nền tảng và tính minh bạch',
        },
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-A': 'Vi phạm xử lý yêu cầu từ cơ quan có thẩm quyền',
            'TELECOM-FINE-B': 'Vi phạm bảo mật và cung cấp thông tin trái phép',
            'TELECOM-FINE-C': 'Vi phạm kiểm soát truy cập và ghi nhật ký',
            'TELECOM-FINE-D': 'Vi phạm lưu trữ và xóa dữ liệu',
            'TELECOM-FINE-E': 'Vi phạm đánh giá sự cố viễn thông',
        },
    },
    framework_fines_detail: {
        VN_TELECOM_LAW_2023: {
            'TELECOM-FINE-E': {
                fine_individual: 'Đến 100 triệu VNĐ',
                fine_org: 'Đến 200 triệu VNĐ',
                deadlines: 'Ngay khi phát hiện',
                remediation: [
                    'Bắt buộc phân loại sự cố',
                    'Bắt buộc hồ sơ mức độ nghiêm trọng và quyết định',
                    'Bắt buộc lưu giữ bằng chứng sự cố bảo mật',
                    'Bắt buộc đóng vụ việc sau sự cố',
                ],
            },
            'TELECOM-FINE-D': {
                fine_individual: 'Đến 100 triệu VNĐ',
                fine_org: 'Đến 200 triệu VNĐ',
                deadlines: 'Nghĩa vụ liên tục',
                remediation: [
                    'Bắt buộc triển khai lịch trình lưu trữ',
                    'Bắt buộc lưu giữ bằng chứng xóa',
                    'Bắt buộc hồ sơ quyết định ngoại lệ lưu trữ',
                ],
            },
            'TELECOM-FINE-C': {
                fine_individual: 'Đến 100 triệu VNĐ',
                fine_org: 'Đến 200 triệu VNĐ',
                deadlines: 'Nghĩa vụ liên tục',
                remediation: [
                    'Bắt buộc triển khai chính sách kiểm soát truy cập',
                    'Bắt buộc ghi nhật ký sự kiện truy cập',
                    'Bắt buộc rà soát quyền truy cập',
                ],
            },
            'TELECOM-FINE-B': {
                fine_individual: 'Đến 100 triệu VNĐ',
                fine_org: 'Đến 200 triệu VNĐ',
                deadlines: 'Nghĩa vụ liên tục',
                remediation: [
                    'Bắt buộc triển khai chính sách bảo mật',
                    'Bắt buộc quy trình phê duyệt tiết lộ',
                    'Bắt buộc duy trì dấu vết tiết lộ',
                    'Bắt buộc kiểm soát truy cập thông tin người dùng',
                ],
            },
            'TELECOM-FINE-A': {
                fine_individual: 'Đến 100 triệu VNĐ',
                fine_org: 'Đến 200 triệu VNĐ',
                deadlines: 'Theo quy định trong yêu cầu của cơ quan có thẩm quyền',
                remediation: [
                    'Bắt buộc tiếp nhận và xác minh yêu cầu của cơ quan có thẩm quyền',
                    'Bắt buộc phản hồi trong thời hạn quy định',
                    'Bắt buộc mục ghi nhật ký tiết lộ',
                    'Bắt buộc lưu giữ bằng chứng',
                ],
            },
        },
        VN_ECOMMERCE_LAW_2025: {
            'ECOM-FINE-E': {
                fine_individual: 'Đến 80 triệu VNĐ',
                fine_org: 'Đến 160 triệu VNĐ',
                deadlines: 'Nghĩa vụ liên tục',
                remediation: [
                    'Bắt buộc công bố và quản lý phiên bản quy tắc nền tảng',
                    'Bắt buộc công bố thông tin hướng đến người dùng',
                    'Bắt buộc có bằng chứng nghĩa vụ của bên bán/đối tác liên kết/phát trực tiếp',
                    'Bắt buộc lịch sử kiểm soát và chuỗi phê duyệt',
                ],
            },
            'ECOM-FINE-D': {
                fine_individual: 'Đến 80 triệu VNĐ',
                fine_org: 'Đến 160 triệu VNĐ',
                deadlines: 'Nghĩa vụ liên tục',
                remediation: [
                    'Bắt buộc đánh giá nghĩa vụ xuyên biên giới',
                    'Bắt buộc sẵn sàng đại diện có thẩm quyền',
                    'Bắt buộc sổ đăng ký hoạt động xuyên biên giới',
                    'Bắt buộc bằng chứng hành động tuân thủ',
                ],
            },
            'ECOM-FINE-C': {
                fine_individual: 'Đến 80 triệu VNĐ',
                fine_org: 'Đến 160 triệu VNĐ',
                deadlines: 'Nghĩa vụ liên tục',
                remediation: [
                    'Bắt buộc rà soát niêm yết bị cấm hoặc bất hợp pháp',
                    'Bắt buộc hồ sơ quyết định gỡ bỏ',
                    'Bắt buộc lưu giữ bằng chứng',
                    'Bắt buộc dấu vết thông báo và đóng vụ việc với bên bán',
                ],
            },
            'ECOM-FINE-B': {
                fine_individual: 'Đến 80 triệu VNĐ',
                fine_org: 'Đến 160 triệu VNĐ',
                deadlines: 'Theo nghĩa vụ xử lý khiếu nại',
                remediation: [
                    'Bắt buộc quy trình tiếp nhận khiếu nại',
                    'Bắt buộc hồ sơ giải quyết',
                    'Bắt buộc dấu vết kiểm toán khiếu nại',
                    'Bắt buộc leo thang đối với vấn đề của bên bán xuyên biên giới',
                ],
            },
            'ECOM-FINE-A': {
                fine_individual: 'Đến 80 triệu VNĐ',
                fine_org: 'Đến 160 triệu VNĐ',
                deadlines: 'Trước khi bắt đầu hoạt động thương mại điện tử',
                remediation: [
                    'Bắt buộc phân loại nền tảng',
                    'Bắt buộc hoàn tất thông báo hoặc đăng ký',
                    'Bắt buộc có bằng chứng nộp qua cổng thông tin',
                    'Bắt buộc theo dõi cập nhật/chấm dứt',
                ],
            },
        },
        VN_CYBERSEC_LAW: {},
    },
    framework_procedures_detail: {
        VN_DP_DRAFT_P7: {
            trigger: 'Hoạt động vận hành liên tục của sàn',
            outputs: [
                'Hồ sơ đánh giá rủi ro',
                'Nhật ký cảnh báo sớm',
                'Hồ sơ khắc phục',
                'Dấu vết rà soát',
            ],
            channels: ['Quy trình trên sàn'],
            responsible: {
                1: 'Đơn vị vận hành sàn / Rủi ro',
                2: 'Đơn vị vận hành sàn / An ninh',
                3: 'Đơn vị vận hành sàn / Rủi ro',
                4: 'Đơn vị vận hành sàn / An ninh',
                5: 'Đơn vị vận hành sàn',
                6: 'Tuân thủ',
            },
            step_outputs: {
                1: ['Hồ sơ đánh giá rủi ro'],
                2: ['Nhật ký cảnh báo sớm'],
                3: ['Kết quả rà soát rủi ro'],
                4: ['Mục ghi sổ đăng ký rủi ro'],
                5: ['Hồ sơ khắc phục'],
                6: ['Dấu vết rà soát'],
            },
        },
        VN_DP_DRAFT_P6: {
            trigger: 'Bên tham gia gửi yêu cầu khiếu nại hoặc tranh chấp',
            outputs: [
                'Hồ sơ tiếp nhận khiếu nại',
                'Hồ sơ giải quyết tranh chấp',
                'Bộ bằng chứng',
                'Hồ sơ đóng vụ việc',
            ],
            channels: ['Quy trình trên sàn'],
            responsible: {
                1: 'Đơn vị vận hành sàn',
                2: 'Đơn vị vận hành sàn',
                3: 'Đơn vị vận hành sàn',
                4: 'Đơn vị vận hành sàn',
                5: 'Đơn vị vận hành sàn / Pháp chế',
                6: 'Đơn vị vận hành sàn',
                7: 'Tuân thủ',
            },
            step_outputs: {
                1: ['Hồ sơ tiếp nhận khiếu nại'],
                2: ['Kiểm tra tính đầy đủ', 'Yêu cầu bổ sung (nếu có)'],
                3: ['Thông báo phương án xử lý'],
                4: ['Bộ bằng chứng'],
                5: ['Kết quả đánh giá'],
                6: ['Hồ sơ giải quyết tranh chấp'],
                7: ['Hồ sơ đóng vụ việc', 'Bộ bằng chứng đã lưu trữ'],
            },
        },
        VN_DP_DRAFT_P5: {
            trigger: 'Việc giao hàng được hoàn tất sau khi đáp ứng điều kiện hợp đồng và thanh toán',
            outputs: [
                'Hồ sơ giao hàng',
                'Giấy chứng nhận quyền sở hữu đối với dữ liệu',
                'Mục ghi sổ đăng ký giao dịch',
            ],
            channels: ['Quy trình trên sàn'],
            responsible: {
                1: 'Bên bán / Đơn vị vận hành sàn',
                2: 'Đơn vị vận hành sàn',
                3: 'Đơn vị vận hành sàn',
                4: 'Đơn vị vận hành sàn',
                5: 'Đơn vị vận hành sàn',
            },
            step_outputs: {
                1: ['Hồ sơ giao hàng'],
                2: ['Mục nhật ký sự kiện giao hàng'],
                3: ['Giấy chứng nhận quyền sở hữu'],
                4: ['Mục ghi sổ đăng ký giao dịch'],
                5: ['Hồ sơ truy cập xác minh'],
            },
        },
        VN_DP_DRAFT_P4: {
            trigger: 'Bên mua khởi tạo giao dịch đối với dữ liệu, sản phẩm hoặc dịch vụ',
            outputs: [
                'Hồ sơ khởi tạo giao dịch',
                'Hợp đồng điện tử',
                'Xác nhận thanh toán',
                'Hồ sơ cho phép giao hàng',
            ],
            channels: ['Quy trình trên sàn'],
            responsible: {
                1: 'Bên mua',
                2: 'Bên mua / Đơn vị vận hành sàn',
                3: 'Đơn vị vận hành sàn',
                4: 'Bên mua / Bên bán',
                5: 'Đơn vị vận hành sàn / Thanh toán',
                6: 'Đơn vị vận hành sàn',
            },
            step_outputs: {
                1: ['Quyết định rà soát niêm yết'],
                2: ['Hồ sơ khởi tạo giao dịch'],
                3: ['Hồ sơ hợp đồng điện tử'],
                4: ['Hồ sơ chấp nhận hợp đồng'],
                5: ['Xác nhận thanh toán'],
                6: ['Hồ sơ cho phép giao hàng'],
            },
        },
        VN_DP_DRAFT_P3: {
            trigger: 'Bên tham gia muốn đánh giá sản phẩm/dịch vụ dữ liệu trong môi trường cách ly',
            outputs: [
                'Yêu cầu môi trường thử nghiệm',
                'Hồ sơ phạm vi môi trường thử nghiệm',
                'Hồ sơ rà soát kết quả đầu ra',
                'Hồ sơ kết thúc môi trường thử nghiệm',
            ],
            channels: ['Quy trình trên sàn'],
            responsible: {
                1: 'Bên tham gia',
                2: 'Đơn vị vận hành sàn / Bên tham gia',
                3: 'Đơn vị vận hành sàn / CNTT',
                4: 'Đơn vị vận hành sàn / An ninh',
                5: 'Đơn vị vận hành sàn',
                6: 'Đơn vị vận hành sàn',
                7: 'Đơn vị vận hành sàn / CNTT',
            },
            step_outputs: {
                1: ['Yêu cầu môi trường thử nghiệm'],
                2: ['Hồ sơ phạm vi môi trường thử nghiệm'],
                3: ['Môi trường đã cấp phát'],
                4: ['Nhật ký giám sát an ninh'],
                5: ['Hồ sơ rà soát kết quả đầu ra'],
                6: ['Quyết định phê duyệt trích xuất'],
                7: ['Hồ sơ kết thúc môi trường thử nghiệm'],
            },
        },
        VN_DP_DRAFT_P2: {
            trigger: 'Bên bán đề nghị niêm yết dữ liệu, sản phẩm hoặc dịch vụ dữ liệu để giao dịch',
            outputs: [
                'Đơn đăng ký niêm yết',
                'Hồ sơ xác minh nguồn hợp pháp',
                'Hồ sơ kiểm định kỹ thuật',
                'Hồ sơ công bố chất lượng',
                'Hồ sơ phê duyệt niêm yết',
                'Mục ghi sổ đăng ký niêm yết',
            ],
            channels: ['Quy trình trên sàn'],
            responsible: {
                1: 'Bên bán',
                2: 'Bên bán / Pháp chế',
                3: 'Bên bán / CNTT',
                4: 'Bên bán',
                5: 'Bên bán',
                6: 'Đơn vị vận hành sàn',
                7: 'Đơn vị vận hành sàn',
                8: 'Đơn vị vận hành sàn',
            },
            step_outputs: {
                1: ['Đơn đăng ký niêm yết'],
                2: ['Hồ sơ xác minh nguồn hợp pháp'],
                3: ['Hồ sơ kiểm định kỹ thuật'],
                4: ['Hồ sơ công bố chất lượng'],
                5: ['Hồ sơ niêm yết đã nộp'],
                6: ['Kết quả rà soát'],
                7: ['Hồ sơ phê duyệt niêm yết'],
                8: ['Niêm yết đã công bố', 'Mục ghi sổ đăng ký niêm yết'],
            },
        },
        VN_DP_DRAFT_P1: {
            trigger: 'Một bên bán hoặc bên mua tham gia sàn dữ liệu',
            outputs: [
                'Hồ sơ tiếp nhận bên bán / bên mua',
                'Mục ghi trong sổ đăng ký bên tham gia',
                'Bằng chứng thiết lập tài khoản',
                'Hồ sơ phê duyệt',
            ],
            channels: ['Quy trình trên sàn'],
            responsible: {
                1: 'Đơn vị vận hành sàn',
                2: 'Đơn vị vận hành sàn / Pháp chế',
                3: 'Đơn vị vận hành sàn / Pháp chế',
                4: 'Đơn vị vận hành sàn',
                5: 'Đơn vị vận hành sàn',
                6: 'Đơn vị vận hành sàn',
                7: 'Tuân thủ',
            },
            step_outputs: {
                1: ['Quyết định loại bên tham gia'],
                2: ['Hồ sơ xác minh năng lực pháp lý'],
                3: ['Hồ sơ kiểm tra ngành nghề có điều kiện'],
                4: ['Hồ sơ đăng ký tài khoản giao dịch'],
                5: ['Hồ sơ liên kết tài khoản thanh toán'],
                6: ['Hồ sơ phê duyệt tham gia'],
                7: ['Mục ghi sổ đăng ký bên tham gia', 'Nhật ký kiểm toán'],
            },
        },
        PDPL_P1: {
            trigger: 'Bắt đầu xử lý dữ liệu cá nhân yêu cầu đánh giá tác động',
            outputs: ['Hồ sơ DPIA', 'Xác nhận nộp', 'Gói bổ sung'],
            channels: ['Cổng thông tin Bộ Công an', 'Nộp trực tiếp tại A05 Bộ Công an'],
            responsible: {
                1: 'DPO / Nhóm Quyền riêng tư',
                2: 'Nhóm Quyền riêng tư',
                3: 'Pháp chế / Tuân thủ',
                4: 'DPO / Nhóm Quyền riêng tư',
                5: 'Nhóm Tuân thủ',
            },
            step_outputs: {
                1: ['Hồ sơ DPIA hoàn chỉnh'],
                2: ['Gói hồ sơ', 'Thư ngỏ'],
                3: ['Xác nhận nộp', 'Mã theo dõi'],
                4: ['Gói bổ sung', 'Hồ sơ cập nhật'],
                5: ['Hồ sơ lưu trữ', 'Gói bằng chứng kiểm toán'],
            },
        },
        PDPL_P2: {
            trigger: 'Có ý định chuyển dữ liệu cá nhân ra ngoài Việt Nam',
            outputs: ['Hồ sơ chuyển dữ liệu', 'Xác nhận nộp', 'Phản hồi bổ sung'],
            channels: ['Cổng thông tin Bộ Công an', 'Nộp trực tiếp tại A05 Bộ Công an'],
            responsible: {
                1: 'DPO / Nhóm Quyền riêng tư',
                2: 'Pháp chế / Tuân thủ',
                3: 'DPO / Nhóm Quyền riêng tư',
            },
            step_outputs: {
                1: ['Gói hồ sơ chuyển dữ liệu'],
                2: ['Xác nhận nộp', 'Mã theo dõi'],
                3: ['Phản hồi bổ sung', 'Hồ sơ cập nhật'],
            },
        },
        PDPL_P3: {
            trigger: 'Tổ chức cung cấp dịch vụ xử lý dữ liệu cần chứng nhận',
            outputs: ['Hồ sơ chứng nhận', 'Giấy chứng nhận', 'Hồ sơ cấp lại, cấp đổi'],
            channels: ['Cổng thông tin Bộ Công an', 'Nộp trực tiếp tại A05 Bộ Công an'],
            responsible: {
                1: 'Pháp chế / Tuân thủ',
                2: 'Pháp chế / Tuân thủ',
                3: 'DPO / Nhóm Quyền riêng tư',
                4: 'Nhóm Tuân thủ',
            },
            step_outputs: {
                1: ['Hồ sơ đăng ký chứng nhận'],
                2: ['Xác nhận nộp'],
                3: ['Phản hồi bổ sung'],
                4: ['Hồ sơ chứng nhận', 'Hồ sơ cấp lại, cấp đổi'],
            },
        },
        PDPL_P4: {
            trigger: 'Nhận được yêu cầu thực hiện quyền chủ thể dữ liệu',
            outputs: [
                'Biên nhận yêu cầu DSR',
                'Xác minh danh tính',
                'Thư phản hồi',
                'Báo cáo đóng vụ việc',
            ],
            channels: ['Cổng trực tuyến', 'Email', 'Trực tiếp'],
            responsible: {
                1: 'Nhóm Quyền riêng tư / Dịch vụ khách hàng',
                2: 'DPO / Nhóm Quyền riêng tư',
                3: 'Trưởng bộ phận / IT',
                4: 'DPO / Nhóm Quyền riêng tư',
                5: 'Nhóm Tuân thủ',
            },
            step_outputs: {
                1: ['Biên nhận yêu cầu DSR', 'Biên bản xác minh danh tính'],
                2: ['Đánh giá yêu cầu', 'Phân công thời hạn'],
                3: ['Bằng chứng thực hiện', 'Xác nhận của bộ phận'],
                4: ['Thư phản hồi'],
                5: ['Báo cáo đóng vụ việc', 'Gói bằng chứng kiểm toán'],
            },
        },
        PDPL_P5: {
            trigger: 'Phát hiện vi phạm bảo vệ dữ liệu cá nhân',
            outputs: ['Biên bản đánh giá vi phạm', 'Gói thông báo', 'Xác nhận nộp', 'Gói bổ sung'],
            channels: ['Cổng thông tin Bộ Công an', 'Nộp trực tiếp tại A05 Bộ Công an'],
            responsible: {
                1: 'Nhóm Ứng phó sự cố / DPO',
                2: 'DPO / Nhóm Quyền riêng tư',
                3: 'Pháp chế / Tuân thủ',
                4: 'DPO / Nhóm Ứng phó sự cố',
            },
            step_outputs: {
                1: ['Biên bản đánh giá vi phạm', 'Biên bản quyết định thông báo'],
                2: ['Gói thông báo vi phạm'],
                3: ['Xác nhận nộp', 'Mã theo dõi'],
                4: ['Gói bổ sung', 'Bằng chứng phối hợp'],
            },
        },
    },
    framework_guidance_references: {
        'Authority practice (unofficial) — email-ZIP submission of PDPL evidence packs during NQ22 era': 'Thực tiễn của cơ quan (không chính thức) — nộp gói bằng chứng PDPL qua email-ZIP trong giai đoạn NQ22',
        'Cross-reference frameworks listed on VN_ECOMMERCE_DECREE_248_2026.': 'Các khung tham chiếu chéo được liệt kê trên VN_ECOMMERCE_DECREE_248_2026.',
        'Cross-reference frameworks on VN_DIGITAL_TECH_INDUSTRY_LAW_2025.': 'Các khung tham chiếu chéo trên VN_DIGITAL_TECH_INDUSTRY_LAW_2025.',
        'Cross-reference frameworks on VN_DIGITAL_TRANSFORMATION_LAW_2025.': 'Các khung tham chiếu chéo trên VN_DIGITAL_TRANSFORMATION_LAW_2025.',
        'Government/MOIT public reporting.': 'Báo cáo công khai của Chính phủ/Bộ Công Thương.',
        'Government/MOIT public reporting; deadline VN_ECOM248_DEADLINE_TAKEDOWN_RESPONSE.': 'Báo cáo công khai của Chính phủ/Bộ Công Thương; thời hạn VN_ECOM248_DEADLINE_TAKEDOWN_RESPONSE.',
        'MPS consultation dossier — draft information-systems protection decree.': 'Hồ sơ tham vấn của Bộ Công an — dự thảo nghị định bảo vệ hệ thống thông tin.',
        'MPS consultation — draft general implementing decree.': 'Tham vấn của Bộ Công an — dự thảo nghị định hướng dẫn chung.',
        'Sector overlay install model (mirrors VN_BANKING_CIRCULAR_83_2025).': 'Mô hình cài đặt lớp phủ ngành (tương tự VN_BANKING_CIRCULAR_83_2025).',
        'Shared draft enforcement overlay VN_CYBER_PDPL_ENFORCEMENT_DRAFT_2026 (home pack: vn-pdpl).': 'Lớp phủ thực thi dự thảo dùng chung VN_CYBER_PDPL_ENFORCEMENT_DRAFT_2026 (gói gốc: vn-pdpl).',
    },
    framework_deadline_references: {
        'ComplianceOne internal review': 'Rà soát nội bộ ComplianceOne',
        'ComplianceOne internal review date': 'Ngày rà soát nội bộ ComplianceOne',
        'Draft personnel provisions': 'Dự thảo quy định về nhân sự',
        'Draft specialist provisions': 'Dự thảo quy định chuyên môn',
        'Internal child-instrument review.': 'Rà soát nội bộ văn bản hướng dẫn.',
        'Internal platform review.': 'Rà soát nội bộ nền tảng.',
        'Internal recommendation based on draft lifecycle governance': 'Khuyến nghị nội bộ dựa trên dự thảo quản trị vòng đời',
        'Internal recommended digital-service procurement/leasing vendor review (before procurement/leasing and on material change).': 'Khuyến nghị nội bộ rà soát nhà cung cấp mua sắm/thuê dịch vụ số (trước khi mua sắm/thuê và khi có thay đổi trọng yếu).',
        'Internal recommended digital-transformation control review.': 'Khuyến nghị nội bộ rà soát kiểm soát chuyển đổi số.',
        'Internal recommended review of digital-system minimum requirements (annual or on material change).': 'Khuyến nghị nội bộ rà soát yêu cầu tối thiểu của hệ thống số (hằng năm hoặc khi có thay đổi trọng yếu).',
        'National digital technology industry database — ad-hoc update at authority request (where direct scope is confirmed).': 'Cơ sở dữ liệu ngành công nghiệp công nghệ số quốc gia — cập nhật đột xuất theo yêu cầu của cơ quan (khi đã xác nhận phạm vi áp dụng trực tiếp).',
        'National digital technology industry database — quarterly update (where direct scope is confirmed).': 'Cơ sở dữ liệu ngành công nghiệp công nghệ số quốc gia — cập nhật hằng quý (khi đã xác nhận phạm vi áp dụng trực tiếp).',
        'Official MPS consultation page': 'Trang tham vấn chính thức của Bộ Công an',
        'Platform operational control — not a statutory deadline': 'Kiểm soát vận hành nền tảng — không phải thời hạn luật định',
        'PDPL Art. 9': 'Luật BVDLCN Điều 9',
        'PDPL Art. 17': 'Luật BVDLCN Điều 17',
        'PDPL Art. 23': 'Luật BVDLCN Điều 23',
        'Decree 13 Art. 24': 'Nghị định 13 Điều 24',
        'MoPS Admin Procedures': 'Thủ tục hành chính Bộ Công an',
        'Annual cycle': 'Chu kỳ hằng năm',
        'Decree 13/2023/NĐ-CP Art. 24': 'Nghị định 13/2023/NĐ-CP Điều 24',
        'Decree 356/2025/NĐ-CP Art. 25(4)': 'Nghị định 356/2025/NĐ-CP Điều 25(4)',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2': 'Nghị định 356/2025/NĐ-CP Điều 5 Khoản 2',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 2–5': 'Nghị định 356/2025/NĐ-CP Điều 5 Khoản 2–5',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 3': 'Nghị định 356/2025/NĐ-CP Điều 5 Khoản 3',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 4': 'Nghị định 356/2025/NĐ-CP Điều 5 Khoản 4',
        'Decree 356/2025/NĐ-CP Art. 5 Cl. 5': 'Nghị định 356/2025/NĐ-CP Điều 5 Khoản 5',
        'Decree 356/2025/NĐ-CP Art. 8(3)': 'Nghị định 356/2025/NĐ-CP Điều 8(3)',
        'Draft Decree on Data Platforms 2026': 'Dự thảo Nghị định về Sàn dữ liệu 2026',
        'Law 122/2025/QH15 Ch. III; NĐ 98/2020; NĐ 24/2025': 'Luật 122/2025/QH15 Chương III; NĐ 98/2020; NĐ 24/2025',
        'Law 122/2025/QH15 Ch. IV (Consumer Protection)': 'Luật 122/2025/QH15 Chương IV (Bảo vệ người tiêu dùng)',
        'Law 122/2025/QH15 — Online.gov.vn operational procedure': 'Luật 122/2025/QH15 — Thủ tục vận hành Online.gov.vn',
        'Law 134/2025/QH15 Article 12': 'Luật 134/2025/QH15 Điều 12',
        'Law 134/2025/QH15 Article 21': 'Luật 134/2025/QH15 Điều 21',
        'Law 134/2025/QH15 Article 27': 'Luật 134/2025/QH15 Điều 27',
        'Law 134/2025/QH15 Articles 9–10': 'Luật 134/2025/QH15 Điều 9–10',
        'Law 24/2023/QH15 — article mapping pending': 'Luật 24/2023/QH15 — chờ ánh xạ điều khoản',
        'Law 60/2024/QH15 (internal control target)': 'Luật 60/2024/QH15 (mục tiêu kiểm soát nội bộ)',
        'Law 91/2025/QH15 Art. 21': 'Luật 91/2025/QH15 Điều 21',
        'Law 91/2025/QH15 Art. 23': 'Luật 91/2025/QH15 Điều 23',
        'Policy-defined': 'Do chính sách quy định',
        Quarterly: 'Hằng quý',
        'QĐ 778/QĐ-BCA-A05 administrative procedure': 'QĐ 778/QĐ-BCA-A05 thủ tục hành chính',
        'internal control target (Law 116/2025/QH15 Art. 24(2)(b), 41(5) — exact timeline pending implementing instrument)': 'mục tiêu kiểm soát nội bộ (Luật 116/2025/QH15 Điều 24(2)(b), 41(5) — thời hạn cụ thể chờ văn bản hướng dẫn)',
        'internal control target (Law 116/2025/QH15 Art. 41(3) — exact timeline pending implementing instrument)': 'mục tiêu kiểm soát nội bộ (Luật 116/2025/QH15 Điều 41(3) — thời hạn cụ thể chờ văn bản hướng dẫn)',
        'source verification pending': 'chờ xác minh nguồn',
        'Circular 83/2025/TT-NHNN — Ad-hoc Internal Audit Reporting to SBV (Layer 5)': 'Thông tư 83/2025/TT-NHNN — Ad-hoc Báo cáo kiểm toán nội bộ gửi NHNN (Tầng 5)',
        'Circular 83/2025/TT-NHNN — Annual ICAAP Report (Phụ lục III) (Layer 5)': 'Thông tư 83/2025/TT-NHNN — Báo cáo ICAAP hằng năm (Phụ lục III) (Tầng 5)',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục I (Layer 5)': 'Thông tư 83/2025/TT-NHNN — Phụ lục hằng năm I (Tầng 5)',
        'Circular 83/2025/TT-NHNN — Annual Phụ lục IV (Layer 5)': 'Thông tư 83/2025/TT-NHNN — Phụ lục hằng năm IV (Tầng 5)',
        'Circular 83/2025/TT-NHNN — Annual Risk Management Report (Phụ lục II) (Layer 5)': 'Thông tư 83/2025/TT-NHNN — Annual Quản lý rủi ro Report (Phụ lục II) (Tầng 5)',
        'Circular 83/2025/TT-NHNN — Asset Management Responsibility (Layer 2, theme C)': 'Thông tư 83/2025/TT-NHNN — Trách nhiệm quản lý tài sản (Tầng 2, chủ đề C)',
        "Circular 83/2025/TT-NHNN — Board / Members' Council Oversight (Layer 2, theme A)": 'Thông tư 83/2025/TT-NHNN — Giám sát của Hội đồng quản trị / Hội đồng thành viên (Tầng 2, chủ đề A)',
        'Circular 83/2025/TT-NHNN — Board Committees (Layer 2, theme A)': 'Thông tư 83/2025/TT-NHNN — Các ủy ban thuộc Hội đồng (Tầng 2, chủ đề A)',
        'Circular 83/2025/TT-NHNN — Board Decisions and Minutes (Layer 2, theme A)': 'Thông tư 83/2025/TT-NHNN — Nghị quyết và biên bản Hội đồng (Tầng 2, chủ đề A)',
        'Circular 83/2025/TT-NHNN — Branch Control Procedures (Layer 2, theme C)': 'Thông tư 83/2025/TT-NHNN — Thủ tục kiểm soát chi nhánh (Tầng 2, chủ đề C)',
        'Circular 83/2025/TT-NHNN — Compliance Assessment of Internal Rules (Layer 2, theme D)': 'Thông tư 83/2025/TT-NHNN — Đánh giá tuân thủ quy định nội bộ (Tầng 2, chủ đề D)',
        'Circular 83/2025/TT-NHNN — Compliance Function (Layer 2, theme D)': 'Thông tư 83/2025/TT-NHNN — Chức năng tuân thủ (Tầng 2, chủ đề D)',
        'Circular 83/2025/TT-NHNN — Compliance Remediation Monitoring (Layer 2, theme D)': 'Thông tư 83/2025/TT-NHNN — Giám sát khắc phục tuân thủ (Tầng 2, chủ đề D)',
        'Circular 83/2025/TT-NHNN — Concentration Risk (Layer 3, theme E)': 'Thông tư 83/2025/TT-NHNN — Rủi ro tập trung (Tầng 3, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Conflict of Interest (Layer 2, theme C)': 'Thông tư 83/2025/TT-NHNN — Xung đột lợi ích (Tầng 2, chủ đề C)',
        'Circular 83/2025/TT-NHNN — Control Culture (Layer 2, theme A/B)': 'Thông tư 83/2025/TT-NHNN — Văn hóa kiểm soát (Tầng 2, chủ đề A/B)',
        'Circular 83/2025/TT-NHNN — Credit Risk (Layer 3, theme E)': 'Thông tư 83/2025/TT-NHNN — Rủi ro tín dụng (Tầng 3, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Delegated Authority (Layer 2, theme C)': 'Thông tư 83/2025/TT-NHNN — Ủy quyền (Tầng 2, chủ đề C)',
        'Circular 83/2025/TT-NHNN — Early Implementation Notification (Layer 5)': 'Thông tư 83/2025/TT-NHNN — Thông báo triển khai sớm (Tầng 5)',
        'Circular 83/2025/TT-NHNN — General Director Responsibility (Layer 2, theme A)': 'Thông tư 83/2025/TT-NHNN — Trách nhiệm của Tổng Giám đốc (Tầng 2, chủ đề A)',
        'Circular 83/2025/TT-NHNN — ICAAP (Layer 3, theme E)': 'Thông tư 83/2025/TT-NHNN — ICAAP (Tầng 3, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Interest-Rate Risk in the Banking Book (Layer 3, theme E)': 'Thông tư 83/2025/TT-NHNN — Rủi ro lãi suất trên sổ ngân hàng (Tầng 3, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Internal Audit Charter (Layer 2, theme H)': 'Thông tư 83/2025/TT-NHNN — Điều lệ kiểm toán nội bộ (Tầng 2, chủ đề H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Engagements (Theme H)': 'Thông tư 83/2025/TT-NHNN — Cuộc kiểm toán nội bộ (chủ đề H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings Communication (Layer 2, theme H)': 'Thông tư 83/2025/TT-NHNN — Truyền đạt phát hiện kiểm toán nội bộ (Tầng 2, chủ đề H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Findings and Corrective Actions (Theme H)': 'Thông tư 83/2025/TT-NHNN — Phát hiện và biện pháp khắc phục của kiểm toán nội bộ (chủ đề H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Follow-Up (Theme H)': 'Thông tư 83/2025/TT-NHNN — Theo dõi sau kiểm toán nội bộ (chủ đề H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Governance': 'Thông tư 83/2025/TT-NHNN — Quản trị kiểm toán nội bộ',
        'Circular 83/2025/TT-NHNN — Internal Audit Independence (Layer 2, theme H)': 'Thông tư 83/2025/TT-NHNN — Tính độc lập của kiểm toán nội bộ (Tầng 2, chủ đề H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Plan (Layer 2/Theme H)': 'Thông tư 83/2025/TT-NHNN — Kế hoạch kiểm toán nội bộ (Tầng 2/chủ đề H)',
        'Circular 83/2025/TT-NHNN — Internal Audit Reporting to SBV (Layer 2, theme H)': 'Thông tư 83/2025/TT-NHNN — Báo cáo kiểm toán nội bộ gửi NHNN (Tầng 2, chủ đề H)',
        'Circular 83/2025/TT-NHNN — Internal Control System Governance (Layer 2)': 'Thông tư 83/2025/TT-NHNN — Quản trị hệ thống kiểm soát nội bộ (Tầng 2)',
        'Circular 83/2025/TT-NHNN — Internal Reporting Procedure (Layer 2, theme C)': 'Thông tư 83/2025/TT-NHNN — Thủ tục báo cáo nội bộ (Tầng 2, chủ đề C)',
        'Circular 83/2025/TT-NHNN — Internal Reports Register (Layer 4, theme F)': 'Thông tư 83/2025/TT-NHNN — Sổ đăng ký báo cáo nội bộ (Tầng 4, chủ đề F)',
        'Circular 83/2025/TT-NHNN — Law-Change Monitoring (Layer 2, theme D)': 'Thông tư 83/2025/TT-NHNN — Luật-Change Monitoring (Tầng 2, chủ đề D)',
        'Circular 83/2025/TT-NHNN — Legal and Reputational Risk (Layer 3, theme E)': 'Thông tư 83/2025/TT-NHNN — Rủi ro pháp lý và danh tiếng (Tầng 3, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Limit Breach Escalation (Layer 3, theme E)': 'Thông tư 83/2025/TT-NHNN — Leo thang vi phạm hạn mức (Tầng 3, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Liquidity Risk (Layer 3, theme E)': 'Thông tư 83/2025/TT-NHNN — Rủi ro thanh khoản (Tầng 3, chủ đề E)',
        'Circular 83/2025/TT-NHNN — MIS Annual Review (Layer 4, theme F)': 'Thông tư 83/2025/TT-NHNN — Rà soát MIS hằng năm (Tầng 4, chủ đề F)',
        'Circular 83/2025/TT-NHNN — MIS Backup and Continuity (Layer 4, theme F)': 'Thông tư 83/2025/TT-NHNN — Sao lưu và liên tục MIS (Tầng 4, chủ đề F)',
        'Circular 83/2025/TT-NHNN — MIS Escalation Mechanisms (Layer 4, theme F)': 'Thông tư 83/2025/TT-NHNN — Cơ chế leo thang MIS (Tầng 4, chủ đề F)',
        'Circular 83/2025/TT-NHNN — MIS Reliability and Confidentiality (Layer 4, theme F)': 'Thông tư 83/2025/TT-NHNN — Độ tin cậy và bảo mật MIS (Tầng 4, chủ đề F)',
        'Circular 83/2025/TT-NHNN — MIS Risk Data Sources (Layer 4, theme F)': 'Thông tư 83/2025/TT-NHNN — Nguồn dữ liệu rủi ro MIS (Tầng 4, chủ đề F)',
        'Circular 83/2025/TT-NHNN — Management Information System (Layer 4)': 'Thông tư 83/2025/TT-NHNN — Hệ thống thông tin quản lý (Tầng 4)',
        'Circular 83/2025/TT-NHNN — Market Risk (Layer 3, theme E)': 'Thông tư 83/2025/TT-NHNN — Rủi ro thị trường (Tầng 3, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Material Risk Register (Layer 3)': 'Thông tư 83/2025/TT-NHNN — Sổ đăng ký rủi ro trọng yếu (Tầng 3)',
        'Circular 83/2025/TT-NHNN — Model Risk (Layer 3, theme E)': 'Thông tư 83/2025/TT-NHNN — Rủi ro mô hình (Tầng 3, chủ đề E)',
        'Circular 83/2025/TT-NHNN — New Product Review (Layer 3, theme E)': 'Thông tư 83/2025/TT-NHNN — Rà soát sản phẩm mới (Tầng 3, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Operational Risk (Layer 3, theme E)': 'Thông tư 83/2025/TT-NHNN — Rủi ro hoạt động (Tầng 3, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Outsourcing BCP (Layer 2, theme G)': 'Thông tư 83/2025/TT-NHNN — BCP thuê ngoài (Tầng 2, chủ đề G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Contracts (Layer 2, theme G)': 'Thông tư 83/2025/TT-NHNN — Hợp đồng thuê ngoài (Tầng 2, chủ đề G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Controls': 'Thông tư 83/2025/TT-NHNN — Kiểm soát thuê ngoài',
        'Circular 83/2025/TT-NHNN — Outsourcing Due Diligence (Layer 2, theme G)': 'Thông tư 83/2025/TT-NHNN — Thẩm định thuê ngoài (Tầng 2, chủ đề G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Fallback Provider (Layer 2, theme G)': 'Thông tư 83/2025/TT-NHNN — Nhà cung cấp dự phòng thuê ngoài (Tầng 2, chủ đề G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Materiality (Layer 2, theme G)': 'Thông tư 83/2025/TT-NHNN — Tính trọng yếu của thuê ngoài (Tầng 2, chủ đề G)',
        'Circular 83/2025/TT-NHNN — Outsourcing Monitoring (Layer 2, theme G)': 'Thông tư 83/2025/TT-NHNN — Giám sát thuê ngoài (Tầng 2, chủ đề G)',
        'Circular 83/2025/TT-NHNN — Phụ lục V/VI Technical References (Layer 5)': 'Thông tư 83/2025/TT-NHNN — Tham chiếu kỹ thuật Phụ lục V/VI (Tầng 5)',
        'Circular 83/2025/TT-NHNN — Policy Register (Layer 2, theme C)': 'Thông tư 83/2025/TT-NHNN — Sổ đăng ký chính sách (Tầng 2, chủ đề C)',
        'Circular 83/2025/TT-NHNN — Professional Ethics (Layer 2, theme C)': 'Thông tư 83/2025/TT-NHNN — Đạo đức nghề nghiệp (Tầng 2, chủ đề C)',
        'Circular 83/2025/TT-NHNN — Risk Appetite (Layer 3)': 'Thông tư 83/2025/TT-NHNN — Khẩu vị rủi ro (Tầng 3)',
        'Circular 83/2025/TT-NHNN — Risk Committee Coordination (Layer 2, theme E)': 'Thông tư 83/2025/TT-NHNN — Phối hợp ủy ban rủi ro (Tầng 2, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Risk Data Governance (Layer 3, theme E/F) — phased to 2028-01-01': 'Thông tư 83/2025/TT-NHNN — Quản trị dữ liệu rủi ro (Tầng 3, chủ đề E/F) — lộ trình đến 2028-01-01',
        'Circular 83/2025/TT-NHNN — Risk Limit Review (Layer 3, theme E)': 'Thông tư 83/2025/TT-NHNN — Rà soát hạn mức rủi ro (Tầng 3, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Risk Limits Framework (Layer 3, theme E)': 'Thông tư 83/2025/TT-NHNN — Khung hạn mức rủi ro (Tầng 3, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Risk Management Function (Layer 2, theme E)': 'Thông tư 83/2025/TT-NHNN — Chức năng quản lý rủi ro (Tầng 2, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Risk Methodology and Models (Layer 2, theme E)': 'Thông tư 83/2025/TT-NHNN — Phương pháp và mô hình rủi ro (Tầng 2, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Risk Reporting (Layer 2, theme E)': 'Thông tư 83/2025/TT-NHNN — Báo cáo rủi ro (Tầng 2, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Risk Reporting Cadence (Layer 4, theme F)': 'Thông tư 83/2025/TT-NHNN — Tần suất báo cáo rủi ro (Tầng 4, chủ đề F)',
        'Circular 83/2025/TT-NHNN — SBV Remediation Submission (Layer 5)': 'Thông tư 83/2025/TT-NHNN — Nộp khắc phục NHNN (Tầng 5)',
        'Circular 83/2025/TT-NHNN — SBV Submission Channels (Layer 5)': 'Thông tư 83/2025/TT-NHNN — Kênh nộp NHNN (Tầng 5)',
        'Circular 83/2025/TT-NHNN — Sector Applicability (Layer 1)': 'Thông tư 83/2025/TT-NHNN — Phạm vi áp dụng theo lĩnh vực (Tầng 1)',
        'Circular 83/2025/TT-NHNN — Segregation of Duties (Layer 2, theme C)': 'Thông tư 83/2025/TT-NHNN — Phân tách nhiệm vụ (Tầng 2, chủ đề C)',
        'Circular 83/2025/TT-NHNN — Senior Management Supervision (Layer 2, theme A)': 'Thông tư 83/2025/TT-NHNN — Giám sát của Ban điều hành (Tầng 2, chủ đề A)',
        'Circular 83/2025/TT-NHNN — Strategic Risk (Layer 3, theme E)': 'Thông tư 83/2025/TT-NHNN — Rủi ro chiến lược (Tầng 3, chủ đề E)',
        'Circular 83/2025/TT-NHNN — Stress Testing (Layer 3, theme E) — phased to 2028-01-01': 'Thông tư 83/2025/TT-NHNN — Kiểm thử căng thẳng (Tầng 3, chủ đề E) — lộ trình đến 2028-01-01',
        'Circular 83/2025/TT-NHNN — Supervisory Board (Layer 2, theme A)': 'Thông tư 83/2025/TT-NHNN — Ban Kiểm soát (Tầng 2, chủ đề A)',
        'Circular 83/2025/TT-NHNN — Supervisory Findings Register (Layer 4, theme F)': 'Thông tư 83/2025/TT-NHNN — Sổ đăng ký phát hiện giám sát (Tầng 4, chủ đề F)',
        'Circular 83/2025/TT-NHNN — Three Lines Roles and Escalation (Layer 2, theme B)': 'Thông tư 83/2025/TT-NHNN — Vai trò ba tuyến và leo thang (Tầng 2, chủ đề B)',
        'Circular 83/2025/TT-NHNN — Three Lines of Defence (Layer 2)': 'Thông tư 83/2025/TT-NHNN — Ba tuyến bảo vệ (Tầng 2)',
        'Circular 83/2025/TT-NHNN — Violation Escalation (Layer 2, theme D)': 'Thông tư 83/2025/TT-NHNN — Leo thang vi phạm (Tầng 2, chủ đề D)',
        // Sprint 62.49.1 (E12.5 pass 1, P3) — consumer-rights and food-traceability references.
        'Law 19/2023/QH15 — Điều 31 khoản 2': 'Luật 19/2023/QH15 — Điều 31 khoản 2',
        'Law 19/2023/QH15 and Decree 55/2024/ND-CP official Government portal metadata.': 'Siêu dữ liệu chính thức của Luật 19/2023/QH15 và Nghị định 55/2024/NĐ-CP trên Cổng Thông tin điện tử Chính phủ.',
        'Circular 11/2026/TT-BCT — Điều 6 khoản 2': 'Thông tư 11/2026/TT-BCT — Điều 6 khoản 2',
        'Circular 11/2026/TT-BCT — Điều 12 khoản 2': 'Thông tư 11/2026/TT-BCT — Điều 12 khoản 2',
        'Circular 11/2026/TT-BCT — Điều 15 khoản 1': 'Thông tư 11/2026/TT-BCT — Điều 15 khoản 1',
        'Circular 11/2026/TT-BCT — Điều 15 khoản 2': 'Thông tư 11/2026/TT-BCT — Điều 15 khoản 2',
        'Circular 63/2026/TT-BCT — Điều 10 khoản 2': 'Thông tư 63/2026/TT-BCT — Điều 10 khoản 2',
        'Circular 63/2026/TT-BCT — Điều 10 khoản 3': 'Thông tư 63/2026/TT-BCT — Điều 10 khoản 3',
        'Circular 63/2026/TT-BCT — Điều 19 khoản 1': 'Thông tư 63/2026/TT-BCT — Điều 19 khoản 1',
    },
    framework_authorities: {
        'Quốc hội (National Assembly)': 'Quốc hội',
        'Ministry of Public Security / A05 Department': 'Bộ Công an / Cục A05',
        'Ministry of Public Security': 'Bộ Công an',
        'Ministry of Information and Communications': 'Bộ Thông tin và Truyền thông',
        'Government of Vietnam': 'Chính phủ Việt Nam',
        'European Data Protection Board (EDPB)': 'Ủy ban Bảo vệ Dữ liệu Châu Âu (EDPB)',
        'ENISA / National CSIRTs': 'ENISA / CSIRT Quốc gia',
        'State Bank of Vietnam': 'Ngân hàng Nhà nước Việt Nam',
    },
    tour_titles: {
        access_accountability: 'Hướng dẫn Trách nhiệm truy cập',
        assessments: 'Hướng dẫn Đánh giá',
        audit_trail: 'Hướng dẫn Dấu vết kiểm toán',
        classification: 'Hướng dẫn Phân loại dữ liệu',
        compliance_forms: 'Hướng dẫn Biểu mẫu tuân thủ',
        connectors: 'Hướng dẫn Kết nối',
        consent_properties: 'Hướng dẫn Thuộc tính đồng ý',
        consent: 'Hướng dẫn Đồng ý',
        dashboard: 'Hướng dẫn Bảng điều khiển',
        data_mapping: 'Hướng dẫn Bản đồ dữ liệu',
        data_subjects: 'Hướng dẫn Chủ thể dữ liệu',
        deletion_orchestration: 'Hướng dẫn Điều phối xóa dữ liệu',
        discovery: 'Hướng dẫn Phát hiện dữ liệu',
        governance: 'Hướng dẫn Quản trị',
        help_center: 'Hướng dẫn Trung tâm trợ giúp',
        incident_ops: 'Hướng dẫn Vận hành sự cố',
        incidents: 'Hướng dẫn Sự cố',
        localization: 'Hướng dẫn Bản địa hóa',
        monitoring: 'Hướng dẫn Giám sát',
        onboarding: 'Hướng dẫn Khởi tạo',
        organizations: 'Hướng dẫn Tổ chức',
        partner_workspace: 'Hướng dẫn Không gian đối tác',
        platform_settings: 'Hướng dẫn Cài đặt nền tảng',
        privacy_scanner: 'Hướng dẫn Quét quyền riêng tư',
        program_governance: 'Hướng dẫn Quản trị chương trình',
        rights_requests: 'Hướng dẫn Yêu cầu quyền',
        task_management: 'Hướng dẫn Quản lý nhiệm vụ',
        vendor_risk: 'Hướng dẫn Rủi ro nhà cung cấp',
    },
    tour_descriptions: {
        access_accountability: 'Với vai trò Trưởng Kiểm toán Nội bộ (P-VN-10), rà soát bằng chứng truy cập, kiểm toán việc sử dụng quyền, và điều tra các mẫu bất thường để chứng minh tính toàn vẹn và bảo mật theo Điều 5(1)(f) GDPR.',
        assessments: 'Với vai trò DPO Doanh nghiệp (P-VN-01), thực hiện đánh giá tác động xử lý theo Nghị định 356, xác định khoảng trống tuân thủ, và đánh giá rủi ro chuyển dữ liệu xuyên biên giới theo Luật BVDLCN.',
        audit_trail: 'Với vai trò Trưởng Kiểm toán Nội bộ (P-VN-10), truy vấn bằng chứng xuyên phân hệ, tập hợp gói kiểm toán, và xuất nhật ký chống giả mạo cho các hồ sơ nộp cơ quan.',
        classification: 'Với vai trò Quản trị Dữ liệu (P-VN-05), xây dựng phân loại dữ liệu, gán nhãn mức độ nhạy cảm, thực thi chính sách lưu trữ, và giải quyết khoảng trống bao phủ theo yêu cầu Luật BVDLCN.',
        compliance_forms: 'Với vai trò DPO Doanh nghiệp (P-VN-01), duyệt, hoàn thành và nộp các biểu mẫu pháp quy chính thức Mẫu số 02a, Mẫu số 02b, và các Mẫu số khác cho hồ sơ nộp Bộ Công an theo Nghị định 356/2025/NĐ-CP.',
        connectors: 'Với vai trò Trưởng Hệ thống CNTT (P-VN-05), thu thập yêu cầu nghiệp vụ cho tích hợp, ánh xạ kết nối với luồng dữ liệu tuân thủ, và xác minh sẵn sàng POC trước khi triển khai.',
        consent_properties: 'Với vai trò DPO Doanh nghiệp (P-VN-01), cấu hình triển khai CMP: đăng ký tài sản số, mẫu chuẩn cho banner đồng ý PDPL nhất quán, và ma trận liên kết thuộc tính với hoạt động xử lý.',
        consent: 'Với vai trò DPO Doanh nghiệp (P-VN-01), quản lý vòng đời chính sách đồng ý: xác định mục đích thu thập, thực thi quyền rút đồng ý theo Luật BVDLCN, và tích hợp với Nền tảng Quản lý Đồng ý.',
        dashboard: 'Với vai trò DPO Doanh nghiệp (P-VN-01), làm quen với trung tâm điều hành tuân thủ hiển thị thời hạn Luật BVDLCN, SLA vi phạm, và KPI sẵn sàng kiểm toán.',
        data_mapping: 'Với vai trò Quản trị Dữ liệu (P-VN-05), xây dựng sổ đăng ký ROPA, lập bản đồ luồng dữ liệu xuyên biên giới, và duy trì sổ hoạt động xử lý theo yêu cầu Luật BVDLCN.',
        data_subjects: 'Với vai trò DPO Doanh nghiệp (P-VN-01) hoặc Trưởng Tuân thủ Giáo dục (P-VN-13), quản lý hồ sơ chủ thể dữ liệu thống nhất liên kết bản ghi đồng ý, yêu cầu quyền, và hoạt động dòng thời gian trên toàn nền tảng.',
        deletion_orchestration: 'Với vai trò DPO (P-VN-01), xác minh xóa dữ liệu toàn diện trên hệ thống nội bộ và nhà cung cấp bên thứ ba, với chuỗi bằng chứng mật mã cho tuân thủ quyền xóa theo Điều 17 GDPR.',
        discovery: 'Với vai trò Quản trị Dữ liệu (P-VN-05), chạy quét tự động phát hiện dữ liệu cá nhân trên các hệ thống kết nối, rà soát kết quả phân loại, và đưa vào phân hệ Phân loại cho gán nhãn Luật BVDLCN.',
        governance: 'Với vai trò Quản lý Rủi ro Nhà cung cấp (P-VN-08), duy trì sổ đăng ký nhà cung cấp, theo dõi chuỗi xử lý phụ, đánh giá rủi ro chuyển dữ liệu xuyên biên giới, và thực thi quy trình quản trị theo Luật BVDLCN.',
        help_center: 'Dành cho tất cả vai trò — DPO, kiểm toán viên, trưởng CNTT, và quản lý tuân thủ — tìm câu trả lời, hướng dẫn thực hành, và tài liệu theo từng phân hệ để hỗ trợ quy trình tuân thủ hàng ngày.',
        incident_ops: 'Với vai trò Chỉ huy Sự cố (P-VN-09), kích hoạt quy trình ứng phó, theo dõi tuân thủ SLA trong khung 72 giờ thông báo Luật BVDLCN, quản lý leo thang, và phối hợp phản hồi nhà cung cấp.',
        incidents: 'Với vai trò Chỉ huy Sự cố (P-VN-09), phát hiện và báo cáo vi phạm dữ liệu theo nghĩa vụ thông báo 72 giờ Luật BVDLCN cho Ủy ban BVDLCN, phân loại theo mức độ nghiêm trọng, và xây dựng hồ sơ sự cố chuẩn kiểm toán.',
        localization: 'Với vai trò DPO Doanh nghiệp (P-VN-01), quản lý vòng đời khung tuân thủ: cài đặt gói thị trường Việt Nam, kích hoạt khung Luật BVDLCN và Nghị định 13, ánh xạ yêu cầu với phân hệ nền tảng, và quản lý bản dịch.',
        monitoring: 'Với vai trò DPO Doanh nghiệp (P-VN-01), thiết lập chương trình giám sát tuân thủ liên tục, theo dõi thay đổi pháp quy, đo lường KPI, và quản lý các trường hợp tương tác pháp quy theo Luật BVDLCN.',
        onboarding: 'Với vai trò Đào tạo Tuân thủ (P-VN-02), cung cấp đào tạo qua hướng dẫn tương tác, tải dữ liệu mẫu thực tế cho bài thực hành, và chạy trình hướng dẫn thiết lập nhanh.',
        organizations: 'Với vai trò DPO (P-VN-01), cấu hình cơ cấu tuân thủ đa tổ chức, thiết lập phân cấp bộ phận, và định tuyến yêu cầu chủ thể dữ liệu trong tập đoàn.',
        partner_workspace: 'Với vai trò Quản lý Tài khoản Đối tác, tiếp nhận tổ chức đối tác, cấu hình cấp dịch vụ, theo dõi kết quả tuân thủ, và quản lý Không gian đối tác.',
        platform_settings: 'Với vai trò Quản trị Nền tảng, quản lý tất cả cấu hình vận hành — danh tính, bảo mật, tích hợp, và quyền truy cập phân hệ làm nền tảng cho chương trình tuân thủ.',
        privacy_scanner: 'Với vai trò Phân tích Quyền riêng tư (P-VN-06), chạy quét giám sát liên tục phát hiện vi phạm đồng ý cookie, trình theo dõi trái phép, và lỗ hổng chính sách — tạo bằng chứng cho tuân thủ ePrivacy và GDPR.',
        program_governance: 'Điều hướng giữa Mô hình Trưởng thành, Đánh giá, Khoảng trống Bằng chứng, Tóm tắt Điều hành, và nhiều hơn nữa. Mỗi phân hệ con đóng góp vào cái nhìn toàn diện về sức khỏe chương trình nội bộ.',
        rights_requests: 'Với vai trò DPO Doanh nghiệp (P-VN-01), quản lý yêu cầu quyền chủ thể dữ liệu theo Luật BVDLCN với thời hạn 15 ngày, xác minh danh tính, và dấu vết giải quyết chuẩn kiểm toán.',
        task_management: 'Định tuyến nhiệm vụ tuân thủ giữa các vai trò, theo dõi thời hạn SLA, và tự động hóa quy trình giữ cho nhóm của bạn có trách nhiệm.',
        vendor_risk: 'Với vai trò Quản lý Rủi ro Nhà cung cấp (P-VN-08), chấm điểm rủi ro bên thứ ba, thực thi rà soát cổng, và kích hoạt đánh giá lại — khác biệt với Quản trị Chương trình theo dõi trưởng thành nội bộ.',
    },
    // ---------- Tong hop (Sprint 28.7.1) ----------
    consolidation: {
        title: 'Hồ sơ tổng hợp',
        loading_cases: 'Đang tải danh sách hồ sơ tổng hợp',
        loading_case_detail: 'Đang tải chi tiết hồ sơ',
        new_case: 'Tạo hồ sơ tổng hợp',
        case_count: 'hồ sơ',
        created: 'Đã tạo hồ sơ tổng hợp',
        create: 'Tạo hồ sơ',
        creating: 'Đang tạo...',
        cancel: 'Hủy',
        no_cases: 'Không tìm thấy hồ sơ tổng hợp.',
        all_statuses: 'Tất cả trạng thái',
        all_purposes: 'Tất cả mục đích',
        filter_status: 'Lọc theo trạng thái',
        filter_purpose: 'Lọc theo mục đích',
        col_title: 'Tiêu đề',
        col_purpose: 'Mục đích',
        col_status: 'Trạng thái',
        col_progress: 'Tiến độ',
        col_deadline: 'Hạn chót',
        col_department: 'Phòng ban',
        col_version: 'Phiên bản',
        col_evidence: 'Bằng chứng',
        sections_accepted: 'đã duyệt',
        prev: 'Trước',
        next: 'Tiếp',
        page: 'Trang',
        prev_page: 'Trang trước',
        next_page: 'Trang tiếp',
        field_title: 'Tiêu đề',
        field_purpose: 'Mục đích',
        field_framework: 'Mã khung tuân thủ',
        field_deadline: 'Hạn chót',
        // fix-sprint-20260821-2140 F7 — see en.ts. The control is a people picker,
        // not a free-text id field.
        field_reviewer: 'Người xem xét',
        title_placeholder: 'Nhập tiêu đề hồ sơ',
        framework_placeholder: 'Chọn khung tuân thủ (không bắt buộc)',
        reviewer_placeholder: 'Chọn người xem xét',
        /*
         * fix-sprint-20260821-2140 F6 — see en.ts for the defect.
         *
         * R-44: `summary`, `risk_assessment` and `mitigation_measures` are governed
         * terms in `registry.en-vi.json` and are used verbatim as approved —
         * 'Tóm tắt' (id `summary`), 'Đánh giá rủi ro' (id
         * `risk-assessment--assessments`) and 'Biện pháp giảm thiểu rủi ro' (id
         * `mitigation-measures`, whose `vi_deprecated` explicitly retires the
         * shorter 'Biện pháp giảm thiểu'). 'Chi tiết' for Details is not governed;
         * it is the rendering already used for `details` elsewhere in this bundle.
         */
        field_summary: 'Tóm tắt',
        field_details: 'Chi tiết',
        field_risk_assessment: 'Đánh giá rủi ro',
        field_mitigation_measures: 'Biện pháp giảm thiểu rủi ro',
        // fix-sprint-20260717-2118-followup F1/F2
        section_case_context: 'Bối cảnh hồ sơ',
        section_review_plan: 'Kế hoạch xem xét',
        purposes: {
            dpia_filing: 'Nộp DPIA',
            cross_border_filing: 'Nộp chuyển dữ liệu xuyên biên giới',
            annual_governance_attestation: 'Chứng nhận quản trị hàng năm',
            breach_package: 'Gói sự cố vi phạm',
            audit_inspection_pack: 'Gói kiểm toán thành trả',
        },
        statuses: {
            draft: 'Nhập',
            collecting: 'Đang thu thập',
            consolidating: 'Đang tổng hợp',
            review: 'Xem xét',
            corrections: 'Chỉnh sửa',
            pending_approval: 'Chờ phê duyệt',
            approved: 'Đã phê duyệt',
            completed: 'Hoàn thành',
            closed: 'Đã đóng',
            rejected: 'Từ chối',
        },
        section_statuses: {
            pending: 'Chờ xử lý',
            in_progress: 'Đang thực hiện',
            submitted: 'Đã nộp',
            accepted: 'Đã chấp nhận',
            needs_correction: 'Cần chỉnh sửa',
            corrected: 'Đã chỉnh sửa',
        },
        flag_types: {
            missing_section: 'Thiếu phần',
            conflicting_entry: 'Dữ liệu xung đột',
            stale_entry: 'Dữ liệu cũ',
            missing_evidence: 'Thiếu bằng chứng',
            incomplete_data: 'Dữ liệu không đầy đủ',
            duplicate_entry: 'Dữ liệu trùng lặp',
        },
        flag_severities: {
            critical: 'Nghiêm trọng',
            warning: 'Cảnh báo',
            info: 'Thông tin',
        },
        sections_title: 'Các phần',
        no_sections: 'Chưa có phân nào được gán.',
        flags_title: 'Có cảnh báo',
        no_flags: 'Không phát hiện có cảnh báo.',
        open: 'đang mở',
        approval_chain: 'Chuỗi phê duyệt',
        pending: 'Chờ xử lý',
        audit_trail: 'Nhật ký kiểm toán',
        no_audit: 'Không có sự kiện kiểm toán.',
        auto_assign: 'Tự động gán phần',
        assign_department: 'Chỉ định phòng ban',
        assign_dept_modal_title: 'Chỉ định phần cho phòng ban',
        field_section_title: 'Tiêu đề phần',
        field_section_description: 'Mô tả',
        field_assignee: 'Người được phân công',
        select_department_placeholder: 'Chọn phòng ban…',
        select_assignee_placeholder: 'Chọn người được phân công…',
        section_assigned: 'Đã chỉ định phần',
        start_collection: 'Bắt đầu thu thập',
        review_case: 'Xem xét hồ sơ',
        generate_export: 'Tạo xuất',
        review_title: 'Xem xét tổng hợp',
        advance_approval: 'Chuyển sang phê duyệt',
        back_to_case: 'Quay lại hồ sơ',
        accept: 'Chấp nhận',
        return_section: 'Trả lại',
        return_comment: 'Nhận xét trả lại...',
        resolve: 'Giải quyết',
        dismiss: 'Bỏ qua',
        resolution_notes: 'Ghi chú giải quyết...',
        notes: 'Ghi chú',
        section_accepted: 'Phân đã được chấp nhận',
        section_returned: 'Phần đã trả lại để chỉnh sửa',
        advanced_to_approval: 'Hồ sơ đã chuyển sang chờ phê duyệt',
        section_data: 'Dữ liệu phân',
        save_progress: 'Lưu tiến độ',
        submit_section: 'Nộp phần',
        submitting: 'Đang nộp...',
        resubmit: 'Nộp lại',
        progress_saved: 'Đã lưu tiến độ',
        section_submitted: 'Đã nộp phần',
        correction_required: 'Yêu cầu chỉnh sửa',
        evidence_title: 'Bằng chứng',
        no_evidence: 'Không có bằng chứng đính kèm.',
        add_evidence: 'Thêm bằng chứng',
        evidence_added: 'Đã thêm bằng chứng',
        evidence_files: 'tệp bằng chứng',
        uploaded_by: 'tải lên bởi',
        comments_title: 'Bình luận',
        no_comments: 'Chưa có bình luận.',
        comment_placeholder: 'Thêm bình luận...',
        add_comment: 'Thêm bình luận',
        comment_added: 'Đã thêm bình luận',
        view_data: 'Xem dữ liệu đã nộp',
        export_title: 'Xuất hồ sơ',
        export_generated: 'Đã tạo gói xuất',
        regenerate: 'Tạo lại',
        regenerating: 'Đang tạo lại...',
        generated_at: 'Tạo lúc',
        artifacts_title: 'Tài liệu xuất',
        artifact_type: 'Loại tài liệu',
        file_name: 'Tên tệp',
        file_size: 'Kích thước',
        generated: 'Đã tạo',
        download: 'Tải xuống',
        artifacts: {
            master_report: 'Báo cáo tổng hợp',
            evidence_bundle: 'Gói bằng chứng (ZIP)',
            contributor_lineage: 'Lịch sử đóng góp',
            conflict_resolution: 'Giải quyết xung đợt',
            approval_history: 'Lịch sử phê duyệt',
        },
        official_forms: 'Biểu mẫu chính thức',
        forms_description: 'Các biểu mẫu chính thức sau đây có thể được tạo từ dữ liệu tổng hợp. Biểu mẫu chính thức tách biệt với tài liệu làm việc nội bộ.',
        errors: {
            load_failed: 'Không thể tải dữ liệu. Vui lòng thử lại.',
            create_failed: 'Không thể tạo hồ sơ. Vui lòng thử lại.',
            required_fields: 'Vui lòng điền đầy đủ tất cả các trường bắt buộc.',
            not_found: 'Không tìm thấy.',
            comment_required: 'Yêu cầu bình luận khi trả lại phân.',
            notes_required: 'Yêu cầu ghi chú khi giải quyết hoặc bỏ qua có cảnh báo.',
            assign_missing_fields: 'Bộ phận và người được phân công là bắt buộc.',
            assign_failed: 'Không thể chỉ định phần. Vui lòng thử lại.',
            no_departments_with_heads: 'Không tìm thấy phòng ban đang hoạt động nào có người phụ trách. Vui lòng thêm người phụ trách phòng ban hoặc chỉ định phần thủ công.',
            transition_failed: 'Không thể chuyển trạng thái hồ sơ. Vui lòng thử lại.',
            auto_assign_failed: 'Không thể tự động phân công các phần. Vui lòng thử lại.',
            save_failed: 'Không thể lưu phần. Vui lòng thử lại.',
            submit_failed: 'Không thể gửi phần. Vui lòng thử lại.',
            // fix-sprint-20260827-2129 residue (B-F18 class) — the review, section and
            // export pages' catch blocks fell back to hardcoded English.
            accept_failed: 'Không thể chấp nhận phần. Vui lòng thử lại.',
            return_failed: 'Không thể trả lại phần. Vui lòng thử lại.',
            flag_action_failed: 'Không thể cập nhật cảnh báo. Vui lòng thử lại.',
            comment_failed: 'Không thể thêm bình luận. Vui lòng thử lại.',
            evidence_failed: 'Không thể thêm bằng chứng. Vui lòng thử lại.',
            export_failed: 'Không thể tạo gói xuất. Vui lòng thử lại.',
        },
        announce_loaded_cases: 'Đã tải {count} hồ sơ tổng hợp',
        announce_case_detail_loaded: 'Đã tải chi tiết hồ sơ',
        announce_case_transitioned: 'Hồ sơ đã chuyển sang {status}',
        announce_flag_resolved: 'Đã giải quyết cảnh báo',
        announce_flag_dismissed: 'Đã bỏ qua cảnh báo',
        case_detail_loaded: 'Đã tải chi tiết hồ sơ',
        sections_auto_assigned: 'Các phần đã được tự động phân công theo phân cấp phòng ban',
    },
    // ---------- Rights Request Import (Sprint 40.0.0) ----------
    rights_requests: {
        import: {
            title: 'Nhập hồ sơ',
            nav_title: 'Nhập hàng loạt',
            description: 'Tải lên tệp CSV để nhập hàng loạt các hồ sơ yêu cầu quyền.',
            select_file: 'Chọn tệp CSV',
            file_help: 'CSV với tiêu đề khớp các trường hồ sơ.',
            column_count_help: 'Hàng có số giá trị khác với số cột trong hàng tiêu đề sẽ không được nhập và được liệt kê trong mục Lỗi kèm số hàng.',
            // fix-sprint #431 — was hard-coded English on the Import page.
            required_columns: 'Cột bắt buộc:',
            file_too_large: 'Tệp quá lớn. Kích thước tối đa là 2MB.',
            preview: 'Xem trước',
            columns_detected: 'Số cột phát hiện: {count}',
            column_mapping: 'Ánh xạ cột',
            import_button: 'Nhập',
            import_complete: 'Nhập hoàn tất',
            import_error: 'Nhập thất bại',
            result: 'Kết quả nhập',
            total: 'Tổng cộng',
            imported: 'Đã nhập',
            skipped: 'Bỏ qua',
            failed: 'Thất bại',
            errors: 'Lỗi',
            error_row: 'Hàng',
            error_field: 'Trường',
            error_message: 'Thông báo',
            history: 'Lịch sử nhập',
            no_history: 'Chưa có lịch sử nhập.',
            history_file: 'Tên tệp',
            history_date: 'Ngày',
        },
        // Sprint 48.1.1 (finish) — Trang xử lý DSR theo lô (workflow Forseti AI).
        batch: {
            nav_title: 'Xử lý theo lô',
            page_title: 'Xử lý DSR theo lô',
            page_subtitle: 'Tải lên CSV các DSR đang chờ. Forseti soạn nháp phản hồi xác nhận cho từng yêu cầu và xếp hàng nhiệm vụ xác minh cho mỗi dòng. DPO xem xét + chấp nhận từng phản hồi trước khi gửi.',
            upload_heading: 'Tải lên',
            csv_hint: 'Cột bắt buộc: request_id, requester_email, request_type. Tuỳ chọn: deadline (ISO-8601), notes, requester_locale (ngôn ngữ của phản hồi được soạn, ví dụ en hoặc vi; nếu để trống, hệ thống dùng ngôn ngữ mặc định của tổ chức).',
            rows_heading: 'Đã phân tích {count} dòng',
            submit_label: 'Chạy lô',
            submitting: 'Đang soạn…',
            col_request_id: 'Mã yêu cầu',
            col_email: 'Email người yêu cầu',
            col_type: 'Loại',
            col_status: 'Trạng thái',
            col_actions: 'Thao tác',
            status_queued: 'Trong hàng đợi',
            status_drafted: 'Đã soạn',
            status_failed: 'Thất bại',
            status_accepted: 'Đã chấp nhận',
            status_rejected: 'Đã từ chối',
            status_parsing_error: 'Lỗi phân tích',
            templates: {
                access: 'Chúng tôi xác nhận đã nhận yêu cầu truy cập dữ liệu cá nhân của bạn. Chúng tôi sẽ phản hồi trước {deadline}, kèm theo bản sao dữ liệu cá nhân của bạn mà chúng tôi đang xử lý, mục đích xử lý dữ liệu cá nhân và các bên tiếp nhận, theo [{frameworks}]. Vui lòng phản hồi nếu bạn cần làm rõ thêm thông tin; nếu không, chúng tôi sẽ cung cấp đầy đủ.',
                deletion: 'Chúng tôi xác nhận đã nhận yêu cầu xóa dữ liệu cá nhân của bạn theo [{frameworks}]. Chúng tôi sẽ xác định các bản ghi thuộc phạm vi yêu cầu, áp dụng các trường hợp vẫn phải tiếp tục lưu trữ (lệnh lưu giữ theo pháp luật, nghĩa vụ theo hợp đồng) và xác nhận việc hoàn tất trước {deadline}.',
                correction: 'Chúng tôi xác nhận đã nhận yêu cầu chỉnh sửa dữ liệu cá nhân của bạn theo [{frameworks}]. Vui lòng cho biết các trường thông tin bạn muốn chỉnh sửa và giá trị mới; chúng tôi sẽ chuyển yêu cầu đến bộ phận liên quan và xác nhận trước {deadline}.',
                objection: 'Chúng tôi xác nhận đã nhận ý kiến phản đối xử lý dữ liệu cá nhân của bạn theo [{frameworks}]. Chúng tôi sẽ tạm dừng hoạt động xử lý liên quan trong thời gian xem xét lý do của bạn và phản hồi trước {deadline}.',
                portability: 'Chúng tôi xác nhận đã nhận yêu cầu chuyển dữ liệu cá nhân của bạn theo [{frameworks}]. Chúng tôi sẽ xuất dữ liệu cá nhân thuộc phạm vi yêu cầu theo định dạng có cấu trúc, thông dụng và máy có thể đọc được, và xác nhận trước {deadline}.',
                restriction: 'Chúng tôi xác nhận đã nhận yêu cầu hạn chế xử lý dữ liệu cá nhân của bạn theo [{frameworks}]. Chúng tôi sẽ đánh dấu các bản ghi liên quan là bị hạn chế xử lý và phản hồi trước {deadline}.',
                consent_withdrawal: 'Chúng tôi xác nhận đã nhận yêu cầu rút lại sự đồng ý của bạn theo [{frameworks}]. Hoạt động xử lý chỉ dựa trên sự đồng ý đã rút lại sẽ chấm dứt; hoạt động xử lý dựa trên căn cứ khác (nghĩa vụ theo quy định của pháp luật, hợp đồng) vẫn tiếp tục, trừ khi bạn phản đối riêng. Chúng tôi sẽ xác nhận trước {deadline}.',
                protective_measures: 'Chúng tôi xác nhận đã nhận yêu cầu áp dụng biện pháp, giải pháp bảo vệ dữ liệu cá nhân của bạn theo [{frameworks}]. Chúng tôi sẽ đánh giá, triển khai các biện pháp bảo vệ dữ liệu cá nhân phù hợp và xác nhận trước {deadline}.',
                processing_information: 'Chúng tôi xác nhận đã nhận yêu cầu được biết về hoạt động xử lý dữ liệu cá nhân của bạn theo [{frameworks}]. Chúng tôi sẽ cho bạn biết dữ liệu cá nhân nào của bạn đang được xử lý, mục đích xử lý dữ liệu cá nhân và các bên tiếp nhận, và phản hồi trước {deadline}.',
                consent_decision: 'Chúng tôi xác nhận đã nhận quyết định đồng ý hoặc không đồng ý cho phép xử lý dữ liệu cá nhân của bạn theo [{frameworks}]. Chúng tôi sẽ ghi nhận và áp dụng quyết định đó đối với hoạt động xử lý dựa trên sự đồng ý của bạn, và xác nhận trước {deadline}.',
                deadline_fallback: 'thời hạn theo quy định của pháp luật áp dụng đối với yêu cầu của bạn',
            },
            errors: {
                csv_empty: 'Tệp CSV trống.',
                csv_missing_header: 'Tệp CSV thiếu cột bắt buộc: {header}.',
                row_missing_field: 'Thiếu trường bắt buộc (request_id, requester_email hoặc request_type).',
                row_unknown_type: 'Loại yêu cầu không xác định: {type}.',
                read_failed: 'Không thể đọc tệp CSV.',
                run_failed: 'Không thể chạy lô.',
                decision_failed: 'Không thể lưu quyết định.',
            },
            synthesis_statuses: {
                model: 'Do mô hình trí tuệ nhân tạo soạn',
                template_parse_failed: 'Mẫu tiêu chuẩn: mô hình trí tuệ nhân tạo không trả về nội dung sử dụng được',
                template_provider_failed: 'Mẫu tiêu chuẩn: lệnh gọi mô hình trí tuệ nhân tạo không thành công',
                template_not_configured: 'Mẫu tiêu chuẩn: chưa cấu hình mô hình trí tuệ nhân tạo',
                template_by_design: 'Mẫu tiêu chuẩn: quy trình này không dùng mô hình trí tuệ nhân tạo cho trường này',
            },
            csv_picker_label: 'Tệp CSV',
            draft_source: 'Nguồn bản nháp',
            draft_language: 'Ngôn ngữ bản nháp: {locale}',
            accept: 'Chấp nhận',
            reject: 'Từ chối',
            permission_denied: 'Bạn cần cả quyền nhập hồ sơ và quyền trò chuyện với Forseti để chạy hàng loạt.',
            col_draft: 'Phản hồi đã soạn',
            view_draft: 'Xem phản hồi đã soạn',
            frameworks_cited: 'Khung tuân thủ được trích dẫn',
        },
    },
    // ---------- Assessment Triggers settings (Sprint 40.1.0) ----------
    assessment_triggers: {
        title: 'Kích hoạt đánh giá',
        subtitle: 'Cấu hình tạo đánh giá tự động và thông báo DPO cho quy trình bảo mật.',
        auto_create_dpia_label: 'Tự động tạo DPIA khi hoạt động xử lý được đánh dấu yêu cầu DPIA',
        auto_notify_new_purpose_label: 'Thông báo cho nhân sự bảo vệ dữ liệu cá nhân (DPO) khi tạo mục đích xử lý dữ liệu cá nhân mới',
        auto_notify_cross_border_label: 'Tự động thông báo DPO khi thêm truyền dữ liệu xuyên biên giới vào hoạt động xử lý',
        default_dpo_label: 'DPO mặc định',
        default_dpo_placeholder: 'Chọn DPO mặc định...',
        notification_channels_label: 'Kênh thông báo',
        channel_in_app: 'Trong ứng dụng',
        channel_email: 'Email',
        save_success: 'Đã lưu cài đặt kích hoạt đánh giá.',
        save_error: 'Không thể lưu cài đặt kích hoạt đánh giá.',
        fetch_error: 'Không thể tải cài đặt kích hoạt đánh giá.',
        fetch_users_error: 'Không thể tải danh sách người dùng.',
        announce_loaded: 'Đã tải cài đặt kích hoạt đánh giá',
        dpia_status: 'Trạng thái DPIA',
        dpia_linked: 'DPIA đã liên kết',
        dpia_required_no_dpia: 'Yêu cầu DPIA — Chưa tạo',
        create_dpia: 'Tạo DPIA',
        create_dpia_success: 'Đã tạo DPIA và liên kết với hoạt động.',
        create_dpia_error: 'Không thể tạo DPIA cho hoạt động.',
        view_dpia: 'Xem DPIA',
        dpo_warning_title: 'DPO mặc định không phải là người dùng đang hoạt động',
        dpo_warning_body: 'DPO mặc định không còn là người dùng đang hoạt động của tổ chức. Các DPIA mới được tạo mà không chỉ định người xem xét, nên bất kỳ người dùng nào có quyền phê duyệt DPIA đều có thể quyết định. Hãy chọn một người dùng đang hoạt động làm DPO mặc định.',
        auto_notify_cross_border_help: 'Khi một hoạt động xử lý dữ liệu cá nhân được lưu với điểm đến xuyên biên giới mà trước đó chưa có, DPO mặc định được thông báo qua các kênh bên dưới. Nếu chưa có DPO mặc định, các Chủ sở hữu tuân thủ được thông báo.',
        auto_notify_processor_change_label: 'Tạo yêu cầu đánh giá lại DPIA khi bên xử lý thay đổi',
        auto_notify_processor_change_help: 'Một thay đổi đối với nhà cung cấp, bên xử lý phụ hoặc thông tin bên xử lý của một hoạt động xử lý dữ liệu cá nhân sẽ tạo một công việc đánh giá lại, kèm danh sách bằng chứng cần kiểm tra lại, cho mỗi DPIA có nêu nhà cung cấp hoặc hoạt động đó. DPIA nào còn công việc đánh giá lại trước đó chưa đóng sẽ không nhận thêm công việc thứ hai.',
        notification_channels_help: 'Nơi gửi thông báo về chuyển dữ liệu cá nhân xuyên biên giới. Tùy chọn thông báo của từng người nhận vẫn được áp dụng.',
    },
    // ---------- Data Subject Profiles (Sprint 40.2.0) ----------
    data_subjects: {
        title: 'Hồ sơ Chủ thể Dữ liệu',
        nav_title: 'Chủ thể Dữ liệu',
        nav: {
            profiles: 'Hồ sơ',
        },
        create: 'Tạo Hồ sơ',
        edit: 'Sửa Hồ sơ',
        delete: 'Xóa Hồ sơ',
        delete_confirm: 'Bạn có chắc chắn muốn xóa hồ sơ chủ thể dữ liệu này?',
        display_name: 'Tên hiển thị',
        email: 'Email',
        phone: 'Điện thoại',
        employee_id: 'Mã nhân viên',
        student_id: 'Mã sinh viên',
        notes: 'Ghi chú',
        external_refs: 'Tham chiếu bên ngoài',
        cases_count: 'Vụ việc',
        workflows_count: 'Hồ sơ Đồng ý',
        last_activity: 'Hoạt động gần nhất',
        timeline: 'Dòng thời gian',
        link_case: 'Thêm Vụ việc DSR',
        link_workflow: 'Thêm Quy trình Đồng ý',
        no_profiles: 'Không tìm thấy hồ sơ chủ thể dữ liệu nào.',
        search_placeholder: 'Tìm theo tên, email, điện thoại hoặc mã...',
        create_success: 'Đã tạo hồ sơ chủ thể dữ liệu.',
        create_error: 'Không thể tạo hồ sơ chủ thể dữ liệu.',
        update_success: 'Đã cập nhật hồ sơ chủ thể dữ liệu.',
        update_error: 'Không thể cập nhật hồ sơ chủ thể dữ liệu.',
        delete_success: 'Đã xóa hồ sơ chủ thể dữ liệu.',
        delete_error: 'Không thể xóa hồ sơ chủ thể dữ liệu.',
        link_case_success: 'Đã liên kết vụ việc với hồ sơ.',
        link_case_error: 'Không thể liên kết vụ việc với hồ sơ.',
        link_workflow_success: 'Đã liên kết quy trình với hồ sơ.',
        link_workflow_error: 'Không thể liên kết quy trình với hồ sơ.',
        load_error: 'Không thể tải hồ sơ chủ thể dữ liệu.',
        detail_load_error: 'Không thể tải hồ sơ chủ thể dữ liệu.',
        timeline_load_error: 'Không thể tải dòng thời gian.',
        tab_cases: 'Vụ việc DSR',
        tab_consent: 'Hồ sơ Đồng ý',
        tab_timeline: 'Dòng thời gian',
        tab_consent_workflows: 'Quy trình Đồng ý',
        tab_web_consent: 'Đồng ý CMP',
        web_consent_empty: 'Không tìm thấy bản ghi đồng ý CMP cho chủ thể này.',
        web_consent_pagination: 'Các trang bản ghi đồng ý CMP',
        web_consent_actions: {
            grant: 'Đã đồng ý',
            revoke: 'Đã rút lại',
            update: 'Đã cập nhật',
            reject_all: 'Đã từ chối tất cả',
            accept_all: 'Đã đồng ý tất cả',
        },
        web_consent_load_error: 'Không thể tải bản ghi đồng ý CMP.',
        col_policy_version: 'Phiên bản Chính sách',
        col_versions: 'Phiên bản',
        col_consent_version: 'Đồng thuận',
        col_cookie_declaration_version: 'Khai báo Cookie',
        col_purposes: 'Mục đích',
        purpose_granted: 'Đồng ý',
        purpose_denied: 'Từ chối',
        granted_domains: 'Đồng ý',
        denied_domains: 'Từ chối',
        col_action: 'Hành động',
        col_timestamp: 'Thời gian',
        col_domain: 'Tên miền',
        no_cases: 'Không có vụ việc liên kết.',
        no_workflows: 'Không có quy trình đồng ý liên kết.',
        no_timeline: 'Không có sự kiện dòng thời gian.',
        case_id: 'Mã Vụ việc',
        case_status: 'Trạng thái',
        case_type: 'Loại Yêu cầu',
        case_created: 'Ngày tạo',
        workflow_id: 'Mã Quy trình',
        workflow_type: 'Loại',
        workflow_status: 'Trạng thái',
        workflow_created: 'Ngày tạo',
        timeline_date: 'Ngày',
        timeline_event: 'Sự kiện',
        timeline_details: 'Chi tiết',
        timeline_time: 'Thời gian',
        timeline_type: 'Loại',
        timeline_summary: 'Tóm tắt',
        type_case: 'Vụ việc DSR',
        type_consent_workflow: 'Quy trình Đồng ý',
        profile_info: 'Thông tin Hồ sơ',
        announce_loaded: 'Đã tải hồ sơ chủ thể dữ liệu',
        announce_detail_loaded: 'Đã tải hồ sơ chủ thể dữ liệu',
        select_case: '— Chọn một trường hợp —',
        select_workflow: '— Chọn một quy trình làm việc —',
        no_cases_hint: 'Liên kết các trường hợp để xem ở đây.',
        no_workflows_hint: 'Liên kết quy trình đồng ý để xem ở đây.',
        // fix-sprint-20260411-0440-followup F2/F3 — the link pickers' failed option reads.
        case_options_read_subject: 'các vụ việc có thể liên kết',
        workflow_options_read_subject: 'các quy trình đồng ý có thể liên kết',
        external_identifiers: 'Mã định danh bên ngoài',
        external_identifiers_desc: 'Các mã định danh mà các loại hồ sơ đã cài đặt khai báo cho chủ thể dữ liệu. Yêu cầu xóa dữ liệu được đối chiếu với các hồ sơ đã cấp theo các mã này.',
        external_identifiers_none_declared: 'Không có loại hồ sơ đã cài đặt nào khai báo mã định danh bên ngoài cho chủ thể dữ liệu.',
        external_identifiers_load_error: 'Không thể đọc các trường mã định danh bên ngoài.',
        external_identifiers_edit_unavailable: 'Không thể đọc các trường mã định danh bên ngoài, nên lần lưu này không thay đổi các trường đó.',
        external_identifier_hint: 'Để trống để xóa.',
        external_ref_conflicts_heading: 'Xung đột mã định danh',
        external_ref_conflict: 'Ngày {date}, một hồ sơ {kind} được tạo cho hồ sơ chủ thể này với {label} khác với giá trị đã ghi nhận tại đây. Giá trị đã ghi nhận được giữ nguyên; hãy kiểm tra giá trị nào là đúng.',
        external_ref_conflict_unlabelled: 'Ngày {date}, một hồ sơ được cấp đã được tạo cho hồ sơ chủ thể này với {label} khác với giá trị đã ghi nhận tại đây. Giá trị đã ghi nhận được giữ nguyên; hãy kiểm tra giá trị nào là đúng.',
        external_ref_conflict_open_record: 'Mở hồ sơ được cấp',
        profile_stale: 'Hồ sơ chủ thể này đã thay đổi sau khi bạn mở, nên thay đổi của bạn chưa được lưu. Hồ sơ đã được tải lại; hãy thực hiện lại thay đổi.',
        identifier_produced_by_record: '{label} được ghi nhận bởi một hồ sơ đã cấp, nên không thể xóa hoặc thay đổi tại đây.',
    },
    // fix-sprint-20260415-0434 F13 — Visual Data Flow Map keys.
    flows: {
        map: {
            description_prefix: '{systems} hệ thống · {flows} luồng · {crossBorder} xuyên biên giới · {highRisk} rủi ro cao/nghiêm trọng',
            switch_to_list: 'Chuyển sang dạng danh sách',
            switch_to_list_aria: 'Chuyển sang chế độ xem bảng',
            svg_aria: 'Bản đồ luồng dữ liệu: {systems} hệ thống, {flows} luồng, {crossBorder} xuyên biên giới',
            selected_system: 'Hệ thống đã chọn',
            drill_hint: 'Mở tab danh sách để chỉnh sửa các luồng, DPIA và phân công nhà cung cấp liên kết với hệ thống này.',
        },
    },
    packages: {
        light: {
            name: 'Cơ bản',
            description: 'Công cụ tuân thủ quyền riêng tư thiết yếu cho nhóm nhỏ',
        },
        standard: {
            name: 'Tiêu chuẩn',
            description: 'Nền tảng tuân thủ đầy đủ tính năng cho tổ chức đang phát triển',
        },
        enterprise_unlimited: {
            name: 'Doanh nghiệp không giới hạn',
            description: 'Tuân thủ cấp doanh nghiệp với hỗ trợ đa tổ chức và dịch vụ chuyên biệt',
        },
    },
    // Sprint 47.5.1 — Forseti AI Legal Advisor: cài đặt nhà cung cấp + bảng sử dụng
    forseti: {
        // Sprint 63.32.0 (Q1, #543) — the record summary's facts, rendered on screen;
        // the model prompt keeps the English summary.
        summary_fields: {
            accepted_until: 'Chấp nhận đến',
            active_timers: 'Bộ đếm thời hạn đang chạy',
            actual_release: 'Ngày phát hành thực tế',
            ad_hoc_answered: 'Báo cáo đột xuất đã trả lời',
            ad_hoc_report_entries: 'Mục báo cáo đột xuất',
            affected_systems: 'Hệ thống bị ảnh hưởng',
            amended_on: 'Sửa đổi gần nhất',
            amendments: 'Số lần sửa đổi',
            answered_on: 'Ngày trả lời',
            approval_mode: 'Chế độ phê duyệt',
            approved: 'Đã phê duyệt',
            approved_on: 'Ngày phê duyệt',
            approved_risk_tier: 'Mức độ rủi ro đã phê duyệt',
            artifact_kind: 'Loại chứng từ',
            authorisation_kind: 'Loại giấy phép',
            authority: 'Cơ quan',
            authority_reference_recorded: 'Đã ghi số tham chiếu của cơ quan',
            authority_request: 'Yêu cầu của cơ quan',
            authority_requests: 'Yêu cầu của cơ quan',
            batches: 'Lô',
            breach_notification: 'Thông báo vi phạm',
            categories: 'Thẻ phân loại',
            channel: 'Kênh',
            claimant: 'Người khiếu nại',
            classification: 'Phân loại',
            classifications: 'Số phân loại',
            closed_on: 'Ngày đóng',
            closure_approved_on: 'Ngày phê duyệt đóng',
            completed_on: 'Ngày hoàn thành',
            conformity_records: 'Hồ sơ hợp quy',
            conformity_route: 'Phương thức đánh giá hợp quy',
            consent_cover_state: 'Phạm vi sự đồng ý',
            consent_evidence_referenced: 'Đã dẫn chiếu bằng chứng đồng ý',
            corrective_measures: 'Biện pháp khắc phục',
            country: 'Quốc gia',
            covered_services: 'Dịch vụ được cấp phép',
            credentials: 'Thông tin đăng nhập',
            cross_border_transfers: 'Chuyển dữ liệu xuyên biên giới',
            cross_mapping_recorded_on: 'Ngày ghi đối chiếu chéo',
            cryptographic_assets: 'Tài sản mật mã',
            current_version: 'Phiên bản hiện hành',
            data_categories: 'Loại dữ liệu',
            data_element: 'Phần tử dữ liệu',
            data_tier: 'Cấp dữ liệu',
            dataset: 'Bộ dữ liệu',
            deadline: 'Thời hạn',
            decided_on: 'Ngày quyết định',
            declared_on: 'Ngày công bố',
            declared_quantity: 'Khối lượng kê khai',
            deployment_context: 'Bối cảnh triển khai',
            deposit_submission_recorded: 'Đã ghi hồ sơ nộp lưu chiểu',
            description_recorded: 'Đã ghi mô tả',
            destination_country: 'Quốc gia nhận',
            details_recorded: 'Đã ghi chi tiết',
            dictionary_version: 'Phiên bản từ điển dữ liệu',
            document_type: 'Loại tài liệu',
            documents: 'Tài liệu',
            domains_evaluated: 'Lĩnh vực đã đánh giá',
            dpa_status: 'Trạng thái DPA',
            dpo_assigned: 'Đã phân công DPO',
            due: 'Hạn',
            effective_on: 'Ngày hiệu lực',
            evidence: 'Tham chiếu bằng chứng',
            evidence_attachments: 'Tệp bằng chứng',
            evidence_pack_linked: 'Đã liên kết gói bằng chứng',
            expires_on: 'Ngày hết hạn',
            filing_linked: 'Đã liên kết hồ sơ nộp',
            filing_type: 'Loại hồ sơ',
            financial_crime_signed: 'Bộ phận phòng chống tội phạm tài chính đã ký',
            fine_areas: 'Lĩnh vực xử phạt được dẫn chiếu',
            form_type: 'Biểu mẫu',
            format: 'Định dạng',
            framework: 'Khung tuân thủ',
            gate_kind: 'Loại điều kiện lưu chiểu',
            generated_tasks: 'Nhiệm vụ đã tạo',
            identity_linked: 'Đã liên kết hồ sơ danh tính',
            identity_verification: 'Xác minh danh tính',
            incident: 'Sự cố',
            incidents: 'Sự cố',
            intake_evidence: 'Bằng chứng tiếp nhận',
            intake_kind: 'Hình thức tiếp nhận',
            issued_on: 'Ngày cấp',
            jurisdiction: 'Phạm vi tài phán',
            kind: 'Loại',
            kind_declared_by_pack: 'Loại được gói đã cài đặt khai báo',
            legal_basis: 'Cơ sở pháp lý',
            legal_review_status: 'Rà soát pháp lý',
            legal_reviews: 'Rà soát pháp lý',
            licence_kind: 'Loại giấy phép',
            lifecycle_events: 'Sự kiện vòng đời',
            lifecycle_stage: 'Giai đoạn vòng đời',
            linked_activities: 'Hoạt động liên kết',
            linked_authority_requests: 'Yêu cầu của cơ quan liên kết',
            linked_dpia: 'DPIA liên kết',
            linked_frameworks: 'Khung tuân thủ liên kết',
            location: 'Vị trí',
            lodged_by_role: 'Người nộp',
            lodged_on: 'Ngày nộp',
            model_version: 'Phiên bản mô hình',
            name: 'Tên',
            notification_entries: 'Mục thông báo',
            notify_decision: 'Quyết định thông báo',
            offerings: 'Dịch vụ được nêu tên',
            onboarding_status: 'Tiếp nhận nhà cung cấp',
            open_findings: 'Phát hiện chưa xử lý',
            ot_asset: 'Tài sản OT',
            outcome_reports: 'Báo cáo kết quả',
            overall_score: 'Điểm tổng thể',
            parcel: 'Bưu gửi',
            period_end: 'Cuối kỳ',
            period_start: 'Đầu kỳ',
            periodic_report_entries: 'Mục báo cáo định kỳ',
            personal_data: 'Dữ liệu cá nhân',
            phases_completed: 'Giai đoạn đã hoàn thành',
            phases_total: 'Tổng số giai đoạn',
            planned_release: 'Ngày phát hành dự kiến',
            playbook_version: 'Phiên bản kịch bản',
            pre_existing_on_commencement: 'Đã tồn tại khi văn bản có hiệu lực',
            priority: 'Mức ưu tiên',
            privacy_signed: 'Bộ phận bảo vệ dữ liệu cá nhân đã ký',
            procedure_reference: 'Số tham chiếu thủ tục',
            product: 'Sản phẩm',
            products: 'Sản phẩm',
            proof_attachments: 'Tệp chứng minh',
            provider: 'Nhà cung cấp',
            provider_type: 'Loại nhà cung cấp',
            publication_evidence: 'Bằng chứng công bố',
            published_on: 'Ngày công bố',
            purpose_recorded: 'Đã ghi mục đích',
            purposes: 'Mục đích đã ghi',
            questions_answered: 'Câu hỏi đã trả lời',
            questions_total: 'Tổng số câu hỏi',
            raised_on: 'Ngày phát sinh',
            rationale_recorded: 'Đã ghi lý do',
            readiness_record: 'Hồ sơ sẵn sàng',
            recall_scope: 'Phạm vi thu hồi',
            receipt_recorded: 'Đã ghi biên nhận',
            received_on: 'Ngày nhận',
            recipient: 'Bên nhận',
            recipient_class: 'Nhóm bên nhận',
            reclassification_changed_fields: 'Dữ liệu đầu vào thay đổi so với lần phân loại đã phê duyệt',
            reclassification_review: 'Rà soát đề nghị phân loại lại',
            reclassification_signal_since: 'Tín hiệu phân loại lại từ',
            reconciliation_exceptions: 'Ngoại lệ đối chiếu',
            record_kind: 'Loại hồ sơ',
            recorded_on: 'Ngày ghi nhận',
            reference: 'Số tham chiếu',
            releasable_marked_on: 'Ngày đánh dấu được phát hành',
            relied_on_events: 'Sự kiện bưu gửi được dẫn chứng',
            remediation_plans: 'Kế hoạch khắc phục',
            remediation_tasks: 'Nhiệm vụ khắc phục đã tạo',
            renewal_of_earlier: 'Gia hạn của chứng thư trước',
            replaces: 'Thay thế',
            reporting_years: 'Năm báo cáo',
            representative_consents: 'Hồ sơ đồng ý của người đại diện',
            request_type: 'Loại yêu cầu',
            requester_recorded: 'Đã ghi người yêu cầu',
            responses: 'Phản hồi',
            responsible_person_recorded: 'Đã ghi người phụ trách',
            retention_duty: 'Nghĩa vụ lưu trữ',
            review_due: 'Hạn rà soát',
            revoked_on: 'Ngày thu hồi',
            rights_evidence: 'Mục bằng chứng quyền',
            risk_level: 'Mức rủi ro',
            root_cause_recorded: 'Đã ghi nguyên nhân gốc',
            rule_type: 'Loại quy tắc',
            sellers: 'Người bán',
            serial_reference: 'Số sê-ri',
            service_type: 'Loại dịch vụ',
            sharing_events: 'Lần chia sẻ',
            sharing_refusals: 'Lần chia sẻ bị từ chối',
            shipment: 'Lô hàng',
            sla_state: 'Đồng hồ thời hạn',
            source_country: 'Quốc gia chuyển',
            stage: 'Giai đoạn',
            state: 'Tình trạng',
            status: 'Trạng thái',
            sub_status: 'Trạng thái chi tiết',
            subject: 'Chủ đề',
            subject_kind: 'Loại đối tượng',
            submission_kind: 'Loại hồ sơ nộp',
            submitted_on: 'Ngày nộp',
            successor_recorded: 'Đã ghi chứng thư kế tiếp',
            supplied_on: 'Ngày cung cấp',
            takedown_reason_recorded: 'Đã ghi lý do gỡ bỏ',
            taken_down_on: 'Ngày gỡ bỏ',
            target_date: 'Ngày mục tiêu',
            technical_actions: 'Biện pháp kỹ thuật',
            technical_regulation: 'Quy chuẩn kỹ thuật',
            title: 'Tiêu đề',
            transfer_assessment_referenced: 'Đã dẫn chiếu đánh giá chuyển dữ liệu',
            transfer_mechanism: 'Cơ chế chuyển',
            transfer_review_state: 'Rà soát chuyển dữ liệu',
            transfer_source_recorded: 'Đã ghi cơ sở chuyển đi',
            valid_from: 'Hiệu lực từ',
            valid_until: 'Hiệu lực đến',
            vendor: 'Nhà cung cấp',
            vendor_type: 'Loại nhà cung cấp',
            version: 'Phiên bản',
            versions: 'Số phiên bản',
            withdrawal_determination_recorded: 'Đã ghi quyết định rút',
        },
        summary_codes: {
            acknowledged: 'Đã xác nhận',
            active: 'Đang hiệu lực',
            all: 'Tất cả người phê duyệt',
            any: 'Bất kỳ người phê duyệt nào',
            approved: 'Đã phê duyệt',
            archived: 'Đã lưu trữ',
            blocked: 'Bị chặn',
            breached: 'Đã quá hạn',
            cancelled: 'Đã hủy',
            closed: 'Đã đóng',
            completed: 'Hoàn thành',
            critical: 'Nghiêm trọng',
            declared: 'Đã công bố',
            do_not_notify: 'Không thông báo',
            draft: 'Bản nháp',
            escalated: 'Đã chuyển cấp',
            expired: 'Hết hạn',
            filed: 'Đã nộp',
            high: 'Cao',
            in_progress: 'Đang thực hiện',
            in_review: 'Đang rà soát',
            inactive: 'Không hoạt động',
            known_data_subject: 'Chủ thể dữ liệu đã biết',
            labelled_claimant: 'Người khiếu nại được gắn nhãn',
            lodged: 'Đã nộp',
            low: 'Thấp',
            medium: 'Trung bình',
            new: 'Mới',
            not_started: 'Chưa bắt đầu',
            notify: 'Thông báo',
            open: 'Đang mở',
            overdue: 'Quá hạn',
            paused: 'Tạm dừng',
            pending: 'Đang chờ',
            personal_data: 'Dữ liệu cá nhân',
            published: 'Đã công bố',
            received: 'Đã nhận',
            rejected: 'Bị từ chối',
            resolved: 'Đã giải quyết',
            revoked: 'Đã thu hồi',
            signed: 'Đã ký',
            special_category: 'Dữ liệu cá nhân nhạy cảm',
            submitted: 'Đã nộp',
            suspended: 'Tạm đình chỉ',
            taken_down: 'Đã gỡ bỏ',
            unclassified: 'Chưa phân loại',
            undecided: 'Chưa quyết định',
            under_review: 'Đang rà soát',
            unverified: 'Chưa xác minh',
            verified: 'Đã xác minh',
            withdrawn: 'Đã rút',
        },
        summary_flag_yes: 'Có',
        summary_flag_no: 'Không',
        summary_not_recorded: 'Chưa ghi nhận',
        summary_fields_label: 'Thông tin hồ sơ',
        providerSettings: {
            title: 'Cài đặt Nhà cung cấp AI Forseti',
            subtitle: 'Cấu hình nhà cung cấp Claude cho Cố vấn Pháp lý AI Forseti.',
            healthHeading: 'Tình trạng nhà cung cấp',
            statusLabel: 'Trạng thái',
            statusOk: 'OK',
            statusFailed: 'Không khả dụng',
            providerLabel: 'Nhà cung cấp',
            providerClaudeApi: 'Claude API',
            providerCliRelay: 'Bộ chuyển tiếp Claude CLI',
            providerAesirManaged: 'Token do Aesir quản lý',
            lastCheckedLabel: 'Lần kiểm tra cuối',
            reasonLabel: 'Lý do',
            refreshButton: 'Làm mới',
            apiKeyHeading: 'Khóa API Claude',
            apiKeyHint: 'Đặt khóa API kích hoạt chế độ Claude API. Để trống để dùng CLI relay cục bộ (chế độ phát triển / tự host).',
            apiKeyLabel: 'Khóa API',
            apiKeyMinLength: 'Tối thiểu 32 ký tự. Mã hóa khi lưu; sẽ không hiển thị lại.',
            apiKeyTooShort: 'Khóa API phải có ít nhất 32 ký tự.',
            apiKeySaved: 'Đã lưu khóa API. Đang làm mới tình trạng…',
            apiKeyCleared: 'Đã xóa khóa API. Forseti hiện sử dụng CLI relay cục bộ.',
            setKeyButton: 'Lưu khóa API',
            clearKeyButton: 'Xóa khóa API (dùng CLI relay)',
        },
        // Owner ruling 2026-10-10 — Forseti → AI Model (provider, model, effort).
        aiModel: {
            title: 'Mô hình AI',
            sidebarLabel: 'Mô hình AI',
            subtitle: 'Chọn nhà cung cấp AI, mô hình và mức suy luận cho mọi yêu cầu Forseti. Tổ chức của bạn kết nối tài khoản nhà cung cấp riêng bằng khóa API riêng, và nhà cung cấp đó tính phí trực tiếp cho bạn theo mức Forseti sử dụng.',
            loadError: 'Không thể đọc cài đặt mô hình AI.',
            retrySubject: 'cài đặt mô hình AI',
            generalHeading: 'Chung',
            generalDescription: 'Nhà cung cấp đang hoạt động trả lời mọi phiên trò chuyện, quy trình, đánh giá dạng bảng và soát đỏ của Forseti. Chỉ nhà cung cấp đã lưu khóa API mới có thể được đặt làm nhà cung cấp hoạt động.',
            activeProviderLabel: 'Nhà cung cấp đang hoạt động',
            activeProviderHint: 'Không thể chọn nhà cung cấp chưa lưu khóa API. Hãy lưu khóa trong thẻ của nhà cung cấp đó bên dưới trước.',
            providerNoKey: '{provider} (chưa lưu khóa API)',
            thinkingLabel: 'Hiển thị tóm tắt suy luận trong trò chuyện',
            thinkingHint: 'Khi mô hình trả về bản tóm tắt quá trình suy luận, Forseti hiển thị bản tóm tắt đó phía trên câu trả lời trong trò chuyện tương tác. Quy trình và đánh giá không bị ảnh hưởng.',
            relayProviderLabel: 'Relay CLI cục bộ (phát triển)',
            relayUrlLabel: 'Địa chỉ relay',
            relayUrlHint: 'Địa chỉ của CLI relay cục bộ. Chỉ dùng trong môi trường phát triển và bản cài đặt tự lưu trữ.',
            saveGeneral: 'Lưu cài đặt chung',
            generalSaved: 'Đã lưu cài đặt chung.',
            providersHeading: 'Nhà cung cấp',
            providersDescription: 'Mỗi nhà cung cấp giữ khóa API, mô hình và mức suy luận riêng. Lưu một nhà cung cấp không làm nhà cung cấp đó hoạt động trừ khi bạn chọn Đặt làm nhà cung cấp đang hoạt động.',
            cardDescription: 'Các mô hình của {provider}, được gọi bằng khóa API riêng của tổ chức bạn.',
            cardDescriptionCompatible: 'Bất kỳ điểm cuối nào triển khai API của OpenAI, chẳng hạn cổng mô hình hoặc máy chủ mô hình tự lưu trữ, được gọi bằng khóa API của điểm cuối đó.',
            activeBadge: 'Đang hoạt động',
            keySetBadge: 'Đã lưu khóa API',
            keyMissingBadge: 'Chưa có khóa API',
            apiKeyLabel: 'Khóa API',
            apiKeySavedHint: 'Đã lưu một khóa kết thúc bằng {hint}. Để trống ô này để giữ khóa đã lưu.',
            apiKeyNoneHint: 'Chưa lưu khóa nào. Khóa được mã hóa khi lưu và sẽ không hiển thị lại sau khi bạn lưu.',
            removeKey: 'Xóa khóa',
            removeKeyTitle: 'Xóa khóa API đã lưu?',
            removeKeyMessage: 'Forseti sẽ không thể gọi {provider} cho đến khi lưu khóa mới. Cài đặt mô hình và mức suy luận được giữ nguyên.',
            removeKeyConfirm: 'Xóa khóa',
            removing: 'Đang xóa khóa…',
            keyRemoved: 'Đã xóa khóa API của {provider}.',
            modelLabel: 'Mô hình',
            modelHint: 'Chọn một mô hình gợi ý hoặc nhập bất kỳ mã mô hình nào {provider} cung cấp.',
            modelHintCompatible: 'Nhập mã mô hình đúng như điểm cuối yêu cầu.',
            modelRequired: 'Nhập mô hình.',
            fastModelLabel: 'Mô hình nhanh (không bắt buộc)',
            fastModelHint: 'Dùng cho tiêu đề cuộc trò chuyện và trích xuất dạng bảng. Để trống để dùng mô hình chính.',
            effortLabel: 'Mức suy luận',
            effortHint: 'Mức suy luận mô hình dành cho mỗi câu trả lời. Các mức mà mô hình đã chọn không chấp nhận sẽ không khả dụng.',
            effortUnsupported: '{effort} không khả dụng cho mô hình này.',
            efforts: {
                default: 'Mặc định của mô hình',
                low: 'Thấp',
                medium: 'Trung bình',
                high: 'Cao',
                xhigh: 'Rất cao',
                max: 'Tối đa',
            },
            apiModeLabel: 'Chế độ API',
            apiModeHint: 'Tự động dùng Responses API cho các mô hình bắt buộc và Chat Completions cho các mô hình còn lại.',
            apiModes: {
                auto: 'Tự động',
                responses: 'Responses API',
                chat_completions: 'Chat Completions API',
            },
            reasoningModeLabel: 'Chế độ suy luận',
            reasoningModeHint: 'Pro dành nhiều suy luận hơn cho mỗi câu trả lời và tốn chi phí hơn. Chế độ này chỉ có cho các mô hình hỗ trợ.',
            reasoningModeUnavailable: 'Pro không khả dụng cho mô hình đã chọn.',
            reasoningModes: {
                standard: 'Tiêu chuẩn',
                pro: 'Pro',
            },
            serviceTierLabel: 'Hạng dịch vụ',
            serviceTierHint: 'Mặc định của dự án dùng hạng đã đặt trong dự án tại nhà cung cấp của bạn.',
            serviceTiers: {
                auto: 'Mặc định của dự án',
                default: 'Tiêu chuẩn',
            },
            baseUrlLabel: 'URL gốc',
            baseUrlHint: 'Địa chỉ gốc API của điểm cuối qua HTTPS, ví dụ https://openrouter.ai/api/v1.',
            baseUrlRequired: 'Nhập URL gốc của điểm cuối.',
            makeActiveLabel: 'Đặt làm nhà cung cấp đang hoạt động',
            saveButton: 'Lưu',
            saved: 'Đã lưu cài đặt của {provider}.',
            testButton: 'Kiểm tra kết nối',
            testing: 'Đang kiểm tra…',
            testNote: 'Kiểm tra dùng cài đặt đã lưu, vì vậy hãy lưu thay đổi trước. Lần kiểm tra gửi một yêu cầu ngắn không chứa dữ liệu khách hàng, và nhà cung cấp có thể tính phí cho yêu cầu này.',
            unsavedNote: 'Thẻ này có thay đổi chưa lưu. Lần kiểm tra dùng cài đặt đã lưu.',
            lastTestHeading: 'Lần kiểm tra gần nhất',
            testNever: 'Chưa kiểm tra.',
            testPassed: 'Đạt',
            testFailed: 'Không thành công',
            testCheckedAt: 'Kiểm tra lúc {time}',
            testError: 'Không thể chạy kiểm tra kết nối.',
            saveError: 'Không thể lưu cài đặt.',
            removeError: 'Không thể xóa khóa API.',
            errors: {
                api_key_required: 'Hãy lưu khóa API cho nhà cung cấp này trước khi đặt làm nhà cung cấp đang hoạt động.',
                api_key_required_for_new_host: 'URL gốc giờ trỏ tới một máy chủ khác. Hãy nhập khóa API của máy chủ đó trước khi lưu; khóa đã lưu không được gửi tới máy chủ mới.',
                invalid_api_key: 'Nhà cung cấp đã từ chối khóa API này.',
                invalid_api_key_format: 'Khóa này không giống khóa của nhà cung cấp này. Hãy kiểm tra bạn đã sao chép toàn bộ khóa.',
                unsupported_model_effort: 'Mô hình đã chọn không chấp nhận mức suy luận này.',
                model_requires_responses: 'Mô hình này cần Responses API. Hãy chọn Tự động hoặc Responses API.',
                base_url_required: 'Nhập URL gốc của điểm cuối.',
                invalid_base_url: 'Nhập URL HTTPS hợp lệ.',
                unsupported_provider_options: 'Các tùy chọn này không có cho nhà cung cấp này.',
            },
        },
        usage: {
            title: 'Mức sử dụng',
            recentHeading: 'Hoạt động gần đây',
            historyHeading: '12 kỳ gần nhất',
            noActivity: 'Chưa có hoạt động trong kỳ này.',
            featureLabel: 'Tính năng',
            whenLabel: 'Thời điểm',
            periodLabel: 'Kỳ',
            // Sprint 47.5.9.6 — phân rã theo tính năng + góc nhìn quản trị theo người dùng.
            byFeatureHeading: 'Tháng này theo tính năng',
            byFeatureEmpty: 'Chưa có hoạt động theo tính năng nào trong kỳ này.',
            featureColumn: 'Tính năng',
            featureUnitsColumn: 'Đơn vị',
            featureRunsColumn: 'Lượt chạy',
            byUserHeading: 'Tháng này theo người dùng (góc nhìn quản trị)',
            byUserEmpty: 'Chưa có hoạt động theo người dùng nào trong kỳ này.',
            userColumn: 'Người dùng',
            reconciliationLinkLabel: 'Xem báo cáo lệch đối soát',
            reconciliationLinkHint: 'Chỉ dành cho quản trị nội bộ Aesir.',
            // Owner ruling 2026-10-10 — consumption by provider, model and effort.
            subtitleProvider: 'Mức Forseti đã sử dụng, cùng nhà cung cấp, mô hình và mức suy luận của từng yêu cầu. Nhà cung cấp AI của tổ chức bạn tính phí trực tiếp cho mức tiêu thụ này.',
            routingHeading: 'Định tuyến hiện tại',
            routingDescription: 'Nhà cung cấp, mô hình và mức suy luận mà mỗi tính năng Forseti đang dùng.',
            routingProviderLabel: 'Nhà cung cấp đang hoạt động',
            routingFeatureColumn: 'Tính năng',
            routingModelColumn: 'Mô hình',
            routingEffortColumn: 'Mức suy luận',
            routingChangeLink: 'Thay đổi cài đặt mô hình AI',
            routingLoadError: 'Không thể đọc định tuyến hiện tại.',
            routingRetrySubject: 'định tuyến hiện tại',
            periodHeading: 'Mức tiêu thụ',
            periodDescription: 'Số yêu cầu và token trong khoảng thời gian bạn chọn. Tháng hiện tại được hiển thị trước.',
            fromLabel: 'Từ ngày',
            toLabel: 'Đến ngày',
            applyPeriod: 'Xem khoảng thời gian',
            periodInvalid: 'Ngày bắt đầu phải trước hoặc trùng ngày kết thúc.',
            summaryLoadError: 'Không thể đọc mức tiêu thụ của khoảng thời gian này.',
            summaryRetrySubject: 'mức tiêu thụ của khoảng thời gian này',
            totalsCalls: 'Yêu cầu',
            totalsInput: 'Token đầu vào',
            totalsOutput: 'Token đầu ra',
            totalsCached: 'Token đầu vào từ bộ nhớ đệm',
            byModelHeading: 'Theo nhà cung cấp, mô hình và mức suy luận',
            byFeaturePeriodHeading: 'Theo tính năng',
            providerColumn: 'Nhà cung cấp',
            modelColumn: 'Mô hình',
            effortColumn: 'Mức suy luận',
            callsColumn: 'Yêu cầu',
            inputColumn: 'Token đầu vào',
            outputColumn: 'Token đầu ra',
            cachedColumn: 'Token đầu vào từ bộ nhớ đệm',
            tokensColumn: 'Token (vào / ra)',
            timeColumn: 'Thời điểm',
            noConsumption: 'Forseti không có yêu cầu nào trong khoảng thời gian này.',
            notRecorded: 'Chưa ghi nhận',
            recentDescription: 'Các yêu cầu gần đây nhất trong khoảng thời gian đã chọn.',
            recentLoadError: 'Không thể đọc hoạt động gần đây.',
            recentRetrySubject: 'hoạt động gần đây',
            byUserPeriodHeading: 'Theo người dùng',
            byUserBasis: 'Tính trên {count} yêu cầu gần đây nhất trong khoảng thời gian này.',
            historyMonthlyHeading: 'Mức tiêu thụ hàng tháng',
            historyConsumedColumn: 'Đơn vị đã dùng',
            historyLoadError: 'Không thể đọc mức tiêu thụ hàng tháng.',
            historyRetrySubject: 'mức tiêu thụ hàng tháng',
            historyEmpty: 'Chưa ghi nhận tháng nào trước đó.',
            featureLabels: {
                chat: 'Trò chuyện',
                workflow: 'Chạy quy trình',
                tabular: 'Trích xuất bảng',
                redline: 'Soát đỏ tài liệu',
                title: 'Tiêu đề hội thoại',
                unknown: 'Khác',
            },
        },
        // Sprint 47.5.9.6 — Báo cáo lệch đối soát Forseti (chỉ dành cho quản trị nội bộ Aesir).
        reconciliation: {
            title: 'Đối soát hạn ngạch Forseti',
            subtitle: 'Mức lệch giữa bộ đếm hạn ngạch cache và sổ cái tính phí gốc. Bộ đối soát chạy mỗi 5 phút và ghi mọi mức lệch vào kênh log có cấu trúc. Chỉ dành cho quản trị nội bộ Aesir.',
            backLink: 'Quay lại trang Sử dụng Forseti',
            stubHeading: 'Nơi ghi kết quả đối soát',
            stubBody: 'Trang này không hiển thị lịch sử các lần chạy. Mỗi lần đối soát ghi số liệu mức lệch vào kênh log có cấu trúc; hãy xem tại đó.',
            permissionDenied: 'Trang này chỉ dành cho quản trị viên nội bộ Aesir. Nếu bạn nghĩ mình cần quyền truy cập, vui lòng liên hệ đại diện AesirX.',
        },
        // Sprint 47.5.2 — Forseti Projects (vỏ workspace).
        projects: {
            title: 'Dự án',
            subtitle: 'Không gian làm việc cho tài liệu, hội thoại, quy trình và rà soát.',
            modeLabel: 'Chế độ xem',
            tabMine: 'Dự án của tôi',
            tabShared: 'Được chia sẻ với tôi',
            searchLabel: 'Tìm kiếm dự án',
            searchPlaceholder: 'Tìm…',
            newButton: 'Dự án mới',
            colName: 'Tên',
            colVisibility: 'Hiển thị',
            colDocs: 'Tài liệu',
            colMembers: 'Thành viên',
            colUpdated: 'Cập nhật',
            visibilityOwn: 'Chỉ của tôi',
            visibilityShared: 'Chia sẻ',
            emptyMine: 'Chưa có dự án. Tạo một dự án để bắt đầu.',
            emptyShared: 'Chưa có dự án nào được chia sẻ với bạn.',
            pageHint: 'Hiển thị {shown} trên {total}.',
            createTitle: 'Dự án mới',
            createSubmit: 'Tạo dự án',
            fieldName: 'Tên',
            fieldDescription: 'Mô tả (tùy chọn)',
            fieldCmNumber: 'Số vụ việc/hồ sơ (tùy chọn)',
            fieldVisibility: 'Hiển thị',
            errorNameRequired: 'Tên là bắt buộc.',
            errorSelectorRequired: 'Chọn một người dùng hoặc nhóm tổ chức để thêm.',
            renameButton: 'Đổi tên',
            renamePrompt: 'Đổi tên dự án',
            deleteButton: 'Xóa',
            deleteConfirm: 'Xóa dự án này? Dự án sẽ biến mất khỏi danh sách của bạn và không thể khôi phục từ sản phẩm.',
            deleteFolderConfirm: 'Xóa thư mục này? Tài liệu bên trong vẫn còn trong dự án nhưng không nằm trong thư mục.',
            removeMemberConfirm: 'Xóa thành viên này?',
            foldersHeading: 'Thư mục',
            foldersEmpty: 'Chưa có thư mục.',
            addFolderButton: 'Thư mục mới',
            addFolderTitle: 'Thư mục mới',
            documentsHeading: 'Tài liệu',
            documentsEmpty: 'Chưa có tài liệu nào được đính kèm.',
            colFilename: 'Tên tệp',
            colAdded: 'Đã thêm',
            unattachButton: 'Bỏ đính kèm',
            membersHeading: 'Thành viên',
            membersEmpty: 'Chỉ chủ sở hữu.',
            addMemberButton: 'Thêm thành viên',
            addMemberTitle: 'Thêm thành viên',
            addMemberSubmit: 'Thêm thành viên',
            colMember: 'Thành viên',
            colRole: 'Vai trò',
            selectorTypeLabel: 'Thêm theo',
            selectorUser: 'ID người dùng',
            selectorGroup: 'ID nhóm tổ chức',
            fieldUserId: 'Người dùng',
            fieldGroupId: 'Nhóm tổ chức',
            fieldRole: 'Vai trò',
            roleAdmin: 'Quản trị',
            roleEditor: 'Biên tập',
            roleViewer: 'Xem',
            notFound: 'Không tìm thấy dự án.',
            // Sprint 47.5.9.3.1 — chuỗi cho bộ chọn + tiêu đề ConfirmDialog.
            selectUserPlaceholder: 'Chọn người dùng…',
            selectGroupPlaceholder: 'Chọn nhóm tổ chức…',
            noUsersAvailable: 'Không có người dùng nào.',
            noGroupsAvailable: 'Không có nhóm tổ chức nào.',
            loadFailed: 'Không thể tải danh sách.',
            deleteProjectTitle: 'Xoá dự án?',
            deleteFolderTitle: 'Xoá thư mục?',
            removeMemberTitle: 'Xoá thành viên?',
            removeMemberConfirmGeneric: 'Xoá thành viên này khỏi dự án?',
            addDocumentButton: 'Thêm tài liệu',
            addDocumentTitle: 'Thêm tài liệu vào dự án',
            fieldDocument: 'Chọn tài liệu',
            selectDocPlaceholder: 'Tìm kiếm tài liệu...',
            ownerLabel: 'Chủ sở hữu hệ thống',
        },
        // Sprint 47.5.4a — Forseti chat shell (chỉ đọc). Streaming + công cụ ở 47.5.4b.
        chat: {
            sidebarLabel: 'Trò chuyện',
            overviewTitle: 'Forseti',
            overviewSubtitle: 'Cố vấn Pháp lý & Tuân thủ AI của bạn — căn cứ dữ liệu tổ chức và các gói pháp lý đã cài.',
            personaSelectorLabel: 'Cố vấn',
            personaHeading: 'Chọn một cố vấn',
            startChatButton: 'Bắt đầu cuộc trò chuyện mới',
            startingChat: 'Đang khởi tạo…',
            recentHeading: 'Cuộc trò chuyện gần đây',
            recentEmpty: 'Chưa có cuộc trò chuyện — hãy bắt đầu ở trên.',
            untitledChat: 'Hội thoại mới',
            chatLoadFailed: 'Forseti không tải được phiên trò chuyện này.',
            streamFailed: 'Forseti không hoàn tất được câu trả lời này. Tin nhắn của bạn vẫn còn trong ô soạn thảo.',
            personaSwitchFailed: 'Không đổi được vai trò cố vấn.',
            renameFailed: 'Không đổi tên được phiên trò chuyện.',
            deleteFailed: 'Không xóa được phiên trò chuyện.',
            messageListLabel: 'Cuộc hội thoại',
            detailSubtitle: 'Cố vấn: {persona}',
            composeHeading: 'Gửi tin nhắn',
            composeLabel: 'Nhắn cho Forseti',
            composeDisabledPlaceholder: 'Cuộc trò chuyện này ở chế độ chỉ đọc.',
            composeDisabledHint: 'Bạn có thể đọc cuộc trò chuyện này nhưng không thể thêm nội dung.',
            switchPersonaHeading: 'Cố vấn',
            presetPersona: 'Cố vấn được đặt sẵn',
            changePersona: 'Đổi cố vấn',
            hidePersonaOptions: 'Ẩn tùy chọn cố vấn',
            starterHeading: 'Bắt đầu bằng một trong các thao tác sau',
            renameButton: 'Đổi tên',
            renamePrompt: 'Đổi tên cuộc trò chuyện',
            deleteButton: 'Xóa',
            deleteConfirm: 'Xóa cuộc trò chuyện này? Cuộc trò chuyện sẽ biến mất khỏi danh sách của bạn và không thể khôi phục từ sản phẩm.',
            notFound: 'Không tìm thấy cuộc trò chuyện.',
            emptyChat: 'Chưa có tin nhắn — hãy chào để bắt đầu.',
            roleUser: 'Bạn',
            roleAssistant: 'Forseti',
            roleSystem: 'Hệ thống',
            thinkingLabel: 'Đang suy nghĩ',
            toolCallPlaceholder: 'Gọi công cụ: ',
            toolResultPlaceholder: 'Kết quả công cụ đang ẩn.',
            docEditPlaceholder: 'Đã đề xuất chỉnh sửa tài liệu (V{version}).',
            disclaimer: 'Forseti hỗ trợ phán đoán của bạn — không thay thế luật sư có giấy phép.',
            // Sprint 47.5.4b — streaming + defenses keys.
            sendButton: 'Gửi',
            sending: 'Đang gửi…',
            composePlaceholder: 'Hỏi Forseti…',
            composingPlaceholder: 'Forseti đang trả lời…',
            streamingPlaceholder: 'Forseti đang gõ…',
            promptInjectionTitle: 'Forseti đã loại bỏ một số token điều khiển.',
            promptInjectionBody: 'Đã loại bỏ các mẫu: {patterns}. Forseti chỉ thấy nội dung văn bản của bạn.',
            rateLimitTitle: 'Bạn đang gửi tin nhắn quá nhanh.',
            rateLimitRetryAfter: 'Thử lại sau {seconds}s.',
            messageLength: '{count} / {max} ký tự',
            messageTooLong: 'Tin nhắn gửi Forseti tối đa {max} ký tự. Hãy rút ngắn tin nhắn hoặc tách thành hai tin nhắn.',
            counselReviewTitle: 'Forseti không chắc chắn ở đây.',
            counselReviewBody: 'Hãy xác nhận với luật sư có giấy phép trước khi hành động theo câu trả lời này.',
            legalConclusionRefused: 'Forseti từ chối đưa ra kết luận pháp lý mà không có căn cứ. Hãy thử search_regulatory trước hoặc chuyển cho luật sư.',
            // Sprint 47.5.4c — ToolCallCard / CreateTaskFromChatModal /
            // AutoRouteHint / ExportChatButton / MessageList.
            toolCallDone: 'Xong.',
            toolCallArgsLabel: 'Tham số',
            toolCallResultLabel: 'Kết quả',
            toolResultLogged: 'Kết quả công cụ đã được ghi vào nhật ký kiểm toán.',
            toolResultAria: 'kết quả công cụ',
            documentEditAria: 'chỉnh sửa tài liệu',
            createTaskFromMessage: 'Tạo công việc từ tin nhắn này',
            createTaskHeading: 'Tạo công việc từ tin nhắn này',
            createTaskTitleLabel: 'Tiêu đề',
            createTaskTitleRequired: 'Tiêu đề là bắt buộc.',
            createTaskDescriptionLabel: 'Mô tả',
            createTaskAssigneeLabel: 'Người được giao',
            createTaskAssigneePlaceholder: 'Chọn người được giao…',
            createTaskAssigneeNone: '— chưa giao —',
            createTaskDueDateLabel: 'Hạn chót',
            createTaskWorkflowLabel: 'Quy trình liên kết (tuỳ chọn)',
            createTaskWorkflowPlaceholder: 'Chọn quy trình…',
            createTaskWorkflowNone: '— không —',
            // Sprint 47.5.9.3.1 — thay window.prompt rename + window.confirm delete.
            renameModalSubmit: 'Đổi tên',
            renameModalSaving: 'Đang lưu…',
            deleteConfirmTitle: 'Xoá cuộc trò chuyện?',
            createTaskSubmit: 'Tạo công việc',
            createTaskSubmitting: 'Đang tạo…',
            cancelButton: 'Huỷ',
            autoRouteHintMessage: 'Câu hỏi này phù hợp hơn với {persona}.',
            autoRouteSwitchButton: 'Chuyển sang {persona}',
            autoRouteSwitching: 'Đang chuyển…',
            handoffSuggestionMessage: 'Hoặc mở cuộc trò chuyện mới với {persona} để mang câu hỏi này theo.',
            handoffSuggestionButton: 'Bắt đầu chat mới với {persona}',
            handoffSuggestionWorking: 'Đang mở…',
            handoffSuggestionDismiss: 'Để sau',
            handoffSuggestionFailed: 'Không thể mở cuộc trò chuyện mới.',
            persona_display: {
                'forseti-generalist': 'Forseti',
                'forseti-compliance': 'Chuyên gia tuân thủ',
                'forseti-legal': 'Cố vấn pháp lý',
                'forseti-dpo': 'Cố vấn DPO',
                'forseti-risk': 'Chuyên gia phân tích rủi ro',
                'forseti-auditor': 'Góc nhìn kiểm toán',
            },
            exportButton: 'Xuất PDF',
            exportRunning: 'Đang xuất…',
            exportSuccess: 'Đã xuất và lưu vào File Browser: {filename}.',
            exportOpenFile: 'Mở trong File Browser',
            exportDownload: 'Tải xuống PDF',
            // Sprint 47.5.7 — citation pill (chú thích nguồn pháp lý).
            citation: {
                verifyBadge: '[VERIFY]',
                verifyAria: 'không thể xác minh trích dẫn — xem lại trước khi dựa vào',
                popoverAria: 'Nguồn cho {label}',
                openSource: 'Mở trang nguồn',
            },
        },
        // Sprint 47.8.0c — huy hiệu Forseti trên trang /admin/audit-trail.
        auditTrail: {
            forsetiBadge: 'Forseti',
            forsetiBadgeTooltip: 'Sự kiện do AI tạo ra từ lineage kiểm toán Forseti.',
        },
        // Sprint 47.8.0b — biến thể nút trên hàng (list page).
        rowAction: {
            shortLabel: 'Forseti',
            ask: 'Hỏi Forseti',
            tooltipOpen: 'Hỏi Forseti về {recordType} này',
            tooltipLocked: '{recordType} này đã bị khóa — Forseti có thể trả lời câu hỏi nhưng không thể thay đổi.',
        },
        // Sprint 47.5.8 — bảng điều khiển nhúng (cross-module).
        // Sprint 47.8.0a — thiết kế lại visual: avatar + tiêu đề + cảnh báo R-39
        // + nhãn thân thiện cho từng loại bản ghi.
        // ── Sprint 63.22.0 — the global Forseti launcher and its launchpad ──
        launcher: {
            openLabel: 'Mở Forseti',
            tooltip: 'Hỏi Forseti (Ctrl+Shift+F)',
            modalTitle: 'Forseti',
            personaHeading: 'Chọn vai trò cố vấn để hỏi',
            scopeHeading: 'Nội dung trò chuyện',
            askAboutRecord: 'Hỏi về {record} này',
            generalChat: 'Trò chuyện chung',
            attachRecord: 'Đính kèm bản ghi',
            attachRecordRequired: 'Hãy chọn một bản ghi để đính kèm, hoặc chọn Trò chuyện chung.',
            recordScopeLost: 'Trang này không còn hiển thị bản ghi nào, nên đây sẽ là một cuộc trò chuyện chung.',
            recentChats: 'Cuộc trò chuyện gần đây',
            recentEmpty: 'Bạn chưa có cuộc trò chuyện nào.',
            resumeChat: 'Tiếp tục {title} — {persona}, {date}',
            startChat: 'Bắt đầu trò chuyện',
            starting: 'Đang bắt đầu trò chuyện…',
            openFullView: 'Mở toàn màn hình',
            loadFailed: 'Forseti không tải được danh sách vai trò cố vấn và các cuộc trò chuyện gần đây.',
            noPersonas: 'Tổ chức của bạn chưa bật vai trò cố vấn Forseti nào.',
        },
        advisorRunPanel: {
            // fix-sprint-20260627-2217-followup F11 — the chat's back control names
            // where it goes (WCAG 2.4.6); it returns to the launchpad.
            backToOptions: 'Quay lại các tùy chọn Forseti',
            workbenchLabel: 'Bàn làm việc Forseti',
            currentRecordLabel: 'Bản ghi hiện tại',
            // Sprint 63.29.0 (Q5, #540) — tóm tắt chỉ được đọc khi được yêu cầu.
            showSummary: 'Xem tóm tắt',
            summaryLoading: 'Đang tải tóm tắt…',
            summaryLoadFailed: 'Không thể tải tóm tắt.',
            summaryUnavailable: 'Không có tóm tắt cho bản ghi này.',
            summaryOnRequestHint: 'Tóm tắt chỉ được đọc khi bạn yêu cầu, và mỗi lần đọc được ghi vào nhật ký truy cập.',
            title: 'Forseti — về bản ghi này',
            heading: 'Forseti — {recordType}',
            summaryLabel: 'Tóm tắt',
            suggestedPersona: 'Persona đề xuất',
            askForseti: 'Hỏi Forseti',
            runWorkflow: 'Chạy quy trình',
            viewLineage: 'Xem lineage kiểm toán',
            createPdplEvidencePack: 'Tạo gói bằng chứng PDPL',
            prepareBreachDraft: 'Chuẩn bị bản nháp thông báo',
            primaryActions: {
                projectSummary: 'Tóm tắt tài liệu dự án',
                supplementSummary: 'Tóm tắt yêu cầu bổ sung',
                authoritySummary: 'Tóm tắt yêu cầu của cơ quan',
                rightsRequestResponse: 'Soạn nháp phản hồi DSR',
                dpiaQuickReview: 'Chạy rà soát nhanh DPIA',
                taskControlWalkthrough: 'Đi qua bằng chứng kiểm soát',
                vendorRiskNarrative: 'Tạo tường thuật rủi ro nhà cung cấp',
                incidentLetter: 'Soạn nháp thư thông báo vi phạm PDPL',
                ropaSufficiency: 'Chạy kiểm tra độ đầy đủ RoPA',
                vendorDpaReview: 'Chạy rà soát DPA nhà cung cấp',
            },
            builtinWorkflowViews: {
                ropaSufficiency: {
                    title: 'Kiểm tra độ đầy đủ RoPA',
                    notice: 'Chạy workflow kiểm tra độ đầy đủ RoPA hiện có cho hoạt động xử lý này. Lần chạy có thể tạo nhiệm vụ theo dõi dạng nháp; người vận hành vẫn rà soát và thực hiện.',
                },
                vendorDpaReview: {
                    title: 'Rà soát DPA nhà cung cấp',
                    notice: 'Chạy workflow rà soát DPA nhà cung cấp hiện có cho hợp đồng nhà cung cấp này. Lần chạy có thể tạo nhiệm vụ theo dõi dạng nháp; người vận hành vẫn rà soát mọi phát hiện và nhiệm vụ.',
                },
                vendorRiskNarrative: {
                    title: 'Tường thuật rủi ro nhà cung cấp',
                    notice: 'Chạy workflow tường thuật rủi ro nhà cung cấp hiện có cho nhà cung cấp này. Kết quả vẫn là bằng chứng nháp; chủ sở hữu rủi ro con người rà soát và phê duyệt trước khi sử dụng.',
                },
                incidentLetter: {
                    title: 'Thư thông báo vi phạm PDPL',
                    notice: 'Chạy workflow thư thông báo vi phạm VN PDPL hiện có cho sự cố hoặc playbook activation này. Kết quả chỉ là bản nháp; việc nộp chính thức cho cơ quan quản lý vẫn cần con người ký duyệt.',
                },
                projectSummary: {
                    title: 'Tóm tắt tài liệu dự án',
                    notice: 'Chạy workflow tóm tắt tài liệu đã tải lên hiện có cho dự án Forseti này. Workflow chỉ đọc và không tạo nhiệm vụ, bằng chứng hoặc cập nhật bản ghi.',
                },
                supplementSummary: {
                    title: 'Tóm tắt yêu cầu bổ sung',
                    notice: 'Chạy workflow tóm tắt tài liệu đã tải lên hiện có cho yêu cầu bổ sung này. Workflow chỉ đọc và không tạo nhiệm vụ, bằng chứng, cập nhật bản ghi hoặc quyết định nộp hồ sơ.',
                },
                authoritySummary: {
                    title: 'Tóm tắt yêu cầu của cơ quan',
                    notice: 'Chạy workflow tóm tắt tài liệu đã tải lên hiện có cho yêu cầu của cơ quan này. Workflow chỉ đọc và không tạo nhiệm vụ, bằng chứng, cập nhật bản ghi, quyết định nộp hồ sơ hoặc bản nháp phản hồi cơ quan.',
                },
                rightsRequestResponse: {
                    title: 'Bản nháp phản hồi DSR',
                    notice: 'Chạy workflow nháp phản hồi DSR hiện có cho yêu cầu quyền này. Kết quả chỉ là bản nháp; việc gửi và cập nhật hồ sơ vẫn phải theo luồng yêu cầu quyền có con người rà soát.',
                },
                dpiaQuickReview: {
                    title: 'Rà soát nhanh DPIA',
                    notice: 'Chạy workflow Rà soát nhanh DPIA hiện có cho DPIA này. Lần chạy có thể tạo nhiệm vụ theo dõi dạng nháp; người vận hành vẫn rà soát mọi phát hiện và nhiệm vụ.',
                },
                taskControlWalkthrough: {
                    title: 'Walkthrough bằng chứng kiểm soát',
                    notice: 'Chạy workflow walkthrough kiểm soát tuân thủ hiện có cho nhiệm vụ này. Workflow phải truy xuất căn cứ quy định trước khi trích dẫn, không đưa ra kết luận pháp lý hoặc đánh dấu kiểm soát/bằng chứng là đã phê duyệt, và chỉ tạo placeholder bằng chứng nháp khi người vận hành yêu cầu rõ ràng.',
                },
            },
            breachDraftNotice: 'Forseti chỉ chuẩn bị nội dung dự thảo cho Mẫu số 08 được liên kết. Forseti không quyết định có phải thông báo hay không và không nộp hoặc gửi biểu mẫu.',
            breachDraftReady: 'Bản nháp Mẫu số 08 đã sẵn sàng để xem xét',
            breachDraftReviewBeforeSelecting: 'Xem xét trước khi chọn',
            breachDraftResolved: {
                accepted: 'Đã chấp nhận: đã áp dụng {count} trường',
                partially_accepted: 'Chấp nhận một phần: đã áp dụng {count} trường',
                rejected: 'Đã từ chối: không áp dụng trường nào',
            },
            workflowHeading: 'Quy trình phù hợp',
            workflowLoading: 'Đang tải các quy trình phù hợp…',
            workflowEmpty: 'Không tìm thấy quy trình phù hợp. Hãy tạo quy trình có hướng dẫn cho bản ghi này.',
            workflowError: 'Không thể tải các quy trình phù hợp.',
            selectWorkflow: 'Chọn {title}',
            workflowSelected: 'Đã chọn quy trình và sẵn sàng chạy cho bản ghi này.',
            workflowRunSelected: 'Chạy quy trình đã chọn',
            workflowStarting: 'Đang khởi chạy quy trình…',
            workflowRunError: 'Không thể khởi chạy quy trình này.',
            workflowCreateGuided: 'Tạo quy trình có hướng dẫn cho bản ghi này',
            lineageHeading: 'Lineage kiểm toán của bản ghi này',
            lineageLoading: 'Đang tải lineage kiểm toán…',
            lineageEmpty: 'Chưa có sự kiện lineage Forseti nào cho bản ghi này.',
            lineageError: 'Không thể tải lineage kiểm toán.',
            retry: 'Thử lại',
            chatContextLoading: 'Đang tải ngữ cảnh bản ghi…',
            chatGuidance: {
                general: 'Forseti có thể tóm tắt bản ghi, xác định thông tin còn thiếu và đề xuất các bước rà soát.',
                privacy: 'Forseti có thể rà soát dữ kiện riêng tư, kiểm tra nghĩa vụ theo các khung đã cài đặt và hỗ trợ chuẩn bị bản nháp để con người xem xét.',
                compliance: 'Forseti có thể xác định khoảng trống tuân thủ, đối chiếu yêu cầu với nguồn đã cài đặt và đề xuất bước tiếp theo có trách nhiệm.',
                legal: 'Forseti có thể tóm tắt bản ghi, tìm nguồn căn cứ và hỗ trợ chuẩn bị bản nháp để cố vấn pháp lý xem xét.',
                risk: 'Forseti có thể đánh giá rủi ro đã ghi nhận, chỉ ra dữ kiện còn thiếu và đề xuất các bước rà soát phù hợp.',
                audit: 'Forseti có thể kiểm tra khoảng trống bằng chứng, liên hệ bản ghi với các kiểm soát đã cài đặt và đề xuất bước theo dõi phục vụ kiểm toán.',
            },
            starterPrompts: {
                identifyGaps: 'Bản ghi này còn thiếu thông tin hoặc bằng chứng nào?',
                reviewFrameworks: 'Tôi cần rà soát những nghĩa vụ nào từ các khung đã cài đặt cho bản ghi này?',
                prepareDraft: 'Hãy giúp tôi chuẩn bị bản nháp chỉ dựa trên bản ghi này và các nguồn đã cài đặt có căn cứ.',
                nextSteps: 'Tôi nên thực hiện các bước rà soát nào tiếp theo?',
                summarizeRecord: 'Hãy tóm tắt bản ghi và chỉ ra những điểm cần con người xem xét.',
                assessRisk: 'Hãy đánh giá các rủi ro đã ghi nhận, xác định dữ kiện còn thiếu và đề xuất bước rà soát.',
            },
            disclaimer: 'Forseti hỗ trợ phán đoán của bạn — không thay thế tư vấn pháp lý có giấy phép.',
            recordType: {
                project: 'Dự án',
                dpia: 'DPIA',
                dossier_filing: 'Hồ sơ nộp',
                transfer_assessment: 'Chuyển dữ liệu xuyên biên giới',
                vendor: 'Nhà cung cấp',
                vendor_contract: 'Hợp đồng nhà cung cấp',
                vendor_acceptance: 'Chấp nhận rủi ro nhà cung cấp',
                incident: 'Sự cố',
                incident_op: 'Hoạt động ứng phó sự cố',
                breach_notification: 'Thông báo vi phạm',
                authority_request: 'Yêu cầu của cơ quan thẩm quyền',
                supplement_request: 'Yêu cầu bổ sung',
                rights_request: 'Yêu cầu quyền của chủ thể dữ liệu',
                contract: 'Hợp đồng',
                task: 'Tác vụ',
                data_mapping_activity: 'Hoạt động RoPA',
                compliance_rule: 'Quy tắc tuân thủ',
                program: 'Chương trình',
                governance_document: 'Tài liệu quản trị',
                remediation_plan: 'Kế hoạch khắc phục',
                cross_border_filing: 'Hồ sơ chuyển dữ liệu xuyên biên giới',
                // Sprint 63.22.0 (OD-A5) — the ten 62.13+ registers with a detail view.
                enforcement_case: 'Vụ việc xử phạt',
                authority_direction: 'Yêu cầu của cơ quan có thẩm quyền (ngoài sự cố)',
                regulated_account: 'Tài khoản chịu quản lý',
                regulatory_placeholder: 'Nội dung dự liệu theo quy định',
                sector_licence: 'Giấy phép ngành',
                credit_information_supply: 'Cung cấp thông tin tín dụng',
                data_service_provider: 'Hồ sơ nhà cung cấp dịch vụ dữ liệu',
                regulatory_disclosure: 'Công bố thông tin',
                issued_record: 'Học bạ số',
                publication: 'Xuất bản phẩm',
            },
        },
        // Sprint 47.9.6 — Mẫu DPIA tự sinh từ Forseti (cross-module workflow).
        autocomplete: {
            // fix-sprint-20260627-2217-followup F9, verifier round 1 — the 409 refusal
            // when no installed framework grounds the draft (raw English before).
            error_no_grounding_scope: 'Forseti không thể soạn bản nháp DPIA này: không có khung tuân thủ đã cài đặt nào cho lựa chọn này ở trạng thái sử dụng được, nên không có văn bản quy định làm căn cứ cho bản nháp. Chưa có nội dung nào được soạn.',
            button_label: 'Yêu cầu Forseti soạn nháp',
            drafting: 'Đang soạn nháp…',
            hint_pick_activity: 'Chọn một hoạt động xử lý liên kết để Forseti có thể soạn nháp.',
            draft_origin_label: 'Bản nháp Forseti — duyệt theo từng trường',
            tokens_label: '≈ {count} token',
            accept_selected: 'Chấp nhận các trường đã chọn',
            reject_all: 'Bỏ bản nháp',
            field_checkbox_label: 'Áp dụng bản nháp Forseti cho {field}',
            // Sprint 48.4.x — nhãn dịch cho 9 giá trị enum DpiaAutocompleteFieldKey
            // để giao diện duyệt theo trường không hiển thị mã snake_case tiếng Anh
            // (sửa lỗi i18n-raw-key-as-label).
            field_labels: {
                description: 'Mô tả',
                purpose: 'Mục đích',
                data_subjects: 'Chủ thể dữ liệu',
                data_types: 'Loại dữ liệu',
                necessity_justification: 'Cần thiết & tương xứng',
                consultation_notes: 'Ghi chú tham vấn',
                dpo_opinion: 'Ý kiến DPO',
                system_ids: 'Hệ thống liên kết',
                vendor_ids: 'Nhà cung cấp liên kết',
            },
            error_generic: 'Forseti không soạn được bản nháp DPIA. Thử lại hoặc bổ sung hoạt động xử lý.',
            // Sprint 48.1.0 — chip nhóm khung tuân thủ + banner xung đột chéo.
            variant_legend: 'Khung tuân thủ',
            variant_label_gdpr: 'GDPR',
            variant_none_available: 'Không có khung tuân thủ đã cài đặt',
            variant_label_pdpl: 'PDPL',
            variant_label_nis2: 'NIS2',
            variant_label_iso27001: 'ISO 27001',
            variant_label_soc2: 'SOC 2',
            conflict_banner: 'Lưu ý: có {count} xung đột giữa các khung tuân thủ áp dụng cho biến thể này. Vui lòng xem xét trước khi chấp nhận.',
        },
        // Sprint 48.1.3 — TIA chuyển dữ liệu xuyên biên giới (workflow đánh giá chuyển nhượng).
        formDraft: {
            button_label: 'Nhờ Forseti soạn thảo biểu mẫu này',
            drafting: 'Đang soạn thảo…',
            draft_origin_label: 'Bản nháp của Forseti — xem xét từng trường',
            tokens_label: '≈ {count} token',
            accept_selected: 'Chấp nhận mục đã chọn',
            reject_all: 'Từ chối bản nháp',
            field_checkbox_label: 'Áp dụng bản nháp Forseti cho {field}',
            excluded_note: '{count} trường không thể soạn thảo (tham chiếu, tệp đính kèm hoặc chỉ đọc).',
            error_generic: 'Forseti không thể soạn thảo biểu mẫu này. Vui lòng thử lại.',
            empty_draft: 'Forseti không tạo bản nháp nào cho biểu mẫu này.',
        },
        tia: {
            // fix-sprint-20260627-2217-followup F9, verifier round 1 — the 409 refusal
            // when no installed framework grounds the draft (raw English before).
            error_no_grounding_scope: 'Forseti không thể soạn bản nháp TIA này: không có khung tuân thủ đã cài đặt nào điều chỉnh hoạt động chuyển dữ liệu này ở trạng thái sử dụng được, nên không có văn bản quy định làm căn cứ cho bản nháp. Chưa có nội dung nào được soạn.',
            button_label: 'Yêu cầu Forseti soạn TIA',
            drafting: 'Đang soạn TIA…',
            hint_pick_destination: 'Hãy điền quốc gia đích trên hồ sơ chuyển dữ liệu trước khi Forseti soạn.',
            draft_origin_label: 'Bản nháp TIA của Forseti — duyệt theo từng trường',
            tokens_label: '≈ {count} token',
            usage_details: 'Chi tiết sử dụng AI',
            accept_selected: 'Chấp nhận các trường đã chọn',
            reject_all: 'Bỏ bản nháp',
            applied_status: 'Đã chấp nhận bản nháp. Các trường đã chọn được lưu vào hồ sơ chuyển dữ liệu.',
            recommended_updates_title: 'Cập nhật hồ sơ được đề xuất',
            mechanism_recommendation: 'Cơ chế chuyển dữ liệu: {value}',
            dpo_review_recommendation: 'Đề nghị DPO xem xét việc chuyển dữ liệu nhạy cảm này.',
            review_date_warning: 'Hãy đặt thời hạn rà soát trước khi cập nhật việc chuyển dữ liệu nhạy cảm này.',
            processing_activity_warning: 'Liên kết ít nhất một hoạt động xử lý / hồ sơ ROPA trước khi hoàn tất TIA.',
            go_to_field: 'Đi đến trường',
            field_checkbox_label: 'Áp dụng bản nháp Forseti cho {field}',
            error_generic: 'Forseti không soạn được bản nháp TIA. Thử lại hoặc bổ sung thông tin chuyển dữ liệu.',
            adequacy_label: 'Cơ chế quốc gia đích',
            adequacy_label_source_route: 'Trường hợp chuyển dữ liệu',
            adequacy_needs_action: 'Cần xử lý',
            adequacy_for_information: 'Để tham khảo',
            adequacy_status_adequacy_decision: 'Có quyết định của EU về mức độ bảo vệ dữ liệu cá nhân tương đương (dữ liệu chuyển ra từ EU/EEA)',
            adequacy_status_non_adequacy_with_sccs: 'Không có quyết định của EU về mức độ bảo vệ dữ liệu cá nhân tương đương — biện pháp theo GDPR Điều 46 cho dữ liệu chuyển ra từ EU/EEA',
            adequacy_status_derogation: 'Trường hợp miễn trừ theo GDPR Điều 49 (dữ liệu chuyển ra từ EU/EEA)',
            adequacy_status_transitional: 'Chuyển tiếp / nội bộ EEA',
            adequacy_status_unknown: 'Không xác định — hãy chọn quốc gia đích',
            adequacy_status_source_jurisdiction_route: 'Chuyển dữ liệu cá nhân ra khỏi Việt Nam — trường hợp lập hồ sơ đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới',
            adequacy_summary_no_destination: 'Chưa chọn quốc gia đích. Hãy chọn quốc gia đích trước khi Forseti soạn thảo đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới.',
            adequacy_summary_intra_eea: 'Chuyển dữ liệu trong EEA ({code}) — đối với dữ liệu chuyển ra từ EU/EEA, GDPR Điều 44–50 không yêu cầu đánh giá tác động chuyển sang nước thứ ba. Việc chuyển dữ liệu cá nhân ra khỏi Việt Nam được đánh giá theo Luật 91/2025/QH15 Điều 20 và Nghị định 356/2025/NĐ-CP Điều 17–18, trừ khi có bằng chứng về một trường hợp không phải lập hồ sơ.',
            adequacy_summary_inbound: 'Quốc gia đích là Việt Nam — bên chuyển dữ liệu tại EU/Vương quốc Anh tự xác lập cơ chế chuyển dữ liệu của mình; quy định của Việt Nam về đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới không áp dụng cho dữ liệu chuyển vào. GDPR chỉ áp dụng khi hồ sơ xác lập được yếu tố làm phát sinh thẩm quyền của EU/EEA.',
            adequacy_summary_us_dpf: 'Bên nhận tại Hoa Kỳ đã được chứng nhận theo Khung bảo mật dữ liệu (DPF) — đối với dữ liệu chuyển ra từ EU/EEA, được điều chỉnh bởi quyết định của Ủy ban châu Âu ngày 10/7/2023 về mức độ bảo vệ dữ liệu cá nhân tương đương, chừng nào bên nhận còn trong danh sách DPF đang hiệu lực. Hãy xác nhận chứng nhận tại https://www.dataprivacyframework.gov trước khi dựa vào đó.',
            adequacy_summary_us_no_dpf: 'Quốc gia đích là Hoa Kỳ, bên nhận không thuộc DPF — đối với dữ liệu chuyển ra từ EU/EEA, không có quyết định nào của EU về mức độ bảo vệ dữ liệu cá nhân tương đương áp dụng cho bên nhận chưa được chứng nhận, và các lo ngại về pháp luật giám sát theo Schrems II (FISA §702, EO 12333) đòi hỏi biện pháp bổ sung.',
            adequacy_summary_eu_adequacy: '{code} có quyết định đang hiệu lực của Ủy ban châu Âu về mức độ bảo vệ dữ liệu cá nhân tương đương — dữ liệu chuyển ra từ EU/EEA có thể được chuyển mà không cần SCC hay biện pháp bổ sung, tùy thuộc vào việc Ủy ban tiếp tục giám sát.',
            adequacy_summary_eu_no_adequacy: '{code} không có quyết định đang hiệu lực của EU về mức độ bảo vệ dữ liệu cá nhân tương đương. Dữ liệu chuyển ra từ EU/EEA có thể dựa vào biện pháp bảo vệ theo GDPR Điều 46 (điều khoản hợp đồng mẫu, BCR, chứng nhận hoặc quy tắc ứng xử) kèm đánh giá Schrems II đối với quốc gia đích, hoặc vào một trường hợp miễn trừ theo GDPR Điều 49.',
            adequacy_summary_source_jurisdiction_route: 'Chuyển dữ liệu cá nhân ra khỏi Việt Nam sang {code} — được đánh giá theo trường hợp Luật 91/2025/QH15 Điều 20 quy định: hồ sơ đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới (Nghị định 356/2025/NĐ-CP Điều 17–18), trừ khi có bằng chứng về một trường hợp không phải lập hồ sơ do các văn bản này quy định. Phân loại theo quyết định của EU về mức độ bảo vệ dữ liệu cá nhân tương đương không được dùng để định khung trường hợp này; khi bản ghi xác lập rằng GDPR áp dụng đối với bên chuyển dữ liệu cho hoạt động xử lý này (Điều 3), Chương V của GDPR được áp dụng bổ sung.',
            adequacy_summary_source_jurisdiction_route_exemption: 'Chuyển dữ liệu cá nhân ra khỏi Việt Nam sang {code} — được đánh giá theo trường hợp Luật 91/2025/QH15 Điều 20 quy định: hồ sơ đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới (Nghị định 356/2025/NĐ-CP Điều 17–18), trừ khi có bằng chứng về một trường hợp không phải lập hồ sơ do các văn bản này quy định. Bản ghi cho thấy việc chuyển có thể thuộc một trường hợp không phải lập hồ sơ; đây chưa phải là trường hợp đã được xác nhận và cần có bằng chứng xác thực cùng sự rà soát của bộ phận Tuân thủ/Pháp chế. Phân loại theo quyết định của EU về mức độ bảo vệ dữ liệu cá nhân tương đương không được dùng để định khung trường hợp này; khi bản ghi xác lập rằng GDPR áp dụng đối với bên chuyển dữ liệu cho hoạt động xử lý này (Điều 3), Chương V của GDPR được áp dụng bổ sung.',
            conflict_banner: 'Lưu ý: có {count} xung đột giữa các khung tuân thủ áp dụng cho cơ chế chuyển này. Hãy xem xét trước khi chấp nhận.',
            field_label_description: 'Mô tả',
            field_label_purpose: 'Mục đích',
            field_label_transfer_mechanism_detail: 'Chi tiết cơ chế chuyển dữ liệu',
            field_label_recipient_name: 'Tên người nhận',
            field_label_recipient_details: 'Chi tiết bên nhận',
            field_label_data_subjects: 'Chủ thể dữ liệu',
            field_label_data_types: 'Loại dữ liệu',
        },
        // Sprint 48.3.6 — nhãn lan can đầu ra bản nháp dùng chung (TIA + DPIA + mọi quy trình soạn thảo).
        guardrails: {
            missing_facts_title: 'Thiếu thông tin bắt buộc',
            missing_facts_hint: 'Forseti đã đánh dấu những thông tin không có trong hồ sơ. Các trường phụ thuộc vào chúng sẽ không được chọn sẵn — hãy bổ sung thông tin hoặc chấp nhận trường một cách có chủ ý.',
            risk_label: 'Mức rủi ro đã hiệu chỉnh',
            risk_low: 'Thấp',
            risk_medium: 'Trung bình',
            risk_high: 'Cao',
            jurisdiction_label: 'Điều kiện áp dụng pháp lý',
            jurisdiction_none_installed: 'Chưa có khung tuân thủ nào đã cài đặt bao quát loại đánh giá này — chưa có chế định pháp lý nào được đánh giá. Hãy cài đặt gói pháp lý phù hợp trước khi dựa vào các kết luận pháp lý trong bản nháp này.',
            jurisdiction_none_assessed: 'Forseti không trả về đánh giá phạm vi pháp lý nào. Chưa có nội dung nào được đánh giá — đây không phải là kết luận rằng không có chế định pháp lý nào áp dụng.',
            jurisdiction_inactive: 'Khung tuân thủ bao trùm đánh giá này đã được cài đặt nhưng không còn hiệu lực — do đó không có chế định pháp lý nào được đánh giá. Không cần cài đặt thêm: hãy kích hoạt văn bản hiện hành, hoặc văn bản thay thế, trước khi dựa vào các kết luận pháp lý ở đây.',
            jurisdiction_resolving: 'Đang tải tên các chế định pháp lý đã đánh giá…',
            trigger_applicable: 'Áp dụng',
            trigger_not_applicable: 'Không kích hoạt',
            trigger_unknown: 'Chưa rõ — thiếu thông tin',
            recipient_role_label: 'Vai trò bên nhận',
            recipient_role_controller: 'Bên kiểm soát',
            recipient_role_processor: 'Bên xử lý',
            recipient_role_joint_controller: 'Đồng kiểm soát',
            recipient_role_unknown: 'Chưa rõ — không nêu',
            opt_in_hint: 'Kết luận pháp lý — chỉ chọn nếu bạn chấp nhận với các dữ kiện hiện có.',
        },
        // Sprint 47.9.7 — Quản trị kết nối MCP (Phase 1, chỉ đọc).
        mcp: {
            pageTitle: 'Khoá kết nối MCP',
            pageSubtitle: 'Kết nối Claude, tác tử Slack và các ứng dụng MCP khác với Forseti. Ứng dụng đã kết nối đọc bản ghi của tổ chức trong phạm vi quyền bạn cấp, và mọi thay đổi ứng dụng đề xuất đều nằm trong hàng đợi phê duyệt cho tới khi quản trị viên phê duyệt.',
            issueButton: 'Cấp khoá mới',
            issueModalTitle: 'Cấp khoá API MCP',
            labelField: 'Nhãn',
            labelHint: 'Mô tả ngắn (ví dụ "Lab nghiên cứu pháp lý").',
            permittedToolsField: 'Công cụ được phép',
            expiresAtField: 'Hết hạn (tuỳ chọn)',
            expiresAtHint: 'Bỏ trống nếu không hết hạn.',
            submit: 'Cấp khoá',
            cancel: 'Huỷ',
            keyDisplayedOnce: 'Sao chép khoá này NGAY — bạn sẽ KHÔNG xem lại được. Lưu vào trình quản lý bí mật (1Password, AWS Secrets Manager, Vault, v.v.).',
            keyDisplayedOnceClose: 'Đã sao chép — đóng',
            colLabel: 'Nhãn',
            colPrefix: 'Tiền tố',
            colStatus: 'Trạng thái',
            colTools: 'Công cụ',
            colCreatedAt: 'Tạo lúc',
            colLastUsed: 'Sử dụng gần nhất',
            colCalls: 'Lượt gọi',
            colActions: 'Hành động',
            statusActive: 'Hoạt động',
            statusRevoked: 'Đã thu hồi',
            statusExpired: 'Hết hạn',
            revokeAction: 'Thu hồi',
            rotateAction: 'Xoay khoá',
            confirmRevokeTitle: 'Thu hồi khoá MCP này?',
            confirmRevokeBody: 'Trình Claude bên ngoài đang dùng khoá này sẽ mất quyền truy cập ngay. Hành động không thể hoàn tác.',
            confirmRevoke: 'Thu hồi khoá',
            rotatedTitle: 'Đã xoay khoá',
            rotatedBody: 'Khoá mới ở dưới. Khoá cũ vẫn hoạt động trong 5 phút để các yêu cầu đang chạy hoàn tất.',
            emptyState: 'Chưa cấp khoá MCP nào.',
            errorIssue: 'Không cấp được khoá MCP.',
            errorList: 'Không tải được danh sách khoá MCP.',
            errorRevoke: 'Không thu hồi được khoá.',
            errorRotate: 'Không xoay được khoá.',
            neverUsed: '—',
            neverExpires: 'Không bao giờ',
            // Sprint 63.23.0 — trang kết nối hướng dẫn cách kết nối trước tiên.
            reloadKeys: 'Tải lại khóa API',
            issuing: 'Đang cấp…',
            labelRequired: 'Nhập nhãn cho khóa.',
            toolsRequired: 'Chọn ít nhất một công cụ.',
            webhookField: 'URL nhận thông báo trạng thái (tùy chọn)',
            webhookHint: 'ComplianceOne gửi kết quả của từng thao tác ghi đang chờ tới địa chỉ này, được ký bằng một khóa bí mật chỉ hiển thị một lần.',
            webhookInvalid: 'Nhập địa chỉ đầy đủ, ví dụ https://example.com/hooks/mcp.',
            webhookSecretLabel: 'Khóa bí mật ký webhook',
            webhookSecretOnce: 'Sao chép khóa bí mật ký ngay bây giờ. Khóa chỉ hiển thị một lần.',
            toolGroupRead: 'Công cụ đọc',
            toolGroupWrite: 'Công cụ ghi',
            toolGroupWriteHint: 'Công cụ ghi không bao giờ thay đổi bản ghi trực tiếp. Mỗi lượt gọi được đưa vào hàng đợi phê duyệt và chỉ chạy sau khi quản trị viên phê duyệt.',
            toolGroupMemory: 'Bộ nhớ tổ chức',
            toolGroupSubagent: 'Chuyển giao persona',
            toolQueued: 'đưa vào hàng đợi phê duyệt',
            allToolsInScope: 'Mọi công cụ mà phạm vi cho phép',
            copy: 'Sao chép',
            copyValue: 'Sao chép {label}',
            copiedValue: 'Đã sao chép {label}',
            copyFailed: 'Không sao chép được {label}. Hãy chọn giá trị và tự sao chép.',
            apiKeyLabel: 'Khóa API',
            registers: {
                clients: 'Ứng dụng OAuth',
                grants: 'Ứng dụng đã kết nối',
                keys: 'Khóa API',
            },
            connection: {
                title: 'Thông tin kết nối',
                intro: 'Mọi ứng dụng đều cần URL máy chủ. Ứng dụng OAuth dùng thêm các địa chỉ bên dưới; ứng dụng dùng khóa API gửi khóa dưới dạng bearer token.',
                serverUrl: 'URL máy chủ',
                transport: 'Giao thức truyền tải',
                transportStreamableHttp: 'Streamable HTTP',
                protectedResourceMetadataUrl: 'URL siêu dữ liệu tài nguyên được bảo vệ',
                asMetadataUrl: 'URL siêu dữ liệu máy chủ ủy quyền',
                authorizeUrl: 'URL ủy quyền',
                tokenUrl: 'URL token',
                registrationUrl: 'URL đăng ký ứng dụng',
                revokeUrl: 'URL thu hồi',
                scopes: 'Phạm vi',
                loading: 'Đang tải thông tin kết nối…',
                error: 'Không đọc được thông tin kết nối nên chưa hiển thị URL máy chủ.',
                reload: 'Tải lại thông tin kết nối',
            },
            dcr: {
                label: 'Cho phép ứng dụng tự đăng ký',
                hint: 'Khi bật, một ứng dụng như Claude có thể tự đăng ký và đề nghị người dùng đã đăng nhập phê duyệt. Ứng dụng không có quyền truy cập nào cho tới khi một người dùng của tổ chức này phê duyệt trên màn hình đồng ý. Tắt công tắc sẽ ngắt kết nối các ứng dụng tự đăng ký ở lần gọi tiếp theo; các ứng dụng được đăng ký bên dưới và khóa API vẫn hoạt động. Bật lại trong vòng 30 ngày kể từ lần cuối ứng dụng làm mới refresh token thì các ứng dụng đó hoạt động trở lại; quá thời hạn đó, người dùng phải kết nối lại ứng dụng.',
                stateOn: 'Bật — ứng dụng có thể tự đăng ký.',
                stateOff: 'Tắt — chỉ ứng dụng được đăng ký bên dưới mới kết nối được.',
                saving: 'Đang lưu…',
                error: 'Không thay đổi được thiết lập cho phép ứng dụng tự đăng ký.',
                confirmOffTitle: 'Tắt chế độ tự đăng ký?',
                confirmOffBody: 'Các ứng dụng tự đăng ký, như Claude, bị ngắt kết nối ở lần gọi tiếp theo đối với mọi người trong tổ chức này, và không ai phê duyệt được ứng dụng mới. Các ứng dụng được đăng ký bên dưới và khóa API vẫn hoạt động. Các kết nối bị tạm ngưng chứ không bị thu hồi: bật lại chế độ tự đăng ký trong vòng 30 ngày kể từ lần cuối ứng dụng làm mới refresh token thì chúng hoạt động trở lại. Quá thời hạn đó, người dùng phải kết nối lại ứng dụng.',
                confirmOff: 'Tắt',
            },
            tabs: {
                label: 'Cách kết nối',
                claude: 'Claude',
                slack: 'Slack và các công cụ tạo tác tử khác',
                apiKey: 'Khóa API',
            },
            claudeTab: {
                step1: 'Trong Claude, thêm một connector tùy chỉnh.',
                step2: 'Dán URL máy chủ. Claude tự tìm cách đăng nhập.',
                step3: 'Đăng nhập ComplianceOne khi được yêu cầu, sau đó đọc màn hình đồng ý và phê duyệt.',
                consentHeading: 'Màn hình đồng ý hiển thị những gì',
                consentItemClient: 'tên ứng dụng và địa chỉ mà ứng dụng sẽ đưa bạn quay lại;',
                consentItemOrg: 'tổ chức của bạn;',
                consentItemScopes: 'những việc ứng dụng được làm — đọc bản ghi của tổ chức, và đề xuất thay đổi để phê duyệt nếu có yêu cầu — cùng các công cụ tương ứng;',
                consentItemOrigin: 'ứng dụng tự đăng ký hay do quản trị viên đăng ký.',
                actsAsUser: 'Sau đó Claude hành động với tư cách người đã phê duyệt, không vượt quá quyền mà vai trò của người đó có.',
                registrationOff: 'Tổ chức này không cho phép ứng dụng tự đăng ký, nên Claude không thể kết nối chỉ bằng URL máy chủ. Hãy bật tự đăng ký, hoặc đăng ký một ứng dụng cho Claude trong mục Ứng dụng OAuth.',
            },
            slackTab: {
                intro: 'Các công cụ tạo tác tử như Slack yêu cầu các trường OAuth. Đăng ký một ứng dụng trong mục Ứng dụng OAuth, sau đó sao chép từng giá trị vào biểu mẫu của công cụ.',
                colField: 'Trường trong công cụ tạo tác tử',
                colValue: 'Giá trị',
                fieldServerUrl: 'URL máy chủ MCP',
                fieldClientId: 'Client ID',
                fieldClientSecret: 'Client secret',
                fieldAuthorizeUrl: 'URL ủy quyền',
                fieldTokenUrl: 'URL token',
                fieldScopes: 'Phạm vi',
                valueClientId: 'Hiển thị trên dòng của ứng dụng trong mục Ứng dụng OAuth.',
                valueScopes: 'Chỉ nhập các phạm vi hiển thị trên dòng của ứng dụng trong mục Ứng dụng OAuth. Phạm vi mà ứng dụng chưa được đăng ký sẽ bị từ chối.',
                valueClientSecret: 'Chỉ hiển thị một lần, khi bạn đăng ký ứng dụng hoặc xoay vòng khóa bí mật. Hãy lưu ngay vào công cụ tạo tác tử.',
                redirectNote: 'Công cụ tạo tác tử hiển thị URI chuyển hướng mà nó dùng. Hãy thêm URI đó vào ứng dụng đúng như hiển thị: ComplianceOne chỉ đưa người dùng quay lại URI chuyển hướng đã đăng ký cho ứng dụng.',
                registerCta: 'Đăng ký ứng dụng',
            },
            apiKeyTab: {
                intro: 'Script và ứng dụng tùy chỉnh có thể dùng khóa API thay cho OAuth. Cấp khóa trong mục Khóa API và gửi khóa trong mọi yêu cầu.',
                headerLabel: 'Header',
                configLabel: 'Cấu hình ứng dụng (JSON)',
                curlLabel: 'Kiểm tra kết nối bằng curl',
                actsAsIssuer: 'Lượt gọi bằng khóa hành động với tư cách quản trị viên đã cấp khóa, giới hạn trong các công cụ đã chọn cho khóa.',
            },
            clients: {
                errorRevokedClient: 'Ứng dụng này đã bị thu hồi nên không có khóa bí mật để xoay vòng.',
                paginationLabel: 'Phân trang ứng dụng OAuth',
                intro: 'Ứng dụng mà công cụ tạo tác tử dùng cùng Client ID và client secret. Các ứng dụng tự đăng ký cũng được liệt kê tại đây.',
                registerButton: 'Đăng ký ứng dụng',
                empty: 'Chưa có ứng dụng OAuth nào.',
                error: 'Không đọc được danh sách ứng dụng OAuth.',
                reload: 'Tải lại ứng dụng OAuth',
                colName: 'Tên',
                colClientId: 'Client ID',
                colType: 'Loại',
                colOrigin: 'Người đăng ký',
                colRedirects: 'URI chuyển hướng',
                colScopes: 'Phạm vi',
                colTools: 'Công cụ',
                colLastUsed: 'Sử dụng gần nhất',
                colStatus: 'Trạng thái',
                colActions: 'Hành động',
                typeConfidential: 'Bảo mật (confidential)',
                typePublic: 'Công khai (public)',
                originAdmin: 'Quản trị viên',
                originDynamic: 'Ứng dụng tự đăng ký',
                statusActive: 'Hoạt động',
                statusRevoked: 'Đã thu hồi',
                rotateSecret: 'Xoay vòng khóa bí mật',
                revoke: 'Thu hồi',
                modalTitle: 'Đăng ký ứng dụng OAuth',
                nameField: 'Tên',
                nameHint: 'Người dùng thấy tên này trên màn hình đồng ý.',
                nameRequired: 'Nhập tên.',
                typeField: 'Loại ứng dụng',
                typeConfidentialHint: 'Bảo mật — ứng dụng giữ khóa bí mật trên máy chủ. Dùng cho Slack và các công cụ tạo tác tử khác.',
                typePublicHint: 'Công khai — ứng dụng không giữ được khóa bí mật (ứng dụng máy tính hoặc trình duyệt) và xác thực bằng PKCE.',
                redirectField: 'URI chuyển hướng',
                redirectHint: 'Địa chỉ chính xác mà ứng dụng đưa người dùng quay lại. Địa chỉ loopback như localhost chấp nhận mọi cổng.',
                redirectUriLabel: 'URI chuyển hướng {n}',
                addRedirect: 'Thêm URI chuyển hướng',
                removeRedirect: 'Xóa URI chuyển hướng {n}',
                redirectInvalid: 'Nhập địa chỉ đầy đủ, ví dụ https://example.com/callback.',
                redirectRequired: 'Thêm ít nhất một URI chuyển hướng.',
                scopesField: 'Phạm vi',
                scopesRequired: 'Chọn ít nhất một phạm vi.',
                toolsField: 'Chỉ cho phép các công cụ này (tùy chọn)',
                toolsHint: 'Để trống tất cả để cho phép mọi công cụ mà phạm vi đã chọn cho phép.',
                submit: 'Đăng ký ứng dụng',
                saving: 'Đang đăng ký…',
                errorCreate: 'Không đăng ký được ứng dụng.',
                createdTitle: 'Đã đăng ký ứng dụng',
                secretTitle: 'Khóa bí mật mới của ứng dụng',
                secretOnce: 'Sao chép client secret ngay bây giờ. Khóa chỉ hiển thị một lần và không thể xem lại; hãy xoay vòng khóa bí mật để lấy khóa mới.',
                publicNoSecret: 'Đây là ứng dụng công khai nên không có khóa bí mật. Ứng dụng đăng nhập bằng PKCE.',
                clientIdLabel: 'Client ID',
                clientSecretLabel: 'Client secret',
                confirmRotateTitle: 'Xoay vòng khóa bí mật của ứng dụng?',
                confirmRotateBody: 'Khóa bí mật hiện tại ngừng hoạt động ngay. Hãy cập nhật khóa mới vào công cụ tạo tác tử ngay lập tức.',
                errorRotate: 'Không xoay vòng được khóa bí mật của ứng dụng.',
                confirmRevokeTitle: 'Thu hồi ứng dụng OAuth này?',
                confirmRevokeBody: 'Mọi ứng dụng kết nối qua ứng dụng này mất quyền truy cập ngay và các kết nối của nó bị thu hồi. Hành động không thể hoàn tác.',
                confirmRevoke: 'Thu hồi ứng dụng',
                errorRevoke: 'Không thu hồi được ứng dụng.',
            },
            grants: {
                errorNotFound: 'Kết nối này không còn tồn tại; có thể kết nối đã bị thu hồi.',
                paginationLabel: 'Phân trang ứng dụng đã kết nối',
                intro: 'Các ứng dụng mà người dùng trong tổ chức này đã phê duyệt trên màn hình đồng ý. Thu hồi sẽ chặn lượt gọi tiếp theo của ứng dụng.',
                empty: 'Chưa có ứng dụng đã kết nối nào.',
                error: 'Không đọc được danh sách ứng dụng đã kết nối.',
                reload: 'Tải lại ứng dụng đã kết nối',
                colApp: 'Ứng dụng',
                colUser: 'Người phê duyệt',
                colScopes: 'Phạm vi',
                colCreated: 'Kết nối lúc',
                colLastUsed: 'Sử dụng gần nhất',
                colActions: 'Hành động',
                revoke: 'Thu hồi',
                confirmRevokeTitle: 'Thu hồi kết nối này?',
                confirmRevokeBody: 'Ứng dụng mất quyền truy cập ngay. Người dùng có thể kết nối lại bằng cách phê duyệt trên màn hình đồng ý.',
                confirmRevoke: 'Thu hồi kết nối',
                errorRevoke: 'Không thu hồi được kết nối.',
            },
            myApps: {
                errorNotFound: 'Ứng dụng này không còn được kết nối; có thể ứng dụng đã bị thu hồi.',
                title: 'Ứng dụng đã kết nối',
                intro: 'Các ứng dụng bạn đã cho phép sử dụng ComplianceOne thay mặt bạn. Mỗi ứng dụng hành động với tư cách của bạn, không vượt quá quyền mà vai trò của bạn có.',
                empty: 'Bạn chưa kết nối ứng dụng nào.',
                error: 'Không đọc được danh sách ứng dụng đã kết nối của bạn.',
                reload: 'Tải lại ứng dụng đã kết nối',
                colApp: 'Ứng dụng',
                colScopes: 'Phạm vi',
                colCreated: 'Kết nối lúc',
                colLastUsed: 'Sử dụng gần nhất',
                colActions: 'Hành động',
                revoke: 'Thu hồi',
                confirmRevokeTitle: 'Thu hồi ứng dụng này?',
                confirmRevokeBody: 'Ứng dụng mất quyền truy cập ngay. Bạn có thể kết nối lại bằng cách phê duyệt trên màn hình đồng ý.',
                confirmRevoke: 'Thu hồi ứng dụng',
                errorRevoke: 'Không thu hồi được ứng dụng.',
            },
        },
        // Sprint 48.0.0c — duyệt và quản lý bộ nhớ Forseti.
        memory: {
            pageTitle: 'Bộ nhớ Forseti',
            pageSubtitle: 'Duyệt và quản lý ngữ cảnh đặc thù tổ chức mà Forseti đã tích luỹ qua các cuộc trò chuyện và quyết định. Mục đã được duyệt sẽ không bị quét retention hằng đêm và luôn có sẵn cho mọi persona.',
            filterCategory: 'Loại',
            filterAllCategories: 'Tất cả loại',
            totalCount: '{count} mục',
            colAnchor: 'Mã anchor',
            colCategory: 'Loại',
            colSource: 'Nguồn',
            colContent: 'Nội dung',
            colCreatedAt: 'Tạo lúc',
            colActions: 'Hành động',
            editButton: 'Chỉnh sửa',
            deleteButton: 'Xoá',
            promoteButton: 'Đánh dấu đã duyệt',
            emptyState: 'Chưa có bộ nhớ nào — Forseti sẽ tích luỹ ngữ cảnh khi bạn trò chuyện.',
            categories: {
                framework_interpretation: 'Diễn giải khung tuân thủ',
                process_preference: 'Tuỳ chọn quy trình',
                escalation_threshold: 'Ngưỡng nâng cấp',
                decision_context: 'Bối cảnh quyết định',
                glossary_term: 'Thuật ngữ',
                auto_inferred: 'Tự suy luận',
            },
            sources: {
                admin_curated: 'Đã duyệt',
                user_explicit: 'Tường minh',
                auto: 'Suy luận',
            },
            deleteConfirmTitle: 'Xoá bộ nhớ này?',
            deleteConfirmBody: 'Xoá sẽ loại anchor này khỏi mọi lần khởi động chat Forseti tiếp theo. Anchor: {anchor}',
            deleteConfirmLabel: 'Xoá',
            deleteCancelLabel: 'Huỷ',
            editModalTitle: 'Chỉnh sửa bộ nhớ',
            editAnchorLabel: 'Anchor',
            editCategoryLabel: 'Loại',
            editContentLabel: 'Nội dung',
            editContentCount: '{n}/{max} ký tự',
            editEmptyError: 'Nội dung không được để trống.',
            editTooLongError: 'Nội dung phải ≤1000 ký tự.',
            editAutoPromoteHint: 'Lưu bộ nhớ suy luận này sẽ đánh dấu là đã được người dùng xác nhận và loại khỏi quét retention.',
            editCancelButton: 'Huỷ',
            editSaveButton: 'Lưu',
            editSaving: 'Đang lưu…',
            loadFailed: 'Không thể tải bộ nhớ.',
            deleteFailed: 'Không thể xóa mục bộ nhớ.',
            promoteFailed: 'Không thể nâng mục bộ nhớ lên mục đã tuyển chọn.',
            saveFailed: 'Không thể lưu mục bộ nhớ.',
        },
        // Sprint 47.5.8 — trang lineage kiểm toán Forseti.
        auditLineage: {
            title: 'Lineage kiểm toán',
            subtitle: 'Truy vết mọi tạo phẩm do AI sinh ra gắn với một bản ghi. Hội thoại, lời gọi công cụ, công việc, bản nháp chứng cứ, phiên bản tài liệu.',
            filterForm: 'Bộ lọc',
            recordType: 'Loại bản ghi',
            recordId: 'Mã bản ghi',
            dateStart: 'Từ',
            dateEnd: 'Đến',
            search: 'Tìm kiếm',
            loading: 'Đang tải…',
            exportPdf: 'Xuất PDF',
            exportCsv: 'Xuất CSV',
            nodesHeading: 'Các nút lineage',
            colType: 'Loại',
            colLabel: 'Nhãn',
            colOccurredAt: 'Thời điểm',
            colActor: 'Người thao tác',
            colId: 'Mã',
            noResults: 'Không có hoạt động Forseti cho bản ghi này.',
            draftBadge: 'Bản nháp do AI sinh',
            prev: 'Trước',
            next: 'Sau',
            // Sprint 47.5.8.3 — chế độ xem dạng đồ thị tùy chọn.
            viewToggleTable: 'Xem dạng bảng',
            viewToggleGraph: 'Xem dạng đồ thị',
            graphAriaLabel: 'Đồ thị lineage (hiển thị). Sử dụng chế độ xem dạng bảng cho công nghệ hỗ trợ.',
            graphLegendDraft: 'Bằng chứng nháp do AI',
            graphEmpty: 'Không có nút nào để vẽ đồ thị.',
            // Sprint 47.5.9.5 — aria-label cho phân trang + mẫu thông báo xuất file.
            paginationAriaLabel: 'Phân trang',
            exportSuccessTemplate: '{format}: {filename}',
            exportErrorTemplate: 'Xuất file thất bại: {message}',
            truncatedNotice: 'Lineage này chưa đầy đủ. Nền tảng chỉ đọc tối đa một số dòng cố định từ mỗi nguồn, theo thứ tự mới nhất trước, và đã chạm giới hạn đối với: {sources}. Các dòng cũ nhất vượt quá giới hạn, nếu có, không được hiển thị. Hãy thu hẹp khoảng ngày để đưa chúng vào.',
            truncatedChatLinksNotice: 'Lineage này chưa đầy đủ: chỉ {limit} cuộc trò chuyện mới nhất của bản ghi này được dùng để tìm các lời gọi công cụ, phiên chạy quy trình, công việc, chứng cứ và phiên bản tài liệu được tạo từ một cuộc trò chuyện. Những mục chỉ liên kết qua một cuộc trò chuyện cũ hơn không được hiển thị, và việc thu hẹp khoảng ngày không đưa chúng vào.',
            recordTypes: {
                project: 'Dự án',
                dpia: 'DPIA',
                transfer_assessment: 'Đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới',
                dossier_filing: 'Hồ sơ nộp',
                cross_border_filing: 'Hồ sơ chuyển dữ liệu cá nhân xuyên biên giới',
                vendor: 'Nhà cung cấp',
                incident: 'Sự cố',
                incident_op: 'Vận hành sự cố',
                rights_request: 'Yêu cầu quyền',
                contract: 'Hợp đồng',
                task: 'Công việc',
                data_mapping_activity: 'Hoạt động lập bản đồ dữ liệu',
                compliance_rule: 'Quy tắc tuân thủ',
                program: 'Chương trình',
            },
            nodeTypes: {
                chat: 'Cuộc trò chuyện',
                tool_call: 'Lời gọi công cụ',
                workflow_run: 'Phiên chạy quy trình',
                task: 'Công việc',
                evidence: 'Chứng cứ',
                document_version: 'Phiên bản tài liệu',
            },
            recordIdManualHint: 'Loại bản ghi này chưa có danh sách ở đây. Hãy nhập mã của chính bản ghi, như hiển thị trong địa chỉ trang của bản ghi.',
            recordIdManualLabel: 'Mã bản ghi',
            colDetails: 'Chi tiết',
        },
        // Sprint 47.5.x — Nhãn verdict cho Trung tâm toàn vẹn (dùng bởi trang IAT).
        integrityCenter: {
            verdicts: {
                ok: 'OK',
                drifted: 'Lệch chuẩn',
                hash_mismatch: 'Sai băm',
                merkle_mismatch: 'Sai Merkle',
                source_missing: 'Thiếu nguồn',
                not_found: 'Không tìm thấy',
                chain_unreachable: 'Không truy cập được chuỗi',
                service_unreachable: 'Không truy cập được dịch vụ',
                pending: 'Đang chờ neo chuỗi',
            },
        },
        // Sprint 47.5.8 — chrome cho chứng cứ nháp (move-to-review/approve/reject).
        evidenceDraft: {
            draftBadge: 'BẢN NHÁP do AI sinh',
            pendingReviewBadge: 'Chờ duyệt',
            approvedBadge: 'Đã duyệt',
            rejectedBadge: 'Đã từ chối',
            moveToReviewButton: 'Chuyển sang chờ duyệt',
            approveButton: 'Duyệt',
            rejectButton: 'Từ chối',
            rejectReasonLabel: 'Lý do từ chối',
            humanSignoffBanner: 'Forseti hỗ trợ phán đoán của bạn — không thay thế luật sư có giấy phép hành nghề. Chứng cứ do AI sinh phải được người có thẩm quyền duyệt trước khi tính là chứng cứ chính thức.',
            // Sprint 47.5.8.6 — chrome cho DraftEvidencePage.
            pageTitle: 'Chứng cứ nháp do AI',
            pageSubtitle: 'Duyệt, phê duyệt, hoặc từ chối chứng cứ do AI sinh. Bản nháp phải được người có thẩm quyền duyệt trước khi trở thành chứng cứ chính thức.',
            filterAll: 'Tất cả cần xử lý',
            filterDrafts: 'Chỉ bản nháp',
            filterPending: 'Đang chờ duyệt',
            filterApproved: 'Vừa duyệt',
            filterRejected: 'Vừa từ chối',
            colId: 'Mã chứng cứ',
            colStatus: 'Trạng thái',
            colSource: 'Nguồn',
            colCreatedAt: 'Tạo lúc',
            colActions: 'Thao tác',
            empty: 'Không có chứng cứ nháp do AI ở trạng thái này.',
            confirmApprove: 'Duyệt chứng cứ do AI sinh này thành chứng cứ chính thức?',
            confirmReject: 'Từ chối bản nháp này. Hành động này không thể hoàn tác.',
            reasonRequired: 'Vui lòng nhập lý do từ chối.',
            rejectModalTitle: 'Từ chối chứng cứ nháp',
            // fix-sprint-20260503-2128 F39 — tiêu đề modal duyệt đối xứng.
            approveModalTitle: 'Duyệt chứng cứ nháp',
            operationFailed: 'Thao tác thất bại. Vui lòng thử lại.',
            moveToReviewSuccess: 'Đã chuyển sang chờ duyệt.',
            approveSuccess: 'Đã duyệt.',
            rejectSuccess: 'Đã từ chối.',
            // Sprint 47.5.9.3.3 (T-3) — nhãn nguồn.
            sourceLabelWorkflowRunTitle: 'Quy trình: {title}',
            sourceLabelWorkflowRunId: 'Lượt chạy quy trình {id}',
            sourceLabelChatTitle: 'Trò chuyện: {title}',
            sourceLabelChatId: 'Trò chuyện Forseti {id}',
            sourceLabelEmpty: '—',
            // Sprint 47.5.9.5 — aria-label cho nhóm bộ lọc.
            filtersAriaLabel: 'Lọc theo trạng thái',
        },
        // Sprint 47.5.5 — Forseti AI Workflows.
        workflows: {
            pageTitle: 'Quy trình AI',
            pageSubtitle: 'Mẫu lệnh AI đã lưu — tạo công việc và chứng cứ nháp.',
            libraryOverviewLabel: 'Tổng quan thư viện quy trình',
            libraryEyebrow: 'Thư viện quy trình',
            libraryTitle: 'Biến hồ sơ tuân thủ thành công việc sẵn sàng để rà soát',
            libraryDescription: 'Chọn quy trình được quản trị, chọn hồ sơ nguồn và rà soát mọi kết quả trước khi thay đổi dữ liệu vận hành.',
            availableLabel: 'Khả dụng',
            myWorkflowsLabel: 'Của bạn',
            customBadge: 'Tuỳ chỉnh',
            openWorkflow: 'Mở quy trình',
            governedWorkflowLabel: 'Quy trình tích hợp được quản trị',
            readyToRunHeading: 'Sẵn sàng cho phiên chạy có người vận hành rà soát',
            workflowProfileHeading: 'Hồ sơ quy trình',
            outputsHeading: 'Kết quả dự kiến',
            humanReviewLabel: 'Cần con người rà soát',
            newWorkflow: 'Quy trình mới',
            newWorkflowHeading: 'Quy trình AI mới',
            tabAll: 'Tất cả',
            tabBuiltin: 'Gói tích hợp sẵn',
            tabMine: 'Của tôi',
            tabDetail: 'Chi tiết',
            tabLinkedTasks: 'Công việc liên kết',
            builtinBadge: 'Tích hợp sẵn',
            builtinSubtitle: 'Quy trình tích hợp sẵn.',
            userSubtitle: 'Quy trình tuỳ chỉnh.',
            emptyHint: 'Chưa có quy trình nào.',
            // Sprint 47.7.4 AC-7 — fallback khi tải quá 10 giây.
            loadTimeoutError: 'Không tải được quy trình sau 10 giây. Hãy thử lại, hoặc kiểm tra tab Network của trình duyệt để xem yêu cầu bị treo.',
            // fix-sprint-20260504-2137 F18 — workflow list error messages.
            loadError: 'Không tải được quy trình.',
            hideError: 'Ẩn thất bại.',
            unhideError: 'Bỏ ẩn thất bại.',
            retry: 'Thử lại',
            producesTasks: 'Tạo công việc',
            producesEvidence: 'Tạo chứng cứ nháp',
            hideButton: 'Ẩn khỏi danh sách',
            unhideButton: 'Bỏ ẩn',
            runButton: 'Chạy',
            editButton: 'Sửa',
            shareButton: 'Chia sẻ',
            backToList: 'Quay lại danh sách',
            syncBuiltinButton: 'Đồng bộ gói tích hợp sẵn',
            syncBuiltinSuccess: 'Đã đồng bộ gói tích hợp sẵn ({loaded} quy trình).',
            syncBuiltinError: 'Không thể đồng bộ gói tích hợp sẵn.',
            syncBuiltinRunning: 'Đang đồng bộ gói tích hợp sẵn…',
            requireTitleAndPrompt: 'Tiêu đề và lệnh là bắt buộc.',
            fieldTitle: 'Tiêu đề',
            fieldDescription: 'Mô tả',
            fieldType: 'Loại',
            fieldPersona: 'Persona ưu tiên',
            fieldPractice: 'Lĩnh vực',
            fieldPrompt: 'Lệnh (Markdown)',
            fieldProducesTasks: 'Tạo công việc',
            fieldProducesEvidence: 'Tạo chứng cứ nháp',
            fieldProjectId: 'Dự án (tuỳ chọn)',
            fieldAttachmentIds: 'Tệp đính kèm',
            fieldParentRecord: 'Bản ghi gốc (tuỳ chọn)',
            fieldPersonaOverride: 'Ghi đè persona (tuỳ chọn)',
            typeAssistant: 'Trợ lý',
            typeTabular: 'Bảng',
            practice_display: {
                privacy: 'Quyền riêng tư',
                legal: 'Pháp lý',
                compliance: 'Tuân thủ',
                risk: 'Rủi ro',
                audit: 'Kiểm toán',
            },
            personaNone: '— không —',
            parentNone: '— không —',
            parentIdPlaceholder: 'Mã bản ghi gốc',
            // Sprint 47.5.9.3.1 — chuỗi cho bộ chọn.
            selectProjectPlaceholder: 'Chọn dự án…',
            selectProjectFirst: 'Chọn dự án trước để chọn tệp đính kèm.',
            selectAttachmentsPlaceholder: 'Chọn tài liệu…',
            noAttachmentsInProject: 'Dự án này chưa có tài liệu đính kèm.',
            selectParentRecordPlaceholder: 'Chọn bản ghi…',
            selectParentRecordFirst: 'Chọn loại bản ghi trước.',
            noRecordsForType: 'Không có bản ghi nào thuộc loại này.',
            shareUserSelectorLabel: 'Người nhận (người dùng)',
            shareGroupSelectorLabel: 'Người nhận (nhóm tổ chức)',
            selectUsersPlaceholder: 'Chọn người dùng…',
            selectOrgGroupsPlaceholder: 'Chọn nhóm tổ chức…',
            loadingOptions: 'Đang tải…',
            loadFailed: 'Không thể tải danh sách.',
            parentRecordTypes: {
                dpia: 'DPIA',
                vendor: 'Nhà cung cấp',
                incident: 'Sự cố',
                rights_request: 'Yêu cầu của chủ thể',
                contract: 'Hợp đồng',
                data_mapping_activity: 'Hoạt động xử lý',
                compliance_rule: 'Quy tắc tuân thủ',
                program: 'Chương trình',
            },
            cancelButton: 'Huỷ',
            closeButton: 'Đóng',
            createButton: 'Tạo',
            creating: 'Đang tạo…',
            saveButton: 'Lưu',
            saving: 'Đang lưu…',
            shareWorkflowHeading: 'Chia sẻ quy trình',
            shareIntro: 'Đang chia sẻ: {title}',
            shareUserIds: 'Mã người dùng (cách bằng dấu cách hoặc dấu phẩy)',
            shareGroupIds: 'Mã nhóm tổ chức (cách bằng dấu cách hoặc dấu phẩy)',
            shareAllowEdit: 'Cho phép người nhận chỉnh sửa',
            shareRequireRecipient: 'Cung cấp ít nhất một mã người dùng hoặc mã nhóm.',
            shareSuccess: 'Đã chia sẻ.',
            sharing: 'Đang chia sẻ…',
            runWorkflowHeading: 'Chạy: {title}',
            runStarting: 'Đang khởi chạy…',
            runStatusLabel: 'Trạng thái: {status}',
            runProducedCounts: 'Công việc: {tasks} · Chứng cứ nháp: {evidence} · Tệp đính kèm: {attachments}',
            runPanelHeading: 'Phiên chạy quy trình',
            runPanelHeadingWithTitle: 'Phiên chạy quy trình: {title}',
            runViewTasks: 'Xem công việc đã tạo',
            runViewEvidence: 'Xem chứng cứ nháp',
            runResultHeading: 'Kết quả tư vấn',
            runNoResult: 'Phiên chạy đã kết thúc nhưng không trả về kết quả có thể rà soát. Không có công việc, chứng cứ hay tệp đính kèm nào được tạo. Hãy thử lại với bản ghi hoặc tài liệu bắt buộc đã chọn.',
            runCitationWarning: 'Một số trích dẫn không thể xác minh tự động. Hãy rà soát trước khi tin cậy vào kết quả này.',
            runToolCallWarning: 'Forseti đã thử gọi một công cụ mà quy trình này không thể chạy và trả lượt gọi công cụ đó về dưới dạng văn bản. Không có kết quả nào được tạo ra từ đó.',
            runNoEnvelopeWarning: 'Forseti trả về một kết quả mà quy trình này không đọc được, nên không có nhiệm vụ hay tài liệu chứng minh nào được tạo ra từ kết quả đó.',
            runNoArtefactsWarning: 'Phiên chạy này đã hoàn tất mà không tạo ra nhiệm vụ hay tài liệu chứng minh dạng nháp nào. Hãy rà soát kết quả trước khi coi công việc đã hoàn thành.',
            runLoadFailed: 'Không thể tải phiên chạy quy trình.',
            runStreamFailed: 'Kết nối tiến trình quy trình thất bại.',
            // Sprint 47.5.9.5 — nhãn trạng thái workflow run + dòng tiến trình SSE.
            runStatusValues: {
                pending: 'Chờ xử lý',
                running: 'Đang chạy',
                completed: 'Hoàn thành',
                succeeded: 'Thành công',
                failed: 'Thất bại',
                cancelled: 'Đã hủy',
            },
            runProgressStatus: 'Trạng thái: {status}',
            runProgressTaskCreated: 'Đã tạo công việc.',
            runProgressEvidenceDrafted: 'Đã tạo bản nháp chứng cứ.',
            runProgressAttachmentGenerated: 'Đã tạo tệp đính kèm.',
            guidedWorkflowTitle: 'Quy trình {recordType} có hướng dẫn',
            guidedWorkflowDescription: 'Được tạo cho bản ghi {recordType}. Hãy rà soát và tùy chỉnh quy trình trước khi lưu.',
            guidedWorkflowPrompt: 'Rà soát bản ghi {recordType} được cung cấp, xác định dữ kiện còn thiếu và đề xuất bước tiếp theo có căn cứ để con người xem xét.',
            promptHeading: 'Lệnh',
            howItWorksHeading: 'Điều gì xảy ra khi bạn chạy quy trình này',
            builtinGuidance: 'Forseti rà soát các hồ sơ và tài liệu bạn chọn, trả về kết quả có thể được cán bộ rà soát, và chỉ tạo công việc hoặc chứng cứ nháp khi kết quả hỗ trợ việc đó. Không có gì được tự động phê duyệt hoặc nộp.',
            editWorkflowHeading: 'Sửa quy trình',
            linkedTasksHint: 'Công việc do quy trình này tạo sẽ xuất hiện trong danh sách Công việc, được lọc theo mã quy trình.',
            notFound: 'Không tìm thấy quy trình.',
            // Sprint 47.7.2 — chạy quy trình theo lịch.
            schedules: {
                tabTitle: 'Lịch chạy',
                sectionHeading: 'Lịch chạy đã đặt',
                empty: 'Chưa có lịch nào. Tạo lịch để chạy tự động.',
                addButton: 'Thêm lịch',
                addHeading: 'Đặt lịch quy trình',
                editHeading: 'Sửa lịch',
                fieldFrequency: 'Tần suất',
                fieldDayOfWeek: 'Thứ trong tuần',
                fieldDayOfMonth: 'Ngày trong tháng',
                fieldTime: 'Giờ (UTC)',
                fieldTimezone: 'Múi giờ',
                fieldProject: 'Dự án (tuỳ chọn)',
                fieldAttachments: 'Tài liệu mặc định',
                fieldPersonaOverride: 'Persona thay thế (tuỳ chọn)',
                frequencyDaily: 'Hằng ngày',
                frequencyWeekly: 'Hằng tuần',
                frequencyMonthly: 'Hằng tháng',
                weekdaySun: 'Chủ nhật',
                weekdayMon: 'Thứ hai',
                weekdayTue: 'Thứ ba',
                weekdayWed: 'Thứ tư',
                weekdayThu: 'Thứ năm',
                weekdayFri: 'Thứ sáu',
                weekdaySat: 'Thứ bảy',
                statusActive: 'Đang chạy',
                statusPaused: 'Đã tạm dừng',
                nextRunLabel: 'Lần chạy kế tiếp',
                lastRunLabel: 'Lần chạy gần nhất',
                pauseButton: 'Tạm dừng',
                resumeButton: 'Tiếp tục',
                deleteButton: 'Xoá',
                triggerButton: 'Chạy ngay',
                savingButton: 'Đang lưu…',
                saveButton: 'Lưu',
                triggered: 'Đã khởi chạy — kiểm tra lịch sử chạy.',
            },
            // Sprint 47.7.2 — phân nhánh điều kiện trong prompt quy trình.
            branching: {
                helpHeading: 'Cú pháp prompt có điều kiện',
                helpBody: 'Dùng {% if persona.slug == "forseti-legal" %}…{% endif %} để thay đổi prompt theo ngữ cảnh. Biến có giá trị: persona.slug (persona được chọn khi chạy, nếu không thì persona của quy trình), org.country và org.locale (quốc gia và ngôn ngữ mặc định của tổ chức), project.name (dự án mà phiên chạy thuộc về). attachment.framework_code, attachment.locale và project.tier được chấp nhận nhưng hiện chưa có nguồn dữ liệu, nên {{ }} cho các biến này hiển thị rỗng và điều kiện trên chúng luôn sai. Không hỗ trợ {% if %} lồng nhau.',
            },
            runCancelButton: 'Hủy phiên chạy',
            runCancelling: 'Đang hủy…',
            runCancelRequested: 'Đã yêu cầu hủy. Yêu cầu đã gửi tới mô hình không thể thu hồi, nhưng khi có phản hồi thì kết quả sẽ bị loại bỏ và không có công việc, chứng cứ nháp hay tệp nào được tạo.',
            runCancelledNote: 'Phiên chạy này đã bị hủy. Không có công việc, chứng cứ nháp hay tệp nào được tạo từ phiên chạy này.',
            runCancelFailed: 'Không thể hủy phiên chạy.',
        },
        // Sprint 47.7.3 — phát hiện xung đột chéo khung tuân thủ.
        crossFrameworkConflicts: {
            pageTitle: 'Xung đột chéo khung tuân thủ',
            pageSubtitle: 'Danh mục được tuyển chọn về nơi các gói pháp lý đã cài đặt của bạn tương tác theo cách xung đột. Forseti hiển thị; con người quyết định.',
            noInstalledPacks: 'Chưa có gói pháp lý nào được cài đặt cho tổ chức này — cài đặt ít nhất hai gói để hiển thị các xung đột chéo khung.',
            noConflicts: 'Không có xung đột nào khớp với bộ lọc hiện tại.',
            allAcknowledged: 'Mọi xung đột hiển thị đều đã được xác nhận. Tốt lắm.',
            columnSeverity: 'Mức độ',
            columnTitle: 'Tiêu đề',
            columnFrameworks: 'Khung tuân thủ',
            columnTopic: 'Chủ đề',
            columnStatus: 'Trạng thái',
            filterFrameworkPlaceholder: 'Tất cả khung',
            filterTopicPlaceholder: 'Tất cả chủ đề',
            filterSeverityPlaceholder: 'Tất cả mức độ',
            filterStatusPlaceholder: 'Tất cả trạng thái',
            filterStatusAcknowledged: 'Đã xác nhận',
            filterStatusUnacknowledged: 'Chưa xác nhận',
            severityCritical: 'Nghiêm trọng',
            severityHigh: 'Cao',
            severityMedium: 'Trung bình',
            severityLow: 'Thấp',
            statusAcknowledged: 'Đã xác nhận',
            statusInReview: 'Đang xem xét',
            statusResolved: 'Đã giải quyết',
            statusWontFix: 'Không xử lý',
            statusUnacknowledged: 'Chưa xác nhận',
            drawerSummaryHeading: 'Tóm tắt',
            drawerSideAHeading: 'Bên A',
            drawerSideBHeading: 'Bên B',
            drawerRequirementsLabel: 'Yêu cầu được trích dẫn',
            drawerProvisionsLabel: 'Điều khoản được trích dẫn',
            drawerSuggestedResolutionHeading: 'Giải pháp đề xuất',
            drawerLegalCounselBadge: 'Cần tư vấn pháp lý xem xét',
            drawerAckHeading: 'Xác nhận',
            drawerAckStatusLabel: 'Trạng thái',
            drawerAckAssigneeLabel: 'Người được giao',
            drawerAckDueDateLabel: 'Hạn chót',
            drawerAckNotesLabel: 'Ghi chú',
            drawerAckButtonAcknowledge: 'Xác nhận',
            drawerAckButtonUpdate: 'Cập nhật',
            drawerAckButtonUnacknowledge: 'Bỏ xác nhận',
            // fix-sprint-20260912-2123 F23 — các chuỗi trước đây bị viết cứng bằng
            // tiếng Anh trong TSX của ngăn chi tiết.
            drawerCloseLabel: 'Đóng',
            drawerAckAssigneePlaceholder: 'Mã người dùng',
            drawerAckSaveFailed: 'Không thể lưu xác nhận.',
            drawerAckUnacknowledgeFailed: 'Không thể bỏ xác nhận.',
            loadFailed: 'Không thể tải danh sách xung đột.',
            searchPlaceholder: 'Tìm kiếm tiêu đề hoặc tóm tắt…',
            // Sprint 47.9.1 — nút submit tìm kiếm tường minh.
            searchButton: 'Tìm kiếm',
            searchButtonAriaLabel: 'Chạy tìm kiếm xung đột',
            // Sprint 47.9.1 — xuất XLSX song song với CSV.
            exportSuccessTemplate: 'CSV: {filename}',
            exportSuccessTemplateXlsx: 'XLSX: {filename}',
            exportErrorTemplate: 'Xuất thất bại: {message}',
            exportAriaLabel: 'Xuất danh sách xung đột',
            // fix-sprint D1 F23 — the page-level load failure now renders through
            // `withRetry`, which needs the control's label, its busy label and the
            // subject a screen reader hears after it.
            reload: 'Tải lại',
            reloading: 'Đang tải lại…',
            retrySubject: 'danh sách xung đột',
        },
        // Sprint 47.5.6 — Forseti Tabular Reviews (lưới trích xuất nhiều tài liệu).
        tabularReviews: {
            pageTitle: 'Đánh giá dạng bảng',
            pageSubtitle: 'So sánh N tài liệu theo M thuộc tính, có trích dẫn căn cứ.',
            newReview: 'Đánh giá mới',
            newReviewHeading: 'Đánh giá dạng bảng mới',
            emptyHint: 'Chưa có đánh giá dạng bảng nào.',
            docsLabel: '{n} tài liệu',
            colsLabel: '{n} cột',
            detailSubtitle: '{docs} tài liệu · {cols} cột',
            addColumn: 'Thêm cột',
            addColumnHeading: 'Thêm cột',
            columnInfo: 'Xem câu lệnh & định dạng',
            columnInfoAria: 'Hiển thị câu lệnh và định dạng cho cột {name}',
            columnInfoPrompt: 'Câu lệnh',
            columnInfoFormat: 'Định dạng trả về',
            columnInfoPresets: 'Giá trị cho phép',
            columnInfoCitations: 'Trích dẫn',
            columnInfoCitationsRequired: 'Bắt buộc',
            removeColumn: 'Xóa cột',
            removeColumnAria: 'Xóa cột {name}',
            removeColumnConfirm: 'Xóa cột "{name}"? Các ô đã trích xuất của cột này sẽ bị xóa.',
            deleteReview: 'Xóa',
            deleteReviewAria: 'Xóa đánh giá {title}',
            deleteReviewConfirm: 'Xóa đánh giá "{title}"? Thao tác này sẽ xóa vĩnh viễn các cột, ô và thảo luận của nó.',
            runAll: 'Chạy tất cả',
            running: 'Đang chạy…',
            cancel: 'Huỷ',
            exportXlsx: 'Xuất Excel',
            exportCsv: 'Xuất CSV',
            exporting: 'Đang xuất…',
            backToList: 'Quay lại danh sách',
            notFound: 'Không tìm thấy đánh giá dạng bảng.',
            loadFailed: 'Không đọc được đánh giá dạng bảng. Hãy tải lại để thử lại.',
            emptyPayload: 'Máy chủ đã trả lời nhưng không kèm đánh giá dạng bảng. Hãy tải lại để thử lại.',
            reload: 'Tải lại',
            reloading: 'Đang tải lại…',
            retrySubject: 'đánh giá dạng bảng này',
            cancelFailed: 'Không huỷ được lần chạy.',
            removeColumnFailed: 'Không xóa được cột.',
            exportFailed: 'Không tạo được bản xuất.',
            noDocuments: 'Đính kèm tài liệu để bắt đầu.',
            noColumns: 'Thêm cột để xác định cần trích xuất gì.',
            tableAriaLabel: 'Lưới trích xuất',
            // fix-sprint-20260504-2137 F15 — TRTable thread aria-labels.
            threadsCountAria: '{n} bài thảo luận',
            startDiscussionAria: 'Bắt đầu thảo luận',
            docColumn: 'Tài liệu',
            statusPending: 'Chờ xử lý',
            statusRunning: 'Đang chạy…',
            statusFailed: 'Thất bại: {msg}',
            statusCancelled: 'Đã huỷ',
            citationsCount: '{n} trích dẫn',
            citationsView: 'Xem đoạn trích nguồn',
            citationPage: 'Trang {n}',
            titleRequired: 'Tiêu đề là bắt buộc.',
            fieldTitle: 'Tiêu đề',
            fieldProjectId: 'Dự án (tuỳ chọn)',
            fieldAttachmentIds: 'Tệp đính kèm',
            fieldColumnName: 'Tên cột',
            fieldColumnNameHelp: 'Nhãn ngắn gọn, mô tả cho cột này trong lưới trích xuất.',
            columnNamePlaceholder: 'VD: Ngày bắt đầu hợp đồng',
            fieldExtractionPrompt: 'Lệnh trích xuất',
            fieldExtractionPromptHelp: 'Mô tả thông tin bạn muốn trích xuất. Hãy cụ thể để có kết quả tốt hơn.',
            columnPromptPlaceholder: 'Forseti cần tìm gì trong tài liệu?',
            fieldReturnFormat: 'Định dạng trả về',
            fieldReturnFormatHelp: 'Kiểm soát cách AI định dạng câu trả lời (ví dụ: ngày hay số).',
            fieldPresets: 'Giá trị cho phép (mỗi dòng một giá trị)',
            fieldPresetsPlaceholder: 'có\nkhông\nmột phần',
            fieldCitationsRequired: 'Bắt buộc trích dẫn',
            formatShortText: 'Văn bản ngắn',
            formatLongText: 'Văn bản dài',
            formatEnum: 'Liệt kê',
            formatNumber: 'Số',
            formatDate: 'Ngày',
            formatList: 'Danh sách',
            columnRequireFields: 'Tên và lệnh là bắt buộc.',
            addColumnError: 'Thêm cột thất bại.',
            cancelButton: 'Huỷ',
            createButton: 'Tạo',
            creating: 'Đang tạo…',
            addButton: 'Thêm',
            adding: 'Đang thêm…',
            runConfirmHeading: 'Chạy trích xuất',
            estimateBody: 'Ước tính ~{units} đơn vị tính phí (độ tin cậy: {confidence}).',
            starting: 'Đang khởi chạy…',
            confirmRun: 'Xác nhận chạy',
            // Sprint 47.7.2 — biểu đồ theo cột.
            charts: {
                title: 'Biểu đồ cột',
                tabsAria: 'Cột biểu đồ',
                // fix-sprint-20260504-2137 F12/F13/F14 — chart aria/empty/excluded i18n.
                enumAria: 'Phân bố giá trị enum',
                numberAria: 'Biểu đồ phân bố giá trị số',
                dateAria: 'Dòng thời gian theo ngày',
                enumEmpty: 'Chưa có ô nào hoàn thành.',
                numberEmpty: 'Không có giá trị số.',
                numberExcluded: '{n} ô bị loại trừ (rỗng / không phải số / chưa hoàn thành).',
                dateEmpty: 'Không có giá trị ngày.',
                dateExcluded: '{n} ô bị loại trừ.',
                unsupportedFormat: 'Định dạng cột không được hỗ trợ.',
            },
            // Sprint 47.7.2 — luồng thảo luận theo ô.
            threads: {
                drawerTitle: 'Thảo luận',
                loading: 'Đang tải…',
                empty: 'Chưa có bài viết nào. Hãy bắt đầu thảo luận.',
                composerLabel: 'Bình luận mới',
                composerPlaceholder: 'Thêm bình luận…',
                post: 'Đăng',
                posting: 'Đang đăng…',
                edit: 'Sửa',
                editLabel: 'Sửa bài viết',
                delete: 'Xoá',
                save: 'Lưu',
                cancel: 'Huỷ',
                close: 'Đóng',
                editedBadge: 'đã sửa',
                // fix-sprint-20260504-2137 F19 — thread drawer error i18n.
                loadError: 'Không tải được luồng thảo luận',
                postError: 'Đăng thất bại',
                editError: 'Sửa thất bại',
                deleteError: 'Xóa thất bại',
            },
            // Sprint 47.7.2 — so sánh hai đánh giá.
            compare: {
                pageTitle: 'So sánh đánh giá',
                leftReviewLabel: 'Đánh giá bên trái',
                rightReviewLabel: 'Đánh giá bên phải',
                pickReview: 'Chọn đánh giá để so sánh',
                noSharedDocuments: 'Hai đánh giá không có tài liệu chung — cần ít nhất một tài liệu trùng nhau.',
                sharedDocumentsHeading: 'Tài liệu chung',
                leftOnlyHeading: 'Cột chỉ có ở đánh giá trái',
                rightOnlyHeading: 'Cột chỉ có ở đánh giá phải',
                differs: 'Khác nhau',
                identical: 'Giống nhau',
                emptyValue: '—',
                compareButton: 'So sánh với…',
                // fix-sprint-20260504-2137 F2/F3/F4/F5 — compare page hardcoded strings.
                documentHeading: 'Tài liệu',
                errorMissingIds: 'Cần cả ID đánh giá bên trái và bên phải.',
                errorComparisonFailed: 'So sánh thất bại.',
                errorLoadFailed: 'Không tải được các đánh giá.',
                pickerLoading: 'Đang tải…',
                pickerNoOtherReviews: 'Không có đánh giá khác để so sánh.',
                pickerCancel: 'Hủy',
            },
        },
        // Sprint 47.5.3a — Forseti Document Review (phiên bản + chỉnh sửa AI).
        documentReview: {
            pageTitle: 'Đánh giá tài liệu',
            pageSubtitle: 'Chấp nhận hoặc từ chối các chỉnh sửa AI đề xuất cho tài liệu này.',
            sidePanelLabel: 'Chỉnh sửa AI',
            sidePanelHeading: 'Chỉnh sửa AI',
            noPendingEdits: 'Không có chỉnh sửa nào đang chờ.',
            pendingCount: '{count} đang chờ',
            acceptAllButton: 'Chấp nhận tất cả',
            rejectAllButton: 'Từ chối tất cả',
            acceptAllTitle: 'Chấp nhận tất cả chỉnh sửa đang chờ?',
            acceptAllConfirm: 'Thao tác này sẽ chấp nhận {count} chỉnh sửa đang chờ và tạo một hoặc nhiều phiên bản mới. Tiếp tục?',
            editsHeading: 'Chỉnh sửa',
            editsEmpty: 'Không có chỉnh sửa nào để xem.',
            versionsHeading: 'Lịch sử phiên bản',
            versionsEmpty: 'Chưa có phiên bản.',
            editLabel: 'Chỉnh sửa',
            editLabelWithId: 'Chỉnh sửa #{id}',
            acceptButton: 'Chấp nhận',
            rejectButton: 'Từ chối',
            accepting: 'Đang chấp nhận…',
            rejecting: 'Đang từ chối…',
            diffDeletedAria: 'Đã xóa',
            diffInsertedAria: 'Đã chèn',
            statusPending: 'Chờ xử lý',
            statusAccepted: 'Đã chấp nhận',
            statusRejected: 'Đã từ chối',
            versionLabel: 'Phiên bản',
            versionAriaLabel: 'Phiên bản {n}',
            versionAriaLabelCurrent: 'Phiên bản {n} ({current})',
            versionCurrentTag: 'hiện tại',
            versionSourceLabel: 'Nguồn',
            versionCreatedLabel: 'Tạo lúc',
            versionModelLabel: 'Mô hình',
            sourceUpload: 'Tải lên',
            sourceUserUpload: 'Người dùng tải lên',
            sourceAssistantEdit: 'Chỉnh sửa của trợ lý',
            sourceUserAccept: 'Người dùng chấp nhận chỉnh sửa',
            sourceUserReject: 'Người dùng từ chối chỉnh sửa',
            sourceGenerated: 'Được tạo',
            extractionExtracted: 'Đã trích xuất văn bản',
            extractionFailed: 'Trích xuất văn bản thất bại',
            extractionUnsupported: 'Không thể trích xuất văn bản',
            extractionPages: '{n} trang',
            extractionWords: '{n} từ',
            extractionReasonScanned: 'Tài liệu này có vẻ là bản quét hoặc chỉ chứa hình ảnh. Forseti chưa đọc được — hãy tải lên tệp dạng văn bản hoặc dán nội dung trực tiếp.',
            extractionReasonEncrypted: 'Tệp được bảo vệ bằng mật khẩu. Hãy gỡ bảo vệ rồi tải lên lại.',
            extractionReasonMalformed: 'Không thể phân tích tệp, có thể tệp đã bị hỏng.',
            extractionReasonParserUnavailable: 'Bộ đọc PDF của máy chủ chưa được cài đặt đúng nên không thể đọc văn bản. Điều này không có nghĩa là tệp của bạn bị lỗi. Hãy đề nghị quản trị viên kiểm tra cài đặt.',
            extractionReasonTooLarge: 'Tệp quá lớn để xử lý.',
            extractionReasonTimeout: 'Xử lý quá lâu. Hãy thử tệp nhỏ hoặc đơn giản hơn.',
            extractionReasonUnknown: 'Không có thêm thông tin chi tiết.',
            // Sprint B — Hành động Forseti trên trang chi tiết rà soát tài liệu.
            // Cả hai đều mở phiên trò chuyện gắn với tài liệu này; câu lệnh đề
            // xuất chỉnh sửa là nút gợi ý (ChatInput không bao giờ tự gửi), nên
            // lệnh gọi mô hình luôn do người dùng chủ động kích hoạt.
            askForsetiButton: 'Hỏi Forseti',
            runRedlineButton: 'Đề xuất chỉnh sửa',
            forsetiModalTitleAsk: 'Hỏi Forseti — {name}',
            forsetiModalTitleRedline: 'Đề xuất chỉnh sửa — {name}',
            forsetiGuidanceAsk: 'Hỏi Forseti về tài liệu này. Chọn một gợi ý bên dưới hoặc tự nhập câu hỏi của bạn.',
            forsetiGuidanceRedline: 'Forseti sẽ đọc tài liệu này và đề xuất các chỉnh sửa trực tiếp. Chọn gợi ý đề xuất chỉnh sửa bên dưới để bắt đầu — các chỉnh sửa sẽ hiển thị trong bảng bên để bạn chấp nhận hoặc từ chối.',
            forsetiStarterRedline: 'Đọc tài liệu đính kèm {id} và đề xuất chỉnh sửa cho các vấn đề pháp lý và tuân thủ',
            forsetiStarterSummarise: 'Tóm tắt các nghĩa vụ chính trong tài liệu đính kèm {id}',
            forsetiStarterRisks: 'Rà soát tài liệu đính kèm {id} để tìm rủi ro pháp lý và điều khoản còn thiếu',
            forsetiStarterFrameworks: 'Những khung tuân thủ nào áp dụng cho tài liệu đính kèm {id}?',
            textPaneLabel: 'Nội dung tài liệu',
            textPaneTitle: 'Nội dung tài liệu',
            textPaneVersion: 'Phiên bản {n}',
            textPaneEmpty: 'Không có nội dung văn bản cho phiên bản này. PDF dạng quét và một số loại tài liệu không có văn bản trích xuất được.',
            downloadVersionAria: 'Tải xuống phiên bản {n}',
            downloadVersionButton: 'Tải xuống',
            rejectAllConfirm: 'Thao tác này từ chối {count} chỉnh sửa đang chờ. Lý do bạn nhập sẽ được ghi trên từng chỉnh sửa.',
            rejectAllTitle: 'Từ chối tất cả chỉnh sửa đang chờ?',
            rejectReasonShown: 'Lý do',
            rejectConfirmButton: 'Xác nhận từ chối',
            loadRedlinesFailed: 'Không tải được các chỉnh sửa AI đề xuất',
            acceptEditsFailed: 'Không chấp nhận được các chỉnh sửa',
            rejectEditsFailed: 'Không từ chối được các chỉnh sửa',
            batchPartialFailure: '{failed} trên {total} thao tác thất bại: {reason}',
            actionFailed: 'Thao tác không thành công',
            rejectReasonLabel: 'Lý do từ chối (không bắt buộc)',
        },
        // Sprint 47.8.0a — Trang chỉ mục Document Review (thay thế màn hình trắng
        // tại `/admin/forseti/document-review`).
        documentReviewIndex: {
            sidebarLabel: 'Rà soát tài liệu',
            pageTitle: 'Rà soát tài liệu',
            pageSubtitle: 'Tài liệu trong tổ chức của bạn có chỉnh sửa do AI đề xuất đang chờ xét duyệt hoặc có phiên bản từ Forseti.',
            colDocument: 'Tài liệu',
            colLinkedRecord: 'Bản ghi liên kết',
            colPendingEdits: 'Chỉnh sửa chờ xử lý',
            colLastActivity: 'Hoạt động gần nhất',
            colOpen: 'Mở',
            open: 'Mở',
            empty: 'Chưa có tài liệu nào đang được Forseti rà soát. Tài liệu vào hàng đợi này khi Forseti đề xuất chỉnh sửa trong hội thoại, khi quy trình AI tạo bản redline, hoặc khi bạn gửi tài liệu để rà soát bằng nút phía trên.',
            loading: 'Đang tải…',
            loadError: 'Không tải được danh sách tài liệu đang rà soát.',
            retryButton: 'Thử lại',
            noLinkedRecord: '—',
            pendingZero: 'Không',
            // Sprint 47.7.4 AC-4 — nút và nhãn modal "Gửi tài liệu để rà soát".
            sendForReviewButton: 'Gửi tài liệu để rà soát',
            sendForReviewTitle: 'Gửi tài liệu để rà soát',
            sendForReviewSubtitle: 'Tải lên tài liệu .txt, .md, .pdf hoặc .docx (tối đa 50 MB). Tài liệu sẽ được thêm vào hàng đợi rà soát và Forseti sẽ tạo bản redline.',
            sendForReviewTabUpload: 'Tải lên tệp mới',
            sendForReviewPickerLabel: 'Tìm tệp đính kèm',
            sendForReviewPickerPlaceholder: 'Nhập để tìm…',
            sendForReviewPickerEmpty: 'Không có tệp đính kèm khớp. Hãy thử từ khóa khác.',
            sendForReviewSubmit: 'Gửi để rà soát',
            sendForReviewCancel: 'Hủy',
            sendForReviewSubmitting: 'Đang gửi…',
            sendForReviewError: 'Không gửi được tài liệu để rà soát. Vui lòng thử lại.',
            sendForReviewSuccess: 'Đã gửi tài liệu để rà soát.',
            // fix-sprint-20260504-2137 F16 — file validation messages.
            sendForReviewAcceptedExt: 'Đã chấp nhận: {ext}.',
            sendForReviewMaxSize: 'Kích thước tối đa {mb} MB.',
        },
        // fix-sprint-20260504-2137 F17 — Forseti chats (export errors).
        chats: {
            exportError: 'Xuất thất bại.',
        },
    },
    pdplEvidencePacks: {
        title: 'Gói bằng chứng PDPL',
        subtitle: 'Nộp bằng chứng cho Bộ Công an A05 qua kênh do khách hàng kiểm soát',
        nav: {
            emailProviders: 'Nhà cung cấp email',
        },
        providers: {
            pageTitle: 'Nhà cung cấp email',
            pageSubtitle: 'Cấu hình nhà cung cấp thư đi của tổ chức để nộp gói bằng chứng PDPL cho Bộ Công an A05.',
            architectureRuleHeading: 'Quy tắc kiến trúc (đã khoá)',
            architectureRuleBody: 'AesirX không phải là người gửi email gói bằng chứng. Mọi lượt gửi đều sử dụng nhà cung cấp do tổ chức của bạn sở hữu và kiểm soát. AesirX không bao giờ gửi thay mặt cho bạn.',
            empty: 'Chưa có nhà cung cấp nào được cấu hình.',
            createCta: 'Tạo nhà cung cấp',
            statusPendingConsent: 'Chờ xác nhận đồng ý',
            statusPendingConnectionCheck: 'Chờ kiểm tra kết nối',
            statusActive: 'Hoạt động',
            statusConnectionCheckFailed: 'Kiểm tra kết nối thất bại',
            statusDisabled: 'Đã vô hiệu hoá',
            acceptConsentCta: 'Xác nhận đồng ý',
            runConnectionCheckCta: 'Chạy kiểm tra kết nối',
            disableCta: 'Vô hiệu hoá',
            disableConfirm: 'Vô hiệu hoá nhà cung cấp này sẽ dừng kênh gửi trực tiếp cho đến khi có nhà cung cấp mới và sự đồng ý được xác nhận lại. Tiếp tục?',
            columnDisplayName: 'Tên',
            columnFromAddress: 'Địa chỉ người gửi',
            columnStatus: 'Trạng thái',
            columnLastCheck: 'Kiểm tra gần nhất',
            columnActions: 'Hành động',
            createModalTitle: 'Nhà cung cấp SMTP mới',
            createDisplayNameLabel: 'Tên hiển thị',
            createFromAddressLabel: 'Địa chỉ người gửi',
            createReplyToLabel: 'Địa chỉ trả lời (tuỳ chọn)',
            createSmtpHostLabel: 'Máy chủ SMTP',
            createSmtpPortLabel: 'Cổng SMTP',
            createSmtpUsernameLabel: 'Tên đăng nhập SMTP',
            createSmtpPasswordLabel: 'Mật khẩu SMTP',
            createSmtpEncryptionLabel: 'Mã hoá',
            createSmtpEncryptionStarttls: 'STARTTLS',
            createSmtpEncryptionTls: 'TLS (ngầm định)',
            createSmtpEncryptionNone: 'Không',
            createOauthM365Tab: 'Microsoft 365',
            createOauthGoogleTab: 'Google Workspace',
            createOauthDisabledBadge: 'Sắp ra mắt',
            createOauthDisabledHint: 'Nhà cung cấp OAuth chưa được kích hoạt. Vui lòng sử dụng SMTP cho hiện tại.',
            createSubmitCta: 'Tạo nhà cung cấp',
            createCancelCta: 'Huỷ',
            createErrorInvalidFromAddress: 'Địa chỉ người gửi phải là một hộp thư hợp lệ.',
            createErrorDuplicateFromAddress: 'Một nhà cung cấp khác đã được cấu hình cho địa chỉ người gửi này.',
            createErrorGeneric: 'Không thể tạo nhà cung cấp. Vui lòng kiểm tra biểu mẫu và thử lại.',
            consentModalTitle: 'Xác nhận quy tắc kiến trúc',
            consentLocaleToggleEn: 'English',
            consentLocaleToggleVi: 'Tiếng Việt',
            consentAcknowledgeCta: 'Tôi xác nhận — Đồng ý',
            consentCancelCta: 'Huỷ',
            consentErrorMismatch: 'Nội dung đồng ý đã bị chỉnh sửa và không còn khớp với văn bản chính tắc. Vui lòng mở lại hộp thoại và gửi lại.',
            testModalTitle: 'Kiểm tra kết nối',
            testRunningCta: 'Đang kiểm tra kết nối…',
            testRunCta: 'Chạy kiểm tra kết nối',
            testRetryCta: 'Thử lại kiểm tra kết nối',
            testSuccessHeading: 'Kết nối thành công',
            testSuccessBody: 'Đã xác thực với {host}:{port} trong {latencyMs} mili-giây. Nhà cung cấp sẵn sàng cho việc gửi trực tiếp.',
            testFailureHeading: 'Kết nối thất bại',
            testFailureBody: 'Quá trình kiểm tra không hoàn tất. Xem lý do bên dưới và thử lại sau khi đã sửa.',
            testFailureReasonLabel: 'Lý do thất bại',
            testCloseCta: 'Đóng',
            detailDrawerTitle: 'Chi tiết nhà cung cấp',
            detailDrawerHistoryHeading: 'Lịch sử kiểm tra kết nối',
            detailDrawerConsentHeading: 'Xác nhận đồng ý',
            detailDrawerNoHistory: 'Chưa có lượt kiểm tra kết nối nào.',
            detailDrawerNoConsent: 'Sự đồng ý chưa được xác nhận.',
            outcomeSuccess: 'Thành công',
            outcomeFailure: 'Thất bại',
        },
        builder: {
            pageTitle: 'Lắp ráp gói bằng chứng',
            pageSubtitle: 'Tải lên 6 tệp thành phần, chọn loại gói và lắp ráp tệp ZIP 8 phần xác định để nộp.',
            packTypeLabel: 'Loại gói',
            packTypeDpia: 'Hồ sơ đánh giá tác động xử lý (thông báo 02a/02b; báo cáo 10)',
            packTypeOtia: 'Hồ sơ đánh giá tác động chuyển xuyên biên giới (thông báo 01a/01b; báo cáo 09)',
            part01CoverLetter: 'Phần 01 — Thư bìa (PDF)',
            part02AuthorityForm: 'Phần 02 — Biểu mẫu của cơ quan (PDF)',
            part03Supporting: 'Phần 03 — Bằng chứng hỗ trợ (≥1)',
            part04Safeguards: 'Phần 04 — Các biện pháp bảo vệ',
            part04SafeguardsRequiredOtia: '(bắt buộc cho OTIA)',
            part05PriorCorrespondence: 'Phần 05 — Thư từ trước đó (tuỳ chọn)',
            part06Signature: 'Phần 06 — Bằng chứng chữ ký + đóng dấu (≥1)',
            uploadPickFile: 'Chọn tệp',
            uploadPickFiles: 'Chọn các tệp',
            uploadRemoveFile: 'Gỡ',
            requiredMissing: 'Phần bắt buộc còn thiếu',
            assembleCta: 'Lắp ráp gói',
            assembling: 'Đang lắp ráp…',
            assembleSuccessHeading: 'Đã lắp ráp gói',
            assembleSuccessSummary: '{fileCount} tệp · {bytes} byte · SHA-256 {shaPrefix}…',
            composeNextCta: 'Soạn bản nháp email',
            warningsHeading: 'Cảnh báo xác thực',
            assembleError: 'Không thể lắp ráp gói. Vui lòng xem lại đầu vào và thử lại.',
            forsetiAssistHeading: 'Hỗ trợ AI Forseti (tùy chọn)',
            forsetiAssistHint: 'Chạy Cố vấn lắp ráp gói bằng chứng PDPL để nêu các phần còn thiếu, soạn dự thảo công văn và cảnh báo khoảng trống bảo vệ. AesirX không phải là người gửi — AI chỉ tư vấn; bạn phê duyệt mọi sản phẩm.',
            forsetiAssistCta: 'Mở thư viện quy trình Forseti',
            forsetiAiRunIdLabel: 'ID lần chạy AI Forseti liên kết (dán để ghi nhận hỗ trợ AI)',
        },
        draft: {
            pageTitle: 'Bản nháp email',
            pageSubtitle: 'Soạn và chỉnh sửa bản nháp email. Gửi trực tiếp sẽ ra mắt trong một bản phát hành tiếp theo.',
            composeCta: 'Soạn bản nháp',
            composing: 'Đang soạn…',
            noDraftYet: 'Chưa có bản nháp. Hãy soạn một bản để bắt đầu.',
            localeToggleLabel: 'Ngôn ngữ',
            localeEn: 'English',
            localeVi: 'Tiếng Việt',
            subjectLabel: 'Tiêu đề',
            bodyLabel: 'Nội dung',
            saveCta: 'Lưu thay đổi',
            saving: 'Đang lưu…',
            saveError: 'Không thể lưu bản nháp. Vui lòng thử lại.',
            manifestSummaryLabel: 'Tóm tắt manifest',
            coverLetterLabel: 'Thư bìa PDF',
            coverLetterDownloadCta: 'Tải xuống PDF',
            editHistoryHeading: 'Lịch sử chỉnh sửa',
            editHistoryEmpty: 'Chưa có chỉnh sửa nào.',
            editHistoryEntry: 'v{version} · {fields} · {when} · {who}',
            unofficialChannelHeading: 'Thông báo kênh không chính thức NQ22',
            uploadSentProofCta: 'Tải lên bằng chứng đã gửi thủ công',
            versionLabel: 'Phiên bản',
            statusDraft: 'Bản nháp',
            statusEdited: 'Đã chỉnh sửa',
            statusFinalized: 'Đã hoàn tất',
        },
        sentProof: {
            modalTitle: 'Tải lên bằng chứng đã gửi thủ công',
            architectureLockNote: 'AesirX không phải là người gửi. Bằng chứng này ghi lại lượt gửi thủ công bạn đã thực hiện qua trình email của riêng mình.',
            fileLabel: 'Tệp bằng chứng (.eml, .png, .jpg)',
            envelopeFromLabel: 'Người gửi',
            envelopeToLabel: 'Người nhận',
            envelopeSubjectLabel: 'Tiêu đề (lúc gửi)',
            envelopeSentAtLabel: 'Thời điểm gửi',
            envelopeAttachmentShaLabel: 'SHA-256 tệp đính kèm (lúc gửi)',
            uploadCta: 'Tải lên bằng chứng',
            uploading: 'Đang tải lên…',
            uploadSuccess: 'Đã tải bằng chứng lên.',
            uploadErrorInvalidMime: 'Loại tệp không được phép. Hãy dùng .eml, .png, .jpg hoặc .jpeg.',
            uploadErrorGeneric: 'Không thể tải bằng chứng lên. Vui lòng thử lại.',
            existingProofsHeading: 'Các bằng chứng đã ghi nhận',
            existingProofsEmpty: 'Chưa ghi nhận bằng chứng nào.',
            proofEntry: '{when} · {filename}',
        },
        packDetail: {
            pageTitle: 'Gói bằng chứng',
            notFoundMessage: 'Không tìm thấy gói — có thể đã bị xóa hoặc đường liên kết không đúng.',
            manifestHeading: 'Manifest',
            dossierLabel: 'Hồ sơ',
            packShaLabel: 'SHA-256 gói',
            fileCountLabel: 'Số tệp',
            bytesLabel: 'Dung lượng',
            composeDraftCta: 'Soạn bản nháp',
            sendComingSoonCta: 'Gửi trực tiếp: sắp ra mắt',
            sendComingSoonHint: 'Luồng gửi trực tiếp đang được phát triển tích cực. Hãy dùng "Tải lên bằng chứng đã gửi thủ công" trên trang bản nháp cho đến khi tính năng này ra mắt.',
            sendCta: 'Gửi qua nhà cung cấp đã cấu hình',
            sendDisabledNoProviderHint: 'Trước tiên hãy cấu hình một nhà cung cấp email do khách hàng kiểm soát. AesirX không bao giờ gửi thay cho bạn.',
            timelineHeading: 'Lịch sử gửi',
        },
        // Sprint 58.4.2 (Phase 25 / Sprint E2) — direct-send + timeline + authority response + hard-copy follow-up.
        send: {
            // Send dialog
            dialogTitle: 'Gửi gói bằng chứng',
            providerPickerLabel: 'Nhà cung cấp email đã cấu hình',
            providerPickerHint: 'AesirX không bao giờ gửi thay cho bạn. Hãy chọn một trong các nhà cung cấp đã cấu hình bên dưới.',
            providerPickerEmpty: 'Chưa có nhà cung cấp nào đang hoạt động. Hãy cấu hình một nhà cung cấp tại trang Nhà cung cấp email trước khi gửi.',
            providerPickerEmptyCta: 'Mở Nhà cung cấp email',
            draftPickerLabel: 'Bản nháp email',
            draftPickerOption: '{locale} · phiên bản {version}',
            draftPickerEmpty: 'Chưa có bản nháp nào được soạn cho gói này. Hãy soạn một bản nháp trên trang bản nháp trước.',
            recipientToLabel: 'Đến',
            recipientToHint: 'Một hoặc nhiều địa chỉ email, phân tách bằng dấu phẩy.',
            recipientCcLabel: 'Cc (phân tách bằng dấu phẩy)',
            recipientCcHint: 'Tùy chọn. Danh sách địa chỉ email phân tách bằng dấu phẩy.',
            recipientBccLabel: 'Bcc (phân tách bằng dấu phẩy)',
            recipientBccHint: 'Tùy chọn. Danh sách địa chỉ email phân tách bằng dấu phẩy.',
            consentReaffirmHeading: 'Xác nhận lại sự đồng ý của nhà cung cấp',
            submitCta: 'Gửi ngay',
            sending: 'Đang gửi…',
            cancelCta: 'Hủy',
            sendSuccess: 'Đã ghi nhận lượt gửi. Gói đã được truyền qua nhà cung cấp đã cấu hình của bạn.',
            sendErrorGeneric: 'Không thể gửi gói. Vui lòng xem lỗi bên dưới và thử lại.',
            sendErrorAlreadyFinalized: 'Bản nháp này đã được sử dụng cho một lượt gửi thành công. Hãy soạn một bản nháp mới trước khi gửi lại.',
            sendErrorInvalidRecipients: 'Một hoặc nhiều địa chỉ người nhận không phải là hộp thư hợp lệ.',
            // Timeline
            timelineEmpty: 'Chưa có lượt gửi nào được ghi nhận. Hãy dùng "Gửi qua nhà cung cấp đã cấu hình" ở trên để truyền qua SMTP / Microsoft 365 / Google Workspace do khách hàng kiểm soát.',
            timelineProviderLabel: 'Đã gửi qua nhà cung cấp đã cấu hình của bạn',
            timelineSentAtLabel: 'Đã gửi',
            timelineRecipientLabel: 'Người nhận',
            timelineOutcomeSent: 'Đã gửi',
            timelineOutcomeFailed: 'Thất bại',
            timelineViewDetailsCta: 'Xem chi tiết',
            // Authority-response chips
            authorityChipNone: 'Đang chờ phản hồi',
            authorityChipAcknowledgement: 'Xác nhận đã nhận',
            authorityChipAcceptance: 'Chấp nhận',
            authorityChipRejection: 'Từ chối',
            authorityChipSupplementRequest: 'Yêu cầu bổ sung',
            authorityChipNoResponse: 'Không phản hồi',
            // Hard-copy chips
            hardCopyChipNone: 'Không có theo dõi bản cứng',
            hardCopyChipPending: 'Đã gửi bưu điện — đang chờ giao',
            hardCopyChipDelivered: 'Đã giao',
            // Drawer
            drawerTitle: 'Bản ghi gửi',
            drawerEnvelopeHeading: 'Phong bì',
            drawerEnvelopeFromLabel: 'Từ',
            drawerEnvelopeToLabel: 'Đến',
            drawerEnvelopeCcLabel: 'Cc',
            drawerEnvelopeBccLabel: 'Bcc',
            drawerEnvelopeSubjectLabel: 'Tiêu đề',
            drawerEnvelopeMessageIdLabel: 'Mã thư',
            drawerOutcomeHeading: 'Kết quả',
            drawerSnapshotHeading: 'Ảnh chụp chuỗi giám sát',
            drawerSnapshotPackShaLabel: 'SHA-256 gói tại thời điểm gửi',
            drawerSnapshotDraftVersionLabel: 'Phiên bản bản nháp tại thời điểm gửi',
            drawerSnapshotAttachmentLabel: 'ZIP đã truyền',
            drawerSnapshotAttachmentDownloadCta: 'Tải xuống ZIP',
            drawerAuthorityResponseHeading: 'Phản hồi của cơ quan',
            drawerHardCopyHeading: 'Theo dõi bản cứng',
            drawerSentByLabel: 'Người gửi',
            drawerSendIdLabel: 'Mã bản ghi gửi',
            drawerSmtpResponseLabel: 'Phản hồi SMTP',
            drawerFailureReasonLabel: 'Lý do thất bại',
            drawerLatencyLabel: 'Độ trễ',
            drawerLatencyValue: '{ms} ms',
            drawerAcceptedLabel: 'Đã chấp nhận',
            drawerRejectedLabel: 'Đã từ chối',
            drawerCloseCta: 'Đóng',
            // Authority-response panel
            authorityRecordCta: 'Ghi nhận phản hồi',
            authorityReclassifyCta: 'Phân loại lại',
            authorityClassificationLabel: 'Phân loại',
            authorityReceivedAtLabel: 'Nhận lúc',
            authorityFreeTextLabel: 'Ghi chú (tùy chọn)',
            authorityEvidenceLabel: 'Tệp bằng chứng (.eml / .pdf / .png / .jpg — tùy chọn)',
            authorityReasonLabel: 'Lý do phân loại lại',
            authorityHistoryHeading: 'Lịch sử phân loại lại',
            authorityHistoryEmpty: 'Chưa ghi nhận lần phân loại lại nào.',
            authorityHistoryEntry: '{when} · {previous} → {next} · {who}{reason}',
            authoritySubmitCta: 'Lưu phản hồi',
            authoritySubmitting: 'Đang lưu…',
            authorityErrorInvalidMime: 'Loại tệp bằng chứng không được phép. Hãy dùng .eml, .pdf, .png hoặc .jpg.',
            authorityErrorGeneric: 'Không thể lưu phản hồi. Vui lòng thử lại.',
            authorityRecordedAtLabel: 'Ghi nhận lúc',
            authorityRecordedByLabel: 'Người ghi nhận',
            authorityEvidenceFilenameLabel: 'Bằng chứng',
            authorityEvidenceDownloadCta: 'Tải xuống bằng chứng',
            // Hard-copy panel
            hardCopyRecordCta: 'Ghi lại theo dõi bản cứng',
            hardCopyConfirmCta: 'Xác nhận đã giao',
            hardCopyEditNotesCta: 'Sửa ghi chú giao hàng',
            hardCopyPostedAtLabel: 'Gửi bưu điện lúc',
            hardCopyCourierLabel: 'Đơn vị chuyển phát',
            hardCopyTrackingLabel: 'Mã vận đơn',
            hardCopyRecipientLabel: 'Người nhận trên nhãn',
            hardCopyReceiptLabel: 'Bằng chứng biên nhận (.pdf / .png / .jpg — tùy chọn)',
            hardCopyReceiptDownloadCta: 'Tải xuống biên nhận',
            hardCopyDeliveredAtLabel: 'Đã giao lúc',
            hardCopyDeliveryNotesLabel: 'Ghi chú giao hàng (tùy chọn)',
            hardCopySubmitCta: 'Lưu theo dõi',
            hardCopySubmitting: 'Đang lưu…',
            hardCopyErrorInvalidMime: 'Loại tệp biên nhận không được phép. Hãy dùng .pdf, .png hoặc .jpg.',
            hardCopyErrorGeneric: 'Không thể lưu theo dõi. Vui lòng thử lại.',
        },
    },
    // Sprint 62.53.0 — khai báo hồ sơ tổ chức.
    org_profile_statements: {
        attribute_names: {
            data_exploitation_routes: 'Cơ chế khai thác dữ liệu',
            regulated_entity_types: 'Loại hình tổ chức thuộc đối tượng điều chỉnh',
        },
        review_task: {
            title: 'Rà soát phạm vi áp dụng: {attribute}',
            description: 'Tổ chức của bạn đã khai báo là chưa xác định được câu trả lời cho “{attribute}”. Các yêu cầu phụ thuộc vào thông tin này đang chờ rà soát phạm vi áp dụng và không bị coi là nằm ngoài phạm vi. Hãy ghi nhận câu trả lời tại trang Hồ sơ tổ chức.',
        },
        nav_label: 'Hồ sơ tổ chức',
        page: {
            title: 'Hồ sơ tổ chức',
            description: 'Những gì tổ chức của bạn khai báo về chính mình: lĩnh vực hoạt động, cơ chế khai thác dữ liệu mà tổ chức tham gia và loại hình tổ chức thuộc đối tượng điều chỉnh. Các khung tuân thủ đã cài đặt đọc các khai báo này để xác định yêu cầu nào áp dụng cho tổ chức. Yêu cầu phụ thuộc vào một câu trả lời chưa được khai báo, hoặc được khai báo là chưa xác định, sẽ chờ rà soát phạm vi áp dụng và không bao giờ bị coi là nằm ngoài phạm vi.',
            sectors_heading: 'Lĩnh vực hoạt động',
        },
        section: {
            state_legend: 'Câu trả lời của tổ chức',
            state_selected: 'Đã chọn',
            state_selected_help: 'Một hoặc nhiều lựa chọn dưới đây áp dụng cho tổ chức của bạn. Đánh dấu từng lựa chọn áp dụng.',
            state_none: 'Không thuộc trường hợp nào',
            state_none_help: 'Không lựa chọn nào áp dụng. Các yêu cầu chỉ phụ thuộc vào các lựa chọn này được hiển thị là nằm ngoài phạm vi.',
            state_unknown: 'Chưa xác định — cần rà soát',
            state_unknown_help: 'Tổ chức chưa xác định được. Một nhiệm vụ rà soát phạm vi áp dụng được thêm vào danh sách nhiệm vụ, và các yêu cầu phụ thuộc vào câu trả lời này không bao giờ bị coi là nằm ngoài phạm vi.',
            values_legend: 'Các lựa chọn áp dụng',
            values_disabled_hint: 'Chọn “Đã chọn” để đánh dấu các lựa chọn áp dụng.',
            values_required: 'Hãy chọn ít nhất một lựa chọn, hoặc chọn câu trả lời khác.',
            used_by_label: 'Được dùng bởi',
            used_by_none: 'Chưa có khung tuân thủ đã cài đặt nào nêu lựa chọn này.',
            used_by_item: '{framework} ({count} yêu cầu)',
            used_by_item_one: '{framework} (1 yêu cầu)',
            used_by_item_reference: '{framework} ({count} yêu cầu, chỉ cài đặt để tham khảo)',
            used_by_item_reference_one: '{framework} (1 yêu cầu, chỉ cài đặt để tham khảo)',
            note_label: 'Ghi chú',
            note_hint: 'Không bắt buộc. Căn cứ của câu trả lời này, do tổ chức tự mô tả (tối đa {max} ký tự).',
            evidence_heading: 'Tài liệu chứng minh',
            evidence_hint: 'Các tệp chứng minh cho câu trả lời này. Tệp được nêu trong một khai báo đã lưu được giữ lại trong suốt thời gian lịch sử khai báo còn tồn tại.',
            evidence_none: 'Chưa đính kèm tài liệu chứng minh.',
            evidence_not_held: 'Tệp không còn được lưu giữ',
            evidence_upload_label: 'Đính kèm tài liệu chứng minh',
            evidence_unbind: 'Gỡ khỏi khai báo',
            evidence_unbind_label: 'Gỡ {filename} khỏi khai báo này',
            evidence_unbind_not_held_label: 'Gỡ tệp không còn được lưu giữ khỏi khai báo này',
            evidence_limit: 'Một khai báo chỉ được nêu tối đa {max} tệp.',
            current_none: 'Chưa ghi nhận khai báo nào. Các yêu cầu phụ thuộc vào câu trả lời này đang chờ rà soát phạm vi áp dụng.',
            current_revision: 'Khai báo hiện hành: phiên bản {revision}, ghi nhận ngày {date}.',
            save: 'Lưu khai báo',
            saving: 'Đang lưu…',
            reset: 'Đặt lại',
            saved: 'Đã lưu khai báo.',
            save_failed: 'Không thể lưu khai báo.',
            conflict: 'Người khác đã thay đổi khai báo này trong lúc bạn chỉnh sửa (bạn đã đọc phiên bản {expected}; hiện là phiên bản {current}). Chưa có nội dung nào được lưu, và các thay đổi của bạn vẫn còn trên màn hình.',
            reload_current: 'Tải lại khai báo hiện hành',
            evidence_not_held_error: 'Một số tệp tài liệu chứng minh nêu trong khai báo này không còn được lưu giữ ({count}). Hãy gỡ các tệp đó khỏi khai báo và lưu lại.',
            load_failed: 'Không thể đọc khai báo này.',
            reload: 'Tải lại',
            reloading: 'Đang tải lại…',
            retry_subject: 'khai báo về {attribute}',
            read_only: 'Bạn có thể xem khai báo này nhưng không thể thay đổi.',
            history_show: 'Hiển thị lịch sử khai báo ({count})',
            history_hide: 'Ẩn lịch sử khai báo',
            history_caption: 'Lịch sử khai báo, mới nhất trước',
            history_revision: 'Phiên bản',
            history_date: 'Ngày ghi nhận',
            history_answer: 'Câu trả lời',
            history_values: 'Lựa chọn',
            history_note: 'Ghi chú',
            history_evidence: 'Tệp tài liệu chứng minh',
            history_none: '—',
        },
        attribute_descriptions: {
            data_exploitation_routes: 'Các cơ chế mà qua đó tổ chức của bạn tham gia khai thác dữ liệu do Nhà nước nắm giữ hoặc cung cấp. Các yêu cầu phụ thuộc vào một cơ chế chỉ áp dụng khi bạn chọn cơ chế đó.',
            regulated_entity_types: 'Loại hình tổ chức thuộc đối tượng điều chỉnh mà tổ chức của bạn thuộc về, trong số quỹ tín dụng nhân dân, tổ chức tài chính vi mô, ngân hàng hợp tác xã và tổ chức bảo hiểm tiền gửi, nếu có. Các yêu cầu đặt ra đối với một loại hình chỉ áp dụng khi bạn chọn loại hình đó.',
        },
        value_labels: {
            data_exploitation_routes: {
                public_data_access_request: 'Đề nghị tiếp cận dữ liệu do Nhà nước nắm giữ',
                state_data_centre_exploitation: 'Khai thác dữ liệu tại trung tâm dữ liệu của Nhà nước',
                state_data_incubator: 'Tham gia vườn ươm dữ liệu của Nhà nước',
                data_controlled_testing: 'Thử nghiệm có kiểm soát giải pháp dữ liệu',
                state_data_centre_data_sharing: 'Chia sẻ dữ liệu với trung tâm dữ liệu của Nhà nước',
                state_data_centre_investment: 'Đầu tư, tài trợ cho trung tâm dữ liệu của Nhà nước',
                foreign_party_data_cooperation: 'Hợp tác dữ liệu với bên nước ngoài',
                state_data_incentive_application: 'Đề nghị hưởng ưu đãi của Nhà nước cho hoạt động dữ liệu',
            },
            regulated_entity_types: {
                credit_cooperative: 'Quỹ tín dụng nhân dân',
                cooperative_central_bank: 'Ngân hàng hợp tác xã',
                deposit_insurer: 'Tổ chức bảo hiểm tiền gửi',
                microfinance_institution: 'Tổ chức tài chính vi mô',
            },
        },
        value_help: {
            data_exploitation_routes: {
                public_data_access_request: 'Tổ chức của bạn đề nghị tiếp cận hoặc khai thác dữ liệu do cơ quan nhà nước nắm giữ bằng một yêu cầu khai thác dữ liệu chính thức.',
                state_data_centre_exploitation: 'Tổ chức của bạn khai thác dữ liệu do một trung tâm sáng tạo, khai thác dữ liệu của Nhà nước cung cấp.',
                state_data_incubator: 'Tổ chức của bạn tham gia chương trình ươm tạo về dữ liệu do Nhà nước tổ chức.',
                data_controlled_testing: 'Tổ chức của bạn thử nghiệm sản phẩm, dịch vụ hoặc giải pháp dữ liệu theo cơ chế thử nghiệm có kiểm soát.',
                state_data_centre_data_sharing: 'Tổ chức của bạn cung cấp hoặc chia sẻ dữ liệu cho trung tâm dữ liệu của Nhà nước, mà không khai thác dữ liệu của trung tâm.',
                state_data_centre_investment: 'Tổ chức của bạn đầu tư, góp tài sản hoặc tài trợ cho trung tâm dữ liệu của Nhà nước, mà không khai thác dữ liệu của trung tâm.',
                foreign_party_data_cooperation: 'Tổ chức của bạn hợp tác với tổ chức, cá nhân nước ngoài trong các hoạt động dữ liệu này.',
                state_data_incentive_application: 'Tổ chức của bạn đề nghị hưởng, hoặc đang được hưởng, ưu đãi hay hỗ trợ của Nhà nước cho hoạt động dữ liệu. Việc đề nghị không phải là khai thác dữ liệu.',
            },
            regulated_entity_types: {
                credit_cooperative: 'Tổ chức của bạn là tổ chức tín dụng hoạt động theo mô hình hợp tác xã, nhận tiền gửi và cho vay đối với thành viên.',
                cooperative_central_bank: 'Tổ chức của bạn là ngân hàng hợp tác xã của hệ thống quỹ tín dụng nhân dân.',
                deposit_insurer: 'Tổ chức của bạn thực hiện bảo hiểm tiền gửi tại các tổ chức tín dụng.',
                microfinance_institution: 'Tổ chức của bạn là tổ chức tài chính vi mô.',
            },
        },
        review: {
            title: 'Rà soát phạm vi áp dụng',
            description: 'Các yêu cầu của khung tuân thủ đã cài đặt đang chờ một câu trả lời trên trang này. Mỗi yêu cầu sẽ áp dụng, hoặc nằm ngoài phạm vi, khi câu trả lời được ghi nhận; cho đến khi đó, yêu cầu không bị coi là nằm ngoài phạm vi.',
            state_not_stated: 'Chưa ghi nhận khai báo',
            state_selected: 'Đã chọn',
            state_none: 'Không thuộc trường hợp nào',
            state_unknown: 'Chưa xác định — cần rà soát',
            group_state: 'Câu trả lời hiện hành: {state}',
            group_count: '{count} yêu cầu đang chờ câu trả lời này.',
            group_count_one: '1 yêu cầu đang chờ câu trả lời này.',
            group_empty: 'Không có yêu cầu nào của khung tuân thủ đã cài đặt đang chờ câu trả lời này.',
            group_empty_reference: 'Không có yêu cầu nào của khung tuân thủ áp dụng trực tiếp đang chờ câu trả lời này.',
            reference_intro: 'Các khung tuân thủ sau chỉ được cài đặt để tham khảo, nên các yêu cầu của chúng không được áp dụng cho tổ chức. Nếu được cài đặt để áp dụng trực tiếp, các yêu cầu này sẽ chờ câu trả lời này:',
            reference_item: '{framework} ({count} yêu cầu)',
            reference_item_one: '{framework} (1 yêu cầu)',
            column_framework: 'Khung tuân thủ',
            column_requirement: 'Yêu cầu',
            load_failed: 'Không thể đọc danh sách rà soát phạm vi áp dụng.',
            retry_subject: 'danh sách rà soát phạm vi áp dụng',
        },
        outcome: {
            column: 'Áp dụng cho tổ chức',
            applicable: 'Áp dụng',
            out_of_scope: 'Nằm ngoài phạm vi',
            not_applicable: 'Chỉ tham khảo — không giao cho tổ chức nào',
            installed_for_reference: 'Chỉ cài đặt để tham khảo — không được áp dụng cho tổ chức',
            not_entitled: 'Không bao gồm trong gói của bạn — không được áp dụng cho tổ chức',
            not_declared: 'Chưa khai báo phạm vi áp dụng',
            profile_incomplete: 'Chờ khai báo hồ sơ tổ chức',
            profile_incomplete_named: 'Chờ khai báo hồ sơ tổ chức: {attributes}',
            attributes: {
                sector: 'lĩnh vực hoạt động',
                data_exploitation_routes: 'cơ chế khai thác dữ liệu',
                regulated_entity_types: 'loại hình tổ chức thuộc đối tượng điều chỉnh',
            },
        },
    },
    // Sprint 63.37.0 (E0, E5)
    org_identity: viOrgIdentity,
    form_prefill: viFormPrefill,
    // Owner rulings 2026-10-26 — idea #717 and OQ-86-6.
    customs_tax_exports: viCustomsTaxExports,
    cross_border_filing_fence: viCrossBorderFilingFence,
    // Sprint 63.43.0 (AC4, AC8) — Phân hệ Lớp phủ ngành: trang Tổng quan.
    sector_overlays_module: viSectorOverlaysModule,
    evidence_reports: {
        intendedFilingReadinessHint: 'Đối với hồ sơ mới, phải có ngày nộp dự kiến để xác định mức độ sẵn sàng về nội dung theo luật định. Bạn có thể để trống để lưu bản nháp hoặc báo cáo về các thiếu sót. Có thể sử dụng lần nộp hồ sơ hiện có làm căn cứ.',
        captureUnconfirmed: 'Việc chốt báo cáo có thể vẫn đang được xử lý. Hãy thử lại đúng lần chốt này để kiểm tra hoặc khôi phục; phiên bản đã hoàn thành sẽ được sử dụng lại.',
        retryCapture: 'Kiểm tra hoặc thử lại lần chốt này',
        sampleEvidenceLimitation: 'Nội dung bắt buộc có thể đã đầy đủ, nhưng tài liệu chứng minh đã được chấp nhận đưa vào báo cáo là dữ liệu mẫu giả lập và không thể chứng minh hồ sơ đã sẵn sàng nộp theo quy định pháp luật. Vẫn có thể xuất báo cáo để dùng nội bộ hoặc đào tạo.',
        referenceRendition: 'Bản thể hiện để tham khảo',
        languagePreservationHint: 'Việc chọn ngôn ngữ chỉ thay đổi tiêu đề và nhãn. Câu trả lời đã lưu và tài liệu chứng minh giữ nguyên ngôn ngữ được soạn. Đầu ra này không dịch hoặc chứng nhận nội dung được cung cấp.',
        title: 'Chuẩn bị báo cáo tài liệu chứng minh',
        intro: 'Xác định câu hỏi và phạm vi, rà soát các hồ sơ thực tế, rồi chốt báo cáo có ghi nhận người chịu trách nhiệm. Biểu mẫu trống không chứng minh công việc đã hoàn thành.',
        legacy: 'Xuất danh mục theo cách cũ',
        legacyHint: 'Bản xuất danh mục chứa thông tin tham chiếu của khung tuân thủ. Đây không phải là báo cáo tài liệu chứng minh đã được rà soát.',
        name: 'Tên báo cáo',
        framework: 'Khung tuân thủ đã cài đặt',
        purpose: 'Mục đích lập báo cáo',
        internal_readiness: 'Rà soát mức độ sẵn sàng nội bộ',
        authority_request: 'Trả lời yêu cầu của cơ quan có thẩm quyền',
        processing_assessment: 'Hồ sơ đánh giá tác động xử lý dữ liệu cá nhân',
        transfer_assessment: 'Hồ sơ đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới',
        dossier_update: 'Cập nhật hồ sơ',
        assessmentKind: 'Loại đánh giá',
        dpia: 'Đánh giá tác động xử lý dữ liệu cá nhân',
        otia: 'Đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới',
        applicant: 'Chủ thể nộp hồ sơ',
        organization: 'Tổ chức',
        individual: 'Cá nhân',
        role: 'Vai trò của tổ chức',
        controller: 'Bên Kiểm soát dữ liệu cá nhân',
        controller_processor: 'Bên Kiểm soát và xử lý dữ liệu cá nhân',
        processor: 'Bên Xử lý dữ liệu cá nhân',
        other: 'Khác',
        coverage: 'Phạm vi bao quát',
        bounded: 'Hoạt động được chọn / phạm vi giới hạn',
        organization_complete: 'Toàn bộ tổ chức và vòng đời xử lý dữ liệu',
        coverageStatement: 'Tuyên bố về phạm vi và mức độ bao quát',
        coverageHint: 'Nêu rõ nội dung báo cáo bao quát và loại trừ. Một hoạt động được chọn không thể hiện phạm vi bao quát theo luật định của toàn tổ chức.',
        recipient: 'Bên nhận dự kiến',
        questions: 'Câu hỏi trong yêu cầu (mỗi dòng một câu)',
        language: 'Ngôn ngữ báo cáo',
        en: 'Tiếng Anh',
        vi: 'Tiếng Việt',
        asOf: 'Thời điểm chốt tài liệu chứng minh',
        timezone: 'Múi giờ IANA',
        periodStart: 'Bắt đầu kỳ báo cáo (không bắt buộc)',
        periodEnd: 'Kết thúc kỳ báo cáo (không bắt buộc)',
        intendedFiling: 'Ngày nộp dự kiến',
        filing: 'Lần nộp hồ sơ hiện có',
        sources: 'Chọn các bản ghi nguồn thực tế',
        sourceKind: 'Loại nguồn',
        sourceSearch: 'Tìm bản ghi nguồn được phép truy cập',
        sourceHint: 'Chỉ hiển thị các bản ghi hiện có mà bạn được phép đọc. Có thể không chọn bản ghi nào để báo cáo phản ánh đúng các thiếu sót. Tìm kiếm hoặc chuyển trang để xem thêm bản ghi.',
        search: 'Tìm kiếm',
        next: 'Trang sau',
        previous: 'Trang trước',
        remove: 'Loại bỏ',
        review: 'Rà soát tài liệu chứng minh và yêu cầu',
        preview: 'Cập nhật rà soát và bản xem trước',
        freeze: 'Chốt báo cáo và tạo tệp',
        busy: 'Đang xử lý…',
        failed: 'Yêu cầu không thành công. Nội dung bạn đã nhập được giữ lại.',
        required: 'Hoàn thành các trường bắt buộc trước khi tiếp tục.',
        emptySources: 'Chưa chọn bản ghi nguồn nào. Nội dung còn thiếu vẫn được nêu rõ.',
        candidate: 'Tài liệu chứng minh từ nguồn',
        noCandidates: 'Chưa cung cấp tài liệu chứng minh có thể truy cập. Báo cáo này thể hiện các thiếu sót, chưa chứng minh công việc đã hoàn thành.',
        openSource: 'Mở bản ghi nguồn',
        inspect: 'Kiểm tra nội dung đã ghi nhận',
        sourceRevision: 'Phiên bản nguồn',
        state: 'Trạng thái nguồn',
        include: 'Đưa vào',
        exclude: 'Loại trừ',
        decision: 'Quyết định về tài liệu chứng minh',
        reason: 'Lý do quyết định',
        requirementLinks: 'Các yêu cầu được chứng minh',
        requirements: 'Đánh giá các yêu cầu',
        applicability: 'Khả năng áp dụng',
        applicable: 'Áp dụng',
        not_applicable: 'Không áp dụng',
        undetermined: 'Chưa xác định',
        adequacy: 'Mức độ đầy đủ của nội dung',
        unreviewed: 'Chưa rà soát',
        adequate: 'Đầy đủ',
        partial: 'Một phần',
        unsupported: 'Chưa có tài liệu chứng minh',
        missing: 'Nội dung còn thiếu',
        present: 'Đã có nội dung',
        supported: 'Các yêu cầu có tài liệu chứng minh',
        blockers: 'Các điểm chặn bắt buộc',
        ready: 'Sẵn sàng cho mục đích đã chọn',
        notReady: 'Chưa sẵn sàng cho mục đích đã chọn',
        statutoryReady: 'Mức độ sẵn sàng về nội dung theo luật định',
        readinessHint: 'Mức độ sẵn sàng về nội dung, phê duyệt nội bộ, gửi hồ sơ, xác nhận tiếp nhận chính thức và kết quả xử lý của cơ quan có thẩm quyền là các quyết định riêng biệt. Một đánh giá đầy đủ vẫn có thể ghi nhận kết quả bất lợi.',
        diagnostics: 'Giới hạn của cấu hình đánh giá và nguồn',
        supplement: 'Nội dung đánh giá bổ sung',
        conclusions: 'Kết luận đánh giá và rủi ro còn lại',
        limitations: 'Giới hạn và câu hỏi chưa được giải quyết',
        disclosure: 'Quyết định cung cấp báo cáo',
        full: 'Cung cấp toàn bộ nội dung đã rà soát',
        redacted_release: 'Chỉ cung cấp tài liệu chứng minh được chọn',
        releaseReason: 'Lý do và rà soát việc cung cấp thông tin cho bên nhận',
        releaseEvidence: 'Tài liệu chứng minh được phép đưa vào bản cung cấp',
        gapTask: 'Giao việc khắc phục thiếu sót',
        taskTitle: 'Tên công việc',
        assignee: 'Người chịu trách nhiệm',
        dueDate: 'Hạn hoàn thành',
        createTask: 'Tạo công việc',
        taskCreated: 'Đã tạo công việc khắc phục thiếu sót',
        openTask: 'Mở công việc',
        taskHint: 'Hoàn thành công việc không đồng nghĩa với việc đã có tài liệu chứng minh đầy đủ. Hãy quay lại và cập nhật sau khi sửa bản ghi nguồn.',
        previewTitle: 'Xem trước báo cáo',
        version: 'Phiên bản',
        snapshot: 'Báo cáo đã chốt',
        capturedAt: 'Thời điểm ghi nhận',
        capturedBy: 'Người ghi nhận',
        reviewedBy: 'Người rà soát',
        manifestHash: 'Giá trị băm của danh mục bản chụp',
        files: 'Tệp báo cáo và tài liệu chứng minh',
        download: 'Tải xuống',
        noFiles: 'Chưa có tệp cho phiên bản này.',
        newVersion: 'Chỉnh sửa thành phiên bản mới',
        frozenHint: 'Đây là phiên bản đã chốt. Mọi thay đổi cần được xem trước và tạo thành phiên bản mới; phê duyệt hiện có chỉ áp dụng cho đúng phiên bản đã được phê duyệt.',
        pending: 'Đang chờ tạo tệp',
        finalized: 'Đã tạo xong tệp',
        failedState: 'Tạo tệp không thành công',
        sourceContent: 'Nội dung nguồn đã ghi nhận',
        attachments: 'Tài liệu đính kèm của nguồn',
        close: 'Đóng',
        saveReview: 'Áp dụng kết quả rà soát vào bản xem trước',
        profile: 'Cấu hình đánh giá',
        noProfile: 'Chưa cài đặt cấu hình đánh giá được hỗ trợ cho lựa chọn này.',
        returnReview: 'Quay lại rà soát',
        create: 'Tạo báo cáo',
        cancel: 'Hủy',
        dpiaSource: 'Đánh giá tác động xử lý dữ liệu cá nhân',
        transfer_assessmentSource: 'Đánh giá tác động chuyển dữ liệu cá nhân xuyên biên giới',
        processing_activitySource: 'Hoạt động xử lý dữ liệu cá nhân',
        systemSource: 'Hệ thống',
        vendorSource: 'Nhà cung cấp',
        consentSource: 'Bản ghi sự đồng ý',
        rights_requestSource: 'Yêu cầu thực hiện quyền',
        incidentSource: 'Sự cố',
        form_instanceSource: 'Bản biểu mẫu đã hoàn thành / bản nháp',
        attachmentSource: 'Tài liệu đính kèm',
        evidenceSource: 'Bản ghi tài liệu chứng minh',
        selected: 'Bản ghi nguồn đã chọn',
        sourceUnavailable: 'Nguồn không khả dụng hoặc bị hạn chế quyền truy cập',
        supplementHint: 'Bổ sung nội dung đánh giá thực chất còn thiếu. Nội dung để trống vẫn được ghi nhận là thiếu sót.',
        choose: 'Chọn…',
        page: 'Trang',
        exemption: 'Khai báo trường hợp miễn trừ',
        exemptionReason: 'Căn cứ miễn trừ và tài liệu chứng minh',
        approvalStatus: 'Trạng thái phê duyệt nội bộ / gửi hồ sơ',
        scope: 'Phạm vi báo cáo',
        sourceOutcomes: 'Kết quả truy xuất nguồn',
        openReportForm: 'Hoàn thành biểu mẫu báo cáo đánh giá tác động',
        openNoticeForm: 'Hoàn thành văn bản thông báo của bên nộp hồ sơ',
        formHint: 'Hoàn thành và chốt các biểu mẫu đã cài đặt này, rồi chọn các bản đã lưu làm bản ghi nguồn. Mở biểu mẫu trống không cung cấp tài liệu chứng minh.',
        reportTitle: 'Báo cáo tài liệu chứng minh',
        final: 'Nội dung đã lưu chính thức',
        draft: 'Nội dung bản nháp',
        historical: 'Nội dung trước đây',
        unverified: 'Nguồn chưa được xác minh',
        captureCurrent: 'Ghi nhận nội dung hiện đang được lưu',
        captureHint: 'Các bản ghi mới hoặc đã chỉnh sửa được lưu sau thời điểm này không thuộc báo cáo. Giữ thời điểm này để lập báo cáo về thời điểm trước đây, hoặc chủ động cập nhật để đưa nội dung hiện đang được lưu vào báo cáo.',
        sourceFacts: 'Thông tin thực tế đã ghi nhận',
        provenance: 'Nguồn gốc bản ghi',
        approveReportConfirm: 'Phê duyệt phiên bản {version} để cung cấp cho bên nhận dự kiến của báo cáo? Thao tác này ghi nhận phê duyệt của bạn; không ghi nhận việc nộp hồ sơ theo luật định, xác nhận tiếp nhận chính thức hay quyết định của cơ quan có thẩm quyền.',
        consent_evidenceSource: 'Bản ghi xác nhận và tài liệu chứng minh sự đồng ý',
        documentRoles: 'Các thành phần tài liệu kèm theo',
        historicalUse: 'Sử dụng tài liệu chứng minh trước đây cho kỳ báo cáo này',
        historicalHint: 'Tài liệu chứng minh trước đây chỉ có thể hỗ trợ việc rà soát nội bộ trong phạm vi giới hạn hoặc trả lời cơ quan có thẩm quyền khi các tệp chứng minh có ghi ngày tháng đã được chấp nhận đưa vào báo cáo xác lập tính hiệu lực trong suốt kỳ đã chọn. Tài liệu này không xác lập mức độ sẵn sàng hiện tại theo luật định.',
        historicalReason: 'Lý do sử dụng tài liệu chứng minh trước đây',
        validFrom: 'Có hiệu lực từ (ngày giờ ISO kèm độ lệch múi giờ)',
        validUntil: 'Có hiệu lực đến (ngày giờ ISO kèm độ lệch múi giờ)',
        historicalProof: 'Các tệp chứng minh có ghi ngày tháng đã được chấp nhận đưa vào báo cáo này',
        savedContentErrors: 'Nội dung biểu mẫu đã lưu cần được sửa',
        historicalCoverageError: 'Khoảng hiệu lực đã nêu phải bao quát toàn bộ kỳ báo cáo.',
        linkTask: 'Liên kết công việc hiện có',
    },
};
//# sourceMappingURL=vi.js.map